export const genesisBoxWearables = [
  {
    genesis_token_id: 0,
    wearable_ids: [362, 347],
  },
  {
    genesis_token_id: 1,
    wearable_ids: [435, 306],
  },
  {
    genesis_token_id: 2,
    wearable_ids: [375, 266],
  },
  {
    genesis_token_id: 3,
    wearable_ids: [387, 325],
  },
  {
    genesis_token_id: 4,
    wearable_ids: [403, 317],
  },
  {
    genesis_token_id: 5,
    wearable_ids: [325, 373],
  },
  {
    genesis_token_id: 6,
    wearable_ids: [400, 343],
  },
  {
    genesis_token_id: 7,
    wearable_ids: [259, 258],
  },
  {
    genesis_token_id: 8,
    wearable_ids: [342, 311],
  },
  {
    genesis_token_id: 9,
    wearable_ids: [326, 290],
  },
  {
    genesis_token_id: 10,
    wearable_ids: [257, 333],
  },
  {
    genesis_token_id: 11,
    wearable_ids: [422, 316],
  },
  {
    genesis_token_id: 12,
    wearable_ids: [304, 412],
  },
  {
    genesis_token_id: 13,
    wearable_ids: [374, 346],
  },
  {
    genesis_token_id: 14,
    wearable_ids: [295, 409],
  },
  {
    genesis_token_id: 15,
    wearable_ids: [389, 412],
  },
  {
    genesis_token_id: 16,
    wearable_ids: [336, 384],
  },
  {
    genesis_token_id: 17,
    wearable_ids: [306, 339],
  },
  {
    genesis_token_id: 18,
    wearable_ids: [273, 445],
  },
  {
    genesis_token_id: 19,
    wearable_ids: [351, 333],
  },
  {
    genesis_token_id: 20,
    wearable_ids: [407, 409],
  },
  {
    genesis_token_id: 21,
    wearable_ids: [326, 311],
  },
  {
    genesis_token_id: 22,
    wearable_ids: [426, 443],
  },
  {
    genesis_token_id: 23,
    wearable_ids: [274, 383],
  },
  {
    genesis_token_id: 24,
    wearable_ids: [348, 426],
  },
  {
    genesis_token_id: 25,
    wearable_ids: [331, 361],
  },
  {
    genesis_token_id: 26,
    wearable_ids: [324, 288],
  },
  {
    genesis_token_id: 27,
    wearable_ids: [247, 432],
  },
  {
    genesis_token_id: 28,
    wearable_ids: [433, 264],
  },
  {
    genesis_token_id: 29,
    wearable_ids: [270, 366],
  },
  {
    genesis_token_id: 30,
    wearable_ids: [306, 316],
  },
  {
    genesis_token_id: 31,
    wearable_ids: [257, 440],
  },
  {
    genesis_token_id: 32,
    wearable_ids: [435, 411],
  },
  {
    genesis_token_id: 33,
    wearable_ids: [278, 398],
  },
  {
    genesis_token_id: 34,
    wearable_ids: [254, 342],
  },
  {
    genesis_token_id: 35,
    wearable_ids: [270, 408],
  },
  {
    genesis_token_id: 36,
    wearable_ids: [399, 339],
  },
  {
    genesis_token_id: 37,
    wearable_ids: [265, 424],
  },
  {
    genesis_token_id: 38,
    wearable_ids: [319, 402],
  },
  {
    genesis_token_id: 39,
    wearable_ids: [300, 336],
  },
  {
    genesis_token_id: 40,
    wearable_ids: [258, 426],
  },
  {
    genesis_token_id: 41,
    wearable_ids: [294, 426],
  },
  {
    genesis_token_id: 42,
    wearable_ids: [266, 405],
  },
  {
    genesis_token_id: 43,
    wearable_ids: [338, 271],
  },
  {
    genesis_token_id: 44,
    wearable_ids: [397, 340],
  },
  {
    genesis_token_id: 45,
    wearable_ids: [291, 326],
  },
  {
    genesis_token_id: 46,
    wearable_ids: [396, 364],
  },
  {
    genesis_token_id: 47,
    wearable_ids: [340, 273],
  },
  {
    genesis_token_id: 48,
    wearable_ids: [259, 247],
  },
  {
    genesis_token_id: 49,
    wearable_ids: [354, 300],
  },
  {
    genesis_token_id: 50,
    wearable_ids: [295, 382],
  },
  {
    genesis_token_id: 51,
    wearable_ids: [251, 434],
  },
  {
    genesis_token_id: 52,
    wearable_ids: [274, 369],
  },
  {
    genesis_token_id: 53,
    wearable_ids: [268, 370],
  },
  {
    genesis_token_id: 54,
    wearable_ids: [311, 427],
  },
  {
    genesis_token_id: 55,
    wearable_ids: [387, 383],
  },
  {
    genesis_token_id: 56,
    wearable_ids: [311, 423],
  },
  {
    genesis_token_id: 57,
    wearable_ids: [297, 391],
  },
  {
    genesis_token_id: 58,
    wearable_ids: [372, 273],
  },
  {
    genesis_token_id: 59,
    wearable_ids: [411, 379],
  },
  {
    genesis_token_id: 60,
    wearable_ids: [383, 277],
  },
  {
    genesis_token_id: 61,
    wearable_ids: [247, 290],
  },
  {
    genesis_token_id: 62,
    wearable_ids: [341, 246],
  },
  {
    genesis_token_id: 63,
    wearable_ids: [373, 350],
  },
  {
    genesis_token_id: 64,
    wearable_ids: [301, 271],
  },
  {
    genesis_token_id: 65,
    wearable_ids: [349, 264],
  },
  {
    genesis_token_id: 66,
    wearable_ids: [423, 377],
  },
  {
    genesis_token_id: 67,
    wearable_ids: [424, 314],
  },
  {
    genesis_token_id: 68,
    wearable_ids: [274, 430],
  },
  {
    genesis_token_id: 69,
    wearable_ids: [406, 347],
  },
  {
    genesis_token_id: 70,
    wearable_ids: [306, 255],
  },
  {
    genesis_token_id: 71,
    wearable_ids: [354, 256],
  },
  {
    genesis_token_id: 72,
    wearable_ids: [424, 260],
  },
  {
    genesis_token_id: 73,
    wearable_ids: [266, 274],
  },
  {
    genesis_token_id: 74,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 75,
    wearable_ids: [253, 415],
  },
  {
    genesis_token_id: 76,
    wearable_ids: [263, 340],
  },
  {
    genesis_token_id: 77,
    wearable_ids: [337, 374],
  },
  {
    genesis_token_id: 78,
    wearable_ids: [346, 392],
  },
  {
    genesis_token_id: 79,
    wearable_ids: [423, 308],
  },
  {
    genesis_token_id: 80,
    wearable_ids: [337, 348],
  },
  {
    genesis_token_id: 81,
    wearable_ids: [289, 400],
  },
  {
    genesis_token_id: 82,
    wearable_ids: [396, 404],
  },
  {
    genesis_token_id: 83,
    wearable_ids: [407, 332],
  },
  {
    genesis_token_id: 84,
    wearable_ids: [304, 393],
  },
  {
    genesis_token_id: 85,
    wearable_ids: [362, 324],
  },
  {
    genesis_token_id: 86,
    wearable_ids: [433, 254],
  },
  {
    genesis_token_id: 87,
    wearable_ids: [355, 304],
  },
  {
    genesis_token_id: 88,
    wearable_ids: [354, 398],
  },
  {
    genesis_token_id: 89,
    wearable_ids: [428, 307],
  },
  {
    genesis_token_id: 90,
    wearable_ids: [344, 263],
  },
  {
    genesis_token_id: 91,
    wearable_ids: [335, 369],
  },
  {
    genesis_token_id: 92,
    wearable_ids: [253, 383],
  },
  {
    genesis_token_id: 93,
    wearable_ids: [373, 418],
  },
  {
    genesis_token_id: 94,
    wearable_ids: [278, 341],
  },
  {
    genesis_token_id: 95,
    wearable_ids: [289, 294],
  },
  {
    genesis_token_id: 96,
    wearable_ids: [423, 406],
  },
  {
    genesis_token_id: 97,
    wearable_ids: [343, 353],
  },
  {
    genesis_token_id: 98,
    wearable_ids: [354, 425],
  },
  {
    genesis_token_id: 99,
    wearable_ids: [364, 304],
  },
  {
    genesis_token_id: 100,
    wearable_ids: [409, 437],
  },
  {
    genesis_token_id: 101,
    wearable_ids: [316, 402],
  },
  {
    genesis_token_id: 102,
    wearable_ids: [406, 344],
  },
  {
    genesis_token_id: 103,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 104,
    wearable_ids: [317, 272],
  },
  {
    genesis_token_id: 105,
    wearable_ids: [300, 404],
  },
  {
    genesis_token_id: 106,
    wearable_ids: [255, 317],
  },
  {
    genesis_token_id: 107,
    wearable_ids: [290, 346],
  },
  {
    genesis_token_id: 108,
    wearable_ids: [386, 273],
  },
  {
    genesis_token_id: 109,
    wearable_ids: [355, 291],
  },
  {
    genesis_token_id: 110,
    wearable_ids: [297, 432],
  },
  {
    genesis_token_id: 111,
    wearable_ids: [291, 416],
  },
  {
    genesis_token_id: 112,
    wearable_ids: [254, 331],
  },
  {
    genesis_token_id: 113,
    wearable_ids: [363, 406],
  },
  {
    genesis_token_id: 114,
    wearable_ids: [396, 330],
  },
  {
    genesis_token_id: 115,
    wearable_ids: [273, 402],
  },
  {
    genesis_token_id: 116,
    wearable_ids: [314, 336],
  },
  {
    genesis_token_id: 117,
    wearable_ids: [339, 273],
  },
  {
    genesis_token_id: 118,
    wearable_ids: [422, 296],
  },
  {
    genesis_token_id: 119,
    wearable_ids: [248, 256],
  },
  {
    genesis_token_id: 120,
    wearable_ids: [374, 296],
  },
  {
    genesis_token_id: 121,
    wearable_ids: [273, 427],
  },
  {
    genesis_token_id: 122,
    wearable_ids: [386, 258],
  },
  {
    genesis_token_id: 123,
    wearable_ids: [300, 349],
  },
  {
    genesis_token_id: 124,
    wearable_ids: [277, 299],
  },
  {
    genesis_token_id: 125,
    wearable_ids: [265, 348],
  },
  {
    genesis_token_id: 126,
    wearable_ids: [262, 397],
  },
  {
    genesis_token_id: 127,
    wearable_ids: [291, 364],
  },
  {
    genesis_token_id: 128,
    wearable_ids: [314, 350],
  },
  {
    genesis_token_id: 129,
    wearable_ids: [248, 287],
  },
  {
    genesis_token_id: 130,
    wearable_ids: [303, 360],
  },
  {
    genesis_token_id: 131,
    wearable_ids: [268, 424],
  },
  {
    genesis_token_id: 132,
    wearable_ids: [271, 286],
  },
  {
    genesis_token_id: 133,
    wearable_ids: [335, 370],
  },
  {
    genesis_token_id: 134,
    wearable_ids: [271, 388],
  },
  {
    genesis_token_id: 135,
    wearable_ids: [395, 420],
  },
  {
    genesis_token_id: 136,
    wearable_ids: [338, 250],
  },
  {
    genesis_token_id: 137,
    wearable_ids: [337, 306],
  },
  {
    genesis_token_id: 138,
    wearable_ids: [415, 260],
  },
  {
    genesis_token_id: 139,
    wearable_ids: [423, 275],
  },
  {
    genesis_token_id: 140,
    wearable_ids: [442, 263],
  },
  {
    genesis_token_id: 141,
    wearable_ids: [301, 369],
  },
  {
    genesis_token_id: 142,
    wearable_ids: [325, 248],
  },
  {
    genesis_token_id: 143,
    wearable_ids: [364, 258],
  },
  {
    genesis_token_id: 144,
    wearable_ids: [378, 346],
  },
  {
    genesis_token_id: 145,
    wearable_ids: [257, 350],
  },
  {
    genesis_token_id: 146,
    wearable_ids: [406, 261],
  },
  {
    genesis_token_id: 147,
    wearable_ids: [436, 360],
  },
  {
    genesis_token_id: 148,
    wearable_ids: [263, 306],
  },
  {
    genesis_token_id: 149,
    wearable_ids: [420, 386],
  },
  {
    genesis_token_id: 150,
    wearable_ids: [422, 264],
  },
  {
    genesis_token_id: 151,
    wearable_ids: [413, 358],
  },
  {
    genesis_token_id: 152,
    wearable_ids: [344, 297],
  },
  {
    genesis_token_id: 153,
    wearable_ids: [412, 280],
  },
  {
    genesis_token_id: 154,
    wearable_ids: [280, 405],
  },
  {
    genesis_token_id: 155,
    wearable_ids: [273, 364],
  },
  {
    genesis_token_id: 156,
    wearable_ids: [317, 347],
  },
  {
    genesis_token_id: 157,
    wearable_ids: [435, 302],
  },
  {
    genesis_token_id: 158,
    wearable_ids: [406, 296],
  },
  {
    genesis_token_id: 159,
    wearable_ids: [369, 347],
  },
  {
    genesis_token_id: 160,
    wearable_ids: [262, 324],
  },
  {
    genesis_token_id: 161,
    wearable_ids: [256, 410],
  },
  {
    genesis_token_id: 162,
    wearable_ids: [413, 353],
  },
  {
    genesis_token_id: 163,
    wearable_ids: [310, 413],
  },
  {
    genesis_token_id: 164,
    wearable_ids: [335, 288],
  },
  {
    genesis_token_id: 165,
    wearable_ids: [284, 410],
  },
  {
    genesis_token_id: 166,
    wearable_ids: [265, 359],
  },
  {
    genesis_token_id: 167,
    wearable_ids: [324, 369],
  },
  {
    genesis_token_id: 168,
    wearable_ids: [442, 370],
  },
  {
    genesis_token_id: 169,
    wearable_ids: [443, 283],
  },
  {
    genesis_token_id: 170,
    wearable_ids: [297, 408],
  },
  {
    genesis_token_id: 171,
    wearable_ids: [422, 395],
  },
  {
    genesis_token_id: 172,
    wearable_ids: [355, 375],
  },
  {
    genesis_token_id: 173,
    wearable_ids: [423, 399],
  },
  {
    genesis_token_id: 174,
    wearable_ids: [306, 432],
  },
  {
    genesis_token_id: 175,
    wearable_ids: [273, 426],
  },
  {
    genesis_token_id: 176,
    wearable_ids: [337, 354],
  },
  {
    genesis_token_id: 177,
    wearable_ids: [284, 374],
  },
  {
    genesis_token_id: 178,
    wearable_ids: [397, 310],
  },
  {
    genesis_token_id: 179,
    wearable_ids: [297, 314],
  },
  {
    genesis_token_id: 180,
    wearable_ids: [384, 317],
  },
  {
    genesis_token_id: 181,
    wearable_ids: [404, 425],
  },
  {
    genesis_token_id: 182,
    wearable_ids: [257, 256],
  },
  {
    genesis_token_id: 183,
    wearable_ids: [276, 319],
  },
  {
    genesis_token_id: 184,
    wearable_ids: [397, 375],
  },
  {
    genesis_token_id: 185,
    wearable_ids: [397, 264],
  },
  {
    genesis_token_id: 186,
    wearable_ids: [354, 269],
  },
  {
    genesis_token_id: 187,
    wearable_ids: [403, 248],
  },
  {
    genesis_token_id: 188,
    wearable_ids: [303, 338],
  },
  {
    genesis_token_id: 189,
    wearable_ids: [295, 320],
  },
  {
    genesis_token_id: 190,
    wearable_ids: [382, 347],
  },
  {
    genesis_token_id: 191,
    wearable_ids: [295, 372],
  },
  {
    genesis_token_id: 192,
    wearable_ids: [251, 355],
  },
  {
    genesis_token_id: 193,
    wearable_ids: [290, 311],
  },
  {
    genesis_token_id: 194,
    wearable_ids: [259, 277],
  },
  {
    genesis_token_id: 195,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 196,
    wearable_ids: [251, 315],
  },
  {
    genesis_token_id: 197,
    wearable_ids: [404, 378],
  },
  {
    genesis_token_id: 198,
    wearable_ids: [408, 425],
  },
  {
    genesis_token_id: 199,
    wearable_ids: [264, 311],
  },
  {
    genesis_token_id: 200,
    wearable_ids: [268, 369],
  },
  {
    genesis_token_id: 201,
    wearable_ids: [280, 412],
  },
  {
    genesis_token_id: 202,
    wearable_ids: [344, 445],
  },
  {
    genesis_token_id: 203,
    wearable_ids: [343, 427],
  },
  {
    genesis_token_id: 204,
    wearable_ids: [442, 368],
  },
  {
    genesis_token_id: 205,
    wearable_ids: [370, 266],
  },
  {
    genesis_token_id: 206,
    wearable_ids: [286, 315],
  },
  {
    genesis_token_id: 207,
    wearable_ids: [431, 395],
  },
  {
    genesis_token_id: 208,
    wearable_ids: [370, 393],
  },
  {
    genesis_token_id: 209,
    wearable_ids: [348, 434],
  },
  {
    genesis_token_id: 210,
    wearable_ids: [397, 328],
  },
  {
    genesis_token_id: 211,
    wearable_ids: [372, 359],
  },
  {
    genesis_token_id: 212,
    wearable_ids: [350, 266],
  },
  {
    genesis_token_id: 213,
    wearable_ids: [437, 313],
  },
  {
    genesis_token_id: 214,
    wearable_ids: [400, 331],
  },
  {
    genesis_token_id: 215,
    wearable_ids: [273, 254],
  },
  {
    genesis_token_id: 216,
    wearable_ids: [292, 409],
  },
  {
    genesis_token_id: 217,
    wearable_ids: [306, 422],
  },
  {
    genesis_token_id: 218,
    wearable_ids: [324, 287],
  },
  {
    genesis_token_id: 219,
    wearable_ids: [310, 316],
  },
  {
    genesis_token_id: 220,
    wearable_ids: [258, 407],
  },
  {
    genesis_token_id: 221,
    wearable_ids: [435, 255],
  },
  {
    genesis_token_id: 222,
    wearable_ids: [354, 290],
  },
  {
    genesis_token_id: 223,
    wearable_ids: [310, 319],
  },
  {
    genesis_token_id: 224,
    wearable_ids: [342, 262],
  },
  {
    genesis_token_id: 225,
    wearable_ids: [370, 258],
  },
  {
    genesis_token_id: 226,
    wearable_ids: [268, 291],
  },
  {
    genesis_token_id: 227,
    wearable_ids: [377, 403],
  },
  {
    genesis_token_id: 228,
    wearable_ids: [408, 379],
  },
  {
    genesis_token_id: 229,
    wearable_ids: [270, 387],
  },
  {
    genesis_token_id: 230,
    wearable_ids: [254, 266],
  },
  {
    genesis_token_id: 231,
    wearable_ids: [257, 339],
  },
  {
    genesis_token_id: 232,
    wearable_ids: [350, 420],
  },
  {
    genesis_token_id: 233,
    wearable_ids: [412, 410],
  },
  {
    genesis_token_id: 234,
    wearable_ids: [303, 374],
  },
  {
    genesis_token_id: 235,
    wearable_ids: [350, 433],
  },
  {
    genesis_token_id: 236,
    wearable_ids: [336, 297],
  },
  {
    genesis_token_id: 237,
    wearable_ids: [296, 331],
  },
  {
    genesis_token_id: 238,
    wearable_ids: [292, 391],
  },
  {
    genesis_token_id: 239,
    wearable_ids: [412, 429],
  },
  {
    genesis_token_id: 240,
    wearable_ids: [368, 429],
  },
  {
    genesis_token_id: 241,
    wearable_ids: [370, 293],
  },
  {
    genesis_token_id: 242,
    wearable_ids: [426, 422],
  },
  {
    genesis_token_id: 243,
    wearable_ids: [264, 325],
  },
  {
    genesis_token_id: 244,
    wearable_ids: [332, 444],
  },
  {
    genesis_token_id: 245,
    wearable_ids: [299, 361],
  },
  {
    genesis_token_id: 246,
    wearable_ids: [444, 385],
  },
  {
    genesis_token_id: 247,
    wearable_ids: [273, 411],
  },
  {
    genesis_token_id: 248,
    wearable_ids: [259, 379],
  },
  {
    genesis_token_id: 249,
    wearable_ids: [436, 379],
  },
  {
    genesis_token_id: 250,
    wearable_ids: [409, 311],
  },
  {
    genesis_token_id: 251,
    wearable_ids: [304, 431],
  },
  {
    genesis_token_id: 252,
    wearable_ids: [369, 247],
  },
  {
    genesis_token_id: 253,
    wearable_ids: [369, 352],
  },
  {
    genesis_token_id: 254,
    wearable_ids: [407, 412],
  },
  {
    genesis_token_id: 255,
    wearable_ids: [270, 370],
  },
  {
    genesis_token_id: 256,
    wearable_ids: [396, 306],
  },
  {
    genesis_token_id: 257,
    wearable_ids: [407, 424],
  },
  {
    genesis_token_id: 258,
    wearable_ids: [339, 417],
  },
  {
    genesis_token_id: 259,
    wearable_ids: [253, 286],
  },
  {
    genesis_token_id: 260,
    wearable_ids: [342, 389],
  },
  {
    genesis_token_id: 261,
    wearable_ids: [383, 400],
  },
  {
    genesis_token_id: 262,
    wearable_ids: [266, 337],
  },
  {
    genesis_token_id: 263,
    wearable_ids: [428, 404],
  },
  {
    genesis_token_id: 264,
    wearable_ids: [351, 257],
  },
  {
    genesis_token_id: 265,
    wearable_ids: [266, 264],
  },
  {
    genesis_token_id: 266,
    wearable_ids: [339, 294],
  },
  {
    genesis_token_id: 267,
    wearable_ids: [410, 412],
  },
  {
    genesis_token_id: 268,
    wearable_ids: [324, 254],
  },
  {
    genesis_token_id: 269,
    wearable_ids: [344, 253],
  },
  {
    genesis_token_id: 270,
    wearable_ids: [373, 268],
  },
  {
    genesis_token_id: 271,
    wearable_ids: [253, 412],
  },
  {
    genesis_token_id: 272,
    wearable_ids: [262, 297],
  },
  {
    genesis_token_id: 273,
    wearable_ids: [378, 343],
  },
  {
    genesis_token_id: 274,
    wearable_ids: [337, 274],
  },
  {
    genesis_token_id: 275,
    wearable_ids: [429, 374],
  },
  {
    genesis_token_id: 276,
    wearable_ids: [251, 443],
  },
  {
    genesis_token_id: 277,
    wearable_ids: [258, 420],
  },
  {
    genesis_token_id: 278,
    wearable_ids: [434, 286],
  },
  {
    genesis_token_id: 279,
    wearable_ids: [428, 312],
  },
  {
    genesis_token_id: 280,
    wearable_ids: [406, 253],
  },
  {
    genesis_token_id: 281,
    wearable_ids: [319, 312],
  },
  {
    genesis_token_id: 282,
    wearable_ids: [350, 323],
  },
  {
    genesis_token_id: 283,
    wearable_ids: [352, 346],
  },
  {
    genesis_token_id: 284,
    wearable_ids: [304, 382],
  },
  {
    genesis_token_id: 285,
    wearable_ids: [331, 385],
  },
  {
    genesis_token_id: 286,
    wearable_ids: [444, 292],
  },
  {
    genesis_token_id: 287,
    wearable_ids: [399, 429],
  },
  {
    genesis_token_id: 288,
    wearable_ids: [378, 279],
  },
  {
    genesis_token_id: 289,
    wearable_ids: [396, 382],
  },
  {
    genesis_token_id: 290,
    wearable_ids: [301, 432],
  },
  {
    genesis_token_id: 291,
    wearable_ids: [344, 248],
  },
  {
    genesis_token_id: 292,
    wearable_ids: [378, 389],
  },
  {
    genesis_token_id: 293,
    wearable_ids: [404, 316],
  },
  {
    genesis_token_id: 294,
    wearable_ids: [303, 401],
  },
  {
    genesis_token_id: 295,
    wearable_ids: [426, 442],
  },
  {
    genesis_token_id: 296,
    wearable_ids: [348, 300],
  },
  {
    genesis_token_id: 297,
    wearable_ids: [409, 276],
  },
  {
    genesis_token_id: 298,
    wearable_ids: [287, 307],
  },
  {
    genesis_token_id: 299,
    wearable_ids: [369, 385],
  },
  {
    genesis_token_id: 300,
    wearable_ids: [256, 313],
  },
  {
    genesis_token_id: 301,
    wearable_ids: [429, 304],
  },
  {
    genesis_token_id: 302,
    wearable_ids: [247, 257],
  },
  {
    genesis_token_id: 303,
    wearable_ids: [276, 413],
  },
  {
    genesis_token_id: 304,
    wearable_ids: [434, 315],
  },
  {
    genesis_token_id: 305,
    wearable_ids: [308, 268],
  },
  {
    genesis_token_id: 306,
    wearable_ids: [308, 284],
  },
  {
    genesis_token_id: 307,
    wearable_ids: [347, 268],
  },
  {
    genesis_token_id: 308,
    wearable_ids: [365, 340],
  },
  {
    genesis_token_id: 309,
    wearable_ids: [274, 271],
  },
  {
    genesis_token_id: 310,
    wearable_ids: [364, 260],
  },
  {
    genesis_token_id: 311,
    wearable_ids: [280, 337],
  },
  {
    genesis_token_id: 312,
    wearable_ids: [389, 264],
  },
  {
    genesis_token_id: 313,
    wearable_ids: [317, 353],
  },
  {
    genesis_token_id: 314,
    wearable_ids: [336, 319],
  },
  {
    genesis_token_id: 315,
    wearable_ids: [435, 278],
  },
  {
    genesis_token_id: 316,
    wearable_ids: [303, 369],
  },
  {
    genesis_token_id: 317,
    wearable_ids: [337, 328],
  },
  {
    genesis_token_id: 318,
    wearable_ids: [445, 363],
  },
  {
    genesis_token_id: 319,
    wearable_ids: [292, 362],
  },
  {
    genesis_token_id: 320,
    wearable_ids: [292, 365],
  },
  {
    genesis_token_id: 321,
    wearable_ids: [258, 324],
  },
  {
    genesis_token_id: 322,
    wearable_ids: [339, 343],
  },
  {
    genesis_token_id: 323,
    wearable_ids: [292, 274],
  },
  {
    genesis_token_id: 324,
    wearable_ids: [314, 258],
  },
  {
    genesis_token_id: 325,
    wearable_ids: [300, 306],
  },
  {
    genesis_token_id: 326,
    wearable_ids: [363, 254],
  },
  {
    genesis_token_id: 327,
    wearable_ids: [287, 444],
  },
  {
    genesis_token_id: 328,
    wearable_ids: [317, 335],
  },
  {
    genesis_token_id: 329,
    wearable_ids: [315, 388],
  },
  {
    genesis_token_id: 330,
    wearable_ids: [254, 377],
  },
  {
    genesis_token_id: 331,
    wearable_ids: [274, 293],
  },
  {
    genesis_token_id: 332,
    wearable_ids: [346, 415],
  },
  {
    genesis_token_id: 333,
    wearable_ids: [422, 306],
  },
  {
    genesis_token_id: 334,
    wearable_ids: [340, 320],
  },
  {
    genesis_token_id: 335,
    wearable_ids: [326, 340],
  },
  {
    genesis_token_id: 336,
    wearable_ids: [376, 271],
  },
  {
    genesis_token_id: 337,
    wearable_ids: [255, 422],
  },
  {
    genesis_token_id: 338,
    wearable_ids: [374, 308],
  },
  {
    genesis_token_id: 339,
    wearable_ids: [434, 350],
  },
  {
    genesis_token_id: 340,
    wearable_ids: [290, 378],
  },
  {
    genesis_token_id: 341,
    wearable_ids: [292, 410],
  },
  {
    genesis_token_id: 342,
    wearable_ids: [311, 443],
  },
  {
    genesis_token_id: 343,
    wearable_ids: [386, 350],
  },
  {
    genesis_token_id: 344,
    wearable_ids: [420, 342],
  },
  {
    genesis_token_id: 345,
    wearable_ids: [255, 358],
  },
  {
    genesis_token_id: 346,
    wearable_ids: [336, 284],
  },
  {
    genesis_token_id: 347,
    wearable_ids: [300, 437],
  },
  {
    genesis_token_id: 348,
    wearable_ids: [308, 255],
  },
  {
    genesis_token_id: 349,
    wearable_ids: [248, 280],
  },
  {
    genesis_token_id: 350,
    wearable_ids: [294, 443],
  },
  {
    genesis_token_id: 351,
    wearable_ids: [385, 331],
  },
  {
    genesis_token_id: 352,
    wearable_ids: [264, 285],
  },
  {
    genesis_token_id: 353,
    wearable_ids: [423, 443],
  },
  {
    genesis_token_id: 354,
    wearable_ids: [420, 354],
  },
  {
    genesis_token_id: 355,
    wearable_ids: [352, 395],
  },
  {
    genesis_token_id: 356,
    wearable_ids: [422, 362],
  },
  {
    genesis_token_id: 357,
    wearable_ids: [436, 347],
  },
  {
    genesis_token_id: 358,
    wearable_ids: [254, 287],
  },
  {
    genesis_token_id: 359,
    wearable_ids: [292, 425],
  },
  {
    genesis_token_id: 360,
    wearable_ids: [350, 271],
  },
  {
    genesis_token_id: 361,
    wearable_ids: [338, 275],
  },
  {
    genesis_token_id: 362,
    wearable_ids: [409, 340],
  },
  {
    genesis_token_id: 363,
    wearable_ids: [404, 314],
  },
  {
    genesis_token_id: 364,
    wearable_ids: [311, 326],
  },
  {
    genesis_token_id: 365,
    wearable_ids: [373, 437],
  },
  {
    genesis_token_id: 366,
    wearable_ids: [431, 291],
  },
  {
    genesis_token_id: 367,
    wearable_ids: [354, 336],
  },
  {
    genesis_token_id: 368,
    wearable_ids: [268, 335],
  },
  {
    genesis_token_id: 369,
    wearable_ids: [315, 276],
  },
  {
    genesis_token_id: 370,
    wearable_ids: [301, 291],
  },
  {
    genesis_token_id: 371,
    wearable_ids: [375, 372],
  },
  {
    genesis_token_id: 372,
    wearable_ids: [286, 341],
  },
  {
    genesis_token_id: 373,
    wearable_ids: [276, 273],
  },
  {
    genesis_token_id: 374,
    wearable_ids: [346, 255],
  },
  {
    genesis_token_id: 375,
    wearable_ids: [383, 377],
  },
  {
    genesis_token_id: 376,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 377,
    wearable_ids: [292, 278],
  },
  {
    genesis_token_id: 378,
    wearable_ids: [386, 405],
  },
  {
    genesis_token_id: 379,
    wearable_ids: [316, 336],
  },
  {
    genesis_token_id: 380,
    wearable_ids: [317, 323],
  },
  {
    genesis_token_id: 381,
    wearable_ids: [408, 404],
  },
  {
    genesis_token_id: 382,
    wearable_ids: [386, 339],
  },
  {
    genesis_token_id: 383,
    wearable_ids: [420, 350],
  },
  {
    genesis_token_id: 384,
    wearable_ids: [412, 271],
  },
  {
    genesis_token_id: 385,
    wearable_ids: [429, 335],
  },
  {
    genesis_token_id: 386,
    wearable_ids: [352, 265],
  },
  {
    genesis_token_id: 387,
    wearable_ids: [259, 331],
  },
  {
    genesis_token_id: 388,
    wearable_ids: [435, 283],
  },
  {
    genesis_token_id: 389,
    wearable_ids: [376, 425],
  },
  {
    genesis_token_id: 390,
    wearable_ids: [423, 375],
  },
  {
    genesis_token_id: 391,
    wearable_ids: [300, 424],
  },
  {
    genesis_token_id: 392,
    wearable_ids: [277, 377],
  },
  {
    genesis_token_id: 393,
    wearable_ids: [308, 349],
  },
  {
    genesis_token_id: 394,
    wearable_ids: [296, 299],
  },
  {
    genesis_token_id: 395,
    wearable_ids: [370, 394],
  },
  {
    genesis_token_id: 396,
    wearable_ids: [317, 310],
  },
  {
    genesis_token_id: 397,
    wearable_ids: [407, 396],
  },
  {
    genesis_token_id: 398,
    wearable_ids: [342, 335],
  },
  {
    genesis_token_id: 399,
    wearable_ids: [263, 338],
  },
  {
    genesis_token_id: 400,
    wearable_ids: [325, 254],
  },
  {
    genesis_token_id: 401,
    wearable_ids: [289, 276],
  },
  {
    genesis_token_id: 402,
    wearable_ids: [386, 443],
  },
  {
    genesis_token_id: 403,
    wearable_ids: [319, 376],
  },
  {
    genesis_token_id: 404,
    wearable_ids: [296, 249],
  },
  {
    genesis_token_id: 405,
    wearable_ids: [404, 400],
  },
  {
    genesis_token_id: 406,
    wearable_ids: [284, 377],
  },
  {
    genesis_token_id: 407,
    wearable_ids: [378, 308],
  },
  {
    genesis_token_id: 408,
    wearable_ids: [409, 347],
  },
  {
    genesis_token_id: 409,
    wearable_ids: [389, 355],
  },
  {
    genesis_token_id: 410,
    wearable_ids: [445, 401],
  },
  {
    genesis_token_id: 411,
    wearable_ids: [308, 350],
  },
  {
    genesis_token_id: 412,
    wearable_ids: [376, 247],
  },
  {
    genesis_token_id: 413,
    wearable_ids: [375, 343],
  },
  {
    genesis_token_id: 414,
    wearable_ids: [264, 330],
  },
  {
    genesis_token_id: 415,
    wearable_ids: [425, 424],
  },
  {
    genesis_token_id: 416,
    wearable_ids: [433, 248],
  },
  {
    genesis_token_id: 417,
    wearable_ids: [403, 288],
  },
  {
    genesis_token_id: 418,
    wearable_ids: [374, 420],
  },
  {
    genesis_token_id: 419,
    wearable_ids: [364, 371],
  },
  {
    genesis_token_id: 420,
    wearable_ids: [371, 409],
  },
  {
    genesis_token_id: 421,
    wearable_ids: [324, 395],
  },
  {
    genesis_token_id: 422,
    wearable_ids: [310, 257],
  },
  {
    genesis_token_id: 423,
    wearable_ids: [372, 386],
  },
  {
    genesis_token_id: 424,
    wearable_ids: [284, 349],
  },
  {
    genesis_token_id: 425,
    wearable_ids: [299, 436],
  },
  {
    genesis_token_id: 426,
    wearable_ids: [315, 350],
  },
  {
    genesis_token_id: 427,
    wearable_ids: [270, 413],
  },
  {
    genesis_token_id: 428,
    wearable_ids: [272, 397],
  },
  {
    genesis_token_id: 429,
    wearable_ids: [445, 408],
  },
  {
    genesis_token_id: 430,
    wearable_ids: [270, 273],
  },
  {
    genesis_token_id: 431,
    wearable_ids: [375, 373],
  },
  {
    genesis_token_id: 432,
    wearable_ids: [368, 258],
  },
  {
    genesis_token_id: 433,
    wearable_ids: [310, 442],
  },
  {
    genesis_token_id: 434,
    wearable_ids: [306, 356],
  },
  {
    genesis_token_id: 435,
    wearable_ids: [415, 364],
  },
  {
    genesis_token_id: 436,
    wearable_ids: [300, 295],
  },
  {
    genesis_token_id: 437,
    wearable_ids: [346, 283],
  },
  {
    genesis_token_id: 438,
    wearable_ids: [347, 371],
  },
  {
    genesis_token_id: 439,
    wearable_ids: [432, 422],
  },
  {
    genesis_token_id: 440,
    wearable_ids: [255, 254],
  },
  {
    genesis_token_id: 441,
    wearable_ids: [354, 415],
  },
  {
    genesis_token_id: 442,
    wearable_ids: [437, 430],
  },
  {
    genesis_token_id: 443,
    wearable_ids: [272, 386],
  },
  {
    genesis_token_id: 444,
    wearable_ids: [286, 430],
  },
  {
    genesis_token_id: 445,
    wearable_ids: [262, 344],
  },
  {
    genesis_token_id: 446,
    wearable_ids: [297, 290],
  },
  {
    genesis_token_id: 447,
    wearable_ids: [306, 386],
  },
  {
    genesis_token_id: 448,
    wearable_ids: [290, 383],
  },
  {
    genesis_token_id: 449,
    wearable_ids: [422, 368],
  },
  {
    genesis_token_id: 450,
    wearable_ids: [364, 376],
  },
  {
    genesis_token_id: 451,
    wearable_ids: [257, 384],
  },
  {
    genesis_token_id: 452,
    wearable_ids: [296, 312],
  },
  {
    genesis_token_id: 453,
    wearable_ids: [435, 273],
  },
  {
    genesis_token_id: 454,
    wearable_ids: [362, 444],
  },
  {
    genesis_token_id: 455,
    wearable_ids: [354, 337],
  },
  {
    genesis_token_id: 456,
    wearable_ids: [400, 385],
  },
  {
    genesis_token_id: 457,
    wearable_ids: [372, 442],
  },
  {
    genesis_token_id: 458,
    wearable_ids: [404, 332],
  },
  {
    genesis_token_id: 459,
    wearable_ids: [431, 387],
  },
  {
    genesis_token_id: 460,
    wearable_ids: [316, 348],
  },
  {
    genesis_token_id: 461,
    wearable_ids: [374, 406],
  },
  {
    genesis_token_id: 462,
    wearable_ids: [277, 384],
  },
  {
    genesis_token_id: 463,
    wearable_ids: [377, 441],
  },
  {
    genesis_token_id: 464,
    wearable_ids: [316, 424],
  },
  {
    genesis_token_id: 465,
    wearable_ids: [273, 362],
  },
  {
    genesis_token_id: 466,
    wearable_ids: [248, 339],
  },
  {
    genesis_token_id: 467,
    wearable_ids: [407, 256],
  },
  {
    genesis_token_id: 468,
    wearable_ids: [266, 389],
  },
  {
    genesis_token_id: 469,
    wearable_ids: [304, 355],
  },
  {
    genesis_token_id: 470,
    wearable_ids: [316, 344],
  },
  {
    genesis_token_id: 471,
    wearable_ids: [337, 386],
  },
  {
    genesis_token_id: 472,
    wearable_ids: [257, 254],
  },
  {
    genesis_token_id: 473,
    wearable_ids: [351, 396],
  },
  {
    genesis_token_id: 474,
    wearable_ids: [325, 284],
  },
  {
    genesis_token_id: 475,
    wearable_ids: [426, 441],
  },
  {
    genesis_token_id: 476,
    wearable_ids: [308, 322],
  },
  {
    genesis_token_id: 477,
    wearable_ids: [372, 369],
  },
  {
    genesis_token_id: 478,
    wearable_ids: [319, 416],
  },
  {
    genesis_token_id: 479,
    wearable_ids: [397, 360],
  },
  {
    genesis_token_id: 480,
    wearable_ids: [300, 255],
  },
  {
    genesis_token_id: 481,
    wearable_ids: [377, 378],
  },
  {
    genesis_token_id: 482,
    wearable_ids: [262, 259],
  },
  {
    genesis_token_id: 483,
    wearable_ids: [273, 435],
  },
  {
    genesis_token_id: 484,
    wearable_ids: [337, 272],
  },
  {
    genesis_token_id: 485,
    wearable_ids: [428, 335],
  },
  {
    genesis_token_id: 486,
    wearable_ids: [355, 431],
  },
  {
    genesis_token_id: 487,
    wearable_ids: [295, 389],
  },
  {
    genesis_token_id: 488,
    wearable_ids: [350, 444],
  },
  {
    genesis_token_id: 489,
    wearable_ids: [372, 266],
  },
  {
    genesis_token_id: 490,
    wearable_ids: [256, 337],
  },
  {
    genesis_token_id: 491,
    wearable_ids: [310, 294],
  },
  {
    genesis_token_id: 492,
    wearable_ids: [291, 383],
  },
  {
    genesis_token_id: 493,
    wearable_ids: [278, 287],
  },
  {
    genesis_token_id: 494,
    wearable_ids: [339, 265],
  },
  {
    genesis_token_id: 495,
    wearable_ids: [314, 327],
  },
  {
    genesis_token_id: 496,
    wearable_ids: [294, 304],
  },
  {
    genesis_token_id: 497,
    wearable_ids: [389, 316],
  },
  {
    genesis_token_id: 498,
    wearable_ids: [369, 277],
  },
  {
    genesis_token_id: 499,
    wearable_ids: [251, 365],
  },
  {
    genesis_token_id: 500,
    wearable_ids: [254, 259],
  },
  {
    genesis_token_id: 501,
    wearable_ids: [376, 397],
  },
  {
    genesis_token_id: 502,
    wearable_ids: [308, 383],
  },
  {
    genesis_token_id: 503,
    wearable_ids: [268, 326],
  },
  {
    genesis_token_id: 504,
    wearable_ids: [347, 339],
  },
  {
    genesis_token_id: 505,
    wearable_ids: [336, 294],
  },
  {
    genesis_token_id: 506,
    wearable_ids: [264, 378],
  },
  {
    genesis_token_id: 507,
    wearable_ids: [369, 355],
  },
  {
    genesis_token_id: 508,
    wearable_ids: [413, 392],
  },
  {
    genesis_token_id: 509,
    wearable_ids: [348, 344],
  },
  {
    genesis_token_id: 510,
    wearable_ids: [304, 325],
  },
  {
    genesis_token_id: 511,
    wearable_ids: [399, 284],
  },
  {
    genesis_token_id: 512,
    wearable_ids: [429, 274],
  },
  {
    genesis_token_id: 513,
    wearable_ids: [428, 270],
  },
  {
    genesis_token_id: 514,
    wearable_ids: [410, 274],
  },
  {
    genesis_token_id: 515,
    wearable_ids: [415, 256],
  },
  {
    genesis_token_id: 516,
    wearable_ids: [409, 387],
  },
  {
    genesis_token_id: 517,
    wearable_ids: [407, 337],
  },
  {
    genesis_token_id: 518,
    wearable_ids: [364, 413],
  },
  {
    genesis_token_id: 519,
    wearable_ids: [325, 399],
  },
  {
    genesis_token_id: 520,
    wearable_ids: [352, 247],
  },
  {
    genesis_token_id: 521,
    wearable_ids: [371, 375],
  },
  {
    genesis_token_id: 522,
    wearable_ids: [270, 332],
  },
  {
    genesis_token_id: 523,
    wearable_ids: [422, 432],
  },
  {
    genesis_token_id: 524,
    wearable_ids: [387, 352],
  },
  {
    genesis_token_id: 525,
    wearable_ids: [399, 382],
  },
  {
    genesis_token_id: 526,
    wearable_ids: [276, 378],
  },
  {
    genesis_token_id: 527,
    wearable_ids: [368, 267],
  },
  {
    genesis_token_id: 528,
    wearable_ids: [286, 351],
  },
  {
    genesis_token_id: 529,
    wearable_ids: [376, 349],
  },
  {
    genesis_token_id: 530,
    wearable_ids: [264, 331],
  },
  {
    genesis_token_id: 531,
    wearable_ids: [257, 291],
  },
  {
    genesis_token_id: 532,
    wearable_ids: [324, 295],
  },
  {
    genesis_token_id: 533,
    wearable_ids: [284, 266],
  },
  {
    genesis_token_id: 534,
    wearable_ids: [408, 406],
  },
  {
    genesis_token_id: 535,
    wearable_ids: [274, 445],
  },
  {
    genesis_token_id: 536,
    wearable_ids: [273, 420],
  },
  {
    genesis_token_id: 537,
    wearable_ids: [431, 349],
  },
  {
    genesis_token_id: 538,
    wearable_ids: [337, 324],
  },
  {
    genesis_token_id: 539,
    wearable_ids: [363, 443],
  },
  {
    genesis_token_id: 540,
    wearable_ids: [406, 275],
  },
  {
    genesis_token_id: 541,
    wearable_ids: [382, 422],
  },
  {
    genesis_token_id: 542,
    wearable_ids: [342, 301],
  },
  {
    genesis_token_id: 543,
    wearable_ids: [420, 440],
  },
  {
    genesis_token_id: 544,
    wearable_ids: [308, 344],
  },
  {
    genesis_token_id: 545,
    wearable_ids: [332, 440],
  },
  {
    genesis_token_id: 546,
    wearable_ids: [314, 404],
  },
  {
    genesis_token_id: 547,
    wearable_ids: [315, 373],
  },
  {
    genesis_token_id: 548,
    wearable_ids: [409, 345],
  },
  {
    genesis_token_id: 549,
    wearable_ids: [255, 301],
  },
  {
    genesis_token_id: 550,
    wearable_ids: [372, 384],
  },
  {
    genesis_token_id: 551,
    wearable_ids: [396, 302],
  },
  {
    genesis_token_id: 552,
    wearable_ids: [308, 432],
  },
  {
    genesis_token_id: 553,
    wearable_ids: [272, 263],
  },
  {
    genesis_token_id: 554,
    wearable_ids: [295, 317],
  },
  {
    genesis_token_id: 555,
    wearable_ids: [363, 357],
  },
  {
    genesis_token_id: 556,
    wearable_ids: [256, 274],
  },
  {
    genesis_token_id: 557,
    wearable_ids: [287, 303],
  },
  {
    genesis_token_id: 558,
    wearable_ids: [301, 276],
  },
  {
    genesis_token_id: 559,
    wearable_ids: [311, 265],
  },
  {
    genesis_token_id: 560,
    wearable_ids: [336, 277],
  },
  {
    genesis_token_id: 561,
    wearable_ids: [335, 350],
  },
  {
    genesis_token_id: 562,
    wearable_ids: [256, 370],
  },
  {
    genesis_token_id: 563,
    wearable_ids: [299, 335],
  },
  {
    genesis_token_id: 564,
    wearable_ids: [429, 299],
  },
  {
    genesis_token_id: 565,
    wearable_ids: [348, 374],
  },
  {
    genesis_token_id: 566,
    wearable_ids: [372, 274],
  },
  {
    genesis_token_id: 567,
    wearable_ids: [351, 423],
  },
  {
    genesis_token_id: 568,
    wearable_ids: [332, 445],
  },
  {
    genesis_token_id: 569,
    wearable_ids: [426, 326],
  },
  {
    genesis_token_id: 570,
    wearable_ids: [338, 409],
  },
  {
    genesis_token_id: 571,
    wearable_ids: [296, 355],
  },
  {
    genesis_token_id: 572,
    wearable_ids: [292, 375],
  },
  {
    genesis_token_id: 573,
    wearable_ids: [339, 395],
  },
  {
    genesis_token_id: 574,
    wearable_ids: [271, 341],
  },
  {
    genesis_token_id: 575,
    wearable_ids: [280, 377],
  },
  {
    genesis_token_id: 576,
    wearable_ids: [370, 354],
  },
  {
    genesis_token_id: 577,
    wearable_ids: [348, 365],
  },
  {
    genesis_token_id: 578,
    wearable_ids: [342, 400],
  },
  {
    genesis_token_id: 579,
    wearable_ids: [286, 304],
  },
  {
    genesis_token_id: 580,
    wearable_ids: [315, 262],
  },
  {
    genesis_token_id: 581,
    wearable_ids: [326, 423],
  },
  {
    genesis_token_id: 582,
    wearable_ids: [373, 264],
  },
  {
    genesis_token_id: 583,
    wearable_ids: [431, 432],
  },
  {
    genesis_token_id: 584,
    wearable_ids: [295, 294],
  },
  {
    genesis_token_id: 585,
    wearable_ids: [292, 272],
  },
  {
    genesis_token_id: 586,
    wearable_ids: [354, 378],
  },
  {
    genesis_token_id: 587,
    wearable_ids: [344, 413],
  },
  {
    genesis_token_id: 588,
    wearable_ids: [420, 445],
  },
  {
    genesis_token_id: 589,
    wearable_ids: [255, 369],
  },
  {
    genesis_token_id: 590,
    wearable_ids: [436, 443],
  },
  {
    genesis_token_id: 591,
    wearable_ids: [399, 264],
  },
  {
    genesis_token_id: 592,
    wearable_ids: [389, 261],
  },
  {
    genesis_token_id: 593,
    wearable_ids: [341, 397],
  },
  {
    genesis_token_id: 594,
    wearable_ids: [339, 378],
  },
  {
    genesis_token_id: 595,
    wearable_ids: [397, 436],
  },
  {
    genesis_token_id: 596,
    wearable_ids: [324, 412],
  },
  {
    genesis_token_id: 597,
    wearable_ids: [304, 315],
  },
  {
    genesis_token_id: 598,
    wearable_ids: [375, 297],
  },
  {
    genesis_token_id: 599,
    wearable_ids: [276, 311],
  },
  {
    genesis_token_id: 600,
    wearable_ids: [337, 268],
  },
  {
    genesis_token_id: 601,
    wearable_ids: [295, 301],
  },
  {
    genesis_token_id: 602,
    wearable_ids: [363, 404],
  },
  {
    genesis_token_id: 603,
    wearable_ids: [341, 443],
  },
  {
    genesis_token_id: 604,
    wearable_ids: [316, 403],
  },
  {
    genesis_token_id: 605,
    wearable_ids: [255, 256],
  },
  {
    genesis_token_id: 606,
    wearable_ids: [291, 436],
  },
  {
    genesis_token_id: 607,
    wearable_ids: [369, 327],
  },
  {
    genesis_token_id: 608,
    wearable_ids: [276, 298],
  },
  {
    genesis_token_id: 609,
    wearable_ids: [348, 398],
  },
  {
    genesis_token_id: 610,
    wearable_ids: [412, 303],
  },
  {
    genesis_token_id: 611,
    wearable_ids: [337, 291],
  },
  {
    genesis_token_id: 612,
    wearable_ids: [382, 286],
  },
  {
    genesis_token_id: 613,
    wearable_ids: [351, 253],
  },
  {
    genesis_token_id: 614,
    wearable_ids: [273, 425],
  },
  {
    genesis_token_id: 615,
    wearable_ids: [324, 287],
  },
  {
    genesis_token_id: 616,
    wearable_ids: [429, 305],
  },
  {
    genesis_token_id: 617,
    wearable_ids: [375, 373],
  },
  {
    genesis_token_id: 618,
    wearable_ids: [265, 399],
  },
  {
    genesis_token_id: 619,
    wearable_ids: [444, 291],
  },
  {
    genesis_token_id: 620,
    wearable_ids: [338, 336],
  },
  {
    genesis_token_id: 621,
    wearable_ids: [349, 358],
  },
  {
    genesis_token_id: 622,
    wearable_ids: [300, 403],
  },
  {
    genesis_token_id: 623,
    wearable_ids: [420, 266],
  },
  {
    genesis_token_id: 624,
    wearable_ids: [423, 260],
  },
  {
    genesis_token_id: 625,
    wearable_ids: [374, 362],
  },
  {
    genesis_token_id: 626,
    wearable_ids: [351, 391],
  },
  {
    genesis_token_id: 627,
    wearable_ids: [364, 385],
  },
  {
    genesis_token_id: 628,
    wearable_ids: [336, 343],
  },
  {
    genesis_token_id: 629,
    wearable_ids: [433, 428],
  },
  {
    genesis_token_id: 630,
    wearable_ids: [319, 299],
  },
  {
    genesis_token_id: 631,
    wearable_ids: [295, 335],
  },
  {
    genesis_token_id: 632,
    wearable_ids: [295, 399],
  },
  {
    genesis_token_id: 633,
    wearable_ids: [277, 342],
  },
  {
    genesis_token_id: 634,
    wearable_ids: [338, 311],
  },
  {
    genesis_token_id: 635,
    wearable_ids: [254, 352],
  },
  {
    genesis_token_id: 636,
    wearable_ids: [411, 377],
  },
  {
    genesis_token_id: 637,
    wearable_ids: [363, 288],
  },
  {
    genesis_token_id: 638,
    wearable_ids: [310, 255],
  },
  {
    genesis_token_id: 639,
    wearable_ids: [319, 348],
  },
  {
    genesis_token_id: 640,
    wearable_ids: [266, 339],
  },
  {
    genesis_token_id: 641,
    wearable_ids: [344, 248],
  },
  {
    genesis_token_id: 642,
    wearable_ids: [387, 406],
  },
  {
    genesis_token_id: 643,
    wearable_ids: [349, 330],
  },
  {
    genesis_token_id: 644,
    wearable_ids: [415, 416],
  },
  {
    genesis_token_id: 645,
    wearable_ids: [256, 331],
  },
  {
    genesis_token_id: 646,
    wearable_ids: [425, 434],
  },
  {
    genesis_token_id: 647,
    wearable_ids: [410, 322],
  },
  {
    genesis_token_id: 648,
    wearable_ids: [276, 296],
  },
  {
    genesis_token_id: 649,
    wearable_ids: [310, 435],
  },
  {
    genesis_token_id: 650,
    wearable_ids: [292, 419],
  },
  {
    genesis_token_id: 651,
    wearable_ids: [303, 306],
  },
  {
    genesis_token_id: 652,
    wearable_ids: [412, 319],
  },
  {
    genesis_token_id: 653,
    wearable_ids: [308, 315],
  },
  {
    genesis_token_id: 654,
    wearable_ids: [435, 406],
  },
  {
    genesis_token_id: 655,
    wearable_ids: [326, 248],
  },
  {
    genesis_token_id: 656,
    wearable_ids: [373, 375],
  },
  {
    genesis_token_id: 657,
    wearable_ids: [284, 271],
  },
  {
    genesis_token_id: 658,
    wearable_ids: [442, 336],
  },
  {
    genesis_token_id: 659,
    wearable_ids: [289, 256],
  },
  {
    genesis_token_id: 660,
    wearable_ids: [270, 303],
  },
  {
    genesis_token_id: 661,
    wearable_ids: [403, 331],
  },
  {
    genesis_token_id: 662,
    wearable_ids: [436, 365],
  },
  {
    genesis_token_id: 663,
    wearable_ids: [292, 302],
  },
  {
    genesis_token_id: 664,
    wearable_ids: [370, 413],
  },
  {
    genesis_token_id: 665,
    wearable_ids: [396, 397],
  },
  {
    genesis_token_id: 666,
    wearable_ids: [352, 425],
  },
  {
    genesis_token_id: 667,
    wearable_ids: [422, 326],
  },
  {
    genesis_token_id: 668,
    wearable_ids: [355, 303],
  },
  {
    genesis_token_id: 669,
    wearable_ids: [433, 254],
  },
  {
    genesis_token_id: 670,
    wearable_ids: [337, 336],
  },
  {
    genesis_token_id: 671,
    wearable_ids: [444, 387],
  },
  {
    genesis_token_id: 672,
    wearable_ids: [276, 422],
  },
  {
    genesis_token_id: 673,
    wearable_ids: [306, 357],
  },
  {
    genesis_token_id: 674,
    wearable_ids: [363, 287],
  },
  {
    genesis_token_id: 675,
    wearable_ids: [290, 422],
  },
  {
    genesis_token_id: 676,
    wearable_ids: [372, 251],
  },
  {
    genesis_token_id: 677,
    wearable_ids: [374, 348],
  },
  {
    genesis_token_id: 678,
    wearable_ids: [350, 307],
  },
  {
    genesis_token_id: 679,
    wearable_ids: [254, 262],
  },
  {
    genesis_token_id: 680,
    wearable_ids: [332, 422],
  },
  {
    genesis_token_id: 681,
    wearable_ids: [365, 270],
  },
  {
    genesis_token_id: 682,
    wearable_ids: [342, 291],
  },
  {
    genesis_token_id: 683,
    wearable_ids: [376, 426],
  },
  {
    genesis_token_id: 684,
    wearable_ids: [314, 268],
  },
  {
    genesis_token_id: 685,
    wearable_ids: [342, 331],
  },
  {
    genesis_token_id: 686,
    wearable_ids: [364, 368],
  },
  {
    genesis_token_id: 687,
    wearable_ids: [399, 336],
  },
  {
    genesis_token_id: 688,
    wearable_ids: [286, 284],
  },
  {
    genesis_token_id: 689,
    wearable_ids: [284, 395],
  },
  {
    genesis_token_id: 690,
    wearable_ids: [372, 254],
  },
  {
    genesis_token_id: 691,
    wearable_ids: [340, 404],
  },
  {
    genesis_token_id: 692,
    wearable_ids: [265, 332],
  },
  {
    genesis_token_id: 693,
    wearable_ids: [301, 300],
  },
  {
    genesis_token_id: 694,
    wearable_ids: [297, 436],
  },
  {
    genesis_token_id: 695,
    wearable_ids: [365, 386],
  },
  {
    genesis_token_id: 696,
    wearable_ids: [296, 422],
  },
  {
    genesis_token_id: 697,
    wearable_ids: [375, 347],
  },
  {
    genesis_token_id: 698,
    wearable_ids: [291, 310],
  },
  {
    genesis_token_id: 699,
    wearable_ids: [276, 391],
  },
  {
    genesis_token_id: 700,
    wearable_ids: [363, 259],
  },
  {
    genesis_token_id: 701,
    wearable_ids: [426, 384],
  },
  {
    genesis_token_id: 702,
    wearable_ids: [411, 295],
  },
  {
    genesis_token_id: 703,
    wearable_ids: [310, 442],
  },
  {
    genesis_token_id: 704,
    wearable_ids: [308, 249],
  },
  {
    genesis_token_id: 705,
    wearable_ids: [399, 355],
  },
  {
    genesis_token_id: 706,
    wearable_ids: [363, 362],
  },
  {
    genesis_token_id: 707,
    wearable_ids: [332, 445],
  },
  {
    genesis_token_id: 708,
    wearable_ids: [365, 304],
  },
  {
    genesis_token_id: 709,
    wearable_ids: [387, 332],
  },
  {
    genesis_token_id: 710,
    wearable_ids: [251, 335],
  },
  {
    genesis_token_id: 711,
    wearable_ids: [272, 350],
  },
  {
    genesis_token_id: 712,
    wearable_ids: [346, 440],
  },
  {
    genesis_token_id: 713,
    wearable_ids: [349, 323],
  },
  {
    genesis_token_id: 714,
    wearable_ids: [386, 257],
  },
  {
    genesis_token_id: 715,
    wearable_ids: [340, 279],
  },
  {
    genesis_token_id: 716,
    wearable_ids: [273, 319],
  },
  {
    genesis_token_id: 717,
    wearable_ids: [297, 326],
  },
  {
    genesis_token_id: 718,
    wearable_ids: [387, 337],
  },
  {
    genesis_token_id: 719,
    wearable_ids: [445, 301],
  },
  {
    genesis_token_id: 720,
    wearable_ids: [422, 299],
  },
  {
    genesis_token_id: 721,
    wearable_ids: [278, 259],
  },
  {
    genesis_token_id: 722,
    wearable_ids: [369, 378],
  },
  {
    genesis_token_id: 723,
    wearable_ids: [255, 337],
  },
  {
    genesis_token_id: 724,
    wearable_ids: [335, 251],
  },
  {
    genesis_token_id: 725,
    wearable_ids: [400, 396],
  },
  {
    genesis_token_id: 726,
    wearable_ids: [296, 307],
  },
  {
    genesis_token_id: 727,
    wearable_ids: [341, 360],
  },
  {
    genesis_token_id: 728,
    wearable_ids: [386, 288],
  },
  {
    genesis_token_id: 729,
    wearable_ids: [316, 326],
  },
  {
    genesis_token_id: 730,
    wearable_ids: [400, 374],
  },
  {
    genesis_token_id: 731,
    wearable_ids: [434, 286],
  },
  {
    genesis_token_id: 732,
    wearable_ids: [411, 423],
  },
  {
    genesis_token_id: 733,
    wearable_ids: [274, 334],
  },
  {
    genesis_token_id: 734,
    wearable_ids: [378, 289],
  },
  {
    genesis_token_id: 735,
    wearable_ids: [362, 312],
  },
  {
    genesis_token_id: 736,
    wearable_ids: [332, 288],
  },
  {
    genesis_token_id: 737,
    wearable_ids: [263, 364],
  },
  {
    genesis_token_id: 738,
    wearable_ids: [308, 409],
  },
  {
    genesis_token_id: 739,
    wearable_ids: [258, 304],
  },
  {
    genesis_token_id: 740,
    wearable_ids: [404, 316],
  },
  {
    genesis_token_id: 741,
    wearable_ids: [364, 298],
  },
  {
    genesis_token_id: 742,
    wearable_ids: [415, 407],
  },
  {
    genesis_token_id: 743,
    wearable_ids: [351, 341],
  },
  {
    genesis_token_id: 744,
    wearable_ids: [386, 249],
  },
  {
    genesis_token_id: 745,
    wearable_ids: [375, 393],
  },
  {
    genesis_token_id: 746,
    wearable_ids: [274, 284],
  },
  {
    genesis_token_id: 747,
    wearable_ids: [255, 315],
  },
  {
    genesis_token_id: 748,
    wearable_ids: [399, 332],
  },
  {
    genesis_token_id: 749,
    wearable_ids: [316, 425],
  },
  {
    genesis_token_id: 750,
    wearable_ids: [445, 426],
  },
  {
    genesis_token_id: 751,
    wearable_ids: [352, 296],
  },
  {
    genesis_token_id: 752,
    wearable_ids: [433, 311],
  },
  {
    genesis_token_id: 753,
    wearable_ids: [300, 386],
  },
  {
    genesis_token_id: 754,
    wearable_ids: [278, 387],
  },
  {
    genesis_token_id: 755,
    wearable_ids: [259, 363],
  },
  {
    genesis_token_id: 756,
    wearable_ids: [436, 294],
  },
  {
    genesis_token_id: 757,
    wearable_ids: [331, 256],
  },
  {
    genesis_token_id: 758,
    wearable_ids: [426, 338],
  },
  {
    genesis_token_id: 759,
    wearable_ids: [270, 263],
  },
  {
    genesis_token_id: 760,
    wearable_ids: [443, 425],
  },
  {
    genesis_token_id: 761,
    wearable_ids: [429, 253],
  },
  {
    genesis_token_id: 762,
    wearable_ids: [377, 397],
  },
  {
    genesis_token_id: 763,
    wearable_ids: [385, 336],
  },
  {
    genesis_token_id: 764,
    wearable_ids: [378, 348],
  },
  {
    genesis_token_id: 765,
    wearable_ids: [272, 295],
  },
  {
    genesis_token_id: 766,
    wearable_ids: [397, 332],
  },
  {
    genesis_token_id: 767,
    wearable_ids: [349, 259],
  },
  {
    genesis_token_id: 768,
    wearable_ids: [324, 338],
  },
  {
    genesis_token_id: 769,
    wearable_ids: [387, 348],
  },
  {
    genesis_token_id: 770,
    wearable_ids: [363, 376],
  },
  {
    genesis_token_id: 771,
    wearable_ids: [248, 396],
  },
  {
    genesis_token_id: 772,
    wearable_ids: [374, 267],
  },
  {
    genesis_token_id: 773,
    wearable_ids: [316, 273],
  },
  {
    genesis_token_id: 774,
    wearable_ids: [403, 392],
  },
  {
    genesis_token_id: 775,
    wearable_ids: [352, 255],
  },
  {
    genesis_token_id: 776,
    wearable_ids: [371, 428],
  },
  {
    genesis_token_id: 777,
    wearable_ids: [259, 393],
  },
  {
    genesis_token_id: 778,
    wearable_ids: [426, 356],
  },
  {
    genesis_token_id: 779,
    wearable_ids: [424, 268],
  },
  {
    genesis_token_id: 780,
    wearable_ids: [386, 405],
  },
  {
    genesis_token_id: 781,
    wearable_ids: [251, 338],
  },
  {
    genesis_token_id: 782,
    wearable_ids: [434, 333],
  },
  {
    genesis_token_id: 783,
    wearable_ids: [370, 366],
  },
  {
    genesis_token_id: 784,
    wearable_ids: [276, 300],
  },
  {
    genesis_token_id: 785,
    wearable_ids: [347, 293],
  },
  {
    genesis_token_id: 786,
    wearable_ids: [377, 364],
  },
  {
    genesis_token_id: 787,
    wearable_ids: [289, 258],
  },
  {
    genesis_token_id: 788,
    wearable_ids: [426, 417],
  },
  {
    genesis_token_id: 789,
    wearable_ids: [436, 296],
  },
  {
    genesis_token_id: 790,
    wearable_ids: [362, 343],
  },
  {
    genesis_token_id: 791,
    wearable_ids: [286, 296],
  },
  {
    genesis_token_id: 792,
    wearable_ids: [395, 425],
  },
  {
    genesis_token_id: 793,
    wearable_ids: [295, 294],
  },
  {
    genesis_token_id: 794,
    wearable_ids: [368, 294],
  },
  {
    genesis_token_id: 795,
    wearable_ids: [278, 371],
  },
  {
    genesis_token_id: 796,
    wearable_ids: [386, 435],
  },
  {
    genesis_token_id: 797,
    wearable_ids: [276, 400],
  },
  {
    genesis_token_id: 798,
    wearable_ids: [310, 262],
  },
  {
    genesis_token_id: 799,
    wearable_ids: [377, 399],
  },
  {
    genesis_token_id: 800,
    wearable_ids: [332, 269],
  },
  {
    genesis_token_id: 801,
    wearable_ids: [386, 435],
  },
  {
    genesis_token_id: 802,
    wearable_ids: [248, 363],
  },
  {
    genesis_token_id: 803,
    wearable_ids: [383, 397],
  },
  {
    genesis_token_id: 804,
    wearable_ids: [364, 374],
  },
  {
    genesis_token_id: 805,
    wearable_ids: [310, 319],
  },
  {
    genesis_token_id: 806,
    wearable_ids: [310, 422],
  },
  {
    genesis_token_id: 807,
    wearable_ids: [303, 435],
  },
  {
    genesis_token_id: 808,
    wearable_ids: [262, 442],
  },
  {
    genesis_token_id: 809,
    wearable_ids: [382, 270],
  },
  {
    genesis_token_id: 810,
    wearable_ids: [376, 293],
  },
  {
    genesis_token_id: 811,
    wearable_ids: [428, 357],
  },
  {
    genesis_token_id: 812,
    wearable_ids: [277, 353],
  },
  {
    genesis_token_id: 813,
    wearable_ids: [337, 440],
  },
  {
    genesis_token_id: 814,
    wearable_ids: [295, 445],
  },
  {
    genesis_token_id: 815,
    wearable_ids: [258, 437],
  },
  {
    genesis_token_id: 816,
    wearable_ids: [297, 300],
  },
  {
    genesis_token_id: 817,
    wearable_ids: [248, 429],
  },
  {
    genesis_token_id: 818,
    wearable_ids: [433, 303],
  },
  {
    genesis_token_id: 819,
    wearable_ids: [369, 378],
  },
  {
    genesis_token_id: 820,
    wearable_ids: [337, 271],
  },
  {
    genesis_token_id: 821,
    wearable_ids: [340, 255],
  },
  {
    genesis_token_id: 822,
    wearable_ids: [271, 408],
  },
  {
    genesis_token_id: 823,
    wearable_ids: [385, 430],
  },
  {
    genesis_token_id: 824,
    wearable_ids: [273, 352],
  },
  {
    genesis_token_id: 825,
    wearable_ids: [372, 363],
  },
  {
    genesis_token_id: 826,
    wearable_ids: [341, 270],
  },
  {
    genesis_token_id: 827,
    wearable_ids: [284, 251],
  },
  {
    genesis_token_id: 828,
    wearable_ids: [259, 406],
  },
  {
    genesis_token_id: 829,
    wearable_ids: [314, 435],
  },
  {
    genesis_token_id: 830,
    wearable_ids: [370, 412],
  },
  {
    genesis_token_id: 831,
    wearable_ids: [310, 301],
  },
  {
    genesis_token_id: 832,
    wearable_ids: [294, 369],
  },
  {
    genesis_token_id: 833,
    wearable_ids: [266, 358],
  },
  {
    genesis_token_id: 834,
    wearable_ids: [254, 304],
  },
  {
    genesis_token_id: 835,
    wearable_ids: [385, 360],
  },
  {
    genesis_token_id: 836,
    wearable_ids: [248, 402],
  },
  {
    genesis_token_id: 837,
    wearable_ids: [341, 278],
  },
  {
    genesis_token_id: 838,
    wearable_ids: [365, 372],
  },
  {
    genesis_token_id: 839,
    wearable_ids: [274, 331],
  },
  {
    genesis_token_id: 840,
    wearable_ids: [292, 294],
  },
  {
    genesis_token_id: 841,
    wearable_ids: [248, 346],
  },
  {
    genesis_token_id: 842,
    wearable_ids: [443, 374],
  },
  {
    genesis_token_id: 843,
    wearable_ids: [258, 423],
  },
  {
    genesis_token_id: 844,
    wearable_ids: [386, 365],
  },
  {
    genesis_token_id: 845,
    wearable_ids: [413, 343],
  },
  {
    genesis_token_id: 846,
    wearable_ids: [348, 365],
  },
  {
    genesis_token_id: 847,
    wearable_ids: [409, 271],
  },
  {
    genesis_token_id: 848,
    wearable_ids: [256, 315],
  },
  {
    genesis_token_id: 849,
    wearable_ids: [386, 395],
  },
  {
    genesis_token_id: 850,
    wearable_ids: [277, 431],
  },
  {
    genesis_token_id: 851,
    wearable_ids: [337, 372],
  },
  {
    genesis_token_id: 852,
    wearable_ids: [248, 378],
  },
  {
    genesis_token_id: 853,
    wearable_ids: [411, 395],
  },
  {
    genesis_token_id: 854,
    wearable_ids: [422, 300],
  },
  {
    genesis_token_id: 855,
    wearable_ids: [420, 369],
  },
  {
    genesis_token_id: 856,
    wearable_ids: [432, 266],
  },
  {
    genesis_token_id: 857,
    wearable_ids: [385, 349],
  },
  {
    genesis_token_id: 858,
    wearable_ids: [251, 264],
  },
  {
    genesis_token_id: 859,
    wearable_ids: [378, 432],
  },
  {
    genesis_token_id: 860,
    wearable_ids: [343, 290],
  },
  {
    genesis_token_id: 861,
    wearable_ids: [444, 424],
  },
  {
    genesis_token_id: 862,
    wearable_ids: [433, 286],
  },
  {
    genesis_token_id: 863,
    wearable_ids: [369, 349],
  },
  {
    genesis_token_id: 864,
    wearable_ids: [433, 372],
  },
  {
    genesis_token_id: 865,
    wearable_ids: [272, 373],
  },
  {
    genesis_token_id: 866,
    wearable_ids: [399, 443],
  },
  {
    genesis_token_id: 867,
    wearable_ids: [339, 301],
  },
  {
    genesis_token_id: 868,
    wearable_ids: [442, 255],
  },
  {
    genesis_token_id: 869,
    wearable_ids: [335, 435],
  },
  {
    genesis_token_id: 870,
    wearable_ids: [424, 273],
  },
  {
    genesis_token_id: 871,
    wearable_ids: [268, 388],
  },
  {
    genesis_token_id: 872,
    wearable_ids: [276, 292],
  },
  {
    genesis_token_id: 873,
    wearable_ids: [287, 442],
  },
  {
    genesis_token_id: 874,
    wearable_ids: [424, 384],
  },
  {
    genesis_token_id: 875,
    wearable_ids: [280, 410],
  },
  {
    genesis_token_id: 876,
    wearable_ids: [385, 442],
  },
  {
    genesis_token_id: 877,
    wearable_ids: [386, 254],
  },
  {
    genesis_token_id: 878,
    wearable_ids: [264, 394],
  },
  {
    genesis_token_id: 879,
    wearable_ids: [431, 378],
  },
  {
    genesis_token_id: 880,
    wearable_ids: [433, 424],
  },
  {
    genesis_token_id: 881,
    wearable_ids: [444, 422],
  },
  {
    genesis_token_id: 882,
    wearable_ids: [311, 260],
  },
  {
    genesis_token_id: 883,
    wearable_ids: [407, 248],
  },
  {
    genesis_token_id: 884,
    wearable_ids: [280, 405],
  },
  {
    genesis_token_id: 885,
    wearable_ids: [377, 280],
  },
  {
    genesis_token_id: 886,
    wearable_ids: [331, 345],
  },
  {
    genesis_token_id: 887,
    wearable_ids: [343, 248],
  },
  {
    genesis_token_id: 888,
    wearable_ids: [348, 426],
  },
  {
    genesis_token_id: 889,
    wearable_ids: [286, 427],
  },
  {
    genesis_token_id: 890,
    wearable_ids: [289, 436],
  },
  {
    genesis_token_id: 891,
    wearable_ids: [319, 400],
  },
  {
    genesis_token_id: 892,
    wearable_ids: [273, 330],
  },
  {
    genesis_token_id: 893,
    wearable_ids: [382, 286],
  },
  {
    genesis_token_id: 894,
    wearable_ids: [384, 420],
  },
  {
    genesis_token_id: 895,
    wearable_ids: [349, 373],
  },
  {
    genesis_token_id: 896,
    wearable_ids: [291, 332],
  },
  {
    genesis_token_id: 897,
    wearable_ids: [253, 314],
  },
  {
    genesis_token_id: 898,
    wearable_ids: [350, 422],
  },
  {
    genesis_token_id: 899,
    wearable_ids: [268, 295],
  },
  {
    genesis_token_id: 900,
    wearable_ids: [374, 256],
  },
  {
    genesis_token_id: 901,
    wearable_ids: [339, 305],
  },
  {
    genesis_token_id: 902,
    wearable_ids: [404, 332],
  },
  {
    genesis_token_id: 903,
    wearable_ids: [412, 267],
  },
  {
    genesis_token_id: 904,
    wearable_ids: [297, 248],
  },
  {
    genesis_token_id: 905,
    wearable_ids: [325, 424],
  },
  {
    genesis_token_id: 906,
    wearable_ids: [389, 348],
  },
  {
    genesis_token_id: 907,
    wearable_ids: [369, 405],
  },
  {
    genesis_token_id: 908,
    wearable_ids: [326, 285],
  },
  {
    genesis_token_id: 909,
    wearable_ids: [349, 343],
  },
  {
    genesis_token_id: 910,
    wearable_ids: [259, 294],
  },
  {
    genesis_token_id: 911,
    wearable_ids: [256, 283],
  },
  {
    genesis_token_id: 912,
    wearable_ids: [389, 440],
  },
  {
    genesis_token_id: 913,
    wearable_ids: [413, 361],
  },
  {
    genesis_token_id: 914,
    wearable_ids: [396, 392],
  },
  {
    genesis_token_id: 915,
    wearable_ids: [308, 425],
  },
  {
    genesis_token_id: 916,
    wearable_ids: [264, 371],
  },
  {
    genesis_token_id: 917,
    wearable_ids: [319, 296],
  },
  {
    genesis_token_id: 918,
    wearable_ids: [291, 280],
  },
  {
    genesis_token_id: 919,
    wearable_ids: [385, 357],
  },
  {
    genesis_token_id: 920,
    wearable_ids: [415, 301],
  },
  {
    genesis_token_id: 921,
    wearable_ids: [404, 407],
  },
  {
    genesis_token_id: 922,
    wearable_ids: [372, 287],
  },
  {
    genesis_token_id: 923,
    wearable_ids: [257, 433],
  },
  {
    genesis_token_id: 924,
    wearable_ids: [265, 373],
  },
  {
    genesis_token_id: 925,
    wearable_ids: [340, 356],
  },
  {
    genesis_token_id: 926,
    wearable_ids: [412, 423],
  },
  {
    genesis_token_id: 927,
    wearable_ids: [368, 286],
  },
  {
    genesis_token_id: 928,
    wearable_ids: [343, 442],
  },
  {
    genesis_token_id: 929,
    wearable_ids: [254, 337],
  },
  {
    genesis_token_id: 930,
    wearable_ids: [411, 254],
  },
  {
    genesis_token_id: 931,
    wearable_ids: [386, 429],
  },
  {
    genesis_token_id: 932,
    wearable_ids: [304, 387],
  },
  {
    genesis_token_id: 933,
    wearable_ids: [352, 383],
  },
  {
    genesis_token_id: 934,
    wearable_ids: [291, 354],
  },
  {
    genesis_token_id: 935,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 936,
    wearable_ids: [335, 344],
  },
  {
    genesis_token_id: 937,
    wearable_ids: [386, 269],
  },
  {
    genesis_token_id: 938,
    wearable_ids: [399, 287],
  },
  {
    genesis_token_id: 939,
    wearable_ids: [435, 332],
  },
  {
    genesis_token_id: 940,
    wearable_ids: [387, 256],
  },
  {
    genesis_token_id: 941,
    wearable_ids: [445, 442],
  },
  {
    genesis_token_id: 942,
    wearable_ids: [247, 291],
  },
  {
    genesis_token_id: 943,
    wearable_ids: [301, 420],
  },
  {
    genesis_token_id: 944,
    wearable_ids: [325, 326],
  },
  {
    genesis_token_id: 945,
    wearable_ids: [382, 272],
  },
  {
    genesis_token_id: 946,
    wearable_ids: [377, 267],
  },
  {
    genesis_token_id: 947,
    wearable_ids: [290, 272],
  },
  {
    genesis_token_id: 948,
    wearable_ids: [344, 347],
  },
  {
    genesis_token_id: 949,
    wearable_ids: [364, 342],
  },
  {
    genesis_token_id: 950,
    wearable_ids: [365, 290],
  },
  {
    genesis_token_id: 951,
    wearable_ids: [434, 277],
  },
  {
    genesis_token_id: 952,
    wearable_ids: [426, 394],
  },
  {
    genesis_token_id: 953,
    wearable_ids: [399, 276],
  },
  {
    genesis_token_id: 954,
    wearable_ids: [383, 333],
  },
  {
    genesis_token_id: 955,
    wearable_ids: [337, 294],
  },
  {
    genesis_token_id: 956,
    wearable_ids: [326, 300],
  },
  {
    genesis_token_id: 957,
    wearable_ids: [404, 383],
  },
  {
    genesis_token_id: 958,
    wearable_ids: [296, 345],
  },
  {
    genesis_token_id: 959,
    wearable_ids: [407, 435],
  },
  {
    genesis_token_id: 960,
    wearable_ids: [339, 308],
  },
  {
    genesis_token_id: 961,
    wearable_ids: [435, 271],
  },
  {
    genesis_token_id: 962,
    wearable_ids: [399, 280],
  },
  {
    genesis_token_id: 963,
    wearable_ids: [432, 345],
  },
  {
    genesis_token_id: 964,
    wearable_ids: [423, 322],
  },
  {
    genesis_token_id: 965,
    wearable_ids: [265, 371],
  },
  {
    genesis_token_id: 966,
    wearable_ids: [422, 259],
  },
  {
    genesis_token_id: 967,
    wearable_ids: [315, 415],
  },
  {
    genesis_token_id: 968,
    wearable_ids: [344, 384],
  },
  {
    genesis_token_id: 969,
    wearable_ids: [335, 442],
  },
  {
    genesis_token_id: 970,
    wearable_ids: [341, 441],
  },
  {
    genesis_token_id: 971,
    wearable_ids: [397, 352],
  },
  {
    genesis_token_id: 972,
    wearable_ids: [431, 325],
  },
  {
    genesis_token_id: 973,
    wearable_ids: [404, 352],
  },
  {
    genesis_token_id: 974,
    wearable_ids: [372, 404],
  },
  {
    genesis_token_id: 975,
    wearable_ids: [314, 396],
  },
  {
    genesis_token_id: 976,
    wearable_ids: [415, 294],
  },
  {
    genesis_token_id: 977,
    wearable_ids: [437, 257],
  },
  {
    genesis_token_id: 978,
    wearable_ids: [311, 327],
  },
  {
    genesis_token_id: 979,
    wearable_ids: [287, 254],
  },
  {
    genesis_token_id: 980,
    wearable_ids: [423, 341],
  },
  {
    genesis_token_id: 981,
    wearable_ids: [287, 389],
  },
  {
    genesis_token_id: 982,
    wearable_ids: [433, 338],
  },
  {
    genesis_token_id: 983,
    wearable_ids: [272, 319],
  },
  {
    genesis_token_id: 984,
    wearable_ids: [316, 419],
  },
  {
    genesis_token_id: 985,
    wearable_ids: [270, 428],
  },
  {
    genesis_token_id: 986,
    wearable_ids: [344, 362],
  },
  {
    genesis_token_id: 987,
    wearable_ids: [291, 263],
  },
  {
    genesis_token_id: 988,
    wearable_ids: [304, 408],
  },
  {
    genesis_token_id: 989,
    wearable_ids: [306, 268],
  },
  {
    genesis_token_id: 990,
    wearable_ids: [287, 246],
  },
  {
    genesis_token_id: 991,
    wearable_ids: [311, 428],
  },
  {
    genesis_token_id: 992,
    wearable_ids: [350, 428],
  },
  {
    genesis_token_id: 993,
    wearable_ids: [289, 258],
  },
  {
    genesis_token_id: 994,
    wearable_ids: [259, 399],
  },
  {
    genesis_token_id: 995,
    wearable_ids: [289, 413],
  },
  {
    genesis_token_id: 996,
    wearable_ids: [437, 254],
  },
  {
    genesis_token_id: 997,
    wearable_ids: [341, 262],
  },
  {
    genesis_token_id: 998,
    wearable_ids: [443, 415],
  },
  {
    genesis_token_id: 999,
    wearable_ids: [354, 317],
  },
  {
    genesis_token_id: 1000,
    wearable_ids: [292, 274],
  },
  {
    genesis_token_id: 1001,
    wearable_ids: [268, 257],
  },
  {
    genesis_token_id: 1002,
    wearable_ids: [287, 431],
  },
  {
    genesis_token_id: 1003,
    wearable_ids: [425, 407],
  },
  {
    genesis_token_id: 1004,
    wearable_ids: [268, 333],
  },
  {
    genesis_token_id: 1005,
    wearable_ids: [324, 303],
  },
  {
    genesis_token_id: 1006,
    wearable_ids: [436, 401],
  },
  {
    genesis_token_id: 1007,
    wearable_ids: [301, 253],
  },
  {
    genesis_token_id: 1008,
    wearable_ids: [412, 295],
  },
  {
    genesis_token_id: 1009,
    wearable_ids: [247, 320],
  },
  {
    genesis_token_id: 1010,
    wearable_ids: [403, 410],
  },
  {
    genesis_token_id: 1011,
    wearable_ids: [335, 375],
  },
  {
    genesis_token_id: 1012,
    wearable_ids: [300, 256],
  },
  {
    genesis_token_id: 1013,
    wearable_ids: [378, 432],
  },
  {
    genesis_token_id: 1014,
    wearable_ids: [396, 316],
  },
  {
    genesis_token_id: 1015,
    wearable_ids: [351, 280],
  },
  {
    genesis_token_id: 1016,
    wearable_ids: [409, 417],
  },
  {
    genesis_token_id: 1017,
    wearable_ids: [389, 366],
  },
  {
    genesis_token_id: 1018,
    wearable_ids: [316, 435],
  },
  {
    genesis_token_id: 1019,
    wearable_ids: [254, 366],
  },
  {
    genesis_token_id: 1020,
    wearable_ids: [368, 272],
  },
  {
    genesis_token_id: 1021,
    wearable_ids: [278, 417],
  },
  {
    genesis_token_id: 1022,
    wearable_ids: [412, 336],
  },
  {
    genesis_token_id: 1023,
    wearable_ids: [403, 392],
  },
  {
    genesis_token_id: 1024,
    wearable_ids: [319, 393],
  },
  {
    genesis_token_id: 1025,
    wearable_ids: [308, 377],
  },
  {
    genesis_token_id: 1026,
    wearable_ids: [337, 434],
  },
  {
    genesis_token_id: 1027,
    wearable_ids: [352, 294],
  },
  {
    genesis_token_id: 1028,
    wearable_ids: [284, 435],
  },
  {
    genesis_token_id: 1029,
    wearable_ids: [338, 258],
  },
  {
    genesis_token_id: 1030,
    wearable_ids: [352, 310],
  },
  {
    genesis_token_id: 1031,
    wearable_ids: [286, 306],
  },
  {
    genesis_token_id: 1032,
    wearable_ids: [376, 303],
  },
  {
    genesis_token_id: 1033,
    wearable_ids: [290, 443],
  },
  {
    genesis_token_id: 1034,
    wearable_ids: [303, 371],
  },
  {
    genesis_token_id: 1035,
    wearable_ids: [371, 315],
  },
  {
    genesis_token_id: 1036,
    wearable_ids: [265, 354],
  },
  {
    genesis_token_id: 1037,
    wearable_ids: [372, 263],
  },
  {
    genesis_token_id: 1038,
    wearable_ids: [445, 410],
  },
  {
    genesis_token_id: 1039,
    wearable_ids: [343, 254],
  },
  {
    genesis_token_id: 1040,
    wearable_ids: [415, 290],
  },
  {
    genesis_token_id: 1041,
    wearable_ids: [375, 348],
  },
  {
    genesis_token_id: 1042,
    wearable_ids: [395, 432],
  },
  {
    genesis_token_id: 1043,
    wearable_ids: [341, 258],
  },
  {
    genesis_token_id: 1044,
    wearable_ids: [326, 315],
  },
  {
    genesis_token_id: 1045,
    wearable_ids: [315, 356],
  },
  {
    genesis_token_id: 1046,
    wearable_ids: [262, 369],
  },
  {
    genesis_token_id: 1047,
    wearable_ids: [411, 265],
  },
  {
    genesis_token_id: 1048,
    wearable_ids: [271, 374],
  },
  {
    genesis_token_id: 1049,
    wearable_ids: [341, 326],
  },
  {
    genesis_token_id: 1050,
    wearable_ids: [404, 292],
  },
  {
    genesis_token_id: 1051,
    wearable_ids: [364, 359],
  },
  {
    genesis_token_id: 1052,
    wearable_ids: [331, 412],
  },
  {
    genesis_token_id: 1053,
    wearable_ids: [422, 297],
  },
  {
    genesis_token_id: 1054,
    wearable_ids: [363, 314],
  },
  {
    genesis_token_id: 1055,
    wearable_ids: [289, 298],
  },
  {
    genesis_token_id: 1056,
    wearable_ids: [410, 413],
  },
  {
    genesis_token_id: 1057,
    wearable_ids: [311, 343],
  },
  {
    genesis_token_id: 1058,
    wearable_ids: [300, 251],
  },
  {
    genesis_token_id: 1059,
    wearable_ids: [311, 394],
  },
  {
    genesis_token_id: 1060,
    wearable_ids: [300, 294],
  },
  {
    genesis_token_id: 1061,
    wearable_ids: [349, 344],
  },
  {
    genesis_token_id: 1062,
    wearable_ids: [263, 301],
  },
  {
    genesis_token_id: 1063,
    wearable_ids: [300, 394],
  },
  {
    genesis_token_id: 1064,
    wearable_ids: [296, 277],
  },
  {
    genesis_token_id: 1065,
    wearable_ids: [337, 344],
  },
  {
    genesis_token_id: 1066,
    wearable_ids: [253, 259],
  },
  {
    genesis_token_id: 1067,
    wearable_ids: [343, 409],
  },
  {
    genesis_token_id: 1068,
    wearable_ids: [350, 254],
  },
  {
    genesis_token_id: 1069,
    wearable_ids: [296, 276],
  },
  {
    genesis_token_id: 1070,
    wearable_ids: [256, 299],
  },
  {
    genesis_token_id: 1071,
    wearable_ids: [308, 386],
  },
  {
    genesis_token_id: 1072,
    wearable_ids: [286, 320],
  },
  {
    genesis_token_id: 1073,
    wearable_ids: [411, 369],
  },
  {
    genesis_token_id: 1074,
    wearable_ids: [412, 409],
  },
  {
    genesis_token_id: 1075,
    wearable_ids: [396, 298],
  },
  {
    genesis_token_id: 1076,
    wearable_ids: [296, 412],
  },
  {
    genesis_token_id: 1077,
    wearable_ids: [326, 343],
  },
  {
    genesis_token_id: 1078,
    wearable_ids: [291, 300],
  },
  {
    genesis_token_id: 1079,
    wearable_ids: [411, 422],
  },
  {
    genesis_token_id: 1080,
    wearable_ids: [389, 361],
  },
  {
    genesis_token_id: 1081,
    wearable_ids: [432, 385],
  },
  {
    genesis_token_id: 1082,
    wearable_ids: [259, 356],
  },
  {
    genesis_token_id: 1083,
    wearable_ids: [429, 444],
  },
  {
    genesis_token_id: 1084,
    wearable_ids: [259, 362],
  },
  {
    genesis_token_id: 1085,
    wearable_ids: [280, 429],
  },
  {
    genesis_token_id: 1086,
    wearable_ids: [262, 348],
  },
  {
    genesis_token_id: 1087,
    wearable_ids: [277, 388],
  },
  {
    genesis_token_id: 1088,
    wearable_ids: [286, 368],
  },
  {
    genesis_token_id: 1089,
    wearable_ids: [301, 305],
  },
  {
    genesis_token_id: 1090,
    wearable_ids: [317, 280],
  },
  {
    genesis_token_id: 1091,
    wearable_ids: [266, 431],
  },
  {
    genesis_token_id: 1092,
    wearable_ids: [364, 433],
  },
  {
    genesis_token_id: 1093,
    wearable_ids: [369, 332],
  },
  {
    genesis_token_id: 1094,
    wearable_ids: [443, 435],
  },
  {
    genesis_token_id: 1095,
    wearable_ids: [387, 325],
  },
  {
    genesis_token_id: 1096,
    wearable_ids: [319, 416],
  },
  {
    genesis_token_id: 1097,
    wearable_ids: [354, 297],
  },
  {
    genesis_token_id: 1098,
    wearable_ids: [368, 364],
  },
  {
    genesis_token_id: 1099,
    wearable_ids: [408, 420],
  },
  {
    genesis_token_id: 1100,
    wearable_ids: [433, 436],
  },
  {
    genesis_token_id: 1101,
    wearable_ids: [399, 272],
  },
  {
    genesis_token_id: 1102,
    wearable_ids: [290, 334],
  },
  {
    genesis_token_id: 1103,
    wearable_ids: [319, 414],
  },
  {
    genesis_token_id: 1104,
    wearable_ids: [352, 260],
  },
  {
    genesis_token_id: 1105,
    wearable_ids: [410, 372],
  },
  {
    genesis_token_id: 1106,
    wearable_ids: [316, 342],
  },
  {
    genesis_token_id: 1107,
    wearable_ids: [344, 400],
  },
  {
    genesis_token_id: 1108,
    wearable_ids: [258, 395],
  },
  {
    genesis_token_id: 1109,
    wearable_ids: [395, 420],
  },
  {
    genesis_token_id: 1110,
    wearable_ids: [433, 263],
  },
  {
    genesis_token_id: 1111,
    wearable_ids: [259, 256],
  },
  {
    genesis_token_id: 1112,
    wearable_ids: [338, 414],
  },
  {
    genesis_token_id: 1113,
    wearable_ids: [300, 349],
  },
  {
    genesis_token_id: 1114,
    wearable_ids: [278, 409],
  },
  {
    genesis_token_id: 1115,
    wearable_ids: [354, 398],
  },
  {
    genesis_token_id: 1116,
    wearable_ids: [248, 277],
  },
  {
    genesis_token_id: 1117,
    wearable_ids: [257, 355],
  },
  {
    genesis_token_id: 1118,
    wearable_ids: [407, 331],
  },
  {
    genesis_token_id: 1119,
    wearable_ids: [431, 377],
  },
  {
    genesis_token_id: 1120,
    wearable_ids: [384, 266],
  },
  {
    genesis_token_id: 1121,
    wearable_ids: [287, 366],
  },
  {
    genesis_token_id: 1122,
    wearable_ids: [274, 315],
  },
  {
    genesis_token_id: 1123,
    wearable_ids: [437, 267],
  },
  {
    genesis_token_id: 1124,
    wearable_ids: [337, 429],
  },
  {
    genesis_token_id: 1125,
    wearable_ids: [436, 435],
  },
  {
    genesis_token_id: 1126,
    wearable_ids: [300, 247],
  },
  {
    genesis_token_id: 1127,
    wearable_ids: [265, 415],
  },
  {
    genesis_token_id: 1128,
    wearable_ids: [296, 262],
  },
  {
    genesis_token_id: 1129,
    wearable_ids: [363, 258],
  },
  {
    genesis_token_id: 1130,
    wearable_ids: [284, 430],
  },
  {
    genesis_token_id: 1131,
    wearable_ids: [389, 257],
  },
  {
    genesis_token_id: 1132,
    wearable_ids: [255, 270],
  },
  {
    genesis_token_id: 1133,
    wearable_ids: [384, 253],
  },
  {
    genesis_token_id: 1134,
    wearable_ids: [432, 443],
  },
  {
    genesis_token_id: 1135,
    wearable_ids: [291, 376],
  },
  {
    genesis_token_id: 1136,
    wearable_ids: [433, 247],
  },
  {
    genesis_token_id: 1137,
    wearable_ids: [301, 347],
  },
  {
    genesis_token_id: 1138,
    wearable_ids: [304, 346],
  },
  {
    genesis_token_id: 1139,
    wearable_ids: [374, 354],
  },
  {
    genesis_token_id: 1140,
    wearable_ids: [435, 302],
  },
  {
    genesis_token_id: 1141,
    wearable_ids: [442, 291],
  },
  {
    genesis_token_id: 1142,
    wearable_ids: [395, 248],
  },
  {
    genesis_token_id: 1143,
    wearable_ids: [343, 419],
  },
  {
    genesis_token_id: 1144,
    wearable_ids: [262, 401],
  },
  {
    genesis_token_id: 1145,
    wearable_ids: [386, 295],
  },
  {
    genesis_token_id: 1146,
    wearable_ids: [411, 444],
  },
  {
    genesis_token_id: 1147,
    wearable_ids: [292, 326],
  },
  {
    genesis_token_id: 1148,
    wearable_ids: [272, 350],
  },
  {
    genesis_token_id: 1149,
    wearable_ids: [258, 301],
  },
  {
    genesis_token_id: 1150,
    wearable_ids: [291, 284],
  },
  {
    genesis_token_id: 1151,
    wearable_ids: [444, 424],
  },
  {
    genesis_token_id: 1152,
    wearable_ids: [375, 395],
  },
  {
    genesis_token_id: 1153,
    wearable_ids: [336, 273],
  },
  {
    genesis_token_id: 1154,
    wearable_ids: [317, 372],
  },
  {
    genesis_token_id: 1155,
    wearable_ids: [290, 274],
  },
  {
    genesis_token_id: 1156,
    wearable_ids: [400, 424],
  },
  {
    genesis_token_id: 1157,
    wearable_ids: [355, 378],
  },
  {
    genesis_token_id: 1158,
    wearable_ids: [341, 352],
  },
  {
    genesis_token_id: 1159,
    wearable_ids: [336, 258],
  },
  {
    genesis_token_id: 1160,
    wearable_ids: [344, 375],
  },
  {
    genesis_token_id: 1161,
    wearable_ids: [375, 398],
  },
  {
    genesis_token_id: 1162,
    wearable_ids: [306, 259],
  },
  {
    genesis_token_id: 1163,
    wearable_ids: [319, 338],
  },
  {
    genesis_token_id: 1164,
    wearable_ids: [372, 315],
  },
  {
    genesis_token_id: 1165,
    wearable_ids: [290, 371],
  },
  {
    genesis_token_id: 1166,
    wearable_ids: [266, 280],
  },
  {
    genesis_token_id: 1167,
    wearable_ids: [371, 374],
  },
  {
    genesis_token_id: 1168,
    wearable_ids: [429, 303],
  },
  {
    genesis_token_id: 1169,
    wearable_ids: [247, 425],
  },
  {
    genesis_token_id: 1170,
    wearable_ids: [424, 412],
  },
  {
    genesis_token_id: 1171,
    wearable_ids: [264, 318],
  },
  {
    genesis_token_id: 1172,
    wearable_ids: [286, 368],
  },
  {
    genesis_token_id: 1173,
    wearable_ids: [386, 270],
  },
  {
    genesis_token_id: 1174,
    wearable_ids: [337, 315],
  },
  {
    genesis_token_id: 1175,
    wearable_ids: [408, 273],
  },
  {
    genesis_token_id: 1176,
    wearable_ids: [375, 373],
  },
  {
    genesis_token_id: 1177,
    wearable_ids: [397, 373],
  },
  {
    genesis_token_id: 1178,
    wearable_ids: [387, 334],
  },
  {
    genesis_token_id: 1179,
    wearable_ids: [442, 443],
  },
  {
    genesis_token_id: 1180,
    wearable_ids: [373, 312],
  },
  {
    genesis_token_id: 1181,
    wearable_ids: [352, 364],
  },
  {
    genesis_token_id: 1182,
    wearable_ids: [314, 263],
  },
  {
    genesis_token_id: 1183,
    wearable_ids: [376, 406],
  },
  {
    genesis_token_id: 1184,
    wearable_ids: [436, 263],
  },
  {
    genesis_token_id: 1185,
    wearable_ids: [338, 377],
  },
  {
    genesis_token_id: 1186,
    wearable_ids: [256, 409],
  },
  {
    genesis_token_id: 1187,
    wearable_ids: [396, 324],
  },
  {
    genesis_token_id: 1188,
    wearable_ids: [422, 333],
  },
  {
    genesis_token_id: 1189,
    wearable_ids: [264, 407],
  },
  {
    genesis_token_id: 1190,
    wearable_ids: [315, 341],
  },
  {
    genesis_token_id: 1191,
    wearable_ids: [274, 441],
  },
  {
    genesis_token_id: 1192,
    wearable_ids: [384, 387],
  },
  {
    genesis_token_id: 1193,
    wearable_ids: [434, 336],
  },
  {
    genesis_token_id: 1194,
    wearable_ids: [336, 335],
  },
  {
    genesis_token_id: 1195,
    wearable_ids: [372, 277],
  },
  {
    genesis_token_id: 1196,
    wearable_ids: [415, 273],
  },
  {
    genesis_token_id: 1197,
    wearable_ids: [443, 369],
  },
  {
    genesis_token_id: 1198,
    wearable_ids: [286, 301],
  },
  {
    genesis_token_id: 1199,
    wearable_ids: [352, 339],
  },
  {
    genesis_token_id: 1200,
    wearable_ids: [365, 248],
  },
  {
    genesis_token_id: 1201,
    wearable_ids: [370, 280],
  },
  {
    genesis_token_id: 1202,
    wearable_ids: [297, 253],
  },
  {
    genesis_token_id: 1203,
    wearable_ids: [348, 368],
  },
  {
    genesis_token_id: 1204,
    wearable_ids: [371, 310],
  },
  {
    genesis_token_id: 1205,
    wearable_ids: [341, 442],
  },
  {
    genesis_token_id: 1206,
    wearable_ids: [286, 397],
  },
  {
    genesis_token_id: 1207,
    wearable_ids: [256, 348],
  },
  {
    genesis_token_id: 1208,
    wearable_ids: [374, 441],
  },
  {
    genesis_token_id: 1209,
    wearable_ids: [429, 314],
  },
  {
    genesis_token_id: 1210,
    wearable_ids: [344, 259],
  },
  {
    genesis_token_id: 1211,
    wearable_ids: [415, 270],
  },
  {
    genesis_token_id: 1212,
    wearable_ids: [397, 411],
  },
  {
    genesis_token_id: 1213,
    wearable_ids: [253, 400],
  },
  {
    genesis_token_id: 1214,
    wearable_ids: [344, 353],
  },
  {
    genesis_token_id: 1215,
    wearable_ids: [384, 403],
  },
  {
    genesis_token_id: 1216,
    wearable_ids: [289, 341],
  },
  {
    genesis_token_id: 1217,
    wearable_ids: [426, 368],
  },
  {
    genesis_token_id: 1218,
    wearable_ids: [443, 349],
  },
  {
    genesis_token_id: 1219,
    wearable_ids: [385, 312],
  },
  {
    genesis_token_id: 1220,
    wearable_ids: [292, 275],
  },
  {
    genesis_token_id: 1221,
    wearable_ids: [324, 266],
  },
  {
    genesis_token_id: 1222,
    wearable_ids: [429, 341],
  },
  {
    genesis_token_id: 1223,
    wearable_ids: [291, 408],
  },
  {
    genesis_token_id: 1224,
    wearable_ids: [337, 433],
  },
  {
    genesis_token_id: 1225,
    wearable_ids: [324, 382],
  },
  {
    genesis_token_id: 1226,
    wearable_ids: [350, 370],
  },
  {
    genesis_token_id: 1227,
    wearable_ids: [315, 433],
  },
  {
    genesis_token_id: 1228,
    wearable_ids: [437, 377],
  },
  {
    genesis_token_id: 1229,
    wearable_ids: [296, 405],
  },
  {
    genesis_token_id: 1230,
    wearable_ids: [315, 395],
  },
  {
    genesis_token_id: 1231,
    wearable_ids: [319, 435],
  },
  {
    genesis_token_id: 1232,
    wearable_ids: [382, 377],
  },
  {
    genesis_token_id: 1233,
    wearable_ids: [399, 308],
  },
  {
    genesis_token_id: 1234,
    wearable_ids: [274, 384],
  },
  {
    genesis_token_id: 1235,
    wearable_ids: [432, 270],
  },
  {
    genesis_token_id: 1236,
    wearable_ids: [399, 389],
  },
  {
    genesis_token_id: 1237,
    wearable_ids: [437, 268],
  },
  {
    genesis_token_id: 1238,
    wearable_ids: [377, 326],
  },
  {
    genesis_token_id: 1239,
    wearable_ids: [429, 260],
  },
  {
    genesis_token_id: 1240,
    wearable_ids: [444, 365],
  },
  {
    genesis_token_id: 1241,
    wearable_ids: [383, 406],
  },
  {
    genesis_token_id: 1242,
    wearable_ids: [289, 444],
  },
  {
    genesis_token_id: 1243,
    wearable_ids: [351, 394],
  },
  {
    genesis_token_id: 1244,
    wearable_ids: [411, 433],
  },
  {
    genesis_token_id: 1245,
    wearable_ids: [351, 436],
  },
  {
    genesis_token_id: 1246,
    wearable_ids: [444, 290],
  },
  {
    genesis_token_id: 1247,
    wearable_ids: [301, 406],
  },
  {
    genesis_token_id: 1248,
    wearable_ids: [442, 401],
  },
  {
    genesis_token_id: 1249,
    wearable_ids: [273, 423],
  },
  {
    genesis_token_id: 1250,
    wearable_ids: [315, 273],
  },
  {
    genesis_token_id: 1251,
    wearable_ids: [289, 342],
  },
  {
    genesis_token_id: 1252,
    wearable_ids: [373, 247],
  },
  {
    genesis_token_id: 1253,
    wearable_ids: [412, 354],
  },
  {
    genesis_token_id: 1254,
    wearable_ids: [268, 290],
  },
  {
    genesis_token_id: 1255,
    wearable_ids: [310, 304],
  },
  {
    genesis_token_id: 1256,
    wearable_ids: [253, 391],
  },
  {
    genesis_token_id: 1257,
    wearable_ids: [374, 260],
  },
  {
    genesis_token_id: 1258,
    wearable_ids: [347, 315],
  },
  {
    genesis_token_id: 1259,
    wearable_ids: [253, 422],
  },
  {
    genesis_token_id: 1260,
    wearable_ids: [295, 273],
  },
  {
    genesis_token_id: 1261,
    wearable_ids: [268, 355],
  },
  {
    genesis_token_id: 1262,
    wearable_ids: [247, 358],
  },
  {
    genesis_token_id: 1263,
    wearable_ids: [346, 424],
  },
  {
    genesis_token_id: 1264,
    wearable_ids: [262, 363],
  },
  {
    genesis_token_id: 1265,
    wearable_ids: [383, 427],
  },
  {
    genesis_token_id: 1266,
    wearable_ids: [432, 274],
  },
  {
    genesis_token_id: 1267,
    wearable_ids: [431, 297],
  },
  {
    genesis_token_id: 1268,
    wearable_ids: [271, 351],
  },
  {
    genesis_token_id: 1269,
    wearable_ids: [371, 346],
  },
  {
    genesis_token_id: 1270,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 1271,
    wearable_ids: [342, 435],
  },
  {
    genesis_token_id: 1272,
    wearable_ids: [408, 337],
  },
  {
    genesis_token_id: 1273,
    wearable_ids: [382, 423],
  },
  {
    genesis_token_id: 1274,
    wearable_ids: [335, 420],
  },
  {
    genesis_token_id: 1275,
    wearable_ids: [355, 343],
  },
  {
    genesis_token_id: 1276,
    wearable_ids: [324, 429],
  },
  {
    genesis_token_id: 1277,
    wearable_ids: [375, 432],
  },
  {
    genesis_token_id: 1278,
    wearable_ids: [300, 386],
  },
  {
    genesis_token_id: 1279,
    wearable_ids: [277, 268],
  },
  {
    genesis_token_id: 1280,
    wearable_ids: [317, 319],
  },
  {
    genesis_token_id: 1281,
    wearable_ids: [264, 308],
  },
  {
    genesis_token_id: 1282,
    wearable_ids: [408, 265],
  },
  {
    genesis_token_id: 1283,
    wearable_ids: [299, 272],
  },
  {
    genesis_token_id: 1284,
    wearable_ids: [253, 371],
  },
  {
    genesis_token_id: 1285,
    wearable_ids: [376, 296],
  },
  {
    genesis_token_id: 1286,
    wearable_ids: [352, 354],
  },
  {
    genesis_token_id: 1287,
    wearable_ids: [378, 433],
  },
  {
    genesis_token_id: 1288,
    wearable_ids: [335, 331],
  },
  {
    genesis_token_id: 1289,
    wearable_ids: [368, 297],
  },
  {
    genesis_token_id: 1290,
    wearable_ids: [407, 284],
  },
  {
    genesis_token_id: 1291,
    wearable_ids: [415, 426],
  },
  {
    genesis_token_id: 1292,
    wearable_ids: [376, 364],
  },
  {
    genesis_token_id: 1293,
    wearable_ids: [286, 320],
  },
  {
    genesis_token_id: 1294,
    wearable_ids: [290, 254],
  },
  {
    genesis_token_id: 1295,
    wearable_ids: [442, 374],
  },
  {
    genesis_token_id: 1296,
    wearable_ids: [375, 445],
  },
  {
    genesis_token_id: 1297,
    wearable_ids: [315, 344],
  },
  {
    genesis_token_id: 1298,
    wearable_ids: [384, 278],
  },
  {
    genesis_token_id: 1299,
    wearable_ids: [434, 388],
  },
  {
    genesis_token_id: 1300,
    wearable_ids: [422, 262],
  },
  {
    genesis_token_id: 1301,
    wearable_ids: [413, 402],
  },
  {
    genesis_token_id: 1302,
    wearable_ids: [295, 257],
  },
  {
    genesis_token_id: 1303,
    wearable_ids: [352, 277],
  },
  {
    genesis_token_id: 1304,
    wearable_ids: [277, 308],
  },
  {
    genesis_token_id: 1305,
    wearable_ids: [354, 293],
  },
  {
    genesis_token_id: 1306,
    wearable_ids: [344, 363],
  },
  {
    genesis_token_id: 1307,
    wearable_ids: [362, 426],
  },
  {
    genesis_token_id: 1308,
    wearable_ids: [372, 253],
  },
  {
    genesis_token_id: 1309,
    wearable_ids: [397, 319],
  },
  {
    genesis_token_id: 1310,
    wearable_ids: [266, 289],
  },
  {
    genesis_token_id: 1311,
    wearable_ids: [395, 362],
  },
  {
    genesis_token_id: 1312,
    wearable_ids: [266, 359],
  },
  {
    genesis_token_id: 1313,
    wearable_ids: [437, 386],
  },
  {
    genesis_token_id: 1314,
    wearable_ids: [351, 299],
  },
  {
    genesis_token_id: 1315,
    wearable_ids: [335, 426],
  },
  {
    genesis_token_id: 1316,
    wearable_ids: [291, 416],
  },
  {
    genesis_token_id: 1317,
    wearable_ids: [395, 297],
  },
  {
    genesis_token_id: 1318,
    wearable_ids: [370, 308],
  },
  {
    genesis_token_id: 1319,
    wearable_ids: [339, 386],
  },
  {
    genesis_token_id: 1320,
    wearable_ids: [442, 312],
  },
  {
    genesis_token_id: 1321,
    wearable_ids: [370, 306],
  },
  {
    genesis_token_id: 1322,
    wearable_ids: [370, 271],
  },
  {
    genesis_token_id: 1323,
    wearable_ids: [375, 323],
  },
  {
    genesis_token_id: 1324,
    wearable_ids: [375, 295],
  },
  {
    genesis_token_id: 1325,
    wearable_ids: [335, 306],
  },
  {
    genesis_token_id: 1326,
    wearable_ids: [290, 284],
  },
  {
    genesis_token_id: 1327,
    wearable_ids: [375, 404],
  },
  {
    genesis_token_id: 1328,
    wearable_ids: [272, 306],
  },
  {
    genesis_token_id: 1329,
    wearable_ids: [324, 251],
  },
  {
    genesis_token_id: 1330,
    wearable_ids: [304, 434],
  },
  {
    genesis_token_id: 1331,
    wearable_ids: [376, 295],
  },
  {
    genesis_token_id: 1332,
    wearable_ids: [395, 292],
  },
  {
    genesis_token_id: 1333,
    wearable_ids: [347, 319],
  },
  {
    genesis_token_id: 1334,
    wearable_ids: [409, 268],
  },
  {
    genesis_token_id: 1335,
    wearable_ids: [272, 433],
  },
  {
    genesis_token_id: 1336,
    wearable_ids: [296, 346],
  },
  {
    genesis_token_id: 1337,
    wearable_ids: [290, 410],
  },
  {
    genesis_token_id: 1338,
    wearable_ids: [431, 247],
  },
  {
    genesis_token_id: 1339,
    wearable_ids: [413, 339],
  },
  {
    genesis_token_id: 1340,
    wearable_ids: [316, 413],
  },
  {
    genesis_token_id: 1341,
    wearable_ids: [346, 349],
  },
  {
    genesis_token_id: 1342,
    wearable_ids: [411, 294],
  },
  {
    genesis_token_id: 1343,
    wearable_ids: [420, 441],
  },
  {
    genesis_token_id: 1344,
    wearable_ids: [346, 391],
  },
  {
    genesis_token_id: 1345,
    wearable_ids: [265, 257],
  },
  {
    genesis_token_id: 1346,
    wearable_ids: [407, 424],
  },
  {
    genesis_token_id: 1347,
    wearable_ids: [422, 268],
  },
  {
    genesis_token_id: 1348,
    wearable_ids: [271, 348],
  },
  {
    genesis_token_id: 1349,
    wearable_ids: [308, 385],
  },
  {
    genesis_token_id: 1350,
    wearable_ids: [385, 307],
  },
  {
    genesis_token_id: 1351,
    wearable_ids: [265, 382],
  },
  {
    genesis_token_id: 1352,
    wearable_ids: [287, 384],
  },
  {
    genesis_token_id: 1353,
    wearable_ids: [413, 365],
  },
  {
    genesis_token_id: 1354,
    wearable_ids: [382, 299],
  },
  {
    genesis_token_id: 1355,
    wearable_ids: [253, 436],
  },
  {
    genesis_token_id: 1356,
    wearable_ids: [294, 349],
  },
  {
    genesis_token_id: 1357,
    wearable_ids: [337, 411],
  },
  {
    genesis_token_id: 1358,
    wearable_ids: [272, 292],
  },
  {
    genesis_token_id: 1359,
    wearable_ids: [399, 352],
  },
  {
    genesis_token_id: 1360,
    wearable_ids: [444, 316],
  },
  {
    genesis_token_id: 1361,
    wearable_ids: [326, 334],
  },
  {
    genesis_token_id: 1362,
    wearable_ids: [383, 290],
  },
  {
    genesis_token_id: 1363,
    wearable_ids: [325, 296],
  },
  {
    genesis_token_id: 1364,
    wearable_ids: [370, 294],
  },
  {
    genesis_token_id: 1365,
    wearable_ids: [271, 352],
  },
  {
    genesis_token_id: 1366,
    wearable_ids: [442, 257],
  },
  {
    genesis_token_id: 1367,
    wearable_ids: [331, 284],
  },
  {
    genesis_token_id: 1368,
    wearable_ids: [306, 263],
  },
  {
    genesis_token_id: 1369,
    wearable_ids: [299, 286],
  },
  {
    genesis_token_id: 1370,
    wearable_ids: [429, 363],
  },
  {
    genesis_token_id: 1371,
    wearable_ids: [376, 416],
  },
  {
    genesis_token_id: 1372,
    wearable_ids: [342, 306],
  },
  {
    genesis_token_id: 1373,
    wearable_ids: [294, 263],
  },
  {
    genesis_token_id: 1374,
    wearable_ids: [406, 316],
  },
  {
    genesis_token_id: 1375,
    wearable_ids: [299, 318],
  },
  {
    genesis_token_id: 1376,
    wearable_ids: [297, 319],
  },
  {
    genesis_token_id: 1377,
    wearable_ids: [308, 422],
  },
  {
    genesis_token_id: 1378,
    wearable_ids: [306, 310],
  },
  {
    genesis_token_id: 1379,
    wearable_ids: [434, 382],
  },
  {
    genesis_token_id: 1380,
    wearable_ids: [251, 385],
  },
  {
    genesis_token_id: 1381,
    wearable_ids: [372, 335],
  },
  {
    genesis_token_id: 1382,
    wearable_ids: [443, 339],
  },
  {
    genesis_token_id: 1383,
    wearable_ids: [349, 366],
  },
  {
    genesis_token_id: 1384,
    wearable_ids: [316, 343],
  },
  {
    genesis_token_id: 1385,
    wearable_ids: [264, 370],
  },
  {
    genesis_token_id: 1386,
    wearable_ids: [296, 278],
  },
  {
    genesis_token_id: 1387,
    wearable_ids: [395, 253],
  },
  {
    genesis_token_id: 1388,
    wearable_ids: [420, 298],
  },
  {
    genesis_token_id: 1389,
    wearable_ids: [338, 425],
  },
  {
    genesis_token_id: 1390,
    wearable_ids: [351, 258],
  },
  {
    genesis_token_id: 1391,
    wearable_ids: [436, 395],
  },
  {
    genesis_token_id: 1392,
    wearable_ids: [406, 415],
  },
  {
    genesis_token_id: 1393,
    wearable_ids: [332, 277],
  },
  {
    genesis_token_id: 1394,
    wearable_ids: [355, 442],
  },
  {
    genesis_token_id: 1395,
    wearable_ids: [262, 268],
  },
  {
    genesis_token_id: 1396,
    wearable_ids: [317, 408],
  },
  {
    genesis_token_id: 1397,
    wearable_ids: [411, 266],
  },
  {
    genesis_token_id: 1398,
    wearable_ids: [389, 292],
  },
  {
    genesis_token_id: 1399,
    wearable_ids: [382, 297],
  },
  {
    genesis_token_id: 1400,
    wearable_ids: [258, 394],
  },
  {
    genesis_token_id: 1401,
    wearable_ids: [311, 325],
  },
  {
    genesis_token_id: 1402,
    wearable_ids: [409, 272],
  },
  {
    genesis_token_id: 1403,
    wearable_ids: [326, 436],
  },
  {
    genesis_token_id: 1404,
    wearable_ids: [335, 407],
  },
  {
    genesis_token_id: 1405,
    wearable_ids: [442, 289],
  },
  {
    genesis_token_id: 1406,
    wearable_ids: [383, 287],
  },
  {
    genesis_token_id: 1407,
    wearable_ids: [425, 355],
  },
  {
    genesis_token_id: 1408,
    wearable_ids: [424, 347],
  },
  {
    genesis_token_id: 1409,
    wearable_ids: [369, 315],
  },
  {
    genesis_token_id: 1410,
    wearable_ids: [259, 287],
  },
  {
    genesis_token_id: 1411,
    wearable_ids: [400, 352],
  },
  {
    genesis_token_id: 1412,
    wearable_ids: [292, 250],
  },
  {
    genesis_token_id: 1413,
    wearable_ids: [346, 260],
  },
  {
    genesis_token_id: 1414,
    wearable_ids: [428, 415],
  },
  {
    genesis_token_id: 1415,
    wearable_ids: [276, 253],
  },
  {
    genesis_token_id: 1416,
    wearable_ids: [311, 402],
  },
  {
    genesis_token_id: 1417,
    wearable_ids: [349, 389],
  },
  {
    genesis_token_id: 1418,
    wearable_ids: [396, 258],
  },
  {
    genesis_token_id: 1419,
    wearable_ids: [247, 353],
  },
  {
    genesis_token_id: 1420,
    wearable_ids: [304, 431],
  },
  {
    genesis_token_id: 1421,
    wearable_ids: [434, 341],
  },
  {
    genesis_token_id: 1422,
    wearable_ids: [387, 314],
  },
  {
    genesis_token_id: 1423,
    wearable_ids: [425, 389],
  },
  {
    genesis_token_id: 1424,
    wearable_ids: [376, 328],
  },
  {
    genesis_token_id: 1425,
    wearable_ids: [247, 299],
  },
  {
    genesis_token_id: 1426,
    wearable_ids: [364, 385],
  },
  {
    genesis_token_id: 1427,
    wearable_ids: [432, 300],
  },
  {
    genesis_token_id: 1428,
    wearable_ids: [342, 270],
  },
  {
    genesis_token_id: 1429,
    wearable_ids: [270, 295],
  },
  {
    genesis_token_id: 1430,
    wearable_ids: [335, 323],
  },
  {
    genesis_token_id: 1431,
    wearable_ids: [443, 434],
  },
  {
    genesis_token_id: 1432,
    wearable_ids: [406, 355],
  },
  {
    genesis_token_id: 1433,
    wearable_ids: [264, 297],
  },
  {
    genesis_token_id: 1434,
    wearable_ids: [411, 343],
  },
  {
    genesis_token_id: 1435,
    wearable_ids: [408, 258],
  },
  {
    genesis_token_id: 1436,
    wearable_ids: [297, 332],
  },
  {
    genesis_token_id: 1437,
    wearable_ids: [344, 312],
  },
  {
    genesis_token_id: 1438,
    wearable_ids: [429, 411],
  },
  {
    genesis_token_id: 1439,
    wearable_ids: [346, 410],
  },
  {
    genesis_token_id: 1440,
    wearable_ids: [247, 340],
  },
  {
    genesis_token_id: 1441,
    wearable_ids: [273, 370],
  },
  {
    genesis_token_id: 1442,
    wearable_ids: [443, 360],
  },
  {
    genesis_token_id: 1443,
    wearable_ids: [287, 325],
  },
  {
    genesis_token_id: 1444,
    wearable_ids: [286, 373],
  },
  {
    genesis_token_id: 1445,
    wearable_ids: [264, 408],
  },
  {
    genesis_token_id: 1446,
    wearable_ids: [411, 336],
  },
  {
    genesis_token_id: 1447,
    wearable_ids: [270, 248],
  },
  {
    genesis_token_id: 1448,
    wearable_ids: [296, 390],
  },
  {
    genesis_token_id: 1449,
    wearable_ids: [339, 445],
  },
  {
    genesis_token_id: 1450,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 1451,
    wearable_ids: [335, 433],
  },
  {
    genesis_token_id: 1452,
    wearable_ids: [319, 428],
  },
  {
    genesis_token_id: 1453,
    wearable_ids: [284, 431],
  },
  {
    genesis_token_id: 1454,
    wearable_ids: [397, 324],
  },
  {
    genesis_token_id: 1455,
    wearable_ids: [395, 247],
  },
  {
    genesis_token_id: 1456,
    wearable_ids: [431, 293],
  },
  {
    genesis_token_id: 1457,
    wearable_ids: [377, 259],
  },
  {
    genesis_token_id: 1458,
    wearable_ids: [364, 341],
  },
  {
    genesis_token_id: 1459,
    wearable_ids: [253, 442],
  },
  {
    genesis_token_id: 1460,
    wearable_ids: [420, 442],
  },
  {
    genesis_token_id: 1461,
    wearable_ids: [284, 406],
  },
  {
    genesis_token_id: 1462,
    wearable_ids: [445, 355],
  },
  {
    genesis_token_id: 1463,
    wearable_ids: [443, 398],
  },
  {
    genesis_token_id: 1464,
    wearable_ids: [354, 337],
  },
  {
    genesis_token_id: 1465,
    wearable_ids: [370, 284],
  },
  {
    genesis_token_id: 1466,
    wearable_ids: [270, 259],
  },
  {
    genesis_token_id: 1467,
    wearable_ids: [294, 253],
  },
  {
    genesis_token_id: 1468,
    wearable_ids: [257, 331],
  },
  {
    genesis_token_id: 1469,
    wearable_ids: [291, 277],
  },
  {
    genesis_token_id: 1470,
    wearable_ids: [300, 445],
  },
  {
    genesis_token_id: 1471,
    wearable_ids: [343, 426],
  },
  {
    genesis_token_id: 1472,
    wearable_ids: [294, 403],
  },
  {
    genesis_token_id: 1473,
    wearable_ids: [431, 342],
  },
  {
    genesis_token_id: 1474,
    wearable_ids: [426, 360],
  },
  {
    genesis_token_id: 1475,
    wearable_ids: [324, 286],
  },
  {
    genesis_token_id: 1476,
    wearable_ids: [291, 412],
  },
  {
    genesis_token_id: 1477,
    wearable_ids: [264, 283],
  },
  {
    genesis_token_id: 1478,
    wearable_ids: [385, 332],
  },
  {
    genesis_token_id: 1479,
    wearable_ids: [431, 335],
  },
  {
    genesis_token_id: 1480,
    wearable_ids: [369, 435],
  },
  {
    genesis_token_id: 1481,
    wearable_ids: [319, 364],
  },
  {
    genesis_token_id: 1482,
    wearable_ids: [254, 407],
  },
  {
    genesis_token_id: 1483,
    wearable_ids: [433, 284],
  },
  {
    genesis_token_id: 1484,
    wearable_ids: [385, 349],
  },
  {
    genesis_token_id: 1485,
    wearable_ids: [372, 315],
  },
  {
    genesis_token_id: 1486,
    wearable_ids: [301, 404],
  },
  {
    genesis_token_id: 1487,
    wearable_ids: [263, 300],
  },
  {
    genesis_token_id: 1488,
    wearable_ids: [344, 347],
  },
  {
    genesis_token_id: 1489,
    wearable_ids: [434, 257],
  },
  {
    genesis_token_id: 1490,
    wearable_ids: [273, 291],
  },
  {
    genesis_token_id: 1491,
    wearable_ids: [347, 262],
  },
  {
    genesis_token_id: 1492,
    wearable_ids: [294, 270],
  },
  {
    genesis_token_id: 1493,
    wearable_ids: [303, 247],
  },
  {
    genesis_token_id: 1494,
    wearable_ids: [258, 286],
  },
  {
    genesis_token_id: 1495,
    wearable_ids: [377, 271],
  },
  {
    genesis_token_id: 1496,
    wearable_ids: [276, 388],
  },
  {
    genesis_token_id: 1497,
    wearable_ids: [296, 308],
  },
  {
    genesis_token_id: 1498,
    wearable_ids: [350, 256],
  },
  {
    genesis_token_id: 1499,
    wearable_ids: [384, 385],
  },
  {
    genesis_token_id: 1500,
    wearable_ids: [276, 294],
  },
  {
    genesis_token_id: 1501,
    wearable_ids: [378, 287],
  },
  {
    genesis_token_id: 1502,
    wearable_ids: [350, 337],
  },
  {
    genesis_token_id: 1503,
    wearable_ids: [342, 443],
  },
  {
    genesis_token_id: 1504,
    wearable_ids: [411, 246],
  },
  {
    genesis_token_id: 1505,
    wearable_ids: [303, 273],
  },
  {
    genesis_token_id: 1506,
    wearable_ids: [431, 388],
  },
  {
    genesis_token_id: 1507,
    wearable_ids: [304, 277],
  },
  {
    genesis_token_id: 1508,
    wearable_ids: [308, 415],
  },
  {
    genesis_token_id: 1509,
    wearable_ids: [266, 445],
  },
  {
    genesis_token_id: 1510,
    wearable_ids: [263, 286],
  },
  {
    genesis_token_id: 1511,
    wearable_ids: [415, 303],
  },
  {
    genesis_token_id: 1512,
    wearable_ids: [412, 392],
  },
  {
    genesis_token_id: 1513,
    wearable_ids: [406, 371],
  },
  {
    genesis_token_id: 1514,
    wearable_ids: [263, 373],
  },
  {
    genesis_token_id: 1515,
    wearable_ids: [374, 298],
  },
  {
    genesis_token_id: 1516,
    wearable_ids: [339, 263],
  },
  {
    genesis_token_id: 1517,
    wearable_ids: [411, 324],
  },
  {
    genesis_token_id: 1518,
    wearable_ids: [280, 395],
  },
  {
    genesis_token_id: 1519,
    wearable_ids: [422, 384],
  },
  {
    genesis_token_id: 1520,
    wearable_ids: [410, 286],
  },
  {
    genesis_token_id: 1521,
    wearable_ids: [395, 332],
  },
  {
    genesis_token_id: 1522,
    wearable_ids: [306, 251],
  },
  {
    genesis_token_id: 1523,
    wearable_ids: [377, 386],
  },
  {
    genesis_token_id: 1524,
    wearable_ids: [428, 339],
  },
  {
    genesis_token_id: 1525,
    wearable_ids: [256, 360],
  },
  {
    genesis_token_id: 1526,
    wearable_ids: [362, 429],
  },
  {
    genesis_token_id: 1527,
    wearable_ids: [257, 341],
  },
  {
    genesis_token_id: 1528,
    wearable_ids: [371, 311],
  },
  {
    genesis_token_id: 1529,
    wearable_ids: [371, 327],
  },
  {
    genesis_token_id: 1530,
    wearable_ids: [410, 427],
  },
  {
    genesis_token_id: 1531,
    wearable_ids: [406, 425],
  },
  {
    genesis_token_id: 1532,
    wearable_ids: [255, 378],
  },
  {
    genesis_token_id: 1533,
    wearable_ids: [294, 304],
  },
  {
    genesis_token_id: 1534,
    wearable_ids: [377, 429],
  },
  {
    genesis_token_id: 1535,
    wearable_ids: [254, 276],
  },
  {
    genesis_token_id: 1536,
    wearable_ids: [420, 262],
  },
  {
    genesis_token_id: 1537,
    wearable_ids: [376, 442],
  },
  {
    genesis_token_id: 1538,
    wearable_ids: [259, 438],
  },
  {
    genesis_token_id: 1539,
    wearable_ids: [319, 300],
  },
  {
    genesis_token_id: 1540,
    wearable_ids: [378, 438],
  },
  {
    genesis_token_id: 1541,
    wearable_ids: [331, 259],
  },
  {
    genesis_token_id: 1542,
    wearable_ids: [272, 314],
  },
  {
    genesis_token_id: 1543,
    wearable_ids: [411, 432],
  },
  {
    genesis_token_id: 1544,
    wearable_ids: [348, 335],
  },
  {
    genesis_token_id: 1545,
    wearable_ids: [266, 256],
  },
  {
    genesis_token_id: 1546,
    wearable_ids: [251, 304],
  },
  {
    genesis_token_id: 1547,
    wearable_ids: [341, 299],
  },
  {
    genesis_token_id: 1548,
    wearable_ids: [276, 364],
  },
  {
    genesis_token_id: 1549,
    wearable_ids: [342, 248],
  },
  {
    genesis_token_id: 1550,
    wearable_ids: [257, 435],
  },
  {
    genesis_token_id: 1551,
    wearable_ids: [343, 374],
  },
  {
    genesis_token_id: 1552,
    wearable_ids: [347, 290],
  },
  {
    genesis_token_id: 1553,
    wearable_ids: [259, 284],
  },
  {
    genesis_token_id: 1554,
    wearable_ids: [299, 266],
  },
  {
    genesis_token_id: 1555,
    wearable_ids: [428, 433],
  },
  {
    genesis_token_id: 1556,
    wearable_ids: [400, 354],
  },
  {
    genesis_token_id: 1557,
    wearable_ids: [332, 433],
  },
  {
    genesis_token_id: 1558,
    wearable_ids: [248, 290],
  },
  {
    genesis_token_id: 1559,
    wearable_ids: [423, 317],
  },
  {
    genesis_token_id: 1560,
    wearable_ids: [399, 424],
  },
  {
    genesis_token_id: 1561,
    wearable_ids: [436, 284],
  },
  {
    genesis_token_id: 1562,
    wearable_ids: [397, 371],
  },
  {
    genesis_token_id: 1563,
    wearable_ids: [350, 409],
  },
  {
    genesis_token_id: 1564,
    wearable_ids: [276, 271],
  },
  {
    genesis_token_id: 1565,
    wearable_ids: [410, 396],
  },
  {
    genesis_token_id: 1566,
    wearable_ids: [270, 302],
  },
  {
    genesis_token_id: 1567,
    wearable_ids: [337, 442],
  },
  {
    genesis_token_id: 1568,
    wearable_ids: [372, 287],
  },
  {
    genesis_token_id: 1569,
    wearable_ids: [397, 403],
  },
  {
    genesis_token_id: 1570,
    wearable_ids: [325, 351],
  },
  {
    genesis_token_id: 1571,
    wearable_ids: [343, 352],
  },
  {
    genesis_token_id: 1572,
    wearable_ids: [420, 319],
  },
  {
    genesis_token_id: 1573,
    wearable_ids: [399, 340],
  },
  {
    genesis_token_id: 1574,
    wearable_ids: [397, 285],
  },
  {
    genesis_token_id: 1575,
    wearable_ids: [434, 326],
  },
  {
    genesis_token_id: 1576,
    wearable_ids: [377, 274],
  },
  {
    genesis_token_id: 1577,
    wearable_ids: [436, 333],
  },
  {
    genesis_token_id: 1578,
    wearable_ids: [371, 251],
  },
  {
    genesis_token_id: 1579,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 1580,
    wearable_ids: [425, 397],
  },
  {
    genesis_token_id: 1581,
    wearable_ids: [287, 254],
  },
  {
    genesis_token_id: 1582,
    wearable_ids: [308, 304],
  },
  {
    genesis_token_id: 1583,
    wearable_ids: [251, 264],
  },
  {
    genesis_token_id: 1584,
    wearable_ids: [437, 351],
  },
  {
    genesis_token_id: 1585,
    wearable_ids: [385, 301],
  },
  {
    genesis_token_id: 1586,
    wearable_ids: [266, 268],
  },
  {
    genesis_token_id: 1587,
    wearable_ids: [442, 310],
  },
  {
    genesis_token_id: 1588,
    wearable_ids: [257, 336],
  },
  {
    genesis_token_id: 1589,
    wearable_ids: [343, 308],
  },
  {
    genesis_token_id: 1590,
    wearable_ids: [351, 318],
  },
  {
    genesis_token_id: 1591,
    wearable_ids: [385, 403],
  },
  {
    genesis_token_id: 1592,
    wearable_ids: [433, 290],
  },
  {
    genesis_token_id: 1593,
    wearable_ids: [436, 299],
  },
  {
    genesis_token_id: 1594,
    wearable_ids: [324, 298],
  },
  {
    genesis_token_id: 1595,
    wearable_ids: [308, 435],
  },
  {
    genesis_token_id: 1596,
    wearable_ids: [255, 291],
  },
  {
    genesis_token_id: 1597,
    wearable_ids: [303, 317],
  },
  {
    genesis_token_id: 1598,
    wearable_ids: [376, 428],
  },
  {
    genesis_token_id: 1599,
    wearable_ids: [444, 431],
  },
  {
    genesis_token_id: 1600,
    wearable_ids: [280, 332],
  },
  {
    genesis_token_id: 1601,
    wearable_ids: [284, 298],
  },
  {
    genesis_token_id: 1602,
    wearable_ids: [445, 444],
  },
  {
    genesis_token_id: 1603,
    wearable_ids: [300, 254],
  },
  {
    genesis_token_id: 1604,
    wearable_ids: [378, 255],
  },
  {
    genesis_token_id: 1605,
    wearable_ids: [445, 322],
  },
  {
    genesis_token_id: 1606,
    wearable_ids: [319, 259],
  },
  {
    genesis_token_id: 1607,
    wearable_ids: [424, 315],
  },
  {
    genesis_token_id: 1608,
    wearable_ids: [317, 413],
  },
  {
    genesis_token_id: 1609,
    wearable_ids: [344, 276],
  },
  {
    genesis_token_id: 1610,
    wearable_ids: [273, 376],
  },
  {
    genesis_token_id: 1611,
    wearable_ids: [273, 408],
  },
  {
    genesis_token_id: 1612,
    wearable_ids: [349, 262],
  },
  {
    genesis_token_id: 1613,
    wearable_ids: [429, 261],
  },
  {
    genesis_token_id: 1614,
    wearable_ids: [332, 406],
  },
  {
    genesis_token_id: 1615,
    wearable_ids: [289, 363],
  },
  {
    genesis_token_id: 1616,
    wearable_ids: [299, 413],
  },
  {
    genesis_token_id: 1617,
    wearable_ids: [287, 277],
  },
  {
    genesis_token_id: 1618,
    wearable_ids: [259, 407],
  },
  {
    genesis_token_id: 1619,
    wearable_ids: [347, 445],
  },
  {
    genesis_token_id: 1620,
    wearable_ids: [319, 320],
  },
  {
    genesis_token_id: 1621,
    wearable_ids: [287, 378],
  },
  {
    genesis_token_id: 1622,
    wearable_ids: [278, 303],
  },
  {
    genesis_token_id: 1623,
    wearable_ids: [271, 339],
  },
  {
    genesis_token_id: 1624,
    wearable_ids: [304, 407],
  },
  {
    genesis_token_id: 1625,
    wearable_ids: [248, 358],
  },
  {
    genesis_token_id: 1626,
    wearable_ids: [289, 281],
  },
  {
    genesis_token_id: 1627,
    wearable_ids: [335, 378],
  },
  {
    genesis_token_id: 1628,
    wearable_ids: [374, 350],
  },
  {
    genesis_token_id: 1629,
    wearable_ids: [255, 304],
  },
  {
    genesis_token_id: 1630,
    wearable_ids: [434, 246],
  },
  {
    genesis_token_id: 1631,
    wearable_ids: [340, 429],
  },
  {
    genesis_token_id: 1632,
    wearable_ids: [355, 371],
  },
  {
    genesis_token_id: 1633,
    wearable_ids: [273, 361],
  },
  {
    genesis_token_id: 1634,
    wearable_ids: [431, 255],
  },
  {
    genesis_token_id: 1635,
    wearable_ids: [256, 368],
  },
  {
    genesis_token_id: 1636,
    wearable_ids: [382, 253],
  },
  {
    genesis_token_id: 1637,
    wearable_ids: [286, 314],
  },
  {
    genesis_token_id: 1638,
    wearable_ids: [443, 336],
  },
  {
    genesis_token_id: 1639,
    wearable_ids: [324, 247],
  },
  {
    genesis_token_id: 1640,
    wearable_ids: [423, 274],
  },
  {
    genesis_token_id: 1641,
    wearable_ids: [317, 358],
  },
  {
    genesis_token_id: 1642,
    wearable_ids: [406, 350],
  },
  {
    genesis_token_id: 1643,
    wearable_ids: [338, 399],
  },
  {
    genesis_token_id: 1644,
    wearable_ids: [432, 274],
  },
  {
    genesis_token_id: 1645,
    wearable_ids: [377, 322],
  },
  {
    genesis_token_id: 1646,
    wearable_ids: [316, 257],
  },
  {
    genesis_token_id: 1647,
    wearable_ids: [425, 264],
  },
  {
    genesis_token_id: 1648,
    wearable_ids: [347, 403],
  },
  {
    genesis_token_id: 1649,
    wearable_ids: [385, 273],
  },
  {
    genesis_token_id: 1650,
    wearable_ids: [326, 403],
  },
  {
    genesis_token_id: 1651,
    wearable_ids: [254, 378],
  },
  {
    genesis_token_id: 1652,
    wearable_ids: [410, 431],
  },
  {
    genesis_token_id: 1653,
    wearable_ids: [326, 356],
  },
  {
    genesis_token_id: 1654,
    wearable_ids: [444, 445],
  },
  {
    genesis_token_id: 1655,
    wearable_ids: [310, 327],
  },
  {
    genesis_token_id: 1656,
    wearable_ids: [387, 277],
  },
  {
    genesis_token_id: 1657,
    wearable_ids: [295, 302],
  },
  {
    genesis_token_id: 1658,
    wearable_ids: [436, 280],
  },
  {
    genesis_token_id: 1659,
    wearable_ids: [423, 388],
  },
  {
    genesis_token_id: 1660,
    wearable_ids: [300, 354],
  },
  {
    genesis_token_id: 1661,
    wearable_ids: [415, 289],
  },
  {
    genesis_token_id: 1662,
    wearable_ids: [442, 445],
  },
  {
    genesis_token_id: 1663,
    wearable_ids: [316, 385],
  },
  {
    genesis_token_id: 1664,
    wearable_ids: [437, 289],
  },
  {
    genesis_token_id: 1665,
    wearable_ids: [415, 429],
  },
  {
    genesis_token_id: 1666,
    wearable_ids: [256, 385],
  },
  {
    genesis_token_id: 1667,
    wearable_ids: [310, 403],
  },
  {
    genesis_token_id: 1668,
    wearable_ids: [335, 276],
  },
  {
    genesis_token_id: 1669,
    wearable_ids: [253, 428],
  },
  {
    genesis_token_id: 1670,
    wearable_ids: [420, 376],
  },
  {
    genesis_token_id: 1671,
    wearable_ids: [247, 278],
  },
  {
    genesis_token_id: 1672,
    wearable_ids: [373, 343],
  },
  {
    genesis_token_id: 1673,
    wearable_ids: [338, 296],
  },
  {
    genesis_token_id: 1674,
    wearable_ids: [272, 310],
  },
  {
    genesis_token_id: 1675,
    wearable_ids: [372, 297],
  },
  {
    genesis_token_id: 1676,
    wearable_ids: [270, 392],
  },
  {
    genesis_token_id: 1677,
    wearable_ids: [429, 307],
  },
  {
    genesis_token_id: 1678,
    wearable_ids: [337, 401],
  },
  {
    genesis_token_id: 1679,
    wearable_ids: [272, 440],
  },
  {
    genesis_token_id: 1680,
    wearable_ids: [404, 255],
  },
  {
    genesis_token_id: 1681,
    wearable_ids: [287, 365],
  },
  {
    genesis_token_id: 1682,
    wearable_ids: [270, 251],
  },
  {
    genesis_token_id: 1683,
    wearable_ids: [407, 262],
  },
  {
    genesis_token_id: 1684,
    wearable_ids: [324, 248],
  },
  {
    genesis_token_id: 1685,
    wearable_ids: [292, 389],
  },
  {
    genesis_token_id: 1686,
    wearable_ids: [294, 319],
  },
  {
    genesis_token_id: 1687,
    wearable_ids: [258, 436],
  },
  {
    genesis_token_id: 1688,
    wearable_ids: [268, 317],
  },
  {
    genesis_token_id: 1689,
    wearable_ids: [310, 277],
  },
  {
    genesis_token_id: 1690,
    wearable_ids: [404, 258],
  },
  {
    genesis_token_id: 1691,
    wearable_ids: [436, 257],
  },
  {
    genesis_token_id: 1692,
    wearable_ids: [424, 375],
  },
  {
    genesis_token_id: 1693,
    wearable_ids: [437, 436],
  },
  {
    genesis_token_id: 1694,
    wearable_ids: [429, 363],
  },
  {
    genesis_token_id: 1695,
    wearable_ids: [294, 323],
  },
  {
    genesis_token_id: 1696,
    wearable_ids: [331, 322],
  },
  {
    genesis_token_id: 1697,
    wearable_ids: [262, 343],
  },
  {
    genesis_token_id: 1698,
    wearable_ids: [300, 254],
  },
  {
    genesis_token_id: 1699,
    wearable_ids: [273, 316],
  },
  {
    genesis_token_id: 1700,
    wearable_ids: [255, 250],
  },
  {
    genesis_token_id: 1701,
    wearable_ids: [247, 270],
  },
  {
    genesis_token_id: 1702,
    wearable_ids: [336, 389],
  },
  {
    genesis_token_id: 1703,
    wearable_ids: [314, 401],
  },
  {
    genesis_token_id: 1704,
    wearable_ids: [290, 258],
  },
  {
    genesis_token_id: 1705,
    wearable_ids: [303, 344],
  },
  {
    genesis_token_id: 1706,
    wearable_ids: [408, 383],
  },
  {
    genesis_token_id: 1707,
    wearable_ids: [319, 315],
  },
  {
    genesis_token_id: 1708,
    wearable_ids: [375, 332],
  },
  {
    genesis_token_id: 1709,
    wearable_ids: [365, 315],
  },
  {
    genesis_token_id: 1710,
    wearable_ids: [435, 396],
  },
  {
    genesis_token_id: 1711,
    wearable_ids: [364, 413],
  },
  {
    genesis_token_id: 1712,
    wearable_ids: [303, 298],
  },
  {
    genesis_token_id: 1713,
    wearable_ids: [349, 384],
  },
  {
    genesis_token_id: 1714,
    wearable_ids: [336, 332],
  },
  {
    genesis_token_id: 1715,
    wearable_ids: [303, 300],
  },
  {
    genesis_token_id: 1716,
    wearable_ids: [310, 297],
  },
  {
    genesis_token_id: 1717,
    wearable_ids: [291, 314],
  },
  {
    genesis_token_id: 1718,
    wearable_ids: [338, 374],
  },
  {
    genesis_token_id: 1719,
    wearable_ids: [256, 295],
  },
  {
    genesis_token_id: 1720,
    wearable_ids: [264, 373],
  },
  {
    genesis_token_id: 1721,
    wearable_ids: [370, 356],
  },
  {
    genesis_token_id: 1722,
    wearable_ids: [256, 407],
  },
  {
    genesis_token_id: 1723,
    wearable_ids: [431, 284],
  },
  {
    genesis_token_id: 1724,
    wearable_ids: [314, 247],
  },
  {
    genesis_token_id: 1725,
    wearable_ids: [262, 344],
  },
  {
    genesis_token_id: 1726,
    wearable_ids: [435, 389],
  },
  {
    genesis_token_id: 1727,
    wearable_ids: [362, 310],
  },
  {
    genesis_token_id: 1728,
    wearable_ids: [410, 434],
  },
  {
    genesis_token_id: 1729,
    wearable_ids: [375, 274],
  },
  {
    genesis_token_id: 1730,
    wearable_ids: [280, 362],
  },
  {
    genesis_token_id: 1731,
    wearable_ids: [412, 352],
  },
  {
    genesis_token_id: 1732,
    wearable_ids: [314, 387],
  },
  {
    genesis_token_id: 1733,
    wearable_ids: [286, 409],
  },
  {
    genesis_token_id: 1734,
    wearable_ids: [377, 425],
  },
  {
    genesis_token_id: 1735,
    wearable_ids: [445, 376],
  },
  {
    genesis_token_id: 1736,
    wearable_ids: [395, 268],
  },
  {
    genesis_token_id: 1737,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 1738,
    wearable_ids: [270, 346],
  },
  {
    genesis_token_id: 1739,
    wearable_ids: [339, 350],
  },
  {
    genesis_token_id: 1740,
    wearable_ids: [377, 283],
  },
  {
    genesis_token_id: 1741,
    wearable_ids: [436, 355],
  },
  {
    genesis_token_id: 1742,
    wearable_ids: [340, 313],
  },
  {
    genesis_token_id: 1743,
    wearable_ids: [314, 278],
  },
  {
    genesis_token_id: 1744,
    wearable_ids: [336, 420],
  },
  {
    genesis_token_id: 1745,
    wearable_ids: [411, 432],
  },
  {
    genesis_token_id: 1746,
    wearable_ids: [415, 271],
  },
  {
    genesis_token_id: 1747,
    wearable_ids: [415, 299],
  },
  {
    genesis_token_id: 1748,
    wearable_ids: [411, 348],
  },
  {
    genesis_token_id: 1749,
    wearable_ids: [254, 301],
  },
  {
    genesis_token_id: 1750,
    wearable_ids: [259, 292],
  },
  {
    genesis_token_id: 1751,
    wearable_ids: [317, 364],
  },
  {
    genesis_token_id: 1752,
    wearable_ids: [437, 327],
  },
  {
    genesis_token_id: 1753,
    wearable_ids: [406, 264],
  },
  {
    genesis_token_id: 1754,
    wearable_ids: [384, 409],
  },
  {
    genesis_token_id: 1755,
    wearable_ids: [326, 327],
  },
  {
    genesis_token_id: 1756,
    wearable_ids: [301, 376],
  },
  {
    genesis_token_id: 1757,
    wearable_ids: [445, 438],
  },
  {
    genesis_token_id: 1758,
    wearable_ids: [301, 270],
  },
  {
    genesis_token_id: 1759,
    wearable_ids: [300, 291],
  },
  {
    genesis_token_id: 1760,
    wearable_ids: [378, 444],
  },
  {
    genesis_token_id: 1761,
    wearable_ids: [292, 340],
  },
  {
    genesis_token_id: 1762,
    wearable_ids: [299, 401],
  },
  {
    genesis_token_id: 1763,
    wearable_ids: [253, 284],
  },
  {
    genesis_token_id: 1764,
    wearable_ids: [254, 407],
  },
  {
    genesis_token_id: 1765,
    wearable_ids: [400, 345],
  },
  {
    genesis_token_id: 1766,
    wearable_ids: [273, 433],
  },
  {
    genesis_token_id: 1767,
    wearable_ids: [424, 354],
  },
  {
    genesis_token_id: 1768,
    wearable_ids: [431, 322],
  },
  {
    genesis_token_id: 1769,
    wearable_ids: [415, 405],
  },
  {
    genesis_token_id: 1770,
    wearable_ids: [265, 377],
  },
  {
    genesis_token_id: 1771,
    wearable_ids: [350, 409],
  },
  {
    genesis_token_id: 1772,
    wearable_ids: [371, 410],
  },
  {
    genesis_token_id: 1773,
    wearable_ids: [385, 404],
  },
  {
    genesis_token_id: 1774,
    wearable_ids: [289, 290],
  },
  {
    genesis_token_id: 1775,
    wearable_ids: [263, 276],
  },
  {
    genesis_token_id: 1776,
    wearable_ids: [270, 408],
  },
  {
    genesis_token_id: 1777,
    wearable_ids: [348, 418],
  },
  {
    genesis_token_id: 1778,
    wearable_ids: [365, 331],
  },
  {
    genesis_token_id: 1779,
    wearable_ids: [362, 312],
  },
  {
    genesis_token_id: 1780,
    wearable_ids: [368, 270],
  },
  {
    genesis_token_id: 1781,
    wearable_ids: [350, 368],
  },
  {
    genesis_token_id: 1782,
    wearable_ids: [354, 301],
  },
  {
    genesis_token_id: 1783,
    wearable_ids: [268, 361],
  },
  {
    genesis_token_id: 1784,
    wearable_ids: [354, 284],
  },
  {
    genesis_token_id: 1785,
    wearable_ids: [369, 350],
  },
  {
    genesis_token_id: 1786,
    wearable_ids: [387, 436],
  },
  {
    genesis_token_id: 1787,
    wearable_ids: [331, 324],
  },
  {
    genesis_token_id: 1788,
    wearable_ids: [338, 257],
  },
  {
    genesis_token_id: 1789,
    wearable_ids: [364, 326],
  },
  {
    genesis_token_id: 1790,
    wearable_ids: [364, 433],
  },
  {
    genesis_token_id: 1791,
    wearable_ids: [362, 351],
  },
  {
    genesis_token_id: 1792,
    wearable_ids: [415, 395],
  },
  {
    genesis_token_id: 1793,
    wearable_ids: [257, 442],
  },
  {
    genesis_token_id: 1794,
    wearable_ids: [435, 427],
  },
  {
    genesis_token_id: 1795,
    wearable_ids: [264, 327],
  },
  {
    genesis_token_id: 1796,
    wearable_ids: [422, 342],
  },
  {
    genesis_token_id: 1797,
    wearable_ids: [343, 342],
  },
  {
    genesis_token_id: 1798,
    wearable_ids: [337, 359],
  },
  {
    genesis_token_id: 1799,
    wearable_ids: [331, 416],
  },
  {
    genesis_token_id: 1800,
    wearable_ids: [271, 434],
  },
  {
    genesis_token_id: 1801,
    wearable_ids: [363, 413],
  },
  {
    genesis_token_id: 1802,
    wearable_ids: [319, 369],
  },
  {
    genesis_token_id: 1803,
    wearable_ids: [384, 291],
  },
  {
    genesis_token_id: 1804,
    wearable_ids: [422, 400],
  },
  {
    genesis_token_id: 1805,
    wearable_ids: [404, 336],
  },
  {
    genesis_token_id: 1806,
    wearable_ids: [344, 262],
  },
  {
    genesis_token_id: 1807,
    wearable_ids: [337, 436],
  },
  {
    genesis_token_id: 1808,
    wearable_ids: [263, 286],
  },
  {
    genesis_token_id: 1809,
    wearable_ids: [300, 401],
  },
  {
    genesis_token_id: 1810,
    wearable_ids: [314, 442],
  },
  {
    genesis_token_id: 1811,
    wearable_ids: [350, 292],
  },
  {
    genesis_token_id: 1812,
    wearable_ids: [317, 298],
  },
  {
    genesis_token_id: 1813,
    wearable_ids: [385, 270],
  },
  {
    genesis_token_id: 1814,
    wearable_ids: [266, 411],
  },
  {
    genesis_token_id: 1815,
    wearable_ids: [348, 342],
  },
  {
    genesis_token_id: 1816,
    wearable_ids: [324, 266],
  },
  {
    genesis_token_id: 1817,
    wearable_ids: [262, 438],
  },
  {
    genesis_token_id: 1818,
    wearable_ids: [349, 318],
  },
  {
    genesis_token_id: 1819,
    wearable_ids: [294, 246],
  },
  {
    genesis_token_id: 1820,
    wearable_ids: [342, 385],
  },
  {
    genesis_token_id: 1821,
    wearable_ids: [339, 324],
  },
  {
    genesis_token_id: 1822,
    wearable_ids: [247, 353],
  },
  {
    genesis_token_id: 1823,
    wearable_ids: [266, 412],
  },
  {
    genesis_token_id: 1824,
    wearable_ids: [324, 275],
  },
  {
    genesis_token_id: 1825,
    wearable_ids: [289, 415],
  },
  {
    genesis_token_id: 1826,
    wearable_ids: [335, 403],
  },
  {
    genesis_token_id: 1827,
    wearable_ids: [341, 400],
  },
  {
    genesis_token_id: 1828,
    wearable_ids: [284, 339],
  },
  {
    genesis_token_id: 1829,
    wearable_ids: [247, 324],
  },
  {
    genesis_token_id: 1830,
    wearable_ids: [372, 295],
  },
  {
    genesis_token_id: 1831,
    wearable_ids: [287, 436],
  },
  {
    genesis_token_id: 1832,
    wearable_ids: [349, 352],
  },
  {
    genesis_token_id: 1833,
    wearable_ids: [276, 270],
  },
  {
    genesis_token_id: 1834,
    wearable_ids: [403, 369],
  },
  {
    genesis_token_id: 1835,
    wearable_ids: [274, 370],
  },
  {
    genesis_token_id: 1836,
    wearable_ids: [248, 336],
  },
  {
    genesis_token_id: 1837,
    wearable_ids: [331, 415],
  },
  {
    genesis_token_id: 1838,
    wearable_ids: [399, 308],
  },
  {
    genesis_token_id: 1839,
    wearable_ids: [399, 303],
  },
  {
    genesis_token_id: 1840,
    wearable_ids: [303, 310],
  },
  {
    genesis_token_id: 1841,
    wearable_ids: [389, 290],
  },
  {
    genesis_token_id: 1842,
    wearable_ids: [270, 291],
  },
  {
    genesis_token_id: 1843,
    wearable_ids: [434, 284],
  },
  {
    genesis_token_id: 1844,
    wearable_ids: [308, 272],
  },
  {
    genesis_token_id: 1845,
    wearable_ids: [412, 303],
  },
  {
    genesis_token_id: 1846,
    wearable_ids: [423, 424],
  },
  {
    genesis_token_id: 1847,
    wearable_ids: [311, 280],
  },
  {
    genesis_token_id: 1848,
    wearable_ids: [408, 286],
  },
  {
    genesis_token_id: 1849,
    wearable_ids: [346, 339],
  },
  {
    genesis_token_id: 1850,
    wearable_ids: [303, 334],
  },
  {
    genesis_token_id: 1851,
    wearable_ids: [374, 287],
  },
  {
    genesis_token_id: 1852,
    wearable_ids: [332, 347],
  },
  {
    genesis_token_id: 1853,
    wearable_ids: [384, 412],
  },
  {
    genesis_token_id: 1854,
    wearable_ids: [350, 258],
  },
  {
    genesis_token_id: 1855,
    wearable_ids: [284, 269],
  },
  {
    genesis_token_id: 1856,
    wearable_ids: [383, 287],
  },
  {
    genesis_token_id: 1857,
    wearable_ids: [370, 383],
  },
  {
    genesis_token_id: 1858,
    wearable_ids: [263, 272],
  },
  {
    genesis_token_id: 1859,
    wearable_ids: [251, 433],
  },
  {
    genesis_token_id: 1860,
    wearable_ids: [319, 405],
  },
  {
    genesis_token_id: 1861,
    wearable_ids: [399, 388],
  },
  {
    genesis_token_id: 1862,
    wearable_ids: [363, 348],
  },
  {
    genesis_token_id: 1863,
    wearable_ids: [294, 303],
  },
  {
    genesis_token_id: 1864,
    wearable_ids: [407, 422],
  },
  {
    genesis_token_id: 1865,
    wearable_ids: [369, 415],
  },
  {
    genesis_token_id: 1866,
    wearable_ids: [248, 319],
  },
  {
    genesis_token_id: 1867,
    wearable_ids: [338, 387],
  },
  {
    genesis_token_id: 1868,
    wearable_ids: [294, 373],
  },
  {
    genesis_token_id: 1869,
    wearable_ids: [338, 265],
  },
  {
    genesis_token_id: 1870,
    wearable_ids: [443, 253],
  },
  {
    genesis_token_id: 1871,
    wearable_ids: [278, 362],
  },
  {
    genesis_token_id: 1872,
    wearable_ids: [347, 354],
  },
  {
    genesis_token_id: 1873,
    wearable_ids: [273, 295],
  },
  {
    genesis_token_id: 1874,
    wearable_ids: [248, 412],
  },
  {
    genesis_token_id: 1875,
    wearable_ids: [368, 272],
  },
  {
    genesis_token_id: 1876,
    wearable_ids: [337, 374],
  },
  {
    genesis_token_id: 1877,
    wearable_ids: [444, 302],
  },
  {
    genesis_token_id: 1878,
    wearable_ids: [415, 402],
  },
  {
    genesis_token_id: 1879,
    wearable_ids: [372, 277],
  },
  {
    genesis_token_id: 1880,
    wearable_ids: [292, 326],
  },
  {
    genesis_token_id: 1881,
    wearable_ids: [373, 397],
  },
  {
    genesis_token_id: 1882,
    wearable_ids: [378, 295],
  },
  {
    genesis_token_id: 1883,
    wearable_ids: [300, 286],
  },
  {
    genesis_token_id: 1884,
    wearable_ids: [363, 262],
  },
  {
    genesis_token_id: 1885,
    wearable_ids: [258, 383],
  },
  {
    genesis_token_id: 1886,
    wearable_ids: [337, 393],
  },
  {
    genesis_token_id: 1887,
    wearable_ids: [337, 266],
  },
  {
    genesis_token_id: 1888,
    wearable_ids: [348, 384],
  },
  {
    genesis_token_id: 1889,
    wearable_ids: [271, 409],
  },
  {
    genesis_token_id: 1890,
    wearable_ids: [347, 278],
  },
  {
    genesis_token_id: 1891,
    wearable_ids: [331, 382],
  },
  {
    genesis_token_id: 1892,
    wearable_ids: [407, 259],
  },
  {
    genesis_token_id: 1893,
    wearable_ids: [406, 431],
  },
  {
    genesis_token_id: 1894,
    wearable_ids: [297, 436],
  },
  {
    genesis_token_id: 1895,
    wearable_ids: [265, 337],
  },
  {
    genesis_token_id: 1896,
    wearable_ids: [422, 403],
  },
  {
    genesis_token_id: 1897,
    wearable_ids: [434, 350],
  },
  {
    genesis_token_id: 1898,
    wearable_ids: [406, 364],
  },
  {
    genesis_token_id: 1899,
    wearable_ids: [444, 295],
  },
  {
    genesis_token_id: 1900,
    wearable_ids: [397, 436],
  },
  {
    genesis_token_id: 1901,
    wearable_ids: [256, 404],
  },
  {
    genesis_token_id: 1902,
    wearable_ids: [396, 441],
  },
  {
    genesis_token_id: 1903,
    wearable_ids: [319, 418],
  },
  {
    genesis_token_id: 1904,
    wearable_ids: [254, 347],
  },
  {
    genesis_token_id: 1905,
    wearable_ids: [352, 363],
  },
  {
    genesis_token_id: 1906,
    wearable_ids: [350, 284],
  },
  {
    genesis_token_id: 1907,
    wearable_ids: [340, 375],
  },
  {
    genesis_token_id: 1908,
    wearable_ids: [373, 443],
  },
  {
    genesis_token_id: 1909,
    wearable_ids: [404, 396],
  },
  {
    genesis_token_id: 1910,
    wearable_ids: [375, 274],
  },
  {
    genesis_token_id: 1911,
    wearable_ids: [319, 295],
  },
  {
    genesis_token_id: 1912,
    wearable_ids: [317, 259],
  },
  {
    genesis_token_id: 1913,
    wearable_ids: [355, 344],
  },
  {
    genesis_token_id: 1914,
    wearable_ids: [442, 420],
  },
  {
    genesis_token_id: 1915,
    wearable_ids: [362, 404],
  },
  {
    genesis_token_id: 1916,
    wearable_ids: [429, 413],
  },
  {
    genesis_token_id: 1917,
    wearable_ids: [375, 295],
  },
  {
    genesis_token_id: 1918,
    wearable_ids: [436, 410],
  },
  {
    genesis_token_id: 1919,
    wearable_ids: [262, 273],
  },
  {
    genesis_token_id: 1920,
    wearable_ids: [247, 339],
  },
  {
    genesis_token_id: 1921,
    wearable_ids: [253, 384],
  },
  {
    genesis_token_id: 1922,
    wearable_ids: [268, 382],
  },
  {
    genesis_token_id: 1923,
    wearable_ids: [383, 364],
  },
  {
    genesis_token_id: 1924,
    wearable_ids: [311, 326],
  },
  {
    genesis_token_id: 1925,
    wearable_ids: [424, 340],
  },
  {
    genesis_token_id: 1926,
    wearable_ids: [383, 295],
  },
  {
    genesis_token_id: 1927,
    wearable_ids: [338, 435],
  },
  {
    genesis_token_id: 1928,
    wearable_ids: [406, 444],
  },
  {
    genesis_token_id: 1929,
    wearable_ids: [385, 422],
  },
  {
    genesis_token_id: 1930,
    wearable_ids: [426, 372],
  },
  {
    genesis_token_id: 1931,
    wearable_ids: [300, 347],
  },
  {
    genesis_token_id: 1932,
    wearable_ids: [364, 365],
  },
  {
    genesis_token_id: 1933,
    wearable_ids: [255, 262],
  },
  {
    genesis_token_id: 1934,
    wearable_ids: [377, 342],
  },
  {
    genesis_token_id: 1935,
    wearable_ids: [290, 319],
  },
  {
    genesis_token_id: 1936,
    wearable_ids: [276, 365],
  },
  {
    genesis_token_id: 1937,
    wearable_ids: [371, 336],
  },
  {
    genesis_token_id: 1938,
    wearable_ids: [355, 365],
  },
  {
    genesis_token_id: 1939,
    wearable_ids: [274, 424],
  },
  {
    genesis_token_id: 1940,
    wearable_ids: [314, 328],
  },
  {
    genesis_token_id: 1941,
    wearable_ids: [304, 412],
  },
  {
    genesis_token_id: 1942,
    wearable_ids: [326, 400],
  },
  {
    genesis_token_id: 1943,
    wearable_ids: [368, 297],
  },
  {
    genesis_token_id: 1944,
    wearable_ids: [276, 338],
  },
  {
    genesis_token_id: 1945,
    wearable_ids: [257, 353],
  },
  {
    genesis_token_id: 1946,
    wearable_ids: [315, 395],
  },
  {
    genesis_token_id: 1947,
    wearable_ids: [433, 378],
  },
  {
    genesis_token_id: 1948,
    wearable_ids: [263, 255],
  },
  {
    genesis_token_id: 1949,
    wearable_ids: [251, 435],
  },
  {
    genesis_token_id: 1950,
    wearable_ids: [354, 434],
  },
  {
    genesis_token_id: 1951,
    wearable_ids: [434, 277],
  },
  {
    genesis_token_id: 1952,
    wearable_ids: [385, 350],
  },
  {
    genesis_token_id: 1953,
    wearable_ids: [301, 354],
  },
  {
    genesis_token_id: 1954,
    wearable_ids: [339, 287],
  },
  {
    genesis_token_id: 1955,
    wearable_ids: [351, 337],
  },
  {
    genesis_token_id: 1956,
    wearable_ids: [317, 395],
  },
  {
    genesis_token_id: 1957,
    wearable_ids: [426, 322],
  },
  {
    genesis_token_id: 1958,
    wearable_ids: [278, 277],
  },
  {
    genesis_token_id: 1959,
    wearable_ids: [371, 375],
  },
  {
    genesis_token_id: 1960,
    wearable_ids: [373, 300],
  },
  {
    genesis_token_id: 1961,
    wearable_ids: [431, 349],
  },
  {
    genesis_token_id: 1962,
    wearable_ids: [341, 353],
  },
  {
    genesis_token_id: 1963,
    wearable_ids: [297, 317],
  },
  {
    genesis_token_id: 1964,
    wearable_ids: [437, 322],
  },
  {
    genesis_token_id: 1965,
    wearable_ids: [254, 401],
  },
  {
    genesis_token_id: 1966,
    wearable_ids: [400, 278],
  },
  {
    genesis_token_id: 1967,
    wearable_ids: [257, 261],
  },
  {
    genesis_token_id: 1968,
    wearable_ids: [426, 278],
  },
  {
    genesis_token_id: 1969,
    wearable_ids: [397, 303],
  },
  {
    genesis_token_id: 1970,
    wearable_ids: [332, 268],
  },
  {
    genesis_token_id: 1971,
    wearable_ids: [257, 443],
  },
  {
    genesis_token_id: 1972,
    wearable_ids: [445, 406],
  },
  {
    genesis_token_id: 1973,
    wearable_ids: [343, 264],
  },
  {
    genesis_token_id: 1974,
    wearable_ids: [253, 431],
  },
  {
    genesis_token_id: 1975,
    wearable_ids: [325, 251],
  },
  {
    genesis_token_id: 1976,
    wearable_ids: [337, 402],
  },
  {
    genesis_token_id: 1977,
    wearable_ids: [268, 382],
  },
  {
    genesis_token_id: 1978,
    wearable_ids: [403, 438],
  },
  {
    genesis_token_id: 1979,
    wearable_ids: [382, 363],
  },
  {
    genesis_token_id: 1980,
    wearable_ids: [287, 363],
  },
  {
    genesis_token_id: 1981,
    wearable_ids: [436, 312],
  },
  {
    genesis_token_id: 1982,
    wearable_ids: [368, 310],
  },
  {
    genesis_token_id: 1983,
    wearable_ids: [406, 375],
  },
  {
    genesis_token_id: 1984,
    wearable_ids: [268, 377],
  },
  {
    genesis_token_id: 1985,
    wearable_ids: [299, 349],
  },
  {
    genesis_token_id: 1986,
    wearable_ids: [274, 268],
  },
  {
    genesis_token_id: 1987,
    wearable_ids: [297, 436],
  },
  {
    genesis_token_id: 1988,
    wearable_ids: [343, 410],
  },
  {
    genesis_token_id: 1989,
    wearable_ids: [335, 311],
  },
  {
    genesis_token_id: 1990,
    wearable_ids: [349, 268],
  },
  {
    genesis_token_id: 1991,
    wearable_ids: [387, 376],
  },
  {
    genesis_token_id: 1992,
    wearable_ids: [397, 331],
  },
  {
    genesis_token_id: 1993,
    wearable_ids: [369, 386],
  },
  {
    genesis_token_id: 1994,
    wearable_ids: [374, 373],
  },
  {
    genesis_token_id: 1995,
    wearable_ids: [437, 371],
  },
  {
    genesis_token_id: 1996,
    wearable_ids: [326, 335],
  },
  {
    genesis_token_id: 1997,
    wearable_ids: [297, 413],
  },
  {
    genesis_token_id: 1998,
    wearable_ids: [428, 370],
  },
  {
    genesis_token_id: 1999,
    wearable_ids: [303, 288],
  },
  {
    genesis_token_id: 2000,
    wearable_ids: [303, 410],
  },
  {
    genesis_token_id: 2001,
    wearable_ids: [284, 268],
  },
  {
    genesis_token_id: 2002,
    wearable_ids: [362, 445],
  },
  {
    genesis_token_id: 2003,
    wearable_ids: [248, 429],
  },
  {
    genesis_token_id: 2004,
    wearable_ids: [314, 407],
  },
  {
    genesis_token_id: 2005,
    wearable_ids: [272, 293],
  },
  {
    genesis_token_id: 2006,
    wearable_ids: [362, 379],
  },
  {
    genesis_token_id: 2007,
    wearable_ids: [287, 414],
  },
  {
    genesis_token_id: 2008,
    wearable_ids: [349, 432],
  },
  {
    genesis_token_id: 2009,
    wearable_ids: [435, 338],
  },
  {
    genesis_token_id: 2010,
    wearable_ids: [396, 423],
  },
  {
    genesis_token_id: 2011,
    wearable_ids: [311, 401],
  },
  {
    genesis_token_id: 2012,
    wearable_ids: [376, 254],
  },
  {
    genesis_token_id: 2013,
    wearable_ids: [349, 268],
  },
  {
    genesis_token_id: 2014,
    wearable_ids: [399, 404],
  },
  {
    genesis_token_id: 2015,
    wearable_ids: [385, 339],
  },
  {
    genesis_token_id: 2016,
    wearable_ids: [339, 253],
  },
  {
    genesis_token_id: 2017,
    wearable_ids: [442, 365],
  },
  {
    genesis_token_id: 2018,
    wearable_ids: [407, 372],
  },
  {
    genesis_token_id: 2019,
    wearable_ids: [352, 410],
  },
  {
    genesis_token_id: 2020,
    wearable_ids: [425, 427],
  },
  {
    genesis_token_id: 2021,
    wearable_ids: [386, 389],
  },
  {
    genesis_token_id: 2022,
    wearable_ids: [352, 249],
  },
  {
    genesis_token_id: 2023,
    wearable_ids: [431, 394],
  },
  {
    genesis_token_id: 2024,
    wearable_ids: [314, 394],
  },
  {
    genesis_token_id: 2025,
    wearable_ids: [316, 375],
  },
  {
    genesis_token_id: 2026,
    wearable_ids: [314, 436],
  },
  {
    genesis_token_id: 2027,
    wearable_ids: [335, 306],
  },
  {
    genesis_token_id: 2028,
    wearable_ids: [289, 378],
  },
  {
    genesis_token_id: 2029,
    wearable_ids: [276, 395],
  },
  {
    genesis_token_id: 2030,
    wearable_ids: [253, 268],
  },
  {
    genesis_token_id: 2031,
    wearable_ids: [368, 406],
  },
  {
    genesis_token_id: 2032,
    wearable_ids: [369, 444],
  },
  {
    genesis_token_id: 2033,
    wearable_ids: [377, 273],
  },
  {
    genesis_token_id: 2034,
    wearable_ids: [395, 432],
  },
  {
    genesis_token_id: 2035,
    wearable_ids: [434, 443],
  },
  {
    genesis_token_id: 2036,
    wearable_ids: [444, 338],
  },
  {
    genesis_token_id: 2037,
    wearable_ids: [310, 332],
  },
  {
    genesis_token_id: 2038,
    wearable_ids: [435, 343],
  },
  {
    genesis_token_id: 2039,
    wearable_ids: [371, 348],
  },
  {
    genesis_token_id: 2040,
    wearable_ids: [429, 253],
  },
  {
    genesis_token_id: 2041,
    wearable_ids: [420, 376],
  },
  {
    genesis_token_id: 2042,
    wearable_ids: [445, 362],
  },
  {
    genesis_token_id: 2043,
    wearable_ids: [299, 445],
  },
  {
    genesis_token_id: 2044,
    wearable_ids: [399, 398],
  },
  {
    genesis_token_id: 2045,
    wearable_ids: [386, 401],
  },
  {
    genesis_token_id: 2046,
    wearable_ids: [424, 375],
  },
  {
    genesis_token_id: 2047,
    wearable_ids: [300, 290],
  },
  {
    genesis_token_id: 2048,
    wearable_ids: [273, 303],
  },
  {
    genesis_token_id: 2049,
    wearable_ids: [257, 332],
  },
  {
    genesis_token_id: 2050,
    wearable_ids: [262, 399],
  },
  {
    genesis_token_id: 2051,
    wearable_ids: [348, 347],
  },
  {
    genesis_token_id: 2052,
    wearable_ids: [383, 352],
  },
  {
    genesis_token_id: 2053,
    wearable_ids: [247, 389],
  },
  {
    genesis_token_id: 2054,
    wearable_ids: [442, 348],
  },
  {
    genesis_token_id: 2055,
    wearable_ids: [347, 330],
  },
  {
    genesis_token_id: 2056,
    wearable_ids: [317, 343],
  },
  {
    genesis_token_id: 2057,
    wearable_ids: [407, 438],
  },
  {
    genesis_token_id: 2058,
    wearable_ids: [415, 280],
  },
  {
    genesis_token_id: 2059,
    wearable_ids: [408, 428],
  },
  {
    genesis_token_id: 2060,
    wearable_ids: [371, 280],
  },
  {
    genesis_token_id: 2061,
    wearable_ids: [336, 435],
  },
  {
    genesis_token_id: 2062,
    wearable_ids: [395, 375],
  },
  {
    genesis_token_id: 2063,
    wearable_ids: [351, 301],
  },
  {
    genesis_token_id: 2064,
    wearable_ids: [349, 437],
  },
  {
    genesis_token_id: 2065,
    wearable_ids: [373, 281],
  },
  {
    genesis_token_id: 2066,
    wearable_ids: [341, 312],
  },
  {
    genesis_token_id: 2067,
    wearable_ids: [407, 342],
  },
  {
    genesis_token_id: 2068,
    wearable_ids: [247, 340],
  },
  {
    genesis_token_id: 2069,
    wearable_ids: [301, 425],
  },
  {
    genesis_token_id: 2070,
    wearable_ids: [428, 423],
  },
  {
    genesis_token_id: 2071,
    wearable_ids: [297, 349],
  },
  {
    genesis_token_id: 2072,
    wearable_ids: [343, 285],
  },
  {
    genesis_token_id: 2073,
    wearable_ids: [306, 304],
  },
  {
    genesis_token_id: 2074,
    wearable_ids: [297, 304],
  },
  {
    genesis_token_id: 2075,
    wearable_ids: [408, 326],
  },
  {
    genesis_token_id: 2076,
    wearable_ids: [264, 426],
  },
  {
    genesis_token_id: 2077,
    wearable_ids: [291, 442],
  },
  {
    genesis_token_id: 2078,
    wearable_ids: [247, 306],
  },
  {
    genesis_token_id: 2079,
    wearable_ids: [258, 402],
  },
  {
    genesis_token_id: 2080,
    wearable_ids: [332, 373],
  },
  {
    genesis_token_id: 2081,
    wearable_ids: [407, 371],
  },
  {
    genesis_token_id: 2082,
    wearable_ids: [247, 436],
  },
  {
    genesis_token_id: 2083,
    wearable_ids: [420, 432],
  },
  {
    genesis_token_id: 2084,
    wearable_ids: [264, 393],
  },
  {
    genesis_token_id: 2085,
    wearable_ids: [259, 376],
  },
  {
    genesis_token_id: 2086,
    wearable_ids: [274, 339],
  },
  {
    genesis_token_id: 2087,
    wearable_ids: [315, 332],
  },
  {
    genesis_token_id: 2088,
    wearable_ids: [340, 360],
  },
  {
    genesis_token_id: 2089,
    wearable_ids: [423, 274],
  },
  {
    genesis_token_id: 2090,
    wearable_ids: [265, 324],
  },
  {
    genesis_token_id: 2091,
    wearable_ids: [442, 395],
  },
  {
    genesis_token_id: 2092,
    wearable_ids: [339, 369],
  },
  {
    genesis_token_id: 2093,
    wearable_ids: [406, 326],
  },
  {
    genesis_token_id: 2094,
    wearable_ids: [253, 335],
  },
  {
    genesis_token_id: 2095,
    wearable_ids: [317, 437],
  },
  {
    genesis_token_id: 2096,
    wearable_ids: [347, 272],
  },
  {
    genesis_token_id: 2097,
    wearable_ids: [287, 323],
  },
  {
    genesis_token_id: 2098,
    wearable_ids: [253, 424],
  },
  {
    genesis_token_id: 2099,
    wearable_ids: [343, 436],
  },
  {
    genesis_token_id: 2100,
    wearable_ids: [251, 280],
  },
  {
    genesis_token_id: 2101,
    wearable_ids: [257, 411],
  },
  {
    genesis_token_id: 2102,
    wearable_ids: [432, 417],
  },
  {
    genesis_token_id: 2103,
    wearable_ids: [369, 339],
  },
  {
    genesis_token_id: 2104,
    wearable_ids: [289, 433],
  },
  {
    genesis_token_id: 2105,
    wearable_ids: [428, 300],
  },
  {
    genesis_token_id: 2106,
    wearable_ids: [354, 394],
  },
  {
    genesis_token_id: 2107,
    wearable_ids: [263, 280],
  },
  {
    genesis_token_id: 2108,
    wearable_ids: [265, 313],
  },
  {
    genesis_token_id: 2109,
    wearable_ids: [271, 333],
  },
  {
    genesis_token_id: 2110,
    wearable_ids: [352, 266],
  },
  {
    genesis_token_id: 2111,
    wearable_ids: [396, 357],
  },
  {
    genesis_token_id: 2112,
    wearable_ids: [255, 397],
  },
  {
    genesis_token_id: 2113,
    wearable_ids: [308, 331],
  },
  {
    genesis_token_id: 2114,
    wearable_ids: [351, 291],
  },
  {
    genesis_token_id: 2115,
    wearable_ids: [362, 302],
  },
  {
    genesis_token_id: 2116,
    wearable_ids: [397, 315],
  },
  {
    genesis_token_id: 2117,
    wearable_ids: [406, 335],
  },
  {
    genesis_token_id: 2118,
    wearable_ids: [352, 400],
  },
  {
    genesis_token_id: 2119,
    wearable_ids: [411, 280],
  },
  {
    genesis_token_id: 2120,
    wearable_ids: [444, 251],
  },
  {
    genesis_token_id: 2121,
    wearable_ids: [443, 341],
  },
  {
    genesis_token_id: 2122,
    wearable_ids: [350, 431],
  },
  {
    genesis_token_id: 2123,
    wearable_ids: [372, 377],
  },
  {
    genesis_token_id: 2124,
    wearable_ids: [385, 437],
  },
  {
    genesis_token_id: 2125,
    wearable_ids: [370, 382],
  },
  {
    genesis_token_id: 2126,
    wearable_ids: [264, 331],
  },
  {
    genesis_token_id: 2127,
    wearable_ids: [373, 385],
  },
  {
    genesis_token_id: 2128,
    wearable_ids: [268, 324],
  },
  {
    genesis_token_id: 2129,
    wearable_ids: [411, 308],
  },
  {
    genesis_token_id: 2130,
    wearable_ids: [434, 298],
  },
  {
    genesis_token_id: 2131,
    wearable_ids: [396, 297],
  },
  {
    genesis_token_id: 2132,
    wearable_ids: [292, 395],
  },
  {
    genesis_token_id: 2133,
    wearable_ids: [315, 422],
  },
  {
    genesis_token_id: 2134,
    wearable_ids: [292, 340],
  },
  {
    genesis_token_id: 2135,
    wearable_ids: [325, 318],
  },
  {
    genesis_token_id: 2136,
    wearable_ids: [437, 263],
  },
  {
    genesis_token_id: 2137,
    wearable_ids: [371, 408],
  },
  {
    genesis_token_id: 2138,
    wearable_ids: [338, 341],
  },
  {
    genesis_token_id: 2139,
    wearable_ids: [257, 258],
  },
  {
    genesis_token_id: 2140,
    wearable_ids: [348, 440],
  },
  {
    genesis_token_id: 2141,
    wearable_ids: [278, 297],
  },
  {
    genesis_token_id: 2142,
    wearable_ids: [425, 274],
  },
  {
    genesis_token_id: 2143,
    wearable_ids: [415, 332],
  },
  {
    genesis_token_id: 2144,
    wearable_ids: [341, 271],
  },
  {
    genesis_token_id: 2145,
    wearable_ids: [403, 369],
  },
  {
    genesis_token_id: 2146,
    wearable_ids: [435, 343],
  },
  {
    genesis_token_id: 2147,
    wearable_ids: [385, 334],
  },
  {
    genesis_token_id: 2148,
    wearable_ids: [386, 288],
  },
  {
    genesis_token_id: 2149,
    wearable_ids: [290, 323],
  },
  {
    genesis_token_id: 2150,
    wearable_ids: [304, 308],
  },
  {
    genesis_token_id: 2151,
    wearable_ids: [349, 246],
  },
  {
    genesis_token_id: 2152,
    wearable_ids: [303, 298],
  },
  {
    genesis_token_id: 2153,
    wearable_ids: [254, 428],
  },
  {
    genesis_token_id: 2154,
    wearable_ids: [349, 286],
  },
  {
    genesis_token_id: 2155,
    wearable_ids: [369, 302],
  },
  {
    genesis_token_id: 2156,
    wearable_ids: [295, 259],
  },
  {
    genesis_token_id: 2157,
    wearable_ids: [365, 357],
  },
  {
    genesis_token_id: 2158,
    wearable_ids: [389, 323],
  },
  {
    genesis_token_id: 2159,
    wearable_ids: [265, 270],
  },
  {
    genesis_token_id: 2160,
    wearable_ids: [422, 402],
  },
  {
    genesis_token_id: 2161,
    wearable_ids: [395, 431],
  },
  {
    genesis_token_id: 2162,
    wearable_ids: [324, 433],
  },
  {
    genesis_token_id: 2163,
    wearable_ids: [347, 335],
  },
  {
    genesis_token_id: 2164,
    wearable_ids: [431, 250],
  },
  {
    genesis_token_id: 2165,
    wearable_ids: [339, 263],
  },
  {
    genesis_token_id: 2166,
    wearable_ids: [403, 332],
  },
  {
    genesis_token_id: 2167,
    wearable_ids: [406, 326],
  },
  {
    genesis_token_id: 2168,
    wearable_ids: [425, 310],
  },
  {
    genesis_token_id: 2169,
    wearable_ids: [306, 272],
  },
  {
    genesis_token_id: 2170,
    wearable_ids: [374, 315],
  },
  {
    genesis_token_id: 2171,
    wearable_ids: [431, 294],
  },
  {
    genesis_token_id: 2172,
    wearable_ids: [311, 376],
  },
  {
    genesis_token_id: 2173,
    wearable_ids: [294, 443],
  },
  {
    genesis_token_id: 2174,
    wearable_ids: [297, 403],
  },
  {
    genesis_token_id: 2175,
    wearable_ids: [253, 426],
  },
  {
    genesis_token_id: 2176,
    wearable_ids: [272, 366],
  },
  {
    genesis_token_id: 2177,
    wearable_ids: [277, 399],
  },
  {
    genesis_token_id: 2178,
    wearable_ids: [319, 396],
  },
  {
    genesis_token_id: 2179,
    wearable_ids: [335, 268],
  },
  {
    genesis_token_id: 2180,
    wearable_ids: [274, 414],
  },
  {
    genesis_token_id: 2181,
    wearable_ids: [364, 437],
  },
  {
    genesis_token_id: 2182,
    wearable_ids: [349, 336],
  },
  {
    genesis_token_id: 2183,
    wearable_ids: [339, 435],
  },
  {
    genesis_token_id: 2184,
    wearable_ids: [408, 322],
  },
  {
    genesis_token_id: 2185,
    wearable_ids: [371, 369],
  },
  {
    genesis_token_id: 2186,
    wearable_ids: [332, 411],
  },
  {
    genesis_token_id: 2187,
    wearable_ids: [262, 423],
  },
  {
    genesis_token_id: 2188,
    wearable_ids: [404, 312],
  },
  {
    genesis_token_id: 2189,
    wearable_ids: [389, 370],
  },
  {
    genesis_token_id: 2190,
    wearable_ids: [299, 292],
  },
  {
    genesis_token_id: 2191,
    wearable_ids: [376, 341],
  },
  {
    genesis_token_id: 2192,
    wearable_ids: [363, 341],
  },
  {
    genesis_token_id: 2193,
    wearable_ids: [308, 352],
  },
  {
    genesis_token_id: 2194,
    wearable_ids: [262, 257],
  },
  {
    genesis_token_id: 2195,
    wearable_ids: [278, 354],
  },
  {
    genesis_token_id: 2196,
    wearable_ids: [332, 254],
  },
  {
    genesis_token_id: 2197,
    wearable_ids: [420, 264],
  },
  {
    genesis_token_id: 2198,
    wearable_ids: [434, 426],
  },
  {
    genesis_token_id: 2199,
    wearable_ids: [287, 442],
  },
  {
    genesis_token_id: 2200,
    wearable_ids: [395, 358],
  },
  {
    genesis_token_id: 2201,
    wearable_ids: [374, 438],
  },
  {
    genesis_token_id: 2202,
    wearable_ids: [368, 365],
  },
  {
    genesis_token_id: 2203,
    wearable_ids: [324, 311],
  },
  {
    genesis_token_id: 2204,
    wearable_ids: [331, 264],
  },
  {
    genesis_token_id: 2205,
    wearable_ids: [289, 444],
  },
  {
    genesis_token_id: 2206,
    wearable_ids: [315, 292],
  },
  {
    genesis_token_id: 2207,
    wearable_ids: [291, 420],
  },
  {
    genesis_token_id: 2208,
    wearable_ids: [271, 355],
  },
  {
    genesis_token_id: 2209,
    wearable_ids: [433, 349],
  },
  {
    genesis_token_id: 2210,
    wearable_ids: [341, 316],
  },
  {
    genesis_token_id: 2211,
    wearable_ids: [294, 259],
  },
  {
    genesis_token_id: 2212,
    wearable_ids: [342, 430],
  },
  {
    genesis_token_id: 2213,
    wearable_ids: [351, 255],
  },
  {
    genesis_token_id: 2214,
    wearable_ids: [411, 286],
  },
  {
    genesis_token_id: 2215,
    wearable_ids: [370, 403],
  },
  {
    genesis_token_id: 2216,
    wearable_ids: [354, 268],
  },
  {
    genesis_token_id: 2217,
    wearable_ids: [299, 306],
  },
  {
    genesis_token_id: 2218,
    wearable_ids: [264, 410],
  },
  {
    genesis_token_id: 2219,
    wearable_ids: [319, 351],
  },
  {
    genesis_token_id: 2220,
    wearable_ids: [349, 414],
  },
  {
    genesis_token_id: 2221,
    wearable_ids: [339, 267],
  },
  {
    genesis_token_id: 2222,
    wearable_ids: [399, 384],
  },
  {
    genesis_token_id: 2223,
    wearable_ids: [315, 318],
  },
  {
    genesis_token_id: 2224,
    wearable_ids: [254, 248],
  },
  {
    genesis_token_id: 2225,
    wearable_ids: [365, 346],
  },
  {
    genesis_token_id: 2226,
    wearable_ids: [423, 350],
  },
  {
    genesis_token_id: 2227,
    wearable_ids: [346, 397],
  },
  {
    genesis_token_id: 2228,
    wearable_ids: [371, 372],
  },
  {
    genesis_token_id: 2229,
    wearable_ids: [248, 325],
  },
  {
    genesis_token_id: 2230,
    wearable_ids: [399, 437],
  },
  {
    genesis_token_id: 2231,
    wearable_ids: [310, 362],
  },
  {
    genesis_token_id: 2232,
    wearable_ids: [378, 418],
  },
  {
    genesis_token_id: 2233,
    wearable_ids: [437, 248],
  },
  {
    genesis_token_id: 2234,
    wearable_ids: [343, 255],
  },
  {
    genesis_token_id: 2235,
    wearable_ids: [372, 335],
  },
  {
    genesis_token_id: 2236,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 2237,
    wearable_ids: [410, 324],
  },
  {
    genesis_token_id: 2238,
    wearable_ids: [415, 377],
  },
  {
    genesis_token_id: 2239,
    wearable_ids: [287, 295],
  },
  {
    genesis_token_id: 2240,
    wearable_ids: [425, 308],
  },
  {
    genesis_token_id: 2241,
    wearable_ids: [263, 394],
  },
  {
    genesis_token_id: 2242,
    wearable_ids: [365, 423],
  },
  {
    genesis_token_id: 2243,
    wearable_ids: [347, 432],
  },
  {
    genesis_token_id: 2244,
    wearable_ids: [301, 296],
  },
  {
    genesis_token_id: 2245,
    wearable_ids: [303, 376],
  },
  {
    genesis_token_id: 2246,
    wearable_ids: [432, 370],
  },
  {
    genesis_token_id: 2247,
    wearable_ids: [355, 391],
  },
  {
    genesis_token_id: 2248,
    wearable_ids: [294, 426],
  },
  {
    genesis_token_id: 2249,
    wearable_ids: [433, 360],
  },
  {
    genesis_token_id: 2250,
    wearable_ids: [311, 405],
  },
  {
    genesis_token_id: 2251,
    wearable_ids: [399, 303],
  },
  {
    genesis_token_id: 2252,
    wearable_ids: [428, 278],
  },
  {
    genesis_token_id: 2253,
    wearable_ids: [435, 370],
  },
  {
    genesis_token_id: 2254,
    wearable_ids: [365, 259],
  },
  {
    genesis_token_id: 2255,
    wearable_ids: [317, 280],
  },
  {
    genesis_token_id: 2256,
    wearable_ids: [387, 355],
  },
  {
    genesis_token_id: 2257,
    wearable_ids: [415, 294],
  },
  {
    genesis_token_id: 2258,
    wearable_ids: [268, 314],
  },
  {
    genesis_token_id: 2259,
    wearable_ids: [408, 347],
  },
  {
    genesis_token_id: 2260,
    wearable_ids: [352, 253],
  },
  {
    genesis_token_id: 2261,
    wearable_ids: [372, 316],
  },
  {
    genesis_token_id: 2262,
    wearable_ids: [338, 342],
  },
  {
    genesis_token_id: 2263,
    wearable_ids: [296, 427],
  },
  {
    genesis_token_id: 2264,
    wearable_ids: [370, 416],
  },
  {
    genesis_token_id: 2265,
    wearable_ids: [436, 340],
  },
  {
    genesis_token_id: 2266,
    wearable_ids: [303, 389],
  },
  {
    genesis_token_id: 2267,
    wearable_ids: [408, 301],
  },
  {
    genesis_token_id: 2268,
    wearable_ids: [289, 415],
  },
  {
    genesis_token_id: 2269,
    wearable_ids: [415, 314],
  },
  {
    genesis_token_id: 2270,
    wearable_ids: [273, 308],
  },
  {
    genesis_token_id: 2271,
    wearable_ids: [346, 298],
  },
  {
    genesis_token_id: 2272,
    wearable_ids: [315, 413],
  },
  {
    genesis_token_id: 2273,
    wearable_ids: [317, 307],
  },
  {
    genesis_token_id: 2274,
    wearable_ids: [338, 249],
  },
  {
    genesis_token_id: 2275,
    wearable_ids: [365, 404],
  },
  {
    genesis_token_id: 2276,
    wearable_ids: [406, 287],
  },
  {
    genesis_token_id: 2277,
    wearable_ids: [257, 423],
  },
  {
    genesis_token_id: 2278,
    wearable_ids: [332, 428],
  },
  {
    genesis_token_id: 2279,
    wearable_ids: [352, 283],
  },
  {
    genesis_token_id: 2280,
    wearable_ids: [304, 391],
  },
  {
    genesis_token_id: 2281,
    wearable_ids: [410, 268],
  },
  {
    genesis_token_id: 2282,
    wearable_ids: [351, 312],
  },
  {
    genesis_token_id: 2283,
    wearable_ids: [308, 276],
  },
  {
    genesis_token_id: 2284,
    wearable_ids: [384, 259],
  },
  {
    genesis_token_id: 2285,
    wearable_ids: [258, 355],
  },
  {
    genesis_token_id: 2286,
    wearable_ids: [273, 297],
  },
  {
    genesis_token_id: 2287,
    wearable_ids: [294, 373],
  },
  {
    genesis_token_id: 2288,
    wearable_ids: [335, 397],
  },
  {
    genesis_token_id: 2289,
    wearable_ids: [311, 268],
  },
  {
    genesis_token_id: 2290,
    wearable_ids: [316, 396],
  },
  {
    genesis_token_id: 2291,
    wearable_ids: [412, 355],
  },
  {
    genesis_token_id: 2292,
    wearable_ids: [268, 336],
  },
  {
    genesis_token_id: 2293,
    wearable_ids: [432, 368],
  },
  {
    genesis_token_id: 2294,
    wearable_ids: [277, 353],
  },
  {
    genesis_token_id: 2295,
    wearable_ids: [325, 303],
  },
  {
    genesis_token_id: 2296,
    wearable_ids: [355, 337],
  },
  {
    genesis_token_id: 2297,
    wearable_ids: [325, 266],
  },
  {
    genesis_token_id: 2298,
    wearable_ids: [382, 368],
  },
  {
    genesis_token_id: 2299,
    wearable_ids: [410, 265],
  },
  {
    genesis_token_id: 2300,
    wearable_ids: [387, 410],
  },
  {
    genesis_token_id: 2301,
    wearable_ids: [344, 442],
  },
  {
    genesis_token_id: 2302,
    wearable_ids: [274, 375],
  },
  {
    genesis_token_id: 2303,
    wearable_ids: [337, 312],
  },
  {
    genesis_token_id: 2304,
    wearable_ids: [315, 382],
  },
  {
    genesis_token_id: 2305,
    wearable_ids: [442, 310],
  },
  {
    genesis_token_id: 2306,
    wearable_ids: [332, 437],
  },
  {
    genesis_token_id: 2307,
    wearable_ids: [247, 392],
  },
  {
    genesis_token_id: 2308,
    wearable_ids: [308, 410],
  },
  {
    genesis_token_id: 2309,
    wearable_ids: [278, 403],
  },
  {
    genesis_token_id: 2310,
    wearable_ids: [396, 289],
  },
  {
    genesis_token_id: 2311,
    wearable_ids: [265, 324],
  },
  {
    genesis_token_id: 2312,
    wearable_ids: [350, 427],
  },
  {
    genesis_token_id: 2313,
    wearable_ids: [436, 397],
  },
  {
    genesis_token_id: 2314,
    wearable_ids: [378, 433],
  },
  {
    genesis_token_id: 2315,
    wearable_ids: [423, 284],
  },
  {
    genesis_token_id: 2316,
    wearable_ids: [424, 428],
  },
  {
    genesis_token_id: 2317,
    wearable_ids: [277, 354],
  },
  {
    genesis_token_id: 2318,
    wearable_ids: [363, 290],
  },
  {
    genesis_token_id: 2319,
    wearable_ids: [337, 428],
  },
  {
    genesis_token_id: 2320,
    wearable_ids: [290, 296],
  },
  {
    genesis_token_id: 2321,
    wearable_ids: [332, 294],
  },
  {
    genesis_token_id: 2322,
    wearable_ids: [431, 316],
  },
  {
    genesis_token_id: 2323,
    wearable_ids: [342, 326],
  },
  {
    genesis_token_id: 2324,
    wearable_ids: [384, 308],
  },
  {
    genesis_token_id: 2325,
    wearable_ids: [255, 293],
  },
  {
    genesis_token_id: 2326,
    wearable_ids: [368, 266],
  },
  {
    genesis_token_id: 2327,
    wearable_ids: [397, 317],
  },
  {
    genesis_token_id: 2328,
    wearable_ids: [257, 406],
  },
  {
    genesis_token_id: 2329,
    wearable_ids: [423, 347],
  },
  {
    genesis_token_id: 2330,
    wearable_ids: [254, 274],
  },
  {
    genesis_token_id: 2331,
    wearable_ids: [445, 266],
  },
  {
    genesis_token_id: 2332,
    wearable_ids: [247, 442],
  },
  {
    genesis_token_id: 2333,
    wearable_ids: [382, 259],
  },
  {
    genesis_token_id: 2334,
    wearable_ids: [399, 246],
  },
  {
    genesis_token_id: 2335,
    wearable_ids: [273, 343],
  },
  {
    genesis_token_id: 2336,
    wearable_ids: [263, 382],
  },
  {
    genesis_token_id: 2337,
    wearable_ids: [378, 340],
  },
  {
    genesis_token_id: 2338,
    wearable_ids: [374, 258],
  },
  {
    genesis_token_id: 2339,
    wearable_ids: [336, 247],
  },
  {
    genesis_token_id: 2340,
    wearable_ids: [303, 307],
  },
  {
    genesis_token_id: 2341,
    wearable_ids: [324, 379],
  },
  {
    genesis_token_id: 2342,
    wearable_ids: [375, 379],
  },
  {
    genesis_token_id: 2343,
    wearable_ids: [383, 319],
  },
  {
    genesis_token_id: 2344,
    wearable_ids: [255, 253],
  },
  {
    genesis_token_id: 2345,
    wearable_ids: [374, 424],
  },
  {
    genesis_token_id: 2346,
    wearable_ids: [295, 292],
  },
  {
    genesis_token_id: 2347,
    wearable_ids: [362, 364],
  },
  {
    genesis_token_id: 2348,
    wearable_ids: [331, 291],
  },
  {
    genesis_token_id: 2349,
    wearable_ids: [306, 362],
  },
  {
    genesis_token_id: 2350,
    wearable_ids: [354, 299],
  },
  {
    genesis_token_id: 2351,
    wearable_ids: [341, 407],
  },
  {
    genesis_token_id: 2352,
    wearable_ids: [303, 412],
  },
  {
    genesis_token_id: 2353,
    wearable_ids: [372, 308],
  },
  {
    genesis_token_id: 2354,
    wearable_ids: [303, 368],
  },
  {
    genesis_token_id: 2355,
    wearable_ids: [404, 335],
  },
  {
    genesis_token_id: 2356,
    wearable_ids: [443, 409],
  },
  {
    genesis_token_id: 2357,
    wearable_ids: [423, 287],
  },
  {
    genesis_token_id: 2358,
    wearable_ids: [263, 304],
  },
  {
    genesis_token_id: 2359,
    wearable_ids: [266, 408],
  },
  {
    genesis_token_id: 2360,
    wearable_ids: [343, 372],
  },
  {
    genesis_token_id: 2361,
    wearable_ids: [420, 441],
  },
  {
    genesis_token_id: 2362,
    wearable_ids: [389, 424],
  },
  {
    genesis_token_id: 2363,
    wearable_ids: [332, 423],
  },
  {
    genesis_token_id: 2364,
    wearable_ids: [415, 267],
  },
  {
    genesis_token_id: 2365,
    wearable_ids: [335, 287],
  },
  {
    genesis_token_id: 2366,
    wearable_ids: [362, 433],
  },
  {
    genesis_token_id: 2367,
    wearable_ids: [308, 348],
  },
  {
    genesis_token_id: 2368,
    wearable_ids: [364, 272],
  },
  {
    genesis_token_id: 2369,
    wearable_ids: [277, 355],
  },
  {
    genesis_token_id: 2370,
    wearable_ids: [340, 283],
  },
  {
    genesis_token_id: 2371,
    wearable_ids: [268, 426],
  },
  {
    genesis_token_id: 2372,
    wearable_ids: [349, 366],
  },
  {
    genesis_token_id: 2373,
    wearable_ids: [362, 411],
  },
  {
    genesis_token_id: 2374,
    wearable_ids: [426, 440],
  },
  {
    genesis_token_id: 2375,
    wearable_ids: [368, 387],
  },
  {
    genesis_token_id: 2376,
    wearable_ids: [415, 408],
  },
  {
    genesis_token_id: 2377,
    wearable_ids: [280, 363],
  },
  {
    genesis_token_id: 2378,
    wearable_ids: [373, 412],
  },
  {
    genesis_token_id: 2379,
    wearable_ids: [352, 335],
  },
  {
    genesis_token_id: 2380,
    wearable_ids: [337, 311],
  },
  {
    genesis_token_id: 2381,
    wearable_ids: [375, 383],
  },
  {
    genesis_token_id: 2382,
    wearable_ids: [273, 251],
  },
  {
    genesis_token_id: 2383,
    wearable_ids: [436, 385],
  },
  {
    genesis_token_id: 2384,
    wearable_ids: [290, 350],
  },
  {
    genesis_token_id: 2385,
    wearable_ids: [396, 291],
  },
  {
    genesis_token_id: 2386,
    wearable_ids: [425, 256],
  },
  {
    genesis_token_id: 2387,
    wearable_ids: [354, 427],
  },
  {
    genesis_token_id: 2388,
    wearable_ids: [326, 316],
  },
  {
    genesis_token_id: 2389,
    wearable_ids: [351, 341],
  },
  {
    genesis_token_id: 2390,
    wearable_ids: [373, 415],
  },
  {
    genesis_token_id: 2391,
    wearable_ids: [314, 299],
  },
  {
    genesis_token_id: 2392,
    wearable_ids: [259, 340],
  },
  {
    genesis_token_id: 2393,
    wearable_ids: [335, 271],
  },
  {
    genesis_token_id: 2394,
    wearable_ids: [403, 404],
  },
  {
    genesis_token_id: 2395,
    wearable_ids: [382, 262],
  },
  {
    genesis_token_id: 2396,
    wearable_ids: [423, 377],
  },
  {
    genesis_token_id: 2397,
    wearable_ids: [422, 305],
  },
  {
    genesis_token_id: 2398,
    wearable_ids: [332, 335],
  },
  {
    genesis_token_id: 2399,
    wearable_ids: [290, 411],
  },
  {
    genesis_token_id: 2400,
    wearable_ids: [362, 378],
  },
  {
    genesis_token_id: 2401,
    wearable_ids: [436, 277],
  },
  {
    genesis_token_id: 2402,
    wearable_ids: [331, 348],
  },
  {
    genesis_token_id: 2403,
    wearable_ids: [404, 428],
  },
  {
    genesis_token_id: 2404,
    wearable_ids: [442, 395],
  },
  {
    genesis_token_id: 2405,
    wearable_ids: [424, 326],
  },
  {
    genesis_token_id: 2406,
    wearable_ids: [343, 308],
  },
  {
    genesis_token_id: 2407,
    wearable_ids: [442, 429],
  },
  {
    genesis_token_id: 2408,
    wearable_ids: [352, 342],
  },
  {
    genesis_token_id: 2409,
    wearable_ids: [280, 432],
  },
  {
    genesis_token_id: 2410,
    wearable_ids: [319, 350],
  },
  {
    genesis_token_id: 2411,
    wearable_ids: [292, 288],
  },
  {
    genesis_token_id: 2412,
    wearable_ids: [294, 352],
  },
  {
    genesis_token_id: 2413,
    wearable_ids: [274, 341],
  },
  {
    genesis_token_id: 2414,
    wearable_ids: [399, 289],
  },
  {
    genesis_token_id: 2415,
    wearable_ids: [428, 281],
  },
  {
    genesis_token_id: 2416,
    wearable_ids: [422, 336],
  },
  {
    genesis_token_id: 2417,
    wearable_ids: [428, 277],
  },
  {
    genesis_token_id: 2418,
    wearable_ids: [326, 385],
  },
  {
    genesis_token_id: 2419,
    wearable_ids: [354, 420],
  },
  {
    genesis_token_id: 2420,
    wearable_ids: [335, 442],
  },
  {
    genesis_token_id: 2421,
    wearable_ids: [316, 342],
  },
  {
    genesis_token_id: 2422,
    wearable_ids: [376, 410],
  },
  {
    genesis_token_id: 2423,
    wearable_ids: [400, 331],
  },
  {
    genesis_token_id: 2424,
    wearable_ids: [258, 279],
  },
  {
    genesis_token_id: 2425,
    wearable_ids: [265, 284],
  },
  {
    genesis_token_id: 2426,
    wearable_ids: [409, 276],
  },
  {
    genesis_token_id: 2427,
    wearable_ids: [442, 290],
  },
  {
    genesis_token_id: 2428,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 2429,
    wearable_ids: [291, 273],
  },
  {
    genesis_token_id: 2430,
    wearable_ids: [434, 349],
  },
  {
    genesis_token_id: 2431,
    wearable_ids: [331, 371],
  },
  {
    genesis_token_id: 2432,
    wearable_ids: [256, 254],
  },
  {
    genesis_token_id: 2433,
    wearable_ids: [299, 307],
  },
  {
    genesis_token_id: 2434,
    wearable_ids: [377, 264],
  },
  {
    genesis_token_id: 2435,
    wearable_ids: [400, 419],
  },
  {
    genesis_token_id: 2436,
    wearable_ids: [409, 425],
  },
  {
    genesis_token_id: 2437,
    wearable_ids: [296, 298],
  },
  {
    genesis_token_id: 2438,
    wearable_ids: [314, 266],
  },
  {
    genesis_token_id: 2439,
    wearable_ids: [341, 384],
  },
  {
    genesis_token_id: 2440,
    wearable_ids: [442, 270],
  },
  {
    genesis_token_id: 2441,
    wearable_ids: [308, 377],
  },
  {
    genesis_token_id: 2442,
    wearable_ids: [376, 292],
  },
  {
    genesis_token_id: 2443,
    wearable_ids: [346, 416],
  },
  {
    genesis_token_id: 2444,
    wearable_ids: [375, 347],
  },
  {
    genesis_token_id: 2445,
    wearable_ids: [364, 288],
  },
  {
    genesis_token_id: 2446,
    wearable_ids: [274, 277],
  },
  {
    genesis_token_id: 2447,
    wearable_ids: [425, 389],
  },
  {
    genesis_token_id: 2448,
    wearable_ids: [362, 397],
  },
  {
    genesis_token_id: 2449,
    wearable_ids: [253, 417],
  },
  {
    genesis_token_id: 2450,
    wearable_ids: [264, 378],
  },
  {
    genesis_token_id: 2451,
    wearable_ids: [310, 340],
  },
  {
    genesis_token_id: 2452,
    wearable_ids: [433, 394],
  },
  {
    genesis_token_id: 2453,
    wearable_ids: [273, 372],
  },
  {
    genesis_token_id: 2454,
    wearable_ids: [370, 425],
  },
  {
    genesis_token_id: 2455,
    wearable_ids: [254, 399],
  },
  {
    genesis_token_id: 2456,
    wearable_ids: [300, 408],
  },
  {
    genesis_token_id: 2457,
    wearable_ids: [331, 398],
  },
  {
    genesis_token_id: 2458,
    wearable_ids: [287, 373],
  },
  {
    genesis_token_id: 2459,
    wearable_ids: [386, 353],
  },
  {
    genesis_token_id: 2460,
    wearable_ids: [271, 341],
  },
  {
    genesis_token_id: 2461,
    wearable_ids: [248, 378],
  },
  {
    genesis_token_id: 2462,
    wearable_ids: [284, 270],
  },
  {
    genesis_token_id: 2463,
    wearable_ids: [306, 340],
  },
  {
    genesis_token_id: 2464,
    wearable_ids: [413, 284],
  },
  {
    genesis_token_id: 2465,
    wearable_ids: [420, 375],
  },
  {
    genesis_token_id: 2466,
    wearable_ids: [355, 391],
  },
  {
    genesis_token_id: 2467,
    wearable_ids: [263, 440],
  },
  {
    genesis_token_id: 2468,
    wearable_ids: [400, 442],
  },
  {
    genesis_token_id: 2469,
    wearable_ids: [294, 363],
  },
  {
    genesis_token_id: 2470,
    wearable_ids: [376, 418],
  },
  {
    genesis_token_id: 2471,
    wearable_ids: [338, 387],
  },
  {
    genesis_token_id: 2472,
    wearable_ids: [344, 294],
  },
  {
    genesis_token_id: 2473,
    wearable_ids: [350, 323],
  },
  {
    genesis_token_id: 2474,
    wearable_ids: [296, 278],
  },
  {
    genesis_token_id: 2475,
    wearable_ids: [350, 303],
  },
  {
    genesis_token_id: 2476,
    wearable_ids: [370, 407],
  },
  {
    genesis_token_id: 2477,
    wearable_ids: [354, 370],
  },
  {
    genesis_token_id: 2478,
    wearable_ids: [274, 382],
  },
  {
    genesis_token_id: 2479,
    wearable_ids: [266, 303],
  },
  {
    genesis_token_id: 2480,
    wearable_ids: [354, 408],
  },
  {
    genesis_token_id: 2481,
    wearable_ids: [284, 279],
  },
  {
    genesis_token_id: 2482,
    wearable_ids: [290, 307],
  },
  {
    genesis_token_id: 2483,
    wearable_ids: [273, 354],
  },
  {
    genesis_token_id: 2484,
    wearable_ids: [277, 267],
  },
  {
    genesis_token_id: 2485,
    wearable_ids: [396, 313],
  },
  {
    genesis_token_id: 2486,
    wearable_ids: [371, 409],
  },
  {
    genesis_token_id: 2487,
    wearable_ids: [331, 347],
  },
  {
    genesis_token_id: 2488,
    wearable_ids: [420, 433],
  },
  {
    genesis_token_id: 2489,
    wearable_ids: [371, 263],
  },
  {
    genesis_token_id: 2490,
    wearable_ids: [365, 338],
  },
  {
    genesis_token_id: 2491,
    wearable_ids: [369, 442],
  },
  {
    genesis_token_id: 2492,
    wearable_ids: [424, 347],
  },
  {
    genesis_token_id: 2493,
    wearable_ids: [296, 411],
  },
  {
    genesis_token_id: 2494,
    wearable_ids: [404, 290],
  },
  {
    genesis_token_id: 2495,
    wearable_ids: [432, 346],
  },
  {
    genesis_token_id: 2496,
    wearable_ids: [412, 434],
  },
  {
    genesis_token_id: 2497,
    wearable_ids: [343, 276],
  },
  {
    genesis_token_id: 2498,
    wearable_ids: [335, 280],
  },
  {
    genesis_token_id: 2499,
    wearable_ids: [315, 418],
  },
  {
    genesis_token_id: 2500,
    wearable_ids: [420, 273],
  },
  {
    genesis_token_id: 2501,
    wearable_ids: [396, 346],
  },
  {
    genesis_token_id: 2502,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 2503,
    wearable_ids: [271, 247],
  },
  {
    genesis_token_id: 2504,
    wearable_ids: [294, 290],
  },
  {
    genesis_token_id: 2505,
    wearable_ids: [317, 372],
  },
  {
    genesis_token_id: 2506,
    wearable_ids: [324, 253],
  },
  {
    genesis_token_id: 2507,
    wearable_ids: [251, 382],
  },
  {
    genesis_token_id: 2508,
    wearable_ids: [310, 359],
  },
  {
    genesis_token_id: 2509,
    wearable_ids: [287, 415],
  },
  {
    genesis_token_id: 2510,
    wearable_ids: [340, 294],
  },
  {
    genesis_token_id: 2511,
    wearable_ids: [411, 285],
  },
  {
    genesis_token_id: 2512,
    wearable_ids: [255, 434],
  },
  {
    genesis_token_id: 2513,
    wearable_ids: [369, 397],
  },
  {
    genesis_token_id: 2514,
    wearable_ids: [348, 336],
  },
  {
    genesis_token_id: 2515,
    wearable_ids: [317, 384],
  },
  {
    genesis_token_id: 2516,
    wearable_ids: [335, 338],
  },
  {
    genesis_token_id: 2517,
    wearable_ids: [268, 368],
  },
  {
    genesis_token_id: 2518,
    wearable_ids: [362, 254],
  },
  {
    genesis_token_id: 2519,
    wearable_ids: [386, 432],
  },
  {
    genesis_token_id: 2520,
    wearable_ids: [352, 345],
  },
  {
    genesis_token_id: 2521,
    wearable_ids: [291, 271],
  },
  {
    genesis_token_id: 2522,
    wearable_ids: [369, 360],
  },
  {
    genesis_token_id: 2523,
    wearable_ids: [377, 408],
  },
  {
    genesis_token_id: 2524,
    wearable_ids: [413, 294],
  },
  {
    genesis_token_id: 2525,
    wearable_ids: [415, 344],
  },
  {
    genesis_token_id: 2526,
    wearable_ids: [314, 375],
  },
  {
    genesis_token_id: 2527,
    wearable_ids: [271, 406],
  },
  {
    genesis_token_id: 2528,
    wearable_ids: [258, 436],
  },
  {
    genesis_token_id: 2529,
    wearable_ids: [272, 343],
  },
  {
    genesis_token_id: 2530,
    wearable_ids: [336, 310],
  },
  {
    genesis_token_id: 2531,
    wearable_ids: [346, 284],
  },
  {
    genesis_token_id: 2532,
    wearable_ids: [431, 326],
  },
  {
    genesis_token_id: 2533,
    wearable_ids: [347, 342],
  },
  {
    genesis_token_id: 2534,
    wearable_ids: [311, 254],
  },
  {
    genesis_token_id: 2535,
    wearable_ids: [343, 424],
  },
  {
    genesis_token_id: 2536,
    wearable_ids: [374, 357],
  },
  {
    genesis_token_id: 2537,
    wearable_ids: [251, 372],
  },
  {
    genesis_token_id: 2538,
    wearable_ids: [335, 259],
  },
  {
    genesis_token_id: 2539,
    wearable_ids: [336, 346],
  },
  {
    genesis_token_id: 2540,
    wearable_ids: [295, 387],
  },
  {
    genesis_token_id: 2541,
    wearable_ids: [351, 303],
  },
  {
    genesis_token_id: 2542,
    wearable_ids: [436, 247],
  },
  {
    genesis_token_id: 2543,
    wearable_ids: [253, 437],
  },
  {
    genesis_token_id: 2544,
    wearable_ids: [389, 271],
  },
  {
    genesis_token_id: 2545,
    wearable_ids: [287, 404],
  },
  {
    genesis_token_id: 2546,
    wearable_ids: [292, 248],
  },
  {
    genesis_token_id: 2547,
    wearable_ids: [426, 434],
  },
  {
    genesis_token_id: 2548,
    wearable_ids: [350, 257],
  },
  {
    genesis_token_id: 2549,
    wearable_ids: [335, 311],
  },
  {
    genesis_token_id: 2550,
    wearable_ids: [336, 385],
  },
  {
    genesis_token_id: 2551,
    wearable_ids: [324, 264],
  },
  {
    genesis_token_id: 2552,
    wearable_ids: [355, 425],
  },
  {
    genesis_token_id: 2553,
    wearable_ids: [426, 362],
  },
  {
    genesis_token_id: 2554,
    wearable_ids: [408, 270],
  },
  {
    genesis_token_id: 2555,
    wearable_ids: [386, 251],
  },
  {
    genesis_token_id: 2556,
    wearable_ids: [319, 424],
  },
  {
    genesis_token_id: 2557,
    wearable_ids: [326, 333],
  },
  {
    genesis_token_id: 2558,
    wearable_ids: [362, 310],
  },
  {
    genesis_token_id: 2559,
    wearable_ids: [432, 326],
  },
  {
    genesis_token_id: 2560,
    wearable_ids: [437, 354],
  },
  {
    genesis_token_id: 2561,
    wearable_ids: [306, 262],
  },
  {
    genesis_token_id: 2562,
    wearable_ids: [255, 413],
  },
  {
    genesis_token_id: 2563,
    wearable_ids: [386, 286],
  },
  {
    genesis_token_id: 2564,
    wearable_ids: [378, 371],
  },
  {
    genesis_token_id: 2565,
    wearable_ids: [413, 349],
  },
  {
    genesis_token_id: 2566,
    wearable_ids: [428, 303],
  },
  {
    genesis_token_id: 2567,
    wearable_ids: [343, 325],
  },
  {
    genesis_token_id: 2568,
    wearable_ids: [433, 269],
  },
  {
    genesis_token_id: 2569,
    wearable_ids: [317, 375],
  },
  {
    genesis_token_id: 2570,
    wearable_ids: [300, 263],
  },
  {
    genesis_token_id: 2571,
    wearable_ids: [443, 354],
  },
  {
    genesis_token_id: 2572,
    wearable_ids: [364, 290],
  },
  {
    genesis_token_id: 2573,
    wearable_ids: [316, 299],
  },
  {
    genesis_token_id: 2574,
    wearable_ids: [346, 302],
  },
  {
    genesis_token_id: 2575,
    wearable_ids: [289, 271],
  },
  {
    genesis_token_id: 2576,
    wearable_ids: [387, 434],
  },
  {
    genesis_token_id: 2577,
    wearable_ids: [286, 295],
  },
  {
    genesis_token_id: 2578,
    wearable_ids: [287, 270],
  },
  {
    genesis_token_id: 2579,
    wearable_ids: [266, 294],
  },
  {
    genesis_token_id: 2580,
    wearable_ids: [432, 293],
  },
  {
    genesis_token_id: 2581,
    wearable_ids: [369, 393],
  },
  {
    genesis_token_id: 2582,
    wearable_ids: [420, 370],
  },
  {
    genesis_token_id: 2583,
    wearable_ids: [395, 296],
  },
  {
    genesis_token_id: 2584,
    wearable_ids: [291, 425],
  },
  {
    genesis_token_id: 2585,
    wearable_ids: [265, 375],
  },
  {
    genesis_token_id: 2586,
    wearable_ids: [349, 304],
  },
  {
    genesis_token_id: 2587,
    wearable_ids: [280, 290],
  },
  {
    genesis_token_id: 2588,
    wearable_ids: [304, 352],
  },
  {
    genesis_token_id: 2589,
    wearable_ids: [300, 370],
  },
  {
    genesis_token_id: 2590,
    wearable_ids: [337, 338],
  },
  {
    genesis_token_id: 2591,
    wearable_ids: [251, 305],
  },
  {
    genesis_token_id: 2592,
    wearable_ids: [290, 364],
  },
  {
    genesis_token_id: 2593,
    wearable_ids: [399, 276],
  },
  {
    genesis_token_id: 2594,
    wearable_ids: [442, 326],
  },
  {
    genesis_token_id: 2595,
    wearable_ids: [346, 262],
  },
  {
    genesis_token_id: 2596,
    wearable_ids: [326, 311],
  },
  {
    genesis_token_id: 2597,
    wearable_ids: [306, 301],
  },
  {
    genesis_token_id: 2598,
    wearable_ids: [342, 437],
  },
  {
    genesis_token_id: 2599,
    wearable_ids: [306, 411],
  },
  {
    genesis_token_id: 2600,
    wearable_ids: [265, 386],
  },
  {
    genesis_token_id: 2601,
    wearable_ids: [410, 254],
  },
  {
    genesis_token_id: 2602,
    wearable_ids: [384, 415],
  },
  {
    genesis_token_id: 2603,
    wearable_ids: [287, 388],
  },
  {
    genesis_token_id: 2604,
    wearable_ids: [445, 382],
  },
  {
    genesis_token_id: 2605,
    wearable_ids: [432, 378],
  },
  {
    genesis_token_id: 2606,
    wearable_ids: [400, 362],
  },
  {
    genesis_token_id: 2607,
    wearable_ids: [369, 374],
  },
  {
    genesis_token_id: 2608,
    wearable_ids: [308, 403],
  },
  {
    genesis_token_id: 2609,
    wearable_ids: [310, 351],
  },
  {
    genesis_token_id: 2610,
    wearable_ids: [339, 315],
  },
  {
    genesis_token_id: 2611,
    wearable_ids: [378, 426],
  },
  {
    genesis_token_id: 2612,
    wearable_ids: [259, 344],
  },
  {
    genesis_token_id: 2613,
    wearable_ids: [289, 350],
  },
  {
    genesis_token_id: 2614,
    wearable_ids: [351, 426],
  },
  {
    genesis_token_id: 2615,
    wearable_ids: [263, 425],
  },
  {
    genesis_token_id: 2616,
    wearable_ids: [314, 268],
  },
  {
    genesis_token_id: 2617,
    wearable_ids: [362, 326],
  },
  {
    genesis_token_id: 2618,
    wearable_ids: [354, 366],
  },
  {
    genesis_token_id: 2619,
    wearable_ids: [424, 333],
  },
  {
    genesis_token_id: 2620,
    wearable_ids: [301, 254],
  },
  {
    genesis_token_id: 2621,
    wearable_ids: [331, 362],
  },
  {
    genesis_token_id: 2622,
    wearable_ids: [291, 363],
  },
  {
    genesis_token_id: 2623,
    wearable_ids: [315, 424],
  },
  {
    genesis_token_id: 2624,
    wearable_ids: [331, 257],
  },
  {
    genesis_token_id: 2625,
    wearable_ids: [284, 294],
  },
  {
    genesis_token_id: 2626,
    wearable_ids: [383, 396],
  },
  {
    genesis_token_id: 2627,
    wearable_ids: [265, 431],
  },
  {
    genesis_token_id: 2628,
    wearable_ids: [258, 298],
  },
  {
    genesis_token_id: 2629,
    wearable_ids: [262, 258],
  },
  {
    genesis_token_id: 2630,
    wearable_ids: [340, 291],
  },
  {
    genesis_token_id: 2631,
    wearable_ids: [265, 275],
  },
  {
    genesis_token_id: 2632,
    wearable_ids: [344, 373],
  },
  {
    genesis_token_id: 2633,
    wearable_ids: [256, 386],
  },
  {
    genesis_token_id: 2634,
    wearable_ids: [431, 442],
  },
  {
    genesis_token_id: 2635,
    wearable_ids: [274, 257],
  },
  {
    genesis_token_id: 2636,
    wearable_ids: [408, 445],
  },
  {
    genesis_token_id: 2637,
    wearable_ids: [280, 417],
  },
  {
    genesis_token_id: 2638,
    wearable_ids: [325, 395],
  },
  {
    genesis_token_id: 2639,
    wearable_ids: [404, 259],
  },
  {
    genesis_token_id: 2640,
    wearable_ids: [409, 292],
  },
  {
    genesis_token_id: 2641,
    wearable_ids: [274, 311],
  },
  {
    genesis_token_id: 2642,
    wearable_ids: [365, 343],
  },
  {
    genesis_token_id: 2643,
    wearable_ids: [420, 265],
  },
  {
    genesis_token_id: 2644,
    wearable_ids: [365, 253],
  },
  {
    genesis_token_id: 2645,
    wearable_ids: [425, 348],
  },
  {
    genesis_token_id: 2646,
    wearable_ids: [364, 303],
  },
  {
    genesis_token_id: 2647,
    wearable_ids: [268, 328],
  },
  {
    genesis_token_id: 2648,
    wearable_ids: [280, 348],
  },
  {
    genesis_token_id: 2649,
    wearable_ids: [406, 377],
  },
  {
    genesis_token_id: 2650,
    wearable_ids: [385, 368],
  },
  {
    genesis_token_id: 2651,
    wearable_ids: [374, 290],
  },
  {
    genesis_token_id: 2652,
    wearable_ids: [273, 319],
  },
  {
    genesis_token_id: 2653,
    wearable_ids: [315, 250],
  },
  {
    genesis_token_id: 2654,
    wearable_ids: [300, 344],
  },
  {
    genesis_token_id: 2655,
    wearable_ids: [280, 376],
  },
  {
    genesis_token_id: 2656,
    wearable_ids: [364, 336],
  },
  {
    genesis_token_id: 2657,
    wearable_ids: [255, 284],
  },
  {
    genesis_token_id: 2658,
    wearable_ids: [365, 306],
  },
  {
    genesis_token_id: 2659,
    wearable_ids: [337, 372],
  },
  {
    genesis_token_id: 2660,
    wearable_ids: [400, 287],
  },
  {
    genesis_token_id: 2661,
    wearable_ids: [403, 319],
  },
  {
    genesis_token_id: 2662,
    wearable_ids: [355, 384],
  },
  {
    genesis_token_id: 2663,
    wearable_ids: [378, 266],
  },
  {
    genesis_token_id: 2664,
    wearable_ids: [384, 288],
  },
  {
    genesis_token_id: 2665,
    wearable_ids: [371, 334],
  },
  {
    genesis_token_id: 2666,
    wearable_ids: [317, 262],
  },
  {
    genesis_token_id: 2667,
    wearable_ids: [265, 259],
  },
  {
    genesis_token_id: 2668,
    wearable_ids: [350, 338],
  },
  {
    genesis_token_id: 2669,
    wearable_ids: [415, 368],
  },
  {
    genesis_token_id: 2670,
    wearable_ids: [248, 340],
  },
  {
    genesis_token_id: 2671,
    wearable_ids: [335, 357],
  },
  {
    genesis_token_id: 2672,
    wearable_ids: [352, 259],
  },
  {
    genesis_token_id: 2673,
    wearable_ids: [396, 271],
  },
  {
    genesis_token_id: 2674,
    wearable_ids: [280, 387],
  },
  {
    genesis_token_id: 2675,
    wearable_ids: [432, 268],
  },
  {
    genesis_token_id: 2676,
    wearable_ids: [257, 413],
  },
  {
    genesis_token_id: 2677,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 2678,
    wearable_ids: [396, 347],
  },
  {
    genesis_token_id: 2679,
    wearable_ids: [346, 418],
  },
  {
    genesis_token_id: 2680,
    wearable_ids: [340, 265],
  },
  {
    genesis_token_id: 2681,
    wearable_ids: [363, 358],
  },
  {
    genesis_token_id: 2682,
    wearable_ids: [303, 392],
  },
  {
    genesis_token_id: 2683,
    wearable_ids: [384, 336],
  },
  {
    genesis_token_id: 2684,
    wearable_ids: [292, 375],
  },
  {
    genesis_token_id: 2685,
    wearable_ids: [294, 445],
  },
  {
    genesis_token_id: 2686,
    wearable_ids: [292, 358],
  },
  {
    genesis_token_id: 2687,
    wearable_ids: [247, 259],
  },
  {
    genesis_token_id: 2688,
    wearable_ids: [349, 424],
  },
  {
    genesis_token_id: 2689,
    wearable_ids: [387, 334],
  },
  {
    genesis_token_id: 2690,
    wearable_ids: [331, 414],
  },
  {
    genesis_token_id: 2691,
    wearable_ids: [316, 375],
  },
  {
    genesis_token_id: 2692,
    wearable_ids: [278, 436],
  },
  {
    genesis_token_id: 2693,
    wearable_ids: [412, 258],
  },
  {
    genesis_token_id: 2694,
    wearable_ids: [311, 413],
  },
  {
    genesis_token_id: 2695,
    wearable_ids: [272, 444],
  },
  {
    genesis_token_id: 2696,
    wearable_ids: [273, 269],
  },
  {
    genesis_token_id: 2697,
    wearable_ids: [347, 336],
  },
  {
    genesis_token_id: 2698,
    wearable_ids: [278, 306],
  },
  {
    genesis_token_id: 2699,
    wearable_ids: [304, 300],
  },
  {
    genesis_token_id: 2700,
    wearable_ids: [301, 338],
  },
  {
    genesis_token_id: 2701,
    wearable_ids: [344, 340],
  },
  {
    genesis_token_id: 2702,
    wearable_ids: [382, 254],
  },
  {
    genesis_token_id: 2703,
    wearable_ids: [406, 344],
  },
  {
    genesis_token_id: 2704,
    wearable_ids: [301, 339],
  },
  {
    genesis_token_id: 2705,
    wearable_ids: [340, 376],
  },
  {
    genesis_token_id: 2706,
    wearable_ids: [301, 261],
  },
  {
    genesis_token_id: 2707,
    wearable_ids: [410, 247],
  },
  {
    genesis_token_id: 2708,
    wearable_ids: [369, 366],
  },
  {
    genesis_token_id: 2709,
    wearable_ids: [437, 288],
  },
  {
    genesis_token_id: 2710,
    wearable_ids: [268, 284],
  },
  {
    genesis_token_id: 2711,
    wearable_ids: [386, 332],
  },
  {
    genesis_token_id: 2712,
    wearable_ids: [341, 261],
  },
  {
    genesis_token_id: 2713,
    wearable_ids: [326, 359],
  },
  {
    genesis_token_id: 2714,
    wearable_ids: [262, 263],
  },
  {
    genesis_token_id: 2715,
    wearable_ids: [431, 302],
  },
  {
    genesis_token_id: 2716,
    wearable_ids: [299, 270],
  },
  {
    genesis_token_id: 2717,
    wearable_ids: [342, 362],
  },
  {
    genesis_token_id: 2718,
    wearable_ids: [407, 396],
  },
  {
    genesis_token_id: 2719,
    wearable_ids: [254, 428],
  },
  {
    genesis_token_id: 2720,
    wearable_ids: [365, 345],
  },
  {
    genesis_token_id: 2721,
    wearable_ids: [247, 326],
  },
  {
    genesis_token_id: 2722,
    wearable_ids: [399, 338],
  },
  {
    genesis_token_id: 2723,
    wearable_ids: [324, 438],
  },
  {
    genesis_token_id: 2724,
    wearable_ids: [278, 444],
  },
  {
    genesis_token_id: 2725,
    wearable_ids: [278, 434],
  },
  {
    genesis_token_id: 2726,
    wearable_ids: [280, 253],
  },
  {
    genesis_token_id: 2727,
    wearable_ids: [428, 293],
  },
  {
    genesis_token_id: 2728,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 2729,
    wearable_ids: [341, 249],
  },
  {
    genesis_token_id: 2730,
    wearable_ids: [368, 412],
  },
  {
    genesis_token_id: 2731,
    wearable_ids: [300, 433],
  },
  {
    genesis_token_id: 2732,
    wearable_ids: [387, 294],
  },
  {
    genesis_token_id: 2733,
    wearable_ids: [291, 339],
  },
  {
    genesis_token_id: 2734,
    wearable_ids: [385, 314],
  },
  {
    genesis_token_id: 2735,
    wearable_ids: [384, 340],
  },
  {
    genesis_token_id: 2736,
    wearable_ids: [253, 437],
  },
  {
    genesis_token_id: 2737,
    wearable_ids: [317, 445],
  },
  {
    genesis_token_id: 2738,
    wearable_ids: [415, 339],
  },
  {
    genesis_token_id: 2739,
    wearable_ids: [444, 360],
  },
  {
    genesis_token_id: 2740,
    wearable_ids: [433, 365],
  },
  {
    genesis_token_id: 2741,
    wearable_ids: [368, 291],
  },
  {
    genesis_token_id: 2742,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 2743,
    wearable_ids: [277, 440],
  },
  {
    genesis_token_id: 2744,
    wearable_ids: [384, 300],
  },
  {
    genesis_token_id: 2745,
    wearable_ids: [372, 435],
  },
  {
    genesis_token_id: 2746,
    wearable_ids: [434, 278],
  },
  {
    genesis_token_id: 2747,
    wearable_ids: [370, 299],
  },
  {
    genesis_token_id: 2748,
    wearable_ids: [347, 358],
  },
  {
    genesis_token_id: 2749,
    wearable_ids: [387, 384],
  },
  {
    genesis_token_id: 2750,
    wearable_ids: [317, 349],
  },
  {
    genesis_token_id: 2751,
    wearable_ids: [423, 405],
  },
  {
    genesis_token_id: 2752,
    wearable_ids: [326, 319],
  },
  {
    genesis_token_id: 2753,
    wearable_ids: [343, 324],
  },
  {
    genesis_token_id: 2754,
    wearable_ids: [422, 337],
  },
  {
    genesis_token_id: 2755,
    wearable_ids: [365, 292],
  },
  {
    genesis_token_id: 2756,
    wearable_ids: [378, 442],
  },
  {
    genesis_token_id: 2757,
    wearable_ids: [350, 420],
  },
  {
    genesis_token_id: 2758,
    wearable_ids: [386, 310],
  },
  {
    genesis_token_id: 2759,
    wearable_ids: [340, 352],
  },
  {
    genesis_token_id: 2760,
    wearable_ids: [335, 266],
  },
  {
    genesis_token_id: 2761,
    wearable_ids: [344, 416],
  },
  {
    genesis_token_id: 2762,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 2763,
    wearable_ids: [316, 417],
  },
  {
    genesis_token_id: 2764,
    wearable_ids: [315, 440],
  },
  {
    genesis_token_id: 2765,
    wearable_ids: [397, 287],
  },
  {
    genesis_token_id: 2766,
    wearable_ids: [337, 378],
  },
  {
    genesis_token_id: 2767,
    wearable_ids: [403, 263],
  },
  {
    genesis_token_id: 2768,
    wearable_ids: [364, 408],
  },
  {
    genesis_token_id: 2769,
    wearable_ids: [445, 425],
  },
  {
    genesis_token_id: 2770,
    wearable_ids: [370, 394],
  },
  {
    genesis_token_id: 2771,
    wearable_ids: [431, 428],
  },
  {
    genesis_token_id: 2772,
    wearable_ids: [316, 327],
  },
  {
    genesis_token_id: 2773,
    wearable_ids: [324, 438],
  },
  {
    genesis_token_id: 2774,
    wearable_ids: [433, 377],
  },
  {
    genesis_token_id: 2775,
    wearable_ids: [262, 441],
  },
  {
    genesis_token_id: 2776,
    wearable_ids: [403, 423],
  },
  {
    genesis_token_id: 2777,
    wearable_ids: [294, 272],
  },
  {
    genesis_token_id: 2778,
    wearable_ids: [284, 428],
  },
  {
    genesis_token_id: 2779,
    wearable_ids: [310, 412],
  },
  {
    genesis_token_id: 2780,
    wearable_ids: [326, 279],
  },
  {
    genesis_token_id: 2781,
    wearable_ids: [385, 418],
  },
  {
    genesis_token_id: 2782,
    wearable_ids: [437, 371],
  },
  {
    genesis_token_id: 2783,
    wearable_ids: [286, 352],
  },
  {
    genesis_token_id: 2784,
    wearable_ids: [248, 445],
  },
  {
    genesis_token_id: 2785,
    wearable_ids: [297, 441],
  },
  {
    genesis_token_id: 2786,
    wearable_ids: [294, 387],
  },
  {
    genesis_token_id: 2787,
    wearable_ids: [319, 284],
  },
  {
    genesis_token_id: 2788,
    wearable_ids: [383, 354],
  },
  {
    genesis_token_id: 2789,
    wearable_ids: [277, 378],
  },
  {
    genesis_token_id: 2790,
    wearable_ids: [413, 420],
  },
  {
    genesis_token_id: 2791,
    wearable_ids: [270, 294],
  },
  {
    genesis_token_id: 2792,
    wearable_ids: [247, 423],
  },
  {
    genesis_token_id: 2793,
    wearable_ids: [400, 414],
  },
  {
    genesis_token_id: 2794,
    wearable_ids: [432, 384],
  },
  {
    genesis_token_id: 2795,
    wearable_ids: [434, 256],
  },
  {
    genesis_token_id: 2796,
    wearable_ids: [341, 351],
  },
  {
    genesis_token_id: 2797,
    wearable_ids: [251, 324],
  },
  {
    genesis_token_id: 2798,
    wearable_ids: [433, 314],
  },
  {
    genesis_token_id: 2799,
    wearable_ids: [442, 415],
  },
  {
    genesis_token_id: 2800,
    wearable_ids: [304, 374],
  },
  {
    genesis_token_id: 2801,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 2802,
    wearable_ids: [376, 431],
  },
  {
    genesis_token_id: 2803,
    wearable_ids: [304, 337],
  },
  {
    genesis_token_id: 2804,
    wearable_ids: [299, 348],
  },
  {
    genesis_token_id: 2805,
    wearable_ids: [276, 342],
  },
  {
    genesis_token_id: 2806,
    wearable_ids: [443, 411],
  },
  {
    genesis_token_id: 2807,
    wearable_ids: [342, 425],
  },
  {
    genesis_token_id: 2808,
    wearable_ids: [248, 317],
  },
  {
    genesis_token_id: 2809,
    wearable_ids: [289, 436],
  },
  {
    genesis_token_id: 2810,
    wearable_ids: [403, 374],
  },
  {
    genesis_token_id: 2811,
    wearable_ids: [342, 306],
  },
  {
    genesis_token_id: 2812,
    wearable_ids: [442, 258],
  },
  {
    genesis_token_id: 2813,
    wearable_ids: [424, 277],
  },
  {
    genesis_token_id: 2814,
    wearable_ids: [258, 355],
  },
  {
    genesis_token_id: 2815,
    wearable_ids: [404, 387],
  },
  {
    genesis_token_id: 2816,
    wearable_ids: [374, 430],
  },
  {
    genesis_token_id: 2817,
    wearable_ids: [434, 324],
  },
  {
    genesis_token_id: 2818,
    wearable_ids: [362, 303],
  },
  {
    genesis_token_id: 2819,
    wearable_ids: [263, 259],
  },
  {
    genesis_token_id: 2820,
    wearable_ids: [296, 355],
  },
  {
    genesis_token_id: 2821,
    wearable_ids: [291, 419],
  },
  {
    genesis_token_id: 2822,
    wearable_ids: [336, 323],
  },
  {
    genesis_token_id: 2823,
    wearable_ids: [363, 354],
  },
  {
    genesis_token_id: 2824,
    wearable_ids: [265, 283],
  },
  {
    genesis_token_id: 2825,
    wearable_ids: [306, 276],
  },
  {
    genesis_token_id: 2826,
    wearable_ids: [424, 301],
  },
  {
    genesis_token_id: 2827,
    wearable_ids: [371, 424],
  },
  {
    genesis_token_id: 2828,
    wearable_ids: [437, 378],
  },
  {
    genesis_token_id: 2829,
    wearable_ids: [304, 337],
  },
  {
    genesis_token_id: 2830,
    wearable_ids: [400, 273],
  },
  {
    genesis_token_id: 2831,
    wearable_ids: [273, 434],
  },
  {
    genesis_token_id: 2832,
    wearable_ids: [364, 429],
  },
  {
    genesis_token_id: 2833,
    wearable_ids: [336, 258],
  },
  {
    genesis_token_id: 2834,
    wearable_ids: [273, 411],
  },
  {
    genesis_token_id: 2835,
    wearable_ids: [264, 437],
  },
  {
    genesis_token_id: 2836,
    wearable_ids: [437, 285],
  },
  {
    genesis_token_id: 2837,
    wearable_ids: [404, 405],
  },
  {
    genesis_token_id: 2838,
    wearable_ids: [375, 432],
  },
  {
    genesis_token_id: 2839,
    wearable_ids: [409, 310],
  },
  {
    genesis_token_id: 2840,
    wearable_ids: [326, 248],
  },
  {
    genesis_token_id: 2841,
    wearable_ids: [255, 314],
  },
  {
    genesis_token_id: 2842,
    wearable_ids: [397, 254],
  },
  {
    genesis_token_id: 2843,
    wearable_ids: [253, 303],
  },
  {
    genesis_token_id: 2844,
    wearable_ids: [377, 413],
  },
  {
    genesis_token_id: 2845,
    wearable_ids: [389, 443],
  },
  {
    genesis_token_id: 2846,
    wearable_ids: [259, 402],
  },
  {
    genesis_token_id: 2847,
    wearable_ids: [408, 249],
  },
  {
    genesis_token_id: 2848,
    wearable_ids: [410, 354],
  },
  {
    genesis_token_id: 2849,
    wearable_ids: [412, 385],
  },
  {
    genesis_token_id: 2850,
    wearable_ids: [404, 360],
  },
  {
    genesis_token_id: 2851,
    wearable_ids: [376, 258],
  },
  {
    genesis_token_id: 2852,
    wearable_ids: [444, 434],
  },
  {
    genesis_token_id: 2853,
    wearable_ids: [386, 409],
  },
  {
    genesis_token_id: 2854,
    wearable_ids: [403, 326],
  },
  {
    genesis_token_id: 2855,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 2856,
    wearable_ids: [420, 294],
  },
  {
    genesis_token_id: 2857,
    wearable_ids: [263, 296],
  },
  {
    genesis_token_id: 2858,
    wearable_ids: [342, 274],
  },
  {
    genesis_token_id: 2859,
    wearable_ids: [350, 420],
  },
  {
    genesis_token_id: 2860,
    wearable_ids: [255, 349],
  },
  {
    genesis_token_id: 2861,
    wearable_ids: [406, 393],
  },
  {
    genesis_token_id: 2862,
    wearable_ids: [350, 251],
  },
  {
    genesis_token_id: 2863,
    wearable_ids: [386, 445],
  },
  {
    genesis_token_id: 2864,
    wearable_ids: [270, 387],
  },
  {
    genesis_token_id: 2865,
    wearable_ids: [263, 377],
  },
  {
    genesis_token_id: 2866,
    wearable_ids: [311, 415],
  },
  {
    genesis_token_id: 2867,
    wearable_ids: [409, 369],
  },
  {
    genesis_token_id: 2868,
    wearable_ids: [368, 410],
  },
  {
    genesis_token_id: 2869,
    wearable_ids: [256, 271],
  },
  {
    genesis_token_id: 2870,
    wearable_ids: [397, 408],
  },
  {
    genesis_token_id: 2871,
    wearable_ids: [426, 333],
  },
  {
    genesis_token_id: 2872,
    wearable_ids: [248, 331],
  },
  {
    genesis_token_id: 2873,
    wearable_ids: [362, 308],
  },
  {
    genesis_token_id: 2874,
    wearable_ids: [376, 423],
  },
  {
    genesis_token_id: 2875,
    wearable_ids: [425, 366],
  },
  {
    genesis_token_id: 2876,
    wearable_ids: [311, 373],
  },
  {
    genesis_token_id: 2877,
    wearable_ids: [265, 368],
  },
  {
    genesis_token_id: 2878,
    wearable_ids: [385, 403],
  },
  {
    genesis_token_id: 2879,
    wearable_ids: [294, 413],
  },
  {
    genesis_token_id: 2880,
    wearable_ids: [290, 284],
  },
  {
    genesis_token_id: 2881,
    wearable_ids: [362, 416],
  },
  {
    genesis_token_id: 2882,
    wearable_ids: [332, 404],
  },
  {
    genesis_token_id: 2883,
    wearable_ids: [346, 278],
  },
  {
    genesis_token_id: 2884,
    wearable_ids: [341, 327],
  },
  {
    genesis_token_id: 2885,
    wearable_ids: [382, 365],
  },
  {
    genesis_token_id: 2886,
    wearable_ids: [442, 348],
  },
  {
    genesis_token_id: 2887,
    wearable_ids: [291, 337],
  },
  {
    genesis_token_id: 2888,
    wearable_ids: [363, 257],
  },
  {
    genesis_token_id: 2889,
    wearable_ids: [436, 305],
  },
  {
    genesis_token_id: 2890,
    wearable_ids: [254, 279],
  },
  {
    genesis_token_id: 2891,
    wearable_ids: [443, 403],
  },
  {
    genesis_token_id: 2892,
    wearable_ids: [255, 251],
  },
  {
    genesis_token_id: 2893,
    wearable_ids: [314, 320],
  },
  {
    genesis_token_id: 2894,
    wearable_ids: [331, 387],
  },
  {
    genesis_token_id: 2895,
    wearable_ids: [410, 442],
  },
  {
    genesis_token_id: 2896,
    wearable_ids: [420, 370],
  },
  {
    genesis_token_id: 2897,
    wearable_ids: [363, 386],
  },
  {
    genesis_token_id: 2898,
    wearable_ids: [355, 407],
  },
  {
    genesis_token_id: 2899,
    wearable_ids: [382, 378],
  },
  {
    genesis_token_id: 2900,
    wearable_ids: [296, 310],
  },
  {
    genesis_token_id: 2901,
    wearable_ids: [342, 260],
  },
  {
    genesis_token_id: 2902,
    wearable_ids: [278, 364],
  },
  {
    genesis_token_id: 2903,
    wearable_ids: [258, 437],
  },
  {
    genesis_token_id: 2904,
    wearable_ids: [348, 310],
  },
  {
    genesis_token_id: 2905,
    wearable_ids: [434, 348],
  },
  {
    genesis_token_id: 2906,
    wearable_ids: [255, 254],
  },
  {
    genesis_token_id: 2907,
    wearable_ids: [343, 344],
  },
  {
    genesis_token_id: 2908,
    wearable_ids: [352, 364],
  },
  {
    genesis_token_id: 2909,
    wearable_ids: [372, 311],
  },
  {
    genesis_token_id: 2910,
    wearable_ids: [445, 369],
  },
  {
    genesis_token_id: 2911,
    wearable_ids: [289, 408],
  },
  {
    genesis_token_id: 2912,
    wearable_ids: [254, 308],
  },
  {
    genesis_token_id: 2913,
    wearable_ids: [404, 277],
  },
  {
    genesis_token_id: 2914,
    wearable_ids: [432, 384],
  },
  {
    genesis_token_id: 2915,
    wearable_ids: [407, 355],
  },
  {
    genesis_token_id: 2916,
    wearable_ids: [437, 350],
  },
  {
    genesis_token_id: 2917,
    wearable_ids: [389, 444],
  },
  {
    genesis_token_id: 2918,
    wearable_ids: [385, 268],
  },
  {
    genesis_token_id: 2919,
    wearable_ids: [310, 354],
  },
  {
    genesis_token_id: 2920,
    wearable_ids: [445, 281],
  },
  {
    genesis_token_id: 2921,
    wearable_ids: [363, 348],
  },
  {
    genesis_token_id: 2922,
    wearable_ids: [350, 370],
  },
  {
    genesis_token_id: 2923,
    wearable_ids: [406, 278],
  },
  {
    genesis_token_id: 2924,
    wearable_ids: [428, 382],
  },
  {
    genesis_token_id: 2925,
    wearable_ids: [310, 331],
  },
  {
    genesis_token_id: 2926,
    wearable_ids: [365, 352],
  },
  {
    genesis_token_id: 2927,
    wearable_ids: [352, 428],
  },
  {
    genesis_token_id: 2928,
    wearable_ids: [251, 391],
  },
  {
    genesis_token_id: 2929,
    wearable_ids: [351, 425],
  },
  {
    genesis_token_id: 2930,
    wearable_ids: [263, 286],
  },
  {
    genesis_token_id: 2931,
    wearable_ids: [348, 374],
  },
  {
    genesis_token_id: 2932,
    wearable_ids: [347, 371],
  },
  {
    genesis_token_id: 2933,
    wearable_ids: [331, 336],
  },
  {
    genesis_token_id: 2934,
    wearable_ids: [375, 249],
  },
  {
    genesis_token_id: 2935,
    wearable_ids: [294, 388],
  },
  {
    genesis_token_id: 2936,
    wearable_ids: [426, 424],
  },
  {
    genesis_token_id: 2937,
    wearable_ids: [274, 397],
  },
  {
    genesis_token_id: 2938,
    wearable_ids: [347, 274],
  },
  {
    genesis_token_id: 2939,
    wearable_ids: [368, 265],
  },
  {
    genesis_token_id: 2940,
    wearable_ids: [404, 411],
  },
  {
    genesis_token_id: 2941,
    wearable_ids: [429, 365],
  },
  {
    genesis_token_id: 2942,
    wearable_ids: [425, 436],
  },
  {
    genesis_token_id: 2943,
    wearable_ids: [259, 418],
  },
  {
    genesis_token_id: 2944,
    wearable_ids: [280, 286],
  },
  {
    genesis_token_id: 2945,
    wearable_ids: [337, 293],
  },
  {
    genesis_token_id: 2946,
    wearable_ids: [342, 290],
  },
  {
    genesis_token_id: 2947,
    wearable_ids: [368, 426],
  },
  {
    genesis_token_id: 2948,
    wearable_ids: [319, 431],
  },
  {
    genesis_token_id: 2949,
    wearable_ids: [400, 341],
  },
  {
    genesis_token_id: 2950,
    wearable_ids: [428, 296],
  },
  {
    genesis_token_id: 2951,
    wearable_ids: [324, 432],
  },
  {
    genesis_token_id: 2952,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 2953,
    wearable_ids: [399, 363],
  },
  {
    genesis_token_id: 2954,
    wearable_ids: [294, 356],
  },
  {
    genesis_token_id: 2955,
    wearable_ids: [325, 403],
  },
  {
    genesis_token_id: 2956,
    wearable_ids: [399, 265],
  },
  {
    genesis_token_id: 2957,
    wearable_ids: [382, 299],
  },
  {
    genesis_token_id: 2958,
    wearable_ids: [389, 401],
  },
  {
    genesis_token_id: 2959,
    wearable_ids: [433, 276],
  },
  {
    genesis_token_id: 2960,
    wearable_ids: [337, 300],
  },
  {
    genesis_token_id: 2961,
    wearable_ids: [257, 340],
  },
  {
    genesis_token_id: 2962,
    wearable_ids: [443, 435],
  },
  {
    genesis_token_id: 2963,
    wearable_ids: [399, 285],
  },
  {
    genesis_token_id: 2964,
    wearable_ids: [280, 375],
  },
  {
    genesis_token_id: 2965,
    wearable_ids: [389, 295],
  },
  {
    genesis_token_id: 2966,
    wearable_ids: [429, 322],
  },
  {
    genesis_token_id: 2967,
    wearable_ids: [270, 411],
  },
  {
    genesis_token_id: 2968,
    wearable_ids: [294, 257],
  },
  {
    genesis_token_id: 2969,
    wearable_ids: [344, 251],
  },
  {
    genesis_token_id: 2970,
    wearable_ids: [412, 330],
  },
  {
    genesis_token_id: 2971,
    wearable_ids: [375, 418],
  },
  {
    genesis_token_id: 2972,
    wearable_ids: [315, 346],
  },
  {
    genesis_token_id: 2973,
    wearable_ids: [341, 386],
  },
  {
    genesis_token_id: 2974,
    wearable_ids: [348, 286],
  },
  {
    genesis_token_id: 2975,
    wearable_ids: [424, 401],
  },
  {
    genesis_token_id: 2976,
    wearable_ids: [426, 349],
  },
  {
    genesis_token_id: 2977,
    wearable_ids: [259, 363],
  },
  {
    genesis_token_id: 2978,
    wearable_ids: [415, 294],
  },
  {
    genesis_token_id: 2979,
    wearable_ids: [424, 318],
  },
  {
    genesis_token_id: 2980,
    wearable_ids: [376, 270],
  },
  {
    genesis_token_id: 2981,
    wearable_ids: [291, 409],
  },
  {
    genesis_token_id: 2982,
    wearable_ids: [256, 437],
  },
  {
    genesis_token_id: 2983,
    wearable_ids: [350, 359],
  },
  {
    genesis_token_id: 2984,
    wearable_ids: [403, 257],
  },
  {
    genesis_token_id: 2985,
    wearable_ids: [274, 305],
  },
  {
    genesis_token_id: 2986,
    wearable_ids: [308, 248],
  },
  {
    genesis_token_id: 2987,
    wearable_ids: [286, 356],
  },
  {
    genesis_token_id: 2988,
    wearable_ids: [437, 361],
  },
  {
    genesis_token_id: 2989,
    wearable_ids: [265, 403],
  },
  {
    genesis_token_id: 2990,
    wearable_ids: [254, 340],
  },
  {
    genesis_token_id: 2991,
    wearable_ids: [284, 311],
  },
  {
    genesis_token_id: 2992,
    wearable_ids: [372, 424],
  },
  {
    genesis_token_id: 2993,
    wearable_ids: [403, 384],
  },
  {
    genesis_token_id: 2994,
    wearable_ids: [382, 403],
  },
  {
    genesis_token_id: 2995,
    wearable_ids: [258, 270],
  },
  {
    genesis_token_id: 2996,
    wearable_ids: [315, 444],
  },
  {
    genesis_token_id: 2997,
    wearable_ids: [256, 432],
  },
  {
    genesis_token_id: 2998,
    wearable_ids: [436, 375],
  },
  {
    genesis_token_id: 2999,
    wearable_ids: [326, 247],
  },
  {
    genesis_token_id: 3000,
    wearable_ids: [326, 280],
  },
  {
    genesis_token_id: 3001,
    wearable_ids: [424, 313],
  },
  {
    genesis_token_id: 3002,
    wearable_ids: [289, 361],
  },
  {
    genesis_token_id: 3003,
    wearable_ids: [383, 263],
  },
  {
    genesis_token_id: 3004,
    wearable_ids: [290, 324],
  },
  {
    genesis_token_id: 3005,
    wearable_ids: [442, 298],
  },
  {
    genesis_token_id: 3006,
    wearable_ids: [410, 255],
  },
  {
    genesis_token_id: 3007,
    wearable_ids: [340, 372],
  },
  {
    genesis_token_id: 3008,
    wearable_ids: [415, 310],
  },
  {
    genesis_token_id: 3009,
    wearable_ids: [272, 256],
  },
  {
    genesis_token_id: 3010,
    wearable_ids: [422, 325],
  },
  {
    genesis_token_id: 3011,
    wearable_ids: [255, 354],
  },
  {
    genesis_token_id: 3012,
    wearable_ids: [316, 425],
  },
  {
    genesis_token_id: 3013,
    wearable_ids: [368, 403],
  },
  {
    genesis_token_id: 3014,
    wearable_ids: [280, 407],
  },
  {
    genesis_token_id: 3015,
    wearable_ids: [335, 300],
  },
  {
    genesis_token_id: 3016,
    wearable_ids: [377, 412],
  },
  {
    genesis_token_id: 3017,
    wearable_ids: [437, 347],
  },
  {
    genesis_token_id: 3018,
    wearable_ids: [344, 412],
  },
  {
    genesis_token_id: 3019,
    wearable_ids: [326, 347],
  },
  {
    genesis_token_id: 3020,
    wearable_ids: [349, 382],
  },
  {
    genesis_token_id: 3021,
    wearable_ids: [351, 444],
  },
  {
    genesis_token_id: 3022,
    wearable_ids: [350, 272],
  },
  {
    genesis_token_id: 3023,
    wearable_ids: [292, 277],
  },
  {
    genesis_token_id: 3024,
    wearable_ids: [256, 267],
  },
  {
    genesis_token_id: 3025,
    wearable_ids: [368, 255],
  },
  {
    genesis_token_id: 3026,
    wearable_ids: [257, 374],
  },
  {
    genesis_token_id: 3027,
    wearable_ids: [326, 253],
  },
  {
    genesis_token_id: 3028,
    wearable_ids: [352, 384],
  },
  {
    genesis_token_id: 3029,
    wearable_ids: [324, 355],
  },
  {
    genesis_token_id: 3030,
    wearable_ids: [363, 312],
  },
  {
    genesis_token_id: 3031,
    wearable_ids: [368, 413],
  },
  {
    genesis_token_id: 3032,
    wearable_ids: [310, 339],
  },
  {
    genesis_token_id: 3033,
    wearable_ids: [264, 297],
  },
  {
    genesis_token_id: 3034,
    wearable_ids: [256, 400],
  },
  {
    genesis_token_id: 3035,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 3036,
    wearable_ids: [403, 300],
  },
  {
    genesis_token_id: 3037,
    wearable_ids: [343, 429],
  },
  {
    genesis_token_id: 3038,
    wearable_ids: [423, 379],
  },
  {
    genesis_token_id: 3039,
    wearable_ids: [273, 318],
  },
  {
    genesis_token_id: 3040,
    wearable_ids: [368, 413],
  },
  {
    genesis_token_id: 3041,
    wearable_ids: [407, 289],
  },
  {
    genesis_token_id: 3042,
    wearable_ids: [280, 397],
  },
  {
    genesis_token_id: 3043,
    wearable_ids: [383, 342],
  },
  {
    genesis_token_id: 3044,
    wearable_ids: [253, 305],
  },
  {
    genesis_token_id: 3045,
    wearable_ids: [373, 251],
  },
  {
    genesis_token_id: 3046,
    wearable_ids: [294, 415],
  },
  {
    genesis_token_id: 3047,
    wearable_ids: [435, 306],
  },
  {
    genesis_token_id: 3048,
    wearable_ids: [314, 397],
  },
  {
    genesis_token_id: 3049,
    wearable_ids: [326, 397],
  },
  {
    genesis_token_id: 3050,
    wearable_ids: [343, 363],
  },
  {
    genesis_token_id: 3051,
    wearable_ids: [300, 414],
  },
  {
    genesis_token_id: 3052,
    wearable_ids: [443, 386],
  },
  {
    genesis_token_id: 3053,
    wearable_ids: [365, 383],
  },
  {
    genesis_token_id: 3054,
    wearable_ids: [306, 377],
  },
  {
    genesis_token_id: 3055,
    wearable_ids: [382, 411],
  },
  {
    genesis_token_id: 3056,
    wearable_ids: [339, 356],
  },
  {
    genesis_token_id: 3057,
    wearable_ids: [306, 355],
  },
  {
    genesis_token_id: 3058,
    wearable_ids: [257, 391],
  },
  {
    genesis_token_id: 3059,
    wearable_ids: [300, 376],
  },
  {
    genesis_token_id: 3060,
    wearable_ids: [331, 255],
  },
  {
    genesis_token_id: 3061,
    wearable_ids: [300, 334],
  },
  {
    genesis_token_id: 3062,
    wearable_ids: [337, 268],
  },
  {
    genesis_token_id: 3063,
    wearable_ids: [255, 358],
  },
  {
    genesis_token_id: 3064,
    wearable_ids: [354, 336],
  },
  {
    genesis_token_id: 3065,
    wearable_ids: [263, 313],
  },
  {
    genesis_token_id: 3066,
    wearable_ids: [348, 278],
  },
  {
    genesis_token_id: 3067,
    wearable_ids: [299, 416],
  },
  {
    genesis_token_id: 3068,
    wearable_ids: [266, 295],
  },
  {
    genesis_token_id: 3069,
    wearable_ids: [374, 316],
  },
  {
    genesis_token_id: 3070,
    wearable_ids: [310, 435],
  },
  {
    genesis_token_id: 3071,
    wearable_ids: [397, 411],
  },
  {
    genesis_token_id: 3072,
    wearable_ids: [311, 316],
  },
  {
    genesis_token_id: 3073,
    wearable_ids: [349, 263],
  },
  {
    genesis_token_id: 3074,
    wearable_ids: [346, 271],
  },
  {
    genesis_token_id: 3075,
    wearable_ids: [326, 395],
  },
  {
    genesis_token_id: 3076,
    wearable_ids: [259, 264],
  },
  {
    genesis_token_id: 3077,
    wearable_ids: [337, 397],
  },
  {
    genesis_token_id: 3078,
    wearable_ids: [280, 402],
  },
  {
    genesis_token_id: 3079,
    wearable_ids: [314, 332],
  },
  {
    genesis_token_id: 3080,
    wearable_ids: [395, 292],
  },
  {
    genesis_token_id: 3081,
    wearable_ids: [387, 294],
  },
  {
    genesis_token_id: 3082,
    wearable_ids: [291, 355],
  },
  {
    genesis_token_id: 3083,
    wearable_ids: [351, 374],
  },
  {
    genesis_token_id: 3084,
    wearable_ids: [365, 400],
  },
  {
    genesis_token_id: 3085,
    wearable_ids: [378, 289],
  },
  {
    genesis_token_id: 3086,
    wearable_ids: [287, 420],
  },
  {
    genesis_token_id: 3087,
    wearable_ids: [385, 395],
  },
  {
    genesis_token_id: 3088,
    wearable_ids: [406, 413],
  },
  {
    genesis_token_id: 3089,
    wearable_ids: [429, 440],
  },
  {
    genesis_token_id: 3090,
    wearable_ids: [248, 403],
  },
  {
    genesis_token_id: 3091,
    wearable_ids: [424, 425],
  },
  {
    genesis_token_id: 3092,
    wearable_ids: [306, 319],
  },
  {
    genesis_token_id: 3093,
    wearable_ids: [287, 393],
  },
  {
    genesis_token_id: 3094,
    wearable_ids: [324, 301],
  },
  {
    genesis_token_id: 3095,
    wearable_ids: [371, 310],
  },
  {
    genesis_token_id: 3096,
    wearable_ids: [431, 327],
  },
  {
    genesis_token_id: 3097,
    wearable_ids: [444, 343],
  },
  {
    genesis_token_id: 3098,
    wearable_ids: [339, 257],
  },
  {
    genesis_token_id: 3099,
    wearable_ids: [280, 299],
  },
  {
    genesis_token_id: 3100,
    wearable_ids: [396, 334],
  },
  {
    genesis_token_id: 3101,
    wearable_ids: [262, 423],
  },
  {
    genesis_token_id: 3102,
    wearable_ids: [262, 325],
  },
  {
    genesis_token_id: 3103,
    wearable_ids: [314, 265],
  },
  {
    genesis_token_id: 3104,
    wearable_ids: [396, 301],
  },
  {
    genesis_token_id: 3105,
    wearable_ids: [338, 319],
  },
  {
    genesis_token_id: 3106,
    wearable_ids: [247, 277],
  },
  {
    genesis_token_id: 3107,
    wearable_ids: [422, 445],
  },
  {
    genesis_token_id: 3108,
    wearable_ids: [431, 297],
  },
  {
    genesis_token_id: 3109,
    wearable_ids: [254, 418],
  },
  {
    genesis_token_id: 3110,
    wearable_ids: [389, 382],
  },
  {
    genesis_token_id: 3111,
    wearable_ids: [378, 399],
  },
  {
    genesis_token_id: 3112,
    wearable_ids: [400, 278],
  },
  {
    genesis_token_id: 3113,
    wearable_ids: [284, 360],
  },
  {
    genesis_token_id: 3114,
    wearable_ids: [378, 377],
  },
  {
    genesis_token_id: 3115,
    wearable_ids: [412, 262],
  },
  {
    genesis_token_id: 3116,
    wearable_ids: [248, 432],
  },
  {
    genesis_token_id: 3117,
    wearable_ids: [277, 370],
  },
  {
    genesis_token_id: 3118,
    wearable_ids: [277, 264],
  },
  {
    genesis_token_id: 3119,
    wearable_ids: [355, 389],
  },
  {
    genesis_token_id: 3120,
    wearable_ids: [251, 340],
  },
  {
    genesis_token_id: 3121,
    wearable_ids: [415, 441],
  },
  {
    genesis_token_id: 3122,
    wearable_ids: [375, 428],
  },
  {
    genesis_token_id: 3123,
    wearable_ids: [384, 411],
  },
  {
    genesis_token_id: 3124,
    wearable_ids: [396, 444],
  },
  {
    genesis_token_id: 3125,
    wearable_ids: [259, 373],
  },
  {
    genesis_token_id: 3126,
    wearable_ids: [349, 389],
  },
  {
    genesis_token_id: 3127,
    wearable_ids: [413, 291],
  },
  {
    genesis_token_id: 3128,
    wearable_ids: [273, 374],
  },
  {
    genesis_token_id: 3129,
    wearable_ids: [306, 266],
  },
  {
    genesis_token_id: 3130,
    wearable_ids: [342, 391],
  },
  {
    genesis_token_id: 3131,
    wearable_ids: [404, 348],
  },
  {
    genesis_token_id: 3132,
    wearable_ids: [268, 422],
  },
  {
    genesis_token_id: 3133,
    wearable_ids: [370, 284],
  },
  {
    genesis_token_id: 3134,
    wearable_ids: [351, 383],
  },
  {
    genesis_token_id: 3135,
    wearable_ids: [375, 419],
  },
  {
    genesis_token_id: 3136,
    wearable_ids: [374, 287],
  },
  {
    genesis_token_id: 3137,
    wearable_ids: [276, 314],
  },
  {
    genesis_token_id: 3138,
    wearable_ids: [253, 324],
  },
  {
    genesis_token_id: 3139,
    wearable_ids: [284, 429],
  },
  {
    genesis_token_id: 3140,
    wearable_ids: [299, 389],
  },
  {
    genesis_token_id: 3141,
    wearable_ids: [257, 301],
  },
  {
    genesis_token_id: 3142,
    wearable_ids: [315, 263],
  },
  {
    genesis_token_id: 3143,
    wearable_ids: [325, 280],
  },
  {
    genesis_token_id: 3144,
    wearable_ids: [403, 339],
  },
  {
    genesis_token_id: 3145,
    wearable_ids: [431, 342],
  },
  {
    genesis_token_id: 3146,
    wearable_ids: [317, 330],
  },
  {
    genesis_token_id: 3147,
    wearable_ids: [311, 273],
  },
  {
    genesis_token_id: 3148,
    wearable_ids: [436, 349],
  },
  {
    genesis_token_id: 3149,
    wearable_ids: [325, 336],
  },
  {
    genesis_token_id: 3150,
    wearable_ids: [370, 436],
  },
  {
    genesis_token_id: 3151,
    wearable_ids: [332, 387],
  },
  {
    genesis_token_id: 3152,
    wearable_ids: [410, 376],
  },
  {
    genesis_token_id: 3153,
    wearable_ids: [375, 265],
  },
  {
    genesis_token_id: 3154,
    wearable_ids: [316, 396],
  },
  {
    genesis_token_id: 3155,
    wearable_ids: [383, 387],
  },
  {
    genesis_token_id: 3156,
    wearable_ids: [406, 311],
  },
  {
    genesis_token_id: 3157,
    wearable_ids: [375, 247],
  },
  {
    genesis_token_id: 3158,
    wearable_ids: [413, 393],
  },
  {
    genesis_token_id: 3159,
    wearable_ids: [387, 246],
  },
  {
    genesis_token_id: 3160,
    wearable_ids: [437, 432],
  },
  {
    genesis_token_id: 3161,
    wearable_ids: [426, 317],
  },
  {
    genesis_token_id: 3162,
    wearable_ids: [303, 316],
  },
  {
    genesis_token_id: 3163,
    wearable_ids: [363, 375],
  },
  {
    genesis_token_id: 3164,
    wearable_ids: [257, 338],
  },
  {
    genesis_token_id: 3165,
    wearable_ids: [363, 287],
  },
  {
    genesis_token_id: 3166,
    wearable_ids: [277, 397],
  },
  {
    genesis_token_id: 3167,
    wearable_ids: [316, 343],
  },
  {
    genesis_token_id: 3168,
    wearable_ids: [301, 261],
  },
  {
    genesis_token_id: 3169,
    wearable_ids: [425, 384],
  },
  {
    genesis_token_id: 3170,
    wearable_ids: [306, 246],
  },
  {
    genesis_token_id: 3171,
    wearable_ids: [370, 386],
  },
  {
    genesis_token_id: 3172,
    wearable_ids: [341, 295],
  },
  {
    genesis_token_id: 3173,
    wearable_ids: [423, 443],
  },
  {
    genesis_token_id: 3174,
    wearable_ids: [341, 371],
  },
  {
    genesis_token_id: 3175,
    wearable_ids: [431, 387],
  },
  {
    genesis_token_id: 3176,
    wearable_ids: [350, 396],
  },
  {
    genesis_token_id: 3177,
    wearable_ids: [372, 343],
  },
  {
    genesis_token_id: 3178,
    wearable_ids: [342, 313],
  },
  {
    genesis_token_id: 3179,
    wearable_ids: [397, 270],
  },
  {
    genesis_token_id: 3180,
    wearable_ids: [341, 262],
  },
  {
    genesis_token_id: 3181,
    wearable_ids: [436, 317],
  },
  {
    genesis_token_id: 3182,
    wearable_ids: [294, 365],
  },
  {
    genesis_token_id: 3183,
    wearable_ids: [316, 385],
  },
  {
    genesis_token_id: 3184,
    wearable_ids: [326, 389],
  },
  {
    genesis_token_id: 3185,
    wearable_ids: [372, 345],
  },
  {
    genesis_token_id: 3186,
    wearable_ids: [251, 314],
  },
  {
    genesis_token_id: 3187,
    wearable_ids: [395, 399],
  },
  {
    genesis_token_id: 3188,
    wearable_ids: [369, 310],
  },
  {
    genesis_token_id: 3189,
    wearable_ids: [316, 265],
  },
  {
    genesis_token_id: 3190,
    wearable_ids: [348, 247],
  },
  {
    genesis_token_id: 3191,
    wearable_ids: [349, 374],
  },
  {
    genesis_token_id: 3192,
    wearable_ids: [378, 413],
  },
  {
    genesis_token_id: 3193,
    wearable_ids: [342, 356],
  },
  {
    genesis_token_id: 3194,
    wearable_ids: [268, 341],
  },
  {
    genesis_token_id: 3195,
    wearable_ids: [422, 396],
  },
  {
    genesis_token_id: 3196,
    wearable_ids: [273, 278],
  },
  {
    genesis_token_id: 3197,
    wearable_ids: [297, 255],
  },
  {
    genesis_token_id: 3198,
    wearable_ids: [365, 418],
  },
  {
    genesis_token_id: 3199,
    wearable_ids: [415, 376],
  },
  {
    genesis_token_id: 3200,
    wearable_ids: [291, 268],
  },
  {
    genesis_token_id: 3201,
    wearable_ids: [347, 384],
  },
  {
    genesis_token_id: 3202,
    wearable_ids: [411, 341],
  },
  {
    genesis_token_id: 3203,
    wearable_ids: [292, 373],
  },
  {
    genesis_token_id: 3204,
    wearable_ids: [301, 371],
  },
  {
    genesis_token_id: 3205,
    wearable_ids: [349, 416],
  },
  {
    genesis_token_id: 3206,
    wearable_ids: [346, 374],
  },
  {
    genesis_token_id: 3207,
    wearable_ids: [382, 288],
  },
  {
    genesis_token_id: 3208,
    wearable_ids: [368, 264],
  },
  {
    genesis_token_id: 3209,
    wearable_ids: [277, 331],
  },
  {
    genesis_token_id: 3210,
    wearable_ids: [303, 434],
  },
  {
    genesis_token_id: 3211,
    wearable_ids: [336, 304],
  },
  {
    genesis_token_id: 3212,
    wearable_ids: [384, 391],
  },
  {
    genesis_token_id: 3213,
    wearable_ids: [339, 332],
  },
  {
    genesis_token_id: 3214,
    wearable_ids: [375, 296],
  },
  {
    genesis_token_id: 3215,
    wearable_ids: [314, 336],
  },
  {
    genesis_token_id: 3216,
    wearable_ids: [385, 433],
  },
  {
    genesis_token_id: 3217,
    wearable_ids: [254, 370],
  },
  {
    genesis_token_id: 3218,
    wearable_ids: [303, 346],
  },
  {
    genesis_token_id: 3219,
    wearable_ids: [273, 301],
  },
  {
    genesis_token_id: 3220,
    wearable_ids: [266, 296],
  },
  {
    genesis_token_id: 3221,
    wearable_ids: [377, 422],
  },
  {
    genesis_token_id: 3222,
    wearable_ids: [407, 265],
  },
  {
    genesis_token_id: 3223,
    wearable_ids: [389, 429],
  },
  {
    genesis_token_id: 3224,
    wearable_ids: [332, 286],
  },
  {
    genesis_token_id: 3225,
    wearable_ids: [300, 256],
  },
  {
    genesis_token_id: 3226,
    wearable_ids: [403, 303],
  },
  {
    genesis_token_id: 3227,
    wearable_ids: [303, 369],
  },
  {
    genesis_token_id: 3228,
    wearable_ids: [271, 371],
  },
  {
    genesis_token_id: 3229,
    wearable_ids: [432, 253],
  },
  {
    genesis_token_id: 3230,
    wearable_ids: [303, 306],
  },
  {
    genesis_token_id: 3231,
    wearable_ids: [425, 404],
  },
  {
    genesis_token_id: 3232,
    wearable_ids: [280, 355],
  },
  {
    genesis_token_id: 3233,
    wearable_ids: [442, 286],
  },
  {
    genesis_token_id: 3234,
    wearable_ids: [400, 422],
  },
  {
    genesis_token_id: 3235,
    wearable_ids: [301, 404],
  },
  {
    genesis_token_id: 3236,
    wearable_ids: [266, 277],
  },
  {
    genesis_token_id: 3237,
    wearable_ids: [364, 395],
  },
  {
    genesis_token_id: 3238,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 3239,
    wearable_ids: [376, 310],
  },
  {
    genesis_token_id: 3240,
    wearable_ids: [396, 432],
  },
  {
    genesis_token_id: 3241,
    wearable_ids: [263, 264],
  },
  {
    genesis_token_id: 3242,
    wearable_ids: [346, 286],
  },
  {
    genesis_token_id: 3243,
    wearable_ids: [256, 385],
  },
  {
    genesis_token_id: 3244,
    wearable_ids: [352, 308],
  },
  {
    genesis_token_id: 3245,
    wearable_ids: [348, 424],
  },
  {
    genesis_token_id: 3246,
    wearable_ids: [254, 425],
  },
  {
    genesis_token_id: 3247,
    wearable_ids: [265, 375],
  },
  {
    genesis_token_id: 3248,
    wearable_ids: [386, 412],
  },
  {
    genesis_token_id: 3249,
    wearable_ids: [377, 362],
  },
  {
    genesis_token_id: 3250,
    wearable_ids: [368, 438],
  },
  {
    genesis_token_id: 3251,
    wearable_ids: [315, 301],
  },
  {
    genesis_token_id: 3252,
    wearable_ids: [372, 397],
  },
  {
    genesis_token_id: 3253,
    wearable_ids: [295, 293],
  },
  {
    genesis_token_id: 3254,
    wearable_ids: [365, 262],
  },
  {
    genesis_token_id: 3255,
    wearable_ids: [272, 403],
  },
  {
    genesis_token_id: 3256,
    wearable_ids: [377, 422],
  },
  {
    genesis_token_id: 3257,
    wearable_ids: [434, 301],
  },
  {
    genesis_token_id: 3258,
    wearable_ids: [425, 385],
  },
  {
    genesis_token_id: 3259,
    wearable_ids: [336, 331],
  },
  {
    genesis_token_id: 3260,
    wearable_ids: [292, 397],
  },
  {
    genesis_token_id: 3261,
    wearable_ids: [253, 382],
  },
  {
    genesis_token_id: 3262,
    wearable_ids: [299, 300],
  },
  {
    genesis_token_id: 3263,
    wearable_ids: [354, 444],
  },
  {
    genesis_token_id: 3264,
    wearable_ids: [300, 319],
  },
  {
    genesis_token_id: 3265,
    wearable_ids: [382, 323],
  },
  {
    genesis_token_id: 3266,
    wearable_ids: [349, 290],
  },
  {
    genesis_token_id: 3267,
    wearable_ids: [444, 294],
  },
  {
    genesis_token_id: 3268,
    wearable_ids: [444, 332],
  },
  {
    genesis_token_id: 3269,
    wearable_ids: [292, 374],
  },
  {
    genesis_token_id: 3270,
    wearable_ids: [432, 290],
  },
  {
    genesis_token_id: 3271,
    wearable_ids: [253, 300],
  },
  {
    genesis_token_id: 3272,
    wearable_ids: [355, 343],
  },
  {
    genesis_token_id: 3273,
    wearable_ids: [310, 335],
  },
  {
    genesis_token_id: 3274,
    wearable_ids: [352, 382],
  },
  {
    genesis_token_id: 3275,
    wearable_ids: [253, 430],
  },
  {
    genesis_token_id: 3276,
    wearable_ids: [289, 347],
  },
  {
    genesis_token_id: 3277,
    wearable_ids: [426, 268],
  },
  {
    genesis_token_id: 3278,
    wearable_ids: [411, 378],
  },
  {
    genesis_token_id: 3279,
    wearable_ids: [266, 315],
  },
  {
    genesis_token_id: 3280,
    wearable_ids: [368, 286],
  },
  {
    genesis_token_id: 3281,
    wearable_ids: [431, 306],
  },
  {
    genesis_token_id: 3282,
    wearable_ids: [437, 364],
  },
  {
    genesis_token_id: 3283,
    wearable_ids: [325, 378],
  },
  {
    genesis_token_id: 3284,
    wearable_ids: [339, 299],
  },
  {
    genesis_token_id: 3285,
    wearable_ids: [262, 317],
  },
  {
    genesis_token_id: 3286,
    wearable_ids: [265, 427],
  },
  {
    genesis_token_id: 3287,
    wearable_ids: [368, 342],
  },
  {
    genesis_token_id: 3288,
    wearable_ids: [274, 372],
  },
  {
    genesis_token_id: 3289,
    wearable_ids: [277, 433],
  },
  {
    genesis_token_id: 3290,
    wearable_ids: [331, 269],
  },
  {
    genesis_token_id: 3291,
    wearable_ids: [372, 385],
  },
  {
    genesis_token_id: 3292,
    wearable_ids: [315, 277],
  },
  {
    genesis_token_id: 3293,
    wearable_ids: [276, 248],
  },
  {
    genesis_token_id: 3294,
    wearable_ids: [346, 429],
  },
  {
    genesis_token_id: 3295,
    wearable_ids: [403, 334],
  },
  {
    genesis_token_id: 3296,
    wearable_ids: [370, 292],
  },
  {
    genesis_token_id: 3297,
    wearable_ids: [352, 259],
  },
  {
    genesis_token_id: 3298,
    wearable_ids: [404, 442],
  },
  {
    genesis_token_id: 3299,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 3300,
    wearable_ids: [408, 312],
  },
  {
    genesis_token_id: 3301,
    wearable_ids: [253, 396],
  },
  {
    genesis_token_id: 3302,
    wearable_ids: [264, 411],
  },
  {
    genesis_token_id: 3303,
    wearable_ids: [263, 281],
  },
  {
    genesis_token_id: 3304,
    wearable_ids: [433, 350],
  },
  {
    genesis_token_id: 3305,
    wearable_ids: [424, 344],
  },
  {
    genesis_token_id: 3306,
    wearable_ids: [295, 301],
  },
  {
    genesis_token_id: 3307,
    wearable_ids: [403, 364],
  },
  {
    genesis_token_id: 3308,
    wearable_ids: [362, 269],
  },
  {
    genesis_token_id: 3309,
    wearable_ids: [335, 336],
  },
  {
    genesis_token_id: 3310,
    wearable_ids: [294, 287],
  },
  {
    genesis_token_id: 3311,
    wearable_ids: [424, 404],
  },
  {
    genesis_token_id: 3312,
    wearable_ids: [436, 340],
  },
  {
    genesis_token_id: 3313,
    wearable_ids: [431, 255],
  },
  {
    genesis_token_id: 3314,
    wearable_ids: [369, 248],
  },
  {
    genesis_token_id: 3315,
    wearable_ids: [422, 400],
  },
  {
    genesis_token_id: 3316,
    wearable_ids: [306, 313],
  },
  {
    genesis_token_id: 3317,
    wearable_ids: [284, 365],
  },
  {
    genesis_token_id: 3318,
    wearable_ids: [308, 429],
  },
  {
    genesis_token_id: 3319,
    wearable_ids: [336, 368],
  },
  {
    genesis_token_id: 3320,
    wearable_ids: [387, 299],
  },
  {
    genesis_token_id: 3321,
    wearable_ids: [445, 348],
  },
  {
    genesis_token_id: 3322,
    wearable_ids: [396, 413],
  },
  {
    genesis_token_id: 3323,
    wearable_ids: [407, 337],
  },
  {
    genesis_token_id: 3324,
    wearable_ids: [277, 323],
  },
  {
    genesis_token_id: 3325,
    wearable_ids: [296, 369],
  },
  {
    genesis_token_id: 3326,
    wearable_ids: [340, 292],
  },
  {
    genesis_token_id: 3327,
    wearable_ids: [420, 377],
  },
  {
    genesis_token_id: 3328,
    wearable_ids: [314, 404],
  },
  {
    genesis_token_id: 3329,
    wearable_ids: [352, 417],
  },
  {
    genesis_token_id: 3330,
    wearable_ids: [411, 445],
  },
  {
    genesis_token_id: 3331,
    wearable_ids: [272, 339],
  },
  {
    genesis_token_id: 3332,
    wearable_ids: [306, 332],
  },
  {
    genesis_token_id: 3333,
    wearable_ids: [343, 404],
  },
  {
    genesis_token_id: 3334,
    wearable_ids: [257, 362],
  },
  {
    genesis_token_id: 3335,
    wearable_ids: [263, 355],
  },
  {
    genesis_token_id: 3336,
    wearable_ids: [346, 384],
  },
  {
    genesis_token_id: 3337,
    wearable_ids: [422, 311],
  },
  {
    genesis_token_id: 3338,
    wearable_ids: [316, 289],
  },
  {
    genesis_token_id: 3339,
    wearable_ids: [289, 248],
  },
  {
    genesis_token_id: 3340,
    wearable_ids: [350, 344],
  },
  {
    genesis_token_id: 3341,
    wearable_ids: [278, 303],
  },
  {
    genesis_token_id: 3342,
    wearable_ids: [278, 257],
  },
  {
    genesis_token_id: 3343,
    wearable_ids: [362, 444],
  },
  {
    genesis_token_id: 3344,
    wearable_ids: [373, 319],
  },
  {
    genesis_token_id: 3345,
    wearable_ids: [319, 346],
  },
  {
    genesis_token_id: 3346,
    wearable_ids: [443, 412],
  },
  {
    genesis_token_id: 3347,
    wearable_ids: [337, 430],
  },
  {
    genesis_token_id: 3348,
    wearable_ids: [413, 296],
  },
  {
    genesis_token_id: 3349,
    wearable_ids: [355, 425],
  },
  {
    genesis_token_id: 3350,
    wearable_ids: [350, 395],
  },
  {
    genesis_token_id: 3351,
    wearable_ids: [410, 337],
  },
  {
    genesis_token_id: 3352,
    wearable_ids: [382, 266],
  },
  {
    genesis_token_id: 3353,
    wearable_ids: [443, 347],
  },
  {
    genesis_token_id: 3354,
    wearable_ids: [349, 319],
  },
  {
    genesis_token_id: 3355,
    wearable_ids: [364, 272],
  },
  {
    genesis_token_id: 3356,
    wearable_ids: [377, 370],
  },
  {
    genesis_token_id: 3357,
    wearable_ids: [335, 287],
  },
  {
    genesis_token_id: 3358,
    wearable_ids: [407, 363],
  },
  {
    genesis_token_id: 3359,
    wearable_ids: [404, 301],
  },
  {
    genesis_token_id: 3360,
    wearable_ids: [422, 423],
  },
  {
    genesis_token_id: 3361,
    wearable_ids: [257, 277],
  },
  {
    genesis_token_id: 3362,
    wearable_ids: [354, 253],
  },
  {
    genesis_token_id: 3363,
    wearable_ids: [331, 426],
  },
  {
    genesis_token_id: 3364,
    wearable_ids: [247, 426],
  },
  {
    genesis_token_id: 3365,
    wearable_ids: [444, 410],
  },
  {
    genesis_token_id: 3366,
    wearable_ids: [429, 296],
  },
  {
    genesis_token_id: 3367,
    wearable_ids: [299, 411],
  },
  {
    genesis_token_id: 3368,
    wearable_ids: [382, 423],
  },
  {
    genesis_token_id: 3369,
    wearable_ids: [429, 402],
  },
  {
    genesis_token_id: 3370,
    wearable_ids: [299, 432],
  },
  {
    genesis_token_id: 3371,
    wearable_ids: [274, 276],
  },
  {
    genesis_token_id: 3372,
    wearable_ids: [277, 323],
  },
  {
    genesis_token_id: 3373,
    wearable_ids: [263, 422],
  },
  {
    genesis_token_id: 3374,
    wearable_ids: [257, 404],
  },
  {
    genesis_token_id: 3375,
    wearable_ids: [362, 272],
  },
  {
    genesis_token_id: 3376,
    wearable_ids: [308, 348],
  },
  {
    genesis_token_id: 3377,
    wearable_ids: [437, 300],
  },
  {
    genesis_token_id: 3378,
    wearable_ids: [266, 315],
  },
  {
    genesis_token_id: 3379,
    wearable_ids: [308, 413],
  },
  {
    genesis_token_id: 3380,
    wearable_ids: [347, 332],
  },
  {
    genesis_token_id: 3381,
    wearable_ids: [254, 422],
  },
  {
    genesis_token_id: 3382,
    wearable_ids: [377, 306],
  },
  {
    genesis_token_id: 3383,
    wearable_ids: [276, 307],
  },
  {
    genesis_token_id: 3384,
    wearable_ids: [352, 437],
  },
  {
    genesis_token_id: 3385,
    wearable_ids: [397, 389],
  },
  {
    genesis_token_id: 3386,
    wearable_ids: [422, 285],
  },
  {
    genesis_token_id: 3387,
    wearable_ids: [348, 299],
  },
  {
    genesis_token_id: 3388,
    wearable_ids: [342, 335],
  },
  {
    genesis_token_id: 3389,
    wearable_ids: [382, 340],
  },
  {
    genesis_token_id: 3390,
    wearable_ids: [351, 435],
  },
  {
    genesis_token_id: 3391,
    wearable_ids: [343, 393],
  },
  {
    genesis_token_id: 3392,
    wearable_ids: [370, 286],
  },
  {
    genesis_token_id: 3393,
    wearable_ids: [264, 394],
  },
  {
    genesis_token_id: 3394,
    wearable_ids: [420, 342],
  },
  {
    genesis_token_id: 3395,
    wearable_ids: [248, 284],
  },
  {
    genesis_token_id: 3396,
    wearable_ids: [408, 389],
  },
  {
    genesis_token_id: 3397,
    wearable_ids: [308, 358],
  },
  {
    genesis_token_id: 3398,
    wearable_ids: [374, 264],
  },
  {
    genesis_token_id: 3399,
    wearable_ids: [383, 247],
  },
  {
    genesis_token_id: 3400,
    wearable_ids: [422, 249],
  },
  {
    genesis_token_id: 3401,
    wearable_ids: [278, 265],
  },
  {
    genesis_token_id: 3402,
    wearable_ids: [383, 365],
  },
  {
    genesis_token_id: 3403,
    wearable_ids: [253, 383],
  },
  {
    genesis_token_id: 3404,
    wearable_ids: [308, 410],
  },
  {
    genesis_token_id: 3405,
    wearable_ids: [314, 340],
  },
  {
    genesis_token_id: 3406,
    wearable_ids: [301, 361],
  },
  {
    genesis_token_id: 3407,
    wearable_ids: [265, 370],
  },
  {
    genesis_token_id: 3408,
    wearable_ids: [445, 365],
  },
  {
    genesis_token_id: 3409,
    wearable_ids: [292, 409],
  },
  {
    genesis_token_id: 3410,
    wearable_ids: [371, 394],
  },
  {
    genesis_token_id: 3411,
    wearable_ids: [264, 278],
  },
  {
    genesis_token_id: 3412,
    wearable_ids: [352, 325],
  },
  {
    genesis_token_id: 3413,
    wearable_ids: [352, 423],
  },
  {
    genesis_token_id: 3414,
    wearable_ids: [272, 416],
  },
  {
    genesis_token_id: 3415,
    wearable_ids: [374, 435],
  },
  {
    genesis_token_id: 3416,
    wearable_ids: [296, 444],
  },
  {
    genesis_token_id: 3417,
    wearable_ids: [370, 352],
  },
  {
    genesis_token_id: 3418,
    wearable_ids: [443, 263],
  },
  {
    genesis_token_id: 3419,
    wearable_ids: [272, 383],
  },
  {
    genesis_token_id: 3420,
    wearable_ids: [325, 432],
  },
  {
    genesis_token_id: 3421,
    wearable_ids: [445, 332],
  },
  {
    genesis_token_id: 3422,
    wearable_ids: [335, 253],
  },
  {
    genesis_token_id: 3423,
    wearable_ids: [255, 397],
  },
  {
    genesis_token_id: 3424,
    wearable_ids: [306, 403],
  },
  {
    genesis_token_id: 3425,
    wearable_ids: [422, 351],
  },
  {
    genesis_token_id: 3426,
    wearable_ids: [341, 378],
  },
  {
    genesis_token_id: 3427,
    wearable_ids: [316, 317],
  },
  {
    genesis_token_id: 3428,
    wearable_ids: [290, 429],
  },
  {
    genesis_token_id: 3429,
    wearable_ids: [264, 289],
  },
  {
    genesis_token_id: 3430,
    wearable_ids: [364, 354],
  },
  {
    genesis_token_id: 3431,
    wearable_ids: [336, 285],
  },
  {
    genesis_token_id: 3432,
    wearable_ids: [297, 407],
  },
  {
    genesis_token_id: 3433,
    wearable_ids: [354, 349],
  },
  {
    genesis_token_id: 3434,
    wearable_ids: [389, 247],
  },
  {
    genesis_token_id: 3435,
    wearable_ids: [268, 270],
  },
  {
    genesis_token_id: 3436,
    wearable_ids: [254, 262],
  },
  {
    genesis_token_id: 3437,
    wearable_ids: [297, 271],
  },
  {
    genesis_token_id: 3438,
    wearable_ids: [308, 291],
  },
  {
    genesis_token_id: 3439,
    wearable_ids: [409, 417],
  },
  {
    genesis_token_id: 3440,
    wearable_ids: [389, 315],
  },
  {
    genesis_token_id: 3441,
    wearable_ids: [308, 445],
  },
  {
    genesis_token_id: 3442,
    wearable_ids: [378, 338],
  },
  {
    genesis_token_id: 3443,
    wearable_ids: [336, 436],
  },
  {
    genesis_token_id: 3444,
    wearable_ids: [274, 337],
  },
  {
    genesis_token_id: 3445,
    wearable_ids: [352, 369],
  },
  {
    genesis_token_id: 3446,
    wearable_ids: [316, 289],
  },
  {
    genesis_token_id: 3447,
    wearable_ids: [410, 328],
  },
  {
    genesis_token_id: 3448,
    wearable_ids: [297, 436],
  },
  {
    genesis_token_id: 3449,
    wearable_ids: [404, 306],
  },
  {
    genesis_token_id: 3450,
    wearable_ids: [326, 410],
  },
  {
    genesis_token_id: 3451,
    wearable_ids: [326, 425],
  },
  {
    genesis_token_id: 3452,
    wearable_ids: [377, 395],
  },
  {
    genesis_token_id: 3453,
    wearable_ids: [266, 287],
  },
  {
    genesis_token_id: 3454,
    wearable_ids: [424, 295],
  },
  {
    genesis_token_id: 3455,
    wearable_ids: [412, 373],
  },
  {
    genesis_token_id: 3456,
    wearable_ids: [355, 267],
  },
  {
    genesis_token_id: 3457,
    wearable_ids: [311, 378],
  },
  {
    genesis_token_id: 3458,
    wearable_ids: [304, 319],
  },
  {
    genesis_token_id: 3459,
    wearable_ids: [287, 300],
  },
  {
    genesis_token_id: 3460,
    wearable_ids: [270, 255],
  },
  {
    genesis_token_id: 3461,
    wearable_ids: [338, 284],
  },
  {
    genesis_token_id: 3462,
    wearable_ids: [311, 251],
  },
  {
    genesis_token_id: 3463,
    wearable_ids: [373, 332],
  },
  {
    genesis_token_id: 3464,
    wearable_ids: [442, 300],
  },
  {
    genesis_token_id: 3465,
    wearable_ids: [348, 258],
  },
  {
    genesis_token_id: 3466,
    wearable_ids: [378, 303],
  },
  {
    genesis_token_id: 3467,
    wearable_ids: [274, 357],
  },
  {
    genesis_token_id: 3468,
    wearable_ids: [314, 301],
  },
  {
    genesis_token_id: 3469,
    wearable_ids: [271, 251],
  },
  {
    genesis_token_id: 3470,
    wearable_ids: [373, 395],
  },
  {
    genesis_token_id: 3471,
    wearable_ids: [395, 255],
  },
  {
    genesis_token_id: 3472,
    wearable_ids: [442, 247],
  },
  {
    genesis_token_id: 3473,
    wearable_ids: [337, 247],
  },
  {
    genesis_token_id: 3474,
    wearable_ids: [428, 398],
  },
  {
    genesis_token_id: 3475,
    wearable_ids: [292, 268],
  },
  {
    genesis_token_id: 3476,
    wearable_ids: [325, 324],
  },
  {
    genesis_token_id: 3477,
    wearable_ids: [408, 368],
  },
  {
    genesis_token_id: 3478,
    wearable_ids: [387, 257],
  },
  {
    genesis_token_id: 3479,
    wearable_ids: [266, 419],
  },
  {
    genesis_token_id: 3480,
    wearable_ids: [271, 324],
  },
  {
    genesis_token_id: 3481,
    wearable_ids: [265, 407],
  },
  {
    genesis_token_id: 3482,
    wearable_ids: [437, 263],
  },
  {
    genesis_token_id: 3483,
    wearable_ids: [434, 336],
  },
  {
    genesis_token_id: 3484,
    wearable_ids: [301, 304],
  },
  {
    genesis_token_id: 3485,
    wearable_ids: [376, 290],
  },
  {
    genesis_token_id: 3486,
    wearable_ids: [326, 429],
  },
  {
    genesis_token_id: 3487,
    wearable_ids: [354, 420],
  },
  {
    genesis_token_id: 3488,
    wearable_ids: [432, 324],
  },
  {
    genesis_token_id: 3489,
    wearable_ids: [429, 330],
  },
  {
    genesis_token_id: 3490,
    wearable_ids: [253, 408],
  },
  {
    genesis_token_id: 3491,
    wearable_ids: [348, 436],
  },
  {
    genesis_token_id: 3492,
    wearable_ids: [397, 432],
  },
  {
    genesis_token_id: 3493,
    wearable_ids: [280, 248],
  },
  {
    genesis_token_id: 3494,
    wearable_ids: [316, 418],
  },
  {
    genesis_token_id: 3495,
    wearable_ids: [374, 414],
  },
  {
    genesis_token_id: 3496,
    wearable_ids: [422, 409],
  },
  {
    genesis_token_id: 3497,
    wearable_ids: [352, 315],
  },
  {
    genesis_token_id: 3498,
    wearable_ids: [286, 365],
  },
  {
    genesis_token_id: 3499,
    wearable_ids: [336, 436],
  },
  {
    genesis_token_id: 3500,
    wearable_ids: [424, 310],
  },
  {
    genesis_token_id: 3501,
    wearable_ids: [291, 433],
  },
  {
    genesis_token_id: 3502,
    wearable_ids: [404, 351],
  },
  {
    genesis_token_id: 3503,
    wearable_ids: [317, 400],
  },
  {
    genesis_token_id: 3504,
    wearable_ids: [295, 274],
  },
  {
    genesis_token_id: 3505,
    wearable_ids: [375, 401],
  },
  {
    genesis_token_id: 3506,
    wearable_ids: [287, 338],
  },
  {
    genesis_token_id: 3507,
    wearable_ids: [384, 268],
  },
  {
    genesis_token_id: 3508,
    wearable_ids: [431, 407],
  },
  {
    genesis_token_id: 3509,
    wearable_ids: [325, 314],
  },
  {
    genesis_token_id: 3510,
    wearable_ids: [263, 311],
  },
  {
    genesis_token_id: 3511,
    wearable_ids: [294, 338],
  },
  {
    genesis_token_id: 3512,
    wearable_ids: [251, 431],
  },
  {
    genesis_token_id: 3513,
    wearable_ids: [423, 384],
  },
  {
    genesis_token_id: 3514,
    wearable_ids: [386, 400],
  },
  {
    genesis_token_id: 3515,
    wearable_ids: [400, 275],
  },
  {
    genesis_token_id: 3516,
    wearable_ids: [343, 317],
  },
  {
    genesis_token_id: 3517,
    wearable_ids: [436, 258],
  },
  {
    genesis_token_id: 3518,
    wearable_ids: [395, 407],
  },
  {
    genesis_token_id: 3519,
    wearable_ids: [339, 396],
  },
  {
    genesis_token_id: 3520,
    wearable_ids: [294, 375],
  },
  {
    genesis_token_id: 3521,
    wearable_ids: [317, 410],
  },
  {
    genesis_token_id: 3522,
    wearable_ids: [346, 253],
  },
  {
    genesis_token_id: 3523,
    wearable_ids: [442, 284],
  },
  {
    genesis_token_id: 3524,
    wearable_ids: [315, 443],
  },
  {
    genesis_token_id: 3525,
    wearable_ids: [375, 366],
  },
  {
    genesis_token_id: 3526,
    wearable_ids: [338, 275],
  },
  {
    genesis_token_id: 3527,
    wearable_ids: [434, 423],
  },
  {
    genesis_token_id: 3528,
    wearable_ids: [364, 403],
  },
  {
    genesis_token_id: 3529,
    wearable_ids: [365, 323],
  },
  {
    genesis_token_id: 3530,
    wearable_ids: [295, 408],
  },
  {
    genesis_token_id: 3531,
    wearable_ids: [409, 394],
  },
  {
    genesis_token_id: 3532,
    wearable_ids: [412, 424],
  },
  {
    genesis_token_id: 3533,
    wearable_ids: [251, 432],
  },
  {
    genesis_token_id: 3534,
    wearable_ids: [431, 435],
  },
  {
    genesis_token_id: 3535,
    wearable_ids: [385, 271],
  },
  {
    genesis_token_id: 3536,
    wearable_ids: [277, 253],
  },
  {
    genesis_token_id: 3537,
    wearable_ids: [423, 361],
  },
  {
    genesis_token_id: 3538,
    wearable_ids: [277, 325],
  },
  {
    genesis_token_id: 3539,
    wearable_ids: [310, 429],
  },
  {
    genesis_token_id: 3540,
    wearable_ids: [435, 338],
  },
  {
    genesis_token_id: 3541,
    wearable_ids: [276, 392],
  },
  {
    genesis_token_id: 3542,
    wearable_ids: [274, 410],
  },
  {
    genesis_token_id: 3543,
    wearable_ids: [263, 291],
  },
  {
    genesis_token_id: 3544,
    wearable_ids: [423, 429],
  },
  {
    genesis_token_id: 3545,
    wearable_ids: [442, 289],
  },
  {
    genesis_token_id: 3546,
    wearable_ids: [349, 294],
  },
  {
    genesis_token_id: 3547,
    wearable_ids: [289, 413],
  },
  {
    genesis_token_id: 3548,
    wearable_ids: [406, 311],
  },
  {
    genesis_token_id: 3549,
    wearable_ids: [331, 384],
  },
  {
    genesis_token_id: 3550,
    wearable_ids: [289, 426],
  },
  {
    genesis_token_id: 3551,
    wearable_ids: [387, 428],
  },
  {
    genesis_token_id: 3552,
    wearable_ids: [406, 316],
  },
  {
    genesis_token_id: 3553,
    wearable_ids: [363, 400],
  },
  {
    genesis_token_id: 3554,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 3555,
    wearable_ids: [258, 279],
  },
  {
    genesis_token_id: 3556,
    wearable_ids: [382, 404],
  },
  {
    genesis_token_id: 3557,
    wearable_ids: [343, 370],
  },
  {
    genesis_token_id: 3558,
    wearable_ids: [347, 387],
  },
  {
    genesis_token_id: 3559,
    wearable_ids: [343, 352],
  },
  {
    genesis_token_id: 3560,
    wearable_ids: [325, 286],
  },
  {
    genesis_token_id: 3561,
    wearable_ids: [278, 339],
  },
  {
    genesis_token_id: 3562,
    wearable_ids: [445, 429],
  },
  {
    genesis_token_id: 3563,
    wearable_ids: [319, 324],
  },
  {
    genesis_token_id: 3564,
    wearable_ids: [315, 410],
  },
  {
    genesis_token_id: 3565,
    wearable_ids: [397, 398],
  },
  {
    genesis_token_id: 3566,
    wearable_ids: [308, 408],
  },
  {
    genesis_token_id: 3567,
    wearable_ids: [420, 249],
  },
  {
    genesis_token_id: 3568,
    wearable_ids: [432, 423],
  },
  {
    genesis_token_id: 3569,
    wearable_ids: [406, 281],
  },
  {
    genesis_token_id: 3570,
    wearable_ids: [308, 295],
  },
  {
    genesis_token_id: 3571,
    wearable_ids: [336, 355],
  },
  {
    genesis_token_id: 3572,
    wearable_ids: [303, 295],
  },
  {
    genesis_token_id: 3573,
    wearable_ids: [355, 373],
  },
  {
    genesis_token_id: 3574,
    wearable_ids: [299, 333],
  },
  {
    genesis_token_id: 3575,
    wearable_ids: [433, 275],
  },
  {
    genesis_token_id: 3576,
    wearable_ids: [396, 351],
  },
  {
    genesis_token_id: 3577,
    wearable_ids: [376, 411],
  },
  {
    genesis_token_id: 3578,
    wearable_ids: [259, 434],
  },
  {
    genesis_token_id: 3579,
    wearable_ids: [364, 337],
  },
  {
    genesis_token_id: 3580,
    wearable_ids: [431, 437],
  },
  {
    genesis_token_id: 3581,
    wearable_ids: [340, 363],
  },
  {
    genesis_token_id: 3582,
    wearable_ids: [373, 308],
  },
  {
    genesis_token_id: 3583,
    wearable_ids: [423, 369],
  },
  {
    genesis_token_id: 3584,
    wearable_ids: [272, 382],
  },
  {
    genesis_token_id: 3585,
    wearable_ids: [406, 369],
  },
  {
    genesis_token_id: 3586,
    wearable_ids: [443, 327],
  },
  {
    genesis_token_id: 3587,
    wearable_ids: [299, 365],
  },
  {
    genesis_token_id: 3588,
    wearable_ids: [444, 362],
  },
  {
    genesis_token_id: 3589,
    wearable_ids: [370, 408],
  },
  {
    genesis_token_id: 3590,
    wearable_ids: [406, 324],
  },
  {
    genesis_token_id: 3591,
    wearable_ids: [276, 365],
  },
  {
    genesis_token_id: 3592,
    wearable_ids: [257, 248],
  },
  {
    genesis_token_id: 3593,
    wearable_ids: [306, 343],
  },
  {
    genesis_token_id: 3594,
    wearable_ids: [340, 250],
  },
  {
    genesis_token_id: 3595,
    wearable_ids: [397, 302],
  },
  {
    genesis_token_id: 3596,
    wearable_ids: [364, 369],
  },
  {
    genesis_token_id: 3597,
    wearable_ids: [299, 323],
  },
  {
    genesis_token_id: 3598,
    wearable_ids: [444, 297],
  },
  {
    genesis_token_id: 3599,
    wearable_ids: [385, 279],
  },
  {
    genesis_token_id: 3600,
    wearable_ids: [406, 263],
  },
  {
    genesis_token_id: 3601,
    wearable_ids: [337, 343],
  },
  {
    genesis_token_id: 3602,
    wearable_ids: [395, 347],
  },
  {
    genesis_token_id: 3603,
    wearable_ids: [254, 376],
  },
  {
    genesis_token_id: 3604,
    wearable_ids: [263, 247],
  },
  {
    genesis_token_id: 3605,
    wearable_ids: [297, 255],
  },
  {
    genesis_token_id: 3606,
    wearable_ids: [444, 341],
  },
  {
    genesis_token_id: 3607,
    wearable_ids: [370, 277],
  },
  {
    genesis_token_id: 3608,
    wearable_ids: [292, 325],
  },
  {
    genesis_token_id: 3609,
    wearable_ids: [287, 301],
  },
  {
    genesis_token_id: 3610,
    wearable_ids: [424, 432],
  },
  {
    genesis_token_id: 3611,
    wearable_ids: [406, 284],
  },
  {
    genesis_token_id: 3612,
    wearable_ids: [263, 388],
  },
  {
    genesis_token_id: 3613,
    wearable_ids: [344, 290],
  },
  {
    genesis_token_id: 3614,
    wearable_ids: [325, 412],
  },
  {
    genesis_token_id: 3615,
    wearable_ids: [352, 361],
  },
  {
    genesis_token_id: 3616,
    wearable_ids: [326, 373],
  },
  {
    genesis_token_id: 3617,
    wearable_ids: [411, 274],
  },
  {
    genesis_token_id: 3618,
    wearable_ids: [431, 357],
  },
  {
    genesis_token_id: 3619,
    wearable_ids: [253, 257],
  },
  {
    genesis_token_id: 3620,
    wearable_ids: [295, 435],
  },
  {
    genesis_token_id: 3621,
    wearable_ids: [410, 279],
  },
  {
    genesis_token_id: 3622,
    wearable_ids: [300, 289],
  },
  {
    genesis_token_id: 3623,
    wearable_ids: [315, 352],
  },
  {
    genesis_token_id: 3624,
    wearable_ids: [253, 337],
  },
  {
    genesis_token_id: 3625,
    wearable_ids: [341, 325],
  },
  {
    genesis_token_id: 3626,
    wearable_ids: [348, 389],
  },
  {
    genesis_token_id: 3627,
    wearable_ids: [256, 408],
  },
  {
    genesis_token_id: 3628,
    wearable_ids: [335, 277],
  },
  {
    genesis_token_id: 3629,
    wearable_ids: [370, 427],
  },
  {
    genesis_token_id: 3630,
    wearable_ids: [368, 324],
  },
  {
    genesis_token_id: 3631,
    wearable_ids: [291, 323],
  },
  {
    genesis_token_id: 3632,
    wearable_ids: [444, 325],
  },
  {
    genesis_token_id: 3633,
    wearable_ids: [268, 261],
  },
  {
    genesis_token_id: 3634,
    wearable_ids: [355, 308],
  },
  {
    genesis_token_id: 3635,
    wearable_ids: [331, 306],
  },
  {
    genesis_token_id: 3636,
    wearable_ids: [428, 257],
  },
  {
    genesis_token_id: 3637,
    wearable_ids: [290, 318],
  },
  {
    genesis_token_id: 3638,
    wearable_ids: [444, 418],
  },
  {
    genesis_token_id: 3639,
    wearable_ids: [257, 382],
  },
  {
    genesis_token_id: 3640,
    wearable_ids: [290, 331],
  },
  {
    genesis_token_id: 3641,
    wearable_ids: [319, 327],
  },
  {
    genesis_token_id: 3642,
    wearable_ids: [429, 339],
  },
  {
    genesis_token_id: 3643,
    wearable_ids: [375, 274],
  },
  {
    genesis_token_id: 3644,
    wearable_ids: [373, 368],
  },
  {
    genesis_token_id: 3645,
    wearable_ids: [284, 297],
  },
  {
    genesis_token_id: 3646,
    wearable_ids: [310, 412],
  },
  {
    genesis_token_id: 3647,
    wearable_ids: [335, 294],
  },
  {
    genesis_token_id: 3648,
    wearable_ids: [383, 376],
  },
  {
    genesis_token_id: 3649,
    wearable_ids: [395, 441],
  },
  {
    genesis_token_id: 3650,
    wearable_ids: [274, 370],
  },
  {
    genesis_token_id: 3651,
    wearable_ids: [262, 426],
  },
  {
    genesis_token_id: 3652,
    wearable_ids: [278, 276],
  },
  {
    genesis_token_id: 3653,
    wearable_ids: [365, 422],
  },
  {
    genesis_token_id: 3654,
    wearable_ids: [255, 270],
  },
  {
    genesis_token_id: 3655,
    wearable_ids: [256, 409],
  },
  {
    genesis_token_id: 3656,
    wearable_ids: [408, 426],
  },
  {
    genesis_token_id: 3657,
    wearable_ids: [284, 273],
  },
  {
    genesis_token_id: 3658,
    wearable_ids: [377, 433],
  },
  {
    genesis_token_id: 3659,
    wearable_ids: [274, 322],
  },
  {
    genesis_token_id: 3660,
    wearable_ids: [258, 291],
  },
  {
    genesis_token_id: 3661,
    wearable_ids: [431, 444],
  },
  {
    genesis_token_id: 3662,
    wearable_ids: [354, 347],
  },
  {
    genesis_token_id: 3663,
    wearable_ids: [403, 280],
  },
  {
    genesis_token_id: 3664,
    wearable_ids: [377, 276],
  },
  {
    genesis_token_id: 3665,
    wearable_ids: [253, 272],
  },
  {
    genesis_token_id: 3666,
    wearable_ids: [349, 326],
  },
  {
    genesis_token_id: 3667,
    wearable_ids: [433, 295],
  },
  {
    genesis_token_id: 3668,
    wearable_ids: [314, 346],
  },
  {
    genesis_token_id: 3669,
    wearable_ids: [315, 255],
  },
  {
    genesis_token_id: 3670,
    wearable_ids: [295, 327],
  },
  {
    genesis_token_id: 3671,
    wearable_ids: [268, 423],
  },
  {
    genesis_token_id: 3672,
    wearable_ids: [415, 333],
  },
  {
    genesis_token_id: 3673,
    wearable_ids: [396, 253],
  },
  {
    genesis_token_id: 3674,
    wearable_ids: [424, 304],
  },
  {
    genesis_token_id: 3675,
    wearable_ids: [332, 384],
  },
  {
    genesis_token_id: 3676,
    wearable_ids: [317, 297],
  },
  {
    genesis_token_id: 3677,
    wearable_ids: [410, 376],
  },
  {
    genesis_token_id: 3678,
    wearable_ids: [436, 372],
  },
  {
    genesis_token_id: 3679,
    wearable_ids: [344, 328],
  },
  {
    genesis_token_id: 3680,
    wearable_ids: [251, 303],
  },
  {
    genesis_token_id: 3681,
    wearable_ids: [251, 437],
  },
  {
    genesis_token_id: 3682,
    wearable_ids: [376, 290],
  },
  {
    genesis_token_id: 3683,
    wearable_ids: [348, 411],
  },
  {
    genesis_token_id: 3684,
    wearable_ids: [253, 356],
  },
  {
    genesis_token_id: 3685,
    wearable_ids: [272, 438],
  },
  {
    genesis_token_id: 3686,
    wearable_ids: [253, 272],
  },
  {
    genesis_token_id: 3687,
    wearable_ids: [354, 256],
  },
  {
    genesis_token_id: 3688,
    wearable_ids: [382, 443],
  },
  {
    genesis_token_id: 3689,
    wearable_ids: [278, 339],
  },
  {
    genesis_token_id: 3690,
    wearable_ids: [444, 258],
  },
  {
    genesis_token_id: 3691,
    wearable_ids: [315, 409],
  },
  {
    genesis_token_id: 3692,
    wearable_ids: [413, 350],
  },
  {
    genesis_token_id: 3693,
    wearable_ids: [374, 275],
  },
  {
    genesis_token_id: 3694,
    wearable_ids: [274, 286],
  },
  {
    genesis_token_id: 3695,
    wearable_ids: [428, 426],
  },
  {
    genesis_token_id: 3696,
    wearable_ids: [386, 253],
  },
  {
    genesis_token_id: 3697,
    wearable_ids: [299, 300],
  },
  {
    genesis_token_id: 3698,
    wearable_ids: [339, 355],
  },
  {
    genesis_token_id: 3699,
    wearable_ids: [339, 265],
  },
  {
    genesis_token_id: 3700,
    wearable_ids: [263, 306],
  },
  {
    genesis_token_id: 3701,
    wearable_ids: [422, 378],
  },
  {
    genesis_token_id: 3702,
    wearable_ids: [420, 342],
  },
  {
    genesis_token_id: 3703,
    wearable_ids: [413, 297],
  },
  {
    genesis_token_id: 3704,
    wearable_ids: [377, 375],
  },
  {
    genesis_token_id: 3705,
    wearable_ids: [431, 272],
  },
  {
    genesis_token_id: 3706,
    wearable_ids: [311, 298],
  },
  {
    genesis_token_id: 3707,
    wearable_ids: [365, 387],
  },
  {
    genesis_token_id: 3708,
    wearable_ids: [257, 415],
  },
  {
    genesis_token_id: 3709,
    wearable_ids: [397, 358],
  },
  {
    genesis_token_id: 3710,
    wearable_ids: [351, 266],
  },
  {
    genesis_token_id: 3711,
    wearable_ids: [265, 392],
  },
  {
    genesis_token_id: 3712,
    wearable_ids: [397, 265],
  },
  {
    genesis_token_id: 3713,
    wearable_ids: [413, 386],
  },
  {
    genesis_token_id: 3714,
    wearable_ids: [347, 420],
  },
  {
    genesis_token_id: 3715,
    wearable_ids: [270, 376],
  },
  {
    genesis_token_id: 3716,
    wearable_ids: [346, 274],
  },
  {
    genesis_token_id: 3717,
    wearable_ids: [264, 384],
  },
  {
    genesis_token_id: 3718,
    wearable_ids: [445, 325],
  },
  {
    genesis_token_id: 3719,
    wearable_ids: [435, 291],
  },
  {
    genesis_token_id: 3720,
    wearable_ids: [310, 324],
  },
  {
    genesis_token_id: 3721,
    wearable_ids: [325, 370],
  },
  {
    genesis_token_id: 3722,
    wearable_ids: [338, 389],
  },
  {
    genesis_token_id: 3723,
    wearable_ids: [319, 396],
  },
  {
    genesis_token_id: 3724,
    wearable_ids: [399, 387],
  },
  {
    genesis_token_id: 3725,
    wearable_ids: [369, 436],
  },
  {
    genesis_token_id: 3726,
    wearable_ids: [362, 254],
  },
  {
    genesis_token_id: 3727,
    wearable_ids: [308, 423],
  },
  {
    genesis_token_id: 3728,
    wearable_ids: [354, 246],
  },
  {
    genesis_token_id: 3729,
    wearable_ids: [342, 424],
  },
  {
    genesis_token_id: 3730,
    wearable_ids: [363, 423],
  },
  {
    genesis_token_id: 3731,
    wearable_ids: [432, 289],
  },
  {
    genesis_token_id: 3732,
    wearable_ids: [422, 399],
  },
  {
    genesis_token_id: 3733,
    wearable_ids: [319, 280],
  },
  {
    genesis_token_id: 3734,
    wearable_ids: [265, 362],
  },
  {
    genesis_token_id: 3735,
    wearable_ids: [316, 256],
  },
  {
    genesis_token_id: 3736,
    wearable_ids: [423, 311],
  },
  {
    genesis_token_id: 3737,
    wearable_ids: [296, 325],
  },
  {
    genesis_token_id: 3738,
    wearable_ids: [422, 443],
  },
  {
    genesis_token_id: 3739,
    wearable_ids: [347, 290],
  },
  {
    genesis_token_id: 3740,
    wearable_ids: [369, 437],
  },
  {
    genesis_token_id: 3741,
    wearable_ids: [403, 396],
  },
  {
    genesis_token_id: 3742,
    wearable_ids: [354, 247],
  },
  {
    genesis_token_id: 3743,
    wearable_ids: [382, 325],
  },
  {
    genesis_token_id: 3744,
    wearable_ids: [374, 343],
  },
  {
    genesis_token_id: 3745,
    wearable_ids: [349, 330],
  },
  {
    genesis_token_id: 3746,
    wearable_ids: [437, 379],
  },
  {
    genesis_token_id: 3747,
    wearable_ids: [319, 404],
  },
  {
    genesis_token_id: 3748,
    wearable_ids: [301, 308],
  },
  {
    genesis_token_id: 3749,
    wearable_ids: [256, 386],
  },
  {
    genesis_token_id: 3750,
    wearable_ids: [369, 290],
  },
  {
    genesis_token_id: 3751,
    wearable_ids: [413, 333],
  },
  {
    genesis_token_id: 3752,
    wearable_ids: [375, 313],
  },
  {
    genesis_token_id: 3753,
    wearable_ids: [284, 264],
  },
  {
    genesis_token_id: 3754,
    wearable_ids: [308, 317],
  },
  {
    genesis_token_id: 3755,
    wearable_ids: [431, 408],
  },
  {
    genesis_token_id: 3756,
    wearable_ids: [350, 319],
  },
  {
    genesis_token_id: 3757,
    wearable_ids: [258, 350],
  },
  {
    genesis_token_id: 3758,
    wearable_ids: [301, 253],
  },
  {
    genesis_token_id: 3759,
    wearable_ids: [344, 317],
  },
  {
    genesis_token_id: 3760,
    wearable_ids: [314, 281],
  },
  {
    genesis_token_id: 3761,
    wearable_ids: [342, 264],
  },
  {
    genesis_token_id: 3762,
    wearable_ids: [306, 430],
  },
  {
    genesis_token_id: 3763,
    wearable_ids: [291, 288],
  },
  {
    genesis_token_id: 3764,
    wearable_ids: [266, 304],
  },
  {
    genesis_token_id: 3765,
    wearable_ids: [364, 410],
  },
  {
    genesis_token_id: 3766,
    wearable_ids: [270, 443],
  },
  {
    genesis_token_id: 3767,
    wearable_ids: [286, 251],
  },
  {
    genesis_token_id: 3768,
    wearable_ids: [375, 348],
  },
  {
    genesis_token_id: 3769,
    wearable_ids: [431, 369],
  },
  {
    genesis_token_id: 3770,
    wearable_ids: [265, 316],
  },
  {
    genesis_token_id: 3771,
    wearable_ids: [299, 297],
  },
  {
    genesis_token_id: 3772,
    wearable_ids: [340, 410],
  },
  {
    genesis_token_id: 3773,
    wearable_ids: [291, 409],
  },
  {
    genesis_token_id: 3774,
    wearable_ids: [303, 394],
  },
  {
    genesis_token_id: 3775,
    wearable_ids: [445, 273],
  },
  {
    genesis_token_id: 3776,
    wearable_ids: [386, 368],
  },
  {
    genesis_token_id: 3777,
    wearable_ids: [341, 365],
  },
  {
    genesis_token_id: 3778,
    wearable_ids: [436, 400],
  },
  {
    genesis_token_id: 3779,
    wearable_ids: [324, 346],
  },
  {
    genesis_token_id: 3780,
    wearable_ids: [340, 342],
  },
  {
    genesis_token_id: 3781,
    wearable_ids: [349, 344],
  },
  {
    genesis_token_id: 3782,
    wearable_ids: [255, 345],
  },
  {
    genesis_token_id: 3783,
    wearable_ids: [374, 365],
  },
  {
    genesis_token_id: 3784,
    wearable_ids: [343, 442],
  },
  {
    genesis_token_id: 3785,
    wearable_ids: [425, 339],
  },
  {
    genesis_token_id: 3786,
    wearable_ids: [256, 338],
  },
  {
    genesis_token_id: 3787,
    wearable_ids: [273, 293],
  },
  {
    genesis_token_id: 3788,
    wearable_ids: [373, 442],
  },
  {
    genesis_token_id: 3789,
    wearable_ids: [348, 296],
  },
  {
    genesis_token_id: 3790,
    wearable_ids: [248, 437],
  },
  {
    genesis_token_id: 3791,
    wearable_ids: [301, 370],
  },
  {
    genesis_token_id: 3792,
    wearable_ids: [284, 385],
  },
  {
    genesis_token_id: 3793,
    wearable_ids: [290, 259],
  },
  {
    genesis_token_id: 3794,
    wearable_ids: [434, 267],
  },
  {
    genesis_token_id: 3795,
    wearable_ids: [300, 257],
  },
  {
    genesis_token_id: 3796,
    wearable_ids: [284, 314],
  },
  {
    genesis_token_id: 3797,
    wearable_ids: [262, 271],
  },
  {
    genesis_token_id: 3798,
    wearable_ids: [268, 385],
  },
  {
    genesis_token_id: 3799,
    wearable_ids: [407, 411],
  },
  {
    genesis_token_id: 3800,
    wearable_ids: [339, 348],
  },
  {
    genesis_token_id: 3801,
    wearable_ids: [263, 324],
  },
  {
    genesis_token_id: 3802,
    wearable_ids: [406, 422],
  },
  {
    genesis_token_id: 3803,
    wearable_ids: [308, 291],
  },
  {
    genesis_token_id: 3804,
    wearable_ids: [297, 274],
  },
  {
    genesis_token_id: 3805,
    wearable_ids: [332, 338],
  },
  {
    genesis_token_id: 3806,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 3807,
    wearable_ids: [257, 420],
  },
  {
    genesis_token_id: 3808,
    wearable_ids: [431, 350],
  },
  {
    genesis_token_id: 3809,
    wearable_ids: [373, 253],
  },
  {
    genesis_token_id: 3810,
    wearable_ids: [375, 391],
  },
  {
    genesis_token_id: 3811,
    wearable_ids: [264, 398],
  },
  {
    genesis_token_id: 3812,
    wearable_ids: [263, 431],
  },
  {
    genesis_token_id: 3813,
    wearable_ids: [389, 269],
  },
  {
    genesis_token_id: 3814,
    wearable_ids: [297, 371],
  },
  {
    genesis_token_id: 3815,
    wearable_ids: [422, 384],
  },
  {
    genesis_token_id: 3816,
    wearable_ids: [314, 246],
  },
  {
    genesis_token_id: 3817,
    wearable_ids: [291, 273],
  },
  {
    genesis_token_id: 3818,
    wearable_ids: [404, 359],
  },
  {
    genesis_token_id: 3819,
    wearable_ids: [373, 269],
  },
  {
    genesis_token_id: 3820,
    wearable_ids: [408, 324],
  },
  {
    genesis_token_id: 3821,
    wearable_ids: [370, 435],
  },
  {
    genesis_token_id: 3822,
    wearable_ids: [435, 409],
  },
  {
    genesis_token_id: 3823,
    wearable_ids: [387, 409],
  },
  {
    genesis_token_id: 3824,
    wearable_ids: [331, 403],
  },
  {
    genesis_token_id: 3825,
    wearable_ids: [383, 387],
  },
  {
    genesis_token_id: 3826,
    wearable_ids: [413, 305],
  },
  {
    genesis_token_id: 3827,
    wearable_ids: [248, 336],
  },
  {
    genesis_token_id: 3828,
    wearable_ids: [354, 304],
  },
  {
    genesis_token_id: 3829,
    wearable_ids: [247, 396],
  },
  {
    genesis_token_id: 3830,
    wearable_ids: [411, 316],
  },
  {
    genesis_token_id: 3831,
    wearable_ids: [443, 292],
  },
  {
    genesis_token_id: 3832,
    wearable_ids: [351, 306],
  },
  {
    genesis_token_id: 3833,
    wearable_ids: [311, 384],
  },
  {
    genesis_token_id: 3834,
    wearable_ids: [395, 331],
  },
  {
    genesis_token_id: 3835,
    wearable_ids: [371, 322],
  },
  {
    genesis_token_id: 3836,
    wearable_ids: [266, 374],
  },
  {
    genesis_token_id: 3837,
    wearable_ids: [259, 324],
  },
  {
    genesis_token_id: 3838,
    wearable_ids: [409, 288],
  },
  {
    genesis_token_id: 3839,
    wearable_ids: [296, 272],
  },
  {
    genesis_token_id: 3840,
    wearable_ids: [368, 394],
  },
  {
    genesis_token_id: 3841,
    wearable_ids: [338, 378],
  },
  {
    genesis_token_id: 3842,
    wearable_ids: [324, 251],
  },
  {
    genesis_token_id: 3843,
    wearable_ids: [259, 444],
  },
  {
    genesis_token_id: 3844,
    wearable_ids: [343, 363],
  },
  {
    genesis_token_id: 3845,
    wearable_ids: [422, 431],
  },
  {
    genesis_token_id: 3846,
    wearable_ids: [336, 435],
  },
  {
    genesis_token_id: 3847,
    wearable_ids: [422, 429],
  },
  {
    genesis_token_id: 3848,
    wearable_ids: [292, 348],
  },
  {
    genesis_token_id: 3849,
    wearable_ids: [387, 377],
  },
  {
    genesis_token_id: 3850,
    wearable_ids: [346, 372],
  },
  {
    genesis_token_id: 3851,
    wearable_ids: [362, 286],
  },
  {
    genesis_token_id: 3852,
    wearable_ids: [396, 256],
  },
  {
    genesis_token_id: 3853,
    wearable_ids: [319, 371],
  },
  {
    genesis_token_id: 3854,
    wearable_ids: [259, 404],
  },
  {
    genesis_token_id: 3855,
    wearable_ids: [319, 341],
  },
  {
    genesis_token_id: 3856,
    wearable_ids: [442, 374],
  },
  {
    genesis_token_id: 3857,
    wearable_ids: [314, 403],
  },
  {
    genesis_token_id: 3858,
    wearable_ids: [314, 273],
  },
  {
    genesis_token_id: 3859,
    wearable_ids: [253, 432],
  },
  {
    genesis_token_id: 3860,
    wearable_ids: [248, 253],
  },
  {
    genesis_token_id: 3861,
    wearable_ids: [378, 351],
  },
  {
    genesis_token_id: 3862,
    wearable_ids: [437, 246],
  },
  {
    genesis_token_id: 3863,
    wearable_ids: [262, 293],
  },
  {
    genesis_token_id: 3864,
    wearable_ids: [385, 438],
  },
  {
    genesis_token_id: 3865,
    wearable_ids: [374, 400],
  },
  {
    genesis_token_id: 3866,
    wearable_ids: [397, 308],
  },
  {
    genesis_token_id: 3867,
    wearable_ids: [347, 331],
  },
  {
    genesis_token_id: 3868,
    wearable_ids: [274, 345],
  },
  {
    genesis_token_id: 3869,
    wearable_ids: [389, 378],
  },
  {
    genesis_token_id: 3870,
    wearable_ids: [384, 277],
  },
  {
    genesis_token_id: 3871,
    wearable_ids: [248, 413],
  },
  {
    genesis_token_id: 3872,
    wearable_ids: [303, 369],
  },
  {
    genesis_token_id: 3873,
    wearable_ids: [277, 247],
  },
  {
    genesis_token_id: 3874,
    wearable_ids: [263, 341],
  },
  {
    genesis_token_id: 3875,
    wearable_ids: [415, 386],
  },
  {
    genesis_token_id: 3876,
    wearable_ids: [406, 435],
  },
  {
    genesis_token_id: 3877,
    wearable_ids: [254, 354],
  },
  {
    genesis_token_id: 3878,
    wearable_ids: [266, 331],
  },
  {
    genesis_token_id: 3879,
    wearable_ids: [389, 319],
  },
  {
    genesis_token_id: 3880,
    wearable_ids: [315, 376],
  },
  {
    genesis_token_id: 3881,
    wearable_ids: [424, 311],
  },
  {
    genesis_token_id: 3882,
    wearable_ids: [255, 254],
  },
  {
    genesis_token_id: 3883,
    wearable_ids: [310, 328],
  },
  {
    genesis_token_id: 3884,
    wearable_ids: [266, 271],
  },
  {
    genesis_token_id: 3885,
    wearable_ids: [296, 384],
  },
  {
    genesis_token_id: 3886,
    wearable_ids: [369, 353],
  },
  {
    genesis_token_id: 3887,
    wearable_ids: [425, 325],
  },
  {
    genesis_token_id: 3888,
    wearable_ids: [332, 304],
  },
  {
    genesis_token_id: 3889,
    wearable_ids: [266, 342],
  },
  {
    genesis_token_id: 3890,
    wearable_ids: [317, 246],
  },
  {
    genesis_token_id: 3891,
    wearable_ids: [444, 374],
  },
  {
    genesis_token_id: 3892,
    wearable_ids: [256, 419],
  },
  {
    genesis_token_id: 3893,
    wearable_ids: [370, 299],
  },
  {
    genesis_token_id: 3894,
    wearable_ids: [325, 322],
  },
  {
    genesis_token_id: 3895,
    wearable_ids: [335, 340],
  },
  {
    genesis_token_id: 3896,
    wearable_ids: [331, 368],
  },
  {
    genesis_token_id: 3897,
    wearable_ids: [308, 328],
  },
  {
    genesis_token_id: 3898,
    wearable_ids: [248, 368],
  },
  {
    genesis_token_id: 3899,
    wearable_ids: [324, 416],
  },
  {
    genesis_token_id: 3900,
    wearable_ids: [355, 330],
  },
  {
    genesis_token_id: 3901,
    wearable_ids: [255, 295],
  },
  {
    genesis_token_id: 3902,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 3903,
    wearable_ids: [426, 271],
  },
  {
    genesis_token_id: 3904,
    wearable_ids: [373, 375],
  },
  {
    genesis_token_id: 3905,
    wearable_ids: [442, 256],
  },
  {
    genesis_token_id: 3906,
    wearable_ids: [292, 368],
  },
  {
    genesis_token_id: 3907,
    wearable_ids: [316, 270],
  },
  {
    genesis_token_id: 3908,
    wearable_ids: [280, 368],
  },
  {
    genesis_token_id: 3909,
    wearable_ids: [383, 399],
  },
  {
    genesis_token_id: 3910,
    wearable_ids: [331, 300],
  },
  {
    genesis_token_id: 3911,
    wearable_ids: [375, 377],
  },
  {
    genesis_token_id: 3912,
    wearable_ids: [295, 403],
  },
  {
    genesis_token_id: 3913,
    wearable_ids: [247, 363],
  },
  {
    genesis_token_id: 3914,
    wearable_ids: [437, 311],
  },
  {
    genesis_token_id: 3915,
    wearable_ids: [251, 262],
  },
  {
    genesis_token_id: 3916,
    wearable_ids: [400, 299],
  },
  {
    genesis_token_id: 3917,
    wearable_ids: [383, 437],
  },
  {
    genesis_token_id: 3918,
    wearable_ids: [364, 330],
  },
  {
    genesis_token_id: 3919,
    wearable_ids: [354, 445],
  },
  {
    genesis_token_id: 3920,
    wearable_ids: [342, 432],
  },
  {
    genesis_token_id: 3921,
    wearable_ids: [404, 316],
  },
  {
    genesis_token_id: 3922,
    wearable_ids: [354, 347],
  },
  {
    genesis_token_id: 3923,
    wearable_ids: [256, 291],
  },
  {
    genesis_token_id: 3924,
    wearable_ids: [364, 346],
  },
  {
    genesis_token_id: 3925,
    wearable_ids: [276, 303],
  },
  {
    genesis_token_id: 3926,
    wearable_ids: [369, 417],
  },
  {
    genesis_token_id: 3927,
    wearable_ids: [436, 351],
  },
  {
    genesis_token_id: 3928,
    wearable_ids: [257, 300],
  },
  {
    genesis_token_id: 3929,
    wearable_ids: [382, 299],
  },
  {
    genesis_token_id: 3930,
    wearable_ids: [431, 250],
  },
  {
    genesis_token_id: 3931,
    wearable_ids: [368, 251],
  },
  {
    genesis_token_id: 3932,
    wearable_ids: [258, 408],
  },
  {
    genesis_token_id: 3933,
    wearable_ids: [350, 292],
  },
  {
    genesis_token_id: 3934,
    wearable_ids: [292, 422],
  },
  {
    genesis_token_id: 3935,
    wearable_ids: [304, 325],
  },
  {
    genesis_token_id: 3936,
    wearable_ids: [399, 331],
  },
  {
    genesis_token_id: 3937,
    wearable_ids: [289, 276],
  },
  {
    genesis_token_id: 3938,
    wearable_ids: [429, 266],
  },
  {
    genesis_token_id: 3939,
    wearable_ids: [336, 306],
  },
  {
    genesis_token_id: 3940,
    wearable_ids: [415, 319],
  },
  {
    genesis_token_id: 3941,
    wearable_ids: [389, 324],
  },
  {
    genesis_token_id: 3942,
    wearable_ids: [286, 354],
  },
  {
    genesis_token_id: 3943,
    wearable_ids: [277, 295],
  },
  {
    genesis_token_id: 3944,
    wearable_ids: [317, 352],
  },
  {
    genesis_token_id: 3945,
    wearable_ids: [384, 365],
  },
  {
    genesis_token_id: 3946,
    wearable_ids: [324, 373],
  },
  {
    genesis_token_id: 3947,
    wearable_ids: [259, 385],
  },
  {
    genesis_token_id: 3948,
    wearable_ids: [331, 260],
  },
  {
    genesis_token_id: 3949,
    wearable_ids: [384, 397],
  },
  {
    genesis_token_id: 3950,
    wearable_ids: [377, 304],
  },
  {
    genesis_token_id: 3951,
    wearable_ids: [287, 371],
  },
  {
    genesis_token_id: 3952,
    wearable_ids: [343, 291],
  },
  {
    genesis_token_id: 3953,
    wearable_ids: [383, 406],
  },
  {
    genesis_token_id: 3954,
    wearable_ids: [364, 374],
  },
  {
    genesis_token_id: 3955,
    wearable_ids: [268, 304],
  },
  {
    genesis_token_id: 3956,
    wearable_ids: [362, 395],
  },
  {
    genesis_token_id: 3957,
    wearable_ids: [415, 344],
  },
  {
    genesis_token_id: 3958,
    wearable_ids: [325, 431],
  },
  {
    genesis_token_id: 3959,
    wearable_ids: [442, 320],
  },
  {
    genesis_token_id: 3960,
    wearable_ids: [396, 418],
  },
  {
    genesis_token_id: 3961,
    wearable_ids: [432, 369],
  },
  {
    genesis_token_id: 3962,
    wearable_ids: [395, 351],
  },
  {
    genesis_token_id: 3963,
    wearable_ids: [407, 255],
  },
  {
    genesis_token_id: 3964,
    wearable_ids: [274, 288],
  },
  {
    genesis_token_id: 3965,
    wearable_ids: [399, 359],
  },
  {
    genesis_token_id: 3966,
    wearable_ids: [284, 258],
  },
  {
    genesis_token_id: 3967,
    wearable_ids: [436, 359],
  },
  {
    genesis_token_id: 3968,
    wearable_ids: [370, 442],
  },
  {
    genesis_token_id: 3969,
    wearable_ids: [363, 247],
  },
  {
    genesis_token_id: 3970,
    wearable_ids: [332, 369],
  },
  {
    genesis_token_id: 3971,
    wearable_ids: [424, 348],
  },
  {
    genesis_token_id: 3972,
    wearable_ids: [349, 286],
  },
  {
    genesis_token_id: 3973,
    wearable_ids: [347, 286],
  },
  {
    genesis_token_id: 3974,
    wearable_ids: [432, 376],
  },
  {
    genesis_token_id: 3975,
    wearable_ids: [284, 270],
  },
  {
    genesis_token_id: 3976,
    wearable_ids: [404, 424],
  },
  {
    genesis_token_id: 3977,
    wearable_ids: [400, 296],
  },
  {
    genesis_token_id: 3978,
    wearable_ids: [331, 337],
  },
  {
    genesis_token_id: 3979,
    wearable_ids: [317, 445],
  },
  {
    genesis_token_id: 3980,
    wearable_ids: [292, 302],
  },
  {
    genesis_token_id: 3981,
    wearable_ids: [256, 273],
  },
  {
    genesis_token_id: 3982,
    wearable_ids: [258, 384],
  },
  {
    genesis_token_id: 3983,
    wearable_ids: [377, 372],
  },
  {
    genesis_token_id: 3984,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 3985,
    wearable_ids: [259, 368],
  },
  {
    genesis_token_id: 3986,
    wearable_ids: [387, 336],
  },
  {
    genesis_token_id: 3987,
    wearable_ids: [278, 290],
  },
  {
    genesis_token_id: 3988,
    wearable_ids: [349, 287],
  },
  {
    genesis_token_id: 3989,
    wearable_ids: [308, 434],
  },
  {
    genesis_token_id: 3990,
    wearable_ids: [386, 287],
  },
  {
    genesis_token_id: 3991,
    wearable_ids: [277, 386],
  },
  {
    genesis_token_id: 3992,
    wearable_ids: [297, 331],
  },
  {
    genesis_token_id: 3993,
    wearable_ids: [399, 320],
  },
  {
    genesis_token_id: 3994,
    wearable_ids: [383, 376],
  },
  {
    genesis_token_id: 3995,
    wearable_ids: [316, 426],
  },
  {
    genesis_token_id: 3996,
    wearable_ids: [374, 311],
  },
  {
    genesis_token_id: 3997,
    wearable_ids: [335, 250],
  },
  {
    genesis_token_id: 3998,
    wearable_ids: [272, 383],
  },
  {
    genesis_token_id: 3999,
    wearable_ids: [348, 297],
  },
  {
    genesis_token_id: 4000,
    wearable_ids: [271, 404],
  },
  {
    genesis_token_id: 4001,
    wearable_ids: [274, 294],
  },
  {
    genesis_token_id: 4002,
    wearable_ids: [297, 407],
  },
  {
    genesis_token_id: 4003,
    wearable_ids: [376, 335],
  },
  {
    genesis_token_id: 4004,
    wearable_ids: [355, 268],
  },
  {
    genesis_token_id: 4005,
    wearable_ids: [296, 305],
  },
  {
    genesis_token_id: 4006,
    wearable_ids: [317, 336],
  },
  {
    genesis_token_id: 4007,
    wearable_ids: [375, 298],
  },
  {
    genesis_token_id: 4008,
    wearable_ids: [278, 356],
  },
  {
    genesis_token_id: 4009,
    wearable_ids: [299, 369],
  },
  {
    genesis_token_id: 4010,
    wearable_ids: [315, 286],
  },
  {
    genesis_token_id: 4011,
    wearable_ids: [428, 296],
  },
  {
    genesis_token_id: 4012,
    wearable_ids: [385, 319],
  },
  {
    genesis_token_id: 4013,
    wearable_ids: [301, 334],
  },
  {
    genesis_token_id: 4014,
    wearable_ids: [338, 353],
  },
  {
    genesis_token_id: 4015,
    wearable_ids: [400, 430],
  },
  {
    genesis_token_id: 4016,
    wearable_ids: [396, 359],
  },
  {
    genesis_token_id: 4017,
    wearable_ids: [362, 308],
  },
  {
    genesis_token_id: 4018,
    wearable_ids: [383, 384],
  },
  {
    genesis_token_id: 4019,
    wearable_ids: [342, 336],
  },
  {
    genesis_token_id: 4020,
    wearable_ids: [408, 325],
  },
  {
    genesis_token_id: 4021,
    wearable_ids: [310, 379],
  },
  {
    genesis_token_id: 4022,
    wearable_ids: [303, 395],
  },
  {
    genesis_token_id: 4023,
    wearable_ids: [351, 360],
  },
  {
    genesis_token_id: 4024,
    wearable_ids: [289, 271],
  },
  {
    genesis_token_id: 4025,
    wearable_ids: [278, 397],
  },
  {
    genesis_token_id: 4026,
    wearable_ids: [254, 371],
  },
  {
    genesis_token_id: 4027,
    wearable_ids: [258, 248],
  },
  {
    genesis_token_id: 4028,
    wearable_ids: [363, 308],
  },
  {
    genesis_token_id: 4029,
    wearable_ids: [324, 404],
  },
  {
    genesis_token_id: 4030,
    wearable_ids: [284, 425],
  },
  {
    genesis_token_id: 4031,
    wearable_ids: [425, 311],
  },
  {
    genesis_token_id: 4032,
    wearable_ids: [253, 266],
  },
  {
    genesis_token_id: 4033,
    wearable_ids: [372, 294],
  },
  {
    genesis_token_id: 4034,
    wearable_ids: [254, 443],
  },
  {
    genesis_token_id: 4035,
    wearable_ids: [336, 278],
  },
  {
    genesis_token_id: 4036,
    wearable_ids: [247, 298],
  },
  {
    genesis_token_id: 4037,
    wearable_ids: [289, 382],
  },
  {
    genesis_token_id: 4038,
    wearable_ids: [286, 409],
  },
  {
    genesis_token_id: 4039,
    wearable_ids: [270, 404],
  },
  {
    genesis_token_id: 4040,
    wearable_ids: [257, 251],
  },
  {
    genesis_token_id: 4041,
    wearable_ids: [316, 442],
  },
  {
    genesis_token_id: 4042,
    wearable_ids: [300, 325],
  },
  {
    genesis_token_id: 4043,
    wearable_ids: [254, 409],
  },
  {
    genesis_token_id: 4044,
    wearable_ids: [403, 412],
  },
  {
    genesis_token_id: 4045,
    wearable_ids: [389, 359],
  },
  {
    genesis_token_id: 4046,
    wearable_ids: [373, 258],
  },
  {
    genesis_token_id: 4047,
    wearable_ids: [413, 375],
  },
  {
    genesis_token_id: 4048,
    wearable_ids: [325, 385],
  },
  {
    genesis_token_id: 4049,
    wearable_ids: [351, 299],
  },
  {
    genesis_token_id: 4050,
    wearable_ids: [378, 409],
  },
  {
    genesis_token_id: 4051,
    wearable_ids: [304, 264],
  },
  {
    genesis_token_id: 4052,
    wearable_ids: [340, 303],
  },
  {
    genesis_token_id: 4053,
    wearable_ids: [300, 247],
  },
  {
    genesis_token_id: 4054,
    wearable_ids: [299, 372],
  },
  {
    genesis_token_id: 4055,
    wearable_ids: [396, 247],
  },
  {
    genesis_token_id: 4056,
    wearable_ids: [296, 331],
  },
  {
    genesis_token_id: 4057,
    wearable_ids: [310, 278],
  },
  {
    genesis_token_id: 4058,
    wearable_ids: [435, 308],
  },
  {
    genesis_token_id: 4059,
    wearable_ids: [429, 295],
  },
  {
    genesis_token_id: 4060,
    wearable_ids: [349, 316],
  },
  {
    genesis_token_id: 4061,
    wearable_ids: [294, 347],
  },
  {
    genesis_token_id: 4062,
    wearable_ids: [340, 317],
  },
  {
    genesis_token_id: 4063,
    wearable_ids: [255, 296],
  },
  {
    genesis_token_id: 4064,
    wearable_ids: [425, 398],
  },
  {
    genesis_token_id: 4065,
    wearable_ids: [276, 396],
  },
  {
    genesis_token_id: 4066,
    wearable_ids: [331, 408],
  },
  {
    genesis_token_id: 4067,
    wearable_ids: [347, 314],
  },
  {
    genesis_token_id: 4068,
    wearable_ids: [444, 397],
  },
  {
    genesis_token_id: 4069,
    wearable_ids: [348, 318],
  },
  {
    genesis_token_id: 4070,
    wearable_ids: [301, 272],
  },
  {
    genesis_token_id: 4071,
    wearable_ids: [386, 311],
  },
  {
    genesis_token_id: 4072,
    wearable_ids: [310, 347],
  },
  {
    genesis_token_id: 4073,
    wearable_ids: [404, 335],
  },
  {
    genesis_token_id: 4074,
    wearable_ids: [403, 283],
  },
  {
    genesis_token_id: 4075,
    wearable_ids: [431, 365],
  },
  {
    genesis_token_id: 4076,
    wearable_ids: [425, 347],
  },
  {
    genesis_token_id: 4077,
    wearable_ids: [280, 410],
  },
  {
    genesis_token_id: 4078,
    wearable_ids: [378, 326],
  },
  {
    genesis_token_id: 4079,
    wearable_ids: [278, 444],
  },
  {
    genesis_token_id: 4080,
    wearable_ids: [297, 429],
  },
  {
    genesis_token_id: 4081,
    wearable_ids: [338, 436],
  },
  {
    genesis_token_id: 4082,
    wearable_ids: [276, 292],
  },
  {
    genesis_token_id: 4083,
    wearable_ids: [375, 340],
  },
  {
    genesis_token_id: 4084,
    wearable_ids: [310, 284],
  },
  {
    genesis_token_id: 4085,
    wearable_ids: [332, 438],
  },
  {
    genesis_token_id: 4086,
    wearable_ids: [415, 398],
  },
  {
    genesis_token_id: 4087,
    wearable_ids: [389, 376],
  },
  {
    genesis_token_id: 4088,
    wearable_ids: [433, 286],
  },
  {
    genesis_token_id: 4089,
    wearable_ids: [351, 311],
  },
  {
    genesis_token_id: 4090,
    wearable_ids: [368, 263],
  },
  {
    genesis_token_id: 4091,
    wearable_ids: [347, 312],
  },
  {
    genesis_token_id: 4092,
    wearable_ids: [286, 325],
  },
  {
    genesis_token_id: 4093,
    wearable_ids: [251, 440],
  },
  {
    genesis_token_id: 4094,
    wearable_ids: [300, 399],
  },
  {
    genesis_token_id: 4095,
    wearable_ids: [336, 316],
  },
  {
    genesis_token_id: 4096,
    wearable_ids: [424, 383],
  },
  {
    genesis_token_id: 4097,
    wearable_ids: [342, 378],
  },
  {
    genesis_token_id: 4098,
    wearable_ids: [264, 376],
  },
  {
    genesis_token_id: 4099,
    wearable_ids: [304, 300],
  },
  {
    genesis_token_id: 4100,
    wearable_ids: [287, 279],
  },
  {
    genesis_token_id: 4101,
    wearable_ids: [349, 352],
  },
  {
    genesis_token_id: 4102,
    wearable_ids: [276, 345],
  },
  {
    genesis_token_id: 4103,
    wearable_ids: [434, 387],
  },
  {
    genesis_token_id: 4104,
    wearable_ids: [348, 279],
  },
  {
    genesis_token_id: 4105,
    wearable_ids: [442, 255],
  },
  {
    genesis_token_id: 4106,
    wearable_ids: [316, 385],
  },
  {
    genesis_token_id: 4107,
    wearable_ids: [348, 363],
  },
  {
    genesis_token_id: 4108,
    wearable_ids: [263, 392],
  },
  {
    genesis_token_id: 4109,
    wearable_ids: [340, 428],
  },
  {
    genesis_token_id: 4110,
    wearable_ids: [400, 437],
  },
  {
    genesis_token_id: 4111,
    wearable_ids: [436, 316],
  },
  {
    genesis_token_id: 4112,
    wearable_ids: [335, 340],
  },
  {
    genesis_token_id: 4113,
    wearable_ids: [314, 402],
  },
  {
    genesis_token_id: 4114,
    wearable_ids: [400, 272],
  },
  {
    genesis_token_id: 4115,
    wearable_ids: [336, 443],
  },
  {
    genesis_token_id: 4116,
    wearable_ids: [264, 342],
  },
  {
    genesis_token_id: 4117,
    wearable_ids: [375, 297],
  },
  {
    genesis_token_id: 4118,
    wearable_ids: [411, 317],
  },
  {
    genesis_token_id: 4119,
    wearable_ids: [336, 267],
  },
  {
    genesis_token_id: 4120,
    wearable_ids: [314, 445],
  },
  {
    genesis_token_id: 4121,
    wearable_ids: [342, 275],
  },
  {
    genesis_token_id: 4122,
    wearable_ids: [410, 259],
  },
  {
    genesis_token_id: 4123,
    wearable_ids: [382, 373],
  },
  {
    genesis_token_id: 4124,
    wearable_ids: [389, 284],
  },
  {
    genesis_token_id: 4125,
    wearable_ids: [255, 412],
  },
  {
    genesis_token_id: 4126,
    wearable_ids: [435, 405],
  },
  {
    genesis_token_id: 4127,
    wearable_ids: [425, 436],
  },
  {
    genesis_token_id: 4128,
    wearable_ids: [444, 270],
  },
  {
    genesis_token_id: 4129,
    wearable_ids: [351, 254],
  },
  {
    genesis_token_id: 4130,
    wearable_ids: [426, 397],
  },
  {
    genesis_token_id: 4131,
    wearable_ids: [253, 429],
  },
  {
    genesis_token_id: 4132,
    wearable_ids: [409, 248],
  },
  {
    genesis_token_id: 4133,
    wearable_ids: [369, 348],
  },
  {
    genesis_token_id: 4134,
    wearable_ids: [352, 274],
  },
  {
    genesis_token_id: 4135,
    wearable_ids: [422, 284],
  },
  {
    genesis_token_id: 4136,
    wearable_ids: [348, 285],
  },
  {
    genesis_token_id: 4137,
    wearable_ids: [431, 247],
  },
  {
    genesis_token_id: 4138,
    wearable_ids: [352, 426],
  },
  {
    genesis_token_id: 4139,
    wearable_ids: [373, 432],
  },
  {
    genesis_token_id: 4140,
    wearable_ids: [262, 268],
  },
  {
    genesis_token_id: 4141,
    wearable_ids: [347, 394],
  },
  {
    genesis_token_id: 4142,
    wearable_ids: [411, 387],
  },
  {
    genesis_token_id: 4143,
    wearable_ids: [399, 374],
  },
  {
    genesis_token_id: 4144,
    wearable_ids: [300, 425],
  },
  {
    genesis_token_id: 4145,
    wearable_ids: [284, 307],
  },
  {
    genesis_token_id: 4146,
    wearable_ids: [253, 272],
  },
  {
    genesis_token_id: 4147,
    wearable_ids: [319, 265],
  },
  {
    genesis_token_id: 4148,
    wearable_ids: [382, 270],
  },
  {
    genesis_token_id: 4149,
    wearable_ids: [273, 314],
  },
  {
    genesis_token_id: 4150,
    wearable_ids: [284, 332],
  },
  {
    genesis_token_id: 4151,
    wearable_ids: [276, 396],
  },
  {
    genesis_token_id: 4152,
    wearable_ids: [376, 373],
  },
  {
    genesis_token_id: 4153,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 4154,
    wearable_ids: [370, 308],
  },
  {
    genesis_token_id: 4155,
    wearable_ids: [443, 419],
  },
  {
    genesis_token_id: 4156,
    wearable_ids: [397, 384],
  },
  {
    genesis_token_id: 4157,
    wearable_ids: [337, 445],
  },
  {
    genesis_token_id: 4158,
    wearable_ids: [276, 409],
  },
  {
    genesis_token_id: 4159,
    wearable_ids: [420, 400],
  },
  {
    genesis_token_id: 4160,
    wearable_ids: [290, 391],
  },
  {
    genesis_token_id: 4161,
    wearable_ids: [258, 351],
  },
  {
    genesis_token_id: 4162,
    wearable_ids: [426, 262],
  },
  {
    genesis_token_id: 4163,
    wearable_ids: [409, 300],
  },
  {
    genesis_token_id: 4164,
    wearable_ids: [365, 413],
  },
  {
    genesis_token_id: 4165,
    wearable_ids: [346, 344],
  },
  {
    genesis_token_id: 4166,
    wearable_ids: [251, 349],
  },
  {
    genesis_token_id: 4167,
    wearable_ids: [348, 288],
  },
  {
    genesis_token_id: 4168,
    wearable_ids: [270, 404],
  },
  {
    genesis_token_id: 4169,
    wearable_ids: [311, 326],
  },
  {
    genesis_token_id: 4170,
    wearable_ids: [336, 284],
  },
  {
    genesis_token_id: 4171,
    wearable_ids: [271, 425],
  },
  {
    genesis_token_id: 4172,
    wearable_ids: [384, 266],
  },
  {
    genesis_token_id: 4173,
    wearable_ids: [433, 397],
  },
  {
    genesis_token_id: 4174,
    wearable_ids: [301, 337],
  },
  {
    genesis_token_id: 4175,
    wearable_ids: [294, 375],
  },
  {
    genesis_token_id: 4176,
    wearable_ids: [311, 286],
  },
  {
    genesis_token_id: 4177,
    wearable_ids: [317, 410],
  },
  {
    genesis_token_id: 4178,
    wearable_ids: [247, 377],
  },
  {
    genesis_token_id: 4179,
    wearable_ids: [435, 346],
  },
  {
    genesis_token_id: 4180,
    wearable_ids: [371, 306],
  },
  {
    genesis_token_id: 4181,
    wearable_ids: [286, 274],
  },
  {
    genesis_token_id: 4182,
    wearable_ids: [337, 422],
  },
  {
    genesis_token_id: 4183,
    wearable_ids: [362, 444],
  },
  {
    genesis_token_id: 4184,
    wearable_ids: [292, 412],
  },
  {
    genesis_token_id: 4185,
    wearable_ids: [349, 335],
  },
  {
    genesis_token_id: 4186,
    wearable_ids: [294, 437],
  },
  {
    genesis_token_id: 4187,
    wearable_ids: [368, 411],
  },
  {
    genesis_token_id: 4188,
    wearable_ids: [348, 428],
  },
  {
    genesis_token_id: 4189,
    wearable_ids: [436, 345],
  },
  {
    genesis_token_id: 4190,
    wearable_ids: [382, 251],
  },
  {
    genesis_token_id: 4191,
    wearable_ids: [262, 435],
  },
  {
    genesis_token_id: 4192,
    wearable_ids: [248, 284],
  },
  {
    genesis_token_id: 4193,
    wearable_ids: [319, 314],
  },
  {
    genesis_token_id: 4194,
    wearable_ids: [377, 287],
  },
  {
    genesis_token_id: 4195,
    wearable_ids: [317, 277],
  },
  {
    genesis_token_id: 4196,
    wearable_ids: [286, 358],
  },
  {
    genesis_token_id: 4197,
    wearable_ids: [354, 396],
  },
  {
    genesis_token_id: 4198,
    wearable_ids: [280, 376],
  },
  {
    genesis_token_id: 4199,
    wearable_ids: [411, 278],
  },
  {
    genesis_token_id: 4200,
    wearable_ids: [425, 412],
  },
  {
    genesis_token_id: 4201,
    wearable_ids: [340, 393],
  },
  {
    genesis_token_id: 4202,
    wearable_ids: [338, 354],
  },
  {
    genesis_token_id: 4203,
    wearable_ids: [254, 298],
  },
  {
    genesis_token_id: 4204,
    wearable_ids: [383, 248],
  },
  {
    genesis_token_id: 4205,
    wearable_ids: [284, 290],
  },
  {
    genesis_token_id: 4206,
    wearable_ids: [348, 365],
  },
  {
    genesis_token_id: 4207,
    wearable_ids: [384, 270],
  },
  {
    genesis_token_id: 4208,
    wearable_ids: [355, 295],
  },
  {
    genesis_token_id: 4209,
    wearable_ids: [257, 377],
  },
  {
    genesis_token_id: 4210,
    wearable_ids: [339, 324],
  },
  {
    genesis_token_id: 4211,
    wearable_ids: [409, 304],
  },
  {
    genesis_token_id: 4212,
    wearable_ids: [340, 393],
  },
  {
    genesis_token_id: 4213,
    wearable_ids: [332, 410],
  },
  {
    genesis_token_id: 4214,
    wearable_ids: [378, 314],
  },
  {
    genesis_token_id: 4215,
    wearable_ids: [349, 415],
  },
  {
    genesis_token_id: 4216,
    wearable_ids: [408, 259],
  },
  {
    genesis_token_id: 4217,
    wearable_ids: [363, 444],
  },
  {
    genesis_token_id: 4218,
    wearable_ids: [425, 443],
  },
  {
    genesis_token_id: 4219,
    wearable_ids: [437, 409],
  },
  {
    genesis_token_id: 4220,
    wearable_ids: [373, 436],
  },
  {
    genesis_token_id: 4221,
    wearable_ids: [369, 300],
  },
  {
    genesis_token_id: 4222,
    wearable_ids: [316, 395],
  },
  {
    genesis_token_id: 4223,
    wearable_ids: [324, 445],
  },
  {
    genesis_token_id: 4224,
    wearable_ids: [268, 297],
  },
  {
    genesis_token_id: 4225,
    wearable_ids: [331, 357],
  },
  {
    genesis_token_id: 4226,
    wearable_ids: [354, 369],
  },
  {
    genesis_token_id: 4227,
    wearable_ids: [259, 407],
  },
  {
    genesis_token_id: 4228,
    wearable_ids: [278, 356],
  },
  {
    genesis_token_id: 4229,
    wearable_ids: [340, 301],
  },
  {
    genesis_token_id: 4230,
    wearable_ids: [341, 292],
  },
  {
    genesis_token_id: 4231,
    wearable_ids: [365, 335],
  },
  {
    genesis_token_id: 4232,
    wearable_ids: [384, 323],
  },
  {
    genesis_token_id: 4233,
    wearable_ids: [429, 328],
  },
  {
    genesis_token_id: 4234,
    wearable_ids: [264, 356],
  },
  {
    genesis_token_id: 4235,
    wearable_ids: [397, 297],
  },
  {
    genesis_token_id: 4236,
    wearable_ids: [384, 251],
  },
  {
    genesis_token_id: 4237,
    wearable_ids: [287, 248],
  },
  {
    genesis_token_id: 4238,
    wearable_ids: [289, 267],
  },
  {
    genesis_token_id: 4239,
    wearable_ids: [423, 310],
  },
  {
    genesis_token_id: 4240,
    wearable_ids: [372, 273],
  },
  {
    genesis_token_id: 4241,
    wearable_ids: [340, 395],
  },
  {
    genesis_token_id: 4242,
    wearable_ids: [443, 256],
  },
  {
    genesis_token_id: 4243,
    wearable_ids: [297, 264],
  },
  {
    genesis_token_id: 4244,
    wearable_ids: [272, 278],
  },
  {
    genesis_token_id: 4245,
    wearable_ids: [274, 341],
  },
  {
    genesis_token_id: 4246,
    wearable_ids: [336, 339],
  },
  {
    genesis_token_id: 4247,
    wearable_ids: [336, 277],
  },
  {
    genesis_token_id: 4248,
    wearable_ids: [433, 378],
  },
  {
    genesis_token_id: 4249,
    wearable_ids: [368, 328],
  },
  {
    genesis_token_id: 4250,
    wearable_ids: [424, 443],
  },
  {
    genesis_token_id: 4251,
    wearable_ids: [436, 290],
  },
  {
    genesis_token_id: 4252,
    wearable_ids: [408, 263],
  },
  {
    genesis_token_id: 4253,
    wearable_ids: [338, 432],
  },
  {
    genesis_token_id: 4254,
    wearable_ids: [399, 317],
  },
  {
    genesis_token_id: 4255,
    wearable_ids: [325, 340],
  },
  {
    genesis_token_id: 4256,
    wearable_ids: [331, 277],
  },
  {
    genesis_token_id: 4257,
    wearable_ids: [372, 432],
  },
  {
    genesis_token_id: 4258,
    wearable_ids: [264, 350],
  },
  {
    genesis_token_id: 4259,
    wearable_ids: [264, 423],
  },
  {
    genesis_token_id: 4260,
    wearable_ids: [436, 399],
  },
  {
    genesis_token_id: 4261,
    wearable_ids: [332, 274],
  },
  {
    genesis_token_id: 4262,
    wearable_ids: [290, 277],
  },
  {
    genesis_token_id: 4263,
    wearable_ids: [315, 275],
  },
  {
    genesis_token_id: 4264,
    wearable_ids: [255, 269],
  },
  {
    genesis_token_id: 4265,
    wearable_ids: [373, 342],
  },
  {
    genesis_token_id: 4266,
    wearable_ids: [395, 257],
  },
  {
    genesis_token_id: 4267,
    wearable_ids: [276, 376],
  },
  {
    genesis_token_id: 4268,
    wearable_ids: [372, 383],
  },
  {
    genesis_token_id: 4269,
    wearable_ids: [423, 308],
  },
  {
    genesis_token_id: 4270,
    wearable_ids: [400, 369],
  },
  {
    genesis_token_id: 4271,
    wearable_ids: [315, 382],
  },
  {
    genesis_token_id: 4272,
    wearable_ids: [435, 247],
  },
  {
    genesis_token_id: 4273,
    wearable_ids: [354, 422],
  },
  {
    genesis_token_id: 4274,
    wearable_ids: [444, 246],
  },
  {
    genesis_token_id: 4275,
    wearable_ids: [306, 377],
  },
  {
    genesis_token_id: 4276,
    wearable_ids: [369, 395],
  },
  {
    genesis_token_id: 4277,
    wearable_ids: [301, 406],
  },
  {
    genesis_token_id: 4278,
    wearable_ids: [338, 400],
  },
  {
    genesis_token_id: 4279,
    wearable_ids: [373, 415],
  },
  {
    genesis_token_id: 4280,
    wearable_ids: [284, 311],
  },
  {
    genesis_token_id: 4281,
    wearable_ids: [270, 251],
  },
  {
    genesis_token_id: 4282,
    wearable_ids: [406, 287],
  },
  {
    genesis_token_id: 4283,
    wearable_ids: [443, 404],
  },
  {
    genesis_token_id: 4284,
    wearable_ids: [315, 438],
  },
  {
    genesis_token_id: 4285,
    wearable_ids: [310, 376],
  },
  {
    genesis_token_id: 4286,
    wearable_ids: [304, 314],
  },
  {
    genesis_token_id: 4287,
    wearable_ids: [262, 312],
  },
  {
    genesis_token_id: 4288,
    wearable_ids: [372, 331],
  },
  {
    genesis_token_id: 4289,
    wearable_ids: [354, 293],
  },
  {
    genesis_token_id: 4290,
    wearable_ids: [347, 269],
  },
  {
    genesis_token_id: 4291,
    wearable_ids: [434, 291],
  },
  {
    genesis_token_id: 4292,
    wearable_ids: [316, 430],
  },
  {
    genesis_token_id: 4293,
    wearable_ids: [428, 351],
  },
  {
    genesis_token_id: 4294,
    wearable_ids: [277, 441],
  },
  {
    genesis_token_id: 4295,
    wearable_ids: [277, 374],
  },
  {
    genesis_token_id: 4296,
    wearable_ids: [432, 342],
  },
  {
    genesis_token_id: 4297,
    wearable_ids: [383, 262],
  },
  {
    genesis_token_id: 4298,
    wearable_ids: [253, 396],
  },
  {
    genesis_token_id: 4299,
    wearable_ids: [319, 246],
  },
  {
    genesis_token_id: 4300,
    wearable_ids: [404, 420],
  },
  {
    genesis_token_id: 4301,
    wearable_ids: [291, 314],
  },
  {
    genesis_token_id: 4302,
    wearable_ids: [435, 258],
  },
  {
    genesis_token_id: 4303,
    wearable_ids: [258, 285],
  },
  {
    genesis_token_id: 4304,
    wearable_ids: [383, 268],
  },
  {
    genesis_token_id: 4305,
    wearable_ids: [382, 336],
  },
  {
    genesis_token_id: 4306,
    wearable_ids: [331, 264],
  },
  {
    genesis_token_id: 4307,
    wearable_ids: [280, 262],
  },
  {
    genesis_token_id: 4308,
    wearable_ids: [280, 424],
  },
  {
    genesis_token_id: 4309,
    wearable_ids: [315, 340],
  },
  {
    genesis_token_id: 4310,
    wearable_ids: [408, 415],
  },
  {
    genesis_token_id: 4311,
    wearable_ids: [410, 385],
  },
  {
    genesis_token_id: 4312,
    wearable_ids: [426, 296],
  },
  {
    genesis_token_id: 4313,
    wearable_ids: [376, 369],
  },
  {
    genesis_token_id: 4314,
    wearable_ids: [292, 399],
  },
  {
    genesis_token_id: 4315,
    wearable_ids: [415, 253],
  },
  {
    genesis_token_id: 4316,
    wearable_ids: [408, 310],
  },
  {
    genesis_token_id: 4317,
    wearable_ids: [354, 280],
  },
  {
    genesis_token_id: 4318,
    wearable_ids: [266, 292],
  },
  {
    genesis_token_id: 4319,
    wearable_ids: [271, 422],
  },
  {
    genesis_token_id: 4320,
    wearable_ids: [445, 424],
  },
  {
    genesis_token_id: 4321,
    wearable_ids: [382, 326],
  },
  {
    genesis_token_id: 4322,
    wearable_ids: [397, 436],
  },
  {
    genesis_token_id: 4323,
    wearable_ids: [301, 310],
  },
  {
    genesis_token_id: 4324,
    wearable_ids: [350, 401],
  },
  {
    genesis_token_id: 4325,
    wearable_ids: [444, 365],
  },
  {
    genesis_token_id: 4326,
    wearable_ids: [349, 272],
  },
  {
    genesis_token_id: 4327,
    wearable_ids: [363, 275],
  },
  {
    genesis_token_id: 4328,
    wearable_ids: [349, 311],
  },
  {
    genesis_token_id: 4329,
    wearable_ids: [364, 411],
  },
  {
    genesis_token_id: 4330,
    wearable_ids: [274, 300],
  },
  {
    genesis_token_id: 4331,
    wearable_ids: [274, 365],
  },
  {
    genesis_token_id: 4332,
    wearable_ids: [344, 279],
  },
  {
    genesis_token_id: 4333,
    wearable_ids: [435, 256],
  },
  {
    genesis_token_id: 4334,
    wearable_ids: [384, 346],
  },
  {
    genesis_token_id: 4335,
    wearable_ids: [429, 353],
  },
  {
    genesis_token_id: 4336,
    wearable_ids: [291, 383],
  },
  {
    genesis_token_id: 4337,
    wearable_ids: [354, 325],
  },
  {
    genesis_token_id: 4338,
    wearable_ids: [384, 371],
  },
  {
    genesis_token_id: 4339,
    wearable_ids: [426, 379],
  },
  {
    genesis_token_id: 4340,
    wearable_ids: [315, 247],
  },
  {
    genesis_token_id: 4341,
    wearable_ids: [368, 258],
  },
  {
    genesis_token_id: 4342,
    wearable_ids: [423, 257],
  },
  {
    genesis_token_id: 4343,
    wearable_ids: [336, 363],
  },
  {
    genesis_token_id: 4344,
    wearable_ids: [277, 343],
  },
  {
    genesis_token_id: 4345,
    wearable_ids: [415, 314],
  },
  {
    genesis_token_id: 4346,
    wearable_ids: [337, 304],
  },
  {
    genesis_token_id: 4347,
    wearable_ids: [266, 355],
  },
  {
    genesis_token_id: 4348,
    wearable_ids: [317, 409],
  },
  {
    genesis_token_id: 4349,
    wearable_ids: [433, 312],
  },
  {
    genesis_token_id: 4350,
    wearable_ids: [346, 408],
  },
  {
    genesis_token_id: 4351,
    wearable_ids: [253, 415],
  },
  {
    genesis_token_id: 4352,
    wearable_ids: [413, 295],
  },
  {
    genesis_token_id: 4353,
    wearable_ids: [396, 320],
  },
  {
    genesis_token_id: 4354,
    wearable_ids: [408, 297],
  },
  {
    genesis_token_id: 4355,
    wearable_ids: [253, 258],
  },
  {
    genesis_token_id: 4356,
    wearable_ids: [445, 354],
  },
  {
    genesis_token_id: 4357,
    wearable_ids: [289, 364],
  },
  {
    genesis_token_id: 4358,
    wearable_ids: [277, 256],
  },
  {
    genesis_token_id: 4359,
    wearable_ids: [266, 348],
  },
  {
    genesis_token_id: 4360,
    wearable_ids: [316, 372],
  },
  {
    genesis_token_id: 4361,
    wearable_ids: [407, 330],
  },
  {
    genesis_token_id: 4362,
    wearable_ids: [347, 296],
  },
  {
    genesis_token_id: 4363,
    wearable_ids: [409, 255],
  },
  {
    genesis_token_id: 4364,
    wearable_ids: [254, 343],
  },
  {
    genesis_token_id: 4365,
    wearable_ids: [248, 366],
  },
  {
    genesis_token_id: 4366,
    wearable_ids: [406, 264],
  },
  {
    genesis_token_id: 4367,
    wearable_ids: [277, 258],
  },
  {
    genesis_token_id: 4368,
    wearable_ids: [428, 281],
  },
  {
    genesis_token_id: 4369,
    wearable_ids: [335, 266],
  },
  {
    genesis_token_id: 4370,
    wearable_ids: [344, 260],
  },
  {
    genesis_token_id: 4371,
    wearable_ids: [407, 271],
  },
  {
    genesis_token_id: 4372,
    wearable_ids: [384, 264],
  },
  {
    genesis_token_id: 4373,
    wearable_ids: [375, 330],
  },
  {
    genesis_token_id: 4374,
    wearable_ids: [406, 420],
  },
  {
    genesis_token_id: 4375,
    wearable_ids: [413, 255],
  },
  {
    genesis_token_id: 4376,
    wearable_ids: [385, 373],
  },
  {
    genesis_token_id: 4377,
    wearable_ids: [331, 258],
  },
  {
    genesis_token_id: 4378,
    wearable_ids: [340, 382],
  },
  {
    genesis_token_id: 4379,
    wearable_ids: [266, 317],
  },
  {
    genesis_token_id: 4380,
    wearable_ids: [257, 377],
  },
  {
    genesis_token_id: 4381,
    wearable_ids: [314, 373],
  },
  {
    genesis_token_id: 4382,
    wearable_ids: [259, 327],
  },
  {
    genesis_token_id: 4383,
    wearable_ids: [292, 408],
  },
  {
    genesis_token_id: 4384,
    wearable_ids: [342, 354],
  },
  {
    genesis_token_id: 4385,
    wearable_ids: [369, 364],
  },
  {
    genesis_token_id: 4386,
    wearable_ids: [319, 371],
  },
  {
    genesis_token_id: 4387,
    wearable_ids: [343, 344],
  },
  {
    genesis_token_id: 4388,
    wearable_ids: [280, 364],
  },
  {
    genesis_token_id: 4389,
    wearable_ids: [352, 384],
  },
  {
    genesis_token_id: 4390,
    wearable_ids: [347, 308],
  },
  {
    genesis_token_id: 4391,
    wearable_ids: [278, 437],
  },
  {
    genesis_token_id: 4392,
    wearable_ids: [306, 349],
  },
  {
    genesis_token_id: 4393,
    wearable_ids: [369, 306],
  },
  {
    genesis_token_id: 4394,
    wearable_ids: [264, 382],
  },
  {
    genesis_token_id: 4395,
    wearable_ids: [365, 433],
  },
  {
    genesis_token_id: 4396,
    wearable_ids: [408, 308],
  },
  {
    genesis_token_id: 4397,
    wearable_ids: [336, 445],
  },
  {
    genesis_token_id: 4398,
    wearable_ids: [280, 250],
  },
  {
    genesis_token_id: 4399,
    wearable_ids: [311, 341],
  },
  {
    genesis_token_id: 4400,
    wearable_ids: [325, 274],
  },
  {
    genesis_token_id: 4401,
    wearable_ids: [295, 429],
  },
  {
    genesis_token_id: 4402,
    wearable_ids: [274, 260],
  },
  {
    genesis_token_id: 4403,
    wearable_ids: [286, 391],
  },
  {
    genesis_token_id: 4404,
    wearable_ids: [337, 410],
  },
  {
    genesis_token_id: 4405,
    wearable_ids: [409, 332],
  },
  {
    genesis_token_id: 4406,
    wearable_ids: [408, 425],
  },
  {
    genesis_token_id: 4407,
    wearable_ids: [310, 268],
  },
  {
    genesis_token_id: 4408,
    wearable_ids: [376, 278],
  },
  {
    genesis_token_id: 4409,
    wearable_ids: [363, 362],
  },
  {
    genesis_token_id: 4410,
    wearable_ids: [303, 428],
  },
  {
    genesis_token_id: 4411,
    wearable_ids: [287, 387],
  },
  {
    genesis_token_id: 4412,
    wearable_ids: [374, 415],
  },
  {
    genesis_token_id: 4413,
    wearable_ids: [355, 383],
  },
  {
    genesis_token_id: 4414,
    wearable_ids: [403, 416],
  },
  {
    genesis_token_id: 4415,
    wearable_ids: [315, 347],
  },
  {
    genesis_token_id: 4416,
    wearable_ids: [268, 332],
  },
  {
    genesis_token_id: 4417,
    wearable_ids: [374, 277],
  },
  {
    genesis_token_id: 4418,
    wearable_ids: [256, 389],
  },
  {
    genesis_token_id: 4419,
    wearable_ids: [284, 265],
  },
  {
    genesis_token_id: 4420,
    wearable_ids: [247, 412],
  },
  {
    genesis_token_id: 4421,
    wearable_ids: [435, 254],
  },
  {
    genesis_token_id: 4422,
    wearable_ids: [352, 287],
  },
  {
    genesis_token_id: 4423,
    wearable_ids: [434, 409],
  },
  {
    genesis_token_id: 4424,
    wearable_ids: [396, 291],
  },
  {
    genesis_token_id: 4425,
    wearable_ids: [294, 304],
  },
  {
    genesis_token_id: 4426,
    wearable_ids: [326, 384],
  },
  {
    genesis_token_id: 4427,
    wearable_ids: [354, 331],
  },
  {
    genesis_token_id: 4428,
    wearable_ids: [300, 348],
  },
  {
    genesis_token_id: 4429,
    wearable_ids: [297, 438],
  },
  {
    genesis_token_id: 4430,
    wearable_ids: [278, 280],
  },
  {
    genesis_token_id: 4431,
    wearable_ids: [251, 266],
  },
  {
    genesis_token_id: 4432,
    wearable_ids: [407, 275],
  },
  {
    genesis_token_id: 4433,
    wearable_ids: [271, 260],
  },
  {
    genesis_token_id: 4434,
    wearable_ids: [344, 280],
  },
  {
    genesis_token_id: 4435,
    wearable_ids: [445, 433],
  },
  {
    genesis_token_id: 4436,
    wearable_ids: [375, 385],
  },
  {
    genesis_token_id: 4437,
    wearable_ids: [325, 316],
  },
  {
    genesis_token_id: 4438,
    wearable_ids: [303, 413],
  },
  {
    genesis_token_id: 4439,
    wearable_ids: [325, 444],
  },
  {
    genesis_token_id: 4440,
    wearable_ids: [303, 338],
  },
  {
    genesis_token_id: 4441,
    wearable_ids: [364, 250],
  },
  {
    genesis_token_id: 4442,
    wearable_ids: [265, 342],
  },
  {
    genesis_token_id: 4443,
    wearable_ids: [254, 407],
  },
  {
    genesis_token_id: 4444,
    wearable_ids: [385, 412],
  },
  {
    genesis_token_id: 4445,
    wearable_ids: [363, 384],
  },
  {
    genesis_token_id: 4446,
    wearable_ids: [253, 273],
  },
  {
    genesis_token_id: 4447,
    wearable_ids: [387, 271],
  },
  {
    genesis_token_id: 4448,
    wearable_ids: [399, 284],
  },
  {
    genesis_token_id: 4449,
    wearable_ids: [316, 350],
  },
  {
    genesis_token_id: 4450,
    wearable_ids: [406, 272],
  },
  {
    genesis_token_id: 4451,
    wearable_ids: [344, 297],
  },
  {
    genesis_token_id: 4452,
    wearable_ids: [377, 378],
  },
  {
    genesis_token_id: 4453,
    wearable_ids: [370, 409],
  },
  {
    genesis_token_id: 4454,
    wearable_ids: [355, 341],
  },
  {
    genesis_token_id: 4455,
    wearable_ids: [292, 437],
  },
  {
    genesis_token_id: 4456,
    wearable_ids: [426, 419],
  },
  {
    genesis_token_id: 4457,
    wearable_ids: [374, 346],
  },
  {
    genesis_token_id: 4458,
    wearable_ids: [445, 298],
  },
  {
    genesis_token_id: 4459,
    wearable_ids: [319, 342],
  },
  {
    genesis_token_id: 4460,
    wearable_ids: [332, 359],
  },
  {
    genesis_token_id: 4461,
    wearable_ids: [434, 254],
  },
  {
    genesis_token_id: 4462,
    wearable_ids: [403, 413],
  },
  {
    genesis_token_id: 4463,
    wearable_ids: [389, 397],
  },
  {
    genesis_token_id: 4464,
    wearable_ids: [396, 408],
  },
  {
    genesis_token_id: 4465,
    wearable_ids: [397, 377],
  },
  {
    genesis_token_id: 4466,
    wearable_ids: [257, 375],
  },
  {
    genesis_token_id: 4467,
    wearable_ids: [296, 319],
  },
  {
    genesis_token_id: 4468,
    wearable_ids: [254, 377],
  },
  {
    genesis_token_id: 4469,
    wearable_ids: [443, 376],
  },
  {
    genesis_token_id: 4470,
    wearable_ids: [437, 429],
  },
  {
    genesis_token_id: 4471,
    wearable_ids: [422, 382],
  },
  {
    genesis_token_id: 4472,
    wearable_ids: [404, 319],
  },
  {
    genesis_token_id: 4473,
    wearable_ids: [385, 297],
  },
  {
    genesis_token_id: 4474,
    wearable_ids: [326, 249],
  },
  {
    genesis_token_id: 4475,
    wearable_ids: [326, 259],
  },
  {
    genesis_token_id: 4476,
    wearable_ids: [314, 415],
  },
  {
    genesis_token_id: 4477,
    wearable_ids: [424, 248],
  },
  {
    genesis_token_id: 4478,
    wearable_ids: [294, 275],
  },
  {
    genesis_token_id: 4479,
    wearable_ids: [435, 248],
  },
  {
    genesis_token_id: 4480,
    wearable_ids: [349, 348],
  },
  {
    genesis_token_id: 4481,
    wearable_ids: [354, 356],
  },
  {
    genesis_token_id: 4482,
    wearable_ids: [413, 388],
  },
  {
    genesis_token_id: 4483,
    wearable_ids: [341, 270],
  },
  {
    genesis_token_id: 4484,
    wearable_ids: [247, 255],
  },
  {
    genesis_token_id: 4485,
    wearable_ids: [292, 384],
  },
  {
    genesis_token_id: 4486,
    wearable_ids: [443, 315],
  },
  {
    genesis_token_id: 4487,
    wearable_ids: [412, 375],
  },
  {
    genesis_token_id: 4488,
    wearable_ids: [335, 347],
  },
  {
    genesis_token_id: 4489,
    wearable_ids: [364, 409],
  },
  {
    genesis_token_id: 4490,
    wearable_ids: [375, 403],
  },
  {
    genesis_token_id: 4491,
    wearable_ids: [425, 410],
  },
  {
    genesis_token_id: 4492,
    wearable_ids: [349, 379],
  },
  {
    genesis_token_id: 4493,
    wearable_ids: [340, 408],
  },
  {
    genesis_token_id: 4494,
    wearable_ids: [347, 445],
  },
  {
    genesis_token_id: 4495,
    wearable_ids: [331, 435],
  },
  {
    genesis_token_id: 4496,
    wearable_ids: [317, 316],
  },
  {
    genesis_token_id: 4497,
    wearable_ids: [274, 311],
  },
  {
    genesis_token_id: 4498,
    wearable_ids: [422, 416],
  },
  {
    genesis_token_id: 4499,
    wearable_ids: [339, 272],
  },
  {
    genesis_token_id: 4500,
    wearable_ids: [424, 302],
  },
  {
    genesis_token_id: 4501,
    wearable_ids: [347, 268],
  },
  {
    genesis_token_id: 4502,
    wearable_ids: [413, 277],
  },
  {
    genesis_token_id: 4503,
    wearable_ids: [272, 395],
  },
  {
    genesis_token_id: 4504,
    wearable_ids: [382, 274],
  },
  {
    genesis_token_id: 4505,
    wearable_ids: [425, 368],
  },
  {
    genesis_token_id: 4506,
    wearable_ids: [273, 253],
  },
  {
    genesis_token_id: 4507,
    wearable_ids: [325, 351],
  },
  {
    genesis_token_id: 4508,
    wearable_ids: [365, 416],
  },
  {
    genesis_token_id: 4509,
    wearable_ids: [429, 440],
  },
  {
    genesis_token_id: 4510,
    wearable_ids: [297, 324],
  },
  {
    genesis_token_id: 4511,
    wearable_ids: [377, 272],
  },
  {
    genesis_token_id: 4512,
    wearable_ids: [291, 278],
  },
  {
    genesis_token_id: 4513,
    wearable_ids: [337, 318],
  },
  {
    genesis_token_id: 4514,
    wearable_ids: [387, 343],
  },
  {
    genesis_token_id: 4515,
    wearable_ids: [332, 263],
  },
  {
    genesis_token_id: 4516,
    wearable_ids: [258, 412],
  },
  {
    genesis_token_id: 4517,
    wearable_ids: [362, 359],
  },
  {
    genesis_token_id: 4518,
    wearable_ids: [435, 312],
  },
  {
    genesis_token_id: 4519,
    wearable_ids: [370, 406],
  },
  {
    genesis_token_id: 4520,
    wearable_ids: [396, 306],
  },
  {
    genesis_token_id: 4521,
    wearable_ids: [403, 441],
  },
  {
    genesis_token_id: 4522,
    wearable_ids: [342, 260],
  },
  {
    genesis_token_id: 4523,
    wearable_ids: [265, 350],
  },
  {
    genesis_token_id: 4524,
    wearable_ids: [375, 429],
  },
  {
    genesis_token_id: 4525,
    wearable_ids: [444, 358],
  },
  {
    genesis_token_id: 4526,
    wearable_ids: [308, 317],
  },
  {
    genesis_token_id: 4527,
    wearable_ids: [301, 346],
  },
  {
    genesis_token_id: 4528,
    wearable_ids: [420, 294],
  },
  {
    genesis_token_id: 4529,
    wearable_ids: [266, 304],
  },
  {
    genesis_token_id: 4530,
    wearable_ids: [362, 352],
  },
  {
    genesis_token_id: 4531,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 4532,
    wearable_ids: [251, 357],
  },
  {
    genesis_token_id: 4533,
    wearable_ids: [434, 271],
  },
  {
    genesis_token_id: 4534,
    wearable_ids: [403, 413],
  },
  {
    genesis_token_id: 4535,
    wearable_ids: [300, 436],
  },
  {
    genesis_token_id: 4536,
    wearable_ids: [408, 411],
  },
  {
    genesis_token_id: 4537,
    wearable_ids: [437, 417],
  },
  {
    genesis_token_id: 4538,
    wearable_ids: [338, 274],
  },
  {
    genesis_token_id: 4539,
    wearable_ids: [429, 335],
  },
  {
    genesis_token_id: 4540,
    wearable_ids: [300, 265],
  },
  {
    genesis_token_id: 4541,
    wearable_ids: [325, 422],
  },
  {
    genesis_token_id: 4542,
    wearable_ids: [287, 422],
  },
  {
    genesis_token_id: 4543,
    wearable_ids: [296, 253],
  },
  {
    genesis_token_id: 4544,
    wearable_ids: [443, 368],
  },
  {
    genesis_token_id: 4545,
    wearable_ids: [338, 356],
  },
  {
    genesis_token_id: 4546,
    wearable_ids: [326, 285],
  },
  {
    genesis_token_id: 4547,
    wearable_ids: [264, 292],
  },
  {
    genesis_token_id: 4548,
    wearable_ids: [407, 363],
  },
  {
    genesis_token_id: 4549,
    wearable_ids: [387, 354],
  },
  {
    genesis_token_id: 4550,
    wearable_ids: [437, 434],
  },
  {
    genesis_token_id: 4551,
    wearable_ids: [383, 263],
  },
  {
    genesis_token_id: 4552,
    wearable_ids: [375, 408],
  },
  {
    genesis_token_id: 4553,
    wearable_ids: [437, 285],
  },
  {
    genesis_token_id: 4554,
    wearable_ids: [348, 424],
  },
  {
    genesis_token_id: 4555,
    wearable_ids: [377, 366],
  },
  {
    genesis_token_id: 4556,
    wearable_ids: [415, 388],
  },
  {
    genesis_token_id: 4557,
    wearable_ids: [326, 348],
  },
  {
    genesis_token_id: 4558,
    wearable_ids: [326, 372],
  },
  {
    genesis_token_id: 4559,
    wearable_ids: [413, 274],
  },
  {
    genesis_token_id: 4560,
    wearable_ids: [337, 429],
  },
  {
    genesis_token_id: 4561,
    wearable_ids: [331, 365],
  },
  {
    genesis_token_id: 4562,
    wearable_ids: [314, 406],
  },
  {
    genesis_token_id: 4563,
    wearable_ids: [264, 265],
  },
  {
    genesis_token_id: 4564,
    wearable_ids: [362, 324],
  },
  {
    genesis_token_id: 4565,
    wearable_ids: [310, 308],
  },
  {
    genesis_token_id: 4566,
    wearable_ids: [435, 255],
  },
  {
    genesis_token_id: 4567,
    wearable_ids: [365, 378],
  },
  {
    genesis_token_id: 4568,
    wearable_ids: [259, 440],
  },
  {
    genesis_token_id: 4569,
    wearable_ids: [382, 303],
  },
  {
    genesis_token_id: 4570,
    wearable_ids: [382, 376],
  },
  {
    genesis_token_id: 4571,
    wearable_ids: [300, 299],
  },
  {
    genesis_token_id: 4572,
    wearable_ids: [257, 278],
  },
  {
    genesis_token_id: 4573,
    wearable_ids: [349, 266],
  },
  {
    genesis_token_id: 4574,
    wearable_ids: [403, 326],
  },
  {
    genesis_token_id: 4575,
    wearable_ids: [270, 370],
  },
  {
    genesis_token_id: 4576,
    wearable_ids: [346, 246],
  },
  {
    genesis_token_id: 4577,
    wearable_ids: [300, 278],
  },
  {
    genesis_token_id: 4578,
    wearable_ids: [434, 399],
  },
  {
    genesis_token_id: 4579,
    wearable_ids: [268, 396],
  },
  {
    genesis_token_id: 4580,
    wearable_ids: [314, 418],
  },
  {
    genesis_token_id: 4581,
    wearable_ids: [343, 409],
  },
  {
    genesis_token_id: 4582,
    wearable_ids: [248, 442],
  },
  {
    genesis_token_id: 4583,
    wearable_ids: [378, 280],
  },
  {
    genesis_token_id: 4584,
    wearable_ids: [266, 305],
  },
  {
    genesis_token_id: 4585,
    wearable_ids: [435, 387],
  },
  {
    genesis_token_id: 4586,
    wearable_ids: [263, 365],
  },
  {
    genesis_token_id: 4587,
    wearable_ids: [272, 425],
  },
  {
    genesis_token_id: 4588,
    wearable_ids: [274, 280],
  },
  {
    genesis_token_id: 4589,
    wearable_ids: [304, 317],
  },
  {
    genesis_token_id: 4590,
    wearable_ids: [415, 406],
  },
  {
    genesis_token_id: 4591,
    wearable_ids: [372, 385],
  },
  {
    genesis_token_id: 4592,
    wearable_ids: [258, 265],
  },
  {
    genesis_token_id: 4593,
    wearable_ids: [286, 308],
  },
  {
    genesis_token_id: 4594,
    wearable_ids: [276, 377],
  },
  {
    genesis_token_id: 4595,
    wearable_ids: [343, 355],
  },
  {
    genesis_token_id: 4596,
    wearable_ids: [292, 444],
  },
  {
    genesis_token_id: 4597,
    wearable_ids: [403, 284],
  },
  {
    genesis_token_id: 4598,
    wearable_ids: [258, 346],
  },
  {
    genesis_token_id: 4599,
    wearable_ids: [375, 365],
  },
  {
    genesis_token_id: 4600,
    wearable_ids: [420, 300],
  },
  {
    genesis_token_id: 4601,
    wearable_ids: [350, 335],
  },
  {
    genesis_token_id: 4602,
    wearable_ids: [306, 317],
  },
  {
    genesis_token_id: 4603,
    wearable_ids: [444, 360],
  },
  {
    genesis_token_id: 4604,
    wearable_ids: [404, 295],
  },
  {
    genesis_token_id: 4605,
    wearable_ids: [268, 386],
  },
  {
    genesis_token_id: 4606,
    wearable_ids: [386, 395],
  },
  {
    genesis_token_id: 4607,
    wearable_ids: [268, 295],
  },
  {
    genesis_token_id: 4608,
    wearable_ids: [344, 325],
  },
  {
    genesis_token_id: 4609,
    wearable_ids: [289, 371],
  },
  {
    genesis_token_id: 4610,
    wearable_ids: [434, 384],
  },
  {
    genesis_token_id: 4611,
    wearable_ids: [406, 410],
  },
  {
    genesis_token_id: 4612,
    wearable_ids: [406, 374],
  },
  {
    genesis_token_id: 4613,
    wearable_ids: [370, 352],
  },
  {
    genesis_token_id: 4614,
    wearable_ids: [383, 255],
  },
  {
    genesis_token_id: 4615,
    wearable_ids: [368, 361],
  },
  {
    genesis_token_id: 4616,
    wearable_ids: [386, 397],
  },
  {
    genesis_token_id: 4617,
    wearable_ids: [287, 400],
  },
  {
    genesis_token_id: 4618,
    wearable_ids: [270, 396],
  },
  {
    genesis_token_id: 4619,
    wearable_ids: [306, 263],
  },
  {
    genesis_token_id: 4620,
    wearable_ids: [368, 384],
  },
  {
    genesis_token_id: 4621,
    wearable_ids: [425, 342],
  },
  {
    genesis_token_id: 4622,
    wearable_ids: [259, 404],
  },
  {
    genesis_token_id: 4623,
    wearable_ids: [300, 350],
  },
  {
    genesis_token_id: 4624,
    wearable_ids: [280, 424],
  },
  {
    genesis_token_id: 4625,
    wearable_ids: [324, 393],
  },
  {
    genesis_token_id: 4626,
    wearable_ids: [376, 400],
  },
  {
    genesis_token_id: 4627,
    wearable_ids: [299, 332],
  },
  {
    genesis_token_id: 4628,
    wearable_ids: [314, 326],
  },
  {
    genesis_token_id: 4629,
    wearable_ids: [374, 436],
  },
  {
    genesis_token_id: 4630,
    wearable_ids: [337, 294],
  },
  {
    genesis_token_id: 4631,
    wearable_ids: [350, 434],
  },
  {
    genesis_token_id: 4632,
    wearable_ids: [286, 403],
  },
  {
    genesis_token_id: 4633,
    wearable_ids: [364, 293],
  },
  {
    genesis_token_id: 4634,
    wearable_ids: [364, 435],
  },
  {
    genesis_token_id: 4635,
    wearable_ids: [299, 271],
  },
  {
    genesis_token_id: 4636,
    wearable_ids: [377, 286],
  },
  {
    genesis_token_id: 4637,
    wearable_ids: [273, 396],
  },
  {
    genesis_token_id: 4638,
    wearable_ids: [375, 374],
  },
  {
    genesis_token_id: 4639,
    wearable_ids: [355, 324],
  },
  {
    genesis_token_id: 4640,
    wearable_ids: [352, 272],
  },
  {
    genesis_token_id: 4641,
    wearable_ids: [317, 303],
  },
  {
    genesis_token_id: 4642,
    wearable_ids: [425, 368],
  },
  {
    genesis_token_id: 4643,
    wearable_ids: [389, 331],
  },
  {
    genesis_token_id: 4644,
    wearable_ids: [411, 383],
  },
  {
    genesis_token_id: 4645,
    wearable_ids: [251, 272],
  },
  {
    genesis_token_id: 4646,
    wearable_ids: [294, 301],
  },
  {
    genesis_token_id: 4647,
    wearable_ids: [310, 405],
  },
  {
    genesis_token_id: 4648,
    wearable_ids: [355, 375],
  },
  {
    genesis_token_id: 4649,
    wearable_ids: [443, 409],
  },
  {
    genesis_token_id: 4650,
    wearable_ids: [284, 330],
  },
  {
    genesis_token_id: 4651,
    wearable_ids: [436, 281],
  },
  {
    genesis_token_id: 4652,
    wearable_ids: [434, 357],
  },
  {
    genesis_token_id: 4653,
    wearable_ids: [429, 427],
  },
  {
    genesis_token_id: 4654,
    wearable_ids: [389, 287],
  },
  {
    genesis_token_id: 4655,
    wearable_ids: [395, 304],
  },
  {
    genesis_token_id: 4656,
    wearable_ids: [324, 314],
  },
  {
    genesis_token_id: 4657,
    wearable_ids: [331, 256],
  },
  {
    genesis_token_id: 4658,
    wearable_ids: [407, 393],
  },
  {
    genesis_token_id: 4659,
    wearable_ids: [276, 349],
  },
  {
    genesis_token_id: 4660,
    wearable_ids: [354, 303],
  },
  {
    genesis_token_id: 4661,
    wearable_ids: [287, 403],
  },
  {
    genesis_token_id: 4662,
    wearable_ids: [311, 253],
  },
  {
    genesis_token_id: 4663,
    wearable_ids: [383, 373],
  },
  {
    genesis_token_id: 4664,
    wearable_ids: [426, 265],
  },
  {
    genesis_token_id: 4665,
    wearable_ids: [386, 319],
  },
  {
    genesis_token_id: 4666,
    wearable_ids: [423, 284],
  },
  {
    genesis_token_id: 4667,
    wearable_ids: [442, 248],
  },
  {
    genesis_token_id: 4668,
    wearable_ids: [262, 270],
  },
  {
    genesis_token_id: 4669,
    wearable_ids: [299, 293],
  },
  {
    genesis_token_id: 4670,
    wearable_ids: [432, 396],
  },
  {
    genesis_token_id: 4671,
    wearable_ids: [319, 429],
  },
  {
    genesis_token_id: 4672,
    wearable_ids: [424, 335],
  },
  {
    genesis_token_id: 4673,
    wearable_ids: [341, 413],
  },
  {
    genesis_token_id: 4674,
    wearable_ids: [415, 442],
  },
  {
    genesis_token_id: 4675,
    wearable_ids: [444, 265],
  },
  {
    genesis_token_id: 4676,
    wearable_ids: [444, 316],
  },
  {
    genesis_token_id: 4677,
    wearable_ids: [420, 409],
  },
  {
    genesis_token_id: 4678,
    wearable_ids: [316, 444],
  },
  {
    genesis_token_id: 4679,
    wearable_ids: [301, 404],
  },
  {
    genesis_token_id: 4680,
    wearable_ids: [343, 357],
  },
  {
    genesis_token_id: 4681,
    wearable_ids: [337, 386],
  },
  {
    genesis_token_id: 4682,
    wearable_ids: [372, 397],
  },
  {
    genesis_token_id: 4683,
    wearable_ids: [277, 336],
  },
  {
    genesis_token_id: 4684,
    wearable_ids: [289, 276],
  },
  {
    genesis_token_id: 4685,
    wearable_ids: [352, 303],
  },
  {
    genesis_token_id: 4686,
    wearable_ids: [265, 311],
  },
  {
    genesis_token_id: 4687,
    wearable_ids: [255, 431],
  },
  {
    genesis_token_id: 4688,
    wearable_ids: [287, 442],
  },
  {
    genesis_token_id: 4689,
    wearable_ids: [272, 263],
  },
  {
    genesis_token_id: 4690,
    wearable_ids: [364, 268],
  },
  {
    genesis_token_id: 4691,
    wearable_ids: [445, 412],
  },
  {
    genesis_token_id: 4692,
    wearable_ids: [428, 444],
  },
  {
    genesis_token_id: 4693,
    wearable_ids: [319, 387],
  },
  {
    genesis_token_id: 4694,
    wearable_ids: [400, 445],
  },
  {
    genesis_token_id: 4695,
    wearable_ids: [410, 277],
  },
  {
    genesis_token_id: 4696,
    wearable_ids: [271, 270],
  },
  {
    genesis_token_id: 4697,
    wearable_ids: [311, 274],
  },
  {
    genesis_token_id: 4698,
    wearable_ids: [297, 371],
  },
  {
    genesis_token_id: 4699,
    wearable_ids: [344, 423],
  },
  {
    genesis_token_id: 4700,
    wearable_ids: [248, 296],
  },
  {
    genesis_token_id: 4701,
    wearable_ids: [368, 255],
  },
  {
    genesis_token_id: 4702,
    wearable_ids: [406, 347],
  },
  {
    genesis_token_id: 4703,
    wearable_ids: [412, 262],
  },
  {
    genesis_token_id: 4704,
    wearable_ids: [389, 286],
  },
  {
    genesis_token_id: 4705,
    wearable_ids: [411, 315],
  },
  {
    genesis_token_id: 4706,
    wearable_ids: [297, 277],
  },
  {
    genesis_token_id: 4707,
    wearable_ids: [247, 413],
  },
  {
    genesis_token_id: 4708,
    wearable_ids: [266, 273],
  },
  {
    genesis_token_id: 4709,
    wearable_ids: [420, 337],
  },
  {
    genesis_token_id: 4710,
    wearable_ids: [248, 338],
  },
  {
    genesis_token_id: 4711,
    wearable_ids: [317, 411],
  },
  {
    genesis_token_id: 4712,
    wearable_ids: [428, 437],
  },
  {
    genesis_token_id: 4713,
    wearable_ids: [324, 430],
  },
  {
    genesis_token_id: 4714,
    wearable_ids: [300, 284],
  },
  {
    genesis_token_id: 4715,
    wearable_ids: [370, 343],
  },
  {
    genesis_token_id: 4716,
    wearable_ids: [255, 279],
  },
  {
    genesis_token_id: 4717,
    wearable_ids: [270, 274],
  },
  {
    genesis_token_id: 4718,
    wearable_ids: [426, 262],
  },
  {
    genesis_token_id: 4719,
    wearable_ids: [415, 435],
  },
  {
    genesis_token_id: 4720,
    wearable_ids: [382, 339],
  },
  {
    genesis_token_id: 4721,
    wearable_ids: [316, 291],
  },
  {
    genesis_token_id: 4722,
    wearable_ids: [425, 301],
  },
  {
    genesis_token_id: 4723,
    wearable_ids: [387, 440],
  },
  {
    genesis_token_id: 4724,
    wearable_ids: [407, 254],
  },
  {
    genesis_token_id: 4725,
    wearable_ids: [326, 428],
  },
  {
    genesis_token_id: 4726,
    wearable_ids: [304, 361],
  },
  {
    genesis_token_id: 4727,
    wearable_ids: [350, 303],
  },
  {
    genesis_token_id: 4728,
    wearable_ids: [248, 362],
  },
  {
    genesis_token_id: 4729,
    wearable_ids: [355, 296],
  },
  {
    genesis_token_id: 4730,
    wearable_ids: [404, 428],
  },
  {
    genesis_token_id: 4731,
    wearable_ids: [325, 422],
  },
  {
    genesis_token_id: 4732,
    wearable_ids: [422, 283],
  },
  {
    genesis_token_id: 4733,
    wearable_ids: [347, 247],
  },
  {
    genesis_token_id: 4734,
    wearable_ids: [436, 280],
  },
  {
    genesis_token_id: 4735,
    wearable_ids: [364, 348],
  },
  {
    genesis_token_id: 4736,
    wearable_ids: [374, 272],
  },
  {
    genesis_token_id: 4737,
    wearable_ids: [295, 438],
  },
  {
    genesis_token_id: 4738,
    wearable_ids: [434, 356],
  },
  {
    genesis_token_id: 4739,
    wearable_ids: [383, 445],
  },
  {
    genesis_token_id: 4740,
    wearable_ids: [369, 339],
  },
  {
    genesis_token_id: 4741,
    wearable_ids: [383, 429],
  },
  {
    genesis_token_id: 4742,
    wearable_ids: [406, 257],
  },
  {
    genesis_token_id: 4743,
    wearable_ids: [306, 366],
  },
  {
    genesis_token_id: 4744,
    wearable_ids: [386, 408],
  },
  {
    genesis_token_id: 4745,
    wearable_ids: [290, 295],
  },
  {
    genesis_token_id: 4746,
    wearable_ids: [412, 258],
  },
  {
    genesis_token_id: 4747,
    wearable_ids: [264, 335],
  },
  {
    genesis_token_id: 4748,
    wearable_ids: [315, 383],
  },
  {
    genesis_token_id: 4749,
    wearable_ids: [411, 382],
  },
  {
    genesis_token_id: 4750,
    wearable_ids: [314, 279],
  },
  {
    genesis_token_id: 4751,
    wearable_ids: [378, 415],
  },
  {
    genesis_token_id: 4752,
    wearable_ids: [434, 444],
  },
  {
    genesis_token_id: 4753,
    wearable_ids: [301, 300],
  },
  {
    genesis_token_id: 4754,
    wearable_ids: [301, 363],
  },
  {
    genesis_token_id: 4755,
    wearable_ids: [346, 412],
  },
  {
    genesis_token_id: 4756,
    wearable_ids: [382, 257],
  },
  {
    genesis_token_id: 4757,
    wearable_ids: [306, 441],
  },
  {
    genesis_token_id: 4758,
    wearable_ids: [389, 435],
  },
  {
    genesis_token_id: 4759,
    wearable_ids: [255, 316],
  },
  {
    genesis_token_id: 4760,
    wearable_ids: [339, 277],
  },
  {
    genesis_token_id: 4761,
    wearable_ids: [336, 377],
  },
  {
    genesis_token_id: 4762,
    wearable_ids: [408, 261],
  },
  {
    genesis_token_id: 4763,
    wearable_ids: [423, 385],
  },
  {
    genesis_token_id: 4764,
    wearable_ids: [319, 246],
  },
  {
    genesis_token_id: 4765,
    wearable_ids: [369, 403],
  },
  {
    genesis_token_id: 4766,
    wearable_ids: [319, 341],
  },
  {
    genesis_token_id: 4767,
    wearable_ids: [341, 262],
  },
  {
    genesis_token_id: 4768,
    wearable_ids: [289, 260],
  },
  {
    genesis_token_id: 4769,
    wearable_ids: [442, 268],
  },
  {
    genesis_token_id: 4770,
    wearable_ids: [276, 423],
  },
  {
    genesis_token_id: 4771,
    wearable_ids: [286, 445],
  },
  {
    genesis_token_id: 4772,
    wearable_ids: [331, 445],
  },
  {
    genesis_token_id: 4773,
    wearable_ids: [254, 405],
  },
  {
    genesis_token_id: 4774,
    wearable_ids: [444, 404],
  },
  {
    genesis_token_id: 4775,
    wearable_ids: [289, 397],
  },
  {
    genesis_token_id: 4776,
    wearable_ids: [259, 354],
  },
  {
    genesis_token_id: 4777,
    wearable_ids: [308, 274],
  },
  {
    genesis_token_id: 4778,
    wearable_ids: [303, 254],
  },
  {
    genesis_token_id: 4779,
    wearable_ids: [287, 435],
  },
  {
    genesis_token_id: 4780,
    wearable_ids: [341, 344],
  },
  {
    genesis_token_id: 4781,
    wearable_ids: [369, 319],
  },
  {
    genesis_token_id: 4782,
    wearable_ids: [433, 391],
  },
  {
    genesis_token_id: 4783,
    wearable_ids: [291, 433],
  },
  {
    genesis_token_id: 4784,
    wearable_ids: [373, 289],
  },
  {
    genesis_token_id: 4785,
    wearable_ids: [344, 370],
  },
  {
    genesis_token_id: 4786,
    wearable_ids: [341, 414],
  },
  {
    genesis_token_id: 4787,
    wearable_ids: [443, 371],
  },
  {
    genesis_token_id: 4788,
    wearable_ids: [326, 258],
  },
  {
    genesis_token_id: 4789,
    wearable_ids: [266, 391],
  },
  {
    genesis_token_id: 4790,
    wearable_ids: [278, 296],
  },
  {
    genesis_token_id: 4791,
    wearable_ids: [400, 247],
  },
  {
    genesis_token_id: 4792,
    wearable_ids: [389, 283],
  },
  {
    genesis_token_id: 4793,
    wearable_ids: [286, 258],
  },
  {
    genesis_token_id: 4794,
    wearable_ids: [374, 415],
  },
  {
    genesis_token_id: 4795,
    wearable_ids: [324, 273],
  },
  {
    genesis_token_id: 4796,
    wearable_ids: [337, 422],
  },
  {
    genesis_token_id: 4797,
    wearable_ids: [423, 266],
  },
  {
    genesis_token_id: 4798,
    wearable_ids: [363, 394],
  },
  {
    genesis_token_id: 4799,
    wearable_ids: [423, 264],
  },
  {
    genesis_token_id: 4800,
    wearable_ids: [431, 363],
  },
  {
    genesis_token_id: 4801,
    wearable_ids: [338, 345],
  },
  {
    genesis_token_id: 4802,
    wearable_ids: [374, 437],
  },
  {
    genesis_token_id: 4803,
    wearable_ids: [355, 399],
  },
  {
    genesis_token_id: 4804,
    wearable_ids: [332, 259],
  },
  {
    genesis_token_id: 4805,
    wearable_ids: [400, 348],
  },
  {
    genesis_token_id: 4806,
    wearable_ids: [331, 373],
  },
  {
    genesis_token_id: 4807,
    wearable_ids: [258, 322],
  },
  {
    genesis_token_id: 4808,
    wearable_ids: [286, 306],
  },
  {
    genesis_token_id: 4809,
    wearable_ids: [317, 320],
  },
  {
    genesis_token_id: 4810,
    wearable_ids: [397, 330],
  },
  {
    genesis_token_id: 4811,
    wearable_ids: [311, 303],
  },
  {
    genesis_token_id: 4812,
    wearable_ids: [343, 426],
  },
  {
    genesis_token_id: 4813,
    wearable_ids: [399, 376],
  },
  {
    genesis_token_id: 4814,
    wearable_ids: [301, 263],
  },
  {
    genesis_token_id: 4815,
    wearable_ids: [377, 375],
  },
  {
    genesis_token_id: 4816,
    wearable_ids: [297, 339],
  },
  {
    genesis_token_id: 4817,
    wearable_ids: [292, 383],
  },
  {
    genesis_token_id: 4818,
    wearable_ids: [409, 303],
  },
  {
    genesis_token_id: 4819,
    wearable_ids: [317, 341],
  },
  {
    genesis_token_id: 4820,
    wearable_ids: [365, 353],
  },
  {
    genesis_token_id: 4821,
    wearable_ids: [406, 246],
  },
  {
    genesis_token_id: 4822,
    wearable_ids: [297, 349],
  },
  {
    genesis_token_id: 4823,
    wearable_ids: [428, 278],
  },
  {
    genesis_token_id: 4824,
    wearable_ids: [362, 363],
  },
  {
    genesis_token_id: 4825,
    wearable_ids: [383, 425],
  },
  {
    genesis_token_id: 4826,
    wearable_ids: [343, 385],
  },
  {
    genesis_token_id: 4827,
    wearable_ids: [432, 351],
  },
  {
    genesis_token_id: 4828,
    wearable_ids: [442, 276],
  },
  {
    genesis_token_id: 4829,
    wearable_ids: [403, 317],
  },
  {
    genesis_token_id: 4830,
    wearable_ids: [370, 339],
  },
  {
    genesis_token_id: 4831,
    wearable_ids: [352, 318],
  },
  {
    genesis_token_id: 4832,
    wearable_ids: [378, 387],
  },
  {
    genesis_token_id: 4833,
    wearable_ids: [375, 359],
  },
  {
    genesis_token_id: 4834,
    wearable_ids: [362, 283],
  },
  {
    genesis_token_id: 4835,
    wearable_ids: [369, 411],
  },
  {
    genesis_token_id: 4836,
    wearable_ids: [352, 431],
  },
  {
    genesis_token_id: 4837,
    wearable_ids: [256, 254],
  },
  {
    genesis_token_id: 4838,
    wearable_ids: [395, 353],
  },
  {
    genesis_token_id: 4839,
    wearable_ids: [277, 397],
  },
  {
    genesis_token_id: 4840,
    wearable_ids: [331, 296],
  },
  {
    genesis_token_id: 4841,
    wearable_ids: [386, 289],
  },
  {
    genesis_token_id: 4842,
    wearable_ids: [443, 395],
  },
  {
    genesis_token_id: 4843,
    wearable_ids: [315, 402],
  },
  {
    genesis_token_id: 4844,
    wearable_ids: [256, 279],
  },
  {
    genesis_token_id: 4845,
    wearable_ids: [425, 338],
  },
  {
    genesis_token_id: 4846,
    wearable_ids: [273, 379],
  },
  {
    genesis_token_id: 4847,
    wearable_ids: [247, 301],
  },
  {
    genesis_token_id: 4848,
    wearable_ids: [325, 301],
  },
  {
    genesis_token_id: 4849,
    wearable_ids: [436, 335],
  },
  {
    genesis_token_id: 4850,
    wearable_ids: [399, 262],
  },
  {
    genesis_token_id: 4851,
    wearable_ids: [262, 385],
  },
  {
    genesis_token_id: 4852,
    wearable_ids: [400, 317],
  },
  {
    genesis_token_id: 4853,
    wearable_ids: [254, 310],
  },
  {
    genesis_token_id: 4854,
    wearable_ids: [400, 300],
  },
  {
    genesis_token_id: 4855,
    wearable_ids: [406, 424],
  },
  {
    genesis_token_id: 4856,
    wearable_ids: [253, 406],
  },
  {
    genesis_token_id: 4857,
    wearable_ids: [364, 410],
  },
  {
    genesis_token_id: 4858,
    wearable_ids: [303, 383],
  },
  {
    genesis_token_id: 4859,
    wearable_ids: [286, 249],
  },
  {
    genesis_token_id: 4860,
    wearable_ids: [296, 304],
  },
  {
    genesis_token_id: 4861,
    wearable_ids: [308, 373],
  },
  {
    genesis_token_id: 4862,
    wearable_ids: [257, 410],
  },
  {
    genesis_token_id: 4863,
    wearable_ids: [436, 352],
  },
  {
    genesis_token_id: 4864,
    wearable_ids: [444, 295],
  },
  {
    genesis_token_id: 4865,
    wearable_ids: [385, 337],
  },
  {
    genesis_token_id: 4866,
    wearable_ids: [422, 398],
  },
  {
    genesis_token_id: 4867,
    wearable_ids: [335, 427],
  },
  {
    genesis_token_id: 4868,
    wearable_ids: [436, 345],
  },
  {
    genesis_token_id: 4869,
    wearable_ids: [297, 296],
  },
  {
    genesis_token_id: 4870,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 4871,
    wearable_ids: [411, 277],
  },
  {
    genesis_token_id: 4872,
    wearable_ids: [348, 363],
  },
  {
    genesis_token_id: 4873,
    wearable_ids: [432, 396],
  },
  {
    genesis_token_id: 4874,
    wearable_ids: [296, 287],
  },
  {
    genesis_token_id: 4875,
    wearable_ids: [291, 361],
  },
  {
    genesis_token_id: 4876,
    wearable_ids: [343, 388],
  },
  {
    genesis_token_id: 4877,
    wearable_ids: [338, 395],
  },
  {
    genesis_token_id: 4878,
    wearable_ids: [276, 268],
  },
  {
    genesis_token_id: 4879,
    wearable_ids: [300, 251],
  },
  {
    genesis_token_id: 4880,
    wearable_ids: [426, 410],
  },
  {
    genesis_token_id: 4881,
    wearable_ids: [384, 326],
  },
  {
    genesis_token_id: 4882,
    wearable_ids: [422, 362],
  },
  {
    genesis_token_id: 4883,
    wearable_ids: [369, 286],
  },
  {
    genesis_token_id: 4884,
    wearable_ids: [268, 297],
  },
  {
    genesis_token_id: 4885,
    wearable_ids: [343, 295],
  },
  {
    genesis_token_id: 4886,
    wearable_ids: [374, 293],
  },
  {
    genesis_token_id: 4887,
    wearable_ids: [362, 272],
  },
  {
    genesis_token_id: 4888,
    wearable_ids: [317, 263],
  },
  {
    genesis_token_id: 4889,
    wearable_ids: [445, 384],
  },
  {
    genesis_token_id: 4890,
    wearable_ids: [251, 343],
  },
  {
    genesis_token_id: 4891,
    wearable_ids: [315, 311],
  },
  {
    genesis_token_id: 4892,
    wearable_ids: [435, 378],
  },
  {
    genesis_token_id: 4893,
    wearable_ids: [436, 247],
  },
  {
    genesis_token_id: 4894,
    wearable_ids: [290, 277],
  },
  {
    genesis_token_id: 4895,
    wearable_ids: [346, 326],
  },
  {
    genesis_token_id: 4896,
    wearable_ids: [373, 374],
  },
  {
    genesis_token_id: 4897,
    wearable_ids: [349, 428],
  },
  {
    genesis_token_id: 4898,
    wearable_ids: [403, 445],
  },
  {
    genesis_token_id: 4899,
    wearable_ids: [412, 430],
  },
  {
    genesis_token_id: 4900,
    wearable_ids: [316, 332],
  },
  {
    genesis_token_id: 4901,
    wearable_ids: [247, 255],
  },
  {
    genesis_token_id: 4902,
    wearable_ids: [292, 404],
  },
  {
    genesis_token_id: 4903,
    wearable_ids: [273, 389],
  },
  {
    genesis_token_id: 4904,
    wearable_ids: [306, 251],
  },
  {
    genesis_token_id: 4905,
    wearable_ids: [409, 382],
  },
  {
    genesis_token_id: 4906,
    wearable_ids: [343, 377],
  },
  {
    genesis_token_id: 4907,
    wearable_ids: [373, 290],
  },
  {
    genesis_token_id: 4908,
    wearable_ids: [326, 279],
  },
  {
    genesis_token_id: 4909,
    wearable_ids: [387, 404],
  },
  {
    genesis_token_id: 4910,
    wearable_ids: [247, 256],
  },
  {
    genesis_token_id: 4911,
    wearable_ids: [410, 375],
  },
  {
    genesis_token_id: 4912,
    wearable_ids: [410, 382],
  },
  {
    genesis_token_id: 4913,
    wearable_ids: [372, 332],
  },
  {
    genesis_token_id: 4914,
    wearable_ids: [377, 374],
  },
  {
    genesis_token_id: 4915,
    wearable_ids: [284, 346],
  },
  {
    genesis_token_id: 4916,
    wearable_ids: [399, 253],
  },
  {
    genesis_token_id: 4917,
    wearable_ids: [251, 370],
  },
  {
    genesis_token_id: 4918,
    wearable_ids: [413, 316],
  },
  {
    genesis_token_id: 4919,
    wearable_ids: [338, 350],
  },
  {
    genesis_token_id: 4920,
    wearable_ids: [424, 443],
  },
  {
    genesis_token_id: 4921,
    wearable_ids: [377, 420],
  },
  {
    genesis_token_id: 4922,
    wearable_ids: [375, 297],
  },
  {
    genesis_token_id: 4923,
    wearable_ids: [274, 266],
  },
  {
    genesis_token_id: 4924,
    wearable_ids: [290, 306],
  },
  {
    genesis_token_id: 4925,
    wearable_ids: [289, 420],
  },
  {
    genesis_token_id: 4926,
    wearable_ids: [337, 313],
  },
  {
    genesis_token_id: 4927,
    wearable_ids: [273, 382],
  },
  {
    genesis_token_id: 4928,
    wearable_ids: [251, 292],
  },
  {
    genesis_token_id: 4929,
    wearable_ids: [396, 274],
  },
  {
    genesis_token_id: 4930,
    wearable_ids: [350, 391],
  },
  {
    genesis_token_id: 4931,
    wearable_ids: [325, 269],
  },
  {
    genesis_token_id: 4932,
    wearable_ids: [404, 415],
  },
  {
    genesis_token_id: 4933,
    wearable_ids: [284, 372],
  },
  {
    genesis_token_id: 4934,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 4935,
    wearable_ids: [410, 273],
  },
  {
    genesis_token_id: 4936,
    wearable_ids: [351, 340],
  },
  {
    genesis_token_id: 4937,
    wearable_ids: [278, 275],
  },
  {
    genesis_token_id: 4938,
    wearable_ids: [255, 415],
  },
  {
    genesis_token_id: 4939,
    wearable_ids: [377, 422],
  },
  {
    genesis_token_id: 4940,
    wearable_ids: [348, 389],
  },
  {
    genesis_token_id: 4941,
    wearable_ids: [389, 348],
  },
  {
    genesis_token_id: 4942,
    wearable_ids: [371, 323],
  },
  {
    genesis_token_id: 4943,
    wearable_ids: [286, 278],
  },
  {
    genesis_token_id: 4944,
    wearable_ids: [362, 340],
  },
  {
    genesis_token_id: 4945,
    wearable_ids: [259, 362],
  },
  {
    genesis_token_id: 4946,
    wearable_ids: [429, 297],
  },
  {
    genesis_token_id: 4947,
    wearable_ids: [362, 375],
  },
  {
    genesis_token_id: 4948,
    wearable_ids: [251, 349],
  },
  {
    genesis_token_id: 4949,
    wearable_ids: [292, 434],
  },
  {
    genesis_token_id: 4950,
    wearable_ids: [310, 384],
  },
  {
    genesis_token_id: 4951,
    wearable_ids: [351, 291],
  },
  {
    genesis_token_id: 4952,
    wearable_ids: [251, 316],
  },
  {
    genesis_token_id: 4953,
    wearable_ids: [364, 443],
  },
  {
    genesis_token_id: 4954,
    wearable_ids: [347, 404],
  },
  {
    genesis_token_id: 4955,
    wearable_ids: [286, 406],
  },
  {
    genesis_token_id: 4956,
    wearable_ids: [266, 374],
  },
  {
    genesis_token_id: 4957,
    wearable_ids: [311, 442],
  },
  {
    genesis_token_id: 4958,
    wearable_ids: [248, 441],
  },
  {
    genesis_token_id: 4959,
    wearable_ids: [432, 397],
  },
  {
    genesis_token_id: 4960,
    wearable_ids: [300, 342],
  },
  {
    genesis_token_id: 4961,
    wearable_ids: [297, 409],
  },
  {
    genesis_token_id: 4962,
    wearable_ids: [264, 426],
  },
  {
    genesis_token_id: 4963,
    wearable_ids: [424, 313],
  },
  {
    genesis_token_id: 4964,
    wearable_ids: [425, 347],
  },
  {
    genesis_token_id: 4965,
    wearable_ids: [277, 368],
  },
  {
    genesis_token_id: 4966,
    wearable_ids: [306, 442],
  },
  {
    genesis_token_id: 4967,
    wearable_ids: [311, 370],
  },
  {
    genesis_token_id: 4968,
    wearable_ids: [443, 289],
  },
  {
    genesis_token_id: 4969,
    wearable_ids: [290, 428],
  },
  {
    genesis_token_id: 4970,
    wearable_ids: [299, 267],
  },
  {
    genesis_token_id: 4971,
    wearable_ids: [265, 277],
  },
  {
    genesis_token_id: 4972,
    wearable_ids: [426, 304],
  },
  {
    genesis_token_id: 4973,
    wearable_ids: [349, 383],
  },
  {
    genesis_token_id: 4974,
    wearable_ids: [375, 311],
  },
  {
    genesis_token_id: 4975,
    wearable_ids: [276, 434],
  },
  {
    genesis_token_id: 4976,
    wearable_ids: [338, 371],
  },
  {
    genesis_token_id: 4977,
    wearable_ids: [376, 433],
  },
  {
    genesis_token_id: 4978,
    wearable_ids: [306, 265],
  },
  {
    genesis_token_id: 4979,
    wearable_ids: [350, 345],
  },
  {
    genesis_token_id: 4980,
    wearable_ids: [400, 382],
  },
  {
    genesis_token_id: 4981,
    wearable_ids: [415, 431],
  },
  {
    genesis_token_id: 4982,
    wearable_ids: [386, 335],
  },
  {
    genesis_token_id: 4983,
    wearable_ids: [385, 348],
  },
  {
    genesis_token_id: 4984,
    wearable_ids: [299, 357],
  },
  {
    genesis_token_id: 4985,
    wearable_ids: [384, 364],
  },
  {
    genesis_token_id: 4986,
    wearable_ids: [342, 405],
  },
  {
    genesis_token_id: 4987,
    wearable_ids: [274, 424],
  },
  {
    genesis_token_id: 4988,
    wearable_ids: [435, 415],
  },
  {
    genesis_token_id: 4989,
    wearable_ids: [355, 325],
  },
  {
    genesis_token_id: 4990,
    wearable_ids: [420, 445],
  },
  {
    genesis_token_id: 4991,
    wearable_ids: [400, 338],
  },
  {
    genesis_token_id: 4992,
    wearable_ids: [262, 392],
  },
  {
    genesis_token_id: 4993,
    wearable_ids: [317, 253],
  },
  {
    genesis_token_id: 4994,
    wearable_ids: [296, 379],
  },
  {
    genesis_token_id: 4995,
    wearable_ids: [310, 339],
  },
  {
    genesis_token_id: 4996,
    wearable_ids: [326, 304],
  },
  {
    genesis_token_id: 4997,
    wearable_ids: [290, 273],
  },
  {
    genesis_token_id: 4998,
    wearable_ids: [410, 382],
  },
  {
    genesis_token_id: 4999,
    wearable_ids: [384, 247],
  },
  {
    genesis_token_id: 5000,
    wearable_ids: [296, 423],
  },
  {
    genesis_token_id: 5001,
    wearable_ids: [425, 306],
  },
  {
    genesis_token_id: 5002,
    wearable_ids: [412, 280],
  },
  {
    genesis_token_id: 5003,
    wearable_ids: [247, 297],
  },
  {
    genesis_token_id: 5004,
    wearable_ids: [399, 445],
  },
  {
    genesis_token_id: 5005,
    wearable_ids: [365, 280],
  },
  {
    genesis_token_id: 5006,
    wearable_ids: [376, 377],
  },
  {
    genesis_token_id: 5007,
    wearable_ids: [248, 318],
  },
  {
    genesis_token_id: 5008,
    wearable_ids: [314, 304],
  },
  {
    genesis_token_id: 5009,
    wearable_ids: [420, 445],
  },
  {
    genesis_token_id: 5010,
    wearable_ids: [270, 334],
  },
  {
    genesis_token_id: 5011,
    wearable_ids: [432, 295],
  },
  {
    genesis_token_id: 5012,
    wearable_ids: [257, 338],
  },
  {
    genesis_token_id: 5013,
    wearable_ids: [423, 400],
  },
  {
    genesis_token_id: 5014,
    wearable_ids: [254, 412],
  },
  {
    genesis_token_id: 5015,
    wearable_ids: [365, 348],
  },
  {
    genesis_token_id: 5016,
    wearable_ids: [437, 331],
  },
  {
    genesis_token_id: 5017,
    wearable_ids: [400, 276],
  },
  {
    genesis_token_id: 5018,
    wearable_ids: [369, 423],
  },
  {
    genesis_token_id: 5019,
    wearable_ids: [373, 445],
  },
  {
    genesis_token_id: 5020,
    wearable_ids: [300, 254],
  },
  {
    genesis_token_id: 5021,
    wearable_ids: [442, 347],
  },
  {
    genesis_token_id: 5022,
    wearable_ids: [351, 289],
  },
  {
    genesis_token_id: 5023,
    wearable_ids: [304, 273],
  },
  {
    genesis_token_id: 5024,
    wearable_ids: [350, 249],
  },
  {
    genesis_token_id: 5025,
    wearable_ids: [399, 301],
  },
  {
    genesis_token_id: 5026,
    wearable_ids: [316, 346],
  },
  {
    genesis_token_id: 5027,
    wearable_ids: [306, 257],
  },
  {
    genesis_token_id: 5028,
    wearable_ids: [437, 300],
  },
  {
    genesis_token_id: 5029,
    wearable_ids: [273, 289],
  },
  {
    genesis_token_id: 5030,
    wearable_ids: [424, 379],
  },
  {
    genesis_token_id: 5031,
    wearable_ids: [280, 409],
  },
  {
    genesis_token_id: 5032,
    wearable_ids: [271, 343],
  },
  {
    genesis_token_id: 5033,
    wearable_ids: [338, 308],
  },
  {
    genesis_token_id: 5034,
    wearable_ids: [319, 308],
  },
  {
    genesis_token_id: 5035,
    wearable_ids: [259, 375],
  },
  {
    genesis_token_id: 5036,
    wearable_ids: [341, 346],
  },
  {
    genesis_token_id: 5037,
    wearable_ids: [434, 354],
  },
  {
    genesis_token_id: 5038,
    wearable_ids: [437, 316],
  },
  {
    genesis_token_id: 5039,
    wearable_ids: [342, 246],
  },
  {
    genesis_token_id: 5040,
    wearable_ids: [339, 304],
  },
  {
    genesis_token_id: 5041,
    wearable_ids: [316, 331],
  },
  {
    genesis_token_id: 5042,
    wearable_ids: [409, 323],
  },
  {
    genesis_token_id: 5043,
    wearable_ids: [257, 392],
  },
  {
    genesis_token_id: 5044,
    wearable_ids: [377, 331],
  },
  {
    genesis_token_id: 5045,
    wearable_ids: [429, 343],
  },
  {
    genesis_token_id: 5046,
    wearable_ids: [352, 430],
  },
  {
    genesis_token_id: 5047,
    wearable_ids: [435, 272],
  },
  {
    genesis_token_id: 5048,
    wearable_ids: [311, 295],
  },
  {
    genesis_token_id: 5049,
    wearable_ids: [412, 369],
  },
  {
    genesis_token_id: 5050,
    wearable_ids: [374, 422],
  },
  {
    genesis_token_id: 5051,
    wearable_ids: [296, 387],
  },
  {
    genesis_token_id: 5052,
    wearable_ids: [423, 406],
  },
  {
    genesis_token_id: 5053,
    wearable_ids: [431, 247],
  },
  {
    genesis_token_id: 5054,
    wearable_ids: [352, 338],
  },
  {
    genesis_token_id: 5055,
    wearable_ids: [413, 378],
  },
  {
    genesis_token_id: 5056,
    wearable_ids: [294, 272],
  },
  {
    genesis_token_id: 5057,
    wearable_ids: [251, 284],
  },
  {
    genesis_token_id: 5058,
    wearable_ids: [324, 272],
  },
  {
    genesis_token_id: 5059,
    wearable_ids: [408, 442],
  },
  {
    genesis_token_id: 5060,
    wearable_ids: [382, 410],
  },
  {
    genesis_token_id: 5061,
    wearable_ids: [423, 316],
  },
  {
    genesis_token_id: 5062,
    wearable_ids: [326, 322],
  },
  {
    genesis_token_id: 5063,
    wearable_ids: [324, 297],
  },
  {
    genesis_token_id: 5064,
    wearable_ids: [412, 442],
  },
  {
    genesis_token_id: 5065,
    wearable_ids: [326, 251],
  },
  {
    genesis_token_id: 5066,
    wearable_ids: [386, 296],
  },
  {
    genesis_token_id: 5067,
    wearable_ids: [257, 316],
  },
  {
    genesis_token_id: 5068,
    wearable_ids: [347, 385],
  },
  {
    genesis_token_id: 5069,
    wearable_ids: [372, 383],
  },
  {
    genesis_token_id: 5070,
    wearable_ids: [314, 404],
  },
  {
    genesis_token_id: 5071,
    wearable_ids: [375, 317],
  },
  {
    genesis_token_id: 5072,
    wearable_ids: [266, 373],
  },
  {
    genesis_token_id: 5073,
    wearable_ids: [348, 287],
  },
  {
    genesis_token_id: 5074,
    wearable_ids: [337, 266],
  },
  {
    genesis_token_id: 5075,
    wearable_ids: [352, 371],
  },
  {
    genesis_token_id: 5076,
    wearable_ids: [355, 291],
  },
  {
    genesis_token_id: 5077,
    wearable_ids: [299, 289],
  },
  {
    genesis_token_id: 5078,
    wearable_ids: [310, 300],
  },
  {
    genesis_token_id: 5079,
    wearable_ids: [351, 399],
  },
  {
    genesis_token_id: 5080,
    wearable_ids: [264, 386],
  },
  {
    genesis_token_id: 5081,
    wearable_ids: [254, 274],
  },
  {
    genesis_token_id: 5082,
    wearable_ids: [258, 308],
  },
  {
    genesis_token_id: 5083,
    wearable_ids: [442, 246],
  },
  {
    genesis_token_id: 5084,
    wearable_ids: [395, 348],
  },
  {
    genesis_token_id: 5085,
    wearable_ids: [324, 443],
  },
  {
    genesis_token_id: 5086,
    wearable_ids: [331, 283],
  },
  {
    genesis_token_id: 5087,
    wearable_ids: [286, 344],
  },
  {
    genesis_token_id: 5088,
    wearable_ids: [420, 283],
  },
  {
    genesis_token_id: 5089,
    wearable_ids: [382, 301],
  },
  {
    genesis_token_id: 5090,
    wearable_ids: [437, 266],
  },
  {
    genesis_token_id: 5091,
    wearable_ids: [348, 399],
  },
  {
    genesis_token_id: 5092,
    wearable_ids: [266, 264],
  },
  {
    genesis_token_id: 5093,
    wearable_ids: [256, 412],
  },
  {
    genesis_token_id: 5094,
    wearable_ids: [341, 392],
  },
  {
    genesis_token_id: 5095,
    wearable_ids: [310, 331],
  },
  {
    genesis_token_id: 5096,
    wearable_ids: [340, 410],
  },
  {
    genesis_token_id: 5097,
    wearable_ids: [443, 319],
  },
  {
    genesis_token_id: 5098,
    wearable_ids: [413, 355],
  },
  {
    genesis_token_id: 5099,
    wearable_ids: [296, 311],
  },
  {
    genesis_token_id: 5100,
    wearable_ids: [374, 262],
  },
  {
    genesis_token_id: 5101,
    wearable_ids: [399, 299],
  },
  {
    genesis_token_id: 5102,
    wearable_ids: [296, 264],
  },
  {
    genesis_token_id: 5103,
    wearable_ids: [264, 307],
  },
  {
    genesis_token_id: 5104,
    wearable_ids: [306, 424],
  },
  {
    genesis_token_id: 5105,
    wearable_ids: [434, 280],
  },
  {
    genesis_token_id: 5106,
    wearable_ids: [319, 299],
  },
  {
    genesis_token_id: 5107,
    wearable_ids: [284, 340],
  },
  {
    genesis_token_id: 5108,
    wearable_ids: [373, 346],
  },
  {
    genesis_token_id: 5109,
    wearable_ids: [292, 290],
  },
  {
    genesis_token_id: 5110,
    wearable_ids: [408, 323],
  },
  {
    genesis_token_id: 5111,
    wearable_ids: [346, 377],
  },
  {
    genesis_token_id: 5112,
    wearable_ids: [278, 443],
  },
  {
    genesis_token_id: 5113,
    wearable_ids: [412, 284],
  },
  {
    genesis_token_id: 5114,
    wearable_ids: [268, 250],
  },
  {
    genesis_token_id: 5115,
    wearable_ids: [286, 384],
  },
  {
    genesis_token_id: 5116,
    wearable_ids: [332, 424],
  },
  {
    genesis_token_id: 5117,
    wearable_ids: [306, 280],
  },
  {
    genesis_token_id: 5118,
    wearable_ids: [400, 308],
  },
  {
    genesis_token_id: 5119,
    wearable_ids: [248, 284],
  },
  {
    genesis_token_id: 5120,
    wearable_ids: [368, 406],
  },
  {
    genesis_token_id: 5121,
    wearable_ids: [336, 300],
  },
  {
    genesis_token_id: 5122,
    wearable_ids: [336, 316],
  },
  {
    genesis_token_id: 5123,
    wearable_ids: [442, 406],
  },
  {
    genesis_token_id: 5124,
    wearable_ids: [316, 423],
  },
  {
    genesis_token_id: 5125,
    wearable_ids: [286, 355],
  },
  {
    genesis_token_id: 5126,
    wearable_ids: [251, 385],
  },
  {
    genesis_token_id: 5127,
    wearable_ids: [339, 412],
  },
  {
    genesis_token_id: 5128,
    wearable_ids: [364, 286],
  },
  {
    genesis_token_id: 5129,
    wearable_ids: [299, 263],
  },
  {
    genesis_token_id: 5130,
    wearable_ids: [395, 265],
  },
  {
    genesis_token_id: 5131,
    wearable_ids: [342, 333],
  },
  {
    genesis_token_id: 5132,
    wearable_ids: [409, 443],
  },
  {
    genesis_token_id: 5133,
    wearable_ids: [344, 339],
  },
  {
    genesis_token_id: 5134,
    wearable_ids: [256, 351],
  },
  {
    genesis_token_id: 5135,
    wearable_ids: [399, 355],
  },
  {
    genesis_token_id: 5136,
    wearable_ids: [426, 376],
  },
  {
    genesis_token_id: 5137,
    wearable_ids: [286, 362],
  },
  {
    genesis_token_id: 5138,
    wearable_ids: [363, 247],
  },
  {
    genesis_token_id: 5139,
    wearable_ids: [397, 259],
  },
  {
    genesis_token_id: 5140,
    wearable_ids: [363, 349],
  },
  {
    genesis_token_id: 5141,
    wearable_ids: [257, 347],
  },
  {
    genesis_token_id: 5142,
    wearable_ids: [344, 346],
  },
  {
    genesis_token_id: 5143,
    wearable_ids: [268, 362],
  },
  {
    genesis_token_id: 5144,
    wearable_ids: [443, 410],
  },
  {
    genesis_token_id: 5145,
    wearable_ids: [256, 273],
  },
  {
    genesis_token_id: 5146,
    wearable_ids: [396, 337],
  },
  {
    genesis_token_id: 5147,
    wearable_ids: [444, 377],
  },
  {
    genesis_token_id: 5148,
    wearable_ids: [383, 247],
  },
  {
    genesis_token_id: 5149,
    wearable_ids: [290, 414],
  },
  {
    genesis_token_id: 5150,
    wearable_ids: [346, 441],
  },
  {
    genesis_token_id: 5151,
    wearable_ids: [387, 425],
  },
  {
    genesis_token_id: 5152,
    wearable_ids: [308, 351],
  },
  {
    genesis_token_id: 5153,
    wearable_ids: [364, 408],
  },
  {
    genesis_token_id: 5154,
    wearable_ids: [303, 442],
  },
  {
    genesis_token_id: 5155,
    wearable_ids: [301, 375],
  },
  {
    genesis_token_id: 5156,
    wearable_ids: [317, 271],
  },
  {
    genesis_token_id: 5157,
    wearable_ids: [296, 333],
  },
  {
    genesis_token_id: 5158,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 5159,
    wearable_ids: [413, 248],
  },
  {
    genesis_token_id: 5160,
    wearable_ids: [431, 273],
  },
  {
    genesis_token_id: 5161,
    wearable_ids: [343, 342],
  },
  {
    genesis_token_id: 5162,
    wearable_ids: [373, 278],
  },
  {
    genesis_token_id: 5163,
    wearable_ids: [351, 383],
  },
  {
    genesis_token_id: 5164,
    wearable_ids: [436, 371],
  },
  {
    genesis_token_id: 5165,
    wearable_ids: [258, 445],
  },
  {
    genesis_token_id: 5166,
    wearable_ids: [311, 423],
  },
  {
    genesis_token_id: 5167,
    wearable_ids: [342, 267],
  },
  {
    genesis_token_id: 5168,
    wearable_ids: [259, 296],
  },
  {
    genesis_token_id: 5169,
    wearable_ids: [342, 262],
  },
  {
    genesis_token_id: 5170,
    wearable_ids: [364, 349],
  },
  {
    genesis_token_id: 5171,
    wearable_ids: [331, 284],
  },
  {
    genesis_token_id: 5172,
    wearable_ids: [408, 248],
  },
  {
    genesis_token_id: 5173,
    wearable_ids: [403, 386],
  },
  {
    genesis_token_id: 5174,
    wearable_ids: [253, 443],
  },
  {
    genesis_token_id: 5175,
    wearable_ids: [372, 265],
  },
  {
    genesis_token_id: 5176,
    wearable_ids: [397, 370],
  },
  {
    genesis_token_id: 5177,
    wearable_ids: [371, 363],
  },
  {
    genesis_token_id: 5178,
    wearable_ids: [294, 256],
  },
  {
    genesis_token_id: 5179,
    wearable_ids: [325, 304],
  },
  {
    genesis_token_id: 5180,
    wearable_ids: [264, 277],
  },
  {
    genesis_token_id: 5181,
    wearable_ids: [443, 285],
  },
  {
    genesis_token_id: 5182,
    wearable_ids: [300, 287],
  },
  {
    genesis_token_id: 5183,
    wearable_ids: [299, 346],
  },
  {
    genesis_token_id: 5184,
    wearable_ids: [371, 432],
  },
  {
    genesis_token_id: 5185,
    wearable_ids: [431, 281],
  },
  {
    genesis_token_id: 5186,
    wearable_ids: [331, 410],
  },
  {
    genesis_token_id: 5187,
    wearable_ids: [316, 343],
  },
  {
    genesis_token_id: 5188,
    wearable_ids: [349, 338],
  },
  {
    genesis_token_id: 5189,
    wearable_ids: [287, 385],
  },
  {
    genesis_token_id: 5190,
    wearable_ids: [377, 407],
  },
  {
    genesis_token_id: 5191,
    wearable_ids: [304, 355],
  },
  {
    genesis_token_id: 5192,
    wearable_ids: [284, 265],
  },
  {
    genesis_token_id: 5193,
    wearable_ids: [371, 363],
  },
  {
    genesis_token_id: 5194,
    wearable_ids: [339, 330],
  },
  {
    genesis_token_id: 5195,
    wearable_ids: [256, 445],
  },
  {
    genesis_token_id: 5196,
    wearable_ids: [370, 259],
  },
  {
    genesis_token_id: 5197,
    wearable_ids: [411, 434],
  },
  {
    genesis_token_id: 5198,
    wearable_ids: [396, 302],
  },
  {
    genesis_token_id: 5199,
    wearable_ids: [344, 335],
  },
  {
    genesis_token_id: 5200,
    wearable_ids: [339, 347],
  },
  {
    genesis_token_id: 5201,
    wearable_ids: [436, 332],
  },
  {
    genesis_token_id: 5202,
    wearable_ids: [340, 312],
  },
  {
    genesis_token_id: 5203,
    wearable_ids: [409, 396],
  },
  {
    genesis_token_id: 5204,
    wearable_ids: [272, 399],
  },
  {
    genesis_token_id: 5205,
    wearable_ids: [410, 361],
  },
  {
    genesis_token_id: 5206,
    wearable_ids: [396, 350],
  },
  {
    genesis_token_id: 5207,
    wearable_ids: [423, 441],
  },
  {
    genesis_token_id: 5208,
    wearable_ids: [437, 428],
  },
  {
    genesis_token_id: 5209,
    wearable_ids: [339, 423],
  },
  {
    genesis_token_id: 5210,
    wearable_ids: [340, 281],
  },
  {
    genesis_token_id: 5211,
    wearable_ids: [425, 296],
  },
  {
    genesis_token_id: 5212,
    wearable_ids: [315, 398],
  },
  {
    genesis_token_id: 5213,
    wearable_ids: [415, 442],
  },
  {
    genesis_token_id: 5214,
    wearable_ids: [437, 249],
  },
  {
    genesis_token_id: 5215,
    wearable_ids: [433, 261],
  },
  {
    genesis_token_id: 5216,
    wearable_ids: [311, 293],
  },
  {
    genesis_token_id: 5217,
    wearable_ids: [365, 350],
  },
  {
    genesis_token_id: 5218,
    wearable_ids: [265, 337],
  },
  {
    genesis_token_id: 5219,
    wearable_ids: [286, 284],
  },
  {
    genesis_token_id: 5220,
    wearable_ids: [319, 443],
  },
  {
    genesis_token_id: 5221,
    wearable_ids: [315, 348],
  },
  {
    genesis_token_id: 5222,
    wearable_ids: [325, 332],
  },
  {
    genesis_token_id: 5223,
    wearable_ids: [257, 355],
  },
  {
    genesis_token_id: 5224,
    wearable_ids: [406, 259],
  },
  {
    genesis_token_id: 5225,
    wearable_ids: [272, 304],
  },
  {
    genesis_token_id: 5226,
    wearable_ids: [434, 281],
  },
  {
    genesis_token_id: 5227,
    wearable_ids: [437, 249],
  },
  {
    genesis_token_id: 5228,
    wearable_ids: [273, 322],
  },
  {
    genesis_token_id: 5229,
    wearable_ids: [435, 433],
  },
  {
    genesis_token_id: 5230,
    wearable_ids: [420, 432],
  },
  {
    genesis_token_id: 5231,
    wearable_ids: [292, 341],
  },
  {
    genesis_token_id: 5232,
    wearable_ids: [383, 335],
  },
  {
    genesis_token_id: 5233,
    wearable_ids: [314, 270],
  },
  {
    genesis_token_id: 5234,
    wearable_ids: [372, 354],
  },
  {
    genesis_token_id: 5235,
    wearable_ids: [289, 347],
  },
  {
    genesis_token_id: 5236,
    wearable_ids: [435, 371],
  },
  {
    genesis_token_id: 5237,
    wearable_ids: [247, 432],
  },
  {
    genesis_token_id: 5238,
    wearable_ids: [270, 384],
  },
  {
    genesis_token_id: 5239,
    wearable_ids: [408, 410],
  },
  {
    genesis_token_id: 5240,
    wearable_ids: [270, 280],
  },
  {
    genesis_token_id: 5241,
    wearable_ids: [256, 268],
  },
  {
    genesis_token_id: 5242,
    wearable_ids: [280, 317],
  },
  {
    genesis_token_id: 5243,
    wearable_ids: [437, 411],
  },
  {
    genesis_token_id: 5244,
    wearable_ids: [385, 378],
  },
  {
    genesis_token_id: 5245,
    wearable_ids: [437, 298],
  },
  {
    genesis_token_id: 5246,
    wearable_ids: [374, 303],
  },
  {
    genesis_token_id: 5247,
    wearable_ids: [264, 382],
  },
  {
    genesis_token_id: 5248,
    wearable_ids: [290, 294],
  },
  {
    genesis_token_id: 5249,
    wearable_ids: [435, 430],
  },
  {
    genesis_token_id: 5250,
    wearable_ids: [399, 314],
  },
  {
    genesis_token_id: 5251,
    wearable_ids: [370, 296],
  },
  {
    genesis_token_id: 5252,
    wearable_ids: [263, 287],
  },
  {
    genesis_token_id: 5253,
    wearable_ids: [289, 409],
  },
  {
    genesis_token_id: 5254,
    wearable_ids: [264, 351],
  },
  {
    genesis_token_id: 5255,
    wearable_ids: [375, 328],
  },
  {
    genesis_token_id: 5256,
    wearable_ids: [424, 299],
  },
  {
    genesis_token_id: 5257,
    wearable_ids: [407, 278],
  },
  {
    genesis_token_id: 5258,
    wearable_ids: [431, 355],
  },
  {
    genesis_token_id: 5259,
    wearable_ids: [382, 394],
  },
  {
    genesis_token_id: 5260,
    wearable_ids: [258, 315],
  },
  {
    genesis_token_id: 5261,
    wearable_ids: [425, 442],
  },
  {
    genesis_token_id: 5262,
    wearable_ids: [290, 349],
  },
  {
    genesis_token_id: 5263,
    wearable_ids: [369, 379],
  },
  {
    genesis_token_id: 5264,
    wearable_ids: [272, 360],
  },
  {
    genesis_token_id: 5265,
    wearable_ids: [317, 307],
  },
  {
    genesis_token_id: 5266,
    wearable_ids: [354, 410],
  },
  {
    genesis_token_id: 5267,
    wearable_ids: [287, 305],
  },
  {
    genesis_token_id: 5268,
    wearable_ids: [415, 337],
  },
  {
    genesis_token_id: 5269,
    wearable_ids: [324, 362],
  },
  {
    genesis_token_id: 5270,
    wearable_ids: [352, 305],
  },
  {
    genesis_token_id: 5271,
    wearable_ids: [396, 363],
  },
  {
    genesis_token_id: 5272,
    wearable_ids: [289, 251],
  },
  {
    genesis_token_id: 5273,
    wearable_ids: [258, 343],
  },
  {
    genesis_token_id: 5274,
    wearable_ids: [314, 408],
  },
  {
    genesis_token_id: 5275,
    wearable_ids: [277, 415],
  },
  {
    genesis_token_id: 5276,
    wearable_ids: [397, 395],
  },
  {
    genesis_token_id: 5277,
    wearable_ids: [369, 383],
  },
  {
    genesis_token_id: 5278,
    wearable_ids: [412, 278],
  },
  {
    genesis_token_id: 5279,
    wearable_ids: [340, 265],
  },
  {
    genesis_token_id: 5280,
    wearable_ids: [310, 406],
  },
  {
    genesis_token_id: 5281,
    wearable_ids: [262, 308],
  },
  {
    genesis_token_id: 5282,
    wearable_ids: [337, 420],
  },
  {
    genesis_token_id: 5283,
    wearable_ids: [271, 314],
  },
  {
    genesis_token_id: 5284,
    wearable_ids: [387, 425],
  },
  {
    genesis_token_id: 5285,
    wearable_ids: [347, 409],
  },
  {
    genesis_token_id: 5286,
    wearable_ids: [349, 400],
  },
  {
    genesis_token_id: 5287,
    wearable_ids: [274, 286],
  },
  {
    genesis_token_id: 5288,
    wearable_ids: [247, 316],
  },
  {
    genesis_token_id: 5289,
    wearable_ids: [258, 347],
  },
  {
    genesis_token_id: 5290,
    wearable_ids: [425, 422],
  },
  {
    genesis_token_id: 5291,
    wearable_ids: [406, 430],
  },
  {
    genesis_token_id: 5292,
    wearable_ids: [434, 428],
  },
  {
    genesis_token_id: 5293,
    wearable_ids: [387, 370],
  },
  {
    genesis_token_id: 5294,
    wearable_ids: [342, 352],
  },
  {
    genesis_token_id: 5295,
    wearable_ids: [433, 287],
  },
  {
    genesis_token_id: 5296,
    wearable_ids: [258, 398],
  },
  {
    genesis_token_id: 5297,
    wearable_ids: [372, 395],
  },
  {
    genesis_token_id: 5298,
    wearable_ids: [264, 300],
  },
  {
    genesis_token_id: 5299,
    wearable_ids: [306, 342],
  },
  {
    genesis_token_id: 5300,
    wearable_ids: [294, 258],
  },
  {
    genesis_token_id: 5301,
    wearable_ids: [352, 298],
  },
  {
    genesis_token_id: 5302,
    wearable_ids: [365, 328],
  },
  {
    genesis_token_id: 5303,
    wearable_ids: [255, 281],
  },
  {
    genesis_token_id: 5304,
    wearable_ids: [310, 394],
  },
  {
    genesis_token_id: 5305,
    wearable_ids: [341, 428],
  },
  {
    genesis_token_id: 5306,
    wearable_ids: [346, 361],
  },
  {
    genesis_token_id: 5307,
    wearable_ids: [386, 412],
  },
  {
    genesis_token_id: 5308,
    wearable_ids: [256, 426],
  },
  {
    genesis_token_id: 5309,
    wearable_ids: [332, 396],
  },
  {
    genesis_token_id: 5310,
    wearable_ids: [424, 402],
  },
  {
    genesis_token_id: 5311,
    wearable_ids: [369, 386],
  },
  {
    genesis_token_id: 5312,
    wearable_ids: [431, 258],
  },
  {
    genesis_token_id: 5313,
    wearable_ids: [308, 346],
  },
  {
    genesis_token_id: 5314,
    wearable_ids: [341, 369],
  },
  {
    genesis_token_id: 5315,
    wearable_ids: [314, 354],
  },
  {
    genesis_token_id: 5316,
    wearable_ids: [344, 407],
  },
  {
    genesis_token_id: 5317,
    wearable_ids: [317, 294],
  },
  {
    genesis_token_id: 5318,
    wearable_ids: [377, 339],
  },
  {
    genesis_token_id: 5319,
    wearable_ids: [254, 294],
  },
  {
    genesis_token_id: 5320,
    wearable_ids: [272, 420],
  },
  {
    genesis_token_id: 5321,
    wearable_ids: [291, 394],
  },
  {
    genesis_token_id: 5322,
    wearable_ids: [412, 343],
  },
  {
    genesis_token_id: 5323,
    wearable_ids: [278, 426],
  },
  {
    genesis_token_id: 5324,
    wearable_ids: [410, 318],
  },
  {
    genesis_token_id: 5325,
    wearable_ids: [342, 276],
  },
  {
    genesis_token_id: 5326,
    wearable_ids: [336, 254],
  },
  {
    genesis_token_id: 5327,
    wearable_ids: [337, 400],
  },
  {
    genesis_token_id: 5328,
    wearable_ids: [410, 353],
  },
  {
    genesis_token_id: 5329,
    wearable_ids: [413, 317],
  },
  {
    genesis_token_id: 5330,
    wearable_ids: [347, 340],
  },
  {
    genesis_token_id: 5331,
    wearable_ids: [270, 275],
  },
  {
    genesis_token_id: 5332,
    wearable_ids: [259, 374],
  },
  {
    genesis_token_id: 5333,
    wearable_ids: [386, 276],
  },
  {
    genesis_token_id: 5334,
    wearable_ids: [350, 340],
  },
  {
    genesis_token_id: 5335,
    wearable_ids: [347, 377],
  },
  {
    genesis_token_id: 5336,
    wearable_ids: [315, 410],
  },
  {
    genesis_token_id: 5337,
    wearable_ids: [352, 277],
  },
  {
    genesis_token_id: 5338,
    wearable_ids: [413, 268],
  },
  {
    genesis_token_id: 5339,
    wearable_ids: [310, 247],
  },
  {
    genesis_token_id: 5340,
    wearable_ids: [349, 360],
  },
  {
    genesis_token_id: 5341,
    wearable_ids: [373, 405],
  },
  {
    genesis_token_id: 5342,
    wearable_ids: [292, 422],
  },
  {
    genesis_token_id: 5343,
    wearable_ids: [429, 259],
  },
  {
    genesis_token_id: 5344,
    wearable_ids: [247, 259],
  },
  {
    genesis_token_id: 5345,
    wearable_ids: [278, 443],
  },
  {
    genesis_token_id: 5346,
    wearable_ids: [384, 375],
  },
  {
    genesis_token_id: 5347,
    wearable_ids: [346, 258],
  },
  {
    genesis_token_id: 5348,
    wearable_ids: [342, 437],
  },
  {
    genesis_token_id: 5349,
    wearable_ids: [290, 360],
  },
  {
    genesis_token_id: 5350,
    wearable_ids: [370, 432],
  },
  {
    genesis_token_id: 5351,
    wearable_ids: [265, 423],
  },
  {
    genesis_token_id: 5352,
    wearable_ids: [431, 247],
  },
  {
    genesis_token_id: 5353,
    wearable_ids: [270, 330],
  },
  {
    genesis_token_id: 5354,
    wearable_ids: [251, 412],
  },
  {
    genesis_token_id: 5355,
    wearable_ids: [386, 314],
  },
  {
    genesis_token_id: 5356,
    wearable_ids: [425, 431],
  },
  {
    genesis_token_id: 5357,
    wearable_ids: [385, 370],
  },
  {
    genesis_token_id: 5358,
    wearable_ids: [389, 316],
  },
  {
    genesis_token_id: 5359,
    wearable_ids: [423, 274],
  },
  {
    genesis_token_id: 5360,
    wearable_ids: [374, 408],
  },
  {
    genesis_token_id: 5361,
    wearable_ids: [270, 356],
  },
  {
    genesis_token_id: 5362,
    wearable_ids: [348, 306],
  },
  {
    genesis_token_id: 5363,
    wearable_ids: [268, 284],
  },
  {
    genesis_token_id: 5364,
    wearable_ids: [292, 258],
  },
  {
    genesis_token_id: 5365,
    wearable_ids: [354, 288],
  },
  {
    genesis_token_id: 5366,
    wearable_ids: [364, 425],
  },
  {
    genesis_token_id: 5367,
    wearable_ids: [317, 291],
  },
  {
    genesis_token_id: 5368,
    wearable_ids: [296, 256],
  },
  {
    genesis_token_id: 5369,
    wearable_ids: [351, 344],
  },
  {
    genesis_token_id: 5370,
    wearable_ids: [265, 294],
  },
  {
    genesis_token_id: 5371,
    wearable_ids: [337, 343],
  },
  {
    genesis_token_id: 5372,
    wearable_ids: [354, 283],
  },
  {
    genesis_token_id: 5373,
    wearable_ids: [407, 400],
  },
  {
    genesis_token_id: 5374,
    wearable_ids: [389, 256],
  },
  {
    genesis_token_id: 5375,
    wearable_ids: [354, 298],
  },
  {
    genesis_token_id: 5376,
    wearable_ids: [384, 426],
  },
  {
    genesis_token_id: 5377,
    wearable_ids: [263, 397],
  },
  {
    genesis_token_id: 5378,
    wearable_ids: [410, 355],
  },
  {
    genesis_token_id: 5379,
    wearable_ids: [280, 343],
  },
  {
    genesis_token_id: 5380,
    wearable_ids: [255, 340],
  },
  {
    genesis_token_id: 5381,
    wearable_ids: [304, 305],
  },
  {
    genesis_token_id: 5382,
    wearable_ids: [310, 400],
  },
  {
    genesis_token_id: 5383,
    wearable_ids: [314, 291],
  },
  {
    genesis_token_id: 5384,
    wearable_ids: [343, 379],
  },
  {
    genesis_token_id: 5385,
    wearable_ids: [274, 385],
  },
  {
    genesis_token_id: 5386,
    wearable_ids: [408, 371],
  },
  {
    genesis_token_id: 5387,
    wearable_ids: [407, 362],
  },
  {
    genesis_token_id: 5388,
    wearable_ids: [295, 314],
  },
  {
    genesis_token_id: 5389,
    wearable_ids: [274, 350],
  },
  {
    genesis_token_id: 5390,
    wearable_ids: [276, 275],
  },
  {
    genesis_token_id: 5391,
    wearable_ids: [290, 376],
  },
  {
    genesis_token_id: 5392,
    wearable_ids: [271, 258],
  },
  {
    genesis_token_id: 5393,
    wearable_ids: [404, 258],
  },
  {
    genesis_token_id: 5394,
    wearable_ids: [352, 431],
  },
  {
    genesis_token_id: 5395,
    wearable_ids: [376, 326],
  },
  {
    genesis_token_id: 5396,
    wearable_ids: [336, 363],
  },
  {
    genesis_token_id: 5397,
    wearable_ids: [346, 354],
  },
  {
    genesis_token_id: 5398,
    wearable_ids: [404, 292],
  },
  {
    genesis_token_id: 5399,
    wearable_ids: [292, 305],
  },
  {
    genesis_token_id: 5400,
    wearable_ids: [404, 415],
  },
  {
    genesis_token_id: 5401,
    wearable_ids: [265, 331],
  },
  {
    genesis_token_id: 5402,
    wearable_ids: [412, 400],
  },
  {
    genesis_token_id: 5403,
    wearable_ids: [382, 349],
  },
  {
    genesis_token_id: 5404,
    wearable_ids: [258, 436],
  },
  {
    genesis_token_id: 5405,
    wearable_ids: [295, 383],
  },
  {
    genesis_token_id: 5406,
    wearable_ids: [378, 410],
  },
  {
    genesis_token_id: 5407,
    wearable_ids: [259, 346],
  },
  {
    genesis_token_id: 5408,
    wearable_ids: [432, 284],
  },
  {
    genesis_token_id: 5409,
    wearable_ids: [409, 296],
  },
  {
    genesis_token_id: 5410,
    wearable_ids: [435, 261],
  },
  {
    genesis_token_id: 5411,
    wearable_ids: [378, 436],
  },
  {
    genesis_token_id: 5412,
    wearable_ids: [382, 300],
  },
  {
    genesis_token_id: 5413,
    wearable_ids: [412, 314],
  },
  {
    genesis_token_id: 5414,
    wearable_ids: [434, 404],
  },
  {
    genesis_token_id: 5415,
    wearable_ids: [434, 431],
  },
  {
    genesis_token_id: 5416,
    wearable_ids: [287, 333],
  },
  {
    genesis_token_id: 5417,
    wearable_ids: [324, 401],
  },
  {
    genesis_token_id: 5418,
    wearable_ids: [413, 261],
  },
  {
    genesis_token_id: 5419,
    wearable_ids: [347, 340],
  },
  {
    genesis_token_id: 5420,
    wearable_ids: [384, 316],
  },
  {
    genesis_token_id: 5421,
    wearable_ids: [314, 315],
  },
  {
    genesis_token_id: 5422,
    wearable_ids: [286, 341],
  },
  {
    genesis_token_id: 5423,
    wearable_ids: [348, 263],
  },
  {
    genesis_token_id: 5424,
    wearable_ids: [291, 316],
  },
  {
    genesis_token_id: 5425,
    wearable_ids: [346, 384],
  },
  {
    genesis_token_id: 5426,
    wearable_ids: [422, 429],
  },
  {
    genesis_token_id: 5427,
    wearable_ids: [297, 406],
  },
  {
    genesis_token_id: 5428,
    wearable_ids: [406, 248],
  },
  {
    genesis_token_id: 5429,
    wearable_ids: [251, 324],
  },
  {
    genesis_token_id: 5430,
    wearable_ids: [248, 263],
  },
  {
    genesis_token_id: 5431,
    wearable_ids: [259, 383],
  },
  {
    genesis_token_id: 5432,
    wearable_ids: [268, 424],
  },
  {
    genesis_token_id: 5433,
    wearable_ids: [442, 407],
  },
  {
    genesis_token_id: 5434,
    wearable_ids: [409, 366],
  },
  {
    genesis_token_id: 5435,
    wearable_ids: [347, 287],
  },
  {
    genesis_token_id: 5436,
    wearable_ids: [397, 405],
  },
  {
    genesis_token_id: 5437,
    wearable_ids: [266, 291],
  },
  {
    genesis_token_id: 5438,
    wearable_ids: [286, 277],
  },
  {
    genesis_token_id: 5439,
    wearable_ids: [406, 326],
  },
  {
    genesis_token_id: 5440,
    wearable_ids: [292, 283],
  },
  {
    genesis_token_id: 5441,
    wearable_ids: [362, 424],
  },
  {
    genesis_token_id: 5442,
    wearable_ids: [339, 377],
  },
  {
    genesis_token_id: 5443,
    wearable_ids: [287, 283],
  },
  {
    genesis_token_id: 5444,
    wearable_ids: [368, 297],
  },
  {
    genesis_token_id: 5445,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 5446,
    wearable_ids: [346, 316],
  },
  {
    genesis_token_id: 5447,
    wearable_ids: [351, 370],
  },
  {
    genesis_token_id: 5448,
    wearable_ids: [263, 256],
  },
  {
    genesis_token_id: 5449,
    wearable_ids: [400, 364],
  },
  {
    genesis_token_id: 5450,
    wearable_ids: [339, 259],
  },
  {
    genesis_token_id: 5451,
    wearable_ids: [365, 348],
  },
  {
    genesis_token_id: 5452,
    wearable_ids: [324, 415],
  },
  {
    genesis_token_id: 5453,
    wearable_ids: [274, 287],
  },
  {
    genesis_token_id: 5454,
    wearable_ids: [331, 291],
  },
  {
    genesis_token_id: 5455,
    wearable_ids: [332, 409],
  },
  {
    genesis_token_id: 5456,
    wearable_ids: [314, 437],
  },
  {
    genesis_token_id: 5457,
    wearable_ids: [374, 444],
  },
  {
    genesis_token_id: 5458,
    wearable_ids: [336, 330],
  },
  {
    genesis_token_id: 5459,
    wearable_ids: [437, 438],
  },
  {
    genesis_token_id: 5460,
    wearable_ids: [286, 364],
  },
  {
    genesis_token_id: 5461,
    wearable_ids: [303, 387],
  },
  {
    genesis_token_id: 5462,
    wearable_ids: [289, 408],
  },
  {
    genesis_token_id: 5463,
    wearable_ids: [433, 424],
  },
  {
    genesis_token_id: 5464,
    wearable_ids: [324, 383],
  },
  {
    genesis_token_id: 5465,
    wearable_ids: [314, 283],
  },
  {
    genesis_token_id: 5466,
    wearable_ids: [251, 387],
  },
  {
    genesis_token_id: 5467,
    wearable_ids: [319, 286],
  },
  {
    genesis_token_id: 5468,
    wearable_ids: [342, 404],
  },
  {
    genesis_token_id: 5469,
    wearable_ids: [303, 389],
  },
  {
    genesis_token_id: 5470,
    wearable_ids: [338, 274],
  },
  {
    genesis_token_id: 5471,
    wearable_ids: [254, 373],
  },
  {
    genesis_token_id: 5472,
    wearable_ids: [273, 256],
  },
  {
    genesis_token_id: 5473,
    wearable_ids: [339, 289],
  },
  {
    genesis_token_id: 5474,
    wearable_ids: [276, 423],
  },
  {
    genesis_token_id: 5475,
    wearable_ids: [325, 406],
  },
  {
    genesis_token_id: 5476,
    wearable_ids: [346, 372],
  },
  {
    genesis_token_id: 5477,
    wearable_ids: [268, 431],
  },
  {
    genesis_token_id: 5478,
    wearable_ids: [344, 338],
  },
  {
    genesis_token_id: 5479,
    wearable_ids: [362, 267],
  },
  {
    genesis_token_id: 5480,
    wearable_ids: [284, 317],
  },
  {
    genesis_token_id: 5481,
    wearable_ids: [315, 332],
  },
  {
    genesis_token_id: 5482,
    wearable_ids: [262, 305],
  },
  {
    genesis_token_id: 5483,
    wearable_ids: [437, 423],
  },
  {
    genesis_token_id: 5484,
    wearable_ids: [264, 341],
  },
  {
    genesis_token_id: 5485,
    wearable_ids: [377, 346],
  },
  {
    genesis_token_id: 5486,
    wearable_ids: [433, 295],
  },
  {
    genesis_token_id: 5487,
    wearable_ids: [384, 349],
  },
  {
    genesis_token_id: 5488,
    wearable_ids: [280, 364],
  },
  {
    genesis_token_id: 5489,
    wearable_ids: [346, 305],
  },
  {
    genesis_token_id: 5490,
    wearable_ids: [428, 314],
  },
  {
    genesis_token_id: 5491,
    wearable_ids: [407, 433],
  },
  {
    genesis_token_id: 5492,
    wearable_ids: [316, 288],
  },
  {
    genesis_token_id: 5493,
    wearable_ids: [276, 360],
  },
  {
    genesis_token_id: 5494,
    wearable_ids: [376, 433],
  },
  {
    genesis_token_id: 5495,
    wearable_ids: [434, 385],
  },
  {
    genesis_token_id: 5496,
    wearable_ids: [291, 343],
  },
  {
    genesis_token_id: 5497,
    wearable_ids: [256, 422],
  },
  {
    genesis_token_id: 5498,
    wearable_ids: [350, 271],
  },
  {
    genesis_token_id: 5499,
    wearable_ids: [429, 341],
  },
  {
    genesis_token_id: 5500,
    wearable_ids: [362, 287],
  },
  {
    genesis_token_id: 5501,
    wearable_ids: [377, 391],
  },
  {
    genesis_token_id: 5502,
    wearable_ids: [368, 436],
  },
  {
    genesis_token_id: 5503,
    wearable_ids: [280, 422],
  },
  {
    genesis_token_id: 5504,
    wearable_ids: [369, 407],
  },
  {
    genesis_token_id: 5505,
    wearable_ids: [270, 436],
  },
  {
    genesis_token_id: 5506,
    wearable_ids: [294, 426],
  },
  {
    genesis_token_id: 5507,
    wearable_ids: [277, 366],
  },
  {
    genesis_token_id: 5508,
    wearable_ids: [271, 369],
  },
  {
    genesis_token_id: 5509,
    wearable_ids: [317, 279],
  },
  {
    genesis_token_id: 5510,
    wearable_ids: [326, 271],
  },
  {
    genesis_token_id: 5511,
    wearable_ids: [363, 266],
  },
  {
    genesis_token_id: 5512,
    wearable_ids: [410, 412],
  },
  {
    genesis_token_id: 5513,
    wearable_ids: [363, 370],
  },
  {
    genesis_token_id: 5514,
    wearable_ids: [272, 332],
  },
  {
    genesis_token_id: 5515,
    wearable_ids: [284, 288],
  },
  {
    genesis_token_id: 5516,
    wearable_ids: [389, 331],
  },
  {
    genesis_token_id: 5517,
    wearable_ids: [370, 339],
  },
  {
    genesis_token_id: 5518,
    wearable_ids: [355, 289],
  },
  {
    genesis_token_id: 5519,
    wearable_ids: [272, 386],
  },
  {
    genesis_token_id: 5520,
    wearable_ids: [340, 354],
  },
  {
    genesis_token_id: 5521,
    wearable_ids: [410, 303],
  },
  {
    genesis_token_id: 5522,
    wearable_ids: [251, 416],
  },
  {
    genesis_token_id: 5523,
    wearable_ids: [274, 436],
  },
  {
    genesis_token_id: 5524,
    wearable_ids: [351, 343],
  },
  {
    genesis_token_id: 5525,
    wearable_ids: [352, 284],
  },
  {
    genesis_token_id: 5526,
    wearable_ids: [273, 435],
  },
  {
    genesis_token_id: 5527,
    wearable_ids: [435, 408],
  },
  {
    genesis_token_id: 5528,
    wearable_ids: [386, 299],
  },
  {
    genesis_token_id: 5529,
    wearable_ids: [256, 283],
  },
  {
    genesis_token_id: 5530,
    wearable_ids: [272, 424],
  },
  {
    genesis_token_id: 5531,
    wearable_ids: [317, 306],
  },
  {
    genesis_token_id: 5532,
    wearable_ids: [341, 326],
  },
  {
    genesis_token_id: 5533,
    wearable_ids: [304, 253],
  },
  {
    genesis_token_id: 5534,
    wearable_ids: [284, 256],
  },
  {
    genesis_token_id: 5535,
    wearable_ids: [340, 373],
  },
  {
    genesis_token_id: 5536,
    wearable_ids: [266, 291],
  },
  {
    genesis_token_id: 5537,
    wearable_ids: [308, 348],
  },
  {
    genesis_token_id: 5538,
    wearable_ids: [444, 383],
  },
  {
    genesis_token_id: 5539,
    wearable_ids: [404, 324],
  },
  {
    genesis_token_id: 5540,
    wearable_ids: [408, 322],
  },
  {
    genesis_token_id: 5541,
    wearable_ids: [437, 355],
  },
  {
    genesis_token_id: 5542,
    wearable_ids: [362, 408],
  },
  {
    genesis_token_id: 5543,
    wearable_ids: [335, 272],
  },
  {
    genesis_token_id: 5544,
    wearable_ids: [408, 311],
  },
  {
    genesis_token_id: 5545,
    wearable_ids: [338, 300],
  },
  {
    genesis_token_id: 5546,
    wearable_ids: [299, 396],
  },
  {
    genesis_token_id: 5547,
    wearable_ids: [404, 366],
  },
  {
    genesis_token_id: 5548,
    wearable_ids: [428, 335],
  },
  {
    genesis_token_id: 5549,
    wearable_ids: [347, 286],
  },
  {
    genesis_token_id: 5550,
    wearable_ids: [254, 274],
  },
  {
    genesis_token_id: 5551,
    wearable_ids: [364, 319],
  },
  {
    genesis_token_id: 5552,
    wearable_ids: [442, 332],
  },
  {
    genesis_token_id: 5553,
    wearable_ids: [443, 425],
  },
  {
    genesis_token_id: 5554,
    wearable_ids: [429, 340],
  },
  {
    genesis_token_id: 5555,
    wearable_ids: [420, 319],
  },
  {
    genesis_token_id: 5556,
    wearable_ids: [248, 286],
  },
  {
    genesis_token_id: 5557,
    wearable_ids: [308, 431],
  },
  {
    genesis_token_id: 5558,
    wearable_ids: [355, 429],
  },
  {
    genesis_token_id: 5559,
    wearable_ids: [352, 290],
  },
  {
    genesis_token_id: 5560,
    wearable_ids: [387, 285],
  },
  {
    genesis_token_id: 5561,
    wearable_ids: [326, 413],
  },
  {
    genesis_token_id: 5562,
    wearable_ids: [276, 406],
  },
  {
    genesis_token_id: 5563,
    wearable_ids: [296, 444],
  },
  {
    genesis_token_id: 5564,
    wearable_ids: [420, 402],
  },
  {
    genesis_token_id: 5565,
    wearable_ids: [314, 307],
  },
  {
    genesis_token_id: 5566,
    wearable_ids: [410, 318],
  },
  {
    genesis_token_id: 5567,
    wearable_ids: [433, 246],
  },
  {
    genesis_token_id: 5568,
    wearable_ids: [433, 429],
  },
  {
    genesis_token_id: 5569,
    wearable_ids: [444, 273],
  },
  {
    genesis_token_id: 5570,
    wearable_ids: [314, 278],
  },
  {
    genesis_token_id: 5571,
    wearable_ids: [442, 258],
  },
  {
    genesis_token_id: 5572,
    wearable_ids: [286, 371],
  },
  {
    genesis_token_id: 5573,
    wearable_ids: [324, 248],
  },
  {
    genesis_token_id: 5574,
    wearable_ids: [420, 344],
  },
  {
    genesis_token_id: 5575,
    wearable_ids: [378, 255],
  },
  {
    genesis_token_id: 5576,
    wearable_ids: [376, 426],
  },
  {
    genesis_token_id: 5577,
    wearable_ids: [297, 295],
  },
  {
    genesis_token_id: 5578,
    wearable_ids: [271, 324],
  },
  {
    genesis_token_id: 5579,
    wearable_ids: [376, 316],
  },
  {
    genesis_token_id: 5580,
    wearable_ids: [374, 413],
  },
  {
    genesis_token_id: 5581,
    wearable_ids: [412, 415],
  },
  {
    genesis_token_id: 5582,
    wearable_ids: [442, 315],
  },
  {
    genesis_token_id: 5583,
    wearable_ids: [364, 304],
  },
  {
    genesis_token_id: 5584,
    wearable_ids: [308, 297],
  },
  {
    genesis_token_id: 5585,
    wearable_ids: [425, 445],
  },
  {
    genesis_token_id: 5586,
    wearable_ids: [336, 382],
  },
  {
    genesis_token_id: 5587,
    wearable_ids: [346, 339],
  },
  {
    genesis_token_id: 5588,
    wearable_ids: [382, 420],
  },
  {
    genesis_token_id: 5589,
    wearable_ids: [278, 344],
  },
  {
    genesis_token_id: 5590,
    wearable_ids: [251, 442],
  },
  {
    genesis_token_id: 5591,
    wearable_ids: [274, 347],
  },
  {
    genesis_token_id: 5592,
    wearable_ids: [326, 429],
  },
  {
    genesis_token_id: 5593,
    wearable_ids: [355, 344],
  },
  {
    genesis_token_id: 5594,
    wearable_ids: [268, 422],
  },
  {
    genesis_token_id: 5595,
    wearable_ids: [432, 300],
  },
  {
    genesis_token_id: 5596,
    wearable_ids: [413, 330],
  },
  {
    genesis_token_id: 5597,
    wearable_ids: [336, 350],
  },
  {
    genesis_token_id: 5598,
    wearable_ids: [316, 428],
  },
  {
    genesis_token_id: 5599,
    wearable_ids: [343, 352],
  },
  {
    genesis_token_id: 5600,
    wearable_ids: [408, 256],
  },
  {
    genesis_token_id: 5601,
    wearable_ids: [284, 351],
  },
  {
    genesis_token_id: 5602,
    wearable_ids: [331, 379],
  },
  {
    genesis_token_id: 5603,
    wearable_ids: [412, 415],
  },
  {
    genesis_token_id: 5604,
    wearable_ids: [344, 287],
  },
  {
    genesis_token_id: 5605,
    wearable_ids: [355, 317],
  },
  {
    genesis_token_id: 5606,
    wearable_ids: [300, 259],
  },
  {
    genesis_token_id: 5607,
    wearable_ids: [338, 278],
  },
  {
    genesis_token_id: 5608,
    wearable_ids: [422, 351],
  },
  {
    genesis_token_id: 5609,
    wearable_ids: [424, 296],
  },
  {
    genesis_token_id: 5610,
    wearable_ids: [383, 325],
  },
  {
    genesis_token_id: 5611,
    wearable_ids: [290, 296],
  },
  {
    genesis_token_id: 5612,
    wearable_ids: [433, 310],
  },
  {
    genesis_token_id: 5613,
    wearable_ids: [335, 430],
  },
  {
    genesis_token_id: 5614,
    wearable_ids: [251, 262],
  },
  {
    genesis_token_id: 5615,
    wearable_ids: [343, 337],
  },
  {
    genesis_token_id: 5616,
    wearable_ids: [384, 432],
  },
  {
    genesis_token_id: 5617,
    wearable_ids: [286, 335],
  },
  {
    genesis_token_id: 5618,
    wearable_ids: [420, 428],
  },
  {
    genesis_token_id: 5619,
    wearable_ids: [272, 263],
  },
  {
    genesis_token_id: 5620,
    wearable_ids: [259, 353],
  },
  {
    genesis_token_id: 5621,
    wearable_ids: [316, 406],
  },
  {
    genesis_token_id: 5622,
    wearable_ids: [253, 310],
  },
  {
    genesis_token_id: 5623,
    wearable_ids: [304, 352],
  },
  {
    genesis_token_id: 5624,
    wearable_ids: [299, 308],
  },
  {
    genesis_token_id: 5625,
    wearable_ids: [410, 333],
  },
  {
    genesis_token_id: 5626,
    wearable_ids: [265, 404],
  },
  {
    genesis_token_id: 5627,
    wearable_ids: [395, 248],
  },
  {
    genesis_token_id: 5628,
    wearable_ids: [247, 377],
  },
  {
    genesis_token_id: 5629,
    wearable_ids: [251, 373],
  },
  {
    genesis_token_id: 5630,
    wearable_ids: [290, 346],
  },
  {
    genesis_token_id: 5631,
    wearable_ids: [378, 428],
  },
  {
    genesis_token_id: 5632,
    wearable_ids: [415, 259],
  },
  {
    genesis_token_id: 5633,
    wearable_ids: [256, 314],
  },
  {
    genesis_token_id: 5634,
    wearable_ids: [292, 253],
  },
  {
    genesis_token_id: 5635,
    wearable_ids: [400, 333],
  },
  {
    genesis_token_id: 5636,
    wearable_ids: [315, 302],
  },
  {
    genesis_token_id: 5637,
    wearable_ids: [348, 357],
  },
  {
    genesis_token_id: 5638,
    wearable_ids: [299, 411],
  },
  {
    genesis_token_id: 5639,
    wearable_ids: [424, 259],
  },
  {
    genesis_token_id: 5640,
    wearable_ids: [268, 369],
  },
  {
    genesis_token_id: 5641,
    wearable_ids: [253, 343],
  },
  {
    genesis_token_id: 5642,
    wearable_ids: [370, 289],
  },
  {
    genesis_token_id: 5643,
    wearable_ids: [338, 369],
  },
  {
    genesis_token_id: 5644,
    wearable_ids: [344, 304],
  },
  {
    genesis_token_id: 5645,
    wearable_ids: [373, 389],
  },
  {
    genesis_token_id: 5646,
    wearable_ids: [270, 262],
  },
  {
    genesis_token_id: 5647,
    wearable_ids: [300, 310],
  },
  {
    genesis_token_id: 5648,
    wearable_ids: [274, 376],
  },
  {
    genesis_token_id: 5649,
    wearable_ids: [258, 293],
  },
  {
    genesis_token_id: 5650,
    wearable_ids: [332, 335],
  },
  {
    genesis_token_id: 5651,
    wearable_ids: [377, 297],
  },
  {
    genesis_token_id: 5652,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 5653,
    wearable_ids: [306, 279],
  },
  {
    genesis_token_id: 5654,
    wearable_ids: [395, 284],
  },
  {
    genesis_token_id: 5655,
    wearable_ids: [268, 308],
  },
  {
    genesis_token_id: 5656,
    wearable_ids: [410, 278],
  },
  {
    genesis_token_id: 5657,
    wearable_ids: [303, 391],
  },
  {
    genesis_token_id: 5658,
    wearable_ids: [347, 412],
  },
  {
    genesis_token_id: 5659,
    wearable_ids: [423, 315],
  },
  {
    genesis_token_id: 5660,
    wearable_ids: [411, 332],
  },
  {
    genesis_token_id: 5661,
    wearable_ids: [254, 278],
  },
  {
    genesis_token_id: 5662,
    wearable_ids: [397, 431],
  },
  {
    genesis_token_id: 5663,
    wearable_ids: [346, 350],
  },
  {
    genesis_token_id: 5664,
    wearable_ids: [265, 250],
  },
  {
    genesis_token_id: 5665,
    wearable_ids: [383, 444],
  },
  {
    genesis_token_id: 5666,
    wearable_ids: [299, 258],
  },
  {
    genesis_token_id: 5667,
    wearable_ids: [311, 310],
  },
  {
    genesis_token_id: 5668,
    wearable_ids: [306, 359],
  },
  {
    genesis_token_id: 5669,
    wearable_ids: [292, 257],
  },
  {
    genesis_token_id: 5670,
    wearable_ids: [365, 422],
  },
  {
    genesis_token_id: 5671,
    wearable_ids: [344, 249],
  },
  {
    genesis_token_id: 5672,
    wearable_ids: [344, 341],
  },
  {
    genesis_token_id: 5673,
    wearable_ids: [443, 277],
  },
  {
    genesis_token_id: 5674,
    wearable_ids: [354, 268],
  },
  {
    genesis_token_id: 5675,
    wearable_ids: [403, 332],
  },
  {
    genesis_token_id: 5676,
    wearable_ids: [364, 265],
  },
  {
    genesis_token_id: 5677,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 5678,
    wearable_ids: [415, 437],
  },
  {
    genesis_token_id: 5679,
    wearable_ids: [383, 403],
  },
  {
    genesis_token_id: 5680,
    wearable_ids: [385, 358],
  },
  {
    genesis_token_id: 5681,
    wearable_ids: [351, 284],
  },
  {
    genesis_token_id: 5682,
    wearable_ids: [411, 349],
  },
  {
    genesis_token_id: 5683,
    wearable_ids: [362, 342],
  },
  {
    genesis_token_id: 5684,
    wearable_ids: [315, 320],
  },
  {
    genesis_token_id: 5685,
    wearable_ids: [272, 363],
  },
  {
    genesis_token_id: 5686,
    wearable_ids: [272, 409],
  },
  {
    genesis_token_id: 5687,
    wearable_ids: [397, 372],
  },
  {
    genesis_token_id: 5688,
    wearable_ids: [352, 268],
  },
  {
    genesis_token_id: 5689,
    wearable_ids: [297, 301],
  },
  {
    genesis_token_id: 5690,
    wearable_ids: [404, 286],
  },
  {
    genesis_token_id: 5691,
    wearable_ids: [341, 373],
  },
  {
    genesis_token_id: 5692,
    wearable_ids: [349, 289],
  },
  {
    genesis_token_id: 5693,
    wearable_ids: [387, 404],
  },
  {
    genesis_token_id: 5694,
    wearable_ids: [300, 406],
  },
  {
    genesis_token_id: 5695,
    wearable_ids: [389, 413],
  },
  {
    genesis_token_id: 5696,
    wearable_ids: [365, 372],
  },
  {
    genesis_token_id: 5697,
    wearable_ids: [403, 425],
  },
  {
    genesis_token_id: 5698,
    wearable_ids: [377, 295],
  },
  {
    genesis_token_id: 5699,
    wearable_ids: [420, 422],
  },
  {
    genesis_token_id: 5700,
    wearable_ids: [413, 399],
  },
  {
    genesis_token_id: 5701,
    wearable_ids: [325, 369],
  },
  {
    genesis_token_id: 5702,
    wearable_ids: [277, 259],
  },
  {
    genesis_token_id: 5703,
    wearable_ids: [248, 332],
  },
  {
    genesis_token_id: 5704,
    wearable_ids: [259, 340],
  },
  {
    genesis_token_id: 5705,
    wearable_ids: [256, 437],
  },
  {
    genesis_token_id: 5706,
    wearable_ids: [435, 257],
  },
  {
    genesis_token_id: 5707,
    wearable_ids: [306, 385],
  },
  {
    genesis_token_id: 5708,
    wearable_ids: [362, 379],
  },
  {
    genesis_token_id: 5709,
    wearable_ids: [399, 401],
  },
  {
    genesis_token_id: 5710,
    wearable_ids: [376, 444],
  },
  {
    genesis_token_id: 5711,
    wearable_ids: [280, 338],
  },
  {
    genesis_token_id: 5712,
    wearable_ids: [429, 338],
  },
  {
    genesis_token_id: 5713,
    wearable_ids: [335, 437],
  },
  {
    genesis_token_id: 5714,
    wearable_ids: [292, 251],
  },
  {
    genesis_token_id: 5715,
    wearable_ids: [264, 389],
  },
  {
    genesis_token_id: 5716,
    wearable_ids: [259, 257],
  },
  {
    genesis_token_id: 5717,
    wearable_ids: [407, 368],
  },
  {
    genesis_token_id: 5718,
    wearable_ids: [340, 425],
  },
  {
    genesis_token_id: 5719,
    wearable_ids: [300, 364],
  },
  {
    genesis_token_id: 5720,
    wearable_ids: [363, 383],
  },
  {
    genesis_token_id: 5721,
    wearable_ids: [399, 344],
  },
  {
    genesis_token_id: 5722,
    wearable_ids: [425, 269],
  },
  {
    genesis_token_id: 5723,
    wearable_ids: [253, 434],
  },
  {
    genesis_token_id: 5724,
    wearable_ids: [335, 428],
  },
  {
    genesis_token_id: 5725,
    wearable_ids: [348, 338],
  },
  {
    genesis_token_id: 5726,
    wearable_ids: [354, 356],
  },
  {
    genesis_token_id: 5727,
    wearable_ids: [395, 335],
  },
  {
    genesis_token_id: 5728,
    wearable_ids: [289, 348],
  },
  {
    genesis_token_id: 5729,
    wearable_ids: [410, 416],
  },
  {
    genesis_token_id: 5730,
    wearable_ids: [284, 397],
  },
  {
    genesis_token_id: 5731,
    wearable_ids: [415, 297],
  },
  {
    genesis_token_id: 5732,
    wearable_ids: [365, 419],
  },
  {
    genesis_token_id: 5733,
    wearable_ids: [255, 433],
  },
  {
    genesis_token_id: 5734,
    wearable_ids: [299, 419],
  },
  {
    genesis_token_id: 5735,
    wearable_ids: [319, 400],
  },
  {
    genesis_token_id: 5736,
    wearable_ids: [291, 287],
  },
  {
    genesis_token_id: 5737,
    wearable_ids: [411, 311],
  },
  {
    genesis_token_id: 5738,
    wearable_ids: [278, 422],
  },
  {
    genesis_token_id: 5739,
    wearable_ids: [403, 261],
  },
  {
    genesis_token_id: 5740,
    wearable_ids: [397, 254],
  },
  {
    genesis_token_id: 5741,
    wearable_ids: [304, 301],
  },
  {
    genesis_token_id: 5742,
    wearable_ids: [326, 363],
  },
  {
    genesis_token_id: 5743,
    wearable_ids: [373, 353],
  },
  {
    genesis_token_id: 5744,
    wearable_ids: [351, 295],
  },
  {
    genesis_token_id: 5745,
    wearable_ids: [365, 377],
  },
  {
    genesis_token_id: 5746,
    wearable_ids: [276, 384],
  },
  {
    genesis_token_id: 5747,
    wearable_ids: [376, 325],
  },
  {
    genesis_token_id: 5748,
    wearable_ids: [273, 396],
  },
  {
    genesis_token_id: 5749,
    wearable_ids: [348, 445],
  },
  {
    genesis_token_id: 5750,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 5751,
    wearable_ids: [436, 375],
  },
  {
    genesis_token_id: 5752,
    wearable_ids: [426, 387],
  },
  {
    genesis_token_id: 5753,
    wearable_ids: [442, 314],
  },
  {
    genesis_token_id: 5754,
    wearable_ids: [373, 307],
  },
  {
    genesis_token_id: 5755,
    wearable_ids: [385, 431],
  },
  {
    genesis_token_id: 5756,
    wearable_ids: [408, 299],
  },
  {
    genesis_token_id: 5757,
    wearable_ids: [428, 320],
  },
  {
    genesis_token_id: 5758,
    wearable_ids: [266, 313],
  },
  {
    genesis_token_id: 5759,
    wearable_ids: [415, 273],
  },
  {
    genesis_token_id: 5760,
    wearable_ids: [314, 344],
  },
  {
    genesis_token_id: 5761,
    wearable_ids: [397, 303],
  },
  {
    genesis_token_id: 5762,
    wearable_ids: [297, 259],
  },
  {
    genesis_token_id: 5763,
    wearable_ids: [274, 298],
  },
  {
    genesis_token_id: 5764,
    wearable_ids: [286, 369],
  },
  {
    genesis_token_id: 5765,
    wearable_ids: [425, 412],
  },
  {
    genesis_token_id: 5766,
    wearable_ids: [248, 293],
  },
  {
    genesis_token_id: 5767,
    wearable_ids: [315, 373],
  },
  {
    genesis_token_id: 5768,
    wearable_ids: [257, 333],
  },
  {
    genesis_token_id: 5769,
    wearable_ids: [306, 316],
  },
  {
    genesis_token_id: 5770,
    wearable_ids: [256, 396],
  },
  {
    genesis_token_id: 5771,
    wearable_ids: [297, 272],
  },
  {
    genesis_token_id: 5772,
    wearable_ids: [297, 293],
  },
  {
    genesis_token_id: 5773,
    wearable_ids: [264, 343],
  },
  {
    genesis_token_id: 5774,
    wearable_ids: [337, 400],
  },
  {
    genesis_token_id: 5775,
    wearable_ids: [384, 385],
  },
  {
    genesis_token_id: 5776,
    wearable_ids: [364, 248],
  },
  {
    genesis_token_id: 5777,
    wearable_ids: [287, 263],
  },
  {
    genesis_token_id: 5778,
    wearable_ids: [264, 280],
  },
  {
    genesis_token_id: 5779,
    wearable_ids: [319, 384],
  },
  {
    genesis_token_id: 5780,
    wearable_ids: [383, 363],
  },
  {
    genesis_token_id: 5781,
    wearable_ids: [253, 314],
  },
  {
    genesis_token_id: 5782,
    wearable_ids: [338, 397],
  },
  {
    genesis_token_id: 5783,
    wearable_ids: [372, 382],
  },
  {
    genesis_token_id: 5784,
    wearable_ids: [415, 338],
  },
  {
    genesis_token_id: 5785,
    wearable_ids: [291, 408],
  },
  {
    genesis_token_id: 5786,
    wearable_ids: [310, 423],
  },
  {
    genesis_token_id: 5787,
    wearable_ids: [256, 263],
  },
  {
    genesis_token_id: 5788,
    wearable_ids: [263, 412],
  },
  {
    genesis_token_id: 5789,
    wearable_ids: [413, 375],
  },
  {
    genesis_token_id: 5790,
    wearable_ids: [386, 420],
  },
  {
    genesis_token_id: 5791,
    wearable_ids: [410, 372],
  },
  {
    genesis_token_id: 5792,
    wearable_ids: [348, 337],
  },
  {
    genesis_token_id: 5793,
    wearable_ids: [382, 420],
  },
  {
    genesis_token_id: 5794,
    wearable_ids: [257, 382],
  },
  {
    genesis_token_id: 5795,
    wearable_ids: [362, 361],
  },
  {
    genesis_token_id: 5796,
    wearable_ids: [291, 297],
  },
  {
    genesis_token_id: 5797,
    wearable_ids: [406, 388],
  },
  {
    genesis_token_id: 5798,
    wearable_ids: [426, 248],
  },
  {
    genesis_token_id: 5799,
    wearable_ids: [445, 327],
  },
  {
    genesis_token_id: 5800,
    wearable_ids: [376, 356],
  },
  {
    genesis_token_id: 5801,
    wearable_ids: [406, 437],
  },
  {
    genesis_token_id: 5802,
    wearable_ids: [346, 377],
  },
  {
    genesis_token_id: 5803,
    wearable_ids: [384, 284],
  },
  {
    genesis_token_id: 5804,
    wearable_ids: [412, 308],
  },
  {
    genesis_token_id: 5805,
    wearable_ids: [287, 310],
  },
  {
    genesis_token_id: 5806,
    wearable_ids: [422, 278],
  },
  {
    genesis_token_id: 5807,
    wearable_ids: [415, 297],
  },
  {
    genesis_token_id: 5808,
    wearable_ids: [264, 383],
  },
  {
    genesis_token_id: 5809,
    wearable_ids: [352, 357],
  },
  {
    genesis_token_id: 5810,
    wearable_ids: [355, 251],
  },
  {
    genesis_token_id: 5811,
    wearable_ids: [407, 434],
  },
  {
    genesis_token_id: 5812,
    wearable_ids: [410, 350],
  },
  {
    genesis_token_id: 5813,
    wearable_ids: [411, 276],
  },
  {
    genesis_token_id: 5814,
    wearable_ids: [352, 368],
  },
  {
    genesis_token_id: 5815,
    wearable_ids: [272, 250],
  },
  {
    genesis_token_id: 5816,
    wearable_ids: [434, 441],
  },
  {
    genesis_token_id: 5817,
    wearable_ids: [303, 323],
  },
  {
    genesis_token_id: 5818,
    wearable_ids: [420, 316],
  },
  {
    genesis_token_id: 5819,
    wearable_ids: [395, 362],
  },
  {
    genesis_token_id: 5820,
    wearable_ids: [434, 316],
  },
  {
    genesis_token_id: 5821,
    wearable_ids: [442, 259],
  },
  {
    genesis_token_id: 5822,
    wearable_ids: [338, 422],
  },
  {
    genesis_token_id: 5823,
    wearable_ids: [331, 315],
  },
  {
    genesis_token_id: 5824,
    wearable_ids: [365, 265],
  },
  {
    genesis_token_id: 5825,
    wearable_ids: [319, 403],
  },
  {
    genesis_token_id: 5826,
    wearable_ids: [316, 406],
  },
  {
    genesis_token_id: 5827,
    wearable_ids: [384, 403],
  },
  {
    genesis_token_id: 5828,
    wearable_ids: [339, 386],
  },
  {
    genesis_token_id: 5829,
    wearable_ids: [396, 316],
  },
  {
    genesis_token_id: 5830,
    wearable_ids: [397, 255],
  },
  {
    genesis_token_id: 5831,
    wearable_ids: [382, 363],
  },
  {
    genesis_token_id: 5832,
    wearable_ids: [400, 434],
  },
  {
    genesis_token_id: 5833,
    wearable_ids: [251, 274],
  },
  {
    genesis_token_id: 5834,
    wearable_ids: [365, 314],
  },
  {
    genesis_token_id: 5835,
    wearable_ids: [339, 411],
  },
  {
    genesis_token_id: 5836,
    wearable_ids: [286, 335],
  },
  {
    genesis_token_id: 5837,
    wearable_ids: [355, 428],
  },
  {
    genesis_token_id: 5838,
    wearable_ids: [287, 371],
  },
  {
    genesis_token_id: 5839,
    wearable_ids: [277, 344],
  },
  {
    genesis_token_id: 5840,
    wearable_ids: [437, 342],
  },
  {
    genesis_token_id: 5841,
    wearable_ids: [286, 418],
  },
  {
    genesis_token_id: 5842,
    wearable_ids: [431, 385],
  },
  {
    genesis_token_id: 5843,
    wearable_ids: [444, 377],
  },
  {
    genesis_token_id: 5844,
    wearable_ids: [325, 409],
  },
  {
    genesis_token_id: 5845,
    wearable_ids: [407, 420],
  },
  {
    genesis_token_id: 5846,
    wearable_ids: [337, 338],
  },
  {
    genesis_token_id: 5847,
    wearable_ids: [443, 425],
  },
  {
    genesis_token_id: 5848,
    wearable_ids: [429, 411],
  },
  {
    genesis_token_id: 5849,
    wearable_ids: [428, 308],
  },
  {
    genesis_token_id: 5850,
    wearable_ids: [413, 302],
  },
  {
    genesis_token_id: 5851,
    wearable_ids: [287, 301],
  },
  {
    genesis_token_id: 5852,
    wearable_ids: [355, 331],
  },
  {
    genesis_token_id: 5853,
    wearable_ids: [364, 290],
  },
  {
    genesis_token_id: 5854,
    wearable_ids: [355, 273],
  },
  {
    genesis_token_id: 5855,
    wearable_ids: [363, 412],
  },
  {
    genesis_token_id: 5856,
    wearable_ids: [411, 313],
  },
  {
    genesis_token_id: 5857,
    wearable_ids: [370, 411],
  },
  {
    genesis_token_id: 5858,
    wearable_ids: [271, 437],
  },
  {
    genesis_token_id: 5859,
    wearable_ids: [346, 368],
  },
  {
    genesis_token_id: 5860,
    wearable_ids: [344, 349],
  },
  {
    genesis_token_id: 5861,
    wearable_ids: [273, 300],
  },
  {
    genesis_token_id: 5862,
    wearable_ids: [413, 350],
  },
  {
    genesis_token_id: 5863,
    wearable_ids: [445, 270],
  },
  {
    genesis_token_id: 5864,
    wearable_ids: [284, 364],
  },
  {
    genesis_token_id: 5865,
    wearable_ids: [326, 417],
  },
  {
    genesis_token_id: 5866,
    wearable_ids: [343, 433],
  },
  {
    genesis_token_id: 5867,
    wearable_ids: [354, 359],
  },
  {
    genesis_token_id: 5868,
    wearable_ids: [347, 270],
  },
  {
    genesis_token_id: 5869,
    wearable_ids: [432, 338],
  },
  {
    genesis_token_id: 5870,
    wearable_ids: [443, 382],
  },
  {
    genesis_token_id: 5871,
    wearable_ids: [315, 339],
  },
  {
    genesis_token_id: 5872,
    wearable_ids: [315, 365],
  },
  {
    genesis_token_id: 5873,
    wearable_ids: [383, 433],
  },
  {
    genesis_token_id: 5874,
    wearable_ids: [304, 283],
  },
  {
    genesis_token_id: 5875,
    wearable_ids: [370, 262],
  },
  {
    genesis_token_id: 5876,
    wearable_ids: [266, 354],
  },
  {
    genesis_token_id: 5877,
    wearable_ids: [396, 405],
  },
  {
    genesis_token_id: 5878,
    wearable_ids: [271, 420],
  },
  {
    genesis_token_id: 5879,
    wearable_ids: [262, 413],
  },
  {
    genesis_token_id: 5880,
    wearable_ids: [404, 266],
  },
  {
    genesis_token_id: 5881,
    wearable_ids: [270, 277],
  },
  {
    genesis_token_id: 5882,
    wearable_ids: [247, 340],
  },
  {
    genesis_token_id: 5883,
    wearable_ids: [337, 295],
  },
  {
    genesis_token_id: 5884,
    wearable_ids: [315, 317],
  },
  {
    genesis_token_id: 5885,
    wearable_ids: [325, 258],
  },
  {
    genesis_token_id: 5886,
    wearable_ids: [256, 292],
  },
  {
    genesis_token_id: 5887,
    wearable_ids: [311, 379],
  },
  {
    genesis_token_id: 5888,
    wearable_ids: [371, 364],
  },
  {
    genesis_token_id: 5889,
    wearable_ids: [346, 395],
  },
  {
    genesis_token_id: 5890,
    wearable_ids: [378, 344],
  },
  {
    genesis_token_id: 5891,
    wearable_ids: [311, 360],
  },
  {
    genesis_token_id: 5892,
    wearable_ids: [371, 435],
  },
  {
    genesis_token_id: 5893,
    wearable_ids: [337, 318],
  },
  {
    genesis_token_id: 5894,
    wearable_ids: [370, 287],
  },
  {
    genesis_token_id: 5895,
    wearable_ids: [370, 360],
  },
  {
    genesis_token_id: 5896,
    wearable_ids: [292, 375],
  },
  {
    genesis_token_id: 5897,
    wearable_ids: [369, 385],
  },
  {
    genesis_token_id: 5898,
    wearable_ids: [403, 312],
  },
  {
    genesis_token_id: 5899,
    wearable_ids: [415, 330],
  },
  {
    genesis_token_id: 5900,
    wearable_ids: [374, 368],
  },
  {
    genesis_token_id: 5901,
    wearable_ids: [271, 403],
  },
  {
    genesis_token_id: 5902,
    wearable_ids: [299, 263],
  },
  {
    genesis_token_id: 5903,
    wearable_ids: [404, 255],
  },
  {
    genesis_token_id: 5904,
    wearable_ids: [429, 315],
  },
  {
    genesis_token_id: 5905,
    wearable_ids: [284, 258],
  },
  {
    genesis_token_id: 5906,
    wearable_ids: [248, 247],
  },
  {
    genesis_token_id: 5907,
    wearable_ids: [385, 287],
  },
  {
    genesis_token_id: 5908,
    wearable_ids: [376, 412],
  },
  {
    genesis_token_id: 5909,
    wearable_ids: [278, 251],
  },
  {
    genesis_token_id: 5910,
    wearable_ids: [311, 247],
  },
  {
    genesis_token_id: 5911,
    wearable_ids: [273, 398],
  },
  {
    genesis_token_id: 5912,
    wearable_ids: [248, 314],
  },
  {
    genesis_token_id: 5913,
    wearable_ids: [319, 408],
  },
  {
    genesis_token_id: 5914,
    wearable_ids: [382, 400],
  },
  {
    genesis_token_id: 5915,
    wearable_ids: [349, 294],
  },
  {
    genesis_token_id: 5916,
    wearable_ids: [258, 254],
  },
  {
    genesis_token_id: 5917,
    wearable_ids: [341, 349],
  },
  {
    genesis_token_id: 5918,
    wearable_ids: [271, 270],
  },
  {
    genesis_token_id: 5919,
    wearable_ids: [432, 415],
  },
  {
    genesis_token_id: 5920,
    wearable_ids: [278, 261],
  },
  {
    genesis_token_id: 5921,
    wearable_ids: [336, 289],
  },
  {
    genesis_token_id: 5922,
    wearable_ids: [415, 275],
  },
  {
    genesis_token_id: 5923,
    wearable_ids: [435, 289],
  },
  {
    genesis_token_id: 5924,
    wearable_ids: [352, 362],
  },
  {
    genesis_token_id: 5925,
    wearable_ids: [339, 388],
  },
  {
    genesis_token_id: 5926,
    wearable_ids: [395, 317],
  },
  {
    genesis_token_id: 5927,
    wearable_ids: [254, 371],
  },
  {
    genesis_token_id: 5928,
    wearable_ids: [266, 383],
  },
  {
    genesis_token_id: 5929,
    wearable_ids: [403, 341],
  },
  {
    genesis_token_id: 5930,
    wearable_ids: [338, 350],
  },
  {
    genesis_token_id: 5931,
    wearable_ids: [412, 368],
  },
  {
    genesis_token_id: 5932,
    wearable_ids: [435, 348],
  },
  {
    genesis_token_id: 5933,
    wearable_ids: [296, 347],
  },
  {
    genesis_token_id: 5934,
    wearable_ids: [403, 347],
  },
  {
    genesis_token_id: 5935,
    wearable_ids: [431, 415],
  },
  {
    genesis_token_id: 5936,
    wearable_ids: [317, 382],
  },
  {
    genesis_token_id: 5937,
    wearable_ids: [375, 383],
  },
  {
    genesis_token_id: 5938,
    wearable_ids: [259, 320],
  },
  {
    genesis_token_id: 5939,
    wearable_ids: [263, 355],
  },
  {
    genesis_token_id: 5940,
    wearable_ids: [311, 384],
  },
  {
    genesis_token_id: 5941,
    wearable_ids: [325, 422],
  },
  {
    genesis_token_id: 5942,
    wearable_ids: [436, 347],
  },
  {
    genesis_token_id: 5943,
    wearable_ids: [316, 365],
  },
  {
    genesis_token_id: 5944,
    wearable_ids: [385, 336],
  },
  {
    genesis_token_id: 5945,
    wearable_ids: [295, 292],
  },
  {
    genesis_token_id: 5946,
    wearable_ids: [443, 272],
  },
  {
    genesis_token_id: 5947,
    wearable_ids: [339, 417],
  },
  {
    genesis_token_id: 5948,
    wearable_ids: [351, 336],
  },
  {
    genesis_token_id: 5949,
    wearable_ids: [344, 400],
  },
  {
    genesis_token_id: 5950,
    wearable_ids: [411, 406],
  },
  {
    genesis_token_id: 5951,
    wearable_ids: [336, 264],
  },
  {
    genesis_token_id: 5952,
    wearable_ids: [289, 338],
  },
  {
    genesis_token_id: 5953,
    wearable_ids: [406, 296],
  },
  {
    genesis_token_id: 5954,
    wearable_ids: [277, 263],
  },
  {
    genesis_token_id: 5955,
    wearable_ids: [274, 429],
  },
  {
    genesis_token_id: 5956,
    wearable_ids: [335, 407],
  },
  {
    genesis_token_id: 5957,
    wearable_ids: [363, 343],
  },
  {
    genesis_token_id: 5958,
    wearable_ids: [364, 429],
  },
  {
    genesis_token_id: 5959,
    wearable_ids: [264, 395],
  },
  {
    genesis_token_id: 5960,
    wearable_ids: [301, 397],
  },
  {
    genesis_token_id: 5961,
    wearable_ids: [364, 339],
  },
  {
    genesis_token_id: 5962,
    wearable_ids: [349, 304],
  },
  {
    genesis_token_id: 5963,
    wearable_ids: [423, 311],
  },
  {
    genesis_token_id: 5964,
    wearable_ids: [436, 340],
  },
  {
    genesis_token_id: 5965,
    wearable_ids: [290, 259],
  },
  {
    genesis_token_id: 5966,
    wearable_ids: [368, 406],
  },
  {
    genesis_token_id: 5967,
    wearable_ids: [311, 414],
  },
  {
    genesis_token_id: 5968,
    wearable_ids: [264, 395],
  },
  {
    genesis_token_id: 5969,
    wearable_ids: [273, 347],
  },
  {
    genesis_token_id: 5970,
    wearable_ids: [264, 352],
  },
  {
    genesis_token_id: 5971,
    wearable_ids: [406, 416],
  },
  {
    genesis_token_id: 5972,
    wearable_ids: [403, 343],
  },
  {
    genesis_token_id: 5973,
    wearable_ids: [248, 408],
  },
  {
    genesis_token_id: 5974,
    wearable_ids: [406, 378],
  },
  {
    genesis_token_id: 5975,
    wearable_ids: [336, 387],
  },
  {
    genesis_token_id: 5976,
    wearable_ids: [278, 400],
  },
  {
    genesis_token_id: 5977,
    wearable_ids: [332, 425],
  },
  {
    genesis_token_id: 5978,
    wearable_ids: [347, 316],
  },
  {
    genesis_token_id: 5979,
    wearable_ids: [276, 314],
  },
  {
    genesis_token_id: 5980,
    wearable_ids: [247, 359],
  },
  {
    genesis_token_id: 5981,
    wearable_ids: [355, 400],
  },
  {
    genesis_token_id: 5982,
    wearable_ids: [300, 277],
  },
  {
    genesis_token_id: 5983,
    wearable_ids: [435, 289],
  },
  {
    genesis_token_id: 5984,
    wearable_ids: [373, 444],
  },
  {
    genesis_token_id: 5985,
    wearable_ids: [346, 292],
  },
  {
    genesis_token_id: 5986,
    wearable_ids: [326, 311],
  },
  {
    genesis_token_id: 5987,
    wearable_ids: [369, 409],
  },
  {
    genesis_token_id: 5988,
    wearable_ids: [400, 359],
  },
  {
    genesis_token_id: 5989,
    wearable_ids: [373, 424],
  },
  {
    genesis_token_id: 5990,
    wearable_ids: [311, 310],
  },
  {
    genesis_token_id: 5991,
    wearable_ids: [342, 343],
  },
  {
    genesis_token_id: 5992,
    wearable_ids: [415, 369],
  },
  {
    genesis_token_id: 5993,
    wearable_ids: [303, 355],
  },
  {
    genesis_token_id: 5994,
    wearable_ids: [364, 360],
  },
  {
    genesis_token_id: 5995,
    wearable_ids: [248, 297],
  },
  {
    genesis_token_id: 5996,
    wearable_ids: [256, 268],
  },
  {
    genesis_token_id: 5997,
    wearable_ids: [276, 319],
  },
  {
    genesis_token_id: 5998,
    wearable_ids: [259, 262],
  },
  {
    genesis_token_id: 5999,
    wearable_ids: [412, 377],
  },
  {
    genesis_token_id: 6000,
    wearable_ids: [424, 429],
  },
  {
    genesis_token_id: 6001,
    wearable_ids: [304, 361],
  },
  {
    genesis_token_id: 6002,
    wearable_ids: [399, 370],
  },
  {
    genesis_token_id: 6003,
    wearable_ids: [385, 277],
  },
  {
    genesis_token_id: 6004,
    wearable_ids: [436, 271],
  },
  {
    genesis_token_id: 6005,
    wearable_ids: [297, 301],
  },
  {
    genesis_token_id: 6006,
    wearable_ids: [271, 353],
  },
  {
    genesis_token_id: 6007,
    wearable_ids: [374, 436],
  },
  {
    genesis_token_id: 6008,
    wearable_ids: [319, 347],
  },
  {
    genesis_token_id: 6009,
    wearable_ids: [387, 276],
  },
  {
    genesis_token_id: 6010,
    wearable_ids: [263, 277],
  },
  {
    genesis_token_id: 6011,
    wearable_ids: [315, 251],
  },
  {
    genesis_token_id: 6012,
    wearable_ids: [264, 424],
  },
  {
    genesis_token_id: 6013,
    wearable_ids: [277, 295],
  },
  {
    genesis_token_id: 6014,
    wearable_ids: [423, 264],
  },
  {
    genesis_token_id: 6015,
    wearable_ids: [263, 319],
  },
  {
    genesis_token_id: 6016,
    wearable_ids: [290, 275],
  },
  {
    genesis_token_id: 6017,
    wearable_ids: [342, 417],
  },
  {
    genesis_token_id: 6018,
    wearable_ids: [370, 340],
  },
  {
    genesis_token_id: 6019,
    wearable_ids: [306, 343],
  },
  {
    genesis_token_id: 6020,
    wearable_ids: [384, 363],
  },
  {
    genesis_token_id: 6021,
    wearable_ids: [247, 419],
  },
  {
    genesis_token_id: 6022,
    wearable_ids: [436, 408],
  },
  {
    genesis_token_id: 6023,
    wearable_ids: [270, 362],
  },
  {
    genesis_token_id: 6024,
    wearable_ids: [355, 399],
  },
  {
    genesis_token_id: 6025,
    wearable_ids: [299, 306],
  },
  {
    genesis_token_id: 6026,
    wearable_ids: [413, 297],
  },
  {
    genesis_token_id: 6027,
    wearable_ids: [382, 251],
  },
  {
    genesis_token_id: 6028,
    wearable_ids: [311, 392],
  },
  {
    genesis_token_id: 6029,
    wearable_ids: [362, 356],
  },
  {
    genesis_token_id: 6030,
    wearable_ids: [410, 255],
  },
  {
    genesis_token_id: 6031,
    wearable_ids: [429, 385],
  },
  {
    genesis_token_id: 6032,
    wearable_ids: [410, 363],
  },
  {
    genesis_token_id: 6033,
    wearable_ids: [403, 414],
  },
  {
    genesis_token_id: 6034,
    wearable_ids: [247, 262],
  },
  {
    genesis_token_id: 6035,
    wearable_ids: [271, 406],
  },
  {
    genesis_token_id: 6036,
    wearable_ids: [254, 317],
  },
  {
    genesis_token_id: 6037,
    wearable_ids: [432, 327],
  },
  {
    genesis_token_id: 6038,
    wearable_ids: [276, 296],
  },
  {
    genesis_token_id: 6039,
    wearable_ids: [304, 435],
  },
  {
    genesis_token_id: 6040,
    wearable_ids: [429, 430],
  },
  {
    genesis_token_id: 6041,
    wearable_ids: [412, 272],
  },
  {
    genesis_token_id: 6042,
    wearable_ids: [400, 310],
  },
  {
    genesis_token_id: 6043,
    wearable_ids: [310, 371],
  },
  {
    genesis_token_id: 6044,
    wearable_ids: [303, 433],
  },
  {
    genesis_token_id: 6045,
    wearable_ids: [348, 417],
  },
  {
    genesis_token_id: 6046,
    wearable_ids: [407, 443],
  },
  {
    genesis_token_id: 6047,
    wearable_ids: [429, 434],
  },
  {
    genesis_token_id: 6048,
    wearable_ids: [276, 419],
  },
  {
    genesis_token_id: 6049,
    wearable_ids: [254, 297],
  },
  {
    genesis_token_id: 6050,
    wearable_ids: [284, 344],
  },
  {
    genesis_token_id: 6051,
    wearable_ids: [336, 365],
  },
  {
    genesis_token_id: 6052,
    wearable_ids: [271, 426],
  },
  {
    genesis_token_id: 6053,
    wearable_ids: [378, 339],
  },
  {
    genesis_token_id: 6054,
    wearable_ids: [304, 442],
  },
  {
    genesis_token_id: 6055,
    wearable_ids: [349, 253],
  },
  {
    genesis_token_id: 6056,
    wearable_ids: [335, 274],
  },
  {
    genesis_token_id: 6057,
    wearable_ids: [428, 276],
  },
  {
    genesis_token_id: 6058,
    wearable_ids: [370, 268],
  },
  {
    genesis_token_id: 6059,
    wearable_ids: [424, 306],
  },
  {
    genesis_token_id: 6060,
    wearable_ids: [251, 348],
  },
  {
    genesis_token_id: 6061,
    wearable_ids: [385, 289],
  },
  {
    genesis_token_id: 6062,
    wearable_ids: [339, 333],
  },
  {
    genesis_token_id: 6063,
    wearable_ids: [265, 276],
  },
  {
    genesis_token_id: 6064,
    wearable_ids: [346, 433],
  },
  {
    genesis_token_id: 6065,
    wearable_ids: [412, 322],
  },
  {
    genesis_token_id: 6066,
    wearable_ids: [372, 384],
  },
  {
    genesis_token_id: 6067,
    wearable_ids: [433, 292],
  },
  {
    genesis_token_id: 6068,
    wearable_ids: [294, 289],
  },
  {
    genesis_token_id: 6069,
    wearable_ids: [409, 311],
  },
  {
    genesis_token_id: 6070,
    wearable_ids: [311, 266],
  },
  {
    genesis_token_id: 6071,
    wearable_ids: [377, 373],
  },
  {
    genesis_token_id: 6072,
    wearable_ids: [437, 346],
  },
  {
    genesis_token_id: 6073,
    wearable_ids: [369, 410],
  },
  {
    genesis_token_id: 6074,
    wearable_ids: [273, 361],
  },
  {
    genesis_token_id: 6075,
    wearable_ids: [272, 255],
  },
  {
    genesis_token_id: 6076,
    wearable_ids: [268, 370],
  },
  {
    genesis_token_id: 6077,
    wearable_ids: [410, 343],
  },
  {
    genesis_token_id: 6078,
    wearable_ids: [289, 395],
  },
  {
    genesis_token_id: 6079,
    wearable_ids: [363, 382],
  },
  {
    genesis_token_id: 6080,
    wearable_ids: [434, 403],
  },
  {
    genesis_token_id: 6081,
    wearable_ids: [253, 266],
  },
  {
    genesis_token_id: 6082,
    wearable_ids: [306, 317],
  },
  {
    genesis_token_id: 6083,
    wearable_ids: [404, 429],
  },
  {
    genesis_token_id: 6084,
    wearable_ids: [411, 250],
  },
  {
    genesis_token_id: 6085,
    wearable_ids: [347, 411],
  },
  {
    genesis_token_id: 6086,
    wearable_ids: [420, 247],
  },
  {
    genesis_token_id: 6087,
    wearable_ids: [284, 408],
  },
  {
    genesis_token_id: 6088,
    wearable_ids: [263, 373],
  },
  {
    genesis_token_id: 6089,
    wearable_ids: [378, 404],
  },
  {
    genesis_token_id: 6090,
    wearable_ids: [276, 294],
  },
  {
    genesis_token_id: 6091,
    wearable_ids: [397, 358],
  },
  {
    genesis_token_id: 6092,
    wearable_ids: [371, 404],
  },
  {
    genesis_token_id: 6093,
    wearable_ids: [420, 342],
  },
  {
    genesis_token_id: 6094,
    wearable_ids: [273, 343],
  },
  {
    genesis_token_id: 6095,
    wearable_ids: [344, 428],
  },
  {
    genesis_token_id: 6096,
    wearable_ids: [428, 286],
  },
  {
    genesis_token_id: 6097,
    wearable_ids: [270, 266],
  },
  {
    genesis_token_id: 6098,
    wearable_ids: [422, 386],
  },
  {
    genesis_token_id: 6099,
    wearable_ids: [325, 433],
  },
  {
    genesis_token_id: 6100,
    wearable_ids: [386, 292],
  },
  {
    genesis_token_id: 6101,
    wearable_ids: [436, 291],
  },
  {
    genesis_token_id: 6102,
    wearable_ids: [257, 424],
  },
  {
    genesis_token_id: 6103,
    wearable_ids: [429, 331],
  },
  {
    genesis_token_id: 6104,
    wearable_ids: [277, 431],
  },
  {
    genesis_token_id: 6105,
    wearable_ids: [349, 434],
  },
  {
    genesis_token_id: 6106,
    wearable_ids: [383, 315],
  },
  {
    genesis_token_id: 6107,
    wearable_ids: [424, 378],
  },
  {
    genesis_token_id: 6108,
    wearable_ids: [371, 342],
  },
  {
    genesis_token_id: 6109,
    wearable_ids: [396, 405],
  },
  {
    genesis_token_id: 6110,
    wearable_ids: [362, 442],
  },
  {
    genesis_token_id: 6111,
    wearable_ids: [385, 273],
  },
  {
    genesis_token_id: 6112,
    wearable_ids: [369, 363],
  },
  {
    genesis_token_id: 6113,
    wearable_ids: [377, 271],
  },
  {
    genesis_token_id: 6114,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 6115,
    wearable_ids: [385, 407],
  },
  {
    genesis_token_id: 6116,
    wearable_ids: [428, 349],
  },
  {
    genesis_token_id: 6117,
    wearable_ids: [331, 325],
  },
  {
    genesis_token_id: 6118,
    wearable_ids: [400, 254],
  },
  {
    genesis_token_id: 6119,
    wearable_ids: [364, 423],
  },
  {
    genesis_token_id: 6120,
    wearable_ids: [412, 444],
  },
  {
    genesis_token_id: 6121,
    wearable_ids: [325, 363],
  },
  {
    genesis_token_id: 6122,
    wearable_ids: [308, 270],
  },
  {
    genesis_token_id: 6123,
    wearable_ids: [332, 409],
  },
  {
    genesis_token_id: 6124,
    wearable_ids: [371, 376],
  },
  {
    genesis_token_id: 6125,
    wearable_ids: [338, 373],
  },
  {
    genesis_token_id: 6126,
    wearable_ids: [385, 434],
  },
  {
    genesis_token_id: 6127,
    wearable_ids: [370, 425],
  },
  {
    genesis_token_id: 6128,
    wearable_ids: [344, 414],
  },
  {
    genesis_token_id: 6129,
    wearable_ids: [317, 337],
  },
  {
    genesis_token_id: 6130,
    wearable_ids: [253, 429],
  },
  {
    genesis_token_id: 6131,
    wearable_ids: [265, 297],
  },
  {
    genesis_token_id: 6132,
    wearable_ids: [396, 411],
  },
  {
    genesis_token_id: 6133,
    wearable_ids: [292, 306],
  },
  {
    genesis_token_id: 6134,
    wearable_ids: [255, 278],
  },
  {
    genesis_token_id: 6135,
    wearable_ids: [338, 319],
  },
  {
    genesis_token_id: 6136,
    wearable_ids: [342, 434],
  },
  {
    genesis_token_id: 6137,
    wearable_ids: [400, 297],
  },
  {
    genesis_token_id: 6138,
    wearable_ids: [389, 272],
  },
  {
    genesis_token_id: 6139,
    wearable_ids: [349, 420],
  },
  {
    genesis_token_id: 6140,
    wearable_ids: [342, 249],
  },
  {
    genesis_token_id: 6141,
    wearable_ids: [335, 408],
  },
  {
    genesis_token_id: 6142,
    wearable_ids: [406, 264],
  },
  {
    genesis_token_id: 6143,
    wearable_ids: [295, 342],
  },
  {
    genesis_token_id: 6144,
    wearable_ids: [404, 376],
  },
  {
    genesis_token_id: 6145,
    wearable_ids: [248, 352],
  },
  {
    genesis_token_id: 6146,
    wearable_ids: [384, 412],
  },
  {
    genesis_token_id: 6147,
    wearable_ids: [310, 412],
  },
  {
    genesis_token_id: 6148,
    wearable_ids: [443, 396],
  },
  {
    genesis_token_id: 6149,
    wearable_ids: [296, 287],
  },
  {
    genesis_token_id: 6150,
    wearable_ids: [324, 406],
  },
  {
    genesis_token_id: 6151,
    wearable_ids: [286, 377],
  },
  {
    genesis_token_id: 6152,
    wearable_ids: [348, 336],
  },
  {
    genesis_token_id: 6153,
    wearable_ids: [377, 429],
  },
  {
    genesis_token_id: 6154,
    wearable_ids: [344, 407],
  },
  {
    genesis_token_id: 6155,
    wearable_ids: [362, 420],
  },
  {
    genesis_token_id: 6156,
    wearable_ids: [404, 304],
  },
  {
    genesis_token_id: 6157,
    wearable_ids: [277, 385],
  },
  {
    genesis_token_id: 6158,
    wearable_ids: [387, 301],
  },
  {
    genesis_token_id: 6159,
    wearable_ids: [363, 270],
  },
  {
    genesis_token_id: 6160,
    wearable_ids: [409, 415],
  },
  {
    genesis_token_id: 6161,
    wearable_ids: [415, 436],
  },
  {
    genesis_token_id: 6162,
    wearable_ids: [442, 284],
  },
  {
    genesis_token_id: 6163,
    wearable_ids: [316, 265],
  },
  {
    genesis_token_id: 6164,
    wearable_ids: [331, 332],
  },
  {
    genesis_token_id: 6165,
    wearable_ids: [400, 415],
  },
  {
    genesis_token_id: 6166,
    wearable_ids: [425, 263],
  },
  {
    genesis_token_id: 6167,
    wearable_ids: [420, 300],
  },
  {
    genesis_token_id: 6168,
    wearable_ids: [351, 440],
  },
  {
    genesis_token_id: 6169,
    wearable_ids: [315, 396],
  },
  {
    genesis_token_id: 6170,
    wearable_ids: [444, 433],
  },
  {
    genesis_token_id: 6171,
    wearable_ids: [362, 278],
  },
  {
    genesis_token_id: 6172,
    wearable_ids: [272, 376],
  },
  {
    genesis_token_id: 6173,
    wearable_ids: [347, 343],
  },
  {
    genesis_token_id: 6174,
    wearable_ids: [363, 306],
  },
  {
    genesis_token_id: 6175,
    wearable_ids: [262, 405],
  },
  {
    genesis_token_id: 6176,
    wearable_ids: [339, 350],
  },
  {
    genesis_token_id: 6177,
    wearable_ids: [389, 404],
  },
  {
    genesis_token_id: 6178,
    wearable_ids: [277, 335],
  },
  {
    genesis_token_id: 6179,
    wearable_ids: [400, 423],
  },
  {
    genesis_token_id: 6180,
    wearable_ids: [445, 306],
  },
  {
    genesis_token_id: 6181,
    wearable_ids: [339, 429],
  },
  {
    genesis_token_id: 6182,
    wearable_ids: [434, 349],
  },
  {
    genesis_token_id: 6183,
    wearable_ids: [422, 265],
  },
  {
    genesis_token_id: 6184,
    wearable_ids: [247, 276],
  },
  {
    genesis_token_id: 6185,
    wearable_ids: [395, 433],
  },
  {
    genesis_token_id: 6186,
    wearable_ids: [444, 412],
  },
  {
    genesis_token_id: 6187,
    wearable_ids: [377, 402],
  },
  {
    genesis_token_id: 6188,
    wearable_ids: [290, 341],
  },
  {
    genesis_token_id: 6189,
    wearable_ids: [272, 291],
  },
  {
    genesis_token_id: 6190,
    wearable_ids: [273, 413],
  },
  {
    genesis_token_id: 6191,
    wearable_ids: [317, 254],
  },
  {
    genesis_token_id: 6192,
    wearable_ids: [351, 429],
  },
  {
    genesis_token_id: 6193,
    wearable_ids: [347, 400],
  },
  {
    genesis_token_id: 6194,
    wearable_ids: [395, 297],
  },
  {
    genesis_token_id: 6195,
    wearable_ids: [387, 386],
  },
  {
    genesis_token_id: 6196,
    wearable_ids: [291, 308],
  },
  {
    genesis_token_id: 6197,
    wearable_ids: [332, 354],
  },
  {
    genesis_token_id: 6198,
    wearable_ids: [338, 272],
  },
  {
    genesis_token_id: 6199,
    wearable_ids: [389, 354],
  },
  {
    genesis_token_id: 6200,
    wearable_ids: [384, 255],
  },
  {
    genesis_token_id: 6201,
    wearable_ids: [314, 324],
  },
  {
    genesis_token_id: 6202,
    wearable_ids: [376, 256],
  },
  {
    genesis_token_id: 6203,
    wearable_ids: [437, 268],
  },
  {
    genesis_token_id: 6204,
    wearable_ids: [443, 370],
  },
  {
    genesis_token_id: 6205,
    wearable_ids: [432, 317],
  },
  {
    genesis_token_id: 6206,
    wearable_ids: [375, 412],
  },
  {
    genesis_token_id: 6207,
    wearable_ids: [435, 399],
  },
  {
    genesis_token_id: 6208,
    wearable_ids: [291, 315],
  },
  {
    genesis_token_id: 6209,
    wearable_ids: [410, 407],
  },
  {
    genesis_token_id: 6210,
    wearable_ids: [344, 336],
  },
  {
    genesis_token_id: 6211,
    wearable_ids: [301, 319],
  },
  {
    genesis_token_id: 6212,
    wearable_ids: [349, 409],
  },
  {
    genesis_token_id: 6213,
    wearable_ids: [348, 425],
  },
  {
    genesis_token_id: 6214,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 6215,
    wearable_ids: [369, 313],
  },
  {
    genesis_token_id: 6216,
    wearable_ids: [378, 354],
  },
  {
    genesis_token_id: 6217,
    wearable_ids: [262, 268],
  },
  {
    genesis_token_id: 6218,
    wearable_ids: [437, 362],
  },
  {
    genesis_token_id: 6219,
    wearable_ids: [254, 261],
  },
  {
    genesis_token_id: 6220,
    wearable_ids: [332, 354],
  },
  {
    genesis_token_id: 6221,
    wearable_ids: [296, 413],
  },
  {
    genesis_token_id: 6222,
    wearable_ids: [317, 253],
  },
  {
    genesis_token_id: 6223,
    wearable_ids: [287, 388],
  },
  {
    genesis_token_id: 6224,
    wearable_ids: [300, 352],
  },
  {
    genesis_token_id: 6225,
    wearable_ids: [443, 326],
  },
  {
    genesis_token_id: 6226,
    wearable_ids: [399, 298],
  },
  {
    genesis_token_id: 6227,
    wearable_ids: [253, 383],
  },
  {
    genesis_token_id: 6228,
    wearable_ids: [355, 312],
  },
  {
    genesis_token_id: 6229,
    wearable_ids: [423, 248],
  },
  {
    genesis_token_id: 6230,
    wearable_ids: [342, 262],
  },
  {
    genesis_token_id: 6231,
    wearable_ids: [273, 373],
  },
  {
    genesis_token_id: 6232,
    wearable_ids: [408, 264],
  },
  {
    genesis_token_id: 6233,
    wearable_ids: [254, 360],
  },
  {
    genesis_token_id: 6234,
    wearable_ids: [406, 435],
  },
  {
    genesis_token_id: 6235,
    wearable_ids: [349, 443],
  },
  {
    genesis_token_id: 6236,
    wearable_ids: [299, 399],
  },
  {
    genesis_token_id: 6237,
    wearable_ids: [420, 337],
  },
  {
    genesis_token_id: 6238,
    wearable_ids: [372, 432],
  },
  {
    genesis_token_id: 6239,
    wearable_ids: [340, 294],
  },
  {
    genesis_token_id: 6240,
    wearable_ids: [331, 286],
  },
  {
    genesis_token_id: 6241,
    wearable_ids: [429, 246],
  },
  {
    genesis_token_id: 6242,
    wearable_ids: [385, 428],
  },
  {
    genesis_token_id: 6243,
    wearable_ids: [248, 275],
  },
  {
    genesis_token_id: 6244,
    wearable_ids: [444, 286],
  },
  {
    genesis_token_id: 6245,
    wearable_ids: [412, 352],
  },
  {
    genesis_token_id: 6246,
    wearable_ids: [310, 315],
  },
  {
    genesis_token_id: 6247,
    wearable_ids: [325, 403],
  },
  {
    genesis_token_id: 6248,
    wearable_ids: [315, 266],
  },
  {
    genesis_token_id: 6249,
    wearable_ids: [375, 318],
  },
  {
    genesis_token_id: 6250,
    wearable_ids: [396, 371],
  },
  {
    genesis_token_id: 6251,
    wearable_ids: [291, 365],
  },
  {
    genesis_token_id: 6252,
    wearable_ids: [377, 445],
  },
  {
    genesis_token_id: 6253,
    wearable_ids: [277, 274],
  },
  {
    genesis_token_id: 6254,
    wearable_ids: [437, 284],
  },
  {
    genesis_token_id: 6255,
    wearable_ids: [442, 396],
  },
  {
    genesis_token_id: 6256,
    wearable_ids: [362, 338],
  },
  {
    genesis_token_id: 6257,
    wearable_ids: [287, 284],
  },
  {
    genesis_token_id: 6258,
    wearable_ids: [271, 403],
  },
  {
    genesis_token_id: 6259,
    wearable_ids: [349, 246],
  },
  {
    genesis_token_id: 6260,
    wearable_ids: [403, 427],
  },
  {
    genesis_token_id: 6261,
    wearable_ids: [258, 250],
  },
  {
    genesis_token_id: 6262,
    wearable_ids: [325, 360],
  },
  {
    genesis_token_id: 6263,
    wearable_ids: [257, 370],
  },
  {
    genesis_token_id: 6264,
    wearable_ids: [276, 382],
  },
  {
    genesis_token_id: 6265,
    wearable_ids: [434, 249],
  },
  {
    genesis_token_id: 6266,
    wearable_ids: [296, 341],
  },
  {
    genesis_token_id: 6267,
    wearable_ids: [289, 331],
  },
  {
    genesis_token_id: 6268,
    wearable_ids: [315, 299],
  },
  {
    genesis_token_id: 6269,
    wearable_ids: [404, 348],
  },
  {
    genesis_token_id: 6270,
    wearable_ids: [291, 402],
  },
  {
    genesis_token_id: 6271,
    wearable_ids: [336, 302],
  },
  {
    genesis_token_id: 6272,
    wearable_ids: [437, 297],
  },
  {
    genesis_token_id: 6273,
    wearable_ids: [349, 311],
  },
  {
    genesis_token_id: 6274,
    wearable_ids: [399, 362],
  },
  {
    genesis_token_id: 6275,
    wearable_ids: [348, 338],
  },
  {
    genesis_token_id: 6276,
    wearable_ids: [362, 303],
  },
  {
    genesis_token_id: 6277,
    wearable_ids: [428, 256],
  },
  {
    genesis_token_id: 6278,
    wearable_ids: [395, 300],
  },
  {
    genesis_token_id: 6279,
    wearable_ids: [280, 389],
  },
  {
    genesis_token_id: 6280,
    wearable_ids: [340, 277],
  },
  {
    genesis_token_id: 6281,
    wearable_ids: [287, 255],
  },
  {
    genesis_token_id: 6282,
    wearable_ids: [317, 319],
  },
  {
    genesis_token_id: 6283,
    wearable_ids: [339, 314],
  },
  {
    genesis_token_id: 6284,
    wearable_ids: [396, 398],
  },
  {
    genesis_token_id: 6285,
    wearable_ids: [431, 361],
  },
  {
    genesis_token_id: 6286,
    wearable_ids: [344, 440],
  },
  {
    genesis_token_id: 6287,
    wearable_ids: [429, 370],
  },
  {
    genesis_token_id: 6288,
    wearable_ids: [445, 355],
  },
  {
    genesis_token_id: 6289,
    wearable_ids: [408, 427],
  },
  {
    genesis_token_id: 6290,
    wearable_ids: [376, 294],
  },
  {
    genesis_token_id: 6291,
    wearable_ids: [284, 410],
  },
  {
    genesis_token_id: 6292,
    wearable_ids: [294, 270],
  },
  {
    genesis_token_id: 6293,
    wearable_ids: [408, 344],
  },
  {
    genesis_token_id: 6294,
    wearable_ids: [420, 397],
  },
  {
    genesis_token_id: 6295,
    wearable_ids: [369, 403],
  },
  {
    genesis_token_id: 6296,
    wearable_ids: [303, 346],
  },
  {
    genesis_token_id: 6297,
    wearable_ids: [342, 318],
  },
  {
    genesis_token_id: 6298,
    wearable_ids: [339, 378],
  },
  {
    genesis_token_id: 6299,
    wearable_ids: [314, 403],
  },
  {
    genesis_token_id: 6300,
    wearable_ids: [274, 429],
  },
  {
    genesis_token_id: 6301,
    wearable_ids: [368, 308],
  },
  {
    genesis_token_id: 6302,
    wearable_ids: [297, 400],
  },
  {
    genesis_token_id: 6303,
    wearable_ids: [326, 357],
  },
  {
    genesis_token_id: 6304,
    wearable_ids: [444, 387],
  },
  {
    genesis_token_id: 6305,
    wearable_ids: [248, 340],
  },
  {
    genesis_token_id: 6306,
    wearable_ids: [387, 330],
  },
  {
    genesis_token_id: 6307,
    wearable_ids: [420, 384],
  },
  {
    genesis_token_id: 6308,
    wearable_ids: [271, 269],
  },
  {
    genesis_token_id: 6309,
    wearable_ids: [343, 296],
  },
  {
    genesis_token_id: 6310,
    wearable_ids: [397, 296],
  },
  {
    genesis_token_id: 6311,
    wearable_ids: [344, 317],
  },
  {
    genesis_token_id: 6312,
    wearable_ids: [308, 317],
  },
  {
    genesis_token_id: 6313,
    wearable_ids: [336, 274],
  },
  {
    genesis_token_id: 6314,
    wearable_ids: [410, 411],
  },
  {
    genesis_token_id: 6315,
    wearable_ids: [256, 408],
  },
  {
    genesis_token_id: 6316,
    wearable_ids: [410, 415],
  },
  {
    genesis_token_id: 6317,
    wearable_ids: [317, 365],
  },
  {
    genesis_token_id: 6318,
    wearable_ids: [389, 254],
  },
  {
    genesis_token_id: 6319,
    wearable_ids: [319, 365],
  },
  {
    genesis_token_id: 6320,
    wearable_ids: [271, 356],
  },
  {
    genesis_token_id: 6321,
    wearable_ids: [296, 368],
  },
  {
    genesis_token_id: 6322,
    wearable_ids: [407, 308],
  },
  {
    genesis_token_id: 6323,
    wearable_ids: [258, 294],
  },
  {
    genesis_token_id: 6324,
    wearable_ids: [338, 360],
  },
  {
    genesis_token_id: 6325,
    wearable_ids: [435, 349],
  },
  {
    genesis_token_id: 6326,
    wearable_ids: [273, 426],
  },
  {
    genesis_token_id: 6327,
    wearable_ids: [295, 337],
  },
  {
    genesis_token_id: 6328,
    wearable_ids: [428, 289],
  },
  {
    genesis_token_id: 6329,
    wearable_ids: [426, 347],
  },
  {
    genesis_token_id: 6330,
    wearable_ids: [325, 259],
  },
  {
    genesis_token_id: 6331,
    wearable_ids: [344, 394],
  },
  {
    genesis_token_id: 6332,
    wearable_ids: [284, 251],
  },
  {
    genesis_token_id: 6333,
    wearable_ids: [368, 432],
  },
  {
    genesis_token_id: 6334,
    wearable_ids: [347, 303],
  },
  {
    genesis_token_id: 6335,
    wearable_ids: [296, 260],
  },
  {
    genesis_token_id: 6336,
    wearable_ids: [270, 341],
  },
  {
    genesis_token_id: 6337,
    wearable_ids: [340, 265],
  },
  {
    genesis_token_id: 6338,
    wearable_ids: [332, 286],
  },
  {
    genesis_token_id: 6339,
    wearable_ids: [355, 303],
  },
  {
    genesis_token_id: 6340,
    wearable_ids: [399, 365],
  },
  {
    genesis_token_id: 6341,
    wearable_ids: [256, 264],
  },
  {
    genesis_token_id: 6342,
    wearable_ids: [303, 294],
  },
  {
    genesis_token_id: 6343,
    wearable_ids: [268, 436],
  },
  {
    genesis_token_id: 6344,
    wearable_ids: [266, 274],
  },
  {
    genesis_token_id: 6345,
    wearable_ids: [347, 378],
  },
  {
    genesis_token_id: 6346,
    wearable_ids: [266, 324],
  },
  {
    genesis_token_id: 6347,
    wearable_ids: [378, 371],
  },
  {
    genesis_token_id: 6348,
    wearable_ids: [377, 248],
  },
  {
    genesis_token_id: 6349,
    wearable_ids: [257, 397],
  },
  {
    genesis_token_id: 6350,
    wearable_ids: [411, 257],
  },
  {
    genesis_token_id: 6351,
    wearable_ids: [326, 264],
  },
  {
    genesis_token_id: 6352,
    wearable_ids: [284, 352],
  },
  {
    genesis_token_id: 6353,
    wearable_ids: [408, 289],
  },
  {
    genesis_token_id: 6354,
    wearable_ids: [339, 319],
  },
  {
    genesis_token_id: 6355,
    wearable_ids: [325, 326],
  },
  {
    genesis_token_id: 6356,
    wearable_ids: [247, 291],
  },
  {
    genesis_token_id: 6357,
    wearable_ids: [258, 382],
  },
  {
    genesis_token_id: 6358,
    wearable_ids: [444, 310],
  },
  {
    genesis_token_id: 6359,
    wearable_ids: [382, 264],
  },
  {
    genesis_token_id: 6360,
    wearable_ids: [349, 408],
  },
  {
    genesis_token_id: 6361,
    wearable_ids: [259, 372],
  },
  {
    genesis_token_id: 6362,
    wearable_ids: [376, 444],
  },
  {
    genesis_token_id: 6363,
    wearable_ids: [370, 298],
  },
  {
    genesis_token_id: 6364,
    wearable_ids: [409, 415],
  },
  {
    genesis_token_id: 6365,
    wearable_ids: [247, 323],
  },
  {
    genesis_token_id: 6366,
    wearable_ids: [257, 264],
  },
  {
    genesis_token_id: 6367,
    wearable_ids: [247, 352],
  },
  {
    genesis_token_id: 6368,
    wearable_ids: [369, 317],
  },
  {
    genesis_token_id: 6369,
    wearable_ids: [386, 315],
  },
  {
    genesis_token_id: 6370,
    wearable_ids: [373, 296],
  },
  {
    genesis_token_id: 6371,
    wearable_ids: [363, 428],
  },
  {
    genesis_token_id: 6372,
    wearable_ids: [410, 444],
  },
  {
    genesis_token_id: 6373,
    wearable_ids: [270, 369],
  },
  {
    genesis_token_id: 6374,
    wearable_ids: [422, 335],
  },
  {
    genesis_token_id: 6375,
    wearable_ids: [397, 275],
  },
  {
    genesis_token_id: 6376,
    wearable_ids: [437, 352],
  },
  {
    genesis_token_id: 6377,
    wearable_ids: [347, 303],
  },
  {
    genesis_token_id: 6378,
    wearable_ids: [290, 278],
  },
  {
    genesis_token_id: 6379,
    wearable_ids: [434, 368],
  },
  {
    genesis_token_id: 6380,
    wearable_ids: [325, 420],
  },
  {
    genesis_token_id: 6381,
    wearable_ids: [407, 248],
  },
  {
    genesis_token_id: 6382,
    wearable_ids: [436, 263],
  },
  {
    genesis_token_id: 6383,
    wearable_ids: [324, 350],
  },
  {
    genesis_token_id: 6384,
    wearable_ids: [278, 248],
  },
  {
    genesis_token_id: 6385,
    wearable_ids: [299, 274],
  },
  {
    genesis_token_id: 6386,
    wearable_ids: [429, 299],
  },
  {
    genesis_token_id: 6387,
    wearable_ids: [363, 265],
  },
  {
    genesis_token_id: 6388,
    wearable_ids: [278, 350],
  },
  {
    genesis_token_id: 6389,
    wearable_ids: [348, 383],
  },
  {
    genesis_token_id: 6390,
    wearable_ids: [253, 304],
  },
  {
    genesis_token_id: 6391,
    wearable_ids: [413, 265],
  },
  {
    genesis_token_id: 6392,
    wearable_ids: [296, 287],
  },
  {
    genesis_token_id: 6393,
    wearable_ids: [343, 431],
  },
  {
    genesis_token_id: 6394,
    wearable_ids: [425, 382],
  },
  {
    genesis_token_id: 6395,
    wearable_ids: [271, 353],
  },
  {
    genesis_token_id: 6396,
    wearable_ids: [370, 325],
  },
  {
    genesis_token_id: 6397,
    wearable_ids: [436, 378],
  },
  {
    genesis_token_id: 6398,
    wearable_ids: [310, 349],
  },
  {
    genesis_token_id: 6399,
    wearable_ids: [363, 352],
  },
  {
    genesis_token_id: 6400,
    wearable_ids: [399, 273],
  },
  {
    genesis_token_id: 6401,
    wearable_ids: [325, 418],
  },
  {
    genesis_token_id: 6402,
    wearable_ids: [273, 311],
  },
  {
    genesis_token_id: 6403,
    wearable_ids: [289, 259],
  },
  {
    genesis_token_id: 6404,
    wearable_ids: [429, 301],
  },
  {
    genesis_token_id: 6405,
    wearable_ids: [296, 425],
  },
  {
    genesis_token_id: 6406,
    wearable_ids: [339, 402],
  },
  {
    genesis_token_id: 6407,
    wearable_ids: [411, 386],
  },
  {
    genesis_token_id: 6408,
    wearable_ids: [295, 270],
  },
  {
    genesis_token_id: 6409,
    wearable_ids: [445, 315],
  },
  {
    genesis_token_id: 6410,
    wearable_ids: [310, 436],
  },
  {
    genesis_token_id: 6411,
    wearable_ids: [365, 272],
  },
  {
    genesis_token_id: 6412,
    wearable_ids: [436, 364],
  },
  {
    genesis_token_id: 6413,
    wearable_ids: [310, 294],
  },
  {
    genesis_token_id: 6414,
    wearable_ids: [399, 442],
  },
  {
    genesis_token_id: 6415,
    wearable_ids: [342, 345],
  },
  {
    genesis_token_id: 6416,
    wearable_ids: [337, 303],
  },
  {
    genesis_token_id: 6417,
    wearable_ids: [326, 301],
  },
  {
    genesis_token_id: 6418,
    wearable_ids: [262, 371],
  },
  {
    genesis_token_id: 6419,
    wearable_ids: [278, 304],
  },
  {
    genesis_token_id: 6420,
    wearable_ids: [314, 319],
  },
  {
    genesis_token_id: 6421,
    wearable_ids: [278, 325],
  },
  {
    genesis_token_id: 6422,
    wearable_ids: [399, 291],
  },
  {
    genesis_token_id: 6423,
    wearable_ids: [348, 374],
  },
  {
    genesis_token_id: 6424,
    wearable_ids: [270, 445],
  },
  {
    genesis_token_id: 6425,
    wearable_ids: [295, 414],
  },
  {
    genesis_token_id: 6426,
    wearable_ids: [272, 261],
  },
  {
    genesis_token_id: 6427,
    wearable_ids: [362, 274],
  },
  {
    genesis_token_id: 6428,
    wearable_ids: [336, 258],
  },
  {
    genesis_token_id: 6429,
    wearable_ids: [362, 307],
  },
  {
    genesis_token_id: 6430,
    wearable_ids: [437, 443],
  },
  {
    genesis_token_id: 6431,
    wearable_ids: [303, 436],
  },
  {
    genesis_token_id: 6432,
    wearable_ids: [276, 271],
  },
  {
    genesis_token_id: 6433,
    wearable_ids: [403, 370],
  },
  {
    genesis_token_id: 6434,
    wearable_ids: [342, 443],
  },
  {
    genesis_token_id: 6435,
    wearable_ids: [373, 319],
  },
  {
    genesis_token_id: 6436,
    wearable_ids: [443, 419],
  },
  {
    genesis_token_id: 6437,
    wearable_ids: [340, 413],
  },
  {
    genesis_token_id: 6438,
    wearable_ids: [342, 290],
  },
  {
    genesis_token_id: 6439,
    wearable_ids: [276, 395],
  },
  {
    genesis_token_id: 6440,
    wearable_ids: [325, 303],
  },
  {
    genesis_token_id: 6441,
    wearable_ids: [435, 324],
  },
  {
    genesis_token_id: 6442,
    wearable_ids: [294, 371],
  },
  {
    genesis_token_id: 6443,
    wearable_ids: [325, 349],
  },
  {
    genesis_token_id: 6444,
    wearable_ids: [317, 324],
  },
  {
    genesis_token_id: 6445,
    wearable_ids: [257, 263],
  },
  {
    genesis_token_id: 6446,
    wearable_ids: [296, 427],
  },
  {
    genesis_token_id: 6447,
    wearable_ids: [409, 387],
  },
  {
    genesis_token_id: 6448,
    wearable_ids: [257, 249],
  },
  {
    genesis_token_id: 6449,
    wearable_ids: [262, 324],
  },
  {
    genesis_token_id: 6450,
    wearable_ids: [308, 247],
  },
  {
    genesis_token_id: 6451,
    wearable_ids: [264, 427],
  },
  {
    genesis_token_id: 6452,
    wearable_ids: [331, 400],
  },
  {
    genesis_token_id: 6453,
    wearable_ids: [436, 396],
  },
  {
    genesis_token_id: 6454,
    wearable_ids: [422, 415],
  },
  {
    genesis_token_id: 6455,
    wearable_ids: [248, 398],
  },
  {
    genesis_token_id: 6456,
    wearable_ids: [432, 253],
  },
  {
    genesis_token_id: 6457,
    wearable_ids: [292, 422],
  },
  {
    genesis_token_id: 6458,
    wearable_ids: [425, 423],
  },
  {
    genesis_token_id: 6459,
    wearable_ids: [432, 250],
  },
  {
    genesis_token_id: 6460,
    wearable_ids: [271, 372],
  },
  {
    genesis_token_id: 6461,
    wearable_ids: [375, 261],
  },
  {
    genesis_token_id: 6462,
    wearable_ids: [296, 269],
  },
  {
    genesis_token_id: 6463,
    wearable_ids: [304, 276],
  },
  {
    genesis_token_id: 6464,
    wearable_ids: [436, 377],
  },
  {
    genesis_token_id: 6465,
    wearable_ids: [425, 277],
  },
  {
    genesis_token_id: 6466,
    wearable_ids: [331, 292],
  },
  {
    genesis_token_id: 6467,
    wearable_ids: [259, 317],
  },
  {
    genesis_token_id: 6468,
    wearable_ids: [278, 375],
  },
  {
    genesis_token_id: 6469,
    wearable_ids: [287, 248],
  },
  {
    genesis_token_id: 6470,
    wearable_ids: [257, 428],
  },
  {
    genesis_token_id: 6471,
    wearable_ids: [433, 277],
  },
  {
    genesis_token_id: 6472,
    wearable_ids: [248, 306],
  },
  {
    genesis_token_id: 6473,
    wearable_ids: [363, 301],
  },
  {
    genesis_token_id: 6474,
    wearable_ids: [408, 265],
  },
  {
    genesis_token_id: 6475,
    wearable_ids: [425, 285],
  },
  {
    genesis_token_id: 6476,
    wearable_ids: [295, 335],
  },
  {
    genesis_token_id: 6477,
    wearable_ids: [311, 336],
  },
  {
    genesis_token_id: 6478,
    wearable_ids: [413, 392],
  },
  {
    genesis_token_id: 6479,
    wearable_ids: [287, 410],
  },
  {
    genesis_token_id: 6480,
    wearable_ids: [263, 375],
  },
  {
    genesis_token_id: 6481,
    wearable_ids: [385, 406],
  },
  {
    genesis_token_id: 6482,
    wearable_ids: [343, 332],
  },
  {
    genesis_token_id: 6483,
    wearable_ids: [442, 303],
  },
  {
    genesis_token_id: 6484,
    wearable_ids: [387, 253],
  },
  {
    genesis_token_id: 6485,
    wearable_ids: [325, 271],
  },
  {
    genesis_token_id: 6486,
    wearable_ids: [351, 372],
  },
  {
    genesis_token_id: 6487,
    wearable_ids: [274, 429],
  },
  {
    genesis_token_id: 6488,
    wearable_ids: [351, 264],
  },
  {
    genesis_token_id: 6489,
    wearable_ids: [347, 400],
  },
  {
    genesis_token_id: 6490,
    wearable_ids: [399, 432],
  },
  {
    genesis_token_id: 6491,
    wearable_ids: [410, 251],
  },
  {
    genesis_token_id: 6492,
    wearable_ids: [399, 444],
  },
  {
    genesis_token_id: 6493,
    wearable_ids: [276, 387],
  },
  {
    genesis_token_id: 6494,
    wearable_ids: [383, 264],
  },
  {
    genesis_token_id: 6495,
    wearable_ids: [257, 299],
  },
  {
    genesis_token_id: 6496,
    wearable_ids: [351, 256],
  },
  {
    genesis_token_id: 6497,
    wearable_ids: [308, 435],
  },
  {
    genesis_token_id: 6498,
    wearable_ids: [286, 398],
  },
  {
    genesis_token_id: 6499,
    wearable_ids: [278, 259],
  },
  {
    genesis_token_id: 6500,
    wearable_ids: [344, 267],
  },
  {
    genesis_token_id: 6501,
    wearable_ids: [395, 310],
  },
  {
    genesis_token_id: 6502,
    wearable_ids: [335, 410],
  },
  {
    genesis_token_id: 6503,
    wearable_ids: [350, 385],
  },
  {
    genesis_token_id: 6504,
    wearable_ids: [406, 408],
  },
  {
    genesis_token_id: 6505,
    wearable_ids: [339, 272],
  },
  {
    genesis_token_id: 6506,
    wearable_ids: [276, 392],
  },
  {
    genesis_token_id: 6507,
    wearable_ids: [386, 379],
  },
  {
    genesis_token_id: 6508,
    wearable_ids: [339, 277],
  },
  {
    genesis_token_id: 6509,
    wearable_ids: [426, 285],
  },
  {
    genesis_token_id: 6510,
    wearable_ids: [374, 434],
  },
  {
    genesis_token_id: 6511,
    wearable_ids: [415, 320],
  },
  {
    genesis_token_id: 6512,
    wearable_ids: [265, 290],
  },
  {
    genesis_token_id: 6513,
    wearable_ids: [300, 327],
  },
  {
    genesis_token_id: 6514,
    wearable_ids: [306, 354],
  },
  {
    genesis_token_id: 6515,
    wearable_ids: [354, 372],
  },
  {
    genesis_token_id: 6516,
    wearable_ids: [364, 270],
  },
  {
    genesis_token_id: 6517,
    wearable_ids: [337, 377],
  },
  {
    genesis_token_id: 6518,
    wearable_ids: [265, 436],
  },
  {
    genesis_token_id: 6519,
    wearable_ids: [247, 332],
  },
  {
    genesis_token_id: 6520,
    wearable_ids: [273, 348],
  },
  {
    genesis_token_id: 6521,
    wearable_ids: [425, 432],
  },
  {
    genesis_token_id: 6522,
    wearable_ids: [256, 295],
  },
  {
    genesis_token_id: 6523,
    wearable_ids: [284, 369],
  },
  {
    genesis_token_id: 6524,
    wearable_ids: [442, 338],
  },
  {
    genesis_token_id: 6525,
    wearable_ids: [420, 387],
  },
  {
    genesis_token_id: 6526,
    wearable_ids: [396, 436],
  },
  {
    genesis_token_id: 6527,
    wearable_ids: [280, 411],
  },
  {
    genesis_token_id: 6528,
    wearable_ids: [410, 411],
  },
  {
    genesis_token_id: 6529,
    wearable_ids: [408, 426],
  },
  {
    genesis_token_id: 6530,
    wearable_ids: [255, 265],
  },
  {
    genesis_token_id: 6531,
    wearable_ids: [375, 344],
  },
  {
    genesis_token_id: 6532,
    wearable_ids: [369, 357],
  },
  {
    genesis_token_id: 6533,
    wearable_ids: [434, 342],
  },
  {
    genesis_token_id: 6534,
    wearable_ids: [274, 335],
  },
  {
    genesis_token_id: 6535,
    wearable_ids: [426, 356],
  },
  {
    genesis_token_id: 6536,
    wearable_ids: [343, 319],
  },
  {
    genesis_token_id: 6537,
    wearable_ids: [276, 415],
  },
  {
    genesis_token_id: 6538,
    wearable_ids: [384, 413],
  },
  {
    genesis_token_id: 6539,
    wearable_ids: [254, 376],
  },
  {
    genesis_token_id: 6540,
    wearable_ids: [263, 368],
  },
  {
    genesis_token_id: 6541,
    wearable_ids: [304, 340],
  },
  {
    genesis_token_id: 6542,
    wearable_ids: [286, 294],
  },
  {
    genesis_token_id: 6543,
    wearable_ids: [340, 411],
  },
  {
    genesis_token_id: 6544,
    wearable_ids: [276, 255],
  },
  {
    genesis_token_id: 6545,
    wearable_ids: [428, 304],
  },
  {
    genesis_token_id: 6546,
    wearable_ids: [339, 352],
  },
  {
    genesis_token_id: 6547,
    wearable_ids: [287, 330],
  },
  {
    genesis_token_id: 6548,
    wearable_ids: [280, 318],
  },
  {
    genesis_token_id: 6549,
    wearable_ids: [363, 290],
  },
  {
    genesis_token_id: 6550,
    wearable_ids: [290, 344],
  },
  {
    genesis_token_id: 6551,
    wearable_ids: [442, 262],
  },
  {
    genesis_token_id: 6552,
    wearable_ids: [371, 404],
  },
  {
    genesis_token_id: 6553,
    wearable_ids: [410, 374],
  },
  {
    genesis_token_id: 6554,
    wearable_ids: [377, 272],
  },
  {
    genesis_token_id: 6555,
    wearable_ids: [348, 372],
  },
  {
    genesis_token_id: 6556,
    wearable_ids: [248, 339],
  },
  {
    genesis_token_id: 6557,
    wearable_ids: [378, 304],
  },
  {
    genesis_token_id: 6558,
    wearable_ids: [364, 347],
  },
  {
    genesis_token_id: 6559,
    wearable_ids: [332, 374],
  },
  {
    genesis_token_id: 6560,
    wearable_ids: [338, 301],
  },
  {
    genesis_token_id: 6561,
    wearable_ids: [348, 365],
  },
  {
    genesis_token_id: 6562,
    wearable_ids: [410, 265],
  },
  {
    genesis_token_id: 6563,
    wearable_ids: [363, 395],
  },
  {
    genesis_token_id: 6564,
    wearable_ids: [444, 437],
  },
  {
    genesis_token_id: 6565,
    wearable_ids: [296, 387],
  },
  {
    genesis_token_id: 6566,
    wearable_ids: [316, 405],
  },
  {
    genesis_token_id: 6567,
    wearable_ids: [296, 304],
  },
  {
    genesis_token_id: 6568,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 6569,
    wearable_ids: [423, 442],
  },
  {
    genesis_token_id: 6570,
    wearable_ids: [335, 253],
  },
  {
    genesis_token_id: 6571,
    wearable_ids: [425, 247],
  },
  {
    genesis_token_id: 6572,
    wearable_ids: [395, 291],
  },
  {
    genesis_token_id: 6573,
    wearable_ids: [311, 302],
  },
  {
    genesis_token_id: 6574,
    wearable_ids: [276, 397],
  },
  {
    genesis_token_id: 6575,
    wearable_ids: [348, 327],
  },
  {
    genesis_token_id: 6576,
    wearable_ids: [248, 363],
  },
  {
    genesis_token_id: 6577,
    wearable_ids: [304, 299],
  },
  {
    genesis_token_id: 6578,
    wearable_ids: [314, 362],
  },
  {
    genesis_token_id: 6579,
    wearable_ids: [310, 365],
  },
  {
    genesis_token_id: 6580,
    wearable_ids: [442, 373],
  },
  {
    genesis_token_id: 6581,
    wearable_ids: [316, 300],
  },
  {
    genesis_token_id: 6582,
    wearable_ids: [340, 257],
  },
  {
    genesis_token_id: 6583,
    wearable_ids: [385, 340],
  },
  {
    genesis_token_id: 6584,
    wearable_ids: [364, 362],
  },
  {
    genesis_token_id: 6585,
    wearable_ids: [409, 389],
  },
  {
    genesis_token_id: 6586,
    wearable_ids: [289, 419],
  },
  {
    genesis_token_id: 6587,
    wearable_ids: [297, 299],
  },
  {
    genesis_token_id: 6588,
    wearable_ids: [314, 387],
  },
  {
    genesis_token_id: 6589,
    wearable_ids: [423, 276],
  },
  {
    genesis_token_id: 6590,
    wearable_ids: [276, 411],
  },
  {
    genesis_token_id: 6591,
    wearable_ids: [290, 308],
  },
  {
    genesis_token_id: 6592,
    wearable_ids: [413, 264],
  },
  {
    genesis_token_id: 6593,
    wearable_ids: [341, 337],
  },
  {
    genesis_token_id: 6594,
    wearable_ids: [277, 281],
  },
  {
    genesis_token_id: 6595,
    wearable_ids: [259, 400],
  },
  {
    genesis_token_id: 6596,
    wearable_ids: [407, 327],
  },
  {
    genesis_token_id: 6597,
    wearable_ids: [290, 340],
  },
  {
    genesis_token_id: 6598,
    wearable_ids: [377, 294],
  },
  {
    genesis_token_id: 6599,
    wearable_ids: [348, 416],
  },
  {
    genesis_token_id: 6600,
    wearable_ids: [342, 347],
  },
  {
    genesis_token_id: 6601,
    wearable_ids: [420, 293],
  },
  {
    genesis_token_id: 6602,
    wearable_ids: [409, 306],
  },
  {
    genesis_token_id: 6603,
    wearable_ids: [375, 391],
  },
  {
    genesis_token_id: 6604,
    wearable_ids: [335, 364],
  },
  {
    genesis_token_id: 6605,
    wearable_ids: [304, 300],
  },
  {
    genesis_token_id: 6606,
    wearable_ids: [296, 327],
  },
  {
    genesis_token_id: 6607,
    wearable_ids: [411, 290],
  },
  {
    genesis_token_id: 6608,
    wearable_ids: [376, 409],
  },
  {
    genesis_token_id: 6609,
    wearable_ids: [415, 407],
  },
  {
    genesis_token_id: 6610,
    wearable_ids: [276, 310],
  },
  {
    genesis_token_id: 6611,
    wearable_ids: [338, 370],
  },
  {
    genesis_token_id: 6612,
    wearable_ids: [347, 382],
  },
  {
    genesis_token_id: 6613,
    wearable_ids: [373, 389],
  },
  {
    genesis_token_id: 6614,
    wearable_ids: [324, 415],
  },
  {
    genesis_token_id: 6615,
    wearable_ids: [332, 300],
  },
  {
    genesis_token_id: 6616,
    wearable_ids: [336, 247],
  },
  {
    genesis_token_id: 6617,
    wearable_ids: [370, 317],
  },
  {
    genesis_token_id: 6618,
    wearable_ids: [426, 300],
  },
  {
    genesis_token_id: 6619,
    wearable_ids: [342, 297],
  },
  {
    genesis_token_id: 6620,
    wearable_ids: [273, 431],
  },
  {
    genesis_token_id: 6621,
    wearable_ids: [253, 255],
  },
  {
    genesis_token_id: 6622,
    wearable_ids: [397, 277],
  },
  {
    genesis_token_id: 6623,
    wearable_ids: [443, 385],
  },
  {
    genesis_token_id: 6624,
    wearable_ids: [445, 413],
  },
  {
    genesis_token_id: 6625,
    wearable_ids: [311, 383],
  },
  {
    genesis_token_id: 6626,
    wearable_ids: [295, 278],
  },
  {
    genesis_token_id: 6627,
    wearable_ids: [270, 358],
  },
  {
    genesis_token_id: 6628,
    wearable_ids: [294, 399],
  },
  {
    genesis_token_id: 6629,
    wearable_ids: [319, 406],
  },
  {
    genesis_token_id: 6630,
    wearable_ids: [336, 346],
  },
  {
    genesis_token_id: 6631,
    wearable_ids: [410, 416],
  },
  {
    genesis_token_id: 6632,
    wearable_ids: [316, 254],
  },
  {
    genesis_token_id: 6633,
    wearable_ids: [407, 327],
  },
  {
    genesis_token_id: 6634,
    wearable_ids: [435, 428],
  },
  {
    genesis_token_id: 6635,
    wearable_ids: [286, 313],
  },
  {
    genesis_token_id: 6636,
    wearable_ids: [432, 365],
  },
  {
    genesis_token_id: 6637,
    wearable_ids: [268, 270],
  },
  {
    genesis_token_id: 6638,
    wearable_ids: [278, 250],
  },
  {
    genesis_token_id: 6639,
    wearable_ids: [306, 332],
  },
  {
    genesis_token_id: 6640,
    wearable_ids: [273, 335],
  },
  {
    genesis_token_id: 6641,
    wearable_ids: [374, 260],
  },
  {
    genesis_token_id: 6642,
    wearable_ids: [365, 266],
  },
  {
    genesis_token_id: 6643,
    wearable_ids: [303, 256],
  },
  {
    genesis_token_id: 6644,
    wearable_ids: [346, 373],
  },
  {
    genesis_token_id: 6645,
    wearable_ids: [253, 383],
  },
  {
    genesis_token_id: 6646,
    wearable_ids: [406, 382],
  },
  {
    genesis_token_id: 6647,
    wearable_ids: [425, 402],
  },
  {
    genesis_token_id: 6648,
    wearable_ids: [291, 349],
  },
  {
    genesis_token_id: 6649,
    wearable_ids: [404, 296],
  },
  {
    genesis_token_id: 6650,
    wearable_ids: [362, 286],
  },
  {
    genesis_token_id: 6651,
    wearable_ids: [280, 397],
  },
  {
    genesis_token_id: 6652,
    wearable_ids: [311, 331],
  },
  {
    genesis_token_id: 6653,
    wearable_ids: [263, 372],
  },
  {
    genesis_token_id: 6654,
    wearable_ids: [397, 338],
  },
  {
    genesis_token_id: 6655,
    wearable_ids: [376, 277],
  },
  {
    genesis_token_id: 6656,
    wearable_ids: [268, 434],
  },
  {
    genesis_token_id: 6657,
    wearable_ids: [371, 325],
  },
  {
    genesis_token_id: 6658,
    wearable_ids: [331, 259],
  },
  {
    genesis_token_id: 6659,
    wearable_ids: [264, 271],
  },
  {
    genesis_token_id: 6660,
    wearable_ids: [389, 378],
  },
  {
    genesis_token_id: 6661,
    wearable_ids: [347, 383],
  },
  {
    genesis_token_id: 6662,
    wearable_ids: [284, 338],
  },
  {
    genesis_token_id: 6663,
    wearable_ids: [397, 385],
  },
  {
    genesis_token_id: 6664,
    wearable_ids: [351, 290],
  },
  {
    genesis_token_id: 6665,
    wearable_ids: [387, 372],
  },
  {
    genesis_token_id: 6666,
    wearable_ids: [273, 249],
  },
  {
    genesis_token_id: 6667,
    wearable_ids: [422, 259],
  },
  {
    genesis_token_id: 6668,
    wearable_ids: [363, 385],
  },
  {
    genesis_token_id: 6669,
    wearable_ids: [406, 346],
  },
  {
    genesis_token_id: 6670,
    wearable_ids: [411, 425],
  },
  {
    genesis_token_id: 6671,
    wearable_ids: [316, 286],
  },
  {
    genesis_token_id: 6672,
    wearable_ids: [276, 291],
  },
  {
    genesis_token_id: 6673,
    wearable_ids: [382, 265],
  },
  {
    genesis_token_id: 6674,
    wearable_ids: [271, 424],
  },
  {
    genesis_token_id: 6675,
    wearable_ids: [373, 330],
  },
  {
    genesis_token_id: 6676,
    wearable_ids: [265, 345],
  },
  {
    genesis_token_id: 6677,
    wearable_ids: [308, 260],
  },
  {
    genesis_token_id: 6678,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 6679,
    wearable_ids: [403, 437],
  },
  {
    genesis_token_id: 6680,
    wearable_ids: [348, 350],
  },
  {
    genesis_token_id: 6681,
    wearable_ids: [344, 406],
  },
  {
    genesis_token_id: 6682,
    wearable_ids: [346, 402],
  },
  {
    genesis_token_id: 6683,
    wearable_ids: [373, 389],
  },
  {
    genesis_token_id: 6684,
    wearable_ids: [278, 411],
  },
  {
    genesis_token_id: 6685,
    wearable_ids: [364, 254],
  },
  {
    genesis_token_id: 6686,
    wearable_ids: [395, 351],
  },
  {
    genesis_token_id: 6687,
    wearable_ids: [378, 318],
  },
  {
    genesis_token_id: 6688,
    wearable_ids: [400, 330],
  },
  {
    genesis_token_id: 6689,
    wearable_ids: [317, 374],
  },
  {
    genesis_token_id: 6690,
    wearable_ids: [428, 316],
  },
  {
    genesis_token_id: 6691,
    wearable_ids: [332, 411],
  },
  {
    genesis_token_id: 6692,
    wearable_ids: [375, 348],
  },
  {
    genesis_token_id: 6693,
    wearable_ids: [340, 270],
  },
  {
    genesis_token_id: 6694,
    wearable_ids: [300, 259],
  },
  {
    genesis_token_id: 6695,
    wearable_ids: [272, 354],
  },
  {
    genesis_token_id: 6696,
    wearable_ids: [346, 352],
  },
  {
    genesis_token_id: 6697,
    wearable_ids: [319, 294],
  },
  {
    genesis_token_id: 6698,
    wearable_ids: [264, 415],
  },
  {
    genesis_token_id: 6699,
    wearable_ids: [373, 371],
  },
  {
    genesis_token_id: 6700,
    wearable_ids: [420, 361],
  },
  {
    genesis_token_id: 6701,
    wearable_ids: [262, 285],
  },
  {
    genesis_token_id: 6702,
    wearable_ids: [286, 341],
  },
  {
    genesis_token_id: 6703,
    wearable_ids: [400, 372],
  },
  {
    genesis_token_id: 6704,
    wearable_ids: [314, 262],
  },
  {
    genesis_token_id: 6705,
    wearable_ids: [409, 247],
  },
  {
    genesis_token_id: 6706,
    wearable_ids: [311, 306],
  },
  {
    genesis_token_id: 6707,
    wearable_ids: [363, 338],
  },
  {
    genesis_token_id: 6708,
    wearable_ids: [406, 396],
  },
  {
    genesis_token_id: 6709,
    wearable_ids: [263, 324],
  },
  {
    genesis_token_id: 6710,
    wearable_ids: [422, 346],
  },
  {
    genesis_token_id: 6711,
    wearable_ids: [383, 396],
  },
  {
    genesis_token_id: 6712,
    wearable_ids: [301, 361],
  },
  {
    genesis_token_id: 6713,
    wearable_ids: [411, 343],
  },
  {
    genesis_token_id: 6714,
    wearable_ids: [412, 350],
  },
  {
    genesis_token_id: 6715,
    wearable_ids: [262, 363],
  },
  {
    genesis_token_id: 6716,
    wearable_ids: [348, 379],
  },
  {
    genesis_token_id: 6717,
    wearable_ids: [304, 260],
  },
  {
    genesis_token_id: 6718,
    wearable_ids: [272, 426],
  },
  {
    genesis_token_id: 6719,
    wearable_ids: [350, 274],
  },
  {
    genesis_token_id: 6720,
    wearable_ids: [342, 256],
  },
  {
    genesis_token_id: 6721,
    wearable_ids: [351, 305],
  },
  {
    genesis_token_id: 6722,
    wearable_ids: [341, 376],
  },
  {
    genesis_token_id: 6723,
    wearable_ids: [339, 277],
  },
  {
    genesis_token_id: 6724,
    wearable_ids: [410, 403],
  },
  {
    genesis_token_id: 6725,
    wearable_ids: [338, 428],
  },
  {
    genesis_token_id: 6726,
    wearable_ids: [332, 400],
  },
  {
    genesis_token_id: 6727,
    wearable_ids: [412, 274],
  },
  {
    genesis_token_id: 6728,
    wearable_ids: [389, 295],
  },
  {
    genesis_token_id: 6729,
    wearable_ids: [425, 364],
  },
  {
    genesis_token_id: 6730,
    wearable_ids: [272, 334],
  },
  {
    genesis_token_id: 6731,
    wearable_ids: [383, 429],
  },
  {
    genesis_token_id: 6732,
    wearable_ids: [444, 266],
  },
  {
    genesis_token_id: 6733,
    wearable_ids: [286, 391],
  },
  {
    genesis_token_id: 6734,
    wearable_ids: [324, 436],
  },
  {
    genesis_token_id: 6735,
    wearable_ids: [272, 353],
  },
  {
    genesis_token_id: 6736,
    wearable_ids: [423, 332],
  },
  {
    genesis_token_id: 6737,
    wearable_ids: [378, 246],
  },
  {
    genesis_token_id: 6738,
    wearable_ids: [289, 324],
  },
  {
    genesis_token_id: 6739,
    wearable_ids: [442, 414],
  },
  {
    genesis_token_id: 6740,
    wearable_ids: [325, 311],
  },
  {
    genesis_token_id: 6741,
    wearable_ids: [362, 423],
  },
  {
    genesis_token_id: 6742,
    wearable_ids: [276, 428],
  },
  {
    genesis_token_id: 6743,
    wearable_ids: [426, 386],
  },
  {
    genesis_token_id: 6744,
    wearable_ids: [404, 322],
  },
  {
    genesis_token_id: 6745,
    wearable_ids: [382, 396],
  },
  {
    genesis_token_id: 6746,
    wearable_ids: [433, 384],
  },
  {
    genesis_token_id: 6747,
    wearable_ids: [254, 358],
  },
  {
    genesis_token_id: 6748,
    wearable_ids: [426, 377],
  },
  {
    genesis_token_id: 6749,
    wearable_ids: [338, 402],
  },
  {
    genesis_token_id: 6750,
    wearable_ids: [306, 415],
  },
  {
    genesis_token_id: 6751,
    wearable_ids: [257, 297],
  },
  {
    genesis_token_id: 6752,
    wearable_ids: [424, 418],
  },
  {
    genesis_token_id: 6753,
    wearable_ids: [362, 326],
  },
  {
    genesis_token_id: 6754,
    wearable_ids: [331, 343],
  },
  {
    genesis_token_id: 6755,
    wearable_ids: [425, 247],
  },
  {
    genesis_token_id: 6756,
    wearable_ids: [287, 433],
  },
  {
    genesis_token_id: 6757,
    wearable_ids: [256, 354],
  },
  {
    genesis_token_id: 6758,
    wearable_ids: [347, 409],
  },
  {
    genesis_token_id: 6759,
    wearable_ids: [347, 402],
  },
  {
    genesis_token_id: 6760,
    wearable_ids: [346, 403],
  },
  {
    genesis_token_id: 6761,
    wearable_ids: [326, 325],
  },
  {
    genesis_token_id: 6762,
    wearable_ids: [300, 379],
  },
  {
    genesis_token_id: 6763,
    wearable_ids: [308, 399],
  },
  {
    genesis_token_id: 6764,
    wearable_ids: [443, 424],
  },
  {
    genesis_token_id: 6765,
    wearable_ids: [268, 262],
  },
  {
    genesis_token_id: 6766,
    wearable_ids: [444, 303],
  },
  {
    genesis_token_id: 6767,
    wearable_ids: [341, 306],
  },
  {
    genesis_token_id: 6768,
    wearable_ids: [437, 253],
  },
  {
    genesis_token_id: 6769,
    wearable_ids: [274, 405],
  },
  {
    genesis_token_id: 6770,
    wearable_ids: [407, 250],
  },
  {
    genesis_token_id: 6771,
    wearable_ids: [266, 281],
  },
  {
    genesis_token_id: 6772,
    wearable_ids: [291, 300],
  },
  {
    genesis_token_id: 6773,
    wearable_ids: [332, 257],
  },
  {
    genesis_token_id: 6774,
    wearable_ids: [363, 273],
  },
  {
    genesis_token_id: 6775,
    wearable_ids: [384, 385],
  },
  {
    genesis_token_id: 6776,
    wearable_ids: [400, 248],
  },
  {
    genesis_token_id: 6777,
    wearable_ids: [303, 417],
  },
  {
    genesis_token_id: 6778,
    wearable_ids: [248, 289],
  },
  {
    genesis_token_id: 6779,
    wearable_ids: [364, 354],
  },
  {
    genesis_token_id: 6780,
    wearable_ids: [396, 292],
  },
  {
    genesis_token_id: 6781,
    wearable_ids: [433, 288],
  },
  {
    genesis_token_id: 6782,
    wearable_ids: [428, 336],
  },
  {
    genesis_token_id: 6783,
    wearable_ids: [247, 255],
  },
  {
    genesis_token_id: 6784,
    wearable_ids: [433, 348],
  },
  {
    genesis_token_id: 6785,
    wearable_ids: [362, 260],
  },
  {
    genesis_token_id: 6786,
    wearable_ids: [382, 310],
  },
  {
    genesis_token_id: 6787,
    wearable_ids: [383, 346],
  },
  {
    genesis_token_id: 6788,
    wearable_ids: [412, 443],
  },
  {
    genesis_token_id: 6789,
    wearable_ids: [335, 402],
  },
  {
    genesis_token_id: 6790,
    wearable_ids: [317, 369],
  },
  {
    genesis_token_id: 6791,
    wearable_ids: [403, 295],
  },
  {
    genesis_token_id: 6792,
    wearable_ids: [403, 300],
  },
  {
    genesis_token_id: 6793,
    wearable_ids: [375, 365],
  },
  {
    genesis_token_id: 6794,
    wearable_ids: [433, 410],
  },
  {
    genesis_token_id: 6795,
    wearable_ids: [363, 323],
  },
  {
    genesis_token_id: 6796,
    wearable_ids: [407, 271],
  },
  {
    genesis_token_id: 6797,
    wearable_ids: [258, 355],
  },
  {
    genesis_token_id: 6798,
    wearable_ids: [362, 423],
  },
  {
    genesis_token_id: 6799,
    wearable_ids: [436, 374],
  },
  {
    genesis_token_id: 6800,
    wearable_ids: [341, 398],
  },
  {
    genesis_token_id: 6801,
    wearable_ids: [443, 271],
  },
  {
    genesis_token_id: 6802,
    wearable_ids: [278, 247],
  },
  {
    genesis_token_id: 6803,
    wearable_ids: [277, 331],
  },
  {
    genesis_token_id: 6804,
    wearable_ids: [423, 349],
  },
  {
    genesis_token_id: 6805,
    wearable_ids: [434, 292],
  },
  {
    genesis_token_id: 6806,
    wearable_ids: [289, 393],
  },
  {
    genesis_token_id: 6807,
    wearable_ids: [346, 413],
  },
  {
    genesis_token_id: 6808,
    wearable_ids: [339, 294],
  },
  {
    genesis_token_id: 6809,
    wearable_ids: [395, 429],
  },
  {
    genesis_token_id: 6810,
    wearable_ids: [355, 300],
  },
  {
    genesis_token_id: 6811,
    wearable_ids: [348, 332],
  },
  {
    genesis_token_id: 6812,
    wearable_ids: [297, 368],
  },
  {
    genesis_token_id: 6813,
    wearable_ids: [347, 257],
  },
  {
    genesis_token_id: 6814,
    wearable_ids: [434, 394],
  },
  {
    genesis_token_id: 6815,
    wearable_ids: [355, 335],
  },
  {
    genesis_token_id: 6816,
    wearable_ids: [339, 348],
  },
  {
    genesis_token_id: 6817,
    wearable_ids: [339, 303],
  },
  {
    genesis_token_id: 6818,
    wearable_ids: [289, 332],
  },
  {
    genesis_token_id: 6819,
    wearable_ids: [291, 313],
  },
  {
    genesis_token_id: 6820,
    wearable_ids: [351, 340],
  },
  {
    genesis_token_id: 6821,
    wearable_ids: [308, 251],
  },
  {
    genesis_token_id: 6822,
    wearable_ids: [422, 265],
  },
  {
    genesis_token_id: 6823,
    wearable_ids: [271, 259],
  },
  {
    genesis_token_id: 6824,
    wearable_ids: [371, 388],
  },
  {
    genesis_token_id: 6825,
    wearable_ids: [317, 414],
  },
  {
    genesis_token_id: 6826,
    wearable_ids: [254, 348],
  },
  {
    genesis_token_id: 6827,
    wearable_ids: [254, 359],
  },
  {
    genesis_token_id: 6828,
    wearable_ids: [384, 432],
  },
  {
    genesis_token_id: 6829,
    wearable_ids: [315, 435],
  },
  {
    genesis_token_id: 6830,
    wearable_ids: [311, 443],
  },
  {
    genesis_token_id: 6831,
    wearable_ids: [415, 349],
  },
  {
    genesis_token_id: 6832,
    wearable_ids: [426, 362],
  },
  {
    genesis_token_id: 6833,
    wearable_ids: [428, 268],
  },
  {
    genesis_token_id: 6834,
    wearable_ids: [340, 410],
  },
  {
    genesis_token_id: 6835,
    wearable_ids: [262, 408],
  },
  {
    genesis_token_id: 6836,
    wearable_ids: [411, 425],
  },
  {
    genesis_token_id: 6837,
    wearable_ids: [420, 378],
  },
  {
    genesis_token_id: 6838,
    wearable_ids: [319, 326],
  },
  {
    genesis_token_id: 6839,
    wearable_ids: [287, 316],
  },
  {
    genesis_token_id: 6840,
    wearable_ids: [277, 346],
  },
  {
    genesis_token_id: 6841,
    wearable_ids: [396, 342],
  },
  {
    genesis_token_id: 6842,
    wearable_ids: [411, 418],
  },
  {
    genesis_token_id: 6843,
    wearable_ids: [382, 341],
  },
  {
    genesis_token_id: 6844,
    wearable_ids: [396, 364],
  },
  {
    genesis_token_id: 6845,
    wearable_ids: [286, 291],
  },
  {
    genesis_token_id: 6846,
    wearable_ids: [262, 299],
  },
  {
    genesis_token_id: 6847,
    wearable_ids: [337, 292],
  },
  {
    genesis_token_id: 6848,
    wearable_ids: [426, 305],
  },
  {
    genesis_token_id: 6849,
    wearable_ids: [284, 340],
  },
  {
    genesis_token_id: 6850,
    wearable_ids: [289, 291],
  },
  {
    genesis_token_id: 6851,
    wearable_ids: [254, 289],
  },
  {
    genesis_token_id: 6852,
    wearable_ids: [362, 382],
  },
  {
    genesis_token_id: 6853,
    wearable_ids: [294, 413],
  },
  {
    genesis_token_id: 6854,
    wearable_ids: [399, 354],
  },
  {
    genesis_token_id: 6855,
    wearable_ids: [271, 422],
  },
  {
    genesis_token_id: 6856,
    wearable_ids: [396, 338],
  },
  {
    genesis_token_id: 6857,
    wearable_ids: [287, 305],
  },
  {
    genesis_token_id: 6858,
    wearable_ids: [344, 302],
  },
  {
    genesis_token_id: 6859,
    wearable_ids: [434, 410],
  },
  {
    genesis_token_id: 6860,
    wearable_ids: [371, 306],
  },
  {
    genesis_token_id: 6861,
    wearable_ids: [297, 437],
  },
  {
    genesis_token_id: 6862,
    wearable_ids: [350, 364],
  },
  {
    genesis_token_id: 6863,
    wearable_ids: [374, 280],
  },
  {
    genesis_token_id: 6864,
    wearable_ids: [384, 335],
  },
  {
    genesis_token_id: 6865,
    wearable_ids: [370, 420],
  },
  {
    genesis_token_id: 6866,
    wearable_ids: [303, 272],
  },
  {
    genesis_token_id: 6867,
    wearable_ids: [259, 287],
  },
  {
    genesis_token_id: 6868,
    wearable_ids: [280, 435],
  },
  {
    genesis_token_id: 6869,
    wearable_ids: [363, 362],
  },
  {
    genesis_token_id: 6870,
    wearable_ids: [259, 396],
  },
  {
    genesis_token_id: 6871,
    wearable_ids: [315, 296],
  },
  {
    genesis_token_id: 6872,
    wearable_ids: [337, 351],
  },
  {
    genesis_token_id: 6873,
    wearable_ids: [258, 304],
  },
  {
    genesis_token_id: 6874,
    wearable_ids: [263, 407],
  },
  {
    genesis_token_id: 6875,
    wearable_ids: [408, 302],
  },
  {
    genesis_token_id: 6876,
    wearable_ids: [311, 293],
  },
  {
    genesis_token_id: 6877,
    wearable_ids: [400, 363],
  },
  {
    genesis_token_id: 6878,
    wearable_ids: [435, 408],
  },
  {
    genesis_token_id: 6879,
    wearable_ids: [335, 414],
  },
  {
    genesis_token_id: 6880,
    wearable_ids: [423, 316],
  },
  {
    genesis_token_id: 6881,
    wearable_ids: [280, 257],
  },
  {
    genesis_token_id: 6882,
    wearable_ids: [374, 423],
  },
  {
    genesis_token_id: 6883,
    wearable_ids: [300, 306],
  },
  {
    genesis_token_id: 6884,
    wearable_ids: [362, 306],
  },
  {
    genesis_token_id: 6885,
    wearable_ids: [404, 295],
  },
  {
    genesis_token_id: 6886,
    wearable_ids: [445, 339],
  },
  {
    genesis_token_id: 6887,
    wearable_ids: [335, 264],
  },
  {
    genesis_token_id: 6888,
    wearable_ids: [395, 409],
  },
  {
    genesis_token_id: 6889,
    wearable_ids: [277, 369],
  },
  {
    genesis_token_id: 6890,
    wearable_ids: [335, 300],
  },
  {
    genesis_token_id: 6891,
    wearable_ids: [259, 323],
  },
  {
    genesis_token_id: 6892,
    wearable_ids: [319, 339],
  },
  {
    genesis_token_id: 6893,
    wearable_ids: [306, 362],
  },
  {
    genesis_token_id: 6894,
    wearable_ids: [276, 426],
  },
  {
    genesis_token_id: 6895,
    wearable_ids: [373, 282],
  },
  {
    genesis_token_id: 6896,
    wearable_ids: [297, 300],
  },
  {
    genesis_token_id: 6897,
    wearable_ids: [426, 345],
  },
  {
    genesis_token_id: 6898,
    wearable_ids: [408, 247],
  },
  {
    genesis_token_id: 6899,
    wearable_ids: [436, 342],
  },
  {
    genesis_token_id: 6900,
    wearable_ids: [289, 310],
  },
  {
    genesis_token_id: 6901,
    wearable_ids: [256, 363],
  },
  {
    genesis_token_id: 6902,
    wearable_ids: [311, 355],
  },
  {
    genesis_token_id: 6903,
    wearable_ids: [278, 365],
  },
  {
    genesis_token_id: 6904,
    wearable_ids: [433, 375],
  },
  {
    genesis_token_id: 6905,
    wearable_ids: [377, 261],
  },
  {
    genesis_token_id: 6906,
    wearable_ids: [316, 400],
  },
  {
    genesis_token_id: 6907,
    wearable_ids: [295, 291],
  },
  {
    genesis_token_id: 6908,
    wearable_ids: [255, 422],
  },
  {
    genesis_token_id: 6909,
    wearable_ids: [316, 276],
  },
  {
    genesis_token_id: 6910,
    wearable_ids: [406, 407],
  },
  {
    genesis_token_id: 6911,
    wearable_ids: [256, 322],
  },
  {
    genesis_token_id: 6912,
    wearable_ids: [373, 367],
  },
  {
    genesis_token_id: 6913,
    wearable_ids: [412, 308],
  },
  {
    genesis_token_id: 6914,
    wearable_ids: [351, 273],
  },
  {
    genesis_token_id: 6915,
    wearable_ids: [432, 254],
  },
  {
    genesis_token_id: 6916,
    wearable_ids: [362, 268],
  },
  {
    genesis_token_id: 6917,
    wearable_ids: [400, 273],
  },
  {
    genesis_token_id: 6918,
    wearable_ids: [378, 407],
  },
  {
    genesis_token_id: 6919,
    wearable_ids: [258, 284],
  },
  {
    genesis_token_id: 6920,
    wearable_ids: [315, 426],
  },
  {
    genesis_token_id: 6921,
    wearable_ids: [387, 262],
  },
  {
    genesis_token_id: 6922,
    wearable_ids: [383, 382],
  },
  {
    genesis_token_id: 6923,
    wearable_ids: [295, 404],
  },
  {
    genesis_token_id: 6924,
    wearable_ids: [371, 374],
  },
  {
    genesis_token_id: 6925,
    wearable_ids: [389, 430],
  },
  {
    genesis_token_id: 6926,
    wearable_ids: [336, 303],
  },
  {
    genesis_token_id: 6927,
    wearable_ids: [341, 255],
  },
  {
    genesis_token_id: 6928,
    wearable_ids: [324, 265],
  },
  {
    genesis_token_id: 6929,
    wearable_ids: [428, 395],
  },
  {
    genesis_token_id: 6930,
    wearable_ids: [406, 264],
  },
  {
    genesis_token_id: 6931,
    wearable_ids: [347, 326],
  },
  {
    genesis_token_id: 6932,
    wearable_ids: [415, 351],
  },
  {
    genesis_token_id: 6933,
    wearable_ids: [291, 405],
  },
  {
    genesis_token_id: 6934,
    wearable_ids: [410, 315],
  },
  {
    genesis_token_id: 6935,
    wearable_ids: [304, 433],
  },
  {
    genesis_token_id: 6936,
    wearable_ids: [431, 301],
  },
  {
    genesis_token_id: 6937,
    wearable_ids: [377, 254],
  },
  {
    genesis_token_id: 6938,
    wearable_ids: [263, 279],
  },
  {
    genesis_token_id: 6939,
    wearable_ids: [276, 398],
  },
  {
    genesis_token_id: 6940,
    wearable_ids: [317, 257],
  },
  {
    genesis_token_id: 6941,
    wearable_ids: [354, 330],
  },
  {
    genesis_token_id: 6942,
    wearable_ids: [310, 379],
  },
  {
    genesis_token_id: 6943,
    wearable_ids: [247, 408],
  },
  {
    genesis_token_id: 6944,
    wearable_ids: [332, 248],
  },
  {
    genesis_token_id: 6945,
    wearable_ids: [354, 388],
  },
  {
    genesis_token_id: 6946,
    wearable_ids: [409, 331],
  },
  {
    genesis_token_id: 6947,
    wearable_ids: [263, 347],
  },
  {
    genesis_token_id: 6948,
    wearable_ids: [294, 444],
  },
  {
    genesis_token_id: 6949,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 6950,
    wearable_ids: [255, 262],
  },
  {
    genesis_token_id: 6951,
    wearable_ids: [272, 433],
  },
  {
    genesis_token_id: 6952,
    wearable_ids: [300, 374],
  },
  {
    genesis_token_id: 6953,
    wearable_ids: [347, 270],
  },
  {
    genesis_token_id: 6954,
    wearable_ids: [308, 272],
  },
  {
    genesis_token_id: 6955,
    wearable_ids: [412, 312],
  },
  {
    genesis_token_id: 6956,
    wearable_ids: [387, 272],
  },
  {
    genesis_token_id: 6957,
    wearable_ids: [420, 270],
  },
  {
    genesis_token_id: 6958,
    wearable_ids: [254, 382],
  },
  {
    genesis_token_id: 6959,
    wearable_ids: [371, 373],
  },
  {
    genesis_token_id: 6960,
    wearable_ids: [306, 423],
  },
  {
    genesis_token_id: 6961,
    wearable_ids: [412, 411],
  },
  {
    genesis_token_id: 6962,
    wearable_ids: [396, 372],
  },
  {
    genesis_token_id: 6963,
    wearable_ids: [435, 372],
  },
  {
    genesis_token_id: 6964,
    wearable_ids: [355, 426],
  },
  {
    genesis_token_id: 6965,
    wearable_ids: [304, 324],
  },
  {
    genesis_token_id: 6966,
    wearable_ids: [339, 432],
  },
  {
    genesis_token_id: 6967,
    wearable_ids: [291, 401],
  },
  {
    genesis_token_id: 6968,
    wearable_ids: [262, 266],
  },
  {
    genesis_token_id: 6969,
    wearable_ids: [290, 389],
  },
  {
    genesis_token_id: 6970,
    wearable_ids: [259, 406],
  },
  {
    genesis_token_id: 6971,
    wearable_ids: [338, 433],
  },
  {
    genesis_token_id: 6972,
    wearable_ids: [248, 366],
  },
  {
    genesis_token_id: 6973,
    wearable_ids: [377, 374],
  },
  {
    genesis_token_id: 6974,
    wearable_ids: [415, 256],
  },
  {
    genesis_token_id: 6975,
    wearable_ids: [347, 285],
  },
  {
    genesis_token_id: 6976,
    wearable_ids: [265, 319],
  },
  {
    genesis_token_id: 6977,
    wearable_ids: [377, 365],
  },
  {
    genesis_token_id: 6978,
    wearable_ids: [251, 291],
  },
  {
    genesis_token_id: 6979,
    wearable_ids: [278, 339],
  },
  {
    genesis_token_id: 6980,
    wearable_ids: [264, 374],
  },
  {
    genesis_token_id: 6981,
    wearable_ids: [342, 426],
  },
  {
    genesis_token_id: 6982,
    wearable_ids: [383, 387],
  },
  {
    genesis_token_id: 6983,
    wearable_ids: [289, 253],
  },
  {
    genesis_token_id: 6984,
    wearable_ids: [272, 384],
  },
  {
    genesis_token_id: 6985,
    wearable_ids: [266, 368],
  },
  {
    genesis_token_id: 6986,
    wearable_ids: [404, 292],
  },
  {
    genesis_token_id: 6987,
    wearable_ids: [349, 335],
  },
  {
    genesis_token_id: 6988,
    wearable_ids: [387, 433],
  },
  {
    genesis_token_id: 6989,
    wearable_ids: [377, 268],
  },
  {
    genesis_token_id: 6990,
    wearable_ids: [378, 253],
  },
  {
    genesis_token_id: 6991,
    wearable_ids: [363, 393],
  },
  {
    genesis_token_id: 6992,
    wearable_ids: [253, 278],
  },
  {
    genesis_token_id: 6993,
    wearable_ids: [303, 268],
  },
  {
    genesis_token_id: 6994,
    wearable_ids: [348, 331],
  },
  {
    genesis_token_id: 6995,
    wearable_ids: [342, 351],
  },
  {
    genesis_token_id: 6996,
    wearable_ids: [319, 284],
  },
  {
    genesis_token_id: 6997,
    wearable_ids: [425, 387],
  },
  {
    genesis_token_id: 6998,
    wearable_ids: [410, 374],
  },
  {
    genesis_token_id: 6999,
    wearable_ids: [284, 292],
  },
  {
    genesis_token_id: 7000,
    wearable_ids: [315, 350],
  },
  {
    genesis_token_id: 7001,
    wearable_ids: [433, 368],
  },
  {
    genesis_token_id: 7002,
    wearable_ids: [289, 389],
  },
  {
    genesis_token_id: 7003,
    wearable_ids: [371, 265],
  },
  {
    genesis_token_id: 7004,
    wearable_ids: [385, 403],
  },
  {
    genesis_token_id: 7005,
    wearable_ids: [444, 320],
  },
  {
    genesis_token_id: 7006,
    wearable_ids: [286, 370],
  },
  {
    genesis_token_id: 7007,
    wearable_ids: [317, 442],
  },
  {
    genesis_token_id: 7008,
    wearable_ids: [368, 370],
  },
  {
    genesis_token_id: 7009,
    wearable_ids: [306, 341],
  },
  {
    genesis_token_id: 7010,
    wearable_ids: [278, 307],
  },
  {
    genesis_token_id: 7011,
    wearable_ids: [387, 347],
  },
  {
    genesis_token_id: 7012,
    wearable_ids: [266, 365],
  },
  {
    genesis_token_id: 7013,
    wearable_ids: [265, 407],
  },
  {
    genesis_token_id: 7014,
    wearable_ids: [297, 342],
  },
  {
    genesis_token_id: 7015,
    wearable_ids: [289, 347],
  },
  {
    genesis_token_id: 7016,
    wearable_ids: [257, 420],
  },
  {
    genesis_token_id: 7017,
    wearable_ids: [263, 399],
  },
  {
    genesis_token_id: 7018,
    wearable_ids: [290, 405],
  },
  {
    genesis_token_id: 7019,
    wearable_ids: [262, 392],
  },
  {
    genesis_token_id: 7020,
    wearable_ids: [420, 349],
  },
  {
    genesis_token_id: 7021,
    wearable_ids: [408, 271],
  },
  {
    genesis_token_id: 7022,
    wearable_ids: [382, 432],
  },
  {
    genesis_token_id: 7023,
    wearable_ids: [265, 443],
  },
  {
    genesis_token_id: 7024,
    wearable_ids: [350, 307],
  },
  {
    genesis_token_id: 7025,
    wearable_ids: [291, 374],
  },
  {
    genesis_token_id: 7026,
    wearable_ids: [432, 315],
  },
  {
    genesis_token_id: 7027,
    wearable_ids: [326, 363],
  },
  {
    genesis_token_id: 7028,
    wearable_ids: [375, 429],
  },
  {
    genesis_token_id: 7029,
    wearable_ids: [351, 372],
  },
  {
    genesis_token_id: 7030,
    wearable_ids: [354, 264],
  },
  {
    genesis_token_id: 7031,
    wearable_ids: [436, 434],
  },
  {
    genesis_token_id: 7032,
    wearable_ids: [372, 420],
  },
  {
    genesis_token_id: 7033,
    wearable_ids: [259, 426],
  },
  {
    genesis_token_id: 7034,
    wearable_ids: [326, 313],
  },
  {
    genesis_token_id: 7035,
    wearable_ids: [257, 437],
  },
  {
    genesis_token_id: 7036,
    wearable_ids: [373, 435],
  },
  {
    genesis_token_id: 7037,
    wearable_ids: [343, 387],
  },
  {
    genesis_token_id: 7038,
    wearable_ids: [354, 265],
  },
  {
    genesis_token_id: 7039,
    wearable_ids: [365, 425],
  },
  {
    genesis_token_id: 7040,
    wearable_ids: [389, 428],
  },
  {
    genesis_token_id: 7041,
    wearable_ids: [425, 335],
  },
  {
    genesis_token_id: 7042,
    wearable_ids: [346, 345],
  },
  {
    genesis_token_id: 7043,
    wearable_ids: [397, 291],
  },
  {
    genesis_token_id: 7044,
    wearable_ids: [362, 406],
  },
  {
    genesis_token_id: 7045,
    wearable_ids: [258, 347],
  },
  {
    genesis_token_id: 7046,
    wearable_ids: [378, 256],
  },
  {
    genesis_token_id: 7047,
    wearable_ids: [268, 318],
  },
  {
    genesis_token_id: 7048,
    wearable_ids: [363, 353],
  },
  {
    genesis_token_id: 7049,
    wearable_ids: [370, 278],
  },
  {
    genesis_token_id: 7050,
    wearable_ids: [349, 291],
  },
  {
    genesis_token_id: 7051,
    wearable_ids: [406, 412],
  },
  {
    genesis_token_id: 7052,
    wearable_ids: [352, 437],
  },
  {
    genesis_token_id: 7053,
    wearable_ids: [247, 369],
  },
  {
    genesis_token_id: 7054,
    wearable_ids: [324, 354],
  },
  {
    genesis_token_id: 7055,
    wearable_ids: [253, 325],
  },
  {
    genesis_token_id: 7056,
    wearable_ids: [319, 326],
  },
  {
    genesis_token_id: 7057,
    wearable_ids: [325, 346],
  },
  {
    genesis_token_id: 7058,
    wearable_ids: [280, 253],
  },
  {
    genesis_token_id: 7059,
    wearable_ids: [352, 248],
  },
  {
    genesis_token_id: 7060,
    wearable_ids: [426, 306],
  },
  {
    genesis_token_id: 7061,
    wearable_ids: [299, 434],
  },
  {
    genesis_token_id: 7062,
    wearable_ids: [311, 411],
  },
  {
    genesis_token_id: 7063,
    wearable_ids: [325, 430],
  },
  {
    genesis_token_id: 7064,
    wearable_ids: [363, 423],
  },
  {
    genesis_token_id: 7065,
    wearable_ids: [284, 386],
  },
  {
    genesis_token_id: 7066,
    wearable_ids: [423, 351],
  },
  {
    genesis_token_id: 7067,
    wearable_ids: [349, 326],
  },
  {
    genesis_token_id: 7068,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 7069,
    wearable_ids: [338, 351],
  },
  {
    genesis_token_id: 7070,
    wearable_ids: [291, 246],
  },
  {
    genesis_token_id: 7071,
    wearable_ids: [265, 274],
  },
  {
    genesis_token_id: 7072,
    wearable_ids: [338, 327],
  },
  {
    genesis_token_id: 7073,
    wearable_ids: [434, 369],
  },
  {
    genesis_token_id: 7074,
    wearable_ids: [343, 256],
  },
  {
    genesis_token_id: 7075,
    wearable_ids: [385, 300],
  },
  {
    genesis_token_id: 7076,
    wearable_ids: [343, 251],
  },
  {
    genesis_token_id: 7077,
    wearable_ids: [343, 369],
  },
  {
    genesis_token_id: 7078,
    wearable_ids: [332, 263],
  },
  {
    genesis_token_id: 7079,
    wearable_ids: [423, 399],
  },
  {
    genesis_token_id: 7080,
    wearable_ids: [254, 292],
  },
  {
    genesis_token_id: 7081,
    wearable_ids: [337, 327],
  },
  {
    genesis_token_id: 7082,
    wearable_ids: [292, 349],
  },
  {
    genesis_token_id: 7083,
    wearable_ids: [295, 419],
  },
  {
    genesis_token_id: 7084,
    wearable_ids: [434, 407],
  },
  {
    genesis_token_id: 7085,
    wearable_ids: [429, 331],
  },
  {
    genesis_token_id: 7086,
    wearable_ids: [337, 271],
  },
  {
    genesis_token_id: 7087,
    wearable_ids: [310, 411],
  },
  {
    genesis_token_id: 7088,
    wearable_ids: [287, 414],
  },
  {
    genesis_token_id: 7089,
    wearable_ids: [409, 424],
  },
  {
    genesis_token_id: 7090,
    wearable_ids: [277, 317],
  },
  {
    genesis_token_id: 7091,
    wearable_ids: [351, 276],
  },
  {
    genesis_token_id: 7092,
    wearable_ids: [273, 445],
  },
  {
    genesis_token_id: 7093,
    wearable_ids: [308, 428],
  },
  {
    genesis_token_id: 7094,
    wearable_ids: [362, 291],
  },
  {
    genesis_token_id: 7095,
    wearable_ids: [265, 365],
  },
  {
    genesis_token_id: 7096,
    wearable_ids: [299, 326],
  },
  {
    genesis_token_id: 7097,
    wearable_ids: [411, 254],
  },
  {
    genesis_token_id: 7098,
    wearable_ids: [397, 403],
  },
  {
    genesis_token_id: 7099,
    wearable_ids: [445, 264],
  },
  {
    genesis_token_id: 7100,
    wearable_ids: [445, 426],
  },
  {
    genesis_token_id: 7101,
    wearable_ids: [437, 326],
  },
  {
    genesis_token_id: 7102,
    wearable_ids: [257, 285],
  },
  {
    genesis_token_id: 7103,
    wearable_ids: [297, 275],
  },
  {
    genesis_token_id: 7104,
    wearable_ids: [291, 353],
  },
  {
    genesis_token_id: 7105,
    wearable_ids: [408, 342],
  },
  {
    genesis_token_id: 7106,
    wearable_ids: [409, 387],
  },
  {
    genesis_token_id: 7107,
    wearable_ids: [410, 331],
  },
  {
    genesis_token_id: 7108,
    wearable_ids: [311, 426],
  },
  {
    genesis_token_id: 7109,
    wearable_ids: [271, 290],
  },
  {
    genesis_token_id: 7110,
    wearable_ids: [429, 297],
  },
  {
    genesis_token_id: 7111,
    wearable_ids: [295, 397],
  },
  {
    genesis_token_id: 7112,
    wearable_ids: [424, 347],
  },
  {
    genesis_token_id: 7113,
    wearable_ids: [445, 429],
  },
  {
    genesis_token_id: 7114,
    wearable_ids: [422, 295],
  },
  {
    genesis_token_id: 7115,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 7116,
    wearable_ids: [426, 319],
  },
  {
    genesis_token_id: 7117,
    wearable_ids: [295, 336],
  },
  {
    genesis_token_id: 7118,
    wearable_ids: [299, 348],
  },
  {
    genesis_token_id: 7119,
    wearable_ids: [411, 277],
  },
  {
    genesis_token_id: 7120,
    wearable_ids: [319, 387],
  },
  {
    genesis_token_id: 7121,
    wearable_ids: [351, 324],
  },
  {
    genesis_token_id: 7122,
    wearable_ids: [344, 420],
  },
  {
    genesis_token_id: 7123,
    wearable_ids: [319, 377],
  },
  {
    genesis_token_id: 7124,
    wearable_ids: [389, 397],
  },
  {
    genesis_token_id: 7125,
    wearable_ids: [268, 339],
  },
  {
    genesis_token_id: 7126,
    wearable_ids: [296, 342],
  },
  {
    genesis_token_id: 7127,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 7128,
    wearable_ids: [365, 325],
  },
  {
    genesis_token_id: 7129,
    wearable_ids: [256, 304],
  },
  {
    genesis_token_id: 7130,
    wearable_ids: [287, 294],
  },
  {
    genesis_token_id: 7131,
    wearable_ids: [262, 297],
  },
  {
    genesis_token_id: 7132,
    wearable_ids: [317, 301],
  },
  {
    genesis_token_id: 7133,
    wearable_ids: [248, 304],
  },
  {
    genesis_token_id: 7134,
    wearable_ids: [400, 420],
  },
  {
    genesis_token_id: 7135,
    wearable_ids: [376, 277],
  },
  {
    genesis_token_id: 7136,
    wearable_ids: [317, 385],
  },
  {
    genesis_token_id: 7137,
    wearable_ids: [352, 300],
  },
  {
    genesis_token_id: 7138,
    wearable_ids: [278, 311],
  },
  {
    genesis_token_id: 7139,
    wearable_ids: [273, 294],
  },
  {
    genesis_token_id: 7140,
    wearable_ids: [443, 342],
  },
  {
    genesis_token_id: 7141,
    wearable_ids: [369, 288],
  },
  {
    genesis_token_id: 7142,
    wearable_ids: [286, 370],
  },
  {
    genesis_token_id: 7143,
    wearable_ids: [251, 341],
  },
  {
    genesis_token_id: 7144,
    wearable_ids: [335, 349],
  },
  {
    genesis_token_id: 7145,
    wearable_ids: [308, 265],
  },
  {
    genesis_token_id: 7146,
    wearable_ids: [300, 377],
  },
  {
    genesis_token_id: 7147,
    wearable_ids: [349, 270],
  },
  {
    genesis_token_id: 7148,
    wearable_ids: [433, 255],
  },
  {
    genesis_token_id: 7149,
    wearable_ids: [346, 365],
  },
  {
    genesis_token_id: 7150,
    wearable_ids: [406, 443],
  },
  {
    genesis_token_id: 7151,
    wearable_ids: [384, 360],
  },
  {
    genesis_token_id: 7152,
    wearable_ids: [384, 271],
  },
  {
    genesis_token_id: 7153,
    wearable_ids: [387, 362],
  },
  {
    genesis_token_id: 7154,
    wearable_ids: [271, 428],
  },
  {
    genesis_token_id: 7155,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 7156,
    wearable_ids: [432, 430],
  },
  {
    genesis_token_id: 7157,
    wearable_ids: [387, 374],
  },
  {
    genesis_token_id: 7158,
    wearable_ids: [434, 276],
  },
  {
    genesis_token_id: 7159,
    wearable_ids: [385, 443],
  },
  {
    genesis_token_id: 7160,
    wearable_ids: [426, 383],
  },
  {
    genesis_token_id: 7161,
    wearable_ids: [410, 260],
  },
  {
    genesis_token_id: 7162,
    wearable_ids: [271, 320],
  },
  {
    genesis_token_id: 7163,
    wearable_ids: [415, 308],
  },
  {
    genesis_token_id: 7164,
    wearable_ids: [410, 397],
  },
  {
    genesis_token_id: 7165,
    wearable_ids: [429, 368],
  },
  {
    genesis_token_id: 7166,
    wearable_ids: [271, 416],
  },
  {
    genesis_token_id: 7167,
    wearable_ids: [407, 435],
  },
  {
    genesis_token_id: 7168,
    wearable_ids: [344, 313],
  },
  {
    genesis_token_id: 7169,
    wearable_ids: [385, 285],
  },
  {
    genesis_token_id: 7170,
    wearable_ids: [354, 377],
  },
  {
    genesis_token_id: 7171,
    wearable_ids: [346, 289],
  },
  {
    genesis_token_id: 7172,
    wearable_ids: [268, 403],
  },
  {
    genesis_token_id: 7173,
    wearable_ids: [349, 295],
  },
  {
    genesis_token_id: 7174,
    wearable_ids: [262, 263],
  },
  {
    genesis_token_id: 7175,
    wearable_ids: [325, 364],
  },
  {
    genesis_token_id: 7176,
    wearable_ids: [338, 342],
  },
  {
    genesis_token_id: 7177,
    wearable_ids: [284, 269],
  },
  {
    genesis_token_id: 7178,
    wearable_ids: [382, 273],
  },
  {
    genesis_token_id: 7179,
    wearable_ids: [371, 393],
  },
  {
    genesis_token_id: 7180,
    wearable_ids: [255, 418],
  },
  {
    genesis_token_id: 7181,
    wearable_ids: [386, 359],
  },
  {
    genesis_token_id: 7182,
    wearable_ids: [434, 266],
  },
  {
    genesis_token_id: 7183,
    wearable_ids: [273, 332],
  },
  {
    genesis_token_id: 7184,
    wearable_ids: [300, 436],
  },
  {
    genesis_token_id: 7185,
    wearable_ids: [400, 295],
  },
  {
    genesis_token_id: 7186,
    wearable_ids: [384, 359],
  },
  {
    genesis_token_id: 7187,
    wearable_ids: [410, 385],
  },
  {
    genesis_token_id: 7188,
    wearable_ids: [435, 402],
  },
  {
    genesis_token_id: 7189,
    wearable_ids: [350, 407],
  },
  {
    genesis_token_id: 7190,
    wearable_ids: [342, 436],
  },
  {
    genesis_token_id: 7191,
    wearable_ids: [292, 426],
  },
  {
    genesis_token_id: 7192,
    wearable_ids: [265, 301],
  },
  {
    genesis_token_id: 7193,
    wearable_ids: [344, 415],
  },
  {
    genesis_token_id: 7194,
    wearable_ids: [256, 324],
  },
  {
    genesis_token_id: 7195,
    wearable_ids: [436, 336],
  },
  {
    genesis_token_id: 7196,
    wearable_ids: [352, 350],
  },
  {
    genesis_token_id: 7197,
    wearable_ids: [375, 400],
  },
  {
    genesis_token_id: 7198,
    wearable_ids: [277, 389],
  },
  {
    genesis_token_id: 7199,
    wearable_ids: [352, 411],
  },
  {
    genesis_token_id: 7200,
    wearable_ids: [351, 319],
  },
  {
    genesis_token_id: 7201,
    wearable_ids: [326, 265],
  },
  {
    genesis_token_id: 7202,
    wearable_ids: [273, 382],
  },
  {
    genesis_token_id: 7203,
    wearable_ids: [316, 250],
  },
  {
    genesis_token_id: 7204,
    wearable_ids: [265, 316],
  },
  {
    genesis_token_id: 7205,
    wearable_ids: [251, 341],
  },
  {
    genesis_token_id: 7206,
    wearable_ids: [256, 251],
  },
  {
    genesis_token_id: 7207,
    wearable_ids: [297, 427],
  },
  {
    genesis_token_id: 7208,
    wearable_ids: [369, 269],
  },
  {
    genesis_token_id: 7209,
    wearable_ids: [319, 426],
  },
  {
    genesis_token_id: 7210,
    wearable_ids: [389, 423],
  },
  {
    genesis_token_id: 7211,
    wearable_ids: [314, 394],
  },
  {
    genesis_token_id: 7212,
    wearable_ids: [317, 271],
  },
  {
    genesis_token_id: 7213,
    wearable_ids: [368, 425],
  },
  {
    genesis_token_id: 7214,
    wearable_ids: [343, 357],
  },
  {
    genesis_token_id: 7215,
    wearable_ids: [362, 325],
  },
  {
    genesis_token_id: 7216,
    wearable_ids: [344, 445],
  },
  {
    genesis_token_id: 7217,
    wearable_ids: [272, 413],
  },
  {
    genesis_token_id: 7218,
    wearable_ids: [434, 425],
  },
  {
    genesis_token_id: 7219,
    wearable_ids: [424, 403],
  },
  {
    genesis_token_id: 7220,
    wearable_ids: [324, 347],
  },
  {
    genesis_token_id: 7221,
    wearable_ids: [423, 293],
  },
  {
    genesis_token_id: 7222,
    wearable_ids: [310, 339],
  },
  {
    genesis_token_id: 7223,
    wearable_ids: [424, 404],
  },
  {
    genesis_token_id: 7224,
    wearable_ids: [395, 298],
  },
  {
    genesis_token_id: 7225,
    wearable_ids: [374, 343],
  },
  {
    genesis_token_id: 7226,
    wearable_ids: [343, 420],
  },
  {
    genesis_token_id: 7227,
    wearable_ids: [433, 355],
  },
  {
    genesis_token_id: 7228,
    wearable_ids: [304, 267],
  },
  {
    genesis_token_id: 7229,
    wearable_ids: [291, 280],
  },
  {
    genesis_token_id: 7230,
    wearable_ids: [412, 315],
  },
  {
    genesis_token_id: 7231,
    wearable_ids: [354, 287],
  },
  {
    genesis_token_id: 7232,
    wearable_ids: [362, 403],
  },
  {
    genesis_token_id: 7233,
    wearable_ids: [340, 297],
  },
  {
    genesis_token_id: 7234,
    wearable_ids: [346, 310],
  },
  {
    genesis_token_id: 7235,
    wearable_ids: [445, 422],
  },
  {
    genesis_token_id: 7236,
    wearable_ids: [297, 370],
  },
  {
    genesis_token_id: 7237,
    wearable_ids: [404, 362],
  },
  {
    genesis_token_id: 7238,
    wearable_ids: [434, 287],
  },
  {
    genesis_token_id: 7239,
    wearable_ids: [403, 372],
  },
  {
    genesis_token_id: 7240,
    wearable_ids: [376, 259],
  },
  {
    genesis_token_id: 7241,
    wearable_ids: [413, 406],
  },
  {
    genesis_token_id: 7242,
    wearable_ids: [347, 375],
  },
  {
    genesis_token_id: 7243,
    wearable_ids: [374, 339],
  },
  {
    genesis_token_id: 7244,
    wearable_ids: [289, 406],
  },
  {
    genesis_token_id: 7245,
    wearable_ids: [423, 312],
  },
  {
    genesis_token_id: 7246,
    wearable_ids: [268, 443],
  },
  {
    genesis_token_id: 7247,
    wearable_ids: [303, 431],
  },
  {
    genesis_token_id: 7248,
    wearable_ids: [339, 276],
  },
  {
    genesis_token_id: 7249,
    wearable_ids: [365, 395],
  },
  {
    genesis_token_id: 7250,
    wearable_ids: [254, 365],
  },
  {
    genesis_token_id: 7251,
    wearable_ids: [434, 344],
  },
  {
    genesis_token_id: 7252,
    wearable_ids: [338, 385],
  },
  {
    genesis_token_id: 7253,
    wearable_ids: [396, 438],
  },
  {
    genesis_token_id: 7254,
    wearable_ids: [287, 254],
  },
  {
    genesis_token_id: 7255,
    wearable_ids: [365, 319],
  },
  {
    genesis_token_id: 7256,
    wearable_ids: [304, 369],
  },
  {
    genesis_token_id: 7257,
    wearable_ids: [408, 441],
  },
  {
    genesis_token_id: 7258,
    wearable_ids: [310, 358],
  },
  {
    genesis_token_id: 7259,
    wearable_ids: [304, 289],
  },
  {
    genesis_token_id: 7260,
    wearable_ids: [332, 310],
  },
  {
    genesis_token_id: 7261,
    wearable_ids: [316, 292],
  },
  {
    genesis_token_id: 7262,
    wearable_ids: [374, 422],
  },
  {
    genesis_token_id: 7263,
    wearable_ids: [411, 284],
  },
  {
    genesis_token_id: 7264,
    wearable_ids: [271, 422],
  },
  {
    genesis_token_id: 7265,
    wearable_ids: [347, 440],
  },
  {
    genesis_token_id: 7266,
    wearable_ids: [406, 362],
  },
  {
    genesis_token_id: 7267,
    wearable_ids: [346, 311],
  },
  {
    genesis_token_id: 7268,
    wearable_ids: [400, 338],
  },
  {
    genesis_token_id: 7269,
    wearable_ids: [382, 302],
  },
  {
    genesis_token_id: 7270,
    wearable_ids: [422, 361],
  },
  {
    genesis_token_id: 7271,
    wearable_ids: [365, 296],
  },
  {
    genesis_token_id: 7272,
    wearable_ids: [428, 429],
  },
  {
    genesis_token_id: 7273,
    wearable_ids: [409, 292],
  },
  {
    genesis_token_id: 7274,
    wearable_ids: [277, 414],
  },
  {
    genesis_token_id: 7275,
    wearable_ids: [310, 253],
  },
  {
    genesis_token_id: 7276,
    wearable_ids: [295, 300],
  },
  {
    genesis_token_id: 7277,
    wearable_ids: [373, 408],
  },
  {
    genesis_token_id: 7278,
    wearable_ids: [349, 442],
  },
  {
    genesis_token_id: 7279,
    wearable_ids: [348, 293],
  },
  {
    genesis_token_id: 7280,
    wearable_ids: [306, 434],
  },
  {
    genesis_token_id: 7281,
    wearable_ids: [251, 284],
  },
  {
    genesis_token_id: 7282,
    wearable_ids: [251, 436],
  },
  {
    genesis_token_id: 7283,
    wearable_ids: [363, 426],
  },
  {
    genesis_token_id: 7284,
    wearable_ids: [349, 289],
  },
  {
    genesis_token_id: 7285,
    wearable_ids: [268, 301],
  },
  {
    genesis_token_id: 7286,
    wearable_ids: [284, 262],
  },
  {
    genesis_token_id: 7287,
    wearable_ids: [273, 255],
  },
  {
    genesis_token_id: 7288,
    wearable_ids: [355, 396],
  },
  {
    genesis_token_id: 7289,
    wearable_ids: [280, 271],
  },
  {
    genesis_token_id: 7290,
    wearable_ids: [314, 345],
  },
  {
    genesis_token_id: 7291,
    wearable_ids: [289, 362],
  },
  {
    genesis_token_id: 7292,
    wearable_ids: [436, 382],
  },
  {
    genesis_token_id: 7293,
    wearable_ids: [442, 370],
  },
  {
    genesis_token_id: 7294,
    wearable_ids: [344, 445],
  },
  {
    genesis_token_id: 7295,
    wearable_ids: [274, 350],
  },
  {
    genesis_token_id: 7296,
    wearable_ids: [352, 412],
  },
  {
    genesis_token_id: 7297,
    wearable_ids: [337, 279],
  },
  {
    genesis_token_id: 7298,
    wearable_ids: [403, 274],
  },
  {
    genesis_token_id: 7299,
    wearable_ids: [397, 362],
  },
  {
    genesis_token_id: 7300,
    wearable_ids: [286, 275],
  },
  {
    genesis_token_id: 7301,
    wearable_ids: [304, 273],
  },
  {
    genesis_token_id: 7302,
    wearable_ids: [443, 345],
  },
  {
    genesis_token_id: 7303,
    wearable_ids: [339, 381],
  },
  {
    genesis_token_id: 7304,
    wearable_ids: [306, 295],
  },
  {
    genesis_token_id: 7305,
    wearable_ids: [368, 254],
  },
  {
    genesis_token_id: 7306,
    wearable_ids: [404, 437],
  },
  {
    genesis_token_id: 7307,
    wearable_ids: [365, 340],
  },
  {
    genesis_token_id: 7308,
    wearable_ids: [295, 326],
  },
  {
    genesis_token_id: 7309,
    wearable_ids: [295, 397],
  },
  {
    genesis_token_id: 7310,
    wearable_ids: [315, 402],
  },
  {
    genesis_token_id: 7311,
    wearable_ids: [280, 300],
  },
  {
    genesis_token_id: 7312,
    wearable_ids: [290, 335],
  },
  {
    genesis_token_id: 7313,
    wearable_ids: [442, 278],
  },
  {
    genesis_token_id: 7314,
    wearable_ids: [408, 300],
  },
  {
    genesis_token_id: 7315,
    wearable_ids: [404, 369],
  },
  {
    genesis_token_id: 7316,
    wearable_ids: [420, 251],
  },
  {
    genesis_token_id: 7317,
    wearable_ids: [280, 312],
  },
  {
    genesis_token_id: 7318,
    wearable_ids: [342, 412],
  },
  {
    genesis_token_id: 7319,
    wearable_ids: [277, 326],
  },
  {
    genesis_token_id: 7320,
    wearable_ids: [385, 278],
  },
  {
    genesis_token_id: 7321,
    wearable_ids: [425, 445],
  },
  {
    genesis_token_id: 7322,
    wearable_ids: [257, 431],
  },
  {
    genesis_token_id: 7323,
    wearable_ids: [308, 378],
  },
  {
    genesis_token_id: 7324,
    wearable_ids: [270, 426],
  },
  {
    genesis_token_id: 7325,
    wearable_ids: [399, 259],
  },
  {
    genesis_token_id: 7326,
    wearable_ids: [377, 290],
  },
  {
    genesis_token_id: 7327,
    wearable_ids: [277, 433],
  },
  {
    genesis_token_id: 7328,
    wearable_ids: [268, 290],
  },
  {
    genesis_token_id: 7329,
    wearable_ids: [409, 299],
  },
  {
    genesis_token_id: 7330,
    wearable_ids: [326, 312],
  },
  {
    genesis_token_id: 7331,
    wearable_ids: [332, 290],
  },
  {
    genesis_token_id: 7332,
    wearable_ids: [385, 422],
  },
  {
    genesis_token_id: 7333,
    wearable_ids: [373, 254],
  },
  {
    genesis_token_id: 7334,
    wearable_ids: [273, 264],
  },
  {
    genesis_token_id: 7335,
    wearable_ids: [274, 413],
  },
  {
    genesis_token_id: 7336,
    wearable_ids: [340, 436],
  },
  {
    genesis_token_id: 7337,
    wearable_ids: [420, 416],
  },
  {
    genesis_token_id: 7338,
    wearable_ids: [264, 432],
  },
  {
    genesis_token_id: 7339,
    wearable_ids: [437, 289],
  },
  {
    genesis_token_id: 7340,
    wearable_ids: [399, 324],
  },
  {
    genesis_token_id: 7341,
    wearable_ids: [411, 310],
  },
  {
    genesis_token_id: 7342,
    wearable_ids: [424, 304],
  },
  {
    genesis_token_id: 7343,
    wearable_ids: [273, 287],
  },
  {
    genesis_token_id: 7344,
    wearable_ids: [408, 272],
  },
  {
    genesis_token_id: 7345,
    wearable_ids: [311, 281],
  },
  {
    genesis_token_id: 7346,
    wearable_ids: [428, 257],
  },
  {
    genesis_token_id: 7347,
    wearable_ids: [442, 384],
  },
  {
    genesis_token_id: 7348,
    wearable_ids: [377, 354],
  },
  {
    genesis_token_id: 7349,
    wearable_ids: [386, 413],
  },
  {
    genesis_token_id: 7350,
    wearable_ids: [304, 428],
  },
  {
    genesis_token_id: 7351,
    wearable_ids: [296, 378],
  },
  {
    genesis_token_id: 7352,
    wearable_ids: [442, 413],
  },
  {
    genesis_token_id: 7353,
    wearable_ids: [442, 262],
  },
  {
    genesis_token_id: 7354,
    wearable_ids: [299, 319],
  },
  {
    genesis_token_id: 7355,
    wearable_ids: [289, 335],
  },
  {
    genesis_token_id: 7356,
    wearable_ids: [319, 314],
  },
  {
    genesis_token_id: 7357,
    wearable_ids: [343, 265],
  },
  {
    genesis_token_id: 7358,
    wearable_ids: [336, 254],
  },
  {
    genesis_token_id: 7359,
    wearable_ids: [352, 316],
  },
  {
    genesis_token_id: 7360,
    wearable_ids: [251, 263],
  },
  {
    genesis_token_id: 7361,
    wearable_ids: [337, 295],
  },
  {
    genesis_token_id: 7362,
    wearable_ids: [303, 387],
  },
  {
    genesis_token_id: 7363,
    wearable_ids: [426, 397],
  },
  {
    genesis_token_id: 7364,
    wearable_ids: [369, 407],
  },
  {
    genesis_token_id: 7365,
    wearable_ids: [350, 408],
  },
  {
    genesis_token_id: 7366,
    wearable_ids: [280, 278],
  },
  {
    genesis_token_id: 7367,
    wearable_ids: [376, 445],
  },
  {
    genesis_token_id: 7368,
    wearable_ids: [299, 413],
  },
  {
    genesis_token_id: 7369,
    wearable_ids: [429, 371],
  },
  {
    genesis_token_id: 7370,
    wearable_ids: [339, 444],
  },
  {
    genesis_token_id: 7371,
    wearable_ids: [432, 307],
  },
  {
    genesis_token_id: 7372,
    wearable_ids: [295, 433],
  },
  {
    genesis_token_id: 7373,
    wearable_ids: [404, 434],
  },
  {
    genesis_token_id: 7374,
    wearable_ids: [399, 312],
  },
  {
    genesis_token_id: 7375,
    wearable_ids: [274, 256],
  },
  {
    genesis_token_id: 7376,
    wearable_ids: [338, 276],
  },
  {
    genesis_token_id: 7377,
    wearable_ids: [292, 355],
  },
  {
    genesis_token_id: 7378,
    wearable_ids: [422, 254],
  },
  {
    genesis_token_id: 7379,
    wearable_ids: [364, 303],
  },
  {
    genesis_token_id: 7380,
    wearable_ids: [292, 251],
  },
  {
    genesis_token_id: 7381,
    wearable_ids: [434, 265],
  },
  {
    genesis_token_id: 7382,
    wearable_ids: [408, 326],
  },
  {
    genesis_token_id: 7383,
    wearable_ids: [263, 269],
  },
  {
    genesis_token_id: 7384,
    wearable_ids: [368, 308],
  },
  {
    genesis_token_id: 7385,
    wearable_ids: [434, 253],
  },
  {
    genesis_token_id: 7386,
    wearable_ids: [395, 434],
  },
  {
    genesis_token_id: 7387,
    wearable_ids: [311, 351],
  },
  {
    genesis_token_id: 7388,
    wearable_ids: [256, 344],
  },
  {
    genesis_token_id: 7389,
    wearable_ids: [387, 368],
  },
  {
    genesis_token_id: 7390,
    wearable_ids: [436, 349],
  },
  {
    genesis_token_id: 7391,
    wearable_ids: [347, 411],
  },
  {
    genesis_token_id: 7392,
    wearable_ids: [350, 348],
  },
  {
    genesis_token_id: 7393,
    wearable_ids: [378, 251],
  },
  {
    genesis_token_id: 7394,
    wearable_ids: [443, 251],
  },
  {
    genesis_token_id: 7395,
    wearable_ids: [286, 297],
  },
  {
    genesis_token_id: 7396,
    wearable_ids: [311, 408],
  },
  {
    genesis_token_id: 7397,
    wearable_ids: [276, 297],
  },
  {
    genesis_token_id: 7398,
    wearable_ids: [389, 299],
  },
  {
    genesis_token_id: 7399,
    wearable_ids: [403, 409],
  },
  {
    genesis_token_id: 7400,
    wearable_ids: [265, 383],
  },
  {
    genesis_token_id: 7401,
    wearable_ids: [351, 289],
  },
  {
    genesis_token_id: 7402,
    wearable_ids: [254, 366],
  },
  {
    genesis_token_id: 7403,
    wearable_ids: [310, 308],
  },
  {
    genesis_token_id: 7404,
    wearable_ids: [383, 372],
  },
  {
    genesis_token_id: 7405,
    wearable_ids: [316, 343],
  },
  {
    genesis_token_id: 7406,
    wearable_ids: [429, 247],
  },
  {
    genesis_token_id: 7407,
    wearable_ids: [413, 315],
  },
  {
    genesis_token_id: 7408,
    wearable_ids: [255, 353],
  },
  {
    genesis_token_id: 7409,
    wearable_ids: [297, 294],
  },
  {
    genesis_token_id: 7410,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 7411,
    wearable_ids: [339, 256],
  },
  {
    genesis_token_id: 7412,
    wearable_ids: [336, 334],
  },
  {
    genesis_token_id: 7413,
    wearable_ids: [424, 372],
  },
  {
    genesis_token_id: 7414,
    wearable_ids: [351, 280],
  },
  {
    genesis_token_id: 7415,
    wearable_ids: [362, 258],
  },
  {
    genesis_token_id: 7416,
    wearable_ids: [369, 389],
  },
  {
    genesis_token_id: 7417,
    wearable_ids: [301, 251],
  },
  {
    genesis_token_id: 7418,
    wearable_ids: [385, 428],
  },
  {
    genesis_token_id: 7419,
    wearable_ids: [410, 400],
  },
  {
    genesis_token_id: 7420,
    wearable_ids: [342, 401],
  },
  {
    genesis_token_id: 7421,
    wearable_ids: [255, 287],
  },
  {
    genesis_token_id: 7422,
    wearable_ids: [258, 386],
  },
  {
    genesis_token_id: 7423,
    wearable_ids: [431, 258],
  },
  {
    genesis_token_id: 7424,
    wearable_ids: [248, 423],
  },
  {
    genesis_token_id: 7425,
    wearable_ids: [387, 290],
  },
  {
    genesis_token_id: 7426,
    wearable_ids: [442, 341],
  },
  {
    genesis_token_id: 7427,
    wearable_ids: [343, 406],
  },
  {
    genesis_token_id: 7428,
    wearable_ids: [280, 357],
  },
  {
    genesis_token_id: 7429,
    wearable_ids: [395, 254],
  },
  {
    genesis_token_id: 7430,
    wearable_ids: [349, 351],
  },
  {
    genesis_token_id: 7431,
    wearable_ids: [247, 355],
  },
  {
    genesis_token_id: 7432,
    wearable_ids: [290, 303],
  },
  {
    genesis_token_id: 7433,
    wearable_ids: [350, 433],
  },
  {
    genesis_token_id: 7434,
    wearable_ids: [372, 341],
  },
  {
    genesis_token_id: 7435,
    wearable_ids: [374, 418],
  },
  {
    genesis_token_id: 7436,
    wearable_ids: [266, 332],
  },
  {
    genesis_token_id: 7437,
    wearable_ids: [444, 351],
  },
  {
    genesis_token_id: 7438,
    wearable_ids: [300, 270],
  },
  {
    genesis_token_id: 7439,
    wearable_ids: [297, 286],
  },
  {
    genesis_token_id: 7440,
    wearable_ids: [251, 305],
  },
  {
    genesis_token_id: 7441,
    wearable_ids: [265, 307],
  },
  {
    genesis_token_id: 7442,
    wearable_ids: [278, 411],
  },
  {
    genesis_token_id: 7443,
    wearable_ids: [319, 372],
  },
  {
    genesis_token_id: 7444,
    wearable_ids: [259, 350],
  },
  {
    genesis_token_id: 7445,
    wearable_ids: [294, 285],
  },
  {
    genesis_token_id: 7446,
    wearable_ids: [384, 437],
  },
  {
    genesis_token_id: 7447,
    wearable_ids: [409, 301],
  },
  {
    genesis_token_id: 7448,
    wearable_ids: [332, 392],
  },
  {
    genesis_token_id: 7449,
    wearable_ids: [386, 350],
  },
  {
    genesis_token_id: 7450,
    wearable_ids: [342, 263],
  },
  {
    genesis_token_id: 7451,
    wearable_ids: [376, 271],
  },
  {
    genesis_token_id: 7452,
    wearable_ids: [248, 310],
  },
  {
    genesis_token_id: 7453,
    wearable_ids: [326, 291],
  },
  {
    genesis_token_id: 7454,
    wearable_ids: [248, 418],
  },
  {
    genesis_token_id: 7455,
    wearable_ids: [324, 388],
  },
  {
    genesis_token_id: 7456,
    wearable_ids: [424, 386],
  },
  {
    genesis_token_id: 7457,
    wearable_ids: [324, 442],
  },
  {
    genesis_token_id: 7458,
    wearable_ids: [255, 304],
  },
  {
    genesis_token_id: 7459,
    wearable_ids: [376, 351],
  },
  {
    genesis_token_id: 7460,
    wearable_ids: [389, 311],
  },
  {
    genesis_token_id: 7461,
    wearable_ids: [287, 435],
  },
  {
    genesis_token_id: 7462,
    wearable_ids: [291, 354],
  },
  {
    genesis_token_id: 7463,
    wearable_ids: [376, 428],
  },
  {
    genesis_token_id: 7464,
    wearable_ids: [409, 308],
  },
  {
    genesis_token_id: 7465,
    wearable_ids: [362, 397],
  },
  {
    genesis_token_id: 7466,
    wearable_ids: [310, 397],
  },
  {
    genesis_token_id: 7467,
    wearable_ids: [425, 263],
  },
  {
    genesis_token_id: 7468,
    wearable_ids: [436, 409],
  },
  {
    genesis_token_id: 7469,
    wearable_ids: [365, 410],
  },
  {
    genesis_token_id: 7470,
    wearable_ids: [409, 292],
  },
  {
    genesis_token_id: 7471,
    wearable_ids: [289, 429],
  },
  {
    genesis_token_id: 7472,
    wearable_ids: [429, 413],
  },
  {
    genesis_token_id: 7473,
    wearable_ids: [410, 325],
  },
  {
    genesis_token_id: 7474,
    wearable_ids: [273, 336],
  },
  {
    genesis_token_id: 7475,
    wearable_ids: [368, 436],
  },
  {
    genesis_token_id: 7476,
    wearable_ids: [284, 263],
  },
  {
    genesis_token_id: 7477,
    wearable_ids: [331, 396],
  },
  {
    genesis_token_id: 7478,
    wearable_ids: [423, 314],
  },
  {
    genesis_token_id: 7479,
    wearable_ids: [395, 319],
  },
  {
    genesis_token_id: 7480,
    wearable_ids: [247, 332],
  },
  {
    genesis_token_id: 7481,
    wearable_ids: [266, 297],
  },
  {
    genesis_token_id: 7482,
    wearable_ids: [263, 332],
  },
  {
    genesis_token_id: 7483,
    wearable_ids: [338, 328],
  },
  {
    genesis_token_id: 7484,
    wearable_ids: [306, 294],
  },
  {
    genesis_token_id: 7485,
    wearable_ids: [408, 317],
  },
  {
    genesis_token_id: 7486,
    wearable_ids: [317, 269],
  },
  {
    genesis_token_id: 7487,
    wearable_ids: [290, 289],
  },
  {
    genesis_token_id: 7488,
    wearable_ids: [271, 444],
  },
  {
    genesis_token_id: 7489,
    wearable_ids: [346, 364],
  },
  {
    genesis_token_id: 7490,
    wearable_ids: [411, 383],
  },
  {
    genesis_token_id: 7491,
    wearable_ids: [424, 340],
  },
  {
    genesis_token_id: 7492,
    wearable_ids: [337, 315],
  },
  {
    genesis_token_id: 7493,
    wearable_ids: [383, 411],
  },
  {
    genesis_token_id: 7494,
    wearable_ids: [300, 274],
  },
  {
    genesis_token_id: 7495,
    wearable_ids: [296, 319],
  },
  {
    genesis_token_id: 7496,
    wearable_ids: [274, 444],
  },
  {
    genesis_token_id: 7497,
    wearable_ids: [413, 392],
  },
  {
    genesis_token_id: 7498,
    wearable_ids: [395, 299],
  },
  {
    genesis_token_id: 7499,
    wearable_ids: [315, 360],
  },
  {
    genesis_token_id: 7500,
    wearable_ids: [348, 391],
  },
  {
    genesis_token_id: 7501,
    wearable_ids: [289, 431],
  },
  {
    genesis_token_id: 7502,
    wearable_ids: [344, 339],
  },
  {
    genesis_token_id: 7503,
    wearable_ids: [331, 295],
  },
  {
    genesis_token_id: 7504,
    wearable_ids: [409, 286],
  },
  {
    genesis_token_id: 7505,
    wearable_ids: [396, 347],
  },
  {
    genesis_token_id: 7506,
    wearable_ids: [301, 356],
  },
  {
    genesis_token_id: 7507,
    wearable_ids: [295, 434],
  },
  {
    genesis_token_id: 7508,
    wearable_ids: [383, 294],
  },
  {
    genesis_token_id: 7509,
    wearable_ids: [396, 422],
  },
  {
    genesis_token_id: 7510,
    wearable_ids: [300, 415],
  },
  {
    genesis_token_id: 7511,
    wearable_ids: [433, 312],
  },
  {
    genesis_token_id: 7512,
    wearable_ids: [423, 437],
  },
  {
    genesis_token_id: 7513,
    wearable_ids: [301, 303],
  },
  {
    genesis_token_id: 7514,
    wearable_ids: [292, 350],
  },
  {
    genesis_token_id: 7515,
    wearable_ids: [409, 341],
  },
  {
    genesis_token_id: 7516,
    wearable_ids: [428, 431],
  },
  {
    genesis_token_id: 7517,
    wearable_ids: [257, 355],
  },
  {
    genesis_token_id: 7518,
    wearable_ids: [296, 284],
  },
  {
    genesis_token_id: 7519,
    wearable_ids: [362, 305],
  },
  {
    genesis_token_id: 7520,
    wearable_ids: [270, 400],
  },
  {
    genesis_token_id: 7521,
    wearable_ids: [295, 425],
  },
  {
    genesis_token_id: 7522,
    wearable_ids: [372, 338],
  },
  {
    genesis_token_id: 7523,
    wearable_ids: [332, 281],
  },
  {
    genesis_token_id: 7524,
    wearable_ids: [277, 412],
  },
  {
    genesis_token_id: 7525,
    wearable_ids: [408, 299],
  },
  {
    genesis_token_id: 7526,
    wearable_ids: [259, 289],
  },
  {
    genesis_token_id: 7527,
    wearable_ids: [277, 284],
  },
  {
    genesis_token_id: 7528,
    wearable_ids: [408, 311],
  },
  {
    genesis_token_id: 7529,
    wearable_ids: [248, 314],
  },
  {
    genesis_token_id: 7530,
    wearable_ids: [443, 333],
  },
  {
    genesis_token_id: 7531,
    wearable_ids: [383, 432],
  },
  {
    genesis_token_id: 7532,
    wearable_ids: [435, 251],
  },
  {
    genesis_token_id: 7533,
    wearable_ids: [434, 370],
  },
  {
    genesis_token_id: 7534,
    wearable_ids: [352, 425],
  },
  {
    genesis_token_id: 7535,
    wearable_ids: [263, 393],
  },
  {
    genesis_token_id: 7536,
    wearable_ids: [443, 301],
  },
  {
    genesis_token_id: 7537,
    wearable_ids: [301, 253],
  },
  {
    genesis_token_id: 7538,
    wearable_ids: [364, 435],
  },
  {
    genesis_token_id: 7539,
    wearable_ids: [422, 332],
  },
  {
    genesis_token_id: 7540,
    wearable_ids: [377, 280],
  },
  {
    genesis_token_id: 7541,
    wearable_ids: [370, 427],
  },
  {
    genesis_token_id: 7542,
    wearable_ids: [422, 393],
  },
  {
    genesis_token_id: 7543,
    wearable_ids: [315, 425],
  },
  {
    genesis_token_id: 7544,
    wearable_ids: [295, 432],
  },
  {
    genesis_token_id: 7545,
    wearable_ids: [256, 306],
  },
  {
    genesis_token_id: 7546,
    wearable_ids: [428, 368],
  },
  {
    genesis_token_id: 7547,
    wearable_ids: [355, 311],
  },
  {
    genesis_token_id: 7548,
    wearable_ids: [340, 374],
  },
  {
    genesis_token_id: 7549,
    wearable_ids: [248, 396],
  },
  {
    genesis_token_id: 7550,
    wearable_ids: [371, 322],
  },
  {
    genesis_token_id: 7551,
    wearable_ids: [325, 283],
  },
  {
    genesis_token_id: 7552,
    wearable_ids: [409, 355],
  },
  {
    genesis_token_id: 7553,
    wearable_ids: [382, 364],
  },
  {
    genesis_token_id: 7554,
    wearable_ids: [271, 281],
  },
  {
    genesis_token_id: 7555,
    wearable_ids: [277, 422],
  },
  {
    genesis_token_id: 7556,
    wearable_ids: [326, 397],
  },
  {
    genesis_token_id: 7557,
    wearable_ids: [433, 404],
  },
  {
    genesis_token_id: 7558,
    wearable_ids: [299, 424],
  },
  {
    genesis_token_id: 7559,
    wearable_ids: [371, 330],
  },
  {
    genesis_token_id: 7560,
    wearable_ids: [410, 347],
  },
  {
    genesis_token_id: 7561,
    wearable_ids: [406, 395],
  },
  {
    genesis_token_id: 7562,
    wearable_ids: [311, 287],
  },
  {
    genesis_token_id: 7563,
    wearable_ids: [291, 258],
  },
  {
    genesis_token_id: 7564,
    wearable_ids: [431, 315],
  },
  {
    genesis_token_id: 7565,
    wearable_ids: [434, 393],
  },
  {
    genesis_token_id: 7566,
    wearable_ids: [297, 410],
  },
  {
    genesis_token_id: 7567,
    wearable_ids: [374, 248],
  },
  {
    genesis_token_id: 7568,
    wearable_ids: [306, 251],
  },
  {
    genesis_token_id: 7569,
    wearable_ids: [406, 268],
  },
  {
    genesis_token_id: 7570,
    wearable_ids: [326, 259],
  },
  {
    genesis_token_id: 7571,
    wearable_ids: [363, 285],
  },
  {
    genesis_token_id: 7572,
    wearable_ids: [387, 311],
  },
  {
    genesis_token_id: 7573,
    wearable_ids: [265, 365],
  },
  {
    genesis_token_id: 7574,
    wearable_ids: [274, 287],
  },
  {
    genesis_token_id: 7575,
    wearable_ids: [444, 299],
  },
  {
    genesis_token_id: 7576,
    wearable_ids: [258, 425],
  },
  {
    genesis_token_id: 7577,
    wearable_ids: [396, 409],
  },
  {
    genesis_token_id: 7578,
    wearable_ids: [274, 385],
  },
  {
    genesis_token_id: 7579,
    wearable_ids: [301, 333],
  },
  {
    genesis_token_id: 7580,
    wearable_ids: [319, 442],
  },
  {
    genesis_token_id: 7581,
    wearable_ids: [299, 278],
  },
  {
    genesis_token_id: 7582,
    wearable_ids: [253, 424],
  },
  {
    genesis_token_id: 7583,
    wearable_ids: [428, 314],
  },
  {
    genesis_token_id: 7584,
    wearable_ids: [254, 262],
  },
  {
    genesis_token_id: 7585,
    wearable_ids: [420, 436],
  },
  {
    genesis_token_id: 7586,
    wearable_ids: [433, 278],
  },
  {
    genesis_token_id: 7587,
    wearable_ids: [431, 382],
  },
  {
    genesis_token_id: 7588,
    wearable_ids: [431, 253],
  },
  {
    genesis_token_id: 7589,
    wearable_ids: [341, 344],
  },
  {
    genesis_token_id: 7590,
    wearable_ids: [335, 337],
  },
  {
    genesis_token_id: 7591,
    wearable_ids: [255, 349],
  },
  {
    genesis_token_id: 7592,
    wearable_ids: [350, 437],
  },
  {
    genesis_token_id: 7593,
    wearable_ids: [324, 444],
  },
  {
    genesis_token_id: 7594,
    wearable_ids: [342, 422],
  },
  {
    genesis_token_id: 7595,
    wearable_ids: [431, 281],
  },
  {
    genesis_token_id: 7596,
    wearable_ids: [326, 265],
  },
  {
    genesis_token_id: 7597,
    wearable_ids: [372, 384],
  },
  {
    genesis_token_id: 7598,
    wearable_ids: [350, 308],
  },
  {
    genesis_token_id: 7599,
    wearable_ids: [437, 259],
  },
  {
    genesis_token_id: 7600,
    wearable_ids: [420, 354],
  },
  {
    genesis_token_id: 7601,
    wearable_ids: [297, 351],
  },
  {
    genesis_token_id: 7602,
    wearable_ids: [349, 289],
  },
  {
    genesis_token_id: 7603,
    wearable_ids: [248, 310],
  },
  {
    genesis_token_id: 7604,
    wearable_ids: [297, 412],
  },
  {
    genesis_token_id: 7605,
    wearable_ids: [306, 276],
  },
  {
    genesis_token_id: 7606,
    wearable_ids: [432, 317],
  },
  {
    genesis_token_id: 7607,
    wearable_ids: [286, 363],
  },
  {
    genesis_token_id: 7608,
    wearable_ids: [350, 343],
  },
  {
    genesis_token_id: 7609,
    wearable_ids: [412, 248],
  },
  {
    genesis_token_id: 7610,
    wearable_ids: [351, 326],
  },
  {
    genesis_token_id: 7611,
    wearable_ids: [306, 436],
  },
  {
    genesis_token_id: 7612,
    wearable_ids: [408, 368],
  },
  {
    genesis_token_id: 7613,
    wearable_ids: [411, 303],
  },
  {
    genesis_token_id: 7614,
    wearable_ids: [346, 419],
  },
  {
    genesis_token_id: 7615,
    wearable_ids: [423, 290],
  },
  {
    genesis_token_id: 7616,
    wearable_ids: [341, 406],
  },
  {
    genesis_token_id: 7617,
    wearable_ids: [264, 432],
  },
  {
    genesis_token_id: 7618,
    wearable_ids: [251, 297],
  },
  {
    genesis_token_id: 7619,
    wearable_ids: [346, 396],
  },
  {
    genesis_token_id: 7620,
    wearable_ids: [256, 312],
  },
  {
    genesis_token_id: 7621,
    wearable_ids: [368, 255],
  },
  {
    genesis_token_id: 7622,
    wearable_ids: [386, 348],
  },
  {
    genesis_token_id: 7623,
    wearable_ids: [270, 442],
  },
  {
    genesis_token_id: 7624,
    wearable_ids: [258, 386],
  },
  {
    genesis_token_id: 7625,
    wearable_ids: [292, 253],
  },
  {
    genesis_token_id: 7626,
    wearable_ids: [278, 303],
  },
  {
    genesis_token_id: 7627,
    wearable_ids: [385, 347],
  },
  {
    genesis_token_id: 7628,
    wearable_ids: [368, 363],
  },
  {
    genesis_token_id: 7629,
    wearable_ids: [369, 440],
  },
  {
    genesis_token_id: 7630,
    wearable_ids: [336, 354],
  },
  {
    genesis_token_id: 7631,
    wearable_ids: [300, 406],
  },
  {
    genesis_token_id: 7632,
    wearable_ids: [412, 337],
  },
  {
    genesis_token_id: 7633,
    wearable_ids: [342, 404],
  },
  {
    genesis_token_id: 7634,
    wearable_ids: [277, 408],
  },
  {
    genesis_token_id: 7635,
    wearable_ids: [395, 327],
  },
  {
    genesis_token_id: 7636,
    wearable_ids: [344, 311],
  },
  {
    genesis_token_id: 7637,
    wearable_ids: [436, 409],
  },
  {
    genesis_token_id: 7638,
    wearable_ids: [332, 388],
  },
  {
    genesis_token_id: 7639,
    wearable_ids: [303, 248],
  },
  {
    genesis_token_id: 7640,
    wearable_ids: [346, 431],
  },
  {
    genesis_token_id: 7641,
    wearable_ids: [368, 337],
  },
  {
    genesis_token_id: 7642,
    wearable_ids: [368, 444],
  },
  {
    genesis_token_id: 7643,
    wearable_ids: [319, 262],
  },
  {
    genesis_token_id: 7644,
    wearable_ids: [355, 258],
  },
  {
    genesis_token_id: 7645,
    wearable_ids: [324, 440],
  },
  {
    genesis_token_id: 7646,
    wearable_ids: [412, 422],
  },
  {
    genesis_token_id: 7647,
    wearable_ids: [385, 287],
  },
  {
    genesis_token_id: 7648,
    wearable_ids: [422, 406],
  },
  {
    genesis_token_id: 7649,
    wearable_ids: [363, 354],
  },
  {
    genesis_token_id: 7650,
    wearable_ids: [425, 293],
  },
  {
    genesis_token_id: 7651,
    wearable_ids: [370, 435],
  },
  {
    genesis_token_id: 7652,
    wearable_ids: [324, 306],
  },
  {
    genesis_token_id: 7653,
    wearable_ids: [378, 272],
  },
  {
    genesis_token_id: 7654,
    wearable_ids: [295, 363],
  },
  {
    genesis_token_id: 7655,
    wearable_ids: [432, 314],
  },
  {
    genesis_token_id: 7656,
    wearable_ids: [364, 420],
  },
  {
    genesis_token_id: 7657,
    wearable_ids: [325, 399],
  },
  {
    genesis_token_id: 7658,
    wearable_ids: [342, 273],
  },
  {
    genesis_token_id: 7659,
    wearable_ids: [251, 400],
  },
  {
    genesis_token_id: 7660,
    wearable_ids: [331, 265],
  },
  {
    genesis_token_id: 7661,
    wearable_ids: [389, 337],
  },
  {
    genesis_token_id: 7662,
    wearable_ids: [338, 342],
  },
  {
    genesis_token_id: 7663,
    wearable_ids: [411, 251],
  },
  {
    genesis_token_id: 7664,
    wearable_ids: [351, 437],
  },
  {
    genesis_token_id: 7665,
    wearable_ids: [443, 370],
  },
  {
    genesis_token_id: 7666,
    wearable_ids: [308, 442],
  },
  {
    genesis_token_id: 7667,
    wearable_ids: [349, 322],
  },
  {
    genesis_token_id: 7668,
    wearable_ids: [370, 267],
  },
  {
    genesis_token_id: 7669,
    wearable_ids: [256, 363],
  },
  {
    genesis_token_id: 7670,
    wearable_ids: [412, 287],
  },
  {
    genesis_token_id: 7671,
    wearable_ids: [396, 335],
  },
  {
    genesis_token_id: 7672,
    wearable_ids: [410, 387],
  },
  {
    genesis_token_id: 7673,
    wearable_ids: [444, 254],
  },
  {
    genesis_token_id: 7674,
    wearable_ids: [251, 427],
  },
  {
    genesis_token_id: 7675,
    wearable_ids: [373, 278],
  },
  {
    genesis_token_id: 7676,
    wearable_ids: [382, 349],
  },
  {
    genesis_token_id: 7677,
    wearable_ids: [365, 270],
  },
  {
    genesis_token_id: 7678,
    wearable_ids: [319, 403],
  },
  {
    genesis_token_id: 7679,
    wearable_ids: [355, 373],
  },
  {
    genesis_token_id: 7680,
    wearable_ids: [331, 413],
  },
  {
    genesis_token_id: 7681,
    wearable_ids: [378, 440],
  },
  {
    genesis_token_id: 7682,
    wearable_ids: [332, 375],
  },
  {
    genesis_token_id: 7683,
    wearable_ids: [351, 311],
  },
  {
    genesis_token_id: 7684,
    wearable_ids: [335, 248],
  },
  {
    genesis_token_id: 7685,
    wearable_ids: [363, 391],
  },
  {
    genesis_token_id: 7686,
    wearable_ids: [297, 325],
  },
  {
    genesis_token_id: 7687,
    wearable_ids: [291, 420],
  },
  {
    genesis_token_id: 7688,
    wearable_ids: [382, 256],
  },
  {
    genesis_token_id: 7689,
    wearable_ids: [399, 422],
  },
  {
    genesis_token_id: 7690,
    wearable_ids: [365, 276],
  },
  {
    genesis_token_id: 7691,
    wearable_ids: [406, 374],
  },
  {
    genesis_token_id: 7692,
    wearable_ids: [426, 363],
  },
  {
    genesis_token_id: 7693,
    wearable_ids: [347, 257],
  },
  {
    genesis_token_id: 7694,
    wearable_ids: [270, 369],
  },
  {
    genesis_token_id: 7695,
    wearable_ids: [248, 374],
  },
  {
    genesis_token_id: 7696,
    wearable_ids: [255, 424],
  },
  {
    genesis_token_id: 7697,
    wearable_ids: [274, 365],
  },
  {
    genesis_token_id: 7698,
    wearable_ids: [424, 432],
  },
  {
    genesis_token_id: 7699,
    wearable_ids: [317, 287],
  },
  {
    genesis_token_id: 7700,
    wearable_ids: [382, 256],
  },
  {
    genesis_token_id: 7701,
    wearable_ids: [445, 425],
  },
  {
    genesis_token_id: 7702,
    wearable_ids: [314, 398],
  },
  {
    genesis_token_id: 7703,
    wearable_ids: [258, 338],
  },
  {
    genesis_token_id: 7704,
    wearable_ids: [370, 364],
  },
  {
    genesis_token_id: 7705,
    wearable_ids: [332, 314],
  },
  {
    genesis_token_id: 7706,
    wearable_ids: [251, 406],
  },
  {
    genesis_token_id: 7707,
    wearable_ids: [396, 354],
  },
  {
    genesis_token_id: 7708,
    wearable_ids: [291, 287],
  },
  {
    genesis_token_id: 7709,
    wearable_ids: [377, 441],
  },
  {
    genesis_token_id: 7710,
    wearable_ids: [296, 274],
  },
  {
    genesis_token_id: 7711,
    wearable_ids: [251, 352],
  },
  {
    genesis_token_id: 7712,
    wearable_ids: [277, 442],
  },
  {
    genesis_token_id: 7713,
    wearable_ids: [406, 435],
  },
  {
    genesis_token_id: 7714,
    wearable_ids: [287, 257],
  },
  {
    genesis_token_id: 7715,
    wearable_ids: [277, 267],
  },
  {
    genesis_token_id: 7716,
    wearable_ids: [289, 396],
  },
  {
    genesis_token_id: 7717,
    wearable_ids: [256, 376],
  },
  {
    genesis_token_id: 7718,
    wearable_ids: [376, 346],
  },
  {
    genesis_token_id: 7719,
    wearable_ids: [340, 365],
  },
  {
    genesis_token_id: 7720,
    wearable_ids: [247, 376],
  },
  {
    genesis_token_id: 7721,
    wearable_ids: [271, 286],
  },
  {
    genesis_token_id: 7722,
    wearable_ids: [375, 335],
  },
  {
    genesis_token_id: 7723,
    wearable_ids: [374, 257],
  },
  {
    genesis_token_id: 7724,
    wearable_ids: [399, 383],
  },
  {
    genesis_token_id: 7725,
    wearable_ids: [435, 327],
  },
  {
    genesis_token_id: 7726,
    wearable_ids: [423, 287],
  },
  {
    genesis_token_id: 7727,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 7728,
    wearable_ids: [286, 303],
  },
  {
    genesis_token_id: 7729,
    wearable_ids: [274, 336],
  },
  {
    genesis_token_id: 7730,
    wearable_ids: [395, 265],
  },
  {
    genesis_token_id: 7731,
    wearable_ids: [280, 262],
  },
  {
    genesis_token_id: 7732,
    wearable_ids: [255, 337],
  },
  {
    genesis_token_id: 7733,
    wearable_ids: [406, 377],
  },
  {
    genesis_token_id: 7734,
    wearable_ids: [406, 369],
  },
  {
    genesis_token_id: 7735,
    wearable_ids: [266, 273],
  },
  {
    genesis_token_id: 7736,
    wearable_ids: [274, 328],
  },
  {
    genesis_token_id: 7737,
    wearable_ids: [311, 429],
  },
  {
    genesis_token_id: 7738,
    wearable_ids: [408, 364],
  },
  {
    genesis_token_id: 7739,
    wearable_ids: [389, 262],
  },
  {
    genesis_token_id: 7740,
    wearable_ids: [374, 445],
  },
  {
    genesis_token_id: 7741,
    wearable_ids: [423, 319],
  },
  {
    genesis_token_id: 7742,
    wearable_ids: [347, 410],
  },
  {
    genesis_token_id: 7743,
    wearable_ids: [263, 301],
  },
  {
    genesis_token_id: 7744,
    wearable_ids: [286, 371],
  },
  {
    genesis_token_id: 7745,
    wearable_ids: [265, 374],
  },
  {
    genesis_token_id: 7746,
    wearable_ids: [389, 403],
  },
  {
    genesis_token_id: 7747,
    wearable_ids: [415, 311],
  },
  {
    genesis_token_id: 7748,
    wearable_ids: [437, 284],
  },
  {
    genesis_token_id: 7749,
    wearable_ids: [409, 383],
  },
  {
    genesis_token_id: 7750,
    wearable_ids: [407, 365],
  },
  {
    genesis_token_id: 7751,
    wearable_ids: [428, 305],
  },
  {
    genesis_token_id: 7752,
    wearable_ids: [292, 341],
  },
  {
    genesis_token_id: 7753,
    wearable_ids: [373, 316],
  },
  {
    genesis_token_id: 7754,
    wearable_ids: [435, 258],
  },
  {
    genesis_token_id: 7755,
    wearable_ids: [340, 415],
  },
  {
    genesis_token_id: 7756,
    wearable_ids: [265, 356],
  },
  {
    genesis_token_id: 7757,
    wearable_ids: [411, 374],
  },
  {
    genesis_token_id: 7758,
    wearable_ids: [407, 270],
  },
  {
    genesis_token_id: 7759,
    wearable_ids: [314, 255],
  },
  {
    genesis_token_id: 7760,
    wearable_ids: [247, 355],
  },
  {
    genesis_token_id: 7761,
    wearable_ids: [396, 406],
  },
  {
    genesis_token_id: 7762,
    wearable_ids: [386, 412],
  },
  {
    genesis_token_id: 7763,
    wearable_ids: [445, 303],
  },
  {
    genesis_token_id: 7764,
    wearable_ids: [352, 349],
  },
  {
    genesis_token_id: 7765,
    wearable_ids: [263, 335],
  },
  {
    genesis_token_id: 7766,
    wearable_ids: [310, 428],
  },
  {
    genesis_token_id: 7767,
    wearable_ids: [347, 302],
  },
  {
    genesis_token_id: 7768,
    wearable_ids: [435, 405],
  },
  {
    genesis_token_id: 7769,
    wearable_ids: [386, 303],
  },
  {
    genesis_token_id: 7770,
    wearable_ids: [378, 415],
  },
  {
    genesis_token_id: 7771,
    wearable_ids: [348, 302],
  },
  {
    genesis_token_id: 7772,
    wearable_ids: [274, 326],
  },
  {
    genesis_token_id: 7773,
    wearable_ids: [423, 387],
  },
  {
    genesis_token_id: 7774,
    wearable_ids: [277, 337],
  },
  {
    genesis_token_id: 7775,
    wearable_ids: [408, 443],
  },
  {
    genesis_token_id: 7776,
    wearable_ids: [286, 331],
  },
  {
    genesis_token_id: 7777,
    wearable_ids: [408, 428],
  },
  {
    genesis_token_id: 7778,
    wearable_ids: [271, 418],
  },
  {
    genesis_token_id: 7779,
    wearable_ids: [400, 395],
  },
  {
    genesis_token_id: 7780,
    wearable_ids: [371, 332],
  },
  {
    genesis_token_id: 7781,
    wearable_ids: [303, 442],
  },
  {
    genesis_token_id: 7782,
    wearable_ids: [255, 359],
  },
  {
    genesis_token_id: 7783,
    wearable_ids: [273, 332],
  },
  {
    genesis_token_id: 7784,
    wearable_ids: [375, 432],
  },
  {
    genesis_token_id: 7785,
    wearable_ids: [404, 406],
  },
  {
    genesis_token_id: 7786,
    wearable_ids: [258, 416],
  },
  {
    genesis_token_id: 7787,
    wearable_ids: [308, 278],
  },
  {
    genesis_token_id: 7788,
    wearable_ids: [295, 424],
  },
  {
    genesis_token_id: 7789,
    wearable_ids: [351, 337],
  },
  {
    genesis_token_id: 7790,
    wearable_ids: [363, 437],
  },
  {
    genesis_token_id: 7791,
    wearable_ids: [277, 351],
  },
  {
    genesis_token_id: 7792,
    wearable_ids: [291, 359],
  },
  {
    genesis_token_id: 7793,
    wearable_ids: [429, 395],
  },
  {
    genesis_token_id: 7794,
    wearable_ids: [368, 315],
  },
  {
    genesis_token_id: 7795,
    wearable_ids: [310, 332],
  },
  {
    genesis_token_id: 7796,
    wearable_ids: [268, 311],
  },
  {
    genesis_token_id: 7797,
    wearable_ids: [370, 251],
  },
  {
    genesis_token_id: 7798,
    wearable_ids: [346, 260],
  },
  {
    genesis_token_id: 7799,
    wearable_ids: [428, 372],
  },
  {
    genesis_token_id: 7800,
    wearable_ids: [337, 343],
  },
  {
    genesis_token_id: 7801,
    wearable_ids: [271, 360],
  },
  {
    genesis_token_id: 7802,
    wearable_ids: [251, 424],
  },
  {
    genesis_token_id: 7803,
    wearable_ids: [303, 363],
  },
  {
    genesis_token_id: 7804,
    wearable_ids: [337, 292],
  },
  {
    genesis_token_id: 7805,
    wearable_ids: [426, 378],
  },
  {
    genesis_token_id: 7806,
    wearable_ids: [352, 338],
  },
  {
    genesis_token_id: 7807,
    wearable_ids: [444, 306],
  },
  {
    genesis_token_id: 7808,
    wearable_ids: [346, 387],
  },
  {
    genesis_token_id: 7809,
    wearable_ids: [443, 281],
  },
  {
    genesis_token_id: 7810,
    wearable_ids: [343, 368],
  },
  {
    genesis_token_id: 7811,
    wearable_ids: [395, 304],
  },
  {
    genesis_token_id: 7812,
    wearable_ids: [400, 377],
  },
  {
    genesis_token_id: 7813,
    wearable_ids: [445, 444],
  },
  {
    genesis_token_id: 7814,
    wearable_ids: [295, 346],
  },
  {
    genesis_token_id: 7815,
    wearable_ids: [436, 308],
  },
  {
    genesis_token_id: 7816,
    wearable_ids: [429, 386],
  },
  {
    genesis_token_id: 7817,
    wearable_ids: [300, 295],
  },
  {
    genesis_token_id: 7818,
    wearable_ids: [434, 256],
  },
  {
    genesis_token_id: 7819,
    wearable_ids: [311, 375],
  },
  {
    genesis_token_id: 7820,
    wearable_ids: [324, 257],
  },
  {
    genesis_token_id: 7821,
    wearable_ids: [317, 292],
  },
  {
    genesis_token_id: 7822,
    wearable_ids: [301, 346],
  },
  {
    genesis_token_id: 7823,
    wearable_ids: [422, 255],
  },
  {
    genesis_token_id: 7824,
    wearable_ids: [266, 345],
  },
  {
    genesis_token_id: 7825,
    wearable_ids: [259, 326],
  },
  {
    genesis_token_id: 7826,
    wearable_ids: [303, 276],
  },
  {
    genesis_token_id: 7827,
    wearable_ids: [256, 415],
  },
  {
    genesis_token_id: 7828,
    wearable_ids: [368, 325],
  },
  {
    genesis_token_id: 7829,
    wearable_ids: [311, 354],
  },
  {
    genesis_token_id: 7830,
    wearable_ids: [409, 413],
  },
  {
    genesis_token_id: 7831,
    wearable_ids: [294, 399],
  },
  {
    genesis_token_id: 7832,
    wearable_ids: [295, 394],
  },
  {
    genesis_token_id: 7833,
    wearable_ids: [384, 423],
  },
  {
    genesis_token_id: 7834,
    wearable_ids: [399, 280],
  },
  {
    genesis_token_id: 7835,
    wearable_ids: [377, 357],
  },
  {
    genesis_token_id: 7836,
    wearable_ids: [354, 411],
  },
  {
    genesis_token_id: 7837,
    wearable_ids: [314, 256],
  },
  {
    genesis_token_id: 7838,
    wearable_ids: [271, 429],
  },
  {
    genesis_token_id: 7839,
    wearable_ids: [259, 374],
  },
  {
    genesis_token_id: 7840,
    wearable_ids: [364, 435],
  },
  {
    genesis_token_id: 7841,
    wearable_ids: [413, 270],
  },
  {
    genesis_token_id: 7842,
    wearable_ids: [420, 424],
  },
  {
    genesis_token_id: 7843,
    wearable_ids: [351, 297],
  },
  {
    genesis_token_id: 7844,
    wearable_ids: [337, 278],
  },
  {
    genesis_token_id: 7845,
    wearable_ids: [437, 256],
  },
  {
    genesis_token_id: 7846,
    wearable_ids: [411, 341],
  },
  {
    genesis_token_id: 7847,
    wearable_ids: [332, 286],
  },
  {
    genesis_token_id: 7848,
    wearable_ids: [442, 394],
  },
  {
    genesis_token_id: 7849,
    wearable_ids: [338, 332],
  },
  {
    genesis_token_id: 7850,
    wearable_ids: [340, 433],
  },
  {
    genesis_token_id: 7851,
    wearable_ids: [368, 348],
  },
  {
    genesis_token_id: 7852,
    wearable_ids: [422, 318],
  },
  {
    genesis_token_id: 7853,
    wearable_ids: [400, 247],
  },
  {
    genesis_token_id: 7854,
    wearable_ids: [429, 350],
  },
  {
    genesis_token_id: 7855,
    wearable_ids: [271, 365],
  },
  {
    genesis_token_id: 7856,
    wearable_ids: [433, 419],
  },
  {
    genesis_token_id: 7857,
    wearable_ids: [436, 317],
  },
  {
    genesis_token_id: 7858,
    wearable_ids: [287, 297],
  },
  {
    genesis_token_id: 7859,
    wearable_ids: [344, 269],
  },
  {
    genesis_token_id: 7860,
    wearable_ids: [445, 247],
  },
  {
    genesis_token_id: 7861,
    wearable_ids: [375, 324],
  },
  {
    genesis_token_id: 7862,
    wearable_ids: [364, 301],
  },
  {
    genesis_token_id: 7863,
    wearable_ids: [266, 273],
  },
  {
    genesis_token_id: 7864,
    wearable_ids: [316, 443],
  },
  {
    genesis_token_id: 7865,
    wearable_ids: [256, 415],
  },
  {
    genesis_token_id: 7866,
    wearable_ids: [291, 256],
  },
  {
    genesis_token_id: 7867,
    wearable_ids: [277, 255],
  },
  {
    genesis_token_id: 7868,
    wearable_ids: [425, 300],
  },
  {
    genesis_token_id: 7869,
    wearable_ids: [287, 269],
  },
  {
    genesis_token_id: 7870,
    wearable_ids: [247, 365],
  },
  {
    genesis_token_id: 7871,
    wearable_ids: [343, 424],
  },
  {
    genesis_token_id: 7872,
    wearable_ids: [368, 274],
  },
  {
    genesis_token_id: 7873,
    wearable_ids: [373, 299],
  },
  {
    genesis_token_id: 7874,
    wearable_ids: [371, 361],
  },
  {
    genesis_token_id: 7875,
    wearable_ids: [266, 269],
  },
  {
    genesis_token_id: 7876,
    wearable_ids: [304, 420],
  },
  {
    genesis_token_id: 7877,
    wearable_ids: [370, 384],
  },
  {
    genesis_token_id: 7878,
    wearable_ids: [442, 306],
  },
  {
    genesis_token_id: 7879,
    wearable_ids: [317, 418],
  },
  {
    genesis_token_id: 7880,
    wearable_ids: [355, 302],
  },
  {
    genesis_token_id: 7881,
    wearable_ids: [254, 257],
  },
  {
    genesis_token_id: 7882,
    wearable_ids: [294, 359],
  },
  {
    genesis_token_id: 7883,
    wearable_ids: [355, 316],
  },
  {
    genesis_token_id: 7884,
    wearable_ids: [265, 400],
  },
  {
    genesis_token_id: 7885,
    wearable_ids: [336, 385],
  },
  {
    genesis_token_id: 7886,
    wearable_ids: [256, 368],
  },
  {
    genesis_token_id: 7887,
    wearable_ids: [378, 395],
  },
  {
    genesis_token_id: 7888,
    wearable_ids: [331, 411],
  },
  {
    genesis_token_id: 7889,
    wearable_ids: [397, 350],
  },
  {
    genesis_token_id: 7890,
    wearable_ids: [355, 314],
  },
  {
    genesis_token_id: 7891,
    wearable_ids: [264, 292],
  },
  {
    genesis_token_id: 7892,
    wearable_ids: [297, 364],
  },
  {
    genesis_token_id: 7893,
    wearable_ids: [372, 298],
  },
  {
    genesis_token_id: 7894,
    wearable_ids: [253, 276],
  },
  {
    genesis_token_id: 7895,
    wearable_ids: [257, 253],
  },
  {
    genesis_token_id: 7896,
    wearable_ids: [273, 280],
  },
  {
    genesis_token_id: 7897,
    wearable_ids: [344, 413],
  },
  {
    genesis_token_id: 7898,
    wearable_ids: [304, 317],
  },
  {
    genesis_token_id: 7899,
    wearable_ids: [344, 443],
  },
  {
    genesis_token_id: 7900,
    wearable_ids: [422, 437],
  },
  {
    genesis_token_id: 7901,
    wearable_ids: [308, 377],
  },
  {
    genesis_token_id: 7902,
    wearable_ids: [396, 296],
  },
  {
    genesis_token_id: 7903,
    wearable_ids: [289, 373],
  },
  {
    genesis_token_id: 7904,
    wearable_ids: [384, 296],
  },
  {
    genesis_token_id: 7905,
    wearable_ids: [253, 420],
  },
  {
    genesis_token_id: 7906,
    wearable_ids: [407, 273],
  },
  {
    genesis_token_id: 7907,
    wearable_ids: [378, 286],
  },
  {
    genesis_token_id: 7908,
    wearable_ids: [389, 287],
  },
  {
    genesis_token_id: 7909,
    wearable_ids: [266, 411],
  },
  {
    genesis_token_id: 7910,
    wearable_ids: [263, 436],
  },
  {
    genesis_token_id: 7911,
    wearable_ids: [248, 434],
  },
  {
    genesis_token_id: 7912,
    wearable_ids: [432, 404],
  },
  {
    genesis_token_id: 7913,
    wearable_ids: [247, 344],
  },
  {
    genesis_token_id: 7914,
    wearable_ids: [335, 315],
  },
  {
    genesis_token_id: 7915,
    wearable_ids: [311, 383],
  },
  {
    genesis_token_id: 7916,
    wearable_ids: [344, 341],
  },
  {
    genesis_token_id: 7917,
    wearable_ids: [339, 433],
  },
  {
    genesis_token_id: 7918,
    wearable_ids: [248, 354],
  },
  {
    genesis_token_id: 7919,
    wearable_ids: [435, 391],
  },
  {
    genesis_token_id: 7920,
    wearable_ids: [373, 335],
  },
  {
    genesis_token_id: 7921,
    wearable_ids: [396, 362],
  },
  {
    genesis_token_id: 7922,
    wearable_ids: [346, 326],
  },
  {
    genesis_token_id: 7923,
    wearable_ids: [352, 385],
  },
  {
    genesis_token_id: 7924,
    wearable_ids: [411, 349],
  },
  {
    genesis_token_id: 7925,
    wearable_ids: [369, 445],
  },
  {
    genesis_token_id: 7926,
    wearable_ids: [347, 377],
  },
  {
    genesis_token_id: 7927,
    wearable_ids: [300, 374],
  },
  {
    genesis_token_id: 7928,
    wearable_ids: [362, 257],
  },
  {
    genesis_token_id: 7929,
    wearable_ids: [346, 436],
  },
  {
    genesis_token_id: 7930,
    wearable_ids: [385, 369],
  },
  {
    genesis_token_id: 7931,
    wearable_ids: [301, 271],
  },
  {
    genesis_token_id: 7932,
    wearable_ids: [265, 371],
  },
  {
    genesis_token_id: 7933,
    wearable_ids: [264, 266],
  },
  {
    genesis_token_id: 7934,
    wearable_ids: [339, 445],
  },
  {
    genesis_token_id: 7935,
    wearable_ids: [429, 410],
  },
  {
    genesis_token_id: 7936,
    wearable_ids: [445, 337],
  },
  {
    genesis_token_id: 7937,
    wearable_ids: [286, 435],
  },
  {
    genesis_token_id: 7938,
    wearable_ids: [424, 441],
  },
  {
    genesis_token_id: 7939,
    wearable_ids: [340, 288],
  },
  {
    genesis_token_id: 7940,
    wearable_ids: [257, 276],
  },
  {
    genesis_token_id: 7941,
    wearable_ids: [303, 300],
  },
  {
    genesis_token_id: 7942,
    wearable_ids: [340, 328],
  },
  {
    genesis_token_id: 7943,
    wearable_ids: [308, 287],
  },
  {
    genesis_token_id: 7944,
    wearable_ids: [429, 401],
  },
  {
    genesis_token_id: 7945,
    wearable_ids: [389, 260],
  },
  {
    genesis_token_id: 7946,
    wearable_ids: [442, 314],
  },
  {
    genesis_token_id: 7947,
    wearable_ids: [277, 289],
  },
  {
    genesis_token_id: 7948,
    wearable_ids: [346, 278],
  },
  {
    genesis_token_id: 7949,
    wearable_ids: [308, 391],
  },
  {
    genesis_token_id: 7950,
    wearable_ids: [376, 382],
  },
  {
    genesis_token_id: 7951,
    wearable_ids: [253, 291],
  },
  {
    genesis_token_id: 7952,
    wearable_ids: [407, 304],
  },
  {
    genesis_token_id: 7953,
    wearable_ids: [429, 317],
  },
  {
    genesis_token_id: 7954,
    wearable_ids: [268, 412],
  },
  {
    genesis_token_id: 7955,
    wearable_ids: [251, 396],
  },
  {
    genesis_token_id: 7956,
    wearable_ids: [413, 371],
  },
  {
    genesis_token_id: 7957,
    wearable_ids: [399, 317],
  },
  {
    genesis_token_id: 7958,
    wearable_ids: [287, 358],
  },
  {
    genesis_token_id: 7959,
    wearable_ids: [362, 364],
  },
  {
    genesis_token_id: 7960,
    wearable_ids: [332, 354],
  },
  {
    genesis_token_id: 7961,
    wearable_ids: [383, 443],
  },
  {
    genesis_token_id: 7962,
    wearable_ids: [350, 436],
  },
  {
    genesis_token_id: 7963,
    wearable_ids: [331, 340],
  },
  {
    genesis_token_id: 7964,
    wearable_ids: [262, 305],
  },
  {
    genesis_token_id: 7965,
    wearable_ids: [297, 428],
  },
  {
    genesis_token_id: 7966,
    wearable_ids: [289, 428],
  },
  {
    genesis_token_id: 7967,
    wearable_ids: [409, 433],
  },
  {
    genesis_token_id: 7968,
    wearable_ids: [383, 266],
  },
  {
    genesis_token_id: 7969,
    wearable_ids: [375, 350],
  },
  {
    genesis_token_id: 7970,
    wearable_ids: [278, 385],
  },
  {
    genesis_token_id: 7971,
    wearable_ids: [310, 433],
  },
  {
    genesis_token_id: 7972,
    wearable_ids: [434, 343],
  },
  {
    genesis_token_id: 7973,
    wearable_ids: [428, 436],
  },
  {
    genesis_token_id: 7974,
    wearable_ids: [317, 358],
  },
  {
    genesis_token_id: 7975,
    wearable_ids: [295, 300],
  },
  {
    genesis_token_id: 7976,
    wearable_ids: [373, 289],
  },
  {
    genesis_token_id: 7977,
    wearable_ids: [273, 377],
  },
  {
    genesis_token_id: 7978,
    wearable_ids: [411, 330],
  },
  {
    genesis_token_id: 7979,
    wearable_ids: [396, 427],
  },
  {
    genesis_token_id: 7980,
    wearable_ids: [274, 296],
  },
  {
    genesis_token_id: 7981,
    wearable_ids: [424, 291],
  },
  {
    genesis_token_id: 7982,
    wearable_ids: [347, 260],
  },
  {
    genesis_token_id: 7983,
    wearable_ids: [326, 316],
  },
  {
    genesis_token_id: 7984,
    wearable_ids: [368, 339],
  },
  {
    genesis_token_id: 7985,
    wearable_ids: [437, 320],
  },
  {
    genesis_token_id: 7986,
    wearable_ids: [304, 395],
  },
  {
    genesis_token_id: 7987,
    wearable_ids: [300, 403],
  },
  {
    genesis_token_id: 7988,
    wearable_ids: [424, 277],
  },
  {
    genesis_token_id: 7989,
    wearable_ids: [259, 286],
  },
  {
    genesis_token_id: 7990,
    wearable_ids: [274, 259],
  },
  {
    genesis_token_id: 7991,
    wearable_ids: [325, 424],
  },
  {
    genesis_token_id: 7992,
    wearable_ids: [377, 295],
  },
  {
    genesis_token_id: 7993,
    wearable_ids: [277, 257],
  },
  {
    genesis_token_id: 7994,
    wearable_ids: [287, 338],
  },
  {
    genesis_token_id: 7995,
    wearable_ids: [316, 440],
  },
  {
    genesis_token_id: 7996,
    wearable_ids: [350, 432],
  },
  {
    genesis_token_id: 7997,
    wearable_ids: [364, 342],
  },
  {
    genesis_token_id: 7998,
    wearable_ids: [308, 249],
  },
  {
    genesis_token_id: 7999,
    wearable_ids: [253, 340],
  },
  {
    genesis_token_id: 8000,
    wearable_ids: [317, 275],
  },
  {
    genesis_token_id: 8001,
    wearable_ids: [263, 409],
  },
  {
    genesis_token_id: 8002,
    wearable_ids: [319, 401],
  },
  {
    genesis_token_id: 8003,
    wearable_ids: [258, 406],
  },
  {
    genesis_token_id: 8004,
    wearable_ids: [257, 306],
  },
  {
    genesis_token_id: 8005,
    wearable_ids: [343, 297],
  },
  {
    genesis_token_id: 8006,
    wearable_ids: [352, 257],
  },
  {
    genesis_token_id: 8007,
    wearable_ids: [400, 356],
  },
  {
    genesis_token_id: 8008,
    wearable_ids: [289, 386],
  },
  {
    genesis_token_id: 8009,
    wearable_ids: [331, 263],
  },
  {
    genesis_token_id: 8010,
    wearable_ids: [315, 386],
  },
  {
    genesis_token_id: 8011,
    wearable_ids: [264, 425],
  },
  {
    genesis_token_id: 8012,
    wearable_ids: [351, 358],
  },
  {
    genesis_token_id: 8013,
    wearable_ids: [272, 347],
  },
  {
    genesis_token_id: 8014,
    wearable_ids: [342, 366],
  },
  {
    genesis_token_id: 8015,
    wearable_ids: [297, 352],
  },
  {
    genesis_token_id: 8016,
    wearable_ids: [442, 247],
  },
  {
    genesis_token_id: 8017,
    wearable_ids: [365, 389],
  },
  {
    genesis_token_id: 8018,
    wearable_ids: [266, 411],
  },
  {
    genesis_token_id: 8019,
    wearable_ids: [374, 406],
  },
  {
    genesis_token_id: 8020,
    wearable_ids: [368, 383],
  },
  {
    genesis_token_id: 8021,
    wearable_ids: [425, 274],
  },
  {
    genesis_token_id: 8022,
    wearable_ids: [254, 265],
  },
  {
    genesis_token_id: 8023,
    wearable_ids: [363, 413],
  },
  {
    genesis_token_id: 8024,
    wearable_ids: [371, 399],
  },
  {
    genesis_token_id: 8025,
    wearable_ids: [286, 411],
  },
  {
    genesis_token_id: 8026,
    wearable_ids: [434, 357],
  },
  {
    genesis_token_id: 8027,
    wearable_ids: [271, 347],
  },
  {
    genesis_token_id: 8028,
    wearable_ids: [373, 295],
  },
  {
    genesis_token_id: 8029,
    wearable_ids: [428, 401],
  },
  {
    genesis_token_id: 8030,
    wearable_ids: [340, 373],
  },
  {
    genesis_token_id: 8031,
    wearable_ids: [297, 389],
  },
  {
    genesis_token_id: 8032,
    wearable_ids: [365, 355],
  },
  {
    genesis_token_id: 8033,
    wearable_ids: [350, 292],
  },
  {
    genesis_token_id: 8034,
    wearable_ids: [352, 286],
  },
  {
    genesis_token_id: 8035,
    wearable_ids: [331, 311],
  },
  {
    genesis_token_id: 8036,
    wearable_ids: [315, 406],
  },
  {
    genesis_token_id: 8037,
    wearable_ids: [325, 253],
  },
  {
    genesis_token_id: 8038,
    wearable_ids: [377, 437],
  },
  {
    genesis_token_id: 8039,
    wearable_ids: [316, 372],
  },
  {
    genesis_token_id: 8040,
    wearable_ids: [276, 395],
  },
  {
    genesis_token_id: 8041,
    wearable_ids: [348, 298],
  },
  {
    genesis_token_id: 8042,
    wearable_ids: [374, 433],
  },
  {
    genesis_token_id: 8043,
    wearable_ids: [434, 362],
  },
  {
    genesis_token_id: 8044,
    wearable_ids: [425, 267],
  },
  {
    genesis_token_id: 8045,
    wearable_ids: [287, 427],
  },
  {
    genesis_token_id: 8046,
    wearable_ids: [429, 378],
  },
  {
    genesis_token_id: 8047,
    wearable_ids: [355, 419],
  },
  {
    genesis_token_id: 8048,
    wearable_ids: [369, 284],
  },
  {
    genesis_token_id: 8049,
    wearable_ids: [369, 360],
  },
  {
    genesis_token_id: 8050,
    wearable_ids: [344, 289],
  },
  {
    genesis_token_id: 8051,
    wearable_ids: [264, 348],
  },
  {
    genesis_token_id: 8052,
    wearable_ids: [386, 436],
  },
  {
    genesis_token_id: 8053,
    wearable_ids: [295, 403],
  },
  {
    genesis_token_id: 8054,
    wearable_ids: [437, 272],
  },
  {
    genesis_token_id: 8055,
    wearable_ids: [303, 286],
  },
  {
    genesis_token_id: 8056,
    wearable_ids: [349, 433],
  },
  {
    genesis_token_id: 8057,
    wearable_ids: [429, 308],
  },
  {
    genesis_token_id: 8058,
    wearable_ids: [343, 418],
  },
  {
    genesis_token_id: 8059,
    wearable_ids: [385, 432],
  },
  {
    genesis_token_id: 8060,
    wearable_ids: [315, 405],
  },
  {
    genesis_token_id: 8061,
    wearable_ids: [386, 315],
  },
  {
    genesis_token_id: 8062,
    wearable_ids: [378, 291],
  },
  {
    genesis_token_id: 8063,
    wearable_ids: [378, 354],
  },
  {
    genesis_token_id: 8064,
    wearable_ids: [384, 268],
  },
  {
    genesis_token_id: 8065,
    wearable_ids: [373, 296],
  },
  {
    genesis_token_id: 8066,
    wearable_ids: [349, 366],
  },
  {
    genesis_token_id: 8067,
    wearable_ids: [424, 400],
  },
  {
    genesis_token_id: 8068,
    wearable_ids: [412, 433],
  },
  {
    genesis_token_id: 8069,
    wearable_ids: [351, 429],
  },
  {
    genesis_token_id: 8070,
    wearable_ids: [369, 411],
  },
  {
    genesis_token_id: 8071,
    wearable_ids: [325, 424],
  },
  {
    genesis_token_id: 8072,
    wearable_ids: [423, 261],
  },
  {
    genesis_token_id: 8073,
    wearable_ids: [257, 370],
  },
  {
    genesis_token_id: 8074,
    wearable_ids: [265, 257],
  },
  {
    genesis_token_id: 8075,
    wearable_ids: [274, 362],
  },
  {
    genesis_token_id: 8076,
    wearable_ids: [408, 434],
  },
  {
    genesis_token_id: 8077,
    wearable_ids: [434, 359],
  },
  {
    genesis_token_id: 8078,
    wearable_ids: [255, 433],
  },
  {
    genesis_token_id: 8079,
    wearable_ids: [254, 382],
  },
  {
    genesis_token_id: 8080,
    wearable_ids: [371, 363],
  },
  {
    genesis_token_id: 8081,
    wearable_ids: [251, 423],
  },
  {
    genesis_token_id: 8082,
    wearable_ids: [331, 442],
  },
  {
    genesis_token_id: 8083,
    wearable_ids: [289, 265],
  },
  {
    genesis_token_id: 8084,
    wearable_ids: [350, 424],
  },
  {
    genesis_token_id: 8085,
    wearable_ids: [266, 264],
  },
  {
    genesis_token_id: 8086,
    wearable_ids: [375, 368],
  },
  {
    genesis_token_id: 8087,
    wearable_ids: [324, 420],
  },
  {
    genesis_token_id: 8088,
    wearable_ids: [412, 257],
  },
  {
    genesis_token_id: 8089,
    wearable_ids: [407, 324],
  },
  {
    genesis_token_id: 8090,
    wearable_ids: [431, 411],
  },
  {
    genesis_token_id: 8091,
    wearable_ids: [377, 354],
  },
  {
    genesis_token_id: 8092,
    wearable_ids: [316, 382],
  },
  {
    genesis_token_id: 8093,
    wearable_ids: [355, 288],
  },
  {
    genesis_token_id: 8094,
    wearable_ids: [428, 276],
  },
  {
    genesis_token_id: 8095,
    wearable_ids: [286, 372],
  },
  {
    genesis_token_id: 8096,
    wearable_ids: [371, 444],
  },
  {
    genesis_token_id: 8097,
    wearable_ids: [338, 335],
  },
  {
    genesis_token_id: 8098,
    wearable_ids: [349, 265],
  },
  {
    genesis_token_id: 8099,
    wearable_ids: [431, 249],
  },
  {
    genesis_token_id: 8100,
    wearable_ids: [403, 262],
  },
  {
    genesis_token_id: 8101,
    wearable_ids: [259, 340],
  },
  {
    genesis_token_id: 8102,
    wearable_ids: [355, 247],
  },
  {
    genesis_token_id: 8103,
    wearable_ids: [325, 429],
  },
  {
    genesis_token_id: 8104,
    wearable_ids: [256, 254],
  },
  {
    genesis_token_id: 8105,
    wearable_ids: [424, 347],
  },
  {
    genesis_token_id: 8106,
    wearable_ids: [273, 326],
  },
  {
    genesis_token_id: 8107,
    wearable_ids: [348, 286],
  },
  {
    genesis_token_id: 8108,
    wearable_ids: [389, 409],
  },
  {
    genesis_token_id: 8109,
    wearable_ids: [310, 412],
  },
  {
    genesis_token_id: 8110,
    wearable_ids: [344, 291],
  },
  {
    genesis_token_id: 8111,
    wearable_ids: [291, 351],
  },
  {
    genesis_token_id: 8112,
    wearable_ids: [339, 365],
  },
  {
    genesis_token_id: 8113,
    wearable_ids: [339, 382],
  },
  {
    genesis_token_id: 8114,
    wearable_ids: [326, 340],
  },
  {
    genesis_token_id: 8115,
    wearable_ids: [365, 261],
  },
  {
    genesis_token_id: 8116,
    wearable_ids: [294, 290],
  },
  {
    genesis_token_id: 8117,
    wearable_ids: [273, 251],
  },
  {
    genesis_token_id: 8118,
    wearable_ids: [341, 414],
  },
  {
    genesis_token_id: 8119,
    wearable_ids: [373, 277],
  },
  {
    genesis_token_id: 8120,
    wearable_ids: [434, 426],
  },
  {
    genesis_token_id: 8121,
    wearable_ids: [311, 258],
  },
  {
    genesis_token_id: 8122,
    wearable_ids: [428, 424],
  },
  {
    genesis_token_id: 8123,
    wearable_ids: [341, 342],
  },
  {
    genesis_token_id: 8124,
    wearable_ids: [444, 330],
  },
  {
    genesis_token_id: 8125,
    wearable_ids: [337, 400],
  },
  {
    genesis_token_id: 8126,
    wearable_ids: [409, 337],
  },
  {
    genesis_token_id: 8127,
    wearable_ids: [433, 289],
  },
  {
    genesis_token_id: 8128,
    wearable_ids: [383, 256],
  },
  {
    genesis_token_id: 8129,
    wearable_ids: [280, 372],
  },
  {
    genesis_token_id: 8130,
    wearable_ids: [284, 437],
  },
  {
    genesis_token_id: 8131,
    wearable_ids: [382, 413],
  },
  {
    genesis_token_id: 8132,
    wearable_ids: [304, 397],
  },
  {
    genesis_token_id: 8133,
    wearable_ids: [382, 284],
  },
  {
    genesis_token_id: 8134,
    wearable_ids: [251, 316],
  },
  {
    genesis_token_id: 8135,
    wearable_ids: [248, 385],
  },
  {
    genesis_token_id: 8136,
    wearable_ids: [362, 371],
  },
  {
    genesis_token_id: 8137,
    wearable_ids: [324, 427],
  },
  {
    genesis_token_id: 8138,
    wearable_ids: [280, 396],
  },
  {
    genesis_token_id: 8139,
    wearable_ids: [413, 396],
  },
  {
    genesis_token_id: 8140,
    wearable_ids: [264, 353],
  },
  {
    genesis_token_id: 8141,
    wearable_ids: [296, 306],
  },
  {
    genesis_token_id: 8142,
    wearable_ids: [304, 295],
  },
  {
    genesis_token_id: 8143,
    wearable_ids: [340, 312],
  },
  {
    genesis_token_id: 8144,
    wearable_ids: [433, 342],
  },
  {
    genesis_token_id: 8145,
    wearable_ids: [303, 254],
  },
  {
    genesis_token_id: 8146,
    wearable_ids: [403, 326],
  },
  {
    genesis_token_id: 8147,
    wearable_ids: [291, 363],
  },
  {
    genesis_token_id: 8148,
    wearable_ids: [295, 322],
  },
  {
    genesis_token_id: 8149,
    wearable_ids: [278, 349],
  },
  {
    genesis_token_id: 8150,
    wearable_ids: [415, 300],
  },
  {
    genesis_token_id: 8151,
    wearable_ids: [299, 248],
  },
  {
    genesis_token_id: 8152,
    wearable_ids: [315, 392],
  },
  {
    genesis_token_id: 8153,
    wearable_ids: [410, 337],
  },
  {
    genesis_token_id: 8154,
    wearable_ids: [273, 291],
  },
  {
    genesis_token_id: 8155,
    wearable_ids: [276, 315],
  },
  {
    genesis_token_id: 8156,
    wearable_ids: [352, 322],
  },
  {
    genesis_token_id: 8157,
    wearable_ids: [403, 345],
  },
  {
    genesis_token_id: 8158,
    wearable_ids: [264, 278],
  },
  {
    genesis_token_id: 8159,
    wearable_ids: [304, 337],
  },
  {
    genesis_token_id: 8160,
    wearable_ids: [428, 255],
  },
  {
    genesis_token_id: 8161,
    wearable_ids: [376, 313],
  },
  {
    genesis_token_id: 8162,
    wearable_ids: [254, 432],
  },
  {
    genesis_token_id: 8163,
    wearable_ids: [271, 273],
  },
  {
    genesis_token_id: 8164,
    wearable_ids: [303, 340],
  },
  {
    genesis_token_id: 8165,
    wearable_ids: [351, 377],
  },
  {
    genesis_token_id: 8166,
    wearable_ids: [369, 417],
  },
  {
    genesis_token_id: 8167,
    wearable_ids: [378, 264],
  },
  {
    genesis_token_id: 8168,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 8169,
    wearable_ids: [316, 377],
  },
  {
    genesis_token_id: 8170,
    wearable_ids: [376, 310],
  },
  {
    genesis_token_id: 8171,
    wearable_ids: [264, 375],
  },
  {
    genesis_token_id: 8172,
    wearable_ids: [434, 432],
  },
  {
    genesis_token_id: 8173,
    wearable_ids: [443, 255],
  },
  {
    genesis_token_id: 8174,
    wearable_ids: [251, 258],
  },
  {
    genesis_token_id: 8175,
    wearable_ids: [432, 343],
  },
  {
    genesis_token_id: 8176,
    wearable_ids: [272, 399],
  },
  {
    genesis_token_id: 8177,
    wearable_ids: [352, 257],
  },
  {
    genesis_token_id: 8178,
    wearable_ids: [395, 277],
  },
  {
    genesis_token_id: 8179,
    wearable_ids: [385, 408],
  },
  {
    genesis_token_id: 8180,
    wearable_ids: [410, 350],
  },
  {
    genesis_token_id: 8181,
    wearable_ids: [315, 277],
  },
  {
    genesis_token_id: 8182,
    wearable_ids: [292, 363],
  },
  {
    genesis_token_id: 8183,
    wearable_ids: [444, 409],
  },
  {
    genesis_token_id: 8184,
    wearable_ids: [382, 291],
  },
  {
    genesis_token_id: 8185,
    wearable_ids: [368, 389],
  },
  {
    genesis_token_id: 8186,
    wearable_ids: [314, 286],
  },
  {
    genesis_token_id: 8187,
    wearable_ids: [428, 400],
  },
  {
    genesis_token_id: 8188,
    wearable_ids: [363, 248],
  },
  {
    genesis_token_id: 8189,
    wearable_ids: [403, 360],
  },
  {
    genesis_token_id: 8190,
    wearable_ids: [273, 284],
  },
  {
    genesis_token_id: 8191,
    wearable_ids: [277, 366],
  },
  {
    genesis_token_id: 8192,
    wearable_ids: [337, 301],
  },
  {
    genesis_token_id: 8193,
    wearable_ids: [370, 254],
  },
  {
    genesis_token_id: 8194,
    wearable_ids: [384, 361],
  },
  {
    genesis_token_id: 8195,
    wearable_ids: [258, 407],
  },
  {
    genesis_token_id: 8196,
    wearable_ids: [355, 403],
  },
  {
    genesis_token_id: 8197,
    wearable_ids: [403, 265],
  },
  {
    genesis_token_id: 8198,
    wearable_ids: [365, 423],
  },
  {
    genesis_token_id: 8199,
    wearable_ids: [423, 276],
  },
  {
    genesis_token_id: 8200,
    wearable_ids: [306, 427],
  },
  {
    genesis_token_id: 8201,
    wearable_ids: [297, 305],
  },
  {
    genesis_token_id: 8202,
    wearable_ids: [251, 372],
  },
  {
    genesis_token_id: 8203,
    wearable_ids: [310, 372],
  },
  {
    genesis_token_id: 8204,
    wearable_ids: [325, 370],
  },
  {
    genesis_token_id: 8205,
    wearable_ids: [300, 397],
  },
  {
    genesis_token_id: 8206,
    wearable_ids: [316, 346],
  },
  {
    genesis_token_id: 8207,
    wearable_ids: [389, 434],
  },
  {
    genesis_token_id: 8208,
    wearable_ids: [428, 400],
  },
  {
    genesis_token_id: 8209,
    wearable_ids: [268, 401],
  },
  {
    genesis_token_id: 8210,
    wearable_ids: [344, 280],
  },
  {
    genesis_token_id: 8211,
    wearable_ids: [397, 299],
  },
  {
    genesis_token_id: 8212,
    wearable_ids: [266, 346],
  },
  {
    genesis_token_id: 8213,
    wearable_ids: [272, 442],
  },
  {
    genesis_token_id: 8214,
    wearable_ids: [306, 315],
  },
  {
    genesis_token_id: 8215,
    wearable_ids: [352, 257],
  },
  {
    genesis_token_id: 8216,
    wearable_ids: [420, 328],
  },
  {
    genesis_token_id: 8217,
    wearable_ids: [343, 425],
  },
  {
    genesis_token_id: 8218,
    wearable_ids: [303, 434],
  },
  {
    genesis_token_id: 8219,
    wearable_ids: [326, 343],
  },
  {
    genesis_token_id: 8220,
    wearable_ids: [371, 254],
  },
  {
    genesis_token_id: 8221,
    wearable_ids: [404, 254],
  },
  {
    genesis_token_id: 8222,
    wearable_ids: [415, 431],
  },
  {
    genesis_token_id: 8223,
    wearable_ids: [384, 332],
  },
  {
    genesis_token_id: 8224,
    wearable_ids: [437, 368],
  },
  {
    genesis_token_id: 8225,
    wearable_ids: [296, 361],
  },
  {
    genesis_token_id: 8226,
    wearable_ids: [284, 306],
  },
  {
    genesis_token_id: 8227,
    wearable_ids: [410, 418],
  },
  {
    genesis_token_id: 8228,
    wearable_ids: [268, 417],
  },
  {
    genesis_token_id: 8229,
    wearable_ids: [259, 278],
  },
  {
    genesis_token_id: 8230,
    wearable_ids: [409, 430],
  },
  {
    genesis_token_id: 8231,
    wearable_ids: [290, 444],
  },
  {
    genesis_token_id: 8232,
    wearable_ids: [400, 362],
  },
  {
    genesis_token_id: 8233,
    wearable_ids: [403, 351],
  },
  {
    genesis_token_id: 8234,
    wearable_ids: [426, 342],
  },
  {
    genesis_token_id: 8235,
    wearable_ids: [412, 304],
  },
  {
    genesis_token_id: 8236,
    wearable_ids: [314, 413],
  },
  {
    genesis_token_id: 8237,
    wearable_ids: [432, 346],
  },
  {
    genesis_token_id: 8238,
    wearable_ids: [264, 395],
  },
  {
    genesis_token_id: 8239,
    wearable_ids: [336, 287],
  },
  {
    genesis_token_id: 8240,
    wearable_ids: [340, 420],
  },
  {
    genesis_token_id: 8241,
    wearable_ids: [443, 398],
  },
  {
    genesis_token_id: 8242,
    wearable_ids: [284, 276],
  },
  {
    genesis_token_id: 8243,
    wearable_ids: [407, 391],
  },
  {
    genesis_token_id: 8244,
    wearable_ids: [426, 396],
  },
  {
    genesis_token_id: 8245,
    wearable_ids: [317, 438],
  },
  {
    genesis_token_id: 8246,
    wearable_ids: [420, 253],
  },
  {
    genesis_token_id: 8247,
    wearable_ids: [308, 366],
  },
  {
    genesis_token_id: 8248,
    wearable_ids: [258, 429],
  },
  {
    genesis_token_id: 8249,
    wearable_ids: [408, 420],
  },
  {
    genesis_token_id: 8250,
    wearable_ids: [297, 369],
  },
  {
    genesis_token_id: 8251,
    wearable_ids: [263, 276],
  },
  {
    genesis_token_id: 8252,
    wearable_ids: [420, 316],
  },
  {
    genesis_token_id: 8253,
    wearable_ids: [310, 260],
  },
  {
    genesis_token_id: 8254,
    wearable_ids: [423, 283],
  },
  {
    genesis_token_id: 8255,
    wearable_ids: [407, 334],
  },
  {
    genesis_token_id: 8256,
    wearable_ids: [426, 325],
  },
  {
    genesis_token_id: 8257,
    wearable_ids: [319, 414],
  },
  {
    genesis_token_id: 8258,
    wearable_ids: [365, 433],
  },
  {
    genesis_token_id: 8259,
    wearable_ids: [296, 257],
  },
  {
    genesis_token_id: 8260,
    wearable_ids: [308, 354],
  },
  {
    genesis_token_id: 8261,
    wearable_ids: [412, 426],
  },
  {
    genesis_token_id: 8262,
    wearable_ids: [406, 397],
  },
  {
    genesis_token_id: 8263,
    wearable_ids: [375, 320],
  },
  {
    genesis_token_id: 8264,
    wearable_ids: [248, 364],
  },
  {
    genesis_token_id: 8265,
    wearable_ids: [265, 335],
  },
  {
    genesis_token_id: 8266,
    wearable_ids: [259, 268],
  },
  {
    genesis_token_id: 8267,
    wearable_ids: [435, 344],
  },
  {
    genesis_token_id: 8268,
    wearable_ids: [319, 442],
  },
  {
    genesis_token_id: 8269,
    wearable_ids: [310, 413],
  },
  {
    genesis_token_id: 8270,
    wearable_ids: [362, 294],
  },
  {
    genesis_token_id: 8271,
    wearable_ids: [300, 397],
  },
  {
    genesis_token_id: 8272,
    wearable_ids: [339, 263],
  },
  {
    genesis_token_id: 8273,
    wearable_ids: [278, 399],
  },
  {
    genesis_token_id: 8274,
    wearable_ids: [257, 372],
  },
  {
    genesis_token_id: 8275,
    wearable_ids: [291, 387],
  },
  {
    genesis_token_id: 8276,
    wearable_ids: [255, 248],
  },
  {
    genesis_token_id: 8277,
    wearable_ids: [253, 295],
  },
  {
    genesis_token_id: 8278,
    wearable_ids: [338, 363],
  },
  {
    genesis_token_id: 8279,
    wearable_ids: [404, 427],
  },
  {
    genesis_token_id: 8280,
    wearable_ids: [270, 339],
  },
  {
    genesis_token_id: 8281,
    wearable_ids: [435, 406],
  },
  {
    genesis_token_id: 8282,
    wearable_ids: [384, 346],
  },
  {
    genesis_token_id: 8283,
    wearable_ids: [396, 319],
  },
  {
    genesis_token_id: 8284,
    wearable_ids: [409, 289],
  },
  {
    genesis_token_id: 8285,
    wearable_ids: [389, 266],
  },
  {
    genesis_token_id: 8286,
    wearable_ids: [292, 312],
  },
  {
    genesis_token_id: 8287,
    wearable_ids: [291, 317],
  },
  {
    genesis_token_id: 8288,
    wearable_ids: [443, 320],
  },
  {
    genesis_token_id: 8289,
    wearable_ids: [315, 378],
  },
  {
    genesis_token_id: 8290,
    wearable_ids: [437, 293],
  },
  {
    genesis_token_id: 8291,
    wearable_ids: [338, 294],
  },
  {
    genesis_token_id: 8292,
    wearable_ids: [407, 349],
  },
  {
    genesis_token_id: 8293,
    wearable_ids: [317, 411],
  },
  {
    genesis_token_id: 8294,
    wearable_ids: [386, 365],
  },
  {
    genesis_token_id: 8295,
    wearable_ids: [248, 259],
  },
  {
    genesis_token_id: 8296,
    wearable_ids: [425, 410],
  },
  {
    genesis_token_id: 8297,
    wearable_ids: [365, 338],
  },
  {
    genesis_token_id: 8298,
    wearable_ids: [372, 308],
  },
  {
    genesis_token_id: 8299,
    wearable_ids: [422, 319],
  },
  {
    genesis_token_id: 8300,
    wearable_ids: [428, 418],
  },
  {
    genesis_token_id: 8301,
    wearable_ids: [316, 407],
  },
  {
    genesis_token_id: 8302,
    wearable_ids: [395, 314],
  },
  {
    genesis_token_id: 8303,
    wearable_ids: [425, 285],
  },
  {
    genesis_token_id: 8304,
    wearable_ids: [375, 370],
  },
  {
    genesis_token_id: 8305,
    wearable_ids: [435, 338],
  },
  {
    genesis_token_id: 8306,
    wearable_ids: [296, 299],
  },
  {
    genesis_token_id: 8307,
    wearable_ids: [445, 257],
  },
  {
    genesis_token_id: 8308,
    wearable_ids: [306, 422],
  },
  {
    genesis_token_id: 8309,
    wearable_ids: [338, 385],
  },
  {
    genesis_token_id: 8310,
    wearable_ids: [280, 258],
  },
  {
    genesis_token_id: 8311,
    wearable_ids: [404, 397],
  },
  {
    genesis_token_id: 8312,
    wearable_ids: [422, 385],
  },
  {
    genesis_token_id: 8313,
    wearable_ids: [273, 424],
  },
  {
    genesis_token_id: 8314,
    wearable_ids: [346, 266],
  },
  {
    genesis_token_id: 8315,
    wearable_ids: [265, 445],
  },
  {
    genesis_token_id: 8316,
    wearable_ids: [295, 305],
  },
  {
    genesis_token_id: 8317,
    wearable_ids: [311, 423],
  },
  {
    genesis_token_id: 8318,
    wearable_ids: [292, 420],
  },
  {
    genesis_token_id: 8319,
    wearable_ids: [284, 397],
  },
  {
    genesis_token_id: 8320,
    wearable_ids: [351, 428],
  },
  {
    genesis_token_id: 8321,
    wearable_ids: [435, 251],
  },
  {
    genesis_token_id: 8322,
    wearable_ids: [344, 317],
  },
  {
    genesis_token_id: 8323,
    wearable_ids: [255, 256],
  },
  {
    genesis_token_id: 8324,
    wearable_ids: [352, 415],
  },
  {
    genesis_token_id: 8325,
    wearable_ids: [384, 445],
  },
  {
    genesis_token_id: 8326,
    wearable_ids: [343, 347],
  },
  {
    genesis_token_id: 8327,
    wearable_ids: [284, 256],
  },
  {
    genesis_token_id: 8328,
    wearable_ids: [247, 363],
  },
  {
    genesis_token_id: 8329,
    wearable_ids: [407, 375],
  },
  {
    genesis_token_id: 8330,
    wearable_ids: [372, 433],
  },
  {
    genesis_token_id: 8331,
    wearable_ids: [296, 317],
  },
  {
    genesis_token_id: 8332,
    wearable_ids: [270, 409],
  },
  {
    genesis_token_id: 8333,
    wearable_ids: [445, 396],
  },
  {
    genesis_token_id: 8334,
    wearable_ids: [395, 264],
  },
  {
    genesis_token_id: 8335,
    wearable_ids: [319, 435],
  },
  {
    genesis_token_id: 8336,
    wearable_ids: [410, 277],
  },
  {
    genesis_token_id: 8337,
    wearable_ids: [369, 271],
  },
  {
    genesis_token_id: 8338,
    wearable_ids: [303, 272],
  },
  {
    genesis_token_id: 8339,
    wearable_ids: [347, 388],
  },
  {
    genesis_token_id: 8340,
    wearable_ids: [375, 283],
  },
  {
    genesis_token_id: 8341,
    wearable_ids: [248, 352],
  },
  {
    genesis_token_id: 8342,
    wearable_ids: [409, 385],
  },
  {
    genesis_token_id: 8343,
    wearable_ids: [423, 424],
  },
  {
    genesis_token_id: 8344,
    wearable_ids: [433, 326],
  },
  {
    genesis_token_id: 8345,
    wearable_ids: [299, 399],
  },
  {
    genesis_token_id: 8346,
    wearable_ids: [373, 408],
  },
  {
    genesis_token_id: 8347,
    wearable_ids: [290, 437],
  },
  {
    genesis_token_id: 8348,
    wearable_ids: [383, 434],
  },
  {
    genesis_token_id: 8349,
    wearable_ids: [272, 303],
  },
  {
    genesis_token_id: 8350,
    wearable_ids: [423, 254],
  },
  {
    genesis_token_id: 8351,
    wearable_ids: [397, 357],
  },
  {
    genesis_token_id: 8352,
    wearable_ids: [384, 258],
  },
  {
    genesis_token_id: 8353,
    wearable_ids: [274, 317],
  },
  {
    genesis_token_id: 8354,
    wearable_ids: [290, 339],
  },
  {
    genesis_token_id: 8355,
    wearable_ids: [372, 355],
  },
  {
    genesis_token_id: 8356,
    wearable_ids: [410, 436],
  },
  {
    genesis_token_id: 8357,
    wearable_ids: [289, 341],
  },
  {
    genesis_token_id: 8358,
    wearable_ids: [263, 332],
  },
  {
    genesis_token_id: 8359,
    wearable_ids: [384, 405],
  },
  {
    genesis_token_id: 8360,
    wearable_ids: [299, 270],
  },
  {
    genesis_token_id: 8361,
    wearable_ids: [383, 317],
  },
  {
    genesis_token_id: 8362,
    wearable_ids: [304, 364],
  },
  {
    genesis_token_id: 8363,
    wearable_ids: [262, 389],
  },
  {
    genesis_token_id: 8364,
    wearable_ids: [423, 253],
  },
  {
    genesis_token_id: 8365,
    wearable_ids: [423, 397],
  },
  {
    genesis_token_id: 8366,
    wearable_ids: [343, 391],
  },
  {
    genesis_token_id: 8367,
    wearable_ids: [415, 263],
  },
  {
    genesis_token_id: 8368,
    wearable_ids: [336, 266],
  },
  {
    genesis_token_id: 8369,
    wearable_ids: [306, 303],
  },
  {
    genesis_token_id: 8370,
    wearable_ids: [385, 256],
  },
  {
    genesis_token_id: 8371,
    wearable_ids: [382, 345],
  },
  {
    genesis_token_id: 8372,
    wearable_ids: [407, 301],
  },
  {
    genesis_token_id: 8373,
    wearable_ids: [383, 253],
  },
  {
    genesis_token_id: 8374,
    wearable_ids: [292, 388],
  },
  {
    genesis_token_id: 8375,
    wearable_ids: [253, 343],
  },
  {
    genesis_token_id: 8376,
    wearable_ids: [278, 423],
  },
  {
    genesis_token_id: 8377,
    wearable_ids: [371, 276],
  },
  {
    genesis_token_id: 8378,
    wearable_ids: [247, 368],
  },
  {
    genesis_token_id: 8379,
    wearable_ids: [436, 283],
  },
  {
    genesis_token_id: 8380,
    wearable_ids: [384, 361],
  },
  {
    genesis_token_id: 8381,
    wearable_ids: [409, 331],
  },
  {
    genesis_token_id: 8382,
    wearable_ids: [315, 299],
  },
  {
    genesis_token_id: 8383,
    wearable_ids: [286, 433],
  },
  {
    genesis_token_id: 8384,
    wearable_ids: [434, 419],
  },
  {
    genesis_token_id: 8385,
    wearable_ids: [377, 265],
  },
  {
    genesis_token_id: 8386,
    wearable_ids: [266, 396],
  },
  {
    genesis_token_id: 8387,
    wearable_ids: [289, 251],
  },
  {
    genesis_token_id: 8388,
    wearable_ids: [428, 307],
  },
  {
    genesis_token_id: 8389,
    wearable_ids: [435, 396],
  },
  {
    genesis_token_id: 8390,
    wearable_ids: [277, 251],
  },
  {
    genesis_token_id: 8391,
    wearable_ids: [340, 404],
  },
  {
    genesis_token_id: 8392,
    wearable_ids: [364, 382],
  },
  {
    genesis_token_id: 8393,
    wearable_ids: [295, 336],
  },
  {
    genesis_token_id: 8394,
    wearable_ids: [352, 371],
  },
  {
    genesis_token_id: 8395,
    wearable_ids: [368, 274],
  },
  {
    genesis_token_id: 8396,
    wearable_ids: [437, 263],
  },
  {
    genesis_token_id: 8397,
    wearable_ids: [371, 251],
  },
  {
    genesis_token_id: 8398,
    wearable_ids: [435, 319],
  },
  {
    genesis_token_id: 8399,
    wearable_ids: [384, 418],
  },
  {
    genesis_token_id: 8400,
    wearable_ids: [300, 296],
  },
  {
    genesis_token_id: 8401,
    wearable_ids: [426, 383],
  },
  {
    genesis_token_id: 8402,
    wearable_ids: [339, 314],
  },
  {
    genesis_token_id: 8403,
    wearable_ids: [317, 325],
  },
  {
    genesis_token_id: 8404,
    wearable_ids: [444, 440],
  },
  {
    genesis_token_id: 8405,
    wearable_ids: [362, 393],
  },
  {
    genesis_token_id: 8406,
    wearable_ids: [342, 277],
  },
  {
    genesis_token_id: 8407,
    wearable_ids: [422, 263],
  },
  {
    genesis_token_id: 8408,
    wearable_ids: [443, 368],
  },
  {
    genesis_token_id: 8409,
    wearable_ids: [336, 382],
  },
  {
    genesis_token_id: 8410,
    wearable_ids: [397, 408],
  },
  {
    genesis_token_id: 8411,
    wearable_ids: [286, 404],
  },
  {
    genesis_token_id: 8412,
    wearable_ids: [276, 311],
  },
  {
    genesis_token_id: 8413,
    wearable_ids: [337, 394],
  },
  {
    genesis_token_id: 8414,
    wearable_ids: [342, 413],
  },
  {
    genesis_token_id: 8415,
    wearable_ids: [255, 387],
  },
  {
    genesis_token_id: 8416,
    wearable_ids: [433, 383],
  },
  {
    genesis_token_id: 8417,
    wearable_ids: [382, 395],
  },
  {
    genesis_token_id: 8418,
    wearable_ids: [268, 408],
  },
  {
    genesis_token_id: 8419,
    wearable_ids: [387, 325],
  },
  {
    genesis_token_id: 8420,
    wearable_ids: [431, 308],
  },
  {
    genesis_token_id: 8421,
    wearable_ids: [426, 434],
  },
  {
    genesis_token_id: 8422,
    wearable_ids: [348, 378],
  },
  {
    genesis_token_id: 8423,
    wearable_ids: [278, 373],
  },
  {
    genesis_token_id: 8424,
    wearable_ids: [255, 424],
  },
  {
    genesis_token_id: 8425,
    wearable_ids: [426, 284],
  },
  {
    genesis_token_id: 8426,
    wearable_ids: [348, 251],
  },
  {
    genesis_token_id: 8427,
    wearable_ids: [426, 342],
  },
  {
    genesis_token_id: 8428,
    wearable_ids: [444, 365],
  },
  {
    genesis_token_id: 8429,
    wearable_ids: [315, 429],
  },
  {
    genesis_token_id: 8430,
    wearable_ids: [370, 437],
  },
  {
    genesis_token_id: 8431,
    wearable_ids: [364, 351],
  },
  {
    genesis_token_id: 8432,
    wearable_ids: [434, 417],
  },
  {
    genesis_token_id: 8433,
    wearable_ids: [432, 289],
  },
  {
    genesis_token_id: 8434,
    wearable_ids: [395, 423],
  },
  {
    genesis_token_id: 8435,
    wearable_ids: [255, 382],
  },
  {
    genesis_token_id: 8436,
    wearable_ids: [301, 401],
  },
  {
    genesis_token_id: 8437,
    wearable_ids: [420, 281],
  },
  {
    genesis_token_id: 8438,
    wearable_ids: [308, 340],
  },
  {
    genesis_token_id: 8439,
    wearable_ids: [403, 264],
  },
  {
    genesis_token_id: 8440,
    wearable_ids: [352, 362],
  },
  {
    genesis_token_id: 8441,
    wearable_ids: [371, 437],
  },
  {
    genesis_token_id: 8442,
    wearable_ids: [429, 326],
  },
  {
    genesis_token_id: 8443,
    wearable_ids: [278, 263],
  },
  {
    genesis_token_id: 8444,
    wearable_ids: [347, 370],
  },
  {
    genesis_token_id: 8445,
    wearable_ids: [375, 316],
  },
  {
    genesis_token_id: 8446,
    wearable_ids: [341, 441],
  },
  {
    genesis_token_id: 8447,
    wearable_ids: [296, 262],
  },
  {
    genesis_token_id: 8448,
    wearable_ids: [289, 278],
  },
  {
    genesis_token_id: 8449,
    wearable_ids: [355, 339],
  },
  {
    genesis_token_id: 8450,
    wearable_ids: [247, 328],
  },
  {
    genesis_token_id: 8451,
    wearable_ids: [420, 386],
  },
  {
    genesis_token_id: 8452,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 8453,
    wearable_ids: [296, 274],
  },
  {
    genesis_token_id: 8454,
    wearable_ids: [324, 386],
  },
  {
    genesis_token_id: 8455,
    wearable_ids: [385, 372],
  },
  {
    genesis_token_id: 8456,
    wearable_ids: [444, 428],
  },
  {
    genesis_token_id: 8457,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 8458,
    wearable_ids: [259, 369],
  },
  {
    genesis_token_id: 8459,
    wearable_ids: [410, 301],
  },
  {
    genesis_token_id: 8460,
    wearable_ids: [264, 335],
  },
  {
    genesis_token_id: 8461,
    wearable_ids: [384, 436],
  },
  {
    genesis_token_id: 8462,
    wearable_ids: [426, 402],
  },
  {
    genesis_token_id: 8463,
    wearable_ids: [378, 336],
  },
  {
    genesis_token_id: 8464,
    wearable_ids: [290, 299],
  },
  {
    genesis_token_id: 8465,
    wearable_ids: [286, 377],
  },
  {
    genesis_token_id: 8466,
    wearable_ids: [371, 254],
  },
  {
    genesis_token_id: 8467,
    wearable_ids: [387, 434],
  },
  {
    genesis_token_id: 8468,
    wearable_ids: [308, 311],
  },
  {
    genesis_token_id: 8469,
    wearable_ids: [376, 331],
  },
  {
    genesis_token_id: 8470,
    wearable_ids: [387, 335],
  },
  {
    genesis_token_id: 8471,
    wearable_ids: [375, 331],
  },
  {
    genesis_token_id: 8472,
    wearable_ids: [363, 434],
  },
  {
    genesis_token_id: 8473,
    wearable_ids: [343, 338],
  },
  {
    genesis_token_id: 8474,
    wearable_ids: [332, 276],
  },
  {
    genesis_token_id: 8475,
    wearable_ids: [253, 425],
  },
  {
    genesis_token_id: 8476,
    wearable_ids: [266, 280],
  },
  {
    genesis_token_id: 8477,
    wearable_ids: [340, 338],
  },
  {
    genesis_token_id: 8478,
    wearable_ids: [371, 251],
  },
  {
    genesis_token_id: 8479,
    wearable_ids: [433, 314],
  },
  {
    genesis_token_id: 8480,
    wearable_ids: [342, 263],
  },
  {
    genesis_token_id: 8481,
    wearable_ids: [428, 290],
  },
  {
    genesis_token_id: 8482,
    wearable_ids: [364, 411],
  },
  {
    genesis_token_id: 8483,
    wearable_ids: [276, 296],
  },
  {
    genesis_token_id: 8484,
    wearable_ids: [343, 424],
  },
  {
    genesis_token_id: 8485,
    wearable_ids: [368, 256],
  },
  {
    genesis_token_id: 8486,
    wearable_ids: [247, 396],
  },
  {
    genesis_token_id: 8487,
    wearable_ids: [400, 344],
  },
  {
    genesis_token_id: 8488,
    wearable_ids: [339, 411],
  },
  {
    genesis_token_id: 8489,
    wearable_ids: [273, 386],
  },
  {
    genesis_token_id: 8490,
    wearable_ids: [343, 269],
  },
  {
    genesis_token_id: 8491,
    wearable_ids: [338, 420],
  },
  {
    genesis_token_id: 8492,
    wearable_ids: [389, 295],
  },
  {
    genesis_token_id: 8493,
    wearable_ids: [292, 386],
  },
  {
    genesis_token_id: 8494,
    wearable_ids: [251, 326],
  },
  {
    genesis_token_id: 8495,
    wearable_ids: [376, 310],
  },
  {
    genesis_token_id: 8496,
    wearable_ids: [299, 383],
  },
  {
    genesis_token_id: 8497,
    wearable_ids: [374, 425],
  },
  {
    genesis_token_id: 8498,
    wearable_ids: [348, 426],
  },
  {
    genesis_token_id: 8499,
    wearable_ids: [314, 395],
  },
  {
    genesis_token_id: 8500,
    wearable_ids: [343, 323],
  },
  {
    genesis_token_id: 8501,
    wearable_ids: [396, 346],
  },
  {
    genesis_token_id: 8502,
    wearable_ids: [299, 266],
  },
  {
    genesis_token_id: 8503,
    wearable_ids: [407, 283],
  },
  {
    genesis_token_id: 8504,
    wearable_ids: [280, 443],
  },
  {
    genesis_token_id: 8505,
    wearable_ids: [435, 429],
  },
  {
    genesis_token_id: 8506,
    wearable_ids: [429, 437],
  },
  {
    genesis_token_id: 8507,
    wearable_ids: [422, 291],
  },
  {
    genesis_token_id: 8508,
    wearable_ids: [415, 304],
  },
  {
    genesis_token_id: 8509,
    wearable_ids: [284, 246],
  },
  {
    genesis_token_id: 8510,
    wearable_ids: [284, 362],
  },
  {
    genesis_token_id: 8511,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 8512,
    wearable_ids: [415, 296],
  },
  {
    genesis_token_id: 8513,
    wearable_ids: [339, 325],
  },
  {
    genesis_token_id: 8514,
    wearable_ids: [409, 276],
  },
  {
    genesis_token_id: 8515,
    wearable_ids: [290, 259],
  },
  {
    genesis_token_id: 8516,
    wearable_ids: [409, 326],
  },
  {
    genesis_token_id: 8517,
    wearable_ids: [339, 270],
  },
  {
    genesis_token_id: 8518,
    wearable_ids: [420, 271],
  },
  {
    genesis_token_id: 8519,
    wearable_ids: [314, 354],
  },
  {
    genesis_token_id: 8520,
    wearable_ids: [314, 414],
  },
  {
    genesis_token_id: 8521,
    wearable_ids: [437, 361],
  },
  {
    genesis_token_id: 8522,
    wearable_ids: [411, 332],
  },
  {
    genesis_token_id: 8523,
    wearable_ids: [399, 351],
  },
  {
    genesis_token_id: 8524,
    wearable_ids: [272, 262],
  },
  {
    genesis_token_id: 8525,
    wearable_ids: [342, 247],
  },
  {
    genesis_token_id: 8526,
    wearable_ids: [383, 289],
  },
  {
    genesis_token_id: 8527,
    wearable_ids: [306, 318],
  },
  {
    genesis_token_id: 8528,
    wearable_ids: [253, 399],
  },
  {
    genesis_token_id: 8529,
    wearable_ids: [436, 392],
  },
  {
    genesis_token_id: 8530,
    wearable_ids: [339, 417],
  },
  {
    genesis_token_id: 8531,
    wearable_ids: [424, 389],
  },
  {
    genesis_token_id: 8532,
    wearable_ids: [368, 429],
  },
  {
    genesis_token_id: 8533,
    wearable_ids: [319, 338],
  },
  {
    genesis_token_id: 8534,
    wearable_ids: [317, 272],
  },
  {
    genesis_token_id: 8535,
    wearable_ids: [373, 315],
  },
  {
    genesis_token_id: 8536,
    wearable_ids: [365, 311],
  },
  {
    genesis_token_id: 8537,
    wearable_ids: [382, 286],
  },
  {
    genesis_token_id: 8538,
    wearable_ids: [278, 299],
  },
  {
    genesis_token_id: 8539,
    wearable_ids: [426, 262],
  },
  {
    genesis_token_id: 8540,
    wearable_ids: [291, 315],
  },
  {
    genesis_token_id: 8541,
    wearable_ids: [337, 441],
  },
  {
    genesis_token_id: 8542,
    wearable_ids: [413, 354],
  },
  {
    genesis_token_id: 8543,
    wearable_ids: [287, 284],
  },
  {
    genesis_token_id: 8544,
    wearable_ids: [289, 310],
  },
  {
    genesis_token_id: 8545,
    wearable_ids: [326, 259],
  },
  {
    genesis_token_id: 8546,
    wearable_ids: [434, 319],
  },
  {
    genesis_token_id: 8547,
    wearable_ids: [429, 271],
  },
  {
    genesis_token_id: 8548,
    wearable_ids: [310, 409],
  },
  {
    genesis_token_id: 8549,
    wearable_ids: [266, 256],
  },
  {
    genesis_token_id: 8550,
    wearable_ids: [344, 337],
  },
  {
    genesis_token_id: 8551,
    wearable_ids: [291, 292],
  },
  {
    genesis_token_id: 8552,
    wearable_ids: [271, 257],
  },
  {
    genesis_token_id: 8553,
    wearable_ids: [268, 441],
  },
  {
    genesis_token_id: 8554,
    wearable_ids: [278, 336],
  },
  {
    genesis_token_id: 8555,
    wearable_ids: [411, 265],
  },
  {
    genesis_token_id: 8556,
    wearable_ids: [248, 319],
  },
  {
    genesis_token_id: 8557,
    wearable_ids: [368, 423],
  },
  {
    genesis_token_id: 8558,
    wearable_ids: [371, 295],
  },
  {
    genesis_token_id: 8559,
    wearable_ids: [258, 300],
  },
  {
    genesis_token_id: 8560,
    wearable_ids: [368, 323],
  },
  {
    genesis_token_id: 8561,
    wearable_ids: [423, 256],
  },
  {
    genesis_token_id: 8562,
    wearable_ids: [340, 260],
  },
  {
    genesis_token_id: 8563,
    wearable_ids: [256, 395],
  },
  {
    genesis_token_id: 8564,
    wearable_ids: [338, 347],
  },
  {
    genesis_token_id: 8565,
    wearable_ids: [257, 315],
  },
  {
    genesis_token_id: 8566,
    wearable_ids: [365, 266],
  },
  {
    genesis_token_id: 8567,
    wearable_ids: [251, 372],
  },
  {
    genesis_token_id: 8568,
    wearable_ids: [340, 301],
  },
  {
    genesis_token_id: 8569,
    wearable_ids: [395, 387],
  },
  {
    genesis_token_id: 8570,
    wearable_ids: [368, 375],
  },
  {
    genesis_token_id: 8571,
    wearable_ids: [375, 248],
  },
  {
    genesis_token_id: 8572,
    wearable_ids: [397, 385],
  },
  {
    genesis_token_id: 8573,
    wearable_ids: [254, 277],
  },
  {
    genesis_token_id: 8574,
    wearable_ids: [257, 426],
  },
  {
    genesis_token_id: 8575,
    wearable_ids: [280, 384],
  },
  {
    genesis_token_id: 8576,
    wearable_ids: [258, 325],
  },
  {
    genesis_token_id: 8577,
    wearable_ids: [262, 405],
  },
  {
    genesis_token_id: 8578,
    wearable_ids: [306, 311],
  },
  {
    genesis_token_id: 8579,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 8580,
    wearable_ids: [386, 399],
  },
  {
    genesis_token_id: 8581,
    wearable_ids: [346, 326],
  },
  {
    genesis_token_id: 8582,
    wearable_ids: [437, 355],
  },
  {
    genesis_token_id: 8583,
    wearable_ids: [331, 319],
  },
  {
    genesis_token_id: 8584,
    wearable_ids: [273, 340],
  },
  {
    genesis_token_id: 8585,
    wearable_ids: [354, 334],
  },
  {
    genesis_token_id: 8586,
    wearable_ids: [443, 418],
  },
  {
    genesis_token_id: 8587,
    wearable_ids: [408, 346],
  },
  {
    genesis_token_id: 8588,
    wearable_ids: [443, 336],
  },
  {
    genesis_token_id: 8589,
    wearable_ids: [397, 361],
  },
  {
    genesis_token_id: 8590,
    wearable_ids: [300, 441],
  },
  {
    genesis_token_id: 8591,
    wearable_ids: [289, 338],
  },
  {
    genesis_token_id: 8592,
    wearable_ids: [278, 407],
  },
  {
    genesis_token_id: 8593,
    wearable_ids: [344, 335],
  },
  {
    genesis_token_id: 8594,
    wearable_ids: [396, 340],
  },
  {
    genesis_token_id: 8595,
    wearable_ids: [259, 429],
  },
  {
    genesis_token_id: 8596,
    wearable_ids: [255, 437],
  },
  {
    genesis_token_id: 8597,
    wearable_ids: [271, 339],
  },
  {
    genesis_token_id: 8598,
    wearable_ids: [411, 278],
  },
  {
    genesis_token_id: 8599,
    wearable_ids: [426, 337],
  },
  {
    genesis_token_id: 8600,
    wearable_ids: [370, 272],
  },
  {
    genesis_token_id: 8601,
    wearable_ids: [272, 406],
  },
  {
    genesis_token_id: 8602,
    wearable_ids: [310, 440],
  },
  {
    genesis_token_id: 8603,
    wearable_ids: [411, 268],
  },
  {
    genesis_token_id: 8604,
    wearable_ids: [396, 258],
  },
  {
    genesis_token_id: 8605,
    wearable_ids: [254, 385],
  },
  {
    genesis_token_id: 8606,
    wearable_ids: [315, 331],
  },
  {
    genesis_token_id: 8607,
    wearable_ids: [286, 270],
  },
  {
    genesis_token_id: 8608,
    wearable_ids: [294, 420],
  },
  {
    genesis_token_id: 8609,
    wearable_ids: [295, 373],
  },
  {
    genesis_token_id: 8610,
    wearable_ids: [295, 428],
  },
  {
    genesis_token_id: 8611,
    wearable_ids: [248, 324],
  },
  {
    genesis_token_id: 8612,
    wearable_ids: [262, 425],
  },
  {
    genesis_token_id: 8613,
    wearable_ids: [363, 354],
  },
  {
    genesis_token_id: 8614,
    wearable_ids: [349, 378],
  },
  {
    genesis_token_id: 8615,
    wearable_ids: [370, 395],
  },
  {
    genesis_token_id: 8616,
    wearable_ids: [286, 369],
  },
  {
    genesis_token_id: 8617,
    wearable_ids: [331, 400],
  },
  {
    genesis_token_id: 8618,
    wearable_ids: [410, 365],
  },
  {
    genesis_token_id: 8619,
    wearable_ids: [303, 302],
  },
  {
    genesis_token_id: 8620,
    wearable_ids: [291, 314],
  },
  {
    genesis_token_id: 8621,
    wearable_ids: [325, 344],
  },
  {
    genesis_token_id: 8622,
    wearable_ids: [317, 369],
  },
  {
    genesis_token_id: 8623,
    wearable_ids: [387, 365],
  },
  {
    genesis_token_id: 8624,
    wearable_ids: [294, 295],
  },
  {
    genesis_token_id: 8625,
    wearable_ids: [384, 292],
  },
  {
    genesis_token_id: 8626,
    wearable_ids: [413, 396],
  },
  {
    genesis_token_id: 8627,
    wearable_ids: [253, 369],
  },
  {
    genesis_token_id: 8628,
    wearable_ids: [315, 325],
  },
  {
    genesis_token_id: 8629,
    wearable_ids: [286, 268],
  },
  {
    genesis_token_id: 8630,
    wearable_ids: [340, 434],
  },
  {
    genesis_token_id: 8631,
    wearable_ids: [399, 425],
  },
  {
    genesis_token_id: 8632,
    wearable_ids: [273, 263],
  },
  {
    genesis_token_id: 8633,
    wearable_ids: [382, 265],
  },
  {
    genesis_token_id: 8634,
    wearable_ids: [408, 291],
  },
  {
    genesis_token_id: 8635,
    wearable_ids: [389, 289],
  },
  {
    genesis_token_id: 8636,
    wearable_ids: [433, 257],
  },
  {
    genesis_token_id: 8637,
    wearable_ids: [426, 255],
  },
  {
    genesis_token_id: 8638,
    wearable_ids: [265, 278],
  },
  {
    genesis_token_id: 8639,
    wearable_ids: [347, 257],
  },
  {
    genesis_token_id: 8640,
    wearable_ids: [314, 396],
  },
  {
    genesis_token_id: 8641,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 8642,
    wearable_ids: [437, 304],
  },
  {
    genesis_token_id: 8643,
    wearable_ids: [352, 294],
  },
  {
    genesis_token_id: 8644,
    wearable_ids: [364, 412],
  },
  {
    genesis_token_id: 8645,
    wearable_ids: [295, 256],
  },
  {
    genesis_token_id: 8646,
    wearable_ids: [341, 409],
  },
  {
    genesis_token_id: 8647,
    wearable_ids: [362, 310],
  },
  {
    genesis_token_id: 8648,
    wearable_ids: [387, 294],
  },
  {
    genesis_token_id: 8649,
    wearable_ids: [271, 337],
  },
  {
    genesis_token_id: 8650,
    wearable_ids: [248, 361],
  },
  {
    genesis_token_id: 8651,
    wearable_ids: [429, 246],
  },
  {
    genesis_token_id: 8652,
    wearable_ids: [331, 303],
  },
  {
    genesis_token_id: 8653,
    wearable_ids: [262, 311],
  },
  {
    genesis_token_id: 8654,
    wearable_ids: [295, 409],
  },
  {
    genesis_token_id: 8655,
    wearable_ids: [336, 300],
  },
  {
    genesis_token_id: 8656,
    wearable_ids: [436, 270],
  },
  {
    genesis_token_id: 8657,
    wearable_ids: [284, 255],
  },
  {
    genesis_token_id: 8658,
    wearable_ids: [429, 370],
  },
  {
    genesis_token_id: 8659,
    wearable_ids: [311, 415],
  },
  {
    genesis_token_id: 8660,
    wearable_ids: [411, 306],
  },
  {
    genesis_token_id: 8661,
    wearable_ids: [278, 265],
  },
  {
    genesis_token_id: 8662,
    wearable_ids: [403, 444],
  },
  {
    genesis_token_id: 8663,
    wearable_ids: [387, 417],
  },
  {
    genesis_token_id: 8664,
    wearable_ids: [263, 352],
  },
  {
    genesis_token_id: 8665,
    wearable_ids: [425, 402],
  },
  {
    genesis_token_id: 8666,
    wearable_ids: [268, 312],
  },
  {
    genesis_token_id: 8667,
    wearable_ids: [442, 340],
  },
  {
    genesis_token_id: 8668,
    wearable_ids: [347, 355],
  },
  {
    genesis_token_id: 8669,
    wearable_ids: [335, 384],
  },
  {
    genesis_token_id: 8670,
    wearable_ids: [347, 326],
  },
  {
    genesis_token_id: 8671,
    wearable_ids: [311, 326],
  },
  {
    genesis_token_id: 8672,
    wearable_ids: [384, 426],
  },
  {
    genesis_token_id: 8673,
    wearable_ids: [319, 431],
  },
  {
    genesis_token_id: 8674,
    wearable_ids: [296, 270],
  },
  {
    genesis_token_id: 8675,
    wearable_ids: [297, 312],
  },
  {
    genesis_token_id: 8676,
    wearable_ids: [258, 407],
  },
  {
    genesis_token_id: 8677,
    wearable_ids: [340, 373],
  },
  {
    genesis_token_id: 8678,
    wearable_ids: [259, 368],
  },
  {
    genesis_token_id: 8679,
    wearable_ids: [365, 301],
  },
  {
    genesis_token_id: 8680,
    wearable_ids: [344, 324],
  },
  {
    genesis_token_id: 8681,
    wearable_ids: [311, 436],
  },
  {
    genesis_token_id: 8682,
    wearable_ids: [256, 314],
  },
  {
    genesis_token_id: 8683,
    wearable_ids: [406, 410],
  },
  {
    genesis_token_id: 8684,
    wearable_ids: [443, 256],
  },
  {
    genesis_token_id: 8685,
    wearable_ids: [287, 403],
  },
  {
    genesis_token_id: 8686,
    wearable_ids: [442, 332],
  },
  {
    genesis_token_id: 8687,
    wearable_ids: [435, 251],
  },
  {
    genesis_token_id: 8688,
    wearable_ids: [339, 410],
  },
  {
    genesis_token_id: 8689,
    wearable_ids: [411, 437],
  },
  {
    genesis_token_id: 8690,
    wearable_ids: [442, 372],
  },
  {
    genesis_token_id: 8691,
    wearable_ids: [316, 290],
  },
  {
    genesis_token_id: 8692,
    wearable_ids: [256, 334],
  },
  {
    genesis_token_id: 8693,
    wearable_ids: [378, 375],
  },
  {
    genesis_token_id: 8694,
    wearable_ids: [331, 431],
  },
  {
    genesis_token_id: 8695,
    wearable_ids: [403, 283],
  },
  {
    genesis_token_id: 8696,
    wearable_ids: [374, 266],
  },
  {
    genesis_token_id: 8697,
    wearable_ids: [386, 335],
  },
  {
    genesis_token_id: 8698,
    wearable_ids: [303, 270],
  },
  {
    genesis_token_id: 8699,
    wearable_ids: [386, 403],
  },
  {
    genesis_token_id: 8700,
    wearable_ids: [304, 373],
  },
  {
    genesis_token_id: 8701,
    wearable_ids: [277, 426],
  },
  {
    genesis_token_id: 8702,
    wearable_ids: [264, 253],
  },
  {
    genesis_token_id: 8703,
    wearable_ids: [336, 318],
  },
  {
    genesis_token_id: 8704,
    wearable_ids: [287, 415],
  },
  {
    genesis_token_id: 8705,
    wearable_ids: [337, 275],
  },
  {
    genesis_token_id: 8706,
    wearable_ids: [289, 348],
  },
  {
    genesis_token_id: 8707,
    wearable_ids: [315, 257],
  },
  {
    genesis_token_id: 8708,
    wearable_ids: [435, 343],
  },
  {
    genesis_token_id: 8709,
    wearable_ids: [268, 408],
  },
  {
    genesis_token_id: 8710,
    wearable_ids: [377, 407],
  },
  {
    genesis_token_id: 8711,
    wearable_ids: [362, 347],
  },
  {
    genesis_token_id: 8712,
    wearable_ids: [373, 426],
  },
  {
    genesis_token_id: 8713,
    wearable_ids: [325, 344],
  },
  {
    genesis_token_id: 8714,
    wearable_ids: [306, 258],
  },
  {
    genesis_token_id: 8715,
    wearable_ids: [336, 376],
  },
  {
    genesis_token_id: 8716,
    wearable_ids: [445, 409],
  },
  {
    genesis_token_id: 8717,
    wearable_ids: [296, 436],
  },
  {
    genesis_token_id: 8718,
    wearable_ids: [300, 403],
  },
  {
    genesis_token_id: 8719,
    wearable_ids: [378, 262],
  },
  {
    genesis_token_id: 8720,
    wearable_ids: [301, 353],
  },
  {
    genesis_token_id: 8721,
    wearable_ids: [363, 292],
  },
  {
    genesis_token_id: 8722,
    wearable_ids: [339, 307],
  },
  {
    genesis_token_id: 8723,
    wearable_ids: [314, 352],
  },
  {
    genesis_token_id: 8724,
    wearable_ids: [251, 326],
  },
  {
    genesis_token_id: 8725,
    wearable_ids: [423, 314],
  },
  {
    genesis_token_id: 8726,
    wearable_ids: [259, 301],
  },
  {
    genesis_token_id: 8727,
    wearable_ids: [373, 436],
  },
  {
    genesis_token_id: 8728,
    wearable_ids: [444, 410],
  },
  {
    genesis_token_id: 8729,
    wearable_ids: [299, 352],
  },
  {
    genesis_token_id: 8730,
    wearable_ids: [311, 386],
  },
  {
    genesis_token_id: 8731,
    wearable_ids: [314, 316],
  },
  {
    genesis_token_id: 8732,
    wearable_ids: [311, 272],
  },
  {
    genesis_token_id: 8733,
    wearable_ids: [311, 332],
  },
  {
    genesis_token_id: 8734,
    wearable_ids: [294, 438],
  },
  {
    genesis_token_id: 8735,
    wearable_ids: [291, 422],
  },
  {
    genesis_token_id: 8736,
    wearable_ids: [286, 389],
  },
  {
    genesis_token_id: 8737,
    wearable_ids: [301, 415],
  },
  {
    genesis_token_id: 8738,
    wearable_ids: [319, 399],
  },
  {
    genesis_token_id: 8739,
    wearable_ids: [331, 354],
  },
  {
    genesis_token_id: 8740,
    wearable_ids: [337, 324],
  },
  {
    genesis_token_id: 8741,
    wearable_ids: [297, 435],
  },
  {
    genesis_token_id: 8742,
    wearable_ids: [294, 280],
  },
  {
    genesis_token_id: 8743,
    wearable_ids: [336, 370],
  },
  {
    genesis_token_id: 8744,
    wearable_ids: [396, 341],
  },
  {
    genesis_token_id: 8745,
    wearable_ids: [385, 386],
  },
  {
    genesis_token_id: 8746,
    wearable_ids: [375, 424],
  },
  {
    genesis_token_id: 8747,
    wearable_ids: [311, 294],
  },
  {
    genesis_token_id: 8748,
    wearable_ids: [332, 372],
  },
  {
    genesis_token_id: 8749,
    wearable_ids: [256, 373],
  },
  {
    genesis_token_id: 8750,
    wearable_ids: [370, 432],
  },
  {
    genesis_token_id: 8751,
    wearable_ids: [355, 294],
  },
  {
    genesis_token_id: 8752,
    wearable_ids: [378, 374],
  },
  {
    genesis_token_id: 8753,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 8754,
    wearable_ids: [273, 277],
  },
  {
    genesis_token_id: 8755,
    wearable_ids: [437, 259],
  },
  {
    genesis_token_id: 8756,
    wearable_ids: [268, 407],
  },
  {
    genesis_token_id: 8757,
    wearable_ids: [343, 441],
  },
  {
    genesis_token_id: 8758,
    wearable_ids: [262, 433],
  },
  {
    genesis_token_id: 8759,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 8760,
    wearable_ids: [301, 314],
  },
  {
    genesis_token_id: 8761,
    wearable_ids: [315, 385],
  },
  {
    genesis_token_id: 8762,
    wearable_ids: [445, 325],
  },
  {
    genesis_token_id: 8763,
    wearable_ids: [280, 410],
  },
  {
    genesis_token_id: 8764,
    wearable_ids: [385, 358],
  },
  {
    genesis_token_id: 8765,
    wearable_ids: [410, 373],
  },
  {
    genesis_token_id: 8766,
    wearable_ids: [435, 416],
  },
  {
    genesis_token_id: 8767,
    wearable_ids: [338, 287],
  },
  {
    genesis_token_id: 8768,
    wearable_ids: [425, 270],
  },
  {
    genesis_token_id: 8769,
    wearable_ids: [445, 425],
  },
  {
    genesis_token_id: 8770,
    wearable_ids: [337, 398],
  },
  {
    genesis_token_id: 8771,
    wearable_ids: [296, 336],
  },
  {
    genesis_token_id: 8772,
    wearable_ids: [431, 382],
  },
  {
    genesis_token_id: 8773,
    wearable_ids: [422, 290],
  },
  {
    genesis_token_id: 8774,
    wearable_ids: [248, 257],
  },
  {
    genesis_token_id: 8775,
    wearable_ids: [370, 259],
  },
  {
    genesis_token_id: 8776,
    wearable_ids: [332, 406],
  },
  {
    genesis_token_id: 8777,
    wearable_ids: [404, 332],
  },
  {
    genesis_token_id: 8778,
    wearable_ids: [331, 386],
  },
  {
    genesis_token_id: 8779,
    wearable_ids: [424, 264],
  },
  {
    genesis_token_id: 8780,
    wearable_ids: [274, 320],
  },
  {
    genesis_token_id: 8781,
    wearable_ids: [339, 284],
  },
  {
    genesis_token_id: 8782,
    wearable_ids: [324, 346],
  },
  {
    genesis_token_id: 8783,
    wearable_ids: [378, 257],
  },
  {
    genesis_token_id: 8784,
    wearable_ids: [266, 336],
  },
  {
    genesis_token_id: 8785,
    wearable_ids: [368, 281],
  },
  {
    genesis_token_id: 8786,
    wearable_ids: [315, 317],
  },
  {
    genesis_token_id: 8787,
    wearable_ids: [331, 301],
  },
  {
    genesis_token_id: 8788,
    wearable_ids: [338, 365],
  },
  {
    genesis_token_id: 8789,
    wearable_ids: [291, 272],
  },
  {
    genesis_token_id: 8790,
    wearable_ids: [314, 289],
  },
  {
    genesis_token_id: 8791,
    wearable_ids: [301, 342],
  },
  {
    genesis_token_id: 8792,
    wearable_ids: [374, 395],
  },
  {
    genesis_token_id: 8793,
    wearable_ids: [407, 370],
  },
  {
    genesis_token_id: 8794,
    wearable_ids: [319, 443],
  },
  {
    genesis_token_id: 8795,
    wearable_ids: [300, 435],
  },
  {
    genesis_token_id: 8796,
    wearable_ids: [409, 273],
  },
  {
    genesis_token_id: 8797,
    wearable_ids: [408, 304],
  },
  {
    genesis_token_id: 8798,
    wearable_ids: [371, 365],
  },
  {
    genesis_token_id: 8799,
    wearable_ids: [315, 383],
  },
  {
    genesis_token_id: 8800,
    wearable_ids: [262, 444],
  },
  {
    genesis_token_id: 8801,
    wearable_ids: [314, 254],
  },
  {
    genesis_token_id: 8802,
    wearable_ids: [365, 255],
  },
  {
    genesis_token_id: 8803,
    wearable_ids: [347, 256],
  },
  {
    genesis_token_id: 8804,
    wearable_ids: [284, 270],
  },
  {
    genesis_token_id: 8805,
    wearable_ids: [422, 256],
  },
  {
    genesis_token_id: 8806,
    wearable_ids: [378, 324],
  },
  {
    genesis_token_id: 8807,
    wearable_ids: [378, 297],
  },
  {
    genesis_token_id: 8808,
    wearable_ids: [397, 378],
  },
  {
    genesis_token_id: 8809,
    wearable_ids: [389, 435],
  },
  {
    genesis_token_id: 8810,
    wearable_ids: [296, 310],
  },
  {
    genesis_token_id: 8811,
    wearable_ids: [264, 369],
  },
  {
    genesis_token_id: 8812,
    wearable_ids: [445, 265],
  },
  {
    genesis_token_id: 8813,
    wearable_ids: [342, 348],
  },
  {
    genesis_token_id: 8814,
    wearable_ids: [355, 417],
  },
  {
    genesis_token_id: 8815,
    wearable_ids: [259, 424],
  },
  {
    genesis_token_id: 8816,
    wearable_ids: [296, 445],
  },
  {
    genesis_token_id: 8817,
    wearable_ids: [435, 264],
  },
  {
    genesis_token_id: 8818,
    wearable_ids: [409, 347],
  },
  {
    genesis_token_id: 8819,
    wearable_ids: [442, 349],
  },
  {
    genesis_token_id: 8820,
    wearable_ids: [299, 273],
  },
  {
    genesis_token_id: 8821,
    wearable_ids: [424, 263],
  },
  {
    genesis_token_id: 8822,
    wearable_ids: [319, 382],
  },
  {
    genesis_token_id: 8823,
    wearable_ids: [277, 271],
  },
  {
    genesis_token_id: 8824,
    wearable_ids: [341, 436],
  },
  {
    genesis_token_id: 8825,
    wearable_ids: [280, 385],
  },
  {
    genesis_token_id: 8826,
    wearable_ids: [363, 263],
  },
  {
    genesis_token_id: 8827,
    wearable_ids: [299, 411],
  },
  {
    genesis_token_id: 8828,
    wearable_ids: [371, 306],
  },
  {
    genesis_token_id: 8829,
    wearable_ids: [370, 432],
  },
  {
    genesis_token_id: 8830,
    wearable_ids: [350, 366],
  },
  {
    genesis_token_id: 8831,
    wearable_ids: [346, 250],
  },
  {
    genesis_token_id: 8832,
    wearable_ids: [349, 311],
  },
  {
    genesis_token_id: 8833,
    wearable_ids: [397, 306],
  },
  {
    genesis_token_id: 8834,
    wearable_ids: [303, 351],
  },
  {
    genesis_token_id: 8835,
    wearable_ids: [377, 259],
  },
  {
    genesis_token_id: 8836,
    wearable_ids: [326, 401],
  },
  {
    genesis_token_id: 8837,
    wearable_ids: [266, 255],
  },
  {
    genesis_token_id: 8838,
    wearable_ids: [424, 276],
  },
  {
    genesis_token_id: 8839,
    wearable_ids: [378, 343],
  },
  {
    genesis_token_id: 8840,
    wearable_ids: [400, 247],
  },
  {
    genesis_token_id: 8841,
    wearable_ids: [336, 350],
  },
  {
    genesis_token_id: 8842,
    wearable_ids: [400, 286],
  },
  {
    genesis_token_id: 8843,
    wearable_ids: [287, 372],
  },
  {
    genesis_token_id: 8844,
    wearable_ids: [338, 289],
  },
  {
    genesis_token_id: 8845,
    wearable_ids: [383, 340],
  },
  {
    genesis_token_id: 8846,
    wearable_ids: [435, 306],
  },
  {
    genesis_token_id: 8847,
    wearable_ids: [408, 271],
  },
  {
    genesis_token_id: 8848,
    wearable_ids: [371, 273],
  },
  {
    genesis_token_id: 8849,
    wearable_ids: [253, 297],
  },
  {
    genesis_token_id: 8850,
    wearable_ids: [445, 387],
  },
  {
    genesis_token_id: 8851,
    wearable_ids: [373, 410],
  },
  {
    genesis_token_id: 8852,
    wearable_ids: [372, 389],
  },
  {
    genesis_token_id: 8853,
    wearable_ids: [314, 271],
  },
  {
    genesis_token_id: 8854,
    wearable_ids: [372, 355],
  },
  {
    genesis_token_id: 8855,
    wearable_ids: [308, 311],
  },
  {
    genesis_token_id: 8856,
    wearable_ids: [372, 276],
  },
  {
    genesis_token_id: 8857,
    wearable_ids: [266, 291],
  },
  {
    genesis_token_id: 8858,
    wearable_ids: [387, 326],
  },
  {
    genesis_token_id: 8859,
    wearable_ids: [442, 432],
  },
  {
    genesis_token_id: 8860,
    wearable_ids: [347, 301],
  },
  {
    genesis_token_id: 8861,
    wearable_ids: [341, 267],
  },
  {
    genesis_token_id: 8862,
    wearable_ids: [297, 405],
  },
  {
    genesis_token_id: 8863,
    wearable_ids: [273, 263],
  },
  {
    genesis_token_id: 8864,
    wearable_ids: [374, 444],
  },
  {
    genesis_token_id: 8865,
    wearable_ids: [344, 383],
  },
  {
    genesis_token_id: 8866,
    wearable_ids: [256, 355],
  },
  {
    genesis_token_id: 8867,
    wearable_ids: [276, 280],
  },
  {
    genesis_token_id: 8868,
    wearable_ids: [403, 255],
  },
  {
    genesis_token_id: 8869,
    wearable_ids: [355, 289],
  },
  {
    genesis_token_id: 8870,
    wearable_ids: [311, 314],
  },
  {
    genesis_token_id: 8871,
    wearable_ids: [431, 372],
  },
  {
    genesis_token_id: 8872,
    wearable_ids: [383, 363],
  },
  {
    genesis_token_id: 8873,
    wearable_ids: [431, 425],
  },
  {
    genesis_token_id: 8874,
    wearable_ids: [395, 387],
  },
  {
    genesis_token_id: 8875,
    wearable_ids: [352, 324],
  },
  {
    genesis_token_id: 8876,
    wearable_ids: [264, 351],
  },
  {
    genesis_token_id: 8877,
    wearable_ids: [257, 255],
  },
  {
    genesis_token_id: 8878,
    wearable_ids: [278, 410],
  },
  {
    genesis_token_id: 8879,
    wearable_ids: [425, 251],
  },
  {
    genesis_token_id: 8880,
    wearable_ids: [257, 347],
  },
  {
    genesis_token_id: 8881,
    wearable_ids: [420, 444],
  },
  {
    genesis_token_id: 8882,
    wearable_ids: [258, 398],
  },
  {
    genesis_token_id: 8883,
    wearable_ids: [291, 316],
  },
  {
    genesis_token_id: 8884,
    wearable_ids: [413, 370],
  },
  {
    genesis_token_id: 8885,
    wearable_ids: [278, 332],
  },
  {
    genesis_token_id: 8886,
    wearable_ids: [406, 355],
  },
  {
    genesis_token_id: 8887,
    wearable_ids: [415, 291],
  },
  {
    genesis_token_id: 8888,
    wearable_ids: [276, 263],
  },
  {
    genesis_token_id: 8889,
    wearable_ids: [332, 250],
  },
  {
    genesis_token_id: 8890,
    wearable_ids: [422, 273],
  },
  {
    genesis_token_id: 8891,
    wearable_ids: [251, 331],
  },
  {
    genesis_token_id: 8892,
    wearable_ids: [272, 303],
  },
  {
    genesis_token_id: 8893,
    wearable_ids: [369, 308],
  },
  {
    genesis_token_id: 8894,
    wearable_ids: [436, 303],
  },
  {
    genesis_token_id: 8895,
    wearable_ids: [336, 435],
  },
  {
    genesis_token_id: 8896,
    wearable_ids: [395, 271],
  },
  {
    genesis_token_id: 8897,
    wearable_ids: [436, 256],
  },
  {
    genesis_token_id: 8898,
    wearable_ids: [443, 377],
  },
  {
    genesis_token_id: 8899,
    wearable_ids: [254, 407],
  },
  {
    genesis_token_id: 8900,
    wearable_ids: [303, 349],
  },
  {
    genesis_token_id: 8901,
    wearable_ids: [268, 369],
  },
  {
    genesis_token_id: 8902,
    wearable_ids: [444, 294],
  },
  {
    genesis_token_id: 8903,
    wearable_ids: [355, 280],
  },
  {
    genesis_token_id: 8904,
    wearable_ids: [385, 341],
  },
  {
    genesis_token_id: 8905,
    wearable_ids: [300, 299],
  },
  {
    genesis_token_id: 8906,
    wearable_ids: [415, 250],
  },
  {
    genesis_token_id: 8907,
    wearable_ids: [262, 429],
  },
  {
    genesis_token_id: 8908,
    wearable_ids: [395, 335],
  },
  {
    genesis_token_id: 8909,
    wearable_ids: [407, 374],
  },
  {
    genesis_token_id: 8910,
    wearable_ids: [351, 362],
  },
  {
    genesis_token_id: 8911,
    wearable_ids: [409, 302],
  },
  {
    genesis_token_id: 8912,
    wearable_ids: [425, 403],
  },
  {
    genesis_token_id: 8913,
    wearable_ids: [289, 306],
  },
  {
    genesis_token_id: 8914,
    wearable_ids: [372, 445],
  },
  {
    genesis_token_id: 8915,
    wearable_ids: [424, 392],
  },
  {
    genesis_token_id: 8916,
    wearable_ids: [336, 337],
  },
  {
    genesis_token_id: 8917,
    wearable_ids: [258, 398],
  },
  {
    genesis_token_id: 8918,
    wearable_ids: [311, 409],
  },
  {
    genesis_token_id: 8919,
    wearable_ids: [384, 319],
  },
  {
    genesis_token_id: 8920,
    wearable_ids: [278, 339],
  },
  {
    genesis_token_id: 8921,
    wearable_ids: [253, 327],
  },
  {
    genesis_token_id: 8922,
    wearable_ids: [306, 279],
  },
  {
    genesis_token_id: 8923,
    wearable_ids: [268, 276],
  },
  {
    genesis_token_id: 8924,
    wearable_ids: [435, 352],
  },
  {
    genesis_token_id: 8925,
    wearable_ids: [255, 302],
  },
  {
    genesis_token_id: 8926,
    wearable_ids: [289, 388],
  },
  {
    genesis_token_id: 8927,
    wearable_ids: [374, 395],
  },
  {
    genesis_token_id: 8928,
    wearable_ids: [291, 298],
  },
  {
    genesis_token_id: 8929,
    wearable_ids: [433, 405],
  },
  {
    genesis_token_id: 8930,
    wearable_ids: [365, 400],
  },
  {
    genesis_token_id: 8931,
    wearable_ids: [300, 348],
  },
  {
    genesis_token_id: 8932,
    wearable_ids: [362, 389],
  },
  {
    genesis_token_id: 8933,
    wearable_ids: [407, 259],
  },
  {
    genesis_token_id: 8934,
    wearable_ids: [397, 317],
  },
  {
    genesis_token_id: 8935,
    wearable_ids: [384, 338],
  },
  {
    genesis_token_id: 8936,
    wearable_ids: [254, 327],
  },
  {
    genesis_token_id: 8937,
    wearable_ids: [411, 389],
  },
  {
    genesis_token_id: 8938,
    wearable_ids: [268, 300],
  },
  {
    genesis_token_id: 8939,
    wearable_ids: [255, 314],
  },
  {
    genesis_token_id: 8940,
    wearable_ids: [292, 336],
  },
  {
    genesis_token_id: 8941,
    wearable_ids: [286, 280],
  },
  {
    genesis_token_id: 8942,
    wearable_ids: [413, 385],
  },
  {
    genesis_token_id: 8943,
    wearable_ids: [355, 393],
  },
  {
    genesis_token_id: 8944,
    wearable_ids: [247, 289],
  },
  {
    genesis_token_id: 8945,
    wearable_ids: [278, 258],
  },
  {
    genesis_token_id: 8946,
    wearable_ids: [284, 338],
  },
  {
    genesis_token_id: 8947,
    wearable_ids: [389, 373],
  },
  {
    genesis_token_id: 8948,
    wearable_ids: [397, 386],
  },
  {
    genesis_token_id: 8949,
    wearable_ids: [301, 378],
  },
  {
    genesis_token_id: 8950,
    wearable_ids: [286, 428],
  },
  {
    genesis_token_id: 8951,
    wearable_ids: [363, 289],
  },
  {
    genesis_token_id: 8952,
    wearable_ids: [432, 396],
  },
  {
    genesis_token_id: 8953,
    wearable_ids: [326, 247],
  },
  {
    genesis_token_id: 8954,
    wearable_ids: [373, 438],
  },
  {
    genesis_token_id: 8955,
    wearable_ids: [273, 251],
  },
  {
    genesis_token_id: 8956,
    wearable_ids: [290, 341],
  },
  {
    genesis_token_id: 8957,
    wearable_ids: [310, 433],
  },
  {
    genesis_token_id: 8958,
    wearable_ids: [384, 264],
  },
  {
    genesis_token_id: 8959,
    wearable_ids: [296, 368],
  },
  {
    genesis_token_id: 8960,
    wearable_ids: [413, 340],
  },
  {
    genesis_token_id: 8961,
    wearable_ids: [428, 341],
  },
  {
    genesis_token_id: 8962,
    wearable_ids: [300, 432],
  },
  {
    genesis_token_id: 8963,
    wearable_ids: [256, 337],
  },
  {
    genesis_token_id: 8964,
    wearable_ids: [324, 361],
  },
  {
    genesis_token_id: 8965,
    wearable_ids: [324, 331],
  },
  {
    genesis_token_id: 8966,
    wearable_ids: [363, 424],
  },
  {
    genesis_token_id: 8967,
    wearable_ids: [315, 258],
  },
  {
    genesis_token_id: 8968,
    wearable_ids: [277, 247],
  },
  {
    genesis_token_id: 8969,
    wearable_ids: [314, 433],
  },
  {
    genesis_token_id: 8970,
    wearable_ids: [426, 399],
  },
  {
    genesis_token_id: 8971,
    wearable_ids: [437, 269],
  },
  {
    genesis_token_id: 8972,
    wearable_ids: [266, 403],
  },
  {
    genesis_token_id: 8973,
    wearable_ids: [268, 371],
  },
  {
    genesis_token_id: 8974,
    wearable_ids: [310, 272],
  },
  {
    genesis_token_id: 8975,
    wearable_ids: [253, 416],
  },
  {
    genesis_token_id: 8976,
    wearable_ids: [376, 400],
  },
  {
    genesis_token_id: 8977,
    wearable_ids: [335, 313],
  },
  {
    genesis_token_id: 8978,
    wearable_ids: [400, 262],
  },
  {
    genesis_token_id: 8979,
    wearable_ids: [265, 368],
  },
  {
    genesis_token_id: 8980,
    wearable_ids: [411, 270],
  },
  {
    genesis_token_id: 8981,
    wearable_ids: [335, 417],
  },
  {
    genesis_token_id: 8982,
    wearable_ids: [382, 295],
  },
  {
    genesis_token_id: 8983,
    wearable_ids: [340, 337],
  },
  {
    genesis_token_id: 8984,
    wearable_ids: [336, 415],
  },
  {
    genesis_token_id: 8985,
    wearable_ids: [444, 295],
  },
  {
    genesis_token_id: 8986,
    wearable_ids: [255, 310],
  },
  {
    genesis_token_id: 8987,
    wearable_ids: [324, 277],
  },
  {
    genesis_token_id: 8988,
    wearable_ids: [378, 407],
  },
  {
    genesis_token_id: 8989,
    wearable_ids: [375, 259],
  },
  {
    genesis_token_id: 8990,
    wearable_ids: [258, 396],
  },
  {
    genesis_token_id: 8991,
    wearable_ids: [429, 246],
  },
  {
    genesis_token_id: 8992,
    wearable_ids: [294, 316],
  },
  {
    genesis_token_id: 8993,
    wearable_ids: [343, 382],
  },
  {
    genesis_token_id: 8994,
    wearable_ids: [255, 430],
  },
  {
    genesis_token_id: 8995,
    wearable_ids: [273, 325],
  },
  {
    genesis_token_id: 8996,
    wearable_ids: [350, 372],
  },
  {
    genesis_token_id: 8997,
    wearable_ids: [352, 293],
  },
  {
    genesis_token_id: 8998,
    wearable_ids: [375, 292],
  },
  {
    genesis_token_id: 8999,
    wearable_ids: [347, 257],
  },
  {
    genesis_token_id: 9000,
    wearable_ids: [290, 395],
  },
  {
    genesis_token_id: 9001,
    wearable_ids: [259, 354],
  },
  {
    genesis_token_id: 9002,
    wearable_ids: [272, 326],
  },
  {
    genesis_token_id: 9003,
    wearable_ids: [365, 269],
  },
  {
    genesis_token_id: 9004,
    wearable_ids: [376, 419],
  },
  {
    genesis_token_id: 9005,
    wearable_ids: [369, 293],
  },
  {
    genesis_token_id: 9006,
    wearable_ids: [382, 432],
  },
  {
    genesis_token_id: 9007,
    wearable_ids: [444, 268],
  },
  {
    genesis_token_id: 9008,
    wearable_ids: [336, 445],
  },
  {
    genesis_token_id: 9009,
    wearable_ids: [287, 266],
  },
  {
    genesis_token_id: 9010,
    wearable_ids: [335, 271],
  },
  {
    genesis_token_id: 9011,
    wearable_ids: [375, 291],
  },
  {
    genesis_token_id: 9012,
    wearable_ids: [256, 271],
  },
  {
    genesis_token_id: 9013,
    wearable_ids: [339, 423],
  },
  {
    genesis_token_id: 9014,
    wearable_ids: [299, 351],
  },
  {
    genesis_token_id: 9015,
    wearable_ids: [344, 416],
  },
  {
    genesis_token_id: 9016,
    wearable_ids: [375, 277],
  },
  {
    genesis_token_id: 9017,
    wearable_ids: [385, 359],
  },
  {
    genesis_token_id: 9018,
    wearable_ids: [306, 324],
  },
  {
    genesis_token_id: 9019,
    wearable_ids: [422, 413],
  },
  {
    genesis_token_id: 9020,
    wearable_ids: [251, 265],
  },
  {
    genesis_token_id: 9021,
    wearable_ids: [385, 370],
  },
  {
    genesis_token_id: 9022,
    wearable_ids: [425, 279],
  },
  {
    genesis_token_id: 9023,
    wearable_ids: [331, 306],
  },
  {
    genesis_token_id: 9024,
    wearable_ids: [437, 352],
  },
  {
    genesis_token_id: 9025,
    wearable_ids: [253, 425],
  },
  {
    genesis_token_id: 9026,
    wearable_ids: [378, 284],
  },
  {
    genesis_token_id: 9027,
    wearable_ids: [413, 410],
  },
  {
    genesis_token_id: 9028,
    wearable_ids: [443, 375],
  },
  {
    genesis_token_id: 9029,
    wearable_ids: [347, 400],
  },
  {
    genesis_token_id: 9030,
    wearable_ids: [386, 287],
  },
  {
    genesis_token_id: 9031,
    wearable_ids: [400, 352],
  },
  {
    genesis_token_id: 9032,
    wearable_ids: [295, 378],
  },
  {
    genesis_token_id: 9033,
    wearable_ids: [383, 371],
  },
  {
    genesis_token_id: 9034,
    wearable_ids: [271, 410],
  },
  {
    genesis_token_id: 9035,
    wearable_ids: [268, 348],
  },
  {
    genesis_token_id: 9036,
    wearable_ids: [317, 307],
  },
  {
    genesis_token_id: 9037,
    wearable_ids: [362, 382],
  },
  {
    genesis_token_id: 9038,
    wearable_ids: [413, 315],
  },
  {
    genesis_token_id: 9039,
    wearable_ids: [258, 322],
  },
  {
    genesis_token_id: 9040,
    wearable_ids: [274, 437],
  },
  {
    genesis_token_id: 9041,
    wearable_ids: [407, 378],
  },
  {
    genesis_token_id: 9042,
    wearable_ids: [337, 346],
  },
  {
    genesis_token_id: 9043,
    wearable_ids: [316, 378],
  },
  {
    genesis_token_id: 9044,
    wearable_ids: [268, 317],
  },
  {
    genesis_token_id: 9045,
    wearable_ids: [316, 371],
  },
  {
    genesis_token_id: 9046,
    wearable_ids: [349, 262],
  },
  {
    genesis_token_id: 9047,
    wearable_ids: [437, 440],
  },
  {
    genesis_token_id: 9048,
    wearable_ids: [387, 261],
  },
  {
    genesis_token_id: 9049,
    wearable_ids: [410, 248],
  },
  {
    genesis_token_id: 9050,
    wearable_ids: [428, 386],
  },
  {
    genesis_token_id: 9051,
    wearable_ids: [304, 354],
  },
  {
    genesis_token_id: 9052,
    wearable_ids: [445, 412],
  },
  {
    genesis_token_id: 9053,
    wearable_ids: [338, 322],
  },
  {
    genesis_token_id: 9054,
    wearable_ids: [443, 387],
  },
  {
    genesis_token_id: 9055,
    wearable_ids: [335, 287],
  },
  {
    genesis_token_id: 9056,
    wearable_ids: [403, 350],
  },
  {
    genesis_token_id: 9057,
    wearable_ids: [262, 383],
  },
  {
    genesis_token_id: 9058,
    wearable_ids: [413, 301],
  },
  {
    genesis_token_id: 9059,
    wearable_ids: [253, 352],
  },
  {
    genesis_token_id: 9060,
    wearable_ids: [445, 425],
  },
  {
    genesis_token_id: 9061,
    wearable_ids: [389, 382],
  },
  {
    genesis_token_id: 9062,
    wearable_ids: [277, 386],
  },
  {
    genesis_token_id: 9063,
    wearable_ids: [311, 333],
  },
  {
    genesis_token_id: 9064,
    wearable_ids: [253, 370],
  },
  {
    genesis_token_id: 9065,
    wearable_ids: [424, 315],
  },
  {
    genesis_token_id: 9066,
    wearable_ids: [442, 251],
  },
  {
    genesis_token_id: 9067,
    wearable_ids: [442, 369],
  },
  {
    genesis_token_id: 9068,
    wearable_ids: [310, 415],
  },
  {
    genesis_token_id: 9069,
    wearable_ids: [442, 346],
  },
  {
    genesis_token_id: 9070,
    wearable_ids: [442, 436],
  },
  {
    genesis_token_id: 9071,
    wearable_ids: [276, 375],
  },
  {
    genesis_token_id: 9072,
    wearable_ids: [404, 297],
  },
  {
    genesis_token_id: 9073,
    wearable_ids: [410, 370],
  },
  {
    genesis_token_id: 9074,
    wearable_ids: [422, 266],
  },
  {
    genesis_token_id: 9075,
    wearable_ids: [443, 298],
  },
  {
    genesis_token_id: 9076,
    wearable_ids: [266, 287],
  },
  {
    genesis_token_id: 9077,
    wearable_ids: [335, 274],
  },
  {
    genesis_token_id: 9078,
    wearable_ids: [384, 387],
  },
  {
    genesis_token_id: 9079,
    wearable_ids: [406, 351],
  },
  {
    genesis_token_id: 9080,
    wearable_ids: [436, 251],
  },
  {
    genesis_token_id: 9081,
    wearable_ids: [349, 363],
  },
  {
    genesis_token_id: 9082,
    wearable_ids: [254, 340],
  },
  {
    genesis_token_id: 9083,
    wearable_ids: [354, 415],
  },
  {
    genesis_token_id: 9084,
    wearable_ids: [264, 289],
  },
  {
    genesis_token_id: 9085,
    wearable_ids: [299, 290],
  },
  {
    genesis_token_id: 9086,
    wearable_ids: [376, 378],
  },
  {
    genesis_token_id: 9087,
    wearable_ids: [263, 400],
  },
  {
    genesis_token_id: 9088,
    wearable_ids: [397, 415],
  },
  {
    genesis_token_id: 9089,
    wearable_ids: [338, 424],
  },
  {
    genesis_token_id: 9090,
    wearable_ids: [389, 267],
  },
  {
    genesis_token_id: 9091,
    wearable_ids: [431, 279],
  },
  {
    genesis_token_id: 9092,
    wearable_ids: [335, 384],
  },
  {
    genesis_token_id: 9093,
    wearable_ids: [372, 310],
  },
  {
    genesis_token_id: 9094,
    wearable_ids: [426, 422],
  },
  {
    genesis_token_id: 9095,
    wearable_ids: [325, 371],
  },
  {
    genesis_token_id: 9096,
    wearable_ids: [415, 389],
  },
  {
    genesis_token_id: 9097,
    wearable_ids: [423, 353],
  },
  {
    genesis_token_id: 9098,
    wearable_ids: [355, 412],
  },
  {
    genesis_token_id: 9099,
    wearable_ids: [385, 340],
  },
  {
    genesis_token_id: 9100,
    wearable_ids: [310, 342],
  },
  {
    genesis_token_id: 9101,
    wearable_ids: [332, 336],
  },
  {
    genesis_token_id: 9102,
    wearable_ids: [254, 428],
  },
  {
    genesis_token_id: 9103,
    wearable_ids: [257, 360],
  },
  {
    genesis_token_id: 9104,
    wearable_ids: [271, 290],
  },
  {
    genesis_token_id: 9105,
    wearable_ids: [335, 413],
  },
  {
    genesis_token_id: 9106,
    wearable_ids: [316, 280],
  },
  {
    genesis_token_id: 9107,
    wearable_ids: [284, 352],
  },
  {
    genesis_token_id: 9108,
    wearable_ids: [436, 379],
  },
  {
    genesis_token_id: 9109,
    wearable_ids: [294, 372],
  },
  {
    genesis_token_id: 9110,
    wearable_ids: [423, 284],
  },
  {
    genesis_token_id: 9111,
    wearable_ids: [258, 398],
  },
  {
    genesis_token_id: 9112,
    wearable_ids: [442, 271],
  },
  {
    genesis_token_id: 9113,
    wearable_ids: [412, 352],
  },
  {
    genesis_token_id: 9114,
    wearable_ids: [437, 279],
  },
  {
    genesis_token_id: 9115,
    wearable_ids: [429, 349],
  },
  {
    genesis_token_id: 9116,
    wearable_ids: [273, 445],
  },
  {
    genesis_token_id: 9117,
    wearable_ids: [351, 297],
  },
  {
    genesis_token_id: 9118,
    wearable_ids: [336, 328],
  },
  {
    genesis_token_id: 9119,
    wearable_ids: [376, 253],
  },
  {
    genesis_token_id: 9120,
    wearable_ids: [273, 324],
  },
  {
    genesis_token_id: 9121,
    wearable_ids: [429, 444],
  },
  {
    genesis_token_id: 9122,
    wearable_ids: [336, 310],
  },
  {
    genesis_token_id: 9123,
    wearable_ids: [297, 337],
  },
  {
    genesis_token_id: 9124,
    wearable_ids: [271, 426],
  },
  {
    genesis_token_id: 9125,
    wearable_ids: [348, 406],
  },
  {
    genesis_token_id: 9126,
    wearable_ids: [385, 402],
  },
  {
    genesis_token_id: 9127,
    wearable_ids: [422, 382],
  },
  {
    genesis_token_id: 9128,
    wearable_ids: [251, 338],
  },
  {
    genesis_token_id: 9129,
    wearable_ids: [445, 384],
  },
  {
    genesis_token_id: 9130,
    wearable_ids: [442, 299],
  },
  {
    genesis_token_id: 9131,
    wearable_ids: [371, 436],
  },
  {
    genesis_token_id: 9132,
    wearable_ids: [263, 350],
  },
  {
    genesis_token_id: 9133,
    wearable_ids: [435, 328],
  },
  {
    genesis_token_id: 9134,
    wearable_ids: [443, 341],
  },
  {
    genesis_token_id: 9135,
    wearable_ids: [434, 408],
  },
  {
    genesis_token_id: 9136,
    wearable_ids: [376, 259],
  },
  {
    genesis_token_id: 9137,
    wearable_ids: [292, 324],
  },
  {
    genesis_token_id: 9138,
    wearable_ids: [341, 377],
  },
  {
    genesis_token_id: 9139,
    wearable_ids: [335, 279],
  },
  {
    genesis_token_id: 9140,
    wearable_ids: [373, 263],
  },
  {
    genesis_token_id: 9141,
    wearable_ids: [433, 424],
  },
  {
    genesis_token_id: 9142,
    wearable_ids: [263, 254],
  },
  {
    genesis_token_id: 9143,
    wearable_ids: [303, 284],
  },
  {
    genesis_token_id: 9144,
    wearable_ids: [301, 374],
  },
  {
    genesis_token_id: 9145,
    wearable_ids: [247, 443],
  },
  {
    genesis_token_id: 9146,
    wearable_ids: [255, 426],
  },
  {
    genesis_token_id: 9147,
    wearable_ids: [300, 432],
  },
  {
    genesis_token_id: 9148,
    wearable_ids: [426, 258],
  },
  {
    genesis_token_id: 9149,
    wearable_ids: [411, 363],
  },
  {
    genesis_token_id: 9150,
    wearable_ids: [335, 368],
  },
  {
    genesis_token_id: 9151,
    wearable_ids: [386, 248],
  },
  {
    genesis_token_id: 9152,
    wearable_ids: [339, 263],
  },
  {
    genesis_token_id: 9153,
    wearable_ids: [317, 399],
  },
  {
    genesis_token_id: 9154,
    wearable_ids: [370, 402],
  },
  {
    genesis_token_id: 9155,
    wearable_ids: [271, 289],
  },
  {
    genesis_token_id: 9156,
    wearable_ids: [372, 278],
  },
  {
    genesis_token_id: 9157,
    wearable_ids: [429, 396],
  },
  {
    genesis_token_id: 9158,
    wearable_ids: [280, 286],
  },
  {
    genesis_token_id: 9159,
    wearable_ids: [373, 397],
  },
  {
    genesis_token_id: 9160,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 9161,
    wearable_ids: [343, 297],
  },
  {
    genesis_token_id: 9162,
    wearable_ids: [372, 330],
  },
  {
    genesis_token_id: 9163,
    wearable_ids: [284, 295],
  },
  {
    genesis_token_id: 9164,
    wearable_ids: [443, 247],
  },
  {
    genesis_token_id: 9165,
    wearable_ids: [346, 297],
  },
  {
    genesis_token_id: 9166,
    wearable_ids: [355, 442],
  },
  {
    genesis_token_id: 9167,
    wearable_ids: [349, 256],
  },
  {
    genesis_token_id: 9168,
    wearable_ids: [425, 354],
  },
  {
    genesis_token_id: 9169,
    wearable_ids: [387, 369],
  },
  {
    genesis_token_id: 9170,
    wearable_ids: [409, 278],
  },
  {
    genesis_token_id: 9171,
    wearable_ids: [372, 266],
  },
  {
    genesis_token_id: 9172,
    wearable_ids: [342, 271],
  },
  {
    genesis_token_id: 9173,
    wearable_ids: [274, 311],
  },
  {
    genesis_token_id: 9174,
    wearable_ids: [304, 253],
  },
  {
    genesis_token_id: 9175,
    wearable_ids: [303, 264],
  },
  {
    genesis_token_id: 9176,
    wearable_ids: [259, 428],
  },
  {
    genesis_token_id: 9177,
    wearable_ids: [354, 263],
  },
  {
    genesis_token_id: 9178,
    wearable_ids: [341, 249],
  },
  {
    genesis_token_id: 9179,
    wearable_ids: [259, 386],
  },
  {
    genesis_token_id: 9180,
    wearable_ids: [308, 438],
  },
  {
    genesis_token_id: 9181,
    wearable_ids: [286, 300],
  },
  {
    genesis_token_id: 9182,
    wearable_ids: [385, 440],
  },
  {
    genesis_token_id: 9183,
    wearable_ids: [423, 432],
  },
  {
    genesis_token_id: 9184,
    wearable_ids: [264, 270],
  },
  {
    genesis_token_id: 9185,
    wearable_ids: [299, 395],
  },
  {
    genesis_token_id: 9186,
    wearable_ids: [431, 343],
  },
  {
    genesis_token_id: 9187,
    wearable_ids: [406, 377],
  },
  {
    genesis_token_id: 9188,
    wearable_ids: [287, 332],
  },
  {
    genesis_token_id: 9189,
    wearable_ids: [389, 413],
  },
  {
    genesis_token_id: 9190,
    wearable_ids: [297, 288],
  },
  {
    genesis_token_id: 9191,
    wearable_ids: [257, 371],
  },
  {
    genesis_token_id: 9192,
    wearable_ids: [411, 424],
  },
  {
    genesis_token_id: 9193,
    wearable_ids: [294, 262],
  },
  {
    genesis_token_id: 9194,
    wearable_ids: [370, 347],
  },
  {
    genesis_token_id: 9195,
    wearable_ids: [408, 349],
  },
  {
    genesis_token_id: 9196,
    wearable_ids: [332, 280],
  },
  {
    genesis_token_id: 9197,
    wearable_ids: [348, 334],
  },
  {
    genesis_token_id: 9198,
    wearable_ids: [326, 311],
  },
  {
    genesis_token_id: 9199,
    wearable_ids: [274, 258],
  },
  {
    genesis_token_id: 9200,
    wearable_ids: [339, 311],
  },
  {
    genesis_token_id: 9201,
    wearable_ids: [423, 254],
  },
  {
    genesis_token_id: 9202,
    wearable_ids: [404, 273],
  },
  {
    genesis_token_id: 9203,
    wearable_ids: [373, 428],
  },
  {
    genesis_token_id: 9204,
    wearable_ids: [315, 257],
  },
  {
    genesis_token_id: 9205,
    wearable_ids: [428, 262],
  },
  {
    genesis_token_id: 9206,
    wearable_ids: [436, 303],
  },
  {
    genesis_token_id: 9207,
    wearable_ids: [343, 336],
  },
  {
    genesis_token_id: 9208,
    wearable_ids: [310, 255],
  },
  {
    genesis_token_id: 9209,
    wearable_ids: [287, 253],
  },
  {
    genesis_token_id: 9210,
    wearable_ids: [431, 276],
  },
  {
    genesis_token_id: 9211,
    wearable_ids: [251, 423],
  },
  {
    genesis_token_id: 9212,
    wearable_ids: [352, 443],
  },
  {
    genesis_token_id: 9213,
    wearable_ids: [420, 316],
  },
  {
    genesis_token_id: 9214,
    wearable_ids: [363, 414],
  },
  {
    genesis_token_id: 9215,
    wearable_ids: [284, 352],
  },
  {
    genesis_token_id: 9216,
    wearable_ids: [399, 387],
  },
  {
    genesis_token_id: 9217,
    wearable_ids: [299, 251],
  },
  {
    genesis_token_id: 9218,
    wearable_ids: [319, 349],
  },
  {
    genesis_token_id: 9219,
    wearable_ids: [264, 443],
  },
  {
    genesis_token_id: 9220,
    wearable_ids: [331, 280],
  },
  {
    genesis_token_id: 9221,
    wearable_ids: [363, 297],
  },
  {
    genesis_token_id: 9222,
    wearable_ids: [378, 445],
  },
  {
    genesis_token_id: 9223,
    wearable_ids: [365, 270],
  },
  {
    genesis_token_id: 9224,
    wearable_ids: [387, 348],
  },
  {
    genesis_token_id: 9225,
    wearable_ids: [277, 256],
  },
  {
    genesis_token_id: 9226,
    wearable_ids: [301, 386],
  },
  {
    genesis_token_id: 9227,
    wearable_ids: [370, 302],
  },
  {
    genesis_token_id: 9228,
    wearable_ids: [429, 405],
  },
  {
    genesis_token_id: 9229,
    wearable_ids: [303, 251],
  },
  {
    genesis_token_id: 9230,
    wearable_ids: [437, 294],
  },
  {
    genesis_token_id: 9231,
    wearable_ids: [273, 264],
  },
  {
    genesis_token_id: 9232,
    wearable_ids: [435, 425],
  },
  {
    genesis_token_id: 9233,
    wearable_ids: [403, 325],
  },
  {
    genesis_token_id: 9234,
    wearable_ids: [258, 273],
  },
  {
    genesis_token_id: 9235,
    wearable_ids: [289, 354],
  },
  {
    genesis_token_id: 9236,
    wearable_ids: [258, 426],
  },
  {
    genesis_token_id: 9237,
    wearable_ids: [268, 352],
  },
  {
    genesis_token_id: 9238,
    wearable_ids: [370, 378],
  },
  {
    genesis_token_id: 9239,
    wearable_ids: [375, 415],
  },
  {
    genesis_token_id: 9240,
    wearable_ids: [428, 273],
  },
  {
    genesis_token_id: 9241,
    wearable_ids: [372, 315],
  },
  {
    genesis_token_id: 9242,
    wearable_ids: [295, 248],
  },
  {
    genesis_token_id: 9243,
    wearable_ids: [445, 415],
  },
  {
    genesis_token_id: 9244,
    wearable_ids: [432, 317],
  },
  {
    genesis_token_id: 9245,
    wearable_ids: [350, 415],
  },
  {
    genesis_token_id: 9246,
    wearable_ids: [337, 332],
  },
  {
    genesis_token_id: 9247,
    wearable_ids: [411, 420],
  },
  {
    genesis_token_id: 9248,
    wearable_ids: [311, 263],
  },
  {
    genesis_token_id: 9249,
    wearable_ids: [403, 410],
  },
  {
    genesis_token_id: 9250,
    wearable_ids: [346, 275],
  },
  {
    genesis_token_id: 9251,
    wearable_ids: [301, 364],
  },
  {
    genesis_token_id: 9252,
    wearable_ids: [396, 366],
  },
  {
    genesis_token_id: 9253,
    wearable_ids: [351, 304],
  },
  {
    genesis_token_id: 9254,
    wearable_ids: [311, 432],
  },
  {
    genesis_token_id: 9255,
    wearable_ids: [443, 347],
  },
  {
    genesis_token_id: 9256,
    wearable_ids: [303, 406],
  },
  {
    genesis_token_id: 9257,
    wearable_ids: [311, 431],
  },
  {
    genesis_token_id: 9258,
    wearable_ids: [280, 265],
  },
  {
    genesis_token_id: 9259,
    wearable_ids: [343, 403],
  },
  {
    genesis_token_id: 9260,
    wearable_ids: [247, 294],
  },
  {
    genesis_token_id: 9261,
    wearable_ids: [274, 420],
  },
  {
    genesis_token_id: 9262,
    wearable_ids: [374, 289],
  },
  {
    genesis_token_id: 9263,
    wearable_ids: [253, 264],
  },
  {
    genesis_token_id: 9264,
    wearable_ids: [396, 346],
  },
  {
    genesis_token_id: 9265,
    wearable_ids: [409, 385],
  },
  {
    genesis_token_id: 9266,
    wearable_ids: [375, 306],
  },
  {
    genesis_token_id: 9267,
    wearable_ids: [399, 290],
  },
  {
    genesis_token_id: 9268,
    wearable_ids: [319, 345],
  },
  {
    genesis_token_id: 9269,
    wearable_ids: [399, 379],
  },
  {
    genesis_token_id: 9270,
    wearable_ids: [257, 289],
  },
  {
    genesis_token_id: 9271,
    wearable_ids: [412, 425],
  },
  {
    genesis_token_id: 9272,
    wearable_ids: [263, 311],
  },
  {
    genesis_token_id: 9273,
    wearable_ids: [264, 341],
  },
  {
    genesis_token_id: 9274,
    wearable_ids: [264, 258],
  },
  {
    genesis_token_id: 9275,
    wearable_ids: [263, 314],
  },
  {
    genesis_token_id: 9276,
    wearable_ids: [268, 314],
  },
  {
    genesis_token_id: 9277,
    wearable_ids: [294, 445],
  },
  {
    genesis_token_id: 9278,
    wearable_ids: [251, 315],
  },
  {
    genesis_token_id: 9279,
    wearable_ids: [310, 389],
  },
  {
    genesis_token_id: 9280,
    wearable_ids: [425, 338],
  },
  {
    genesis_token_id: 9281,
    wearable_ids: [274, 415],
  },
  {
    genesis_token_id: 9282,
    wearable_ids: [354, 386],
  },
  {
    genesis_token_id: 9283,
    wearable_ids: [410, 248],
  },
  {
    genesis_token_id: 9284,
    wearable_ids: [397, 317],
  },
  {
    genesis_token_id: 9285,
    wearable_ids: [378, 387],
  },
  {
    genesis_token_id: 9286,
    wearable_ids: [425, 251],
  },
  {
    genesis_token_id: 9287,
    wearable_ids: [291, 415],
  },
  {
    genesis_token_id: 9288,
    wearable_ids: [386, 284],
  },
  {
    genesis_token_id: 9289,
    wearable_ids: [413, 396],
  },
  {
    genesis_token_id: 9290,
    wearable_ids: [315, 307],
  },
  {
    genesis_token_id: 9291,
    wearable_ids: [385, 355],
  },
  {
    genesis_token_id: 9292,
    wearable_ids: [271, 424],
  },
  {
    genesis_token_id: 9293,
    wearable_ids: [335, 395],
  },
  {
    genesis_token_id: 9294,
    wearable_ids: [410, 317],
  },
  {
    genesis_token_id: 9295,
    wearable_ids: [409, 434],
  },
  {
    genesis_token_id: 9296,
    wearable_ids: [404, 371],
  },
  {
    genesis_token_id: 9297,
    wearable_ids: [254, 365],
  },
  {
    genesis_token_id: 9298,
    wearable_ids: [304, 350],
  },
  {
    genesis_token_id: 9299,
    wearable_ids: [425, 347],
  },
  {
    genesis_token_id: 9300,
    wearable_ids: [308, 396],
  },
  {
    genesis_token_id: 9301,
    wearable_ids: [435, 378],
  },
  {
    genesis_token_id: 9302,
    wearable_ids: [294, 402],
  },
  {
    genesis_token_id: 9303,
    wearable_ids: [403, 247],
  },
  {
    genesis_token_id: 9304,
    wearable_ids: [382, 387],
  },
  {
    genesis_token_id: 9305,
    wearable_ids: [340, 375],
  },
  {
    genesis_token_id: 9306,
    wearable_ids: [371, 304],
  },
  {
    genesis_token_id: 9307,
    wearable_ids: [247, 322],
  },
  {
    genesis_token_id: 9308,
    wearable_ids: [258, 408],
  },
  {
    genesis_token_id: 9309,
    wearable_ids: [290, 406],
  },
  {
    genesis_token_id: 9310,
    wearable_ids: [407, 296],
  },
  {
    genesis_token_id: 9311,
    wearable_ids: [278, 335],
  },
  {
    genesis_token_id: 9312,
    wearable_ids: [272, 364],
  },
  {
    genesis_token_id: 9313,
    wearable_ids: [268, 254],
  },
  {
    genesis_token_id: 9314,
    wearable_ids: [409, 297],
  },
  {
    genesis_token_id: 9315,
    wearable_ids: [433, 270],
  },
  {
    genesis_token_id: 9316,
    wearable_ids: [346, 266],
  },
  {
    genesis_token_id: 9317,
    wearable_ids: [371, 429],
  },
  {
    genesis_token_id: 9318,
    wearable_ids: [376, 317],
  },
  {
    genesis_token_id: 9319,
    wearable_ids: [299, 432],
  },
  {
    genesis_token_id: 9320,
    wearable_ids: [369, 298],
  },
  {
    genesis_token_id: 9321,
    wearable_ids: [247, 398],
  },
  {
    genesis_token_id: 9322,
    wearable_ids: [289, 326],
  },
  {
    genesis_token_id: 9323,
    wearable_ids: [383, 442],
  },
  {
    genesis_token_id: 9324,
    wearable_ids: [272, 406],
  },
  {
    genesis_token_id: 9325,
    wearable_ids: [420, 378],
  },
  {
    genesis_token_id: 9326,
    wearable_ids: [444, 377],
  },
  {
    genesis_token_id: 9327,
    wearable_ids: [326, 331],
  },
  {
    genesis_token_id: 9328,
    wearable_ids: [408, 253],
  },
  {
    genesis_token_id: 9329,
    wearable_ids: [251, 443],
  },
  {
    genesis_token_id: 9330,
    wearable_ids: [349, 344],
  },
  {
    genesis_token_id: 9331,
    wearable_ids: [369, 336],
  },
  {
    genesis_token_id: 9332,
    wearable_ids: [355, 364],
  },
  {
    genesis_token_id: 9333,
    wearable_ids: [257, 386],
  },
  {
    genesis_token_id: 9334,
    wearable_ids: [326, 349],
  },
  {
    genesis_token_id: 9335,
    wearable_ids: [272, 248],
  },
  {
    genesis_token_id: 9336,
    wearable_ids: [254, 292],
  },
  {
    genesis_token_id: 9337,
    wearable_ids: [362, 422],
  },
  {
    genesis_token_id: 9338,
    wearable_ids: [442, 265],
  },
  {
    genesis_token_id: 9339,
    wearable_ids: [409, 317],
  },
  {
    genesis_token_id: 9340,
    wearable_ids: [262, 363],
  },
  {
    genesis_token_id: 9341,
    wearable_ids: [287, 355],
  },
  {
    genesis_token_id: 9342,
    wearable_ids: [409, 445],
  },
  {
    genesis_token_id: 9343,
    wearable_ids: [437, 419],
  },
  {
    genesis_token_id: 9344,
    wearable_ids: [355, 360],
  },
  {
    genesis_token_id: 9345,
    wearable_ids: [291, 407],
  },
  {
    genesis_token_id: 9346,
    wearable_ids: [445, 431],
  },
  {
    genesis_token_id: 9347,
    wearable_ids: [371, 407],
  },
  {
    genesis_token_id: 9348,
    wearable_ids: [247, 292],
  },
  {
    genesis_token_id: 9349,
    wearable_ids: [315, 325],
  },
  {
    genesis_token_id: 9350,
    wearable_ids: [354, 247],
  },
  {
    genesis_token_id: 9351,
    wearable_ids: [280, 370],
  },
  {
    genesis_token_id: 9352,
    wearable_ids: [251, 442],
  },
  {
    genesis_token_id: 9353,
    wearable_ids: [374, 362],
  },
  {
    genesis_token_id: 9354,
    wearable_ids: [395, 293],
  },
  {
    genesis_token_id: 9355,
    wearable_ids: [341, 277],
  },
  {
    genesis_token_id: 9356,
    wearable_ids: [335, 409],
  },
  {
    genesis_token_id: 9357,
    wearable_ids: [411, 332],
  },
  {
    genesis_token_id: 9358,
    wearable_ids: [434, 304],
  },
  {
    genesis_token_id: 9359,
    wearable_ids: [422, 386],
  },
  {
    genesis_token_id: 9360,
    wearable_ids: [270, 276],
  },
  {
    genesis_token_id: 9361,
    wearable_ids: [351, 342],
  },
  {
    genesis_token_id: 9362,
    wearable_ids: [274, 391],
  },
  {
    genesis_token_id: 9363,
    wearable_ids: [301, 336],
  },
  {
    genesis_token_id: 9364,
    wearable_ids: [437, 304],
  },
  {
    genesis_token_id: 9365,
    wearable_ids: [338, 289],
  },
  {
    genesis_token_id: 9366,
    wearable_ids: [324, 273],
  },
  {
    genesis_token_id: 9367,
    wearable_ids: [265, 250],
  },
  {
    genesis_token_id: 9368,
    wearable_ids: [343, 294],
  },
  {
    genesis_token_id: 9369,
    wearable_ids: [248, 296],
  },
  {
    genesis_token_id: 9370,
    wearable_ids: [437, 354],
  },
  {
    genesis_token_id: 9371,
    wearable_ids: [310, 332],
  },
  {
    genesis_token_id: 9372,
    wearable_ids: [273, 299],
  },
  {
    genesis_token_id: 9373,
    wearable_ids: [406, 434],
  },
  {
    genesis_token_id: 9374,
    wearable_ids: [410, 365],
  },
  {
    genesis_token_id: 9375,
    wearable_ids: [374, 420],
  },
  {
    genesis_token_id: 9376,
    wearable_ids: [431, 423],
  },
  {
    genesis_token_id: 9377,
    wearable_ids: [396, 304],
  },
  {
    genesis_token_id: 9378,
    wearable_ids: [437, 432],
  },
  {
    genesis_token_id: 9379,
    wearable_ids: [289, 343],
  },
  {
    genesis_token_id: 9380,
    wearable_ids: [423, 389],
  },
  {
    genesis_token_id: 9381,
    wearable_ids: [247, 411],
  },
  {
    genesis_token_id: 9382,
    wearable_ids: [274, 300],
  },
  {
    genesis_token_id: 9383,
    wearable_ids: [351, 258],
  },
  {
    genesis_token_id: 9384,
    wearable_ids: [408, 342],
  },
  {
    genesis_token_id: 9385,
    wearable_ids: [349, 322],
  },
  {
    genesis_token_id: 9386,
    wearable_ids: [423, 351],
  },
  {
    genesis_token_id: 9387,
    wearable_ids: [296, 347],
  },
  {
    genesis_token_id: 9388,
    wearable_ids: [286, 361],
  },
  {
    genesis_token_id: 9389,
    wearable_ids: [350, 407],
  },
  {
    genesis_token_id: 9390,
    wearable_ids: [317, 371],
  },
  {
    genesis_token_id: 9391,
    wearable_ids: [436, 299],
  },
  {
    genesis_token_id: 9392,
    wearable_ids: [299, 313],
  },
  {
    genesis_token_id: 9393,
    wearable_ids: [317, 340],
  },
  {
    genesis_token_id: 9394,
    wearable_ids: [344, 254],
  },
  {
    genesis_token_id: 9395,
    wearable_ids: [389, 444],
  },
  {
    genesis_token_id: 9396,
    wearable_ids: [264, 397],
  },
  {
    genesis_token_id: 9397,
    wearable_ids: [375, 256],
  },
  {
    genesis_token_id: 9398,
    wearable_ids: [273, 293],
  },
  {
    genesis_token_id: 9399,
    wearable_ids: [444, 411],
  },
  {
    genesis_token_id: 9400,
    wearable_ids: [316, 409],
  },
  {
    genesis_token_id: 9401,
    wearable_ids: [346, 261],
  },
  {
    genesis_token_id: 9402,
    wearable_ids: [351, 342],
  },
  {
    genesis_token_id: 9403,
    wearable_ids: [300, 271],
  },
  {
    genesis_token_id: 9404,
    wearable_ids: [403, 350],
  },
  {
    genesis_token_id: 9405,
    wearable_ids: [433, 331],
  },
  {
    genesis_token_id: 9406,
    wearable_ids: [445, 396],
  },
  {
    genesis_token_id: 9407,
    wearable_ids: [280, 355],
  },
  {
    genesis_token_id: 9408,
    wearable_ids: [372, 354],
  },
  {
    genesis_token_id: 9409,
    wearable_ids: [303, 262],
  },
  {
    genesis_token_id: 9410,
    wearable_ids: [386, 265],
  },
  {
    genesis_token_id: 9411,
    wearable_ids: [339, 246],
  },
  {
    genesis_token_id: 9412,
    wearable_ids: [306, 407],
  },
  {
    genesis_token_id: 9413,
    wearable_ids: [274, 435],
  },
  {
    genesis_token_id: 9414,
    wearable_ids: [301, 419],
  },
  {
    genesis_token_id: 9415,
    wearable_ids: [280, 346],
  },
  {
    genesis_token_id: 9416,
    wearable_ids: [291, 383],
  },
  {
    genesis_token_id: 9417,
    wearable_ids: [350, 285],
  },
  {
    genesis_token_id: 9418,
    wearable_ids: [335, 429],
  },
  {
    genesis_token_id: 9419,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 9420,
    wearable_ids: [396, 364],
  },
  {
    genesis_token_id: 9421,
    wearable_ids: [445, 403],
  },
  {
    genesis_token_id: 9422,
    wearable_ids: [346, 383],
  },
  {
    genesis_token_id: 9423,
    wearable_ids: [314, 261],
  },
  {
    genesis_token_id: 9424,
    wearable_ids: [362, 417],
  },
  {
    genesis_token_id: 9425,
    wearable_ids: [276, 372],
  },
  {
    genesis_token_id: 9426,
    wearable_ids: [372, 389],
  },
  {
    genesis_token_id: 9427,
    wearable_ids: [420, 379],
  },
  {
    genesis_token_id: 9428,
    wearable_ids: [277, 401],
  },
  {
    genesis_token_id: 9429,
    wearable_ids: [253, 349],
  },
  {
    genesis_token_id: 9430,
    wearable_ids: [317, 412],
  },
  {
    genesis_token_id: 9431,
    wearable_ids: [355, 259],
  },
  {
    genesis_token_id: 9432,
    wearable_ids: [316, 356],
  },
  {
    genesis_token_id: 9433,
    wearable_ids: [403, 440],
  },
  {
    genesis_token_id: 9434,
    wearable_ids: [272, 412],
  },
  {
    genesis_token_id: 9435,
    wearable_ids: [383, 340],
  },
  {
    genesis_token_id: 9436,
    wearable_ids: [314, 370],
  },
  {
    genesis_token_id: 9437,
    wearable_ids: [436, 391],
  },
  {
    genesis_token_id: 9438,
    wearable_ids: [400, 253],
  },
  {
    genesis_token_id: 9439,
    wearable_ids: [407, 428],
  },
  {
    genesis_token_id: 9440,
    wearable_ids: [386, 360],
  },
  {
    genesis_token_id: 9441,
    wearable_ids: [395, 350],
  },
  {
    genesis_token_id: 9442,
    wearable_ids: [434, 287],
  },
  {
    genesis_token_id: 9443,
    wearable_ids: [350, 313],
  },
  {
    genesis_token_id: 9444,
    wearable_ids: [258, 311],
  },
  {
    genesis_token_id: 9445,
    wearable_ids: [287, 319],
  },
  {
    genesis_token_id: 9446,
    wearable_ids: [400, 254],
  },
  {
    genesis_token_id: 9447,
    wearable_ids: [272, 393],
  },
  {
    genesis_token_id: 9448,
    wearable_ids: [332, 295],
  },
  {
    genesis_token_id: 9449,
    wearable_ids: [409, 268],
  },
  {
    genesis_token_id: 9450,
    wearable_ids: [383, 273],
  },
  {
    genesis_token_id: 9451,
    wearable_ids: [300, 271],
  },
  {
    genesis_token_id: 9452,
    wearable_ids: [277, 314],
  },
  {
    genesis_token_id: 9453,
    wearable_ids: [272, 370],
  },
  {
    genesis_token_id: 9454,
    wearable_ids: [297, 322],
  },
  {
    genesis_token_id: 9455,
    wearable_ids: [433, 395],
  },
  {
    genesis_token_id: 9456,
    wearable_ids: [355, 262],
  },
  {
    genesis_token_id: 9457,
    wearable_ids: [336, 370],
  },
  {
    genesis_token_id: 9458,
    wearable_ids: [310, 398],
  },
  {
    genesis_token_id: 9459,
    wearable_ids: [351, 263],
  },
  {
    genesis_token_id: 9460,
    wearable_ids: [306, 395],
  },
  {
    genesis_token_id: 9461,
    wearable_ids: [266, 325],
  },
  {
    genesis_token_id: 9462,
    wearable_ids: [407, 389],
  },
  {
    genesis_token_id: 9463,
    wearable_ids: [264, 287],
  },
  {
    genesis_token_id: 9464,
    wearable_ids: [300, 297],
  },
  {
    genesis_token_id: 9465,
    wearable_ids: [384, 388],
  },
  {
    genesis_token_id: 9466,
    wearable_ids: [434, 338],
  },
  {
    genesis_token_id: 9467,
    wearable_ids: [331, 305],
  },
  {
    genesis_token_id: 9468,
    wearable_ids: [350, 348],
  },
  {
    genesis_token_id: 9469,
    wearable_ids: [277, 337],
  },
  {
    genesis_token_id: 9470,
    wearable_ids: [373, 266],
  },
  {
    genesis_token_id: 9471,
    wearable_ids: [315, 399],
  },
  {
    genesis_token_id: 9472,
    wearable_ids: [355, 437],
  },
  {
    genesis_token_id: 9473,
    wearable_ids: [304, 364],
  },
  {
    genesis_token_id: 9474,
    wearable_ids: [404, 346],
  },
  {
    genesis_token_id: 9475,
    wearable_ids: [343, 362],
  },
  {
    genesis_token_id: 9476,
    wearable_ids: [431, 406],
  },
  {
    genesis_token_id: 9477,
    wearable_ids: [262, 406],
  },
  {
    genesis_token_id: 9478,
    wearable_ids: [304, 430],
  },
  {
    genesis_token_id: 9479,
    wearable_ids: [415, 409],
  },
  {
    genesis_token_id: 9480,
    wearable_ids: [343, 287],
  },
  {
    genesis_token_id: 9481,
    wearable_ids: [378, 444],
  },
  {
    genesis_token_id: 9482,
    wearable_ids: [412, 374],
  },
  {
    genesis_token_id: 9483,
    wearable_ids: [408, 375],
  },
  {
    genesis_token_id: 9484,
    wearable_ids: [317, 338],
  },
  {
    genesis_token_id: 9485,
    wearable_ids: [270, 385],
  },
  {
    genesis_token_id: 9486,
    wearable_ids: [296, 289],
  },
  {
    genesis_token_id: 9487,
    wearable_ids: [343, 350],
  },
  {
    genesis_token_id: 9488,
    wearable_ids: [399, 373],
  },
  {
    genesis_token_id: 9489,
    wearable_ids: [387, 357],
  },
  {
    genesis_token_id: 9490,
    wearable_ids: [355, 267],
  },
  {
    genesis_token_id: 9491,
    wearable_ids: [284, 413],
  },
  {
    genesis_token_id: 9492,
    wearable_ids: [413, 353],
  },
  {
    genesis_token_id: 9493,
    wearable_ids: [376, 429],
  },
  {
    genesis_token_id: 9494,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 9495,
    wearable_ids: [286, 303],
  },
  {
    genesis_token_id: 9496,
    wearable_ids: [371, 312],
  },
  {
    genesis_token_id: 9497,
    wearable_ids: [424, 253],
  },
  {
    genesis_token_id: 9498,
    wearable_ids: [336, 404],
  },
  {
    genesis_token_id: 9499,
    wearable_ids: [364, 315],
  },
  {
    genesis_token_id: 9500,
    wearable_ids: [407, 271],
  },
  {
    genesis_token_id: 9501,
    wearable_ids: [395, 332],
  },
  {
    genesis_token_id: 9502,
    wearable_ids: [425, 410],
  },
  {
    genesis_token_id: 9503,
    wearable_ids: [292, 414],
  },
  {
    genesis_token_id: 9504,
    wearable_ids: [270, 277],
  },
  {
    genesis_token_id: 9505,
    wearable_ids: [263, 272],
  },
  {
    genesis_token_id: 9506,
    wearable_ids: [429, 362],
  },
  {
    genesis_token_id: 9507,
    wearable_ids: [247, 412],
  },
  {
    genesis_token_id: 9508,
    wearable_ids: [422, 368],
  },
  {
    genesis_token_id: 9509,
    wearable_ids: [343, 288],
  },
  {
    genesis_token_id: 9510,
    wearable_ids: [387, 431],
  },
  {
    genesis_token_id: 9511,
    wearable_ids: [420, 426],
  },
  {
    genesis_token_id: 9512,
    wearable_ids: [426, 274],
  },
  {
    genesis_token_id: 9513,
    wearable_ids: [284, 307],
  },
  {
    genesis_token_id: 9514,
    wearable_ids: [397, 295],
  },
  {
    genesis_token_id: 9515,
    wearable_ids: [404, 344],
  },
  {
    genesis_token_id: 9516,
    wearable_ids: [289, 342],
  },
  {
    genesis_token_id: 9517,
    wearable_ids: [292, 434],
  },
  {
    genesis_token_id: 9518,
    wearable_ids: [365, 254],
  },
  {
    genesis_token_id: 9519,
    wearable_ids: [274, 261],
  },
  {
    genesis_token_id: 9520,
    wearable_ids: [280, 349],
  },
  {
    genesis_token_id: 9521,
    wearable_ids: [372, 337],
  },
  {
    genesis_token_id: 9522,
    wearable_ids: [341, 298],
  },
  {
    genesis_token_id: 9523,
    wearable_ids: [303, 394],
  },
  {
    genesis_token_id: 9524,
    wearable_ids: [255, 377],
  },
  {
    genesis_token_id: 9525,
    wearable_ids: [273, 399],
  },
  {
    genesis_token_id: 9526,
    wearable_ids: [443, 287],
  },
  {
    genesis_token_id: 9527,
    wearable_ids: [355, 332],
  },
  {
    genesis_token_id: 9528,
    wearable_ids: [317, 351],
  },
  {
    genesis_token_id: 9529,
    wearable_ids: [355, 401],
  },
  {
    genesis_token_id: 9530,
    wearable_ids: [351, 438],
  },
  {
    genesis_token_id: 9531,
    wearable_ids: [354, 277],
  },
  {
    genesis_token_id: 9532,
    wearable_ids: [432, 353],
  },
  {
    genesis_token_id: 9533,
    wearable_ids: [369, 443],
  },
  {
    genesis_token_id: 9534,
    wearable_ids: [348, 414],
  },
  {
    genesis_token_id: 9535,
    wearable_ids: [316, 406],
  },
  {
    genesis_token_id: 9536,
    wearable_ids: [289, 280],
  },
  {
    genesis_token_id: 9537,
    wearable_ids: [420, 335],
  },
  {
    genesis_token_id: 9538,
    wearable_ids: [355, 404],
  },
  {
    genesis_token_id: 9539,
    wearable_ids: [428, 353],
  },
  {
    genesis_token_id: 9540,
    wearable_ids: [355, 372],
  },
  {
    genesis_token_id: 9541,
    wearable_ids: [339, 318],
  },
  {
    genesis_token_id: 9542,
    wearable_ids: [296, 442],
  },
  {
    genesis_token_id: 9543,
    wearable_ids: [310, 286],
  },
  {
    genesis_token_id: 9544,
    wearable_ids: [397, 325],
  },
  {
    genesis_token_id: 9545,
    wearable_ids: [409, 342],
  },
  {
    genesis_token_id: 9546,
    wearable_ids: [341, 270],
  },
  {
    genesis_token_id: 9547,
    wearable_ids: [368, 339],
  },
  {
    genesis_token_id: 9548,
    wearable_ids: [349, 384],
  },
  {
    genesis_token_id: 9549,
    wearable_ids: [338, 266],
  },
  {
    genesis_token_id: 9550,
    wearable_ids: [413, 374],
  },
  {
    genesis_token_id: 9551,
    wearable_ids: [315, 384],
  },
  {
    genesis_token_id: 9552,
    wearable_ids: [259, 325],
  },
  {
    genesis_token_id: 9553,
    wearable_ids: [375, 351],
  },
  {
    genesis_token_id: 9554,
    wearable_ids: [406, 425],
  },
  {
    genesis_token_id: 9555,
    wearable_ids: [272, 279],
  },
  {
    genesis_token_id: 9556,
    wearable_ids: [296, 336],
  },
  {
    genesis_token_id: 9557,
    wearable_ids: [342, 376],
  },
  {
    genesis_token_id: 9558,
    wearable_ids: [363, 257],
  },
  {
    genesis_token_id: 9559,
    wearable_ids: [432, 354],
  },
  {
    genesis_token_id: 9560,
    wearable_ids: [412, 423],
  },
  {
    genesis_token_id: 9561,
    wearable_ids: [442, 423],
  },
  {
    genesis_token_id: 9562,
    wearable_ids: [265, 403],
  },
  {
    genesis_token_id: 9563,
    wearable_ids: [422, 374],
  },
  {
    genesis_token_id: 9564,
    wearable_ids: [396, 387],
  },
  {
    genesis_token_id: 9565,
    wearable_ids: [257, 370],
  },
  {
    genesis_token_id: 9566,
    wearable_ids: [270, 292],
  },
  {
    genesis_token_id: 9567,
    wearable_ids: [410, 371],
  },
  {
    genesis_token_id: 9568,
    wearable_ids: [431, 327],
  },
  {
    genesis_token_id: 9569,
    wearable_ids: [355, 384],
  },
  {
    genesis_token_id: 9570,
    wearable_ids: [301, 291],
  },
  {
    genesis_token_id: 9571,
    wearable_ids: [263, 382],
  },
  {
    genesis_token_id: 9572,
    wearable_ids: [383, 426],
  },
  {
    genesis_token_id: 9573,
    wearable_ids: [272, 376],
  },
  {
    genesis_token_id: 9574,
    wearable_ids: [268, 384],
  },
  {
    genesis_token_id: 9575,
    wearable_ids: [431, 364],
  },
  {
    genesis_token_id: 9576,
    wearable_ids: [422, 374],
  },
  {
    genesis_token_id: 9577,
    wearable_ids: [420, 366],
  },
  {
    genesis_token_id: 9578,
    wearable_ids: [311, 248],
  },
  {
    genesis_token_id: 9579,
    wearable_ids: [295, 401],
  },
  {
    genesis_token_id: 9580,
    wearable_ids: [254, 374],
  },
  {
    genesis_token_id: 9581,
    wearable_ids: [340, 251],
  },
  {
    genesis_token_id: 9582,
    wearable_ids: [284, 254],
  },
  {
    genesis_token_id: 9583,
    wearable_ids: [437, 401],
  },
  {
    genesis_token_id: 9584,
    wearable_ids: [291, 303],
  },
  {
    genesis_token_id: 9585,
    wearable_ids: [349, 295],
  },
  {
    genesis_token_id: 9586,
    wearable_ids: [403, 437],
  },
  {
    genesis_token_id: 9587,
    wearable_ids: [426, 303],
  },
  {
    genesis_token_id: 9588,
    wearable_ids: [316, 283],
  },
  {
    genesis_token_id: 9589,
    wearable_ids: [409, 293],
  },
  {
    genesis_token_id: 9590,
    wearable_ids: [436, 337],
  },
  {
    genesis_token_id: 9591,
    wearable_ids: [265, 349],
  },
  {
    genesis_token_id: 9592,
    wearable_ids: [369, 365],
  },
  {
    genesis_token_id: 9593,
    wearable_ids: [297, 371],
  },
  {
    genesis_token_id: 9594,
    wearable_ids: [428, 348],
  },
  {
    genesis_token_id: 9595,
    wearable_ids: [374, 257],
  },
  {
    genesis_token_id: 9596,
    wearable_ids: [251, 350],
  },
  {
    genesis_token_id: 9597,
    wearable_ids: [335, 300],
  },
  {
    genesis_token_id: 9598,
    wearable_ids: [424, 277],
  },
  {
    genesis_token_id: 9599,
    wearable_ids: [344, 388],
  },
  {
    genesis_token_id: 9600,
    wearable_ids: [415, 363],
  },
  {
    genesis_token_id: 9601,
    wearable_ids: [412, 438],
  },
  {
    genesis_token_id: 9602,
    wearable_ids: [326, 290],
  },
  {
    genesis_token_id: 9603,
    wearable_ids: [326, 344],
  },
  {
    genesis_token_id: 9604,
    wearable_ids: [444, 434],
  },
  {
    genesis_token_id: 9605,
    wearable_ids: [424, 400],
  },
  {
    genesis_token_id: 9606,
    wearable_ids: [314, 428],
  },
  {
    genesis_token_id: 9607,
    wearable_ids: [428, 332],
  },
  {
    genesis_token_id: 9608,
    wearable_ids: [308, 405],
  },
  {
    genesis_token_id: 9609,
    wearable_ids: [389, 369],
  },
  {
    genesis_token_id: 9610,
    wearable_ids: [262, 324],
  },
  {
    genesis_token_id: 9611,
    wearable_ids: [407, 263],
  },
  {
    genesis_token_id: 9612,
    wearable_ids: [316, 262],
  },
  {
    genesis_token_id: 9613,
    wearable_ids: [383, 299],
  },
  {
    genesis_token_id: 9614,
    wearable_ids: [348, 341],
  },
  {
    genesis_token_id: 9615,
    wearable_ids: [272, 314],
  },
  {
    genesis_token_id: 9616,
    wearable_ids: [258, 394],
  },
  {
    genesis_token_id: 9617,
    wearable_ids: [294, 296],
  },
  {
    genesis_token_id: 9618,
    wearable_ids: [324, 268],
  },
  {
    genesis_token_id: 9619,
    wearable_ids: [292, 404],
  },
  {
    genesis_token_id: 9620,
    wearable_ids: [423, 262],
  },
  {
    genesis_token_id: 9621,
    wearable_ids: [437, 255],
  },
  {
    genesis_token_id: 9622,
    wearable_ids: [304, 441],
  },
  {
    genesis_token_id: 9623,
    wearable_ids: [437, 277],
  },
  {
    genesis_token_id: 9624,
    wearable_ids: [422, 265],
  },
  {
    genesis_token_id: 9625,
    wearable_ids: [375, 314],
  },
  {
    genesis_token_id: 9626,
    wearable_ids: [270, 393],
  },
  {
    genesis_token_id: 9627,
    wearable_ids: [308, 344],
  },
  {
    genesis_token_id: 9628,
    wearable_ids: [435, 276],
  },
  {
    genesis_token_id: 9629,
    wearable_ids: [372, 407],
  },
  {
    genesis_token_id: 9630,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 9631,
    wearable_ids: [349, 257],
  },
  {
    genesis_token_id: 9632,
    wearable_ids: [408, 334],
  },
  {
    genesis_token_id: 9633,
    wearable_ids: [363, 297],
  },
  {
    genesis_token_id: 9634,
    wearable_ids: [251, 408],
  },
  {
    genesis_token_id: 9635,
    wearable_ids: [286, 290],
  },
  {
    genesis_token_id: 9636,
    wearable_ids: [292, 356],
  },
  {
    genesis_token_id: 9637,
    wearable_ids: [276, 292],
  },
  {
    genesis_token_id: 9638,
    wearable_ids: [346, 258],
  },
  {
    genesis_token_id: 9639,
    wearable_ids: [383, 278],
  },
  {
    genesis_token_id: 9640,
    wearable_ids: [326, 409],
  },
  {
    genesis_token_id: 9641,
    wearable_ids: [404, 432],
  },
  {
    genesis_token_id: 9642,
    wearable_ids: [422, 339],
  },
  {
    genesis_token_id: 9643,
    wearable_ids: [372, 419],
  },
  {
    genesis_token_id: 9644,
    wearable_ids: [400, 383],
  },
  {
    genesis_token_id: 9645,
    wearable_ids: [277, 371],
  },
  {
    genesis_token_id: 9646,
    wearable_ids: [372, 407],
  },
  {
    genesis_token_id: 9647,
    wearable_ids: [437, 415],
  },
  {
    genesis_token_id: 9648,
    wearable_ids: [386, 266],
  },
  {
    genesis_token_id: 9649,
    wearable_ids: [291, 290],
  },
  {
    genesis_token_id: 9650,
    wearable_ids: [443, 397],
  },
  {
    genesis_token_id: 9651,
    wearable_ids: [337, 366],
  },
  {
    genesis_token_id: 9652,
    wearable_ids: [255, 395],
  },
  {
    genesis_token_id: 9653,
    wearable_ids: [387, 414],
  },
  {
    genesis_token_id: 9654,
    wearable_ids: [420, 411],
  },
  {
    genesis_token_id: 9655,
    wearable_ids: [410, 323],
  },
  {
    genesis_token_id: 9656,
    wearable_ids: [399, 382],
  },
  {
    genesis_token_id: 9657,
    wearable_ids: [378, 386],
  },
  {
    genesis_token_id: 9658,
    wearable_ids: [373, 251],
  },
  {
    genesis_token_id: 9659,
    wearable_ids: [340, 253],
  },
  {
    genesis_token_id: 9660,
    wearable_ids: [339, 338],
  },
  {
    genesis_token_id: 9661,
    wearable_ids: [316, 335],
  },
  {
    genesis_token_id: 9662,
    wearable_ids: [338, 389],
  },
  {
    genesis_token_id: 9663,
    wearable_ids: [306, 277],
  },
  {
    genesis_token_id: 9664,
    wearable_ids: [255, 348],
  },
  {
    genesis_token_id: 9665,
    wearable_ids: [444, 398],
  },
  {
    genesis_token_id: 9666,
    wearable_ids: [264, 443],
  },
  {
    genesis_token_id: 9667,
    wearable_ids: [387, 444],
  },
  {
    genesis_token_id: 9668,
    wearable_ids: [324, 444],
  },
  {
    genesis_token_id: 9669,
    wearable_ids: [396, 429],
  },
  {
    genesis_token_id: 9670,
    wearable_ids: [387, 403],
  },
  {
    genesis_token_id: 9671,
    wearable_ids: [336, 265],
  },
  {
    genesis_token_id: 9672,
    wearable_ids: [371, 276],
  },
  {
    genesis_token_id: 9673,
    wearable_ids: [374, 266],
  },
  {
    genesis_token_id: 9674,
    wearable_ids: [332, 350],
  },
  {
    genesis_token_id: 9675,
    wearable_ids: [331, 418],
  },
  {
    genesis_token_id: 9676,
    wearable_ids: [277, 272],
  },
  {
    genesis_token_id: 9677,
    wearable_ids: [259, 302],
  },
  {
    genesis_token_id: 9678,
    wearable_ids: [445, 394],
  },
  {
    genesis_token_id: 9679,
    wearable_ids: [413, 368],
  },
  {
    genesis_token_id: 9680,
    wearable_ids: [369, 350],
  },
  {
    genesis_token_id: 9681,
    wearable_ids: [411, 407],
  },
  {
    genesis_token_id: 9682,
    wearable_ids: [412, 330],
  },
  {
    genesis_token_id: 9683,
    wearable_ids: [349, 326],
  },
  {
    genesis_token_id: 9684,
    wearable_ids: [256, 442],
  },
  {
    genesis_token_id: 9685,
    wearable_ids: [337, 294],
  },
  {
    genesis_token_id: 9686,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 9687,
    wearable_ids: [400, 331],
  },
  {
    genesis_token_id: 9688,
    wearable_ids: [349, 246],
  },
  {
    genesis_token_id: 9689,
    wearable_ids: [389, 365],
  },
  {
    genesis_token_id: 9690,
    wearable_ids: [295, 259],
  },
  {
    genesis_token_id: 9691,
    wearable_ids: [372, 444],
  },
  {
    genesis_token_id: 9692,
    wearable_ids: [443, 256],
  },
  {
    genesis_token_id: 9693,
    wearable_ids: [435, 407],
  },
  {
    genesis_token_id: 9694,
    wearable_ids: [364, 372],
  },
  {
    genesis_token_id: 9695,
    wearable_ids: [277, 289],
  },
  {
    genesis_token_id: 9696,
    wearable_ids: [270, 407],
  },
  {
    genesis_token_id: 9697,
    wearable_ids: [251, 272],
  },
  {
    genesis_token_id: 9698,
    wearable_ids: [294, 254],
  },
  {
    genesis_token_id: 9699,
    wearable_ids: [424, 272],
  },
  {
    genesis_token_id: 9700,
    wearable_ids: [286, 335],
  },
  {
    genesis_token_id: 9701,
    wearable_ids: [365, 313],
  },
  {
    genesis_token_id: 9702,
    wearable_ids: [311, 345],
  },
  {
    genesis_token_id: 9703,
    wearable_ids: [326, 270],
  },
  {
    genesis_token_id: 9704,
    wearable_ids: [266, 247],
  },
  {
    genesis_token_id: 9705,
    wearable_ids: [317, 443],
  },
  {
    genesis_token_id: 9706,
    wearable_ids: [384, 411],
  },
  {
    genesis_token_id: 9707,
    wearable_ids: [263, 445],
  },
  {
    genesis_token_id: 9708,
    wearable_ids: [362, 364],
  },
  {
    genesis_token_id: 9709,
    wearable_ids: [310, 425],
  },
  {
    genesis_token_id: 9710,
    wearable_ids: [337, 288],
  },
  {
    genesis_token_id: 9711,
    wearable_ids: [410, 377],
  },
  {
    genesis_token_id: 9712,
    wearable_ids: [257, 445],
  },
  {
    genesis_token_id: 9713,
    wearable_ids: [389, 422],
  },
  {
    genesis_token_id: 9714,
    wearable_ids: [301, 397],
  },
  {
    genesis_token_id: 9715,
    wearable_ids: [268, 392],
  },
  {
    genesis_token_id: 9716,
    wearable_ids: [324, 425],
  },
  {
    genesis_token_id: 9717,
    wearable_ids: [338, 308],
  },
  {
    genesis_token_id: 9718,
    wearable_ids: [436, 247],
  },
  {
    genesis_token_id: 9719,
    wearable_ids: [258, 389],
  },
  {
    genesis_token_id: 9720,
    wearable_ids: [295, 350],
  },
  {
    genesis_token_id: 9721,
    wearable_ids: [280, 427],
  },
  {
    genesis_token_id: 9722,
    wearable_ids: [335, 431],
  },
  {
    genesis_token_id: 9723,
    wearable_ids: [354, 330],
  },
  {
    genesis_token_id: 9724,
    wearable_ids: [340, 267],
  },
  {
    genesis_token_id: 9725,
    wearable_ids: [317, 430],
  },
  {
    genesis_token_id: 9726,
    wearable_ids: [263, 374],
  },
  {
    genesis_token_id: 9727,
    wearable_ids: [315, 378],
  },
  {
    genesis_token_id: 9728,
    wearable_ids: [278, 294],
  },
  {
    genesis_token_id: 9729,
    wearable_ids: [264, 435],
  },
  {
    genesis_token_id: 9730,
    wearable_ids: [348, 292],
  },
  {
    genesis_token_id: 9731,
    wearable_ids: [343, 347],
  },
  {
    genesis_token_id: 9732,
    wearable_ids: [272, 386],
  },
  {
    genesis_token_id: 9733,
    wearable_ids: [317, 408],
  },
  {
    genesis_token_id: 9734,
    wearable_ids: [375, 334],
  },
  {
    genesis_token_id: 9735,
    wearable_ids: [344, 444],
  },
  {
    genesis_token_id: 9736,
    wearable_ids: [277, 425],
  },
  {
    genesis_token_id: 9737,
    wearable_ids: [266, 291],
  },
  {
    genesis_token_id: 9738,
    wearable_ids: [325, 264],
  },
  {
    genesis_token_id: 9739,
    wearable_ids: [310, 369],
  },
  {
    genesis_token_id: 9740,
    wearable_ids: [420, 363],
  },
  {
    genesis_token_id: 9741,
    wearable_ids: [296, 376],
  },
  {
    genesis_token_id: 9742,
    wearable_ids: [443, 259],
  },
  {
    genesis_token_id: 9743,
    wearable_ids: [341, 433],
  },
  {
    genesis_token_id: 9744,
    wearable_ids: [348, 379],
  },
  {
    genesis_token_id: 9745,
    wearable_ids: [262, 407],
  },
  {
    genesis_token_id: 9746,
    wearable_ids: [445, 314],
  },
  {
    genesis_token_id: 9747,
    wearable_ids: [277, 254],
  },
  {
    genesis_token_id: 9748,
    wearable_ids: [385, 263],
  },
  {
    genesis_token_id: 9749,
    wearable_ids: [308, 437],
  },
  {
    genesis_token_id: 9750,
    wearable_ids: [270, 255],
  },
  {
    genesis_token_id: 9751,
    wearable_ids: [254, 429],
  },
  {
    genesis_token_id: 9752,
    wearable_ids: [259, 303],
  },
  {
    genesis_token_id: 9753,
    wearable_ids: [253, 425],
  },
  {
    genesis_token_id: 9754,
    wearable_ids: [319, 389],
  },
  {
    genesis_token_id: 9755,
    wearable_ids: [292, 253],
  },
  {
    genesis_token_id: 9756,
    wearable_ids: [397, 314],
  },
  {
    genesis_token_id: 9757,
    wearable_ids: [444, 278],
  },
  {
    genesis_token_id: 9758,
    wearable_ids: [292, 388],
  },
  {
    genesis_token_id: 9759,
    wearable_ids: [270, 341],
  },
  {
    genesis_token_id: 9760,
    wearable_ids: [284, 291],
  },
  {
    genesis_token_id: 9761,
    wearable_ids: [258, 294],
  },
  {
    genesis_token_id: 9762,
    wearable_ids: [315, 375],
  },
  {
    genesis_token_id: 9763,
    wearable_ids: [350, 386],
  },
  {
    genesis_token_id: 9764,
    wearable_ids: [254, 442],
  },
  {
    genesis_token_id: 9765,
    wearable_ids: [325, 294],
  },
  {
    genesis_token_id: 9766,
    wearable_ids: [289, 269],
  },
  {
    genesis_token_id: 9767,
    wearable_ids: [341, 256],
  },
  {
    genesis_token_id: 9768,
    wearable_ids: [332, 305],
  },
  {
    genesis_token_id: 9769,
    wearable_ids: [432, 323],
  },
  {
    genesis_token_id: 9770,
    wearable_ids: [247, 422],
  },
  {
    genesis_token_id: 9771,
    wearable_ids: [295, 365],
  },
  {
    genesis_token_id: 9772,
    wearable_ids: [408, 264],
  },
  {
    genesis_token_id: 9773,
    wearable_ids: [368, 373],
  },
  {
    genesis_token_id: 9774,
    wearable_ids: [287, 376],
  },
  {
    genesis_token_id: 9775,
    wearable_ids: [308, 355],
  },
  {
    genesis_token_id: 9776,
    wearable_ids: [247, 260],
  },
  {
    genesis_token_id: 9777,
    wearable_ids: [378, 355],
  },
  {
    genesis_token_id: 9778,
    wearable_ids: [310, 417],
  },
  {
    genesis_token_id: 9779,
    wearable_ids: [428, 281],
  },
  {
    genesis_token_id: 9780,
    wearable_ids: [373, 437],
  },
  {
    genesis_token_id: 9781,
    wearable_ids: [433, 362],
  },
  {
    genesis_token_id: 9782,
    wearable_ids: [423, 444],
  },
  {
    genesis_token_id: 9783,
    wearable_ids: [386, 435],
  },
  {
    genesis_token_id: 9784,
    wearable_ids: [352, 348],
  },
  {
    genesis_token_id: 9785,
    wearable_ids: [395, 398],
  },
  {
    genesis_token_id: 9786,
    wearable_ids: [344, 359],
  },
  {
    genesis_token_id: 9787,
    wearable_ids: [314, 251],
  },
  {
    genesis_token_id: 9788,
    wearable_ids: [248, 273],
  },
  {
    genesis_token_id: 9789,
    wearable_ids: [289, 332],
  },
  {
    genesis_token_id: 9790,
    wearable_ids: [274, 317],
  },
  {
    genesis_token_id: 9791,
    wearable_ids: [276, 331],
  },
  {
    genesis_token_id: 9792,
    wearable_ids: [389, 382],
  },
  {
    genesis_token_id: 9793,
    wearable_ids: [264, 347],
  },
  {
    genesis_token_id: 9794,
    wearable_ids: [400, 310],
  },
  {
    genesis_token_id: 9795,
    wearable_ids: [300, 389],
  },
  {
    genesis_token_id: 9796,
    wearable_ids: [429, 411],
  },
  {
    genesis_token_id: 9797,
    wearable_ids: [290, 315],
  },
  {
    genesis_token_id: 9798,
    wearable_ids: [354, 410],
  },
  {
    genesis_token_id: 9799,
    wearable_ids: [403, 294],
  },
  {
    genesis_token_id: 9800,
    wearable_ids: [395, 397],
  },
  {
    genesis_token_id: 9801,
    wearable_ids: [295, 271],
  },
  {
    genesis_token_id: 9802,
    wearable_ids: [346, 332],
  },
  {
    genesis_token_id: 9803,
    wearable_ids: [308, 378],
  },
  {
    genesis_token_id: 9804,
    wearable_ids: [259, 378],
  },
  {
    genesis_token_id: 9805,
    wearable_ids: [308, 403],
  },
  {
    genesis_token_id: 9806,
    wearable_ids: [397, 431],
  },
  {
    genesis_token_id: 9807,
    wearable_ids: [384, 365],
  },
  {
    genesis_token_id: 9808,
    wearable_ids: [389, 271],
  },
  {
    genesis_token_id: 9809,
    wearable_ids: [411, 315],
  },
  {
    genesis_token_id: 9810,
    wearable_ids: [324, 391],
  },
  {
    genesis_token_id: 9811,
    wearable_ids: [317, 266],
  },
  {
    genesis_token_id: 9812,
    wearable_ids: [377, 257],
  },
  {
    genesis_token_id: 9813,
    wearable_ids: [263, 415],
  },
  {
    genesis_token_id: 9814,
    wearable_ids: [331, 414],
  },
  {
    genesis_token_id: 9815,
    wearable_ids: [413, 290],
  },
  {
    genesis_token_id: 9816,
    wearable_ids: [338, 372],
  },
  {
    genesis_token_id: 9817,
    wearable_ids: [397, 341],
  },
  {
    genesis_token_id: 9818,
    wearable_ids: [325, 408],
  },
  {
    genesis_token_id: 9819,
    wearable_ids: [295, 357],
  },
  {
    genesis_token_id: 9820,
    wearable_ids: [413, 291],
  },
  {
    genesis_token_id: 9821,
    wearable_ids: [314, 426],
  },
  {
    genesis_token_id: 9822,
    wearable_ids: [423, 389],
  },
  {
    genesis_token_id: 9823,
    wearable_ids: [411, 290],
  },
  {
    genesis_token_id: 9824,
    wearable_ids: [271, 407],
  },
  {
    genesis_token_id: 9825,
    wearable_ids: [314, 378],
  },
  {
    genesis_token_id: 9826,
    wearable_ids: [415, 296],
  },
  {
    genesis_token_id: 9827,
    wearable_ids: [362, 369],
  },
  {
    genesis_token_id: 9828,
    wearable_ids: [254, 391],
  },
  {
    genesis_token_id: 9829,
    wearable_ids: [350, 424],
  },
  {
    genesis_token_id: 9830,
    wearable_ids: [290, 271],
  },
  {
    genesis_token_id: 9831,
    wearable_ids: [429, 400],
  },
  {
    genesis_token_id: 9832,
    wearable_ids: [389, 287],
  },
  {
    genesis_token_id: 9833,
    wearable_ids: [308, 382],
  },
  {
    genesis_token_id: 9834,
    wearable_ids: [371, 413],
  },
  {
    genesis_token_id: 9835,
    wearable_ids: [412, 408],
  },
  {
    genesis_token_id: 9836,
    wearable_ids: [332, 441],
  },
  {
    genesis_token_id: 9837,
    wearable_ids: [354, 431],
  },
  {
    genesis_token_id: 9838,
    wearable_ids: [331, 362],
  },
  {
    genesis_token_id: 9839,
    wearable_ids: [407, 377],
  },
  {
    genesis_token_id: 9840,
    wearable_ids: [266, 422],
  },
  {
    genesis_token_id: 9841,
    wearable_ids: [373, 333],
  },
  {
    genesis_token_id: 9842,
    wearable_ids: [308, 299],
  },
  {
    genesis_token_id: 9843,
    wearable_ids: [349, 250],
  },
  {
    genesis_token_id: 9844,
    wearable_ids: [435, 261],
  },
  {
    genesis_token_id: 9845,
    wearable_ids: [399, 266],
  },
  {
    genesis_token_id: 9846,
    wearable_ids: [384, 255],
  },
  {
    genesis_token_id: 9847,
    wearable_ids: [314, 299],
  },
  {
    genesis_token_id: 9848,
    wearable_ids: [428, 365],
  },
  {
    genesis_token_id: 9849,
    wearable_ids: [263, 434],
  },
  {
    genesis_token_id: 9850,
    wearable_ids: [248, 341],
  },
  {
    genesis_token_id: 9851,
    wearable_ids: [420, 436],
  },
  {
    genesis_token_id: 9852,
    wearable_ids: [365, 294],
  },
  {
    genesis_token_id: 9853,
    wearable_ids: [339, 410],
  },
  {
    genesis_token_id: 9854,
    wearable_ids: [256, 396],
  },
  {
    genesis_token_id: 9855,
    wearable_ids: [376, 287],
  },
  {
    genesis_token_id: 9856,
    wearable_ids: [310, 375],
  },
  {
    genesis_token_id: 9857,
    wearable_ids: [317, 389],
  },
  {
    genesis_token_id: 9858,
    wearable_ids: [423, 353],
  },
  {
    genesis_token_id: 9859,
    wearable_ids: [311, 303],
  },
  {
    genesis_token_id: 9860,
    wearable_ids: [263, 434],
  },
  {
    genesis_token_id: 9861,
    wearable_ids: [434, 316],
  },
  {
    genesis_token_id: 9862,
    wearable_ids: [310, 382],
  },
  {
    genesis_token_id: 9863,
    wearable_ids: [254, 298],
  },
  {
    genesis_token_id: 9864,
    wearable_ids: [385, 340],
  },
  {
    genesis_token_id: 9865,
    wearable_ids: [306, 400],
  },
  {
    genesis_token_id: 9866,
    wearable_ids: [370, 412],
  },
  {
    genesis_token_id: 9867,
    wearable_ids: [259, 433],
  },
  {
    genesis_token_id: 9868,
    wearable_ids: [264, 259],
  },
  {
    genesis_token_id: 9869,
    wearable_ids: [384, 292],
  },
  {
    genesis_token_id: 9870,
    wearable_ids: [292, 291],
  },
  {
    genesis_token_id: 9871,
    wearable_ids: [306, 403],
  },
  {
    genesis_token_id: 9872,
    wearable_ids: [387, 276],
  },
  {
    genesis_token_id: 9873,
    wearable_ids: [350, 268],
  },
  {
    genesis_token_id: 9874,
    wearable_ids: [263, 403],
  },
  {
    genesis_token_id: 9875,
    wearable_ids: [315, 445],
  },
  {
    genesis_token_id: 9876,
    wearable_ids: [256, 257],
  },
  {
    genesis_token_id: 9877,
    wearable_ids: [291, 374],
  },
  {
    genesis_token_id: 9878,
    wearable_ids: [326, 369],
  },
  {
    genesis_token_id: 9879,
    wearable_ids: [407, 376],
  },
  {
    genesis_token_id: 9880,
    wearable_ids: [389, 396],
  },
  {
    genesis_token_id: 9881,
    wearable_ids: [264, 412],
  },
  {
    genesis_token_id: 9882,
    wearable_ids: [258, 428],
  },
  {
    genesis_token_id: 9883,
    wearable_ids: [383, 402],
  },
  {
    genesis_token_id: 9884,
    wearable_ids: [258, 297],
  },
  {
    genesis_token_id: 9885,
    wearable_ids: [324, 270],
  },
  {
    genesis_token_id: 9886,
    wearable_ids: [284, 396],
  },
  {
    genesis_token_id: 9887,
    wearable_ids: [374, 383],
  },
  {
    genesis_token_id: 9888,
    wearable_ids: [287, 256],
  },
  {
    genesis_token_id: 9889,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 9890,
    wearable_ids: [306, 343],
  },
  {
    genesis_token_id: 9891,
    wearable_ids: [324, 338],
  },
  {
    genesis_token_id: 9892,
    wearable_ids: [301, 249],
  },
  {
    genesis_token_id: 9893,
    wearable_ids: [301, 343],
  },
  {
    genesis_token_id: 9894,
    wearable_ids: [303, 440],
  },
  {
    genesis_token_id: 9895,
    wearable_ids: [346, 338],
  },
  {
    genesis_token_id: 9896,
    wearable_ids: [258, 399],
  },
  {
    genesis_token_id: 9897,
    wearable_ids: [292, 369],
  },
  {
    genesis_token_id: 9898,
    wearable_ids: [311, 404],
  },
  {
    genesis_token_id: 9899,
    wearable_ids: [413, 277],
  },
  {
    genesis_token_id: 9900,
    wearable_ids: [251, 412],
  },
  {
    genesis_token_id: 9901,
    wearable_ids: [369, 304],
  },
  {
    genesis_token_id: 9902,
    wearable_ids: [371, 395],
  },
  {
    genesis_token_id: 9903,
    wearable_ids: [364, 301],
  },
  {
    genesis_token_id: 9904,
    wearable_ids: [349, 269],
  },
  {
    genesis_token_id: 9905,
    wearable_ids: [270, 346],
  },
  {
    genesis_token_id: 9906,
    wearable_ids: [410, 268],
  },
  {
    genesis_token_id: 9907,
    wearable_ids: [296, 325],
  },
  {
    genesis_token_id: 9908,
    wearable_ids: [397, 268],
  },
  {
    genesis_token_id: 9909,
    wearable_ids: [266, 432],
  },
  {
    genesis_token_id: 9910,
    wearable_ids: [431, 394],
  },
  {
    genesis_token_id: 9911,
    wearable_ids: [335, 301],
  },
  {
    genesis_token_id: 9912,
    wearable_ids: [265, 280],
  },
  {
    genesis_token_id: 9913,
    wearable_ids: [325, 349],
  },
  {
    genesis_token_id: 9914,
    wearable_ids: [410, 290],
  },
  {
    genesis_token_id: 9915,
    wearable_ids: [433, 341],
  },
  {
    genesis_token_id: 9916,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 9917,
    wearable_ids: [255, 408],
  },
  {
    genesis_token_id: 9918,
    wearable_ids: [410, 295],
  },
  {
    genesis_token_id: 9919,
    wearable_ids: [286, 373],
  },
  {
    genesis_token_id: 9920,
    wearable_ids: [375, 383],
  },
  {
    genesis_token_id: 9921,
    wearable_ids: [294, 370],
  },
  {
    genesis_token_id: 9922,
    wearable_ids: [316, 373],
  },
  {
    genesis_token_id: 9923,
    wearable_ids: [284, 431],
  },
  {
    genesis_token_id: 9924,
    wearable_ids: [395, 422],
  },
  {
    genesis_token_id: 9925,
    wearable_ids: [256, 443],
  },
  {
    genesis_token_id: 9926,
    wearable_ids: [278, 392],
  },
  {
    genesis_token_id: 9927,
    wearable_ids: [378, 348],
  },
  {
    genesis_token_id: 9928,
    wearable_ids: [268, 408],
  },
  {
    genesis_token_id: 9929,
    wearable_ids: [375, 270],
  },
  {
    genesis_token_id: 9930,
    wearable_ids: [406, 388],
  },
  {
    genesis_token_id: 9931,
    wearable_ids: [274, 253],
  },
  {
    genesis_token_id: 9932,
    wearable_ids: [347, 310],
  },
  {
    genesis_token_id: 9933,
    wearable_ids: [378, 333],
  },
  {
    genesis_token_id: 9934,
    wearable_ids: [304, 255],
  },
  {
    genesis_token_id: 9935,
    wearable_ids: [296, 420],
  },
  {
    genesis_token_id: 9936,
    wearable_ids: [378, 420],
  },
  {
    genesis_token_id: 9937,
    wearable_ids: [256, 382],
  },
  {
    genesis_token_id: 9938,
    wearable_ids: [316, 265],
  },
  {
    genesis_token_id: 9939,
    wearable_ids: [410, 376],
  },
  {
    genesis_token_id: 9940,
    wearable_ids: [316, 404],
  },
  {
    genesis_token_id: 9941,
    wearable_ids: [407, 351],
  },
  {
    genesis_token_id: 9942,
    wearable_ids: [444, 429],
  },
  {
    genesis_token_id: 9943,
    wearable_ids: [372, 323],
  },
  {
    genesis_token_id: 9944,
    wearable_ids: [287, 392],
  },
  {
    genesis_token_id: 9945,
    wearable_ids: [429, 416],
  },
  {
    genesis_token_id: 9946,
    wearable_ids: [404, 296],
  },
  {
    genesis_token_id: 9947,
    wearable_ids: [247, 289],
  },
  {
    genesis_token_id: 9948,
    wearable_ids: [324, 435],
  },
  {
    genesis_token_id: 9949,
    wearable_ids: [435, 300],
  },
  {
    genesis_token_id: 9950,
    wearable_ids: [268, 364],
  },
  {
    genesis_token_id: 9951,
    wearable_ids: [287, 428],
  },
  {
    genesis_token_id: 9952,
    wearable_ids: [374, 304],
  },
  {
    genesis_token_id: 9953,
    wearable_ids: [400, 308],
  },
  {
    genesis_token_id: 9954,
    wearable_ids: [399, 318],
  },
  {
    genesis_token_id: 9955,
    wearable_ids: [428, 436],
  },
  {
    genesis_token_id: 9956,
    wearable_ids: [370, 299],
  },
  {
    genesis_token_id: 9957,
    wearable_ids: [343, 336],
  },
  {
    genesis_token_id: 9958,
    wearable_ids: [264, 271],
  },
  {
    genesis_token_id: 9959,
    wearable_ids: [434, 340],
  },
  {
    genesis_token_id: 9960,
    wearable_ids: [412, 400],
  },
  {
    genesis_token_id: 9961,
    wearable_ids: [443, 250],
  },
  {
    genesis_token_id: 9962,
    wearable_ids: [284, 385],
  },
  {
    genesis_token_id: 9963,
    wearable_ids: [378, 364],
  },
  {
    genesis_token_id: 9964,
    wearable_ids: [346, 328],
  },
  {
    genesis_token_id: 9965,
    wearable_ids: [294, 342],
  },
  {
    genesis_token_id: 9966,
    wearable_ids: [406, 404],
  },
  {
    genesis_token_id: 9967,
    wearable_ids: [254, 291],
  },
  {
    genesis_token_id: 9968,
    wearable_ids: [311, 341],
  },
  {
    genesis_token_id: 9969,
    wearable_ids: [370, 430],
  },
  {
    genesis_token_id: 9970,
    wearable_ids: [271, 334],
  },
  {
    genesis_token_id: 9971,
    wearable_ids: [286, 378],
  },
  {
    genesis_token_id: 9972,
    wearable_ids: [382, 266],
  },
  {
    genesis_token_id: 9973,
    wearable_ids: [355, 306],
  },
  {
    genesis_token_id: 9974,
    wearable_ids: [335, 343],
  },
  {
    genesis_token_id: 9975,
    wearable_ids: [300, 337],
  },
  {
    genesis_token_id: 9976,
    wearable_ids: [384, 348],
  },
  {
    genesis_token_id: 9977,
    wearable_ids: [351, 399],
  },
  {
    genesis_token_id: 9978,
    wearable_ids: [300, 289],
  },
  {
    genesis_token_id: 9979,
    wearable_ids: [411, 310],
  },
  {
    genesis_token_id: 9980,
    wearable_ids: [346, 397],
  },
  {
    genesis_token_id: 9981,
    wearable_ids: [428, 365],
  },
  {
    genesis_token_id: 9982,
    wearable_ids: [276, 363],
  },
  {
    genesis_token_id: 9983,
    wearable_ids: [424, 437],
  },
  {
    genesis_token_id: 9984,
    wearable_ids: [325, 442],
  },
  {
    genesis_token_id: 9985,
    wearable_ids: [308, 288],
  },
  {
    genesis_token_id: 9986,
    wearable_ids: [424, 396],
  },
  {
    genesis_token_id: 9987,
    wearable_ids: [248, 389],
  },
  {
    genesis_token_id: 9988,
    wearable_ids: [407, 347],
  },
  {
    genesis_token_id: 9989,
    wearable_ids: [408, 290],
  },
  {
    genesis_token_id: 9990,
    wearable_ids: [284, 316],
  },
  {
    genesis_token_id: 9991,
    wearable_ids: [426, 364],
  },
  {
    genesis_token_id: 9992,
    wearable_ids: [296, 260],
  },
  {
    genesis_token_id: 9993,
    wearable_ids: [270, 364],
  },
  {
    genesis_token_id: 9994,
    wearable_ids: [429, 303],
  },
  {
    genesis_token_id: 9995,
    wearable_ids: [301, 361],
  },
  {
    genesis_token_id: 9996,
    wearable_ids: [364, 316],
  },
  {
    genesis_token_id: 9997,
    wearable_ids: [434, 303],
  },
  {
    genesis_token_id: 9998,
    wearable_ids: [271, 258],
  },
  {
    genesis_token_id: 9999,
    wearable_ids: [425, 255],
  },
  {
    genesis_token_id: 10000,
    wearable_ids: [292, 437],
  },
  {
    genesis_token_id: 10001,
    wearable_ids: [374, 274],
  },
  {
    genesis_token_id: 10002,
    wearable_ids: [435, 413],
  },
  {
    genesis_token_id: 10003,
    wearable_ids: [277, 386],
  },
  {
    genesis_token_id: 10004,
    wearable_ids: [262, 387],
  },
  {
    genesis_token_id: 10005,
    wearable_ids: [290, 406],
  },
  {
    genesis_token_id: 10006,
    wearable_ids: [407, 362],
  },
  {
    genesis_token_id: 10007,
    wearable_ids: [385, 372],
  },
  {
    genesis_token_id: 10008,
    wearable_ids: [444, 336],
  },
  {
    genesis_token_id: 10009,
    wearable_ids: [406, 257],
  },
  {
    genesis_token_id: 10010,
    wearable_ids: [276, 301],
  },
  {
    genesis_token_id: 10011,
    wearable_ids: [373, 365],
  },
  {
    genesis_token_id: 10012,
    wearable_ids: [370, 364],
  },
  {
    genesis_token_id: 10013,
    wearable_ids: [297, 373],
  },
  {
    genesis_token_id: 10014,
    wearable_ids: [410, 350],
  },
  {
    genesis_token_id: 10015,
    wearable_ids: [344, 375],
  },
  {
    genesis_token_id: 10016,
    wearable_ids: [294, 437],
  },
  {
    genesis_token_id: 10017,
    wearable_ids: [415, 434],
  },
  {
    genesis_token_id: 10018,
    wearable_ids: [389, 281],
  },
  {
    genesis_token_id: 10019,
    wearable_ids: [316, 417],
  },
  {
    genesis_token_id: 10020,
    wearable_ids: [435, 327],
  },
  {
    genesis_token_id: 10021,
    wearable_ids: [266, 326],
  },
  {
    genesis_token_id: 10022,
    wearable_ids: [324, 285],
  },
  {
    genesis_token_id: 10023,
    wearable_ids: [287, 304],
  },
  {
    genesis_token_id: 10024,
    wearable_ids: [303, 320],
  },
  {
    genesis_token_id: 10025,
    wearable_ids: [289, 264],
  },
  {
    genesis_token_id: 10026,
    wearable_ids: [276, 410],
  },
  {
    genesis_token_id: 10027,
    wearable_ids: [272, 291],
  },
  {
    genesis_token_id: 10028,
    wearable_ids: [431, 263],
  },
  {
    genesis_token_id: 10029,
    wearable_ids: [409, 372],
  },
  {
    genesis_token_id: 10030,
    wearable_ids: [259, 246],
  },
  {
    genesis_token_id: 10031,
    wearable_ids: [382, 289],
  },
  {
    genesis_token_id: 10032,
    wearable_ids: [301, 351],
  },
  {
    genesis_token_id: 10033,
    wearable_ids: [338, 357],
  },
  {
    genesis_token_id: 10034,
    wearable_ids: [291, 423],
  },
  {
    genesis_token_id: 10035,
    wearable_ids: [376, 317],
  },
  {
    genesis_token_id: 10036,
    wearable_ids: [247, 363],
  },
  {
    genesis_token_id: 10037,
    wearable_ids: [408, 271],
  },
  {
    genesis_token_id: 10038,
    wearable_ids: [314, 343],
  },
  {
    genesis_token_id: 10039,
    wearable_ids: [425, 403],
  },
  {
    genesis_token_id: 10040,
    wearable_ids: [266, 440],
  },
  {
    genesis_token_id: 10041,
    wearable_ids: [337, 319],
  },
  {
    genesis_token_id: 10042,
    wearable_ids: [315, 257],
  },
  {
    genesis_token_id: 10043,
    wearable_ids: [264, 262],
  },
  {
    genesis_token_id: 10044,
    wearable_ids: [362, 434],
  },
  {
    genesis_token_id: 10045,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 10046,
    wearable_ids: [325, 426],
  },
  {
    genesis_token_id: 10047,
    wearable_ids: [429, 291],
  },
  {
    genesis_token_id: 10048,
    wearable_ids: [270, 357],
  },
  {
    genesis_token_id: 10049,
    wearable_ids: [432, 429],
  },
  {
    genesis_token_id: 10050,
    wearable_ids: [437, 355],
  },
  {
    genesis_token_id: 10051,
    wearable_ids: [396, 303],
  },
  {
    genesis_token_id: 10052,
    wearable_ids: [253, 400],
  },
  {
    genesis_token_id: 10053,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 10054,
    wearable_ids: [410, 396],
  },
  {
    genesis_token_id: 10055,
    wearable_ids: [420, 331],
  },
  {
    genesis_token_id: 10056,
    wearable_ids: [276, 414],
  },
  {
    genesis_token_id: 10057,
    wearable_ids: [434, 363],
  },
  {
    genesis_token_id: 10058,
    wearable_ids: [399, 385],
  },
  {
    genesis_token_id: 10059,
    wearable_ids: [254, 442],
  },
  {
    genesis_token_id: 10060,
    wearable_ids: [362, 319],
  },
  {
    genesis_token_id: 10061,
    wearable_ids: [337, 290],
  },
  {
    genesis_token_id: 10062,
    wearable_ids: [308, 292],
  },
  {
    genesis_token_id: 10063,
    wearable_ids: [369, 400],
  },
  {
    genesis_token_id: 10064,
    wearable_ids: [407, 337],
  },
  {
    genesis_token_id: 10065,
    wearable_ids: [368, 311],
  },
  {
    genesis_token_id: 10066,
    wearable_ids: [326, 287],
  },
  {
    genesis_token_id: 10067,
    wearable_ids: [413, 434],
  },
  {
    genesis_token_id: 10068,
    wearable_ids: [377, 419],
  },
  {
    genesis_token_id: 10069,
    wearable_ids: [397, 248],
  },
  {
    genesis_token_id: 10070,
    wearable_ids: [341, 352],
  },
  {
    genesis_token_id: 10071,
    wearable_ids: [325, 386],
  },
  {
    genesis_token_id: 10072,
    wearable_ids: [292, 375],
  },
  {
    genesis_token_id: 10073,
    wearable_ids: [253, 320],
  },
  {
    genesis_token_id: 10074,
    wearable_ids: [303, 263],
  },
  {
    genesis_token_id: 10075,
    wearable_ids: [415, 361],
  },
  {
    genesis_token_id: 10076,
    wearable_ids: [368, 292],
  },
  {
    genesis_token_id: 10077,
    wearable_ids: [369, 304],
  },
  {
    genesis_token_id: 10078,
    wearable_ids: [256, 319],
  },
  {
    genesis_token_id: 10079,
    wearable_ids: [276, 443],
  },
  {
    genesis_token_id: 10080,
    wearable_ids: [373, 400],
  },
  {
    genesis_token_id: 10081,
    wearable_ids: [301, 401],
  },
  {
    genesis_token_id: 10082,
    wearable_ids: [262, 251],
  },
  {
    genesis_token_id: 10083,
    wearable_ids: [350, 274],
  },
  {
    genesis_token_id: 10084,
    wearable_ids: [407, 384],
  },
  {
    genesis_token_id: 10085,
    wearable_ids: [415, 284],
  },
  {
    genesis_token_id: 10086,
    wearable_ids: [431, 271],
  },
  {
    genesis_token_id: 10087,
    wearable_ids: [339, 317],
  },
  {
    genesis_token_id: 10088,
    wearable_ids: [254, 307],
  },
  {
    genesis_token_id: 10089,
    wearable_ids: [389, 250],
  },
  {
    genesis_token_id: 10090,
    wearable_ids: [386, 327],
  },
  {
    genesis_token_id: 10091,
    wearable_ids: [301, 411],
  },
  {
    genesis_token_id: 10092,
    wearable_ids: [363, 416],
  },
  {
    genesis_token_id: 10093,
    wearable_ids: [409, 418],
  },
  {
    genesis_token_id: 10094,
    wearable_ids: [254, 396],
  },
  {
    genesis_token_id: 10095,
    wearable_ids: [426, 286],
  },
  {
    genesis_token_id: 10096,
    wearable_ids: [376, 353],
  },
  {
    genesis_token_id: 10097,
    wearable_ids: [277, 350],
  },
  {
    genesis_token_id: 10098,
    wearable_ids: [403, 280],
  },
  {
    genesis_token_id: 10099,
    wearable_ids: [251, 392],
  },
  {
    genesis_token_id: 10100,
    wearable_ids: [295, 348],
  },
  {
    genesis_token_id: 10101,
    wearable_ids: [284, 437],
  },
  {
    genesis_token_id: 10102,
    wearable_ids: [413, 373],
  },
  {
    genesis_token_id: 10103,
    wearable_ids: [262, 341],
  },
  {
    genesis_token_id: 10104,
    wearable_ids: [301, 288],
  },
  {
    genesis_token_id: 10105,
    wearable_ids: [300, 340],
  },
  {
    genesis_token_id: 10106,
    wearable_ids: [371, 341],
  },
  {
    genesis_token_id: 10107,
    wearable_ids: [299, 415],
  },
  {
    genesis_token_id: 10108,
    wearable_ids: [422, 376],
  },
  {
    genesis_token_id: 10109,
    wearable_ids: [274, 325],
  },
  {
    genesis_token_id: 10110,
    wearable_ids: [365, 362],
  },
  {
    genesis_token_id: 10111,
    wearable_ids: [266, 345],
  },
  {
    genesis_token_id: 10112,
    wearable_ids: [423, 312],
  },
  {
    genesis_token_id: 10113,
    wearable_ids: [444, 296],
  },
  {
    genesis_token_id: 10114,
    wearable_ids: [259, 387],
  },
  {
    genesis_token_id: 10115,
    wearable_ids: [354, 284],
  },
  {
    genesis_token_id: 10116,
    wearable_ids: [373, 300],
  },
  {
    genesis_token_id: 10117,
    wearable_ids: [337, 314],
  },
  {
    genesis_token_id: 10118,
    wearable_ids: [363, 274],
  },
  {
    genesis_token_id: 10119,
    wearable_ids: [383, 295],
  },
  {
    genesis_token_id: 10120,
    wearable_ids: [273, 394],
  },
  {
    genesis_token_id: 10121,
    wearable_ids: [294, 256],
  },
  {
    genesis_token_id: 10122,
    wearable_ids: [340, 428],
  },
  {
    genesis_token_id: 10123,
    wearable_ids: [363, 414],
  },
  {
    genesis_token_id: 10124,
    wearable_ids: [266, 328],
  },
  {
    genesis_token_id: 10125,
    wearable_ids: [389, 435],
  },
  {
    genesis_token_id: 10126,
    wearable_ids: [273, 346],
  },
  {
    genesis_token_id: 10127,
    wearable_ids: [432, 297],
  },
  {
    genesis_token_id: 10128,
    wearable_ids: [332, 352],
  },
  {
    genesis_token_id: 10129,
    wearable_ids: [297, 249],
  },
  {
    genesis_token_id: 10130,
    wearable_ids: [431, 292],
  },
  {
    genesis_token_id: 10131,
    wearable_ids: [434, 445],
  },
  {
    genesis_token_id: 10132,
    wearable_ids: [386, 345],
  },
  {
    genesis_token_id: 10133,
    wearable_ids: [256, 296],
  },
  {
    genesis_token_id: 10134,
    wearable_ids: [336, 304],
  },
  {
    genesis_token_id: 10135,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 10136,
    wearable_ids: [326, 413],
  },
  {
    genesis_token_id: 10137,
    wearable_ids: [337, 420],
  },
  {
    genesis_token_id: 10138,
    wearable_ids: [348, 305],
  },
  {
    genesis_token_id: 10139,
    wearable_ids: [286, 428],
  },
  {
    genesis_token_id: 10140,
    wearable_ids: [270, 263],
  },
  {
    genesis_token_id: 10141,
    wearable_ids: [369, 358],
  },
  {
    genesis_token_id: 10142,
    wearable_ids: [365, 415],
  },
  {
    genesis_token_id: 10143,
    wearable_ids: [428, 410],
  },
  {
    genesis_token_id: 10144,
    wearable_ids: [399, 364],
  },
  {
    genesis_token_id: 10145,
    wearable_ids: [363, 317],
  },
  {
    genesis_token_id: 10146,
    wearable_ids: [335, 336],
  },
  {
    genesis_token_id: 10147,
    wearable_ids: [253, 344],
  },
  {
    genesis_token_id: 10148,
    wearable_ids: [335, 316],
  },
  {
    genesis_token_id: 10149,
    wearable_ids: [442, 310],
  },
  {
    genesis_token_id: 10150,
    wearable_ids: [278, 272],
  },
  {
    genesis_token_id: 10151,
    wearable_ids: [431, 333],
  },
  {
    genesis_token_id: 10152,
    wearable_ids: [351, 263],
  },
  {
    genesis_token_id: 10153,
    wearable_ids: [324, 413],
  },
  {
    genesis_token_id: 10154,
    wearable_ids: [251, 386],
  },
  {
    genesis_token_id: 10155,
    wearable_ids: [407, 432],
  },
  {
    genesis_token_id: 10156,
    wearable_ids: [354, 362],
  },
  {
    genesis_token_id: 10157,
    wearable_ids: [263, 350],
  },
  {
    genesis_token_id: 10158,
    wearable_ids: [253, 303],
  },
  {
    genesis_token_id: 10159,
    wearable_ids: [308, 300],
  },
  {
    genesis_token_id: 10160,
    wearable_ids: [399, 363],
  },
  {
    genesis_token_id: 10161,
    wearable_ids: [377, 359],
  },
  {
    genesis_token_id: 10162,
    wearable_ids: [422, 398],
  },
  {
    genesis_token_id: 10163,
    wearable_ids: [256, 384],
  },
  {
    genesis_token_id: 10164,
    wearable_ids: [408, 382],
  },
  {
    genesis_token_id: 10165,
    wearable_ids: [314, 383],
  },
  {
    genesis_token_id: 10166,
    wearable_ids: [256, 428],
  },
  {
    genesis_token_id: 10167,
    wearable_ids: [276, 378],
  },
  {
    genesis_token_id: 10168,
    wearable_ids: [442, 361],
  },
  {
    genesis_token_id: 10169,
    wearable_ids: [257, 262],
  },
  {
    genesis_token_id: 10170,
    wearable_ids: [407, 319],
  },
  {
    genesis_token_id: 10171,
    wearable_ids: [303, 397],
  },
  {
    genesis_token_id: 10172,
    wearable_ids: [338, 415],
  },
  {
    genesis_token_id: 10173,
    wearable_ids: [251, 411],
  },
  {
    genesis_token_id: 10174,
    wearable_ids: [344, 366],
  },
  {
    genesis_token_id: 10175,
    wearable_ids: [363, 375],
  },
  {
    genesis_token_id: 10176,
    wearable_ids: [263, 352],
  },
  {
    genesis_token_id: 10177,
    wearable_ids: [268, 369],
  },
  {
    genesis_token_id: 10178,
    wearable_ids: [349, 254],
  },
  {
    genesis_token_id: 10179,
    wearable_ids: [247, 299],
  },
  {
    genesis_token_id: 10180,
    wearable_ids: [410, 404],
  },
  {
    genesis_token_id: 10181,
    wearable_ids: [339, 254],
  },
  {
    genesis_token_id: 10182,
    wearable_ids: [304, 404],
  },
  {
    genesis_token_id: 10183,
    wearable_ids: [409, 311],
  },
  {
    genesis_token_id: 10184,
    wearable_ids: [326, 264],
  },
  {
    genesis_token_id: 10185,
    wearable_ids: [344, 262],
  },
  {
    genesis_token_id: 10186,
    wearable_ids: [389, 352],
  },
  {
    genesis_token_id: 10187,
    wearable_ids: [314, 372],
  },
  {
    genesis_token_id: 10188,
    wearable_ids: [422, 382],
  },
  {
    genesis_token_id: 10189,
    wearable_ids: [403, 331],
  },
  {
    genesis_token_id: 10190,
    wearable_ids: [370, 254],
  },
  {
    genesis_token_id: 10191,
    wearable_ids: [257, 415],
  },
  {
    genesis_token_id: 10192,
    wearable_ids: [311, 409],
  },
  {
    genesis_token_id: 10193,
    wearable_ids: [412, 334],
  },
  {
    genesis_token_id: 10194,
    wearable_ids: [354, 284],
  },
  {
    genesis_token_id: 10195,
    wearable_ids: [270, 254],
  },
  {
    genesis_token_id: 10196,
    wearable_ids: [397, 432],
  },
  {
    genesis_token_id: 10197,
    wearable_ids: [271, 428],
  },
  {
    genesis_token_id: 10198,
    wearable_ids: [303, 385],
  },
  {
    genesis_token_id: 10199,
    wearable_ids: [397, 291],
  },
  {
    genesis_token_id: 10200,
    wearable_ids: [396, 249],
  },
  {
    genesis_token_id: 10201,
    wearable_ids: [294, 355],
  },
  {
    genesis_token_id: 10202,
    wearable_ids: [270, 373],
  },
  {
    genesis_token_id: 10203,
    wearable_ids: [386, 352],
  },
  {
    genesis_token_id: 10204,
    wearable_ids: [315, 356],
  },
  {
    genesis_token_id: 10205,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 10206,
    wearable_ids: [354, 340],
  },
  {
    genesis_token_id: 10207,
    wearable_ids: [270, 378],
  },
  {
    genesis_token_id: 10208,
    wearable_ids: [257, 442],
  },
  {
    genesis_token_id: 10209,
    wearable_ids: [429, 334],
  },
  {
    genesis_token_id: 10210,
    wearable_ids: [445, 389],
  },
  {
    genesis_token_id: 10211,
    wearable_ids: [382, 317],
  },
  {
    genesis_token_id: 10212,
    wearable_ids: [319, 437],
  },
  {
    genesis_token_id: 10213,
    wearable_ids: [431, 253],
  },
  {
    genesis_token_id: 10214,
    wearable_ids: [363, 356],
  },
  {
    genesis_token_id: 10215,
    wearable_ids: [433, 285],
  },
  {
    genesis_token_id: 10216,
    wearable_ids: [435, 383],
  },
  {
    genesis_token_id: 10217,
    wearable_ids: [425, 266],
  },
  {
    genesis_token_id: 10218,
    wearable_ids: [422, 364],
  },
  {
    genesis_token_id: 10219,
    wearable_ids: [258, 295],
  },
  {
    genesis_token_id: 10220,
    wearable_ids: [425, 415],
  },
  {
    genesis_token_id: 10221,
    wearable_ids: [338, 400],
  },
  {
    genesis_token_id: 10222,
    wearable_ids: [304, 335],
  },
  {
    genesis_token_id: 10223,
    wearable_ids: [371, 272],
  },
  {
    genesis_token_id: 10224,
    wearable_ids: [286, 322],
  },
  {
    genesis_token_id: 10225,
    wearable_ids: [255, 396],
  },
  {
    genesis_token_id: 10226,
    wearable_ids: [410, 428],
  },
  {
    genesis_token_id: 10227,
    wearable_ids: [351, 404],
  },
  {
    genesis_token_id: 10228,
    wearable_ids: [344, 408],
  },
  {
    genesis_token_id: 10229,
    wearable_ids: [286, 404],
  },
  {
    genesis_token_id: 10230,
    wearable_ids: [383, 407],
  },
  {
    genesis_token_id: 10231,
    wearable_ids: [294, 336],
  },
  {
    genesis_token_id: 10232,
    wearable_ids: [444, 302],
  },
  {
    genesis_token_id: 10233,
    wearable_ids: [247, 358],
  },
  {
    genesis_token_id: 10234,
    wearable_ids: [292, 324],
  },
  {
    genesis_token_id: 10235,
    wearable_ids: [374, 375],
  },
  {
    genesis_token_id: 10236,
    wearable_ids: [257, 251],
  },
  {
    genesis_token_id: 10237,
    wearable_ids: [347, 325],
  },
  {
    genesis_token_id: 10238,
    wearable_ids: [265, 355],
  },
  {
    genesis_token_id: 10239,
    wearable_ids: [387, 426],
  },
  {
    genesis_token_id: 10240,
    wearable_ids: [355, 434],
  },
  {
    genesis_token_id: 10241,
    wearable_ids: [445, 325],
  },
  {
    genesis_token_id: 10242,
    wearable_ids: [422, 395],
  },
  {
    genesis_token_id: 10243,
    wearable_ids: [395, 392],
  },
  {
    genesis_token_id: 10244,
    wearable_ids: [399, 276],
  },
  {
    genesis_token_id: 10245,
    wearable_ids: [268, 262],
  },
  {
    genesis_token_id: 10246,
    wearable_ids: [363, 326],
  },
  {
    genesis_token_id: 10247,
    wearable_ids: [422, 399],
  },
  {
    genesis_token_id: 10248,
    wearable_ids: [257, 259],
  },
  {
    genesis_token_id: 10249,
    wearable_ids: [251, 432],
  },
  {
    genesis_token_id: 10250,
    wearable_ids: [384, 247],
  },
  {
    genesis_token_id: 10251,
    wearable_ids: [413, 346],
  },
  {
    genesis_token_id: 10252,
    wearable_ids: [372, 366],
  },
  {
    genesis_token_id: 10253,
    wearable_ids: [268, 248],
  },
  {
    genesis_token_id: 10254,
    wearable_ids: [370, 344],
  },
  {
    genesis_token_id: 10255,
    wearable_ids: [292, 352],
  },
  {
    genesis_token_id: 10256,
    wearable_ids: [280, 333],
  },
  {
    genesis_token_id: 10257,
    wearable_ids: [291, 319],
  },
  {
    genesis_token_id: 10258,
    wearable_ids: [268, 373],
  },
  {
    genesis_token_id: 10259,
    wearable_ids: [420, 403],
  },
  {
    genesis_token_id: 10260,
    wearable_ids: [342, 429],
  },
  {
    genesis_token_id: 10261,
    wearable_ids: [265, 340],
  },
  {
    genesis_token_id: 10262,
    wearable_ids: [296, 399],
  },
  {
    genesis_token_id: 10263,
    wearable_ids: [354, 410],
  },
  {
    genesis_token_id: 10264,
    wearable_ids: [316, 253],
  },
  {
    genesis_token_id: 10265,
    wearable_ids: [409, 377],
  },
  {
    genesis_token_id: 10266,
    wearable_ids: [369, 372],
  },
  {
    genesis_token_id: 10267,
    wearable_ids: [300, 317],
  },
  {
    genesis_token_id: 10268,
    wearable_ids: [304, 369],
  },
  {
    genesis_token_id: 10269,
    wearable_ids: [383, 385],
  },
  {
    genesis_token_id: 10270,
    wearable_ids: [426, 346],
  },
  {
    genesis_token_id: 10271,
    wearable_ids: [385, 306],
  },
  {
    genesis_token_id: 10272,
    wearable_ids: [339, 414],
  },
  {
    genesis_token_id: 10273,
    wearable_ids: [352, 410],
  },
  {
    genesis_token_id: 10274,
    wearable_ids: [396, 247],
  },
  {
    genesis_token_id: 10275,
    wearable_ids: [272, 350],
  },
  {
    genesis_token_id: 10276,
    wearable_ids: [280, 384],
  },
  {
    genesis_token_id: 10277,
    wearable_ids: [287, 389],
  },
  {
    genesis_token_id: 10278,
    wearable_ids: [431, 284],
  },
  {
    genesis_token_id: 10279,
    wearable_ids: [311, 300],
  },
  {
    genesis_token_id: 10280,
    wearable_ids: [407, 348],
  },
  {
    genesis_token_id: 10281,
    wearable_ids: [432, 251],
  },
  {
    genesis_token_id: 10282,
    wearable_ids: [428, 308],
  },
  {
    genesis_token_id: 10283,
    wearable_ids: [338, 265],
  },
  {
    genesis_token_id: 10284,
    wearable_ids: [304, 378],
  },
  {
    genesis_token_id: 10285,
    wearable_ids: [341, 278],
  },
  {
    genesis_token_id: 10286,
    wearable_ids: [255, 286],
  },
  {
    genesis_token_id: 10287,
    wearable_ids: [342, 303],
  },
  {
    genesis_token_id: 10288,
    wearable_ids: [277, 364],
  },
  {
    genesis_token_id: 10289,
    wearable_ids: [364, 305],
  },
  {
    genesis_token_id: 10290,
    wearable_ids: [319, 417],
  },
  {
    genesis_token_id: 10291,
    wearable_ids: [314, 257],
  },
  {
    genesis_token_id: 10292,
    wearable_ids: [428, 338],
  },
  {
    genesis_token_id: 10293,
    wearable_ids: [436, 319],
  },
  {
    genesis_token_id: 10294,
    wearable_ids: [297, 423],
  },
  {
    genesis_token_id: 10295,
    wearable_ids: [444, 351],
  },
  {
    genesis_token_id: 10296,
    wearable_ids: [354, 300],
  },
  {
    genesis_token_id: 10297,
    wearable_ids: [319, 326],
  },
  {
    genesis_token_id: 10298,
    wearable_ids: [442, 262],
  },
  {
    genesis_token_id: 10299,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 10300,
    wearable_ids: [347, 327],
  },
  {
    genesis_token_id: 10301,
    wearable_ids: [428, 406],
  },
  {
    genesis_token_id: 10302,
    wearable_ids: [355, 401],
  },
  {
    genesis_token_id: 10303,
    wearable_ids: [428, 427],
  },
  {
    genesis_token_id: 10304,
    wearable_ids: [271, 385],
  },
  {
    genesis_token_id: 10305,
    wearable_ids: [434, 410],
  },
  {
    genesis_token_id: 10306,
    wearable_ids: [251, 358],
  },
  {
    genesis_token_id: 10307,
    wearable_ids: [389, 410],
  },
  {
    genesis_token_id: 10308,
    wearable_ids: [420, 430],
  },
  {
    genesis_token_id: 10309,
    wearable_ids: [445, 435],
  },
  {
    genesis_token_id: 10310,
    wearable_ids: [396, 306],
  },
  {
    genesis_token_id: 10311,
    wearable_ids: [408, 328],
  },
  {
    genesis_token_id: 10312,
    wearable_ids: [376, 434],
  },
  {
    genesis_token_id: 10313,
    wearable_ids: [385, 272],
  },
  {
    genesis_token_id: 10314,
    wearable_ids: [369, 407],
  },
  {
    genesis_token_id: 10315,
    wearable_ids: [386, 260],
  },
  {
    genesis_token_id: 10316,
    wearable_ids: [378, 276],
  },
  {
    genesis_token_id: 10317,
    wearable_ids: [373, 360],
  },
  {
    genesis_token_id: 10318,
    wearable_ids: [386, 426],
  },
  {
    genesis_token_id: 10319,
    wearable_ids: [342, 310],
  },
  {
    genesis_token_id: 10320,
    wearable_ids: [435, 257],
  },
  {
    genesis_token_id: 10321,
    wearable_ids: [256, 342],
  },
  {
    genesis_token_id: 10322,
    wearable_ids: [375, 327],
  },
  {
    genesis_token_id: 10323,
    wearable_ids: [291, 335],
  },
  {
    genesis_token_id: 10324,
    wearable_ids: [265, 254],
  },
  {
    genesis_token_id: 10325,
    wearable_ids: [287, 273],
  },
  {
    genesis_token_id: 10326,
    wearable_ids: [423, 352],
  },
  {
    genesis_token_id: 10327,
    wearable_ids: [251, 253],
  },
  {
    genesis_token_id: 10328,
    wearable_ids: [335, 328],
  },
  {
    genesis_token_id: 10329,
    wearable_ids: [341, 278],
  },
  {
    genesis_token_id: 10330,
    wearable_ids: [332, 436],
  },
  {
    genesis_token_id: 10331,
    wearable_ids: [365, 271],
  },
  {
    genesis_token_id: 10332,
    wearable_ids: [264, 341],
  },
  {
    genesis_token_id: 10333,
    wearable_ids: [371, 411],
  },
  {
    genesis_token_id: 10334,
    wearable_ids: [266, 423],
  },
  {
    genesis_token_id: 10335,
    wearable_ids: [428, 308],
  },
  {
    genesis_token_id: 10336,
    wearable_ids: [284, 386],
  },
  {
    genesis_token_id: 10337,
    wearable_ids: [383, 410],
  },
  {
    genesis_token_id: 10338,
    wearable_ids: [415, 311],
  },
  {
    genesis_token_id: 10339,
    wearable_ids: [432, 383],
  },
  {
    genesis_token_id: 10340,
    wearable_ids: [337, 284],
  },
  {
    genesis_token_id: 10341,
    wearable_ids: [296, 339],
  },
  {
    genesis_token_id: 10342,
    wearable_ids: [326, 369],
  },
  {
    genesis_token_id: 10343,
    wearable_ids: [382, 351],
  },
  {
    genesis_token_id: 10344,
    wearable_ids: [362, 258],
  },
  {
    genesis_token_id: 10345,
    wearable_ids: [263, 316],
  },
  {
    genesis_token_id: 10346,
    wearable_ids: [370, 258],
  },
  {
    genesis_token_id: 10347,
    wearable_ids: [304, 332],
  },
  {
    genesis_token_id: 10348,
    wearable_ids: [308, 334],
  },
  {
    genesis_token_id: 10349,
    wearable_ids: [396, 278],
  },
  {
    genesis_token_id: 10350,
    wearable_ids: [296, 273],
  },
  {
    genesis_token_id: 10351,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 10352,
    wearable_ids: [264, 271],
  },
  {
    genesis_token_id: 10353,
    wearable_ids: [257, 407],
  },
  {
    genesis_token_id: 10354,
    wearable_ids: [296, 304],
  },
  {
    genesis_token_id: 10355,
    wearable_ids: [425, 313],
  },
  {
    genesis_token_id: 10356,
    wearable_ids: [431, 435],
  },
  {
    genesis_token_id: 10357,
    wearable_ids: [306, 335],
  },
  {
    genesis_token_id: 10358,
    wearable_ids: [436, 262],
  },
  {
    genesis_token_id: 10359,
    wearable_ids: [364, 292],
  },
  {
    genesis_token_id: 10360,
    wearable_ids: [374, 437],
  },
  {
    genesis_token_id: 10361,
    wearable_ids: [265, 424],
  },
  {
    genesis_token_id: 10362,
    wearable_ids: [306, 354],
  },
  {
    genesis_token_id: 10363,
    wearable_ids: [292, 370],
  },
  {
    genesis_token_id: 10364,
    wearable_ids: [412, 433],
  },
  {
    genesis_token_id: 10365,
    wearable_ids: [442, 418],
  },
  {
    genesis_token_id: 10366,
    wearable_ids: [342, 285],
  },
  {
    genesis_token_id: 10367,
    wearable_ids: [346, 267],
  },
  {
    genesis_token_id: 10368,
    wearable_ids: [256, 442],
  },
  {
    genesis_token_id: 10369,
    wearable_ids: [314, 263],
  },
  {
    genesis_token_id: 10370,
    wearable_ids: [422, 319],
  },
  {
    genesis_token_id: 10371,
    wearable_ids: [375, 300],
  },
  {
    genesis_token_id: 10372,
    wearable_ids: [251, 406],
  },
  {
    genesis_token_id: 10373,
    wearable_ids: [295, 272],
  },
  {
    genesis_token_id: 10374,
    wearable_ids: [404, 406],
  },
  {
    genesis_token_id: 10375,
    wearable_ids: [268, 332],
  },
  {
    genesis_token_id: 10376,
    wearable_ids: [429, 388],
  },
  {
    genesis_token_id: 10377,
    wearable_ids: [263, 276],
  },
  {
    genesis_token_id: 10378,
    wearable_ids: [425, 334],
  },
  {
    genesis_token_id: 10379,
    wearable_ids: [431, 268],
  },
  {
    genesis_token_id: 10380,
    wearable_ids: [386, 348],
  },
  {
    genesis_token_id: 10381,
    wearable_ids: [396, 401],
  },
  {
    genesis_token_id: 10382,
    wearable_ids: [411, 396],
  },
  {
    genesis_token_id: 10383,
    wearable_ids: [420, 403],
  },
  {
    genesis_token_id: 10384,
    wearable_ids: [319, 359],
  },
  {
    genesis_token_id: 10385,
    wearable_ids: [406, 337],
  },
  {
    genesis_token_id: 10386,
    wearable_ids: [271, 413],
  },
  {
    genesis_token_id: 10387,
    wearable_ids: [315, 342],
  },
  {
    genesis_token_id: 10388,
    wearable_ids: [396, 443],
  },
  {
    genesis_token_id: 10389,
    wearable_ids: [437, 407],
  },
  {
    genesis_token_id: 10390,
    wearable_ids: [352, 319],
  },
  {
    genesis_token_id: 10391,
    wearable_ids: [299, 437],
  },
  {
    genesis_token_id: 10392,
    wearable_ids: [437, 264],
  },
  {
    genesis_token_id: 10393,
    wearable_ids: [354, 346],
  },
  {
    genesis_token_id: 10394,
    wearable_ids: [420, 364],
  },
  {
    genesis_token_id: 10395,
    wearable_ids: [420, 300],
  },
  {
    genesis_token_id: 10396,
    wearable_ids: [435, 344],
  },
  {
    genesis_token_id: 10397,
    wearable_ids: [324, 399],
  },
  {
    genesis_token_id: 10398,
    wearable_ids: [291, 384],
  },
  {
    genesis_token_id: 10399,
    wearable_ids: [386, 251],
  },
  {
    genesis_token_id: 10400,
    wearable_ids: [286, 296],
  },
  {
    genesis_token_id: 10401,
    wearable_ids: [352, 374],
  },
  {
    genesis_token_id: 10402,
    wearable_ids: [342, 441],
  },
  {
    genesis_token_id: 10403,
    wearable_ids: [257, 338],
  },
  {
    genesis_token_id: 10404,
    wearable_ids: [271, 325],
  },
  {
    genesis_token_id: 10405,
    wearable_ids: [340, 375],
  },
  {
    genesis_token_id: 10406,
    wearable_ids: [262, 341],
  },
  {
    genesis_token_id: 10407,
    wearable_ids: [399, 304],
  },
  {
    genesis_token_id: 10408,
    wearable_ids: [403, 273],
  },
  {
    genesis_token_id: 10409,
    wearable_ids: [363, 323],
  },
  {
    genesis_token_id: 10410,
    wearable_ids: [386, 397],
  },
  {
    genesis_token_id: 10411,
    wearable_ids: [365, 277],
  },
  {
    genesis_token_id: 10412,
    wearable_ids: [301, 382],
  },
  {
    genesis_token_id: 10413,
    wearable_ids: [274, 445],
  },
  {
    genesis_token_id: 10414,
    wearable_ids: [253, 268],
  },
  {
    genesis_token_id: 10415,
    wearable_ids: [404, 280],
  },
  {
    genesis_token_id: 10416,
    wearable_ids: [317, 404],
  },
  {
    genesis_token_id: 10417,
    wearable_ids: [316, 431],
  },
  {
    genesis_token_id: 10418,
    wearable_ids: [404, 392],
  },
  {
    genesis_token_id: 10419,
    wearable_ids: [433, 419],
  },
  {
    genesis_token_id: 10420,
    wearable_ids: [344, 320],
  },
  {
    genesis_token_id: 10421,
    wearable_ids: [395, 253],
  },
  {
    genesis_token_id: 10422,
    wearable_ids: [344, 350],
  },
  {
    genesis_token_id: 10423,
    wearable_ids: [363, 337],
  },
  {
    genesis_token_id: 10424,
    wearable_ids: [296, 301],
  },
  {
    genesis_token_id: 10425,
    wearable_ids: [253, 386],
  },
  {
    genesis_token_id: 10426,
    wearable_ids: [276, 344],
  },
  {
    genesis_token_id: 10427,
    wearable_ids: [270, 371],
  },
  {
    genesis_token_id: 10428,
    wearable_ids: [420, 415],
  },
  {
    genesis_token_id: 10429,
    wearable_ids: [377, 277],
  },
  {
    genesis_token_id: 10430,
    wearable_ids: [423, 273],
  },
  {
    genesis_token_id: 10431,
    wearable_ids: [403, 265],
  },
  {
    genesis_token_id: 10432,
    wearable_ids: [335, 352],
  },
  {
    genesis_token_id: 10433,
    wearable_ids: [371, 383],
  },
  {
    genesis_token_id: 10434,
    wearable_ids: [415, 316],
  },
  {
    genesis_token_id: 10435,
    wearable_ids: [389, 247],
  },
  {
    genesis_token_id: 10436,
    wearable_ids: [299, 312],
  },
  {
    genesis_token_id: 10437,
    wearable_ids: [369, 270],
  },
  {
    genesis_token_id: 10438,
    wearable_ids: [349, 336],
  },
  {
    genesis_token_id: 10439,
    wearable_ids: [265, 427],
  },
  {
    genesis_token_id: 10440,
    wearable_ids: [354, 289],
  },
  {
    genesis_token_id: 10441,
    wearable_ids: [253, 266],
  },
  {
    genesis_token_id: 10442,
    wearable_ids: [444, 422],
  },
  {
    genesis_token_id: 10443,
    wearable_ids: [351, 425],
  },
  {
    genesis_token_id: 10444,
    wearable_ids: [399, 324],
  },
  {
    genesis_token_id: 10445,
    wearable_ids: [376, 355],
  },
  {
    genesis_token_id: 10446,
    wearable_ids: [315, 364],
  },
  {
    genesis_token_id: 10447,
    wearable_ids: [290, 445],
  },
  {
    genesis_token_id: 10448,
    wearable_ids: [383, 402],
  },
  {
    genesis_token_id: 10449,
    wearable_ids: [253, 397],
  },
  {
    genesis_token_id: 10450,
    wearable_ids: [344, 253],
  },
  {
    genesis_token_id: 10451,
    wearable_ids: [404, 270],
  },
  {
    genesis_token_id: 10452,
    wearable_ids: [376, 340],
  },
  {
    genesis_token_id: 10453,
    wearable_ids: [324, 338],
  },
  {
    genesis_token_id: 10454,
    wearable_ids: [432, 416],
  },
  {
    genesis_token_id: 10455,
    wearable_ids: [253, 268],
  },
  {
    genesis_token_id: 10456,
    wearable_ids: [364, 372],
  },
  {
    genesis_token_id: 10457,
    wearable_ids: [425, 344],
  },
  {
    genesis_token_id: 10458,
    wearable_ids: [399, 414],
  },
  {
    genesis_token_id: 10459,
    wearable_ids: [268, 412],
  },
  {
    genesis_token_id: 10460,
    wearable_ids: [435, 397],
  },
  {
    genesis_token_id: 10461,
    wearable_ids: [324, 413],
  },
  {
    genesis_token_id: 10462,
    wearable_ids: [256, 420],
  },
  {
    genesis_token_id: 10463,
    wearable_ids: [335, 437],
  },
  {
    genesis_token_id: 10464,
    wearable_ids: [376, 306],
  },
  {
    genesis_token_id: 10465,
    wearable_ids: [270, 310],
  },
  {
    genesis_token_id: 10466,
    wearable_ids: [363, 266],
  },
  {
    genesis_token_id: 10467,
    wearable_ids: [374, 393],
  },
  {
    genesis_token_id: 10468,
    wearable_ids: [413, 299],
  },
  {
    genesis_token_id: 10469,
    wearable_ids: [372, 278],
  },
  {
    genesis_token_id: 10470,
    wearable_ids: [350, 341],
  },
  {
    genesis_token_id: 10471,
    wearable_ids: [408, 382],
  },
  {
    genesis_token_id: 10472,
    wearable_ids: [265, 365],
  },
  {
    genesis_token_id: 10473,
    wearable_ids: [433, 251],
  },
  {
    genesis_token_id: 10474,
    wearable_ids: [420, 386],
  },
  {
    genesis_token_id: 10475,
    wearable_ids: [424, 333],
  },
  {
    genesis_token_id: 10476,
    wearable_ids: [301, 266],
  },
  {
    genesis_token_id: 10477,
    wearable_ids: [273, 355],
  },
  {
    genesis_token_id: 10478,
    wearable_ids: [377, 262],
  },
  {
    genesis_token_id: 10479,
    wearable_ids: [276, 425],
  },
  {
    genesis_token_id: 10480,
    wearable_ids: [355, 426],
  },
  {
    genesis_token_id: 10481,
    wearable_ids: [437, 332],
  },
  {
    genesis_token_id: 10482,
    wearable_ids: [434, 348],
  },
  {
    genesis_token_id: 10483,
    wearable_ids: [272, 262],
  },
  {
    genesis_token_id: 10484,
    wearable_ids: [316, 270],
  },
  {
    genesis_token_id: 10485,
    wearable_ids: [397, 336],
  },
  {
    genesis_token_id: 10486,
    wearable_ids: [308, 372],
  },
  {
    genesis_token_id: 10487,
    wearable_ids: [444, 361],
  },
  {
    genesis_token_id: 10488,
    wearable_ids: [410, 315],
  },
  {
    genesis_token_id: 10489,
    wearable_ids: [317, 441],
  },
  {
    genesis_token_id: 10490,
    wearable_ids: [364, 436],
  },
  {
    genesis_token_id: 10491,
    wearable_ids: [413, 335],
  },
  {
    genesis_token_id: 10492,
    wearable_ids: [386, 397],
  },
  {
    genesis_token_id: 10493,
    wearable_ids: [290, 284],
  },
  {
    genesis_token_id: 10494,
    wearable_ids: [422, 339],
  },
  {
    genesis_token_id: 10495,
    wearable_ids: [400, 444],
  },
  {
    genesis_token_id: 10496,
    wearable_ids: [286, 343],
  },
  {
    genesis_token_id: 10497,
    wearable_ids: [273, 393],
  },
  {
    genesis_token_id: 10498,
    wearable_ids: [262, 444],
  },
  {
    genesis_token_id: 10499,
    wearable_ids: [362, 283],
  },
  {
    genesis_token_id: 10500,
    wearable_ids: [337, 286],
  },
  {
    genesis_token_id: 10501,
    wearable_ids: [280, 258],
  },
  {
    genesis_token_id: 10502,
    wearable_ids: [316, 272],
  },
  {
    genesis_token_id: 10503,
    wearable_ids: [315, 364],
  },
  {
    genesis_token_id: 10504,
    wearable_ids: [443, 331],
  },
  {
    genesis_token_id: 10505,
    wearable_ids: [431, 324],
  },
  {
    genesis_token_id: 10506,
    wearable_ids: [284, 317],
  },
  {
    genesis_token_id: 10507,
    wearable_ids: [437, 407],
  },
  {
    genesis_token_id: 10508,
    wearable_ids: [326, 284],
  },
  {
    genesis_token_id: 10509,
    wearable_ids: [324, 423],
  },
  {
    genesis_token_id: 10510,
    wearable_ids: [294, 306],
  },
  {
    genesis_token_id: 10511,
    wearable_ids: [368, 437],
  },
  {
    genesis_token_id: 10512,
    wearable_ids: [276, 353],
  },
  {
    genesis_token_id: 10513,
    wearable_ids: [363, 295],
  },
  {
    genesis_token_id: 10514,
    wearable_ids: [294, 349],
  },
  {
    genesis_token_id: 10515,
    wearable_ids: [408, 373],
  },
  {
    genesis_token_id: 10516,
    wearable_ids: [383, 419],
  },
  {
    genesis_token_id: 10517,
    wearable_ids: [337, 323],
  },
  {
    genesis_token_id: 10518,
    wearable_ids: [425, 256],
  },
  {
    genesis_token_id: 10519,
    wearable_ids: [344, 304],
  },
  {
    genesis_token_id: 10520,
    wearable_ids: [251, 328],
  },
  {
    genesis_token_id: 10521,
    wearable_ids: [274, 279],
  },
  {
    genesis_token_id: 10522,
    wearable_ids: [315, 331],
  },
  {
    genesis_token_id: 10523,
    wearable_ids: [341, 410],
  },
  {
    genesis_token_id: 10524,
    wearable_ids: [375, 266],
  },
  {
    genesis_token_id: 10525,
    wearable_ids: [406, 388],
  },
  {
    genesis_token_id: 10526,
    wearable_ids: [286, 258],
  },
  {
    genesis_token_id: 10527,
    wearable_ids: [365, 411],
  },
  {
    genesis_token_id: 10528,
    wearable_ids: [255, 385],
  },
  {
    genesis_token_id: 10529,
    wearable_ids: [424, 355],
  },
  {
    genesis_token_id: 10530,
    wearable_ids: [262, 347],
  },
  {
    genesis_token_id: 10531,
    wearable_ids: [389, 344],
  },
  {
    genesis_token_id: 10532,
    wearable_ids: [268, 313],
  },
  {
    genesis_token_id: 10533,
    wearable_ids: [397, 322],
  },
  {
    genesis_token_id: 10534,
    wearable_ids: [371, 340],
  },
  {
    genesis_token_id: 10535,
    wearable_ids: [304, 415],
  },
  {
    genesis_token_id: 10536,
    wearable_ids: [433, 258],
  },
  {
    genesis_token_id: 10537,
    wearable_ids: [362, 412],
  },
  {
    genesis_token_id: 10538,
    wearable_ids: [338, 249],
  },
  {
    genesis_token_id: 10539,
    wearable_ids: [339, 310],
  },
  {
    genesis_token_id: 10540,
    wearable_ids: [256, 374],
  },
  {
    genesis_token_id: 10541,
    wearable_ids: [306, 375],
  },
  {
    genesis_token_id: 10542,
    wearable_ids: [397, 444],
  },
  {
    genesis_token_id: 10543,
    wearable_ids: [377, 305],
  },
  {
    genesis_token_id: 10544,
    wearable_ids: [363, 318],
  },
  {
    genesis_token_id: 10545,
    wearable_ids: [442, 371],
  },
  {
    genesis_token_id: 10546,
    wearable_ids: [369, 413],
  },
  {
    genesis_token_id: 10547,
    wearable_ids: [300, 286],
  },
  {
    genesis_token_id: 10548,
    wearable_ids: [339, 327],
  },
  {
    genesis_token_id: 10549,
    wearable_ids: [276, 407],
  },
  {
    genesis_token_id: 10550,
    wearable_ids: [408, 338],
  },
  {
    genesis_token_id: 10551,
    wearable_ids: [434, 389],
  },
  {
    genesis_token_id: 10552,
    wearable_ids: [325, 308],
  },
  {
    genesis_token_id: 10553,
    wearable_ids: [442, 315],
  },
  {
    genesis_token_id: 10554,
    wearable_ids: [371, 370],
  },
  {
    genesis_token_id: 10555,
    wearable_ids: [426, 279],
  },
  {
    genesis_token_id: 10556,
    wearable_ids: [257, 246],
  },
  {
    genesis_token_id: 10557,
    wearable_ids: [294, 354],
  },
  {
    genesis_token_id: 10558,
    wearable_ids: [308, 280],
  },
  {
    genesis_token_id: 10559,
    wearable_ids: [349, 274],
  },
  {
    genesis_token_id: 10560,
    wearable_ids: [251, 365],
  },
  {
    genesis_token_id: 10561,
    wearable_ids: [331, 269],
  },
  {
    genesis_token_id: 10562,
    wearable_ids: [280, 336],
  },
  {
    genesis_token_id: 10563,
    wearable_ids: [276, 275],
  },
  {
    genesis_token_id: 10564,
    wearable_ids: [338, 318],
  },
  {
    genesis_token_id: 10565,
    wearable_ids: [270, 302],
  },
  {
    genesis_token_id: 10566,
    wearable_ids: [410, 374],
  },
  {
    genesis_token_id: 10567,
    wearable_ids: [257, 251],
  },
  {
    genesis_token_id: 10568,
    wearable_ids: [290, 279],
  },
  {
    genesis_token_id: 10569,
    wearable_ids: [374, 384],
  },
  {
    genesis_token_id: 10570,
    wearable_ids: [364, 389],
  },
  {
    genesis_token_id: 10571,
    wearable_ids: [264, 287],
  },
  {
    genesis_token_id: 10572,
    wearable_ids: [444, 413],
  },
  {
    genesis_token_id: 10573,
    wearable_ids: [257, 328],
  },
  {
    genesis_token_id: 10574,
    wearable_ids: [385, 261],
  },
  {
    genesis_token_id: 10575,
    wearable_ids: [247, 256],
  },
  {
    genesis_token_id: 10576,
    wearable_ids: [253, 427],
  },
  {
    genesis_token_id: 10577,
    wearable_ids: [310, 335],
  },
  {
    genesis_token_id: 10578,
    wearable_ids: [399, 445],
  },
  {
    genesis_token_id: 10579,
    wearable_ids: [255, 356],
  },
  {
    genesis_token_id: 10580,
    wearable_ids: [371, 258],
  },
  {
    genesis_token_id: 10581,
    wearable_ids: [339, 272],
  },
  {
    genesis_token_id: 10582,
    wearable_ids: [296, 272],
  },
  {
    genesis_token_id: 10583,
    wearable_ids: [315, 289],
  },
  {
    genesis_token_id: 10584,
    wearable_ids: [316, 368],
  },
  {
    genesis_token_id: 10585,
    wearable_ids: [272, 268],
  },
  {
    genesis_token_id: 10586,
    wearable_ids: [276, 305],
  },
  {
    genesis_token_id: 10587,
    wearable_ids: [371, 378],
  },
  {
    genesis_token_id: 10588,
    wearable_ids: [444, 303],
  },
  {
    genesis_token_id: 10589,
    wearable_ids: [278, 258],
  },
  {
    genesis_token_id: 10590,
    wearable_ids: [443, 292],
  },
  {
    genesis_token_id: 10591,
    wearable_ids: [397, 407],
  },
  {
    genesis_token_id: 10592,
    wearable_ids: [375, 299],
  },
  {
    genesis_token_id: 10593,
    wearable_ids: [411, 305],
  },
  {
    genesis_token_id: 10594,
    wearable_ids: [316, 317],
  },
  {
    genesis_token_id: 10595,
    wearable_ids: [284, 387],
  },
  {
    genesis_token_id: 10596,
    wearable_ids: [277, 315],
  },
  {
    genesis_token_id: 10597,
    wearable_ids: [324, 270],
  },
  {
    genesis_token_id: 10598,
    wearable_ids: [289, 435],
  },
  {
    genesis_token_id: 10599,
    wearable_ids: [348, 317],
  },
  {
    genesis_token_id: 10600,
    wearable_ids: [383, 366],
  },
  {
    genesis_token_id: 10601,
    wearable_ids: [258, 422],
  },
  {
    genesis_token_id: 10602,
    wearable_ids: [306, 290],
  },
  {
    genesis_token_id: 10603,
    wearable_ids: [364, 340],
  },
  {
    genesis_token_id: 10604,
    wearable_ids: [294, 423],
  },
  {
    genesis_token_id: 10605,
    wearable_ids: [375, 251],
  },
  {
    genesis_token_id: 10606,
    wearable_ids: [378, 278],
  },
  {
    genesis_token_id: 10607,
    wearable_ids: [271, 274],
  },
  {
    genesis_token_id: 10608,
    wearable_ids: [287, 426],
  },
  {
    genesis_token_id: 10609,
    wearable_ids: [265, 292],
  },
  {
    genesis_token_id: 10610,
    wearable_ids: [289, 319],
  },
  {
    genesis_token_id: 10611,
    wearable_ids: [306, 288],
  },
  {
    genesis_token_id: 10612,
    wearable_ids: [247, 443],
  },
  {
    genesis_token_id: 10613,
    wearable_ids: [337, 395],
  },
  {
    genesis_token_id: 10614,
    wearable_ids: [411, 335],
  },
  {
    genesis_token_id: 10615,
    wearable_ids: [395, 430],
  },
  {
    genesis_token_id: 10616,
    wearable_ids: [336, 304],
  },
  {
    genesis_token_id: 10617,
    wearable_ids: [383, 341],
  },
  {
    genesis_token_id: 10618,
    wearable_ids: [332, 264],
  },
  {
    genesis_token_id: 10619,
    wearable_ids: [404, 265],
  },
  {
    genesis_token_id: 10620,
    wearable_ids: [340, 343],
  },
  {
    genesis_token_id: 10621,
    wearable_ids: [251, 385],
  },
  {
    genesis_token_id: 10622,
    wearable_ids: [255, 413],
  },
  {
    genesis_token_id: 10623,
    wearable_ids: [276, 341],
  },
  {
    genesis_token_id: 10624,
    wearable_ids: [432, 336],
  },
  {
    genesis_token_id: 10625,
    wearable_ids: [315, 324],
  },
  {
    genesis_token_id: 10626,
    wearable_ids: [436, 253],
  },
  {
    genesis_token_id: 10627,
    wearable_ids: [408, 392],
  },
  {
    genesis_token_id: 10628,
    wearable_ids: [331, 359],
  },
  {
    genesis_token_id: 10629,
    wearable_ids: [363, 337],
  },
  {
    genesis_token_id: 10630,
    wearable_ids: [423, 263],
  },
  {
    genesis_token_id: 10631,
    wearable_ids: [324, 348],
  },
  {
    genesis_token_id: 10632,
    wearable_ids: [408, 373],
  },
  {
    genesis_token_id: 10633,
    wearable_ids: [280, 431],
  },
  {
    genesis_token_id: 10634,
    wearable_ids: [442, 347],
  },
  {
    genesis_token_id: 10635,
    wearable_ids: [437, 336],
  },
  {
    genesis_token_id: 10636,
    wearable_ids: [315, 363],
  },
  {
    genesis_token_id: 10637,
    wearable_ids: [273, 278],
  },
  {
    genesis_token_id: 10638,
    wearable_ids: [266, 413],
  },
  {
    genesis_token_id: 10639,
    wearable_ids: [384, 308],
  },
  {
    genesis_token_id: 10640,
    wearable_ids: [387, 399],
  },
  {
    genesis_token_id: 10641,
    wearable_ids: [399, 300],
  },
  {
    genesis_token_id: 10642,
    wearable_ids: [433, 396],
  },
  {
    genesis_token_id: 10643,
    wearable_ids: [435, 383],
  },
  {
    genesis_token_id: 10644,
    wearable_ids: [412, 441],
  },
  {
    genesis_token_id: 10645,
    wearable_ids: [276, 410],
  },
  {
    genesis_token_id: 10646,
    wearable_ids: [270, 289],
  },
  {
    genesis_token_id: 10647,
    wearable_ids: [407, 314],
  },
  {
    genesis_token_id: 10648,
    wearable_ids: [412, 372],
  },
  {
    genesis_token_id: 10649,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 10650,
    wearable_ids: [403, 445],
  },
  {
    genesis_token_id: 10651,
    wearable_ids: [368, 293],
  },
  {
    genesis_token_id: 10652,
    wearable_ids: [253, 426],
  },
  {
    genesis_token_id: 10653,
    wearable_ids: [299, 364],
  },
  {
    genesis_token_id: 10654,
    wearable_ids: [428, 377],
  },
  {
    genesis_token_id: 10655,
    wearable_ids: [442, 387],
  },
  {
    genesis_token_id: 10656,
    wearable_ids: [411, 358],
  },
  {
    genesis_token_id: 10657,
    wearable_ids: [337, 410],
  },
  {
    genesis_token_id: 10658,
    wearable_ids: [265, 345],
  },
  {
    genesis_token_id: 10659,
    wearable_ids: [271, 445],
  },
  {
    genesis_token_id: 10660,
    wearable_ids: [342, 333],
  },
  {
    genesis_token_id: 10661,
    wearable_ids: [397, 334],
  },
  {
    genesis_token_id: 10662,
    wearable_ids: [413, 347],
  },
  {
    genesis_token_id: 10663,
    wearable_ids: [326, 362],
  },
  {
    genesis_token_id: 10664,
    wearable_ids: [284, 373],
  },
  {
    genesis_token_id: 10665,
    wearable_ids: [424, 276],
  },
  {
    genesis_token_id: 10666,
    wearable_ids: [410, 250],
  },
  {
    genesis_token_id: 10667,
    wearable_ids: [254, 331],
  },
  {
    genesis_token_id: 10668,
    wearable_ids: [324, 272],
  },
  {
    genesis_token_id: 10669,
    wearable_ids: [247, 251],
  },
  {
    genesis_token_id: 10670,
    wearable_ids: [276, 257],
  },
  {
    genesis_token_id: 10671,
    wearable_ids: [371, 293],
  },
  {
    genesis_token_id: 10672,
    wearable_ids: [413, 343],
  },
  {
    genesis_token_id: 10673,
    wearable_ids: [337, 270],
  },
  {
    genesis_token_id: 10674,
    wearable_ids: [254, 365],
  },
  {
    genesis_token_id: 10675,
    wearable_ids: [255, 280],
  },
  {
    genesis_token_id: 10676,
    wearable_ids: [445, 436],
  },
  {
    genesis_token_id: 10677,
    wearable_ids: [304, 332],
  },
  {
    genesis_token_id: 10678,
    wearable_ids: [372, 255],
  },
  {
    genesis_token_id: 10679,
    wearable_ids: [396, 271],
  },
  {
    genesis_token_id: 10680,
    wearable_ids: [378, 430],
  },
  {
    genesis_token_id: 10681,
    wearable_ids: [404, 416],
  },
  {
    genesis_token_id: 10682,
    wearable_ids: [251, 432],
  },
  {
    genesis_token_id: 10683,
    wearable_ids: [319, 330],
  },
  {
    genesis_token_id: 10684,
    wearable_ids: [435, 258],
  },
  {
    genesis_token_id: 10685,
    wearable_ids: [413, 385],
  },
  {
    genesis_token_id: 10686,
    wearable_ids: [444, 428],
  },
  {
    genesis_token_id: 10687,
    wearable_ids: [409, 445],
  },
  {
    genesis_token_id: 10688,
    wearable_ids: [389, 406],
  },
  {
    genesis_token_id: 10689,
    wearable_ids: [265, 299],
  },
  {
    genesis_token_id: 10690,
    wearable_ids: [343, 299],
  },
  {
    genesis_token_id: 10691,
    wearable_ids: [338, 289],
  },
  {
    genesis_token_id: 10692,
    wearable_ids: [434, 431],
  },
  {
    genesis_token_id: 10693,
    wearable_ids: [362, 436],
  },
  {
    genesis_token_id: 10694,
    wearable_ids: [429, 312],
  },
  {
    genesis_token_id: 10695,
    wearable_ids: [286, 343],
  },
  {
    genesis_token_id: 10696,
    wearable_ids: [370, 257],
  },
  {
    genesis_token_id: 10697,
    wearable_ids: [341, 257],
  },
  {
    genesis_token_id: 10698,
    wearable_ids: [325, 363],
  },
  {
    genesis_token_id: 10699,
    wearable_ids: [256, 251],
  },
  {
    genesis_token_id: 10700,
    wearable_ids: [325, 283],
  },
  {
    genesis_token_id: 10701,
    wearable_ids: [413, 420],
  },
  {
    genesis_token_id: 10702,
    wearable_ids: [368, 273],
  },
  {
    genesis_token_id: 10703,
    wearable_ids: [443, 290],
  },
  {
    genesis_token_id: 10704,
    wearable_ids: [373, 278],
  },
  {
    genesis_token_id: 10705,
    wearable_ids: [297, 343],
  },
  {
    genesis_token_id: 10706,
    wearable_ids: [326, 397],
  },
  {
    genesis_token_id: 10707,
    wearable_ids: [264, 394],
  },
  {
    genesis_token_id: 10708,
    wearable_ids: [415, 335],
  },
  {
    genesis_token_id: 10709,
    wearable_ids: [266, 344],
  },
  {
    genesis_token_id: 10710,
    wearable_ids: [271, 299],
  },
  {
    genesis_token_id: 10711,
    wearable_ids: [303, 427],
  },
  {
    genesis_token_id: 10712,
    wearable_ids: [311, 382],
  },
  {
    genesis_token_id: 10713,
    wearable_ids: [426, 293],
  },
  {
    genesis_token_id: 10714,
    wearable_ids: [410, 327],
  },
  {
    genesis_token_id: 10715,
    wearable_ids: [407, 378],
  },
  {
    genesis_token_id: 10716,
    wearable_ids: [262, 414],
  },
  {
    genesis_token_id: 10717,
    wearable_ids: [332, 352],
  },
  {
    genesis_token_id: 10718,
    wearable_ids: [247, 362],
  },
  {
    genesis_token_id: 10719,
    wearable_ids: [382, 436],
  },
  {
    genesis_token_id: 10720,
    wearable_ids: [324, 248],
  },
  {
    genesis_token_id: 10721,
    wearable_ids: [306, 263],
  },
  {
    genesis_token_id: 10722,
    wearable_ids: [378, 387],
  },
  {
    genesis_token_id: 10723,
    wearable_ids: [326, 300],
  },
  {
    genesis_token_id: 10724,
    wearable_ids: [294, 400],
  },
  {
    genesis_token_id: 10725,
    wearable_ids: [413, 409],
  },
  {
    genesis_token_id: 10726,
    wearable_ids: [336, 289],
  },
  {
    genesis_token_id: 10727,
    wearable_ids: [253, 412],
  },
  {
    genesis_token_id: 10728,
    wearable_ids: [254, 403],
  },
  {
    genesis_token_id: 10729,
    wearable_ids: [432, 266],
  },
  {
    genesis_token_id: 10730,
    wearable_ids: [372, 287],
  },
  {
    genesis_token_id: 10731,
    wearable_ids: [262, 248],
  },
  {
    genesis_token_id: 10732,
    wearable_ids: [301, 417],
  },
  {
    genesis_token_id: 10733,
    wearable_ids: [294, 260],
  },
  {
    genesis_token_id: 10734,
    wearable_ids: [435, 378],
  },
  {
    genesis_token_id: 10735,
    wearable_ids: [373, 369],
  },
  {
    genesis_token_id: 10736,
    wearable_ids: [270, 248],
  },
  {
    genesis_token_id: 10737,
    wearable_ids: [406, 280],
  },
  {
    genesis_token_id: 10738,
    wearable_ids: [364, 434],
  },
  {
    genesis_token_id: 10739,
    wearable_ids: [428, 397],
  },
  {
    genesis_token_id: 10740,
    wearable_ids: [428, 262],
  },
  {
    genesis_token_id: 10741,
    wearable_ids: [265, 342],
  },
  {
    genesis_token_id: 10742,
    wearable_ids: [277, 316],
  },
  {
    genesis_token_id: 10743,
    wearable_ids: [406, 299],
  },
  {
    genesis_token_id: 10744,
    wearable_ids: [444, 427],
  },
  {
    genesis_token_id: 10745,
    wearable_ids: [373, 350],
  },
  {
    genesis_token_id: 10746,
    wearable_ids: [255, 375],
  },
  {
    genesis_token_id: 10747,
    wearable_ids: [310, 385],
  },
  {
    genesis_token_id: 10748,
    wearable_ids: [259, 385],
  },
  {
    genesis_token_id: 10749,
    wearable_ids: [375, 443],
  },
  {
    genesis_token_id: 10750,
    wearable_ids: [429, 313],
  },
  {
    genesis_token_id: 10751,
    wearable_ids: [382, 294],
  },
  {
    genesis_token_id: 10752,
    wearable_ids: [347, 349],
  },
  {
    genesis_token_id: 10753,
    wearable_ids: [346, 424],
  },
  {
    genesis_token_id: 10754,
    wearable_ids: [258, 346],
  },
  {
    genesis_token_id: 10755,
    wearable_ids: [395, 266],
  },
  {
    genesis_token_id: 10756,
    wearable_ids: [347, 412],
  },
  {
    genesis_token_id: 10757,
    wearable_ids: [386, 275],
  },
  {
    genesis_token_id: 10758,
    wearable_ids: [351, 257],
  },
  {
    genesis_token_id: 10759,
    wearable_ids: [395, 407],
  },
  {
    genesis_token_id: 10760,
    wearable_ids: [342, 317],
  },
  {
    genesis_token_id: 10761,
    wearable_ids: [339, 417],
  },
  {
    genesis_token_id: 10762,
    wearable_ids: [335, 307],
  },
  {
    genesis_token_id: 10763,
    wearable_ids: [304, 361],
  },
  {
    genesis_token_id: 10764,
    wearable_ids: [410, 276],
  },
  {
    genesis_token_id: 10765,
    wearable_ids: [371, 287],
  },
  {
    genesis_token_id: 10766,
    wearable_ids: [306, 375],
  },
  {
    genesis_token_id: 10767,
    wearable_ids: [256, 407],
  },
  {
    genesis_token_id: 10768,
    wearable_ids: [420, 308],
  },
  {
    genesis_token_id: 10769,
    wearable_ids: [247, 428],
  },
  {
    genesis_token_id: 10770,
    wearable_ids: [382, 384],
  },
  {
    genesis_token_id: 10771,
    wearable_ids: [335, 386],
  },
  {
    genesis_token_id: 10772,
    wearable_ids: [303, 348],
  },
  {
    genesis_token_id: 10773,
    wearable_ids: [407, 302],
  },
  {
    genesis_token_id: 10774,
    wearable_ids: [257, 299],
  },
  {
    genesis_token_id: 10775,
    wearable_ids: [383, 266],
  },
  {
    genesis_token_id: 10776,
    wearable_ids: [258, 337],
  },
  {
    genesis_token_id: 10777,
    wearable_ids: [292, 334],
  },
  {
    genesis_token_id: 10778,
    wearable_ids: [289, 296],
  },
  {
    genesis_token_id: 10779,
    wearable_ids: [317, 383],
  },
  {
    genesis_token_id: 10780,
    wearable_ids: [325, 420],
  },
  {
    genesis_token_id: 10781,
    wearable_ids: [257, 431],
  },
  {
    genesis_token_id: 10782,
    wearable_ids: [265, 257],
  },
  {
    genesis_token_id: 10783,
    wearable_ids: [386, 332],
  },
  {
    genesis_token_id: 10784,
    wearable_ids: [364, 368],
  },
  {
    genesis_token_id: 10785,
    wearable_ids: [445, 344],
  },
  {
    genesis_token_id: 10786,
    wearable_ids: [277, 434],
  },
  {
    genesis_token_id: 10787,
    wearable_ids: [270, 384],
  },
  {
    genesis_token_id: 10788,
    wearable_ids: [297, 408],
  },
  {
    genesis_token_id: 10789,
    wearable_ids: [276, 332],
  },
  {
    genesis_token_id: 10790,
    wearable_ids: [400, 441],
  },
  {
    genesis_token_id: 10791,
    wearable_ids: [284, 402],
  },
  {
    genesis_token_id: 10792,
    wearable_ids: [255, 301],
  },
  {
    genesis_token_id: 10793,
    wearable_ids: [370, 257],
  },
  {
    genesis_token_id: 10794,
    wearable_ids: [411, 326],
  },
  {
    genesis_token_id: 10795,
    wearable_ids: [406, 407],
  },
  {
    genesis_token_id: 10796,
    wearable_ids: [280, 339],
  },
  {
    genesis_token_id: 10797,
    wearable_ids: [289, 423],
  },
  {
    genesis_token_id: 10798,
    wearable_ids: [346, 270],
  },
  {
    genesis_token_id: 10799,
    wearable_ids: [370, 379],
  },
  {
    genesis_token_id: 10800,
    wearable_ids: [272, 348],
  },
  {
    genesis_token_id: 10801,
    wearable_ids: [435, 314],
  },
  {
    genesis_token_id: 10802,
    wearable_ids: [325, 272],
  },
  {
    genesis_token_id: 10803,
    wearable_ids: [306, 289],
  },
  {
    genesis_token_id: 10804,
    wearable_ids: [372, 371],
  },
  {
    genesis_token_id: 10805,
    wearable_ids: [340, 284],
  },
  {
    genesis_token_id: 10806,
    wearable_ids: [295, 319],
  },
  {
    genesis_token_id: 10807,
    wearable_ids: [432, 351],
  },
  {
    genesis_token_id: 10808,
    wearable_ids: [325, 306],
  },
  {
    genesis_token_id: 10809,
    wearable_ids: [262, 261],
  },
  {
    genesis_token_id: 10810,
    wearable_ids: [299, 389],
  },
  {
    genesis_token_id: 10811,
    wearable_ids: [375, 369],
  },
  {
    genesis_token_id: 10812,
    wearable_ids: [399, 268],
  },
  {
    genesis_token_id: 10813,
    wearable_ids: [292, 445],
  },
  {
    genesis_token_id: 10814,
    wearable_ids: [373, 415],
  },
  {
    genesis_token_id: 10815,
    wearable_ids: [409, 350],
  },
  {
    genesis_token_id: 10816,
    wearable_ids: [270, 255],
  },
  {
    genesis_token_id: 10817,
    wearable_ids: [399, 296],
  },
  {
    genesis_token_id: 10818,
    wearable_ids: [319, 416],
  },
  {
    genesis_token_id: 10819,
    wearable_ids: [375, 261],
  },
  {
    genesis_token_id: 10820,
    wearable_ids: [362, 386],
  },
  {
    genesis_token_id: 10821,
    wearable_ids: [420, 389],
  },
  {
    genesis_token_id: 10822,
    wearable_ids: [363, 369],
  },
  {
    genesis_token_id: 10823,
    wearable_ids: [342, 362],
  },
  {
    genesis_token_id: 10824,
    wearable_ids: [306, 301],
  },
  {
    genesis_token_id: 10825,
    wearable_ids: [257, 331],
  },
  {
    genesis_token_id: 10826,
    wearable_ids: [304, 266],
  },
  {
    genesis_token_id: 10827,
    wearable_ids: [349, 337],
  },
  {
    genesis_token_id: 10828,
    wearable_ids: [331, 335],
  },
  {
    genesis_token_id: 10829,
    wearable_ids: [364, 424],
  },
  {
    genesis_token_id: 10830,
    wearable_ids: [376, 372],
  },
  {
    genesis_token_id: 10831,
    wearable_ids: [310, 319],
  },
  {
    genesis_token_id: 10832,
    wearable_ids: [271, 281],
  },
  {
    genesis_token_id: 10833,
    wearable_ids: [325, 425],
  },
  {
    genesis_token_id: 10834,
    wearable_ids: [306, 262],
  },
  {
    genesis_token_id: 10835,
    wearable_ids: [270, 427],
  },
  {
    genesis_token_id: 10836,
    wearable_ids: [389, 378],
  },
  {
    genesis_token_id: 10837,
    wearable_ids: [382, 442],
  },
  {
    genesis_token_id: 10838,
    wearable_ids: [324, 264],
  },
  {
    genesis_token_id: 10839,
    wearable_ids: [294, 267],
  },
  {
    genesis_token_id: 10840,
    wearable_ids: [332, 415],
  },
  {
    genesis_token_id: 10841,
    wearable_ids: [429, 444],
  },
  {
    genesis_token_id: 10842,
    wearable_ids: [372, 431],
  },
  {
    genesis_token_id: 10843,
    wearable_ids: [368, 383],
  },
  {
    genesis_token_id: 10844,
    wearable_ids: [425, 303],
  },
  {
    genesis_token_id: 10845,
    wearable_ids: [341, 247],
  },
  {
    genesis_token_id: 10846,
    wearable_ids: [310, 363],
  },
  {
    genesis_token_id: 10847,
    wearable_ids: [306, 347],
  },
  {
    genesis_token_id: 10848,
    wearable_ids: [400, 412],
  },
  {
    genesis_token_id: 10849,
    wearable_ids: [303, 338],
  },
  {
    genesis_token_id: 10850,
    wearable_ids: [383, 385],
  },
  {
    genesis_token_id: 10851,
    wearable_ids: [336, 256],
  },
  {
    genesis_token_id: 10852,
    wearable_ids: [364, 280],
  },
  {
    genesis_token_id: 10853,
    wearable_ids: [412, 432],
  },
  {
    genesis_token_id: 10854,
    wearable_ids: [248, 247],
  },
  {
    genesis_token_id: 10855,
    wearable_ids: [253, 339],
  },
  {
    genesis_token_id: 10856,
    wearable_ids: [409, 296],
  },
  {
    genesis_token_id: 10857,
    wearable_ids: [314, 433],
  },
  {
    genesis_token_id: 10858,
    wearable_ids: [343, 355],
  },
  {
    genesis_token_id: 10859,
    wearable_ids: [258, 355],
  },
  {
    genesis_token_id: 10860,
    wearable_ids: [370, 434],
  },
  {
    genesis_token_id: 10861,
    wearable_ids: [266, 410],
  },
  {
    genesis_token_id: 10862,
    wearable_ids: [387, 349],
  },
  {
    genesis_token_id: 10863,
    wearable_ids: [429, 256],
  },
  {
    genesis_token_id: 10864,
    wearable_ids: [377, 411],
  },
  {
    genesis_token_id: 10865,
    wearable_ids: [373, 445],
  },
  {
    genesis_token_id: 10866,
    wearable_ids: [284, 405],
  },
  {
    genesis_token_id: 10867,
    wearable_ids: [411, 319],
  },
  {
    genesis_token_id: 10868,
    wearable_ids: [386, 432],
  },
  {
    genesis_token_id: 10869,
    wearable_ids: [255, 397],
  },
  {
    genesis_token_id: 10870,
    wearable_ids: [435, 301],
  },
  {
    genesis_token_id: 10871,
    wearable_ids: [396, 331],
  },
  {
    genesis_token_id: 10872,
    wearable_ids: [409, 420],
  },
  {
    genesis_token_id: 10873,
    wearable_ids: [420, 356],
  },
  {
    genesis_token_id: 10874,
    wearable_ids: [434, 265],
  },
  {
    genesis_token_id: 10875,
    wearable_ids: [270, 359],
  },
  {
    genesis_token_id: 10876,
    wearable_ids: [284, 316],
  },
  {
    genesis_token_id: 10877,
    wearable_ids: [385, 247],
  },
  {
    genesis_token_id: 10878,
    wearable_ids: [350, 414],
  },
  {
    genesis_token_id: 10879,
    wearable_ids: [277, 438],
  },
  {
    genesis_token_id: 10880,
    wearable_ids: [306, 372],
  },
  {
    genesis_token_id: 10881,
    wearable_ids: [373, 304],
  },
  {
    genesis_token_id: 10882,
    wearable_ids: [332, 308],
  },
  {
    genesis_token_id: 10883,
    wearable_ids: [248, 413],
  },
  {
    genesis_token_id: 10884,
    wearable_ids: [341, 365],
  },
  {
    genesis_token_id: 10885,
    wearable_ids: [407, 356],
  },
  {
    genesis_token_id: 10886,
    wearable_ids: [280, 331],
  },
  {
    genesis_token_id: 10887,
    wearable_ids: [443, 347],
  },
  {
    genesis_token_id: 10888,
    wearable_ids: [337, 265],
  },
  {
    genesis_token_id: 10889,
    wearable_ids: [315, 319],
  },
  {
    genesis_token_id: 10890,
    wearable_ids: [426, 302],
  },
  {
    genesis_token_id: 10891,
    wearable_ids: [364, 300],
  },
  {
    genesis_token_id: 10892,
    wearable_ids: [340, 370],
  },
  {
    genesis_token_id: 10893,
    wearable_ids: [371, 301],
  },
  {
    genesis_token_id: 10894,
    wearable_ids: [434, 268],
  },
  {
    genesis_token_id: 10895,
    wearable_ids: [429, 297],
  },
  {
    genesis_token_id: 10896,
    wearable_ids: [262, 407],
  },
  {
    genesis_token_id: 10897,
    wearable_ids: [351, 340],
  },
  {
    genesis_token_id: 10898,
    wearable_ids: [415, 332],
  },
  {
    genesis_token_id: 10899,
    wearable_ids: [354, 254],
  },
  {
    genesis_token_id: 10900,
    wearable_ids: [296, 384],
  },
  {
    genesis_token_id: 10901,
    wearable_ids: [251, 257],
  },
  {
    genesis_token_id: 10902,
    wearable_ids: [299, 324],
  },
  {
    genesis_token_id: 10903,
    wearable_ids: [364, 415],
  },
  {
    genesis_token_id: 10904,
    wearable_ids: [337, 263],
  },
  {
    genesis_token_id: 10905,
    wearable_ids: [284, 266],
  },
  {
    genesis_token_id: 10906,
    wearable_ids: [316, 362],
  },
  {
    genesis_token_id: 10907,
    wearable_ids: [445, 370],
  },
  {
    genesis_token_id: 10908,
    wearable_ids: [263, 278],
  },
  {
    genesis_token_id: 10909,
    wearable_ids: [268, 262],
  },
  {
    genesis_token_id: 10910,
    wearable_ids: [348, 419],
  },
  {
    genesis_token_id: 10911,
    wearable_ids: [257, 251],
  },
  {
    genesis_token_id: 10912,
    wearable_ids: [300, 409],
  },
  {
    genesis_token_id: 10913,
    wearable_ids: [423, 435],
  },
  {
    genesis_token_id: 10914,
    wearable_ids: [255, 265],
  },
  {
    genesis_token_id: 10915,
    wearable_ids: [350, 264],
  },
  {
    genesis_token_id: 10916,
    wearable_ids: [352, 344],
  },
  {
    genesis_token_id: 10917,
    wearable_ids: [370, 399],
  },
  {
    genesis_token_id: 10918,
    wearable_ids: [276, 336],
  },
  {
    genesis_token_id: 10919,
    wearable_ids: [382, 369],
  },
  {
    genesis_token_id: 10920,
    wearable_ids: [399, 250],
  },
  {
    genesis_token_id: 10921,
    wearable_ids: [266, 412],
  },
  {
    genesis_token_id: 10922,
    wearable_ids: [297, 343],
  },
  {
    genesis_token_id: 10923,
    wearable_ids: [270, 392],
  },
  {
    genesis_token_id: 10924,
    wearable_ids: [435, 428],
  },
  {
    genesis_token_id: 10925,
    wearable_ids: [274, 307],
  },
  {
    genesis_token_id: 10926,
    wearable_ids: [437, 358],
  },
  {
    genesis_token_id: 10927,
    wearable_ids: [304, 335],
  },
  {
    genesis_token_id: 10928,
    wearable_ids: [445, 371],
  },
  {
    genesis_token_id: 10929,
    wearable_ids: [374, 348],
  },
  {
    genesis_token_id: 10930,
    wearable_ids: [311, 382],
  },
  {
    genesis_token_id: 10931,
    wearable_ids: [270, 382],
  },
  {
    genesis_token_id: 10932,
    wearable_ids: [346, 289],
  },
  {
    genesis_token_id: 10933,
    wearable_ids: [400, 280],
  },
  {
    genesis_token_id: 10934,
    wearable_ids: [297, 437],
  },
  {
    genesis_token_id: 10935,
    wearable_ids: [375, 330],
  },
  {
    genesis_token_id: 10936,
    wearable_ids: [278, 304],
  },
  {
    genesis_token_id: 10937,
    wearable_ids: [389, 391],
  },
  {
    genesis_token_id: 10938,
    wearable_ids: [372, 389],
  },
  {
    genesis_token_id: 10939,
    wearable_ids: [429, 356],
  },
  {
    genesis_token_id: 10940,
    wearable_ids: [248, 411],
  },
  {
    genesis_token_id: 10941,
    wearable_ids: [386, 411],
  },
  {
    genesis_token_id: 10942,
    wearable_ids: [432, 256],
  },
  {
    genesis_token_id: 10943,
    wearable_ids: [306, 338],
  },
  {
    genesis_token_id: 10944,
    wearable_ids: [368, 254],
  },
  {
    genesis_token_id: 10945,
    wearable_ids: [290, 394],
  },
  {
    genesis_token_id: 10946,
    wearable_ids: [383, 387],
  },
  {
    genesis_token_id: 10947,
    wearable_ids: [411, 440],
  },
  {
    genesis_token_id: 10948,
    wearable_ids: [424, 375],
  },
  {
    genesis_token_id: 10949,
    wearable_ids: [256, 318],
  },
  {
    genesis_token_id: 10950,
    wearable_ids: [257, 384],
  },
  {
    genesis_token_id: 10951,
    wearable_ids: [383, 437],
  },
  {
    genesis_token_id: 10952,
    wearable_ids: [257, 427],
  },
  {
    genesis_token_id: 10953,
    wearable_ids: [371, 261],
  },
  {
    genesis_token_id: 10954,
    wearable_ids: [278, 354],
  },
  {
    genesis_token_id: 10955,
    wearable_ids: [369, 444],
  },
  {
    genesis_token_id: 10956,
    wearable_ids: [374, 436],
  },
  {
    genesis_token_id: 10957,
    wearable_ids: [280, 275],
  },
  {
    genesis_token_id: 10958,
    wearable_ids: [265, 371],
  },
  {
    genesis_token_id: 10959,
    wearable_ids: [338, 397],
  },
  {
    genesis_token_id: 10960,
    wearable_ids: [301, 311],
  },
  {
    genesis_token_id: 10961,
    wearable_ids: [432, 407],
  },
  {
    genesis_token_id: 10962,
    wearable_ids: [259, 377],
  },
  {
    genesis_token_id: 10963,
    wearable_ids: [406, 373],
  },
  {
    genesis_token_id: 10964,
    wearable_ids: [399, 331],
  },
  {
    genesis_token_id: 10965,
    wearable_ids: [399, 303],
  },
  {
    genesis_token_id: 10966,
    wearable_ids: [433, 342],
  },
  {
    genesis_token_id: 10967,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 10968,
    wearable_ids: [425, 433],
  },
  {
    genesis_token_id: 10969,
    wearable_ids: [382, 347],
  },
  {
    genesis_token_id: 10970,
    wearable_ids: [350, 416],
  },
  {
    genesis_token_id: 10971,
    wearable_ids: [256, 443],
  },
  {
    genesis_token_id: 10972,
    wearable_ids: [406, 287],
  },
  {
    genesis_token_id: 10973,
    wearable_ids: [436, 404],
  },
  {
    genesis_token_id: 10974,
    wearable_ids: [445, 275],
  },
  {
    genesis_token_id: 10975,
    wearable_ids: [400, 397],
  },
  {
    genesis_token_id: 10976,
    wearable_ids: [299, 268],
  },
  {
    genesis_token_id: 10977,
    wearable_ids: [383, 437],
  },
  {
    genesis_token_id: 10978,
    wearable_ids: [425, 266],
  },
  {
    genesis_token_id: 10979,
    wearable_ids: [426, 332],
  },
  {
    genesis_token_id: 10980,
    wearable_ids: [300, 428],
  },
  {
    genesis_token_id: 10981,
    wearable_ids: [445, 411],
  },
  {
    genesis_token_id: 10982,
    wearable_ids: [258, 310],
  },
  {
    genesis_token_id: 10983,
    wearable_ids: [372, 420],
  },
  {
    genesis_token_id: 10984,
    wearable_ids: [423, 335],
  },
  {
    genesis_token_id: 10985,
    wearable_ids: [429, 328],
  },
  {
    genesis_token_id: 10986,
    wearable_ids: [299, 387],
  },
  {
    genesis_token_id: 10987,
    wearable_ids: [280, 366],
  },
  {
    genesis_token_id: 10988,
    wearable_ids: [326, 337],
  },
  {
    genesis_token_id: 10989,
    wearable_ids: [272, 358],
  },
  {
    genesis_token_id: 10990,
    wearable_ids: [369, 365],
  },
  {
    genesis_token_id: 10991,
    wearable_ids: [375, 345],
  },
  {
    genesis_token_id: 10992,
    wearable_ids: [259, 356],
  },
  {
    genesis_token_id: 10993,
    wearable_ids: [253, 294],
  },
  {
    genesis_token_id: 10994,
    wearable_ids: [429, 323],
  },
  {
    genesis_token_id: 10995,
    wearable_ids: [247, 290],
  },
  {
    genesis_token_id: 10996,
    wearable_ids: [363, 411],
  },
  {
    genesis_token_id: 10997,
    wearable_ids: [289, 278],
  },
  {
    genesis_token_id: 10998,
    wearable_ids: [411, 320],
  },
  {
    genesis_token_id: 10999,
    wearable_ids: [319, 412],
  },
  {
    genesis_token_id: 11000,
    wearable_ids: [331, 383],
  },
  {
    genesis_token_id: 11001,
    wearable_ids: [429, 406],
  },
  {
    genesis_token_id: 11002,
    wearable_ids: [257, 391],
  },
  {
    genesis_token_id: 11003,
    wearable_ids: [428, 308],
  },
  {
    genesis_token_id: 11004,
    wearable_ids: [287, 314],
  },
  {
    genesis_token_id: 11005,
    wearable_ids: [280, 339],
  },
  {
    genesis_token_id: 11006,
    wearable_ids: [403, 400],
  },
  {
    genesis_token_id: 11007,
    wearable_ids: [404, 317],
  },
  {
    genesis_token_id: 11008,
    wearable_ids: [326, 288],
  },
  {
    genesis_token_id: 11009,
    wearable_ids: [354, 336],
  },
  {
    genesis_token_id: 11010,
    wearable_ids: [314, 395],
  },
  {
    genesis_token_id: 11011,
    wearable_ids: [384, 299],
  },
  {
    genesis_token_id: 11012,
    wearable_ids: [301, 277],
  },
  {
    genesis_token_id: 11013,
    wearable_ids: [272, 355],
  },
  {
    genesis_token_id: 11014,
    wearable_ids: [291, 362],
  },
  {
    genesis_token_id: 11015,
    wearable_ids: [443, 306],
  },
  {
    genesis_token_id: 11016,
    wearable_ids: [410, 405],
  },
  {
    genesis_token_id: 11017,
    wearable_ids: [406, 315],
  },
  {
    genesis_token_id: 11018,
    wearable_ids: [336, 393],
  },
  {
    genesis_token_id: 11019,
    wearable_ids: [372, 378],
  },
  {
    genesis_token_id: 11020,
    wearable_ids: [247, 440],
  },
  {
    genesis_token_id: 11021,
    wearable_ids: [344, 379],
  },
  {
    genesis_token_id: 11022,
    wearable_ids: [378, 442],
  },
  {
    genesis_token_id: 11023,
    wearable_ids: [274, 363],
  },
  {
    genesis_token_id: 11024,
    wearable_ids: [428, 313],
  },
  {
    genesis_token_id: 11025,
    wearable_ids: [344, 363],
  },
  {
    genesis_token_id: 11026,
    wearable_ids: [412, 434],
  },
  {
    genesis_token_id: 11027,
    wearable_ids: [287, 443],
  },
  {
    genesis_token_id: 11028,
    wearable_ids: [348, 370],
  },
  {
    genesis_token_id: 11029,
    wearable_ids: [332, 364],
  },
  {
    genesis_token_id: 11030,
    wearable_ids: [371, 435],
  },
  {
    genesis_token_id: 11031,
    wearable_ids: [433, 313],
  },
  {
    genesis_token_id: 11032,
    wearable_ids: [431, 383],
  },
  {
    genesis_token_id: 11033,
    wearable_ids: [268, 274],
  },
  {
    genesis_token_id: 11034,
    wearable_ids: [368, 263],
  },
  {
    genesis_token_id: 11035,
    wearable_ids: [295, 441],
  },
  {
    genesis_token_id: 11036,
    wearable_ids: [426, 318],
  },
  {
    genesis_token_id: 11037,
    wearable_ids: [397, 444],
  },
  {
    genesis_token_id: 11038,
    wearable_ids: [332, 253],
  },
  {
    genesis_token_id: 11039,
    wearable_ids: [404, 258],
  },
  {
    genesis_token_id: 11040,
    wearable_ids: [316, 298],
  },
  {
    genesis_token_id: 11041,
    wearable_ids: [373, 445],
  },
  {
    genesis_token_id: 11042,
    wearable_ids: [348, 374],
  },
  {
    genesis_token_id: 11043,
    wearable_ids: [332, 303],
  },
  {
    genesis_token_id: 11044,
    wearable_ids: [337, 402],
  },
  {
    genesis_token_id: 11045,
    wearable_ids: [248, 254],
  },
  {
    genesis_token_id: 11046,
    wearable_ids: [304, 415],
  },
  {
    genesis_token_id: 11047,
    wearable_ids: [317, 346],
  },
  {
    genesis_token_id: 11048,
    wearable_ids: [369, 359],
  },
  {
    genesis_token_id: 11049,
    wearable_ids: [373, 275],
  },
  {
    genesis_token_id: 11050,
    wearable_ids: [370, 257],
  },
  {
    genesis_token_id: 11051,
    wearable_ids: [351, 304],
  },
  {
    genesis_token_id: 11052,
    wearable_ids: [300, 333],
  },
  {
    genesis_token_id: 11053,
    wearable_ids: [425, 375],
  },
  {
    genesis_token_id: 11054,
    wearable_ids: [251, 332],
  },
  {
    genesis_token_id: 11055,
    wearable_ids: [290, 432],
  },
  {
    genesis_token_id: 11056,
    wearable_ids: [301, 424],
  },
  {
    genesis_token_id: 11057,
    wearable_ids: [396, 399],
  },
  {
    genesis_token_id: 11058,
    wearable_ids: [299, 251],
  },
  {
    genesis_token_id: 11059,
    wearable_ids: [253, 268],
  },
  {
    genesis_token_id: 11060,
    wearable_ids: [272, 375],
  },
  {
    genesis_token_id: 11061,
    wearable_ids: [311, 294],
  },
  {
    genesis_token_id: 11062,
    wearable_ids: [413, 306],
  },
  {
    genesis_token_id: 11063,
    wearable_ids: [324, 281],
  },
  {
    genesis_token_id: 11064,
    wearable_ids: [407, 403],
  },
  {
    genesis_token_id: 11065,
    wearable_ids: [369, 334],
  },
  {
    genesis_token_id: 11066,
    wearable_ids: [304, 407],
  },
  {
    genesis_token_id: 11067,
    wearable_ids: [272, 298],
  },
  {
    genesis_token_id: 11068,
    wearable_ids: [372, 386],
  },
  {
    genesis_token_id: 11069,
    wearable_ids: [432, 397],
  },
  {
    genesis_token_id: 11070,
    wearable_ids: [292, 254],
  },
  {
    genesis_token_id: 11071,
    wearable_ids: [300, 286],
  },
  {
    genesis_token_id: 11072,
    wearable_ids: [273, 287],
  },
  {
    genesis_token_id: 11073,
    wearable_ids: [442, 403],
  },
  {
    genesis_token_id: 11074,
    wearable_ids: [422, 280],
  },
  {
    genesis_token_id: 11075,
    wearable_ids: [363, 411],
  },
  {
    genesis_token_id: 11076,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 11077,
    wearable_ids: [378, 424],
  },
  {
    genesis_token_id: 11078,
    wearable_ids: [363, 364],
  },
  {
    genesis_token_id: 11079,
    wearable_ids: [295, 283],
  },
  {
    genesis_token_id: 11080,
    wearable_ids: [387, 383],
  },
  {
    genesis_token_id: 11081,
    wearable_ids: [384, 348],
  },
  {
    genesis_token_id: 11082,
    wearable_ids: [372, 332],
  },
  {
    genesis_token_id: 11083,
    wearable_ids: [289, 436],
  },
  {
    genesis_token_id: 11084,
    wearable_ids: [424, 343],
  },
  {
    genesis_token_id: 11085,
    wearable_ids: [286, 349],
  },
  {
    genesis_token_id: 11086,
    wearable_ids: [317, 434],
  },
  {
    genesis_token_id: 11087,
    wearable_ids: [280, 396],
  },
  {
    genesis_token_id: 11088,
    wearable_ids: [434, 423],
  },
  {
    genesis_token_id: 11089,
    wearable_ids: [314, 286],
  },
  {
    genesis_token_id: 11090,
    wearable_ids: [376, 419],
  },
  {
    genesis_token_id: 11091,
    wearable_ids: [332, 443],
  },
  {
    genesis_token_id: 11092,
    wearable_ids: [403, 289],
  },
  {
    genesis_token_id: 11093,
    wearable_ids: [255, 372],
  },
  {
    genesis_token_id: 11094,
    wearable_ids: [355, 267],
  },
  {
    genesis_token_id: 11095,
    wearable_ids: [364, 274],
  },
  {
    genesis_token_id: 11096,
    wearable_ids: [383, 438],
  },
  {
    genesis_token_id: 11097,
    wearable_ids: [256, 389],
  },
  {
    genesis_token_id: 11098,
    wearable_ids: [340, 387],
  },
  {
    genesis_token_id: 11099,
    wearable_ids: [403, 375],
  },
  {
    genesis_token_id: 11100,
    wearable_ids: [338, 257],
  },
  {
    genesis_token_id: 11101,
    wearable_ids: [434, 291],
  },
  {
    genesis_token_id: 11102,
    wearable_ids: [276, 351],
  },
  {
    genesis_token_id: 11103,
    wearable_ids: [407, 400],
  },
  {
    genesis_token_id: 11104,
    wearable_ids: [412, 394],
  },
  {
    genesis_token_id: 11105,
    wearable_ids: [375, 262],
  },
  {
    genesis_token_id: 11106,
    wearable_ids: [303, 358],
  },
  {
    genesis_token_id: 11107,
    wearable_ids: [429, 391],
  },
  {
    genesis_token_id: 11108,
    wearable_ids: [445, 416],
  },
  {
    genesis_token_id: 11109,
    wearable_ids: [268, 262],
  },
  {
    genesis_token_id: 11110,
    wearable_ids: [301, 254],
  },
  {
    genesis_token_id: 11111,
    wearable_ids: [400, 425],
  },
  {
    genesis_token_id: 11112,
    wearable_ids: [412, 254],
  },
  {
    genesis_token_id: 11113,
    wearable_ids: [443, 255],
  },
  {
    genesis_token_id: 11114,
    wearable_ids: [338, 378],
  },
  {
    genesis_token_id: 11115,
    wearable_ids: [332, 325],
  },
  {
    genesis_token_id: 11116,
    wearable_ids: [404, 247],
  },
  {
    genesis_token_id: 11117,
    wearable_ids: [340, 296],
  },
  {
    genesis_token_id: 11118,
    wearable_ids: [258, 326],
  },
  {
    genesis_token_id: 11119,
    wearable_ids: [352, 407],
  },
  {
    genesis_token_id: 11120,
    wearable_ids: [284, 431],
  },
  {
    genesis_token_id: 11121,
    wearable_ids: [336, 328],
  },
  {
    genesis_token_id: 11122,
    wearable_ids: [377, 359],
  },
  {
    genesis_token_id: 11123,
    wearable_ids: [363, 423],
  },
  {
    genesis_token_id: 11124,
    wearable_ids: [363, 315],
  },
  {
    genesis_token_id: 11125,
    wearable_ids: [348, 337],
  },
  {
    genesis_token_id: 11126,
    wearable_ids: [396, 328],
  },
  {
    genesis_token_id: 11127,
    wearable_ids: [254, 435],
  },
  {
    genesis_token_id: 11128,
    wearable_ids: [422, 344],
  },
  {
    genesis_token_id: 11129,
    wearable_ids: [399, 408],
  },
  {
    genesis_token_id: 11130,
    wearable_ids: [372, 426],
  },
  {
    genesis_token_id: 11131,
    wearable_ids: [262, 304],
  },
  {
    genesis_token_id: 11132,
    wearable_ids: [317, 291],
  },
  {
    genesis_token_id: 11133,
    wearable_ids: [295, 376],
  },
  {
    genesis_token_id: 11134,
    wearable_ids: [270, 408],
  },
  {
    genesis_token_id: 11135,
    wearable_ids: [247, 304],
  },
  {
    genesis_token_id: 11136,
    wearable_ids: [273, 304],
  },
  {
    genesis_token_id: 11137,
    wearable_ids: [290, 354],
  },
  {
    genesis_token_id: 11138,
    wearable_ids: [369, 269],
  },
  {
    genesis_token_id: 11139,
    wearable_ids: [273, 409],
  },
  {
    genesis_token_id: 11140,
    wearable_ids: [319, 436],
  },
  {
    genesis_token_id: 11141,
    wearable_ids: [311, 369],
  },
  {
    genesis_token_id: 11142,
    wearable_ids: [424, 399],
  },
  {
    genesis_token_id: 11143,
    wearable_ids: [382, 278],
  },
  {
    genesis_token_id: 11144,
    wearable_ids: [354, 255],
  },
  {
    genesis_token_id: 11145,
    wearable_ids: [280, 257],
  },
  {
    genesis_token_id: 11146,
    wearable_ids: [325, 404],
  },
  {
    genesis_token_id: 11147,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 11148,
    wearable_ids: [397, 289],
  },
  {
    genesis_token_id: 11149,
    wearable_ids: [342, 350],
  },
  {
    genesis_token_id: 11150,
    wearable_ids: [433, 389],
  },
  {
    genesis_token_id: 11151,
    wearable_ids: [382, 352],
  },
  {
    genesis_token_id: 11152,
    wearable_ids: [308, 352],
  },
  {
    genesis_token_id: 11153,
    wearable_ids: [376, 340],
  },
  {
    genesis_token_id: 11154,
    wearable_ids: [377, 299],
  },
  {
    genesis_token_id: 11155,
    wearable_ids: [332, 248],
  },
  {
    genesis_token_id: 11156,
    wearable_ids: [263, 258],
  },
  {
    genesis_token_id: 11157,
    wearable_ids: [412, 374],
  },
  {
    genesis_token_id: 11158,
    wearable_ids: [273, 422],
  },
  {
    genesis_token_id: 11159,
    wearable_ids: [422, 270],
  },
  {
    genesis_token_id: 11160,
    wearable_ids: [291, 435],
  },
  {
    genesis_token_id: 11161,
    wearable_ids: [316, 395],
  },
  {
    genesis_token_id: 11162,
    wearable_ids: [403, 315],
  },
  {
    genesis_token_id: 11163,
    wearable_ids: [326, 290],
  },
  {
    genesis_token_id: 11164,
    wearable_ids: [259, 325],
  },
  {
    genesis_token_id: 11165,
    wearable_ids: [444, 387],
  },
  {
    genesis_token_id: 11166,
    wearable_ids: [435, 313],
  },
  {
    genesis_token_id: 11167,
    wearable_ids: [258, 441],
  },
  {
    genesis_token_id: 11168,
    wearable_ids: [385, 263],
  },
  {
    genesis_token_id: 11169,
    wearable_ids: [386, 259],
  },
  {
    genesis_token_id: 11170,
    wearable_ids: [297, 434],
  },
  {
    genesis_token_id: 11171,
    wearable_ids: [306, 299],
  },
  {
    genesis_token_id: 11172,
    wearable_ids: [339, 299],
  },
  {
    genesis_token_id: 11173,
    wearable_ids: [276, 444],
  },
  {
    genesis_token_id: 11174,
    wearable_ids: [289, 419],
  },
  {
    genesis_token_id: 11175,
    wearable_ids: [354, 272],
  },
  {
    genesis_token_id: 11176,
    wearable_ids: [445, 374],
  },
  {
    genesis_token_id: 11177,
    wearable_ids: [272, 308],
  },
  {
    genesis_token_id: 11178,
    wearable_ids: [348, 258],
  },
  {
    genesis_token_id: 11179,
    wearable_ids: [403, 382],
  },
  {
    genesis_token_id: 11180,
    wearable_ids: [376, 331],
  },
  {
    genesis_token_id: 11181,
    wearable_ids: [387, 357],
  },
  {
    genesis_token_id: 11182,
    wearable_ids: [420, 299],
  },
  {
    genesis_token_id: 11183,
    wearable_ids: [431, 435],
  },
  {
    genesis_token_id: 11184,
    wearable_ids: [384, 368],
  },
  {
    genesis_token_id: 11185,
    wearable_ids: [297, 318],
  },
  {
    genesis_token_id: 11186,
    wearable_ids: [251, 388],
  },
  {
    genesis_token_id: 11187,
    wearable_ids: [292, 444],
  },
  {
    genesis_token_id: 11188,
    wearable_ids: [294, 417],
  },
  {
    genesis_token_id: 11189,
    wearable_ids: [396, 395],
  },
  {
    genesis_token_id: 11190,
    wearable_ids: [442, 409],
  },
  {
    genesis_token_id: 11191,
    wearable_ids: [362, 420],
  },
  {
    genesis_token_id: 11192,
    wearable_ids: [407, 355],
  },
  {
    genesis_token_id: 11193,
    wearable_ids: [310, 297],
  },
  {
    genesis_token_id: 11194,
    wearable_ids: [304, 300],
  },
  {
    genesis_token_id: 11195,
    wearable_ids: [297, 443],
  },
  {
    genesis_token_id: 11196,
    wearable_ids: [290, 291],
  },
  {
    genesis_token_id: 11197,
    wearable_ids: [443, 409],
  },
  {
    genesis_token_id: 11198,
    wearable_ids: [336, 324],
  },
  {
    genesis_token_id: 11199,
    wearable_ids: [348, 373],
  },
  {
    genesis_token_id: 11200,
    wearable_ids: [286, 352],
  },
  {
    genesis_token_id: 11201,
    wearable_ids: [352, 346],
  },
  {
    genesis_token_id: 11202,
    wearable_ids: [314, 317],
  },
  {
    genesis_token_id: 11203,
    wearable_ids: [384, 286],
  },
  {
    genesis_token_id: 11204,
    wearable_ids: [331, 422],
  },
  {
    genesis_token_id: 11205,
    wearable_ids: [290, 362],
  },
  {
    genesis_token_id: 11206,
    wearable_ids: [425, 316],
  },
  {
    genesis_token_id: 11207,
    wearable_ids: [271, 326],
  },
  {
    genesis_token_id: 11208,
    wearable_ids: [444, 274],
  },
  {
    genesis_token_id: 11209,
    wearable_ids: [400, 443],
  },
  {
    genesis_token_id: 11210,
    wearable_ids: [424, 395],
  },
  {
    genesis_token_id: 11211,
    wearable_ids: [284, 371],
  },
  {
    genesis_token_id: 11212,
    wearable_ids: [256, 378],
  },
  {
    genesis_token_id: 11213,
    wearable_ids: [276, 294],
  },
  {
    genesis_token_id: 11214,
    wearable_ids: [325, 351],
  },
  {
    genesis_token_id: 11215,
    wearable_ids: [248, 299],
  },
  {
    genesis_token_id: 11216,
    wearable_ids: [372, 246],
  },
  {
    genesis_token_id: 11217,
    wearable_ids: [287, 445],
  },
  {
    genesis_token_id: 11218,
    wearable_ids: [266, 278],
  },
  {
    genesis_token_id: 11219,
    wearable_ids: [363, 389],
  },
  {
    genesis_token_id: 11220,
    wearable_ids: [369, 343],
  },
  {
    genesis_token_id: 11221,
    wearable_ids: [409, 362],
  },
  {
    genesis_token_id: 11222,
    wearable_ids: [273, 281],
  },
  {
    genesis_token_id: 11223,
    wearable_ids: [324, 284],
  },
  {
    genesis_token_id: 11224,
    wearable_ids: [368, 370],
  },
  {
    genesis_token_id: 11225,
    wearable_ids: [378, 311],
  },
  {
    genesis_token_id: 11226,
    wearable_ids: [256, 297],
  },
  {
    genesis_token_id: 11227,
    wearable_ids: [314, 436],
  },
  {
    genesis_token_id: 11228,
    wearable_ids: [254, 389],
  },
  {
    genesis_token_id: 11229,
    wearable_ids: [271, 341],
  },
  {
    genesis_token_id: 11230,
    wearable_ids: [340, 289],
  },
  {
    genesis_token_id: 11231,
    wearable_ids: [369, 400],
  },
  {
    genesis_token_id: 11232,
    wearable_ids: [336, 413],
  },
  {
    genesis_token_id: 11233,
    wearable_ids: [425, 406],
  },
  {
    genesis_token_id: 11234,
    wearable_ids: [308, 351],
  },
  {
    genesis_token_id: 11235,
    wearable_ids: [351, 384],
  },
  {
    genesis_token_id: 11236,
    wearable_ids: [428, 271],
  },
  {
    genesis_token_id: 11237,
    wearable_ids: [251, 335],
  },
  {
    genesis_token_id: 11238,
    wearable_ids: [442, 371],
  },
  {
    genesis_token_id: 11239,
    wearable_ids: [273, 350],
  },
  {
    genesis_token_id: 11240,
    wearable_ids: [301, 266],
  },
  {
    genesis_token_id: 11241,
    wearable_ids: [371, 347],
  },
  {
    genesis_token_id: 11242,
    wearable_ids: [397, 365],
  },
  {
    genesis_token_id: 11243,
    wearable_ids: [368, 362],
  },
  {
    genesis_token_id: 11244,
    wearable_ids: [286, 444],
  },
  {
    genesis_token_id: 11245,
    wearable_ids: [294, 424],
  },
  {
    genesis_token_id: 11246,
    wearable_ids: [324, 261],
  },
  {
    genesis_token_id: 11247,
    wearable_ids: [270, 410],
  },
  {
    genesis_token_id: 11248,
    wearable_ids: [346, 262],
  },
  {
    genesis_token_id: 11249,
    wearable_ids: [406, 338],
  },
  {
    genesis_token_id: 11250,
    wearable_ids: [303, 409],
  },
  {
    genesis_token_id: 11251,
    wearable_ids: [248, 316],
  },
  {
    genesis_token_id: 11252,
    wearable_ids: [259, 334],
  },
  {
    genesis_token_id: 11253,
    wearable_ids: [406, 350],
  },
  {
    genesis_token_id: 11254,
    wearable_ids: [385, 319],
  },
  {
    genesis_token_id: 11255,
    wearable_ids: [338, 349],
  },
  {
    genesis_token_id: 11256,
    wearable_ids: [255, 276],
  },
  {
    genesis_token_id: 11257,
    wearable_ids: [376, 300],
  },
  {
    genesis_token_id: 11258,
    wearable_ids: [248, 278],
  },
  {
    genesis_token_id: 11259,
    wearable_ids: [339, 291],
  },
  {
    genesis_token_id: 11260,
    wearable_ids: [289, 264],
  },
  {
    genesis_token_id: 11261,
    wearable_ids: [287, 284],
  },
  {
    genesis_token_id: 11262,
    wearable_ids: [303, 351],
  },
  {
    genesis_token_id: 11263,
    wearable_ids: [299, 326],
  },
  {
    genesis_token_id: 11264,
    wearable_ids: [270, 271],
  },
  {
    genesis_token_id: 11265,
    wearable_ids: [294, 307],
  },
  {
    genesis_token_id: 11266,
    wearable_ids: [425, 346],
  },
  {
    genesis_token_id: 11267,
    wearable_ids: [365, 431],
  },
  {
    genesis_token_id: 11268,
    wearable_ids: [362, 287],
  },
  {
    genesis_token_id: 11269,
    wearable_ids: [362, 431],
  },
  {
    genesis_token_id: 11270,
    wearable_ids: [271, 347],
  },
  {
    genesis_token_id: 11271,
    wearable_ids: [374, 433],
  },
  {
    genesis_token_id: 11272,
    wearable_ids: [280, 272],
  },
  {
    genesis_token_id: 11273,
    wearable_ids: [403, 271],
  },
  {
    genesis_token_id: 11274,
    wearable_ids: [270, 315],
  },
  {
    genesis_token_id: 11275,
    wearable_ids: [348, 258],
  },
  {
    genesis_token_id: 11276,
    wearable_ids: [296, 343],
  },
  {
    genesis_token_id: 11277,
    wearable_ids: [395, 318],
  },
  {
    genesis_token_id: 11278,
    wearable_ids: [276, 340],
  },
  {
    genesis_token_id: 11279,
    wearable_ids: [410, 352],
  },
  {
    genesis_token_id: 11280,
    wearable_ids: [408, 419],
  },
  {
    genesis_token_id: 11281,
    wearable_ids: [270, 438],
  },
  {
    genesis_token_id: 11282,
    wearable_ids: [396, 352],
  },
  {
    genesis_token_id: 11283,
    wearable_ids: [274, 386],
  },
  {
    genesis_token_id: 11284,
    wearable_ids: [428, 338],
  },
  {
    genesis_token_id: 11285,
    wearable_ids: [339, 350],
  },
  {
    genesis_token_id: 11286,
    wearable_ids: [395, 313],
  },
  {
    genesis_token_id: 11287,
    wearable_ids: [304, 435],
  },
  {
    genesis_token_id: 11288,
    wearable_ids: [355, 339],
  },
  {
    genesis_token_id: 11289,
    wearable_ids: [253, 301],
  },
  {
    genesis_token_id: 11290,
    wearable_ids: [264, 281],
  },
  {
    genesis_token_id: 11291,
    wearable_ids: [372, 268],
  },
  {
    genesis_token_id: 11292,
    wearable_ids: [354, 289],
  },
  {
    genesis_token_id: 11293,
    wearable_ids: [347, 422],
  },
  {
    genesis_token_id: 11294,
    wearable_ids: [339, 308],
  },
  {
    genesis_token_id: 11295,
    wearable_ids: [265, 317],
  },
  {
    genesis_token_id: 11296,
    wearable_ids: [437, 386],
  },
  {
    genesis_token_id: 11297,
    wearable_ids: [257, 340],
  },
  {
    genesis_token_id: 11298,
    wearable_ids: [266, 432],
  },
  {
    genesis_token_id: 11299,
    wearable_ids: [400, 253],
  },
  {
    genesis_token_id: 11300,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 11301,
    wearable_ids: [348, 444],
  },
  {
    genesis_token_id: 11302,
    wearable_ids: [336, 266],
  },
  {
    genesis_token_id: 11303,
    wearable_ids: [336, 257],
  },
  {
    genesis_token_id: 11304,
    wearable_ids: [317, 399],
  },
  {
    genesis_token_id: 11305,
    wearable_ids: [247, 425],
  },
  {
    genesis_token_id: 11306,
    wearable_ids: [404, 428],
  },
  {
    genesis_token_id: 11307,
    wearable_ids: [286, 276],
  },
  {
    genesis_token_id: 11308,
    wearable_ids: [290, 312],
  },
  {
    genesis_token_id: 11309,
    wearable_ids: [303, 434],
  },
  {
    genesis_token_id: 11310,
    wearable_ids: [342, 273],
  },
  {
    genesis_token_id: 11311,
    wearable_ids: [371, 293],
  },
  {
    genesis_token_id: 11312,
    wearable_ids: [308, 393],
  },
  {
    genesis_token_id: 11313,
    wearable_ids: [340, 257],
  },
  {
    genesis_token_id: 11314,
    wearable_ids: [396, 317],
  },
  {
    genesis_token_id: 11315,
    wearable_ids: [310, 352],
  },
  {
    genesis_token_id: 11316,
    wearable_ids: [400, 374],
  },
  {
    genesis_token_id: 11317,
    wearable_ids: [346, 258],
  },
  {
    genesis_token_id: 11318,
    wearable_ids: [413, 375],
  },
  {
    genesis_token_id: 11319,
    wearable_ids: [373, 301],
  },
  {
    genesis_token_id: 11320,
    wearable_ids: [389, 436],
  },
  {
    genesis_token_id: 11321,
    wearable_ids: [336, 247],
  },
  {
    genesis_token_id: 11322,
    wearable_ids: [337, 254],
  },
  {
    genesis_token_id: 11323,
    wearable_ids: [350, 332],
  },
  {
    genesis_token_id: 11324,
    wearable_ids: [363, 285],
  },
  {
    genesis_token_id: 11325,
    wearable_ids: [382, 322],
  },
  {
    genesis_token_id: 11326,
    wearable_ids: [304, 345],
  },
  {
    genesis_token_id: 11327,
    wearable_ids: [258, 283],
  },
  {
    genesis_token_id: 11328,
    wearable_ids: [397, 286],
  },
  {
    genesis_token_id: 11329,
    wearable_ids: [362, 344],
  },
  {
    genesis_token_id: 11330,
    wearable_ids: [362, 319],
  },
  {
    genesis_token_id: 11331,
    wearable_ids: [372, 424],
  },
  {
    genesis_token_id: 11332,
    wearable_ids: [319, 337],
  },
  {
    genesis_token_id: 11333,
    wearable_ids: [319, 268],
  },
  {
    genesis_token_id: 11334,
    wearable_ids: [301, 431],
  },
  {
    genesis_token_id: 11335,
    wearable_ids: [362, 350],
  },
  {
    genesis_token_id: 11336,
    wearable_ids: [365, 444],
  },
  {
    genesis_token_id: 11337,
    wearable_ids: [434, 364],
  },
  {
    genesis_token_id: 11338,
    wearable_ids: [389, 385],
  },
  {
    genesis_token_id: 11339,
    wearable_ids: [347, 419],
  },
  {
    genesis_token_id: 11340,
    wearable_ids: [265, 442],
  },
  {
    genesis_token_id: 11341,
    wearable_ids: [301, 397],
  },
  {
    genesis_token_id: 11342,
    wearable_ids: [251, 357],
  },
  {
    genesis_token_id: 11343,
    wearable_ids: [437, 385],
  },
  {
    genesis_token_id: 11344,
    wearable_ids: [409, 249],
  },
  {
    genesis_token_id: 11345,
    wearable_ids: [340, 369],
  },
  {
    genesis_token_id: 11346,
    wearable_ids: [325, 259],
  },
  {
    genesis_token_id: 11347,
    wearable_ids: [372, 432],
  },
  {
    genesis_token_id: 11348,
    wearable_ids: [335, 443],
  },
  {
    genesis_token_id: 11349,
    wearable_ids: [382, 411],
  },
  {
    genesis_token_id: 11350,
    wearable_ids: [290, 422],
  },
  {
    genesis_token_id: 11351,
    wearable_ids: [373, 363],
  },
  {
    genesis_token_id: 11352,
    wearable_ids: [286, 396],
  },
  {
    genesis_token_id: 11353,
    wearable_ids: [408, 422],
  },
  {
    genesis_token_id: 11354,
    wearable_ids: [338, 397],
  },
  {
    genesis_token_id: 11355,
    wearable_ids: [395, 424],
  },
  {
    genesis_token_id: 11356,
    wearable_ids: [445, 299],
  },
  {
    genesis_token_id: 11357,
    wearable_ids: [409, 424],
  },
  {
    genesis_token_id: 11358,
    wearable_ids: [350, 332],
  },
  {
    genesis_token_id: 11359,
    wearable_ids: [314, 437],
  },
  {
    genesis_token_id: 11360,
    wearable_ids: [300, 306],
  },
  {
    genesis_token_id: 11361,
    wearable_ids: [442, 379],
  },
  {
    genesis_token_id: 11362,
    wearable_ids: [350, 443],
  },
  {
    genesis_token_id: 11363,
    wearable_ids: [400, 401],
  },
  {
    genesis_token_id: 11364,
    wearable_ids: [280, 401],
  },
  {
    genesis_token_id: 11365,
    wearable_ids: [362, 325],
  },
  {
    genesis_token_id: 11366,
    wearable_ids: [254, 347],
  },
  {
    genesis_token_id: 11367,
    wearable_ids: [406, 429],
  },
  {
    genesis_token_id: 11368,
    wearable_ids: [295, 277],
  },
  {
    genesis_token_id: 11369,
    wearable_ids: [262, 281],
  },
  {
    genesis_token_id: 11370,
    wearable_ids: [411, 264],
  },
  {
    genesis_token_id: 11371,
    wearable_ids: [355, 369],
  },
  {
    genesis_token_id: 11372,
    wearable_ids: [373, 327],
  },
  {
    genesis_token_id: 11373,
    wearable_ids: [265, 258],
  },
  {
    genesis_token_id: 11374,
    wearable_ids: [351, 254],
  },
  {
    genesis_token_id: 11375,
    wearable_ids: [341, 377],
  },
  {
    genesis_token_id: 11376,
    wearable_ids: [316, 257],
  },
  {
    genesis_token_id: 11377,
    wearable_ids: [319, 369],
  },
  {
    genesis_token_id: 11378,
    wearable_ids: [354, 257],
  },
  {
    genesis_token_id: 11379,
    wearable_ids: [420, 411],
  },
  {
    genesis_token_id: 11380,
    wearable_ids: [291, 277],
  },
  {
    genesis_token_id: 11381,
    wearable_ids: [375, 371],
  },
  {
    genesis_token_id: 11382,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 11383,
    wearable_ids: [338, 425],
  },
  {
    genesis_token_id: 11384,
    wearable_ids: [296, 278],
  },
  {
    genesis_token_id: 11385,
    wearable_ids: [274, 319],
  },
  {
    genesis_token_id: 11386,
    wearable_ids: [314, 379],
  },
  {
    genesis_token_id: 11387,
    wearable_ids: [395, 336],
  },
  {
    genesis_token_id: 11388,
    wearable_ids: [375, 428],
  },
  {
    genesis_token_id: 11389,
    wearable_ids: [376, 396],
  },
  {
    genesis_token_id: 11390,
    wearable_ids: [272, 360],
  },
  {
    genesis_token_id: 11391,
    wearable_ids: [374, 414],
  },
  {
    genesis_token_id: 11392,
    wearable_ids: [347, 259],
  },
  {
    genesis_token_id: 11393,
    wearable_ids: [377, 325],
  },
  {
    genesis_token_id: 11394,
    wearable_ids: [303, 364],
  },
  {
    genesis_token_id: 11395,
    wearable_ids: [374, 291],
  },
  {
    genesis_token_id: 11396,
    wearable_ids: [386, 430],
  },
  {
    genesis_token_id: 11397,
    wearable_ids: [340, 306],
  },
  {
    genesis_token_id: 11398,
    wearable_ids: [251, 407],
  },
  {
    genesis_token_id: 11399,
    wearable_ids: [400, 332],
  },
  {
    genesis_token_id: 11400,
    wearable_ids: [368, 366],
  },
  {
    genesis_token_id: 11401,
    wearable_ids: [415, 400],
  },
  {
    genesis_token_id: 11402,
    wearable_ids: [365, 344],
  },
  {
    genesis_token_id: 11403,
    wearable_ids: [413, 392],
  },
  {
    genesis_token_id: 11404,
    wearable_ids: [433, 342],
  },
  {
    genesis_token_id: 11405,
    wearable_ids: [376, 301],
  },
  {
    genesis_token_id: 11406,
    wearable_ids: [404, 360],
  },
  {
    genesis_token_id: 11407,
    wearable_ids: [339, 291],
  },
  {
    genesis_token_id: 11408,
    wearable_ids: [270, 259],
  },
  {
    genesis_token_id: 11409,
    wearable_ids: [287, 254],
  },
  {
    genesis_token_id: 11410,
    wearable_ids: [263, 319],
  },
  {
    genesis_token_id: 11411,
    wearable_ids: [317, 431],
  },
  {
    genesis_token_id: 11412,
    wearable_ids: [268, 397],
  },
  {
    genesis_token_id: 11413,
    wearable_ids: [255, 377],
  },
  {
    genesis_token_id: 11414,
    wearable_ids: [308, 441],
  },
  {
    genesis_token_id: 11415,
    wearable_ids: [308, 265],
  },
  {
    genesis_token_id: 11416,
    wearable_ids: [346, 272],
  },
  {
    genesis_token_id: 11417,
    wearable_ids: [434, 438],
  },
  {
    genesis_token_id: 11418,
    wearable_ids: [434, 277],
  },
  {
    genesis_token_id: 11419,
    wearable_ids: [436, 289],
  },
  {
    genesis_token_id: 11420,
    wearable_ids: [315, 405],
  },
  {
    genesis_token_id: 11421,
    wearable_ids: [404, 264],
  },
  {
    genesis_token_id: 11422,
    wearable_ids: [374, 428],
  },
  {
    genesis_token_id: 11423,
    wearable_ids: [437, 265],
  },
  {
    genesis_token_id: 11424,
    wearable_ids: [409, 344],
  },
  {
    genesis_token_id: 11425,
    wearable_ids: [410, 276],
  },
  {
    genesis_token_id: 11426,
    wearable_ids: [354, 362],
  },
  {
    genesis_token_id: 11427,
    wearable_ids: [376, 317],
  },
  {
    genesis_token_id: 11428,
    wearable_ids: [428, 287],
  },
  {
    genesis_token_id: 11429,
    wearable_ids: [335, 420],
  },
  {
    genesis_token_id: 11430,
    wearable_ids: [284, 368],
  },
  {
    genesis_token_id: 11431,
    wearable_ids: [368, 318],
  },
  {
    genesis_token_id: 11432,
    wearable_ids: [403, 290],
  },
  {
    genesis_token_id: 11433,
    wearable_ids: [335, 419],
  },
  {
    genesis_token_id: 11434,
    wearable_ids: [331, 369],
  },
  {
    genesis_token_id: 11435,
    wearable_ids: [296, 320],
  },
  {
    genesis_token_id: 11436,
    wearable_ids: [343, 352],
  },
  {
    genesis_token_id: 11437,
    wearable_ids: [315, 425],
  },
  {
    genesis_token_id: 11438,
    wearable_ids: [259, 371],
  },
  {
    genesis_token_id: 11439,
    wearable_ids: [411, 401],
  },
  {
    genesis_token_id: 11440,
    wearable_ids: [315, 432],
  },
  {
    genesis_token_id: 11441,
    wearable_ids: [308, 442],
  },
  {
    genesis_token_id: 11442,
    wearable_ids: [389, 272],
  },
  {
    genesis_token_id: 11443,
    wearable_ids: [397, 351],
  },
  {
    genesis_token_id: 11444,
    wearable_ids: [273, 307],
  },
  {
    genesis_token_id: 11445,
    wearable_ids: [266, 259],
  },
  {
    genesis_token_id: 11446,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 11447,
    wearable_ids: [376, 426],
  },
  {
    genesis_token_id: 11448,
    wearable_ids: [355, 397],
  },
  {
    genesis_token_id: 11449,
    wearable_ids: [385, 272],
  },
  {
    genesis_token_id: 11450,
    wearable_ids: [347, 300],
  },
  {
    genesis_token_id: 11451,
    wearable_ids: [434, 370],
  },
  {
    genesis_token_id: 11452,
    wearable_ids: [351, 314],
  },
  {
    genesis_token_id: 11453,
    wearable_ids: [306, 311],
  },
  {
    genesis_token_id: 11454,
    wearable_ids: [254, 271],
  },
  {
    genesis_token_id: 11455,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 11456,
    wearable_ids: [424, 330],
  },
  {
    genesis_token_id: 11457,
    wearable_ids: [426, 288],
  },
  {
    genesis_token_id: 11458,
    wearable_ids: [369, 315],
  },
  {
    genesis_token_id: 11459,
    wearable_ids: [326, 368],
  },
  {
    genesis_token_id: 11460,
    wearable_ids: [437, 365],
  },
  {
    genesis_token_id: 11461,
    wearable_ids: [443, 351],
  },
  {
    genesis_token_id: 11462,
    wearable_ids: [344, 412],
  },
  {
    genesis_token_id: 11463,
    wearable_ids: [434, 433],
  },
  {
    genesis_token_id: 11464,
    wearable_ids: [266, 383],
  },
  {
    genesis_token_id: 11465,
    wearable_ids: [433, 307],
  },
  {
    genesis_token_id: 11466,
    wearable_ids: [278, 349],
  },
  {
    genesis_token_id: 11467,
    wearable_ids: [257, 389],
  },
  {
    genesis_token_id: 11468,
    wearable_ids: [351, 415],
  },
  {
    genesis_token_id: 11469,
    wearable_ids: [363, 335],
  },
  {
    genesis_token_id: 11470,
    wearable_ids: [340, 299],
  },
  {
    genesis_token_id: 11471,
    wearable_ids: [415, 259],
  },
  {
    genesis_token_id: 11472,
    wearable_ids: [423, 264],
  },
  {
    genesis_token_id: 11473,
    wearable_ids: [435, 355],
  },
  {
    genesis_token_id: 11474,
    wearable_ids: [325, 431],
  },
  {
    genesis_token_id: 11475,
    wearable_ids: [341, 326],
  },
  {
    genesis_token_id: 11476,
    wearable_ids: [272, 299],
  },
  {
    genesis_token_id: 11477,
    wearable_ids: [310, 331],
  },
  {
    genesis_token_id: 11478,
    wearable_ids: [255, 313],
  },
  {
    genesis_token_id: 11479,
    wearable_ids: [294, 255],
  },
  {
    genesis_token_id: 11480,
    wearable_ids: [435, 294],
  },
  {
    genesis_token_id: 11481,
    wearable_ids: [389, 358],
  },
  {
    genesis_token_id: 11482,
    wearable_ids: [316, 276],
  },
  {
    genesis_token_id: 11483,
    wearable_ids: [297, 345],
  },
  {
    genesis_token_id: 11484,
    wearable_ids: [444, 297],
  },
  {
    genesis_token_id: 11485,
    wearable_ids: [297, 285],
  },
  {
    genesis_token_id: 11486,
    wearable_ids: [297, 420],
  },
  {
    genesis_token_id: 11487,
    wearable_ids: [362, 324],
  },
  {
    genesis_token_id: 11488,
    wearable_ids: [400, 347],
  },
  {
    genesis_token_id: 11489,
    wearable_ids: [268, 280],
  },
  {
    genesis_token_id: 11490,
    wearable_ids: [351, 372],
  },
  {
    genesis_token_id: 11491,
    wearable_ids: [410, 296],
  },
  {
    genesis_token_id: 11492,
    wearable_ids: [326, 262],
  },
  {
    genesis_token_id: 11493,
    wearable_ids: [335, 267],
  },
  {
    genesis_token_id: 11494,
    wearable_ids: [258, 310],
  },
  {
    genesis_token_id: 11495,
    wearable_ids: [303, 274],
  },
  {
    genesis_token_id: 11496,
    wearable_ids: [291, 362],
  },
  {
    genesis_token_id: 11497,
    wearable_ids: [369, 261],
  },
  {
    genesis_token_id: 11498,
    wearable_ids: [341, 428],
  },
  {
    genesis_token_id: 11499,
    wearable_ids: [259, 408],
  },
  {
    genesis_token_id: 11500,
    wearable_ids: [395, 396],
  },
  {
    genesis_token_id: 11501,
    wearable_ids: [411, 426],
  },
  {
    genesis_token_id: 11502,
    wearable_ids: [251, 378],
  },
  {
    genesis_token_id: 11503,
    wearable_ids: [372, 336],
  },
  {
    genesis_token_id: 11504,
    wearable_ids: [340, 317],
  },
  {
    genesis_token_id: 11505,
    wearable_ids: [308, 355],
  },
  {
    genesis_token_id: 11506,
    wearable_ids: [396, 307],
  },
  {
    genesis_token_id: 11507,
    wearable_ids: [370, 255],
  },
  {
    genesis_token_id: 11508,
    wearable_ids: [292, 404],
  },
  {
    genesis_token_id: 11509,
    wearable_ids: [377, 386],
  },
  {
    genesis_token_id: 11510,
    wearable_ids: [247, 349],
  },
  {
    genesis_token_id: 11511,
    wearable_ids: [369, 270],
  },
  {
    genesis_token_id: 11512,
    wearable_ids: [437, 289],
  },
  {
    genesis_token_id: 11513,
    wearable_ids: [442, 299],
  },
  {
    genesis_token_id: 11514,
    wearable_ids: [382, 342],
  },
  {
    genesis_token_id: 11515,
    wearable_ids: [347, 403],
  },
  {
    genesis_token_id: 11516,
    wearable_ids: [406, 259],
  },
  {
    genesis_token_id: 11517,
    wearable_ids: [437, 346],
  },
  {
    genesis_token_id: 11518,
    wearable_ids: [258, 284],
  },
  {
    genesis_token_id: 11519,
    wearable_ids: [389, 405],
  },
  {
    genesis_token_id: 11520,
    wearable_ids: [374, 287],
  },
  {
    genesis_token_id: 11521,
    wearable_ids: [304, 428],
  },
  {
    genesis_token_id: 11522,
    wearable_ids: [373, 318],
  },
  {
    genesis_token_id: 11523,
    wearable_ids: [428, 308],
  },
  {
    genesis_token_id: 11524,
    wearable_ids: [408, 302],
  },
  {
    genesis_token_id: 11525,
    wearable_ids: [364, 334],
  },
  {
    genesis_token_id: 11526,
    wearable_ids: [399, 307],
  },
  {
    genesis_token_id: 11527,
    wearable_ids: [424, 377],
  },
  {
    genesis_token_id: 11528,
    wearable_ids: [423, 400],
  },
  {
    genesis_token_id: 11529,
    wearable_ids: [371, 431],
  },
  {
    genesis_token_id: 11530,
    wearable_ids: [385, 384],
  },
  {
    genesis_token_id: 11531,
    wearable_ids: [364, 427],
  },
  {
    genesis_token_id: 11532,
    wearable_ids: [433, 351],
  },
  {
    genesis_token_id: 11533,
    wearable_ids: [411, 400],
  },
  {
    genesis_token_id: 11534,
    wearable_ids: [339, 376],
  },
  {
    genesis_token_id: 11535,
    wearable_ids: [264, 317],
  },
  {
    genesis_token_id: 11536,
    wearable_ids: [292, 355],
  },
  {
    genesis_token_id: 11537,
    wearable_ids: [308, 355],
  },
  {
    genesis_token_id: 11538,
    wearable_ids: [415, 403],
  },
  {
    genesis_token_id: 11539,
    wearable_ids: [404, 281],
  },
  {
    genesis_token_id: 11540,
    wearable_ids: [406, 327],
  },
  {
    genesis_token_id: 11541,
    wearable_ids: [371, 358],
  },
  {
    genesis_token_id: 11542,
    wearable_ids: [415, 361],
  },
  {
    genesis_token_id: 11543,
    wearable_ids: [378, 271],
  },
  {
    genesis_token_id: 11544,
    wearable_ids: [363, 430],
  },
  {
    genesis_token_id: 11545,
    wearable_ids: [371, 269],
  },
  {
    genesis_token_id: 11546,
    wearable_ids: [368, 401],
  },
  {
    genesis_token_id: 11547,
    wearable_ids: [445, 267],
  },
  {
    genesis_token_id: 11548,
    wearable_ids: [271, 277],
  },
  {
    genesis_token_id: 11549,
    wearable_ids: [349, 429],
  },
  {
    genesis_token_id: 11550,
    wearable_ids: [340, 362],
  },
  {
    genesis_token_id: 11551,
    wearable_ids: [257, 435],
  },
  {
    genesis_token_id: 11552,
    wearable_ids: [339, 423],
  },
  {
    genesis_token_id: 11553,
    wearable_ids: [289, 391],
  },
  {
    genesis_token_id: 11554,
    wearable_ids: [262, 348],
  },
  {
    genesis_token_id: 11555,
    wearable_ids: [306, 372],
  },
  {
    genesis_token_id: 11556,
    wearable_ids: [352, 377],
  },
  {
    genesis_token_id: 11557,
    wearable_ids: [316, 358],
  },
  {
    genesis_token_id: 11558,
    wearable_ids: [412, 400],
  },
  {
    genesis_token_id: 11559,
    wearable_ids: [287, 407],
  },
  {
    genesis_token_id: 11560,
    wearable_ids: [301, 376],
  },
  {
    genesis_token_id: 11561,
    wearable_ids: [384, 277],
  },
  {
    genesis_token_id: 11562,
    wearable_ids: [383, 436],
  },
  {
    genesis_token_id: 11563,
    wearable_ids: [424, 362],
  },
  {
    genesis_token_id: 11564,
    wearable_ids: [376, 443],
  },
  {
    genesis_token_id: 11565,
    wearable_ids: [424, 289],
  },
  {
    genesis_token_id: 11566,
    wearable_ids: [412, 378],
  },
  {
    genesis_token_id: 11567,
    wearable_ids: [263, 324],
  },
  {
    genesis_token_id: 11568,
    wearable_ids: [287, 407],
  },
  {
    genesis_token_id: 11569,
    wearable_ids: [411, 438],
  },
  {
    genesis_token_id: 11570,
    wearable_ids: [443, 326],
  },
  {
    genesis_token_id: 11571,
    wearable_ids: [291, 382],
  },
  {
    genesis_token_id: 11572,
    wearable_ids: [266, 438],
  },
  {
    genesis_token_id: 11573,
    wearable_ids: [335, 265],
  },
  {
    genesis_token_id: 11574,
    wearable_ids: [412, 325],
  },
  {
    genesis_token_id: 11575,
    wearable_ids: [415, 389],
  },
  {
    genesis_token_id: 11576,
    wearable_ids: [311, 418],
  },
  {
    genesis_token_id: 11577,
    wearable_ids: [259, 435],
  },
  {
    genesis_token_id: 11578,
    wearable_ids: [336, 326],
  },
  {
    genesis_token_id: 11579,
    wearable_ids: [409, 362],
  },
  {
    genesis_token_id: 11580,
    wearable_ids: [385, 271],
  },
  {
    genesis_token_id: 11581,
    wearable_ids: [422, 251],
  },
  {
    genesis_token_id: 11582,
    wearable_ids: [248, 382],
  },
  {
    genesis_token_id: 11583,
    wearable_ids: [404, 344],
  },
  {
    genesis_token_id: 11584,
    wearable_ids: [350, 426],
  },
  {
    genesis_token_id: 11585,
    wearable_ids: [284, 316],
  },
  {
    genesis_token_id: 11586,
    wearable_ids: [337, 258],
  },
  {
    genesis_token_id: 11587,
    wearable_ids: [407, 433],
  },
  {
    genesis_token_id: 11588,
    wearable_ids: [337, 259],
  },
  {
    genesis_token_id: 11589,
    wearable_ids: [299, 444],
  },
  {
    genesis_token_id: 11590,
    wearable_ids: [387, 278],
  },
  {
    genesis_token_id: 11591,
    wearable_ids: [280, 378],
  },
  {
    genesis_token_id: 11592,
    wearable_ids: [420, 383],
  },
  {
    genesis_token_id: 11593,
    wearable_ids: [311, 260],
  },
  {
    genesis_token_id: 11594,
    wearable_ids: [255, 426],
  },
  {
    genesis_token_id: 11595,
    wearable_ids: [374, 276],
  },
  {
    genesis_token_id: 11596,
    wearable_ids: [403, 354],
  },
  {
    genesis_token_id: 11597,
    wearable_ids: [411, 343],
  },
  {
    genesis_token_id: 11598,
    wearable_ids: [369, 397],
  },
  {
    genesis_token_id: 11599,
    wearable_ids: [387, 388],
  },
  {
    genesis_token_id: 11600,
    wearable_ids: [432, 296],
  },
  {
    genesis_token_id: 11601,
    wearable_ids: [376, 317],
  },
  {
    genesis_token_id: 11602,
    wearable_ids: [374, 382],
  },
  {
    genesis_token_id: 11603,
    wearable_ids: [354, 260],
  },
  {
    genesis_token_id: 11604,
    wearable_ids: [355, 304],
  },
  {
    genesis_token_id: 11605,
    wearable_ids: [420, 248],
  },
  {
    genesis_token_id: 11606,
    wearable_ids: [286, 372],
  },
  {
    genesis_token_id: 11607,
    wearable_ids: [259, 411],
  },
  {
    genesis_token_id: 11608,
    wearable_ids: [376, 281],
  },
  {
    genesis_token_id: 11609,
    wearable_ids: [377, 304],
  },
  {
    genesis_token_id: 11610,
    wearable_ids: [389, 419],
  },
  {
    genesis_token_id: 11611,
    wearable_ids: [348, 289],
  },
  {
    genesis_token_id: 11612,
    wearable_ids: [344, 268],
  },
  {
    genesis_token_id: 11613,
    wearable_ids: [338, 310],
  },
  {
    genesis_token_id: 11614,
    wearable_ids: [385, 375],
  },
  {
    genesis_token_id: 11615,
    wearable_ids: [346, 259],
  },
  {
    genesis_token_id: 11616,
    wearable_ids: [378, 273],
  },
  {
    genesis_token_id: 11617,
    wearable_ids: [444, 248],
  },
  {
    genesis_token_id: 11618,
    wearable_ids: [346, 287],
  },
  {
    genesis_token_id: 11619,
    wearable_ids: [301, 365],
  },
  {
    genesis_token_id: 11620,
    wearable_ids: [347, 284],
  },
  {
    genesis_token_id: 11621,
    wearable_ids: [315, 303],
  },
  {
    genesis_token_id: 11622,
    wearable_ids: [399, 297],
  },
  {
    genesis_token_id: 11623,
    wearable_ids: [436, 295],
  },
  {
    genesis_token_id: 11624,
    wearable_ids: [400, 420],
  },
  {
    genesis_token_id: 11625,
    wearable_ids: [373, 371],
  },
  {
    genesis_token_id: 11626,
    wearable_ids: [351, 415],
  },
  {
    genesis_token_id: 11627,
    wearable_ids: [265, 393],
  },
  {
    genesis_token_id: 11628,
    wearable_ids: [343, 257],
  },
  {
    genesis_token_id: 11629,
    wearable_ids: [274, 393],
  },
  {
    genesis_token_id: 11630,
    wearable_ids: [355, 263],
  },
  {
    genesis_token_id: 11631,
    wearable_ids: [253, 314],
  },
  {
    genesis_token_id: 11632,
    wearable_ids: [251, 371],
  },
  {
    genesis_token_id: 11633,
    wearable_ids: [257, 410],
  },
  {
    genesis_token_id: 11634,
    wearable_ids: [291, 286],
  },
  {
    genesis_token_id: 11635,
    wearable_ids: [355, 376],
  },
  {
    genesis_token_id: 11636,
    wearable_ids: [425, 444],
  },
  {
    genesis_token_id: 11637,
    wearable_ids: [300, 317],
  },
  {
    genesis_token_id: 11638,
    wearable_ids: [290, 248],
  },
  {
    genesis_token_id: 11639,
    wearable_ids: [299, 342],
  },
  {
    genesis_token_id: 11640,
    wearable_ids: [248, 428],
  },
  {
    genesis_token_id: 11641,
    wearable_ids: [296, 386],
  },
  {
    genesis_token_id: 11642,
    wearable_ids: [278, 403],
  },
  {
    genesis_token_id: 11643,
    wearable_ids: [304, 389],
  },
  {
    genesis_token_id: 11644,
    wearable_ids: [349, 374],
  },
  {
    genesis_token_id: 11645,
    wearable_ids: [256, 445],
  },
  {
    genesis_token_id: 11646,
    wearable_ids: [342, 257],
  },
  {
    genesis_token_id: 11647,
    wearable_ids: [403, 391],
  },
  {
    genesis_token_id: 11648,
    wearable_ids: [341, 254],
  },
  {
    genesis_token_id: 11649,
    wearable_ids: [294, 427],
  },
  {
    genesis_token_id: 11650,
    wearable_ids: [350, 275],
  },
  {
    genesis_token_id: 11651,
    wearable_ids: [263, 397],
  },
  {
    genesis_token_id: 11652,
    wearable_ids: [324, 369],
  },
  {
    genesis_token_id: 11653,
    wearable_ids: [350, 383],
  },
  {
    genesis_token_id: 11654,
    wearable_ids: [411, 273],
  },
  {
    genesis_token_id: 11655,
    wearable_ids: [271, 306],
  },
  {
    genesis_token_id: 11656,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 11657,
    wearable_ids: [347, 262],
  },
  {
    genesis_token_id: 11658,
    wearable_ids: [408, 406],
  },
  {
    genesis_token_id: 11659,
    wearable_ids: [437, 254],
  },
  {
    genesis_token_id: 11660,
    wearable_ids: [324, 317],
  },
  {
    genesis_token_id: 11661,
    wearable_ids: [335, 383],
  },
  {
    genesis_token_id: 11662,
    wearable_ids: [385, 376],
  },
  {
    genesis_token_id: 11663,
    wearable_ids: [286, 372],
  },
  {
    genesis_token_id: 11664,
    wearable_ids: [247, 256],
  },
  {
    genesis_token_id: 11665,
    wearable_ids: [331, 371],
  },
  {
    genesis_token_id: 11666,
    wearable_ids: [368, 442],
  },
  {
    genesis_token_id: 11667,
    wearable_ids: [400, 316],
  },
  {
    genesis_token_id: 11668,
    wearable_ids: [354, 382],
  },
  {
    genesis_token_id: 11669,
    wearable_ids: [400, 292],
  },
  {
    genesis_token_id: 11670,
    wearable_ids: [258, 296],
  },
  {
    genesis_token_id: 11671,
    wearable_ids: [289, 432],
  },
  {
    genesis_token_id: 11672,
    wearable_ids: [343, 277],
  },
  {
    genesis_token_id: 11673,
    wearable_ids: [389, 297],
  },
  {
    genesis_token_id: 11674,
    wearable_ids: [295, 442],
  },
  {
    genesis_token_id: 11675,
    wearable_ids: [310, 336],
  },
  {
    genesis_token_id: 11676,
    wearable_ids: [248, 375],
  },
  {
    genesis_token_id: 11677,
    wearable_ids: [271, 435],
  },
  {
    genesis_token_id: 11678,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 11679,
    wearable_ids: [400, 265],
  },
  {
    genesis_token_id: 11680,
    wearable_ids: [406, 399],
  },
  {
    genesis_token_id: 11681,
    wearable_ids: [259, 389],
  },
  {
    genesis_token_id: 11682,
    wearable_ids: [251, 376],
  },
  {
    genesis_token_id: 11683,
    wearable_ids: [301, 273],
  },
  {
    genesis_token_id: 11684,
    wearable_ids: [425, 375],
  },
  {
    genesis_token_id: 11685,
    wearable_ids: [343, 423],
  },
  {
    genesis_token_id: 11686,
    wearable_ids: [311, 374],
  },
  {
    genesis_token_id: 11687,
    wearable_ids: [413, 378],
  },
  {
    genesis_token_id: 11688,
    wearable_ids: [262, 428],
  },
  {
    genesis_token_id: 11689,
    wearable_ids: [286, 364],
  },
  {
    genesis_token_id: 11690,
    wearable_ids: [351, 285],
  },
  {
    genesis_token_id: 11691,
    wearable_ids: [280, 355],
  },
  {
    genesis_token_id: 11692,
    wearable_ids: [382, 334],
  },
  {
    genesis_token_id: 11693,
    wearable_ids: [385, 296],
  },
  {
    genesis_token_id: 11694,
    wearable_ids: [415, 307],
  },
  {
    genesis_token_id: 11695,
    wearable_ids: [433, 399],
  },
  {
    genesis_token_id: 11696,
    wearable_ids: [339, 313],
  },
  {
    genesis_token_id: 11697,
    wearable_ids: [262, 332],
  },
  {
    genesis_token_id: 11698,
    wearable_ids: [397, 289],
  },
  {
    genesis_token_id: 11699,
    wearable_ids: [247, 310],
  },
  {
    genesis_token_id: 11700,
    wearable_ids: [340, 425],
  },
  {
    genesis_token_id: 11701,
    wearable_ids: [336, 292],
  },
  {
    genesis_token_id: 11702,
    wearable_ids: [412, 328],
  },
  {
    genesis_token_id: 11703,
    wearable_ids: [268, 276],
  },
  {
    genesis_token_id: 11704,
    wearable_ids: [383, 296],
  },
  {
    genesis_token_id: 11705,
    wearable_ids: [424, 319],
  },
  {
    genesis_token_id: 11706,
    wearable_ids: [420, 337],
  },
  {
    genesis_token_id: 11707,
    wearable_ids: [296, 246],
  },
  {
    genesis_token_id: 11708,
    wearable_ids: [443, 266],
  },
  {
    genesis_token_id: 11709,
    wearable_ids: [363, 352],
  },
  {
    genesis_token_id: 11710,
    wearable_ids: [337, 433],
  },
  {
    genesis_token_id: 11711,
    wearable_ids: [423, 378],
  },
  {
    genesis_token_id: 11712,
    wearable_ids: [362, 330],
  },
  {
    genesis_token_id: 11713,
    wearable_ids: [434, 427],
  },
  {
    genesis_token_id: 11714,
    wearable_ids: [378, 438],
  },
  {
    genesis_token_id: 11715,
    wearable_ids: [251, 375],
  },
  {
    genesis_token_id: 11716,
    wearable_ids: [351, 397],
  },
  {
    genesis_token_id: 11717,
    wearable_ids: [339, 346],
  },
  {
    genesis_token_id: 11718,
    wearable_ids: [400, 429],
  },
  {
    genesis_token_id: 11719,
    wearable_ids: [407, 298],
  },
  {
    genesis_token_id: 11720,
    wearable_ids: [433, 346],
  },
  {
    genesis_token_id: 11721,
    wearable_ids: [263, 247],
  },
  {
    genesis_token_id: 11722,
    wearable_ids: [331, 258],
  },
  {
    genesis_token_id: 11723,
    wearable_ids: [300, 437],
  },
  {
    genesis_token_id: 11724,
    wearable_ids: [376, 399],
  },
  {
    genesis_token_id: 11725,
    wearable_ids: [371, 425],
  },
  {
    genesis_token_id: 11726,
    wearable_ids: [311, 297],
  },
  {
    genesis_token_id: 11727,
    wearable_ids: [257, 269],
  },
  {
    genesis_token_id: 11728,
    wearable_ids: [411, 262],
  },
  {
    genesis_token_id: 11729,
    wearable_ids: [306, 345],
  },
  {
    genesis_token_id: 11730,
    wearable_ids: [304, 277],
  },
  {
    genesis_token_id: 11731,
    wearable_ids: [274, 343],
  },
  {
    genesis_token_id: 11732,
    wearable_ids: [278, 346],
  },
  {
    genesis_token_id: 11733,
    wearable_ids: [331, 408],
  },
  {
    genesis_token_id: 11734,
    wearable_ids: [278, 343],
  },
  {
    genesis_token_id: 11735,
    wearable_ids: [387, 400],
  },
  {
    genesis_token_id: 11736,
    wearable_ids: [371, 276],
  },
  {
    genesis_token_id: 11737,
    wearable_ids: [337, 377],
  },
  {
    genesis_token_id: 11738,
    wearable_ids: [364, 368],
  },
  {
    genesis_token_id: 11739,
    wearable_ids: [348, 434],
  },
  {
    genesis_token_id: 11740,
    wearable_ids: [395, 271],
  },
  {
    genesis_token_id: 11741,
    wearable_ids: [437, 430],
  },
  {
    genesis_token_id: 11742,
    wearable_ids: [251, 358],
  },
  {
    genesis_token_id: 11743,
    wearable_ids: [351, 437],
  },
  {
    genesis_token_id: 11744,
    wearable_ids: [294, 295],
  },
  {
    genesis_token_id: 11745,
    wearable_ids: [294, 266],
  },
  {
    genesis_token_id: 11746,
    wearable_ids: [278, 322],
  },
  {
    genesis_token_id: 11747,
    wearable_ids: [294, 425],
  },
  {
    genesis_token_id: 11748,
    wearable_ids: [317, 262],
  },
  {
    genesis_token_id: 11749,
    wearable_ids: [437, 326],
  },
  {
    genesis_token_id: 11750,
    wearable_ids: [411, 273],
  },
  {
    genesis_token_id: 11751,
    wearable_ids: [407, 290],
  },
  {
    genesis_token_id: 11752,
    wearable_ids: [341, 290],
  },
  {
    genesis_token_id: 11753,
    wearable_ids: [371, 263],
  },
  {
    genesis_token_id: 11754,
    wearable_ids: [351, 253],
  },
  {
    genesis_token_id: 11755,
    wearable_ids: [395, 315],
  },
  {
    genesis_token_id: 11756,
    wearable_ids: [397, 411],
  },
  {
    genesis_token_id: 11757,
    wearable_ids: [425, 281],
  },
  {
    genesis_token_id: 11758,
    wearable_ids: [365, 372],
  },
  {
    genesis_token_id: 11759,
    wearable_ids: [410, 405],
  },
  {
    genesis_token_id: 11760,
    wearable_ids: [290, 344],
  },
  {
    genesis_token_id: 11761,
    wearable_ids: [409, 343],
  },
  {
    genesis_token_id: 11762,
    wearable_ids: [343, 253],
  },
  {
    genesis_token_id: 11763,
    wearable_ids: [339, 365],
  },
  {
    genesis_token_id: 11764,
    wearable_ids: [395, 444],
  },
  {
    genesis_token_id: 11765,
    wearable_ids: [341, 348],
  },
  {
    genesis_token_id: 11766,
    wearable_ids: [420, 354],
  },
  {
    genesis_token_id: 11767,
    wearable_ids: [406, 386],
  },
  {
    genesis_token_id: 11768,
    wearable_ids: [408, 425],
  },
  {
    genesis_token_id: 11769,
    wearable_ids: [268, 341],
  },
  {
    genesis_token_id: 11770,
    wearable_ids: [336, 371],
  },
  {
    genesis_token_id: 11771,
    wearable_ids: [289, 375],
  },
  {
    genesis_token_id: 11772,
    wearable_ids: [362, 326],
  },
  {
    genesis_token_id: 11773,
    wearable_ids: [409, 443],
  },
  {
    genesis_token_id: 11774,
    wearable_ids: [331, 410],
  },
  {
    genesis_token_id: 11775,
    wearable_ids: [372, 317],
  },
  {
    genesis_token_id: 11776,
    wearable_ids: [311, 347],
  },
  {
    genesis_token_id: 11777,
    wearable_ids: [317, 397],
  },
  {
    genesis_token_id: 11778,
    wearable_ids: [373, 413],
  },
  {
    genesis_token_id: 11779,
    wearable_ids: [347, 251],
  },
  {
    genesis_token_id: 11780,
    wearable_ids: [271, 308],
  },
  {
    genesis_token_id: 11781,
    wearable_ids: [273, 434],
  },
  {
    genesis_token_id: 11782,
    wearable_ids: [445, 404],
  },
  {
    genesis_token_id: 11783,
    wearable_ids: [368, 373],
  },
  {
    genesis_token_id: 11784,
    wearable_ids: [362, 262],
  },
  {
    genesis_token_id: 11785,
    wearable_ids: [301, 266],
  },
  {
    genesis_token_id: 11786,
    wearable_ids: [266, 384],
  },
  {
    genesis_token_id: 11787,
    wearable_ids: [396, 266],
  },
  {
    genesis_token_id: 11788,
    wearable_ids: [339, 391],
  },
  {
    genesis_token_id: 11789,
    wearable_ids: [308, 315],
  },
  {
    genesis_token_id: 11790,
    wearable_ids: [343, 280],
  },
  {
    genesis_token_id: 11791,
    wearable_ids: [286, 416],
  },
  {
    genesis_token_id: 11792,
    wearable_ids: [263, 275],
  },
  {
    genesis_token_id: 11793,
    wearable_ids: [259, 297],
  },
  {
    genesis_token_id: 11794,
    wearable_ids: [253, 271],
  },
  {
    genesis_token_id: 11795,
    wearable_ids: [286, 325],
  },
  {
    genesis_token_id: 11796,
    wearable_ids: [340, 271],
  },
  {
    genesis_token_id: 11797,
    wearable_ids: [265, 399],
  },
  {
    genesis_token_id: 11798,
    wearable_ids: [284, 278],
  },
  {
    genesis_token_id: 11799,
    wearable_ids: [387, 271],
  },
  {
    genesis_token_id: 11800,
    wearable_ids: [331, 432],
  },
  {
    genesis_token_id: 11801,
    wearable_ids: [325, 444],
  },
  {
    genesis_token_id: 11802,
    wearable_ids: [445, 292],
  },
  {
    genesis_token_id: 11803,
    wearable_ids: [445, 294],
  },
  {
    genesis_token_id: 11804,
    wearable_ids: [364, 415],
  },
  {
    genesis_token_id: 11805,
    wearable_ids: [259, 363],
  },
  {
    genesis_token_id: 11806,
    wearable_ids: [433, 376],
  },
  {
    genesis_token_id: 11807,
    wearable_ids: [254, 404],
  },
  {
    genesis_token_id: 11808,
    wearable_ids: [342, 325],
  },
  {
    genesis_token_id: 11809,
    wearable_ids: [385, 445],
  },
  {
    genesis_token_id: 11810,
    wearable_ids: [274, 346],
  },
  {
    genesis_token_id: 11811,
    wearable_ids: [287, 335],
  },
  {
    genesis_token_id: 11812,
    wearable_ids: [408, 425],
  },
  {
    genesis_token_id: 11813,
    wearable_ids: [270, 422],
  },
  {
    genesis_token_id: 11814,
    wearable_ids: [268, 352],
  },
  {
    genesis_token_id: 11815,
    wearable_ids: [371, 406],
  },
  {
    genesis_token_id: 11816,
    wearable_ids: [384, 424],
  },
  {
    genesis_token_id: 11817,
    wearable_ids: [268, 394],
  },
  {
    genesis_token_id: 11818,
    wearable_ids: [257, 311],
  },
  {
    genesis_token_id: 11819,
    wearable_ids: [431, 306],
  },
  {
    genesis_token_id: 11820,
    wearable_ids: [346, 432],
  },
  {
    genesis_token_id: 11821,
    wearable_ids: [424, 443],
  },
  {
    genesis_token_id: 11822,
    wearable_ids: [337, 443],
  },
  {
    genesis_token_id: 11823,
    wearable_ids: [404, 331],
  },
  {
    genesis_token_id: 11824,
    wearable_ids: [378, 429],
  },
  {
    genesis_token_id: 11825,
    wearable_ids: [363, 302],
  },
  {
    genesis_token_id: 11826,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 11827,
    wearable_ids: [431, 339],
  },
  {
    genesis_token_id: 11828,
    wearable_ids: [344, 320],
  },
  {
    genesis_token_id: 11829,
    wearable_ids: [432, 326],
  },
  {
    genesis_token_id: 11830,
    wearable_ids: [253, 303],
  },
  {
    genesis_token_id: 11831,
    wearable_ids: [341, 315],
  },
  {
    genesis_token_id: 11832,
    wearable_ids: [335, 249],
  },
  {
    genesis_token_id: 11833,
    wearable_ids: [348, 265],
  },
  {
    genesis_token_id: 11834,
    wearable_ids: [403, 314],
  },
  {
    genesis_token_id: 11835,
    wearable_ids: [352, 364],
  },
  {
    genesis_token_id: 11836,
    wearable_ids: [445, 373],
  },
  {
    genesis_token_id: 11837,
    wearable_ids: [425, 299],
  },
  {
    genesis_token_id: 11838,
    wearable_ids: [352, 320],
  },
  {
    genesis_token_id: 11839,
    wearable_ids: [412, 350],
  },
  {
    genesis_token_id: 11840,
    wearable_ids: [410, 423],
  },
  {
    genesis_token_id: 11841,
    wearable_ids: [436, 404],
  },
  {
    genesis_token_id: 11842,
    wearable_ids: [437, 433],
  },
  {
    genesis_token_id: 11843,
    wearable_ids: [442, 399],
  },
  {
    genesis_token_id: 11844,
    wearable_ids: [348, 275],
  },
  {
    genesis_token_id: 11845,
    wearable_ids: [331, 289],
  },
  {
    genesis_token_id: 11846,
    wearable_ids: [332, 414],
  },
  {
    genesis_token_id: 11847,
    wearable_ids: [355, 311],
  },
  {
    genesis_token_id: 11848,
    wearable_ids: [294, 328],
  },
  {
    genesis_token_id: 11849,
    wearable_ids: [415, 373],
  },
  {
    genesis_token_id: 11850,
    wearable_ids: [413, 401],
  },
  {
    genesis_token_id: 11851,
    wearable_ids: [289, 391],
  },
  {
    genesis_token_id: 11852,
    wearable_ids: [349, 340],
  },
  {
    genesis_token_id: 11853,
    wearable_ids: [431, 253],
  },
  {
    genesis_token_id: 11854,
    wearable_ids: [415, 355],
  },
  {
    genesis_token_id: 11855,
    wearable_ids: [436, 444],
  },
  {
    genesis_token_id: 11856,
    wearable_ids: [303, 331],
  },
  {
    genesis_token_id: 11857,
    wearable_ids: [273, 248],
  },
  {
    genesis_token_id: 11858,
    wearable_ids: [434, 365],
  },
  {
    genesis_token_id: 11859,
    wearable_ids: [368, 350],
  },
  {
    genesis_token_id: 11860,
    wearable_ids: [326, 314],
  },
  {
    genesis_token_id: 11861,
    wearable_ids: [362, 364],
  },
  {
    genesis_token_id: 11862,
    wearable_ids: [310, 410],
  },
  {
    genesis_token_id: 11863,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 11864,
    wearable_ids: [265, 407],
  },
  {
    genesis_token_id: 11865,
    wearable_ids: [297, 416],
  },
  {
    genesis_token_id: 11866,
    wearable_ids: [271, 433],
  },
  {
    genesis_token_id: 11867,
    wearable_ids: [325, 344],
  },
  {
    genesis_token_id: 11868,
    wearable_ids: [428, 418],
  },
  {
    genesis_token_id: 11869,
    wearable_ids: [280, 322],
  },
  {
    genesis_token_id: 11870,
    wearable_ids: [291, 364],
  },
  {
    genesis_token_id: 11871,
    wearable_ids: [348, 324],
  },
  {
    genesis_token_id: 11872,
    wearable_ids: [326, 375],
  },
  {
    genesis_token_id: 11873,
    wearable_ids: [385, 351],
  },
  {
    genesis_token_id: 11874,
    wearable_ids: [397, 378],
  },
  {
    genesis_token_id: 11875,
    wearable_ids: [299, 315],
  },
  {
    genesis_token_id: 11876,
    wearable_ids: [292, 406],
  },
  {
    genesis_token_id: 11877,
    wearable_ids: [248, 289],
  },
  {
    genesis_token_id: 11878,
    wearable_ids: [370, 276],
  },
  {
    genesis_token_id: 11879,
    wearable_ids: [383, 277],
  },
  {
    genesis_token_id: 11880,
    wearable_ids: [423, 385],
  },
  {
    genesis_token_id: 11881,
    wearable_ids: [409, 366],
  },
  {
    genesis_token_id: 11882,
    wearable_ids: [341, 313],
  },
  {
    genesis_token_id: 11883,
    wearable_ids: [337, 419],
  },
  {
    genesis_token_id: 11884,
    wearable_ids: [280, 278],
  },
  {
    genesis_token_id: 11885,
    wearable_ids: [382, 340],
  },
  {
    genesis_token_id: 11886,
    wearable_ids: [280, 399],
  },
  {
    genesis_token_id: 11887,
    wearable_ids: [395, 377],
  },
  {
    genesis_token_id: 11888,
    wearable_ids: [432, 422],
  },
  {
    genesis_token_id: 11889,
    wearable_ids: [382, 344],
  },
  {
    genesis_token_id: 11890,
    wearable_ids: [319, 256],
  },
  {
    genesis_token_id: 11891,
    wearable_ids: [349, 269],
  },
  {
    genesis_token_id: 11892,
    wearable_ids: [316, 298],
  },
  {
    genesis_token_id: 11893,
    wearable_ids: [301, 263],
  },
  {
    genesis_token_id: 11894,
    wearable_ids: [364, 382],
  },
  {
    genesis_token_id: 11895,
    wearable_ids: [331, 423],
  },
  {
    genesis_token_id: 11896,
    wearable_ids: [384, 369],
  },
  {
    genesis_token_id: 11897,
    wearable_ids: [384, 424],
  },
  {
    genesis_token_id: 11898,
    wearable_ids: [435, 337],
  },
  {
    genesis_token_id: 11899,
    wearable_ids: [297, 338],
  },
  {
    genesis_token_id: 11900,
    wearable_ids: [375, 429],
  },
  {
    genesis_token_id: 11901,
    wearable_ids: [306, 351],
  },
  {
    genesis_token_id: 11902,
    wearable_ids: [342, 255],
  },
  {
    genesis_token_id: 11903,
    wearable_ids: [371, 342],
  },
  {
    genesis_token_id: 11904,
    wearable_ids: [389, 423],
  },
  {
    genesis_token_id: 11905,
    wearable_ids: [332, 266],
  },
  {
    genesis_token_id: 11906,
    wearable_ids: [426, 268],
  },
  {
    genesis_token_id: 11907,
    wearable_ids: [378, 307],
  },
  {
    genesis_token_id: 11908,
    wearable_ids: [306, 403],
  },
  {
    genesis_token_id: 11909,
    wearable_ids: [436, 304],
  },
  {
    genesis_token_id: 11910,
    wearable_ids: [422, 368],
  },
  {
    genesis_token_id: 11911,
    wearable_ids: [326, 426],
  },
  {
    genesis_token_id: 11912,
    wearable_ids: [274, 328],
  },
  {
    genesis_token_id: 11913,
    wearable_ids: [350, 341],
  },
  {
    genesis_token_id: 11914,
    wearable_ids: [424, 340],
  },
  {
    genesis_token_id: 11915,
    wearable_ids: [351, 352],
  },
  {
    genesis_token_id: 11916,
    wearable_ids: [262, 350],
  },
  {
    genesis_token_id: 11917,
    wearable_ids: [308, 315],
  },
  {
    genesis_token_id: 11918,
    wearable_ids: [268, 403],
  },
  {
    genesis_token_id: 11919,
    wearable_ids: [341, 316],
  },
  {
    genesis_token_id: 11920,
    wearable_ids: [371, 432],
  },
  {
    genesis_token_id: 11921,
    wearable_ids: [335, 289],
  },
  {
    genesis_token_id: 11922,
    wearable_ids: [315, 291],
  },
  {
    genesis_token_id: 11923,
    wearable_ids: [423, 338],
  },
  {
    genesis_token_id: 11924,
    wearable_ids: [299, 355],
  },
  {
    genesis_token_id: 11925,
    wearable_ids: [284, 411],
  },
  {
    genesis_token_id: 11926,
    wearable_ids: [325, 342],
  },
  {
    genesis_token_id: 11927,
    wearable_ids: [412, 399],
  },
  {
    genesis_token_id: 11928,
    wearable_ids: [399, 413],
  },
  {
    genesis_token_id: 11929,
    wearable_ids: [369, 416],
  },
  {
    genesis_token_id: 11930,
    wearable_ids: [338, 350],
  },
  {
    genesis_token_id: 11931,
    wearable_ids: [315, 308],
  },
  {
    genesis_token_id: 11932,
    wearable_ids: [337, 387],
  },
  {
    genesis_token_id: 11933,
    wearable_ids: [373, 411],
  },
  {
    genesis_token_id: 11934,
    wearable_ids: [290, 253],
  },
  {
    genesis_token_id: 11935,
    wearable_ids: [384, 344],
  },
  {
    genesis_token_id: 11936,
    wearable_ids: [304, 350],
  },
  {
    genesis_token_id: 11937,
    wearable_ids: [295, 257],
  },
  {
    genesis_token_id: 11938,
    wearable_ids: [317, 257],
  },
  {
    genesis_token_id: 11939,
    wearable_ids: [355, 312],
  },
  {
    genesis_token_id: 11940,
    wearable_ids: [433, 314],
  },
  {
    genesis_token_id: 11941,
    wearable_ids: [443, 324],
  },
  {
    genesis_token_id: 11942,
    wearable_ids: [315, 433],
  },
  {
    genesis_token_id: 11943,
    wearable_ids: [407, 340],
  },
  {
    genesis_token_id: 11944,
    wearable_ids: [263, 409],
  },
  {
    genesis_token_id: 11945,
    wearable_ids: [404, 263],
  },
  {
    genesis_token_id: 11946,
    wearable_ids: [316, 355],
  },
  {
    genesis_token_id: 11947,
    wearable_ids: [407, 428],
  },
  {
    genesis_token_id: 11948,
    wearable_ids: [326, 371],
  },
  {
    genesis_token_id: 11949,
    wearable_ids: [408, 373],
  },
  {
    genesis_token_id: 11950,
    wearable_ids: [308, 413],
  },
  {
    genesis_token_id: 11951,
    wearable_ids: [314, 387],
  },
  {
    genesis_token_id: 11952,
    wearable_ids: [303, 389],
  },
  {
    genesis_token_id: 11953,
    wearable_ids: [259, 427],
  },
  {
    genesis_token_id: 11954,
    wearable_ids: [425, 424],
  },
  {
    genesis_token_id: 11955,
    wearable_ids: [304, 274],
  },
  {
    genesis_token_id: 11956,
    wearable_ids: [348, 265],
  },
  {
    genesis_token_id: 11957,
    wearable_ids: [348, 377],
  },
  {
    genesis_token_id: 11958,
    wearable_ids: [340, 311],
  },
  {
    genesis_token_id: 11959,
    wearable_ids: [378, 324],
  },
  {
    genesis_token_id: 11960,
    wearable_ids: [432, 429],
  },
  {
    genesis_token_id: 11961,
    wearable_ids: [274, 374],
  },
  {
    genesis_token_id: 11962,
    wearable_ids: [339, 406],
  },
  {
    genesis_token_id: 11963,
    wearable_ids: [386, 297],
  },
  {
    genesis_token_id: 11964,
    wearable_ids: [343, 442],
  },
  {
    genesis_token_id: 11965,
    wearable_ids: [354, 271],
  },
  {
    genesis_token_id: 11966,
    wearable_ids: [443, 351],
  },
  {
    genesis_token_id: 11967,
    wearable_ids: [404, 395],
  },
  {
    genesis_token_id: 11968,
    wearable_ids: [280, 376],
  },
  {
    genesis_token_id: 11969,
    wearable_ids: [350, 407],
  },
  {
    genesis_token_id: 11970,
    wearable_ids: [258, 396],
  },
  {
    genesis_token_id: 11971,
    wearable_ids: [331, 290],
  },
  {
    genesis_token_id: 11972,
    wearable_ids: [251, 428],
  },
  {
    genesis_token_id: 11973,
    wearable_ids: [342, 413],
  },
  {
    genesis_token_id: 11974,
    wearable_ids: [272, 311],
  },
  {
    genesis_token_id: 11975,
    wearable_ids: [258, 251],
  },
  {
    genesis_token_id: 11976,
    wearable_ids: [437, 326],
  },
  {
    genesis_token_id: 11977,
    wearable_ids: [424, 256],
  },
  {
    genesis_token_id: 11978,
    wearable_ids: [372, 433],
  },
  {
    genesis_token_id: 11979,
    wearable_ids: [424, 280],
  },
  {
    genesis_token_id: 11980,
    wearable_ids: [429, 290],
  },
  {
    genesis_token_id: 11981,
    wearable_ids: [409, 280],
  },
  {
    genesis_token_id: 11982,
    wearable_ids: [445, 436],
  },
  {
    genesis_token_id: 11983,
    wearable_ids: [442, 312],
  },
  {
    genesis_token_id: 11984,
    wearable_ids: [343, 371],
  },
  {
    genesis_token_id: 11985,
    wearable_ids: [423, 311],
  },
  {
    genesis_token_id: 11986,
    wearable_ids: [331, 389],
  },
  {
    genesis_token_id: 11987,
    wearable_ids: [433, 262],
  },
  {
    genesis_token_id: 11988,
    wearable_ids: [395, 408],
  },
  {
    genesis_token_id: 11989,
    wearable_ids: [408, 368],
  },
  {
    genesis_token_id: 11990,
    wearable_ids: [343, 292],
  },
  {
    genesis_token_id: 11991,
    wearable_ids: [350, 308],
  },
  {
    genesis_token_id: 11992,
    wearable_ids: [304, 375],
  },
  {
    genesis_token_id: 11993,
    wearable_ids: [306, 424],
  },
  {
    genesis_token_id: 11994,
    wearable_ids: [314, 395],
  },
  {
    genesis_token_id: 11995,
    wearable_ids: [258, 286],
  },
  {
    genesis_token_id: 11996,
    wearable_ids: [443, 428],
  },
  {
    genesis_token_id: 11997,
    wearable_ids: [248, 352],
  },
  {
    genesis_token_id: 11998,
    wearable_ids: [251, 264],
  },
  {
    genesis_token_id: 11999,
    wearable_ids: [251, 337],
  },
  {
    genesis_token_id: 12000,
    wearable_ids: [265, 403],
  },
  {
    genesis_token_id: 12001,
    wearable_ids: [428, 415],
  },
  {
    genesis_token_id: 12002,
    wearable_ids: [443, 294],
  },
  {
    genesis_token_id: 12003,
    wearable_ids: [299, 331],
  },
  {
    genesis_token_id: 12004,
    wearable_ids: [299, 323],
  },
  {
    genesis_token_id: 12005,
    wearable_ids: [255, 406],
  },
  {
    genesis_token_id: 12006,
    wearable_ids: [247, 300],
  },
  {
    genesis_token_id: 12007,
    wearable_ids: [413, 261],
  },
  {
    genesis_token_id: 12008,
    wearable_ids: [341, 325],
  },
  {
    genesis_token_id: 12009,
    wearable_ids: [389, 335],
  },
  {
    genesis_token_id: 12010,
    wearable_ids: [354, 263],
  },
  {
    genesis_token_id: 12011,
    wearable_ids: [289, 331],
  },
  {
    genesis_token_id: 12012,
    wearable_ids: [364, 401],
  },
  {
    genesis_token_id: 12013,
    wearable_ids: [412, 351],
  },
  {
    genesis_token_id: 12014,
    wearable_ids: [409, 347],
  },
  {
    genesis_token_id: 12015,
    wearable_ids: [377, 376],
  },
  {
    genesis_token_id: 12016,
    wearable_ids: [299, 314],
  },
  {
    genesis_token_id: 12017,
    wearable_ids: [336, 365],
  },
  {
    genesis_token_id: 12018,
    wearable_ids: [410, 323],
  },
  {
    genesis_token_id: 12019,
    wearable_ids: [299, 325],
  },
  {
    genesis_token_id: 12020,
    wearable_ids: [339, 277],
  },
  {
    genesis_token_id: 12021,
    wearable_ids: [442, 304],
  },
  {
    genesis_token_id: 12022,
    wearable_ids: [346, 322],
  },
  {
    genesis_token_id: 12023,
    wearable_ids: [264, 407],
  },
  {
    genesis_token_id: 12024,
    wearable_ids: [363, 305],
  },
  {
    genesis_token_id: 12025,
    wearable_ids: [378, 373],
  },
  {
    genesis_token_id: 12026,
    wearable_ids: [331, 355],
  },
  {
    genesis_token_id: 12027,
    wearable_ids: [409, 280],
  },
  {
    genesis_token_id: 12028,
    wearable_ids: [325, 419],
  },
  {
    genesis_token_id: 12029,
    wearable_ids: [308, 264],
  },
  {
    genesis_token_id: 12030,
    wearable_ids: [265, 432],
  },
  {
    genesis_token_id: 12031,
    wearable_ids: [404, 425],
  },
  {
    genesis_token_id: 12032,
    wearable_ids: [442, 284],
  },
  {
    genesis_token_id: 12033,
    wearable_ids: [290, 406],
  },
  {
    genesis_token_id: 12034,
    wearable_ids: [304, 407],
  },
  {
    genesis_token_id: 12035,
    wearable_ids: [247, 362],
  },
  {
    genesis_token_id: 12036,
    wearable_ids: [442, 255],
  },
  {
    genesis_token_id: 12037,
    wearable_ids: [344, 280],
  },
  {
    genesis_token_id: 12038,
    wearable_ids: [262, 407],
  },
  {
    genesis_token_id: 12039,
    wearable_ids: [255, 417],
  },
  {
    genesis_token_id: 12040,
    wearable_ids: [411, 404],
  },
  {
    genesis_token_id: 12041,
    wearable_ids: [303, 368],
  },
  {
    genesis_token_id: 12042,
    wearable_ids: [399, 354],
  },
  {
    genesis_token_id: 12043,
    wearable_ids: [382, 273],
  },
  {
    genesis_token_id: 12044,
    wearable_ids: [410, 422],
  },
  {
    genesis_token_id: 12045,
    wearable_ids: [253, 308],
  },
  {
    genesis_token_id: 12046,
    wearable_ids: [408, 374],
  },
  {
    genesis_token_id: 12047,
    wearable_ids: [426, 301],
  },
  {
    genesis_token_id: 12048,
    wearable_ids: [363, 351],
  },
  {
    genesis_token_id: 12049,
    wearable_ids: [397, 369],
  },
  {
    genesis_token_id: 12050,
    wearable_ids: [375, 397],
  },
  {
    genesis_token_id: 12051,
    wearable_ids: [251, 276],
  },
  {
    genesis_token_id: 12052,
    wearable_ids: [278, 339],
  },
  {
    genesis_token_id: 12053,
    wearable_ids: [255, 333],
  },
  {
    genesis_token_id: 12054,
    wearable_ids: [368, 347],
  },
  {
    genesis_token_id: 12055,
    wearable_ids: [412, 298],
  },
  {
    genesis_token_id: 12056,
    wearable_ids: [372, 334],
  },
  {
    genesis_token_id: 12057,
    wearable_ids: [303, 266],
  },
  {
    genesis_token_id: 12058,
    wearable_ids: [306, 410],
  },
  {
    genesis_token_id: 12059,
    wearable_ids: [268, 444],
  },
  {
    genesis_token_id: 12060,
    wearable_ids: [326, 416],
  },
  {
    genesis_token_id: 12061,
    wearable_ids: [428, 297],
  },
  {
    genesis_token_id: 12062,
    wearable_ids: [259, 339],
  },
  {
    genesis_token_id: 12063,
    wearable_ids: [399, 249],
  },
  {
    genesis_token_id: 12064,
    wearable_ids: [295, 368],
  },
  {
    genesis_token_id: 12065,
    wearable_ids: [444, 413],
  },
  {
    genesis_token_id: 12066,
    wearable_ids: [365, 350],
  },
  {
    genesis_token_id: 12067,
    wearable_ids: [314, 275],
  },
  {
    genesis_token_id: 12068,
    wearable_ids: [346, 417],
  },
  {
    genesis_token_id: 12069,
    wearable_ids: [378, 358],
  },
  {
    genesis_token_id: 12070,
    wearable_ids: [342, 350],
  },
  {
    genesis_token_id: 12071,
    wearable_ids: [378, 314],
  },
  {
    genesis_token_id: 12072,
    wearable_ids: [365, 317],
  },
  {
    genesis_token_id: 12073,
    wearable_ids: [289, 377],
  },
  {
    genesis_token_id: 12074,
    wearable_ids: [442, 396],
  },
  {
    genesis_token_id: 12075,
    wearable_ids: [407, 253],
  },
  {
    genesis_token_id: 12076,
    wearable_ids: [375, 278],
  },
  {
    genesis_token_id: 12077,
    wearable_ids: [331, 433],
  },
  {
    genesis_token_id: 12078,
    wearable_ids: [412, 445],
  },
  {
    genesis_token_id: 12079,
    wearable_ids: [248, 280],
  },
  {
    genesis_token_id: 12080,
    wearable_ids: [423, 342],
  },
  {
    genesis_token_id: 12081,
    wearable_ids: [412, 268],
  },
  {
    genesis_token_id: 12082,
    wearable_ids: [253, 286],
  },
  {
    genesis_token_id: 12083,
    wearable_ids: [332, 304],
  },
  {
    genesis_token_id: 12084,
    wearable_ids: [301, 296],
  },
  {
    genesis_token_id: 12085,
    wearable_ids: [426, 301],
  },
  {
    genesis_token_id: 12086,
    wearable_ids: [355, 344],
  },
  {
    genesis_token_id: 12087,
    wearable_ids: [411, 334],
  },
  {
    genesis_token_id: 12088,
    wearable_ids: [342, 283],
  },
  {
    genesis_token_id: 12089,
    wearable_ids: [435, 414],
  },
  {
    genesis_token_id: 12090,
    wearable_ids: [382, 415],
  },
  {
    genesis_token_id: 12091,
    wearable_ids: [412, 377],
  },
  {
    genesis_token_id: 12092,
    wearable_ids: [295, 287],
  },
  {
    genesis_token_id: 12093,
    wearable_ids: [258, 388],
  },
  {
    genesis_token_id: 12094,
    wearable_ids: [397, 362],
  },
  {
    genesis_token_id: 12095,
    wearable_ids: [442, 315],
  },
  {
    genesis_token_id: 12096,
    wearable_ids: [256, 257],
  },
  {
    genesis_token_id: 12097,
    wearable_ids: [350, 408],
  },
  {
    genesis_token_id: 12098,
    wearable_ids: [270, 373],
  },
  {
    genesis_token_id: 12099,
    wearable_ids: [338, 257],
  },
  {
    genesis_token_id: 12100,
    wearable_ids: [429, 354],
  },
  {
    genesis_token_id: 12101,
    wearable_ids: [372, 292],
  },
  {
    genesis_token_id: 12102,
    wearable_ids: [274, 268],
  },
  {
    genesis_token_id: 12103,
    wearable_ids: [287, 413],
  },
  {
    genesis_token_id: 12104,
    wearable_ids: [268, 354],
  },
  {
    genesis_token_id: 12105,
    wearable_ids: [337, 273],
  },
  {
    genesis_token_id: 12106,
    wearable_ids: [284, 444],
  },
  {
    genesis_token_id: 12107,
    wearable_ids: [278, 304],
  },
  {
    genesis_token_id: 12108,
    wearable_ids: [257, 407],
  },
  {
    genesis_token_id: 12109,
    wearable_ids: [255, 400],
  },
  {
    genesis_token_id: 12110,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 12111,
    wearable_ids: [442, 292],
  },
  {
    genesis_token_id: 12112,
    wearable_ids: [433, 427],
  },
  {
    genesis_token_id: 12113,
    wearable_ids: [317, 395],
  },
  {
    genesis_token_id: 12114,
    wearable_ids: [276, 259],
  },
  {
    genesis_token_id: 12115,
    wearable_ids: [297, 425],
  },
  {
    genesis_token_id: 12116,
    wearable_ids: [271, 409],
  },
  {
    genesis_token_id: 12117,
    wearable_ids: [308, 275],
  },
  {
    genesis_token_id: 12118,
    wearable_ids: [256, 291],
  },
  {
    genesis_token_id: 12119,
    wearable_ids: [397, 440],
  },
  {
    genesis_token_id: 12120,
    wearable_ids: [410, 403],
  },
  {
    genesis_token_id: 12121,
    wearable_ids: [289, 285],
  },
  {
    genesis_token_id: 12122,
    wearable_ids: [365, 295],
  },
  {
    genesis_token_id: 12123,
    wearable_ids: [432, 276],
  },
  {
    genesis_token_id: 12124,
    wearable_ids: [403, 305],
  },
  {
    genesis_token_id: 12125,
    wearable_ids: [276, 316],
  },
  {
    genesis_token_id: 12126,
    wearable_ids: [368, 369],
  },
  {
    genesis_token_id: 12127,
    wearable_ids: [436, 424],
  },
  {
    genesis_token_id: 12128,
    wearable_ids: [248, 278],
  },
  {
    genesis_token_id: 12129,
    wearable_ids: [284, 372],
  },
  {
    genesis_token_id: 12130,
    wearable_ids: [294, 402],
  },
  {
    genesis_token_id: 12131,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 12132,
    wearable_ids: [386, 328],
  },
  {
    genesis_token_id: 12133,
    wearable_ids: [371, 297],
  },
  {
    genesis_token_id: 12134,
    wearable_ids: [350, 415],
  },
  {
    genesis_token_id: 12135,
    wearable_ids: [364, 288],
  },
  {
    genesis_token_id: 12136,
    wearable_ids: [352, 399],
  },
  {
    genesis_token_id: 12137,
    wearable_ids: [354, 262],
  },
  {
    genesis_token_id: 12138,
    wearable_ids: [420, 357],
  },
  {
    genesis_token_id: 12139,
    wearable_ids: [354, 272],
  },
  {
    genesis_token_id: 12140,
    wearable_ids: [395, 375],
  },
  {
    genesis_token_id: 12141,
    wearable_ids: [280, 273],
  },
  {
    genesis_token_id: 12142,
    wearable_ids: [268, 336],
  },
  {
    genesis_token_id: 12143,
    wearable_ids: [284, 255],
  },
  {
    genesis_token_id: 12144,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 12145,
    wearable_ids: [289, 320],
  },
  {
    genesis_token_id: 12146,
    wearable_ids: [280, 303],
  },
  {
    genesis_token_id: 12147,
    wearable_ids: [340, 410],
  },
  {
    genesis_token_id: 12148,
    wearable_ids: [256, 335],
  },
  {
    genesis_token_id: 12149,
    wearable_ids: [377, 427],
  },
  {
    genesis_token_id: 12150,
    wearable_ids: [411, 317],
  },
  {
    genesis_token_id: 12151,
    wearable_ids: [434, 303],
  },
  {
    genesis_token_id: 12152,
    wearable_ids: [382, 366],
  },
  {
    genesis_token_id: 12153,
    wearable_ids: [387, 442],
  },
  {
    genesis_token_id: 12154,
    wearable_ids: [351, 269],
  },
  {
    genesis_token_id: 12155,
    wearable_ids: [409, 360],
  },
  {
    genesis_token_id: 12156,
    wearable_ids: [374, 369],
  },
  {
    genesis_token_id: 12157,
    wearable_ids: [263, 314],
  },
  {
    genesis_token_id: 12158,
    wearable_ids: [400, 339],
  },
  {
    genesis_token_id: 12159,
    wearable_ids: [352, 360],
  },
  {
    genesis_token_id: 12160,
    wearable_ids: [442, 440],
  },
  {
    genesis_token_id: 12161,
    wearable_ids: [436, 395],
  },
  {
    genesis_token_id: 12162,
    wearable_ids: [351, 268],
  },
  {
    genesis_token_id: 12163,
    wearable_ids: [409, 411],
  },
  {
    genesis_token_id: 12164,
    wearable_ids: [294, 354],
  },
  {
    genesis_token_id: 12165,
    wearable_ids: [435, 433],
  },
  {
    genesis_token_id: 12166,
    wearable_ids: [289, 397],
  },
  {
    genesis_token_id: 12167,
    wearable_ids: [256, 382],
  },
  {
    genesis_token_id: 12168,
    wearable_ids: [296, 306],
  },
  {
    genesis_token_id: 12169,
    wearable_ids: [273, 271],
  },
  {
    genesis_token_id: 12170,
    wearable_ids: [422, 434],
  },
  {
    genesis_token_id: 12171,
    wearable_ids: [297, 378],
  },
  {
    genesis_token_id: 12172,
    wearable_ids: [425, 354],
  },
  {
    genesis_token_id: 12173,
    wearable_ids: [273, 377],
  },
  {
    genesis_token_id: 12174,
    wearable_ids: [262, 290],
  },
  {
    genesis_token_id: 12175,
    wearable_ids: [407, 375],
  },
  {
    genesis_token_id: 12176,
    wearable_ids: [336, 363],
  },
  {
    genesis_token_id: 12177,
    wearable_ids: [291, 339],
  },
  {
    genesis_token_id: 12178,
    wearable_ids: [344, 299],
  },
  {
    genesis_token_id: 12179,
    wearable_ids: [262, 336],
  },
  {
    genesis_token_id: 12180,
    wearable_ids: [272, 248],
  },
  {
    genesis_token_id: 12181,
    wearable_ids: [437, 255],
  },
  {
    genesis_token_id: 12182,
    wearable_ids: [280, 292],
  },
  {
    genesis_token_id: 12183,
    wearable_ids: [300, 250],
  },
  {
    genesis_token_id: 12184,
    wearable_ids: [248, 437],
  },
  {
    genesis_token_id: 12185,
    wearable_ids: [300, 314],
  },
  {
    genesis_token_id: 12186,
    wearable_ids: [433, 347],
  },
  {
    genesis_token_id: 12187,
    wearable_ids: [403, 344],
  },
  {
    genesis_token_id: 12188,
    wearable_ids: [256, 372],
  },
  {
    genesis_token_id: 12189,
    wearable_ids: [420, 371],
  },
  {
    genesis_token_id: 12190,
    wearable_ids: [423, 391],
  },
  {
    genesis_token_id: 12191,
    wearable_ids: [247, 349],
  },
  {
    genesis_token_id: 12192,
    wearable_ids: [406, 428],
  },
  {
    genesis_token_id: 12193,
    wearable_ids: [373, 285],
  },
  {
    genesis_token_id: 12194,
    wearable_ids: [425, 316],
  },
  {
    genesis_token_id: 12195,
    wearable_ids: [335, 318],
  },
  {
    genesis_token_id: 12196,
    wearable_ids: [315, 274],
  },
  {
    genesis_token_id: 12197,
    wearable_ids: [266, 440],
  },
  {
    genesis_token_id: 12198,
    wearable_ids: [403, 376],
  },
  {
    genesis_token_id: 12199,
    wearable_ids: [382, 392],
  },
  {
    genesis_token_id: 12200,
    wearable_ids: [317, 265],
  },
  {
    genesis_token_id: 12201,
    wearable_ids: [404, 342],
  },
  {
    genesis_token_id: 12202,
    wearable_ids: [304, 306],
  },
  {
    genesis_token_id: 12203,
    wearable_ids: [354, 322],
  },
  {
    genesis_token_id: 12204,
    wearable_ids: [332, 289],
  },
  {
    genesis_token_id: 12205,
    wearable_ids: [423, 258],
  },
  {
    genesis_token_id: 12206,
    wearable_ids: [254, 273],
  },
  {
    genesis_token_id: 12207,
    wearable_ids: [369, 389],
  },
  {
    genesis_token_id: 12208,
    wearable_ids: [256, 378],
  },
  {
    genesis_token_id: 12209,
    wearable_ids: [389, 291],
  },
  {
    genesis_token_id: 12210,
    wearable_ids: [348, 423],
  },
  {
    genesis_token_id: 12211,
    wearable_ids: [349, 324],
  },
  {
    genesis_token_id: 12212,
    wearable_ids: [415, 339],
  },
  {
    genesis_token_id: 12213,
    wearable_ids: [338, 285],
  },
  {
    genesis_token_id: 12214,
    wearable_ids: [306, 444],
  },
  {
    genesis_token_id: 12215,
    wearable_ids: [363, 253],
  },
  {
    genesis_token_id: 12216,
    wearable_ids: [411, 399],
  },
  {
    genesis_token_id: 12217,
    wearable_ids: [424, 335],
  },
  {
    genesis_token_id: 12218,
    wearable_ids: [423, 341],
  },
  {
    genesis_token_id: 12219,
    wearable_ids: [264, 256],
  },
  {
    genesis_token_id: 12220,
    wearable_ids: [296, 275],
  },
  {
    genesis_token_id: 12221,
    wearable_ids: [314, 424],
  },
  {
    genesis_token_id: 12222,
    wearable_ids: [386, 316],
  },
  {
    genesis_token_id: 12223,
    wearable_ids: [435, 297],
  },
  {
    genesis_token_id: 12224,
    wearable_ids: [319, 296],
  },
  {
    genesis_token_id: 12225,
    wearable_ids: [399, 328],
  },
  {
    genesis_token_id: 12226,
    wearable_ids: [347, 289],
  },
  {
    genesis_token_id: 12227,
    wearable_ids: [325, 250],
  },
  {
    genesis_token_id: 12228,
    wearable_ids: [444, 258],
  },
  {
    genesis_token_id: 12229,
    wearable_ids: [291, 310],
  },
  {
    genesis_token_id: 12230,
    wearable_ids: [411, 415],
  },
  {
    genesis_token_id: 12231,
    wearable_ids: [308, 418],
  },
  {
    genesis_token_id: 12232,
    wearable_ids: [257, 264],
  },
  {
    genesis_token_id: 12233,
    wearable_ids: [266, 264],
  },
  {
    genesis_token_id: 12234,
    wearable_ids: [403, 384],
  },
  {
    genesis_token_id: 12235,
    wearable_ids: [368, 313],
  },
  {
    genesis_token_id: 12236,
    wearable_ids: [326, 444],
  },
  {
    genesis_token_id: 12237,
    wearable_ids: [319, 362],
  },
  {
    genesis_token_id: 12238,
    wearable_ids: [426, 276],
  },
  {
    genesis_token_id: 12239,
    wearable_ids: [375, 385],
  },
  {
    genesis_token_id: 12240,
    wearable_ids: [342, 247],
  },
  {
    genesis_token_id: 12241,
    wearable_ids: [274, 436],
  },
  {
    genesis_token_id: 12242,
    wearable_ids: [270, 310],
  },
  {
    genesis_token_id: 12243,
    wearable_ids: [316, 274],
  },
  {
    genesis_token_id: 12244,
    wearable_ids: [270, 333],
  },
  {
    genesis_token_id: 12245,
    wearable_ids: [377, 295],
  },
  {
    genesis_token_id: 12246,
    wearable_ids: [277, 342],
  },
  {
    genesis_token_id: 12247,
    wearable_ids: [266, 316],
  },
  {
    genesis_token_id: 12248,
    wearable_ids: [383, 339],
  },
  {
    genesis_token_id: 12249,
    wearable_ids: [295, 404],
  },
  {
    genesis_token_id: 12250,
    wearable_ids: [343, 425],
  },
  {
    genesis_token_id: 12251,
    wearable_ids: [256, 301],
  },
  {
    genesis_token_id: 12252,
    wearable_ids: [292, 344],
  },
  {
    genesis_token_id: 12253,
    wearable_ids: [445, 369],
  },
  {
    genesis_token_id: 12254,
    wearable_ids: [273, 314],
  },
  {
    genesis_token_id: 12255,
    wearable_ids: [317, 301],
  },
  {
    genesis_token_id: 12256,
    wearable_ids: [295, 445],
  },
  {
    genesis_token_id: 12257,
    wearable_ids: [442, 398],
  },
  {
    genesis_token_id: 12258,
    wearable_ids: [386, 355],
  },
  {
    genesis_token_id: 12259,
    wearable_ids: [253, 280],
  },
  {
    genesis_token_id: 12260,
    wearable_ids: [372, 278],
  },
  {
    genesis_token_id: 12261,
    wearable_ids: [300, 287],
  },
  {
    genesis_token_id: 12262,
    wearable_ids: [326, 397],
  },
  {
    genesis_token_id: 12263,
    wearable_ids: [378, 434],
  },
  {
    genesis_token_id: 12264,
    wearable_ids: [433, 289],
  },
  {
    genesis_token_id: 12265,
    wearable_ids: [385, 325],
  },
  {
    genesis_token_id: 12266,
    wearable_ids: [426, 345],
  },
  {
    genesis_token_id: 12267,
    wearable_ids: [377, 300],
  },
  {
    genesis_token_id: 12268,
    wearable_ids: [433, 270],
  },
  {
    genesis_token_id: 12269,
    wearable_ids: [426, 373],
  },
  {
    genesis_token_id: 12270,
    wearable_ids: [347, 285],
  },
  {
    genesis_token_id: 12271,
    wearable_ids: [256, 407],
  },
  {
    genesis_token_id: 12272,
    wearable_ids: [331, 303],
  },
  {
    genesis_token_id: 12273,
    wearable_ids: [262, 253],
  },
  {
    genesis_token_id: 12274,
    wearable_ids: [377, 327],
  },
  {
    genesis_token_id: 12275,
    wearable_ids: [325, 444],
  },
  {
    genesis_token_id: 12276,
    wearable_ids: [276, 347],
  },
  {
    genesis_token_id: 12277,
    wearable_ids: [304, 302],
  },
  {
    genesis_token_id: 12278,
    wearable_ids: [348, 312],
  },
  {
    genesis_token_id: 12279,
    wearable_ids: [363, 429],
  },
  {
    genesis_token_id: 12280,
    wearable_ids: [399, 425],
  },
  {
    genesis_token_id: 12281,
    wearable_ids: [278, 301],
  },
  {
    genesis_token_id: 12282,
    wearable_ids: [311, 266],
  },
  {
    genesis_token_id: 12283,
    wearable_ids: [408, 444],
  },
  {
    genesis_token_id: 12284,
    wearable_ids: [255, 343],
  },
  {
    genesis_token_id: 12285,
    wearable_ids: [304, 315],
  },
  {
    genesis_token_id: 12286,
    wearable_ids: [294, 377],
  },
  {
    genesis_token_id: 12287,
    wearable_ids: [303, 364],
  },
  {
    genesis_token_id: 12288,
    wearable_ids: [364, 413],
  },
  {
    genesis_token_id: 12289,
    wearable_ids: [306, 377],
  },
  {
    genesis_token_id: 12290,
    wearable_ids: [289, 442],
  },
  {
    genesis_token_id: 12291,
    wearable_ids: [331, 337],
  },
  {
    genesis_token_id: 12292,
    wearable_ids: [364, 311],
  },
  {
    genesis_token_id: 12293,
    wearable_ids: [382, 260],
  },
  {
    genesis_token_id: 12294,
    wearable_ids: [432, 302],
  },
  {
    genesis_token_id: 12295,
    wearable_ids: [382, 278],
  },
  {
    genesis_token_id: 12296,
    wearable_ids: [437, 317],
  },
  {
    genesis_token_id: 12297,
    wearable_ids: [303, 384],
  },
  {
    genesis_token_id: 12298,
    wearable_ids: [248, 284],
  },
  {
    genesis_token_id: 12299,
    wearable_ids: [277, 413],
  },
  {
    genesis_token_id: 12300,
    wearable_ids: [383, 299],
  },
  {
    genesis_token_id: 12301,
    wearable_ids: [395, 303],
  },
  {
    genesis_token_id: 12302,
    wearable_ids: [387, 433],
  },
  {
    genesis_token_id: 12303,
    wearable_ids: [411, 423],
  },
  {
    genesis_token_id: 12304,
    wearable_ids: [434, 327],
  },
  {
    genesis_token_id: 12305,
    wearable_ids: [377, 280],
  },
  {
    genesis_token_id: 12306,
    wearable_ids: [386, 365],
  },
  {
    genesis_token_id: 12307,
    wearable_ids: [303, 284],
  },
  {
    genesis_token_id: 12308,
    wearable_ids: [291, 349],
  },
  {
    genesis_token_id: 12309,
    wearable_ids: [426, 434],
  },
  {
    genesis_token_id: 12310,
    wearable_ids: [365, 363],
  },
  {
    genesis_token_id: 12311,
    wearable_ids: [294, 387],
  },
  {
    genesis_token_id: 12312,
    wearable_ids: [389, 377],
  },
  {
    genesis_token_id: 12313,
    wearable_ids: [347, 428],
  },
  {
    genesis_token_id: 12314,
    wearable_ids: [445, 265],
  },
  {
    genesis_token_id: 12315,
    wearable_ids: [424, 263],
  },
  {
    genesis_token_id: 12316,
    wearable_ids: [340, 431],
  },
  {
    genesis_token_id: 12317,
    wearable_ids: [384, 440],
  },
  {
    genesis_token_id: 12318,
    wearable_ids: [265, 266],
  },
  {
    genesis_token_id: 12319,
    wearable_ids: [384, 356],
  },
  {
    genesis_token_id: 12320,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 12321,
    wearable_ids: [315, 347],
  },
  {
    genesis_token_id: 12322,
    wearable_ids: [263, 325],
  },
  {
    genesis_token_id: 12323,
    wearable_ids: [316, 404],
  },
  {
    genesis_token_id: 12324,
    wearable_ids: [409, 286],
  },
  {
    genesis_token_id: 12325,
    wearable_ids: [294, 339],
  },
  {
    genesis_token_id: 12326,
    wearable_ids: [415, 292],
  },
  {
    genesis_token_id: 12327,
    wearable_ids: [256, 248],
  },
  {
    genesis_token_id: 12328,
    wearable_ids: [294, 363],
  },
  {
    genesis_token_id: 12329,
    wearable_ids: [377, 278],
  },
  {
    genesis_token_id: 12330,
    wearable_ids: [294, 251],
  },
  {
    genesis_token_id: 12331,
    wearable_ids: [376, 337],
  },
  {
    genesis_token_id: 12332,
    wearable_ids: [335, 247],
  },
  {
    genesis_token_id: 12333,
    wearable_ids: [319, 268],
  },
  {
    genesis_token_id: 12334,
    wearable_ids: [308, 377],
  },
  {
    genesis_token_id: 12335,
    wearable_ids: [422, 407],
  },
  {
    genesis_token_id: 12336,
    wearable_ids: [383, 442],
  },
  {
    genesis_token_id: 12337,
    wearable_ids: [278, 348],
  },
  {
    genesis_token_id: 12338,
    wearable_ids: [310, 359],
  },
  {
    genesis_token_id: 12339,
    wearable_ids: [264, 250],
  },
  {
    genesis_token_id: 12340,
    wearable_ids: [292, 283],
  },
  {
    genesis_token_id: 12341,
    wearable_ids: [346, 294],
  },
  {
    genesis_token_id: 12342,
    wearable_ids: [254, 336],
  },
  {
    genesis_token_id: 12343,
    wearable_ids: [413, 341],
  },
  {
    genesis_token_id: 12344,
    wearable_ids: [434, 366],
  },
  {
    genesis_token_id: 12345,
    wearable_ids: [346, 271],
  },
  {
    genesis_token_id: 12346,
    wearable_ids: [265, 341],
  },
  {
    genesis_token_id: 12347,
    wearable_ids: [300, 331],
  },
  {
    genesis_token_id: 12348,
    wearable_ids: [437, 353],
  },
  {
    genesis_token_id: 12349,
    wearable_ids: [432, 289],
  },
  {
    genesis_token_id: 12350,
    wearable_ids: [268, 358],
  },
  {
    genesis_token_id: 12351,
    wearable_ids: [300, 408],
  },
  {
    genesis_token_id: 12352,
    wearable_ids: [396, 263],
  },
  {
    genesis_token_id: 12353,
    wearable_ids: [343, 337],
  },
  {
    genesis_token_id: 12354,
    wearable_ids: [428, 440],
  },
  {
    genesis_token_id: 12355,
    wearable_ids: [271, 416],
  },
  {
    genesis_token_id: 12356,
    wearable_ids: [344, 443],
  },
  {
    genesis_token_id: 12357,
    wearable_ids: [434, 399],
  },
  {
    genesis_token_id: 12358,
    wearable_ids: [247, 276],
  },
  {
    genesis_token_id: 12359,
    wearable_ids: [425, 373],
  },
  {
    genesis_token_id: 12360,
    wearable_ids: [280, 342],
  },
  {
    genesis_token_id: 12361,
    wearable_ids: [314, 378],
  },
  {
    genesis_token_id: 12362,
    wearable_ids: [341, 400],
  },
  {
    genesis_token_id: 12363,
    wearable_ids: [289, 366],
  },
  {
    genesis_token_id: 12364,
    wearable_ids: [336, 364],
  },
  {
    genesis_token_id: 12365,
    wearable_ids: [265, 332],
  },
  {
    genesis_token_id: 12366,
    wearable_ids: [284, 325],
  },
  {
    genesis_token_id: 12367,
    wearable_ids: [365, 344],
  },
  {
    genesis_token_id: 12368,
    wearable_ids: [413, 432],
  },
  {
    genesis_token_id: 12369,
    wearable_ids: [378, 304],
  },
  {
    genesis_token_id: 12370,
    wearable_ids: [343, 382],
  },
  {
    genesis_token_id: 12371,
    wearable_ids: [311, 258],
  },
  {
    genesis_token_id: 12372,
    wearable_ids: [306, 324],
  },
  {
    genesis_token_id: 12373,
    wearable_ids: [437, 344],
  },
  {
    genesis_token_id: 12374,
    wearable_ids: [303, 408],
  },
  {
    genesis_token_id: 12375,
    wearable_ids: [316, 288],
  },
  {
    genesis_token_id: 12376,
    wearable_ids: [303, 317],
  },
  {
    genesis_token_id: 12377,
    wearable_ids: [254, 412],
  },
  {
    genesis_token_id: 12378,
    wearable_ids: [349, 392],
  },
  {
    genesis_token_id: 12379,
    wearable_ids: [272, 308],
  },
  {
    genesis_token_id: 12380,
    wearable_ids: [411, 255],
  },
  {
    genesis_token_id: 12381,
    wearable_ids: [436, 315],
  },
  {
    genesis_token_id: 12382,
    wearable_ids: [253, 364],
  },
  {
    genesis_token_id: 12383,
    wearable_ids: [415, 349],
  },
  {
    genesis_token_id: 12384,
    wearable_ids: [306, 323],
  },
  {
    genesis_token_id: 12385,
    wearable_ids: [396, 297],
  },
  {
    genesis_token_id: 12386,
    wearable_ids: [290, 344],
  },
  {
    genesis_token_id: 12387,
    wearable_ids: [371, 404],
  },
  {
    genesis_token_id: 12388,
    wearable_ids: [436, 414],
  },
  {
    genesis_token_id: 12389,
    wearable_ids: [324, 396],
  },
  {
    genesis_token_id: 12390,
    wearable_ids: [316, 274],
  },
  {
    genesis_token_id: 12391,
    wearable_ids: [383, 273],
  },
  {
    genesis_token_id: 12392,
    wearable_ids: [355, 332],
  },
  {
    genesis_token_id: 12393,
    wearable_ids: [346, 400],
  },
  {
    genesis_token_id: 12394,
    wearable_ids: [397, 425],
  },
  {
    genesis_token_id: 12395,
    wearable_ids: [387, 304],
  },
  {
    genesis_token_id: 12396,
    wearable_ids: [443, 411],
  },
  {
    genesis_token_id: 12397,
    wearable_ids: [290, 272],
  },
  {
    genesis_token_id: 12398,
    wearable_ids: [294, 408],
  },
  {
    genesis_token_id: 12399,
    wearable_ids: [444, 313],
  },
  {
    genesis_token_id: 12400,
    wearable_ids: [377, 372],
  },
  {
    genesis_token_id: 12401,
    wearable_ids: [257, 348],
  },
  {
    genesis_token_id: 12402,
    wearable_ids: [297, 270],
  },
  {
    genesis_token_id: 12403,
    wearable_ids: [304, 428],
  },
  {
    genesis_token_id: 12404,
    wearable_ids: [436, 438],
  },
  {
    genesis_token_id: 12405,
    wearable_ids: [311, 443],
  },
  {
    genesis_token_id: 12406,
    wearable_ids: [310, 441],
  },
  {
    genesis_token_id: 12407,
    wearable_ids: [354, 280],
  },
  {
    genesis_token_id: 12408,
    wearable_ids: [422, 311],
  },
  {
    genesis_token_id: 12409,
    wearable_ids: [364, 404],
  },
  {
    genesis_token_id: 12410,
    wearable_ids: [433, 352],
  },
  {
    genesis_token_id: 12411,
    wearable_ids: [316, 433],
  },
  {
    genesis_token_id: 12412,
    wearable_ids: [432, 255],
  },
  {
    genesis_token_id: 12413,
    wearable_ids: [413, 342],
  },
  {
    genesis_token_id: 12414,
    wearable_ids: [425, 371],
  },
  {
    genesis_token_id: 12415,
    wearable_ids: [369, 425],
  },
  {
    genesis_token_id: 12416,
    wearable_ids: [253, 296],
  },
  {
    genesis_token_id: 12417,
    wearable_ids: [412, 445],
  },
  {
    genesis_token_id: 12418,
    wearable_ids: [355, 434],
  },
  {
    genesis_token_id: 12419,
    wearable_ids: [336, 440],
  },
  {
    genesis_token_id: 12420,
    wearable_ids: [443, 258],
  },
  {
    genesis_token_id: 12421,
    wearable_ids: [340, 407],
  },
  {
    genesis_token_id: 12422,
    wearable_ids: [387, 410],
  },
  {
    genesis_token_id: 12423,
    wearable_ids: [259, 264],
  },
  {
    genesis_token_id: 12424,
    wearable_ids: [346, 300],
  },
  {
    genesis_token_id: 12425,
    wearable_ids: [434, 289],
  },
  {
    genesis_token_id: 12426,
    wearable_ids: [301, 409],
  },
  {
    genesis_token_id: 12427,
    wearable_ids: [257, 344],
  },
  {
    genesis_token_id: 12428,
    wearable_ids: [271, 395],
  },
  {
    genesis_token_id: 12429,
    wearable_ids: [403, 315],
  },
  {
    genesis_token_id: 12430,
    wearable_ids: [299, 266],
  },
  {
    genesis_token_id: 12431,
    wearable_ids: [373, 362],
  },
  {
    genesis_token_id: 12432,
    wearable_ids: [351, 292],
  },
  {
    genesis_token_id: 12433,
    wearable_ids: [268, 428],
  },
  {
    genesis_token_id: 12434,
    wearable_ids: [382, 354],
  },
  {
    genesis_token_id: 12435,
    wearable_ids: [407, 260],
  },
  {
    genesis_token_id: 12436,
    wearable_ids: [324, 422],
  },
  {
    genesis_token_id: 12437,
    wearable_ids: [270, 433],
  },
  {
    genesis_token_id: 12438,
    wearable_ids: [315, 412],
  },
  {
    genesis_token_id: 12439,
    wearable_ids: [342, 247],
  },
  {
    genesis_token_id: 12440,
    wearable_ids: [442, 364],
  },
  {
    genesis_token_id: 12441,
    wearable_ids: [400, 398],
  },
  {
    genesis_token_id: 12442,
    wearable_ids: [264, 338],
  },
  {
    genesis_token_id: 12443,
    wearable_ids: [290, 410],
  },
  {
    genesis_token_id: 12444,
    wearable_ids: [362, 435],
  },
  {
    genesis_token_id: 12445,
    wearable_ids: [258, 311],
  },
  {
    genesis_token_id: 12446,
    wearable_ids: [254, 290],
  },
  {
    genesis_token_id: 12447,
    wearable_ids: [340, 442],
  },
  {
    genesis_token_id: 12448,
    wearable_ids: [436, 270],
  },
  {
    genesis_token_id: 12449,
    wearable_ids: [290, 348],
  },
  {
    genesis_token_id: 12450,
    wearable_ids: [343, 354],
  },
  {
    genesis_token_id: 12451,
    wearable_ids: [301, 291],
  },
  {
    genesis_token_id: 12452,
    wearable_ids: [296, 435],
  },
  {
    genesis_token_id: 12453,
    wearable_ids: [317, 280],
  },
  {
    genesis_token_id: 12454,
    wearable_ids: [256, 403],
  },
  {
    genesis_token_id: 12455,
    wearable_ids: [344, 379],
  },
  {
    genesis_token_id: 12456,
    wearable_ids: [256, 437],
  },
  {
    genesis_token_id: 12457,
    wearable_ids: [445, 356],
  },
  {
    genesis_token_id: 12458,
    wearable_ids: [337, 410],
  },
  {
    genesis_token_id: 12459,
    wearable_ids: [299, 357],
  },
  {
    genesis_token_id: 12460,
    wearable_ids: [436, 418],
  },
  {
    genesis_token_id: 12461,
    wearable_ids: [339, 295],
  },
  {
    genesis_token_id: 12462,
    wearable_ids: [280, 332],
  },
  {
    genesis_token_id: 12463,
    wearable_ids: [352, 247],
  },
  {
    genesis_token_id: 12464,
    wearable_ids: [348, 398],
  },
  {
    genesis_token_id: 12465,
    wearable_ids: [294, 316],
  },
  {
    genesis_token_id: 12466,
    wearable_ids: [346, 400],
  },
  {
    genesis_token_id: 12467,
    wearable_ids: [272, 255],
  },
  {
    genesis_token_id: 12468,
    wearable_ids: [396, 362],
  },
  {
    genesis_token_id: 12469,
    wearable_ids: [423, 408],
  },
  {
    genesis_token_id: 12470,
    wearable_ids: [433, 361],
  },
  {
    genesis_token_id: 12471,
    wearable_ids: [258, 293],
  },
  {
    genesis_token_id: 12472,
    wearable_ids: [362, 315],
  },
  {
    genesis_token_id: 12473,
    wearable_ids: [445, 409],
  },
  {
    genesis_token_id: 12474,
    wearable_ids: [268, 332],
  },
  {
    genesis_token_id: 12475,
    wearable_ids: [395, 332],
  },
  {
    genesis_token_id: 12476,
    wearable_ids: [263, 274],
  },
  {
    genesis_token_id: 12477,
    wearable_ids: [400, 346],
  },
  {
    genesis_token_id: 12478,
    wearable_ids: [263, 419],
  },
  {
    genesis_token_id: 12479,
    wearable_ids: [277, 296],
  },
  {
    genesis_token_id: 12480,
    wearable_ids: [399, 253],
  },
  {
    genesis_token_id: 12481,
    wearable_ids: [303, 298],
  },
  {
    genesis_token_id: 12482,
    wearable_ids: [299, 326],
  },
  {
    genesis_token_id: 12483,
    wearable_ids: [373, 343],
  },
  {
    genesis_token_id: 12484,
    wearable_ids: [308, 297],
  },
  {
    genesis_token_id: 12485,
    wearable_ids: [355, 265],
  },
  {
    genesis_token_id: 12486,
    wearable_ids: [364, 370],
  },
  {
    genesis_token_id: 12487,
    wearable_ids: [383, 326],
  },
  {
    genesis_token_id: 12488,
    wearable_ids: [363, 308],
  },
  {
    genesis_token_id: 12489,
    wearable_ids: [264, 286],
  },
  {
    genesis_token_id: 12490,
    wearable_ids: [412, 290],
  },
  {
    genesis_token_id: 12491,
    wearable_ids: [311, 277],
  },
  {
    genesis_token_id: 12492,
    wearable_ids: [342, 385],
  },
  {
    genesis_token_id: 12493,
    wearable_ids: [315, 348],
  },
  {
    genesis_token_id: 12494,
    wearable_ids: [304, 314],
  },
  {
    genesis_token_id: 12495,
    wearable_ids: [301, 402],
  },
  {
    genesis_token_id: 12496,
    wearable_ids: [343, 349],
  },
  {
    genesis_token_id: 12497,
    wearable_ids: [376, 336],
  },
  {
    genesis_token_id: 12498,
    wearable_ids: [431, 297],
  },
  {
    genesis_token_id: 12499,
    wearable_ids: [262, 289],
  },
  {
    genesis_token_id: 12500,
    wearable_ids: [444, 262],
  },
  {
    genesis_token_id: 12501,
    wearable_ids: [425, 254],
  },
  {
    genesis_token_id: 12502,
    wearable_ids: [400, 373],
  },
  {
    genesis_token_id: 12503,
    wearable_ids: [431, 407],
  },
  {
    genesis_token_id: 12504,
    wearable_ids: [266, 350],
  },
  {
    genesis_token_id: 12505,
    wearable_ids: [431, 336],
  },
  {
    genesis_token_id: 12506,
    wearable_ids: [426, 307],
  },
  {
    genesis_token_id: 12507,
    wearable_ids: [340, 410],
  },
  {
    genesis_token_id: 12508,
    wearable_ids: [412, 299],
  },
  {
    genesis_token_id: 12509,
    wearable_ids: [408, 428],
  },
  {
    genesis_token_id: 12510,
    wearable_ids: [407, 287],
  },
  {
    genesis_token_id: 12511,
    wearable_ids: [264, 376],
  },
  {
    genesis_token_id: 12512,
    wearable_ids: [352, 376],
  },
  {
    genesis_token_id: 12513,
    wearable_ids: [365, 443],
  },
  {
    genesis_token_id: 12514,
    wearable_ids: [432, 280],
  },
  {
    genesis_token_id: 12515,
    wearable_ids: [341, 250],
  },
  {
    genesis_token_id: 12516,
    wearable_ids: [331, 377],
  },
  {
    genesis_token_id: 12517,
    wearable_ids: [382, 274],
  },
  {
    genesis_token_id: 12518,
    wearable_ids: [384, 262],
  },
  {
    genesis_token_id: 12519,
    wearable_ids: [350, 283],
  },
  {
    genesis_token_id: 12520,
    wearable_ids: [255, 247],
  },
  {
    genesis_token_id: 12521,
    wearable_ids: [363, 295],
  },
  {
    genesis_token_id: 12522,
    wearable_ids: [264, 323],
  },
  {
    genesis_token_id: 12523,
    wearable_ids: [375, 444],
  },
  {
    genesis_token_id: 12524,
    wearable_ids: [412, 368],
  },
  {
    genesis_token_id: 12525,
    wearable_ids: [340, 326],
  },
  {
    genesis_token_id: 12526,
    wearable_ids: [297, 291],
  },
  {
    genesis_token_id: 12527,
    wearable_ids: [374, 383],
  },
  {
    genesis_token_id: 12528,
    wearable_ids: [373, 394],
  },
  {
    genesis_token_id: 12529,
    wearable_ids: [338, 424],
  },
  {
    genesis_token_id: 12530,
    wearable_ids: [431, 403],
  },
  {
    genesis_token_id: 12531,
    wearable_ids: [287, 280],
  },
  {
    genesis_token_id: 12532,
    wearable_ids: [403, 441],
  },
  {
    genesis_token_id: 12533,
    wearable_ids: [373, 261],
  },
  {
    genesis_token_id: 12534,
    wearable_ids: [355, 357],
  },
  {
    genesis_token_id: 12535,
    wearable_ids: [399, 308],
  },
  {
    genesis_token_id: 12536,
    wearable_ids: [413, 366],
  },
  {
    genesis_token_id: 12537,
    wearable_ids: [376, 398],
  },
  {
    genesis_token_id: 12538,
    wearable_ids: [278, 426],
  },
  {
    genesis_token_id: 12539,
    wearable_ids: [344, 429],
  },
  {
    genesis_token_id: 12540,
    wearable_ids: [433, 377],
  },
  {
    genesis_token_id: 12541,
    wearable_ids: [373, 443],
  },
  {
    genesis_token_id: 12542,
    wearable_ids: [319, 351],
  },
  {
    genesis_token_id: 12543,
    wearable_ids: [403, 375],
  },
  {
    genesis_token_id: 12544,
    wearable_ids: [343, 267],
  },
  {
    genesis_token_id: 12545,
    wearable_ids: [364, 420],
  },
  {
    genesis_token_id: 12546,
    wearable_ids: [278, 341],
  },
  {
    genesis_token_id: 12547,
    wearable_ids: [346, 324],
  },
  {
    genesis_token_id: 12548,
    wearable_ids: [297, 326],
  },
  {
    genesis_token_id: 12549,
    wearable_ids: [332, 364],
  },
  {
    genesis_token_id: 12550,
    wearable_ids: [248, 296],
  },
  {
    genesis_token_id: 12551,
    wearable_ids: [422, 444],
  },
  {
    genesis_token_id: 12552,
    wearable_ids: [445, 365],
  },
  {
    genesis_token_id: 12553,
    wearable_ids: [387, 262],
  },
  {
    genesis_token_id: 12554,
    wearable_ids: [303, 358],
  },
  {
    genesis_token_id: 12555,
    wearable_ids: [264, 426],
  },
  {
    genesis_token_id: 12556,
    wearable_ids: [271, 415],
  },
  {
    genesis_token_id: 12557,
    wearable_ids: [342, 314],
  },
  {
    genesis_token_id: 12558,
    wearable_ids: [340, 423],
  },
  {
    genesis_token_id: 12559,
    wearable_ids: [435, 257],
  },
  {
    genesis_token_id: 12560,
    wearable_ids: [413, 408],
  },
  {
    genesis_token_id: 12561,
    wearable_ids: [341, 422],
  },
  {
    genesis_token_id: 12562,
    wearable_ids: [286, 442],
  },
  {
    genesis_token_id: 12563,
    wearable_ids: [413, 278],
  },
  {
    genesis_token_id: 12564,
    wearable_ids: [270, 422],
  },
  {
    genesis_token_id: 12565,
    wearable_ids: [344, 412],
  },
  {
    genesis_token_id: 12566,
    wearable_ids: [332, 306],
  },
  {
    genesis_token_id: 12567,
    wearable_ids: [442, 266],
  },
  {
    genesis_token_id: 12568,
    wearable_ids: [247, 335],
  },
  {
    genesis_token_id: 12569,
    wearable_ids: [303, 261],
  },
  {
    genesis_token_id: 12570,
    wearable_ids: [382, 274],
  },
  {
    genesis_token_id: 12571,
    wearable_ids: [404, 266],
  },
  {
    genesis_token_id: 12572,
    wearable_ids: [301, 387],
  },
  {
    genesis_token_id: 12573,
    wearable_ids: [396, 339],
  },
  {
    genesis_token_id: 12574,
    wearable_ids: [443, 314],
  },
  {
    genesis_token_id: 12575,
    wearable_ids: [295, 325],
  },
  {
    genesis_token_id: 12576,
    wearable_ids: [295, 310],
  },
  {
    genesis_token_id: 12577,
    wearable_ids: [362, 261],
  },
  {
    genesis_token_id: 12578,
    wearable_ids: [257, 278],
  },
  {
    genesis_token_id: 12579,
    wearable_ids: [274, 314],
  },
  {
    genesis_token_id: 12580,
    wearable_ids: [268, 314],
  },
  {
    genesis_token_id: 12581,
    wearable_ids: [270, 341],
  },
  {
    genesis_token_id: 12582,
    wearable_ids: [344, 295],
  },
  {
    genesis_token_id: 12583,
    wearable_ids: [389, 301],
  },
  {
    genesis_token_id: 12584,
    wearable_ids: [400, 368],
  },
  {
    genesis_token_id: 12585,
    wearable_ids: [411, 436],
  },
  {
    genesis_token_id: 12586,
    wearable_ids: [403, 255],
  },
  {
    genesis_token_id: 12587,
    wearable_ids: [308, 346],
  },
  {
    genesis_token_id: 12588,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 12589,
    wearable_ids: [382, 411],
  },
  {
    genesis_token_id: 12590,
    wearable_ids: [365, 339],
  },
  {
    genesis_token_id: 12591,
    wearable_ids: [389, 280],
  },
  {
    genesis_token_id: 12592,
    wearable_ids: [426, 429],
  },
  {
    genesis_token_id: 12593,
    wearable_ids: [436, 301],
  },
  {
    genesis_token_id: 12594,
    wearable_ids: [370, 306],
  },
  {
    genesis_token_id: 12595,
    wearable_ids: [273, 260],
  },
  {
    genesis_token_id: 12596,
    wearable_ids: [297, 338],
  },
  {
    genesis_token_id: 12597,
    wearable_ids: [280, 320],
  },
  {
    genesis_token_id: 12598,
    wearable_ids: [424, 348],
  },
  {
    genesis_token_id: 12599,
    wearable_ids: [426, 407],
  },
  {
    genesis_token_id: 12600,
    wearable_ids: [304, 414],
  },
  {
    genesis_token_id: 12601,
    wearable_ids: [410, 365],
  },
  {
    genesis_token_id: 12602,
    wearable_ids: [422, 430],
  },
  {
    genesis_token_id: 12603,
    wearable_ids: [400, 271],
  },
  {
    genesis_token_id: 12604,
    wearable_ids: [382, 318],
  },
  {
    genesis_token_id: 12605,
    wearable_ids: [342, 292],
  },
  {
    genesis_token_id: 12606,
    wearable_ids: [339, 300],
  },
  {
    genesis_token_id: 12607,
    wearable_ids: [276, 324],
  },
  {
    genesis_token_id: 12608,
    wearable_ids: [397, 262],
  },
  {
    genesis_token_id: 12609,
    wearable_ids: [406, 441],
  },
  {
    genesis_token_id: 12610,
    wearable_ids: [436, 293],
  },
  {
    genesis_token_id: 12611,
    wearable_ids: [349, 330],
  },
  {
    genesis_token_id: 12612,
    wearable_ids: [310, 339],
  },
  {
    genesis_token_id: 12613,
    wearable_ids: [436, 317],
  },
  {
    genesis_token_id: 12614,
    wearable_ids: [432, 310],
  },
  {
    genesis_token_id: 12615,
    wearable_ids: [429, 392],
  },
  {
    genesis_token_id: 12616,
    wearable_ids: [291, 372],
  },
  {
    genesis_token_id: 12617,
    wearable_ids: [407, 293],
  },
  {
    genesis_token_id: 12618,
    wearable_ids: [383, 411],
  },
  {
    genesis_token_id: 12619,
    wearable_ids: [338, 292],
  },
  {
    genesis_token_id: 12620,
    wearable_ids: [257, 387],
  },
  {
    genesis_token_id: 12621,
    wearable_ids: [423, 435],
  },
  {
    genesis_token_id: 12622,
    wearable_ids: [377, 437],
  },
  {
    genesis_token_id: 12623,
    wearable_ids: [315, 434],
  },
  {
    genesis_token_id: 12624,
    wearable_ids: [377, 311],
  },
  {
    genesis_token_id: 12625,
    wearable_ids: [371, 437],
  },
  {
    genesis_token_id: 12626,
    wearable_ids: [433, 370],
  },
  {
    genesis_token_id: 12627,
    wearable_ids: [444, 432],
  },
  {
    genesis_token_id: 12628,
    wearable_ids: [296, 297],
  },
  {
    genesis_token_id: 12629,
    wearable_ids: [365, 274],
  },
  {
    genesis_token_id: 12630,
    wearable_ids: [319, 383],
  },
  {
    genesis_token_id: 12631,
    wearable_ids: [426, 352],
  },
  {
    genesis_token_id: 12632,
    wearable_ids: [299, 364],
  },
  {
    genesis_token_id: 12633,
    wearable_ids: [369, 417],
  },
  {
    genesis_token_id: 12634,
    wearable_ids: [319, 317],
  },
  {
    genesis_token_id: 12635,
    wearable_ids: [375, 273],
  },
  {
    genesis_token_id: 12636,
    wearable_ids: [324, 420],
  },
  {
    genesis_token_id: 12637,
    wearable_ids: [306, 284],
  },
  {
    genesis_token_id: 12638,
    wearable_ids: [290, 426],
  },
  {
    genesis_token_id: 12639,
    wearable_ids: [411, 268],
  },
  {
    genesis_token_id: 12640,
    wearable_ids: [265, 251],
  },
  {
    genesis_token_id: 12641,
    wearable_ids: [348, 336],
  },
  {
    genesis_token_id: 12642,
    wearable_ids: [389, 445],
  },
  {
    genesis_token_id: 12643,
    wearable_ids: [348, 373],
  },
  {
    genesis_token_id: 12644,
    wearable_ids: [289, 310],
  },
  {
    genesis_token_id: 12645,
    wearable_ids: [382, 383],
  },
  {
    genesis_token_id: 12646,
    wearable_ids: [308, 400],
  },
  {
    genesis_token_id: 12647,
    wearable_ids: [296, 324],
  },
  {
    genesis_token_id: 12648,
    wearable_ids: [382, 315],
  },
  {
    genesis_token_id: 12649,
    wearable_ids: [387, 357],
  },
  {
    genesis_token_id: 12650,
    wearable_ids: [255, 389],
  },
  {
    genesis_token_id: 12651,
    wearable_ids: [337, 395],
  },
  {
    genesis_token_id: 12652,
    wearable_ids: [445, 316],
  },
  {
    genesis_token_id: 12653,
    wearable_ids: [343, 257],
  },
  {
    genesis_token_id: 12654,
    wearable_ids: [306, 420],
  },
  {
    genesis_token_id: 12655,
    wearable_ids: [340, 341],
  },
  {
    genesis_token_id: 12656,
    wearable_ids: [335, 266],
  },
  {
    genesis_token_id: 12657,
    wearable_ids: [258, 363],
  },
  {
    genesis_token_id: 12658,
    wearable_ids: [295, 389],
  },
  {
    genesis_token_id: 12659,
    wearable_ids: [352, 444],
  },
  {
    genesis_token_id: 12660,
    wearable_ids: [444, 426],
  },
  {
    genesis_token_id: 12661,
    wearable_ids: [364, 358],
  },
  {
    genesis_token_id: 12662,
    wearable_ids: [442, 437],
  },
  {
    genesis_token_id: 12663,
    wearable_ids: [432, 328],
  },
  {
    genesis_token_id: 12664,
    wearable_ids: [292, 442],
  },
  {
    genesis_token_id: 12665,
    wearable_ids: [428, 371],
  },
  {
    genesis_token_id: 12666,
    wearable_ids: [403, 436],
  },
  {
    genesis_token_id: 12667,
    wearable_ids: [404, 387],
  },
  {
    genesis_token_id: 12668,
    wearable_ids: [422, 313],
  },
  {
    genesis_token_id: 12669,
    wearable_ids: [406, 325],
  },
  {
    genesis_token_id: 12670,
    wearable_ids: [326, 287],
  },
  {
    genesis_token_id: 12671,
    wearable_ids: [268, 445],
  },
  {
    genesis_token_id: 12672,
    wearable_ids: [385, 301],
  },
  {
    genesis_token_id: 12673,
    wearable_ids: [264, 291],
  },
  {
    genesis_token_id: 12674,
    wearable_ids: [384, 409],
  },
  {
    genesis_token_id: 12675,
    wearable_ids: [374, 378],
  },
  {
    genesis_token_id: 12676,
    wearable_ids: [297, 328],
  },
  {
    genesis_token_id: 12677,
    wearable_ids: [425, 411],
  },
  {
    genesis_token_id: 12678,
    wearable_ids: [407, 350],
  },
  {
    genesis_token_id: 12679,
    wearable_ids: [386, 266],
  },
  {
    genesis_token_id: 12680,
    wearable_ids: [343, 383],
  },
  {
    genesis_token_id: 12681,
    wearable_ids: [335, 362],
  },
  {
    genesis_token_id: 12682,
    wearable_ids: [384, 355],
  },
  {
    genesis_token_id: 12683,
    wearable_ids: [255, 368],
  },
  {
    genesis_token_id: 12684,
    wearable_ids: [291, 333],
  },
  {
    genesis_token_id: 12685,
    wearable_ids: [344, 286],
  },
  {
    genesis_token_id: 12686,
    wearable_ids: [340, 276],
  },
  {
    genesis_token_id: 12687,
    wearable_ids: [429, 346],
  },
  {
    genesis_token_id: 12688,
    wearable_ids: [428, 389],
  },
  {
    genesis_token_id: 12689,
    wearable_ids: [341, 316],
  },
  {
    genesis_token_id: 12690,
    wearable_ids: [347, 279],
  },
  {
    genesis_token_id: 12691,
    wearable_ids: [445, 375],
  },
  {
    genesis_token_id: 12692,
    wearable_ids: [429, 299],
  },
  {
    genesis_token_id: 12693,
    wearable_ids: [383, 360],
  },
  {
    genesis_token_id: 12694,
    wearable_ids: [314, 343],
  },
  {
    genesis_token_id: 12695,
    wearable_ids: [296, 303],
  },
  {
    genesis_token_id: 12696,
    wearable_ids: [395, 295],
  },
  {
    genesis_token_id: 12697,
    wearable_ids: [378, 352],
  },
  {
    genesis_token_id: 12698,
    wearable_ids: [431, 389],
  },
  {
    genesis_token_id: 12699,
    wearable_ids: [350, 284],
  },
  {
    genesis_token_id: 12700,
    wearable_ids: [369, 308],
  },
  {
    genesis_token_id: 12701,
    wearable_ids: [251, 249],
  },
  {
    genesis_token_id: 12702,
    wearable_ids: [316, 317],
  },
  {
    genesis_token_id: 12703,
    wearable_ids: [338, 347],
  },
  {
    genesis_token_id: 12704,
    wearable_ids: [397, 382],
  },
  {
    genesis_token_id: 12705,
    wearable_ids: [340, 259],
  },
  {
    genesis_token_id: 12706,
    wearable_ids: [291, 301],
  },
  {
    genesis_token_id: 12707,
    wearable_ids: [387, 337],
  },
  {
    genesis_token_id: 12708,
    wearable_ids: [365, 272],
  },
  {
    genesis_token_id: 12709,
    wearable_ids: [428, 290],
  },
  {
    genesis_token_id: 12710,
    wearable_ids: [303, 427],
  },
  {
    genesis_token_id: 12711,
    wearable_ids: [408, 401],
  },
  {
    genesis_token_id: 12712,
    wearable_ids: [254, 336],
  },
  {
    genesis_token_id: 12713,
    wearable_ids: [326, 362],
  },
  {
    genesis_token_id: 12714,
    wearable_ids: [386, 382],
  },
  {
    genesis_token_id: 12715,
    wearable_ids: [424, 362],
  },
  {
    genesis_token_id: 12716,
    wearable_ids: [437, 334],
  },
  {
    genesis_token_id: 12717,
    wearable_ids: [383, 337],
  },
  {
    genesis_token_id: 12718,
    wearable_ids: [375, 374],
  },
  {
    genesis_token_id: 12719,
    wearable_ids: [255, 347],
  },
  {
    genesis_token_id: 12720,
    wearable_ids: [255, 343],
  },
  {
    genesis_token_id: 12721,
    wearable_ids: [335, 270],
  },
  {
    genesis_token_id: 12722,
    wearable_ids: [287, 362],
  },
  {
    genesis_token_id: 12723,
    wearable_ids: [292, 337],
  },
  {
    genesis_token_id: 12724,
    wearable_ids: [432, 372],
  },
  {
    genesis_token_id: 12725,
    wearable_ids: [306, 364],
  },
  {
    genesis_token_id: 12726,
    wearable_ids: [324, 338],
  },
  {
    genesis_token_id: 12727,
    wearable_ids: [378, 364],
  },
  {
    genesis_token_id: 12728,
    wearable_ids: [317, 406],
  },
  {
    genesis_token_id: 12729,
    wearable_ids: [387, 428],
  },
  {
    genesis_token_id: 12730,
    wearable_ids: [271, 363],
  },
  {
    genesis_token_id: 12731,
    wearable_ids: [385, 407],
  },
  {
    genesis_token_id: 12732,
    wearable_ids: [306, 287],
  },
  {
    genesis_token_id: 12733,
    wearable_ids: [348, 344],
  },
  {
    genesis_token_id: 12734,
    wearable_ids: [432, 263],
  },
  {
    genesis_token_id: 12735,
    wearable_ids: [324, 310],
  },
  {
    genesis_token_id: 12736,
    wearable_ids: [270, 348],
  },
  {
    genesis_token_id: 12737,
    wearable_ids: [444, 272],
  },
  {
    genesis_token_id: 12738,
    wearable_ids: [295, 429],
  },
  {
    genesis_token_id: 12739,
    wearable_ids: [363, 341],
  },
  {
    genesis_token_id: 12740,
    wearable_ids: [387, 281],
  },
  {
    genesis_token_id: 12741,
    wearable_ids: [271, 404],
  },
  {
    genesis_token_id: 12742,
    wearable_ids: [428, 389],
  },
  {
    genesis_token_id: 12743,
    wearable_ids: [385, 377],
  },
  {
    genesis_token_id: 12744,
    wearable_ids: [255, 326],
  },
  {
    genesis_token_id: 12745,
    wearable_ids: [404, 393],
  },
  {
    genesis_token_id: 12746,
    wearable_ids: [376, 351],
  },
  {
    genesis_token_id: 12747,
    wearable_ids: [385, 325],
  },
  {
    genesis_token_id: 12748,
    wearable_ids: [294, 356],
  },
  {
    genesis_token_id: 12749,
    wearable_ids: [413, 378],
  },
  {
    genesis_token_id: 12750,
    wearable_ids: [319, 422],
  },
  {
    genesis_token_id: 12751,
    wearable_ids: [254, 337],
  },
  {
    genesis_token_id: 12752,
    wearable_ids: [273, 347],
  },
  {
    genesis_token_id: 12753,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 12754,
    wearable_ids: [270, 411],
  },
  {
    genesis_token_id: 12755,
    wearable_ids: [257, 346],
  },
  {
    genesis_token_id: 12756,
    wearable_ids: [373, 339],
  },
  {
    genesis_token_id: 12757,
    wearable_ids: [382, 263],
  },
  {
    genesis_token_id: 12758,
    wearable_ids: [287, 248],
  },
  {
    genesis_token_id: 12759,
    wearable_ids: [432, 344],
  },
  {
    genesis_token_id: 12760,
    wearable_ids: [400, 411],
  },
  {
    genesis_token_id: 12761,
    wearable_ids: [306, 284],
  },
  {
    genesis_token_id: 12762,
    wearable_ids: [277, 346],
  },
  {
    genesis_token_id: 12763,
    wearable_ids: [310, 420],
  },
  {
    genesis_token_id: 12764,
    wearable_ids: [443, 399],
  },
  {
    genesis_token_id: 12765,
    wearable_ids: [348, 319],
  },
  {
    genesis_token_id: 12766,
    wearable_ids: [280, 426],
  },
  {
    genesis_token_id: 12767,
    wearable_ids: [387, 385],
  },
  {
    genesis_token_id: 12768,
    wearable_ids: [247, 385],
  },
  {
    genesis_token_id: 12769,
    wearable_ids: [422, 338],
  },
  {
    genesis_token_id: 12770,
    wearable_ids: [278, 389],
  },
  {
    genesis_token_id: 12771,
    wearable_ids: [265, 426],
  },
  {
    genesis_token_id: 12772,
    wearable_ids: [410, 336],
  },
  {
    genesis_token_id: 12773,
    wearable_ids: [287, 274],
  },
  {
    genesis_token_id: 12774,
    wearable_ids: [341, 268],
  },
  {
    genesis_token_id: 12775,
    wearable_ids: [395, 364],
  },
  {
    genesis_token_id: 12776,
    wearable_ids: [314, 265],
  },
  {
    genesis_token_id: 12777,
    wearable_ids: [428, 279],
  },
  {
    genesis_token_id: 12778,
    wearable_ids: [324, 328],
  },
  {
    genesis_token_id: 12779,
    wearable_ids: [295, 420],
  },
  {
    genesis_token_id: 12780,
    wearable_ids: [248, 315],
  },
  {
    genesis_token_id: 12781,
    wearable_ids: [371, 376],
  },
  {
    genesis_token_id: 12782,
    wearable_ids: [270, 345],
  },
  {
    genesis_token_id: 12783,
    wearable_ids: [308, 311],
  },
  {
    genesis_token_id: 12784,
    wearable_ids: [291, 287],
  },
  {
    genesis_token_id: 12785,
    wearable_ids: [431, 432],
  },
  {
    genesis_token_id: 12786,
    wearable_ids: [317, 401],
  },
  {
    genesis_token_id: 12787,
    wearable_ids: [384, 267],
  },
  {
    genesis_token_id: 12788,
    wearable_ids: [271, 410],
  },
  {
    genesis_token_id: 12789,
    wearable_ids: [376, 335],
  },
  {
    genesis_token_id: 12790,
    wearable_ids: [339, 430],
  },
  {
    genesis_token_id: 12791,
    wearable_ids: [426, 386],
  },
  {
    genesis_token_id: 12792,
    wearable_ids: [263, 436],
  },
  {
    genesis_token_id: 12793,
    wearable_ids: [364, 376],
  },
  {
    genesis_token_id: 12794,
    wearable_ids: [384, 396],
  },
  {
    genesis_token_id: 12795,
    wearable_ids: [264, 285],
  },
  {
    genesis_token_id: 12796,
    wearable_ids: [315, 430],
  },
  {
    genesis_token_id: 12797,
    wearable_ids: [415, 423],
  },
  {
    genesis_token_id: 12798,
    wearable_ids: [266, 356],
  },
  {
    genesis_token_id: 12799,
    wearable_ids: [425, 352],
  },
  {
    genesis_token_id: 12800,
    wearable_ids: [294, 264],
  },
  {
    genesis_token_id: 12801,
    wearable_ids: [263, 337],
  },
  {
    genesis_token_id: 12802,
    wearable_ids: [303, 301],
  },
  {
    genesis_token_id: 12803,
    wearable_ids: [295, 422],
  },
  {
    genesis_token_id: 12804,
    wearable_ids: [289, 385],
  },
  {
    genesis_token_id: 12805,
    wearable_ids: [300, 260],
  },
  {
    genesis_token_id: 12806,
    wearable_ids: [368, 370],
  },
  {
    genesis_token_id: 12807,
    wearable_ids: [371, 405],
  },
  {
    genesis_token_id: 12808,
    wearable_ids: [299, 393],
  },
  {
    genesis_token_id: 12809,
    wearable_ids: [258, 304],
  },
  {
    genesis_token_id: 12810,
    wearable_ids: [276, 430],
  },
  {
    genesis_token_id: 12811,
    wearable_ids: [364, 386],
  },
  {
    genesis_token_id: 12812,
    wearable_ids: [337, 351],
  },
  {
    genesis_token_id: 12813,
    wearable_ids: [431, 319],
  },
  {
    genesis_token_id: 12814,
    wearable_ids: [375, 420],
  },
  {
    genesis_token_id: 12815,
    wearable_ids: [387, 280],
  },
  {
    genesis_token_id: 12816,
    wearable_ids: [411, 365],
  },
  {
    genesis_token_id: 12817,
    wearable_ids: [420, 265],
  },
  {
    genesis_token_id: 12818,
    wearable_ids: [265, 301],
  },
  {
    genesis_token_id: 12819,
    wearable_ids: [382, 250],
  },
  {
    genesis_token_id: 12820,
    wearable_ids: [341, 375],
  },
  {
    genesis_token_id: 12821,
    wearable_ids: [280, 320],
  },
  {
    genesis_token_id: 12822,
    wearable_ids: [407, 276],
  },
  {
    genesis_token_id: 12823,
    wearable_ids: [340, 350],
  },
  {
    genesis_token_id: 12824,
    wearable_ids: [262, 376],
  },
  {
    genesis_token_id: 12825,
    wearable_ids: [254, 430],
  },
  {
    genesis_token_id: 12826,
    wearable_ids: [266, 273],
  },
  {
    genesis_token_id: 12827,
    wearable_ids: [386, 278],
  },
  {
    genesis_token_id: 12828,
    wearable_ids: [374, 377],
  },
  {
    genesis_token_id: 12829,
    wearable_ids: [362, 247],
  },
  {
    genesis_token_id: 12830,
    wearable_ids: [409, 378],
  },
  {
    genesis_token_id: 12831,
    wearable_ids: [424, 396],
  },
  {
    genesis_token_id: 12832,
    wearable_ids: [404, 424],
  },
  {
    genesis_token_id: 12833,
    wearable_ids: [434, 260],
  },
  {
    genesis_token_id: 12834,
    wearable_ids: [317, 410],
  },
  {
    genesis_token_id: 12835,
    wearable_ids: [314, 368],
  },
  {
    genesis_token_id: 12836,
    wearable_ids: [363, 371],
  },
  {
    genesis_token_id: 12837,
    wearable_ids: [301, 349],
  },
  {
    genesis_token_id: 12838,
    wearable_ids: [425, 292],
  },
  {
    genesis_token_id: 12839,
    wearable_ids: [259, 364],
  },
  {
    genesis_token_id: 12840,
    wearable_ids: [290, 303],
  },
  {
    genesis_token_id: 12841,
    wearable_ids: [306, 357],
  },
  {
    genesis_token_id: 12842,
    wearable_ids: [331, 405],
  },
  {
    genesis_token_id: 12843,
    wearable_ids: [395, 374],
  },
  {
    genesis_token_id: 12844,
    wearable_ids: [280, 369],
  },
  {
    genesis_token_id: 12845,
    wearable_ids: [301, 297],
  },
  {
    genesis_token_id: 12846,
    wearable_ids: [413, 415],
  },
  {
    genesis_token_id: 12847,
    wearable_ids: [247, 351],
  },
  {
    genesis_token_id: 12848,
    wearable_ids: [410, 255],
  },
  {
    genesis_token_id: 12849,
    wearable_ids: [424, 275],
  },
  {
    genesis_token_id: 12850,
    wearable_ids: [400, 343],
  },
  {
    genesis_token_id: 12851,
    wearable_ids: [280, 340],
  },
  {
    genesis_token_id: 12852,
    wearable_ids: [301, 408],
  },
  {
    genesis_token_id: 12853,
    wearable_ids: [336, 424],
  },
  {
    genesis_token_id: 12854,
    wearable_ids: [443, 352],
  },
  {
    genesis_token_id: 12855,
    wearable_ids: [385, 325],
  },
  {
    genesis_token_id: 12856,
    wearable_ids: [326, 340],
  },
  {
    genesis_token_id: 12857,
    wearable_ids: [255, 445],
  },
  {
    genesis_token_id: 12858,
    wearable_ids: [247, 299],
  },
  {
    genesis_token_id: 12859,
    wearable_ids: [340, 375],
  },
  {
    genesis_token_id: 12860,
    wearable_ids: [410, 255],
  },
  {
    genesis_token_id: 12861,
    wearable_ids: [268, 254],
  },
  {
    genesis_token_id: 12862,
    wearable_ids: [274, 275],
  },
  {
    genesis_token_id: 12863,
    wearable_ids: [331, 341],
  },
  {
    genesis_token_id: 12864,
    wearable_ids: [387, 273],
  },
  {
    genesis_token_id: 12865,
    wearable_ids: [272, 298],
  },
  {
    genesis_token_id: 12866,
    wearable_ids: [286, 316],
  },
  {
    genesis_token_id: 12867,
    wearable_ids: [259, 311],
  },
  {
    genesis_token_id: 12868,
    wearable_ids: [266, 365],
  },
  {
    genesis_token_id: 12869,
    wearable_ids: [292, 436],
  },
  {
    genesis_token_id: 12870,
    wearable_ids: [287, 360],
  },
  {
    genesis_token_id: 12871,
    wearable_ids: [436, 443],
  },
  {
    genesis_token_id: 12872,
    wearable_ids: [382, 318],
  },
  {
    genesis_token_id: 12873,
    wearable_ids: [385, 277],
  },
  {
    genesis_token_id: 12874,
    wearable_ids: [395, 301],
  },
  {
    genesis_token_id: 12875,
    wearable_ids: [424, 436],
  },
  {
    genesis_token_id: 12876,
    wearable_ids: [415, 357],
  },
  {
    genesis_token_id: 12877,
    wearable_ids: [363, 377],
  },
  {
    genesis_token_id: 12878,
    wearable_ids: [374, 332],
  },
  {
    genesis_token_id: 12879,
    wearable_ids: [350, 374],
  },
  {
    genesis_token_id: 12880,
    wearable_ids: [426, 266],
  },
  {
    genesis_token_id: 12881,
    wearable_ids: [336, 308],
  },
  {
    genesis_token_id: 12882,
    wearable_ids: [352, 436],
  },
  {
    genesis_token_id: 12883,
    wearable_ids: [259, 308],
  },
  {
    genesis_token_id: 12884,
    wearable_ids: [396, 343],
  },
  {
    genesis_token_id: 12885,
    wearable_ids: [363, 416],
  },
  {
    genesis_token_id: 12886,
    wearable_ids: [395, 254],
  },
  {
    genesis_token_id: 12887,
    wearable_ids: [248, 370],
  },
  {
    genesis_token_id: 12888,
    wearable_ids: [325, 314],
  },
  {
    genesis_token_id: 12889,
    wearable_ids: [297, 389],
  },
  {
    genesis_token_id: 12890,
    wearable_ids: [373, 432],
  },
  {
    genesis_token_id: 12891,
    wearable_ids: [248, 346],
  },
  {
    genesis_token_id: 12892,
    wearable_ids: [368, 296],
  },
  {
    genesis_token_id: 12893,
    wearable_ids: [315, 264],
  },
  {
    genesis_token_id: 12894,
    wearable_ids: [295, 319],
  },
  {
    genesis_token_id: 12895,
    wearable_ids: [258, 284],
  },
  {
    genesis_token_id: 12896,
    wearable_ids: [297, 279],
  },
  {
    genesis_token_id: 12897,
    wearable_ids: [338, 271],
  },
  {
    genesis_token_id: 12898,
    wearable_ids: [303, 370],
  },
  {
    genesis_token_id: 12899,
    wearable_ids: [287, 444],
  },
  {
    genesis_token_id: 12900,
    wearable_ids: [424, 376],
  },
  {
    genesis_token_id: 12901,
    wearable_ids: [355, 259],
  },
  {
    genesis_token_id: 12902,
    wearable_ids: [437, 430],
  },
  {
    genesis_token_id: 12903,
    wearable_ids: [396, 406],
  },
  {
    genesis_token_id: 12904,
    wearable_ids: [344, 262],
  },
  {
    genesis_token_id: 12905,
    wearable_ids: [406, 444],
  },
  {
    genesis_token_id: 12906,
    wearable_ids: [295, 322],
  },
  {
    genesis_token_id: 12907,
    wearable_ids: [351, 414],
  },
  {
    genesis_token_id: 12908,
    wearable_ids: [374, 268],
  },
  {
    genesis_token_id: 12909,
    wearable_ids: [262, 294],
  },
  {
    genesis_token_id: 12910,
    wearable_ids: [410, 297],
  },
  {
    genesis_token_id: 12911,
    wearable_ids: [377, 280],
  },
  {
    genesis_token_id: 12912,
    wearable_ids: [306, 374],
  },
  {
    genesis_token_id: 12913,
    wearable_ids: [278, 368],
  },
  {
    genesis_token_id: 12914,
    wearable_ids: [254, 434],
  },
  {
    genesis_token_id: 12915,
    wearable_ids: [299, 418],
  },
  {
    genesis_token_id: 12916,
    wearable_ids: [348, 304],
  },
  {
    genesis_token_id: 12917,
    wearable_ids: [442, 280],
  },
  {
    genesis_token_id: 12918,
    wearable_ids: [274, 422],
  },
  {
    genesis_token_id: 12919,
    wearable_ids: [433, 356],
  },
  {
    genesis_token_id: 12920,
    wearable_ids: [295, 405],
  },
  {
    genesis_token_id: 12921,
    wearable_ids: [396, 308],
  },
  {
    genesis_token_id: 12922,
    wearable_ids: [374, 386],
  },
  {
    genesis_token_id: 12923,
    wearable_ids: [431, 350],
  },
  {
    genesis_token_id: 12924,
    wearable_ids: [263, 438],
  },
  {
    genesis_token_id: 12925,
    wearable_ids: [301, 369],
  },
  {
    genesis_token_id: 12926,
    wearable_ids: [352, 415],
  },
  {
    genesis_token_id: 12927,
    wearable_ids: [444, 294],
  },
  {
    genesis_token_id: 12928,
    wearable_ids: [257, 372],
  },
  {
    genesis_token_id: 12929,
    wearable_ids: [304, 397],
  },
  {
    genesis_token_id: 12930,
    wearable_ids: [259, 332],
  },
  {
    genesis_token_id: 12931,
    wearable_ids: [253, 387],
  },
  {
    genesis_token_id: 12932,
    wearable_ids: [271, 431],
  },
  {
    genesis_token_id: 12933,
    wearable_ids: [273, 393],
  },
  {
    genesis_token_id: 12934,
    wearable_ids: [255, 320],
  },
  {
    genesis_token_id: 12935,
    wearable_ids: [315, 257],
  },
  {
    genesis_token_id: 12936,
    wearable_ids: [308, 394],
  },
  {
    genesis_token_id: 12937,
    wearable_ids: [287, 438],
  },
  {
    genesis_token_id: 12938,
    wearable_ids: [326, 411],
  },
  {
    genesis_token_id: 12939,
    wearable_ids: [259, 394],
  },
  {
    genesis_token_id: 12940,
    wearable_ids: [311, 344],
  },
  {
    genesis_token_id: 12941,
    wearable_ids: [335, 429],
  },
  {
    genesis_token_id: 12942,
    wearable_ids: [397, 386],
  },
  {
    genesis_token_id: 12943,
    wearable_ids: [384, 315],
  },
  {
    genesis_token_id: 12944,
    wearable_ids: [406, 270],
  },
  {
    genesis_token_id: 12945,
    wearable_ids: [337, 432],
  },
  {
    genesis_token_id: 12946,
    wearable_ids: [336, 437],
  },
  {
    genesis_token_id: 12947,
    wearable_ids: [368, 438],
  },
  {
    genesis_token_id: 12948,
    wearable_ids: [383, 364],
  },
  {
    genesis_token_id: 12949,
    wearable_ids: [251, 270],
  },
  {
    genesis_token_id: 12950,
    wearable_ids: [286, 406],
  },
  {
    genesis_token_id: 12951,
    wearable_ids: [295, 259],
  },
  {
    genesis_token_id: 12952,
    wearable_ids: [384, 269],
  },
  {
    genesis_token_id: 12953,
    wearable_ids: [426, 431],
  },
  {
    genesis_token_id: 12954,
    wearable_ids: [326, 386],
  },
  {
    genesis_token_id: 12955,
    wearable_ids: [337, 379],
  },
  {
    genesis_token_id: 12956,
    wearable_ids: [315, 273],
  },
  {
    genesis_token_id: 12957,
    wearable_ids: [382, 285],
  },
  {
    genesis_token_id: 12958,
    wearable_ids: [310, 314],
  },
  {
    genesis_token_id: 12959,
    wearable_ids: [406, 404],
  },
  {
    genesis_token_id: 12960,
    wearable_ids: [422, 257],
  },
  {
    genesis_token_id: 12961,
    wearable_ids: [251, 396],
  },
  {
    genesis_token_id: 12962,
    wearable_ids: [319, 338],
  },
  {
    genesis_token_id: 12963,
    wearable_ids: [332, 394],
  },
  {
    genesis_token_id: 12964,
    wearable_ids: [428, 315],
  },
  {
    genesis_token_id: 12965,
    wearable_ids: [253, 354],
  },
  {
    genesis_token_id: 12966,
    wearable_ids: [296, 351],
  },
  {
    genesis_token_id: 12967,
    wearable_ids: [352, 343],
  },
  {
    genesis_token_id: 12968,
    wearable_ids: [423, 375],
  },
  {
    genesis_token_id: 12969,
    wearable_ids: [429, 251],
  },
  {
    genesis_token_id: 12970,
    wearable_ids: [386, 263],
  },
  {
    genesis_token_id: 12971,
    wearable_ids: [270, 349],
  },
  {
    genesis_token_id: 12972,
    wearable_ids: [266, 387],
  },
  {
    genesis_token_id: 12973,
    wearable_ids: [262, 378],
  },
  {
    genesis_token_id: 12974,
    wearable_ids: [350, 393],
  },
  {
    genesis_token_id: 12975,
    wearable_ids: [426, 343],
  },
  {
    genesis_token_id: 12976,
    wearable_ids: [429, 303],
  },
  {
    genesis_token_id: 12977,
    wearable_ids: [280, 314],
  },
  {
    genesis_token_id: 12978,
    wearable_ids: [444, 272],
  },
  {
    genesis_token_id: 12979,
    wearable_ids: [276, 351],
  },
  {
    genesis_token_id: 12980,
    wearable_ids: [386, 293],
  },
  {
    genesis_token_id: 12981,
    wearable_ids: [296, 344],
  },
  {
    genesis_token_id: 12982,
    wearable_ids: [409, 426],
  },
  {
    genesis_token_id: 12983,
    wearable_ids: [251, 443],
  },
  {
    genesis_token_id: 12984,
    wearable_ids: [289, 287],
  },
  {
    genesis_token_id: 12985,
    wearable_ids: [362, 266],
  },
  {
    genesis_token_id: 12986,
    wearable_ids: [344, 286],
  },
  {
    genesis_token_id: 12987,
    wearable_ids: [403, 266],
  },
  {
    genesis_token_id: 12988,
    wearable_ids: [251, 315],
  },
  {
    genesis_token_id: 12989,
    wearable_ids: [410, 305],
  },
  {
    genesis_token_id: 12990,
    wearable_ids: [316, 413],
  },
  {
    genesis_token_id: 12991,
    wearable_ids: [372, 296],
  },
  {
    genesis_token_id: 12992,
    wearable_ids: [344, 264],
  },
  {
    genesis_token_id: 12993,
    wearable_ids: [262, 263],
  },
  {
    genesis_token_id: 12994,
    wearable_ids: [396, 326],
  },
  {
    genesis_token_id: 12995,
    wearable_ids: [409, 299],
  },
  {
    genesis_token_id: 12996,
    wearable_ids: [254, 433],
  },
  {
    genesis_token_id: 12997,
    wearable_ids: [278, 372],
  },
  {
    genesis_token_id: 12998,
    wearable_ids: [425, 247],
  },
  {
    genesis_token_id: 12999,
    wearable_ids: [346, 417],
  },
  {
    genesis_token_id: 13000,
    wearable_ids: [382, 364],
  },
  {
    genesis_token_id: 13001,
    wearable_ids: [408, 251],
  },
  {
    genesis_token_id: 13002,
    wearable_ids: [431, 425],
  },
  {
    genesis_token_id: 13003,
    wearable_ids: [415, 370],
  },
  {
    genesis_token_id: 13004,
    wearable_ids: [304, 296],
  },
  {
    genesis_token_id: 13005,
    wearable_ids: [363, 404],
  },
  {
    genesis_token_id: 13006,
    wearable_ids: [287, 274],
  },
  {
    genesis_token_id: 13007,
    wearable_ids: [425, 314],
  },
  {
    genesis_token_id: 13008,
    wearable_ids: [432, 359],
  },
  {
    genesis_token_id: 13009,
    wearable_ids: [253, 285],
  },
  {
    genesis_token_id: 13010,
    wearable_ids: [262, 263],
  },
  {
    genesis_token_id: 13011,
    wearable_ids: [336, 351],
  },
  {
    genesis_token_id: 13012,
    wearable_ids: [373, 260],
  },
  {
    genesis_token_id: 13013,
    wearable_ids: [253, 419],
  },
  {
    genesis_token_id: 13014,
    wearable_ids: [266, 273],
  },
  {
    genesis_token_id: 13015,
    wearable_ids: [396, 259],
  },
  {
    genesis_token_id: 13016,
    wearable_ids: [289, 268],
  },
  {
    genesis_token_id: 13017,
    wearable_ids: [317, 256],
  },
  {
    genesis_token_id: 13018,
    wearable_ids: [291, 308],
  },
  {
    genesis_token_id: 13019,
    wearable_ids: [411, 308],
  },
  {
    genesis_token_id: 13020,
    wearable_ids: [314, 246],
  },
  {
    genesis_token_id: 13021,
    wearable_ids: [255, 414],
  },
  {
    genesis_token_id: 13022,
    wearable_ids: [423, 300],
  },
  {
    genesis_token_id: 13023,
    wearable_ids: [256, 299],
  },
  {
    genesis_token_id: 13024,
    wearable_ids: [263, 426],
  },
  {
    genesis_token_id: 13025,
    wearable_ids: [266, 342],
  },
  {
    genesis_token_id: 13026,
    wearable_ids: [397, 352],
  },
  {
    genesis_token_id: 13027,
    wearable_ids: [444, 347],
  },
  {
    genesis_token_id: 13028,
    wearable_ids: [266, 314],
  },
  {
    genesis_token_id: 13029,
    wearable_ids: [331, 343],
  },
  {
    genesis_token_id: 13030,
    wearable_ids: [256, 317],
  },
  {
    genesis_token_id: 13031,
    wearable_ids: [385, 413],
  },
  {
    genesis_token_id: 13032,
    wearable_ids: [306, 350],
  },
  {
    genesis_token_id: 13033,
    wearable_ids: [344, 397],
  },
  {
    genesis_token_id: 13034,
    wearable_ids: [412, 342],
  },
  {
    genesis_token_id: 13035,
    wearable_ids: [254, 287],
  },
  {
    genesis_token_id: 13036,
    wearable_ids: [341, 287],
  },
  {
    genesis_token_id: 13037,
    wearable_ids: [336, 324],
  },
  {
    genesis_token_id: 13038,
    wearable_ids: [331, 431],
  },
  {
    genesis_token_id: 13039,
    wearable_ids: [408, 267],
  },
  {
    genesis_token_id: 13040,
    wearable_ids: [257, 274],
  },
  {
    genesis_token_id: 13041,
    wearable_ids: [362, 274],
  },
  {
    genesis_token_id: 13042,
    wearable_ids: [424, 433],
  },
  {
    genesis_token_id: 13043,
    wearable_ids: [347, 295],
  },
  {
    genesis_token_id: 13044,
    wearable_ids: [247, 400],
  },
  {
    genesis_token_id: 13045,
    wearable_ids: [411, 289],
  },
  {
    genesis_token_id: 13046,
    wearable_ids: [308, 439],
  },
  {
    genesis_token_id: 13047,
    wearable_ids: [300, 272],
  },
  {
    genesis_token_id: 13048,
    wearable_ids: [369, 297],
  },
  {
    genesis_token_id: 13049,
    wearable_ids: [259, 354],
  },
  {
    genesis_token_id: 13050,
    wearable_ids: [265, 430],
  },
  {
    genesis_token_id: 13051,
    wearable_ids: [277, 424],
  },
  {
    genesis_token_id: 13052,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 13053,
    wearable_ids: [324, 343],
  },
  {
    genesis_token_id: 13054,
    wearable_ids: [342, 319],
  },
  {
    genesis_token_id: 13055,
    wearable_ids: [375, 395],
  },
  {
    genesis_token_id: 13056,
    wearable_ids: [432, 290],
  },
  {
    genesis_token_id: 13057,
    wearable_ids: [351, 427],
  },
  {
    genesis_token_id: 13058,
    wearable_ids: [389, 336],
  },
  {
    genesis_token_id: 13059,
    wearable_ids: [299, 401],
  },
  {
    genesis_token_id: 13060,
    wearable_ids: [378, 402],
  },
  {
    genesis_token_id: 13061,
    wearable_ids: [347, 436],
  },
  {
    genesis_token_id: 13062,
    wearable_ids: [403, 409],
  },
  {
    genesis_token_id: 13063,
    wearable_ids: [434, 373],
  },
  {
    genesis_token_id: 13064,
    wearable_ids: [354, 445],
  },
  {
    genesis_token_id: 13065,
    wearable_ids: [324, 271],
  },
  {
    genesis_token_id: 13066,
    wearable_ids: [314, 320],
  },
  {
    genesis_token_id: 13067,
    wearable_ids: [372, 403],
  },
  {
    genesis_token_id: 13068,
    wearable_ids: [436, 338],
  },
  {
    genesis_token_id: 13069,
    wearable_ids: [301, 419],
  },
  {
    genesis_token_id: 13070,
    wearable_ids: [351, 308],
  },
  {
    genesis_token_id: 13071,
    wearable_ids: [407, 299],
  },
  {
    genesis_token_id: 13072,
    wearable_ids: [397, 291],
  },
  {
    genesis_token_id: 13073,
    wearable_ids: [347, 299],
  },
  {
    genesis_token_id: 13074,
    wearable_ids: [292, 348],
  },
  {
    genesis_token_id: 13075,
    wearable_ids: [383, 359],
  },
  {
    genesis_token_id: 13076,
    wearable_ids: [371, 255],
  },
  {
    genesis_token_id: 13077,
    wearable_ids: [316, 384],
  },
  {
    genesis_token_id: 13078,
    wearable_ids: [373, 340],
  },
  {
    genesis_token_id: 13079,
    wearable_ids: [300, 303],
  },
  {
    genesis_token_id: 13080,
    wearable_ids: [343, 429],
  },
  {
    genesis_token_id: 13081,
    wearable_ids: [348, 335],
  },
  {
    genesis_token_id: 13082,
    wearable_ids: [308, 433],
  },
  {
    genesis_token_id: 13083,
    wearable_ids: [404, 311],
  },
  {
    genesis_token_id: 13084,
    wearable_ids: [287, 336],
  },
  {
    genesis_token_id: 13085,
    wearable_ids: [268, 287],
  },
  {
    genesis_token_id: 13086,
    wearable_ids: [344, 436],
  },
  {
    genesis_token_id: 13087,
    wearable_ids: [387, 364],
  },
  {
    genesis_token_id: 13088,
    wearable_ids: [297, 346],
  },
  {
    genesis_token_id: 13089,
    wearable_ids: [373, 415],
  },
  {
    genesis_token_id: 13090,
    wearable_ids: [426, 412],
  },
  {
    genesis_token_id: 13091,
    wearable_ids: [331, 408],
  },
  {
    genesis_token_id: 13092,
    wearable_ids: [432, 299],
  },
  {
    genesis_token_id: 13093,
    wearable_ids: [404, 331],
  },
  {
    genesis_token_id: 13094,
    wearable_ids: [338, 246],
  },
  {
    genesis_token_id: 13095,
    wearable_ids: [247, 393],
  },
  {
    genesis_token_id: 13096,
    wearable_ids: [410, 289],
  },
  {
    genesis_token_id: 13097,
    wearable_ids: [346, 358],
  },
  {
    genesis_token_id: 13098,
    wearable_ids: [341, 338],
  },
  {
    genesis_token_id: 13099,
    wearable_ids: [273, 318],
  },
  {
    genesis_token_id: 13100,
    wearable_ids: [277, 399],
  },
  {
    genesis_token_id: 13101,
    wearable_ids: [397, 290],
  },
  {
    genesis_token_id: 13102,
    wearable_ids: [389, 395],
  },
  {
    genesis_token_id: 13103,
    wearable_ids: [429, 349],
  },
  {
    genesis_token_id: 13104,
    wearable_ids: [268, 396],
  },
  {
    genesis_token_id: 13105,
    wearable_ids: [291, 297],
  },
  {
    genesis_token_id: 13106,
    wearable_ids: [364, 272],
  },
  {
    genesis_token_id: 13107,
    wearable_ids: [429, 286],
  },
  {
    genesis_token_id: 13108,
    wearable_ids: [364, 249],
  },
  {
    genesis_token_id: 13109,
    wearable_ids: [291, 342],
  },
  {
    genesis_token_id: 13110,
    wearable_ids: [326, 305],
  },
  {
    genesis_token_id: 13111,
    wearable_ids: [422, 314],
  },
  {
    genesis_token_id: 13112,
    wearable_ids: [343, 363],
  },
  {
    genesis_token_id: 13113,
    wearable_ids: [371, 264],
  },
  {
    genesis_token_id: 13114,
    wearable_ids: [332, 429],
  },
  {
    genesis_token_id: 13115,
    wearable_ids: [412, 259],
  },
  {
    genesis_token_id: 13116,
    wearable_ids: [445, 277],
  },
  {
    genesis_token_id: 13117,
    wearable_ids: [311, 373],
  },
  {
    genesis_token_id: 13118,
    wearable_ids: [443, 319],
  },
  {
    genesis_token_id: 13119,
    wearable_ids: [374, 306],
  },
  {
    genesis_token_id: 13120,
    wearable_ids: [435, 293],
  },
  {
    genesis_token_id: 13121,
    wearable_ids: [299, 370],
  },
  {
    genesis_token_id: 13122,
    wearable_ids: [384, 290],
  },
  {
    genesis_token_id: 13123,
    wearable_ids: [352, 442],
  },
  {
    genesis_token_id: 13124,
    wearable_ids: [374, 354],
  },
  {
    genesis_token_id: 13125,
    wearable_ids: [248, 273],
  },
  {
    genesis_token_id: 13126,
    wearable_ids: [412, 291],
  },
  {
    genesis_token_id: 13127,
    wearable_ids: [253, 263],
  },
  {
    genesis_token_id: 13128,
    wearable_ids: [290, 328],
  },
  {
    genesis_token_id: 13129,
    wearable_ids: [347, 415],
  },
  {
    genesis_token_id: 13130,
    wearable_ids: [292, 358],
  },
  {
    genesis_token_id: 13131,
    wearable_ids: [436, 377],
  },
  {
    genesis_token_id: 13132,
    wearable_ids: [432, 382],
  },
  {
    genesis_token_id: 13133,
    wearable_ids: [251, 296],
  },
  {
    genesis_token_id: 13134,
    wearable_ids: [431, 428],
  },
  {
    genesis_token_id: 13135,
    wearable_ids: [352, 399],
  },
  {
    genesis_token_id: 13136,
    wearable_ids: [295, 400],
  },
  {
    genesis_token_id: 13137,
    wearable_ids: [445, 357],
  },
  {
    genesis_token_id: 13138,
    wearable_ids: [268, 405],
  },
  {
    genesis_token_id: 13139,
    wearable_ids: [292, 400],
  },
  {
    genesis_token_id: 13140,
    wearable_ids: [335, 319],
  },
  {
    genesis_token_id: 13141,
    wearable_ids: [296, 395],
  },
  {
    genesis_token_id: 13142,
    wearable_ids: [268, 297],
  },
  {
    genesis_token_id: 13143,
    wearable_ids: [343, 248],
  },
  {
    genesis_token_id: 13144,
    wearable_ids: [265, 351],
  },
  {
    genesis_token_id: 13145,
    wearable_ids: [395, 344],
  },
  {
    genesis_token_id: 13146,
    wearable_ids: [431, 444],
  },
  {
    genesis_token_id: 13147,
    wearable_ids: [348, 303],
  },
  {
    genesis_token_id: 13148,
    wearable_ids: [301, 277],
  },
  {
    genesis_token_id: 13149,
    wearable_ids: [306, 362],
  },
  {
    genesis_token_id: 13150,
    wearable_ids: [264, 364],
  },
  {
    genesis_token_id: 13151,
    wearable_ids: [412, 293],
  },
  {
    genesis_token_id: 13152,
    wearable_ids: [287, 431],
  },
  {
    genesis_token_id: 13153,
    wearable_ids: [348, 349],
  },
  {
    genesis_token_id: 13154,
    wearable_ids: [271, 422],
  },
  {
    genesis_token_id: 13155,
    wearable_ids: [308, 263],
  },
  {
    genesis_token_id: 13156,
    wearable_ids: [426, 362],
  },
  {
    genesis_token_id: 13157,
    wearable_ids: [407, 443],
  },
  {
    genesis_token_id: 13158,
    wearable_ids: [301, 262],
  },
  {
    genesis_token_id: 13159,
    wearable_ids: [258, 347],
  },
  {
    genesis_token_id: 13160,
    wearable_ids: [314, 362],
  },
  {
    genesis_token_id: 13161,
    wearable_ids: [371, 342],
  },
  {
    genesis_token_id: 13162,
    wearable_ids: [365, 284],
  },
  {
    genesis_token_id: 13163,
    wearable_ids: [413, 368],
  },
  {
    genesis_token_id: 13164,
    wearable_ids: [286, 372],
  },
  {
    genesis_token_id: 13165,
    wearable_ids: [276, 387],
  },
  {
    genesis_token_id: 13166,
    wearable_ids: [374, 420],
  },
  {
    genesis_token_id: 13167,
    wearable_ids: [364, 431],
  },
  {
    genesis_token_id: 13168,
    wearable_ids: [319, 403],
  },
  {
    genesis_token_id: 13169,
    wearable_ids: [445, 373],
  },
  {
    genesis_token_id: 13170,
    wearable_ids: [425, 291],
  },
  {
    genesis_token_id: 13171,
    wearable_ids: [433, 369],
  },
  {
    genesis_token_id: 13172,
    wearable_ids: [444, 420],
  },
  {
    genesis_token_id: 13173,
    wearable_ids: [362, 426],
  },
  {
    genesis_token_id: 13174,
    wearable_ids: [314, 417],
  },
  {
    genesis_token_id: 13175,
    wearable_ids: [385, 250],
  },
  {
    genesis_token_id: 13176,
    wearable_ids: [354, 277],
  },
  {
    genesis_token_id: 13177,
    wearable_ids: [317, 351],
  },
  {
    genesis_token_id: 13178,
    wearable_ids: [340, 308],
  },
  {
    genesis_token_id: 13179,
    wearable_ids: [273, 291],
  },
  {
    genesis_token_id: 13180,
    wearable_ids: [436, 267],
  },
  {
    genesis_token_id: 13181,
    wearable_ids: [371, 383],
  },
  {
    genesis_token_id: 13182,
    wearable_ids: [428, 422],
  },
  {
    genesis_token_id: 13183,
    wearable_ids: [363, 402],
  },
  {
    genesis_token_id: 13184,
    wearable_ids: [284, 272],
  },
  {
    genesis_token_id: 13185,
    wearable_ids: [407, 319],
  },
  {
    genesis_token_id: 13186,
    wearable_ids: [377, 295],
  },
  {
    genesis_token_id: 13187,
    wearable_ids: [296, 274],
  },
  {
    genesis_token_id: 13188,
    wearable_ids: [377, 420],
  },
  {
    genesis_token_id: 13189,
    wearable_ids: [335, 354],
  },
  {
    genesis_token_id: 13190,
    wearable_ids: [426, 409],
  },
  {
    genesis_token_id: 13191,
    wearable_ids: [256, 385],
  },
  {
    genesis_token_id: 13192,
    wearable_ids: [306, 290],
  },
  {
    genesis_token_id: 13193,
    wearable_ids: [434, 249],
  },
  {
    genesis_token_id: 13194,
    wearable_ids: [263, 286],
  },
  {
    genesis_token_id: 13195,
    wearable_ids: [424, 364],
  },
  {
    genesis_token_id: 13196,
    wearable_ids: [382, 270],
  },
  {
    genesis_token_id: 13197,
    wearable_ids: [387, 368],
  },
  {
    genesis_token_id: 13198,
    wearable_ids: [420, 300],
  },
  {
    genesis_token_id: 13199,
    wearable_ids: [248, 326],
  },
  {
    genesis_token_id: 13200,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 13201,
    wearable_ids: [301, 395],
  },
  {
    genesis_token_id: 13202,
    wearable_ids: [389, 369],
  },
  {
    genesis_token_id: 13203,
    wearable_ids: [371, 411],
  },
  {
    genesis_token_id: 13204,
    wearable_ids: [336, 258],
  },
  {
    genesis_token_id: 13205,
    wearable_ids: [253, 393],
  },
  {
    genesis_token_id: 13206,
    wearable_ids: [326, 270],
  },
  {
    genesis_token_id: 13207,
    wearable_ids: [341, 264],
  },
  {
    genesis_token_id: 13208,
    wearable_ids: [378, 406],
  },
  {
    genesis_token_id: 13209,
    wearable_ids: [434, 294],
  },
  {
    genesis_token_id: 13210,
    wearable_ids: [342, 311],
  },
  {
    genesis_token_id: 13211,
    wearable_ids: [420, 299],
  },
  {
    genesis_token_id: 13212,
    wearable_ids: [262, 271],
  },
  {
    genesis_token_id: 13213,
    wearable_ids: [311, 310],
  },
  {
    genesis_token_id: 13214,
    wearable_ids: [290, 431],
  },
  {
    genesis_token_id: 13215,
    wearable_ids: [428, 417],
  },
  {
    genesis_token_id: 13216,
    wearable_ids: [445, 292],
  },
  {
    genesis_token_id: 13217,
    wearable_ids: [301, 247],
  },
  {
    genesis_token_id: 13218,
    wearable_ids: [408, 341],
  },
  {
    genesis_token_id: 13219,
    wearable_ids: [404, 360],
  },
  {
    genesis_token_id: 13220,
    wearable_ids: [311, 291],
  },
  {
    genesis_token_id: 13221,
    wearable_ids: [265, 258],
  },
  {
    genesis_token_id: 13222,
    wearable_ids: [403, 343],
  },
  {
    genesis_token_id: 13223,
    wearable_ids: [387, 250],
  },
  {
    genesis_token_id: 13224,
    wearable_ids: [386, 423],
  },
  {
    genesis_token_id: 13225,
    wearable_ids: [346, 270],
  },
  {
    genesis_token_id: 13226,
    wearable_ids: [268, 272],
  },
  {
    genesis_token_id: 13227,
    wearable_ids: [300, 270],
  },
  {
    genesis_token_id: 13228,
    wearable_ids: [364, 271],
  },
  {
    genesis_token_id: 13229,
    wearable_ids: [338, 278],
  },
  {
    genesis_token_id: 13230,
    wearable_ids: [304, 442],
  },
  {
    genesis_token_id: 13231,
    wearable_ids: [262, 331],
  },
  {
    genesis_token_id: 13232,
    wearable_ids: [346, 386],
  },
  {
    genesis_token_id: 13233,
    wearable_ids: [442, 360],
  },
  {
    genesis_token_id: 13234,
    wearable_ids: [355, 246],
  },
  {
    genesis_token_id: 13235,
    wearable_ids: [395, 300],
  },
  {
    genesis_token_id: 13236,
    wearable_ids: [444, 408],
  },
  {
    genesis_token_id: 13237,
    wearable_ids: [349, 346],
  },
  {
    genesis_token_id: 13238,
    wearable_ids: [270, 420],
  },
  {
    genesis_token_id: 13239,
    wearable_ids: [332, 428],
  },
  {
    genesis_token_id: 13240,
    wearable_ids: [362, 437],
  },
  {
    genesis_token_id: 13241,
    wearable_ids: [407, 374],
  },
  {
    genesis_token_id: 13242,
    wearable_ids: [286, 284],
  },
  {
    genesis_token_id: 13243,
    wearable_ids: [280, 432],
  },
  {
    genesis_token_id: 13244,
    wearable_ids: [382, 433],
  },
  {
    genesis_token_id: 13245,
    wearable_ids: [276, 410],
  },
  {
    genesis_token_id: 13246,
    wearable_ids: [373, 374],
  },
  {
    genesis_token_id: 13247,
    wearable_ids: [336, 444],
  },
  {
    genesis_token_id: 13248,
    wearable_ids: [284, 406],
  },
  {
    genesis_token_id: 13249,
    wearable_ids: [428, 412],
  },
  {
    genesis_token_id: 13250,
    wearable_ids: [340, 445],
  },
  {
    genesis_token_id: 13251,
    wearable_ids: [444, 284],
  },
  {
    genesis_token_id: 13252,
    wearable_ids: [301, 427],
  },
  {
    genesis_token_id: 13253,
    wearable_ids: [310, 425],
  },
  {
    genesis_token_id: 13254,
    wearable_ids: [263, 413],
  },
  {
    genesis_token_id: 13255,
    wearable_ids: [332, 285],
  },
  {
    genesis_token_id: 13256,
    wearable_ids: [306, 248],
  },
  {
    genesis_token_id: 13257,
    wearable_ids: [429, 434],
  },
  {
    genesis_token_id: 13258,
    wearable_ids: [299, 306],
  },
  {
    genesis_token_id: 13259,
    wearable_ids: [432, 343],
  },
  {
    genesis_token_id: 13260,
    wearable_ids: [444, 424],
  },
  {
    genesis_token_id: 13261,
    wearable_ids: [407, 400],
  },
  {
    genesis_token_id: 13262,
    wearable_ids: [428, 349],
  },
  {
    genesis_token_id: 13263,
    wearable_ids: [445, 408],
  },
  {
    genesis_token_id: 13264,
    wearable_ids: [355, 400],
  },
  {
    genesis_token_id: 13265,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 13266,
    wearable_ids: [247, 272],
  },
  {
    genesis_token_id: 13267,
    wearable_ids: [375, 335],
  },
  {
    genesis_token_id: 13268,
    wearable_ids: [277, 436],
  },
  {
    genesis_token_id: 13269,
    wearable_ids: [310, 397],
  },
  {
    genesis_token_id: 13270,
    wearable_ids: [271, 352],
  },
  {
    genesis_token_id: 13271,
    wearable_ids: [362, 350],
  },
  {
    genesis_token_id: 13272,
    wearable_ids: [400, 387],
  },
  {
    genesis_token_id: 13273,
    wearable_ids: [369, 330],
  },
  {
    genesis_token_id: 13274,
    wearable_ids: [270, 420],
  },
  {
    genesis_token_id: 13275,
    wearable_ids: [265, 398],
  },
  {
    genesis_token_id: 13276,
    wearable_ids: [351, 364],
  },
  {
    genesis_token_id: 13277,
    wearable_ids: [248, 416],
  },
  {
    genesis_token_id: 13278,
    wearable_ids: [348, 431],
  },
  {
    genesis_token_id: 13279,
    wearable_ids: [377, 290],
  },
  {
    genesis_token_id: 13280,
    wearable_ids: [442, 407],
  },
  {
    genesis_token_id: 13281,
    wearable_ids: [373, 396],
  },
  {
    genesis_token_id: 13282,
    wearable_ids: [372, 311],
  },
  {
    genesis_token_id: 13283,
    wearable_ids: [257, 377],
  },
  {
    genesis_token_id: 13284,
    wearable_ids: [315, 387],
  },
  {
    genesis_token_id: 13285,
    wearable_ids: [350, 418],
  },
  {
    genesis_token_id: 13286,
    wearable_ids: [385, 354],
  },
  {
    genesis_token_id: 13287,
    wearable_ids: [363, 409],
  },
  {
    genesis_token_id: 13288,
    wearable_ids: [376, 363],
  },
  {
    genesis_token_id: 13289,
    wearable_ids: [383, 314],
  },
  {
    genesis_token_id: 13290,
    wearable_ids: [426, 363],
  },
  {
    genesis_token_id: 13291,
    wearable_ids: [349, 310],
  },
  {
    genesis_token_id: 13292,
    wearable_ids: [278, 287],
  },
  {
    genesis_token_id: 13293,
    wearable_ids: [415, 289],
  },
  {
    genesis_token_id: 13294,
    wearable_ids: [325, 342],
  },
  {
    genesis_token_id: 13295,
    wearable_ids: [257, 405],
  },
  {
    genesis_token_id: 13296,
    wearable_ids: [413, 388],
  },
  {
    genesis_token_id: 13297,
    wearable_ids: [425, 344],
  },
  {
    genesis_token_id: 13298,
    wearable_ids: [264, 324],
  },
  {
    genesis_token_id: 13299,
    wearable_ids: [399, 299],
  },
  {
    genesis_token_id: 13300,
    wearable_ids: [306, 366],
  },
  {
    genesis_token_id: 13301,
    wearable_ids: [368, 349],
  },
  {
    genesis_token_id: 13302,
    wearable_ids: [399, 310],
  },
  {
    genesis_token_id: 13303,
    wearable_ids: [409, 255],
  },
  {
    genesis_token_id: 13304,
    wearable_ids: [316, 256],
  },
  {
    genesis_token_id: 13305,
    wearable_ids: [316, 330],
  },
  {
    genesis_token_id: 13306,
    wearable_ids: [280, 247],
  },
  {
    genesis_token_id: 13307,
    wearable_ids: [343, 262],
  },
  {
    genesis_token_id: 13308,
    wearable_ids: [351, 407],
  },
  {
    genesis_token_id: 13309,
    wearable_ids: [382, 300],
  },
  {
    genesis_token_id: 13310,
    wearable_ids: [400, 425],
  },
  {
    genesis_token_id: 13311,
    wearable_ids: [368, 431],
  },
  {
    genesis_token_id: 13312,
    wearable_ids: [362, 406],
  },
  {
    genesis_token_id: 13313,
    wearable_ids: [407, 277],
  },
  {
    genesis_token_id: 13314,
    wearable_ids: [301, 292],
  },
  {
    genesis_token_id: 13315,
    wearable_ids: [385, 265],
  },
  {
    genesis_token_id: 13316,
    wearable_ids: [407, 293],
  },
  {
    genesis_token_id: 13317,
    wearable_ids: [403, 404],
  },
  {
    genesis_token_id: 13318,
    wearable_ids: [383, 413],
  },
  {
    genesis_token_id: 13319,
    wearable_ids: [346, 296],
  },
  {
    genesis_token_id: 13320,
    wearable_ids: [349, 403],
  },
  {
    genesis_token_id: 13321,
    wearable_ids: [310, 373],
  },
  {
    genesis_token_id: 13322,
    wearable_ids: [429, 366],
  },
  {
    genesis_token_id: 13323,
    wearable_ids: [341, 435],
  },
  {
    genesis_token_id: 13324,
    wearable_ids: [317, 417],
  },
  {
    genesis_token_id: 13325,
    wearable_ids: [284, 249],
  },
  {
    genesis_token_id: 13326,
    wearable_ids: [385, 339],
  },
  {
    genesis_token_id: 13327,
    wearable_ids: [331, 259],
  },
  {
    genesis_token_id: 13328,
    wearable_ids: [344, 294],
  },
  {
    genesis_token_id: 13329,
    wearable_ids: [274, 280],
  },
  {
    genesis_token_id: 13330,
    wearable_ids: [331, 278],
  },
  {
    genesis_token_id: 13331,
    wearable_ids: [346, 263],
  },
  {
    genesis_token_id: 13332,
    wearable_ids: [273, 433],
  },
  {
    genesis_token_id: 13333,
    wearable_ids: [340, 338],
  },
  {
    genesis_token_id: 13334,
    wearable_ids: [399, 403],
  },
  {
    genesis_token_id: 13335,
    wearable_ids: [422, 267],
  },
  {
    genesis_token_id: 13336,
    wearable_ids: [372, 379],
  },
  {
    genesis_token_id: 13337,
    wearable_ids: [339, 308],
  },
  {
    genesis_token_id: 13338,
    wearable_ids: [370, 268],
  },
  {
    genesis_token_id: 13339,
    wearable_ids: [289, 270],
  },
  {
    genesis_token_id: 13340,
    wearable_ids: [408, 420],
  },
  {
    genesis_token_id: 13341,
    wearable_ids: [426, 257],
  },
  {
    genesis_token_id: 13342,
    wearable_ids: [432, 268],
  },
  {
    genesis_token_id: 13343,
    wearable_ids: [426, 407],
  },
  {
    genesis_token_id: 13344,
    wearable_ids: [256, 372],
  },
  {
    genesis_token_id: 13345,
    wearable_ids: [337, 373],
  },
  {
    genesis_token_id: 13346,
    wearable_ids: [248, 341],
  },
  {
    genesis_token_id: 13347,
    wearable_ids: [382, 395],
  },
  {
    genesis_token_id: 13348,
    wearable_ids: [377, 342],
  },
  {
    genesis_token_id: 13349,
    wearable_ids: [435, 408],
  },
  {
    genesis_token_id: 13350,
    wearable_ids: [375, 253],
  },
  {
    genesis_token_id: 13351,
    wearable_ids: [263, 279],
  },
  {
    genesis_token_id: 13352,
    wearable_ids: [326, 296],
  },
  {
    genesis_token_id: 13353,
    wearable_ids: [370, 292],
  },
  {
    genesis_token_id: 13354,
    wearable_ids: [290, 349],
  },
  {
    genesis_token_id: 13355,
    wearable_ids: [291, 431],
  },
  {
    genesis_token_id: 13356,
    wearable_ids: [332, 336],
  },
  {
    genesis_token_id: 13357,
    wearable_ids: [304, 363],
  },
  {
    genesis_token_id: 13358,
    wearable_ids: [339, 347],
  },
  {
    genesis_token_id: 13359,
    wearable_ids: [354, 376],
  },
  {
    genesis_token_id: 13360,
    wearable_ids: [332, 328],
  },
  {
    genesis_token_id: 13361,
    wearable_ids: [436, 404],
  },
  {
    genesis_token_id: 13362,
    wearable_ids: [445, 358],
  },
  {
    genesis_token_id: 13363,
    wearable_ids: [387, 287],
  },
  {
    genesis_token_id: 13364,
    wearable_ids: [444, 265],
  },
  {
    genesis_token_id: 13365,
    wearable_ids: [315, 326],
  },
  {
    genesis_token_id: 13366,
    wearable_ids: [436, 254],
  },
  {
    genesis_token_id: 13367,
    wearable_ids: [435, 349],
  },
  {
    genesis_token_id: 13368,
    wearable_ids: [363, 336],
  },
  {
    genesis_token_id: 13369,
    wearable_ids: [263, 377],
  },
  {
    genesis_token_id: 13370,
    wearable_ids: [294, 283],
  },
  {
    genesis_token_id: 13371,
    wearable_ids: [308, 304],
  },
  {
    genesis_token_id: 13372,
    wearable_ids: [266, 265],
  },
  {
    genesis_token_id: 13373,
    wearable_ids: [407, 298],
  },
  {
    genesis_token_id: 13374,
    wearable_ids: [346, 370],
  },
  {
    genesis_token_id: 13375,
    wearable_ids: [291, 270],
  },
  {
    genesis_token_id: 13376,
    wearable_ids: [395, 266],
  },
  {
    genesis_token_id: 13377,
    wearable_ids: [264, 344],
  },
  {
    genesis_token_id: 13378,
    wearable_ids: [434, 369],
  },
  {
    genesis_token_id: 13379,
    wearable_ids: [376, 441],
  },
  {
    genesis_token_id: 13380,
    wearable_ids: [268, 343],
  },
  {
    genesis_token_id: 13381,
    wearable_ids: [303, 301],
  },
  {
    genesis_token_id: 13382,
    wearable_ids: [277, 294],
  },
  {
    genesis_token_id: 13383,
    wearable_ids: [304, 437],
  },
  {
    genesis_token_id: 13384,
    wearable_ids: [410, 292],
  },
  {
    genesis_token_id: 13385,
    wearable_ids: [287, 350],
  },
  {
    genesis_token_id: 13386,
    wearable_ids: [299, 260],
  },
  {
    genesis_token_id: 13387,
    wearable_ids: [412, 420],
  },
  {
    genesis_token_id: 13388,
    wearable_ids: [415, 396],
  },
  {
    genesis_token_id: 13389,
    wearable_ids: [342, 314],
  },
  {
    genesis_token_id: 13390,
    wearable_ids: [304, 249],
  },
  {
    genesis_token_id: 13391,
    wearable_ids: [270, 377],
  },
  {
    genesis_token_id: 13392,
    wearable_ids: [287, 334],
  },
  {
    genesis_token_id: 13393,
    wearable_ids: [385, 272],
  },
  {
    genesis_token_id: 13394,
    wearable_ids: [415, 353],
  },
  {
    genesis_token_id: 13395,
    wearable_ids: [412, 340],
  },
  {
    genesis_token_id: 13396,
    wearable_ids: [445, 412],
  },
  {
    genesis_token_id: 13397,
    wearable_ids: [389, 413],
  },
  {
    genesis_token_id: 13398,
    wearable_ids: [276, 300],
  },
  {
    genesis_token_id: 13399,
    wearable_ids: [443, 437],
  },
  {
    genesis_token_id: 13400,
    wearable_ids: [415, 341],
  },
  {
    genesis_token_id: 13401,
    wearable_ids: [404, 428],
  },
  {
    genesis_token_id: 13402,
    wearable_ids: [264, 399],
  },
  {
    genesis_token_id: 13403,
    wearable_ids: [355, 274],
  },
  {
    genesis_token_id: 13404,
    wearable_ids: [368, 412],
  },
  {
    genesis_token_id: 13405,
    wearable_ids: [395, 253],
  },
  {
    genesis_token_id: 13406,
    wearable_ids: [351, 273],
  },
  {
    genesis_token_id: 13407,
    wearable_ids: [428, 256],
  },
  {
    genesis_token_id: 13408,
    wearable_ids: [387, 291],
  },
  {
    genesis_token_id: 13409,
    wearable_ids: [259, 382],
  },
  {
    genesis_token_id: 13410,
    wearable_ids: [255, 379],
  },
  {
    genesis_token_id: 13411,
    wearable_ids: [374, 409],
  },
  {
    genesis_token_id: 13412,
    wearable_ids: [274, 316],
  },
  {
    genesis_token_id: 13413,
    wearable_ids: [270, 399],
  },
  {
    genesis_token_id: 13414,
    wearable_ids: [332, 354],
  },
  {
    genesis_token_id: 13415,
    wearable_ids: [311, 431],
  },
  {
    genesis_token_id: 13416,
    wearable_ids: [434, 347],
  },
  {
    genesis_token_id: 13417,
    wearable_ids: [348, 352],
  },
  {
    genesis_token_id: 13418,
    wearable_ids: [372, 311],
  },
  {
    genesis_token_id: 13419,
    wearable_ids: [299, 319],
  },
  {
    genesis_token_id: 13420,
    wearable_ids: [262, 303],
  },
  {
    genesis_token_id: 13421,
    wearable_ids: [410, 317],
  },
  {
    genesis_token_id: 13422,
    wearable_ids: [429, 348],
  },
  {
    genesis_token_id: 13423,
    wearable_ids: [289, 363],
  },
  {
    genesis_token_id: 13424,
    wearable_ids: [308, 401],
  },
  {
    genesis_token_id: 13425,
    wearable_ids: [332, 444],
  },
  {
    genesis_token_id: 13426,
    wearable_ids: [431, 337],
  },
  {
    genesis_token_id: 13427,
    wearable_ids: [423, 347],
  },
  {
    genesis_token_id: 13428,
    wearable_ids: [315, 259],
  },
  {
    genesis_token_id: 13429,
    wearable_ids: [434, 264],
  },
  {
    genesis_token_id: 13430,
    wearable_ids: [404, 310],
  },
  {
    genesis_token_id: 13431,
    wearable_ids: [270, 374],
  },
  {
    genesis_token_id: 13432,
    wearable_ids: [278, 445],
  },
  {
    genesis_token_id: 13433,
    wearable_ids: [370, 323],
  },
  {
    genesis_token_id: 13434,
    wearable_ids: [432, 387],
  },
  {
    genesis_token_id: 13435,
    wearable_ids: [280, 363],
  },
  {
    genesis_token_id: 13436,
    wearable_ids: [378, 270],
  },
  {
    genesis_token_id: 13437,
    wearable_ids: [352, 373],
  },
  {
    genesis_token_id: 13438,
    wearable_ids: [369, 440],
  },
  {
    genesis_token_id: 13439,
    wearable_ids: [384, 259],
  },
  {
    genesis_token_id: 13440,
    wearable_ids: [373, 248],
  },
  {
    genesis_token_id: 13441,
    wearable_ids: [347, 355],
  },
  {
    genesis_token_id: 13442,
    wearable_ids: [344, 438],
  },
  {
    genesis_token_id: 13443,
    wearable_ids: [278, 287],
  },
  {
    genesis_token_id: 13444,
    wearable_ids: [278, 375],
  },
  {
    genesis_token_id: 13445,
    wearable_ids: [297, 405],
  },
  {
    genesis_token_id: 13446,
    wearable_ids: [348, 436],
  },
  {
    genesis_token_id: 13447,
    wearable_ids: [301, 271],
  },
  {
    genesis_token_id: 13448,
    wearable_ids: [338, 442],
  },
  {
    genesis_token_id: 13449,
    wearable_ids: [251, 443],
  },
  {
    genesis_token_id: 13450,
    wearable_ids: [435, 251],
  },
  {
    genesis_token_id: 13451,
    wearable_ids: [314, 268],
  },
  {
    genesis_token_id: 13452,
    wearable_ids: [385, 339],
  },
  {
    genesis_token_id: 13453,
    wearable_ids: [331, 262],
  },
  {
    genesis_token_id: 13454,
    wearable_ids: [276, 383],
  },
  {
    genesis_token_id: 13455,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 13456,
    wearable_ids: [347, 373],
  },
  {
    genesis_token_id: 13457,
    wearable_ids: [403, 267],
  },
  {
    genesis_token_id: 13458,
    wearable_ids: [304, 339],
  },
  {
    genesis_token_id: 13459,
    wearable_ids: [351, 328],
  },
  {
    genesis_token_id: 13460,
    wearable_ids: [354, 284],
  },
  {
    genesis_token_id: 13461,
    wearable_ids: [248, 295],
  },
  {
    genesis_token_id: 13462,
    wearable_ids: [397, 339],
  },
  {
    genesis_token_id: 13463,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 13464,
    wearable_ids: [363, 262],
  },
  {
    genesis_token_id: 13465,
    wearable_ids: [253, 387],
  },
  {
    genesis_token_id: 13466,
    wearable_ids: [443, 432],
  },
  {
    genesis_token_id: 13467,
    wearable_ids: [336, 395],
  },
  {
    genesis_token_id: 13468,
    wearable_ids: [289, 373],
  },
  {
    genesis_token_id: 13469,
    wearable_ids: [304, 385],
  },
  {
    genesis_token_id: 13470,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 13471,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 13472,
    wearable_ids: [291, 273],
  },
  {
    genesis_token_id: 13473,
    wearable_ids: [413, 297],
  },
  {
    genesis_token_id: 13474,
    wearable_ids: [389, 266],
  },
  {
    genesis_token_id: 13475,
    wearable_ids: [383, 354],
  },
  {
    genesis_token_id: 13476,
    wearable_ids: [341, 375],
  },
  {
    genesis_token_id: 13477,
    wearable_ids: [412, 348],
  },
  {
    genesis_token_id: 13478,
    wearable_ids: [372, 263],
  },
  {
    genesis_token_id: 13479,
    wearable_ids: [432, 306],
  },
  {
    genesis_token_id: 13480,
    wearable_ids: [311, 280],
  },
  {
    genesis_token_id: 13481,
    wearable_ids: [378, 268],
  },
  {
    genesis_token_id: 13482,
    wearable_ids: [290, 423],
  },
  {
    genesis_token_id: 13483,
    wearable_ids: [304, 375],
  },
  {
    genesis_token_id: 13484,
    wearable_ids: [389, 354],
  },
  {
    genesis_token_id: 13485,
    wearable_ids: [408, 323],
  },
  {
    genesis_token_id: 13486,
    wearable_ids: [256, 337],
  },
  {
    genesis_token_id: 13487,
    wearable_ids: [290, 310],
  },
  {
    genesis_token_id: 13488,
    wearable_ids: [399, 389],
  },
  {
    genesis_token_id: 13489,
    wearable_ids: [254, 303],
  },
  {
    genesis_token_id: 13490,
    wearable_ids: [248, 431],
  },
  {
    genesis_token_id: 13491,
    wearable_ids: [406, 359],
  },
  {
    genesis_token_id: 13492,
    wearable_ids: [429, 409],
  },
  {
    genesis_token_id: 13493,
    wearable_ids: [354, 349],
  },
  {
    genesis_token_id: 13494,
    wearable_ids: [355, 341],
  },
  {
    genesis_token_id: 13495,
    wearable_ids: [255, 279],
  },
  {
    genesis_token_id: 13496,
    wearable_ids: [299, 333],
  },
  {
    genesis_token_id: 13497,
    wearable_ids: [396, 338],
  },
  {
    genesis_token_id: 13498,
    wearable_ids: [375, 277],
  },
  {
    genesis_token_id: 13499,
    wearable_ids: [295, 314],
  },
  {
    genesis_token_id: 13500,
    wearable_ids: [292, 404],
  },
  {
    genesis_token_id: 13501,
    wearable_ids: [301, 286],
  },
  {
    genesis_token_id: 13502,
    wearable_ids: [263, 289],
  },
  {
    genesis_token_id: 13503,
    wearable_ids: [397, 273],
  },
  {
    genesis_token_id: 13504,
    wearable_ids: [248, 349],
  },
  {
    genesis_token_id: 13505,
    wearable_ids: [387, 340],
  },
  {
    genesis_token_id: 13506,
    wearable_ids: [369, 432],
  },
  {
    genesis_token_id: 13507,
    wearable_ids: [257, 264],
  },
  {
    genesis_token_id: 13508,
    wearable_ids: [397, 383],
  },
  {
    genesis_token_id: 13509,
    wearable_ids: [382, 338],
  },
  {
    genesis_token_id: 13510,
    wearable_ids: [377, 327],
  },
  {
    genesis_token_id: 13511,
    wearable_ids: [255, 325],
  },
  {
    genesis_token_id: 13512,
    wearable_ids: [341, 310],
  },
  {
    genesis_token_id: 13513,
    wearable_ids: [364, 262],
  },
  {
    genesis_token_id: 13514,
    wearable_ids: [374, 297],
  },
  {
    genesis_token_id: 13515,
    wearable_ids: [247, 305],
  },
  {
    genesis_token_id: 13516,
    wearable_ids: [317, 271],
  },
  {
    genesis_token_id: 13517,
    wearable_ids: [344, 407],
  },
  {
    genesis_token_id: 13518,
    wearable_ids: [409, 376],
  },
  {
    genesis_token_id: 13519,
    wearable_ids: [290, 432],
  },
  {
    genesis_token_id: 13520,
    wearable_ids: [274, 428],
  },
  {
    genesis_token_id: 13521,
    wearable_ids: [350, 417],
  },
  {
    genesis_token_id: 13522,
    wearable_ids: [397, 411],
  },
  {
    genesis_token_id: 13523,
    wearable_ids: [444, 391],
  },
  {
    genesis_token_id: 13524,
    wearable_ids: [344, 341],
  },
  {
    genesis_token_id: 13525,
    wearable_ids: [265, 442],
  },
  {
    genesis_token_id: 13526,
    wearable_ids: [317, 400],
  },
  {
    genesis_token_id: 13527,
    wearable_ids: [413, 396],
  },
  {
    genesis_token_id: 13528,
    wearable_ids: [365, 305],
  },
  {
    genesis_token_id: 13529,
    wearable_ids: [273, 254],
  },
  {
    genesis_token_id: 13530,
    wearable_ids: [399, 306],
  },
  {
    genesis_token_id: 13531,
    wearable_ids: [431, 376],
  },
  {
    genesis_token_id: 13532,
    wearable_ids: [426, 369],
  },
  {
    genesis_token_id: 13533,
    wearable_ids: [277, 398],
  },
  {
    genesis_token_id: 13534,
    wearable_ids: [434, 319],
  },
  {
    genesis_token_id: 13535,
    wearable_ids: [384, 370],
  },
  {
    genesis_token_id: 13536,
    wearable_ids: [400, 337],
  },
  {
    genesis_token_id: 13537,
    wearable_ids: [389, 379],
  },
  {
    genesis_token_id: 13538,
    wearable_ids: [287, 403],
  },
  {
    genesis_token_id: 13539,
    wearable_ids: [399, 340],
  },
  {
    genesis_token_id: 13540,
    wearable_ids: [262, 415],
  },
  {
    genesis_token_id: 13541,
    wearable_ids: [362, 443],
  },
  {
    genesis_token_id: 13542,
    wearable_ids: [347, 432],
  },
  {
    genesis_token_id: 13543,
    wearable_ids: [350, 402],
  },
  {
    genesis_token_id: 13544,
    wearable_ids: [410, 257],
  },
  {
    genesis_token_id: 13545,
    wearable_ids: [424, 258],
  },
  {
    genesis_token_id: 13546,
    wearable_ids: [332, 397],
  },
  {
    genesis_token_id: 13547,
    wearable_ids: [426, 337],
  },
  {
    genesis_token_id: 13548,
    wearable_ids: [256, 354],
  },
  {
    genesis_token_id: 13549,
    wearable_ids: [443, 304],
  },
  {
    genesis_token_id: 13550,
    wearable_ids: [385, 290],
  },
  {
    genesis_token_id: 13551,
    wearable_ids: [445, 324],
  },
  {
    genesis_token_id: 13552,
    wearable_ids: [406, 385],
  },
  {
    genesis_token_id: 13553,
    wearable_ids: [301, 440],
  },
  {
    genesis_token_id: 13554,
    wearable_ids: [292, 427],
  },
  {
    genesis_token_id: 13555,
    wearable_ids: [368, 426],
  },
  {
    genesis_token_id: 13556,
    wearable_ids: [413, 375],
  },
  {
    genesis_token_id: 13557,
    wearable_ids: [342, 330],
  },
  {
    genesis_token_id: 13558,
    wearable_ids: [299, 383],
  },
  {
    genesis_token_id: 13559,
    wearable_ids: [299, 325],
  },
  {
    genesis_token_id: 13560,
    wearable_ids: [311, 253],
  },
  {
    genesis_token_id: 13561,
    wearable_ids: [319, 258],
  },
  {
    genesis_token_id: 13562,
    wearable_ids: [299, 363],
  },
  {
    genesis_token_id: 13563,
    wearable_ids: [378, 412],
  },
  {
    genesis_token_id: 13564,
    wearable_ids: [276, 432],
  },
  {
    genesis_token_id: 13565,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 13566,
    wearable_ids: [326, 350],
  },
  {
    genesis_token_id: 13567,
    wearable_ids: [296, 441],
  },
  {
    genesis_token_id: 13568,
    wearable_ids: [387, 299],
  },
  {
    genesis_token_id: 13569,
    wearable_ids: [424, 324],
  },
  {
    genesis_token_id: 13570,
    wearable_ids: [284, 432],
  },
  {
    genesis_token_id: 13571,
    wearable_ids: [306, 348],
  },
  {
    genesis_token_id: 13572,
    wearable_ids: [383, 424],
  },
  {
    genesis_token_id: 13573,
    wearable_ids: [410, 304],
  },
  {
    genesis_token_id: 13574,
    wearable_ids: [325, 337],
  },
  {
    genesis_token_id: 13575,
    wearable_ids: [395, 376],
  },
  {
    genesis_token_id: 13576,
    wearable_ids: [411, 331],
  },
  {
    genesis_token_id: 13577,
    wearable_ids: [296, 273],
  },
  {
    genesis_token_id: 13578,
    wearable_ids: [256, 323],
  },
  {
    genesis_token_id: 13579,
    wearable_ids: [350, 314],
  },
  {
    genesis_token_id: 13580,
    wearable_ids: [292, 423],
  },
  {
    genesis_token_id: 13581,
    wearable_ids: [410, 368],
  },
  {
    genesis_token_id: 13582,
    wearable_ids: [412, 298],
  },
  {
    genesis_token_id: 13583,
    wearable_ids: [428, 343],
  },
  {
    genesis_token_id: 13584,
    wearable_ids: [262, 325],
  },
  {
    genesis_token_id: 13585,
    wearable_ids: [377, 343],
  },
  {
    genesis_token_id: 13586,
    wearable_ids: [407, 344],
  },
  {
    genesis_token_id: 13587,
    wearable_ids: [420, 276],
  },
  {
    genesis_token_id: 13588,
    wearable_ids: [436, 416],
  },
  {
    genesis_token_id: 13589,
    wearable_ids: [426, 365],
  },
  {
    genesis_token_id: 13590,
    wearable_ids: [265, 299],
  },
  {
    genesis_token_id: 13591,
    wearable_ids: [276, 377],
  },
  {
    genesis_token_id: 13592,
    wearable_ids: [412, 339],
  },
  {
    genesis_token_id: 13593,
    wearable_ids: [270, 249],
  },
  {
    genesis_token_id: 13594,
    wearable_ids: [273, 340],
  },
  {
    genesis_token_id: 13595,
    wearable_ids: [365, 423],
  },
  {
    genesis_token_id: 13596,
    wearable_ids: [343, 374],
  },
  {
    genesis_token_id: 13597,
    wearable_ids: [332, 350],
  },
  {
    genesis_token_id: 13598,
    wearable_ids: [386, 281],
  },
  {
    genesis_token_id: 13599,
    wearable_ids: [335, 385],
  },
  {
    genesis_token_id: 13600,
    wearable_ids: [396, 304],
  },
  {
    genesis_token_id: 13601,
    wearable_ids: [411, 408],
  },
  {
    genesis_token_id: 13602,
    wearable_ids: [343, 348],
  },
  {
    genesis_token_id: 13603,
    wearable_ids: [409, 301],
  },
  {
    genesis_token_id: 13604,
    wearable_ids: [362, 319],
  },
  {
    genesis_token_id: 13605,
    wearable_ids: [411, 428],
  },
  {
    genesis_token_id: 13606,
    wearable_ids: [276, 320],
  },
  {
    genesis_token_id: 13607,
    wearable_ids: [348, 301],
  },
  {
    genesis_token_id: 13608,
    wearable_ids: [268, 275],
  },
  {
    genesis_token_id: 13609,
    wearable_ids: [355, 272],
  },
  {
    genesis_token_id: 13610,
    wearable_ids: [412, 308],
  },
  {
    genesis_token_id: 13611,
    wearable_ids: [295, 301],
  },
  {
    genesis_token_id: 13612,
    wearable_ids: [292, 400],
  },
  {
    genesis_token_id: 13613,
    wearable_ids: [369, 378],
  },
  {
    genesis_token_id: 13614,
    wearable_ids: [264, 351],
  },
  {
    genesis_token_id: 13615,
    wearable_ids: [326, 304],
  },
  {
    genesis_token_id: 13616,
    wearable_ids: [442, 256],
  },
  {
    genesis_token_id: 13617,
    wearable_ids: [409, 265],
  },
  {
    genesis_token_id: 13618,
    wearable_ids: [442, 263],
  },
  {
    genesis_token_id: 13619,
    wearable_ids: [387, 312],
  },
  {
    genesis_token_id: 13620,
    wearable_ids: [332, 325],
  },
  {
    genesis_token_id: 13621,
    wearable_ids: [343, 340],
  },
  {
    genesis_token_id: 13622,
    wearable_ids: [272, 362],
  },
  {
    genesis_token_id: 13623,
    wearable_ids: [373, 317],
  },
  {
    genesis_token_id: 13624,
    wearable_ids: [386, 337],
  },
  {
    genesis_token_id: 13625,
    wearable_ids: [404, 311],
  },
  {
    genesis_token_id: 13626,
    wearable_ids: [264, 254],
  },
  {
    genesis_token_id: 13627,
    wearable_ids: [319, 403],
  },
  {
    genesis_token_id: 13628,
    wearable_ids: [378, 310],
  },
  {
    genesis_token_id: 13629,
    wearable_ids: [316, 437],
  },
  {
    genesis_token_id: 13630,
    wearable_ids: [371, 377],
  },
  {
    genesis_token_id: 13631,
    wearable_ids: [300, 258],
  },
  {
    genesis_token_id: 13632,
    wearable_ids: [349, 346],
  },
  {
    genesis_token_id: 13633,
    wearable_ids: [295, 386],
  },
  {
    genesis_token_id: 13634,
    wearable_ids: [434, 384],
  },
  {
    genesis_token_id: 13635,
    wearable_ids: [412, 342],
  },
  {
    genesis_token_id: 13636,
    wearable_ids: [268, 424],
  },
  {
    genesis_token_id: 13637,
    wearable_ids: [339, 266],
  },
  {
    genesis_token_id: 13638,
    wearable_ids: [291, 437],
  },
  {
    genesis_token_id: 13639,
    wearable_ids: [370, 324],
  },
  {
    genesis_token_id: 13640,
    wearable_ids: [270, 444],
  },
  {
    genesis_token_id: 13641,
    wearable_ids: [286, 296],
  },
  {
    genesis_token_id: 13642,
    wearable_ids: [257, 364],
  },
  {
    genesis_token_id: 13643,
    wearable_ids: [259, 412],
  },
  {
    genesis_token_id: 13644,
    wearable_ids: [374, 425],
  },
  {
    genesis_token_id: 13645,
    wearable_ids: [271, 306],
  },
  {
    genesis_token_id: 13646,
    wearable_ids: [254, 435],
  },
  {
    genesis_token_id: 13647,
    wearable_ids: [396, 362],
  },
  {
    genesis_token_id: 13648,
    wearable_ids: [396, 315],
  },
  {
    genesis_token_id: 13649,
    wearable_ids: [349, 396],
  },
  {
    genesis_token_id: 13650,
    wearable_ids: [253, 315],
  },
  {
    genesis_token_id: 13651,
    wearable_ids: [432, 340],
  },
  {
    genesis_token_id: 13652,
    wearable_ids: [247, 417],
  },
  {
    genesis_token_id: 13653,
    wearable_ids: [445, 350],
  },
  {
    genesis_token_id: 13654,
    wearable_ids: [297, 407],
  },
  {
    genesis_token_id: 13655,
    wearable_ids: [336, 264],
  },
  {
    genesis_token_id: 13656,
    wearable_ids: [436, 386],
  },
  {
    genesis_token_id: 13657,
    wearable_ids: [422, 428],
  },
  {
    genesis_token_id: 13658,
    wearable_ids: [310, 344],
  },
  {
    genesis_token_id: 13659,
    wearable_ids: [435, 373],
  },
  {
    genesis_token_id: 13660,
    wearable_ids: [433, 366],
  },
  {
    genesis_token_id: 13661,
    wearable_ids: [375, 253],
  },
  {
    genesis_token_id: 13662,
    wearable_ids: [354, 340],
  },
  {
    genesis_token_id: 13663,
    wearable_ids: [369, 444],
  },
  {
    genesis_token_id: 13664,
    wearable_ids: [324, 319],
  },
  {
    genesis_token_id: 13665,
    wearable_ids: [370, 306],
  },
  {
    genesis_token_id: 13666,
    wearable_ids: [395, 350],
  },
  {
    genesis_token_id: 13667,
    wearable_ids: [434, 420],
  },
  {
    genesis_token_id: 13668,
    wearable_ids: [255, 348],
  },
  {
    genesis_token_id: 13669,
    wearable_ids: [276, 413],
  },
  {
    genesis_token_id: 13670,
    wearable_ids: [264, 257],
  },
  {
    genesis_token_id: 13671,
    wearable_ids: [420, 337],
  },
  {
    genesis_token_id: 13672,
    wearable_ids: [343, 296],
  },
  {
    genesis_token_id: 13673,
    wearable_ids: [256, 327],
  },
  {
    genesis_token_id: 13674,
    wearable_ids: [443, 274],
  },
  {
    genesis_token_id: 13675,
    wearable_ids: [445, 276],
  },
  {
    genesis_token_id: 13676,
    wearable_ids: [435, 436],
  },
  {
    genesis_token_id: 13677,
    wearable_ids: [317, 417],
  },
  {
    genesis_token_id: 13678,
    wearable_ids: [315, 444],
  },
  {
    genesis_token_id: 13679,
    wearable_ids: [435, 370],
  },
  {
    genesis_token_id: 13680,
    wearable_ids: [342, 286],
  },
  {
    genesis_token_id: 13681,
    wearable_ids: [335, 429],
  },
  {
    genesis_token_id: 13682,
    wearable_ids: [319, 265],
  },
  {
    genesis_token_id: 13683,
    wearable_ids: [297, 349],
  },
  {
    genesis_token_id: 13684,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 13685,
    wearable_ids: [292, 326],
  },
  {
    genesis_token_id: 13686,
    wearable_ids: [304, 370],
  },
  {
    genesis_token_id: 13687,
    wearable_ids: [268, 277],
  },
  {
    genesis_token_id: 13688,
    wearable_ids: [335, 256],
  },
  {
    genesis_token_id: 13689,
    wearable_ids: [280, 314],
  },
  {
    genesis_token_id: 13690,
    wearable_ids: [371, 410],
  },
  {
    genesis_token_id: 13691,
    wearable_ids: [324, 251],
  },
  {
    genesis_token_id: 13692,
    wearable_ids: [276, 341],
  },
  {
    genesis_token_id: 13693,
    wearable_ids: [373, 247],
  },
  {
    genesis_token_id: 13694,
    wearable_ids: [280, 260],
  },
  {
    genesis_token_id: 13695,
    wearable_ids: [308, 408],
  },
  {
    genesis_token_id: 13696,
    wearable_ids: [437, 265],
  },
  {
    genesis_token_id: 13697,
    wearable_ids: [253, 301],
  },
  {
    genesis_token_id: 13698,
    wearable_ids: [264, 255],
  },
  {
    genesis_token_id: 13699,
    wearable_ids: [286, 269],
  },
  {
    genesis_token_id: 13700,
    wearable_ids: [428, 429],
  },
  {
    genesis_token_id: 13701,
    wearable_ids: [434, 315],
  },
  {
    genesis_token_id: 13702,
    wearable_ids: [310, 341],
  },
  {
    genesis_token_id: 13703,
    wearable_ids: [251, 336],
  },
  {
    genesis_token_id: 13704,
    wearable_ids: [271, 323],
  },
  {
    genesis_token_id: 13705,
    wearable_ids: [436, 290],
  },
  {
    genesis_token_id: 13706,
    wearable_ids: [300, 383],
  },
  {
    genesis_token_id: 13707,
    wearable_ids: [385, 371],
  },
  {
    genesis_token_id: 13708,
    wearable_ids: [247, 251],
  },
  {
    genesis_token_id: 13709,
    wearable_ids: [262, 358],
  },
  {
    genesis_token_id: 13710,
    wearable_ids: [258, 269],
  },
  {
    genesis_token_id: 13711,
    wearable_ids: [437, 320],
  },
  {
    genesis_token_id: 13712,
    wearable_ids: [435, 393],
  },
  {
    genesis_token_id: 13713,
    wearable_ids: [434, 425],
  },
  {
    genesis_token_id: 13714,
    wearable_ids: [444, 346],
  },
  {
    genesis_token_id: 13715,
    wearable_ids: [311, 425],
  },
  {
    genesis_token_id: 13716,
    wearable_ids: [325, 257],
  },
  {
    genesis_token_id: 13717,
    wearable_ids: [271, 397],
  },
  {
    genesis_token_id: 13718,
    wearable_ids: [383, 313],
  },
  {
    genesis_token_id: 13719,
    wearable_ids: [295, 318],
  },
  {
    genesis_token_id: 13720,
    wearable_ids: [297, 442],
  },
  {
    genesis_token_id: 13721,
    wearable_ids: [248, 399],
  },
  {
    genesis_token_id: 13722,
    wearable_ids: [376, 305],
  },
  {
    genesis_token_id: 13723,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 13724,
    wearable_ids: [384, 327],
  },
  {
    genesis_token_id: 13725,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 13726,
    wearable_ids: [399, 383],
  },
  {
    genesis_token_id: 13727,
    wearable_ids: [350, 284],
  },
  {
    genesis_token_id: 13728,
    wearable_ids: [336, 404],
  },
  {
    genesis_token_id: 13729,
    wearable_ids: [277, 376],
  },
  {
    genesis_token_id: 13730,
    wearable_ids: [372, 317],
  },
  {
    genesis_token_id: 13731,
    wearable_ids: [295, 276],
  },
  {
    genesis_token_id: 13732,
    wearable_ids: [374, 255],
  },
  {
    genesis_token_id: 13733,
    wearable_ids: [266, 319],
  },
  {
    genesis_token_id: 13734,
    wearable_ids: [431, 336],
  },
  {
    genesis_token_id: 13735,
    wearable_ids: [276, 403],
  },
  {
    genesis_token_id: 13736,
    wearable_ids: [297, 276],
  },
  {
    genesis_token_id: 13737,
    wearable_ids: [339, 299],
  },
  {
    genesis_token_id: 13738,
    wearable_ids: [384, 297],
  },
  {
    genesis_token_id: 13739,
    wearable_ids: [295, 376],
  },
  {
    genesis_token_id: 13740,
    wearable_ids: [265, 268],
  },
  {
    genesis_token_id: 13741,
    wearable_ids: [277, 397],
  },
  {
    genesis_token_id: 13742,
    wearable_ids: [343, 289],
  },
  {
    genesis_token_id: 13743,
    wearable_ids: [271, 369],
  },
  {
    genesis_token_id: 13744,
    wearable_ids: [324, 444],
  },
  {
    genesis_token_id: 13745,
    wearable_ids: [338, 431],
  },
  {
    genesis_token_id: 13746,
    wearable_ids: [389, 420],
  },
  {
    genesis_token_id: 13747,
    wearable_ids: [378, 272],
  },
  {
    genesis_token_id: 13748,
    wearable_ids: [270, 311],
  },
  {
    genesis_token_id: 13749,
    wearable_ids: [362, 370],
  },
  {
    genesis_token_id: 13750,
    wearable_ids: [395, 391],
  },
  {
    genesis_token_id: 13751,
    wearable_ids: [378, 273],
  },
  {
    genesis_token_id: 13752,
    wearable_ids: [397, 374],
  },
  {
    genesis_token_id: 13753,
    wearable_ids: [314, 339],
  },
  {
    genesis_token_id: 13754,
    wearable_ids: [433, 318],
  },
  {
    genesis_token_id: 13755,
    wearable_ids: [265, 262],
  },
  {
    genesis_token_id: 13756,
    wearable_ids: [326, 261],
  },
  {
    genesis_token_id: 13757,
    wearable_ids: [303, 342],
  },
  {
    genesis_token_id: 13758,
    wearable_ids: [362, 284],
  },
  {
    genesis_token_id: 13759,
    wearable_ids: [348, 271],
  },
  {
    genesis_token_id: 13760,
    wearable_ids: [247, 347],
  },
  {
    genesis_token_id: 13761,
    wearable_ids: [304, 352],
  },
  {
    genesis_token_id: 13762,
    wearable_ids: [396, 412],
  },
  {
    genesis_token_id: 13763,
    wearable_ids: [375, 326],
  },
  {
    genesis_token_id: 13764,
    wearable_ids: [378, 251],
  },
  {
    genesis_token_id: 13765,
    wearable_ids: [263, 253],
  },
  {
    genesis_token_id: 13766,
    wearable_ids: [331, 399],
  },
  {
    genesis_token_id: 13767,
    wearable_ids: [386, 374],
  },
  {
    genesis_token_id: 13768,
    wearable_ids: [404, 444],
  },
  {
    genesis_token_id: 13769,
    wearable_ids: [257, 423],
  },
  {
    genesis_token_id: 13770,
    wearable_ids: [351, 426],
  },
  {
    genesis_token_id: 13771,
    wearable_ids: [344, 304],
  },
  {
    genesis_token_id: 13772,
    wearable_ids: [346, 295],
  },
  {
    genesis_token_id: 13773,
    wearable_ids: [368, 264],
  },
  {
    genesis_token_id: 13774,
    wearable_ids: [270, 378],
  },
  {
    genesis_token_id: 13775,
    wearable_ids: [337, 385],
  },
  {
    genesis_token_id: 13776,
    wearable_ids: [436, 274],
  },
  {
    genesis_token_id: 13777,
    wearable_ids: [317, 422],
  },
  {
    genesis_token_id: 13778,
    wearable_ids: [377, 400],
  },
  {
    genesis_token_id: 13779,
    wearable_ids: [308, 437],
  },
  {
    genesis_token_id: 13780,
    wearable_ids: [308, 268],
  },
  {
    genesis_token_id: 13781,
    wearable_ids: [377, 277],
  },
  {
    genesis_token_id: 13782,
    wearable_ids: [415, 357],
  },
  {
    genesis_token_id: 13783,
    wearable_ids: [251, 399],
  },
  {
    genesis_token_id: 13784,
    wearable_ids: [364, 339],
  },
  {
    genesis_token_id: 13785,
    wearable_ids: [325, 297],
  },
  {
    genesis_token_id: 13786,
    wearable_ids: [338, 294],
  },
  {
    genesis_token_id: 13787,
    wearable_ids: [340, 263],
  },
  {
    genesis_token_id: 13788,
    wearable_ids: [331, 317],
  },
  {
    genesis_token_id: 13789,
    wearable_ids: [289, 349],
  },
  {
    genesis_token_id: 13790,
    wearable_ids: [340, 384],
  },
  {
    genesis_token_id: 13791,
    wearable_ids: [376, 394],
  },
  {
    genesis_token_id: 13792,
    wearable_ids: [265, 414],
  },
  {
    genesis_token_id: 13793,
    wearable_ids: [429, 278],
  },
  {
    genesis_token_id: 13794,
    wearable_ids: [336, 441],
  },
  {
    genesis_token_id: 13795,
    wearable_ids: [272, 423],
  },
  {
    genesis_token_id: 13796,
    wearable_ids: [424, 374],
  },
  {
    genesis_token_id: 13797,
    wearable_ids: [415, 422],
  },
  {
    genesis_token_id: 13798,
    wearable_ids: [303, 289],
  },
  {
    genesis_token_id: 13799,
    wearable_ids: [340, 270],
  },
  {
    genesis_token_id: 13800,
    wearable_ids: [337, 247],
  },
  {
    genesis_token_id: 13801,
    wearable_ids: [433, 365],
  },
  {
    genesis_token_id: 13802,
    wearable_ids: [377, 412],
  },
  {
    genesis_token_id: 13803,
    wearable_ids: [442, 352],
  },
  {
    genesis_token_id: 13804,
    wearable_ids: [364, 413],
  },
  {
    genesis_token_id: 13805,
    wearable_ids: [277, 295],
  },
  {
    genesis_token_id: 13806,
    wearable_ids: [408, 441],
  },
  {
    genesis_token_id: 13807,
    wearable_ids: [346, 251],
  },
  {
    genesis_token_id: 13808,
    wearable_ids: [268, 262],
  },
  {
    genesis_token_id: 13809,
    wearable_ids: [295, 365],
  },
  {
    genesis_token_id: 13810,
    wearable_ids: [442, 300],
  },
  {
    genesis_token_id: 13811,
    wearable_ids: [336, 410],
  },
  {
    genesis_token_id: 13812,
    wearable_ids: [272, 378],
  },
  {
    genesis_token_id: 13813,
    wearable_ids: [286, 340],
  },
  {
    genesis_token_id: 13814,
    wearable_ids: [344, 383],
  },
  {
    genesis_token_id: 13815,
    wearable_ids: [292, 352],
  },
  {
    genesis_token_id: 13816,
    wearable_ids: [256, 428],
  },
  {
    genesis_token_id: 13817,
    wearable_ids: [284, 335],
  },
  {
    genesis_token_id: 13818,
    wearable_ids: [263, 272],
  },
  {
    genesis_token_id: 13819,
    wearable_ids: [295, 368],
  },
  {
    genesis_token_id: 13820,
    wearable_ids: [326, 372],
  },
  {
    genesis_token_id: 13821,
    wearable_ids: [376, 280],
  },
  {
    genesis_token_id: 13822,
    wearable_ids: [400, 291],
  },
  {
    genesis_token_id: 13823,
    wearable_ids: [434, 379],
  },
  {
    genesis_token_id: 13824,
    wearable_ids: [254, 318],
  },
  {
    genesis_token_id: 13825,
    wearable_ids: [375, 265],
  },
  {
    genesis_token_id: 13826,
    wearable_ids: [410, 387],
  },
  {
    genesis_token_id: 13827,
    wearable_ids: [372, 278],
  },
  {
    genesis_token_id: 13828,
    wearable_ids: [324, 332],
  },
  {
    genesis_token_id: 13829,
    wearable_ids: [426, 396],
  },
  {
    genesis_token_id: 13830,
    wearable_ids: [299, 273],
  },
  {
    genesis_token_id: 13831,
    wearable_ids: [277, 399],
  },
  {
    genesis_token_id: 13832,
    wearable_ids: [248, 392],
  },
  {
    genesis_token_id: 13833,
    wearable_ids: [399, 310],
  },
  {
    genesis_token_id: 13834,
    wearable_ids: [375, 344],
  },
  {
    genesis_token_id: 13835,
    wearable_ids: [387, 302],
  },
  {
    genesis_token_id: 13836,
    wearable_ids: [291, 310],
  },
  {
    genesis_token_id: 13837,
    wearable_ids: [291, 333],
  },
  {
    genesis_token_id: 13838,
    wearable_ids: [270, 274],
  },
  {
    genesis_token_id: 13839,
    wearable_ids: [399, 255],
  },
  {
    genesis_token_id: 13840,
    wearable_ids: [350, 265],
  },
  {
    genesis_token_id: 13841,
    wearable_ids: [433, 423],
  },
  {
    genesis_token_id: 13842,
    wearable_ids: [371, 375],
  },
  {
    genesis_token_id: 13843,
    wearable_ids: [376, 371],
  },
  {
    genesis_token_id: 13844,
    wearable_ids: [371, 324],
  },
  {
    genesis_token_id: 13845,
    wearable_ids: [364, 415],
  },
  {
    genesis_token_id: 13846,
    wearable_ids: [354, 429],
  },
  {
    genesis_token_id: 13847,
    wearable_ids: [376, 270],
  },
  {
    genesis_token_id: 13848,
    wearable_ids: [254, 264],
  },
  {
    genesis_token_id: 13849,
    wearable_ids: [280, 291],
  },
  {
    genesis_token_id: 13850,
    wearable_ids: [444, 354],
  },
  {
    genesis_token_id: 13851,
    wearable_ids: [422, 387],
  },
  {
    genesis_token_id: 13852,
    wearable_ids: [342, 422],
  },
  {
    genesis_token_id: 13853,
    wearable_ids: [436, 292],
  },
  {
    genesis_token_id: 13854,
    wearable_ids: [444, 303],
  },
  {
    genesis_token_id: 13855,
    wearable_ids: [291, 310],
  },
  {
    genesis_token_id: 13856,
    wearable_ids: [339, 387],
  },
  {
    genesis_token_id: 13857,
    wearable_ids: [274, 265],
  },
  {
    genesis_token_id: 13858,
    wearable_ids: [295, 423],
  },
  {
    genesis_token_id: 13859,
    wearable_ids: [431, 354],
  },
  {
    genesis_token_id: 13860,
    wearable_ids: [338, 434],
  },
  {
    genesis_token_id: 13861,
    wearable_ids: [251, 365],
  },
  {
    genesis_token_id: 13862,
    wearable_ids: [373, 377],
  },
  {
    genesis_token_id: 13863,
    wearable_ids: [319, 430],
  },
  {
    genesis_token_id: 13864,
    wearable_ids: [364, 251],
  },
  {
    genesis_token_id: 13865,
    wearable_ids: [272, 343],
  },
  {
    genesis_token_id: 13866,
    wearable_ids: [372, 437],
  },
  {
    genesis_token_id: 13867,
    wearable_ids: [351, 259],
  },
  {
    genesis_token_id: 13868,
    wearable_ids: [403, 363],
  },
  {
    genesis_token_id: 13869,
    wearable_ids: [257, 437],
  },
  {
    genesis_token_id: 13870,
    wearable_ids: [296, 369],
  },
  {
    genesis_token_id: 13871,
    wearable_ids: [248, 268],
  },
  {
    genesis_token_id: 13872,
    wearable_ids: [348, 342],
  },
  {
    genesis_token_id: 13873,
    wearable_ids: [301, 313],
  },
  {
    genesis_token_id: 13874,
    wearable_ids: [308, 295],
  },
  {
    genesis_token_id: 13875,
    wearable_ids: [385, 393],
  },
  {
    genesis_token_id: 13876,
    wearable_ids: [382, 376],
  },
  {
    genesis_token_id: 13877,
    wearable_ids: [253, 285],
  },
  {
    genesis_token_id: 13878,
    wearable_ids: [395, 440],
  },
  {
    genesis_token_id: 13879,
    wearable_ids: [383, 374],
  },
  {
    genesis_token_id: 13880,
    wearable_ids: [278, 364],
  },
  {
    genesis_token_id: 13881,
    wearable_ids: [354, 283],
  },
  {
    genesis_token_id: 13882,
    wearable_ids: [355, 292],
  },
  {
    genesis_token_id: 13883,
    wearable_ids: [411, 422],
  },
  {
    genesis_token_id: 13884,
    wearable_ids: [276, 423],
  },
  {
    genesis_token_id: 13885,
    wearable_ids: [422, 295],
  },
  {
    genesis_token_id: 13886,
    wearable_ids: [413, 261],
  },
  {
    genesis_token_id: 13887,
    wearable_ids: [424, 256],
  },
  {
    genesis_token_id: 13888,
    wearable_ids: [326, 255],
  },
  {
    genesis_token_id: 13889,
    wearable_ids: [376, 286],
  },
  {
    genesis_token_id: 13890,
    wearable_ids: [408, 314],
  },
  {
    genesis_token_id: 13891,
    wearable_ids: [383, 397],
  },
  {
    genesis_token_id: 13892,
    wearable_ids: [409, 423],
  },
  {
    genesis_token_id: 13893,
    wearable_ids: [397, 406],
  },
  {
    genesis_token_id: 13894,
    wearable_ids: [408, 254],
  },
  {
    genesis_token_id: 13895,
    wearable_ids: [340, 413],
  },
  {
    genesis_token_id: 13896,
    wearable_ids: [339, 254],
  },
  {
    genesis_token_id: 13897,
    wearable_ids: [374, 410],
  },
  {
    genesis_token_id: 13898,
    wearable_ids: [306, 325],
  },
  {
    genesis_token_id: 13899,
    wearable_ids: [432, 370],
  },
  {
    genesis_token_id: 13900,
    wearable_ids: [364, 316],
  },
  {
    genesis_token_id: 13901,
    wearable_ids: [429, 247],
  },
  {
    genesis_token_id: 13902,
    wearable_ids: [415, 264],
  },
  {
    genesis_token_id: 13903,
    wearable_ids: [317, 346],
  },
  {
    genesis_token_id: 13904,
    wearable_ids: [386, 247],
  },
  {
    genesis_token_id: 13905,
    wearable_ids: [443, 332],
  },
  {
    genesis_token_id: 13906,
    wearable_ids: [376, 260],
  },
  {
    genesis_token_id: 13907,
    wearable_ids: [444, 305],
  },
  {
    genesis_token_id: 13908,
    wearable_ids: [310, 404],
  },
  {
    genesis_token_id: 13909,
    wearable_ids: [256, 258],
  },
  {
    genesis_token_id: 13910,
    wearable_ids: [257, 291],
  },
  {
    genesis_token_id: 13911,
    wearable_ids: [336, 432],
  },
  {
    genesis_token_id: 13912,
    wearable_ids: [292, 410],
  },
  {
    genesis_token_id: 13913,
    wearable_ids: [407, 387],
  },
  {
    genesis_token_id: 13914,
    wearable_ids: [310, 249],
  },
  {
    genesis_token_id: 13915,
    wearable_ids: [256, 278],
  },
  {
    genesis_token_id: 13916,
    wearable_ids: [303, 254],
  },
  {
    genesis_token_id: 13917,
    wearable_ids: [253, 429],
  },
  {
    genesis_token_id: 13918,
    wearable_ids: [437, 268],
  },
  {
    genesis_token_id: 13919,
    wearable_ids: [341, 352],
  },
  {
    genesis_token_id: 13920,
    wearable_ids: [310, 426],
  },
  {
    genesis_token_id: 13921,
    wearable_ids: [413, 429],
  },
  {
    genesis_token_id: 13922,
    wearable_ids: [424, 363],
  },
  {
    genesis_token_id: 13923,
    wearable_ids: [247, 326],
  },
  {
    genesis_token_id: 13924,
    wearable_ids: [287, 280],
  },
  {
    genesis_token_id: 13925,
    wearable_ids: [253, 373],
  },
  {
    genesis_token_id: 13926,
    wearable_ids: [385, 401],
  },
  {
    genesis_token_id: 13927,
    wearable_ids: [319, 424],
  },
  {
    genesis_token_id: 13928,
    wearable_ids: [400, 351],
  },
  {
    genesis_token_id: 13929,
    wearable_ids: [259, 443],
  },
  {
    genesis_token_id: 13930,
    wearable_ids: [395, 308],
  },
  {
    genesis_token_id: 13931,
    wearable_ids: [400, 259],
  },
  {
    genesis_token_id: 13932,
    wearable_ids: [362, 436],
  },
  {
    genesis_token_id: 13933,
    wearable_ids: [364, 269],
  },
  {
    genesis_token_id: 13934,
    wearable_ids: [265, 416],
  },
  {
    genesis_token_id: 13935,
    wearable_ids: [254, 409],
  },
  {
    genesis_token_id: 13936,
    wearable_ids: [303, 431],
  },
  {
    genesis_token_id: 13937,
    wearable_ids: [382, 333],
  },
  {
    genesis_token_id: 13938,
    wearable_ids: [403, 365],
  },
  {
    genesis_token_id: 13939,
    wearable_ids: [397, 428],
  },
  {
    genesis_token_id: 13940,
    wearable_ids: [420, 253],
  },
  {
    genesis_token_id: 13941,
    wearable_ids: [350, 423],
  },
  {
    genesis_token_id: 13942,
    wearable_ids: [292, 255],
  },
  {
    genesis_token_id: 13943,
    wearable_ids: [395, 369],
  },
  {
    genesis_token_id: 13944,
    wearable_ids: [262, 389],
  },
  {
    genesis_token_id: 13945,
    wearable_ids: [296, 325],
  },
  {
    genesis_token_id: 13946,
    wearable_ids: [377, 344],
  },
  {
    genesis_token_id: 13947,
    wearable_ids: [284, 431],
  },
  {
    genesis_token_id: 13948,
    wearable_ids: [273, 251],
  },
  {
    genesis_token_id: 13949,
    wearable_ids: [319, 261],
  },
  {
    genesis_token_id: 13950,
    wearable_ids: [400, 361],
  },
  {
    genesis_token_id: 13951,
    wearable_ids: [341, 286],
  },
  {
    genesis_token_id: 13952,
    wearable_ids: [423, 424],
  },
  {
    genesis_token_id: 13953,
    wearable_ids: [339, 393],
  },
  {
    genesis_token_id: 13954,
    wearable_ids: [350, 337],
  },
  {
    genesis_token_id: 13955,
    wearable_ids: [259, 273],
  },
  {
    genesis_token_id: 13956,
    wearable_ids: [348, 257],
  },
  {
    genesis_token_id: 13957,
    wearable_ids: [340, 357],
  },
  {
    genesis_token_id: 13958,
    wearable_ids: [314, 394],
  },
  {
    genesis_token_id: 13959,
    wearable_ids: [337, 356],
  },
  {
    genesis_token_id: 13960,
    wearable_ids: [262, 432],
  },
  {
    genesis_token_id: 13961,
    wearable_ids: [337, 423],
  },
  {
    genesis_token_id: 13962,
    wearable_ids: [265, 425],
  },
  {
    genesis_token_id: 13963,
    wearable_ids: [408, 368],
  },
  {
    genesis_token_id: 13964,
    wearable_ids: [403, 326],
  },
  {
    genesis_token_id: 13965,
    wearable_ids: [256, 386],
  },
  {
    genesis_token_id: 13966,
    wearable_ids: [344, 368],
  },
  {
    genesis_token_id: 13967,
    wearable_ids: [284, 331],
  },
  {
    genesis_token_id: 13968,
    wearable_ids: [254, 360],
  },
  {
    genesis_token_id: 13969,
    wearable_ids: [410, 424],
  },
  {
    genesis_token_id: 13970,
    wearable_ids: [340, 361],
  },
  {
    genesis_token_id: 13971,
    wearable_ids: [355, 384],
  },
  {
    genesis_token_id: 13972,
    wearable_ids: [346, 301],
  },
  {
    genesis_token_id: 13973,
    wearable_ids: [319, 377],
  },
  {
    genesis_token_id: 13974,
    wearable_ids: [277, 387],
  },
  {
    genesis_token_id: 13975,
    wearable_ids: [399, 281],
  },
  {
    genesis_token_id: 13976,
    wearable_ids: [296, 349],
  },
  {
    genesis_token_id: 13977,
    wearable_ids: [343, 363],
  },
  {
    genesis_token_id: 13978,
    wearable_ids: [372, 400],
  },
  {
    genesis_token_id: 13979,
    wearable_ids: [400, 262],
  },
  {
    genesis_token_id: 13980,
    wearable_ids: [340, 370],
  },
  {
    genesis_token_id: 13981,
    wearable_ids: [304, 340],
  },
  {
    genesis_token_id: 13982,
    wearable_ids: [335, 332],
  },
  {
    genesis_token_id: 13983,
    wearable_ids: [256, 415],
  },
  {
    genesis_token_id: 13984,
    wearable_ids: [265, 293],
  },
  {
    genesis_token_id: 13985,
    wearable_ids: [407, 295],
  },
  {
    genesis_token_id: 13986,
    wearable_ids: [271, 425],
  },
  {
    genesis_token_id: 13987,
    wearable_ids: [300, 343],
  },
  {
    genesis_token_id: 13988,
    wearable_ids: [324, 366],
  },
  {
    genesis_token_id: 13989,
    wearable_ids: [306, 422],
  },
  {
    genesis_token_id: 13990,
    wearable_ids: [253, 369],
  },
  {
    genesis_token_id: 13991,
    wearable_ids: [370, 306],
  },
  {
    genesis_token_id: 13992,
    wearable_ids: [389, 395],
  },
  {
    genesis_token_id: 13993,
    wearable_ids: [352, 420],
  },
  {
    genesis_token_id: 13994,
    wearable_ids: [278, 262],
  },
  {
    genesis_token_id: 13995,
    wearable_ids: [378, 295],
  },
  {
    genesis_token_id: 13996,
    wearable_ids: [364, 371],
  },
  {
    genesis_token_id: 13997,
    wearable_ids: [374, 369],
  },
  {
    genesis_token_id: 13998,
    wearable_ids: [258, 410],
  },
  {
    genesis_token_id: 13999,
    wearable_ids: [435, 422],
  },
  {
    genesis_token_id: 14000,
    wearable_ids: [434, 383],
  },
  {
    genesis_token_id: 14001,
    wearable_ids: [443, 338],
  },
  {
    genesis_token_id: 14002,
    wearable_ids: [425, 358],
  },
  {
    genesis_token_id: 14003,
    wearable_ids: [382, 308],
  },
  {
    genesis_token_id: 14004,
    wearable_ids: [437, 370],
  },
  {
    genesis_token_id: 14005,
    wearable_ids: [376, 420],
  },
  {
    genesis_token_id: 14006,
    wearable_ids: [286, 303],
  },
  {
    genesis_token_id: 14007,
    wearable_ids: [444, 388],
  },
  {
    genesis_token_id: 14008,
    wearable_ids: [304, 306],
  },
  {
    genesis_token_id: 14009,
    wearable_ids: [346, 416],
  },
  {
    genesis_token_id: 14010,
    wearable_ids: [347, 289],
  },
  {
    genesis_token_id: 14011,
    wearable_ids: [403, 368],
  },
  {
    genesis_token_id: 14012,
    wearable_ids: [369, 415],
  },
  {
    genesis_token_id: 14013,
    wearable_ids: [377, 255],
  },
  {
    genesis_token_id: 14014,
    wearable_ids: [315, 306],
  },
  {
    genesis_token_id: 14015,
    wearable_ids: [408, 409],
  },
  {
    genesis_token_id: 14016,
    wearable_ids: [431, 359],
  },
  {
    genesis_token_id: 14017,
    wearable_ids: [387, 412],
  },
  {
    genesis_token_id: 14018,
    wearable_ids: [423, 435],
  },
  {
    genesis_token_id: 14019,
    wearable_ids: [425, 441],
  },
  {
    genesis_token_id: 14020,
    wearable_ids: [422, 291],
  },
  {
    genesis_token_id: 14021,
    wearable_ids: [336, 411],
  },
  {
    genesis_token_id: 14022,
    wearable_ids: [399, 287],
  },
  {
    genesis_token_id: 14023,
    wearable_ids: [274, 347],
  },
  {
    genesis_token_id: 14024,
    wearable_ids: [371, 351],
  },
  {
    genesis_token_id: 14025,
    wearable_ids: [274, 413],
  },
  {
    genesis_token_id: 14026,
    wearable_ids: [301, 271],
  },
  {
    genesis_token_id: 14027,
    wearable_ids: [294, 442],
  },
  {
    genesis_token_id: 14028,
    wearable_ids: [389, 362],
  },
  {
    genesis_token_id: 14029,
    wearable_ids: [287, 403],
  },
  {
    genesis_token_id: 14030,
    wearable_ids: [351, 413],
  },
  {
    genesis_token_id: 14031,
    wearable_ids: [425, 275],
  },
  {
    genesis_token_id: 14032,
    wearable_ids: [248, 350],
  },
  {
    genesis_token_id: 14033,
    wearable_ids: [258, 363],
  },
  {
    genesis_token_id: 14034,
    wearable_ids: [300, 257],
  },
  {
    genesis_token_id: 14035,
    wearable_ids: [340, 355],
  },
  {
    genesis_token_id: 14036,
    wearable_ids: [278, 333],
  },
  {
    genesis_token_id: 14037,
    wearable_ids: [371, 344],
  },
  {
    genesis_token_id: 14038,
    wearable_ids: [266, 328],
  },
  {
    genesis_token_id: 14039,
    wearable_ids: [433, 256],
  },
  {
    genesis_token_id: 14040,
    wearable_ids: [274, 338],
  },
  {
    genesis_token_id: 14041,
    wearable_ids: [262, 281],
  },
  {
    genesis_token_id: 14042,
    wearable_ids: [299, 428],
  },
  {
    genesis_token_id: 14043,
    wearable_ids: [301, 347],
  },
  {
    genesis_token_id: 14044,
    wearable_ids: [251, 288],
  },
  {
    genesis_token_id: 14045,
    wearable_ids: [408, 374],
  },
  {
    genesis_token_id: 14046,
    wearable_ids: [339, 323],
  },
  {
    genesis_token_id: 14047,
    wearable_ids: [277, 376],
  },
  {
    genesis_token_id: 14048,
    wearable_ids: [315, 420],
  },
  {
    genesis_token_id: 14049,
    wearable_ids: [415, 433],
  },
  {
    genesis_token_id: 14050,
    wearable_ids: [384, 303],
  },
  {
    genesis_token_id: 14051,
    wearable_ids: [428, 344],
  },
  {
    genesis_token_id: 14052,
    wearable_ids: [332, 265],
  },
  {
    genesis_token_id: 14053,
    wearable_ids: [278, 404],
  },
  {
    genesis_token_id: 14054,
    wearable_ids: [262, 364],
  },
  {
    genesis_token_id: 14055,
    wearable_ids: [341, 386],
  },
  {
    genesis_token_id: 14056,
    wearable_ids: [287, 413],
  },
  {
    genesis_token_id: 14057,
    wearable_ids: [286, 337],
  },
  {
    genesis_token_id: 14058,
    wearable_ids: [378, 369],
  },
  {
    genesis_token_id: 14059,
    wearable_ids: [347, 316],
  },
  {
    genesis_token_id: 14060,
    wearable_ids: [270, 280],
  },
  {
    genesis_token_id: 14061,
    wearable_ids: [350, 364],
  },
  {
    genesis_token_id: 14062,
    wearable_ids: [278, 300],
  },
  {
    genesis_token_id: 14063,
    wearable_ids: [369, 300],
  },
  {
    genesis_token_id: 14064,
    wearable_ids: [325, 310],
  },
  {
    genesis_token_id: 14065,
    wearable_ids: [277, 407],
  },
  {
    genesis_token_id: 14066,
    wearable_ids: [255, 324],
  },
  {
    genesis_token_id: 14067,
    wearable_ids: [348, 299],
  },
  {
    genesis_token_id: 14068,
    wearable_ids: [257, 426],
  },
  {
    genesis_token_id: 14069,
    wearable_ids: [444, 303],
  },
  {
    genesis_token_id: 14070,
    wearable_ids: [378, 292],
  },
  {
    genesis_token_id: 14071,
    wearable_ids: [306, 354],
  },
  {
    genesis_token_id: 14072,
    wearable_ids: [300, 429],
  },
  {
    genesis_token_id: 14073,
    wearable_ids: [433, 364],
  },
  {
    genesis_token_id: 14074,
    wearable_ids: [301, 384],
  },
  {
    genesis_token_id: 14075,
    wearable_ids: [423, 397],
  },
  {
    genesis_token_id: 14076,
    wearable_ids: [437, 435],
  },
  {
    genesis_token_id: 14077,
    wearable_ids: [412, 327],
  },
  {
    genesis_token_id: 14078,
    wearable_ids: [436, 376],
  },
  {
    genesis_token_id: 14079,
    wearable_ids: [306, 281],
  },
  {
    genesis_token_id: 14080,
    wearable_ids: [374, 428],
  },
  {
    genesis_token_id: 14081,
    wearable_ids: [354, 370],
  },
  {
    genesis_token_id: 14082,
    wearable_ids: [315, 372],
  },
  {
    genesis_token_id: 14083,
    wearable_ids: [297, 375],
  },
  {
    genesis_token_id: 14084,
    wearable_ids: [339, 372],
  },
  {
    genesis_token_id: 14085,
    wearable_ids: [340, 429],
  },
  {
    genesis_token_id: 14086,
    wearable_ids: [374, 348],
  },
  {
    genesis_token_id: 14087,
    wearable_ids: [382, 315],
  },
  {
    genesis_token_id: 14088,
    wearable_ids: [253, 430],
  },
  {
    genesis_token_id: 14089,
    wearable_ids: [372, 254],
  },
  {
    genesis_token_id: 14090,
    wearable_ids: [385, 292],
  },
  {
    genesis_token_id: 14091,
    wearable_ids: [344, 256],
  },
  {
    genesis_token_id: 14092,
    wearable_ids: [433, 396],
  },
  {
    genesis_token_id: 14093,
    wearable_ids: [444, 323],
  },
  {
    genesis_token_id: 14094,
    wearable_ids: [444, 355],
  },
  {
    genesis_token_id: 14095,
    wearable_ids: [372, 370],
  },
  {
    genesis_token_id: 14096,
    wearable_ids: [395, 401],
  },
  {
    genesis_token_id: 14097,
    wearable_ids: [373, 312],
  },
  {
    genesis_token_id: 14098,
    wearable_ids: [386, 332],
  },
  {
    genesis_token_id: 14099,
    wearable_ids: [408, 344],
  },
  {
    genesis_token_id: 14100,
    wearable_ids: [317, 280],
  },
  {
    genesis_token_id: 14101,
    wearable_ids: [270, 348],
  },
  {
    genesis_token_id: 14102,
    wearable_ids: [437, 247],
  },
  {
    genesis_token_id: 14103,
    wearable_ids: [262, 369],
  },
  {
    genesis_token_id: 14104,
    wearable_ids: [300, 297],
  },
  {
    genesis_token_id: 14105,
    wearable_ids: [346, 414],
  },
  {
    genesis_token_id: 14106,
    wearable_ids: [304, 336],
  },
  {
    genesis_token_id: 14107,
    wearable_ids: [378, 300],
  },
  {
    genesis_token_id: 14108,
    wearable_ids: [428, 389],
  },
  {
    genesis_token_id: 14109,
    wearable_ids: [363, 288],
  },
  {
    genesis_token_id: 14110,
    wearable_ids: [373, 284],
  },
  {
    genesis_token_id: 14111,
    wearable_ids: [270, 369],
  },
  {
    genesis_token_id: 14112,
    wearable_ids: [274, 316],
  },
  {
    genesis_token_id: 14113,
    wearable_ids: [365, 323],
  },
  {
    genesis_token_id: 14114,
    wearable_ids: [364, 300],
  },
  {
    genesis_token_id: 14115,
    wearable_ids: [386, 314],
  },
  {
    genesis_token_id: 14116,
    wearable_ids: [344, 405],
  },
  {
    genesis_token_id: 14117,
    wearable_ids: [397, 377],
  },
  {
    genesis_token_id: 14118,
    wearable_ids: [340, 344],
  },
  {
    genesis_token_id: 14119,
    wearable_ids: [315, 395],
  },
  {
    genesis_token_id: 14120,
    wearable_ids: [424, 269],
  },
  {
    genesis_token_id: 14121,
    wearable_ids: [287, 296],
  },
  {
    genesis_token_id: 14122,
    wearable_ids: [370, 251],
  },
  {
    genesis_token_id: 14123,
    wearable_ids: [373, 349],
  },
  {
    genesis_token_id: 14124,
    wearable_ids: [406, 264],
  },
  {
    genesis_token_id: 14125,
    wearable_ids: [342, 416],
  },
  {
    genesis_token_id: 14126,
    wearable_ids: [303, 442],
  },
  {
    genesis_token_id: 14127,
    wearable_ids: [375, 248],
  },
  {
    genesis_token_id: 14128,
    wearable_ids: [265, 415],
  },
  {
    genesis_token_id: 14129,
    wearable_ids: [434, 427],
  },
  {
    genesis_token_id: 14130,
    wearable_ids: [262, 389],
  },
  {
    genesis_token_id: 14131,
    wearable_ids: [372, 434],
  },
  {
    genesis_token_id: 14132,
    wearable_ids: [369, 350],
  },
  {
    genesis_token_id: 14133,
    wearable_ids: [266, 349],
  },
  {
    genesis_token_id: 14134,
    wearable_ids: [308, 293],
  },
  {
    genesis_token_id: 14135,
    wearable_ids: [370, 266],
  },
  {
    genesis_token_id: 14136,
    wearable_ids: [409, 418],
  },
  {
    genesis_token_id: 14137,
    wearable_ids: [428, 427],
  },
  {
    genesis_token_id: 14138,
    wearable_ids: [413, 283],
  },
  {
    genesis_token_id: 14139,
    wearable_ids: [347, 316],
  },
  {
    genesis_token_id: 14140,
    wearable_ids: [378, 415],
  },
  {
    genesis_token_id: 14141,
    wearable_ids: [341, 316],
  },
  {
    genesis_token_id: 14142,
    wearable_ids: [364, 323],
  },
  {
    genesis_token_id: 14143,
    wearable_ids: [276, 407],
  },
  {
    genesis_token_id: 14144,
    wearable_ids: [351, 273],
  },
  {
    genesis_token_id: 14145,
    wearable_ids: [263, 384],
  },
  {
    genesis_token_id: 14146,
    wearable_ids: [373, 364],
  },
  {
    genesis_token_id: 14147,
    wearable_ids: [340, 403],
  },
  {
    genesis_token_id: 14148,
    wearable_ids: [407, 280],
  },
  {
    genesis_token_id: 14149,
    wearable_ids: [434, 331],
  },
  {
    genesis_token_id: 14150,
    wearable_ids: [308, 284],
  },
  {
    genesis_token_id: 14151,
    wearable_ids: [436, 423],
  },
  {
    genesis_token_id: 14152,
    wearable_ids: [396, 385],
  },
  {
    genesis_token_id: 14153,
    wearable_ids: [348, 307],
  },
  {
    genesis_token_id: 14154,
    wearable_ids: [349, 399],
  },
  {
    genesis_token_id: 14155,
    wearable_ids: [399, 408],
  },
  {
    genesis_token_id: 14156,
    wearable_ids: [422, 295],
  },
  {
    genesis_token_id: 14157,
    wearable_ids: [352, 303],
  },
  {
    genesis_token_id: 14158,
    wearable_ids: [375, 353],
  },
  {
    genesis_token_id: 14159,
    wearable_ids: [251, 272],
  },
  {
    genesis_token_id: 14160,
    wearable_ids: [248, 368],
  },
  {
    genesis_token_id: 14161,
    wearable_ids: [276, 366],
  },
  {
    genesis_token_id: 14162,
    wearable_ids: [365, 427],
  },
  {
    genesis_token_id: 14163,
    wearable_ids: [258, 266],
  },
  {
    genesis_token_id: 14164,
    wearable_ids: [408, 290],
  },
  {
    genesis_token_id: 14165,
    wearable_ids: [271, 407],
  },
  {
    genesis_token_id: 14166,
    wearable_ids: [294, 303],
  },
  {
    genesis_token_id: 14167,
    wearable_ids: [376, 384],
  },
  {
    genesis_token_id: 14168,
    wearable_ids: [294, 433],
  },
  {
    genesis_token_id: 14169,
    wearable_ids: [407, 355],
  },
  {
    genesis_token_id: 14170,
    wearable_ids: [434, 353],
  },
  {
    genesis_token_id: 14171,
    wearable_ids: [412, 404],
  },
  {
    genesis_token_id: 14172,
    wearable_ids: [403, 408],
  },
  {
    genesis_token_id: 14173,
    wearable_ids: [344, 299],
  },
  {
    genesis_token_id: 14174,
    wearable_ids: [286, 435],
  },
  {
    genesis_token_id: 14175,
    wearable_ids: [350, 346],
  },
  {
    genesis_token_id: 14176,
    wearable_ids: [340, 323],
  },
  {
    genesis_token_id: 14177,
    wearable_ids: [352, 324],
  },
  {
    genesis_token_id: 14178,
    wearable_ids: [406, 378],
  },
  {
    genesis_token_id: 14179,
    wearable_ids: [325, 387],
  },
  {
    genesis_token_id: 14180,
    wearable_ids: [310, 442],
  },
  {
    genesis_token_id: 14181,
    wearable_ids: [341, 442],
  },
  {
    genesis_token_id: 14182,
    wearable_ids: [351, 320],
  },
  {
    genesis_token_id: 14183,
    wearable_ids: [415, 372],
  },
  {
    genesis_token_id: 14184,
    wearable_ids: [300, 350],
  },
  {
    genesis_token_id: 14185,
    wearable_ids: [442, 420],
  },
  {
    genesis_token_id: 14186,
    wearable_ids: [326, 352],
  },
  {
    genesis_token_id: 14187,
    wearable_ids: [258, 440],
  },
  {
    genesis_token_id: 14188,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 14189,
    wearable_ids: [433, 272],
  },
  {
    genesis_token_id: 14190,
    wearable_ids: [277, 253],
  },
  {
    genesis_token_id: 14191,
    wearable_ids: [324, 374],
  },
  {
    genesis_token_id: 14192,
    wearable_ids: [375, 265],
  },
  {
    genesis_token_id: 14193,
    wearable_ids: [297, 362],
  },
  {
    genesis_token_id: 14194,
    wearable_ids: [383, 319],
  },
  {
    genesis_token_id: 14195,
    wearable_ids: [444, 297],
  },
  {
    genesis_token_id: 14196,
    wearable_ids: [386, 394],
  },
  {
    genesis_token_id: 14197,
    wearable_ids: [409, 388],
  },
  {
    genesis_token_id: 14198,
    wearable_ids: [364, 345],
  },
  {
    genesis_token_id: 14199,
    wearable_ids: [280, 428],
  },
  {
    genesis_token_id: 14200,
    wearable_ids: [371, 360],
  },
  {
    genesis_token_id: 14201,
    wearable_ids: [433, 411],
  },
  {
    genesis_token_id: 14202,
    wearable_ids: [248, 440],
  },
  {
    genesis_token_id: 14203,
    wearable_ids: [340, 299],
  },
  {
    genesis_token_id: 14204,
    wearable_ids: [303, 365],
  },
  {
    genesis_token_id: 14205,
    wearable_ids: [303, 264],
  },
  {
    genesis_token_id: 14206,
    wearable_ids: [263, 440],
  },
  {
    genesis_token_id: 14207,
    wearable_ids: [280, 344],
  },
  {
    genesis_token_id: 14208,
    wearable_ids: [411, 407],
  },
  {
    genesis_token_id: 14209,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 14210,
    wearable_ids: [271, 261],
  },
  {
    genesis_token_id: 14211,
    wearable_ids: [258, 368],
  },
  {
    genesis_token_id: 14212,
    wearable_ids: [412, 397],
  },
  {
    genesis_token_id: 14213,
    wearable_ids: [406, 396],
  },
  {
    genesis_token_id: 14214,
    wearable_ids: [295, 316],
  },
  {
    genesis_token_id: 14215,
    wearable_ids: [306, 376],
  },
  {
    genesis_token_id: 14216,
    wearable_ids: [410, 432],
  },
  {
    genesis_token_id: 14217,
    wearable_ids: [370, 351],
  },
  {
    genesis_token_id: 14218,
    wearable_ids: [408, 374],
  },
  {
    genesis_token_id: 14219,
    wearable_ids: [344, 286],
  },
  {
    genesis_token_id: 14220,
    wearable_ids: [383, 254],
  },
  {
    genesis_token_id: 14221,
    wearable_ids: [335, 320],
  },
  {
    genesis_token_id: 14222,
    wearable_ids: [425, 346],
  },
  {
    genesis_token_id: 14223,
    wearable_ids: [363, 340],
  },
  {
    genesis_token_id: 14224,
    wearable_ids: [295, 297],
  },
  {
    genesis_token_id: 14225,
    wearable_ids: [274, 298],
  },
  {
    genesis_token_id: 14226,
    wearable_ids: [324, 383],
  },
  {
    genesis_token_id: 14227,
    wearable_ids: [382, 304],
  },
  {
    genesis_token_id: 14228,
    wearable_ids: [396, 372],
  },
  {
    genesis_token_id: 14229,
    wearable_ids: [408, 289],
  },
  {
    genesis_token_id: 14230,
    wearable_ids: [306, 276],
  },
  {
    genesis_token_id: 14231,
    wearable_ids: [443, 270],
  },
  {
    genesis_token_id: 14232,
    wearable_ids: [341, 380],
  },
  {
    genesis_token_id: 14233,
    wearable_ids: [263, 415],
  },
  {
    genesis_token_id: 14234,
    wearable_ids: [349, 269],
  },
  {
    genesis_token_id: 14235,
    wearable_ids: [374, 288],
  },
  {
    genesis_token_id: 14236,
    wearable_ids: [403, 389],
  },
  {
    genesis_token_id: 14237,
    wearable_ids: [247, 346],
  },
  {
    genesis_token_id: 14238,
    wearable_ids: [376, 442],
  },
  {
    genesis_token_id: 14239,
    wearable_ids: [270, 291],
  },
  {
    genesis_token_id: 14240,
    wearable_ids: [271, 403],
  },
  {
    genesis_token_id: 14241,
    wearable_ids: [399, 369],
  },
  {
    genesis_token_id: 14242,
    wearable_ids: [445, 419],
  },
  {
    genesis_token_id: 14243,
    wearable_ids: [343, 284],
  },
  {
    genesis_token_id: 14244,
    wearable_ids: [299, 342],
  },
  {
    genesis_token_id: 14245,
    wearable_ids: [377, 426],
  },
  {
    genesis_token_id: 14246,
    wearable_ids: [408, 288],
  },
  {
    genesis_token_id: 14247,
    wearable_ids: [389, 310],
  },
  {
    genesis_token_id: 14248,
    wearable_ids: [286, 351],
  },
  {
    genesis_token_id: 14249,
    wearable_ids: [365, 316],
  },
  {
    genesis_token_id: 14250,
    wearable_ids: [396, 373],
  },
  {
    genesis_token_id: 14251,
    wearable_ids: [257, 400],
  },
  {
    genesis_token_id: 14252,
    wearable_ids: [413, 290],
  },
  {
    genesis_token_id: 14253,
    wearable_ids: [350, 420],
  },
  {
    genesis_token_id: 14254,
    wearable_ids: [400, 340],
  },
  {
    genesis_token_id: 14255,
    wearable_ids: [420, 343],
  },
  {
    genesis_token_id: 14256,
    wearable_ids: [383, 264],
  },
  {
    genesis_token_id: 14257,
    wearable_ids: [433, 368],
  },
  {
    genesis_token_id: 14258,
    wearable_ids: [258, 291],
  },
  {
    genesis_token_id: 14259,
    wearable_ids: [370, 420],
  },
  {
    genesis_token_id: 14260,
    wearable_ids: [319, 342],
  },
  {
    genesis_token_id: 14261,
    wearable_ids: [268, 280],
  },
  {
    genesis_token_id: 14262,
    wearable_ids: [335, 356],
  },
  {
    genesis_token_id: 14263,
    wearable_ids: [365, 357],
  },
  {
    genesis_token_id: 14264,
    wearable_ids: [354, 261],
  },
  {
    genesis_token_id: 14265,
    wearable_ids: [432, 393],
  },
  {
    genesis_token_id: 14266,
    wearable_ids: [412, 404],
  },
  {
    genesis_token_id: 14267,
    wearable_ids: [348, 325],
  },
  {
    genesis_token_id: 14268,
    wearable_ids: [277, 292],
  },
  {
    genesis_token_id: 14269,
    wearable_ids: [268, 331],
  },
  {
    genesis_token_id: 14270,
    wearable_ids: [362, 440],
  },
  {
    genesis_token_id: 14271,
    wearable_ids: [389, 417],
  },
  {
    genesis_token_id: 14272,
    wearable_ids: [442, 401],
  },
  {
    genesis_token_id: 14273,
    wearable_ids: [304, 287],
  },
  {
    genesis_token_id: 14274,
    wearable_ids: [268, 279],
  },
  {
    genesis_token_id: 14275,
    wearable_ids: [336, 261],
  },
  {
    genesis_token_id: 14276,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 14277,
    wearable_ids: [373, 362],
  },
  {
    genesis_token_id: 14278,
    wearable_ids: [347, 278],
  },
  {
    genesis_token_id: 14279,
    wearable_ids: [426, 437],
  },
  {
    genesis_token_id: 14280,
    wearable_ids: [383, 293],
  },
  {
    genesis_token_id: 14281,
    wearable_ids: [425, 311],
  },
  {
    genesis_token_id: 14282,
    wearable_ids: [355, 286],
  },
  {
    genesis_token_id: 14283,
    wearable_ids: [265, 354],
  },
  {
    genesis_token_id: 14284,
    wearable_ids: [377, 397],
  },
  {
    genesis_token_id: 14285,
    wearable_ids: [362, 399],
  },
  {
    genesis_token_id: 14286,
    wearable_ids: [436, 306],
  },
  {
    genesis_token_id: 14287,
    wearable_ids: [386, 270],
  },
  {
    genesis_token_id: 14288,
    wearable_ids: [436, 363],
  },
  {
    genesis_token_id: 14289,
    wearable_ids: [395, 262],
  },
  {
    genesis_token_id: 14290,
    wearable_ids: [303, 308],
  },
  {
    genesis_token_id: 14291,
    wearable_ids: [409, 272],
  },
  {
    genesis_token_id: 14292,
    wearable_ids: [412, 262],
  },
  {
    genesis_token_id: 14293,
    wearable_ids: [310, 431],
  },
  {
    genesis_token_id: 14294,
    wearable_ids: [400, 263],
  },
  {
    genesis_token_id: 14295,
    wearable_ids: [372, 248],
  },
  {
    genesis_token_id: 14296,
    wearable_ids: [433, 434],
  },
  {
    genesis_token_id: 14297,
    wearable_ids: [258, 416],
  },
  {
    genesis_token_id: 14298,
    wearable_ids: [431, 308],
  },
  {
    genesis_token_id: 14299,
    wearable_ids: [369, 383],
  },
  {
    genesis_token_id: 14300,
    wearable_ids: [326, 412],
  },
  {
    genesis_token_id: 14301,
    wearable_ids: [352, 351],
  },
  {
    genesis_token_id: 14302,
    wearable_ids: [355, 248],
  },
  {
    genesis_token_id: 14303,
    wearable_ids: [319, 435],
  },
  {
    genesis_token_id: 14304,
    wearable_ids: [332, 315],
  },
  {
    genesis_token_id: 14305,
    wearable_ids: [403, 351],
  },
  {
    genesis_token_id: 14306,
    wearable_ids: [375, 314],
  },
  {
    genesis_token_id: 14307,
    wearable_ids: [399, 445],
  },
  {
    genesis_token_id: 14308,
    wearable_ids: [337, 296],
  },
  {
    genesis_token_id: 14309,
    wearable_ids: [317, 435],
  },
  {
    genesis_token_id: 14310,
    wearable_ids: [299, 326],
  },
  {
    genesis_token_id: 14311,
    wearable_ids: [413, 426],
  },
  {
    genesis_token_id: 14312,
    wearable_ids: [343, 289],
  },
  {
    genesis_token_id: 14313,
    wearable_ids: [342, 339],
  },
  {
    genesis_token_id: 14314,
    wearable_ids: [292, 248],
  },
  {
    genesis_token_id: 14315,
    wearable_ids: [354, 311],
  },
  {
    genesis_token_id: 14316,
    wearable_ids: [292, 435],
  },
  {
    genesis_token_id: 14317,
    wearable_ids: [277, 312],
  },
  {
    genesis_token_id: 14318,
    wearable_ids: [335, 424],
  },
  {
    genesis_token_id: 14319,
    wearable_ids: [413, 369],
  },
  {
    genesis_token_id: 14320,
    wearable_ids: [325, 294],
  },
  {
    genesis_token_id: 14321,
    wearable_ids: [445, 420],
  },
  {
    genesis_token_id: 14322,
    wearable_ids: [317, 365],
  },
  {
    genesis_token_id: 14323,
    wearable_ids: [385, 341],
  },
  {
    genesis_token_id: 14324,
    wearable_ids: [325, 324],
  },
  {
    genesis_token_id: 14325,
    wearable_ids: [316, 437],
  },
  {
    genesis_token_id: 14326,
    wearable_ids: [433, 276],
  },
  {
    genesis_token_id: 14327,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 14328,
    wearable_ids: [420, 341],
  },
  {
    genesis_token_id: 14329,
    wearable_ids: [425, 391],
  },
  {
    genesis_token_id: 14330,
    wearable_ids: [295, 314],
  },
  {
    genesis_token_id: 14331,
    wearable_ids: [339, 444],
  },
  {
    genesis_token_id: 14332,
    wearable_ids: [337, 378],
  },
  {
    genesis_token_id: 14333,
    wearable_ids: [368, 281],
  },
  {
    genesis_token_id: 14334,
    wearable_ids: [259, 274],
  },
  {
    genesis_token_id: 14335,
    wearable_ids: [340, 339],
  },
  {
    genesis_token_id: 14336,
    wearable_ids: [437, 373],
  },
  {
    genesis_token_id: 14337,
    wearable_ids: [443, 400],
  },
  {
    genesis_token_id: 14338,
    wearable_ids: [395, 254],
  },
  {
    genesis_token_id: 14339,
    wearable_ids: [301, 366],
  },
  {
    genesis_token_id: 14340,
    wearable_ids: [292, 423],
  },
  {
    genesis_token_id: 14341,
    wearable_ids: [362, 262],
  },
  {
    genesis_token_id: 14342,
    wearable_ids: [387, 433],
  },
  {
    genesis_token_id: 14343,
    wearable_ids: [436, 310],
  },
  {
    genesis_token_id: 14344,
    wearable_ids: [415, 383],
  },
  {
    genesis_token_id: 14345,
    wearable_ids: [336, 287],
  },
  {
    genesis_token_id: 14346,
    wearable_ids: [341, 351],
  },
  {
    genesis_token_id: 14347,
    wearable_ids: [434, 423],
  },
  {
    genesis_token_id: 14348,
    wearable_ids: [248, 443],
  },
  {
    genesis_token_id: 14349,
    wearable_ids: [423, 374],
  },
  {
    genesis_token_id: 14350,
    wearable_ids: [395, 385],
  },
  {
    genesis_token_id: 14351,
    wearable_ids: [423, 443],
  },
  {
    genesis_token_id: 14352,
    wearable_ids: [317, 408],
  },
  {
    genesis_token_id: 14353,
    wearable_ids: [317, 369],
  },
  {
    genesis_token_id: 14354,
    wearable_ids: [263, 366],
  },
  {
    genesis_token_id: 14355,
    wearable_ids: [437, 412],
  },
  {
    genesis_token_id: 14356,
    wearable_ids: [337, 285],
  },
  {
    genesis_token_id: 14357,
    wearable_ids: [432, 314],
  },
  {
    genesis_token_id: 14358,
    wearable_ids: [270, 318],
  },
  {
    genesis_token_id: 14359,
    wearable_ids: [276, 318],
  },
  {
    genesis_token_id: 14360,
    wearable_ids: [299, 260],
  },
  {
    genesis_token_id: 14361,
    wearable_ids: [308, 299],
  },
  {
    genesis_token_id: 14362,
    wearable_ids: [311, 276],
  },
  {
    genesis_token_id: 14363,
    wearable_ids: [375, 348],
  },
  {
    genesis_token_id: 14364,
    wearable_ids: [420, 347],
  },
  {
    genesis_token_id: 14365,
    wearable_ids: [258, 277],
  },
  {
    genesis_token_id: 14366,
    wearable_ids: [311, 430],
  },
  {
    genesis_token_id: 14367,
    wearable_ids: [412, 301],
  },
  {
    genesis_token_id: 14368,
    wearable_ids: [263, 257],
  },
  {
    genesis_token_id: 14369,
    wearable_ids: [437, 373],
  },
  {
    genesis_token_id: 14370,
    wearable_ids: [325, 262],
  },
  {
    genesis_token_id: 14371,
    wearable_ids: [383, 335],
  },
  {
    genesis_token_id: 14372,
    wearable_ids: [272, 247],
  },
  {
    genesis_token_id: 14373,
    wearable_ids: [324, 445],
  },
  {
    genesis_token_id: 14374,
    wearable_ids: [296, 374],
  },
  {
    genesis_token_id: 14375,
    wearable_ids: [376, 347],
  },
  {
    genesis_token_id: 14376,
    wearable_ids: [341, 274],
  },
  {
    genesis_token_id: 14377,
    wearable_ids: [317, 320],
  },
  {
    genesis_token_id: 14378,
    wearable_ids: [340, 269],
  },
  {
    genesis_token_id: 14379,
    wearable_ids: [258, 410],
  },
  {
    genesis_token_id: 14380,
    wearable_ids: [443, 284],
  },
  {
    genesis_token_id: 14381,
    wearable_ids: [299, 363],
  },
  {
    genesis_token_id: 14382,
    wearable_ids: [319, 295],
  },
  {
    genesis_token_id: 14383,
    wearable_ids: [274, 337],
  },
  {
    genesis_token_id: 14384,
    wearable_ids: [276, 432],
  },
  {
    genesis_token_id: 14385,
    wearable_ids: [265, 342],
  },
  {
    genesis_token_id: 14386,
    wearable_ids: [350, 410],
  },
  {
    genesis_token_id: 14387,
    wearable_ids: [355, 332],
  },
  {
    genesis_token_id: 14388,
    wearable_ids: [332, 269],
  },
  {
    genesis_token_id: 14389,
    wearable_ids: [254, 338],
  },
  {
    genesis_token_id: 14390,
    wearable_ids: [423, 272],
  },
  {
    genesis_token_id: 14391,
    wearable_ids: [335, 349],
  },
  {
    genesis_token_id: 14392,
    wearable_ids: [335, 413],
  },
  {
    genesis_token_id: 14393,
    wearable_ids: [397, 424],
  },
  {
    genesis_token_id: 14394,
    wearable_ids: [434, 295],
  },
  {
    genesis_token_id: 14395,
    wearable_ids: [424, 395],
  },
  {
    genesis_token_id: 14396,
    wearable_ids: [268, 310],
  },
  {
    genesis_token_id: 14397,
    wearable_ids: [276, 364],
  },
  {
    genesis_token_id: 14398,
    wearable_ids: [422, 251],
  },
  {
    genesis_token_id: 14399,
    wearable_ids: [403, 349],
  },
  {
    genesis_token_id: 14400,
    wearable_ids: [254, 370],
  },
  {
    genesis_token_id: 14401,
    wearable_ids: [332, 345],
  },
  {
    genesis_token_id: 14402,
    wearable_ids: [274, 437],
  },
  {
    genesis_token_id: 14403,
    wearable_ids: [306, 310],
  },
  {
    genesis_token_id: 14404,
    wearable_ids: [265, 288],
  },
  {
    genesis_token_id: 14405,
    wearable_ids: [271, 429],
  },
  {
    genesis_token_id: 14406,
    wearable_ids: [420, 296],
  },
  {
    genesis_token_id: 14407,
    wearable_ids: [397, 341],
  },
  {
    genesis_token_id: 14408,
    wearable_ids: [324, 314],
  },
  {
    genesis_token_id: 14409,
    wearable_ids: [409, 348],
  },
  {
    genesis_token_id: 14410,
    wearable_ids: [344, 247],
  },
  {
    genesis_token_id: 14411,
    wearable_ids: [337, 302],
  },
  {
    genesis_token_id: 14412,
    wearable_ids: [423, 350],
  },
  {
    genesis_token_id: 14413,
    wearable_ids: [435, 255],
  },
  {
    genesis_token_id: 14414,
    wearable_ids: [335, 424],
  },
  {
    genesis_token_id: 14415,
    wearable_ids: [407, 424],
  },
  {
    genesis_token_id: 14416,
    wearable_ids: [443, 332],
  },
  {
    genesis_token_id: 14417,
    wearable_ids: [300, 369],
  },
  {
    genesis_token_id: 14418,
    wearable_ids: [324, 298],
  },
  {
    genesis_token_id: 14419,
    wearable_ids: [355, 344],
  },
  {
    genesis_token_id: 14420,
    wearable_ids: [374, 335],
  },
  {
    genesis_token_id: 14421,
    wearable_ids: [371, 424],
  },
  {
    genesis_token_id: 14422,
    wearable_ids: [363, 378],
  },
  {
    genesis_token_id: 14423,
    wearable_ids: [346, 254],
  },
  {
    genesis_token_id: 14424,
    wearable_ids: [382, 352],
  },
  {
    genesis_token_id: 14425,
    wearable_ids: [290, 276],
  },
  {
    genesis_token_id: 14426,
    wearable_ids: [331, 334],
  },
  {
    genesis_token_id: 14427,
    wearable_ids: [409, 429],
  },
  {
    genesis_token_id: 14428,
    wearable_ids: [431, 300],
  },
  {
    genesis_token_id: 14429,
    wearable_ids: [319, 300],
  },
  {
    genesis_token_id: 14430,
    wearable_ids: [294, 415],
  },
  {
    genesis_token_id: 14431,
    wearable_ids: [429, 285],
  },
  {
    genesis_token_id: 14432,
    wearable_ids: [362, 295],
  },
  {
    genesis_token_id: 14433,
    wearable_ids: [263, 313],
  },
  {
    genesis_token_id: 14434,
    wearable_ids: [348, 342],
  },
  {
    genesis_token_id: 14435,
    wearable_ids: [348, 370],
  },
  {
    genesis_token_id: 14436,
    wearable_ids: [289, 375],
  },
  {
    genesis_token_id: 14437,
    wearable_ids: [404, 410],
  },
  {
    genesis_token_id: 14438,
    wearable_ids: [263, 424],
  },
  {
    genesis_token_id: 14439,
    wearable_ids: [303, 256],
  },
  {
    genesis_token_id: 14440,
    wearable_ids: [376, 338],
  },
  {
    genesis_token_id: 14441,
    wearable_ids: [248, 387],
  },
  {
    genesis_token_id: 14442,
    wearable_ids: [351, 436],
  },
  {
    genesis_token_id: 14443,
    wearable_ids: [432, 351],
  },
  {
    genesis_token_id: 14444,
    wearable_ids: [374, 296],
  },
  {
    genesis_token_id: 14445,
    wearable_ids: [276, 389],
  },
  {
    genesis_token_id: 14446,
    wearable_ids: [339, 391],
  },
  {
    genesis_token_id: 14447,
    wearable_ids: [349, 403],
  },
  {
    genesis_token_id: 14448,
    wearable_ids: [434, 445],
  },
  {
    genesis_token_id: 14449,
    wearable_ids: [346, 442],
  },
  {
    genesis_token_id: 14450,
    wearable_ids: [403, 430],
  },
  {
    genesis_token_id: 14451,
    wearable_ids: [396, 375],
  },
  {
    genesis_token_id: 14452,
    wearable_ids: [400, 259],
  },
  {
    genesis_token_id: 14453,
    wearable_ids: [339, 292],
  },
  {
    genesis_token_id: 14454,
    wearable_ids: [409, 300],
  },
  {
    genesis_token_id: 14455,
    wearable_ids: [431, 304],
  },
  {
    genesis_token_id: 14456,
    wearable_ids: [264, 340],
  },
  {
    genesis_token_id: 14457,
    wearable_ids: [436, 357],
  },
  {
    genesis_token_id: 14458,
    wearable_ids: [370, 277],
  },
  {
    genesis_token_id: 14459,
    wearable_ids: [258, 443],
  },
  {
    genesis_token_id: 14460,
    wearable_ids: [396, 302],
  },
  {
    genesis_token_id: 14461,
    wearable_ids: [278, 399],
  },
  {
    genesis_token_id: 14462,
    wearable_ids: [341, 416],
  },
  {
    genesis_token_id: 14463,
    wearable_ids: [276, 406],
  },
  {
    genesis_token_id: 14464,
    wearable_ids: [278, 334],
  },
  {
    genesis_token_id: 14465,
    wearable_ids: [376, 372],
  },
  {
    genesis_token_id: 14466,
    wearable_ids: [271, 287],
  },
  {
    genesis_token_id: 14467,
    wearable_ids: [287, 406],
  },
  {
    genesis_token_id: 14468,
    wearable_ids: [264, 418],
  },
  {
    genesis_token_id: 14469,
    wearable_ids: [423, 431],
  },
  {
    genesis_token_id: 14470,
    wearable_ids: [373, 408],
  },
  {
    genesis_token_id: 14471,
    wearable_ids: [325, 292],
  },
  {
    genesis_token_id: 14472,
    wearable_ids: [425, 299],
  },
  {
    genesis_token_id: 14473,
    wearable_ids: [297, 319],
  },
  {
    genesis_token_id: 14474,
    wearable_ids: [408, 319],
  },
  {
    genesis_token_id: 14475,
    wearable_ids: [383, 318],
  },
  {
    genesis_token_id: 14476,
    wearable_ids: [383, 316],
  },
  {
    genesis_token_id: 14477,
    wearable_ids: [273, 407],
  },
  {
    genesis_token_id: 14478,
    wearable_ids: [399, 379],
  },
  {
    genesis_token_id: 14479,
    wearable_ids: [395, 338],
  },
  {
    genesis_token_id: 14480,
    wearable_ids: [443, 348],
  },
  {
    genesis_token_id: 14481,
    wearable_ids: [268, 303],
  },
  {
    genesis_token_id: 14482,
    wearable_ids: [311, 406],
  },
  {
    genesis_token_id: 14483,
    wearable_ids: [437, 323],
  },
  {
    genesis_token_id: 14484,
    wearable_ids: [314, 289],
  },
  {
    genesis_token_id: 14485,
    wearable_ids: [426, 423],
  },
  {
    genesis_token_id: 14486,
    wearable_ids: [284, 280],
  },
  {
    genesis_token_id: 14487,
    wearable_ids: [426, 297],
  },
  {
    genesis_token_id: 14488,
    wearable_ids: [444, 434],
  },
  {
    genesis_token_id: 14489,
    wearable_ids: [434, 426],
  },
  {
    genesis_token_id: 14490,
    wearable_ids: [355, 338],
  },
  {
    genesis_token_id: 14491,
    wearable_ids: [272, 278],
  },
  {
    genesis_token_id: 14492,
    wearable_ids: [395, 422],
  },
  {
    genesis_token_id: 14493,
    wearable_ids: [426, 335],
  },
  {
    genesis_token_id: 14494,
    wearable_ids: [410, 311],
  },
  {
    genesis_token_id: 14495,
    wearable_ids: [299, 373],
  },
  {
    genesis_token_id: 14496,
    wearable_ids: [311, 399],
  },
  {
    genesis_token_id: 14497,
    wearable_ids: [411, 346],
  },
  {
    genesis_token_id: 14498,
    wearable_ids: [325, 332],
  },
  {
    genesis_token_id: 14499,
    wearable_ids: [412, 253],
  },
  {
    genesis_token_id: 14500,
    wearable_ids: [319, 410],
  },
  {
    genesis_token_id: 14501,
    wearable_ids: [341, 287],
  },
  {
    genesis_token_id: 14502,
    wearable_ids: [444, 246],
  },
  {
    genesis_token_id: 14503,
    wearable_ids: [331, 264],
  },
  {
    genesis_token_id: 14504,
    wearable_ids: [264, 413],
  },
  {
    genesis_token_id: 14505,
    wearable_ids: [262, 429],
  },
  {
    genesis_token_id: 14506,
    wearable_ids: [346, 248],
  },
  {
    genesis_token_id: 14507,
    wearable_ids: [338, 401],
  },
  {
    genesis_token_id: 14508,
    wearable_ids: [272, 278],
  },
  {
    genesis_token_id: 14509,
    wearable_ids: [363, 303],
  },
  {
    genesis_token_id: 14510,
    wearable_ids: [346, 418],
  },
  {
    genesis_token_id: 14511,
    wearable_ids: [336, 284],
  },
  {
    genesis_token_id: 14512,
    wearable_ids: [384, 319],
  },
  {
    genesis_token_id: 14513,
    wearable_ids: [336, 363],
  },
  {
    genesis_token_id: 14514,
    wearable_ids: [304, 429],
  },
  {
    genesis_token_id: 14515,
    wearable_ids: [263, 271],
  },
  {
    genesis_token_id: 14516,
    wearable_ids: [373, 384],
  },
  {
    genesis_token_id: 14517,
    wearable_ids: [325, 426],
  },
  {
    genesis_token_id: 14518,
    wearable_ids: [377, 368],
  },
  {
    genesis_token_id: 14519,
    wearable_ids: [259, 343],
  },
  {
    genesis_token_id: 14520,
    wearable_ids: [377, 431],
  },
  {
    genesis_token_id: 14521,
    wearable_ids: [428, 431],
  },
  {
    genesis_token_id: 14522,
    wearable_ids: [265, 304],
  },
  {
    genesis_token_id: 14523,
    wearable_ids: [335, 429],
  },
  {
    genesis_token_id: 14524,
    wearable_ids: [337, 312],
  },
  {
    genesis_token_id: 14525,
    wearable_ids: [377, 407],
  },
  {
    genesis_token_id: 14526,
    wearable_ids: [382, 407],
  },
  {
    genesis_token_id: 14527,
    wearable_ids: [445, 410],
  },
  {
    genesis_token_id: 14528,
    wearable_ids: [385, 270],
  },
  {
    genesis_token_id: 14529,
    wearable_ids: [436, 258],
  },
  {
    genesis_token_id: 14530,
    wearable_ids: [340, 375],
  },
  {
    genesis_token_id: 14531,
    wearable_ids: [368, 261],
  },
  {
    genesis_token_id: 14532,
    wearable_ids: [301, 340],
  },
  {
    genesis_token_id: 14533,
    wearable_ids: [351, 433],
  },
  {
    genesis_token_id: 14534,
    wearable_ids: [426, 294],
  },
  {
    genesis_token_id: 14535,
    wearable_ids: [337, 294],
  },
  {
    genesis_token_id: 14536,
    wearable_ids: [310, 281],
  },
  {
    genesis_token_id: 14537,
    wearable_ids: [254, 377],
  },
  {
    genesis_token_id: 14538,
    wearable_ids: [257, 395],
  },
  {
    genesis_token_id: 14539,
    wearable_ids: [253, 356],
  },
  {
    genesis_token_id: 14540,
    wearable_ids: [355, 307],
  },
  {
    genesis_token_id: 14541,
    wearable_ids: [355, 383],
  },
  {
    genesis_token_id: 14542,
    wearable_ids: [287, 429],
  },
  {
    genesis_token_id: 14543,
    wearable_ids: [253, 261],
  },
  {
    genesis_token_id: 14544,
    wearable_ids: [253, 274],
  },
  {
    genesis_token_id: 14545,
    wearable_ids: [429, 296],
  },
  {
    genesis_token_id: 14546,
    wearable_ids: [444, 359],
  },
  {
    genesis_token_id: 14547,
    wearable_ids: [396, 294],
  },
  {
    genesis_token_id: 14548,
    wearable_ids: [377, 340],
  },
  {
    genesis_token_id: 14549,
    wearable_ids: [376, 304],
  },
  {
    genesis_token_id: 14550,
    wearable_ids: [258, 289],
  },
  {
    genesis_token_id: 14551,
    wearable_ids: [266, 279],
  },
  {
    genesis_token_id: 14552,
    wearable_ids: [433, 280],
  },
  {
    genesis_token_id: 14553,
    wearable_ids: [370, 290],
  },
  {
    genesis_token_id: 14554,
    wearable_ids: [303, 248],
  },
  {
    genesis_token_id: 14555,
    wearable_ids: [426, 250],
  },
  {
    genesis_token_id: 14556,
    wearable_ids: [258, 442],
  },
  {
    genesis_token_id: 14557,
    wearable_ids: [354, 368],
  },
  {
    genesis_token_id: 14558,
    wearable_ids: [295, 273],
  },
  {
    genesis_token_id: 14559,
    wearable_ids: [337, 295],
  },
  {
    genesis_token_id: 14560,
    wearable_ids: [378, 404],
  },
  {
    genesis_token_id: 14561,
    wearable_ids: [344, 294],
  },
  {
    genesis_token_id: 14562,
    wearable_ids: [404, 296],
  },
  {
    genesis_token_id: 14563,
    wearable_ids: [413, 256],
  },
  {
    genesis_token_id: 14564,
    wearable_ids: [403, 388],
  },
  {
    genesis_token_id: 14565,
    wearable_ids: [265, 314],
  },
  {
    genesis_token_id: 14566,
    wearable_ids: [339, 299],
  },
  {
    genesis_token_id: 14567,
    wearable_ids: [445, 262],
  },
  {
    genesis_token_id: 14568,
    wearable_ids: [342, 364],
  },
  {
    genesis_token_id: 14569,
    wearable_ids: [429, 414],
  },
  {
    genesis_token_id: 14570,
    wearable_ids: [291, 406],
  },
  {
    genesis_token_id: 14571,
    wearable_ids: [265, 295],
  },
  {
    genesis_token_id: 14572,
    wearable_ids: [301, 420],
  },
  {
    genesis_token_id: 14573,
    wearable_ids: [411, 437],
  },
  {
    genesis_token_id: 14574,
    wearable_ids: [286, 323],
  },
  {
    genesis_token_id: 14575,
    wearable_ids: [286, 340],
  },
  {
    genesis_token_id: 14576,
    wearable_ids: [297, 370],
  },
  {
    genesis_token_id: 14577,
    wearable_ids: [404, 342],
  },
  {
    genesis_token_id: 14578,
    wearable_ids: [289, 294],
  },
  {
    genesis_token_id: 14579,
    wearable_ids: [292, 297],
  },
  {
    genesis_token_id: 14580,
    wearable_ids: [432, 422],
  },
  {
    genesis_token_id: 14581,
    wearable_ids: [383, 358],
  },
  {
    genesis_token_id: 14582,
    wearable_ids: [385, 347],
  },
  {
    genesis_token_id: 14583,
    wearable_ids: [256, 354],
  },
  {
    genesis_token_id: 14584,
    wearable_ids: [371, 261],
  },
  {
    genesis_token_id: 14585,
    wearable_ids: [266, 420],
  },
  {
    genesis_token_id: 14586,
    wearable_ids: [289, 251],
  },
  {
    genesis_token_id: 14587,
    wearable_ids: [407, 296],
  },
  {
    genesis_token_id: 14588,
    wearable_ids: [271, 289],
  },
  {
    genesis_token_id: 14589,
    wearable_ids: [264, 371],
  },
  {
    genesis_token_id: 14590,
    wearable_ids: [437, 266],
  },
  {
    genesis_token_id: 14591,
    wearable_ids: [404, 300],
  },
  {
    genesis_token_id: 14592,
    wearable_ids: [408, 432],
  },
  {
    genesis_token_id: 14593,
    wearable_ids: [301, 251],
  },
  {
    genesis_token_id: 14594,
    wearable_ids: [385, 350],
  },
  {
    genesis_token_id: 14595,
    wearable_ids: [262, 379],
  },
  {
    genesis_token_id: 14596,
    wearable_ids: [431, 356],
  },
  {
    genesis_token_id: 14597,
    wearable_ids: [373, 262],
  },
  {
    genesis_token_id: 14598,
    wearable_ids: [423, 291],
  },
  {
    genesis_token_id: 14599,
    wearable_ids: [259, 344],
  },
  {
    genesis_token_id: 14600,
    wearable_ids: [276, 357],
  },
  {
    genesis_token_id: 14601,
    wearable_ids: [435, 258],
  },
  {
    genesis_token_id: 14602,
    wearable_ids: [277, 308],
  },
  {
    genesis_token_id: 14603,
    wearable_ids: [396, 360],
  },
  {
    genesis_token_id: 14604,
    wearable_ids: [429, 308],
  },
  {
    genesis_token_id: 14605,
    wearable_ids: [434, 302],
  },
  {
    genesis_token_id: 14606,
    wearable_ids: [274, 265],
  },
  {
    genesis_token_id: 14607,
    wearable_ids: [304, 303],
  },
  {
    genesis_token_id: 14608,
    wearable_ids: [437, 316],
  },
  {
    genesis_token_id: 14609,
    wearable_ids: [354, 342],
  },
  {
    genesis_token_id: 14610,
    wearable_ids: [347, 316],
  },
  {
    genesis_token_id: 14611,
    wearable_ids: [268, 431],
  },
  {
    genesis_token_id: 14612,
    wearable_ids: [287, 400],
  },
  {
    genesis_token_id: 14613,
    wearable_ids: [317, 335],
  },
  {
    genesis_token_id: 14614,
    wearable_ids: [445, 312],
  },
  {
    genesis_token_id: 14615,
    wearable_ids: [289, 433],
  },
  {
    genesis_token_id: 14616,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 14617,
    wearable_ids: [340, 376],
  },
  {
    genesis_token_id: 14618,
    wearable_ids: [294, 249],
  },
  {
    genesis_token_id: 14619,
    wearable_ids: [426, 382],
  },
  {
    genesis_token_id: 14620,
    wearable_ids: [273, 276],
  },
  {
    genesis_token_id: 14621,
    wearable_ids: [256, 377],
  },
  {
    genesis_token_id: 14622,
    wearable_ids: [433, 444],
  },
  {
    genesis_token_id: 14623,
    wearable_ids: [385, 368],
  },
  {
    genesis_token_id: 14624,
    wearable_ids: [372, 340],
  },
  {
    genesis_token_id: 14625,
    wearable_ids: [319, 288],
  },
  {
    genesis_token_id: 14626,
    wearable_ids: [314, 350],
  },
  {
    genesis_token_id: 14627,
    wearable_ids: [266, 324],
  },
  {
    genesis_token_id: 14628,
    wearable_ids: [295, 407],
  },
  {
    genesis_token_id: 14629,
    wearable_ids: [264, 271],
  },
  {
    genesis_token_id: 14630,
    wearable_ids: [409, 274],
  },
  {
    genesis_token_id: 14631,
    wearable_ids: [289, 443],
  },
  {
    genesis_token_id: 14632,
    wearable_ids: [352, 267],
  },
  {
    genesis_token_id: 14633,
    wearable_ids: [372, 377],
  },
  {
    genesis_token_id: 14634,
    wearable_ids: [290, 257],
  },
  {
    genesis_token_id: 14635,
    wearable_ids: [286, 258],
  },
  {
    genesis_token_id: 14636,
    wearable_ids: [336, 431],
  },
  {
    genesis_token_id: 14637,
    wearable_ids: [291, 286],
  },
  {
    genesis_token_id: 14638,
    wearable_ids: [315, 425],
  },
  {
    genesis_token_id: 14639,
    wearable_ids: [410, 268],
  },
  {
    genesis_token_id: 14640,
    wearable_ids: [415, 375],
  },
  {
    genesis_token_id: 14641,
    wearable_ids: [300, 267],
  },
  {
    genesis_token_id: 14642,
    wearable_ids: [387, 270],
  },
  {
    genesis_token_id: 14643,
    wearable_ids: [422, 348],
  },
  {
    genesis_token_id: 14644,
    wearable_ids: [337, 352],
  },
  {
    genesis_token_id: 14645,
    wearable_ids: [342, 368],
  },
  {
    genesis_token_id: 14646,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 14647,
    wearable_ids: [403, 384],
  },
  {
    genesis_token_id: 14648,
    wearable_ids: [339, 442],
  },
  {
    genesis_token_id: 14649,
    wearable_ids: [349, 332],
  },
  {
    genesis_token_id: 14650,
    wearable_ids: [278, 317],
  },
  {
    genesis_token_id: 14651,
    wearable_ids: [338, 403],
  },
  {
    genesis_token_id: 14652,
    wearable_ids: [310, 404],
  },
  {
    genesis_token_id: 14653,
    wearable_ids: [341, 384],
  },
  {
    genesis_token_id: 14654,
    wearable_ids: [347, 355],
  },
  {
    genesis_token_id: 14655,
    wearable_ids: [258, 319],
  },
  {
    genesis_token_id: 14656,
    wearable_ids: [400, 294],
  },
  {
    genesis_token_id: 14657,
    wearable_ids: [300, 350],
  },
  {
    genesis_token_id: 14658,
    wearable_ids: [384, 250],
  },
  {
    genesis_token_id: 14659,
    wearable_ids: [354, 394],
  },
  {
    genesis_token_id: 14660,
    wearable_ids: [404, 382],
  },
  {
    genesis_token_id: 14661,
    wearable_ids: [284, 368],
  },
  {
    genesis_token_id: 14662,
    wearable_ids: [355, 258],
  },
  {
    genesis_token_id: 14663,
    wearable_ids: [346, 291],
  },
  {
    genesis_token_id: 14664,
    wearable_ids: [311, 278],
  },
  {
    genesis_token_id: 14665,
    wearable_ids: [274, 428],
  },
  {
    genesis_token_id: 14666,
    wearable_ids: [412, 398],
  },
  {
    genesis_token_id: 14667,
    wearable_ids: [374, 356],
  },
  {
    genesis_token_id: 14668,
    wearable_ids: [375, 438],
  },
  {
    genesis_token_id: 14669,
    wearable_ids: [428, 426],
  },
  {
    genesis_token_id: 14670,
    wearable_ids: [306, 411],
  },
  {
    genesis_token_id: 14671,
    wearable_ids: [412, 304],
  },
  {
    genesis_token_id: 14672,
    wearable_ids: [340, 261],
  },
  {
    genesis_token_id: 14673,
    wearable_ids: [266, 418],
  },
  {
    genesis_token_id: 14674,
    wearable_ids: [272, 291],
  },
  {
    genesis_token_id: 14675,
    wearable_ids: [435, 348],
  },
  {
    genesis_token_id: 14676,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 14677,
    wearable_ids: [386, 327],
  },
  {
    genesis_token_id: 14678,
    wearable_ids: [373, 423],
  },
  {
    genesis_token_id: 14679,
    wearable_ids: [395, 271],
  },
  {
    genesis_token_id: 14680,
    wearable_ids: [308, 379],
  },
  {
    genesis_token_id: 14681,
    wearable_ids: [355, 372],
  },
  {
    genesis_token_id: 14682,
    wearable_ids: [428, 354],
  },
  {
    genesis_token_id: 14683,
    wearable_ids: [429, 431],
  },
  {
    genesis_token_id: 14684,
    wearable_ids: [370, 336],
  },
  {
    genesis_token_id: 14685,
    wearable_ids: [384, 399],
  },
  {
    genesis_token_id: 14686,
    wearable_ids: [262, 435],
  },
  {
    genesis_token_id: 14687,
    wearable_ids: [365, 444],
  },
  {
    genesis_token_id: 14688,
    wearable_ids: [257, 304],
  },
  {
    genesis_token_id: 14689,
    wearable_ids: [373, 415],
  },
  {
    genesis_token_id: 14690,
    wearable_ids: [370, 319],
  },
  {
    genesis_token_id: 14691,
    wearable_ids: [415, 433],
  },
  {
    genesis_token_id: 14692,
    wearable_ids: [251, 373],
  },
  {
    genesis_token_id: 14693,
    wearable_ids: [255, 297],
  },
  {
    genesis_token_id: 14694,
    wearable_ids: [363, 379],
  },
  {
    genesis_token_id: 14695,
    wearable_ids: [292, 407],
  },
  {
    genesis_token_id: 14696,
    wearable_ids: [280, 406],
  },
  {
    genesis_token_id: 14697,
    wearable_ids: [299, 248],
  },
  {
    genesis_token_id: 14698,
    wearable_ids: [403, 374],
  },
  {
    genesis_token_id: 14699,
    wearable_ids: [257, 272],
  },
  {
    genesis_token_id: 14700,
    wearable_ids: [385, 316],
  },
  {
    genesis_token_id: 14701,
    wearable_ids: [346, 382],
  },
  {
    genesis_token_id: 14702,
    wearable_ids: [413, 267],
  },
  {
    genesis_token_id: 14703,
    wearable_ids: [303, 351],
  },
  {
    genesis_token_id: 14704,
    wearable_ids: [428, 284],
  },
  {
    genesis_token_id: 14705,
    wearable_ids: [304, 413],
  },
  {
    genesis_token_id: 14706,
    wearable_ids: [376, 326],
  },
  {
    genesis_token_id: 14707,
    wearable_ids: [425, 341],
  },
  {
    genesis_token_id: 14708,
    wearable_ids: [262, 371],
  },
  {
    genesis_token_id: 14709,
    wearable_ids: [262, 408],
  },
  {
    genesis_token_id: 14710,
    wearable_ids: [276, 337],
  },
  {
    genesis_token_id: 14711,
    wearable_ids: [270, 414],
  },
  {
    genesis_token_id: 14712,
    wearable_ids: [332, 373],
  },
  {
    genesis_token_id: 14713,
    wearable_ids: [374, 351],
  },
  {
    genesis_token_id: 14714,
    wearable_ids: [296, 443],
  },
  {
    genesis_token_id: 14715,
    wearable_ids: [325, 317],
  },
  {
    genesis_token_id: 14716,
    wearable_ids: [315, 373],
  },
  {
    genesis_token_id: 14717,
    wearable_ids: [422, 368],
  },
  {
    genesis_token_id: 14718,
    wearable_ids: [340, 352],
  },
  {
    genesis_token_id: 14719,
    wearable_ids: [376, 306],
  },
  {
    genesis_token_id: 14720,
    wearable_ids: [350, 322],
  },
  {
    genesis_token_id: 14721,
    wearable_ids: [372, 436],
  },
  {
    genesis_token_id: 14722,
    wearable_ids: [428, 425],
  },
  {
    genesis_token_id: 14723,
    wearable_ids: [434, 264],
  },
  {
    genesis_token_id: 14724,
    wearable_ids: [280, 375],
  },
  {
    genesis_token_id: 14725,
    wearable_ids: [310, 313],
  },
  {
    genesis_token_id: 14726,
    wearable_ids: [342, 327],
  },
  {
    genesis_token_id: 14727,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 14728,
    wearable_ids: [348, 258],
  },
  {
    genesis_token_id: 14729,
    wearable_ids: [342, 406],
  },
  {
    genesis_token_id: 14730,
    wearable_ids: [265, 373],
  },
  {
    genesis_token_id: 14731,
    wearable_ids: [295, 265],
  },
  {
    genesis_token_id: 14732,
    wearable_ids: [289, 283],
  },
  {
    genesis_token_id: 14733,
    wearable_ids: [338, 387],
  },
  {
    genesis_token_id: 14734,
    wearable_ids: [369, 339],
  },
  {
    genesis_token_id: 14735,
    wearable_ids: [308, 371],
  },
  {
    genesis_token_id: 14736,
    wearable_ids: [341, 336],
  },
  {
    genesis_token_id: 14737,
    wearable_ids: [376, 430],
  },
  {
    genesis_token_id: 14738,
    wearable_ids: [287, 445],
  },
  {
    genesis_token_id: 14739,
    wearable_ids: [445, 266],
  },
  {
    genesis_token_id: 14740,
    wearable_ids: [337, 272],
  },
  {
    genesis_token_id: 14741,
    wearable_ids: [349, 369],
  },
  {
    genesis_token_id: 14742,
    wearable_ids: [445, 254],
  },
  {
    genesis_token_id: 14743,
    wearable_ids: [304, 253],
  },
  {
    genesis_token_id: 14744,
    wearable_ids: [428, 341],
  },
  {
    genesis_token_id: 14745,
    wearable_ids: [251, 286],
  },
  {
    genesis_token_id: 14746,
    wearable_ids: [395, 372],
  },
  {
    genesis_token_id: 14747,
    wearable_ids: [255, 256],
  },
  {
    genesis_token_id: 14748,
    wearable_ids: [363, 410],
  },
  {
    genesis_token_id: 14749,
    wearable_ids: [369, 296],
  },
  {
    genesis_token_id: 14750,
    wearable_ids: [341, 435],
  },
  {
    genesis_token_id: 14751,
    wearable_ids: [317, 286],
  },
  {
    genesis_token_id: 14752,
    wearable_ids: [338, 402],
  },
  {
    genesis_token_id: 14753,
    wearable_ids: [348, 347],
  },
  {
    genesis_token_id: 14754,
    wearable_ids: [406, 254],
  },
  {
    genesis_token_id: 14755,
    wearable_ids: [347, 335],
  },
  {
    genesis_token_id: 14756,
    wearable_ids: [296, 442],
  },
  {
    genesis_token_id: 14757,
    wearable_ids: [324, 288],
  },
  {
    genesis_token_id: 14758,
    wearable_ids: [349, 431],
  },
  {
    genesis_token_id: 14759,
    wearable_ids: [315, 431],
  },
  {
    genesis_token_id: 14760,
    wearable_ids: [403, 344],
  },
  {
    genesis_token_id: 14761,
    wearable_ids: [272, 293],
  },
  {
    genesis_token_id: 14762,
    wearable_ids: [425, 373],
  },
  {
    genesis_token_id: 14763,
    wearable_ids: [437, 313],
  },
  {
    genesis_token_id: 14764,
    wearable_ids: [290, 342],
  },
  {
    genesis_token_id: 14765,
    wearable_ids: [364, 366],
  },
  {
    genesis_token_id: 14766,
    wearable_ids: [276, 277],
  },
  {
    genesis_token_id: 14767,
    wearable_ids: [325, 315],
  },
  {
    genesis_token_id: 14768,
    wearable_ids: [389, 383],
  },
  {
    genesis_token_id: 14769,
    wearable_ids: [349, 370],
  },
  {
    genesis_token_id: 14770,
    wearable_ids: [332, 331],
  },
  {
    genesis_token_id: 14771,
    wearable_ids: [347, 344],
  },
  {
    genesis_token_id: 14772,
    wearable_ids: [425, 370],
  },
  {
    genesis_token_id: 14773,
    wearable_ids: [317, 310],
  },
  {
    genesis_token_id: 14774,
    wearable_ids: [415, 285],
  },
  {
    genesis_token_id: 14775,
    wearable_ids: [316, 387],
  },
  {
    genesis_token_id: 14776,
    wearable_ids: [276, 286],
  },
  {
    genesis_token_id: 14777,
    wearable_ids: [265, 363],
  },
  {
    genesis_token_id: 14778,
    wearable_ids: [326, 290],
  },
  {
    genesis_token_id: 14779,
    wearable_ids: [277, 304],
  },
  {
    genesis_token_id: 14780,
    wearable_ids: [352, 276],
  },
  {
    genesis_token_id: 14781,
    wearable_ids: [407, 311],
  },
  {
    genesis_token_id: 14782,
    wearable_ids: [435, 305],
  },
  {
    genesis_token_id: 14783,
    wearable_ids: [248, 411],
  },
  {
    genesis_token_id: 14784,
    wearable_ids: [319, 294],
  },
  {
    genesis_token_id: 14785,
    wearable_ids: [424, 284],
  },
  {
    genesis_token_id: 14786,
    wearable_ids: [426, 406],
  },
  {
    genesis_token_id: 14787,
    wearable_ids: [268, 304],
  },
  {
    genesis_token_id: 14788,
    wearable_ids: [247, 443],
  },
  {
    genesis_token_id: 14789,
    wearable_ids: [424, 406],
  },
  {
    genesis_token_id: 14790,
    wearable_ids: [270, 434],
  },
  {
    genesis_token_id: 14791,
    wearable_ids: [337, 406],
  },
  {
    genesis_token_id: 14792,
    wearable_ids: [364, 425],
  },
  {
    genesis_token_id: 14793,
    wearable_ids: [395, 428],
  },
  {
    genesis_token_id: 14794,
    wearable_ids: [396, 357],
  },
  {
    genesis_token_id: 14795,
    wearable_ids: [396, 413],
  },
  {
    genesis_token_id: 14796,
    wearable_ids: [368, 422],
  },
  {
    genesis_token_id: 14797,
    wearable_ids: [290, 351],
  },
  {
    genesis_token_id: 14798,
    wearable_ids: [386, 424],
  },
  {
    genesis_token_id: 14799,
    wearable_ids: [257, 382],
  },
  {
    genesis_token_id: 14800,
    wearable_ids: [338, 364],
  },
  {
    genesis_token_id: 14801,
    wearable_ids: [426, 423],
  },
  {
    genesis_token_id: 14802,
    wearable_ids: [368, 394],
  },
  {
    genesis_token_id: 14803,
    wearable_ids: [339, 414],
  },
  {
    genesis_token_id: 14804,
    wearable_ids: [443, 353],
  },
  {
    genesis_token_id: 14805,
    wearable_ids: [303, 349],
  },
  {
    genesis_token_id: 14806,
    wearable_ids: [292, 319],
  },
  {
    genesis_token_id: 14807,
    wearable_ids: [258, 401],
  },
  {
    genesis_token_id: 14808,
    wearable_ids: [431, 284],
  },
  {
    genesis_token_id: 14809,
    wearable_ids: [277, 424],
  },
  {
    genesis_token_id: 14810,
    wearable_ids: [399, 315],
  },
  {
    genesis_token_id: 14811,
    wearable_ids: [251, 281],
  },
  {
    genesis_token_id: 14812,
    wearable_ids: [425, 338],
  },
  {
    genesis_token_id: 14813,
    wearable_ids: [442, 280],
  },
  {
    genesis_token_id: 14814,
    wearable_ids: [408, 337],
  },
  {
    genesis_token_id: 14815,
    wearable_ids: [378, 285],
  },
  {
    genesis_token_id: 14816,
    wearable_ids: [316, 270],
  },
  {
    genesis_token_id: 14817,
    wearable_ids: [287, 259],
  },
  {
    genesis_token_id: 14818,
    wearable_ids: [406, 261],
  },
  {
    genesis_token_id: 14819,
    wearable_ids: [325, 324],
  },
  {
    genesis_token_id: 14820,
    wearable_ids: [412, 292],
  },
  {
    genesis_token_id: 14821,
    wearable_ids: [373, 247],
  },
  {
    genesis_token_id: 14822,
    wearable_ids: [376, 337],
  },
  {
    genesis_token_id: 14823,
    wearable_ids: [365, 290],
  },
  {
    genesis_token_id: 14824,
    wearable_ids: [409, 266],
  },
  {
    genesis_token_id: 14825,
    wearable_ids: [314, 279],
  },
  {
    genesis_token_id: 14826,
    wearable_ids: [317, 385],
  },
  {
    genesis_token_id: 14827,
    wearable_ids: [259, 286],
  },
  {
    genesis_token_id: 14828,
    wearable_ids: [352, 397],
  },
  {
    genesis_token_id: 14829,
    wearable_ids: [277, 268],
  },
  {
    genesis_token_id: 14830,
    wearable_ids: [266, 415],
  },
  {
    genesis_token_id: 14831,
    wearable_ids: [248, 420],
  },
  {
    genesis_token_id: 14832,
    wearable_ids: [445, 250],
  },
  {
    genesis_token_id: 14833,
    wearable_ids: [355, 403],
  },
  {
    genesis_token_id: 14834,
    wearable_ids: [385, 403],
  },
  {
    genesis_token_id: 14835,
    wearable_ids: [297, 399],
  },
  {
    genesis_token_id: 14836,
    wearable_ids: [344, 272],
  },
  {
    genesis_token_id: 14837,
    wearable_ids: [338, 391],
  },
  {
    genesis_token_id: 14838,
    wearable_ids: [284, 369],
  },
  {
    genesis_token_id: 14839,
    wearable_ids: [444, 422],
  },
  {
    genesis_token_id: 14840,
    wearable_ids: [437, 294],
  },
  {
    genesis_token_id: 14841,
    wearable_ids: [311, 429],
  },
  {
    genesis_token_id: 14842,
    wearable_ids: [368, 316],
  },
  {
    genesis_token_id: 14843,
    wearable_ids: [436, 254],
  },
  {
    genesis_token_id: 14844,
    wearable_ids: [383, 258],
  },
  {
    genesis_token_id: 14845,
    wearable_ids: [375, 263],
  },
  {
    genesis_token_id: 14846,
    wearable_ids: [374, 343],
  },
  {
    genesis_token_id: 14847,
    wearable_ids: [374, 341],
  },
  {
    genesis_token_id: 14848,
    wearable_ids: [306, 261],
  },
  {
    genesis_token_id: 14849,
    wearable_ids: [350, 324],
  },
  {
    genesis_token_id: 14850,
    wearable_ids: [344, 436],
  },
  {
    genesis_token_id: 14851,
    wearable_ids: [431, 377],
  },
  {
    genesis_token_id: 14852,
    wearable_ids: [268, 366],
  },
  {
    genesis_token_id: 14853,
    wearable_ids: [259, 248],
  },
  {
    genesis_token_id: 14854,
    wearable_ids: [378, 275],
  },
  {
    genesis_token_id: 14855,
    wearable_ids: [290, 300],
  },
  {
    genesis_token_id: 14856,
    wearable_ids: [339, 349],
  },
  {
    genesis_token_id: 14857,
    wearable_ids: [296, 339],
  },
  {
    genesis_token_id: 14858,
    wearable_ids: [368, 275],
  },
  {
    genesis_token_id: 14859,
    wearable_ids: [316, 355],
  },
  {
    genesis_token_id: 14860,
    wearable_ids: [299, 387],
  },
  {
    genesis_token_id: 14861,
    wearable_ids: [337, 434],
  },
  {
    genesis_token_id: 14862,
    wearable_ids: [375, 388],
  },
  {
    genesis_token_id: 14863,
    wearable_ids: [256, 351],
  },
  {
    genesis_token_id: 14864,
    wearable_ids: [290, 403],
  },
  {
    genesis_token_id: 14865,
    wearable_ids: [263, 420],
  },
  {
    genesis_token_id: 14866,
    wearable_ids: [290, 319],
  },
  {
    genesis_token_id: 14867,
    wearable_ids: [376, 395],
  },
  {
    genesis_token_id: 14868,
    wearable_ids: [272, 436],
  },
  {
    genesis_token_id: 14869,
    wearable_ids: [424, 410],
  },
  {
    genesis_token_id: 14870,
    wearable_ids: [253, 263],
  },
  {
    genesis_token_id: 14871,
    wearable_ids: [347, 328],
  },
  {
    genesis_token_id: 14872,
    wearable_ids: [354, 258],
  },
  {
    genesis_token_id: 14873,
    wearable_ids: [410, 310],
  },
  {
    genesis_token_id: 14874,
    wearable_ids: [311, 404],
  },
  {
    genesis_token_id: 14875,
    wearable_ids: [263, 339],
  },
  {
    genesis_token_id: 14876,
    wearable_ids: [253, 346],
  },
  {
    genesis_token_id: 14877,
    wearable_ids: [350, 423],
  },
  {
    genesis_token_id: 14878,
    wearable_ids: [422, 420],
  },
  {
    genesis_token_id: 14879,
    wearable_ids: [429, 286],
  },
  {
    genesis_token_id: 14880,
    wearable_ids: [278, 320],
  },
  {
    genesis_token_id: 14881,
    wearable_ids: [382, 372],
  },
  {
    genesis_token_id: 14882,
    wearable_ids: [434, 353],
  },
  {
    genesis_token_id: 14883,
    wearable_ids: [408, 247],
  },
  {
    genesis_token_id: 14884,
    wearable_ids: [347, 359],
  },
  {
    genesis_token_id: 14885,
    wearable_ids: [389, 269],
  },
  {
    genesis_token_id: 14886,
    wearable_ids: [335, 393],
  },
  {
    genesis_token_id: 14887,
    wearable_ids: [341, 438],
  },
  {
    genesis_token_id: 14888,
    wearable_ids: [347, 362],
  },
  {
    genesis_token_id: 14889,
    wearable_ids: [352, 300],
  },
  {
    genesis_token_id: 14890,
    wearable_ids: [264, 326],
  },
  {
    genesis_token_id: 14891,
    wearable_ids: [303, 396],
  },
  {
    genesis_token_id: 14892,
    wearable_ids: [278, 273],
  },
  {
    genesis_token_id: 14893,
    wearable_ids: [437, 253],
  },
  {
    genesis_token_id: 14894,
    wearable_ids: [272, 408],
  },
  {
    genesis_token_id: 14895,
    wearable_ids: [415, 383],
  },
  {
    genesis_token_id: 14896,
    wearable_ids: [426, 407],
  },
  {
    genesis_token_id: 14897,
    wearable_ids: [304, 294],
  },
  {
    genesis_token_id: 14898,
    wearable_ids: [428, 388],
  },
  {
    genesis_token_id: 14899,
    wearable_ids: [387, 326],
  },
  {
    genesis_token_id: 14900,
    wearable_ids: [372, 345],
  },
  {
    genesis_token_id: 14901,
    wearable_ids: [432, 273],
  },
  {
    genesis_token_id: 14902,
    wearable_ids: [407, 436],
  },
  {
    genesis_token_id: 14903,
    wearable_ids: [352, 303],
  },
  {
    genesis_token_id: 14904,
    wearable_ids: [351, 403],
  },
  {
    genesis_token_id: 14905,
    wearable_ids: [304, 315],
  },
  {
    genesis_token_id: 14906,
    wearable_ids: [413, 255],
  },
  {
    genesis_token_id: 14907,
    wearable_ids: [426, 319],
  },
  {
    genesis_token_id: 14908,
    wearable_ids: [406, 323],
  },
  {
    genesis_token_id: 14909,
    wearable_ids: [431, 392],
  },
  {
    genesis_token_id: 14910,
    wearable_ids: [382, 371],
  },
  {
    genesis_token_id: 14911,
    wearable_ids: [248, 310],
  },
  {
    genesis_token_id: 14912,
    wearable_ids: [377, 434],
  },
  {
    genesis_token_id: 14913,
    wearable_ids: [263, 313],
  },
  {
    genesis_token_id: 14914,
    wearable_ids: [409, 326],
  },
  {
    genesis_token_id: 14915,
    wearable_ids: [376, 300],
  },
  {
    genesis_token_id: 14916,
    wearable_ids: [268, 374],
  },
  {
    genesis_token_id: 14917,
    wearable_ids: [324, 351],
  },
  {
    genesis_token_id: 14918,
    wearable_ids: [276, 345],
  },
  {
    genesis_token_id: 14919,
    wearable_ids: [335, 265],
  },
  {
    genesis_token_id: 14920,
    wearable_ids: [415, 442],
  },
  {
    genesis_token_id: 14921,
    wearable_ids: [386, 258],
  },
  {
    genesis_token_id: 14922,
    wearable_ids: [317, 304],
  },
  {
    genesis_token_id: 14923,
    wearable_ids: [315, 349],
  },
  {
    genesis_token_id: 14924,
    wearable_ids: [354, 261],
  },
  {
    genesis_token_id: 14925,
    wearable_ids: [347, 325],
  },
  {
    genesis_token_id: 14926,
    wearable_ids: [434, 263],
  },
  {
    genesis_token_id: 14927,
    wearable_ids: [278, 344],
  },
  {
    genesis_token_id: 14928,
    wearable_ids: [422, 432],
  },
  {
    genesis_token_id: 14929,
    wearable_ids: [442, 361],
  },
  {
    genesis_token_id: 14930,
    wearable_ids: [396, 426],
  },
  {
    genesis_token_id: 14931,
    wearable_ids: [266, 267],
  },
  {
    genesis_token_id: 14932,
    wearable_ids: [324, 290],
  },
  {
    genesis_token_id: 14933,
    wearable_ids: [264, 349],
  },
  {
    genesis_token_id: 14934,
    wearable_ids: [341, 331],
  },
  {
    genesis_token_id: 14935,
    wearable_ids: [311, 339],
  },
  {
    genesis_token_id: 14936,
    wearable_ids: [259, 354],
  },
  {
    genesis_token_id: 14937,
    wearable_ids: [319, 301],
  },
  {
    genesis_token_id: 14938,
    wearable_ids: [404, 317],
  },
  {
    genesis_token_id: 14939,
    wearable_ids: [403, 395],
  },
  {
    genesis_token_id: 14940,
    wearable_ids: [348, 424],
  },
  {
    genesis_token_id: 14941,
    wearable_ids: [325, 285],
  },
  {
    genesis_token_id: 14942,
    wearable_ids: [254, 333],
  },
  {
    genesis_token_id: 14943,
    wearable_ids: [274, 406],
  },
  {
    genesis_token_id: 14944,
    wearable_ids: [247, 277],
  },
  {
    genesis_token_id: 14945,
    wearable_ids: [258, 398],
  },
  {
    genesis_token_id: 14946,
    wearable_ids: [349, 383],
  },
  {
    genesis_token_id: 14947,
    wearable_ids: [247, 256],
  },
  {
    genesis_token_id: 14948,
    wearable_ids: [247, 412],
  },
  {
    genesis_token_id: 14949,
    wearable_ids: [256, 267],
  },
  {
    genesis_token_id: 14950,
    wearable_ids: [425, 399],
  },
  {
    genesis_token_id: 14951,
    wearable_ids: [425, 274],
  },
  {
    genesis_token_id: 14952,
    wearable_ids: [286, 442],
  },
  {
    genesis_token_id: 14953,
    wearable_ids: [336, 352],
  },
  {
    genesis_token_id: 14954,
    wearable_ids: [355, 400],
  },
  {
    genesis_token_id: 14955,
    wearable_ids: [335, 283],
  },
  {
    genesis_token_id: 14956,
    wearable_ids: [295, 407],
  },
  {
    genesis_token_id: 14957,
    wearable_ids: [423, 403],
  },
  {
    genesis_token_id: 14958,
    wearable_ids: [431, 382],
  },
  {
    genesis_token_id: 14959,
    wearable_ids: [376, 257],
  },
  {
    genesis_token_id: 14960,
    wearable_ids: [332, 395],
  },
  {
    genesis_token_id: 14961,
    wearable_ids: [289, 320],
  },
  {
    genesis_token_id: 14962,
    wearable_ids: [332, 411],
  },
  {
    genesis_token_id: 14963,
    wearable_ids: [385, 400],
  },
  {
    genesis_token_id: 14964,
    wearable_ids: [259, 360],
  },
  {
    genesis_token_id: 14965,
    wearable_ids: [389, 303],
  },
  {
    genesis_token_id: 14966,
    wearable_ids: [315, 311],
  },
  {
    genesis_token_id: 14967,
    wearable_ids: [350, 254],
  },
  {
    genesis_token_id: 14968,
    wearable_ids: [375, 302],
  },
  {
    genesis_token_id: 14969,
    wearable_ids: [286, 264],
  },
  {
    genesis_token_id: 14970,
    wearable_ids: [423, 258],
  },
  {
    genesis_token_id: 14971,
    wearable_ids: [277, 396],
  },
  {
    genesis_token_id: 14972,
    wearable_ids: [263, 396],
  },
  {
    genesis_token_id: 14973,
    wearable_ids: [257, 315],
  },
  {
    genesis_token_id: 14974,
    wearable_ids: [319, 365],
  },
  {
    genesis_token_id: 14975,
    wearable_ids: [423, 348],
  },
  {
    genesis_token_id: 14976,
    wearable_ids: [272, 283],
  },
  {
    genesis_token_id: 14977,
    wearable_ids: [423, 374],
  },
  {
    genesis_token_id: 14978,
    wearable_ids: [343, 310],
  },
  {
    genesis_token_id: 14979,
    wearable_ids: [317, 336],
  },
  {
    genesis_token_id: 14980,
    wearable_ids: [291, 294],
  },
  {
    genesis_token_id: 14981,
    wearable_ids: [433, 289],
  },
  {
    genesis_token_id: 14982,
    wearable_ids: [304, 402],
  },
  {
    genesis_token_id: 14983,
    wearable_ids: [346, 399],
  },
  {
    genesis_token_id: 14984,
    wearable_ids: [340, 394],
  },
  {
    genesis_token_id: 14985,
    wearable_ids: [376, 307],
  },
  {
    genesis_token_id: 14986,
    wearable_ids: [442, 347],
  },
  {
    genesis_token_id: 14987,
    wearable_ids: [299, 338],
  },
  {
    genesis_token_id: 14988,
    wearable_ids: [342, 308],
  },
  {
    genesis_token_id: 14989,
    wearable_ids: [254, 375],
  },
  {
    genesis_token_id: 14990,
    wearable_ids: [434, 330],
  },
  {
    genesis_token_id: 14991,
    wearable_ids: [294, 339],
  },
  {
    genesis_token_id: 14992,
    wearable_ids: [425, 255],
  },
  {
    genesis_token_id: 14993,
    wearable_ids: [300, 429],
  },
  {
    genesis_token_id: 14994,
    wearable_ids: [426, 349],
  },
  {
    genesis_token_id: 14995,
    wearable_ids: [280, 304],
  },
  {
    genesis_token_id: 14996,
    wearable_ids: [259, 411],
  },
  {
    genesis_token_id: 14997,
    wearable_ids: [387, 287],
  },
  {
    genesis_token_id: 14998,
    wearable_ids: [336, 429],
  },
  {
    genesis_token_id: 14999,
    wearable_ids: [319, 322],
  },
  {
    genesis_token_id: 15000,
    wearable_ids: [341, 274],
  },
  {
    genesis_token_id: 15001,
    wearable_ids: [258, 443],
  },
  {
    genesis_token_id: 15002,
    wearable_ids: [444, 286],
  },
  {
    genesis_token_id: 15003,
    wearable_ids: [424, 268],
  },
  {
    genesis_token_id: 15004,
    wearable_ids: [346, 376],
  },
  {
    genesis_token_id: 15005,
    wearable_ids: [342, 383],
  },
  {
    genesis_token_id: 15006,
    wearable_ids: [385, 428],
  },
  {
    genesis_token_id: 15007,
    wearable_ids: [268, 364],
  },
  {
    genesis_token_id: 15008,
    wearable_ids: [444, 375],
  },
  {
    genesis_token_id: 15009,
    wearable_ids: [387, 304],
  },
  {
    genesis_token_id: 15010,
    wearable_ids: [248, 267],
  },
  {
    genesis_token_id: 15011,
    wearable_ids: [294, 350],
  },
  {
    genesis_token_id: 15012,
    wearable_ids: [338, 443],
  },
  {
    genesis_token_id: 15013,
    wearable_ids: [399, 311],
  },
  {
    genesis_token_id: 15014,
    wearable_ids: [400, 249],
  },
  {
    genesis_token_id: 15015,
    wearable_ids: [311, 295],
  },
  {
    genesis_token_id: 15016,
    wearable_ids: [259, 384],
  },
  {
    genesis_token_id: 15017,
    wearable_ids: [259, 422],
  },
  {
    genesis_token_id: 15018,
    wearable_ids: [271, 331],
  },
  {
    genesis_token_id: 15019,
    wearable_ids: [303, 326],
  },
  {
    genesis_token_id: 15020,
    wearable_ids: [272, 258],
  },
  {
    genesis_token_id: 15021,
    wearable_ids: [371, 369],
  },
  {
    genesis_token_id: 15022,
    wearable_ids: [364, 348],
  },
  {
    genesis_token_id: 15023,
    wearable_ids: [363, 255],
  },
  {
    genesis_token_id: 15024,
    wearable_ids: [338, 354],
  },
  {
    genesis_token_id: 15025,
    wearable_ids: [294, 293],
  },
  {
    genesis_token_id: 15026,
    wearable_ids: [342, 400],
  },
  {
    genesis_token_id: 15027,
    wearable_ids: [386, 364],
  },
  {
    genesis_token_id: 15028,
    wearable_ids: [284, 272],
  },
  {
    genesis_token_id: 15029,
    wearable_ids: [257, 284],
  },
  {
    genesis_token_id: 15030,
    wearable_ids: [256, 246],
  },
  {
    genesis_token_id: 15031,
    wearable_ids: [346, 404],
  },
  {
    genesis_token_id: 15032,
    wearable_ids: [382, 246],
  },
  {
    genesis_token_id: 15033,
    wearable_ids: [434, 292],
  },
  {
    genesis_token_id: 15034,
    wearable_ids: [364, 387],
  },
  {
    genesis_token_id: 15035,
    wearable_ids: [408, 278],
  },
  {
    genesis_token_id: 15036,
    wearable_ids: [248, 424],
  },
  {
    genesis_token_id: 15037,
    wearable_ids: [443, 271],
  },
  {
    genesis_token_id: 15038,
    wearable_ids: [264, 272],
  },
  {
    genesis_token_id: 15039,
    wearable_ids: [349, 273],
  },
  {
    genesis_token_id: 15040,
    wearable_ids: [422, 256],
  },
  {
    genesis_token_id: 15041,
    wearable_ids: [404, 408],
  },
  {
    genesis_token_id: 15042,
    wearable_ids: [377, 434],
  },
  {
    genesis_token_id: 15043,
    wearable_ids: [301, 263],
  },
  {
    genesis_token_id: 15044,
    wearable_ids: [350, 368],
  },
  {
    genesis_token_id: 15045,
    wearable_ids: [280, 384],
  },
  {
    genesis_token_id: 15046,
    wearable_ids: [429, 395],
  },
  {
    genesis_token_id: 15047,
    wearable_ids: [301, 374],
  },
  {
    genesis_token_id: 15048,
    wearable_ids: [295, 272],
  },
  {
    genesis_token_id: 15049,
    wearable_ids: [362, 247],
  },
  {
    genesis_token_id: 15050,
    wearable_ids: [306, 254],
  },
  {
    genesis_token_id: 15051,
    wearable_ids: [310, 410],
  },
  {
    genesis_token_id: 15052,
    wearable_ids: [271, 396],
  },
  {
    genesis_token_id: 15053,
    wearable_ids: [435, 426],
  },
  {
    genesis_token_id: 15054,
    wearable_ids: [424, 389],
  },
  {
    genesis_token_id: 15055,
    wearable_ids: [351, 412],
  },
  {
    genesis_token_id: 15056,
    wearable_ids: [316, 388],
  },
  {
    genesis_token_id: 15057,
    wearable_ids: [422, 407],
  },
  {
    genesis_token_id: 15058,
    wearable_ids: [316, 248],
  },
  {
    genesis_token_id: 15059,
    wearable_ids: [351, 402],
  },
  {
    genesis_token_id: 15060,
    wearable_ids: [396, 308],
  },
  {
    genesis_token_id: 15061,
    wearable_ids: [383, 438],
  },
  {
    genesis_token_id: 15062,
    wearable_ids: [362, 317],
  },
  {
    genesis_token_id: 15063,
    wearable_ids: [368, 426],
  },
  {
    genesis_token_id: 15064,
    wearable_ids: [274, 324],
  },
  {
    genesis_token_id: 15065,
    wearable_ids: [316, 289],
  },
  {
    genesis_token_id: 15066,
    wearable_ids: [420, 372],
  },
  {
    genesis_token_id: 15067,
    wearable_ids: [316, 365],
  },
  {
    genesis_token_id: 15068,
    wearable_ids: [291, 387],
  },
  {
    genesis_token_id: 15069,
    wearable_ids: [272, 342],
  },
  {
    genesis_token_id: 15070,
    wearable_ids: [254, 348],
  },
  {
    genesis_token_id: 15071,
    wearable_ids: [431, 301],
  },
  {
    genesis_token_id: 15072,
    wearable_ids: [437, 316],
  },
  {
    genesis_token_id: 15073,
    wearable_ids: [251, 415],
  },
  {
    genesis_token_id: 15074,
    wearable_ids: [434, 437],
  },
  {
    genesis_token_id: 15075,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 15076,
    wearable_ids: [319, 341],
  },
  {
    genesis_token_id: 15077,
    wearable_ids: [425, 304],
  },
  {
    genesis_token_id: 15078,
    wearable_ids: [259, 363],
  },
  {
    genesis_token_id: 15079,
    wearable_ids: [290, 363],
  },
  {
    genesis_token_id: 15080,
    wearable_ids: [337, 273],
  },
  {
    genesis_token_id: 15081,
    wearable_ids: [291, 255],
  },
  {
    genesis_token_id: 15082,
    wearable_ids: [259, 366],
  },
  {
    genesis_token_id: 15083,
    wearable_ids: [397, 277],
  },
  {
    genesis_token_id: 15084,
    wearable_ids: [403, 266],
  },
  {
    genesis_token_id: 15085,
    wearable_ids: [406, 426],
  },
  {
    genesis_token_id: 15086,
    wearable_ids: [292, 377],
  },
  {
    genesis_token_id: 15087,
    wearable_ids: [255, 385],
  },
  {
    genesis_token_id: 15088,
    wearable_ids: [396, 351],
  },
  {
    genesis_token_id: 15089,
    wearable_ids: [362, 303],
  },
  {
    genesis_token_id: 15090,
    wearable_ids: [350, 409],
  },
  {
    genesis_token_id: 15091,
    wearable_ids: [407, 391],
  },
  {
    genesis_token_id: 15092,
    wearable_ids: [444, 359],
  },
  {
    genesis_token_id: 15093,
    wearable_ids: [423, 348],
  },
  {
    genesis_token_id: 15094,
    wearable_ids: [331, 327],
  },
  {
    genesis_token_id: 15095,
    wearable_ids: [271, 253],
  },
  {
    genesis_token_id: 15096,
    wearable_ids: [340, 304],
  },
  {
    genesis_token_id: 15097,
    wearable_ids: [262, 331],
  },
  {
    genesis_token_id: 15098,
    wearable_ids: [413, 417],
  },
  {
    genesis_token_id: 15099,
    wearable_ids: [287, 283],
  },
  {
    genesis_token_id: 15100,
    wearable_ids: [433, 387],
  },
  {
    genesis_token_id: 15101,
    wearable_ids: [413, 275],
  },
  {
    genesis_token_id: 15102,
    wearable_ids: [400, 306],
  },
  {
    genesis_token_id: 15103,
    wearable_ids: [415, 324],
  },
  {
    genesis_token_id: 15104,
    wearable_ids: [324, 336],
  },
  {
    genesis_token_id: 15105,
    wearable_ids: [432, 425],
  },
  {
    genesis_token_id: 15106,
    wearable_ids: [310, 416],
  },
  {
    genesis_token_id: 15107,
    wearable_ids: [272, 407],
  },
  {
    genesis_token_id: 15108,
    wearable_ids: [355, 403],
  },
  {
    genesis_token_id: 15109,
    wearable_ids: [341, 324],
  },
  {
    genesis_token_id: 15110,
    wearable_ids: [287, 338],
  },
  {
    genesis_token_id: 15111,
    wearable_ids: [435, 442],
  },
  {
    genesis_token_id: 15112,
    wearable_ids: [351, 279],
  },
  {
    genesis_token_id: 15113,
    wearable_ids: [255, 334],
  },
  {
    genesis_token_id: 15114,
    wearable_ids: [270, 374],
  },
  {
    genesis_token_id: 15115,
    wearable_ids: [354, 296],
  },
  {
    genesis_token_id: 15116,
    wearable_ids: [253, 425],
  },
  {
    genesis_token_id: 15117,
    wearable_ids: [424, 285],
  },
  {
    genesis_token_id: 15118,
    wearable_ids: [251, 384],
  },
  {
    genesis_token_id: 15119,
    wearable_ids: [295, 264],
  },
  {
    genesis_token_id: 15120,
    wearable_ids: [262, 400],
  },
  {
    genesis_token_id: 15121,
    wearable_ids: [273, 376],
  },
  {
    genesis_token_id: 15122,
    wearable_ids: [311, 255],
  },
  {
    genesis_token_id: 15123,
    wearable_ids: [432, 389],
  },
  {
    genesis_token_id: 15124,
    wearable_ids: [365, 397],
  },
  {
    genesis_token_id: 15125,
    wearable_ids: [368, 402],
  },
  {
    genesis_token_id: 15126,
    wearable_ids: [382, 254],
  },
  {
    genesis_token_id: 15127,
    wearable_ids: [294, 277],
  },
  {
    genesis_token_id: 15128,
    wearable_ids: [383, 386],
  },
  {
    genesis_token_id: 15129,
    wearable_ids: [268, 292],
  },
  {
    genesis_token_id: 15130,
    wearable_ids: [317, 414],
  },
  {
    genesis_token_id: 15131,
    wearable_ids: [256, 339],
  },
  {
    genesis_token_id: 15132,
    wearable_ids: [375, 440],
  },
  {
    genesis_token_id: 15133,
    wearable_ids: [409, 432],
  },
  {
    genesis_token_id: 15134,
    wearable_ids: [443, 378],
  },
  {
    genesis_token_id: 15135,
    wearable_ids: [254, 388],
  },
  {
    genesis_token_id: 15136,
    wearable_ids: [303, 270],
  },
  {
    genesis_token_id: 15137,
    wearable_ids: [350, 299],
  },
  {
    genesis_token_id: 15138,
    wearable_ids: [371, 285],
  },
  {
    genesis_token_id: 15139,
    wearable_ids: [400, 326],
  },
  {
    genesis_token_id: 15140,
    wearable_ids: [301, 281],
  },
  {
    genesis_token_id: 15141,
    wearable_ids: [373, 386],
  },
  {
    genesis_token_id: 15142,
    wearable_ids: [363, 359],
  },
  {
    genesis_token_id: 15143,
    wearable_ids: [310, 360],
  },
  {
    genesis_token_id: 15144,
    wearable_ids: [278, 333],
  },
  {
    genesis_token_id: 15145,
    wearable_ids: [433, 443],
  },
  {
    genesis_token_id: 15146,
    wearable_ids: [383, 281],
  },
  {
    genesis_token_id: 15147,
    wearable_ids: [352, 410],
  },
  {
    genesis_token_id: 15148,
    wearable_ids: [301, 257],
  },
  {
    genesis_token_id: 15149,
    wearable_ids: [264, 393],
  },
  {
    genesis_token_id: 15150,
    wearable_ids: [300, 342],
  },
  {
    genesis_token_id: 15151,
    wearable_ids: [332, 278],
  },
  {
    genesis_token_id: 15152,
    wearable_ids: [300, 255],
  },
  {
    genesis_token_id: 15153,
    wearable_ids: [385, 433],
  },
  {
    genesis_token_id: 15154,
    wearable_ids: [354, 397],
  },
  {
    genesis_token_id: 15155,
    wearable_ids: [272, 255],
  },
  {
    genesis_token_id: 15156,
    wearable_ids: [265, 376],
  },
  {
    genesis_token_id: 15157,
    wearable_ids: [407, 437],
  },
  {
    genesis_token_id: 15158,
    wearable_ids: [436, 303],
  },
  {
    genesis_token_id: 15159,
    wearable_ids: [372, 422],
  },
  {
    genesis_token_id: 15160,
    wearable_ids: [444, 377],
  },
  {
    genesis_token_id: 15161,
    wearable_ids: [397, 413],
  },
  {
    genesis_token_id: 15162,
    wearable_ids: [376, 423],
  },
  {
    genesis_token_id: 15163,
    wearable_ids: [337, 364],
  },
  {
    genesis_token_id: 15164,
    wearable_ids: [317, 437],
  },
  {
    genesis_token_id: 15165,
    wearable_ids: [413, 326],
  },
  {
    genesis_token_id: 15166,
    wearable_ids: [371, 432],
  },
  {
    genesis_token_id: 15167,
    wearable_ids: [352, 253],
  },
  {
    genesis_token_id: 15168,
    wearable_ids: [369, 327],
  },
  {
    genesis_token_id: 15169,
    wearable_ids: [363, 402],
  },
  {
    genesis_token_id: 15170,
    wearable_ids: [409, 386],
  },
  {
    genesis_token_id: 15171,
    wearable_ids: [270, 376],
  },
  {
    genesis_token_id: 15172,
    wearable_ids: [365, 352],
  },
  {
    genesis_token_id: 15173,
    wearable_ids: [350, 405],
  },
  {
    genesis_token_id: 15174,
    wearable_ids: [374, 258],
  },
  {
    genesis_token_id: 15175,
    wearable_ids: [257, 253],
  },
  {
    genesis_token_id: 15176,
    wearable_ids: [276, 288],
  },
  {
    genesis_token_id: 15177,
    wearable_ids: [270, 355],
  },
  {
    genesis_token_id: 15178,
    wearable_ids: [385, 351],
  },
  {
    genesis_token_id: 15179,
    wearable_ids: [266, 308],
  },
  {
    genesis_token_id: 15180,
    wearable_ids: [399, 353],
  },
  {
    genesis_token_id: 15181,
    wearable_ids: [341, 378],
  },
  {
    genesis_token_id: 15182,
    wearable_ids: [319, 435],
  },
  {
    genesis_token_id: 15183,
    wearable_ids: [277, 364],
  },
  {
    genesis_token_id: 15184,
    wearable_ids: [445, 278],
  },
  {
    genesis_token_id: 15185,
    wearable_ids: [378, 429],
  },
  {
    genesis_token_id: 15186,
    wearable_ids: [431, 299],
  },
  {
    genesis_token_id: 15187,
    wearable_ids: [363, 376],
  },
  {
    genesis_token_id: 15188,
    wearable_ids: [253, 324],
  },
  {
    genesis_token_id: 15189,
    wearable_ids: [422, 247],
  },
  {
    genesis_token_id: 15190,
    wearable_ids: [387, 399],
  },
  {
    genesis_token_id: 15191,
    wearable_ids: [406, 352],
  },
  {
    genesis_token_id: 15192,
    wearable_ids: [422, 406],
  },
  {
    genesis_token_id: 15193,
    wearable_ids: [289, 346],
  },
  {
    genesis_token_id: 15194,
    wearable_ids: [435, 421],
  },
  {
    genesis_token_id: 15195,
    wearable_ids: [370, 384],
  },
  {
    genesis_token_id: 15196,
    wearable_ids: [385, 423],
  },
  {
    genesis_token_id: 15197,
    wearable_ids: [371, 273],
  },
  {
    genesis_token_id: 15198,
    wearable_ids: [424, 361],
  },
  {
    genesis_token_id: 15199,
    wearable_ids: [415, 261],
  },
  {
    genesis_token_id: 15200,
    wearable_ids: [373, 265],
  },
  {
    genesis_token_id: 15201,
    wearable_ids: [385, 370],
  },
  {
    genesis_token_id: 15202,
    wearable_ids: [372, 285],
  },
  {
    genesis_token_id: 15203,
    wearable_ids: [332, 372],
  },
  {
    genesis_token_id: 15204,
    wearable_ids: [371, 436],
  },
  {
    genesis_token_id: 15205,
    wearable_ids: [385, 434],
  },
  {
    genesis_token_id: 15206,
    wearable_ids: [431, 303],
  },
  {
    genesis_token_id: 15207,
    wearable_ids: [339, 371],
  },
  {
    genesis_token_id: 15208,
    wearable_ids: [352, 272],
  },
  {
    genesis_token_id: 15209,
    wearable_ids: [431, 259],
  },
  {
    genesis_token_id: 15210,
    wearable_ids: [331, 445],
  },
  {
    genesis_token_id: 15211,
    wearable_ids: [436, 320],
  },
  {
    genesis_token_id: 15212,
    wearable_ids: [442, 389],
  },
  {
    genesis_token_id: 15213,
    wearable_ids: [363, 261],
  },
  {
    genesis_token_id: 15214,
    wearable_ids: [294, 430],
  },
  {
    genesis_token_id: 15215,
    wearable_ids: [383, 368],
  },
  {
    genesis_token_id: 15216,
    wearable_ids: [443, 382],
  },
  {
    genesis_token_id: 15217,
    wearable_ids: [290, 394],
  },
  {
    genesis_token_id: 15218,
    wearable_ids: [351, 443],
  },
  {
    genesis_token_id: 15219,
    wearable_ids: [435, 388],
  },
  {
    genesis_token_id: 15220,
    wearable_ids: [296, 364],
  },
  {
    genesis_token_id: 15221,
    wearable_ids: [263, 316],
  },
  {
    genesis_token_id: 15222,
    wearable_ids: [265, 284],
  },
  {
    genesis_token_id: 15223,
    wearable_ids: [420, 362],
  },
  {
    genesis_token_id: 15224,
    wearable_ids: [426, 392],
  },
  {
    genesis_token_id: 15225,
    wearable_ids: [374, 260],
  },
  {
    genesis_token_id: 15226,
    wearable_ids: [365, 435],
  },
  {
    genesis_token_id: 15227,
    wearable_ids: [387, 266],
  },
  {
    genesis_token_id: 15228,
    wearable_ids: [336, 350],
  },
  {
    genesis_token_id: 15229,
    wearable_ids: [386, 283],
  },
  {
    genesis_token_id: 15230,
    wearable_ids: [435, 341],
  },
  {
    genesis_token_id: 15231,
    wearable_ids: [268, 437],
  },
  {
    genesis_token_id: 15232,
    wearable_ids: [325, 385],
  },
  {
    genesis_token_id: 15233,
    wearable_ids: [278, 395],
  },
  {
    genesis_token_id: 15234,
    wearable_ids: [274, 275],
  },
  {
    genesis_token_id: 15235,
    wearable_ids: [415, 254],
  },
  {
    genesis_token_id: 15236,
    wearable_ids: [369, 401],
  },
  {
    genesis_token_id: 15237,
    wearable_ids: [264, 344],
  },
  {
    genesis_token_id: 15238,
    wearable_ids: [319, 344],
  },
  {
    genesis_token_id: 15239,
    wearable_ids: [385, 276],
  },
  {
    genesis_token_id: 15240,
    wearable_ids: [278, 290],
  },
  {
    genesis_token_id: 15241,
    wearable_ids: [445, 368],
  },
  {
    genesis_token_id: 15242,
    wearable_ids: [433, 300],
  },
  {
    genesis_token_id: 15243,
    wearable_ids: [425, 302],
  },
  {
    genesis_token_id: 15244,
    wearable_ids: [272, 428],
  },
  {
    genesis_token_id: 15245,
    wearable_ids: [278, 255],
  },
  {
    genesis_token_id: 15246,
    wearable_ids: [412, 271],
  },
  {
    genesis_token_id: 15247,
    wearable_ids: [263, 443],
  },
  {
    genesis_token_id: 15248,
    wearable_ids: [372, 406],
  },
  {
    genesis_token_id: 15249,
    wearable_ids: [274, 386],
  },
  {
    genesis_token_id: 15250,
    wearable_ids: [442, 297],
  },
  {
    genesis_token_id: 15251,
    wearable_ids: [339, 295],
  },
  {
    genesis_token_id: 15252,
    wearable_ids: [316, 332],
  },
  {
    genesis_token_id: 15253,
    wearable_ids: [389, 318],
  },
  {
    genesis_token_id: 15254,
    wearable_ids: [343, 285],
  },
  {
    genesis_token_id: 15255,
    wearable_ids: [387, 257],
  },
  {
    genesis_token_id: 15256,
    wearable_ids: [382, 420],
  },
  {
    genesis_token_id: 15257,
    wearable_ids: [368, 388],
  },
  {
    genesis_token_id: 15258,
    wearable_ids: [404, 360],
  },
  {
    genesis_token_id: 15259,
    wearable_ids: [374, 266],
  },
  {
    genesis_token_id: 15260,
    wearable_ids: [426, 351],
  },
  {
    genesis_token_id: 15261,
    wearable_ids: [420, 268],
  },
  {
    genesis_token_id: 15262,
    wearable_ids: [284, 362],
  },
  {
    genesis_token_id: 15263,
    wearable_ids: [445, 311],
  },
  {
    genesis_token_id: 15264,
    wearable_ids: [400, 411],
  },
  {
    genesis_token_id: 15265,
    wearable_ids: [292, 354],
  },
  {
    genesis_token_id: 15266,
    wearable_ids: [343, 386],
  },
  {
    genesis_token_id: 15267,
    wearable_ids: [277, 322],
  },
  {
    genesis_token_id: 15268,
    wearable_ids: [346, 369],
  },
  {
    genesis_token_id: 15269,
    wearable_ids: [277, 362],
  },
  {
    genesis_token_id: 15270,
    wearable_ids: [375, 376],
  },
  {
    genesis_token_id: 15271,
    wearable_ids: [349, 272],
  },
  {
    genesis_token_id: 15272,
    wearable_ids: [315, 270],
  },
  {
    genesis_token_id: 15273,
    wearable_ids: [365, 395],
  },
  {
    genesis_token_id: 15274,
    wearable_ids: [432, 437],
  },
  {
    genesis_token_id: 15275,
    wearable_ids: [274, 425],
  },
  {
    genesis_token_id: 15276,
    wearable_ids: [352, 426],
  },
  {
    genesis_token_id: 15277,
    wearable_ids: [280, 365],
  },
  {
    genesis_token_id: 15278,
    wearable_ids: [258, 395],
  },
  {
    genesis_token_id: 15279,
    wearable_ids: [434, 302],
  },
  {
    genesis_token_id: 15280,
    wearable_ids: [248, 409],
  },
  {
    genesis_token_id: 15281,
    wearable_ids: [436, 349],
  },
  {
    genesis_token_id: 15282,
    wearable_ids: [397, 362],
  },
  {
    genesis_token_id: 15283,
    wearable_ids: [270, 257],
  },
  {
    genesis_token_id: 15284,
    wearable_ids: [364, 316],
  },
  {
    genesis_token_id: 15285,
    wearable_ids: [347, 355],
  },
  {
    genesis_token_id: 15286,
    wearable_ids: [408, 369],
  },
  {
    genesis_token_id: 15287,
    wearable_ids: [247, 442],
  },
  {
    genesis_token_id: 15288,
    wearable_ids: [286, 341],
  },
  {
    genesis_token_id: 15289,
    wearable_ids: [348, 326],
  },
  {
    genesis_token_id: 15290,
    wearable_ids: [264, 411],
  },
  {
    genesis_token_id: 15291,
    wearable_ids: [383, 370],
  },
  {
    genesis_token_id: 15292,
    wearable_ids: [341, 407],
  },
  {
    genesis_token_id: 15293,
    wearable_ids: [287, 262],
  },
  {
    genesis_token_id: 15294,
    wearable_ids: [284, 420],
  },
  {
    genesis_token_id: 15295,
    wearable_ids: [412, 443],
  },
  {
    genesis_token_id: 15296,
    wearable_ids: [308, 268],
  },
  {
    genesis_token_id: 15297,
    wearable_ids: [254, 256],
  },
  {
    genesis_token_id: 15298,
    wearable_ids: [255, 418],
  },
  {
    genesis_token_id: 15299,
    wearable_ids: [301, 351],
  },
  {
    genesis_token_id: 15300,
    wearable_ids: [429, 248],
  },
  {
    genesis_token_id: 15301,
    wearable_ids: [316, 278],
  },
  {
    genesis_token_id: 15302,
    wearable_ids: [253, 322],
  },
  {
    genesis_token_id: 15303,
    wearable_ids: [377, 301],
  },
  {
    genesis_token_id: 15304,
    wearable_ids: [299, 288],
  },
  {
    genesis_token_id: 15305,
    wearable_ids: [354, 264],
  },
  {
    genesis_token_id: 15306,
    wearable_ids: [253, 405],
  },
  {
    genesis_token_id: 15307,
    wearable_ids: [347, 259],
  },
  {
    genesis_token_id: 15308,
    wearable_ids: [350, 277],
  },
  {
    genesis_token_id: 15309,
    wearable_ids: [314, 275],
  },
  {
    genesis_token_id: 15310,
    wearable_ids: [303, 397],
  },
  {
    genesis_token_id: 15311,
    wearable_ids: [310, 258],
  },
  {
    genesis_token_id: 15312,
    wearable_ids: [336, 274],
  },
  {
    genesis_token_id: 15313,
    wearable_ids: [423, 369],
  },
  {
    genesis_token_id: 15314,
    wearable_ids: [432, 396],
  },
  {
    genesis_token_id: 15315,
    wearable_ids: [420, 372],
  },
  {
    genesis_token_id: 15316,
    wearable_ids: [296, 324],
  },
  {
    genesis_token_id: 15317,
    wearable_ids: [247, 249],
  },
  {
    genesis_token_id: 15318,
    wearable_ids: [296, 336],
  },
  {
    genesis_token_id: 15319,
    wearable_ids: [296, 287],
  },
  {
    genesis_token_id: 15320,
    wearable_ids: [420, 296],
  },
  {
    genesis_token_id: 15321,
    wearable_ids: [339, 268],
  },
  {
    genesis_token_id: 15322,
    wearable_ids: [314, 271],
  },
  {
    genesis_token_id: 15323,
    wearable_ids: [277, 433],
  },
  {
    genesis_token_id: 15324,
    wearable_ids: [276, 310],
  },
  {
    genesis_token_id: 15325,
    wearable_ids: [308, 429],
  },
  {
    genesis_token_id: 15326,
    wearable_ids: [314, 354],
  },
  {
    genesis_token_id: 15327,
    wearable_ids: [444, 303],
  },
  {
    genesis_token_id: 15328,
    wearable_ids: [304, 277],
  },
  {
    genesis_token_id: 15329,
    wearable_ids: [332, 391],
  },
  {
    genesis_token_id: 15330,
    wearable_ids: [297, 395],
  },
  {
    genesis_token_id: 15331,
    wearable_ids: [362, 372],
  },
  {
    genesis_token_id: 15332,
    wearable_ids: [423, 247],
  },
  {
    genesis_token_id: 15333,
    wearable_ids: [436, 339],
  },
  {
    genesis_token_id: 15334,
    wearable_ids: [264, 445],
  },
  {
    genesis_token_id: 15335,
    wearable_ids: [374, 350],
  },
  {
    genesis_token_id: 15336,
    wearable_ids: [375, 364],
  },
  {
    genesis_token_id: 15337,
    wearable_ids: [431, 371],
  },
  {
    genesis_token_id: 15338,
    wearable_ids: [280, 435],
  },
  {
    genesis_token_id: 15339,
    wearable_ids: [443, 404],
  },
  {
    genesis_token_id: 15340,
    wearable_ids: [340, 392],
  },
  {
    genesis_token_id: 15341,
    wearable_ids: [370, 280],
  },
  {
    genesis_token_id: 15342,
    wearable_ids: [383, 373],
  },
  {
    genesis_token_id: 15343,
    wearable_ids: [352, 342],
  },
  {
    genesis_token_id: 15344,
    wearable_ids: [443, 311],
  },
  {
    genesis_token_id: 15345,
    wearable_ids: [311, 360],
  },
  {
    genesis_token_id: 15346,
    wearable_ids: [297, 377],
  },
  {
    genesis_token_id: 15347,
    wearable_ids: [403, 255],
  },
  {
    genesis_token_id: 15348,
    wearable_ids: [445, 278],
  },
  {
    genesis_token_id: 15349,
    wearable_ids: [251, 362],
  },
  {
    genesis_token_id: 15350,
    wearable_ids: [280, 350],
  },
  {
    genesis_token_id: 15351,
    wearable_ids: [420, 253],
  },
  {
    genesis_token_id: 15352,
    wearable_ids: [296, 443],
  },
  {
    genesis_token_id: 15353,
    wearable_ids: [429, 259],
  },
  {
    genesis_token_id: 15354,
    wearable_ids: [295, 331],
  },
  {
    genesis_token_id: 15355,
    wearable_ids: [351, 254],
  },
  {
    genesis_token_id: 15356,
    wearable_ids: [365, 340],
  },
  {
    genesis_token_id: 15357,
    wearable_ids: [303, 249],
  },
  {
    genesis_token_id: 15358,
    wearable_ids: [373, 348],
  },
  {
    genesis_token_id: 15359,
    wearable_ids: [325, 296],
  },
  {
    genesis_token_id: 15360,
    wearable_ids: [408, 303],
  },
  {
    genesis_token_id: 15361,
    wearable_ids: [432, 266],
  },
  {
    genesis_token_id: 15362,
    wearable_ids: [365, 433],
  },
  {
    genesis_token_id: 15363,
    wearable_ids: [347, 383],
  },
  {
    genesis_token_id: 15364,
    wearable_ids: [325, 376],
  },
  {
    genesis_token_id: 15365,
    wearable_ids: [352, 274],
  },
  {
    genesis_token_id: 15366,
    wearable_ids: [407, 349],
  },
  {
    genesis_token_id: 15367,
    wearable_ids: [406, 253],
  },
  {
    genesis_token_id: 15368,
    wearable_ids: [341, 403],
  },
  {
    genesis_token_id: 15369,
    wearable_ids: [284, 411],
  },
  {
    genesis_token_id: 15370,
    wearable_ids: [371, 357],
  },
  {
    genesis_token_id: 15371,
    wearable_ids: [415, 399],
  },
  {
    genesis_token_id: 15372,
    wearable_ids: [344, 309],
  },
  {
    genesis_token_id: 15373,
    wearable_ids: [340, 368],
  },
  {
    genesis_token_id: 15374,
    wearable_ids: [290, 420],
  },
  {
    genesis_token_id: 15375,
    wearable_ids: [384, 270],
  },
  {
    genesis_token_id: 15376,
    wearable_ids: [262, 330],
  },
  {
    genesis_token_id: 15377,
    wearable_ids: [395, 384],
  },
  {
    genesis_token_id: 15378,
    wearable_ids: [403, 254],
  },
  {
    genesis_token_id: 15379,
    wearable_ids: [354, 428],
  },
  {
    genesis_token_id: 15380,
    wearable_ids: [290, 368],
  },
  {
    genesis_token_id: 15381,
    wearable_ids: [422, 346],
  },
  {
    genesis_token_id: 15382,
    wearable_ids: [354, 432],
  },
  {
    genesis_token_id: 15383,
    wearable_ids: [263, 363],
  },
  {
    genesis_token_id: 15384,
    wearable_ids: [270, 397],
  },
  {
    genesis_token_id: 15385,
    wearable_ids: [325, 375],
  },
  {
    genesis_token_id: 15386,
    wearable_ids: [399, 328],
  },
  {
    genesis_token_id: 15387,
    wearable_ids: [277, 341],
  },
  {
    genesis_token_id: 15388,
    wearable_ids: [431, 319],
  },
  {
    genesis_token_id: 15389,
    wearable_ids: [280, 423],
  },
  {
    genesis_token_id: 15390,
    wearable_ids: [349, 300],
  },
  {
    genesis_token_id: 15391,
    wearable_ids: [294, 290],
  },
  {
    genesis_token_id: 15392,
    wearable_ids: [407, 322],
  },
  {
    genesis_token_id: 15393,
    wearable_ids: [257, 364],
  },
  {
    genesis_token_id: 15394,
    wearable_ids: [389, 397],
  },
  {
    genesis_token_id: 15395,
    wearable_ids: [376, 416],
  },
  {
    genesis_token_id: 15396,
    wearable_ids: [338, 256],
  },
  {
    genesis_token_id: 15397,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 15398,
    wearable_ids: [272, 251],
  },
  {
    genesis_token_id: 15399,
    wearable_ids: [429, 289],
  },
  {
    genesis_token_id: 15400,
    wearable_ids: [372, 378],
  },
  {
    genesis_token_id: 15401,
    wearable_ids: [256, 317],
  },
  {
    genesis_token_id: 15402,
    wearable_ids: [443, 265],
  },
  {
    genesis_token_id: 15403,
    wearable_ids: [389, 366],
  },
  {
    genesis_token_id: 15404,
    wearable_ids: [262, 442],
  },
  {
    genesis_token_id: 15405,
    wearable_ids: [265, 301],
  },
  {
    genesis_token_id: 15406,
    wearable_ids: [256, 249],
  },
  {
    genesis_token_id: 15407,
    wearable_ids: [365, 434],
  },
  {
    genesis_token_id: 15408,
    wearable_ids: [432, 385],
  },
  {
    genesis_token_id: 15409,
    wearable_ids: [251, 286],
  },
  {
    genesis_token_id: 15410,
    wearable_ids: [303, 339],
  },
  {
    genesis_token_id: 15411,
    wearable_ids: [397, 262],
  },
  {
    genesis_token_id: 15412,
    wearable_ids: [301, 376],
  },
  {
    genesis_token_id: 15413,
    wearable_ids: [362, 299],
  },
  {
    genesis_token_id: 15414,
    wearable_ids: [354, 353],
  },
  {
    genesis_token_id: 15415,
    wearable_ids: [289, 392],
  },
  {
    genesis_token_id: 15416,
    wearable_ids: [287, 424],
  },
  {
    genesis_token_id: 15417,
    wearable_ids: [425, 400],
  },
  {
    genesis_token_id: 15418,
    wearable_ids: [372, 374],
  },
  {
    genesis_token_id: 15419,
    wearable_ids: [257, 371],
  },
  {
    genesis_token_id: 15420,
    wearable_ids: [324, 425],
  },
  {
    genesis_token_id: 15421,
    wearable_ids: [434, 265],
  },
  {
    genesis_token_id: 15422,
    wearable_ids: [370, 260],
  },
  {
    genesis_token_id: 15423,
    wearable_ids: [263, 371],
  },
  {
    genesis_token_id: 15424,
    wearable_ids: [368, 373],
  },
  {
    genesis_token_id: 15425,
    wearable_ids: [350, 298],
  },
  {
    genesis_token_id: 15426,
    wearable_ids: [292, 259],
  },
  {
    genesis_token_id: 15427,
    wearable_ids: [408, 415],
  },
  {
    genesis_token_id: 15428,
    wearable_ids: [375, 368],
  },
  {
    genesis_token_id: 15429,
    wearable_ids: [254, 395],
  },
  {
    genesis_token_id: 15430,
    wearable_ids: [403, 410],
  },
  {
    genesis_token_id: 15431,
    wearable_ids: [373, 420],
  },
  {
    genesis_token_id: 15432,
    wearable_ids: [256, 433],
  },
  {
    genesis_token_id: 15433,
    wearable_ids: [363, 365],
  },
  {
    genesis_token_id: 15434,
    wearable_ids: [296, 387],
  },
  {
    genesis_token_id: 15435,
    wearable_ids: [295, 386],
  },
  {
    genesis_token_id: 15436,
    wearable_ids: [276, 257],
  },
  {
    genesis_token_id: 15437,
    wearable_ids: [336, 344],
  },
  {
    genesis_token_id: 15438,
    wearable_ids: [256, 369],
  },
  {
    genesis_token_id: 15439,
    wearable_ids: [316, 324],
  },
  {
    genesis_token_id: 15440,
    wearable_ids: [338, 306],
  },
  {
    genesis_token_id: 15441,
    wearable_ids: [325, 374],
  },
  {
    genesis_token_id: 15442,
    wearable_ids: [315, 349],
  },
  {
    genesis_token_id: 15443,
    wearable_ids: [304, 445],
  },
  {
    genesis_token_id: 15444,
    wearable_ids: [272, 355],
  },
  {
    genesis_token_id: 15445,
    wearable_ids: [259, 310],
  },
  {
    genesis_token_id: 15446,
    wearable_ids: [291, 347],
  },
  {
    genesis_token_id: 15447,
    wearable_ids: [265, 246],
  },
  {
    genesis_token_id: 15448,
    wearable_ids: [303, 444],
  },
  {
    genesis_token_id: 15449,
    wearable_ids: [364, 417],
  },
  {
    genesis_token_id: 15450,
    wearable_ids: [365, 377],
  },
  {
    genesis_token_id: 15451,
    wearable_ids: [364, 290],
  },
  {
    genesis_token_id: 15452,
    wearable_ids: [256, 365],
  },
  {
    genesis_token_id: 15453,
    wearable_ids: [373, 420],
  },
  {
    genesis_token_id: 15454,
    wearable_ids: [374, 342],
  },
  {
    genesis_token_id: 15455,
    wearable_ids: [387, 442],
  },
  {
    genesis_token_id: 15456,
    wearable_ids: [378, 383],
  },
  {
    genesis_token_id: 15457,
    wearable_ids: [266, 279],
  },
  {
    genesis_token_id: 15458,
    wearable_ids: [412, 264],
  },
  {
    genesis_token_id: 15459,
    wearable_ids: [296, 286],
  },
  {
    genesis_token_id: 15460,
    wearable_ids: [389, 281],
  },
  {
    genesis_token_id: 15461,
    wearable_ids: [315, 344],
  },
  {
    genesis_token_id: 15462,
    wearable_ids: [265, 301],
  },
  {
    genesis_token_id: 15463,
    wearable_ids: [406, 371],
  },
  {
    genesis_token_id: 15464,
    wearable_ids: [344, 290],
  },
  {
    genesis_token_id: 15465,
    wearable_ids: [311, 355],
  },
  {
    genesis_token_id: 15466,
    wearable_ids: [415, 274],
  },
  {
    genesis_token_id: 15467,
    wearable_ids: [354, 285],
  },
  {
    genesis_token_id: 15468,
    wearable_ids: [376, 312],
  },
  {
    genesis_token_id: 15469,
    wearable_ids: [342, 347],
  },
  {
    genesis_token_id: 15470,
    wearable_ids: [385, 314],
  },
  {
    genesis_token_id: 15471,
    wearable_ids: [337, 286],
  },
  {
    genesis_token_id: 15472,
    wearable_ids: [290, 336],
  },
  {
    genesis_token_id: 15473,
    wearable_ids: [349, 372],
  },
  {
    genesis_token_id: 15474,
    wearable_ids: [408, 396],
  },
  {
    genesis_token_id: 15475,
    wearable_ids: [444, 292],
  },
  {
    genesis_token_id: 15476,
    wearable_ids: [276, 442],
  },
  {
    genesis_token_id: 15477,
    wearable_ids: [263, 424],
  },
  {
    genesis_token_id: 15478,
    wearable_ids: [344, 270],
  },
  {
    genesis_token_id: 15479,
    wearable_ids: [311, 310],
  },
  {
    genesis_token_id: 15480,
    wearable_ids: [424, 440],
  },
  {
    genesis_token_id: 15481,
    wearable_ids: [372, 370],
  },
  {
    genesis_token_id: 15482,
    wearable_ids: [407, 297],
  },
  {
    genesis_token_id: 15483,
    wearable_ids: [349, 424],
  },
  {
    genesis_token_id: 15484,
    wearable_ids: [376, 307],
  },
  {
    genesis_token_id: 15485,
    wearable_ids: [403, 262],
  },
  {
    genesis_token_id: 15486,
    wearable_ids: [343, 352],
  },
  {
    genesis_token_id: 15487,
    wearable_ids: [264, 376],
  },
  {
    genesis_token_id: 15488,
    wearable_ids: [437, 335],
  },
  {
    genesis_token_id: 15489,
    wearable_ids: [258, 426],
  },
  {
    genesis_token_id: 15490,
    wearable_ids: [294, 354],
  },
  {
    genesis_token_id: 15491,
    wearable_ids: [435, 358],
  },
  {
    genesis_token_id: 15492,
    wearable_ids: [429, 346],
  },
  {
    genesis_token_id: 15493,
    wearable_ids: [297, 341],
  },
  {
    genesis_token_id: 15494,
    wearable_ids: [340, 354],
  },
  {
    genesis_token_id: 15495,
    wearable_ids: [410, 371],
  },
  {
    genesis_token_id: 15496,
    wearable_ids: [352, 331],
  },
  {
    genesis_token_id: 15497,
    wearable_ids: [299, 396],
  },
  {
    genesis_token_id: 15498,
    wearable_ids: [294, 424],
  },
  {
    genesis_token_id: 15499,
    wearable_ids: [295, 378],
  },
  {
    genesis_token_id: 15500,
    wearable_ids: [437, 289],
  },
  {
    genesis_token_id: 15501,
    wearable_ids: [412, 255],
  },
  {
    genesis_token_id: 15502,
    wearable_ids: [376, 276],
  },
  {
    genesis_token_id: 15503,
    wearable_ids: [423, 414],
  },
  {
    genesis_token_id: 15504,
    wearable_ids: [349, 259],
  },
  {
    genesis_token_id: 15505,
    wearable_ids: [297, 302],
  },
  {
    genesis_token_id: 15506,
    wearable_ids: [339, 385],
  },
  {
    genesis_token_id: 15507,
    wearable_ids: [406, 356],
  },
  {
    genesis_token_id: 15508,
    wearable_ids: [253, 340],
  },
  {
    genesis_token_id: 15509,
    wearable_ids: [365, 442],
  },
  {
    genesis_token_id: 15510,
    wearable_ids: [274, 431],
  },
  {
    genesis_token_id: 15511,
    wearable_ids: [444, 426],
  },
  {
    genesis_token_id: 15512,
    wearable_ids: [287, 418],
  },
  {
    genesis_token_id: 15513,
    wearable_ids: [386, 397],
  },
  {
    genesis_token_id: 15514,
    wearable_ids: [433, 308],
  },
  {
    genesis_token_id: 15515,
    wearable_ids: [259, 324],
  },
  {
    genesis_token_id: 15516,
    wearable_ids: [389, 436],
  },
  {
    genesis_token_id: 15517,
    wearable_ids: [408, 375],
  },
  {
    genesis_token_id: 15518,
    wearable_ids: [444, 271],
  },
  {
    genesis_token_id: 15519,
    wearable_ids: [413, 308],
  },
  {
    genesis_token_id: 15520,
    wearable_ids: [273, 248],
  },
  {
    genesis_token_id: 15521,
    wearable_ids: [375, 414],
  },
  {
    genesis_token_id: 15522,
    wearable_ids: [340, 317],
  },
  {
    genesis_token_id: 15523,
    wearable_ids: [342, 384],
  },
  {
    genesis_token_id: 15524,
    wearable_ids: [425, 337],
  },
  {
    genesis_token_id: 15525,
    wearable_ids: [303, 263],
  },
  {
    genesis_token_id: 15526,
    wearable_ids: [368, 428],
  },
  {
    genesis_token_id: 15527,
    wearable_ids: [387, 364],
  },
  {
    genesis_token_id: 15528,
    wearable_ids: [292, 256],
  },
  {
    genesis_token_id: 15529,
    wearable_ids: [368, 339],
  },
  {
    genesis_token_id: 15530,
    wearable_ids: [332, 300],
  },
  {
    genesis_token_id: 15531,
    wearable_ids: [351, 343],
  },
  {
    genesis_token_id: 15532,
    wearable_ids: [354, 386],
  },
  {
    genesis_token_id: 15533,
    wearable_ids: [347, 324],
  },
  {
    genesis_token_id: 15534,
    wearable_ids: [349, 411],
  },
  {
    genesis_token_id: 15535,
    wearable_ids: [433, 434],
  },
  {
    genesis_token_id: 15536,
    wearable_ids: [254, 362],
  },
  {
    genesis_token_id: 15537,
    wearable_ids: [354, 399],
  },
  {
    genesis_token_id: 15538,
    wearable_ids: [326, 300],
  },
  {
    genesis_token_id: 15539,
    wearable_ids: [270, 344],
  },
  {
    genesis_token_id: 15540,
    wearable_ids: [403, 328],
  },
  {
    genesis_token_id: 15541,
    wearable_ids: [254, 304],
  },
  {
    genesis_token_id: 15542,
    wearable_ids: [374, 310],
  },
  {
    genesis_token_id: 15543,
    wearable_ids: [377, 400],
  },
  {
    genesis_token_id: 15544,
    wearable_ids: [253, 286],
  },
  {
    genesis_token_id: 15545,
    wearable_ids: [378, 420],
  },
  {
    genesis_token_id: 15546,
    wearable_ids: [337, 370],
  },
  {
    genesis_token_id: 15547,
    wearable_ids: [297, 256],
  },
  {
    genesis_token_id: 15548,
    wearable_ids: [382, 369],
  },
  {
    genesis_token_id: 15549,
    wearable_ids: [371, 405],
  },
  {
    genesis_token_id: 15550,
    wearable_ids: [325, 433],
  },
  {
    genesis_token_id: 15551,
    wearable_ids: [290, 403],
  },
  {
    genesis_token_id: 15552,
    wearable_ids: [274, 350],
  },
  {
    genesis_token_id: 15553,
    wearable_ids: [319, 258],
  },
  {
    genesis_token_id: 15554,
    wearable_ids: [372, 335],
  },
  {
    genesis_token_id: 15555,
    wearable_ids: [370, 255],
  },
  {
    genesis_token_id: 15556,
    wearable_ids: [384, 428],
  },
  {
    genesis_token_id: 15557,
    wearable_ids: [378, 353],
  },
  {
    genesis_token_id: 15558,
    wearable_ids: [432, 314],
  },
  {
    genesis_token_id: 15559,
    wearable_ids: [445, 412],
  },
  {
    genesis_token_id: 15560,
    wearable_ids: [432, 335],
  },
  {
    genesis_token_id: 15561,
    wearable_ids: [271, 335],
  },
  {
    genesis_token_id: 15562,
    wearable_ids: [256, 270],
  },
  {
    genesis_token_id: 15563,
    wearable_ids: [308, 350],
  },
  {
    genesis_token_id: 15564,
    wearable_ids: [253, 278],
  },
  {
    genesis_token_id: 15565,
    wearable_ids: [435, 324],
  },
  {
    genesis_token_id: 15566,
    wearable_ids: [274, 301],
  },
  {
    genesis_token_id: 15567,
    wearable_ids: [443, 250],
  },
  {
    genesis_token_id: 15568,
    wearable_ids: [368, 311],
  },
  {
    genesis_token_id: 15569,
    wearable_ids: [364, 387],
  },
  {
    genesis_token_id: 15570,
    wearable_ids: [301, 280],
  },
  {
    genesis_token_id: 15571,
    wearable_ids: [325, 358],
  },
  {
    genesis_token_id: 15572,
    wearable_ids: [413, 262],
  },
  {
    genesis_token_id: 15573,
    wearable_ids: [253, 301],
  },
  {
    genesis_token_id: 15574,
    wearable_ids: [303, 274],
  },
  {
    genesis_token_id: 15575,
    wearable_ids: [443, 429],
  },
  {
    genesis_token_id: 15576,
    wearable_ids: [247, 292],
  },
  {
    genesis_token_id: 15577,
    wearable_ids: [332, 268],
  },
  {
    genesis_token_id: 15578,
    wearable_ids: [354, 403],
  },
  {
    genesis_token_id: 15579,
    wearable_ids: [349, 348],
  },
  {
    genesis_token_id: 15580,
    wearable_ids: [300, 404],
  },
  {
    genesis_token_id: 15581,
    wearable_ids: [444, 271],
  },
  {
    genesis_token_id: 15582,
    wearable_ids: [254, 426],
  },
  {
    genesis_token_id: 15583,
    wearable_ids: [443, 246],
  },
  {
    genesis_token_id: 15584,
    wearable_ids: [395, 283],
  },
  {
    genesis_token_id: 15585,
    wearable_ids: [432, 373],
  },
  {
    genesis_token_id: 15586,
    wearable_ids: [410, 440],
  },
  {
    genesis_token_id: 15587,
    wearable_ids: [255, 291],
  },
  {
    genesis_token_id: 15588,
    wearable_ids: [395, 289],
  },
  {
    genesis_token_id: 15589,
    wearable_ids: [376, 349],
  },
  {
    genesis_token_id: 15590,
    wearable_ids: [292, 365],
  },
  {
    genesis_token_id: 15591,
    wearable_ids: [346, 296],
  },
  {
    genesis_token_id: 15592,
    wearable_ids: [265, 397],
  },
  {
    genesis_token_id: 15593,
    wearable_ids: [422, 299],
  },
  {
    genesis_token_id: 15594,
    wearable_ids: [286, 335],
  },
  {
    genesis_token_id: 15595,
    wearable_ids: [335, 403],
  },
  {
    genesis_token_id: 15596,
    wearable_ids: [332, 313],
  },
  {
    genesis_token_id: 15597,
    wearable_ids: [420, 324],
  },
  {
    genesis_token_id: 15598,
    wearable_ids: [389, 318],
  },
  {
    genesis_token_id: 15599,
    wearable_ids: [287, 300],
  },
  {
    genesis_token_id: 15600,
    wearable_ids: [354, 290],
  },
  {
    genesis_token_id: 15601,
    wearable_ids: [395, 261],
  },
  {
    genesis_token_id: 15602,
    wearable_ids: [308, 273],
  },
  {
    genesis_token_id: 15603,
    wearable_ids: [268, 340],
  },
  {
    genesis_token_id: 15604,
    wearable_ids: [301, 254],
  },
  {
    genesis_token_id: 15605,
    wearable_ids: [274, 422],
  },
  {
    genesis_token_id: 15606,
    wearable_ids: [254, 371],
  },
  {
    genesis_token_id: 15607,
    wearable_ids: [370, 430],
  },
  {
    genesis_token_id: 15608,
    wearable_ids: [264, 420],
  },
  {
    genesis_token_id: 15609,
    wearable_ids: [436, 303],
  },
  {
    genesis_token_id: 15610,
    wearable_ids: [287, 395],
  },
  {
    genesis_token_id: 15611,
    wearable_ids: [413, 389],
  },
  {
    genesis_token_id: 15612,
    wearable_ids: [340, 248],
  },
  {
    genesis_token_id: 15613,
    wearable_ids: [407, 327],
  },
  {
    genesis_token_id: 15614,
    wearable_ids: [297, 355],
  },
  {
    genesis_token_id: 15615,
    wearable_ids: [341, 346],
  },
  {
    genesis_token_id: 15616,
    wearable_ids: [265, 376],
  },
  {
    genesis_token_id: 15617,
    wearable_ids: [251, 415],
  },
  {
    genesis_token_id: 15618,
    wearable_ids: [397, 420],
  },
  {
    genesis_token_id: 15619,
    wearable_ids: [337, 273],
  },
  {
    genesis_token_id: 15620,
    wearable_ids: [265, 392],
  },
  {
    genesis_token_id: 15621,
    wearable_ids: [373, 259],
  },
  {
    genesis_token_id: 15622,
    wearable_ids: [373, 395],
  },
  {
    genesis_token_id: 15623,
    wearable_ids: [311, 323],
  },
  {
    genesis_token_id: 15624,
    wearable_ids: [248, 350],
  },
  {
    genesis_token_id: 15625,
    wearable_ids: [399, 432],
  },
  {
    genesis_token_id: 15626,
    wearable_ids: [365, 246],
  },
  {
    genesis_token_id: 15627,
    wearable_ids: [376, 290],
  },
  {
    genesis_token_id: 15628,
    wearable_ids: [432, 303],
  },
  {
    genesis_token_id: 15629,
    wearable_ids: [292, 408],
  },
  {
    genesis_token_id: 15630,
    wearable_ids: [336, 256],
  },
  {
    genesis_token_id: 15631,
    wearable_ids: [268, 292],
  },
  {
    genesis_token_id: 15632,
    wearable_ids: [248, 398],
  },
  {
    genesis_token_id: 15633,
    wearable_ids: [292, 424],
  },
  {
    genesis_token_id: 15634,
    wearable_ids: [384, 346],
  },
  {
    genesis_token_id: 15635,
    wearable_ids: [412, 385],
  },
  {
    genesis_token_id: 15636,
    wearable_ids: [400, 290],
  },
  {
    genesis_token_id: 15637,
    wearable_ids: [348, 258],
  },
  {
    genesis_token_id: 15638,
    wearable_ids: [287, 333],
  },
  {
    genesis_token_id: 15639,
    wearable_ids: [363, 269],
  },
  {
    genesis_token_id: 15640,
    wearable_ids: [336, 363],
  },
  {
    genesis_token_id: 15641,
    wearable_ids: [432, 267],
  },
  {
    genesis_token_id: 15642,
    wearable_ids: [436, 347],
  },
  {
    genesis_token_id: 15643,
    wearable_ids: [363, 425],
  },
  {
    genesis_token_id: 15644,
    wearable_ids: [266, 373],
  },
  {
    genesis_token_id: 15645,
    wearable_ids: [272, 409],
  },
  {
    genesis_token_id: 15646,
    wearable_ids: [415, 321],
  },
  {
    genesis_token_id: 15647,
    wearable_ids: [310, 444],
  },
  {
    genesis_token_id: 15648,
    wearable_ids: [254, 355],
  },
  {
    genesis_token_id: 15649,
    wearable_ids: [432, 364],
  },
  {
    genesis_token_id: 15650,
    wearable_ids: [424, 407],
  },
  {
    genesis_token_id: 15651,
    wearable_ids: [303, 274],
  },
  {
    genesis_token_id: 15652,
    wearable_ids: [445, 311],
  },
  {
    genesis_token_id: 15653,
    wearable_ids: [364, 326],
  },
  {
    genesis_token_id: 15654,
    wearable_ids: [316, 344],
  },
  {
    genesis_token_id: 15655,
    wearable_ids: [341, 315],
  },
  {
    genesis_token_id: 15656,
    wearable_ids: [286, 253],
  },
  {
    genesis_token_id: 15657,
    wearable_ids: [335, 317],
  },
  {
    genesis_token_id: 15658,
    wearable_ids: [387, 382],
  },
  {
    genesis_token_id: 15659,
    wearable_ids: [326, 297],
  },
  {
    genesis_token_id: 15660,
    wearable_ids: [265, 407],
  },
  {
    genesis_token_id: 15661,
    wearable_ids: [277, 325],
  },
  {
    genesis_token_id: 15662,
    wearable_ids: [273, 303],
  },
  {
    genesis_token_id: 15663,
    wearable_ids: [300, 430],
  },
  {
    genesis_token_id: 15664,
    wearable_ids: [300, 399],
  },
  {
    genesis_token_id: 15665,
    wearable_ids: [433, 410],
  },
  {
    genesis_token_id: 15666,
    wearable_ids: [425, 429],
  },
  {
    genesis_token_id: 15667,
    wearable_ids: [272, 249],
  },
  {
    genesis_token_id: 15668,
    wearable_ids: [290, 399],
  },
  {
    genesis_token_id: 15669,
    wearable_ids: [349, 290],
  },
  {
    genesis_token_id: 15670,
    wearable_ids: [262, 399],
  },
  {
    genesis_token_id: 15671,
    wearable_ids: [385, 350],
  },
  {
    genesis_token_id: 15672,
    wearable_ids: [263, 255],
  },
  {
    genesis_token_id: 15673,
    wearable_ids: [342, 270],
  },
  {
    genesis_token_id: 15674,
    wearable_ids: [370, 268],
  },
  {
    genesis_token_id: 15675,
    wearable_ids: [370, 297],
  },
  {
    genesis_token_id: 15676,
    wearable_ids: [350, 326],
  },
  {
    genesis_token_id: 15677,
    wearable_ids: [264, 355],
  },
  {
    genesis_token_id: 15678,
    wearable_ids: [291, 375],
  },
  {
    genesis_token_id: 15679,
    wearable_ids: [404, 354],
  },
  {
    genesis_token_id: 15680,
    wearable_ids: [297, 289],
  },
  {
    genesis_token_id: 15681,
    wearable_ids: [326, 389],
  },
  {
    genesis_token_id: 15682,
    wearable_ids: [300, 394],
  },
  {
    genesis_token_id: 15683,
    wearable_ids: [317, 348],
  },
  {
    genesis_token_id: 15684,
    wearable_ids: [435, 314],
  },
  {
    genesis_token_id: 15685,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 15686,
    wearable_ids: [324, 257],
  },
  {
    genesis_token_id: 15687,
    wearable_ids: [338, 313],
  },
  {
    genesis_token_id: 15688,
    wearable_ids: [277, 260],
  },
  {
    genesis_token_id: 15689,
    wearable_ids: [371, 268],
  },
  {
    genesis_token_id: 15690,
    wearable_ids: [325, 269],
  },
  {
    genesis_token_id: 15691,
    wearable_ids: [335, 326],
  },
  {
    genesis_token_id: 15692,
    wearable_ids: [403, 338],
  },
  {
    genesis_token_id: 15693,
    wearable_ids: [247, 256],
  },
  {
    genesis_token_id: 15694,
    wearable_ids: [413, 349],
  },
  {
    genesis_token_id: 15695,
    wearable_ids: [278, 259],
  },
  {
    genesis_token_id: 15696,
    wearable_ids: [303, 248],
  },
  {
    genesis_token_id: 15697,
    wearable_ids: [344, 389],
  },
  {
    genesis_token_id: 15698,
    wearable_ids: [396, 369],
  },
  {
    genesis_token_id: 15699,
    wearable_ids: [271, 401],
  },
  {
    genesis_token_id: 15700,
    wearable_ids: [266, 247],
  },
  {
    genesis_token_id: 15701,
    wearable_ids: [263, 396],
  },
  {
    genesis_token_id: 15702,
    wearable_ids: [339, 280],
  },
  {
    genesis_token_id: 15703,
    wearable_ids: [317, 294],
  },
  {
    genesis_token_id: 15704,
    wearable_ids: [280, 256],
  },
  {
    genesis_token_id: 15705,
    wearable_ids: [374, 436],
  },
  {
    genesis_token_id: 15706,
    wearable_ids: [387, 355],
  },
  {
    genesis_token_id: 15707,
    wearable_ids: [292, 248],
  },
  {
    genesis_token_id: 15708,
    wearable_ids: [350, 443],
  },
  {
    genesis_token_id: 15709,
    wearable_ids: [342, 314],
  },
  {
    genesis_token_id: 15710,
    wearable_ids: [308, 283],
  },
  {
    genesis_token_id: 15711,
    wearable_ids: [413, 434],
  },
  {
    genesis_token_id: 15712,
    wearable_ids: [355, 271],
  },
  {
    genesis_token_id: 15713,
    wearable_ids: [300, 351],
  },
  {
    genesis_token_id: 15714,
    wearable_ids: [314, 318],
  },
  {
    genesis_token_id: 15715,
    wearable_ids: [399, 330],
  },
  {
    genesis_token_id: 15716,
    wearable_ids: [294, 298],
  },
  {
    genesis_token_id: 15717,
    wearable_ids: [294, 337],
  },
  {
    genesis_token_id: 15718,
    wearable_ids: [247, 292],
  },
  {
    genesis_token_id: 15719,
    wearable_ids: [257, 254],
  },
  {
    genesis_token_id: 15720,
    wearable_ids: [308, 424],
  },
  {
    genesis_token_id: 15721,
    wearable_ids: [251, 253],
  },
  {
    genesis_token_id: 15722,
    wearable_ids: [422, 247],
  },
  {
    genesis_token_id: 15723,
    wearable_ids: [378, 314],
  },
  {
    genesis_token_id: 15724,
    wearable_ids: [316, 318],
  },
  {
    genesis_token_id: 15725,
    wearable_ids: [370, 286],
  },
  {
    genesis_token_id: 15726,
    wearable_ids: [382, 295],
  },
  {
    genesis_token_id: 15727,
    wearable_ids: [248, 331],
  },
  {
    genesis_token_id: 15728,
    wearable_ids: [422, 420],
  },
  {
    genesis_token_id: 15729,
    wearable_ids: [341, 320],
  },
  {
    genesis_token_id: 15730,
    wearable_ids: [431, 263],
  },
  {
    genesis_token_id: 15731,
    wearable_ids: [280, 285],
  },
  {
    genesis_token_id: 15732,
    wearable_ids: [308, 331],
  },
  {
    genesis_token_id: 15733,
    wearable_ids: [263, 306],
  },
  {
    genesis_token_id: 15734,
    wearable_ids: [395, 319],
  },
  {
    genesis_token_id: 15735,
    wearable_ids: [306, 332],
  },
  {
    genesis_token_id: 15736,
    wearable_ids: [332, 326],
  },
  {
    genesis_token_id: 15737,
    wearable_ids: [433, 389],
  },
  {
    genesis_token_id: 15738,
    wearable_ids: [271, 371],
  },
  {
    genesis_token_id: 15739,
    wearable_ids: [315, 387],
  },
  {
    genesis_token_id: 15740,
    wearable_ids: [276, 310],
  },
  {
    genesis_token_id: 15741,
    wearable_ids: [349, 377],
  },
  {
    genesis_token_id: 15742,
    wearable_ids: [271, 416],
  },
  {
    genesis_token_id: 15743,
    wearable_ids: [332, 316],
  },
  {
    genesis_token_id: 15744,
    wearable_ids: [348, 351],
  },
  {
    genesis_token_id: 15745,
    wearable_ids: [297, 257],
  },
  {
    genesis_token_id: 15746,
    wearable_ids: [365, 251],
  },
  {
    genesis_token_id: 15747,
    wearable_ids: [291, 271],
  },
  {
    genesis_token_id: 15748,
    wearable_ids: [295, 354],
  },
  {
    genesis_token_id: 15749,
    wearable_ids: [409, 291],
  },
  {
    genesis_token_id: 15750,
    wearable_ids: [423, 442],
  },
  {
    genesis_token_id: 15751,
    wearable_ids: [426, 435],
  },
  {
    genesis_token_id: 15752,
    wearable_ids: [445, 348],
  },
  {
    genesis_token_id: 15753,
    wearable_ids: [340, 382],
  },
  {
    genesis_token_id: 15754,
    wearable_ids: [311, 356],
  },
  {
    genesis_token_id: 15755,
    wearable_ids: [319, 407],
  },
  {
    genesis_token_id: 15756,
    wearable_ids: [409, 435],
  },
  {
    genesis_token_id: 15757,
    wearable_ids: [264, 301],
  },
  {
    genesis_token_id: 15758,
    wearable_ids: [258, 442],
  },
  {
    genesis_token_id: 15759,
    wearable_ids: [272, 431],
  },
  {
    genesis_token_id: 15760,
    wearable_ids: [326, 434],
  },
  {
    genesis_token_id: 15761,
    wearable_ids: [352, 334],
  },
  {
    genesis_token_id: 15762,
    wearable_ids: [435, 288],
  },
  {
    genesis_token_id: 15763,
    wearable_ids: [315, 426],
  },
  {
    genesis_token_id: 15764,
    wearable_ids: [420, 368],
  },
  {
    genesis_token_id: 15765,
    wearable_ids: [395, 251],
  },
  {
    genesis_token_id: 15766,
    wearable_ids: [407, 401],
  },
  {
    genesis_token_id: 15767,
    wearable_ids: [368, 280],
  },
  {
    genesis_token_id: 15768,
    wearable_ids: [326, 280],
  },
  {
    genesis_token_id: 15769,
    wearable_ids: [370, 426],
  },
  {
    genesis_token_id: 15770,
    wearable_ids: [314, 302],
  },
  {
    genesis_token_id: 15771,
    wearable_ids: [352, 258],
  },
  {
    genesis_token_id: 15772,
    wearable_ids: [386, 337],
  },
  {
    genesis_token_id: 15773,
    wearable_ids: [314, 396],
  },
  {
    genesis_token_id: 15774,
    wearable_ids: [415, 275],
  },
  {
    genesis_token_id: 15775,
    wearable_ids: [377, 437],
  },
  {
    genesis_token_id: 15776,
    wearable_ids: [371, 413],
  },
  {
    genesis_token_id: 15777,
    wearable_ids: [396, 404],
  },
  {
    genesis_token_id: 15778,
    wearable_ids: [295, 264],
  },
  {
    genesis_token_id: 15779,
    wearable_ids: [444, 397],
  },
  {
    genesis_token_id: 15780,
    wearable_ids: [284, 315],
  },
  {
    genesis_token_id: 15781,
    wearable_ids: [428, 359],
  },
  {
    genesis_token_id: 15782,
    wearable_ids: [247, 399],
  },
  {
    genesis_token_id: 15783,
    wearable_ids: [431, 370],
  },
  {
    genesis_token_id: 15784,
    wearable_ids: [422, 336],
  },
  {
    genesis_token_id: 15785,
    wearable_ids: [369, 344],
  },
  {
    genesis_token_id: 15786,
    wearable_ids: [315, 265],
  },
  {
    genesis_token_id: 15787,
    wearable_ids: [314, 400],
  },
  {
    genesis_token_id: 15788,
    wearable_ids: [349, 306],
  },
  {
    genesis_token_id: 15789,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 15790,
    wearable_ids: [280, 374],
  },
  {
    genesis_token_id: 15791,
    wearable_ids: [397, 350],
  },
  {
    genesis_token_id: 15792,
    wearable_ids: [386, 251],
  },
  {
    genesis_token_id: 15793,
    wearable_ids: [396, 267],
  },
  {
    genesis_token_id: 15794,
    wearable_ids: [443, 318],
  },
  {
    genesis_token_id: 15795,
    wearable_ids: [364, 377],
  },
  {
    genesis_token_id: 15796,
    wearable_ids: [364, 261],
  },
  {
    genesis_token_id: 15797,
    wearable_ids: [429, 299],
  },
  {
    genesis_token_id: 15798,
    wearable_ids: [286, 273],
  },
  {
    genesis_token_id: 15799,
    wearable_ids: [374, 296],
  },
  {
    genesis_token_id: 15800,
    wearable_ids: [385, 290],
  },
  {
    genesis_token_id: 15801,
    wearable_ids: [432, 402],
  },
  {
    genesis_token_id: 15802,
    wearable_ids: [289, 333],
  },
  {
    genesis_token_id: 15803,
    wearable_ids: [355, 399],
  },
  {
    genesis_token_id: 15804,
    wearable_ids: [331, 374],
  },
  {
    genesis_token_id: 15805,
    wearable_ids: [265, 442],
  },
  {
    genesis_token_id: 15806,
    wearable_ids: [289, 280],
  },
  {
    genesis_token_id: 15807,
    wearable_ids: [413, 325],
  },
  {
    genesis_token_id: 15808,
    wearable_ids: [314, 324],
  },
  {
    genesis_token_id: 15809,
    wearable_ids: [374, 370],
  },
  {
    genesis_token_id: 15810,
    wearable_ids: [413, 340],
  },
  {
    genesis_token_id: 15811,
    wearable_ids: [409, 254],
  },
  {
    genesis_token_id: 15812,
    wearable_ids: [272, 275],
  },
  {
    genesis_token_id: 15813,
    wearable_ids: [351, 297],
  },
  {
    genesis_token_id: 15814,
    wearable_ids: [258, 303],
  },
  {
    genesis_token_id: 15815,
    wearable_ids: [247, 253],
  },
  {
    genesis_token_id: 15816,
    wearable_ids: [272, 425],
  },
  {
    genesis_token_id: 15817,
    wearable_ids: [432, 429],
  },
  {
    genesis_token_id: 15818,
    wearable_ids: [442, 435],
  },
  {
    genesis_token_id: 15819,
    wearable_ids: [355, 370],
  },
  {
    genesis_token_id: 15820,
    wearable_ids: [403, 386],
  },
  {
    genesis_token_id: 15821,
    wearable_ids: [303, 352],
  },
  {
    genesis_token_id: 15822,
    wearable_ids: [278, 269],
  },
  {
    genesis_token_id: 15823,
    wearable_ids: [350, 378],
  },
  {
    genesis_token_id: 15824,
    wearable_ids: [436, 326],
  },
  {
    genesis_token_id: 15825,
    wearable_ids: [376, 306],
  },
  {
    genesis_token_id: 15826,
    wearable_ids: [412, 246],
  },
  {
    genesis_token_id: 15827,
    wearable_ids: [336, 423],
  },
  {
    genesis_token_id: 15828,
    wearable_ids: [386, 434],
  },
  {
    genesis_token_id: 15829,
    wearable_ids: [339, 256],
  },
  {
    genesis_token_id: 15830,
    wearable_ids: [396, 248],
  },
  {
    genesis_token_id: 15831,
    wearable_ids: [253, 258],
  },
  {
    genesis_token_id: 15832,
    wearable_ids: [423, 261],
  },
  {
    genesis_token_id: 15833,
    wearable_ids: [411, 428],
  },
  {
    genesis_token_id: 15834,
    wearable_ids: [332, 270],
  },
  {
    genesis_token_id: 15835,
    wearable_ids: [349, 263],
  },
  {
    genesis_token_id: 15836,
    wearable_ids: [404, 336],
  },
  {
    genesis_token_id: 15837,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 15838,
    wearable_ids: [369, 435],
  },
  {
    genesis_token_id: 15839,
    wearable_ids: [294, 258],
  },
  {
    genesis_token_id: 15840,
    wearable_ids: [347, 325],
  },
  {
    genesis_token_id: 15841,
    wearable_ids: [378, 386],
  },
  {
    genesis_token_id: 15842,
    wearable_ids: [410, 268],
  },
  {
    genesis_token_id: 15843,
    wearable_ids: [316, 344],
  },
  {
    genesis_token_id: 15844,
    wearable_ids: [396, 297],
  },
  {
    genesis_token_id: 15845,
    wearable_ids: [377, 409],
  },
  {
    genesis_token_id: 15846,
    wearable_ids: [350, 432],
  },
  {
    genesis_token_id: 15847,
    wearable_ids: [370, 351],
  },
  {
    genesis_token_id: 15848,
    wearable_ids: [342, 383],
  },
  {
    genesis_token_id: 15849,
    wearable_ids: [332, 289],
  },
  {
    genesis_token_id: 15850,
    wearable_ids: [445, 428],
  },
  {
    genesis_token_id: 15851,
    wearable_ids: [300, 263],
  },
  {
    genesis_token_id: 15852,
    wearable_ids: [303, 358],
  },
  {
    genesis_token_id: 15853,
    wearable_ids: [384, 315],
  },
  {
    genesis_token_id: 15854,
    wearable_ids: [411, 396],
  },
  {
    genesis_token_id: 15855,
    wearable_ids: [399, 338],
  },
  {
    genesis_token_id: 15856,
    wearable_ids: [342, 378],
  },
  {
    genesis_token_id: 15857,
    wearable_ids: [431, 277],
  },
  {
    genesis_token_id: 15858,
    wearable_ids: [277, 438],
  },
  {
    genesis_token_id: 15859,
    wearable_ids: [280, 325],
  },
  {
    genesis_token_id: 15860,
    wearable_ids: [274, 406],
  },
  {
    genesis_token_id: 15861,
    wearable_ids: [314, 395],
  },
  {
    genesis_token_id: 15862,
    wearable_ids: [374, 423],
  },
  {
    genesis_token_id: 15863,
    wearable_ids: [432, 337],
  },
  {
    genesis_token_id: 15864,
    wearable_ids: [431, 407],
  },
  {
    genesis_token_id: 15865,
    wearable_ids: [300, 337],
  },
  {
    genesis_token_id: 15866,
    wearable_ids: [291, 377],
  },
  {
    genesis_token_id: 15867,
    wearable_ids: [289, 295],
  },
  {
    genesis_token_id: 15868,
    wearable_ids: [354, 383],
  },
  {
    genesis_token_id: 15869,
    wearable_ids: [290, 337],
  },
  {
    genesis_token_id: 15870,
    wearable_ids: [396, 416],
  },
  {
    genesis_token_id: 15871,
    wearable_ids: [377, 358],
  },
  {
    genesis_token_id: 15872,
    wearable_ids: [248, 271],
  },
  {
    genesis_token_id: 15873,
    wearable_ids: [373, 428],
  },
  {
    genesis_token_id: 15874,
    wearable_ids: [399, 386],
  },
  {
    genesis_token_id: 15875,
    wearable_ids: [292, 294],
  },
  {
    genesis_token_id: 15876,
    wearable_ids: [369, 256],
  },
  {
    genesis_token_id: 15877,
    wearable_ids: [257, 308],
  },
  {
    genesis_token_id: 15878,
    wearable_ids: [263, 375],
  },
  {
    genesis_token_id: 15879,
    wearable_ids: [399, 301],
  },
  {
    genesis_token_id: 15880,
    wearable_ids: [413, 399],
  },
  {
    genesis_token_id: 15881,
    wearable_ids: [273, 341],
  },
  {
    genesis_token_id: 15882,
    wearable_ids: [375, 385],
  },
  {
    genesis_token_id: 15883,
    wearable_ids: [259, 279],
  },
  {
    genesis_token_id: 15884,
    wearable_ids: [299, 256],
  },
  {
    genesis_token_id: 15885,
    wearable_ids: [387, 422],
  },
  {
    genesis_token_id: 15886,
    wearable_ids: [297, 251],
  },
  {
    genesis_token_id: 15887,
    wearable_ids: [274, 443],
  },
  {
    genesis_token_id: 15888,
    wearable_ids: [317, 298],
  },
  {
    genesis_token_id: 15889,
    wearable_ids: [257, 335],
  },
  {
    genesis_token_id: 15890,
    wearable_ids: [273, 251],
  },
  {
    genesis_token_id: 15891,
    wearable_ids: [344, 249],
  },
  {
    genesis_token_id: 15892,
    wearable_ids: [325, 406],
  },
  {
    genesis_token_id: 15893,
    wearable_ids: [426, 254],
  },
  {
    genesis_token_id: 15894,
    wearable_ids: [429, 378],
  },
  {
    genesis_token_id: 15895,
    wearable_ids: [316, 420],
  },
  {
    genesis_token_id: 15896,
    wearable_ids: [425, 423],
  },
  {
    genesis_token_id: 15897,
    wearable_ids: [268, 296],
  },
  {
    genesis_token_id: 15898,
    wearable_ids: [349, 371],
  },
  {
    genesis_token_id: 15899,
    wearable_ids: [289, 423],
  },
  {
    genesis_token_id: 15900,
    wearable_ids: [256, 251],
  },
  {
    genesis_token_id: 15901,
    wearable_ids: [248, 328],
  },
  {
    genesis_token_id: 15902,
    wearable_ids: [273, 266],
  },
  {
    genesis_token_id: 15903,
    wearable_ids: [287, 428],
  },
  {
    genesis_token_id: 15904,
    wearable_ids: [399, 362],
  },
  {
    genesis_token_id: 15905,
    wearable_ids: [412, 347],
  },
  {
    genesis_token_id: 15906,
    wearable_ids: [374, 275],
  },
  {
    genesis_token_id: 15907,
    wearable_ids: [412, 392],
  },
  {
    genesis_token_id: 15908,
    wearable_ids: [395, 330],
  },
  {
    genesis_token_id: 15909,
    wearable_ids: [259, 354],
  },
  {
    genesis_token_id: 15910,
    wearable_ids: [311, 295],
  },
  {
    genesis_token_id: 15911,
    wearable_ids: [294, 296],
  },
  {
    genesis_token_id: 15912,
    wearable_ids: [437, 373],
  },
  {
    genesis_token_id: 15913,
    wearable_ids: [370, 362],
  },
  {
    genesis_token_id: 15914,
    wearable_ids: [344, 320],
  },
  {
    genesis_token_id: 15915,
    wearable_ids: [387, 278],
  },
  {
    genesis_token_id: 15916,
    wearable_ids: [294, 277],
  },
  {
    genesis_token_id: 15917,
    wearable_ids: [432, 434],
  },
  {
    genesis_token_id: 15918,
    wearable_ids: [263, 364],
  },
  {
    genesis_token_id: 15919,
    wearable_ids: [423, 271],
  },
  {
    genesis_token_id: 15920,
    wearable_ids: [436, 341],
  },
  {
    genesis_token_id: 15921,
    wearable_ids: [383, 315],
  },
  {
    genesis_token_id: 15922,
    wearable_ids: [311, 437],
  },
  {
    genesis_token_id: 15923,
    wearable_ids: [349, 433],
  },
  {
    genesis_token_id: 15924,
    wearable_ids: [297, 339],
  },
  {
    genesis_token_id: 15925,
    wearable_ids: [344, 341],
  },
  {
    genesis_token_id: 15926,
    wearable_ids: [263, 280],
  },
  {
    genesis_token_id: 15927,
    wearable_ids: [355, 442],
  },
  {
    genesis_token_id: 15928,
    wearable_ids: [435, 378],
  },
  {
    genesis_token_id: 15929,
    wearable_ids: [306, 316],
  },
  {
    genesis_token_id: 15930,
    wearable_ids: [306, 399],
  },
  {
    genesis_token_id: 15931,
    wearable_ids: [355, 393],
  },
  {
    genesis_token_id: 15932,
    wearable_ids: [263, 257],
  },
  {
    genesis_token_id: 15933,
    wearable_ids: [371, 348],
  },
  {
    genesis_token_id: 15934,
    wearable_ids: [315, 289],
  },
  {
    genesis_token_id: 15935,
    wearable_ids: [300, 444],
  },
  {
    genesis_token_id: 15936,
    wearable_ids: [445, 279],
  },
  {
    genesis_token_id: 15937,
    wearable_ids: [387, 414],
  },
  {
    genesis_token_id: 15938,
    wearable_ids: [395, 419],
  },
  {
    genesis_token_id: 15939,
    wearable_ids: [290, 408],
  },
  {
    genesis_token_id: 15940,
    wearable_ids: [352, 300],
  },
  {
    genesis_token_id: 15941,
    wearable_ids: [395, 288],
  },
  {
    genesis_token_id: 15942,
    wearable_ids: [294, 382],
  },
  {
    genesis_token_id: 15943,
    wearable_ids: [410, 278],
  },
  {
    genesis_token_id: 15944,
    wearable_ids: [404, 264],
  },
  {
    genesis_token_id: 15945,
    wearable_ids: [266, 408],
  },
  {
    genesis_token_id: 15946,
    wearable_ids: [274, 259],
  },
  {
    genesis_token_id: 15947,
    wearable_ids: [395, 325],
  },
  {
    genesis_token_id: 15948,
    wearable_ids: [277, 294],
  },
  {
    genesis_token_id: 15949,
    wearable_ids: [412, 253],
  },
  {
    genesis_token_id: 15950,
    wearable_ids: [311, 384],
  },
  {
    genesis_token_id: 15951,
    wearable_ids: [411, 428],
  },
  {
    genesis_token_id: 15952,
    wearable_ids: [303, 338],
  },
  {
    genesis_token_id: 15953,
    wearable_ids: [251, 361],
  },
  {
    genesis_token_id: 15954,
    wearable_ids: [296, 295],
  },
  {
    genesis_token_id: 15955,
    wearable_ids: [255, 316],
  },
  {
    genesis_token_id: 15956,
    wearable_ids: [338, 428],
  },
  {
    genesis_token_id: 15957,
    wearable_ids: [284, 270],
  },
  {
    genesis_token_id: 15958,
    wearable_ids: [290, 293],
  },
  {
    genesis_token_id: 15959,
    wearable_ids: [301, 407],
  },
  {
    genesis_token_id: 15960,
    wearable_ids: [369, 429],
  },
  {
    genesis_token_id: 15961,
    wearable_ids: [407, 272],
  },
  {
    genesis_token_id: 15962,
    wearable_ids: [378, 347],
  },
  {
    genesis_token_id: 15963,
    wearable_ids: [406, 391],
  },
  {
    genesis_token_id: 15964,
    wearable_ids: [395, 369],
  },
  {
    genesis_token_id: 15965,
    wearable_ids: [362, 325],
  },
  {
    genesis_token_id: 15966,
    wearable_ids: [371, 278],
  },
  {
    genesis_token_id: 15967,
    wearable_ids: [382, 415],
  },
  {
    genesis_token_id: 15968,
    wearable_ids: [413, 408],
  },
  {
    genesis_token_id: 15969,
    wearable_ids: [387, 297],
  },
  {
    genesis_token_id: 15970,
    wearable_ids: [355, 362],
  },
  {
    genesis_token_id: 15971,
    wearable_ids: [387, 356],
  },
  {
    genesis_token_id: 15972,
    wearable_ids: [319, 290],
  },
  {
    genesis_token_id: 15973,
    wearable_ids: [404, 342],
  },
  {
    genesis_token_id: 15974,
    wearable_ids: [378, 422],
  },
  {
    genesis_token_id: 15975,
    wearable_ids: [371, 372],
  },
  {
    genesis_token_id: 15976,
    wearable_ids: [423, 295],
  },
  {
    genesis_token_id: 15977,
    wearable_ids: [271, 378],
  },
  {
    genesis_token_id: 15978,
    wearable_ids: [437, 349],
  },
  {
    genesis_token_id: 15979,
    wearable_ids: [363, 409],
  },
  {
    genesis_token_id: 15980,
    wearable_ids: [257, 276],
  },
  {
    genesis_token_id: 15981,
    wearable_ids: [296, 422],
  },
  {
    genesis_token_id: 15982,
    wearable_ids: [268, 362],
  },
  {
    genesis_token_id: 15983,
    wearable_ids: [332, 422],
  },
  {
    genesis_token_id: 15984,
    wearable_ids: [437, 280],
  },
  {
    genesis_token_id: 15985,
    wearable_ids: [314, 408],
  },
  {
    genesis_token_id: 15986,
    wearable_ids: [265, 413],
  },
  {
    genesis_token_id: 15987,
    wearable_ids: [284, 373],
  },
  {
    genesis_token_id: 15988,
    wearable_ids: [352, 262],
  },
  {
    genesis_token_id: 15989,
    wearable_ids: [337, 353],
  },
  {
    genesis_token_id: 15990,
    wearable_ids: [274, 372],
  },
  {
    genesis_token_id: 15991,
    wearable_ids: [310, 431],
  },
  {
    genesis_token_id: 15992,
    wearable_ids: [362, 444],
  },
  {
    genesis_token_id: 15993,
    wearable_ids: [255, 407],
  },
  {
    genesis_token_id: 15994,
    wearable_ids: [355, 271],
  },
  {
    genesis_token_id: 15995,
    wearable_ids: [409, 258],
  },
  {
    genesis_token_id: 15996,
    wearable_ids: [396, 387],
  },
  {
    genesis_token_id: 15997,
    wearable_ids: [331, 378],
  },
  {
    genesis_token_id: 15998,
    wearable_ids: [407, 356],
  },
  {
    genesis_token_id: 15999,
    wearable_ids: [277, 275],
  },
  {
    genesis_token_id: 16000,
    wearable_ids: [433, 386],
  },
  {
    genesis_token_id: 16001,
    wearable_ids: [310, 395],
  },
  {
    genesis_token_id: 16002,
    wearable_ids: [310, 413],
  },
  {
    genesis_token_id: 16003,
    wearable_ids: [370, 290],
  },
  {
    genesis_token_id: 16004,
    wearable_ids: [404, 374],
  },
  {
    genesis_token_id: 16005,
    wearable_ids: [352, 364],
  },
  {
    genesis_token_id: 16006,
    wearable_ids: [257, 435],
  },
  {
    genesis_token_id: 16007,
    wearable_ids: [363, 352],
  },
  {
    genesis_token_id: 16008,
    wearable_ids: [335, 403],
  },
  {
    genesis_token_id: 16009,
    wearable_ids: [435, 376],
  },
  {
    genesis_token_id: 16010,
    wearable_ids: [373, 334],
  },
  {
    genesis_token_id: 16011,
    wearable_ids: [385, 417],
  },
  {
    genesis_token_id: 16012,
    wearable_ids: [277, 370],
  },
  {
    genesis_token_id: 16013,
    wearable_ids: [408, 376],
  },
  {
    genesis_token_id: 16014,
    wearable_ids: [314, 398],
  },
  {
    genesis_token_id: 16015,
    wearable_ids: [389, 305],
  },
  {
    genesis_token_id: 16016,
    wearable_ids: [343, 262],
  },
  {
    genesis_token_id: 16017,
    wearable_ids: [317, 400],
  },
  {
    genesis_token_id: 16018,
    wearable_ids: [262, 429],
  },
  {
    genesis_token_id: 16019,
    wearable_ids: [339, 341],
  },
  {
    genesis_token_id: 16020,
    wearable_ids: [265, 395],
  },
  {
    genesis_token_id: 16021,
    wearable_ids: [423, 331],
  },
  {
    genesis_token_id: 16022,
    wearable_ids: [337, 399],
  },
  {
    genesis_token_id: 16023,
    wearable_ids: [376, 326],
  },
  {
    genesis_token_id: 16024,
    wearable_ids: [280, 339],
  },
  {
    genesis_token_id: 16025,
    wearable_ids: [272, 326],
  },
  {
    genesis_token_id: 16026,
    wearable_ids: [251, 352],
  },
  {
    genesis_token_id: 16027,
    wearable_ids: [317, 365],
  },
  {
    genesis_token_id: 16028,
    wearable_ids: [304, 406],
  },
  {
    genesis_token_id: 16029,
    wearable_ids: [432, 256],
  },
  {
    genesis_token_id: 16030,
    wearable_ids: [277, 293],
  },
  {
    genesis_token_id: 16031,
    wearable_ids: [435, 346],
  },
  {
    genesis_token_id: 16032,
    wearable_ids: [266, 272],
  },
  {
    genesis_token_id: 16033,
    wearable_ids: [425, 287],
  },
  {
    genesis_token_id: 16034,
    wearable_ids: [372, 411],
  },
  {
    genesis_token_id: 16035,
    wearable_ids: [314, 339],
  },
  {
    genesis_token_id: 16036,
    wearable_ids: [364, 306],
  },
  {
    genesis_token_id: 16037,
    wearable_ids: [362, 382],
  },
  {
    genesis_token_id: 16038,
    wearable_ids: [290, 332],
  },
  {
    genesis_token_id: 16039,
    wearable_ids: [290, 296],
  },
  {
    genesis_token_id: 16040,
    wearable_ids: [409, 413],
  },
  {
    genesis_token_id: 16041,
    wearable_ids: [355, 290],
  },
  {
    genesis_token_id: 16042,
    wearable_ids: [247, 246],
  },
  {
    genesis_token_id: 16043,
    wearable_ids: [411, 433],
  },
  {
    genesis_token_id: 16044,
    wearable_ids: [251, 430],
  },
  {
    genesis_token_id: 16045,
    wearable_ids: [311, 257],
  },
  {
    genesis_token_id: 16046,
    wearable_ids: [429, 434],
  },
  {
    genesis_token_id: 16047,
    wearable_ids: [387, 373],
  },
  {
    genesis_token_id: 16048,
    wearable_ids: [382, 433],
  },
  {
    genesis_token_id: 16049,
    wearable_ids: [332, 351],
  },
  {
    genesis_token_id: 16050,
    wearable_ids: [431, 287],
  },
  {
    genesis_token_id: 16051,
    wearable_ids: [326, 429],
  },
  {
    genesis_token_id: 16052,
    wearable_ids: [346, 364],
  },
  {
    genesis_token_id: 16053,
    wearable_ids: [332, 348],
  },
  {
    genesis_token_id: 16054,
    wearable_ids: [277, 251],
  },
  {
    genesis_token_id: 16055,
    wearable_ids: [299, 271],
  },
  {
    genesis_token_id: 16056,
    wearable_ids: [408, 412],
  },
  {
    genesis_token_id: 16057,
    wearable_ids: [364, 408],
  },
  {
    genesis_token_id: 16058,
    wearable_ids: [372, 359],
  },
  {
    genesis_token_id: 16059,
    wearable_ids: [433, 315],
  },
  {
    genesis_token_id: 16060,
    wearable_ids: [434, 349],
  },
  {
    genesis_token_id: 16061,
    wearable_ids: [364, 285],
  },
  {
    genesis_token_id: 16062,
    wearable_ids: [287, 404],
  },
  {
    genesis_token_id: 16063,
    wearable_ids: [295, 297],
  },
  {
    genesis_token_id: 16064,
    wearable_ids: [278, 436],
  },
  {
    genesis_token_id: 16065,
    wearable_ids: [296, 372],
  },
  {
    genesis_token_id: 16066,
    wearable_ids: [286, 269],
  },
  {
    genesis_token_id: 16067,
    wearable_ids: [248, 306],
  },
  {
    genesis_token_id: 16068,
    wearable_ids: [355, 271],
  },
  {
    genesis_token_id: 16069,
    wearable_ids: [294, 406],
  },
  {
    genesis_token_id: 16070,
    wearable_ids: [292, 395],
  },
  {
    genesis_token_id: 16071,
    wearable_ids: [256, 360],
  },
  {
    genesis_token_id: 16072,
    wearable_ids: [332, 404],
  },
  {
    genesis_token_id: 16073,
    wearable_ids: [337, 442],
  },
  {
    genesis_token_id: 16074,
    wearable_ids: [254, 331],
  },
  {
    genesis_token_id: 16075,
    wearable_ids: [256, 404],
  },
  {
    genesis_token_id: 16076,
    wearable_ids: [273, 255],
  },
  {
    genesis_token_id: 16077,
    wearable_ids: [396, 355],
  },
  {
    genesis_token_id: 16078,
    wearable_ids: [389, 344],
  },
  {
    genesis_token_id: 16079,
    wearable_ids: [340, 272],
  },
  {
    genesis_token_id: 16080,
    wearable_ids: [431, 372],
  },
  {
    genesis_token_id: 16081,
    wearable_ids: [369, 371],
  },
  {
    genesis_token_id: 16082,
    wearable_ids: [304, 348],
  },
  {
    genesis_token_id: 16083,
    wearable_ids: [343, 431],
  },
  {
    genesis_token_id: 16084,
    wearable_ids: [426, 389],
  },
  {
    genesis_token_id: 16085,
    wearable_ids: [287, 263],
  },
  {
    genesis_token_id: 16086,
    wearable_ids: [347, 406],
  },
  {
    genesis_token_id: 16087,
    wearable_ids: [295, 426],
  },
  {
    genesis_token_id: 16088,
    wearable_ids: [256, 435],
  },
  {
    genesis_token_id: 16089,
    wearable_ids: [437, 444],
  },
  {
    genesis_token_id: 16090,
    wearable_ids: [292, 383],
  },
  {
    genesis_token_id: 16091,
    wearable_ids: [306, 445],
  },
  {
    genesis_token_id: 16092,
    wearable_ids: [413, 300],
  },
  {
    genesis_token_id: 16093,
    wearable_ids: [442, 317],
  },
  {
    genesis_token_id: 16094,
    wearable_ids: [266, 301],
  },
  {
    genesis_token_id: 16095,
    wearable_ids: [256, 290],
  },
  {
    genesis_token_id: 16096,
    wearable_ids: [424, 331],
  },
  {
    genesis_token_id: 16097,
    wearable_ids: [257, 428],
  },
  {
    genesis_token_id: 16098,
    wearable_ids: [276, 445],
  },
  {
    genesis_token_id: 16099,
    wearable_ids: [247, 356],
  },
  {
    genesis_token_id: 16100,
    wearable_ids: [332, 445],
  },
  {
    genesis_token_id: 16101,
    wearable_ids: [433, 354],
  },
  {
    genesis_token_id: 16102,
    wearable_ids: [268, 290],
  },
  {
    genesis_token_id: 16103,
    wearable_ids: [289, 377],
  },
  {
    genesis_token_id: 16104,
    wearable_ids: [337, 344],
  },
  {
    genesis_token_id: 16105,
    wearable_ids: [403, 363],
  },
  {
    genesis_token_id: 16106,
    wearable_ids: [354, 249],
  },
  {
    genesis_token_id: 16107,
    wearable_ids: [434, 431],
  },
  {
    genesis_token_id: 16108,
    wearable_ids: [400, 370],
  },
  {
    genesis_token_id: 16109,
    wearable_ids: [376, 413],
  },
  {
    genesis_token_id: 16110,
    wearable_ids: [272, 310],
  },
  {
    genesis_token_id: 16111,
    wearable_ids: [274, 317],
  },
  {
    genesis_token_id: 16112,
    wearable_ids: [262, 412],
  },
  {
    genesis_token_id: 16113,
    wearable_ids: [425, 304],
  },
  {
    genesis_token_id: 16114,
    wearable_ids: [395, 300],
  },
  {
    genesis_token_id: 16115,
    wearable_ids: [386, 388],
  },
  {
    genesis_token_id: 16116,
    wearable_ids: [297, 413],
  },
  {
    genesis_token_id: 16117,
    wearable_ids: [363, 402],
  },
  {
    genesis_token_id: 16118,
    wearable_ids: [411, 292],
  },
  {
    genesis_token_id: 16119,
    wearable_ids: [387, 275],
  },
  {
    genesis_token_id: 16120,
    wearable_ids: [255, 325],
  },
  {
    genesis_token_id: 16121,
    wearable_ids: [271, 274],
  },
  {
    genesis_token_id: 16122,
    wearable_ids: [326, 420],
  },
  {
    genesis_token_id: 16123,
    wearable_ids: [352, 280],
  },
  {
    genesis_token_id: 16124,
    wearable_ids: [247, 374],
  },
  {
    genesis_token_id: 16125,
    wearable_ids: [287, 294],
  },
  {
    genesis_token_id: 16126,
    wearable_ids: [256, 253],
  },
  {
    genesis_token_id: 16127,
    wearable_ids: [271, 415],
  },
  {
    genesis_token_id: 16128,
    wearable_ids: [304, 384],
  },
  {
    genesis_token_id: 16129,
    wearable_ids: [301, 368],
  },
  {
    genesis_token_id: 16130,
    wearable_ids: [365, 386],
  },
  {
    genesis_token_id: 16131,
    wearable_ids: [406, 414],
  },
  {
    genesis_token_id: 16132,
    wearable_ids: [343, 315],
  },
  {
    genesis_token_id: 16133,
    wearable_ids: [255, 385],
  },
  {
    genesis_token_id: 16134,
    wearable_ids: [355, 323],
  },
  {
    genesis_token_id: 16135,
    wearable_ids: [404, 385],
  },
  {
    genesis_token_id: 16136,
    wearable_ids: [406, 287],
  },
  {
    genesis_token_id: 16137,
    wearable_ids: [433, 340],
  },
  {
    genesis_token_id: 16138,
    wearable_ids: [426, 397],
  },
  {
    genesis_token_id: 16139,
    wearable_ids: [363, 344],
  },
  {
    genesis_token_id: 16140,
    wearable_ids: [304, 423],
  },
  {
    genesis_token_id: 16141,
    wearable_ids: [350, 361],
  },
  {
    genesis_token_id: 16142,
    wearable_ids: [371, 440],
  },
  {
    genesis_token_id: 16143,
    wearable_ids: [425, 343],
  },
  {
    genesis_token_id: 16144,
    wearable_ids: [272, 440],
  },
  {
    genesis_token_id: 16145,
    wearable_ids: [409, 272],
  },
  {
    genesis_token_id: 16146,
    wearable_ids: [374, 411],
  },
  {
    genesis_token_id: 16147,
    wearable_ids: [290, 436],
  },
  {
    genesis_token_id: 16148,
    wearable_ids: [272, 341],
  },
  {
    genesis_token_id: 16149,
    wearable_ids: [364, 355],
  },
  {
    genesis_token_id: 16150,
    wearable_ids: [276, 422],
  },
  {
    genesis_token_id: 16151,
    wearable_ids: [271, 396],
  },
  {
    genesis_token_id: 16152,
    wearable_ids: [435, 362],
  },
  {
    genesis_token_id: 16153,
    wearable_ids: [325, 298],
  },
  {
    genesis_token_id: 16154,
    wearable_ids: [429, 297],
  },
  {
    genesis_token_id: 16155,
    wearable_ids: [409, 287],
  },
  {
    genesis_token_id: 16156,
    wearable_ids: [274, 343],
  },
  {
    genesis_token_id: 16157,
    wearable_ids: [370, 399],
  },
  {
    genesis_token_id: 16158,
    wearable_ids: [435, 317],
  },
  {
    genesis_token_id: 16159,
    wearable_ids: [324, 339],
  },
  {
    genesis_token_id: 16160,
    wearable_ids: [310, 371],
  },
  {
    genesis_token_id: 16161,
    wearable_ids: [363, 262],
  },
  {
    genesis_token_id: 16162,
    wearable_ids: [436, 441],
  },
  {
    genesis_token_id: 16163,
    wearable_ids: [389, 265],
  },
  {
    genesis_token_id: 16164,
    wearable_ids: [335, 347],
  },
  {
    genesis_token_id: 16165,
    wearable_ids: [435, 295],
  },
  {
    genesis_token_id: 16166,
    wearable_ids: [277, 444],
  },
  {
    genesis_token_id: 16167,
    wearable_ids: [311, 272],
  },
  {
    genesis_token_id: 16168,
    wearable_ids: [266, 445],
  },
  {
    genesis_token_id: 16169,
    wearable_ids: [351, 270],
  },
  {
    genesis_token_id: 16170,
    wearable_ids: [423, 386],
  },
  {
    genesis_token_id: 16171,
    wearable_ids: [347, 387],
  },
  {
    genesis_token_id: 16172,
    wearable_ids: [445, 304],
  },
  {
    genesis_token_id: 16173,
    wearable_ids: [387, 425],
  },
  {
    genesis_token_id: 16174,
    wearable_ids: [256, 342],
  },
  {
    genesis_token_id: 16175,
    wearable_ids: [355, 349],
  },
  {
    genesis_token_id: 16176,
    wearable_ids: [299, 401],
  },
  {
    genesis_token_id: 16177,
    wearable_ids: [362, 436],
  },
  {
    genesis_token_id: 16178,
    wearable_ids: [384, 368],
  },
  {
    genesis_token_id: 16179,
    wearable_ids: [265, 254],
  },
  {
    genesis_token_id: 16180,
    wearable_ids: [370, 389],
  },
  {
    genesis_token_id: 16181,
    wearable_ids: [284, 289],
  },
  {
    genesis_token_id: 16182,
    wearable_ids: [314, 315],
  },
  {
    genesis_token_id: 16183,
    wearable_ids: [274, 281],
  },
  {
    genesis_token_id: 16184,
    wearable_ids: [258, 382],
  },
  {
    genesis_token_id: 16185,
    wearable_ids: [423, 389],
  },
  {
    genesis_token_id: 16186,
    wearable_ids: [247, 342],
  },
  {
    genesis_token_id: 16187,
    wearable_ids: [337, 432],
  },
  {
    genesis_token_id: 16188,
    wearable_ids: [409, 348],
  },
  {
    genesis_token_id: 16189,
    wearable_ids: [287, 246],
  },
  {
    genesis_token_id: 16190,
    wearable_ids: [259, 400],
  },
  {
    genesis_token_id: 16191,
    wearable_ids: [273, 429],
  },
  {
    genesis_token_id: 16192,
    wearable_ids: [278, 308],
  },
  {
    genesis_token_id: 16193,
    wearable_ids: [306, 392],
  },
  {
    genesis_token_id: 16194,
    wearable_ids: [299, 388],
  },
  {
    genesis_token_id: 16195,
    wearable_ids: [276, 286],
  },
  {
    genesis_token_id: 16196,
    wearable_ids: [253, 278],
  },
  {
    genesis_token_id: 16197,
    wearable_ids: [426, 288],
  },
  {
    genesis_token_id: 16198,
    wearable_ids: [341, 438],
  },
  {
    genesis_token_id: 16199,
    wearable_ids: [413, 355],
  },
  {
    genesis_token_id: 16200,
    wearable_ids: [272, 247],
  },
  {
    genesis_token_id: 16201,
    wearable_ids: [344, 314],
  },
  {
    genesis_token_id: 16202,
    wearable_ids: [270, 404],
  },
  {
    genesis_token_id: 16203,
    wearable_ids: [349, 253],
  },
  {
    genesis_token_id: 16204,
    wearable_ids: [277, 311],
  },
  {
    genesis_token_id: 16205,
    wearable_ids: [342, 412],
  },
  {
    genesis_token_id: 16206,
    wearable_ids: [370, 355],
  },
  {
    genesis_token_id: 16207,
    wearable_ids: [351, 274],
  },
  {
    genesis_token_id: 16208,
    wearable_ids: [435, 272],
  },
  {
    genesis_token_id: 16209,
    wearable_ids: [433, 278],
  },
  {
    genesis_token_id: 16210,
    wearable_ids: [378, 352],
  },
  {
    genesis_token_id: 16211,
    wearable_ids: [310, 291],
  },
  {
    genesis_token_id: 16212,
    wearable_ids: [268, 277],
  },
  {
    genesis_token_id: 16213,
    wearable_ids: [434, 409],
  },
  {
    genesis_token_id: 16214,
    wearable_ids: [284, 375],
  },
  {
    genesis_token_id: 16215,
    wearable_ids: [303, 294],
  },
  {
    genesis_token_id: 16216,
    wearable_ids: [317, 259],
  },
  {
    genesis_token_id: 16217,
    wearable_ids: [325, 292],
  },
  {
    genesis_token_id: 16218,
    wearable_ids: [443, 306],
  },
  {
    genesis_token_id: 16219,
    wearable_ids: [297, 336],
  },
  {
    genesis_token_id: 16220,
    wearable_ids: [413, 343],
  },
  {
    genesis_token_id: 16221,
    wearable_ids: [335, 426],
  },
  {
    genesis_token_id: 16222,
    wearable_ids: [341, 433],
  },
  {
    genesis_token_id: 16223,
    wearable_ids: [311, 263],
  },
  {
    genesis_token_id: 16224,
    wearable_ids: [355, 364],
  },
  {
    genesis_token_id: 16225,
    wearable_ids: [342, 250],
  },
  {
    genesis_token_id: 16226,
    wearable_ids: [397, 343],
  },
  {
    genesis_token_id: 16227,
    wearable_ids: [295, 316],
  },
  {
    genesis_token_id: 16228,
    wearable_ids: [310, 392],
  },
  {
    genesis_token_id: 16229,
    wearable_ids: [368, 437],
  },
  {
    genesis_token_id: 16230,
    wearable_ids: [340, 289],
  },
  {
    genesis_token_id: 16231,
    wearable_ids: [372, 441],
  },
  {
    genesis_token_id: 16232,
    wearable_ids: [404, 368],
  },
  {
    genesis_token_id: 16233,
    wearable_ids: [338, 320],
  },
  {
    genesis_token_id: 16234,
    wearable_ids: [443, 371],
  },
  {
    genesis_token_id: 16235,
    wearable_ids: [435, 357],
  },
  {
    genesis_token_id: 16236,
    wearable_ids: [265, 414],
  },
  {
    genesis_token_id: 16237,
    wearable_ids: [289, 361],
  },
  {
    genesis_token_id: 16238,
    wearable_ids: [306, 371],
  },
  {
    genesis_token_id: 16239,
    wearable_ids: [349, 363],
  },
  {
    genesis_token_id: 16240,
    wearable_ids: [377, 352],
  },
  {
    genesis_token_id: 16241,
    wearable_ids: [363, 320],
  },
  {
    genesis_token_id: 16242,
    wearable_ids: [278, 335],
  },
  {
    genesis_token_id: 16243,
    wearable_ids: [409, 363],
  },
  {
    genesis_token_id: 16244,
    wearable_ids: [338, 346],
  },
  {
    genesis_token_id: 16245,
    wearable_ids: [265, 327],
  },
  {
    genesis_token_id: 16246,
    wearable_ids: [365, 314],
  },
  {
    genesis_token_id: 16247,
    wearable_ids: [277, 257],
  },
  {
    genesis_token_id: 16248,
    wearable_ids: [297, 286],
  },
  {
    genesis_token_id: 16249,
    wearable_ids: [354, 369],
  },
  {
    genesis_token_id: 16250,
    wearable_ids: [264, 384],
  },
  {
    genesis_token_id: 16251,
    wearable_ids: [311, 290],
  },
  {
    genesis_token_id: 16252,
    wearable_ids: [284, 303],
  },
  {
    genesis_token_id: 16253,
    wearable_ids: [349, 325],
  },
  {
    genesis_token_id: 16254,
    wearable_ids: [369, 272],
  },
  {
    genesis_token_id: 16255,
    wearable_ids: [287, 318],
  },
  {
    genesis_token_id: 16256,
    wearable_ids: [299, 315],
  },
  {
    genesis_token_id: 16257,
    wearable_ids: [306, 418],
  },
  {
    genesis_token_id: 16258,
    wearable_ids: [410, 379],
  },
  {
    genesis_token_id: 16259,
    wearable_ids: [294, 352],
  },
  {
    genesis_token_id: 16260,
    wearable_ids: [308, 392],
  },
  {
    genesis_token_id: 16261,
    wearable_ids: [424, 301],
  },
  {
    genesis_token_id: 16262,
    wearable_ids: [371, 255],
  },
  {
    genesis_token_id: 16263,
    wearable_ids: [271, 416],
  },
  {
    genesis_token_id: 16264,
    wearable_ids: [337, 419],
  },
  {
    genesis_token_id: 16265,
    wearable_ids: [412, 346],
  },
  {
    genesis_token_id: 16266,
    wearable_ids: [259, 403],
  },
  {
    genesis_token_id: 16267,
    wearable_ids: [273, 254],
  },
  {
    genesis_token_id: 16268,
    wearable_ids: [340, 263],
  },
  {
    genesis_token_id: 16269,
    wearable_ids: [273, 416],
  },
  {
    genesis_token_id: 16270,
    wearable_ids: [284, 304],
  },
  {
    genesis_token_id: 16271,
    wearable_ids: [278, 295],
  },
  {
    genesis_token_id: 16272,
    wearable_ids: [384, 408],
  },
  {
    genesis_token_id: 16273,
    wearable_ids: [247, 419],
  },
  {
    genesis_token_id: 16274,
    wearable_ids: [445, 297],
  },
  {
    genesis_token_id: 16275,
    wearable_ids: [274, 248],
  },
  {
    genesis_token_id: 16276,
    wearable_ids: [410, 406],
  },
  {
    genesis_token_id: 16277,
    wearable_ids: [306, 263],
  },
  {
    genesis_token_id: 16278,
    wearable_ids: [403, 391],
  },
  {
    genesis_token_id: 16279,
    wearable_ids: [277, 365],
  },
  {
    genesis_token_id: 16280,
    wearable_ids: [324, 274],
  },
  {
    genesis_token_id: 16281,
    wearable_ids: [409, 415],
  },
  {
    genesis_token_id: 16282,
    wearable_ids: [384, 363],
  },
  {
    genesis_token_id: 16283,
    wearable_ids: [270, 378],
  },
  {
    genesis_token_id: 16284,
    wearable_ids: [344, 348],
  },
  {
    genesis_token_id: 16285,
    wearable_ids: [409, 338],
  },
  {
    genesis_token_id: 16286,
    wearable_ids: [265, 444],
  },
  {
    genesis_token_id: 16287,
    wearable_ids: [262, 376],
  },
  {
    genesis_token_id: 16288,
    wearable_ids: [286, 264],
  },
  {
    genesis_token_id: 16289,
    wearable_ids: [382, 364],
  },
  {
    genesis_token_id: 16290,
    wearable_ids: [247, 375],
  },
  {
    genesis_token_id: 16291,
    wearable_ids: [349, 286],
  },
  {
    genesis_token_id: 16292,
    wearable_ids: [262, 406],
  },
  {
    genesis_token_id: 16293,
    wearable_ids: [372, 297],
  },
  {
    genesis_token_id: 16294,
    wearable_ids: [265, 271],
  },
  {
    genesis_token_id: 16295,
    wearable_ids: [370, 300],
  },
  {
    genesis_token_id: 16296,
    wearable_ids: [326, 345],
  },
  {
    genesis_token_id: 16297,
    wearable_ids: [386, 363],
  },
  {
    genesis_token_id: 16298,
    wearable_ids: [253, 382],
  },
  {
    genesis_token_id: 16299,
    wearable_ids: [365, 276],
  },
  {
    genesis_token_id: 16300,
    wearable_ids: [377, 413],
  },
  {
    genesis_token_id: 16301,
    wearable_ids: [265, 397],
  },
  {
    genesis_token_id: 16302,
    wearable_ids: [291, 386],
  },
  {
    genesis_token_id: 16303,
    wearable_ids: [384, 426],
  },
  {
    genesis_token_id: 16304,
    wearable_ids: [373, 274],
  },
  {
    genesis_token_id: 16305,
    wearable_ids: [432, 308],
  },
  {
    genesis_token_id: 16306,
    wearable_ids: [310, 268],
  },
  {
    genesis_token_id: 16307,
    wearable_ids: [262, 435],
  },
  {
    genesis_token_id: 16308,
    wearable_ids: [343, 413],
  },
  {
    genesis_token_id: 16309,
    wearable_ids: [337, 269],
  },
  {
    genesis_token_id: 16310,
    wearable_ids: [339, 348],
  },
  {
    genesis_token_id: 16311,
    wearable_ids: [382, 407],
  },
  {
    genesis_token_id: 16312,
    wearable_ids: [410, 373],
  },
  {
    genesis_token_id: 16313,
    wearable_ids: [411, 331],
  },
  {
    genesis_token_id: 16314,
    wearable_ids: [331, 325],
  },
  {
    genesis_token_id: 16315,
    wearable_ids: [435, 368],
  },
  {
    genesis_token_id: 16316,
    wearable_ids: [303, 292],
  },
  {
    genesis_token_id: 16317,
    wearable_ids: [399, 301],
  },
  {
    genesis_token_id: 16318,
    wearable_ids: [420, 397],
  },
  {
    genesis_token_id: 16319,
    wearable_ids: [342, 308],
  },
  {
    genesis_token_id: 16320,
    wearable_ids: [304, 406],
  },
  {
    genesis_token_id: 16321,
    wearable_ids: [389, 338],
  },
  {
    genesis_token_id: 16322,
    wearable_ids: [292, 420],
  },
  {
    genesis_token_id: 16323,
    wearable_ids: [365, 270],
  },
  {
    genesis_token_id: 16324,
    wearable_ids: [420, 422],
  },
  {
    genesis_token_id: 16325,
    wearable_ids: [365, 289],
  },
  {
    genesis_token_id: 16326,
    wearable_ids: [426, 320],
  },
  {
    genesis_token_id: 16327,
    wearable_ids: [263, 250],
  },
  {
    genesis_token_id: 16328,
    wearable_ids: [351, 437],
  },
  {
    genesis_token_id: 16329,
    wearable_ids: [271, 259],
  },
  {
    genesis_token_id: 16330,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 16331,
    wearable_ids: [301, 332],
  },
  {
    genesis_token_id: 16332,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 16333,
    wearable_ids: [374, 326],
  },
  {
    genesis_token_id: 16334,
    wearable_ids: [296, 399],
  },
  {
    genesis_token_id: 16335,
    wearable_ids: [375, 284],
  },
  {
    genesis_token_id: 16336,
    wearable_ids: [445, 339],
  },
  {
    genesis_token_id: 16337,
    wearable_ids: [290, 293],
  },
  {
    genesis_token_id: 16338,
    wearable_ids: [420, 246],
  },
  {
    genesis_token_id: 16339,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 16340,
    wearable_ids: [337, 361],
  },
  {
    genesis_token_id: 16341,
    wearable_ids: [404, 412],
  },
  {
    genesis_token_id: 16342,
    wearable_ids: [376, 382],
  },
  {
    genesis_token_id: 16343,
    wearable_ids: [290, 375],
  },
  {
    genesis_token_id: 16344,
    wearable_ids: [335, 314],
  },
  {
    genesis_token_id: 16345,
    wearable_ids: [424, 346],
  },
  {
    genesis_token_id: 16346,
    wearable_ids: [378, 256],
  },
  {
    genesis_token_id: 16347,
    wearable_ids: [326, 270],
  },
  {
    genesis_token_id: 16348,
    wearable_ids: [408, 396],
  },
  {
    genesis_token_id: 16349,
    wearable_ids: [253, 303],
  },
  {
    genesis_token_id: 16350,
    wearable_ids: [270, 276],
  },
  {
    genesis_token_id: 16351,
    wearable_ids: [259, 396],
  },
  {
    genesis_token_id: 16352,
    wearable_ids: [377, 290],
  },
  {
    genesis_token_id: 16353,
    wearable_ids: [375, 410],
  },
  {
    genesis_token_id: 16354,
    wearable_ids: [431, 315],
  },
  {
    genesis_token_id: 16355,
    wearable_ids: [341, 370],
  },
  {
    genesis_token_id: 16356,
    wearable_ids: [368, 403],
  },
  {
    genesis_token_id: 16357,
    wearable_ids: [373, 374],
  },
  {
    genesis_token_id: 16358,
    wearable_ids: [314, 434],
  },
  {
    genesis_token_id: 16359,
    wearable_ids: [389, 272],
  },
  {
    genesis_token_id: 16360,
    wearable_ids: [406, 413],
  },
  {
    genesis_token_id: 16361,
    wearable_ids: [362, 292],
  },
  {
    genesis_token_id: 16362,
    wearable_ids: [422, 255],
  },
  {
    genesis_token_id: 16363,
    wearable_ids: [338, 441],
  },
  {
    genesis_token_id: 16364,
    wearable_ids: [378, 311],
  },
  {
    genesis_token_id: 16365,
    wearable_ids: [387, 280],
  },
  {
    genesis_token_id: 16366,
    wearable_ids: [290, 337],
  },
  {
    genesis_token_id: 16367,
    wearable_ids: [370, 342],
  },
  {
    genesis_token_id: 16368,
    wearable_ids: [397, 315],
  },
  {
    genesis_token_id: 16369,
    wearable_ids: [297, 406],
  },
  {
    genesis_token_id: 16370,
    wearable_ids: [291, 369],
  },
  {
    genesis_token_id: 16371,
    wearable_ids: [259, 423],
  },
  {
    genesis_token_id: 16372,
    wearable_ids: [384, 388],
  },
  {
    genesis_token_id: 16373,
    wearable_ids: [296, 259],
  },
  {
    genesis_token_id: 16374,
    wearable_ids: [343, 270],
  },
  {
    genesis_token_id: 16375,
    wearable_ids: [431, 263],
  },
  {
    genesis_token_id: 16376,
    wearable_ids: [406, 346],
  },
  {
    genesis_token_id: 16377,
    wearable_ids: [296, 272],
  },
  {
    genesis_token_id: 16378,
    wearable_ids: [409, 348],
  },
  {
    genesis_token_id: 16379,
    wearable_ids: [422, 423],
  },
  {
    genesis_token_id: 16380,
    wearable_ids: [420, 375],
  },
  {
    genesis_token_id: 16381,
    wearable_ids: [292, 389],
  },
  {
    genesis_token_id: 16382,
    wearable_ids: [428, 354],
  },
  {
    genesis_token_id: 16383,
    wearable_ids: [324, 299],
  },
  {
    genesis_token_id: 16384,
    wearable_ids: [434, 383],
  },
  {
    genesis_token_id: 16385,
    wearable_ids: [258, 310],
  },
  {
    genesis_token_id: 16386,
    wearable_ids: [317, 445],
  },
  {
    genesis_token_id: 16387,
    wearable_ids: [286, 377],
  },
  {
    genesis_token_id: 16388,
    wearable_ids: [432, 287],
  },
  {
    genesis_token_id: 16389,
    wearable_ids: [352, 371],
  },
  {
    genesis_token_id: 16390,
    wearable_ids: [433, 331],
  },
  {
    genesis_token_id: 16391,
    wearable_ids: [404, 265],
  },
  {
    genesis_token_id: 16392,
    wearable_ids: [251, 371],
  },
  {
    genesis_token_id: 16393,
    wearable_ids: [426, 343],
  },
  {
    genesis_token_id: 16394,
    wearable_ids: [254, 415],
  },
  {
    genesis_token_id: 16395,
    wearable_ids: [284, 345],
  },
  {
    genesis_token_id: 16396,
    wearable_ids: [331, 263],
  },
  {
    genesis_token_id: 16397,
    wearable_ids: [377, 256],
  },
  {
    genesis_token_id: 16398,
    wearable_ids: [349, 315],
  },
  {
    genesis_token_id: 16399,
    wearable_ids: [341, 273],
  },
  {
    genesis_token_id: 16400,
    wearable_ids: [319, 272],
  },
  {
    genesis_token_id: 16401,
    wearable_ids: [284, 259],
  },
  {
    genesis_token_id: 16402,
    wearable_ids: [376, 249],
  },
  {
    genesis_token_id: 16403,
    wearable_ids: [303, 310],
  },
  {
    genesis_token_id: 16404,
    wearable_ids: [287, 372],
  },
  {
    genesis_token_id: 16405,
    wearable_ids: [315, 415],
  },
  {
    genesis_token_id: 16406,
    wearable_ids: [271, 335],
  },
  {
    genesis_token_id: 16407,
    wearable_ids: [289, 412],
  },
  {
    genesis_token_id: 16408,
    wearable_ids: [297, 404],
  },
  {
    genesis_token_id: 16409,
    wearable_ids: [301, 348],
  },
  {
    genesis_token_id: 16410,
    wearable_ids: [248, 412],
  },
  {
    genesis_token_id: 16411,
    wearable_ids: [301, 276],
  },
  {
    genesis_token_id: 16412,
    wearable_ids: [396, 348],
  },
  {
    genesis_token_id: 16413,
    wearable_ids: [278, 391],
  },
  {
    genesis_token_id: 16414,
    wearable_ids: [253, 427],
  },
  {
    genesis_token_id: 16415,
    wearable_ids: [408, 308],
  },
  {
    genesis_token_id: 16416,
    wearable_ids: [338, 254],
  },
  {
    genesis_token_id: 16417,
    wearable_ids: [290, 396],
  },
  {
    genesis_token_id: 16418,
    wearable_ids: [371, 247],
  },
  {
    genesis_token_id: 16419,
    wearable_ids: [287, 347],
  },
  {
    genesis_token_id: 16420,
    wearable_ids: [326, 335],
  },
  {
    genesis_token_id: 16421,
    wearable_ids: [331, 382],
  },
  {
    genesis_token_id: 16422,
    wearable_ids: [324, 362],
  },
  {
    genesis_token_id: 16423,
    wearable_ids: [266, 315],
  },
  {
    genesis_token_id: 16424,
    wearable_ids: [428, 311],
  },
  {
    genesis_token_id: 16425,
    wearable_ids: [264, 314],
  },
  {
    genesis_token_id: 16426,
    wearable_ids: [384, 290],
  },
  {
    genesis_token_id: 16427,
    wearable_ids: [336, 323],
  },
  {
    genesis_token_id: 16428,
    wearable_ids: [289, 407],
  },
  {
    genesis_token_id: 16429,
    wearable_ids: [400, 294],
  },
  {
    genesis_token_id: 16430,
    wearable_ids: [310, 325],
  },
  {
    genesis_token_id: 16431,
    wearable_ids: [365, 253],
  },
  {
    genesis_token_id: 16432,
    wearable_ids: [300, 352],
  },
  {
    genesis_token_id: 16433,
    wearable_ids: [255, 262],
  },
  {
    genesis_token_id: 16434,
    wearable_ids: [409, 335],
  },
  {
    genesis_token_id: 16435,
    wearable_ids: [341, 336],
  },
  {
    genesis_token_id: 16436,
    wearable_ids: [408, 332],
  },
  {
    genesis_token_id: 16437,
    wearable_ids: [397, 408],
  },
  {
    genesis_token_id: 16438,
    wearable_ids: [369, 363],
  },
  {
    genesis_token_id: 16439,
    wearable_ids: [303, 276],
  },
  {
    genesis_token_id: 16440,
    wearable_ids: [342, 374],
  },
  {
    genesis_token_id: 16441,
    wearable_ids: [444, 275],
  },
  {
    genesis_token_id: 16442,
    wearable_ids: [410, 408],
  },
  {
    genesis_token_id: 16443,
    wearable_ids: [306, 370],
  },
  {
    genesis_token_id: 16444,
    wearable_ids: [431, 325],
  },
  {
    genesis_token_id: 16445,
    wearable_ids: [274, 299],
  },
  {
    genesis_token_id: 16446,
    wearable_ids: [385, 432],
  },
  {
    genesis_token_id: 16447,
    wearable_ids: [428, 287],
  },
  {
    genesis_token_id: 16448,
    wearable_ids: [262, 290],
  },
  {
    genesis_token_id: 16449,
    wearable_ids: [271, 334],
  },
  {
    genesis_token_id: 16450,
    wearable_ids: [331, 349],
  },
  {
    genesis_token_id: 16451,
    wearable_ids: [254, 306],
  },
  {
    genesis_token_id: 16452,
    wearable_ids: [296, 331],
  },
  {
    genesis_token_id: 16453,
    wearable_ids: [435, 284],
  },
  {
    genesis_token_id: 16454,
    wearable_ids: [291, 301],
  },
  {
    genesis_token_id: 16455,
    wearable_ids: [338, 259],
  },
  {
    genesis_token_id: 16456,
    wearable_ids: [258, 342],
  },
  {
    genesis_token_id: 16457,
    wearable_ids: [376, 384],
  },
  {
    genesis_token_id: 16458,
    wearable_ids: [289, 350],
  },
  {
    genesis_token_id: 16459,
    wearable_ids: [300, 348],
  },
  {
    genesis_token_id: 16460,
    wearable_ids: [314, 341],
  },
  {
    genesis_token_id: 16461,
    wearable_ids: [350, 284],
  },
  {
    genesis_token_id: 16462,
    wearable_ids: [355, 369],
  },
  {
    genesis_token_id: 16463,
    wearable_ids: [338, 290],
  },
  {
    genesis_token_id: 16464,
    wearable_ids: [368, 403],
  },
  {
    genesis_token_id: 16465,
    wearable_ids: [368, 356],
  },
  {
    genesis_token_id: 16466,
    wearable_ids: [264, 273],
  },
  {
    genesis_token_id: 16467,
    wearable_ids: [409, 289],
  },
  {
    genesis_token_id: 16468,
    wearable_ids: [278, 280],
  },
  {
    genesis_token_id: 16469,
    wearable_ids: [335, 394],
  },
  {
    genesis_token_id: 16470,
    wearable_ids: [344, 331],
  },
  {
    genesis_token_id: 16471,
    wearable_ids: [289, 260],
  },
  {
    genesis_token_id: 16472,
    wearable_ids: [325, 297],
  },
  {
    genesis_token_id: 16473,
    wearable_ids: [290, 376],
  },
  {
    genesis_token_id: 16474,
    wearable_ids: [259, 286],
  },
  {
    genesis_token_id: 16475,
    wearable_ids: [248, 389],
  },
  {
    genesis_token_id: 16476,
    wearable_ids: [409, 311],
  },
  {
    genesis_token_id: 16477,
    wearable_ids: [424, 287],
  },
  {
    genesis_token_id: 16478,
    wearable_ids: [276, 274],
  },
  {
    genesis_token_id: 16479,
    wearable_ids: [408, 322],
  },
  {
    genesis_token_id: 16480,
    wearable_ids: [354, 405],
  },
  {
    genesis_token_id: 16481,
    wearable_ids: [428, 356],
  },
  {
    genesis_token_id: 16482,
    wearable_ids: [265, 336],
  },
  {
    genesis_token_id: 16483,
    wearable_ids: [368, 399],
  },
  {
    genesis_token_id: 16484,
    wearable_ids: [303, 378],
  },
  {
    genesis_token_id: 16485,
    wearable_ids: [385, 276],
  },
  {
    genesis_token_id: 16486,
    wearable_ids: [428, 431],
  },
  {
    genesis_token_id: 16487,
    wearable_ids: [384, 324],
  },
  {
    genesis_token_id: 16488,
    wearable_ids: [324, 342],
  },
  {
    genesis_token_id: 16489,
    wearable_ids: [445, 317],
  },
  {
    genesis_token_id: 16490,
    wearable_ids: [316, 268],
  },
  {
    genesis_token_id: 16491,
    wearable_ids: [311, 324],
  },
  {
    genesis_token_id: 16492,
    wearable_ids: [365, 417],
  },
  {
    genesis_token_id: 16493,
    wearable_ids: [308, 339],
  },
  {
    genesis_token_id: 16494,
    wearable_ids: [297, 433],
  },
  {
    genesis_token_id: 16495,
    wearable_ids: [432, 340],
  },
  {
    genesis_token_id: 16496,
    wearable_ids: [374, 376],
  },
  {
    genesis_token_id: 16497,
    wearable_ids: [354, 248],
  },
  {
    genesis_token_id: 16498,
    wearable_ids: [287, 440],
  },
  {
    genesis_token_id: 16499,
    wearable_ids: [445, 356],
  },
  {
    genesis_token_id: 16500,
    wearable_ids: [257, 420],
  },
  {
    genesis_token_id: 16501,
    wearable_ids: [354, 444],
  },
  {
    genesis_token_id: 16502,
    wearable_ids: [340, 409],
  },
  {
    genesis_token_id: 16503,
    wearable_ids: [355, 371],
  },
  {
    genesis_token_id: 16504,
    wearable_ids: [310, 346],
  },
  {
    genesis_token_id: 16505,
    wearable_ids: [426, 256],
  },
  {
    genesis_token_id: 16506,
    wearable_ids: [292, 355],
  },
  {
    genesis_token_id: 16507,
    wearable_ids: [432, 301],
  },
  {
    genesis_token_id: 16508,
    wearable_ids: [271, 288],
  },
  {
    genesis_token_id: 16509,
    wearable_ids: [268, 337],
  },
  {
    genesis_token_id: 16510,
    wearable_ids: [272, 438],
  },
  {
    genesis_token_id: 16511,
    wearable_ids: [376, 364],
  },
  {
    genesis_token_id: 16512,
    wearable_ids: [280, 404],
  },
  {
    genesis_token_id: 16513,
    wearable_ids: [299, 370],
  },
  {
    genesis_token_id: 16514,
    wearable_ids: [435, 400],
  },
  {
    genesis_token_id: 16515,
    wearable_ids: [296, 278],
  },
  {
    genesis_token_id: 16516,
    wearable_ids: [278, 332],
  },
  {
    genesis_token_id: 16517,
    wearable_ids: [349, 327],
  },
  {
    genesis_token_id: 16518,
    wearable_ids: [248, 422],
  },
  {
    genesis_token_id: 16519,
    wearable_ids: [365, 383],
  },
  {
    genesis_token_id: 16520,
    wearable_ids: [286, 422],
  },
  {
    genesis_token_id: 16521,
    wearable_ids: [408, 341],
  },
  {
    genesis_token_id: 16522,
    wearable_ids: [338, 359],
  },
  {
    genesis_token_id: 16523,
    wearable_ids: [442, 445],
  },
  {
    genesis_token_id: 16524,
    wearable_ids: [433, 354],
  },
  {
    genesis_token_id: 16525,
    wearable_ids: [316, 299],
  },
  {
    genesis_token_id: 16526,
    wearable_ids: [280, 330],
  },
  {
    genesis_token_id: 16527,
    wearable_ids: [412, 265],
  },
  {
    genesis_token_id: 16528,
    wearable_ids: [303, 326],
  },
  {
    genesis_token_id: 16529,
    wearable_ids: [354, 443],
  },
  {
    genesis_token_id: 16530,
    wearable_ids: [340, 260],
  },
  {
    genesis_token_id: 16531,
    wearable_ids: [259, 257],
  },
  {
    genesis_token_id: 16532,
    wearable_ids: [270, 347],
  },
  {
    genesis_token_id: 16533,
    wearable_ids: [331, 404],
  },
  {
    genesis_token_id: 16534,
    wearable_ids: [316, 260],
  },
  {
    genesis_token_id: 16535,
    wearable_ids: [299, 338],
  },
  {
    genesis_token_id: 16536,
    wearable_ids: [301, 272],
  },
  {
    genesis_token_id: 16537,
    wearable_ids: [258, 403],
  },
  {
    genesis_token_id: 16538,
    wearable_ids: [295, 340],
  },
  {
    genesis_token_id: 16539,
    wearable_ids: [315, 382],
  },
  {
    genesis_token_id: 16540,
    wearable_ids: [378, 407],
  },
  {
    genesis_token_id: 16541,
    wearable_ids: [262, 289],
  },
  {
    genesis_token_id: 16542,
    wearable_ids: [287, 415],
  },
  {
    genesis_token_id: 16543,
    wearable_ids: [397, 383],
  },
  {
    genesis_token_id: 16544,
    wearable_ids: [287, 443],
  },
  {
    genesis_token_id: 16545,
    wearable_ids: [409, 362],
  },
  {
    genesis_token_id: 16546,
    wearable_ids: [278, 402],
  },
  {
    genesis_token_id: 16547,
    wearable_ids: [404, 355],
  },
  {
    genesis_token_id: 16548,
    wearable_ids: [319, 415],
  },
  {
    genesis_token_id: 16549,
    wearable_ids: [435, 365],
  },
  {
    genesis_token_id: 16550,
    wearable_ids: [335, 436],
  },
  {
    genesis_token_id: 16551,
    wearable_ids: [415, 398],
  },
  {
    genesis_token_id: 16552,
    wearable_ids: [403, 386],
  },
  {
    genesis_token_id: 16553,
    wearable_ids: [311, 343],
  },
  {
    genesis_token_id: 16554,
    wearable_ids: [375, 418],
  },
  {
    genesis_token_id: 16555,
    wearable_ids: [383, 389],
  },
  {
    genesis_token_id: 16556,
    wearable_ids: [436, 340],
  },
  {
    genesis_token_id: 16557,
    wearable_ids: [254, 387],
  },
  {
    genesis_token_id: 16558,
    wearable_ids: [335, 444],
  },
  {
    genesis_token_id: 16559,
    wearable_ids: [325, 372],
  },
  {
    genesis_token_id: 16560,
    wearable_ids: [292, 317],
  },
  {
    genesis_token_id: 16561,
    wearable_ids: [247, 264],
  },
  {
    genesis_token_id: 16562,
    wearable_ids: [294, 323],
  },
  {
    genesis_token_id: 16563,
    wearable_ids: [411, 386],
  },
  {
    genesis_token_id: 16564,
    wearable_ids: [273, 373],
  },
  {
    genesis_token_id: 16565,
    wearable_ids: [397, 416],
  },
  {
    genesis_token_id: 16566,
    wearable_ids: [258, 285],
  },
  {
    genesis_token_id: 16567,
    wearable_ids: [362, 393],
  },
  {
    genesis_token_id: 16568,
    wearable_ids: [409, 256],
  },
  {
    genesis_token_id: 16569,
    wearable_ids: [436, 412],
  },
  {
    genesis_token_id: 16570,
    wearable_ids: [369, 291],
  },
  {
    genesis_token_id: 16571,
    wearable_ids: [263, 377],
  },
  {
    genesis_token_id: 16572,
    wearable_ids: [424, 437],
  },
  {
    genesis_token_id: 16573,
    wearable_ids: [349, 280],
  },
  {
    genesis_token_id: 16574,
    wearable_ids: [280, 349],
  },
  {
    genesis_token_id: 16575,
    wearable_ids: [311, 273],
  },
  {
    genesis_token_id: 16576,
    wearable_ids: [271, 341],
  },
  {
    genesis_token_id: 16577,
    wearable_ids: [404, 408],
  },
  {
    genesis_token_id: 16578,
    wearable_ids: [262, 255],
  },
  {
    genesis_token_id: 16579,
    wearable_ids: [265, 352],
  },
  {
    genesis_token_id: 16580,
    wearable_ids: [332, 358],
  },
  {
    genesis_token_id: 16581,
    wearable_ids: [263, 397],
  },
  {
    genesis_token_id: 16582,
    wearable_ids: [316, 279],
  },
  {
    genesis_token_id: 16583,
    wearable_ids: [319, 271],
  },
  {
    genesis_token_id: 16584,
    wearable_ids: [368, 417],
  },
  {
    genesis_token_id: 16585,
    wearable_ids: [410, 296],
  },
  {
    genesis_token_id: 16586,
    wearable_ids: [428, 290],
  },
  {
    genesis_token_id: 16587,
    wearable_ids: [299, 416],
  },
  {
    genesis_token_id: 16588,
    wearable_ids: [407, 384],
  },
  {
    genesis_token_id: 16589,
    wearable_ids: [304, 286],
  },
  {
    genesis_token_id: 16590,
    wearable_ids: [253, 419],
  },
  {
    genesis_token_id: 16591,
    wearable_ids: [396, 419],
  },
  {
    genesis_token_id: 16592,
    wearable_ids: [274, 419],
  },
  {
    genesis_token_id: 16593,
    wearable_ids: [364, 341],
  },
  {
    genesis_token_id: 16594,
    wearable_ids: [341, 340],
  },
  {
    genesis_token_id: 16595,
    wearable_ids: [274, 411],
  },
  {
    genesis_token_id: 16596,
    wearable_ids: [274, 311],
  },
  {
    genesis_token_id: 16597,
    wearable_ids: [342, 265],
  },
  {
    genesis_token_id: 16598,
    wearable_ids: [385, 253],
  },
  {
    genesis_token_id: 16599,
    wearable_ids: [362, 393],
  },
  {
    genesis_token_id: 16600,
    wearable_ids: [387, 310],
  },
  {
    genesis_token_id: 16601,
    wearable_ids: [412, 407],
  },
  {
    genesis_token_id: 16602,
    wearable_ids: [384, 276],
  },
  {
    genesis_token_id: 16603,
    wearable_ids: [396, 383],
  },
  {
    genesis_token_id: 16604,
    wearable_ids: [352, 377],
  },
  {
    genesis_token_id: 16605,
    wearable_ids: [294, 336],
  },
  {
    genesis_token_id: 16606,
    wearable_ids: [378, 293],
  },
  {
    genesis_token_id: 16607,
    wearable_ids: [341, 423],
  },
  {
    genesis_token_id: 16608,
    wearable_ids: [351, 250],
  },
  {
    genesis_token_id: 16609,
    wearable_ids: [342, 332],
  },
  {
    genesis_token_id: 16610,
    wearable_ids: [300, 319],
  },
  {
    genesis_token_id: 16611,
    wearable_ids: [370, 337],
  },
  {
    genesis_token_id: 16612,
    wearable_ids: [299, 443],
  },
  {
    genesis_token_id: 16613,
    wearable_ids: [284, 431],
  },
  {
    genesis_token_id: 16614,
    wearable_ids: [386, 296],
  },
  {
    genesis_token_id: 16615,
    wearable_ids: [340, 315],
  },
  {
    genesis_token_id: 16616,
    wearable_ids: [254, 395],
  },
  {
    genesis_token_id: 16617,
    wearable_ids: [436, 277],
  },
  {
    genesis_token_id: 16618,
    wearable_ids: [346, 355],
  },
  {
    genesis_token_id: 16619,
    wearable_ids: [304, 444],
  },
  {
    genesis_token_id: 16620,
    wearable_ids: [270, 444],
  },
  {
    genesis_token_id: 16621,
    wearable_ids: [342, 331],
  },
  {
    genesis_token_id: 16622,
    wearable_ids: [425, 373],
  },
  {
    genesis_token_id: 16623,
    wearable_ids: [384, 250],
  },
  {
    genesis_token_id: 16624,
    wearable_ids: [400, 431],
  },
  {
    genesis_token_id: 16625,
    wearable_ids: [374, 415],
  },
  {
    genesis_token_id: 16626,
    wearable_ids: [378, 301],
  },
  {
    genesis_token_id: 16627,
    wearable_ids: [295, 424],
  },
  {
    genesis_token_id: 16628,
    wearable_ids: [352, 343],
  },
  {
    genesis_token_id: 16629,
    wearable_ids: [247, 432],
  },
  {
    genesis_token_id: 16630,
    wearable_ids: [431, 355],
  },
  {
    genesis_token_id: 16631,
    wearable_ids: [270, 406],
  },
  {
    genesis_token_id: 16632,
    wearable_ids: [378, 362],
  },
  {
    genesis_token_id: 16633,
    wearable_ids: [407, 413],
  },
  {
    genesis_token_id: 16634,
    wearable_ids: [385, 437],
  },
  {
    genesis_token_id: 16635,
    wearable_ids: [400, 385],
  },
  {
    genesis_token_id: 16636,
    wearable_ids: [420, 409],
  },
  {
    genesis_token_id: 16637,
    wearable_ids: [259, 299],
  },
  {
    genesis_token_id: 16638,
    wearable_ids: [423, 441],
  },
  {
    genesis_token_id: 16639,
    wearable_ids: [340, 258],
  },
  {
    genesis_token_id: 16640,
    wearable_ids: [292, 280],
  },
  {
    genesis_token_id: 16641,
    wearable_ids: [370, 364],
  },
  {
    genesis_token_id: 16642,
    wearable_ids: [397, 294],
  },
  {
    genesis_token_id: 16643,
    wearable_ids: [268, 297],
  },
  {
    genesis_token_id: 16644,
    wearable_ids: [408, 271],
  },
  {
    genesis_token_id: 16645,
    wearable_ids: [291, 334],
  },
  {
    genesis_token_id: 16646,
    wearable_ids: [425, 273],
  },
  {
    genesis_token_id: 16647,
    wearable_ids: [284, 291],
  },
  {
    genesis_token_id: 16648,
    wearable_ids: [372, 254],
  },
  {
    genesis_token_id: 16649,
    wearable_ids: [378, 259],
  },
  {
    genesis_token_id: 16650,
    wearable_ids: [340, 365],
  },
  {
    genesis_token_id: 16651,
    wearable_ids: [347, 441],
  },
  {
    genesis_token_id: 16652,
    wearable_ids: [407, 372],
  },
  {
    genesis_token_id: 16653,
    wearable_ids: [351, 270],
  },
  {
    genesis_token_id: 16654,
    wearable_ids: [296, 313],
  },
  {
    genesis_token_id: 16655,
    wearable_ids: [262, 250],
  },
  {
    genesis_token_id: 16656,
    wearable_ids: [326, 437],
  },
  {
    genesis_token_id: 16657,
    wearable_ids: [336, 322],
  },
  {
    genesis_token_id: 16658,
    wearable_ids: [370, 338],
  },
  {
    genesis_token_id: 16659,
    wearable_ids: [310, 403],
  },
  {
    genesis_token_id: 16660,
    wearable_ids: [331, 433],
  },
  {
    genesis_token_id: 16661,
    wearable_ids: [424, 376],
  },
  {
    genesis_token_id: 16662,
    wearable_ids: [256, 326],
  },
  {
    genesis_token_id: 16663,
    wearable_ids: [264, 361],
  },
  {
    genesis_token_id: 16664,
    wearable_ids: [383, 441],
  },
  {
    genesis_token_id: 16665,
    wearable_ids: [403, 366],
  },
  {
    genesis_token_id: 16666,
    wearable_ids: [317, 406],
  },
  {
    genesis_token_id: 16667,
    wearable_ids: [437, 248],
  },
  {
    genesis_token_id: 16668,
    wearable_ids: [254, 256],
  },
  {
    genesis_token_id: 16669,
    wearable_ids: [258, 339],
  },
  {
    genesis_token_id: 16670,
    wearable_ids: [365, 301],
  },
  {
    genesis_token_id: 16671,
    wearable_ids: [415, 290],
  },
  {
    genesis_token_id: 16672,
    wearable_ids: [325, 376],
  },
  {
    genesis_token_id: 16673,
    wearable_ids: [362, 274],
  },
  {
    genesis_token_id: 16674,
    wearable_ids: [339, 352],
  },
  {
    genesis_token_id: 16675,
    wearable_ids: [255, 374],
  },
  {
    genesis_token_id: 16676,
    wearable_ids: [335, 412],
  },
  {
    genesis_token_id: 16677,
    wearable_ids: [442, 437],
  },
  {
    genesis_token_id: 16678,
    wearable_ids: [407, 433],
  },
  {
    genesis_token_id: 16679,
    wearable_ids: [412, 432],
  },
  {
    genesis_token_id: 16680,
    wearable_ids: [435, 310],
  },
  {
    genesis_token_id: 16681,
    wearable_ids: [349, 343],
  },
  {
    genesis_token_id: 16682,
    wearable_ids: [424, 305],
  },
  {
    genesis_token_id: 16683,
    wearable_ids: [383, 265],
  },
  {
    genesis_token_id: 16684,
    wearable_ids: [262, 422],
  },
  {
    genesis_token_id: 16685,
    wearable_ids: [294, 435],
  },
  {
    genesis_token_id: 16686,
    wearable_ids: [409, 420],
  },
  {
    genesis_token_id: 16687,
    wearable_ids: [415, 319],
  },
  {
    genesis_token_id: 16688,
    wearable_ids: [365, 384],
  },
  {
    genesis_token_id: 16689,
    wearable_ids: [406, 383],
  },
  {
    genesis_token_id: 16690,
    wearable_ids: [258, 443],
  },
  {
    genesis_token_id: 16691,
    wearable_ids: [266, 269],
  },
  {
    genesis_token_id: 16692,
    wearable_ids: [314, 304],
  },
  {
    genesis_token_id: 16693,
    wearable_ids: [415, 272],
  },
  {
    genesis_token_id: 16694,
    wearable_ids: [292, 424],
  },
  {
    genesis_token_id: 16695,
    wearable_ids: [408, 386],
  },
  {
    genesis_token_id: 16696,
    wearable_ids: [277, 273],
  },
  {
    genesis_token_id: 16697,
    wearable_ids: [284, 303],
  },
  {
    genesis_token_id: 16698,
    wearable_ids: [272, 352],
  },
  {
    genesis_token_id: 16699,
    wearable_ids: [296, 311],
  },
  {
    genesis_token_id: 16700,
    wearable_ids: [264, 400],
  },
  {
    genesis_token_id: 16701,
    wearable_ids: [248, 364],
  },
  {
    genesis_token_id: 16702,
    wearable_ids: [289, 271],
  },
  {
    genesis_token_id: 16703,
    wearable_ids: [297, 378],
  },
  {
    genesis_token_id: 16704,
    wearable_ids: [296, 418],
  },
  {
    genesis_token_id: 16705,
    wearable_ids: [422, 315],
  },
  {
    genesis_token_id: 16706,
    wearable_ids: [442, 274],
  },
  {
    genesis_token_id: 16707,
    wearable_ids: [386, 368],
  },
  {
    genesis_token_id: 16708,
    wearable_ids: [284, 385],
  },
  {
    genesis_token_id: 16709,
    wearable_ids: [294, 423],
  },
  {
    genesis_token_id: 16710,
    wearable_ids: [443, 280],
  },
  {
    genesis_token_id: 16711,
    wearable_ids: [382, 352],
  },
  {
    genesis_token_id: 16712,
    wearable_ids: [383, 315],
  },
  {
    genesis_token_id: 16713,
    wearable_ids: [410, 251],
  },
  {
    genesis_token_id: 16714,
    wearable_ids: [341, 429],
  },
  {
    genesis_token_id: 16715,
    wearable_ids: [271, 413],
  },
  {
    genesis_token_id: 16716,
    wearable_ids: [400, 315],
  },
  {
    genesis_token_id: 16717,
    wearable_ids: [374, 322],
  },
  {
    genesis_token_id: 16718,
    wearable_ids: [374, 418],
  },
  {
    genesis_token_id: 16719,
    wearable_ids: [385, 279],
  },
  {
    genesis_token_id: 16720,
    wearable_ids: [347, 363],
  },
  {
    genesis_token_id: 16721,
    wearable_ids: [350, 302],
  },
  {
    genesis_token_id: 16722,
    wearable_ids: [374, 318],
  },
  {
    genesis_token_id: 16723,
    wearable_ids: [273, 306],
  },
  {
    genesis_token_id: 16724,
    wearable_ids: [268, 284],
  },
  {
    genesis_token_id: 16725,
    wearable_ids: [338, 323],
  },
  {
    genesis_token_id: 16726,
    wearable_ids: [296, 429],
  },
  {
    genesis_token_id: 16727,
    wearable_ids: [324, 263],
  },
  {
    genesis_token_id: 16728,
    wearable_ids: [410, 266],
  },
  {
    genesis_token_id: 16729,
    wearable_ids: [337, 355],
  },
  {
    genesis_token_id: 16730,
    wearable_ids: [300, 373],
  },
  {
    genesis_token_id: 16731,
    wearable_ids: [378, 276],
  },
  {
    genesis_token_id: 16732,
    wearable_ids: [431, 411],
  },
  {
    genesis_token_id: 16733,
    wearable_ids: [400, 294],
  },
  {
    genesis_token_id: 16734,
    wearable_ids: [400, 270],
  },
  {
    genesis_token_id: 16735,
    wearable_ids: [372, 257],
  },
  {
    genesis_token_id: 16736,
    wearable_ids: [336, 308],
  },
  {
    genesis_token_id: 16737,
    wearable_ids: [434, 407],
  },
  {
    genesis_token_id: 16738,
    wearable_ids: [253, 300],
  },
  {
    genesis_token_id: 16739,
    wearable_ids: [263, 310],
  },
  {
    genesis_token_id: 16740,
    wearable_ids: [374, 280],
  },
  {
    genesis_token_id: 16741,
    wearable_ids: [435, 412],
  },
  {
    genesis_token_id: 16742,
    wearable_ids: [270, 330],
  },
  {
    genesis_token_id: 16743,
    wearable_ids: [247, 325],
  },
  {
    genesis_token_id: 16744,
    wearable_ids: [433, 290],
  },
  {
    genesis_token_id: 16745,
    wearable_ids: [370, 354],
  },
  {
    genesis_token_id: 16746,
    wearable_ids: [301, 332],
  },
  {
    genesis_token_id: 16747,
    wearable_ids: [372, 275],
  },
  {
    genesis_token_id: 16748,
    wearable_ids: [258, 406],
  },
  {
    genesis_token_id: 16749,
    wearable_ids: [289, 273],
  },
  {
    genesis_token_id: 16750,
    wearable_ids: [426, 292],
  },
  {
    genesis_token_id: 16751,
    wearable_ids: [255, 274],
  },
  {
    genesis_token_id: 16752,
    wearable_ids: [254, 317],
  },
  {
    genesis_token_id: 16753,
    wearable_ids: [253, 276],
  },
  {
    genesis_token_id: 16754,
    wearable_ids: [254, 443],
  },
  {
    genesis_token_id: 16755,
    wearable_ids: [420, 299],
  },
  {
    genesis_token_id: 16756,
    wearable_ids: [350, 400],
  },
  {
    genesis_token_id: 16757,
    wearable_ids: [273, 316],
  },
  {
    genesis_token_id: 16758,
    wearable_ids: [297, 251],
  },
  {
    genesis_token_id: 16759,
    wearable_ids: [251, 420],
  },
  {
    genesis_token_id: 16760,
    wearable_ids: [436, 350],
  },
  {
    genesis_token_id: 16761,
    wearable_ids: [258, 289],
  },
  {
    genesis_token_id: 16762,
    wearable_ids: [444, 388],
  },
  {
    genesis_token_id: 16763,
    wearable_ids: [355, 343],
  },
  {
    genesis_token_id: 16764,
    wearable_ids: [271, 385],
  },
  {
    genesis_token_id: 16765,
    wearable_ids: [409, 295],
  },
  {
    genesis_token_id: 16766,
    wearable_ids: [316, 332],
  },
  {
    genesis_token_id: 16767,
    wearable_ids: [301, 445],
  },
  {
    genesis_token_id: 16768,
    wearable_ids: [370, 268],
  },
  {
    genesis_token_id: 16769,
    wearable_ids: [295, 436],
  },
  {
    genesis_token_id: 16770,
    wearable_ids: [274, 273],
  },
  {
    genesis_token_id: 16771,
    wearable_ids: [276, 356],
  },
  {
    genesis_token_id: 16772,
    wearable_ids: [437, 377],
  },
  {
    genesis_token_id: 16773,
    wearable_ids: [270, 418],
  },
  {
    genesis_token_id: 16774,
    wearable_ids: [395, 423],
  },
  {
    genesis_token_id: 16775,
    wearable_ids: [352, 280],
  },
  {
    genesis_token_id: 16776,
    wearable_ids: [292, 325],
  },
  {
    genesis_token_id: 16777,
    wearable_ids: [253, 251],
  },
  {
    genesis_token_id: 16778,
    wearable_ids: [324, 409],
  },
  {
    genesis_token_id: 16779,
    wearable_ids: [433, 283],
  },
  {
    genesis_token_id: 16780,
    wearable_ids: [297, 331],
  },
  {
    genesis_token_id: 16781,
    wearable_ids: [336, 357],
  },
  {
    genesis_token_id: 16782,
    wearable_ids: [436, 307],
  },
  {
    genesis_token_id: 16783,
    wearable_ids: [444, 248],
  },
  {
    genesis_token_id: 16784,
    wearable_ids: [369, 308],
  },
  {
    genesis_token_id: 16785,
    wearable_ids: [338, 301],
  },
  {
    genesis_token_id: 16786,
    wearable_ids: [257, 384],
  },
  {
    genesis_token_id: 16787,
    wearable_ids: [254, 397],
  },
  {
    genesis_token_id: 16788,
    wearable_ids: [264, 425],
  },
  {
    genesis_token_id: 16789,
    wearable_ids: [400, 410],
  },
  {
    genesis_token_id: 16790,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 16791,
    wearable_ids: [420, 436],
  },
  {
    genesis_token_id: 16792,
    wearable_ids: [376, 334],
  },
  {
    genesis_token_id: 16793,
    wearable_ids: [396, 362],
  },
  {
    genesis_token_id: 16794,
    wearable_ids: [292, 384],
  },
  {
    genesis_token_id: 16795,
    wearable_ids: [336, 399],
  },
  {
    genesis_token_id: 16796,
    wearable_ids: [371, 308],
  },
  {
    genesis_token_id: 16797,
    wearable_ids: [294, 297],
  },
  {
    genesis_token_id: 16798,
    wearable_ids: [257, 392],
  },
  {
    genesis_token_id: 16799,
    wearable_ids: [253, 292],
  },
  {
    genesis_token_id: 16800,
    wearable_ids: [308, 268],
  },
  {
    genesis_token_id: 16801,
    wearable_ids: [264, 346],
  },
  {
    genesis_token_id: 16802,
    wearable_ids: [350, 263],
  },
  {
    genesis_token_id: 16803,
    wearable_ids: [255, 384],
  },
  {
    genesis_token_id: 16804,
    wearable_ids: [362, 264],
  },
  {
    genesis_token_id: 16805,
    wearable_ids: [342, 366],
  },
  {
    genesis_token_id: 16806,
    wearable_ids: [350, 272],
  },
  {
    genesis_token_id: 16807,
    wearable_ids: [247, 306],
  },
  {
    genesis_token_id: 16808,
    wearable_ids: [368, 273],
  },
  {
    genesis_token_id: 16809,
    wearable_ids: [287, 298],
  },
  {
    genesis_token_id: 16810,
    wearable_ids: [431, 428],
  },
  {
    genesis_token_id: 16811,
    wearable_ids: [350, 278],
  },
  {
    genesis_token_id: 16812,
    wearable_ids: [286, 285],
  },
  {
    genesis_token_id: 16813,
    wearable_ids: [373, 287],
  },
  {
    genesis_token_id: 16814,
    wearable_ids: [258, 445],
  },
  {
    genesis_token_id: 16815,
    wearable_ids: [258, 374],
  },
  {
    genesis_token_id: 16816,
    wearable_ids: [341, 383],
  },
  {
    genesis_token_id: 16817,
    wearable_ids: [411, 404],
  },
  {
    genesis_token_id: 16818,
    wearable_ids: [385, 395],
  },
  {
    genesis_token_id: 16819,
    wearable_ids: [347, 407],
  },
  {
    genesis_token_id: 16820,
    wearable_ids: [253, 268],
  },
  {
    genesis_token_id: 16821,
    wearable_ids: [314, 335],
  },
  {
    genesis_token_id: 16822,
    wearable_ids: [364, 371],
  },
  {
    genesis_token_id: 16823,
    wearable_ids: [295, 429],
  },
  {
    genesis_token_id: 16824,
    wearable_ids: [352, 331],
  },
  {
    genesis_token_id: 16825,
    wearable_ids: [410, 290],
  },
  {
    genesis_token_id: 16826,
    wearable_ids: [362, 350],
  },
  {
    genesis_token_id: 16827,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 16828,
    wearable_ids: [343, 383],
  },
  {
    genesis_token_id: 16829,
    wearable_ids: [384, 331],
  },
  {
    genesis_token_id: 16830,
    wearable_ids: [408, 431],
  },
  {
    genesis_token_id: 16831,
    wearable_ids: [314, 308],
  },
  {
    genesis_token_id: 16832,
    wearable_ids: [397, 376],
  },
  {
    genesis_token_id: 16833,
    wearable_ids: [270, 415],
  },
  {
    genesis_token_id: 16834,
    wearable_ids: [355, 257],
  },
  {
    genesis_token_id: 16835,
    wearable_ids: [365, 323],
  },
  {
    genesis_token_id: 16836,
    wearable_ids: [396, 378],
  },
  {
    genesis_token_id: 16837,
    wearable_ids: [445, 289],
  },
  {
    genesis_token_id: 16838,
    wearable_ids: [277, 355],
  },
  {
    genesis_token_id: 16839,
    wearable_ids: [254, 334],
  },
  {
    genesis_token_id: 16840,
    wearable_ids: [336, 332],
  },
  {
    genesis_token_id: 16841,
    wearable_ids: [304, 364],
  },
  {
    genesis_token_id: 16842,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 16843,
    wearable_ids: [304, 382],
  },
  {
    genesis_token_id: 16844,
    wearable_ids: [272, 403],
  },
  {
    genesis_token_id: 16845,
    wearable_ids: [340, 335],
  },
  {
    genesis_token_id: 16846,
    wearable_ids: [415, 295],
  },
  {
    genesis_token_id: 16847,
    wearable_ids: [370, 436],
  },
  {
    genesis_token_id: 16848,
    wearable_ids: [342, 434],
  },
  {
    genesis_token_id: 16849,
    wearable_ids: [434, 412],
  },
  {
    genesis_token_id: 16850,
    wearable_ids: [290, 382],
  },
  {
    genesis_token_id: 16851,
    wearable_ids: [297, 276],
  },
  {
    genesis_token_id: 16852,
    wearable_ids: [363, 417],
  },
  {
    genesis_token_id: 16853,
    wearable_ids: [399, 262],
  },
  {
    genesis_token_id: 16854,
    wearable_ids: [259, 305],
  },
  {
    genesis_token_id: 16855,
    wearable_ids: [385, 354],
  },
  {
    genesis_token_id: 16856,
    wearable_ids: [400, 335],
  },
  {
    genesis_token_id: 16857,
    wearable_ids: [413, 423],
  },
  {
    genesis_token_id: 16858,
    wearable_ids: [301, 278],
  },
  {
    genesis_token_id: 16859,
    wearable_ids: [274, 320],
  },
  {
    genesis_token_id: 16860,
    wearable_ids: [370, 264],
  },
  {
    genesis_token_id: 16861,
    wearable_ids: [264, 337],
  },
  {
    genesis_token_id: 16862,
    wearable_ids: [355, 278],
  },
  {
    genesis_token_id: 16863,
    wearable_ids: [331, 254],
  },
  {
    genesis_token_id: 16864,
    wearable_ids: [266, 347],
  },
  {
    genesis_token_id: 16865,
    wearable_ids: [351, 389],
  },
  {
    genesis_token_id: 16866,
    wearable_ids: [426, 429],
  },
  {
    genesis_token_id: 16867,
    wearable_ids: [295, 386],
  },
  {
    genesis_token_id: 16868,
    wearable_ids: [400, 362],
  },
  {
    genesis_token_id: 16869,
    wearable_ids: [284, 413],
  },
  {
    genesis_token_id: 16870,
    wearable_ids: [332, 362],
  },
  {
    genesis_token_id: 16871,
    wearable_ids: [426, 435],
  },
  {
    genesis_token_id: 16872,
    wearable_ids: [277, 346],
  },
  {
    genesis_token_id: 16873,
    wearable_ids: [389, 384],
  },
  {
    genesis_token_id: 16874,
    wearable_ids: [368, 426],
  },
  {
    genesis_token_id: 16875,
    wearable_ids: [407, 416],
  },
  {
    genesis_token_id: 16876,
    wearable_ids: [422, 342],
  },
  {
    genesis_token_id: 16877,
    wearable_ids: [257, 280],
  },
  {
    genesis_token_id: 16878,
    wearable_ids: [368, 409],
  },
  {
    genesis_token_id: 16879,
    wearable_ids: [248, 330],
  },
  {
    genesis_token_id: 16880,
    wearable_ids: [286, 334],
  },
  {
    genesis_token_id: 16881,
    wearable_ids: [387, 290],
  },
  {
    genesis_token_id: 16882,
    wearable_ids: [331, 303],
  },
  {
    genesis_token_id: 16883,
    wearable_ids: [258, 247],
  },
  {
    genesis_token_id: 16884,
    wearable_ids: [259, 399],
  },
  {
    genesis_token_id: 16885,
    wearable_ids: [396, 325],
  },
  {
    genesis_token_id: 16886,
    wearable_ids: [411, 434],
  },
  {
    genesis_token_id: 16887,
    wearable_ids: [420, 280],
  },
  {
    genesis_token_id: 16888,
    wearable_ids: [351, 302],
  },
  {
    genesis_token_id: 16889,
    wearable_ids: [432, 331],
  },
  {
    genesis_token_id: 16890,
    wearable_ids: [383, 283],
  },
  {
    genesis_token_id: 16891,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 16892,
    wearable_ids: [294, 382],
  },
  {
    genesis_token_id: 16893,
    wearable_ids: [295, 331],
  },
  {
    genesis_token_id: 16894,
    wearable_ids: [406, 302],
  },
  {
    genesis_token_id: 16895,
    wearable_ids: [374, 409],
  },
  {
    genesis_token_id: 16896,
    wearable_ids: [278, 298],
  },
  {
    genesis_token_id: 16897,
    wearable_ids: [268, 425],
  },
  {
    genesis_token_id: 16898,
    wearable_ids: [369, 406],
  },
  {
    genesis_token_id: 16899,
    wearable_ids: [433, 436],
  },
  {
    genesis_token_id: 16900,
    wearable_ids: [278, 434],
  },
  {
    genesis_token_id: 16901,
    wearable_ids: [386, 248],
  },
  {
    genesis_token_id: 16902,
    wearable_ids: [311, 373],
  },
  {
    genesis_token_id: 16903,
    wearable_ids: [432, 405],
  },
  {
    genesis_token_id: 16904,
    wearable_ids: [306, 338],
  },
  {
    genesis_token_id: 16905,
    wearable_ids: [326, 426],
  },
  {
    genesis_token_id: 16906,
    wearable_ids: [373, 437],
  },
  {
    genesis_token_id: 16907,
    wearable_ids: [332, 257],
  },
  {
    genesis_token_id: 16908,
    wearable_ids: [296, 271],
  },
  {
    genesis_token_id: 16909,
    wearable_ids: [436, 404],
  },
  {
    genesis_token_id: 16910,
    wearable_ids: [425, 254],
  },
  {
    genesis_token_id: 16911,
    wearable_ids: [442, 322],
  },
  {
    genesis_token_id: 16912,
    wearable_ids: [387, 311],
  },
  {
    genesis_token_id: 16913,
    wearable_ids: [425, 330],
  },
  {
    genesis_token_id: 16914,
    wearable_ids: [325, 290],
  },
  {
    genesis_token_id: 16915,
    wearable_ids: [255, 368],
  },
  {
    genesis_token_id: 16916,
    wearable_ids: [306, 299],
  },
  {
    genesis_token_id: 16917,
    wearable_ids: [406, 420],
  },
  {
    genesis_token_id: 16918,
    wearable_ids: [316, 431],
  },
  {
    genesis_token_id: 16919,
    wearable_ids: [315, 324],
  },
  {
    genesis_token_id: 16920,
    wearable_ids: [296, 384],
  },
  {
    genesis_token_id: 16921,
    wearable_ids: [339, 345],
  },
  {
    genesis_token_id: 16922,
    wearable_ids: [341, 398],
  },
  {
    genesis_token_id: 16923,
    wearable_ids: [324, 436],
  },
  {
    genesis_token_id: 16924,
    wearable_ids: [369, 306],
  },
  {
    genesis_token_id: 16925,
    wearable_ids: [365, 445],
  },
  {
    genesis_token_id: 16926,
    wearable_ids: [403, 266],
  },
  {
    genesis_token_id: 16927,
    wearable_ids: [383, 371],
  },
  {
    genesis_token_id: 16928,
    wearable_ids: [324, 442],
  },
  {
    genesis_token_id: 16929,
    wearable_ids: [324, 426],
  },
  {
    genesis_token_id: 16930,
    wearable_ids: [400, 404],
  },
  {
    genesis_token_id: 16931,
    wearable_ids: [286, 277],
  },
  {
    genesis_token_id: 16932,
    wearable_ids: [423, 400],
  },
  {
    genesis_token_id: 16933,
    wearable_ids: [278, 316],
  },
  {
    genesis_token_id: 16934,
    wearable_ids: [277, 310],
  },
  {
    genesis_token_id: 16935,
    wearable_ids: [251, 270],
  },
  {
    genesis_token_id: 16936,
    wearable_ids: [255, 431],
  },
  {
    genesis_token_id: 16937,
    wearable_ids: [317, 335],
  },
  {
    genesis_token_id: 16938,
    wearable_ids: [336, 374],
  },
  {
    genesis_token_id: 16939,
    wearable_ids: [399, 293],
  },
  {
    genesis_token_id: 16940,
    wearable_ids: [336, 332],
  },
  {
    genesis_token_id: 16941,
    wearable_ids: [349, 385],
  },
  {
    genesis_token_id: 16942,
    wearable_ids: [289, 435],
  },
  {
    genesis_token_id: 16943,
    wearable_ids: [346, 338],
  },
  {
    genesis_token_id: 16944,
    wearable_ids: [350, 384],
  },
  {
    genesis_token_id: 16945,
    wearable_ids: [319, 276],
  },
  {
    genesis_token_id: 16946,
    wearable_ids: [251, 384],
  },
  {
    genesis_token_id: 16947,
    wearable_ids: [258, 311],
  },
  {
    genesis_token_id: 16948,
    wearable_ids: [276, 331],
  },
  {
    genesis_token_id: 16949,
    wearable_ids: [247, 253],
  },
  {
    genesis_token_id: 16950,
    wearable_ids: [284, 246],
  },
  {
    genesis_token_id: 16951,
    wearable_ids: [266, 395],
  },
  {
    genesis_token_id: 16952,
    wearable_ids: [326, 383],
  },
  {
    genesis_token_id: 16953,
    wearable_ids: [407, 363],
  },
  {
    genesis_token_id: 16954,
    wearable_ids: [263, 365],
  },
  {
    genesis_token_id: 16955,
    wearable_ids: [443, 262],
  },
  {
    genesis_token_id: 16956,
    wearable_ids: [355, 303],
  },
  {
    genesis_token_id: 16957,
    wearable_ids: [368, 283],
  },
  {
    genesis_token_id: 16958,
    wearable_ids: [290, 352],
  },
  {
    genesis_token_id: 16959,
    wearable_ids: [351, 445],
  },
  {
    genesis_token_id: 16960,
    wearable_ids: [368, 431],
  },
  {
    genesis_token_id: 16961,
    wearable_ids: [373, 392],
  },
  {
    genesis_token_id: 16962,
    wearable_ids: [385, 444],
  },
  {
    genesis_token_id: 16963,
    wearable_ids: [400, 279],
  },
  {
    genesis_token_id: 16964,
    wearable_ids: [287, 420],
  },
  {
    genesis_token_id: 16965,
    wearable_ids: [396, 428],
  },
  {
    genesis_token_id: 16966,
    wearable_ids: [346, 291],
  },
  {
    genesis_token_id: 16967,
    wearable_ids: [310, 443],
  },
  {
    genesis_token_id: 16968,
    wearable_ids: [403, 443],
  },
  {
    genesis_token_id: 16969,
    wearable_ids: [428, 442],
  },
  {
    genesis_token_id: 16970,
    wearable_ids: [255, 429],
  },
  {
    genesis_token_id: 16971,
    wearable_ids: [271, 446],
  },
  {
    genesis_token_id: 16972,
    wearable_ids: [445, 415],
  },
  {
    genesis_token_id: 16973,
    wearable_ids: [412, 295],
  },
  {
    genesis_token_id: 16974,
    wearable_ids: [332, 264],
  },
  {
    genesis_token_id: 16975,
    wearable_ids: [265, 376],
  },
  {
    genesis_token_id: 16976,
    wearable_ids: [415, 422],
  },
  {
    genesis_token_id: 16977,
    wearable_ids: [384, 444],
  },
  {
    genesis_token_id: 16978,
    wearable_ids: [407, 314],
  },
  {
    genesis_token_id: 16979,
    wearable_ids: [428, 368],
  },
  {
    genesis_token_id: 16980,
    wearable_ids: [432, 335],
  },
  {
    genesis_token_id: 16981,
    wearable_ids: [382, 368],
  },
  {
    genesis_token_id: 16982,
    wearable_ids: [276, 364],
  },
  {
    genesis_token_id: 16983,
    wearable_ids: [349, 431],
  },
  {
    genesis_token_id: 16984,
    wearable_ids: [425, 357],
  },
  {
    genesis_token_id: 16985,
    wearable_ids: [354, 383],
  },
  {
    genesis_token_id: 16986,
    wearable_ids: [272, 266],
  },
  {
    genesis_token_id: 16987,
    wearable_ids: [376, 423],
  },
  {
    genesis_token_id: 16988,
    wearable_ids: [375, 326],
  },
  {
    genesis_token_id: 16989,
    wearable_ids: [258, 274],
  },
  {
    genesis_token_id: 16990,
    wearable_ids: [428, 444],
  },
  {
    genesis_token_id: 16991,
    wearable_ids: [299, 279],
  },
  {
    genesis_token_id: 16992,
    wearable_ids: [396, 255],
  },
  {
    genesis_token_id: 16993,
    wearable_ids: [348, 346],
  },
  {
    genesis_token_id: 16994,
    wearable_ids: [324, 354],
  },
  {
    genesis_token_id: 16995,
    wearable_ids: [347, 275],
  },
  {
    genesis_token_id: 16996,
    wearable_ids: [445, 281],
  },
  {
    genesis_token_id: 16997,
    wearable_ids: [299, 342],
  },
  {
    genesis_token_id: 16998,
    wearable_ids: [344, 430],
  },
  {
    genesis_token_id: 16999,
    wearable_ids: [325, 404],
  },
  {
    genesis_token_id: 17000,
    wearable_ids: [413, 403],
  },
  {
    genesis_token_id: 17001,
    wearable_ids: [344, 373],
  },
  {
    genesis_token_id: 17002,
    wearable_ids: [415, 315],
  },
  {
    genesis_token_id: 17003,
    wearable_ids: [266, 337],
  },
  {
    genesis_token_id: 17004,
    wearable_ids: [352, 438],
  },
  {
    genesis_token_id: 17005,
    wearable_ids: [445, 387],
  },
  {
    genesis_token_id: 17006,
    wearable_ids: [286, 333],
  },
  {
    genesis_token_id: 17007,
    wearable_ids: [432, 437],
  },
  {
    genesis_token_id: 17008,
    wearable_ids: [432, 250],
  },
  {
    genesis_token_id: 17009,
    wearable_ids: [378, 435],
  },
  {
    genesis_token_id: 17010,
    wearable_ids: [263, 397],
  },
  {
    genesis_token_id: 17011,
    wearable_ids: [270, 363],
  },
  {
    genesis_token_id: 17012,
    wearable_ids: [257, 357],
  },
  {
    genesis_token_id: 17013,
    wearable_ids: [347, 278],
  },
  {
    genesis_token_id: 17014,
    wearable_ids: [442, 378],
  },
  {
    genesis_token_id: 17015,
    wearable_ids: [397, 373],
  },
  {
    genesis_token_id: 17016,
    wearable_ids: [369, 410],
  },
  {
    genesis_token_id: 17017,
    wearable_ids: [371, 376],
  },
  {
    genesis_token_id: 17018,
    wearable_ids: [429, 248],
  },
  {
    genesis_token_id: 17019,
    wearable_ids: [352, 442],
  },
  {
    genesis_token_id: 17020,
    wearable_ids: [435, 334],
  },
  {
    genesis_token_id: 17021,
    wearable_ids: [286, 435],
  },
  {
    genesis_token_id: 17022,
    wearable_ids: [404, 442],
  },
  {
    genesis_token_id: 17023,
    wearable_ids: [433, 343],
  },
  {
    genesis_token_id: 17024,
    wearable_ids: [251, 273],
  },
  {
    genesis_token_id: 17025,
    wearable_ids: [429, 307],
  },
  {
    genesis_token_id: 17026,
    wearable_ids: [404, 354],
  },
  {
    genesis_token_id: 17027,
    wearable_ids: [351, 384],
  },
  {
    genesis_token_id: 17028,
    wearable_ids: [436, 424],
  },
  {
    genesis_token_id: 17029,
    wearable_ids: [407, 346],
  },
  {
    genesis_token_id: 17030,
    wearable_ids: [258, 392],
  },
  {
    genesis_token_id: 17031,
    wearable_ids: [424, 265],
  },
  {
    genesis_token_id: 17032,
    wearable_ids: [372, 314],
  },
  {
    genesis_token_id: 17033,
    wearable_ids: [407, 274],
  },
  {
    genesis_token_id: 17034,
    wearable_ids: [354, 426],
  },
  {
    genesis_token_id: 17035,
    wearable_ids: [274, 316],
  },
  {
    genesis_token_id: 17036,
    wearable_ids: [403, 303],
  },
  {
    genesis_token_id: 17037,
    wearable_ids: [404, 410],
  },
  {
    genesis_token_id: 17038,
    wearable_ids: [443, 433],
  },
  {
    genesis_token_id: 17039,
    wearable_ids: [442, 387],
  },
  {
    genesis_token_id: 17040,
    wearable_ids: [297, 386],
  },
  {
    genesis_token_id: 17041,
    wearable_ids: [289, 315],
  },
  {
    genesis_token_id: 17042,
    wearable_ids: [429, 311],
  },
  {
    genesis_token_id: 17043,
    wearable_ids: [317, 409],
  },
  {
    genesis_token_id: 17044,
    wearable_ids: [286, 392],
  },
  {
    genesis_token_id: 17045,
    wearable_ids: [262, 420],
  },
  {
    genesis_token_id: 17046,
    wearable_ids: [290, 343],
  },
  {
    genesis_token_id: 17047,
    wearable_ids: [350, 318],
  },
  {
    genesis_token_id: 17048,
    wearable_ids: [347, 348],
  },
  {
    genesis_token_id: 17049,
    wearable_ids: [343, 265],
  },
  {
    genesis_token_id: 17050,
    wearable_ids: [404, 306],
  },
  {
    genesis_token_id: 17051,
    wearable_ids: [435, 408],
  },
  {
    genesis_token_id: 17052,
    wearable_ids: [295, 330],
  },
  {
    genesis_token_id: 17053,
    wearable_ids: [310, 249],
  },
  {
    genesis_token_id: 17054,
    wearable_ids: [270, 328],
  },
  {
    genesis_token_id: 17055,
    wearable_ids: [413, 363],
  },
  {
    genesis_token_id: 17056,
    wearable_ids: [412, 289],
  },
  {
    genesis_token_id: 17057,
    wearable_ids: [299, 391],
  },
  {
    genesis_token_id: 17058,
    wearable_ids: [303, 379],
  },
  {
    genesis_token_id: 17059,
    wearable_ids: [341, 364],
  },
  {
    genesis_token_id: 17060,
    wearable_ids: [425, 408],
  },
  {
    genesis_token_id: 17061,
    wearable_ids: [247, 265],
  },
  {
    genesis_token_id: 17062,
    wearable_ids: [335, 339],
  },
  {
    genesis_token_id: 17063,
    wearable_ids: [248, 325],
  },
  {
    genesis_token_id: 17064,
    wearable_ids: [443, 434],
  },
  {
    genesis_token_id: 17065,
    wearable_ids: [436, 272],
  },
  {
    genesis_token_id: 17066,
    wearable_ids: [442, 350],
  },
  {
    genesis_token_id: 17067,
    wearable_ids: [444, 331],
  },
  {
    genesis_token_id: 17068,
    wearable_ids: [289, 426],
  },
  {
    genesis_token_id: 17069,
    wearable_ids: [412, 326],
  },
  {
    genesis_token_id: 17070,
    wearable_ids: [257, 273],
  },
  {
    genesis_token_id: 17071,
    wearable_ids: [280, 426],
  },
  {
    genesis_token_id: 17072,
    wearable_ids: [411, 369],
  },
  {
    genesis_token_id: 17073,
    wearable_ids: [291, 400],
  },
  {
    genesis_token_id: 17074,
    wearable_ids: [423, 417],
  },
  {
    genesis_token_id: 17075,
    wearable_ids: [294, 271],
  },
  {
    genesis_token_id: 17076,
    wearable_ids: [339, 362],
  },
  {
    genesis_token_id: 17077,
    wearable_ids: [354, 343],
  },
  {
    genesis_token_id: 17078,
    wearable_ids: [262, 351],
  },
  {
    genesis_token_id: 17079,
    wearable_ids: [409, 303],
  },
  {
    genesis_token_id: 17080,
    wearable_ids: [301, 298],
  },
  {
    genesis_token_id: 17081,
    wearable_ids: [258, 324],
  },
  {
    genesis_token_id: 17082,
    wearable_ids: [424, 406],
  },
  {
    genesis_token_id: 17083,
    wearable_ids: [435, 424],
  },
  {
    genesis_token_id: 17084,
    wearable_ids: [342, 425],
  },
  {
    genesis_token_id: 17085,
    wearable_ids: [426, 263],
  },
  {
    genesis_token_id: 17086,
    wearable_ids: [247, 248],
  },
  {
    genesis_token_id: 17087,
    wearable_ids: [444, 342],
  },
  {
    genesis_token_id: 17088,
    wearable_ids: [271, 347],
  },
  {
    genesis_token_id: 17089,
    wearable_ids: [426, 342],
  },
  {
    genesis_token_id: 17090,
    wearable_ids: [348, 287],
  },
  {
    genesis_token_id: 17091,
    wearable_ids: [374, 347],
  },
  {
    genesis_token_id: 17092,
    wearable_ids: [255, 425],
  },
  {
    genesis_token_id: 17093,
    wearable_ids: [297, 376],
  },
  {
    genesis_token_id: 17094,
    wearable_ids: [409, 399],
  },
  {
    genesis_token_id: 17095,
    wearable_ids: [383, 269],
  },
  {
    genesis_token_id: 17096,
    wearable_ids: [247, 417],
  },
  {
    genesis_token_id: 17097,
    wearable_ids: [384, 369],
  },
  {
    genesis_token_id: 17098,
    wearable_ids: [426, 262],
  },
  {
    genesis_token_id: 17099,
    wearable_ids: [304, 275],
  },
  {
    genesis_token_id: 17100,
    wearable_ids: [299, 364],
  },
  {
    genesis_token_id: 17101,
    wearable_ids: [437, 248],
  },
  {
    genesis_token_id: 17102,
    wearable_ids: [428, 322],
  },
  {
    genesis_token_id: 17103,
    wearable_ids: [255, 264],
  },
  {
    genesis_token_id: 17104,
    wearable_ids: [265, 368],
  },
  {
    genesis_token_id: 17105,
    wearable_ids: [412, 251],
  },
  {
    genesis_token_id: 17106,
    wearable_ids: [289, 300],
  },
  {
    genesis_token_id: 17107,
    wearable_ids: [286, 372],
  },
  {
    genesis_token_id: 17108,
    wearable_ids: [295, 368],
  },
  {
    genesis_token_id: 17109,
    wearable_ids: [364, 250],
  },
  {
    genesis_token_id: 17110,
    wearable_ids: [277, 407],
  },
  {
    genesis_token_id: 17111,
    wearable_ids: [254, 283],
  },
  {
    genesis_token_id: 17112,
    wearable_ids: [255, 296],
  },
  {
    genesis_token_id: 17113,
    wearable_ids: [287, 262],
  },
  {
    genesis_token_id: 17114,
    wearable_ids: [443, 276],
  },
  {
    genesis_token_id: 17115,
    wearable_ids: [324, 389],
  },
  {
    genesis_token_id: 17116,
    wearable_ids: [272, 345],
  },
  {
    genesis_token_id: 17117,
    wearable_ids: [408, 365],
  },
  {
    genesis_token_id: 17118,
    wearable_ids: [331, 429],
  },
  {
    genesis_token_id: 17119,
    wearable_ids: [371, 425],
  },
  {
    genesis_token_id: 17120,
    wearable_ids: [287, 370],
  },
  {
    genesis_token_id: 17121,
    wearable_ids: [287, 266],
  },
  {
    genesis_token_id: 17122,
    wearable_ids: [348, 316],
  },
  {
    genesis_token_id: 17123,
    wearable_ids: [263, 434],
  },
  {
    genesis_token_id: 17124,
    wearable_ids: [340, 290],
  },
  {
    genesis_token_id: 17125,
    wearable_ids: [365, 370],
  },
  {
    genesis_token_id: 17126,
    wearable_ids: [308, 326],
  },
  {
    genesis_token_id: 17127,
    wearable_ids: [445, 263],
  },
  {
    genesis_token_id: 17128,
    wearable_ids: [299, 433],
  },
  {
    genesis_token_id: 17129,
    wearable_ids: [280, 247],
  },
  {
    genesis_token_id: 17130,
    wearable_ids: [325, 347],
  },
  {
    genesis_token_id: 17131,
    wearable_ids: [395, 306],
  },
  {
    genesis_token_id: 17132,
    wearable_ids: [310, 431],
  },
  {
    genesis_token_id: 17133,
    wearable_ids: [277, 412],
  },
  {
    genesis_token_id: 17134,
    wearable_ids: [296, 264],
  },
  {
    genesis_token_id: 17135,
    wearable_ids: [354, 259],
  },
  {
    genesis_token_id: 17136,
    wearable_ids: [325, 369],
  },
  {
    genesis_token_id: 17137,
    wearable_ids: [301, 418],
  },
  {
    genesis_token_id: 17138,
    wearable_ids: [433, 336],
  },
  {
    genesis_token_id: 17139,
    wearable_ids: [341, 279],
  },
  {
    genesis_token_id: 17140,
    wearable_ids: [315, 284],
  },
  {
    genesis_token_id: 17141,
    wearable_ids: [254, 269],
  },
  {
    genesis_token_id: 17142,
    wearable_ids: [406, 445],
  },
  {
    genesis_token_id: 17143,
    wearable_ids: [262, 332],
  },
  {
    genesis_token_id: 17144,
    wearable_ids: [411, 249],
  },
  {
    genesis_token_id: 17145,
    wearable_ids: [268, 347],
  },
  {
    genesis_token_id: 17146,
    wearable_ids: [338, 255],
  },
  {
    genesis_token_id: 17147,
    wearable_ids: [444, 274],
  },
  {
    genesis_token_id: 17148,
    wearable_ids: [274, 270],
  },
  {
    genesis_token_id: 17149,
    wearable_ids: [335, 262],
  },
  {
    genesis_token_id: 17150,
    wearable_ids: [316, 393],
  },
  {
    genesis_token_id: 17151,
    wearable_ids: [301, 336],
  },
  {
    genesis_token_id: 17152,
    wearable_ids: [445, 271],
  },
  {
    genesis_token_id: 17153,
    wearable_ids: [340, 386],
  },
  {
    genesis_token_id: 17154,
    wearable_ids: [410, 414],
  },
  {
    genesis_token_id: 17155,
    wearable_ids: [387, 373],
  },
  {
    genesis_token_id: 17156,
    wearable_ids: [294, 291],
  },
  {
    genesis_token_id: 17157,
    wearable_ids: [385, 276],
  },
  {
    genesis_token_id: 17158,
    wearable_ids: [271, 287],
  },
  {
    genesis_token_id: 17159,
    wearable_ids: [354, 287],
  },
  {
    genesis_token_id: 17160,
    wearable_ids: [431, 281],
  },
  {
    genesis_token_id: 17161,
    wearable_ids: [284, 291],
  },
  {
    genesis_token_id: 17162,
    wearable_ids: [444, 352],
  },
  {
    genesis_token_id: 17163,
    wearable_ids: [277, 398],
  },
  {
    genesis_token_id: 17164,
    wearable_ids: [272, 396],
  },
  {
    genesis_token_id: 17165,
    wearable_ids: [304, 376],
  },
  {
    genesis_token_id: 17166,
    wearable_ids: [310, 388],
  },
  {
    genesis_token_id: 17167,
    wearable_ids: [251, 256],
  },
  {
    genesis_token_id: 17168,
    wearable_ids: [256, 406],
  },
  {
    genesis_token_id: 17169,
    wearable_ids: [385, 409],
  },
  {
    genesis_token_id: 17170,
    wearable_ids: [247, 304],
  },
  {
    genesis_token_id: 17171,
    wearable_ids: [406, 346],
  },
  {
    genesis_token_id: 17172,
    wearable_ids: [433, 311],
  },
  {
    genesis_token_id: 17173,
    wearable_ids: [443, 304],
  },
  {
    genesis_token_id: 17174,
    wearable_ids: [415, 428],
  },
  {
    genesis_token_id: 17175,
    wearable_ids: [424, 352],
  },
  {
    genesis_token_id: 17176,
    wearable_ids: [251, 336],
  },
  {
    genesis_token_id: 17177,
    wearable_ids: [445, 268],
  },
  {
    genesis_token_id: 17178,
    wearable_ids: [365, 268],
  },
  {
    genesis_token_id: 17179,
    wearable_ids: [271, 395],
  },
  {
    genesis_token_id: 17180,
    wearable_ids: [397, 347],
  },
  {
    genesis_token_id: 17181,
    wearable_ids: [341, 415],
  },
  {
    genesis_token_id: 17182,
    wearable_ids: [422, 350],
  },
  {
    genesis_token_id: 17183,
    wearable_ids: [429, 435],
  },
  {
    genesis_token_id: 17184,
    wearable_ids: [306, 291],
  },
  {
    genesis_token_id: 17185,
    wearable_ids: [273, 270],
  },
  {
    genesis_token_id: 17186,
    wearable_ids: [304, 342],
  },
  {
    genesis_token_id: 17187,
    wearable_ids: [372, 350],
  },
  {
    genesis_token_id: 17188,
    wearable_ids: [257, 283],
  },
  {
    genesis_token_id: 17189,
    wearable_ids: [445, 363],
  },
  {
    genesis_token_id: 17190,
    wearable_ids: [442, 386],
  },
  {
    genesis_token_id: 17191,
    wearable_ids: [253, 372],
  },
  {
    genesis_token_id: 17192,
    wearable_ids: [384, 438],
  },
  {
    genesis_token_id: 17193,
    wearable_ids: [268, 333],
  },
  {
    genesis_token_id: 17194,
    wearable_ids: [331, 272],
  },
  {
    genesis_token_id: 17195,
    wearable_ids: [325, 382],
  },
  {
    genesis_token_id: 17196,
    wearable_ids: [364, 394],
  },
  {
    genesis_token_id: 17197,
    wearable_ids: [292, 296],
  },
  {
    genesis_token_id: 17198,
    wearable_ids: [404, 402],
  },
  {
    genesis_token_id: 17199,
    wearable_ids: [296, 251],
  },
  {
    genesis_token_id: 17200,
    wearable_ids: [363, 341],
  },
  {
    genesis_token_id: 17201,
    wearable_ids: [377, 253],
  },
  {
    genesis_token_id: 17202,
    wearable_ids: [413, 368],
  },
  {
    genesis_token_id: 17203,
    wearable_ids: [347, 405],
  },
  {
    genesis_token_id: 17204,
    wearable_ids: [445, 404],
  },
  {
    genesis_token_id: 17205,
    wearable_ids: [290, 422],
  },
  {
    genesis_token_id: 17206,
    wearable_ids: [262, 324],
  },
  {
    genesis_token_id: 17207,
    wearable_ids: [349, 382],
  },
  {
    genesis_token_id: 17208,
    wearable_ids: [384, 374],
  },
  {
    genesis_token_id: 17209,
    wearable_ids: [431, 342],
  },
  {
    genesis_token_id: 17210,
    wearable_ids: [364, 420],
  },
  {
    genesis_token_id: 17211,
    wearable_ids: [424, 400],
  },
  {
    genesis_token_id: 17212,
    wearable_ids: [371, 437],
  },
  {
    genesis_token_id: 17213,
    wearable_ids: [289, 271],
  },
  {
    genesis_token_id: 17214,
    wearable_ids: [338, 440],
  },
  {
    genesis_token_id: 17215,
    wearable_ids: [337, 394],
  },
  {
    genesis_token_id: 17216,
    wearable_ids: [363, 429],
  },
  {
    genesis_token_id: 17217,
    wearable_ids: [306, 250],
  },
  {
    genesis_token_id: 17218,
    wearable_ids: [443, 270],
  },
  {
    genesis_token_id: 17219,
    wearable_ids: [340, 273],
  },
  {
    genesis_token_id: 17220,
    wearable_ids: [343, 407],
  },
  {
    genesis_token_id: 17221,
    wearable_ids: [272, 342],
  },
  {
    genesis_token_id: 17222,
    wearable_ids: [263, 301],
  },
  {
    genesis_token_id: 17223,
    wearable_ids: [295, 355],
  },
  {
    genesis_token_id: 17224,
    wearable_ids: [411, 262],
  },
  {
    genesis_token_id: 17225,
    wearable_ids: [319, 332],
  },
  {
    genesis_token_id: 17226,
    wearable_ids: [384, 344],
  },
  {
    genesis_token_id: 17227,
    wearable_ids: [325, 299],
  },
  {
    genesis_token_id: 17228,
    wearable_ids: [324, 287],
  },
  {
    genesis_token_id: 17229,
    wearable_ids: [445, 373],
  },
  {
    genesis_token_id: 17230,
    wearable_ids: [271, 336],
  },
  {
    genesis_token_id: 17231,
    wearable_ids: [420, 305],
  },
  {
    genesis_token_id: 17232,
    wearable_ids: [316, 278],
  },
  {
    genesis_token_id: 17233,
    wearable_ids: [286, 431],
  },
  {
    genesis_token_id: 17234,
    wearable_ids: [278, 387],
  },
  {
    genesis_token_id: 17235,
    wearable_ids: [424, 362],
  },
  {
    genesis_token_id: 17236,
    wearable_ids: [295, 383],
  },
  {
    genesis_token_id: 17237,
    wearable_ids: [319, 385],
  },
  {
    genesis_token_id: 17238,
    wearable_ids: [420, 372],
  },
  {
    genesis_token_id: 17239,
    wearable_ids: [349, 400],
  },
  {
    genesis_token_id: 17240,
    wearable_ids: [311, 411],
  },
  {
    genesis_token_id: 17241,
    wearable_ids: [368, 299],
  },
  {
    genesis_token_id: 17242,
    wearable_ids: [404, 419],
  },
  {
    genesis_token_id: 17243,
    wearable_ids: [354, 277],
  },
  {
    genesis_token_id: 17244,
    wearable_ids: [319, 368],
  },
  {
    genesis_token_id: 17245,
    wearable_ids: [331, 407],
  },
  {
    genesis_token_id: 17246,
    wearable_ids: [420, 336],
  },
  {
    genesis_token_id: 17247,
    wearable_ids: [397, 297],
  },
  {
    genesis_token_id: 17248,
    wearable_ids: [335, 397],
  },
  {
    genesis_token_id: 17249,
    wearable_ids: [273, 295],
  },
  {
    genesis_token_id: 17250,
    wearable_ids: [264, 342],
  },
  {
    genesis_token_id: 17251,
    wearable_ids: [429, 422],
  },
  {
    genesis_token_id: 17252,
    wearable_ids: [290, 428],
  },
  {
    genesis_token_id: 17253,
    wearable_ids: [397, 352],
  },
  {
    genesis_token_id: 17254,
    wearable_ids: [326, 260],
  },
  {
    genesis_token_id: 17255,
    wearable_ids: [435, 280],
  },
  {
    genesis_token_id: 17256,
    wearable_ids: [315, 443],
  },
  {
    genesis_token_id: 17257,
    wearable_ids: [445, 288],
  },
  {
    genesis_token_id: 17258,
    wearable_ids: [336, 433],
  },
  {
    genesis_token_id: 17259,
    wearable_ids: [371, 341],
  },
  {
    genesis_token_id: 17260,
    wearable_ids: [340, 426],
  },
  {
    genesis_token_id: 17261,
    wearable_ids: [331, 425],
  },
  {
    genesis_token_id: 17262,
    wearable_ids: [274, 404],
  },
  {
    genesis_token_id: 17263,
    wearable_ids: [326, 434],
  },
  {
    genesis_token_id: 17264,
    wearable_ids: [349, 265],
  },
  {
    genesis_token_id: 17265,
    wearable_ids: [280, 377],
  },
  {
    genesis_token_id: 17266,
    wearable_ids: [389, 248],
  },
  {
    genesis_token_id: 17267,
    wearable_ids: [384, 431],
  },
  {
    genesis_token_id: 17268,
    wearable_ids: [264, 350],
  },
  {
    genesis_token_id: 17269,
    wearable_ids: [378, 304],
  },
  {
    genesis_token_id: 17270,
    wearable_ids: [286, 378],
  },
  {
    genesis_token_id: 17271,
    wearable_ids: [374, 305],
  },
  {
    genesis_token_id: 17272,
    wearable_ids: [377, 372],
  },
  {
    genesis_token_id: 17273,
    wearable_ids: [340, 248],
  },
  {
    genesis_token_id: 17274,
    wearable_ids: [396, 296],
  },
  {
    genesis_token_id: 17275,
    wearable_ids: [253, 339],
  },
  {
    genesis_token_id: 17276,
    wearable_ids: [432, 351],
  },
  {
    genesis_token_id: 17277,
    wearable_ids: [278, 400],
  },
  {
    genesis_token_id: 17278,
    wearable_ids: [326, 310],
  },
  {
    genesis_token_id: 17279,
    wearable_ids: [371, 316],
  },
  {
    genesis_token_id: 17280,
    wearable_ids: [271, 280],
  },
  {
    genesis_token_id: 17281,
    wearable_ids: [256, 400],
  },
  {
    genesis_token_id: 17282,
    wearable_ids: [383, 354],
  },
  {
    genesis_token_id: 17283,
    wearable_ids: [317, 340],
  },
  {
    genesis_token_id: 17284,
    wearable_ids: [354, 392],
  },
  {
    genesis_token_id: 17285,
    wearable_ids: [408, 248],
  },
  {
    genesis_token_id: 17286,
    wearable_ids: [284, 294],
  },
  {
    genesis_token_id: 17287,
    wearable_ids: [263, 353],
  },
  {
    genesis_token_id: 17288,
    wearable_ids: [341, 288],
  },
  {
    genesis_token_id: 17289,
    wearable_ids: [314, 424],
  },
  {
    genesis_token_id: 17290,
    wearable_ids: [407, 430],
  },
  {
    genesis_token_id: 17291,
    wearable_ids: [349, 268],
  },
  {
    genesis_token_id: 17292,
    wearable_ids: [284, 296],
  },
  {
    genesis_token_id: 17293,
    wearable_ids: [407, 301],
  },
  {
    genesis_token_id: 17294,
    wearable_ids: [424, 436],
  },
  {
    genesis_token_id: 17295,
    wearable_ids: [378, 402],
  },
  {
    genesis_token_id: 17296,
    wearable_ids: [301, 254],
  },
  {
    genesis_token_id: 17297,
    wearable_ids: [342, 414],
  },
  {
    genesis_token_id: 17298,
    wearable_ids: [408, 292],
  },
  {
    genesis_token_id: 17299,
    wearable_ids: [287, 420],
  },
  {
    genesis_token_id: 17300,
    wearable_ids: [433, 428],
  },
  {
    genesis_token_id: 17301,
    wearable_ids: [306, 438],
  },
  {
    genesis_token_id: 17302,
    wearable_ids: [299, 423],
  },
  {
    genesis_token_id: 17303,
    wearable_ids: [443, 444],
  },
  {
    genesis_token_id: 17304,
    wearable_ids: [355, 416],
  },
  {
    genesis_token_id: 17305,
    wearable_ids: [347, 432],
  },
  {
    genesis_token_id: 17306,
    wearable_ids: [443, 259],
  },
  {
    genesis_token_id: 17307,
    wearable_ids: [254, 332],
  },
  {
    genesis_token_id: 17308,
    wearable_ids: [428, 412],
  },
  {
    genesis_token_id: 17309,
    wearable_ids: [273, 320],
  },
  {
    genesis_token_id: 17310,
    wearable_ids: [396, 370],
  },
  {
    genesis_token_id: 17311,
    wearable_ids: [372, 379],
  },
  {
    genesis_token_id: 17312,
    wearable_ids: [340, 265],
  },
  {
    genesis_token_id: 17313,
    wearable_ids: [308, 250],
  },
  {
    genesis_token_id: 17314,
    wearable_ids: [278, 365],
  },
  {
    genesis_token_id: 17315,
    wearable_ids: [336, 305],
  },
  {
    genesis_token_id: 17316,
    wearable_ids: [299, 372],
  },
  {
    genesis_token_id: 17317,
    wearable_ids: [251, 342],
  },
  {
    genesis_token_id: 17318,
    wearable_ids: [332, 428],
  },
  {
    genesis_token_id: 17319,
    wearable_ids: [291, 349],
  },
  {
    genesis_token_id: 17320,
    wearable_ids: [434, 319],
  },
  {
    genesis_token_id: 17321,
    wearable_ids: [385, 373],
  },
  {
    genesis_token_id: 17322,
    wearable_ids: [435, 303],
  },
  {
    genesis_token_id: 17323,
    wearable_ids: [369, 376],
  },
  {
    genesis_token_id: 17324,
    wearable_ids: [299, 395],
  },
  {
    genesis_token_id: 17325,
    wearable_ids: [266, 272],
  },
  {
    genesis_token_id: 17326,
    wearable_ids: [396, 387],
  },
  {
    genesis_token_id: 17327,
    wearable_ids: [291, 408],
  },
  {
    genesis_token_id: 17328,
    wearable_ids: [272, 248],
  },
  {
    genesis_token_id: 17329,
    wearable_ids: [295, 311],
  },
  {
    genesis_token_id: 17330,
    wearable_ids: [425, 295],
  },
  {
    genesis_token_id: 17331,
    wearable_ids: [429, 445],
  },
  {
    genesis_token_id: 17332,
    wearable_ids: [291, 375],
  },
  {
    genesis_token_id: 17333,
    wearable_ids: [299, 404],
  },
  {
    genesis_token_id: 17334,
    wearable_ids: [326, 346],
  },
  {
    genesis_token_id: 17335,
    wearable_ids: [410, 325],
  },
  {
    genesis_token_id: 17336,
    wearable_ids: [444, 284],
  },
  {
    genesis_token_id: 17337,
    wearable_ids: [336, 258],
  },
  {
    genesis_token_id: 17338,
    wearable_ids: [387, 330],
  },
  {
    genesis_token_id: 17339,
    wearable_ids: [372, 316],
  },
  {
    genesis_token_id: 17340,
    wearable_ids: [415, 292],
  },
  {
    genesis_token_id: 17341,
    wearable_ids: [445, 337],
  },
  {
    genesis_token_id: 17342,
    wearable_ids: [382, 342],
  },
  {
    genesis_token_id: 17343,
    wearable_ids: [258, 355],
  },
  {
    genesis_token_id: 17344,
    wearable_ids: [297, 284],
  },
  {
    genesis_token_id: 17345,
    wearable_ids: [339, 360],
  },
  {
    genesis_token_id: 17346,
    wearable_ids: [324, 375],
  },
  {
    genesis_token_id: 17347,
    wearable_ids: [295, 378],
  },
  {
    genesis_token_id: 17348,
    wearable_ids: [325, 395],
  },
  {
    genesis_token_id: 17349,
    wearable_ids: [272, 341],
  },
  {
    genesis_token_id: 17350,
    wearable_ids: [325, 373],
  },
  {
    genesis_token_id: 17351,
    wearable_ids: [325, 340],
  },
  {
    genesis_token_id: 17352,
    wearable_ids: [303, 314],
  },
  {
    genesis_token_id: 17353,
    wearable_ids: [338, 418],
  },
  {
    genesis_token_id: 17354,
    wearable_ids: [308, 273],
  },
  {
    genesis_token_id: 17355,
    wearable_ids: [396, 391],
  },
  {
    genesis_token_id: 17356,
    wearable_ids: [371, 299],
  },
  {
    genesis_token_id: 17357,
    wearable_ids: [437, 385],
  },
  {
    genesis_token_id: 17358,
    wearable_ids: [340, 296],
  },
  {
    genesis_token_id: 17359,
    wearable_ids: [386, 369],
  },
  {
    genesis_token_id: 17360,
    wearable_ids: [407, 347],
  },
  {
    genesis_token_id: 17361,
    wearable_ids: [425, 340],
  },
  {
    genesis_token_id: 17362,
    wearable_ids: [247, 396],
  },
  {
    genesis_token_id: 17363,
    wearable_ids: [344, 277],
  },
  {
    genesis_token_id: 17364,
    wearable_ids: [255, 286],
  },
  {
    genesis_token_id: 17365,
    wearable_ids: [434, 255],
  },
  {
    genesis_token_id: 17366,
    wearable_ids: [304, 316],
  },
  {
    genesis_token_id: 17367,
    wearable_ids: [301, 331],
  },
  {
    genesis_token_id: 17368,
    wearable_ids: [341, 288],
  },
  {
    genesis_token_id: 17369,
    wearable_ids: [251, 301],
  },
  {
    genesis_token_id: 17370,
    wearable_ids: [432, 437],
  },
  {
    genesis_token_id: 17371,
    wearable_ids: [263, 308],
  },
  {
    genesis_token_id: 17372,
    wearable_ids: [426, 391],
  },
  {
    genesis_token_id: 17373,
    wearable_ids: [408, 426],
  },
  {
    genesis_token_id: 17374,
    wearable_ids: [404, 419],
  },
  {
    genesis_token_id: 17375,
    wearable_ids: [369, 336],
  },
  {
    genesis_token_id: 17376,
    wearable_ids: [428, 398],
  },
  {
    genesis_token_id: 17377,
    wearable_ids: [262, 370],
  },
  {
    genesis_token_id: 17378,
    wearable_ids: [266, 316],
  },
  {
    genesis_token_id: 17379,
    wearable_ids: [286, 310],
  },
  {
    genesis_token_id: 17380,
    wearable_ids: [432, 438],
  },
  {
    genesis_token_id: 17381,
    wearable_ids: [335, 287],
  },
  {
    genesis_token_id: 17382,
    wearable_ids: [362, 360],
  },
  {
    genesis_token_id: 17383,
    wearable_ids: [424, 286],
  },
  {
    genesis_token_id: 17384,
    wearable_ids: [268, 347],
  },
  {
    genesis_token_id: 17385,
    wearable_ids: [273, 344],
  },
  {
    genesis_token_id: 17386,
    wearable_ids: [410, 290],
  },
  {
    genesis_token_id: 17387,
    wearable_ids: [378, 396],
  },
  {
    genesis_token_id: 17388,
    wearable_ids: [387, 265],
  },
  {
    genesis_token_id: 17389,
    wearable_ids: [347, 434],
  },
  {
    genesis_token_id: 17390,
    wearable_ids: [411, 432],
  },
  {
    genesis_token_id: 17391,
    wearable_ids: [273, 382],
  },
  {
    genesis_token_id: 17392,
    wearable_ids: [347, 314],
  },
  {
    genesis_token_id: 17393,
    wearable_ids: [346, 327],
  },
  {
    genesis_token_id: 17394,
    wearable_ids: [432, 378],
  },
  {
    genesis_token_id: 17395,
    wearable_ids: [369, 341],
  },
  {
    genesis_token_id: 17396,
    wearable_ids: [352, 391],
  },
  {
    genesis_token_id: 17397,
    wearable_ids: [278, 317],
  },
  {
    genesis_token_id: 17398,
    wearable_ids: [258, 308],
  },
  {
    genesis_token_id: 17399,
    wearable_ids: [445, 373],
  },
  {
    genesis_token_id: 17400,
    wearable_ids: [349, 400],
  },
  {
    genesis_token_id: 17401,
    wearable_ids: [272, 340],
  },
  {
    genesis_token_id: 17402,
    wearable_ids: [363, 272],
  },
  {
    genesis_token_id: 17403,
    wearable_ids: [408, 412],
  },
  {
    genesis_token_id: 17404,
    wearable_ids: [304, 249],
  },
  {
    genesis_token_id: 17405,
    wearable_ids: [351, 384],
  },
  {
    genesis_token_id: 17406,
    wearable_ids: [432, 317],
  },
  {
    genesis_token_id: 17407,
    wearable_ids: [346, 312],
  },
  {
    genesis_token_id: 17408,
    wearable_ids: [400, 317],
  },
  {
    genesis_token_id: 17409,
    wearable_ids: [338, 438],
  },
  {
    genesis_token_id: 17410,
    wearable_ids: [332, 397],
  },
  {
    genesis_token_id: 17411,
    wearable_ids: [262, 259],
  },
  {
    genesis_token_id: 17412,
    wearable_ids: [406, 318],
  },
  {
    genesis_token_id: 17413,
    wearable_ids: [262, 263],
  },
  {
    genesis_token_id: 17414,
    wearable_ids: [368, 324],
  },
  {
    genesis_token_id: 17415,
    wearable_ids: [291, 424],
  },
  {
    genesis_token_id: 17416,
    wearable_ids: [264, 385],
  },
  {
    genesis_token_id: 17417,
    wearable_ids: [259, 345],
  },
  {
    genesis_token_id: 17418,
    wearable_ids: [406, 324],
  },
  {
    genesis_token_id: 17419,
    wearable_ids: [310, 343],
  },
  {
    genesis_token_id: 17420,
    wearable_ids: [409, 415],
  },
  {
    genesis_token_id: 17421,
    wearable_ids: [350, 403],
  },
  {
    genesis_token_id: 17422,
    wearable_ids: [384, 248],
  },
  {
    genesis_token_id: 17423,
    wearable_ids: [331, 345],
  },
  {
    genesis_token_id: 17424,
    wearable_ids: [317, 383],
  },
  {
    genesis_token_id: 17425,
    wearable_ids: [331, 357],
  },
  {
    genesis_token_id: 17426,
    wearable_ids: [257, 291],
  },
  {
    genesis_token_id: 17427,
    wearable_ids: [444, 266],
  },
  {
    genesis_token_id: 17428,
    wearable_ids: [432, 322],
  },
  {
    genesis_token_id: 17429,
    wearable_ids: [286, 385],
  },
  {
    genesis_token_id: 17430,
    wearable_ids: [384, 385],
  },
  {
    genesis_token_id: 17431,
    wearable_ids: [294, 429],
  },
  {
    genesis_token_id: 17432,
    wearable_ids: [404, 408],
  },
  {
    genesis_token_id: 17433,
    wearable_ids: [362, 289],
  },
  {
    genesis_token_id: 17434,
    wearable_ids: [339, 247],
  },
  {
    genesis_token_id: 17435,
    wearable_ids: [423, 267],
  },
  {
    genesis_token_id: 17436,
    wearable_ids: [263, 395],
  },
  {
    genesis_token_id: 17437,
    wearable_ids: [287, 347],
  },
  {
    genesis_token_id: 17438,
    wearable_ids: [278, 357],
  },
  {
    genesis_token_id: 17439,
    wearable_ids: [278, 255],
  },
  {
    genesis_token_id: 17440,
    wearable_ids: [395, 351],
  },
  {
    genesis_token_id: 17441,
    wearable_ids: [274, 415],
  },
  {
    genesis_token_id: 17442,
    wearable_ids: [301, 426],
  },
  {
    genesis_token_id: 17443,
    wearable_ids: [400, 422],
  },
  {
    genesis_token_id: 17444,
    wearable_ids: [339, 402],
  },
  {
    genesis_token_id: 17445,
    wearable_ids: [347, 349],
  },
  {
    genesis_token_id: 17446,
    wearable_ids: [412, 361],
  },
  {
    genesis_token_id: 17447,
    wearable_ids: [339, 445],
  },
  {
    genesis_token_id: 17448,
    wearable_ids: [364, 374],
  },
  {
    genesis_token_id: 17449,
    wearable_ids: [362, 405],
  },
  {
    genesis_token_id: 17450,
    wearable_ids: [289, 336],
  },
  {
    genesis_token_id: 17451,
    wearable_ids: [396, 348],
  },
  {
    genesis_token_id: 17452,
    wearable_ids: [373, 262],
  },
  {
    genesis_token_id: 17453,
    wearable_ids: [369, 248],
  },
  {
    genesis_token_id: 17454,
    wearable_ids: [278, 347],
  },
  {
    genesis_token_id: 17455,
    wearable_ids: [426, 363],
  },
  {
    genesis_token_id: 17456,
    wearable_ids: [397, 274],
  },
  {
    genesis_token_id: 17457,
    wearable_ids: [266, 345],
  },
  {
    genesis_token_id: 17458,
    wearable_ids: [265, 355],
  },
  {
    genesis_token_id: 17459,
    wearable_ids: [406, 429],
  },
  {
    genesis_token_id: 17460,
    wearable_ids: [382, 335],
  },
  {
    genesis_token_id: 17461,
    wearable_ids: [326, 314],
  },
  {
    genesis_token_id: 17462,
    wearable_ids: [365, 307],
  },
  {
    genesis_token_id: 17463,
    wearable_ids: [304, 264],
  },
  {
    genesis_token_id: 17464,
    wearable_ids: [262, 422],
  },
  {
    genesis_token_id: 17465,
    wearable_ids: [403, 264],
  },
  {
    genesis_token_id: 17466,
    wearable_ids: [251, 445],
  },
  {
    genesis_token_id: 17467,
    wearable_ids: [340, 299],
  },
  {
    genesis_token_id: 17468,
    wearable_ids: [255, 407],
  },
  {
    genesis_token_id: 17469,
    wearable_ids: [413, 411],
  },
  {
    genesis_token_id: 17470,
    wearable_ids: [420, 351],
  },
  {
    genesis_token_id: 17471,
    wearable_ids: [311, 383],
  },
  {
    genesis_token_id: 17472,
    wearable_ids: [344, 292],
  },
  {
    genesis_token_id: 17473,
    wearable_ids: [316, 346],
  },
  {
    genesis_token_id: 17474,
    wearable_ids: [370, 392],
  },
  {
    genesis_token_id: 17475,
    wearable_ids: [433, 293],
  },
  {
    genesis_token_id: 17476,
    wearable_ids: [364, 346],
  },
  {
    genesis_token_id: 17477,
    wearable_ids: [308, 405],
  },
  {
    genesis_token_id: 17478,
    wearable_ids: [272, 422],
  },
  {
    genesis_token_id: 17479,
    wearable_ids: [290, 276],
  },
  {
    genesis_token_id: 17480,
    wearable_ids: [363, 253],
  },
  {
    genesis_token_id: 17481,
    wearable_ids: [423, 256],
  },
  {
    genesis_token_id: 17482,
    wearable_ids: [264, 346],
  },
  {
    genesis_token_id: 17483,
    wearable_ids: [254, 341],
  },
  {
    genesis_token_id: 17484,
    wearable_ids: [255, 408],
  },
  {
    genesis_token_id: 17485,
    wearable_ids: [422, 308],
  },
  {
    genesis_token_id: 17486,
    wearable_ids: [253, 397],
  },
  {
    genesis_token_id: 17487,
    wearable_ids: [316, 415],
  },
  {
    genesis_token_id: 17488,
    wearable_ids: [374, 341],
  },
  {
    genesis_token_id: 17489,
    wearable_ids: [286, 414],
  },
  {
    genesis_token_id: 17490,
    wearable_ids: [308, 296],
  },
  {
    genesis_token_id: 17491,
    wearable_ids: [335, 347],
  },
  {
    genesis_token_id: 17492,
    wearable_ids: [425, 272],
  },
  {
    genesis_token_id: 17493,
    wearable_ids: [306, 258],
  },
  {
    genesis_token_id: 17494,
    wearable_ids: [253, 259],
  },
  {
    genesis_token_id: 17495,
    wearable_ids: [389, 347],
  },
  {
    genesis_token_id: 17496,
    wearable_ids: [434, 399],
  },
  {
    genesis_token_id: 17497,
    wearable_ids: [374, 331],
  },
  {
    genesis_token_id: 17498,
    wearable_ids: [286, 278],
  },
  {
    genesis_token_id: 17499,
    wearable_ids: [257, 393],
  },
  {
    genesis_token_id: 17500,
    wearable_ids: [420, 267],
  },
  {
    genesis_token_id: 17501,
    wearable_ids: [253, 393],
  },
  {
    genesis_token_id: 17502,
    wearable_ids: [266, 403],
  },
  {
    genesis_token_id: 17503,
    wearable_ids: [375, 335],
  },
  {
    genesis_token_id: 17504,
    wearable_ids: [433, 255],
  },
  {
    genesis_token_id: 17505,
    wearable_ids: [340, 250],
  },
  {
    genesis_token_id: 17506,
    wearable_ids: [338, 428],
  },
  {
    genesis_token_id: 17507,
    wearable_ids: [442, 330],
  },
  {
    genesis_token_id: 17508,
    wearable_ids: [294, 324],
  },
  {
    genesis_token_id: 17509,
    wearable_ids: [425, 361],
  },
  {
    genesis_token_id: 17510,
    wearable_ids: [257, 341],
  },
  {
    genesis_token_id: 17511,
    wearable_ids: [420, 324],
  },
  {
    genesis_token_id: 17512,
    wearable_ids: [257, 378],
  },
  {
    genesis_token_id: 17513,
    wearable_ids: [432, 277],
  },
  {
    genesis_token_id: 17514,
    wearable_ids: [364, 372],
  },
  {
    genesis_token_id: 17515,
    wearable_ids: [425, 401],
  },
  {
    genesis_token_id: 17516,
    wearable_ids: [372, 389],
  },
  {
    genesis_token_id: 17517,
    wearable_ids: [420, 297],
  },
  {
    genesis_token_id: 17518,
    wearable_ids: [343, 265],
  },
  {
    genesis_token_id: 17519,
    wearable_ids: [377, 299],
  },
  {
    genesis_token_id: 17520,
    wearable_ids: [351, 424],
  },
  {
    genesis_token_id: 17521,
    wearable_ids: [319, 330],
  },
  {
    genesis_token_id: 17522,
    wearable_ids: [291, 368],
  },
  {
    genesis_token_id: 17523,
    wearable_ids: [410, 345],
  },
  {
    genesis_token_id: 17524,
    wearable_ids: [383, 392],
  },
  {
    genesis_token_id: 17525,
    wearable_ids: [306, 315],
  },
  {
    genesis_token_id: 17526,
    wearable_ids: [425, 289],
  },
  {
    genesis_token_id: 17527,
    wearable_ids: [403, 422],
  },
  {
    genesis_token_id: 17528,
    wearable_ids: [315, 383],
  },
  {
    genesis_token_id: 17529,
    wearable_ids: [368, 316],
  },
  {
    genesis_token_id: 17530,
    wearable_ids: [377, 253],
  },
  {
    genesis_token_id: 17531,
    wearable_ids: [435, 292],
  },
  {
    genesis_token_id: 17532,
    wearable_ids: [395, 310],
  },
  {
    genesis_token_id: 17533,
    wearable_ids: [295, 442],
  },
  {
    genesis_token_id: 17534,
    wearable_ids: [326, 430],
  },
  {
    genesis_token_id: 17535,
    wearable_ids: [436, 372],
  },
  {
    genesis_token_id: 17536,
    wearable_ids: [433, 410],
  },
  {
    genesis_token_id: 17537,
    wearable_ids: [374, 286],
  },
  {
    genesis_token_id: 17538,
    wearable_ids: [443, 364],
  },
  {
    genesis_token_id: 17539,
    wearable_ids: [263, 442],
  },
  {
    genesis_token_id: 17540,
    wearable_ids: [263, 429],
  },
  {
    genesis_token_id: 17541,
    wearable_ids: [409, 262],
  },
  {
    genesis_token_id: 17542,
    wearable_ids: [409, 375],
  },
  {
    genesis_token_id: 17543,
    wearable_ids: [431, 344],
  },
  {
    genesis_token_id: 17544,
    wearable_ids: [324, 442],
  },
  {
    genesis_token_id: 17545,
    wearable_ids: [428, 307],
  },
  {
    genesis_token_id: 17546,
    wearable_ids: [431, 434],
  },
  {
    genesis_token_id: 17547,
    wearable_ids: [338, 265],
  },
  {
    genesis_token_id: 17548,
    wearable_ids: [290, 400],
  },
  {
    genesis_token_id: 17549,
    wearable_ids: [432, 308],
  },
  {
    genesis_token_id: 17550,
    wearable_ids: [382, 336],
  },
  {
    genesis_token_id: 17551,
    wearable_ids: [337, 432],
  },
  {
    genesis_token_id: 17552,
    wearable_ids: [355, 428],
  },
  {
    genesis_token_id: 17553,
    wearable_ids: [346, 375],
  },
  {
    genesis_token_id: 17554,
    wearable_ids: [296, 264],
  },
  {
    genesis_token_id: 17555,
    wearable_ids: [259, 368],
  },
  {
    genesis_token_id: 17556,
    wearable_ids: [400, 410],
  },
  {
    genesis_token_id: 17557,
    wearable_ids: [373, 262],
  },
  {
    genesis_token_id: 17558,
    wearable_ids: [299, 313],
  },
  {
    genesis_token_id: 17559,
    wearable_ids: [415, 428],
  },
  {
    genesis_token_id: 17560,
    wearable_ids: [314, 363],
  },
  {
    genesis_token_id: 17561,
    wearable_ids: [335, 422],
  },
  {
    genesis_token_id: 17562,
    wearable_ids: [292, 442],
  },
  {
    genesis_token_id: 17563,
    wearable_ids: [386, 444],
  },
  {
    genesis_token_id: 17564,
    wearable_ids: [408, 376],
  },
  {
    genesis_token_id: 17565,
    wearable_ids: [247, 251],
  },
  {
    genesis_token_id: 17566,
    wearable_ids: [314, 386],
  },
  {
    genesis_token_id: 17567,
    wearable_ids: [406, 311],
  },
  {
    genesis_token_id: 17568,
    wearable_ids: [348, 317],
  },
  {
    genesis_token_id: 17569,
    wearable_ids: [411, 359],
  },
  {
    genesis_token_id: 17570,
    wearable_ids: [256, 422],
  },
  {
    genesis_token_id: 17571,
    wearable_ids: [397, 286],
  },
  {
    genesis_token_id: 17572,
    wearable_ids: [315, 264],
  },
  {
    genesis_token_id: 17573,
    wearable_ids: [258, 268],
  },
  {
    genesis_token_id: 17574,
    wearable_ids: [368, 298],
  },
  {
    genesis_token_id: 17575,
    wearable_ids: [316, 429],
  },
  {
    genesis_token_id: 17576,
    wearable_ids: [316, 384],
  },
  {
    genesis_token_id: 17577,
    wearable_ids: [294, 274],
  },
  {
    genesis_token_id: 17578,
    wearable_ids: [374, 431],
  },
  {
    genesis_token_id: 17579,
    wearable_ids: [404, 365],
  },
  {
    genesis_token_id: 17580,
    wearable_ids: [406, 255],
  },
  {
    genesis_token_id: 17581,
    wearable_ids: [376, 281],
  },
  {
    genesis_token_id: 17582,
    wearable_ids: [348, 292],
  },
  {
    genesis_token_id: 17583,
    wearable_ids: [336, 303],
  },
  {
    genesis_token_id: 17584,
    wearable_ids: [363, 389],
  },
  {
    genesis_token_id: 17585,
    wearable_ids: [406, 270],
  },
  {
    genesis_token_id: 17586,
    wearable_ids: [436, 255],
  },
  {
    genesis_token_id: 17587,
    wearable_ids: [437, 443],
  },
  {
    genesis_token_id: 17588,
    wearable_ids: [332, 389],
  },
  {
    genesis_token_id: 17589,
    wearable_ids: [442, 432],
  },
  {
    genesis_token_id: 17590,
    wearable_ids: [409, 304],
  },
  {
    genesis_token_id: 17591,
    wearable_ids: [423, 341],
  },
  {
    genesis_token_id: 17592,
    wearable_ids: [338, 324],
  },
  {
    genesis_token_id: 17593,
    wearable_ids: [270, 399],
  },
  {
    genesis_token_id: 17594,
    wearable_ids: [373, 256],
  },
  {
    genesis_token_id: 17595,
    wearable_ids: [420, 342],
  },
  {
    genesis_token_id: 17596,
    wearable_ids: [413, 362],
  },
  {
    genesis_token_id: 17597,
    wearable_ids: [362, 408],
  },
  {
    genesis_token_id: 17598,
    wearable_ids: [314, 384],
  },
  {
    genesis_token_id: 17599,
    wearable_ids: [276, 272],
  },
  {
    genesis_token_id: 17600,
    wearable_ids: [332, 253],
  },
  {
    genesis_token_id: 17601,
    wearable_ids: [425, 378],
  },
  {
    genesis_token_id: 17602,
    wearable_ids: [368, 247],
  },
  {
    genesis_token_id: 17603,
    wearable_ids: [278, 280],
  },
  {
    genesis_token_id: 17604,
    wearable_ids: [258, 319],
  },
  {
    genesis_token_id: 17605,
    wearable_ids: [299, 434],
  },
  {
    genesis_token_id: 17606,
    wearable_ids: [422, 277],
  },
  {
    genesis_token_id: 17607,
    wearable_ids: [343, 348],
  },
  {
    genesis_token_id: 17608,
    wearable_ids: [378, 271],
  },
  {
    genesis_token_id: 17609,
    wearable_ids: [280, 440],
  },
  {
    genesis_token_id: 17610,
    wearable_ids: [362, 445],
  },
  {
    genesis_token_id: 17611,
    wearable_ids: [255, 292],
  },
  {
    genesis_token_id: 17612,
    wearable_ids: [291, 276],
  },
  {
    genesis_token_id: 17613,
    wearable_ids: [396, 407],
  },
  {
    genesis_token_id: 17614,
    wearable_ids: [315, 406],
  },
  {
    genesis_token_id: 17615,
    wearable_ids: [372, 308],
  },
  {
    genesis_token_id: 17616,
    wearable_ids: [365, 279],
  },
  {
    genesis_token_id: 17617,
    wearable_ids: [247, 404],
  },
  {
    genesis_token_id: 17618,
    wearable_ids: [340, 412],
  },
  {
    genesis_token_id: 17619,
    wearable_ids: [432, 355],
  },
  {
    genesis_token_id: 17620,
    wearable_ids: [396, 344],
  },
  {
    genesis_token_id: 17621,
    wearable_ids: [354, 350],
  },
  {
    genesis_token_id: 17622,
    wearable_ids: [424, 375],
  },
  {
    genesis_token_id: 17623,
    wearable_ids: [306, 420],
  },
  {
    genesis_token_id: 17624,
    wearable_ids: [422, 412],
  },
  {
    genesis_token_id: 17625,
    wearable_ids: [384, 272],
  },
  {
    genesis_token_id: 17626,
    wearable_ids: [317, 394],
  },
  {
    genesis_token_id: 17627,
    wearable_ids: [382, 352],
  },
  {
    genesis_token_id: 17628,
    wearable_ids: [420, 418],
  },
  {
    genesis_token_id: 17629,
    wearable_ids: [264, 340],
  },
  {
    genesis_token_id: 17630,
    wearable_ids: [428, 311],
  },
  {
    genesis_token_id: 17631,
    wearable_ids: [354, 406],
  },
  {
    genesis_token_id: 17632,
    wearable_ids: [316, 336],
  },
  {
    genesis_token_id: 17633,
    wearable_ids: [377, 355],
  },
  {
    genesis_token_id: 17634,
    wearable_ids: [256, 396],
  },
  {
    genesis_token_id: 17635,
    wearable_ids: [387, 308],
  },
  {
    genesis_token_id: 17636,
    wearable_ids: [371, 280],
  },
  {
    genesis_token_id: 17637,
    wearable_ids: [287, 352],
  },
  {
    genesis_token_id: 17638,
    wearable_ids: [437, 308],
  },
  {
    genesis_token_id: 17639,
    wearable_ids: [383, 429],
  },
  {
    genesis_token_id: 17640,
    wearable_ids: [384, 294],
  },
  {
    genesis_token_id: 17641,
    wearable_ids: [436, 267],
  },
  {
    genesis_token_id: 17642,
    wearable_ids: [375, 319],
  },
  {
    genesis_token_id: 17643,
    wearable_ids: [375, 382],
  },
  {
    genesis_token_id: 17644,
    wearable_ids: [284, 384],
  },
  {
    genesis_token_id: 17645,
    wearable_ids: [258, 278],
  },
  {
    genesis_token_id: 17646,
    wearable_ids: [336, 434],
  },
  {
    genesis_token_id: 17647,
    wearable_ids: [304, 386],
  },
  {
    genesis_token_id: 17648,
    wearable_ids: [351, 289],
  },
  {
    genesis_token_id: 17649,
    wearable_ids: [435, 336],
  },
  {
    genesis_token_id: 17650,
    wearable_ids: [266, 426],
  },
  {
    genesis_token_id: 17651,
    wearable_ids: [443, 424],
  },
  {
    genesis_token_id: 17652,
    wearable_ids: [351, 304],
  },
  {
    genesis_token_id: 17653,
    wearable_ids: [422, 398],
  },
  {
    genesis_token_id: 17654,
    wearable_ids: [290, 423],
  },
  {
    genesis_token_id: 17655,
    wearable_ids: [290, 263],
  },
  {
    genesis_token_id: 17656,
    wearable_ids: [276, 358],
  },
  {
    genesis_token_id: 17657,
    wearable_ids: [413, 273],
  },
  {
    genesis_token_id: 17658,
    wearable_ids: [374, 276],
  },
  {
    genesis_token_id: 17659,
    wearable_ids: [365, 266],
  },
  {
    genesis_token_id: 17660,
    wearable_ids: [410, 436],
  },
  {
    genesis_token_id: 17661,
    wearable_ids: [254, 319],
  },
  {
    genesis_token_id: 17662,
    wearable_ids: [346, 270],
  },
  {
    genesis_token_id: 17663,
    wearable_ids: [284, 299],
  },
  {
    genesis_token_id: 17664,
    wearable_ids: [423, 320],
  },
  {
    genesis_token_id: 17665,
    wearable_ids: [290, 445],
  },
  {
    genesis_token_id: 17666,
    wearable_ids: [413, 317],
  },
  {
    genesis_token_id: 17667,
    wearable_ids: [409, 285],
  },
  {
    genesis_token_id: 17668,
    wearable_ids: [382, 319],
  },
  {
    genesis_token_id: 17669,
    wearable_ids: [338, 278],
  },
  {
    genesis_token_id: 17670,
    wearable_ids: [273, 262],
  },
  {
    genesis_token_id: 17671,
    wearable_ids: [406, 298],
  },
  {
    genesis_token_id: 17672,
    wearable_ids: [273, 274],
  },
  {
    genesis_token_id: 17673,
    wearable_ids: [372, 259],
  },
  {
    genesis_token_id: 17674,
    wearable_ids: [395, 291],
  },
  {
    genesis_token_id: 17675,
    wearable_ids: [255, 357],
  },
  {
    genesis_token_id: 17676,
    wearable_ids: [247, 423],
  },
  {
    genesis_token_id: 17677,
    wearable_ids: [303, 279],
  },
  {
    genesis_token_id: 17678,
    wearable_ids: [287, 389],
  },
  {
    genesis_token_id: 17679,
    wearable_ids: [324, 399],
  },
  {
    genesis_token_id: 17680,
    wearable_ids: [349, 404],
  },
  {
    genesis_token_id: 17681,
    wearable_ids: [317, 334],
  },
  {
    genesis_token_id: 17682,
    wearable_ids: [442, 316],
  },
  {
    genesis_token_id: 17683,
    wearable_ids: [434, 251],
  },
  {
    genesis_token_id: 17684,
    wearable_ids: [290, 248],
  },
  {
    genesis_token_id: 17685,
    wearable_ids: [348, 270],
  },
  {
    genesis_token_id: 17686,
    wearable_ids: [397, 303],
  },
  {
    genesis_token_id: 17687,
    wearable_ids: [262, 429],
  },
  {
    genesis_token_id: 17688,
    wearable_ids: [266, 305],
  },
  {
    genesis_token_id: 17689,
    wearable_ids: [338, 307],
  },
  {
    genesis_token_id: 17690,
    wearable_ids: [336, 350],
  },
  {
    genesis_token_id: 17691,
    wearable_ids: [432, 445],
  },
  {
    genesis_token_id: 17692,
    wearable_ids: [410, 413],
  },
  {
    genesis_token_id: 17693,
    wearable_ids: [386, 355],
  },
  {
    genesis_token_id: 17694,
    wearable_ids: [272, 297],
  },
  {
    genesis_token_id: 17695,
    wearable_ids: [325, 408],
  },
  {
    genesis_token_id: 17696,
    wearable_ids: [382, 437],
  },
  {
    genesis_token_id: 17697,
    wearable_ids: [412, 313],
  },
  {
    genesis_token_id: 17698,
    wearable_ids: [315, 384],
  },
  {
    genesis_token_id: 17699,
    wearable_ids: [300, 330],
  },
  {
    genesis_token_id: 17700,
    wearable_ids: [338, 318],
  },
  {
    genesis_token_id: 17701,
    wearable_ids: [338, 402],
  },
  {
    genesis_token_id: 17702,
    wearable_ids: [257, 268],
  },
  {
    genesis_token_id: 17703,
    wearable_ids: [362, 425],
  },
  {
    genesis_token_id: 17704,
    wearable_ids: [387, 274],
  },
  {
    genesis_token_id: 17705,
    wearable_ids: [331, 268],
  },
  {
    genesis_token_id: 17706,
    wearable_ids: [433, 286],
  },
  {
    genesis_token_id: 17707,
    wearable_ids: [408, 280],
  },
  {
    genesis_token_id: 17708,
    wearable_ids: [254, 247],
  },
  {
    genesis_token_id: 17709,
    wearable_ids: [387, 314],
  },
  {
    genesis_token_id: 17710,
    wearable_ids: [255, 256],
  },
  {
    genesis_token_id: 17711,
    wearable_ids: [308, 433],
  },
  {
    genesis_token_id: 17712,
    wearable_ids: [251, 403],
  },
  {
    genesis_token_id: 17713,
    wearable_ids: [395, 315],
  },
  {
    genesis_token_id: 17714,
    wearable_ids: [341, 389],
  },
  {
    genesis_token_id: 17715,
    wearable_ids: [352, 392],
  },
  {
    genesis_token_id: 17716,
    wearable_ids: [444, 356],
  },
  {
    genesis_token_id: 17717,
    wearable_ids: [424, 371],
  },
  {
    genesis_token_id: 17718,
    wearable_ids: [263, 408],
  },
  {
    genesis_token_id: 17719,
    wearable_ids: [368, 326],
  },
  {
    genesis_token_id: 17720,
    wearable_ids: [434, 412],
  },
  {
    genesis_token_id: 17721,
    wearable_ids: [340, 369],
  },
  {
    genesis_token_id: 17722,
    wearable_ids: [271, 433],
  },
  {
    genesis_token_id: 17723,
    wearable_ids: [351, 353],
  },
  {
    genesis_token_id: 17724,
    wearable_ids: [251, 383],
  },
  {
    genesis_token_id: 17725,
    wearable_ids: [432, 304],
  },
  {
    genesis_token_id: 17726,
    wearable_ids: [429, 357],
  },
  {
    genesis_token_id: 17727,
    wearable_ids: [332, 274],
  },
  {
    genesis_token_id: 17728,
    wearable_ids: [346, 326],
  },
  {
    genesis_token_id: 17729,
    wearable_ids: [347, 413],
  },
  {
    genesis_token_id: 17730,
    wearable_ids: [324, 247],
  },
  {
    genesis_token_id: 17731,
    wearable_ids: [355, 264],
  },
  {
    genesis_token_id: 17732,
    wearable_ids: [395, 410],
  },
  {
    genesis_token_id: 17733,
    wearable_ids: [377, 299],
  },
  {
    genesis_token_id: 17734,
    wearable_ids: [350, 335],
  },
  {
    genesis_token_id: 17735,
    wearable_ids: [299, 355],
  },
  {
    genesis_token_id: 17736,
    wearable_ids: [263, 425],
  },
  {
    genesis_token_id: 17737,
    wearable_ids: [396, 419],
  },
  {
    genesis_token_id: 17738,
    wearable_ids: [426, 375],
  },
  {
    genesis_token_id: 17739,
    wearable_ids: [395, 299],
  },
  {
    genesis_token_id: 17740,
    wearable_ids: [325, 384],
  },
  {
    genesis_token_id: 17741,
    wearable_ids: [342, 434],
  },
  {
    genesis_token_id: 17742,
    wearable_ids: [422, 415],
  },
  {
    genesis_token_id: 17743,
    wearable_ids: [362, 431],
  },
  {
    genesis_token_id: 17744,
    wearable_ids: [254, 263],
  },
  {
    genesis_token_id: 17745,
    wearable_ids: [400, 417],
  },
  {
    genesis_token_id: 17746,
    wearable_ids: [433, 274],
  },
  {
    genesis_token_id: 17747,
    wearable_ids: [410, 378],
  },
  {
    genesis_token_id: 17748,
    wearable_ids: [251, 341],
  },
  {
    genesis_token_id: 17749,
    wearable_ids: [429, 352],
  },
  {
    genesis_token_id: 17750,
    wearable_ids: [266, 400],
  },
  {
    genesis_token_id: 17751,
    wearable_ids: [422, 383],
  },
  {
    genesis_token_id: 17752,
    wearable_ids: [363, 436],
  },
  {
    genesis_token_id: 17753,
    wearable_ids: [272, 281],
  },
  {
    genesis_token_id: 17754,
    wearable_ids: [290, 297],
  },
  {
    genesis_token_id: 17755,
    wearable_ids: [400, 277],
  },
  {
    genesis_token_id: 17756,
    wearable_ids: [332, 435],
  },
  {
    genesis_token_id: 17757,
    wearable_ids: [262, 383],
  },
  {
    genesis_token_id: 17758,
    wearable_ids: [442, 364],
  },
  {
    genesis_token_id: 17759,
    wearable_ids: [291, 284],
  },
  {
    genesis_token_id: 17760,
    wearable_ids: [365, 277],
  },
  {
    genesis_token_id: 17761,
    wearable_ids: [362, 328],
  },
  {
    genesis_token_id: 17762,
    wearable_ids: [332, 396],
  },
  {
    genesis_token_id: 17763,
    wearable_ids: [370, 352],
  },
  {
    genesis_token_id: 17764,
    wearable_ids: [248, 383],
  },
  {
    genesis_token_id: 17765,
    wearable_ids: [355, 371],
  },
  {
    genesis_token_id: 17766,
    wearable_ids: [444, 383],
  },
  {
    genesis_token_id: 17767,
    wearable_ids: [264, 436],
  },
  {
    genesis_token_id: 17768,
    wearable_ids: [294, 338],
  },
  {
    genesis_token_id: 17769,
    wearable_ids: [404, 425],
  },
  {
    genesis_token_id: 17770,
    wearable_ids: [278, 397],
  },
  {
    genesis_token_id: 17771,
    wearable_ids: [337, 374],
  },
  {
    genesis_token_id: 17772,
    wearable_ids: [346, 340],
  },
  {
    genesis_token_id: 17773,
    wearable_ids: [436, 256],
  },
  {
    genesis_token_id: 17774,
    wearable_ids: [304, 325],
  },
  {
    genesis_token_id: 17775,
    wearable_ids: [411, 262],
  },
  {
    genesis_token_id: 17776,
    wearable_ids: [337, 316],
  },
  {
    genesis_token_id: 17777,
    wearable_ids: [387, 410],
  },
  {
    genesis_token_id: 17778,
    wearable_ids: [372, 402],
  },
  {
    genesis_token_id: 17779,
    wearable_ids: [382, 372],
  },
  {
    genesis_token_id: 17780,
    wearable_ids: [368, 277],
  },
  {
    genesis_token_id: 17781,
    wearable_ids: [371, 305],
  },
  {
    genesis_token_id: 17782,
    wearable_ids: [248, 305],
  },
  {
    genesis_token_id: 17783,
    wearable_ids: [386, 431],
  },
  {
    genesis_token_id: 17784,
    wearable_ids: [308, 273],
  },
  {
    genesis_token_id: 17785,
    wearable_ids: [420, 396],
  },
  {
    genesis_token_id: 17786,
    wearable_ids: [437, 253],
  },
  {
    genesis_token_id: 17787,
    wearable_ids: [424, 253],
  },
  {
    genesis_token_id: 17788,
    wearable_ids: [274, 271],
  },
  {
    genesis_token_id: 17789,
    wearable_ids: [411, 273],
  },
  {
    genesis_token_id: 17790,
    wearable_ids: [399, 272],
  },
  {
    genesis_token_id: 17791,
    wearable_ids: [308, 431],
  },
  {
    genesis_token_id: 17792,
    wearable_ids: [254, 293],
  },
  {
    genesis_token_id: 17793,
    wearable_ids: [426, 310],
  },
  {
    genesis_token_id: 17794,
    wearable_ids: [336, 255],
  },
  {
    genesis_token_id: 17795,
    wearable_ids: [338, 292],
  },
  {
    genesis_token_id: 17796,
    wearable_ids: [386, 406],
  },
  {
    genesis_token_id: 17797,
    wearable_ids: [326, 357],
  },
  {
    genesis_token_id: 17798,
    wearable_ids: [424, 356],
  },
  {
    genesis_token_id: 17799,
    wearable_ids: [277, 291],
  },
  {
    genesis_token_id: 17800,
    wearable_ids: [325, 322],
  },
  {
    genesis_token_id: 17801,
    wearable_ids: [425, 404],
  },
  {
    genesis_token_id: 17802,
    wearable_ids: [257, 419],
  },
  {
    genesis_token_id: 17803,
    wearable_ids: [248, 247],
  },
  {
    genesis_token_id: 17804,
    wearable_ids: [384, 310],
  },
  {
    genesis_token_id: 17805,
    wearable_ids: [384, 250],
  },
  {
    genesis_token_id: 17806,
    wearable_ids: [350, 253],
  },
  {
    genesis_token_id: 17807,
    wearable_ids: [429, 396],
  },
  {
    genesis_token_id: 17808,
    wearable_ids: [296, 316],
  },
  {
    genesis_token_id: 17809,
    wearable_ids: [259, 435],
  },
  {
    genesis_token_id: 17810,
    wearable_ids: [343, 302],
  },
  {
    genesis_token_id: 17811,
    wearable_ids: [383, 365],
  },
  {
    genesis_token_id: 17812,
    wearable_ids: [311, 433],
  },
  {
    genesis_token_id: 17813,
    wearable_ids: [374, 382],
  },
  {
    genesis_token_id: 17814,
    wearable_ids: [373, 343],
  },
  {
    genesis_token_id: 17815,
    wearable_ids: [422, 264],
  },
  {
    genesis_token_id: 17816,
    wearable_ids: [362, 382],
  },
  {
    genesis_token_id: 17817,
    wearable_ids: [348, 260],
  },
  {
    genesis_token_id: 17818,
    wearable_ids: [248, 253],
  },
  {
    genesis_token_id: 17819,
    wearable_ids: [301, 410],
  },
  {
    genesis_token_id: 17820,
    wearable_ids: [271, 365],
  },
  {
    genesis_token_id: 17821,
    wearable_ids: [290, 360],
  },
  {
    genesis_token_id: 17822,
    wearable_ids: [256, 303],
  },
  {
    genesis_token_id: 17823,
    wearable_ids: [272, 331],
  },
  {
    genesis_token_id: 17824,
    wearable_ids: [292, 437],
  },
  {
    genesis_token_id: 17825,
    wearable_ids: [371, 343],
  },
  {
    genesis_token_id: 17826,
    wearable_ids: [306, 339],
  },
  {
    genesis_token_id: 17827,
    wearable_ids: [443, 316],
  },
  {
    genesis_token_id: 17828,
    wearable_ids: [291, 333],
  },
  {
    genesis_token_id: 17829,
    wearable_ids: [271, 406],
  },
  {
    genesis_token_id: 17830,
    wearable_ids: [253, 343],
  },
  {
    genesis_token_id: 17831,
    wearable_ids: [403, 396],
  },
  {
    genesis_token_id: 17832,
    wearable_ids: [256, 315],
  },
  {
    genesis_token_id: 17833,
    wearable_ids: [377, 247],
  },
  {
    genesis_token_id: 17834,
    wearable_ids: [297, 266],
  },
  {
    genesis_token_id: 17835,
    wearable_ids: [422, 337],
  },
  {
    genesis_token_id: 17836,
    wearable_ids: [304, 259],
  },
  {
    genesis_token_id: 17837,
    wearable_ids: [354, 274],
  },
  {
    genesis_token_id: 17838,
    wearable_ids: [253, 366],
  },
  {
    genesis_token_id: 17839,
    wearable_ids: [300, 403],
  },
  {
    genesis_token_id: 17840,
    wearable_ids: [325, 286],
  },
  {
    genesis_token_id: 17841,
    wearable_ids: [247, 415],
  },
  {
    genesis_token_id: 17842,
    wearable_ids: [301, 353],
  },
  {
    genesis_token_id: 17843,
    wearable_ids: [415, 320],
  },
  {
    genesis_token_id: 17844,
    wearable_ids: [375, 313],
  },
  {
    genesis_token_id: 17845,
    wearable_ids: [444, 326],
  },
  {
    genesis_token_id: 17846,
    wearable_ids: [396, 411],
  },
  {
    genesis_token_id: 17847,
    wearable_ids: [365, 354],
  },
  {
    genesis_token_id: 17848,
    wearable_ids: [442, 308],
  },
  {
    genesis_token_id: 17849,
    wearable_ids: [369, 265],
  },
  {
    genesis_token_id: 17850,
    wearable_ids: [270, 250],
  },
  {
    genesis_token_id: 17851,
    wearable_ids: [310, 389],
  },
  {
    genesis_token_id: 17852,
    wearable_ids: [316, 422],
  },
  {
    genesis_token_id: 17853,
    wearable_ids: [411, 248],
  },
  {
    genesis_token_id: 17854,
    wearable_ids: [331, 270],
  },
  {
    genesis_token_id: 17855,
    wearable_ids: [445, 424],
  },
  {
    genesis_token_id: 17856,
    wearable_ids: [253, 281],
  },
  {
    genesis_token_id: 17857,
    wearable_ids: [255, 315],
  },
  {
    genesis_token_id: 17858,
    wearable_ids: [370, 404],
  },
  {
    genesis_token_id: 17859,
    wearable_ids: [412, 347],
  },
  {
    genesis_token_id: 17860,
    wearable_ids: [426, 313],
  },
  {
    genesis_token_id: 17861,
    wearable_ids: [396, 425],
  },
  {
    genesis_token_id: 17862,
    wearable_ids: [274, 292],
  },
  {
    genesis_token_id: 17863,
    wearable_ids: [301, 426],
  },
  {
    genesis_token_id: 17864,
    wearable_ids: [254, 247],
  },
  {
    genesis_token_id: 17865,
    wearable_ids: [253, 389],
  },
  {
    genesis_token_id: 17866,
    wearable_ids: [344, 375],
  },
  {
    genesis_token_id: 17867,
    wearable_ids: [343, 386],
  },
  {
    genesis_token_id: 17868,
    wearable_ids: [404, 324],
  },
  {
    genesis_token_id: 17869,
    wearable_ids: [264, 431],
  },
  {
    genesis_token_id: 17870,
    wearable_ids: [344, 378],
  },
  {
    genesis_token_id: 17871,
    wearable_ids: [338, 260],
  },
  {
    genesis_token_id: 17872,
    wearable_ids: [375, 386],
  },
  {
    genesis_token_id: 17873,
    wearable_ids: [378, 431],
  },
  {
    genesis_token_id: 17874,
    wearable_ids: [435, 371],
  },
  {
    genesis_token_id: 17875,
    wearable_ids: [304, 288],
  },
  {
    genesis_token_id: 17876,
    wearable_ids: [444, 400],
  },
  {
    genesis_token_id: 17877,
    wearable_ids: [369, 398],
  },
  {
    genesis_token_id: 17878,
    wearable_ids: [263, 268],
  },
  {
    genesis_token_id: 17879,
    wearable_ids: [424, 379],
  },
  {
    genesis_token_id: 17880,
    wearable_ids: [436, 432],
  },
  {
    genesis_token_id: 17881,
    wearable_ids: [373, 405],
  },
  {
    genesis_token_id: 17882,
    wearable_ids: [274, 316],
  },
  {
    genesis_token_id: 17883,
    wearable_ids: [294, 412],
  },
  {
    genesis_token_id: 17884,
    wearable_ids: [248, 247],
  },
  {
    genesis_token_id: 17885,
    wearable_ids: [420, 350],
  },
  {
    genesis_token_id: 17886,
    wearable_ids: [444, 373],
  },
  {
    genesis_token_id: 17887,
    wearable_ids: [255, 353],
  },
  {
    genesis_token_id: 17888,
    wearable_ids: [291, 379],
  },
  {
    genesis_token_id: 17889,
    wearable_ids: [362, 353],
  },
  {
    genesis_token_id: 17890,
    wearable_ids: [387, 346],
  },
  {
    genesis_token_id: 17891,
    wearable_ids: [263, 397],
  },
  {
    genesis_token_id: 17892,
    wearable_ids: [332, 276],
  },
  {
    genesis_token_id: 17893,
    wearable_ids: [413, 268],
  },
  {
    genesis_token_id: 17894,
    wearable_ids: [278, 425],
  },
  {
    genesis_token_id: 17895,
    wearable_ids: [386, 294],
  },
  {
    genesis_token_id: 17896,
    wearable_ids: [404, 271],
  },
  {
    genesis_token_id: 17897,
    wearable_ids: [270, 305],
  },
  {
    genesis_token_id: 17898,
    wearable_ids: [370, 270],
  },
  {
    genesis_token_id: 17899,
    wearable_ids: [399, 253],
  },
  {
    genesis_token_id: 17900,
    wearable_ids: [408, 376],
  },
  {
    genesis_token_id: 17901,
    wearable_ids: [436, 353],
  },
  {
    genesis_token_id: 17902,
    wearable_ids: [263, 413],
  },
  {
    genesis_token_id: 17903,
    wearable_ids: [331, 406],
  },
  {
    genesis_token_id: 17904,
    wearable_ids: [422, 406],
  },
  {
    genesis_token_id: 17905,
    wearable_ids: [268, 404],
  },
  {
    genesis_token_id: 17906,
    wearable_ids: [365, 371],
  },
  {
    genesis_token_id: 17907,
    wearable_ids: [431, 295],
  },
  {
    genesis_token_id: 17908,
    wearable_ids: [274, 410],
  },
  {
    genesis_token_id: 17909,
    wearable_ids: [349, 333],
  },
  {
    genesis_token_id: 17910,
    wearable_ids: [291, 258],
  },
  {
    genesis_token_id: 17911,
    wearable_ids: [389, 416],
  },
  {
    genesis_token_id: 17912,
    wearable_ids: [255, 270],
  },
  {
    genesis_token_id: 17913,
    wearable_ids: [433, 333],
  },
  {
    genesis_token_id: 17914,
    wearable_ids: [253, 383],
  },
  {
    genesis_token_id: 17915,
    wearable_ids: [409, 431],
  },
  {
    genesis_token_id: 17916,
    wearable_ids: [256, 400],
  },
  {
    genesis_token_id: 17917,
    wearable_ids: [407, 411],
  },
  {
    genesis_token_id: 17918,
    wearable_ids: [347, 415],
  },
  {
    genesis_token_id: 17919,
    wearable_ids: [432, 374],
  },
  {
    genesis_token_id: 17920,
    wearable_ids: [335, 266],
  },
  {
    genesis_token_id: 17921,
    wearable_ids: [295, 335],
  },
  {
    genesis_token_id: 17922,
    wearable_ids: [332, 294],
  },
  {
    genesis_token_id: 17923,
    wearable_ids: [335, 418],
  },
  {
    genesis_token_id: 17924,
    wearable_ids: [295, 425],
  },
  {
    genesis_token_id: 17925,
    wearable_ids: [426, 443],
  },
  {
    genesis_token_id: 17926,
    wearable_ids: [340, 423],
  },
  {
    genesis_token_id: 17927,
    wearable_ids: [342, 253],
  },
  {
    genesis_token_id: 17928,
    wearable_ids: [292, 386],
  },
  {
    genesis_token_id: 17929,
    wearable_ids: [374, 248],
  },
  {
    genesis_token_id: 17930,
    wearable_ids: [352, 287],
  },
  {
    genesis_token_id: 17931,
    wearable_ids: [350, 397],
  },
  {
    genesis_token_id: 17932,
    wearable_ids: [377, 436],
  },
  {
    genesis_token_id: 17933,
    wearable_ids: [339, 415],
  },
  {
    genesis_token_id: 17934,
    wearable_ids: [351, 412],
  },
  {
    genesis_token_id: 17935,
    wearable_ids: [355, 337],
  },
  {
    genesis_token_id: 17936,
    wearable_ids: [384, 386],
  },
  {
    genesis_token_id: 17937,
    wearable_ids: [423, 337],
  },
  {
    genesis_token_id: 17938,
    wearable_ids: [315, 258],
  },
  {
    genesis_token_id: 17939,
    wearable_ids: [407, 258],
  },
  {
    genesis_token_id: 17940,
    wearable_ids: [385, 364],
  },
  {
    genesis_token_id: 17941,
    wearable_ids: [339, 359],
  },
  {
    genesis_token_id: 17942,
    wearable_ids: [376, 434],
  },
  {
    genesis_token_id: 17943,
    wearable_ids: [442, 294],
  },
  {
    genesis_token_id: 17944,
    wearable_ids: [251, 253],
  },
  {
    genesis_token_id: 17945,
    wearable_ids: [368, 254],
  },
  {
    genesis_token_id: 17946,
    wearable_ids: [303, 292],
  },
  {
    genesis_token_id: 17947,
    wearable_ids: [365, 249],
  },
  {
    genesis_token_id: 17948,
    wearable_ids: [424, 379],
  },
  {
    genesis_token_id: 17949,
    wearable_ids: [272, 305],
  },
  {
    genesis_token_id: 17950,
    wearable_ids: [386, 426],
  },
  {
    genesis_token_id: 17951,
    wearable_ids: [266, 346],
  },
  {
    genesis_token_id: 17952,
    wearable_ids: [257, 365],
  },
  {
    genesis_token_id: 17953,
    wearable_ids: [403, 347],
  },
  {
    genesis_token_id: 17954,
    wearable_ids: [434, 368],
  },
  {
    genesis_token_id: 17955,
    wearable_ids: [370, 276],
  },
  {
    genesis_token_id: 17956,
    wearable_ids: [413, 411],
  },
  {
    genesis_token_id: 17957,
    wearable_ids: [262, 418],
  },
  {
    genesis_token_id: 17958,
    wearable_ids: [257, 348],
  },
  {
    genesis_token_id: 17959,
    wearable_ids: [378, 291],
  },
  {
    genesis_token_id: 17960,
    wearable_ids: [277, 295],
  },
  {
    genesis_token_id: 17961,
    wearable_ids: [324, 442],
  },
  {
    genesis_token_id: 17962,
    wearable_ids: [376, 294],
  },
  {
    genesis_token_id: 17963,
    wearable_ids: [263, 304],
  },
  {
    genesis_token_id: 17964,
    wearable_ids: [384, 317],
  },
  {
    genesis_token_id: 17965,
    wearable_ids: [290, 338],
  },
  {
    genesis_token_id: 17966,
    wearable_ids: [265, 295],
  },
  {
    genesis_token_id: 17967,
    wearable_ids: [342, 406],
  },
  {
    genesis_token_id: 17968,
    wearable_ids: [425, 437],
  },
  {
    genesis_token_id: 17969,
    wearable_ids: [415, 292],
  },
  {
    genesis_token_id: 17970,
    wearable_ids: [443, 324],
  },
  {
    genesis_token_id: 17971,
    wearable_ids: [376, 299],
  },
  {
    genesis_token_id: 17972,
    wearable_ids: [354, 296],
  },
  {
    genesis_token_id: 17973,
    wearable_ids: [404, 297],
  },
  {
    genesis_token_id: 17974,
    wearable_ids: [266, 337],
  },
  {
    genesis_token_id: 17975,
    wearable_ids: [346, 366],
  },
  {
    genesis_token_id: 17976,
    wearable_ids: [276, 368],
  },
  {
    genesis_token_id: 17977,
    wearable_ids: [422, 334],
  },
  {
    genesis_token_id: 17978,
    wearable_ids: [326, 432],
  },
  {
    genesis_token_id: 17979,
    wearable_ids: [347, 382],
  },
  {
    genesis_token_id: 17980,
    wearable_ids: [373, 387],
  },
  {
    genesis_token_id: 17981,
    wearable_ids: [254, 251],
  },
  {
    genesis_token_id: 17982,
    wearable_ids: [389, 311],
  },
  {
    genesis_token_id: 17983,
    wearable_ids: [325, 445],
  },
  {
    genesis_token_id: 17984,
    wearable_ids: [406, 307],
  },
  {
    genesis_token_id: 17985,
    wearable_ids: [338, 310],
  },
  {
    genesis_token_id: 17986,
    wearable_ids: [420, 283],
  },
  {
    genesis_token_id: 17987,
    wearable_ids: [316, 400],
  },
  {
    genesis_token_id: 17988,
    wearable_ids: [263, 259],
  },
  {
    genesis_token_id: 17989,
    wearable_ids: [433, 395],
  },
  {
    genesis_token_id: 17990,
    wearable_ids: [340, 342],
  },
  {
    genesis_token_id: 17991,
    wearable_ids: [396, 273],
  },
  {
    genesis_token_id: 17992,
    wearable_ids: [395, 344],
  },
  {
    genesis_token_id: 17993,
    wearable_ids: [365, 351],
  },
  {
    genesis_token_id: 17994,
    wearable_ids: [311, 255],
  },
  {
    genesis_token_id: 17995,
    wearable_ids: [335, 302],
  },
  {
    genesis_token_id: 17996,
    wearable_ids: [247, 331],
  },
  {
    genesis_token_id: 17997,
    wearable_ids: [433, 374],
  },
  {
    genesis_token_id: 17998,
    wearable_ids: [385, 279],
  },
  {
    genesis_token_id: 17999,
    wearable_ids: [428, 397],
  },
  {
    genesis_token_id: 18000,
    wearable_ids: [406, 432],
  },
  {
    genesis_token_id: 18001,
    wearable_ids: [403, 278],
  },
  {
    genesis_token_id: 18002,
    wearable_ids: [431, 341],
  },
  {
    genesis_token_id: 18003,
    wearable_ids: [264, 290],
  },
  {
    genesis_token_id: 18004,
    wearable_ids: [304, 264],
  },
  {
    genesis_token_id: 18005,
    wearable_ids: [410, 274],
  },
  {
    genesis_token_id: 18006,
    wearable_ids: [443, 341],
  },
  {
    genesis_token_id: 18007,
    wearable_ids: [386, 345],
  },
  {
    genesis_token_id: 18008,
    wearable_ids: [411, 300],
  },
  {
    genesis_token_id: 18009,
    wearable_ids: [271, 318],
  },
  {
    genesis_token_id: 18010,
    wearable_ids: [299, 341],
  },
  {
    genesis_token_id: 18011,
    wearable_ids: [336, 444],
  },
  {
    genesis_token_id: 18012,
    wearable_ids: [410, 289],
  },
  {
    genesis_token_id: 18013,
    wearable_ids: [411, 255],
  },
  {
    genesis_token_id: 18014,
    wearable_ids: [362, 304],
  },
  {
    genesis_token_id: 18015,
    wearable_ids: [271, 314],
  },
  {
    genesis_token_id: 18016,
    wearable_ids: [372, 346],
  },
  {
    genesis_token_id: 18017,
    wearable_ids: [280, 251],
  },
  {
    genesis_token_id: 18018,
    wearable_ids: [265, 441],
  },
  {
    genesis_token_id: 18019,
    wearable_ids: [306, 409],
  },
  {
    genesis_token_id: 18020,
    wearable_ids: [331, 301],
  },
  {
    genesis_token_id: 18021,
    wearable_ids: [375, 443],
  },
  {
    genesis_token_id: 18022,
    wearable_ids: [324, 384],
  },
  {
    genesis_token_id: 18023,
    wearable_ids: [310, 272],
  },
  {
    genesis_token_id: 18024,
    wearable_ids: [433, 363],
  },
  {
    genesis_token_id: 18025,
    wearable_ids: [350, 434],
  },
  {
    genesis_token_id: 18026,
    wearable_ids: [371, 263],
  },
  {
    genesis_token_id: 18027,
    wearable_ids: [436, 338],
  },
  {
    genesis_token_id: 18028,
    wearable_ids: [264, 256],
  },
  {
    genesis_token_id: 18029,
    wearable_ids: [399, 368],
  },
  {
    genesis_token_id: 18030,
    wearable_ids: [413, 251],
  },
  {
    genesis_token_id: 18031,
    wearable_ids: [434, 270],
  },
  {
    genesis_token_id: 18032,
    wearable_ids: [284, 295],
  },
  {
    genesis_token_id: 18033,
    wearable_ids: [258, 433],
  },
  {
    genesis_token_id: 18034,
    wearable_ids: [354, 256],
  },
  {
    genesis_token_id: 18035,
    wearable_ids: [304, 301],
  },
  {
    genesis_token_id: 18036,
    wearable_ids: [371, 359],
  },
  {
    genesis_token_id: 18037,
    wearable_ids: [382, 436],
  },
  {
    genesis_token_id: 18038,
    wearable_ids: [387, 440],
  },
  {
    genesis_token_id: 18039,
    wearable_ids: [399, 250],
  },
  {
    genesis_token_id: 18040,
    wearable_ids: [362, 295],
  },
  {
    genesis_token_id: 18041,
    wearable_ids: [340, 325],
  },
  {
    genesis_token_id: 18042,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 18043,
    wearable_ids: [332, 410],
  },
  {
    genesis_token_id: 18044,
    wearable_ids: [410, 379],
  },
  {
    genesis_token_id: 18045,
    wearable_ids: [268, 287],
  },
  {
    genesis_token_id: 18046,
    wearable_ids: [270, 398],
  },
  {
    genesis_token_id: 18047,
    wearable_ids: [407, 333],
  },
  {
    genesis_token_id: 18048,
    wearable_ids: [296, 332],
  },
  {
    genesis_token_id: 18049,
    wearable_ids: [339, 410],
  },
  {
    genesis_token_id: 18050,
    wearable_ids: [423, 344],
  },
  {
    genesis_token_id: 18051,
    wearable_ids: [372, 335],
  },
  {
    genesis_token_id: 18052,
    wearable_ids: [317, 354],
  },
  {
    genesis_token_id: 18053,
    wearable_ids: [270, 385],
  },
  {
    genesis_token_id: 18054,
    wearable_ids: [284, 290],
  },
  {
    genesis_token_id: 18055,
    wearable_ids: [420, 257],
  },
  {
    genesis_token_id: 18056,
    wearable_ids: [363, 260],
  },
  {
    genesis_token_id: 18057,
    wearable_ids: [368, 412],
  },
  {
    genesis_token_id: 18058,
    wearable_ids: [413, 357],
  },
  {
    genesis_token_id: 18059,
    wearable_ids: [342, 324],
  },
  {
    genesis_token_id: 18060,
    wearable_ids: [399, 385],
  },
  {
    genesis_token_id: 18061,
    wearable_ids: [395, 391],
  },
  {
    genesis_token_id: 18062,
    wearable_ids: [383, 332],
  },
  {
    genesis_token_id: 18063,
    wearable_ids: [350, 364],
  },
  {
    genesis_token_id: 18064,
    wearable_ids: [413, 437],
  },
  {
    genesis_token_id: 18065,
    wearable_ids: [284, 419],
  },
  {
    genesis_token_id: 18066,
    wearable_ids: [385, 370],
  },
  {
    genesis_token_id: 18067,
    wearable_ids: [411, 250],
  },
  {
    genesis_token_id: 18068,
    wearable_ids: [404, 434],
  },
  {
    genesis_token_id: 18069,
    wearable_ids: [286, 440],
  },
  {
    genesis_token_id: 18070,
    wearable_ids: [409, 277],
  },
  {
    genesis_token_id: 18071,
    wearable_ids: [412, 327],
  },
  {
    genesis_token_id: 18072,
    wearable_ids: [377, 339],
  },
  {
    genesis_token_id: 18073,
    wearable_ids: [409, 261],
  },
  {
    genesis_token_id: 18074,
    wearable_ids: [435, 312],
  },
  {
    genesis_token_id: 18075,
    wearable_ids: [411, 375],
  },
  {
    genesis_token_id: 18076,
    wearable_ids: [442, 274],
  },
  {
    genesis_token_id: 18077,
    wearable_ids: [272, 404],
  },
  {
    genesis_token_id: 18078,
    wearable_ids: [432, 306],
  },
  {
    genesis_token_id: 18079,
    wearable_ids: [373, 320],
  },
  {
    genesis_token_id: 18080,
    wearable_ids: [426, 289],
  },
  {
    genesis_token_id: 18081,
    wearable_ids: [296, 438],
  },
  {
    genesis_token_id: 18082,
    wearable_ids: [314, 306],
  },
  {
    genesis_token_id: 18083,
    wearable_ids: [428, 396],
  },
  {
    genesis_token_id: 18084,
    wearable_ids: [256, 316],
  },
  {
    genesis_token_id: 18085,
    wearable_ids: [292, 259],
  },
  {
    genesis_token_id: 18086,
    wearable_ids: [341, 279],
  },
  {
    genesis_token_id: 18087,
    wearable_ids: [378, 284],
  },
  {
    genesis_token_id: 18088,
    wearable_ids: [389, 444],
  },
  {
    genesis_token_id: 18089,
    wearable_ids: [315, 444],
  },
  {
    genesis_token_id: 18090,
    wearable_ids: [299, 378],
  },
  {
    genesis_token_id: 18091,
    wearable_ids: [272, 384],
  },
  {
    genesis_token_id: 18092,
    wearable_ids: [411, 313],
  },
  {
    genesis_token_id: 18093,
    wearable_ids: [420, 392],
  },
  {
    genesis_token_id: 18094,
    wearable_ids: [384, 374],
  },
  {
    genesis_token_id: 18095,
    wearable_ids: [254, 408],
  },
  {
    genesis_token_id: 18096,
    wearable_ids: [265, 387],
  },
  {
    genesis_token_id: 18097,
    wearable_ids: [289, 426],
  },
  {
    genesis_token_id: 18098,
    wearable_ids: [255, 382],
  },
  {
    genesis_token_id: 18099,
    wearable_ids: [389, 407],
  },
  {
    genesis_token_id: 18100,
    wearable_ids: [336, 342],
  },
  {
    genesis_token_id: 18101,
    wearable_ids: [403, 278],
  },
  {
    genesis_token_id: 18102,
    wearable_ids: [274, 427],
  },
  {
    genesis_token_id: 18103,
    wearable_ids: [372, 403],
  },
  {
    genesis_token_id: 18104,
    wearable_ids: [382, 355],
  },
  {
    genesis_token_id: 18105,
    wearable_ids: [336, 337],
  },
  {
    genesis_token_id: 18106,
    wearable_ids: [407, 355],
  },
  {
    genesis_token_id: 18107,
    wearable_ids: [263, 254],
  },
  {
    genesis_token_id: 18108,
    wearable_ids: [371, 322],
  },
  {
    genesis_token_id: 18109,
    wearable_ids: [295, 293],
  },
  {
    genesis_token_id: 18110,
    wearable_ids: [346, 383],
  },
  {
    genesis_token_id: 18111,
    wearable_ids: [407, 437],
  },
  {
    genesis_token_id: 18112,
    wearable_ids: [258, 276],
  },
  {
    genesis_token_id: 18113,
    wearable_ids: [429, 353],
  },
  {
    genesis_token_id: 18114,
    wearable_ids: [420, 399],
  },
  {
    genesis_token_id: 18115,
    wearable_ids: [349, 423],
  },
  {
    genesis_token_id: 18116,
    wearable_ids: [350, 335],
  },
  {
    genesis_token_id: 18117,
    wearable_ids: [314, 327],
  },
  {
    genesis_token_id: 18118,
    wearable_ids: [433, 442],
  },
  {
    genesis_token_id: 18119,
    wearable_ids: [268, 254],
  },
  {
    genesis_token_id: 18120,
    wearable_ids: [254, 426],
  },
  {
    genesis_token_id: 18121,
    wearable_ids: [262, 406],
  },
  {
    genesis_token_id: 18122,
    wearable_ids: [396, 327],
  },
  {
    genesis_token_id: 18123,
    wearable_ids: [343, 274],
  },
  {
    genesis_token_id: 18124,
    wearable_ids: [263, 386],
  },
  {
    genesis_token_id: 18125,
    wearable_ids: [363, 349],
  },
  {
    genesis_token_id: 18126,
    wearable_ids: [399, 305],
  },
  {
    genesis_token_id: 18127,
    wearable_ids: [399, 269],
  },
  {
    genesis_token_id: 18128,
    wearable_ids: [259, 307],
  },
  {
    genesis_token_id: 18129,
    wearable_ids: [435, 399],
  },
  {
    genesis_token_id: 18130,
    wearable_ids: [369, 325],
  },
  {
    genesis_token_id: 18131,
    wearable_ids: [377, 273],
  },
  {
    genesis_token_id: 18132,
    wearable_ids: [385, 349],
  },
  {
    genesis_token_id: 18133,
    wearable_ids: [348, 325],
  },
  {
    genesis_token_id: 18134,
    wearable_ids: [335, 370],
  },
  {
    genesis_token_id: 18135,
    wearable_ids: [431, 350],
  },
  {
    genesis_token_id: 18136,
    wearable_ids: [431, 370],
  },
  {
    genesis_token_id: 18137,
    wearable_ids: [264, 351],
  },
  {
    genesis_token_id: 18138,
    wearable_ids: [248, 396],
  },
  {
    genesis_token_id: 18139,
    wearable_ids: [404, 369],
  },
  {
    genesis_token_id: 18140,
    wearable_ids: [408, 290],
  },
  {
    genesis_token_id: 18141,
    wearable_ids: [301, 422],
  },
  {
    genesis_token_id: 18142,
    wearable_ids: [286, 263],
  },
  {
    genesis_token_id: 18143,
    wearable_ids: [444, 397],
  },
  {
    genesis_token_id: 18144,
    wearable_ids: [435, 273],
  },
  {
    genesis_token_id: 18145,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 18146,
    wearable_ids: [437, 308],
  },
  {
    genesis_token_id: 18147,
    wearable_ids: [304, 416],
  },
  {
    genesis_token_id: 18148,
    wearable_ids: [444, 307],
  },
  {
    genesis_token_id: 18149,
    wearable_ids: [363, 364],
  },
  {
    genesis_token_id: 18150,
    wearable_ids: [325, 377],
  },
  {
    genesis_token_id: 18151,
    wearable_ids: [399, 308],
  },
  {
    genesis_token_id: 18152,
    wearable_ids: [386, 288],
  },
  {
    genesis_token_id: 18153,
    wearable_ids: [348, 369],
  },
  {
    genesis_token_id: 18154,
    wearable_ids: [355, 292],
  },
  {
    genesis_token_id: 18155,
    wearable_ids: [259, 382],
  },
  {
    genesis_token_id: 18156,
    wearable_ids: [277, 278],
  },
  {
    genesis_token_id: 18157,
    wearable_ids: [344, 256],
  },
  {
    genesis_token_id: 18158,
    wearable_ids: [319, 332],
  },
  {
    genesis_token_id: 18159,
    wearable_ids: [425, 408],
  },
  {
    genesis_token_id: 18160,
    wearable_ids: [296, 280],
  },
  {
    genesis_token_id: 18161,
    wearable_ids: [434, 346],
  },
  {
    genesis_token_id: 18162,
    wearable_ids: [376, 256],
  },
  {
    genesis_token_id: 18163,
    wearable_ids: [336, 361],
  },
  {
    genesis_token_id: 18164,
    wearable_ids: [350, 363],
  },
  {
    genesis_token_id: 18165,
    wearable_ids: [437, 316],
  },
  {
    genesis_token_id: 18166,
    wearable_ids: [382, 300],
  },
  {
    genesis_token_id: 18167,
    wearable_ids: [332, 264],
  },
  {
    genesis_token_id: 18168,
    wearable_ids: [297, 264],
  },
  {
    genesis_token_id: 18169,
    wearable_ids: [280, 399],
  },
  {
    genesis_token_id: 18170,
    wearable_ids: [354, 310],
  },
  {
    genesis_token_id: 18171,
    wearable_ids: [435, 301],
  },
  {
    genesis_token_id: 18172,
    wearable_ids: [295, 358],
  },
  {
    genesis_token_id: 18173,
    wearable_ids: [436, 251],
  },
  {
    genesis_token_id: 18174,
    wearable_ids: [278, 369],
  },
  {
    genesis_token_id: 18175,
    wearable_ids: [371, 408],
  },
  {
    genesis_token_id: 18176,
    wearable_ids: [409, 363],
  },
  {
    genesis_token_id: 18177,
    wearable_ids: [251, 399],
  },
  {
    genesis_token_id: 18178,
    wearable_ids: [350, 429],
  },
  {
    genesis_token_id: 18179,
    wearable_ids: [396, 358],
  },
  {
    genesis_token_id: 18180,
    wearable_ids: [301, 443],
  },
  {
    genesis_token_id: 18181,
    wearable_ids: [434, 415],
  },
  {
    genesis_token_id: 18182,
    wearable_ids: [294, 369],
  },
  {
    genesis_token_id: 18183,
    wearable_ids: [277, 423],
  },
  {
    genesis_token_id: 18184,
    wearable_ids: [432, 420],
  },
  {
    genesis_token_id: 18185,
    wearable_ids: [317, 331],
  },
  {
    genesis_token_id: 18186,
    wearable_ids: [256, 316],
  },
  {
    genesis_token_id: 18187,
    wearable_ids: [342, 307],
  },
  {
    genesis_token_id: 18188,
    wearable_ids: [408, 259],
  },
  {
    genesis_token_id: 18189,
    wearable_ids: [347, 434],
  },
  {
    genesis_token_id: 18190,
    wearable_ids: [400, 393],
  },
  {
    genesis_token_id: 18191,
    wearable_ids: [371, 270],
  },
  {
    genesis_token_id: 18192,
    wearable_ids: [259, 346],
  },
  {
    genesis_token_id: 18193,
    wearable_ids: [290, 364],
  },
  {
    genesis_token_id: 18194,
    wearable_ids: [299, 264],
  },
  {
    genesis_token_id: 18195,
    wearable_ids: [403, 399],
  },
  {
    genesis_token_id: 18196,
    wearable_ids: [354, 262],
  },
  {
    genesis_token_id: 18197,
    wearable_ids: [385, 415],
  },
  {
    genesis_token_id: 18198,
    wearable_ids: [408, 285],
  },
  {
    genesis_token_id: 18199,
    wearable_ids: [277, 287],
  },
  {
    genesis_token_id: 18200,
    wearable_ids: [400, 433],
  },
  {
    genesis_token_id: 18201,
    wearable_ids: [395, 298],
  },
  {
    genesis_token_id: 18202,
    wearable_ids: [428, 425],
  },
  {
    genesis_token_id: 18203,
    wearable_ids: [372, 299],
  },
  {
    genesis_token_id: 18204,
    wearable_ids: [290, 413],
  },
  {
    genesis_token_id: 18205,
    wearable_ids: [371, 404],
  },
  {
    genesis_token_id: 18206,
    wearable_ids: [301, 386],
  },
  {
    genesis_token_id: 18207,
    wearable_ids: [420, 307],
  },
  {
    genesis_token_id: 18208,
    wearable_ids: [314, 256],
  },
  {
    genesis_token_id: 18209,
    wearable_ids: [316, 411],
  },
  {
    genesis_token_id: 18210,
    wearable_ids: [375, 362],
  },
  {
    genesis_token_id: 18211,
    wearable_ids: [335, 420],
  },
  {
    genesis_token_id: 18212,
    wearable_ids: [259, 420],
  },
  {
    genesis_token_id: 18213,
    wearable_ids: [384, 359],
  },
  {
    genesis_token_id: 18214,
    wearable_ids: [428, 330],
  },
  {
    genesis_token_id: 18215,
    wearable_ids: [385, 389],
  },
  {
    genesis_token_id: 18216,
    wearable_ids: [349, 295],
  },
  {
    genesis_token_id: 18217,
    wearable_ids: [319, 262],
  },
  {
    genesis_token_id: 18218,
    wearable_ids: [444, 408],
  },
  {
    genesis_token_id: 18219,
    wearable_ids: [410, 406],
  },
  {
    genesis_token_id: 18220,
    wearable_ids: [274, 277],
  },
  {
    genesis_token_id: 18221,
    wearable_ids: [408, 442],
  },
  {
    genesis_token_id: 18222,
    wearable_ids: [268, 355],
  },
  {
    genesis_token_id: 18223,
    wearable_ids: [270, 247],
  },
  {
    genesis_token_id: 18224,
    wearable_ids: [431, 412],
  },
  {
    genesis_token_id: 18225,
    wearable_ids: [338, 337],
  },
  {
    genesis_token_id: 18226,
    wearable_ids: [311, 375],
  },
  {
    genesis_token_id: 18227,
    wearable_ids: [400, 298],
  },
  {
    genesis_token_id: 18228,
    wearable_ids: [291, 292],
  },
  {
    genesis_token_id: 18229,
    wearable_ids: [262, 292],
  },
  {
    genesis_token_id: 18230,
    wearable_ids: [403, 413],
  },
  {
    genesis_token_id: 18231,
    wearable_ids: [325, 418],
  },
  {
    genesis_token_id: 18232,
    wearable_ids: [400, 306],
  },
  {
    genesis_token_id: 18233,
    wearable_ids: [340, 387],
  },
  {
    genesis_token_id: 18234,
    wearable_ids: [304, 411],
  },
  {
    genesis_token_id: 18235,
    wearable_ids: [373, 406],
  },
  {
    genesis_token_id: 18236,
    wearable_ids: [259, 371],
  },
  {
    genesis_token_id: 18237,
    wearable_ids: [444, 351],
  },
  {
    genesis_token_id: 18238,
    wearable_ids: [370, 302],
  },
  {
    genesis_token_id: 18239,
    wearable_ids: [413, 274],
  },
  {
    genesis_token_id: 18240,
    wearable_ids: [431, 344],
  },
  {
    genesis_token_id: 18241,
    wearable_ids: [370, 345],
  },
  {
    genesis_token_id: 18242,
    wearable_ids: [259, 319],
  },
  {
    genesis_token_id: 18243,
    wearable_ids: [308, 320],
  },
  {
    genesis_token_id: 18244,
    wearable_ids: [387, 400],
  },
  {
    genesis_token_id: 18245,
    wearable_ids: [351, 389],
  },
  {
    genesis_token_id: 18246,
    wearable_ids: [351, 344],
  },
  {
    genesis_token_id: 18247,
    wearable_ids: [363, 373],
  },
  {
    genesis_token_id: 18248,
    wearable_ids: [397, 286],
  },
  {
    genesis_token_id: 18249,
    wearable_ids: [377, 277],
  },
  {
    genesis_token_id: 18250,
    wearable_ids: [408, 346],
  },
  {
    genesis_token_id: 18251,
    wearable_ids: [268, 423],
  },
  {
    genesis_token_id: 18252,
    wearable_ids: [442, 445],
  },
  {
    genesis_token_id: 18253,
    wearable_ids: [374, 404],
  },
  {
    genesis_token_id: 18254,
    wearable_ids: [319, 402],
  },
  {
    genesis_token_id: 18255,
    wearable_ids: [310, 428],
  },
  {
    genesis_token_id: 18256,
    wearable_ids: [270, 308],
  },
  {
    genesis_token_id: 18257,
    wearable_ids: [316, 338],
  },
  {
    genesis_token_id: 18258,
    wearable_ids: [400, 419],
  },
  {
    genesis_token_id: 18259,
    wearable_ids: [432, 399],
  },
  {
    genesis_token_id: 18260,
    wearable_ids: [436, 432],
  },
  {
    genesis_token_id: 18261,
    wearable_ids: [248, 334],
  },
  {
    genesis_token_id: 18262,
    wearable_ids: [344, 351],
  },
  {
    genesis_token_id: 18263,
    wearable_ids: [289, 349],
  },
  {
    genesis_token_id: 18264,
    wearable_ids: [258, 374],
  },
  {
    genesis_token_id: 18265,
    wearable_ids: [369, 349],
  },
  {
    genesis_token_id: 18266,
    wearable_ids: [257, 437],
  },
  {
    genesis_token_id: 18267,
    wearable_ids: [375, 342],
  },
  {
    genesis_token_id: 18268,
    wearable_ids: [254, 383],
  },
  {
    genesis_token_id: 18269,
    wearable_ids: [355, 428],
  },
  {
    genesis_token_id: 18270,
    wearable_ids: [294, 389],
  },
  {
    genesis_token_id: 18271,
    wearable_ids: [310, 354],
  },
  {
    genesis_token_id: 18272,
    wearable_ids: [315, 434],
  },
  {
    genesis_token_id: 18273,
    wearable_ids: [304, 331],
  },
  {
    genesis_token_id: 18274,
    wearable_ids: [262, 279],
  },
  {
    genesis_token_id: 18275,
    wearable_ids: [344, 355],
  },
  {
    genesis_token_id: 18276,
    wearable_ids: [373, 326],
  },
  {
    genesis_token_id: 18277,
    wearable_ids: [351, 310],
  },
  {
    genesis_token_id: 18278,
    wearable_ids: [370, 338],
  },
  {
    genesis_token_id: 18279,
    wearable_ids: [251, 387],
  },
  {
    genesis_token_id: 18280,
    wearable_ids: [423, 304],
  },
  {
    genesis_token_id: 18281,
    wearable_ids: [299, 262],
  },
  {
    genesis_token_id: 18282,
    wearable_ids: [429, 374],
  },
  {
    genesis_token_id: 18283,
    wearable_ids: [396, 265],
  },
  {
    genesis_token_id: 18284,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 18285,
    wearable_ids: [325, 266],
  },
  {
    genesis_token_id: 18286,
    wearable_ids: [352, 346],
  },
  {
    genesis_token_id: 18287,
    wearable_ids: [437, 357],
  },
  {
    genesis_token_id: 18288,
    wearable_ids: [344, 278],
  },
  {
    genesis_token_id: 18289,
    wearable_ids: [300, 373],
  },
  {
    genesis_token_id: 18290,
    wearable_ids: [272, 377],
  },
  {
    genesis_token_id: 18291,
    wearable_ids: [434, 420],
  },
  {
    genesis_token_id: 18292,
    wearable_ids: [340, 253],
  },
  {
    genesis_token_id: 18293,
    wearable_ids: [271, 389],
  },
  {
    genesis_token_id: 18294,
    wearable_ids: [432, 351],
  },
  {
    genesis_token_id: 18295,
    wearable_ids: [314, 276],
  },
  {
    genesis_token_id: 18296,
    wearable_ids: [443, 389],
  },
  {
    genesis_token_id: 18297,
    wearable_ids: [280, 363],
  },
  {
    genesis_token_id: 18298,
    wearable_ids: [341, 317],
  },
  {
    genesis_token_id: 18299,
    wearable_ids: [292, 431],
  },
  {
    genesis_token_id: 18300,
    wearable_ids: [387, 261],
  },
  {
    genesis_token_id: 18301,
    wearable_ids: [256, 352],
  },
  {
    genesis_token_id: 18302,
    wearable_ids: [410, 336],
  },
  {
    genesis_token_id: 18303,
    wearable_ids: [428, 444],
  },
  {
    genesis_token_id: 18304,
    wearable_ids: [326, 368],
  },
  {
    genesis_token_id: 18305,
    wearable_ids: [339, 373],
  },
  {
    genesis_token_id: 18306,
    wearable_ids: [371, 400],
  },
  {
    genesis_token_id: 18307,
    wearable_ids: [397, 360],
  },
  {
    genesis_token_id: 18308,
    wearable_ids: [372, 353],
  },
  {
    genesis_token_id: 18309,
    wearable_ids: [432, 425],
  },
  {
    genesis_token_id: 18310,
    wearable_ids: [431, 268],
  },
  {
    genesis_token_id: 18311,
    wearable_ids: [371, 345],
  },
  {
    genesis_token_id: 18312,
    wearable_ids: [422, 340],
  },
  {
    genesis_token_id: 18313,
    wearable_ids: [290, 291],
  },
  {
    genesis_token_id: 18314,
    wearable_ids: [404, 434],
  },
  {
    genesis_token_id: 18315,
    wearable_ids: [306, 286],
  },
  {
    genesis_token_id: 18316,
    wearable_ids: [270, 330],
  },
  {
    genesis_token_id: 18317,
    wearable_ids: [428, 323],
  },
  {
    genesis_token_id: 18318,
    wearable_ids: [344, 372],
  },
  {
    genesis_token_id: 18319,
    wearable_ids: [355, 326],
  },
  {
    genesis_token_id: 18320,
    wearable_ids: [315, 388],
  },
  {
    genesis_token_id: 18321,
    wearable_ids: [397, 293],
  },
  {
    genesis_token_id: 18322,
    wearable_ids: [396, 415],
  },
  {
    genesis_token_id: 18323,
    wearable_ids: [311, 335],
  },
  {
    genesis_token_id: 18324,
    wearable_ids: [270, 389],
  },
  {
    genesis_token_id: 18325,
    wearable_ids: [289, 403],
  },
  {
    genesis_token_id: 18326,
    wearable_ids: [259, 331],
  },
  {
    genesis_token_id: 18327,
    wearable_ids: [335, 374],
  },
  {
    genesis_token_id: 18328,
    wearable_ids: [332, 374],
  },
  {
    genesis_token_id: 18329,
    wearable_ids: [431, 331],
  },
  {
    genesis_token_id: 18330,
    wearable_ids: [337, 405],
  },
  {
    genesis_token_id: 18331,
    wearable_ids: [400, 386],
  },
  {
    genesis_token_id: 18332,
    wearable_ids: [352, 412],
  },
  {
    genesis_token_id: 18333,
    wearable_ids: [422, 339],
  },
  {
    genesis_token_id: 18334,
    wearable_ids: [403, 434],
  },
  {
    genesis_token_id: 18335,
    wearable_ids: [444, 330],
  },
  {
    genesis_token_id: 18336,
    wearable_ids: [319, 414],
  },
  {
    genesis_token_id: 18337,
    wearable_ids: [407, 306],
  },
  {
    genesis_token_id: 18338,
    wearable_ids: [346, 395],
  },
  {
    genesis_token_id: 18339,
    wearable_ids: [364, 372],
  },
  {
    genesis_token_id: 18340,
    wearable_ids: [365, 264],
  },
  {
    genesis_token_id: 18341,
    wearable_ids: [400, 253],
  },
  {
    genesis_token_id: 18342,
    wearable_ids: [434, 311],
  },
  {
    genesis_token_id: 18343,
    wearable_ids: [354, 352],
  },
  {
    genesis_token_id: 18344,
    wearable_ids: [311, 360],
  },
  {
    genesis_token_id: 18345,
    wearable_ids: [420, 440],
  },
  {
    genesis_token_id: 18346,
    wearable_ids: [289, 435],
  },
  {
    genesis_token_id: 18347,
    wearable_ids: [363, 295],
  },
  {
    genesis_token_id: 18348,
    wearable_ids: [291, 266],
  },
  {
    genesis_token_id: 18349,
    wearable_ids: [363, 283],
  },
  {
    genesis_token_id: 18350,
    wearable_ids: [268, 430],
  },
  {
    genesis_token_id: 18351,
    wearable_ids: [368, 370],
  },
  {
    genesis_token_id: 18352,
    wearable_ids: [325, 304],
  },
  {
    genesis_token_id: 18353,
    wearable_ids: [436, 432],
  },
  {
    genesis_token_id: 18354,
    wearable_ids: [306, 350],
  },
  {
    genesis_token_id: 18355,
    wearable_ids: [325, 326],
  },
  {
    genesis_token_id: 18356,
    wearable_ids: [383, 335],
  },
  {
    genesis_token_id: 18357,
    wearable_ids: [389, 373],
  },
  {
    genesis_token_id: 18358,
    wearable_ids: [341, 433],
  },
  {
    genesis_token_id: 18359,
    wearable_ids: [341, 344],
  },
  {
    genesis_token_id: 18360,
    wearable_ids: [411, 432],
  },
  {
    genesis_token_id: 18361,
    wearable_ids: [272, 286],
  },
  {
    genesis_token_id: 18362,
    wearable_ids: [272, 279],
  },
  {
    genesis_token_id: 18363,
    wearable_ids: [434, 251],
  },
  {
    genesis_token_id: 18364,
    wearable_ids: [339, 353],
  },
  {
    genesis_token_id: 18365,
    wearable_ids: [389, 371],
  },
  {
    genesis_token_id: 18366,
    wearable_ids: [299, 289],
  },
  {
    genesis_token_id: 18367,
    wearable_ids: [335, 383],
  },
  {
    genesis_token_id: 18368,
    wearable_ids: [434, 262],
  },
  {
    genesis_token_id: 18369,
    wearable_ids: [420, 398],
  },
  {
    genesis_token_id: 18370,
    wearable_ids: [445, 276],
  },
  {
    genesis_token_id: 18371,
    wearable_ids: [425, 335],
  },
  {
    genesis_token_id: 18372,
    wearable_ids: [273, 306],
  },
  {
    genesis_token_id: 18373,
    wearable_ids: [292, 348],
  },
  {
    genesis_token_id: 18374,
    wearable_ids: [270, 364],
  },
  {
    genesis_token_id: 18375,
    wearable_ids: [411, 279],
  },
  {
    genesis_token_id: 18376,
    wearable_ids: [370, 270],
  },
  {
    genesis_token_id: 18377,
    wearable_ids: [297, 389],
  },
  {
    genesis_token_id: 18378,
    wearable_ids: [399, 339],
  },
  {
    genesis_token_id: 18379,
    wearable_ids: [262, 251],
  },
  {
    genesis_token_id: 18380,
    wearable_ids: [429, 382],
  },
  {
    genesis_token_id: 18381,
    wearable_ids: [355, 296],
  },
  {
    genesis_token_id: 18382,
    wearable_ids: [376, 359],
  },
  {
    genesis_token_id: 18383,
    wearable_ids: [286, 253],
  },
  {
    genesis_token_id: 18384,
    wearable_ids: [348, 337],
  },
  {
    genesis_token_id: 18385,
    wearable_ids: [338, 254],
  },
  {
    genesis_token_id: 18386,
    wearable_ids: [292, 424],
  },
  {
    genesis_token_id: 18387,
    wearable_ids: [437, 267],
  },
  {
    genesis_token_id: 18388,
    wearable_ids: [324, 310],
  },
  {
    genesis_token_id: 18389,
    wearable_ids: [389, 352],
  },
  {
    genesis_token_id: 18390,
    wearable_ids: [373, 419],
  },
  {
    genesis_token_id: 18391,
    wearable_ids: [297, 384],
  },
  {
    genesis_token_id: 18392,
    wearable_ids: [364, 395],
  },
  {
    genesis_token_id: 18393,
    wearable_ids: [445, 276],
  },
  {
    genesis_token_id: 18394,
    wearable_ids: [300, 365],
  },
  {
    genesis_token_id: 18395,
    wearable_ids: [273, 311],
  },
  {
    genesis_token_id: 18396,
    wearable_ids: [412, 395],
  },
  {
    genesis_token_id: 18397,
    wearable_ids: [375, 337],
  },
  {
    genesis_token_id: 18398,
    wearable_ids: [289, 338],
  },
  {
    genesis_token_id: 18399,
    wearable_ids: [294, 363],
  },
  {
    genesis_token_id: 18400,
    wearable_ids: [407, 316],
  },
  {
    genesis_token_id: 18401,
    wearable_ids: [424, 295],
  },
  {
    genesis_token_id: 18402,
    wearable_ids: [437, 296],
  },
  {
    genesis_token_id: 18403,
    wearable_ids: [332, 269],
  },
  {
    genesis_token_id: 18404,
    wearable_ids: [423, 402],
  },
  {
    genesis_token_id: 18405,
    wearable_ids: [363, 431],
  },
  {
    genesis_token_id: 18406,
    wearable_ids: [266, 268],
  },
  {
    genesis_token_id: 18407,
    wearable_ids: [287, 248],
  },
  {
    genesis_token_id: 18408,
    wearable_ids: [310, 295],
  },
  {
    genesis_token_id: 18409,
    wearable_ids: [431, 371],
  },
  {
    genesis_token_id: 18410,
    wearable_ids: [286, 300],
  },
  {
    genesis_token_id: 18411,
    wearable_ids: [273, 274],
  },
  {
    genesis_token_id: 18412,
    wearable_ids: [403, 278],
  },
  {
    genesis_token_id: 18413,
    wearable_ids: [403, 332],
  },
  {
    genesis_token_id: 18414,
    wearable_ids: [350, 433],
  },
  {
    genesis_token_id: 18415,
    wearable_ids: [426, 373],
  },
  {
    genesis_token_id: 18416,
    wearable_ids: [352, 283],
  },
  {
    genesis_token_id: 18417,
    wearable_ids: [277, 337],
  },
  {
    genesis_token_id: 18418,
    wearable_ids: [395, 369],
  },
  {
    genesis_token_id: 18419,
    wearable_ids: [387, 407],
  },
  {
    genesis_token_id: 18420,
    wearable_ids: [338, 274],
  },
  {
    genesis_token_id: 18421,
    wearable_ids: [268, 431],
  },
  {
    genesis_token_id: 18422,
    wearable_ids: [372, 445],
  },
  {
    genesis_token_id: 18423,
    wearable_ids: [278, 312],
  },
  {
    genesis_token_id: 18424,
    wearable_ids: [280, 365],
  },
  {
    genesis_token_id: 18425,
    wearable_ids: [346, 292],
  },
  {
    genesis_token_id: 18426,
    wearable_ids: [331, 327],
  },
  {
    genesis_token_id: 18427,
    wearable_ids: [251, 286],
  },
  {
    genesis_token_id: 18428,
    wearable_ids: [332, 362],
  },
  {
    genesis_token_id: 18429,
    wearable_ids: [399, 331],
  },
  {
    genesis_token_id: 18430,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 18431,
    wearable_ids: [436, 406],
  },
  {
    genesis_token_id: 18432,
    wearable_ids: [248, 268],
  },
  {
    genesis_token_id: 18433,
    wearable_ids: [287, 362],
  },
  {
    genesis_token_id: 18434,
    wearable_ids: [272, 389],
  },
  {
    genesis_token_id: 18435,
    wearable_ids: [400, 415],
  },
  {
    genesis_token_id: 18436,
    wearable_ids: [348, 400],
  },
  {
    genesis_token_id: 18437,
    wearable_ids: [412, 431],
  },
  {
    genesis_token_id: 18438,
    wearable_ids: [425, 336],
  },
  {
    genesis_token_id: 18439,
    wearable_ids: [368, 420],
  },
  {
    genesis_token_id: 18440,
    wearable_ids: [435, 413],
  },
  {
    genesis_token_id: 18441,
    wearable_ids: [369, 374],
  },
  {
    genesis_token_id: 18442,
    wearable_ids: [300, 255],
  },
  {
    genesis_token_id: 18443,
    wearable_ids: [254, 255],
  },
  {
    genesis_token_id: 18444,
    wearable_ids: [277, 349],
  },
  {
    genesis_token_id: 18445,
    wearable_ids: [443, 371],
  },
  {
    genesis_token_id: 18446,
    wearable_ids: [425, 315],
  },
  {
    genesis_token_id: 18447,
    wearable_ids: [278, 253],
  },
  {
    genesis_token_id: 18448,
    wearable_ids: [397, 323],
  },
  {
    genesis_token_id: 18449,
    wearable_ids: [325, 330],
  },
  {
    genesis_token_id: 18450,
    wearable_ids: [316, 301],
  },
  {
    genesis_token_id: 18451,
    wearable_ids: [346, 377],
  },
  {
    genesis_token_id: 18452,
    wearable_ids: [290, 372],
  },
  {
    genesis_token_id: 18453,
    wearable_ids: [409, 315],
  },
  {
    genesis_token_id: 18454,
    wearable_ids: [368, 274],
  },
  {
    genesis_token_id: 18455,
    wearable_ids: [389, 257],
  },
  {
    genesis_token_id: 18456,
    wearable_ids: [331, 364],
  },
  {
    genesis_token_id: 18457,
    wearable_ids: [423, 333],
  },
  {
    genesis_token_id: 18458,
    wearable_ids: [425, 402],
  },
  {
    genesis_token_id: 18459,
    wearable_ids: [386, 273],
  },
  {
    genesis_token_id: 18460,
    wearable_ids: [268, 342],
  },
  {
    genesis_token_id: 18461,
    wearable_ids: [271, 359],
  },
  {
    genesis_token_id: 18462,
    wearable_ids: [403, 286],
  },
  {
    genesis_token_id: 18463,
    wearable_ids: [407, 434],
  },
  {
    genesis_token_id: 18464,
    wearable_ids: [266, 335],
  },
  {
    genesis_token_id: 18465,
    wearable_ids: [254, 264],
  },
  {
    genesis_token_id: 18466,
    wearable_ids: [400, 343],
  },
  {
    genesis_token_id: 18467,
    wearable_ids: [377, 361],
  },
  {
    genesis_token_id: 18468,
    wearable_ids: [395, 442],
  },
  {
    genesis_token_id: 18469,
    wearable_ids: [442, 328],
  },
  {
    genesis_token_id: 18470,
    wearable_ids: [274, 426],
  },
  {
    genesis_token_id: 18471,
    wearable_ids: [280, 389],
  },
  {
    genesis_token_id: 18472,
    wearable_ids: [377, 272],
  },
  {
    genesis_token_id: 18473,
    wearable_ids: [415, 445],
  },
  {
    genesis_token_id: 18474,
    wearable_ids: [433, 350],
  },
  {
    genesis_token_id: 18475,
    wearable_ids: [304, 264],
  },
  {
    genesis_token_id: 18476,
    wearable_ids: [341, 393],
  },
  {
    genesis_token_id: 18477,
    wearable_ids: [317, 310],
  },
  {
    genesis_token_id: 18478,
    wearable_ids: [432, 273],
  },
  {
    genesis_token_id: 18479,
    wearable_ids: [422, 270],
  },
  {
    genesis_token_id: 18480,
    wearable_ids: [399, 445],
  },
  {
    genesis_token_id: 18481,
    wearable_ids: [369, 406],
  },
  {
    genesis_token_id: 18482,
    wearable_ids: [280, 376],
  },
  {
    genesis_token_id: 18483,
    wearable_ids: [336, 276],
  },
  {
    genesis_token_id: 18484,
    wearable_ids: [443, 426],
  },
  {
    genesis_token_id: 18485,
    wearable_ids: [286, 379],
  },
  {
    genesis_token_id: 18486,
    wearable_ids: [264, 254],
  },
  {
    genesis_token_id: 18487,
    wearable_ids: [268, 365],
  },
  {
    genesis_token_id: 18488,
    wearable_ids: [324, 435],
  },
  {
    genesis_token_id: 18489,
    wearable_ids: [404, 433],
  },
  {
    genesis_token_id: 18490,
    wearable_ids: [301, 409],
  },
  {
    genesis_token_id: 18491,
    wearable_ids: [331, 403],
  },
  {
    genesis_token_id: 18492,
    wearable_ids: [254, 253],
  },
  {
    genesis_token_id: 18493,
    wearable_ids: [314, 371],
  },
  {
    genesis_token_id: 18494,
    wearable_ids: [420, 257],
  },
  {
    genesis_token_id: 18495,
    wearable_ids: [273, 435],
  },
  {
    genesis_token_id: 18496,
    wearable_ids: [410, 409],
  },
  {
    genesis_token_id: 18497,
    wearable_ids: [311, 408],
  },
  {
    genesis_token_id: 18498,
    wearable_ids: [284, 334],
  },
  {
    genesis_token_id: 18499,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 18500,
    wearable_ids: [413, 266],
  },
  {
    genesis_token_id: 18501,
    wearable_ids: [372, 400],
  },
  {
    genesis_token_id: 18502,
    wearable_ids: [383, 369],
  },
  {
    genesis_token_id: 18503,
    wearable_ids: [287, 325],
  },
  {
    genesis_token_id: 18504,
    wearable_ids: [258, 276],
  },
  {
    genesis_token_id: 18505,
    wearable_ids: [434, 420],
  },
  {
    genesis_token_id: 18506,
    wearable_ids: [437, 311],
  },
  {
    genesis_token_id: 18507,
    wearable_ids: [317, 408],
  },
  {
    genesis_token_id: 18508,
    wearable_ids: [382, 412],
  },
  {
    genesis_token_id: 18509,
    wearable_ids: [331, 261],
  },
  {
    genesis_token_id: 18510,
    wearable_ids: [415, 288],
  },
  {
    genesis_token_id: 18511,
    wearable_ids: [433, 371],
  },
  {
    genesis_token_id: 18512,
    wearable_ids: [432, 289],
  },
  {
    genesis_token_id: 18513,
    wearable_ids: [301, 337],
  },
  {
    genesis_token_id: 18514,
    wearable_ids: [415, 249],
  },
  {
    genesis_token_id: 18515,
    wearable_ids: [429, 409],
  },
  {
    genesis_token_id: 18516,
    wearable_ids: [395, 382],
  },
  {
    genesis_token_id: 18517,
    wearable_ids: [276, 377],
  },
  {
    genesis_token_id: 18518,
    wearable_ids: [273, 360],
  },
  {
    genesis_token_id: 18519,
    wearable_ids: [290, 270],
  },
  {
    genesis_token_id: 18520,
    wearable_ids: [436, 299],
  },
  {
    genesis_token_id: 18521,
    wearable_ids: [422, 393],
  },
  {
    genesis_token_id: 18522,
    wearable_ids: [341, 262],
  },
  {
    genesis_token_id: 18523,
    wearable_ids: [355, 373],
  },
  {
    genesis_token_id: 18524,
    wearable_ids: [272, 290],
  },
  {
    genesis_token_id: 18525,
    wearable_ids: [308, 281],
  },
  {
    genesis_token_id: 18526,
    wearable_ids: [268, 322],
  },
  {
    genesis_token_id: 18527,
    wearable_ids: [354, 259],
  },
  {
    genesis_token_id: 18528,
    wearable_ids: [256, 324],
  },
  {
    genesis_token_id: 18529,
    wearable_ids: [384, 273],
  },
  {
    genesis_token_id: 18530,
    wearable_ids: [407, 384],
  },
  {
    genesis_token_id: 18531,
    wearable_ids: [378, 368],
  },
  {
    genesis_token_id: 18532,
    wearable_ids: [324, 346],
  },
  {
    genesis_token_id: 18533,
    wearable_ids: [435, 341],
  },
  {
    genesis_token_id: 18534,
    wearable_ids: [377, 324],
  },
  {
    genesis_token_id: 18535,
    wearable_ids: [270, 338],
  },
  {
    genesis_token_id: 18536,
    wearable_ids: [342, 419],
  },
  {
    genesis_token_id: 18537,
    wearable_ids: [406, 259],
  },
  {
    genesis_token_id: 18538,
    wearable_ids: [406, 324],
  },
  {
    genesis_token_id: 18539,
    wearable_ids: [386, 412],
  },
  {
    genesis_token_id: 18540,
    wearable_ids: [331, 254],
  },
  {
    genesis_token_id: 18541,
    wearable_ids: [407, 316],
  },
  {
    genesis_token_id: 18542,
    wearable_ids: [265, 387],
  },
  {
    genesis_token_id: 18543,
    wearable_ids: [400, 297],
  },
  {
    genesis_token_id: 18544,
    wearable_ids: [399, 417],
  },
  {
    genesis_token_id: 18545,
    wearable_ids: [399, 258],
  },
  {
    genesis_token_id: 18546,
    wearable_ids: [343, 396],
  },
  {
    genesis_token_id: 18547,
    wearable_ids: [308, 259],
  },
  {
    genesis_token_id: 18548,
    wearable_ids: [407, 424],
  },
  {
    genesis_token_id: 18549,
    wearable_ids: [255, 296],
  },
  {
    genesis_token_id: 18550,
    wearable_ids: [376, 307],
  },
  {
    genesis_token_id: 18551,
    wearable_ids: [339, 284],
  },
  {
    genesis_token_id: 18552,
    wearable_ids: [287, 404],
  },
  {
    genesis_token_id: 18553,
    wearable_ids: [422, 291],
  },
  {
    genesis_token_id: 18554,
    wearable_ids: [262, 337],
  },
  {
    genesis_token_id: 18555,
    wearable_ids: [280, 372],
  },
  {
    genesis_token_id: 18556,
    wearable_ids: [343, 325],
  },
  {
    genesis_token_id: 18557,
    wearable_ids: [317, 266],
  },
  {
    genesis_token_id: 18558,
    wearable_ids: [386, 284],
  },
  {
    genesis_token_id: 18559,
    wearable_ids: [350, 438],
  },
  {
    genesis_token_id: 18560,
    wearable_ids: [342, 384],
  },
  {
    genesis_token_id: 18561,
    wearable_ids: [339, 397],
  },
  {
    genesis_token_id: 18562,
    wearable_ids: [368, 372],
  },
  {
    genesis_token_id: 18563,
    wearable_ids: [376, 247],
  },
  {
    genesis_token_id: 18564,
    wearable_ids: [254, 347],
  },
  {
    genesis_token_id: 18565,
    wearable_ids: [291, 395],
  },
  {
    genesis_token_id: 18566,
    wearable_ids: [372, 370],
  },
  {
    genesis_token_id: 18567,
    wearable_ids: [341, 322],
  },
  {
    genesis_token_id: 18568,
    wearable_ids: [324, 310],
  },
  {
    genesis_token_id: 18569,
    wearable_ids: [270, 279],
  },
  {
    genesis_token_id: 18570,
    wearable_ids: [317, 422],
  },
  {
    genesis_token_id: 18571,
    wearable_ids: [315, 301],
  },
  {
    genesis_token_id: 18572,
    wearable_ids: [255, 420],
  },
  {
    genesis_token_id: 18573,
    wearable_ids: [403, 422],
  },
  {
    genesis_token_id: 18574,
    wearable_ids: [259, 360],
  },
  {
    genesis_token_id: 18575,
    wearable_ids: [257, 395],
  },
  {
    genesis_token_id: 18576,
    wearable_ids: [254, 437],
  },
  {
    genesis_token_id: 18577,
    wearable_ids: [445, 354],
  },
  {
    genesis_token_id: 18578,
    wearable_ids: [412, 298],
  },
  {
    genesis_token_id: 18579,
    wearable_ids: [377, 336],
  },
  {
    genesis_token_id: 18580,
    wearable_ids: [395, 369],
  },
  {
    genesis_token_id: 18581,
    wearable_ids: [294, 316],
  },
  {
    genesis_token_id: 18582,
    wearable_ids: [284, 426],
  },
  {
    genesis_token_id: 18583,
    wearable_ids: [255, 420],
  },
  {
    genesis_token_id: 18584,
    wearable_ids: [428, 411],
  },
  {
    genesis_token_id: 18585,
    wearable_ids: [433, 335],
  },
  {
    genesis_token_id: 18586,
    wearable_ids: [423, 444],
  },
  {
    genesis_token_id: 18587,
    wearable_ids: [408, 272],
  },
  {
    genesis_token_id: 18588,
    wearable_ids: [278, 279],
  },
  {
    genesis_token_id: 18589,
    wearable_ids: [257, 334],
  },
  {
    genesis_token_id: 18590,
    wearable_ids: [397, 402],
  },
  {
    genesis_token_id: 18591,
    wearable_ids: [399, 264],
  },
  {
    genesis_token_id: 18592,
    wearable_ids: [340, 253],
  },
  {
    genesis_token_id: 18593,
    wearable_ids: [332, 442],
  },
  {
    genesis_token_id: 18594,
    wearable_ids: [332, 323],
  },
  {
    genesis_token_id: 18595,
    wearable_ids: [292, 322],
  },
  {
    genesis_token_id: 18596,
    wearable_ids: [295, 341],
  },
  {
    genesis_token_id: 18597,
    wearable_ids: [266, 270],
  },
  {
    genesis_token_id: 18598,
    wearable_ids: [287, 356],
  },
  {
    genesis_token_id: 18599,
    wearable_ids: [413, 354],
  },
  {
    genesis_token_id: 18600,
    wearable_ids: [324, 426],
  },
  {
    genesis_token_id: 18601,
    wearable_ids: [324, 445],
  },
  {
    genesis_token_id: 18602,
    wearable_ids: [324, 370],
  },
  {
    genesis_token_id: 18603,
    wearable_ids: [300, 306],
  },
  {
    genesis_token_id: 18604,
    wearable_ids: [413, 300],
  },
  {
    genesis_token_id: 18605,
    wearable_ids: [343, 259],
  },
  {
    genesis_token_id: 18606,
    wearable_ids: [247, 274],
  },
  {
    genesis_token_id: 18607,
    wearable_ids: [445, 304],
  },
  {
    genesis_token_id: 18608,
    wearable_ids: [387, 355],
  },
  {
    genesis_token_id: 18609,
    wearable_ids: [295, 284],
  },
  {
    genesis_token_id: 18610,
    wearable_ids: [296, 432],
  },
  {
    genesis_token_id: 18611,
    wearable_ids: [344, 308],
  },
  {
    genesis_token_id: 18612,
    wearable_ids: [344, 352],
  },
  {
    genesis_token_id: 18613,
    wearable_ids: [325, 400],
  },
  {
    genesis_token_id: 18614,
    wearable_ids: [404, 399],
  },
  {
    genesis_token_id: 18615,
    wearable_ids: [259, 277],
  },
  {
    genesis_token_id: 18616,
    wearable_ids: [299, 266],
  },
  {
    genesis_token_id: 18617,
    wearable_ids: [352, 391],
  },
  {
    genesis_token_id: 18618,
    wearable_ids: [344, 274],
  },
  {
    genesis_token_id: 18619,
    wearable_ids: [292, 303],
  },
  {
    genesis_token_id: 18620,
    wearable_ids: [346, 422],
  },
  {
    genesis_token_id: 18621,
    wearable_ids: [319, 353],
  },
  {
    genesis_token_id: 18622,
    wearable_ids: [373, 357],
  },
  {
    genesis_token_id: 18623,
    wearable_ids: [270, 352],
  },
  {
    genesis_token_id: 18624,
    wearable_ids: [253, 338],
  },
  {
    genesis_token_id: 18625,
    wearable_ids: [436, 382],
  },
  {
    genesis_token_id: 18626,
    wearable_ids: [332, 297],
  },
  {
    genesis_token_id: 18627,
    wearable_ids: [255, 319],
  },
  {
    genesis_token_id: 18628,
    wearable_ids: [433, 353],
  },
  {
    genesis_token_id: 18629,
    wearable_ids: [292, 271],
  },
  {
    genesis_token_id: 18630,
    wearable_ids: [259, 358],
  },
  {
    genesis_token_id: 18631,
    wearable_ids: [348, 318],
  },
  {
    genesis_token_id: 18632,
    wearable_ids: [276, 326],
  },
  {
    genesis_token_id: 18633,
    wearable_ids: [273, 259],
  },
  {
    genesis_token_id: 18634,
    wearable_ids: [316, 339],
  },
  {
    genesis_token_id: 18635,
    wearable_ids: [277, 403],
  },
  {
    genesis_token_id: 18636,
    wearable_ids: [407, 322],
  },
  {
    genesis_token_id: 18637,
    wearable_ids: [339, 378],
  },
  {
    genesis_token_id: 18638,
    wearable_ids: [306, 431],
  },
  {
    genesis_token_id: 18639,
    wearable_ids: [422, 414],
  },
  {
    genesis_token_id: 18640,
    wearable_ids: [255, 320],
  },
  {
    genesis_token_id: 18641,
    wearable_ids: [375, 419],
  },
  {
    genesis_token_id: 18642,
    wearable_ids: [280, 318],
  },
  {
    genesis_token_id: 18643,
    wearable_ids: [336, 257],
  },
  {
    genesis_token_id: 18644,
    wearable_ids: [300, 325],
  },
  {
    genesis_token_id: 18645,
    wearable_ids: [349, 442],
  },
  {
    genesis_token_id: 18646,
    wearable_ids: [372, 355],
  },
  {
    genesis_token_id: 18647,
    wearable_ids: [289, 303],
  },
  {
    genesis_token_id: 18648,
    wearable_ids: [296, 420],
  },
  {
    genesis_token_id: 18649,
    wearable_ids: [270, 349],
  },
  {
    genesis_token_id: 18650,
    wearable_ids: [444, 427],
  },
  {
    genesis_token_id: 18651,
    wearable_ids: [355, 344],
  },
  {
    genesis_token_id: 18652,
    wearable_ids: [316, 283],
  },
  {
    genesis_token_id: 18653,
    wearable_ids: [442, 444],
  },
  {
    genesis_token_id: 18654,
    wearable_ids: [399, 289],
  },
  {
    genesis_token_id: 18655,
    wearable_ids: [332, 267],
  },
  {
    genesis_token_id: 18656,
    wearable_ids: [352, 389],
  },
  {
    genesis_token_id: 18657,
    wearable_ids: [253, 296],
  },
  {
    genesis_token_id: 18658,
    wearable_ids: [369, 297],
  },
  {
    genesis_token_id: 18659,
    wearable_ids: [273, 344],
  },
  {
    genesis_token_id: 18660,
    wearable_ids: [389, 285],
  },
  {
    genesis_token_id: 18661,
    wearable_ids: [314, 280],
  },
  {
    genesis_token_id: 18662,
    wearable_ids: [395, 348],
  },
  {
    genesis_token_id: 18663,
    wearable_ids: [437, 268],
  },
  {
    genesis_token_id: 18664,
    wearable_ids: [262, 426],
  },
  {
    genesis_token_id: 18665,
    wearable_ids: [400, 280],
  },
  {
    genesis_token_id: 18666,
    wearable_ids: [270, 318],
  },
  {
    genesis_token_id: 18667,
    wearable_ids: [339, 296],
  },
  {
    genesis_token_id: 18668,
    wearable_ids: [355, 319],
  },
  {
    genesis_token_id: 18669,
    wearable_ids: [350, 265],
  },
  {
    genesis_token_id: 18670,
    wearable_ids: [274, 428],
  },
  {
    genesis_token_id: 18671,
    wearable_ids: [436, 383],
  },
  {
    genesis_token_id: 18672,
    wearable_ids: [429, 259],
  },
  {
    genesis_token_id: 18673,
    wearable_ids: [355, 280],
  },
  {
    genesis_token_id: 18674,
    wearable_ids: [306, 355],
  },
  {
    genesis_token_id: 18675,
    wearable_ids: [352, 400],
  },
  {
    genesis_token_id: 18676,
    wearable_ids: [248, 247],
  },
  {
    genesis_token_id: 18677,
    wearable_ids: [386, 403],
  },
  {
    genesis_token_id: 18678,
    wearable_ids: [351, 293],
  },
  {
    genesis_token_id: 18679,
    wearable_ids: [424, 294],
  },
  {
    genesis_token_id: 18680,
    wearable_ids: [278, 392],
  },
  {
    genesis_token_id: 18681,
    wearable_ids: [306, 300],
  },
  {
    genesis_token_id: 18682,
    wearable_ids: [370, 413],
  },
  {
    genesis_token_id: 18683,
    wearable_ids: [262, 372],
  },
  {
    genesis_token_id: 18684,
    wearable_ids: [406, 274],
  },
  {
    genesis_token_id: 18685,
    wearable_ids: [410, 339],
  },
  {
    genesis_token_id: 18686,
    wearable_ids: [268, 343],
  },
  {
    genesis_token_id: 18687,
    wearable_ids: [373, 297],
  },
  {
    genesis_token_id: 18688,
    wearable_ids: [343, 432],
  },
  {
    genesis_token_id: 18689,
    wearable_ids: [331, 265],
  },
  {
    genesis_token_id: 18690,
    wearable_ids: [338, 408],
  },
  {
    genesis_token_id: 18691,
    wearable_ids: [349, 413],
  },
  {
    genesis_token_id: 18692,
    wearable_ids: [370, 443],
  },
  {
    genesis_token_id: 18693,
    wearable_ids: [404, 407],
  },
  {
    genesis_token_id: 18694,
    wearable_ids: [422, 337],
  },
  {
    genesis_token_id: 18695,
    wearable_ids: [277, 249],
  },
  {
    genesis_token_id: 18696,
    wearable_ids: [426, 311],
  },
  {
    genesis_token_id: 18697,
    wearable_ids: [437, 371],
  },
  {
    genesis_token_id: 18698,
    wearable_ids: [415, 383],
  },
  {
    genesis_token_id: 18699,
    wearable_ids: [308, 269],
  },
  {
    genesis_token_id: 18700,
    wearable_ids: [372, 384],
  },
  {
    genesis_token_id: 18701,
    wearable_ids: [352, 427],
  },
  {
    genesis_token_id: 18702,
    wearable_ids: [268, 248],
  },
  {
    genesis_token_id: 18703,
    wearable_ids: [292, 332],
  },
  {
    genesis_token_id: 18704,
    wearable_ids: [377, 253],
  },
  {
    genesis_token_id: 18705,
    wearable_ids: [442, 359],
  },
  {
    genesis_token_id: 18706,
    wearable_ids: [324, 349],
  },
  {
    genesis_token_id: 18707,
    wearable_ids: [425, 398],
  },
  {
    genesis_token_id: 18708,
    wearable_ids: [266, 441],
  },
  {
    genesis_token_id: 18709,
    wearable_ids: [346, 420],
  },
  {
    genesis_token_id: 18710,
    wearable_ids: [428, 436],
  },
  {
    genesis_token_id: 18711,
    wearable_ids: [304, 333],
  },
  {
    genesis_token_id: 18712,
    wearable_ids: [422, 299],
  },
  {
    genesis_token_id: 18713,
    wearable_ids: [301, 404],
  },
  {
    genesis_token_id: 18714,
    wearable_ids: [434, 325],
  },
  {
    genesis_token_id: 18715,
    wearable_ids: [396, 248],
  },
  {
    genesis_token_id: 18716,
    wearable_ids: [301, 359],
  },
  {
    genesis_token_id: 18717,
    wearable_ids: [342, 301],
  },
  {
    genesis_token_id: 18718,
    wearable_ids: [373, 247],
  },
  {
    genesis_token_id: 18719,
    wearable_ids: [280, 388],
  },
  {
    genesis_token_id: 18720,
    wearable_ids: [400, 253],
  },
  {
    genesis_token_id: 18721,
    wearable_ids: [437, 254],
  },
  {
    genesis_token_id: 18722,
    wearable_ids: [286, 385],
  },
  {
    genesis_token_id: 18723,
    wearable_ids: [382, 317],
  },
  {
    genesis_token_id: 18724,
    wearable_ids: [375, 248],
  },
  {
    genesis_token_id: 18725,
    wearable_ids: [369, 347],
  },
  {
    genesis_token_id: 18726,
    wearable_ids: [347, 345],
  },
  {
    genesis_token_id: 18727,
    wearable_ids: [425, 326],
  },
  {
    genesis_token_id: 18728,
    wearable_ids: [389, 399],
  },
  {
    genesis_token_id: 18729,
    wearable_ids: [291, 377],
  },
  {
    genesis_token_id: 18730,
    wearable_ids: [410, 379],
  },
  {
    genesis_token_id: 18731,
    wearable_ids: [378, 306],
  },
  {
    genesis_token_id: 18732,
    wearable_ids: [258, 308],
  },
  {
    genesis_token_id: 18733,
    wearable_ids: [443, 376],
  },
  {
    genesis_token_id: 18734,
    wearable_ids: [297, 344],
  },
  {
    genesis_token_id: 18735,
    wearable_ids: [256, 379],
  },
  {
    genesis_token_id: 18736,
    wearable_ids: [445, 340],
  },
  {
    genesis_token_id: 18737,
    wearable_ids: [351, 300],
  },
  {
    genesis_token_id: 18738,
    wearable_ids: [363, 422],
  },
  {
    genesis_token_id: 18739,
    wearable_ids: [256, 350],
  },
  {
    genesis_token_id: 18740,
    wearable_ids: [299, 370],
  },
  {
    genesis_token_id: 18741,
    wearable_ids: [444, 437],
  },
  {
    genesis_token_id: 18742,
    wearable_ids: [338, 377],
  },
  {
    genesis_token_id: 18743,
    wearable_ids: [411, 401],
  },
  {
    genesis_token_id: 18744,
    wearable_ids: [286, 319],
  },
  {
    genesis_token_id: 18745,
    wearable_ids: [371, 384],
  },
  {
    genesis_token_id: 18746,
    wearable_ids: [423, 443],
  },
  {
    genesis_token_id: 18747,
    wearable_ids: [352, 434],
  },
  {
    genesis_token_id: 18748,
    wearable_ids: [364, 426],
  },
  {
    genesis_token_id: 18749,
    wearable_ids: [331, 336],
  },
  {
    genesis_token_id: 18750,
    wearable_ids: [370, 350],
  },
  {
    genesis_token_id: 18751,
    wearable_ids: [316, 312],
  },
  {
    genesis_token_id: 18752,
    wearable_ids: [292, 251],
  },
  {
    genesis_token_id: 18753,
    wearable_ids: [372, 420],
  },
  {
    genesis_token_id: 18754,
    wearable_ids: [437, 371],
  },
  {
    genesis_token_id: 18755,
    wearable_ids: [351, 344],
  },
  {
    genesis_token_id: 18756,
    wearable_ids: [400, 411],
  },
  {
    genesis_token_id: 18757,
    wearable_ids: [374, 256],
  },
  {
    genesis_token_id: 18758,
    wearable_ids: [442, 341],
  },
  {
    genesis_token_id: 18759,
    wearable_ids: [272, 372],
  },
  {
    genesis_token_id: 18760,
    wearable_ids: [274, 288],
  },
  {
    genesis_token_id: 18761,
    wearable_ids: [422, 316],
  },
  {
    genesis_token_id: 18762,
    wearable_ids: [253, 306],
  },
  {
    genesis_token_id: 18763,
    wearable_ids: [383, 315],
  },
  {
    genesis_token_id: 18764,
    wearable_ids: [337, 388],
  },
  {
    genesis_token_id: 18765,
    wearable_ids: [431, 355],
  },
  {
    genesis_token_id: 18766,
    wearable_ids: [256, 365],
  },
  {
    genesis_token_id: 18767,
    wearable_ids: [383, 363],
  },
  {
    genesis_token_id: 18768,
    wearable_ids: [375, 342],
  },
  {
    genesis_token_id: 18769,
    wearable_ids: [251, 391],
  },
  {
    genesis_token_id: 18770,
    wearable_ids: [413, 250],
  },
  {
    genesis_token_id: 18771,
    wearable_ids: [335, 247],
  },
  {
    genesis_token_id: 18772,
    wearable_ids: [284, 413],
  },
  {
    genesis_token_id: 18773,
    wearable_ids: [294, 429],
  },
  {
    genesis_token_id: 18774,
    wearable_ids: [443, 315],
  },
  {
    genesis_token_id: 18775,
    wearable_ids: [317, 397],
  },
  {
    genesis_token_id: 18776,
    wearable_ids: [384, 317],
  },
  {
    genesis_token_id: 18777,
    wearable_ids: [387, 339],
  },
  {
    genesis_token_id: 18778,
    wearable_ids: [270, 429],
  },
  {
    genesis_token_id: 18779,
    wearable_ids: [368, 256],
  },
  {
    genesis_token_id: 18780,
    wearable_ids: [412, 442],
  },
  {
    genesis_token_id: 18781,
    wearable_ids: [432, 310],
  },
  {
    genesis_token_id: 18782,
    wearable_ids: [408, 433],
  },
  {
    genesis_token_id: 18783,
    wearable_ids: [311, 349],
  },
  {
    genesis_token_id: 18784,
    wearable_ids: [382, 387],
  },
  {
    genesis_token_id: 18785,
    wearable_ids: [344, 363],
  },
  {
    genesis_token_id: 18786,
    wearable_ids: [278, 374],
  },
  {
    genesis_token_id: 18787,
    wearable_ids: [255, 319],
  },
  {
    genesis_token_id: 18788,
    wearable_ids: [266, 445],
  },
  {
    genesis_token_id: 18789,
    wearable_ids: [426, 443],
  },
  {
    genesis_token_id: 18790,
    wearable_ids: [437, 270],
  },
  {
    genesis_token_id: 18791,
    wearable_ids: [431, 259],
  },
  {
    genesis_token_id: 18792,
    wearable_ids: [296, 348],
  },
  {
    genesis_token_id: 18793,
    wearable_ids: [314, 342],
  },
  {
    genesis_token_id: 18794,
    wearable_ids: [273, 271],
  },
  {
    genesis_token_id: 18795,
    wearable_ids: [304, 359],
  },
  {
    genesis_token_id: 18796,
    wearable_ids: [286, 348],
  },
  {
    genesis_token_id: 18797,
    wearable_ids: [292, 368],
  },
  {
    genesis_token_id: 18798,
    wearable_ids: [294, 289],
  },
  {
    genesis_token_id: 18799,
    wearable_ids: [324, 376],
  },
  {
    genesis_token_id: 18800,
    wearable_ids: [389, 387],
  },
  {
    genesis_token_id: 18801,
    wearable_ids: [424, 295],
  },
  {
    genesis_token_id: 18802,
    wearable_ids: [429, 408],
  },
  {
    genesis_token_id: 18803,
    wearable_ids: [352, 322],
  },
  {
    genesis_token_id: 18804,
    wearable_ids: [343, 346],
  },
  {
    genesis_token_id: 18805,
    wearable_ids: [350, 370],
  },
  {
    genesis_token_id: 18806,
    wearable_ids: [383, 341],
  },
  {
    genesis_token_id: 18807,
    wearable_ids: [428, 360],
  },
  {
    genesis_token_id: 18808,
    wearable_ids: [434, 267],
  },
  {
    genesis_token_id: 18809,
    wearable_ids: [428, 376],
  },
  {
    genesis_token_id: 18810,
    wearable_ids: [338, 286],
  },
  {
    genesis_token_id: 18811,
    wearable_ids: [375, 422],
  },
  {
    genesis_token_id: 18812,
    wearable_ids: [272, 353],
  },
  {
    genesis_token_id: 18813,
    wearable_ids: [355, 263],
  },
  {
    genesis_token_id: 18814,
    wearable_ids: [368, 415],
  },
  {
    genesis_token_id: 18815,
    wearable_ids: [266, 283],
  },
  {
    genesis_token_id: 18816,
    wearable_ids: [375, 426],
  },
  {
    genesis_token_id: 18817,
    wearable_ids: [303, 388],
  },
  {
    genesis_token_id: 18818,
    wearable_ids: [326, 293],
  },
  {
    genesis_token_id: 18819,
    wearable_ids: [278, 317],
  },
  {
    genesis_token_id: 18820,
    wearable_ids: [400, 248],
  },
  {
    genesis_token_id: 18821,
    wearable_ids: [382, 280],
  },
  {
    genesis_token_id: 18822,
    wearable_ids: [348, 407],
  },
  {
    genesis_token_id: 18823,
    wearable_ids: [411, 344],
  },
  {
    genesis_token_id: 18824,
    wearable_ids: [289, 393],
  },
  {
    genesis_token_id: 18825,
    wearable_ids: [262, 248],
  },
  {
    genesis_token_id: 18826,
    wearable_ids: [284, 412],
  },
  {
    genesis_token_id: 18827,
    wearable_ids: [385, 323],
  },
  {
    genesis_token_id: 18828,
    wearable_ids: [303, 287],
  },
  {
    genesis_token_id: 18829,
    wearable_ids: [266, 300],
  },
  {
    genesis_token_id: 18830,
    wearable_ids: [428, 320],
  },
  {
    genesis_token_id: 18831,
    wearable_ids: [265, 323],
  },
  {
    genesis_token_id: 18832,
    wearable_ids: [403, 300],
  },
  {
    genesis_token_id: 18833,
    wearable_ids: [348, 414],
  },
  {
    genesis_token_id: 18834,
    wearable_ids: [364, 314],
  },
  {
    genesis_token_id: 18835,
    wearable_ids: [407, 319],
  },
  {
    genesis_token_id: 18836,
    wearable_ids: [325, 346],
  },
  {
    genesis_token_id: 18837,
    wearable_ids: [377, 368],
  },
  {
    genesis_token_id: 18838,
    wearable_ids: [387, 258],
  },
  {
    genesis_token_id: 18839,
    wearable_ids: [412, 339],
  },
  {
    genesis_token_id: 18840,
    wearable_ids: [266, 445],
  },
  {
    genesis_token_id: 18841,
    wearable_ids: [404, 333],
  },
  {
    genesis_token_id: 18842,
    wearable_ids: [399, 338],
  },
  {
    genesis_token_id: 18843,
    wearable_ids: [297, 264],
  },
  {
    genesis_token_id: 18844,
    wearable_ids: [409, 268],
  },
  {
    genesis_token_id: 18845,
    wearable_ids: [350, 431],
  },
  {
    genesis_token_id: 18846,
    wearable_ids: [251, 365],
  },
  {
    genesis_token_id: 18847,
    wearable_ids: [399, 420],
  },
  {
    genesis_token_id: 18848,
    wearable_ids: [369, 366],
  },
  {
    genesis_token_id: 18849,
    wearable_ids: [304, 339],
  },
  {
    genesis_token_id: 18850,
    wearable_ids: [340, 335],
  },
  {
    genesis_token_id: 18851,
    wearable_ids: [263, 292],
  },
  {
    genesis_token_id: 18852,
    wearable_ids: [324, 386],
  },
  {
    genesis_token_id: 18853,
    wearable_ids: [247, 294],
  },
  {
    genesis_token_id: 18854,
    wearable_ids: [422, 267],
  },
  {
    genesis_token_id: 18855,
    wearable_ids: [255, 320],
  },
  {
    genesis_token_id: 18856,
    wearable_ids: [284, 365],
  },
  {
    genesis_token_id: 18857,
    wearable_ids: [377, 331],
  },
  {
    genesis_token_id: 18858,
    wearable_ids: [365, 272],
  },
  {
    genesis_token_id: 18859,
    wearable_ids: [412, 419],
  },
  {
    genesis_token_id: 18860,
    wearable_ids: [340, 336],
  },
  {
    genesis_token_id: 18861,
    wearable_ids: [425, 365],
  },
  {
    genesis_token_id: 18862,
    wearable_ids: [296, 305],
  },
  {
    genesis_token_id: 18863,
    wearable_ids: [362, 346],
  },
  {
    genesis_token_id: 18864,
    wearable_ids: [310, 442],
  },
  {
    genesis_token_id: 18865,
    wearable_ids: [258, 301],
  },
  {
    genesis_token_id: 18866,
    wearable_ids: [432, 273],
  },
  {
    genesis_token_id: 18867,
    wearable_ids: [376, 373],
  },
  {
    genesis_token_id: 18868,
    wearable_ids: [262, 394],
  },
  {
    genesis_token_id: 18869,
    wearable_ids: [284, 296],
  },
  {
    genesis_token_id: 18870,
    wearable_ids: [431, 283],
  },
  {
    genesis_token_id: 18871,
    wearable_ids: [437, 329],
  },
  {
    genesis_token_id: 18872,
    wearable_ids: [289, 378],
  },
  {
    genesis_token_id: 18873,
    wearable_ids: [296, 336],
  },
  {
    genesis_token_id: 18874,
    wearable_ids: [254, 289],
  },
  {
    genesis_token_id: 18875,
    wearable_ids: [310, 311],
  },
  {
    genesis_token_id: 18876,
    wearable_ids: [262, 339],
  },
  {
    genesis_token_id: 18877,
    wearable_ids: [337, 396],
  },
  {
    genesis_token_id: 18878,
    wearable_ids: [383, 416],
  },
  {
    genesis_token_id: 18879,
    wearable_ids: [404, 434],
  },
  {
    genesis_token_id: 18880,
    wearable_ids: [303, 386],
  },
  {
    genesis_token_id: 18881,
    wearable_ids: [403, 426],
  },
  {
    genesis_token_id: 18882,
    wearable_ids: [423, 413],
  },
  {
    genesis_token_id: 18883,
    wearable_ids: [341, 426],
  },
  {
    genesis_token_id: 18884,
    wearable_ids: [262, 396],
  },
  {
    genesis_token_id: 18885,
    wearable_ids: [324, 335],
  },
  {
    genesis_token_id: 18886,
    wearable_ids: [290, 274],
  },
  {
    genesis_token_id: 18887,
    wearable_ids: [348, 287],
  },
  {
    genesis_token_id: 18888,
    wearable_ids: [411, 336],
  },
  {
    genesis_token_id: 18889,
    wearable_ids: [425, 287],
  },
  {
    genesis_token_id: 18890,
    wearable_ids: [348, 338],
  },
  {
    genesis_token_id: 18891,
    wearable_ids: [372, 292],
  },
  {
    genesis_token_id: 18892,
    wearable_ids: [289, 375],
  },
  {
    genesis_token_id: 18893,
    wearable_ids: [411, 387],
  },
  {
    genesis_token_id: 18894,
    wearable_ids: [306, 399],
  },
  {
    genesis_token_id: 18895,
    wearable_ids: [300, 413],
  },
  {
    genesis_token_id: 18896,
    wearable_ids: [350, 387],
  },
  {
    genesis_token_id: 18897,
    wearable_ids: [383, 315],
  },
  {
    genesis_token_id: 18898,
    wearable_ids: [420, 355],
  },
  {
    genesis_token_id: 18899,
    wearable_ids: [268, 409],
  },
  {
    genesis_token_id: 18900,
    wearable_ids: [292, 256],
  },
  {
    genesis_token_id: 18901,
    wearable_ids: [343, 432],
  },
  {
    genesis_token_id: 18902,
    wearable_ids: [296, 295],
  },
  {
    genesis_token_id: 18903,
    wearable_ids: [290, 314],
  },
  {
    genesis_token_id: 18904,
    wearable_ids: [399, 396],
  },
  {
    genesis_token_id: 18905,
    wearable_ids: [389, 431],
  },
  {
    genesis_token_id: 18906,
    wearable_ids: [395, 254],
  },
  {
    genesis_token_id: 18907,
    wearable_ids: [299, 417],
  },
  {
    genesis_token_id: 18908,
    wearable_ids: [374, 267],
  },
  {
    genesis_token_id: 18909,
    wearable_ids: [331, 325],
  },
  {
    genesis_token_id: 18910,
    wearable_ids: [411, 266],
  },
  {
    genesis_token_id: 18911,
    wearable_ids: [384, 300],
  },
  {
    genesis_token_id: 18912,
    wearable_ids: [397, 443],
  },
  {
    genesis_token_id: 18913,
    wearable_ids: [355, 427],
  },
  {
    genesis_token_id: 18914,
    wearable_ids: [340, 353],
  },
  {
    genesis_token_id: 18915,
    wearable_ids: [365, 389],
  },
  {
    genesis_token_id: 18916,
    wearable_ids: [376, 445],
  },
  {
    genesis_token_id: 18917,
    wearable_ids: [284, 300],
  },
  {
    genesis_token_id: 18918,
    wearable_ids: [423, 262],
  },
  {
    genesis_token_id: 18919,
    wearable_ids: [310, 370],
  },
  {
    genesis_token_id: 18920,
    wearable_ids: [445, 313],
  },
  {
    genesis_token_id: 18921,
    wearable_ids: [415, 250],
  },
  {
    genesis_token_id: 18922,
    wearable_ids: [406, 410],
  },
  {
    genesis_token_id: 18923,
    wearable_ids: [422, 249],
  },
  {
    genesis_token_id: 18924,
    wearable_ids: [338, 293],
  },
  {
    genesis_token_id: 18925,
    wearable_ids: [375, 346],
  },
  {
    genesis_token_id: 18926,
    wearable_ids: [410, 372],
  },
  {
    genesis_token_id: 18927,
    wearable_ids: [319, 337],
  },
  {
    genesis_token_id: 18928,
    wearable_ids: [403, 287],
  },
  {
    genesis_token_id: 18929,
    wearable_ids: [255, 286],
  },
  {
    genesis_token_id: 18930,
    wearable_ids: [370, 441],
  },
  {
    genesis_token_id: 18931,
    wearable_ids: [300, 286],
  },
  {
    genesis_token_id: 18932,
    wearable_ids: [304, 396],
  },
  {
    genesis_token_id: 18933,
    wearable_ids: [389, 258],
  },
  {
    genesis_token_id: 18934,
    wearable_ids: [374, 429],
  },
  {
    genesis_token_id: 18935,
    wearable_ids: [311, 346],
  },
  {
    genesis_token_id: 18936,
    wearable_ids: [343, 400],
  },
  {
    genesis_token_id: 18937,
    wearable_ids: [435, 371],
  },
  {
    genesis_token_id: 18938,
    wearable_ids: [268, 247],
  },
  {
    genesis_token_id: 18939,
    wearable_ids: [351, 259],
  },
  {
    genesis_token_id: 18940,
    wearable_ids: [420, 436],
  },
  {
    genesis_token_id: 18941,
    wearable_ids: [270, 438],
  },
  {
    genesis_token_id: 18942,
    wearable_ids: [247, 300],
  },
  {
    genesis_token_id: 18943,
    wearable_ids: [364, 247],
  },
  {
    genesis_token_id: 18944,
    wearable_ids: [424, 308],
  },
  {
    genesis_token_id: 18945,
    wearable_ids: [336, 364],
  },
  {
    genesis_token_id: 18946,
    wearable_ids: [308, 429],
  },
  {
    genesis_token_id: 18947,
    wearable_ids: [420, 355],
  },
  {
    genesis_token_id: 18948,
    wearable_ids: [324, 358],
  },
  {
    genesis_token_id: 18949,
    wearable_ids: [347, 279],
  },
  {
    genesis_token_id: 18950,
    wearable_ids: [306, 256],
  },
  {
    genesis_token_id: 18951,
    wearable_ids: [349, 279],
  },
  {
    genesis_token_id: 18952,
    wearable_ids: [346, 341],
  },
  {
    genesis_token_id: 18953,
    wearable_ids: [363, 279],
  },
  {
    genesis_token_id: 18954,
    wearable_ids: [389, 310],
  },
  {
    genesis_token_id: 18955,
    wearable_ids: [339, 354],
  },
  {
    genesis_token_id: 18956,
    wearable_ids: [332, 357],
  },
  {
    genesis_token_id: 18957,
    wearable_ids: [410, 400],
  },
  {
    genesis_token_id: 18958,
    wearable_ids: [397, 433],
  },
  {
    genesis_token_id: 18959,
    wearable_ids: [342, 306],
  },
  {
    genesis_token_id: 18960,
    wearable_ids: [407, 308],
  },
  {
    genesis_token_id: 18961,
    wearable_ids: [266, 341],
  },
  {
    genesis_token_id: 18962,
    wearable_ids: [339, 273],
  },
  {
    genesis_token_id: 18963,
    wearable_ids: [289, 416],
  },
  {
    genesis_token_id: 18964,
    wearable_ids: [348, 266],
  },
  {
    genesis_token_id: 18965,
    wearable_ids: [343, 315],
  },
  {
    genesis_token_id: 18966,
    wearable_ids: [277, 248],
  },
  {
    genesis_token_id: 18967,
    wearable_ids: [259, 395],
  },
  {
    genesis_token_id: 18968,
    wearable_ids: [311, 301],
  },
  {
    genesis_token_id: 18969,
    wearable_ids: [294, 342],
  },
  {
    genesis_token_id: 18970,
    wearable_ids: [403, 393],
  },
  {
    genesis_token_id: 18971,
    wearable_ids: [424, 316],
  },
  {
    genesis_token_id: 18972,
    wearable_ids: [338, 423],
  },
  {
    genesis_token_id: 18973,
    wearable_ids: [292, 431],
  },
  {
    genesis_token_id: 18974,
    wearable_ids: [266, 299],
  },
  {
    genesis_token_id: 18975,
    wearable_ids: [266, 328],
  },
  {
    genesis_token_id: 18976,
    wearable_ids: [377, 258],
  },
  {
    genesis_token_id: 18977,
    wearable_ids: [445, 277],
  },
  {
    genesis_token_id: 18978,
    wearable_ids: [352, 435],
  },
  {
    genesis_token_id: 18979,
    wearable_ids: [350, 415],
  },
  {
    genesis_token_id: 18980,
    wearable_ids: [335, 256],
  },
  {
    genesis_token_id: 18981,
    wearable_ids: [259, 276],
  },
  {
    genesis_token_id: 18982,
    wearable_ids: [410, 435],
  },
  {
    genesis_token_id: 18983,
    wearable_ids: [397, 389],
  },
  {
    genesis_token_id: 18984,
    wearable_ids: [436, 287],
  },
  {
    genesis_token_id: 18985,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 18986,
    wearable_ids: [262, 436],
  },
  {
    genesis_token_id: 18987,
    wearable_ids: [268, 300],
  },
  {
    genesis_token_id: 18988,
    wearable_ids: [314, 406],
  },
  {
    genesis_token_id: 18989,
    wearable_ids: [258, 382],
  },
  {
    genesis_token_id: 18990,
    wearable_ids: [266, 341],
  },
  {
    genesis_token_id: 18991,
    wearable_ids: [319, 429],
  },
  {
    genesis_token_id: 18992,
    wearable_ids: [308, 411],
  },
  {
    genesis_token_id: 18993,
    wearable_ids: [351, 387],
  },
  {
    genesis_token_id: 18994,
    wearable_ids: [301, 251],
  },
  {
    genesis_token_id: 18995,
    wearable_ids: [369, 349],
  },
  {
    genesis_token_id: 18996,
    wearable_ids: [271, 257],
  },
  {
    genesis_token_id: 18997,
    wearable_ids: [336, 379],
  },
  {
    genesis_token_id: 18998,
    wearable_ids: [433, 387],
  },
  {
    genesis_token_id: 18999,
    wearable_ids: [335, 313],
  },
  {
    genesis_token_id: 19000,
    wearable_ids: [423, 333],
  },
  {
    genesis_token_id: 19001,
    wearable_ids: [404, 365],
  },
  {
    genesis_token_id: 19002,
    wearable_ids: [303, 341],
  },
  {
    genesis_token_id: 19003,
    wearable_ids: [248, 301],
  },
  {
    genesis_token_id: 19004,
    wearable_ids: [348, 364],
  },
  {
    genesis_token_id: 19005,
    wearable_ids: [389, 433],
  },
  {
    genesis_token_id: 19006,
    wearable_ids: [382, 389],
  },
  {
    genesis_token_id: 19007,
    wearable_ids: [364, 294],
  },
  {
    genesis_token_id: 19008,
    wearable_ids: [299, 427],
  },
  {
    genesis_token_id: 19009,
    wearable_ids: [265, 249],
  },
  {
    genesis_token_id: 19010,
    wearable_ids: [385, 274],
  },
  {
    genesis_token_id: 19011,
    wearable_ids: [299, 443],
  },
  {
    genesis_token_id: 19012,
    wearable_ids: [317, 332],
  },
  {
    genesis_token_id: 19013,
    wearable_ids: [369, 292],
  },
  {
    genesis_token_id: 19014,
    wearable_ids: [445, 429],
  },
  {
    genesis_token_id: 19015,
    wearable_ids: [409, 296],
  },
  {
    genesis_token_id: 19016,
    wearable_ids: [304, 306],
  },
  {
    genesis_token_id: 19017,
    wearable_ids: [258, 399],
  },
  {
    genesis_token_id: 19018,
    wearable_ids: [383, 435],
  },
  {
    genesis_token_id: 19019,
    wearable_ids: [291, 336],
  },
  {
    genesis_token_id: 19020,
    wearable_ids: [343, 397],
  },
  {
    genesis_token_id: 19021,
    wearable_ids: [299, 275],
  },
  {
    genesis_token_id: 19022,
    wearable_ids: [424, 339],
  },
  {
    genesis_token_id: 19023,
    wearable_ids: [342, 360],
  },
  {
    genesis_token_id: 19024,
    wearable_ids: [385, 250],
  },
  {
    genesis_token_id: 19025,
    wearable_ids: [310, 387],
  },
  {
    genesis_token_id: 19026,
    wearable_ids: [286, 272],
  },
  {
    genesis_token_id: 19027,
    wearable_ids: [319, 378],
  },
  {
    genesis_token_id: 19028,
    wearable_ids: [431, 306],
  },
  {
    genesis_token_id: 19029,
    wearable_ids: [336, 384],
  },
  {
    genesis_token_id: 19030,
    wearable_ids: [378, 444],
  },
  {
    genesis_token_id: 19031,
    wearable_ids: [375, 366],
  },
  {
    genesis_token_id: 19032,
    wearable_ids: [292, 270],
  },
  {
    genesis_token_id: 19033,
    wearable_ids: [326, 263],
  },
  {
    genesis_token_id: 19034,
    wearable_ids: [369, 387],
  },
  {
    genesis_token_id: 19035,
    wearable_ids: [431, 352],
  },
  {
    genesis_token_id: 19036,
    wearable_ids: [375, 422],
  },
  {
    genesis_token_id: 19037,
    wearable_ids: [308, 404],
  },
  {
    genesis_token_id: 19038,
    wearable_ids: [352, 268],
  },
  {
    genesis_token_id: 19039,
    wearable_ids: [340, 281],
  },
  {
    genesis_token_id: 19040,
    wearable_ids: [378, 324],
  },
  {
    genesis_token_id: 19041,
    wearable_ids: [326, 274],
  },
  {
    genesis_token_id: 19042,
    wearable_ids: [374, 344],
  },
  {
    genesis_token_id: 19043,
    wearable_ids: [364, 317],
  },
  {
    genesis_token_id: 19044,
    wearable_ids: [373, 364],
  },
  {
    genesis_token_id: 19045,
    wearable_ids: [383, 423],
  },
  {
    genesis_token_id: 19046,
    wearable_ids: [409, 280],
  },
  {
    genesis_token_id: 19047,
    wearable_ids: [383, 431],
  },
  {
    genesis_token_id: 19048,
    wearable_ids: [432, 262],
  },
  {
    genesis_token_id: 19049,
    wearable_ids: [337, 371],
  },
  {
    genesis_token_id: 19050,
    wearable_ids: [442, 376],
  },
  {
    genesis_token_id: 19051,
    wearable_ids: [296, 352],
  },
  {
    genesis_token_id: 19052,
    wearable_ids: [316, 444],
  },
  {
    genesis_token_id: 19053,
    wearable_ids: [291, 248],
  },
  {
    genesis_token_id: 19054,
    wearable_ids: [343, 413],
  },
  {
    genesis_token_id: 19055,
    wearable_ids: [445, 412],
  },
  {
    genesis_token_id: 19056,
    wearable_ids: [297, 304],
  },
  {
    genesis_token_id: 19057,
    wearable_ids: [256, 337],
  },
  {
    genesis_token_id: 19058,
    wearable_ids: [310, 365],
  },
  {
    genesis_token_id: 19059,
    wearable_ids: [403, 292],
  },
  {
    genesis_token_id: 19060,
    wearable_ids: [284, 319],
  },
  {
    genesis_token_id: 19061,
    wearable_ids: [382, 355],
  },
  {
    genesis_token_id: 19062,
    wearable_ids: [258, 308],
  },
  {
    genesis_token_id: 19063,
    wearable_ids: [349, 251],
  },
  {
    genesis_token_id: 19064,
    wearable_ids: [255, 424],
  },
  {
    genesis_token_id: 19065,
    wearable_ids: [387, 411],
  },
  {
    genesis_token_id: 19066,
    wearable_ids: [266, 254],
  },
  {
    genesis_token_id: 19067,
    wearable_ids: [437, 373],
  },
  {
    genesis_token_id: 19068,
    wearable_ids: [426, 297],
  },
  {
    genesis_token_id: 19069,
    wearable_ids: [432, 400],
  },
  {
    genesis_token_id: 19070,
    wearable_ids: [432, 426],
  },
  {
    genesis_token_id: 19071,
    wearable_ids: [377, 280],
  },
  {
    genesis_token_id: 19072,
    wearable_ids: [287, 326],
  },
  {
    genesis_token_id: 19073,
    wearable_ids: [301, 444],
  },
  {
    genesis_token_id: 19074,
    wearable_ids: [272, 411],
  },
  {
    genesis_token_id: 19075,
    wearable_ids: [385, 267],
  },
  {
    genesis_token_id: 19076,
    wearable_ids: [272, 273],
  },
  {
    genesis_token_id: 19077,
    wearable_ids: [277, 349],
  },
  {
    genesis_token_id: 19078,
    wearable_ids: [369, 385],
  },
  {
    genesis_token_id: 19079,
    wearable_ids: [429, 342],
  },
  {
    genesis_token_id: 19080,
    wearable_ids: [397, 428],
  },
  {
    genesis_token_id: 19081,
    wearable_ids: [433, 260],
  },
  {
    genesis_token_id: 19082,
    wearable_ids: [412, 434],
  },
  {
    genesis_token_id: 19083,
    wearable_ids: [341, 331],
  },
  {
    genesis_token_id: 19084,
    wearable_ids: [278, 373],
  },
  {
    genesis_token_id: 19085,
    wearable_ids: [265, 436],
  },
  {
    genesis_token_id: 19086,
    wearable_ids: [316, 370],
  },
  {
    genesis_token_id: 19087,
    wearable_ids: [315, 410],
  },
  {
    genesis_token_id: 19088,
    wearable_ids: [290, 306],
  },
  {
    genesis_token_id: 19089,
    wearable_ids: [316, 372],
  },
  {
    genesis_token_id: 19090,
    wearable_ids: [436, 315],
  },
  {
    genesis_token_id: 19091,
    wearable_ids: [343, 362],
  },
  {
    genesis_token_id: 19092,
    wearable_ids: [433, 335],
  },
  {
    genesis_token_id: 19093,
    wearable_ids: [374, 252],
  },
  {
    genesis_token_id: 19094,
    wearable_ids: [426, 331],
  },
  {
    genesis_token_id: 19095,
    wearable_ids: [310, 264],
  },
  {
    genesis_token_id: 19096,
    wearable_ids: [435, 308],
  },
  {
    genesis_token_id: 19097,
    wearable_ids: [409, 288],
  },
  {
    genesis_token_id: 19098,
    wearable_ids: [395, 316],
  },
  {
    genesis_token_id: 19099,
    wearable_ids: [310, 303],
  },
  {
    genesis_token_id: 19100,
    wearable_ids: [337, 368],
  },
  {
    genesis_token_id: 19101,
    wearable_ids: [377, 255],
  },
  {
    genesis_token_id: 19102,
    wearable_ids: [404, 259],
  },
  {
    genesis_token_id: 19103,
    wearable_ids: [262, 253],
  },
  {
    genesis_token_id: 19104,
    wearable_ids: [251, 436],
  },
  {
    genesis_token_id: 19105,
    wearable_ids: [347, 248],
  },
  {
    genesis_token_id: 19106,
    wearable_ids: [383, 430],
  },
  {
    genesis_token_id: 19107,
    wearable_ids: [403, 299],
  },
  {
    genesis_token_id: 19108,
    wearable_ids: [400, 410],
  },
  {
    genesis_token_id: 19109,
    wearable_ids: [266, 274],
  },
  {
    genesis_token_id: 19110,
    wearable_ids: [263, 388],
  },
  {
    genesis_token_id: 19111,
    wearable_ids: [435, 353],
  },
  {
    genesis_token_id: 19112,
    wearable_ids: [431, 342],
  },
  {
    genesis_token_id: 19113,
    wearable_ids: [247, 277],
  },
  {
    genesis_token_id: 19114,
    wearable_ids: [384, 263],
  },
  {
    genesis_token_id: 19115,
    wearable_ids: [378, 351],
  },
  {
    genesis_token_id: 19116,
    wearable_ids: [276, 389],
  },
  {
    genesis_token_id: 19117,
    wearable_ids: [415, 385],
  },
  {
    genesis_token_id: 19118,
    wearable_ids: [338, 409],
  },
  {
    genesis_token_id: 19119,
    wearable_ids: [445, 430],
  },
  {
    genesis_token_id: 19120,
    wearable_ids: [272, 335],
  },
  {
    genesis_token_id: 19121,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 19122,
    wearable_ids: [375, 344],
  },
  {
    genesis_token_id: 19123,
    wearable_ids: [284, 266],
  },
  {
    genesis_token_id: 19124,
    wearable_ids: [290, 400],
  },
  {
    genesis_token_id: 19125,
    wearable_ids: [368, 300],
  },
  {
    genesis_token_id: 19126,
    wearable_ids: [343, 269],
  },
  {
    genesis_token_id: 19127,
    wearable_ids: [315, 332],
  },
  {
    genesis_token_id: 19128,
    wearable_ids: [422, 268],
  },
  {
    genesis_token_id: 19129,
    wearable_ids: [343, 292],
  },
  {
    genesis_token_id: 19130,
    wearable_ids: [429, 368],
  },
  {
    genesis_token_id: 19131,
    wearable_ids: [369, 274],
  },
  {
    genesis_token_id: 19132,
    wearable_ids: [385, 376],
  },
  {
    genesis_token_id: 19133,
    wearable_ids: [265, 407],
  },
  {
    genesis_token_id: 19134,
    wearable_ids: [355, 311],
  },
  {
    genesis_token_id: 19135,
    wearable_ids: [342, 412],
  },
  {
    genesis_token_id: 19136,
    wearable_ids: [317, 444],
  },
  {
    genesis_token_id: 19137,
    wearable_ids: [373, 393],
  },
  {
    genesis_token_id: 19138,
    wearable_ids: [254, 292],
  },
  {
    genesis_token_id: 19139,
    wearable_ids: [385, 254],
  },
  {
    genesis_token_id: 19140,
    wearable_ids: [297, 290],
  },
  {
    genesis_token_id: 19141,
    wearable_ids: [325, 402],
  },
  {
    genesis_token_id: 19142,
    wearable_ids: [413, 292],
  },
  {
    genesis_token_id: 19143,
    wearable_ids: [400, 276],
  },
  {
    genesis_token_id: 19144,
    wearable_ids: [343, 340],
  },
  {
    genesis_token_id: 19145,
    wearable_ids: [377, 409],
  },
  {
    genesis_token_id: 19146,
    wearable_ids: [368, 420],
  },
  {
    genesis_token_id: 19147,
    wearable_ids: [350, 272],
  },
  {
    genesis_token_id: 19148,
    wearable_ids: [332, 260],
  },
  {
    genesis_token_id: 19149,
    wearable_ids: [274, 294],
  },
  {
    genesis_token_id: 19150,
    wearable_ids: [406, 262],
  },
  {
    genesis_token_id: 19151,
    wearable_ids: [278, 441],
  },
  {
    genesis_token_id: 19152,
    wearable_ids: [426, 354],
  },
  {
    genesis_token_id: 19153,
    wearable_ids: [377, 349],
  },
  {
    genesis_token_id: 19154,
    wearable_ids: [264, 382],
  },
  {
    genesis_token_id: 19155,
    wearable_ids: [445, 408],
  },
  {
    genesis_token_id: 19156,
    wearable_ids: [355, 351],
  },
  {
    genesis_token_id: 19157,
    wearable_ids: [423, 343],
  },
  {
    genesis_token_id: 19158,
    wearable_ids: [369, 294],
  },
  {
    genesis_token_id: 19159,
    wearable_ids: [378, 343],
  },
  {
    genesis_token_id: 19160,
    wearable_ids: [326, 325],
  },
  {
    genesis_token_id: 19161,
    wearable_ids: [350, 423],
  },
  {
    genesis_token_id: 19162,
    wearable_ids: [395, 339],
  },
  {
    genesis_token_id: 19163,
    wearable_ids: [428, 396],
  },
  {
    genesis_token_id: 19164,
    wearable_ids: [292, 365],
  },
  {
    genesis_token_id: 19165,
    wearable_ids: [365, 317],
  },
  {
    genesis_token_id: 19166,
    wearable_ids: [331, 435],
  },
  {
    genesis_token_id: 19167,
    wearable_ids: [429, 276],
  },
  {
    genesis_token_id: 19168,
    wearable_ids: [325, 397],
  },
  {
    genesis_token_id: 19169,
    wearable_ids: [294, 424],
  },
  {
    genesis_token_id: 19170,
    wearable_ids: [386, 366],
  },
  {
    genesis_token_id: 19171,
    wearable_ids: [443, 331],
  },
  {
    genesis_token_id: 19172,
    wearable_ids: [299, 388],
  },
  {
    genesis_token_id: 19173,
    wearable_ids: [304, 278],
  },
  {
    genesis_token_id: 19174,
    wearable_ids: [257, 337],
  },
  {
    genesis_token_id: 19175,
    wearable_ids: [363, 330],
  },
  {
    genesis_token_id: 19176,
    wearable_ids: [370, 374],
  },
  {
    genesis_token_id: 19177,
    wearable_ids: [314, 425],
  },
  {
    genesis_token_id: 19178,
    wearable_ids: [364, 373],
  },
  {
    genesis_token_id: 19179,
    wearable_ids: [337, 295],
  },
  {
    genesis_token_id: 19180,
    wearable_ids: [355, 335],
  },
  {
    genesis_token_id: 19181,
    wearable_ids: [370, 369],
  },
  {
    genesis_token_id: 19182,
    wearable_ids: [325, 377],
  },
  {
    genesis_token_id: 19183,
    wearable_ids: [371, 286],
  },
  {
    genesis_token_id: 19184,
    wearable_ids: [342, 347],
  },
  {
    genesis_token_id: 19185,
    wearable_ids: [346, 310],
  },
  {
    genesis_token_id: 19186,
    wearable_ids: [264, 364],
  },
  {
    genesis_token_id: 19187,
    wearable_ids: [262, 289],
  },
  {
    genesis_token_id: 19188,
    wearable_ids: [301, 433],
  },
  {
    genesis_token_id: 19189,
    wearable_ids: [365, 319],
  },
  {
    genesis_token_id: 19190,
    wearable_ids: [295, 332],
  },
  {
    genesis_token_id: 19191,
    wearable_ids: [395, 344],
  },
  {
    genesis_token_id: 19192,
    wearable_ids: [264, 434],
  },
  {
    genesis_token_id: 19193,
    wearable_ids: [255, 260],
  },
  {
    genesis_token_id: 19194,
    wearable_ids: [316, 436],
  },
  {
    genesis_token_id: 19195,
    wearable_ids: [365, 438],
  },
  {
    genesis_token_id: 19196,
    wearable_ids: [317, 350],
  },
  {
    genesis_token_id: 19197,
    wearable_ids: [413, 352],
  },
  {
    genesis_token_id: 19198,
    wearable_ids: [442, 247],
  },
  {
    genesis_token_id: 19199,
    wearable_ids: [403, 291],
  },
  {
    genesis_token_id: 19200,
    wearable_ids: [403, 291],
  },
  {
    genesis_token_id: 19201,
    wearable_ids: [272, 339],
  },
  {
    genesis_token_id: 19202,
    wearable_ids: [368, 306],
  },
  {
    genesis_token_id: 19203,
    wearable_ids: [248, 420],
  },
  {
    genesis_token_id: 19204,
    wearable_ids: [266, 307],
  },
  {
    genesis_token_id: 19205,
    wearable_ids: [396, 354],
  },
  {
    genesis_token_id: 19206,
    wearable_ids: [406, 352],
  },
  {
    genesis_token_id: 19207,
    wearable_ids: [326, 264],
  },
  {
    genesis_token_id: 19208,
    wearable_ids: [286, 406],
  },
  {
    genesis_token_id: 19209,
    wearable_ids: [272, 297],
  },
  {
    genesis_token_id: 19210,
    wearable_ids: [344, 306],
  },
  {
    genesis_token_id: 19211,
    wearable_ids: [291, 383],
  },
  {
    genesis_token_id: 19212,
    wearable_ids: [372, 259],
  },
  {
    genesis_token_id: 19213,
    wearable_ids: [262, 423],
  },
  {
    genesis_token_id: 19214,
    wearable_ids: [368, 397],
  },
  {
    genesis_token_id: 19215,
    wearable_ids: [363, 338],
  },
  {
    genesis_token_id: 19216,
    wearable_ids: [370, 301],
  },
  {
    genesis_token_id: 19217,
    wearable_ids: [372, 343],
  },
  {
    genesis_token_id: 19218,
    wearable_ids: [395, 253],
  },
  {
    genesis_token_id: 19219,
    wearable_ids: [299, 362],
  },
  {
    genesis_token_id: 19220,
    wearable_ids: [403, 260],
  },
  {
    genesis_token_id: 19221,
    wearable_ids: [324, 425],
  },
  {
    genesis_token_id: 19222,
    wearable_ids: [389, 258],
  },
  {
    genesis_token_id: 19223,
    wearable_ids: [311, 314],
  },
  {
    genesis_token_id: 19224,
    wearable_ids: [396, 435],
  },
  {
    genesis_token_id: 19225,
    wearable_ids: [348, 254],
  },
  {
    genesis_token_id: 19226,
    wearable_ids: [324, 443],
  },
  {
    genesis_token_id: 19227,
    wearable_ids: [335, 377],
  },
  {
    genesis_token_id: 19228,
    wearable_ids: [347, 290],
  },
  {
    genesis_token_id: 19229,
    wearable_ids: [294, 336],
  },
  {
    genesis_token_id: 19230,
    wearable_ids: [444, 371],
  },
  {
    genesis_token_id: 19231,
    wearable_ids: [294, 411],
  },
  {
    genesis_token_id: 19232,
    wearable_ids: [315, 423],
  },
  {
    genesis_token_id: 19233,
    wearable_ids: [433, 376],
  },
  {
    genesis_token_id: 19234,
    wearable_ids: [407, 270],
  },
  {
    genesis_token_id: 19235,
    wearable_ids: [299, 290],
  },
  {
    genesis_token_id: 19236,
    wearable_ids: [399, 246],
  },
  {
    genesis_token_id: 19237,
    wearable_ids: [386, 422],
  },
  {
    genesis_token_id: 19238,
    wearable_ids: [404, 410],
  },
  {
    genesis_token_id: 19239,
    wearable_ids: [431, 345],
  },
  {
    genesis_token_id: 19240,
    wearable_ids: [259, 286],
  },
  {
    genesis_token_id: 19241,
    wearable_ids: [299, 400],
  },
  {
    genesis_token_id: 19242,
    wearable_ids: [400, 415],
  },
  {
    genesis_token_id: 19243,
    wearable_ids: [253, 294],
  },
  {
    genesis_token_id: 19244,
    wearable_ids: [376, 338],
  },
  {
    genesis_token_id: 19245,
    wearable_ids: [365, 345],
  },
  {
    genesis_token_id: 19246,
    wearable_ids: [347, 384],
  },
  {
    genesis_token_id: 19247,
    wearable_ids: [373, 283],
  },
  {
    genesis_token_id: 19248,
    wearable_ids: [270, 436],
  },
  {
    genesis_token_id: 19249,
    wearable_ids: [409, 399],
  },
  {
    genesis_token_id: 19250,
    wearable_ids: [253, 265],
  },
  {
    genesis_token_id: 19251,
    wearable_ids: [294, 296],
  },
  {
    genesis_token_id: 19252,
    wearable_ids: [304, 384],
  },
  {
    genesis_token_id: 19253,
    wearable_ids: [291, 429],
  },
  {
    genesis_token_id: 19254,
    wearable_ids: [350, 255],
  },
  {
    genesis_token_id: 19255,
    wearable_ids: [300, 268],
  },
  {
    genesis_token_id: 19256,
    wearable_ids: [410, 428],
  },
  {
    genesis_token_id: 19257,
    wearable_ids: [341, 267],
  },
  {
    genesis_token_id: 19258,
    wearable_ids: [331, 348],
  },
  {
    genesis_token_id: 19259,
    wearable_ids: [314, 377],
  },
  {
    genesis_token_id: 19260,
    wearable_ids: [301, 316],
  },
  {
    genesis_token_id: 19261,
    wearable_ids: [297, 296],
  },
  {
    genesis_token_id: 19262,
    wearable_ids: [387, 335],
  },
  {
    genesis_token_id: 19263,
    wearable_ids: [404, 284],
  },
  {
    genesis_token_id: 19264,
    wearable_ids: [408, 293],
  },
  {
    genesis_token_id: 19265,
    wearable_ids: [316, 324],
  },
  {
    genesis_token_id: 19266,
    wearable_ids: [354, 263],
  },
  {
    genesis_token_id: 19267,
    wearable_ids: [326, 340],
  },
  {
    genesis_token_id: 19268,
    wearable_ids: [364, 316],
  },
  {
    genesis_token_id: 19269,
    wearable_ids: [259, 270],
  },
  {
    genesis_token_id: 19270,
    wearable_ids: [425, 420],
  },
  {
    genesis_token_id: 19271,
    wearable_ids: [350, 413],
  },
  {
    genesis_token_id: 19272,
    wearable_ids: [435, 397],
  },
  {
    genesis_token_id: 19273,
    wearable_ids: [324, 433],
  },
  {
    genesis_token_id: 19274,
    wearable_ids: [272, 284],
  },
  {
    genesis_token_id: 19275,
    wearable_ids: [385, 332],
  },
  {
    genesis_token_id: 19276,
    wearable_ids: [397, 347],
  },
  {
    genesis_token_id: 19277,
    wearable_ids: [404, 303],
  },
  {
    genesis_token_id: 19278,
    wearable_ids: [435, 277],
  },
  {
    genesis_token_id: 19279,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 19280,
    wearable_ids: [431, 328],
  },
  {
    genesis_token_id: 19281,
    wearable_ids: [362, 312],
  },
  {
    genesis_token_id: 19282,
    wearable_ids: [341, 328],
  },
  {
    genesis_token_id: 19283,
    wearable_ids: [343, 387],
  },
  {
    genesis_token_id: 19284,
    wearable_ids: [377, 362],
  },
  {
    genesis_token_id: 19285,
    wearable_ids: [311, 409],
  },
  {
    genesis_token_id: 19286,
    wearable_ids: [384, 365],
  },
  {
    genesis_token_id: 19287,
    wearable_ids: [339, 376],
  },
  {
    genesis_token_id: 19288,
    wearable_ids: [331, 403],
  },
  {
    genesis_token_id: 19289,
    wearable_ids: [289, 422],
  },
  {
    genesis_token_id: 19290,
    wearable_ids: [342, 271],
  },
  {
    genesis_token_id: 19291,
    wearable_ids: [277, 292],
  },
  {
    genesis_token_id: 19292,
    wearable_ids: [265, 307],
  },
  {
    genesis_token_id: 19293,
    wearable_ids: [262, 364],
  },
  {
    genesis_token_id: 19294,
    wearable_ids: [424, 428],
  },
  {
    genesis_token_id: 19295,
    wearable_ids: [404, 344],
  },
  {
    genesis_token_id: 19296,
    wearable_ids: [386, 289],
  },
  {
    genesis_token_id: 19297,
    wearable_ids: [296, 397],
  },
  {
    genesis_token_id: 19298,
    wearable_ids: [251, 369],
  },
  {
    genesis_token_id: 19299,
    wearable_ids: [413, 428],
  },
  {
    genesis_token_id: 19300,
    wearable_ids: [389, 272],
  },
  {
    genesis_token_id: 19301,
    wearable_ids: [432, 325],
  },
  {
    genesis_token_id: 19302,
    wearable_ids: [369, 325],
  },
  {
    genesis_token_id: 19303,
    wearable_ids: [259, 268],
  },
  {
    genesis_token_id: 19304,
    wearable_ids: [433, 259],
  },
  {
    genesis_token_id: 19305,
    wearable_ids: [364, 426],
  },
  {
    genesis_token_id: 19306,
    wearable_ids: [354, 335],
  },
  {
    genesis_token_id: 19307,
    wearable_ids: [297, 337],
  },
  {
    genesis_token_id: 19308,
    wearable_ids: [271, 436],
  },
  {
    genesis_token_id: 19309,
    wearable_ids: [368, 436],
  },
  {
    genesis_token_id: 19310,
    wearable_ids: [337, 268],
  },
  {
    genesis_token_id: 19311,
    wearable_ids: [315, 408],
  },
  {
    genesis_token_id: 19312,
    wearable_ids: [303, 300],
  },
  {
    genesis_token_id: 19313,
    wearable_ids: [303, 324],
  },
  {
    genesis_token_id: 19314,
    wearable_ids: [264, 311],
  },
  {
    genesis_token_id: 19315,
    wearable_ids: [338, 278],
  },
  {
    genesis_token_id: 19316,
    wearable_ids: [276, 342],
  },
  {
    genesis_token_id: 19317,
    wearable_ids: [311, 257],
  },
  {
    genesis_token_id: 19318,
    wearable_ids: [326, 432],
  },
  {
    genesis_token_id: 19319,
    wearable_ids: [420, 264],
  },
  {
    genesis_token_id: 19320,
    wearable_ids: [382, 394],
  },
  {
    genesis_token_id: 19321,
    wearable_ids: [303, 403],
  },
  {
    genesis_token_id: 19322,
    wearable_ids: [284, 293],
  },
  {
    genesis_token_id: 19323,
    wearable_ids: [433, 431],
  },
  {
    genesis_token_id: 19324,
    wearable_ids: [266, 443],
  },
  {
    genesis_token_id: 19325,
    wearable_ids: [387, 304],
  },
  {
    genesis_token_id: 19326,
    wearable_ids: [315, 387],
  },
  {
    genesis_token_id: 19327,
    wearable_ids: [377, 267],
  },
  {
    genesis_token_id: 19328,
    wearable_ids: [378, 395],
  },
  {
    genesis_token_id: 19329,
    wearable_ids: [303, 424],
  },
  {
    genesis_token_id: 19330,
    wearable_ids: [386, 401],
  },
  {
    genesis_token_id: 19331,
    wearable_ids: [362, 431],
  },
  {
    genesis_token_id: 19332,
    wearable_ids: [351, 350],
  },
  {
    genesis_token_id: 19333,
    wearable_ids: [411, 378],
  },
  {
    genesis_token_id: 19334,
    wearable_ids: [266, 432],
  },
  {
    genesis_token_id: 19335,
    wearable_ids: [424, 342],
  },
  {
    genesis_token_id: 19336,
    wearable_ids: [339, 409],
  },
  {
    genesis_token_id: 19337,
    wearable_ids: [257, 363],
  },
  {
    genesis_token_id: 19338,
    wearable_ids: [389, 272],
  },
  {
    genesis_token_id: 19339,
    wearable_ids: [444, 432],
  },
  {
    genesis_token_id: 19340,
    wearable_ids: [408, 346],
  },
  {
    genesis_token_id: 19341,
    wearable_ids: [422, 319],
  },
  {
    genesis_token_id: 19342,
    wearable_ids: [411, 325],
  },
  {
    genesis_token_id: 19343,
    wearable_ids: [254, 375],
  },
  {
    genesis_token_id: 19344,
    wearable_ids: [425, 265],
  },
  {
    genesis_token_id: 19345,
    wearable_ids: [289, 370],
  },
  {
    genesis_token_id: 19346,
    wearable_ids: [343, 290],
  },
  {
    genesis_token_id: 19347,
    wearable_ids: [384, 337],
  },
  {
    genesis_token_id: 19348,
    wearable_ids: [412, 265],
  },
  {
    genesis_token_id: 19349,
    wearable_ids: [256, 406],
  },
  {
    genesis_token_id: 19350,
    wearable_ids: [429, 288],
  },
  {
    genesis_token_id: 19351,
    wearable_ids: [423, 302],
  },
  {
    genesis_token_id: 19352,
    wearable_ids: [370, 260],
  },
  {
    genesis_token_id: 19353,
    wearable_ids: [442, 429],
  },
  {
    genesis_token_id: 19354,
    wearable_ids: [310, 324],
  },
  {
    genesis_token_id: 19355,
    wearable_ids: [324, 346],
  },
  {
    genesis_token_id: 19356,
    wearable_ids: [399, 376],
  },
  {
    genesis_token_id: 19357,
    wearable_ids: [316, 438],
  },
  {
    genesis_token_id: 19358,
    wearable_ids: [406, 382],
  },
  {
    genesis_token_id: 19359,
    wearable_ids: [429, 349],
  },
  {
    genesis_token_id: 19360,
    wearable_ids: [331, 268],
  },
  {
    genesis_token_id: 19361,
    wearable_ids: [248, 269],
  },
  {
    genesis_token_id: 19362,
    wearable_ids: [364, 341],
  },
  {
    genesis_token_id: 19363,
    wearable_ids: [251, 249],
  },
  {
    genesis_token_id: 19364,
    wearable_ids: [434, 253],
  },
  {
    genesis_token_id: 19365,
    wearable_ids: [350, 261],
  },
  {
    genesis_token_id: 19366,
    wearable_ids: [387, 372],
  },
  {
    genesis_token_id: 19367,
    wearable_ids: [420, 251],
  },
  {
    genesis_token_id: 19368,
    wearable_ids: [299, 372],
  },
  {
    genesis_token_id: 19369,
    wearable_ids: [422, 310],
  },
  {
    genesis_token_id: 19370,
    wearable_ids: [296, 432],
  },
  {
    genesis_token_id: 19371,
    wearable_ids: [413, 433],
  },
  {
    genesis_token_id: 19372,
    wearable_ids: [317, 315],
  },
  {
    genesis_token_id: 19373,
    wearable_ids: [411, 430],
  },
  {
    genesis_token_id: 19374,
    wearable_ids: [383, 435],
  },
  {
    genesis_token_id: 19375,
    wearable_ids: [437, 445],
  },
  {
    genesis_token_id: 19376,
    wearable_ids: [325, 362],
  },
  {
    genesis_token_id: 19377,
    wearable_ids: [300, 404],
  },
  {
    genesis_token_id: 19378,
    wearable_ids: [443, 357],
  },
  {
    genesis_token_id: 19379,
    wearable_ids: [341, 306],
  },
  {
    genesis_token_id: 19380,
    wearable_ids: [395, 387],
  },
  {
    genesis_token_id: 19381,
    wearable_ids: [410, 311],
  },
  {
    genesis_token_id: 19382,
    wearable_ids: [350, 264],
  },
  {
    genesis_token_id: 19383,
    wearable_ids: [384, 412],
  },
  {
    genesis_token_id: 19384,
    wearable_ids: [337, 284],
  },
  {
    genesis_token_id: 19385,
    wearable_ids: [271, 410],
  },
  {
    genesis_token_id: 19386,
    wearable_ids: [434, 343],
  },
  {
    genesis_token_id: 19387,
    wearable_ids: [409, 296],
  },
  {
    genesis_token_id: 19388,
    wearable_ids: [444, 259],
  },
  {
    genesis_token_id: 19389,
    wearable_ids: [369, 409],
  },
  {
    genesis_token_id: 19390,
    wearable_ids: [301, 335],
  },
  {
    genesis_token_id: 19391,
    wearable_ids: [444, 277],
  },
  {
    genesis_token_id: 19392,
    wearable_ids: [426, 325],
  },
  {
    genesis_token_id: 19393,
    wearable_ids: [429, 378],
  },
  {
    genesis_token_id: 19394,
    wearable_ids: [294, 352],
  },
  {
    genesis_token_id: 19395,
    wearable_ids: [304, 435],
  },
  {
    genesis_token_id: 19396,
    wearable_ids: [426, 412],
  },
  {
    genesis_token_id: 19397,
    wearable_ids: [335, 296],
  },
  {
    genesis_token_id: 19398,
    wearable_ids: [331, 251],
  },
  {
    genesis_token_id: 19399,
    wearable_ids: [350, 285],
  },
  {
    genesis_token_id: 19400,
    wearable_ids: [424, 443],
  },
  {
    genesis_token_id: 19401,
    wearable_ids: [389, 437],
  },
  {
    genesis_token_id: 19402,
    wearable_ids: [375, 350],
  },
  {
    genesis_token_id: 19403,
    wearable_ids: [369, 342],
  },
  {
    genesis_token_id: 19404,
    wearable_ids: [255, 278],
  },
  {
    genesis_token_id: 19405,
    wearable_ids: [326, 400],
  },
  {
    genesis_token_id: 19406,
    wearable_ids: [372, 248],
  },
  {
    genesis_token_id: 19407,
    wearable_ids: [387, 383],
  },
  {
    genesis_token_id: 19408,
    wearable_ids: [373, 383],
  },
  {
    genesis_token_id: 19409,
    wearable_ids: [278, 284],
  },
  {
    genesis_token_id: 19410,
    wearable_ids: [406, 384],
  },
  {
    genesis_token_id: 19411,
    wearable_ids: [247, 372],
  },
  {
    genesis_token_id: 19412,
    wearable_ids: [343, 353],
  },
  {
    genesis_token_id: 19413,
    wearable_ids: [413, 411],
  },
  {
    genesis_token_id: 19414,
    wearable_ids: [351, 248],
  },
  {
    genesis_token_id: 19415,
    wearable_ids: [432, 413],
  },
  {
    genesis_token_id: 19416,
    wearable_ids: [286, 437],
  },
  {
    genesis_token_id: 19417,
    wearable_ids: [254, 408],
  },
  {
    genesis_token_id: 19418,
    wearable_ids: [335, 379],
  },
  {
    genesis_token_id: 19419,
    wearable_ids: [445, 257],
  },
  {
    genesis_token_id: 19420,
    wearable_ids: [339, 332],
  },
  {
    genesis_token_id: 19421,
    wearable_ids: [343, 346],
  },
  {
    genesis_token_id: 19422,
    wearable_ids: [332, 361],
  },
  {
    genesis_token_id: 19423,
    wearable_ids: [271, 278],
  },
  {
    genesis_token_id: 19424,
    wearable_ids: [403, 326],
  },
  {
    genesis_token_id: 19425,
    wearable_ids: [326, 386],
  },
  {
    genesis_token_id: 19426,
    wearable_ids: [344, 409],
  },
  {
    genesis_token_id: 19427,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 19428,
    wearable_ids: [374, 319],
  },
  {
    genesis_token_id: 19429,
    wearable_ids: [435, 371],
  },
  {
    genesis_token_id: 19430,
    wearable_ids: [365, 317],
  },
  {
    genesis_token_id: 19431,
    wearable_ids: [280, 330],
  },
  {
    genesis_token_id: 19432,
    wearable_ids: [403, 426],
  },
  {
    genesis_token_id: 19433,
    wearable_ids: [395, 363],
  },
  {
    genesis_token_id: 19434,
    wearable_ids: [384, 332],
  },
  {
    genesis_token_id: 19435,
    wearable_ids: [395, 400],
  },
  {
    genesis_token_id: 19436,
    wearable_ids: [303, 247],
  },
  {
    genesis_token_id: 19437,
    wearable_ids: [406, 273],
  },
  {
    genesis_token_id: 19438,
    wearable_ids: [435, 301],
  },
  {
    genesis_token_id: 19439,
    wearable_ids: [395, 332],
  },
  {
    genesis_token_id: 19440,
    wearable_ids: [297, 276],
  },
  {
    genesis_token_id: 19441,
    wearable_ids: [265, 420],
  },
  {
    genesis_token_id: 19442,
    wearable_ids: [247, 325],
  },
  {
    genesis_token_id: 19443,
    wearable_ids: [444, 400],
  },
  {
    genesis_token_id: 19444,
    wearable_ids: [325, 376],
  },
  {
    genesis_token_id: 19445,
    wearable_ids: [268, 302],
  },
  {
    genesis_token_id: 19446,
    wearable_ids: [332, 327],
  },
  {
    genesis_token_id: 19447,
    wearable_ids: [375, 372],
  },
  {
    genesis_token_id: 19448,
    wearable_ids: [442, 410],
  },
  {
    genesis_token_id: 19449,
    wearable_ids: [384, 310],
  },
  {
    genesis_token_id: 19450,
    wearable_ids: [363, 388],
  },
  {
    genesis_token_id: 19451,
    wearable_ids: [411, 281],
  },
  {
    genesis_token_id: 19452,
    wearable_ids: [443, 405],
  },
  {
    genesis_token_id: 19453,
    wearable_ids: [278, 338],
  },
  {
    genesis_token_id: 19454,
    wearable_ids: [406, 274],
  },
  {
    genesis_token_id: 19455,
    wearable_ids: [268, 289],
  },
  {
    genesis_token_id: 19456,
    wearable_ids: [270, 374],
  },
  {
    genesis_token_id: 19457,
    wearable_ids: [350, 402],
  },
  {
    genesis_token_id: 19458,
    wearable_ids: [294, 399],
  },
  {
    genesis_token_id: 19459,
    wearable_ids: [378, 388],
  },
  {
    genesis_token_id: 19460,
    wearable_ids: [403, 396],
  },
  {
    genesis_token_id: 19461,
    wearable_ids: [296, 291],
  },
  {
    genesis_token_id: 19462,
    wearable_ids: [332, 360],
  },
  {
    genesis_token_id: 19463,
    wearable_ids: [251, 273],
  },
  {
    genesis_token_id: 19464,
    wearable_ids: [273, 332],
  },
  {
    genesis_token_id: 19465,
    wearable_ids: [400, 344],
  },
  {
    genesis_token_id: 19466,
    wearable_ids: [337, 412],
  },
  {
    genesis_token_id: 19467,
    wearable_ids: [292, 442],
  },
  {
    genesis_token_id: 19468,
    wearable_ids: [253, 352],
  },
  {
    genesis_token_id: 19469,
    wearable_ids: [311, 444],
  },
  {
    genesis_token_id: 19470,
    wearable_ids: [415, 277],
  },
  {
    genesis_token_id: 19471,
    wearable_ids: [280, 368],
  },
  {
    genesis_token_id: 19472,
    wearable_ids: [397, 369],
  },
  {
    genesis_token_id: 19473,
    wearable_ids: [362, 286],
  },
  {
    genesis_token_id: 19474,
    wearable_ids: [443, 338],
  },
  {
    genesis_token_id: 19475,
    wearable_ids: [274, 261],
  },
  {
    genesis_token_id: 19476,
    wearable_ids: [400, 251],
  },
  {
    genesis_token_id: 19477,
    wearable_ids: [433, 316],
  },
  {
    genesis_token_id: 19478,
    wearable_ids: [432, 271],
  },
  {
    genesis_token_id: 19479,
    wearable_ids: [301, 382],
  },
  {
    genesis_token_id: 19480,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 19481,
    wearable_ids: [255, 442],
  },
  {
    genesis_token_id: 19482,
    wearable_ids: [299, 350],
  },
  {
    genesis_token_id: 19483,
    wearable_ids: [273, 296],
  },
  {
    genesis_token_id: 19484,
    wearable_ids: [284, 246],
  },
  {
    genesis_token_id: 19485,
    wearable_ids: [373, 340],
  },
  {
    genesis_token_id: 19486,
    wearable_ids: [385, 387],
  },
  {
    genesis_token_id: 19487,
    wearable_ids: [376, 357],
  },
  {
    genesis_token_id: 19488,
    wearable_ids: [423, 286],
  },
  {
    genesis_token_id: 19489,
    wearable_ids: [420, 373],
  },
  {
    genesis_token_id: 19490,
    wearable_ids: [426, 247],
  },
  {
    genesis_token_id: 19491,
    wearable_ids: [319, 335],
  },
  {
    genesis_token_id: 19492,
    wearable_ids: [303, 251],
  },
  {
    genesis_token_id: 19493,
    wearable_ids: [348, 248],
  },
  {
    genesis_token_id: 19494,
    wearable_ids: [437, 349],
  },
  {
    genesis_token_id: 19495,
    wearable_ids: [374, 331],
  },
  {
    genesis_token_id: 19496,
    wearable_ids: [247, 387],
  },
  {
    genesis_token_id: 19497,
    wearable_ids: [436, 295],
  },
  {
    genesis_token_id: 19498,
    wearable_ids: [271, 286],
  },
  {
    genesis_token_id: 19499,
    wearable_ids: [274, 437],
  },
  {
    genesis_token_id: 19500,
    wearable_ids: [300, 338],
  },
  {
    genesis_token_id: 19501,
    wearable_ids: [257, 274],
  },
  {
    genesis_token_id: 19502,
    wearable_ids: [306, 277],
  },
  {
    genesis_token_id: 19503,
    wearable_ids: [311, 363],
  },
  {
    genesis_token_id: 19504,
    wearable_ids: [397, 351],
  },
  {
    genesis_token_id: 19505,
    wearable_ids: [315, 297],
  },
  {
    genesis_token_id: 19506,
    wearable_ids: [306, 354],
  },
  {
    genesis_token_id: 19507,
    wearable_ids: [300, 299],
  },
  {
    genesis_token_id: 19508,
    wearable_ids: [300, 445],
  },
  {
    genesis_token_id: 19509,
    wearable_ids: [413, 398],
  },
  {
    genesis_token_id: 19510,
    wearable_ids: [270, 379],
  },
  {
    genesis_token_id: 19511,
    wearable_ids: [299, 355],
  },
  {
    genesis_token_id: 19512,
    wearable_ids: [338, 445],
  },
  {
    genesis_token_id: 19513,
    wearable_ids: [325, 261],
  },
  {
    genesis_token_id: 19514,
    wearable_ids: [370, 431],
  },
  {
    genesis_token_id: 19515,
    wearable_ids: [365, 263],
  },
  {
    genesis_token_id: 19516,
    wearable_ids: [378, 338],
  },
  {
    genesis_token_id: 19517,
    wearable_ids: [276, 299],
  },
  {
    genesis_token_id: 19518,
    wearable_ids: [350, 334],
  },
  {
    genesis_token_id: 19519,
    wearable_ids: [428, 284],
  },
  {
    genesis_token_id: 19520,
    wearable_ids: [304, 433],
  },
  {
    genesis_token_id: 19521,
    wearable_ids: [341, 251],
  },
  {
    genesis_token_id: 19522,
    wearable_ids: [295, 344],
  },
  {
    genesis_token_id: 19523,
    wearable_ids: [362, 251],
  },
  {
    genesis_token_id: 19524,
    wearable_ids: [426, 271],
  },
  {
    genesis_token_id: 19525,
    wearable_ids: [264, 351],
  },
  {
    genesis_token_id: 19526,
    wearable_ids: [299, 333],
  },
  {
    genesis_token_id: 19527,
    wearable_ids: [263, 291],
  },
  {
    genesis_token_id: 19528,
    wearable_ids: [310, 424],
  },
  {
    genesis_token_id: 19529,
    wearable_ids: [443, 332],
  },
  {
    genesis_token_id: 19530,
    wearable_ids: [315, 291],
  },
  {
    genesis_token_id: 19531,
    wearable_ids: [409, 376],
  },
  {
    genesis_token_id: 19532,
    wearable_ids: [445, 358],
  },
  {
    genesis_token_id: 19533,
    wearable_ids: [387, 308],
  },
  {
    genesis_token_id: 19534,
    wearable_ids: [341, 247],
  },
  {
    genesis_token_id: 19535,
    wearable_ids: [300, 409],
  },
  {
    genesis_token_id: 19536,
    wearable_ids: [332, 343],
  },
  {
    genesis_token_id: 19537,
    wearable_ids: [434, 408],
  },
  {
    genesis_token_id: 19538,
    wearable_ids: [395, 376],
  },
  {
    genesis_token_id: 19539,
    wearable_ids: [425, 334],
  },
  {
    genesis_token_id: 19540,
    wearable_ids: [424, 339],
  },
  {
    genesis_token_id: 19541,
    wearable_ids: [276, 369],
  },
  {
    genesis_token_id: 19542,
    wearable_ids: [410, 264],
  },
  {
    genesis_token_id: 19543,
    wearable_ids: [317, 409],
  },
  {
    genesis_token_id: 19544,
    wearable_ids: [276, 325],
  },
  {
    genesis_token_id: 19545,
    wearable_ids: [406, 386],
  },
  {
    genesis_token_id: 19546,
    wearable_ids: [336, 278],
  },
  {
    genesis_token_id: 19547,
    wearable_ids: [422, 444],
  },
  {
    genesis_token_id: 19548,
    wearable_ids: [383, 257],
  },
  {
    genesis_token_id: 19549,
    wearable_ids: [314, 279],
  },
  {
    genesis_token_id: 19550,
    wearable_ids: [277, 343],
  },
  {
    genesis_token_id: 19551,
    wearable_ids: [310, 356],
  },
  {
    genesis_token_id: 19552,
    wearable_ids: [317, 379],
  },
  {
    genesis_token_id: 19553,
    wearable_ids: [377, 368],
  },
  {
    genesis_token_id: 19554,
    wearable_ids: [284, 300],
  },
  {
    genesis_token_id: 19555,
    wearable_ids: [420, 258],
  },
  {
    genesis_token_id: 19556,
    wearable_ids: [342, 385],
  },
  {
    genesis_token_id: 19557,
    wearable_ids: [386, 324],
  },
  {
    genesis_token_id: 19558,
    wearable_ids: [364, 343],
  },
  {
    genesis_token_id: 19559,
    wearable_ids: [444, 349],
  },
  {
    genesis_token_id: 19560,
    wearable_ids: [443, 357],
  },
  {
    genesis_token_id: 19561,
    wearable_ids: [325, 374],
  },
  {
    genesis_token_id: 19562,
    wearable_ids: [315, 281],
  },
  {
    genesis_token_id: 19563,
    wearable_ids: [378, 346],
  },
  {
    genesis_token_id: 19564,
    wearable_ids: [395, 317],
  },
  {
    genesis_token_id: 19565,
    wearable_ids: [253, 286],
  },
  {
    genesis_token_id: 19566,
    wearable_ids: [387, 363],
  },
  {
    genesis_token_id: 19567,
    wearable_ids: [443, 256],
  },
  {
    genesis_token_id: 19568,
    wearable_ids: [443, 276],
  },
  {
    genesis_token_id: 19569,
    wearable_ids: [315, 444],
  },
  {
    genesis_token_id: 19570,
    wearable_ids: [277, 303],
  },
  {
    genesis_token_id: 19571,
    wearable_ids: [314, 349],
  },
  {
    genesis_token_id: 19572,
    wearable_ids: [256, 432],
  },
  {
    genesis_token_id: 19573,
    wearable_ids: [314, 289],
  },
  {
    genesis_token_id: 19574,
    wearable_ids: [423, 315],
  },
  {
    genesis_token_id: 19575,
    wearable_ids: [338, 413],
  },
  {
    genesis_token_id: 19576,
    wearable_ids: [268, 403],
  },
  {
    genesis_token_id: 19577,
    wearable_ids: [337, 265],
  },
  {
    genesis_token_id: 19578,
    wearable_ids: [263, 426],
  },
  {
    genesis_token_id: 19579,
    wearable_ids: [368, 347],
  },
  {
    genesis_token_id: 19580,
    wearable_ids: [352, 387],
  },
  {
    genesis_token_id: 19581,
    wearable_ids: [371, 270],
  },
  {
    genesis_token_id: 19582,
    wearable_ids: [296, 387],
  },
  {
    genesis_token_id: 19583,
    wearable_ids: [273, 379],
  },
  {
    genesis_token_id: 19584,
    wearable_ids: [378, 280],
  },
  {
    genesis_token_id: 19585,
    wearable_ids: [445, 409],
  },
  {
    genesis_token_id: 19586,
    wearable_ids: [331, 437],
  },
  {
    genesis_token_id: 19587,
    wearable_ids: [262, 300],
  },
  {
    genesis_token_id: 19588,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 19589,
    wearable_ids: [355, 324],
  },
  {
    genesis_token_id: 19590,
    wearable_ids: [258, 420],
  },
  {
    genesis_token_id: 19591,
    wearable_ids: [277, 374],
  },
  {
    genesis_token_id: 19592,
    wearable_ids: [411, 420],
  },
  {
    genesis_token_id: 19593,
    wearable_ids: [289, 354],
  },
  {
    genesis_token_id: 19594,
    wearable_ids: [374, 307],
  },
  {
    genesis_token_id: 19595,
    wearable_ids: [365, 273],
  },
  {
    genesis_token_id: 19596,
    wearable_ids: [344, 317],
  },
  {
    genesis_token_id: 19597,
    wearable_ids: [284, 376],
  },
  {
    genesis_token_id: 19598,
    wearable_ids: [308, 335],
  },
  {
    genesis_token_id: 19599,
    wearable_ids: [338, 344],
  },
  {
    genesis_token_id: 19600,
    wearable_ids: [365, 257],
  },
  {
    genesis_token_id: 19601,
    wearable_ids: [272, 299],
  },
  {
    genesis_token_id: 19602,
    wearable_ids: [445, 313],
  },
  {
    genesis_token_id: 19603,
    wearable_ids: [251, 362],
  },
  {
    genesis_token_id: 19604,
    wearable_ids: [332, 295],
  },
  {
    genesis_token_id: 19605,
    wearable_ids: [263, 325],
  },
  {
    genesis_token_id: 19606,
    wearable_ids: [410, 433],
  },
  {
    genesis_token_id: 19607,
    wearable_ids: [251, 292],
  },
  {
    genesis_token_id: 19608,
    wearable_ids: [425, 422],
  },
  {
    genesis_token_id: 19609,
    wearable_ids: [347, 326],
  },
  {
    genesis_token_id: 19610,
    wearable_ids: [395, 356],
  },
  {
    genesis_token_id: 19611,
    wearable_ids: [326, 383],
  },
  {
    genesis_token_id: 19612,
    wearable_ids: [262, 410],
  },
  {
    genesis_token_id: 19613,
    wearable_ids: [368, 286],
  },
  {
    genesis_token_id: 19614,
    wearable_ids: [340, 248],
  },
  {
    genesis_token_id: 19615,
    wearable_ids: [395, 311],
  },
  {
    genesis_token_id: 19616,
    wearable_ids: [257, 392],
  },
  {
    genesis_token_id: 19617,
    wearable_ids: [372, 435],
  },
  {
    genesis_token_id: 19618,
    wearable_ids: [308, 342],
  },
  {
    genesis_token_id: 19619,
    wearable_ids: [445, 312],
  },
  {
    genesis_token_id: 19620,
    wearable_ids: [395, 433],
  },
  {
    genesis_token_id: 19621,
    wearable_ids: [363, 274],
  },
  {
    genesis_token_id: 19622,
    wearable_ids: [429, 310],
  },
  {
    genesis_token_id: 19623,
    wearable_ids: [266, 346],
  },
  {
    genesis_token_id: 19624,
    wearable_ids: [396, 268],
  },
  {
    genesis_token_id: 19625,
    wearable_ids: [331, 413],
  },
  {
    genesis_token_id: 19626,
    wearable_ids: [335, 402],
  },
  {
    genesis_token_id: 19627,
    wearable_ids: [290, 307],
  },
  {
    genesis_token_id: 19628,
    wearable_ids: [343, 428],
  },
  {
    genesis_token_id: 19629,
    wearable_ids: [342, 295],
  },
  {
    genesis_token_id: 19630,
    wearable_ids: [325, 315],
  },
  {
    genesis_token_id: 19631,
    wearable_ids: [335, 398],
  },
  {
    genesis_token_id: 19632,
    wearable_ids: [420, 277],
  },
  {
    genesis_token_id: 19633,
    wearable_ids: [257, 259],
  },
  {
    genesis_token_id: 19634,
    wearable_ids: [262, 273],
  },
  {
    genesis_token_id: 19635,
    wearable_ids: [346, 365],
  },
  {
    genesis_token_id: 19636,
    wearable_ids: [377, 319],
  },
  {
    genesis_token_id: 19637,
    wearable_ids: [324, 389],
  },
  {
    genesis_token_id: 19638,
    wearable_ids: [300, 264],
  },
  {
    genesis_token_id: 19639,
    wearable_ids: [364, 303],
  },
  {
    genesis_token_id: 19640,
    wearable_ids: [426, 432],
  },
  {
    genesis_token_id: 19641,
    wearable_ids: [424, 299],
  },
  {
    genesis_token_id: 19642,
    wearable_ids: [295, 270],
  },
  {
    genesis_token_id: 19643,
    wearable_ids: [311, 339],
  },
  {
    genesis_token_id: 19644,
    wearable_ids: [376, 408],
  },
  {
    genesis_token_id: 19645,
    wearable_ids: [396, 431],
  },
  {
    genesis_token_id: 19646,
    wearable_ids: [342, 302],
  },
  {
    genesis_token_id: 19647,
    wearable_ids: [375, 374],
  },
  {
    genesis_token_id: 19648,
    wearable_ids: [295, 434],
  },
  {
    genesis_token_id: 19649,
    wearable_ids: [346, 295],
  },
  {
    genesis_token_id: 19650,
    wearable_ids: [349, 377],
  },
  {
    genesis_token_id: 19651,
    wearable_ids: [387, 316],
  },
  {
    genesis_token_id: 19652,
    wearable_ids: [412, 306],
  },
  {
    genesis_token_id: 19653,
    wearable_ids: [316, 301],
  },
  {
    genesis_token_id: 19654,
    wearable_ids: [426, 324],
  },
  {
    genesis_token_id: 19655,
    wearable_ids: [382, 323],
  },
  {
    genesis_token_id: 19656,
    wearable_ids: [383, 422],
  },
  {
    genesis_token_id: 19657,
    wearable_ids: [255, 310],
  },
  {
    genesis_token_id: 19658,
    wearable_ids: [319, 437],
  },
  {
    genesis_token_id: 19659,
    wearable_ids: [412, 258],
  },
  {
    genesis_token_id: 19660,
    wearable_ids: [433, 318],
  },
  {
    genesis_token_id: 19661,
    wearable_ids: [368, 409],
  },
  {
    genesis_token_id: 19662,
    wearable_ids: [352, 269],
  },
  {
    genesis_token_id: 19663,
    wearable_ids: [413, 407],
  },
  {
    genesis_token_id: 19664,
    wearable_ids: [270, 349],
  },
  {
    genesis_token_id: 19665,
    wearable_ids: [270, 382],
  },
  {
    genesis_token_id: 19666,
    wearable_ids: [433, 365],
  },
  {
    genesis_token_id: 19667,
    wearable_ids: [291, 366],
  },
  {
    genesis_token_id: 19668,
    wearable_ids: [247, 335],
  },
  {
    genesis_token_id: 19669,
    wearable_ids: [268, 378],
  },
  {
    genesis_token_id: 19670,
    wearable_ids: [308, 258],
  },
  {
    genesis_token_id: 19671,
    wearable_ids: [335, 291],
  },
  {
    genesis_token_id: 19672,
    wearable_ids: [406, 290],
  },
  {
    genesis_token_id: 19673,
    wearable_ids: [437, 394],
  },
  {
    genesis_token_id: 19674,
    wearable_ids: [386, 398],
  },
  {
    genesis_token_id: 19675,
    wearable_ids: [280, 247],
  },
  {
    genesis_token_id: 19676,
    wearable_ids: [408, 412],
  },
  {
    genesis_token_id: 19677,
    wearable_ids: [406, 431],
  },
  {
    genesis_token_id: 19678,
    wearable_ids: [396, 348],
  },
  {
    genesis_token_id: 19679,
    wearable_ids: [317, 362],
  },
  {
    genesis_token_id: 19680,
    wearable_ids: [262, 324],
  },
  {
    genesis_token_id: 19681,
    wearable_ids: [442, 441],
  },
  {
    genesis_token_id: 19682,
    wearable_ids: [389, 307],
  },
  {
    genesis_token_id: 19683,
    wearable_ids: [395, 249],
  },
  {
    genesis_token_id: 19684,
    wearable_ids: [326, 290],
  },
  {
    genesis_token_id: 19685,
    wearable_ids: [429, 324],
  },
  {
    genesis_token_id: 19686,
    wearable_ids: [248, 301],
  },
  {
    genesis_token_id: 19687,
    wearable_ids: [325, 316],
  },
  {
    genesis_token_id: 19688,
    wearable_ids: [365, 346],
  },
  {
    genesis_token_id: 19689,
    wearable_ids: [287, 408],
  },
  {
    genesis_token_id: 19690,
    wearable_ids: [443, 411],
  },
  {
    genesis_token_id: 19691,
    wearable_ids: [423, 407],
  },
  {
    genesis_token_id: 19692,
    wearable_ids: [332, 297],
  },
  {
    genesis_token_id: 19693,
    wearable_ids: [247, 426],
  },
  {
    genesis_token_id: 19694,
    wearable_ids: [331, 328],
  },
  {
    genesis_token_id: 19695,
    wearable_ids: [376, 270],
  },
  {
    genesis_token_id: 19696,
    wearable_ids: [408, 422],
  },
  {
    genesis_token_id: 19697,
    wearable_ids: [304, 378],
  },
  {
    genesis_token_id: 19698,
    wearable_ids: [352, 281],
  },
  {
    genesis_token_id: 19699,
    wearable_ids: [342, 271],
  },
  {
    genesis_token_id: 19700,
    wearable_ids: [306, 264],
  },
  {
    genesis_token_id: 19701,
    wearable_ids: [431, 316],
  },
  {
    genesis_token_id: 19702,
    wearable_ids: [354, 345],
  },
  {
    genesis_token_id: 19703,
    wearable_ids: [371, 344],
  },
  {
    genesis_token_id: 19704,
    wearable_ids: [413, 291],
  },
  {
    genesis_token_id: 19705,
    wearable_ids: [247, 436],
  },
  {
    genesis_token_id: 19706,
    wearable_ids: [296, 279],
  },
  {
    genesis_token_id: 19707,
    wearable_ids: [377, 404],
  },
  {
    genesis_token_id: 19708,
    wearable_ids: [295, 379],
  },
  {
    genesis_token_id: 19709,
    wearable_ids: [363, 436],
  },
  {
    genesis_token_id: 19710,
    wearable_ids: [364, 304],
  },
  {
    genesis_token_id: 19711,
    wearable_ids: [286, 437],
  },
  {
    genesis_token_id: 19712,
    wearable_ids: [340, 258],
  },
  {
    genesis_token_id: 19713,
    wearable_ids: [383, 419],
  },
  {
    genesis_token_id: 19714,
    wearable_ids: [365, 375],
  },
  {
    genesis_token_id: 19715,
    wearable_ids: [424, 376],
  },
  {
    genesis_token_id: 19716,
    wearable_ids: [271, 361],
  },
  {
    genesis_token_id: 19717,
    wearable_ids: [277, 395],
  },
  {
    genesis_token_id: 19718,
    wearable_ids: [277, 354],
  },
  {
    genesis_token_id: 19719,
    wearable_ids: [248, 400],
  },
  {
    genesis_token_id: 19720,
    wearable_ids: [259, 292],
  },
  {
    genesis_token_id: 19721,
    wearable_ids: [291, 437],
  },
  {
    genesis_token_id: 19722,
    wearable_ids: [372, 349],
  },
  {
    genesis_token_id: 19723,
    wearable_ids: [300, 340],
  },
  {
    genesis_token_id: 19724,
    wearable_ids: [291, 320],
  },
  {
    genesis_token_id: 19725,
    wearable_ids: [254, 391],
  },
  {
    genesis_token_id: 19726,
    wearable_ids: [289, 348],
  },
  {
    genesis_token_id: 19727,
    wearable_ids: [383, 304],
  },
  {
    genesis_token_id: 19728,
    wearable_ids: [303, 271],
  },
  {
    genesis_token_id: 19729,
    wearable_ids: [386, 443],
  },
  {
    genesis_token_id: 19730,
    wearable_ids: [272, 375],
  },
  {
    genesis_token_id: 19731,
    wearable_ids: [371, 427],
  },
  {
    genesis_token_id: 19732,
    wearable_ids: [247, 302],
  },
  {
    genesis_token_id: 19733,
    wearable_ids: [387, 278],
  },
  {
    genesis_token_id: 19734,
    wearable_ids: [384, 386],
  },
  {
    genesis_token_id: 19735,
    wearable_ids: [319, 442],
  },
  {
    genesis_token_id: 19736,
    wearable_ids: [332, 423],
  },
  {
    genesis_token_id: 19737,
    wearable_ids: [386, 284],
  },
  {
    genesis_token_id: 19738,
    wearable_ids: [268, 429],
  },
  {
    genesis_token_id: 19739,
    wearable_ids: [363, 403],
  },
  {
    genesis_token_id: 19740,
    wearable_ids: [376, 299],
  },
  {
    genesis_token_id: 19741,
    wearable_ids: [377, 386],
  },
  {
    genesis_token_id: 19742,
    wearable_ids: [426, 370],
  },
  {
    genesis_token_id: 19743,
    wearable_ids: [280, 264],
  },
  {
    genesis_token_id: 19744,
    wearable_ids: [295, 263],
  },
  {
    genesis_token_id: 19745,
    wearable_ids: [346, 291],
  },
  {
    genesis_token_id: 19746,
    wearable_ids: [437, 284],
  },
  {
    genesis_token_id: 19747,
    wearable_ids: [306, 371],
  },
  {
    genesis_token_id: 19748,
    wearable_ids: [265, 431],
  },
  {
    genesis_token_id: 19749,
    wearable_ids: [262, 368],
  },
  {
    genesis_token_id: 19750,
    wearable_ids: [442, 297],
  },
  {
    genesis_token_id: 19751,
    wearable_ids: [332, 278],
  },
  {
    genesis_token_id: 19752,
    wearable_ids: [271, 267],
  },
  {
    genesis_token_id: 19753,
    wearable_ids: [396, 268],
  },
  {
    genesis_token_id: 19754,
    wearable_ids: [374, 295],
  },
  {
    genesis_token_id: 19755,
    wearable_ids: [347, 315],
  },
  {
    genesis_token_id: 19756,
    wearable_ids: [340, 299],
  },
  {
    genesis_token_id: 19757,
    wearable_ids: [265, 297],
  },
  {
    genesis_token_id: 19758,
    wearable_ids: [399, 378],
  },
  {
    genesis_token_id: 19759,
    wearable_ids: [331, 433],
  },
  {
    genesis_token_id: 19760,
    wearable_ids: [354, 397],
  },
  {
    genesis_token_id: 19761,
    wearable_ids: [338, 257],
  },
  {
    genesis_token_id: 19762,
    wearable_ids: [426, 276],
  },
  {
    genesis_token_id: 19763,
    wearable_ids: [300, 261],
  },
  {
    genesis_token_id: 19764,
    wearable_ids: [382, 310],
  },
  {
    genesis_token_id: 19765,
    wearable_ids: [424, 384],
  },
  {
    genesis_token_id: 19766,
    wearable_ids: [300, 385],
  },
  {
    genesis_token_id: 19767,
    wearable_ids: [429, 293],
  },
  {
    genesis_token_id: 19768,
    wearable_ids: [287, 412],
  },
  {
    genesis_token_id: 19769,
    wearable_ids: [350, 289],
  },
  {
    genesis_token_id: 19770,
    wearable_ids: [315, 399],
  },
  {
    genesis_token_id: 19771,
    wearable_ids: [375, 328],
  },
  {
    genesis_token_id: 19772,
    wearable_ids: [324, 435],
  },
  {
    genesis_token_id: 19773,
    wearable_ids: [289, 358],
  },
  {
    genesis_token_id: 19774,
    wearable_ids: [276, 420],
  },
  {
    genesis_token_id: 19775,
    wearable_ids: [350, 370],
  },
  {
    genesis_token_id: 19776,
    wearable_ids: [268, 397],
  },
  {
    genesis_token_id: 19777,
    wearable_ids: [375, 428],
  },
  {
    genesis_token_id: 19778,
    wearable_ids: [301, 254],
  },
  {
    genesis_token_id: 19779,
    wearable_ids: [297, 377],
  },
  {
    genesis_token_id: 19780,
    wearable_ids: [270, 361],
  },
  {
    genesis_token_id: 19781,
    wearable_ids: [411, 408],
  },
  {
    genesis_token_id: 19782,
    wearable_ids: [420, 382],
  },
  {
    genesis_token_id: 19783,
    wearable_ids: [424, 410],
  },
  {
    genesis_token_id: 19784,
    wearable_ids: [397, 277],
  },
  {
    genesis_token_id: 19785,
    wearable_ids: [289, 342],
  },
  {
    genesis_token_id: 19786,
    wearable_ids: [377, 250],
  },
  {
    genesis_token_id: 19787,
    wearable_ids: [273, 402],
  },
  {
    genesis_token_id: 19788,
    wearable_ids: [389, 413],
  },
  {
    genesis_token_id: 19789,
    wearable_ids: [387, 258],
  },
  {
    genesis_token_id: 19790,
    wearable_ids: [436, 251],
  },
  {
    genesis_token_id: 19791,
    wearable_ids: [346, 430],
  },
  {
    genesis_token_id: 19792,
    wearable_ids: [259, 311],
  },
  {
    genesis_token_id: 19793,
    wearable_ids: [292, 301],
  },
  {
    genesis_token_id: 19794,
    wearable_ids: [370, 385],
  },
  {
    genesis_token_id: 19795,
    wearable_ids: [263, 445],
  },
  {
    genesis_token_id: 19796,
    wearable_ids: [355, 356],
  },
  {
    genesis_token_id: 19797,
    wearable_ids: [343, 327],
  },
  {
    genesis_token_id: 19798,
    wearable_ids: [310, 412],
  },
  {
    genesis_token_id: 19799,
    wearable_ids: [314, 317],
  },
  {
    genesis_token_id: 19800,
    wearable_ids: [372, 258],
  },
  {
    genesis_token_id: 19801,
    wearable_ids: [384, 369],
  },
  {
    genesis_token_id: 19802,
    wearable_ids: [348, 362],
  },
  {
    genesis_token_id: 19803,
    wearable_ids: [291, 372],
  },
  {
    genesis_token_id: 19804,
    wearable_ids: [300, 264],
  },
  {
    genesis_token_id: 19805,
    wearable_ids: [415, 407],
  },
  {
    genesis_token_id: 19806,
    wearable_ids: [286, 434],
  },
  {
    genesis_token_id: 19807,
    wearable_ids: [348, 307],
  },
  {
    genesis_token_id: 19808,
    wearable_ids: [433, 271],
  },
  {
    genesis_token_id: 19809,
    wearable_ids: [415, 420],
  },
  {
    genesis_token_id: 19810,
    wearable_ids: [284, 286],
  },
  {
    genesis_token_id: 19811,
    wearable_ids: [294, 376],
  },
  {
    genesis_token_id: 19812,
    wearable_ids: [270, 444],
  },
  {
    genesis_token_id: 19813,
    wearable_ids: [369, 262],
  },
  {
    genesis_token_id: 19814,
    wearable_ids: [292, 330],
  },
  {
    genesis_token_id: 19815,
    wearable_ids: [348, 427],
  },
  {
    genesis_token_id: 19816,
    wearable_ids: [342, 433],
  },
  {
    genesis_token_id: 19817,
    wearable_ids: [324, 272],
  },
  {
    genesis_token_id: 19818,
    wearable_ids: [303, 379],
  },
  {
    genesis_token_id: 19819,
    wearable_ids: [256, 269],
  },
  {
    genesis_token_id: 19820,
    wearable_ids: [308, 375],
  },
  {
    genesis_token_id: 19821,
    wearable_ids: [354, 335],
  },
  {
    genesis_token_id: 19822,
    wearable_ids: [286, 344],
  },
  {
    genesis_token_id: 19823,
    wearable_ids: [354, 374],
  },
  {
    genesis_token_id: 19824,
    wearable_ids: [365, 253],
  },
  {
    genesis_token_id: 19825,
    wearable_ids: [428, 371],
  },
  {
    genesis_token_id: 19826,
    wearable_ids: [445, 444],
  },
  {
    genesis_token_id: 19827,
    wearable_ids: [369, 303],
  },
  {
    genesis_token_id: 19828,
    wearable_ids: [337, 343],
  },
  {
    genesis_token_id: 19829,
    wearable_ids: [326, 406],
  },
  {
    genesis_token_id: 19830,
    wearable_ids: [339, 314],
  },
  {
    genesis_token_id: 19831,
    wearable_ids: [301, 325],
  },
  {
    genesis_token_id: 19832,
    wearable_ids: [399, 428],
  },
  {
    genesis_token_id: 19833,
    wearable_ids: [443, 248],
  },
  {
    genesis_token_id: 19834,
    wearable_ids: [370, 407],
  },
  {
    genesis_token_id: 19835,
    wearable_ids: [297, 319],
  },
  {
    genesis_token_id: 19836,
    wearable_ids: [262, 342],
  },
  {
    genesis_token_id: 19837,
    wearable_ids: [442, 348],
  },
  {
    genesis_token_id: 19838,
    wearable_ids: [399, 297],
  },
  {
    genesis_token_id: 19839,
    wearable_ids: [352, 417],
  },
  {
    genesis_token_id: 19840,
    wearable_ids: [377, 258],
  },
  {
    genesis_token_id: 19841,
    wearable_ids: [415, 368],
  },
  {
    genesis_token_id: 19842,
    wearable_ids: [365, 278],
  },
  {
    genesis_token_id: 19843,
    wearable_ids: [284, 435],
  },
  {
    genesis_token_id: 19844,
    wearable_ids: [292, 442],
  },
  {
    genesis_token_id: 19845,
    wearable_ids: [397, 334],
  },
  {
    genesis_token_id: 19846,
    wearable_ids: [386, 344],
  },
  {
    genesis_token_id: 19847,
    wearable_ids: [314, 358],
  },
  {
    genesis_token_id: 19848,
    wearable_ids: [429, 326],
  },
  {
    genesis_token_id: 19849,
    wearable_ids: [248, 414],
  },
  {
    genesis_token_id: 19850,
    wearable_ids: [344, 347],
  },
  {
    genesis_token_id: 19851,
    wearable_ids: [395, 284],
  },
  {
    genesis_token_id: 19852,
    wearable_ids: [385, 399],
  },
  {
    genesis_token_id: 19853,
    wearable_ids: [377, 308],
  },
  {
    genesis_token_id: 19854,
    wearable_ids: [335, 359],
  },
  {
    genesis_token_id: 19855,
    wearable_ids: [339, 426],
  },
  {
    genesis_token_id: 19856,
    wearable_ids: [319, 383],
  },
  {
    genesis_token_id: 19857,
    wearable_ids: [308, 371],
  },
  {
    genesis_token_id: 19858,
    wearable_ids: [400, 410],
  },
  {
    genesis_token_id: 19859,
    wearable_ids: [415, 343],
  },
  {
    genesis_token_id: 19860,
    wearable_ids: [429, 299],
  },
  {
    genesis_token_id: 19861,
    wearable_ids: [437, 418],
  },
  {
    genesis_token_id: 19862,
    wearable_ids: [271, 311],
  },
  {
    genesis_token_id: 19863,
    wearable_ids: [389, 328],
  },
  {
    genesis_token_id: 19864,
    wearable_ids: [355, 297],
  },
  {
    genesis_token_id: 19865,
    wearable_ids: [292, 441],
  },
  {
    genesis_token_id: 19866,
    wearable_ids: [259, 362],
  },
  {
    genesis_token_id: 19867,
    wearable_ids: [342, 416],
  },
  {
    genesis_token_id: 19868,
    wearable_ids: [331, 311],
  },
  {
    genesis_token_id: 19869,
    wearable_ids: [432, 376],
  },
  {
    genesis_token_id: 19870,
    wearable_ids: [299, 254],
  },
  {
    genesis_token_id: 19871,
    wearable_ids: [436, 351],
  },
  {
    genesis_token_id: 19872,
    wearable_ids: [436, 434],
  },
  {
    genesis_token_id: 19873,
    wearable_ids: [336, 265],
  },
  {
    genesis_token_id: 19874,
    wearable_ids: [316, 410],
  },
  {
    genesis_token_id: 19875,
    wearable_ids: [299, 348],
  },
  {
    genesis_token_id: 19876,
    wearable_ids: [397, 417],
  },
  {
    genesis_token_id: 19877,
    wearable_ids: [268, 337],
  },
  {
    genesis_token_id: 19878,
    wearable_ids: [340, 287],
  },
  {
    genesis_token_id: 19879,
    wearable_ids: [433, 341],
  },
  {
    genesis_token_id: 19880,
    wearable_ids: [258, 341],
  },
  {
    genesis_token_id: 19881,
    wearable_ids: [287, 433],
  },
  {
    genesis_token_id: 19882,
    wearable_ids: [445, 404],
  },
  {
    genesis_token_id: 19883,
    wearable_ids: [248, 294],
  },
  {
    genesis_token_id: 19884,
    wearable_ids: [397, 304],
  },
  {
    genesis_token_id: 19885,
    wearable_ids: [336, 433],
  },
  {
    genesis_token_id: 19886,
    wearable_ids: [337, 280],
  },
  {
    genesis_token_id: 19887,
    wearable_ids: [351, 319],
  },
  {
    genesis_token_id: 19888,
    wearable_ids: [409, 256],
  },
  {
    genesis_token_id: 19889,
    wearable_ids: [408, 303],
  },
  {
    genesis_token_id: 19890,
    wearable_ids: [352, 437],
  },
  {
    genesis_token_id: 19891,
    wearable_ids: [432, 403],
  },
  {
    genesis_token_id: 19892,
    wearable_ids: [280, 350],
  },
  {
    genesis_token_id: 19893,
    wearable_ids: [265, 302],
  },
  {
    genesis_token_id: 19894,
    wearable_ids: [397, 354],
  },
  {
    genesis_token_id: 19895,
    wearable_ids: [404, 363],
  },
  {
    genesis_token_id: 19896,
    wearable_ids: [413, 382],
  },
  {
    genesis_token_id: 19897,
    wearable_ids: [436, 376],
  },
  {
    genesis_token_id: 19898,
    wearable_ids: [303, 365],
  },
  {
    genesis_token_id: 19899,
    wearable_ids: [332, 396],
  },
  {
    genesis_token_id: 19900,
    wearable_ids: [325, 369],
  },
  {
    genesis_token_id: 19901,
    wearable_ids: [340, 397],
  },
  {
    genesis_token_id: 19902,
    wearable_ids: [336, 261],
  },
  {
    genesis_token_id: 19903,
    wearable_ids: [442, 289],
  },
  {
    genesis_token_id: 19904,
    wearable_ids: [342, 287],
  },
  {
    genesis_token_id: 19905,
    wearable_ids: [344, 361],
  },
  {
    genesis_token_id: 19906,
    wearable_ids: [336, 364],
  },
  {
    genesis_token_id: 19907,
    wearable_ids: [336, 409],
  },
  {
    genesis_token_id: 19908,
    wearable_ids: [437, 280],
  },
  {
    genesis_token_id: 19909,
    wearable_ids: [403, 303],
  },
  {
    genesis_token_id: 19910,
    wearable_ids: [316, 415],
  },
  {
    genesis_token_id: 19911,
    wearable_ids: [286, 442],
  },
  {
    genesis_token_id: 19912,
    wearable_ids: [382, 310],
  },
  {
    genesis_token_id: 19913,
    wearable_ids: [422, 387],
  },
  {
    genesis_token_id: 19914,
    wearable_ids: [276, 330],
  },
  {
    genesis_token_id: 19915,
    wearable_ids: [354, 286],
  },
  {
    genesis_token_id: 19916,
    wearable_ids: [266, 422],
  },
  {
    genesis_token_id: 19917,
    wearable_ids: [273, 429],
  },
  {
    genesis_token_id: 19918,
    wearable_ids: [400, 378],
  },
  {
    genesis_token_id: 19919,
    wearable_ids: [400, 349],
  },
  {
    genesis_token_id: 19920,
    wearable_ids: [443, 378],
  },
  {
    genesis_token_id: 19921,
    wearable_ids: [362, 376],
  },
  {
    genesis_token_id: 19922,
    wearable_ids: [370, 403],
  },
  {
    genesis_token_id: 19923,
    wearable_ids: [386, 352],
  },
  {
    genesis_token_id: 19924,
    wearable_ids: [431, 268],
  },
  {
    genesis_token_id: 19925,
    wearable_ids: [411, 310],
  },
  {
    genesis_token_id: 19926,
    wearable_ids: [423, 365],
  },
  {
    genesis_token_id: 19927,
    wearable_ids: [431, 255],
  },
  {
    genesis_token_id: 19928,
    wearable_ids: [248, 328],
  },
  {
    genesis_token_id: 19929,
    wearable_ids: [428, 318],
  },
  {
    genesis_token_id: 19930,
    wearable_ids: [290, 342],
  },
  {
    genesis_token_id: 19931,
    wearable_ids: [407, 296],
  },
  {
    genesis_token_id: 19932,
    wearable_ids: [319, 253],
  },
  {
    genesis_token_id: 19933,
    wearable_ids: [292, 368],
  },
  {
    genesis_token_id: 19934,
    wearable_ids: [337, 369],
  },
  {
    genesis_token_id: 19935,
    wearable_ids: [407, 289],
  },
  {
    genesis_token_id: 19936,
    wearable_ids: [297, 403],
  },
  {
    genesis_token_id: 19937,
    wearable_ids: [280, 272],
  },
  {
    genesis_token_id: 19938,
    wearable_ids: [326, 352],
  },
  {
    genesis_token_id: 19939,
    wearable_ids: [351, 294],
  },
  {
    genesis_token_id: 19940,
    wearable_ids: [308, 413],
  },
  {
    genesis_token_id: 19941,
    wearable_ids: [337, 395],
  },
  {
    genesis_token_id: 19942,
    wearable_ids: [434, 271],
  },
  {
    genesis_token_id: 19943,
    wearable_ids: [375, 431],
  },
  {
    genesis_token_id: 19944,
    wearable_ids: [432, 378],
  },
  {
    genesis_token_id: 19945,
    wearable_ids: [395, 368],
  },
  {
    genesis_token_id: 19946,
    wearable_ids: [343, 445],
  },
  {
    genesis_token_id: 19947,
    wearable_ids: [316, 351],
  },
  {
    genesis_token_id: 19948,
    wearable_ids: [335, 425],
  },
  {
    genesis_token_id: 19949,
    wearable_ids: [296, 269],
  },
  {
    genesis_token_id: 19950,
    wearable_ids: [423, 305],
  },
  {
    genesis_token_id: 19951,
    wearable_ids: [332, 311],
  },
  {
    genesis_token_id: 19952,
    wearable_ids: [376, 331],
  },
  {
    genesis_token_id: 19953,
    wearable_ids: [342, 436],
  },
  {
    genesis_token_id: 19954,
    wearable_ids: [294, 445],
  },
  {
    genesis_token_id: 19955,
    wearable_ids: [346, 317],
  },
  {
    genesis_token_id: 19956,
    wearable_ids: [415, 412],
  },
  {
    genesis_token_id: 19957,
    wearable_ids: [370, 331],
  },
  {
    genesis_token_id: 19958,
    wearable_ids: [335, 277],
  },
  {
    genesis_token_id: 19959,
    wearable_ids: [286, 313],
  },
  {
    genesis_token_id: 19960,
    wearable_ids: [407, 303],
  },
  {
    genesis_token_id: 19961,
    wearable_ids: [289, 273],
  },
  {
    genesis_token_id: 19962,
    wearable_ids: [434, 364],
  },
  {
    genesis_token_id: 19963,
    wearable_ids: [399, 254],
  },
  {
    genesis_token_id: 19964,
    wearable_ids: [385, 287],
  },
  {
    genesis_token_id: 19965,
    wearable_ids: [420, 306],
  },
  {
    genesis_token_id: 19966,
    wearable_ids: [326, 276],
  },
  {
    genesis_token_id: 19967,
    wearable_ids: [274, 316],
  },
  {
    genesis_token_id: 19968,
    wearable_ids: [386, 284],
  },
  {
    genesis_token_id: 19969,
    wearable_ids: [384, 427],
  },
  {
    genesis_token_id: 19970,
    wearable_ids: [262, 259],
  },
  {
    genesis_token_id: 19971,
    wearable_ids: [369, 370],
  },
  {
    genesis_token_id: 19972,
    wearable_ids: [371, 264],
  },
  {
    genesis_token_id: 19973,
    wearable_ids: [374, 306],
  },
  {
    genesis_token_id: 19974,
    wearable_ids: [266, 247],
  },
  {
    genesis_token_id: 19975,
    wearable_ids: [290, 423],
  },
  {
    genesis_token_id: 19976,
    wearable_ids: [257, 366],
  },
  {
    genesis_token_id: 19977,
    wearable_ids: [423, 398],
  },
  {
    genesis_token_id: 19978,
    wearable_ids: [370, 334],
  },
  {
    genesis_token_id: 19979,
    wearable_ids: [278, 274],
  },
  {
    genesis_token_id: 19980,
    wearable_ids: [299, 397],
  },
  {
    genesis_token_id: 19981,
    wearable_ids: [270, 290],
  },
  {
    genesis_token_id: 19982,
    wearable_ids: [413, 344],
  },
  {
    genesis_token_id: 19983,
    wearable_ids: [316, 433],
  },
  {
    genesis_token_id: 19984,
    wearable_ids: [299, 283],
  },
  {
    genesis_token_id: 19985,
    wearable_ids: [289, 338],
  },
  {
    genesis_token_id: 19986,
    wearable_ids: [442, 291],
  },
  {
    genesis_token_id: 19987,
    wearable_ids: [280, 345],
  },
  {
    genesis_token_id: 19988,
    wearable_ids: [422, 261],
  },
  {
    genesis_token_id: 19989,
    wearable_ids: [344, 265],
  },
  {
    genesis_token_id: 19990,
    wearable_ids: [258, 276],
  },
  {
    genesis_token_id: 19991,
    wearable_ids: [372, 375],
  },
  {
    genesis_token_id: 19992,
    wearable_ids: [365, 374],
  },
  {
    genesis_token_id: 19993,
    wearable_ids: [274, 303],
  },
  {
    genesis_token_id: 19994,
    wearable_ids: [319, 351],
  },
  {
    genesis_token_id: 19995,
    wearable_ids: [431, 273],
  },
  {
    genesis_token_id: 19996,
    wearable_ids: [311, 277],
  },
  {
    genesis_token_id: 19997,
    wearable_ids: [297, 422],
  },
  {
    genesis_token_id: 19998,
    wearable_ids: [324, 400],
  },
  {
    genesis_token_id: 19999,
    wearable_ids: [259, 310],
  },
  {
    genesis_token_id: 20000,
    wearable_ids: [384, 411],
  },
  {
    genesis_token_id: 20001,
    wearable_ids: [271, 404],
  },
  {
    genesis_token_id: 20002,
    wearable_ids: [270, 294],
  },
  {
    genesis_token_id: 20003,
    wearable_ids: [354, 286],
  },
  {
    genesis_token_id: 20004,
    wearable_ids: [371, 257],
  },
  {
    genesis_token_id: 20005,
    wearable_ids: [445, 378],
  },
  {
    genesis_token_id: 20006,
    wearable_ids: [415, 263],
  },
  {
    genesis_token_id: 20007,
    wearable_ids: [413, 272],
  },
  {
    genesis_token_id: 20008,
    wearable_ids: [437, 262],
  },
  {
    genesis_token_id: 20009,
    wearable_ids: [351, 330],
  },
  {
    genesis_token_id: 20010,
    wearable_ids: [376, 415],
  },
  {
    genesis_token_id: 20011,
    wearable_ids: [295, 384],
  },
  {
    genesis_token_id: 20012,
    wearable_ids: [408, 349],
  },
  {
    genesis_token_id: 20013,
    wearable_ids: [385, 427],
  },
  {
    genesis_token_id: 20014,
    wearable_ids: [382, 292],
  },
  {
    genesis_token_id: 20015,
    wearable_ids: [425, 296],
  },
  {
    genesis_token_id: 20016,
    wearable_ids: [412, 429],
  },
  {
    genesis_token_id: 20017,
    wearable_ids: [338, 286],
  },
  {
    genesis_token_id: 20018,
    wearable_ids: [408, 254],
  },
  {
    genesis_token_id: 20019,
    wearable_ids: [376, 295],
  },
  {
    genesis_token_id: 20020,
    wearable_ids: [411, 412],
  },
  {
    genesis_token_id: 20021,
    wearable_ids: [364, 266],
  },
  {
    genesis_token_id: 20022,
    wearable_ids: [354, 348],
  },
  {
    genesis_token_id: 20023,
    wearable_ids: [299, 377],
  },
  {
    genesis_token_id: 20024,
    wearable_ids: [319, 437],
  },
  {
    genesis_token_id: 20025,
    wearable_ids: [291, 384],
  },
  {
    genesis_token_id: 20026,
    wearable_ids: [291, 338],
  },
  {
    genesis_token_id: 20027,
    wearable_ids: [346, 429],
  },
  {
    genesis_token_id: 20028,
    wearable_ids: [365, 350],
  },
  {
    genesis_token_id: 20029,
    wearable_ids: [248, 278],
  },
  {
    genesis_token_id: 20030,
    wearable_ids: [409, 294],
  },
  {
    genesis_token_id: 20031,
    wearable_ids: [349, 376],
  },
  {
    genesis_token_id: 20032,
    wearable_ids: [331, 385],
  },
  {
    genesis_token_id: 20033,
    wearable_ids: [431, 368],
  },
  {
    genesis_token_id: 20034,
    wearable_ids: [412, 436],
  },
  {
    genesis_token_id: 20035,
    wearable_ids: [404, 423],
  },
  {
    genesis_token_id: 20036,
    wearable_ids: [317, 276],
  },
  {
    genesis_token_id: 20037,
    wearable_ids: [256, 384],
  },
  {
    genesis_token_id: 20038,
    wearable_ids: [256, 424],
  },
  {
    genesis_token_id: 20039,
    wearable_ids: [351, 302],
  },
  {
    genesis_token_id: 20040,
    wearable_ids: [445, 378],
  },
  {
    genesis_token_id: 20041,
    wearable_ids: [310, 375],
  },
  {
    genesis_token_id: 20042,
    wearable_ids: [342, 278],
  },
  {
    genesis_token_id: 20043,
    wearable_ids: [300, 337],
  },
  {
    genesis_token_id: 20044,
    wearable_ids: [301, 253],
  },
  {
    genesis_token_id: 20045,
    wearable_ids: [408, 386],
  },
  {
    genesis_token_id: 20046,
    wearable_ids: [376, 334],
  },
  {
    genesis_token_id: 20047,
    wearable_ids: [299, 272],
  },
  {
    genesis_token_id: 20048,
    wearable_ids: [255, 371],
  },
  {
    genesis_token_id: 20049,
    wearable_ids: [443, 433],
  },
  {
    genesis_token_id: 20050,
    wearable_ids: [297, 378],
  },
  {
    genesis_token_id: 20051,
    wearable_ids: [412, 394],
  },
  {
    genesis_token_id: 20052,
    wearable_ids: [295, 322],
  },
  {
    genesis_token_id: 20053,
    wearable_ids: [317, 310],
  },
  {
    genesis_token_id: 20054,
    wearable_ids: [442, 314],
  },
  {
    genesis_token_id: 20055,
    wearable_ids: [331, 418],
  },
  {
    genesis_token_id: 20056,
    wearable_ids: [284, 386],
  },
  {
    genesis_token_id: 20057,
    wearable_ids: [378, 287],
  },
  {
    genesis_token_id: 20058,
    wearable_ids: [375, 273],
  },
  {
    genesis_token_id: 20059,
    wearable_ids: [404, 274],
  },
  {
    genesis_token_id: 20060,
    wearable_ids: [254, 354],
  },
  {
    genesis_token_id: 20061,
    wearable_ids: [429, 443],
  },
  {
    genesis_token_id: 20062,
    wearable_ids: [411, 319],
  },
  {
    genesis_token_id: 20063,
    wearable_ids: [294, 399],
  },
  {
    genesis_token_id: 20064,
    wearable_ids: [265, 291],
  },
  {
    genesis_token_id: 20065,
    wearable_ids: [290, 370],
  },
  {
    genesis_token_id: 20066,
    wearable_ids: [444, 425],
  },
  {
    genesis_token_id: 20067,
    wearable_ids: [384, 274],
  },
  {
    genesis_token_id: 20068,
    wearable_ids: [291, 386],
  },
  {
    genesis_token_id: 20069,
    wearable_ids: [297, 340],
  },
  {
    genesis_token_id: 20070,
    wearable_ids: [443, 345],
  },
  {
    genesis_token_id: 20071,
    wearable_ids: [291, 264],
  },
  {
    genesis_token_id: 20072,
    wearable_ids: [386, 388],
  },
  {
    genesis_token_id: 20073,
    wearable_ids: [258, 429],
  },
  {
    genesis_token_id: 20074,
    wearable_ids: [310, 297],
  },
  {
    genesis_token_id: 20075,
    wearable_ids: [384, 443],
  },
  {
    genesis_token_id: 20076,
    wearable_ids: [389, 298],
  },
  {
    genesis_token_id: 20077,
    wearable_ids: [407, 404],
  },
  {
    genesis_token_id: 20078,
    wearable_ids: [291, 337],
  },
  {
    genesis_token_id: 20079,
    wearable_ids: [422, 340],
  },
  {
    genesis_token_id: 20080,
    wearable_ids: [413, 273],
  },
  {
    genesis_token_id: 20081,
    wearable_ids: [303, 343],
  },
  {
    genesis_token_id: 20082,
    wearable_ids: [346, 247],
  },
  {
    genesis_token_id: 20083,
    wearable_ids: [428, 334],
  },
  {
    genesis_token_id: 20084,
    wearable_ids: [294, 440],
  },
  {
    genesis_token_id: 20085,
    wearable_ids: [278, 411],
  },
  {
    genesis_token_id: 20086,
    wearable_ids: [432, 287],
  },
  {
    genesis_token_id: 20087,
    wearable_ids: [268, 412],
  },
  {
    genesis_token_id: 20088,
    wearable_ids: [351, 376],
  },
  {
    genesis_token_id: 20089,
    wearable_ids: [290, 337],
  },
  {
    genesis_token_id: 20090,
    wearable_ids: [314, 312],
  },
  {
    genesis_token_id: 20091,
    wearable_ids: [368, 275],
  },
  {
    genesis_token_id: 20092,
    wearable_ids: [315, 445],
  },
  {
    genesis_token_id: 20093,
    wearable_ids: [272, 431],
  },
  {
    genesis_token_id: 20094,
    wearable_ids: [387, 422],
  },
  {
    genesis_token_id: 20095,
    wearable_ids: [344, 400],
  },
  {
    genesis_token_id: 20096,
    wearable_ids: [297, 247],
  },
  {
    genesis_token_id: 20097,
    wearable_ids: [423, 431],
  },
  {
    genesis_token_id: 20098,
    wearable_ids: [325, 370],
  },
  {
    genesis_token_id: 20099,
    wearable_ids: [314, 290],
  },
  {
    genesis_token_id: 20100,
    wearable_ids: [413, 331],
  },
  {
    genesis_token_id: 20101,
    wearable_ids: [363, 303],
  },
  {
    genesis_token_id: 20102,
    wearable_ids: [311, 280],
  },
  {
    genesis_token_id: 20103,
    wearable_ids: [411, 417],
  },
  {
    genesis_token_id: 20104,
    wearable_ids: [326, 306],
  },
  {
    genesis_token_id: 20105,
    wearable_ids: [432, 435],
  },
  {
    genesis_token_id: 20106,
    wearable_ids: [258, 382],
  },
  {
    genesis_token_id: 20107,
    wearable_ids: [349, 325],
  },
  {
    genesis_token_id: 20108,
    wearable_ids: [411, 363],
  },
  {
    genesis_token_id: 20109,
    wearable_ids: [433, 332],
  },
  {
    genesis_token_id: 20110,
    wearable_ids: [336, 316],
  },
  {
    genesis_token_id: 20111,
    wearable_ids: [410, 371],
  },
  {
    genesis_token_id: 20112,
    wearable_ids: [297, 344],
  },
  {
    genesis_token_id: 20113,
    wearable_ids: [364, 397],
  },
  {
    genesis_token_id: 20114,
    wearable_ids: [339, 376],
  },
  {
    genesis_token_id: 20115,
    wearable_ids: [304, 265],
  },
  {
    genesis_token_id: 20116,
    wearable_ids: [306, 266],
  },
  {
    genesis_token_id: 20117,
    wearable_ids: [396, 357],
  },
  {
    genesis_token_id: 20118,
    wearable_ids: [437, 351],
  },
  {
    genesis_token_id: 20119,
    wearable_ids: [422, 442],
  },
  {
    genesis_token_id: 20120,
    wearable_ids: [253, 311],
  },
  {
    genesis_token_id: 20121,
    wearable_ids: [263, 313],
  },
  {
    genesis_token_id: 20122,
    wearable_ids: [377, 291],
  },
  {
    genesis_token_id: 20123,
    wearable_ids: [274, 259],
  },
  {
    genesis_token_id: 20124,
    wearable_ids: [270, 311],
  },
  {
    genesis_token_id: 20125,
    wearable_ids: [378, 317],
  },
  {
    genesis_token_id: 20126,
    wearable_ids: [344, 352],
  },
  {
    genesis_token_id: 20127,
    wearable_ids: [256, 349],
  },
  {
    genesis_token_id: 20128,
    wearable_ids: [403, 284],
  },
  {
    genesis_token_id: 20129,
    wearable_ids: [352, 410],
  },
  {
    genesis_token_id: 20130,
    wearable_ids: [310, 392],
  },
  {
    genesis_token_id: 20131,
    wearable_ids: [278, 349],
  },
  {
    genesis_token_id: 20132,
    wearable_ids: [351, 349],
  },
  {
    genesis_token_id: 20133,
    wearable_ids: [387, 397],
  },
  {
    genesis_token_id: 20134,
    wearable_ids: [374, 411],
  },
  {
    genesis_token_id: 20135,
    wearable_ids: [350, 259],
  },
  {
    genesis_token_id: 20136,
    wearable_ids: [326, 266],
  },
  {
    genesis_token_id: 20137,
    wearable_ids: [311, 273],
  },
  {
    genesis_token_id: 20138,
    wearable_ids: [355, 379],
  },
  {
    genesis_token_id: 20139,
    wearable_ids: [284, 294],
  },
  {
    genesis_token_id: 20140,
    wearable_ids: [370, 350],
  },
  {
    genesis_token_id: 20141,
    wearable_ids: [251, 302],
  },
  {
    genesis_token_id: 20142,
    wearable_ids: [386, 407],
  },
  {
    genesis_token_id: 20143,
    wearable_ids: [383, 262],
  },
  {
    genesis_token_id: 20144,
    wearable_ids: [291, 389],
  },
  {
    genesis_token_id: 20145,
    wearable_ids: [372, 417],
  },
  {
    genesis_token_id: 20146,
    wearable_ids: [254, 386],
  },
  {
    genesis_token_id: 20147,
    wearable_ids: [404, 411],
  },
  {
    genesis_token_id: 20148,
    wearable_ids: [395, 262],
  },
  {
    genesis_token_id: 20149,
    wearable_ids: [415, 419],
  },
  {
    genesis_token_id: 20150,
    wearable_ids: [403, 280],
  },
  {
    genesis_token_id: 20151,
    wearable_ids: [343, 366],
  },
  {
    genesis_token_id: 20152,
    wearable_ids: [443, 310],
  },
  {
    genesis_token_id: 20153,
    wearable_ids: [308, 393],
  },
  {
    genesis_token_id: 20154,
    wearable_ids: [351, 392],
  },
  {
    genesis_token_id: 20155,
    wearable_ids: [336, 346],
  },
  {
    genesis_token_id: 20156,
    wearable_ids: [340, 319],
  },
  {
    genesis_token_id: 20157,
    wearable_ids: [254, 405],
  },
  {
    genesis_token_id: 20158,
    wearable_ids: [304, 436],
  },
  {
    genesis_token_id: 20159,
    wearable_ids: [371, 261],
  },
  {
    genesis_token_id: 20160,
    wearable_ids: [286, 386],
  },
  {
    genesis_token_id: 20161,
    wearable_ids: [424, 407],
  },
  {
    genesis_token_id: 20162,
    wearable_ids: [286, 413],
  },
  {
    genesis_token_id: 20163,
    wearable_ids: [316, 255],
  },
  {
    genesis_token_id: 20164,
    wearable_ids: [338, 404],
  },
  {
    genesis_token_id: 20165,
    wearable_ids: [352, 266],
  },
  {
    genesis_token_id: 20166,
    wearable_ids: [277, 369],
  },
  {
    genesis_token_id: 20167,
    wearable_ids: [338, 331],
  },
  {
    genesis_token_id: 20168,
    wearable_ids: [276, 368],
  },
  {
    genesis_token_id: 20169,
    wearable_ids: [326, 443],
  },
  {
    genesis_token_id: 20170,
    wearable_ids: [254, 247],
  },
  {
    genesis_token_id: 20171,
    wearable_ids: [268, 305],
  },
  {
    genesis_token_id: 20172,
    wearable_ids: [434, 382],
  },
  {
    genesis_token_id: 20173,
    wearable_ids: [273, 299],
  },
  {
    genesis_token_id: 20174,
    wearable_ids: [262, 287],
  },
  {
    genesis_token_id: 20175,
    wearable_ids: [347, 407],
  },
  {
    genesis_token_id: 20176,
    wearable_ids: [292, 351],
  },
  {
    genesis_token_id: 20177,
    wearable_ids: [297, 379],
  },
  {
    genesis_token_id: 20178,
    wearable_ids: [251, 339],
  },
  {
    genesis_token_id: 20179,
    wearable_ids: [422, 279],
  },
  {
    genesis_token_id: 20180,
    wearable_ids: [325, 352],
  },
  {
    genesis_token_id: 20181,
    wearable_ids: [371, 377],
  },
  {
    genesis_token_id: 20182,
    wearable_ids: [424, 248],
  },
  {
    genesis_token_id: 20183,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 20184,
    wearable_ids: [317, 394],
  },
  {
    genesis_token_id: 20185,
    wearable_ids: [292, 340],
  },
  {
    genesis_token_id: 20186,
    wearable_ids: [257, 284],
  },
  {
    genesis_token_id: 20187,
    wearable_ids: [295, 246],
  },
  {
    genesis_token_id: 20188,
    wearable_ids: [385, 397],
  },
  {
    genesis_token_id: 20189,
    wearable_ids: [425, 292],
  },
  {
    genesis_token_id: 20190,
    wearable_ids: [258, 363],
  },
  {
    genesis_token_id: 20191,
    wearable_ids: [299, 260],
  },
  {
    genesis_token_id: 20192,
    wearable_ids: [384, 415],
  },
  {
    genesis_token_id: 20193,
    wearable_ids: [314, 372],
  },
  {
    genesis_token_id: 20194,
    wearable_ids: [429, 274],
  },
  {
    genesis_token_id: 20195,
    wearable_ids: [351, 364],
  },
  {
    genesis_token_id: 20196,
    wearable_ids: [277, 409],
  },
  {
    genesis_token_id: 20197,
    wearable_ids: [270, 346],
  },
  {
    genesis_token_id: 20198,
    wearable_ids: [425, 383],
  },
  {
    genesis_token_id: 20199,
    wearable_ids: [315, 284],
  },
  {
    genesis_token_id: 20200,
    wearable_ids: [294, 290],
  },
  {
    genesis_token_id: 20201,
    wearable_ids: [257, 355],
  },
  {
    genesis_token_id: 20202,
    wearable_ids: [259, 319],
  },
  {
    genesis_token_id: 20203,
    wearable_ids: [396, 304],
  },
  {
    genesis_token_id: 20204,
    wearable_ids: [346, 291],
  },
  {
    genesis_token_id: 20205,
    wearable_ids: [324, 258],
  },
  {
    genesis_token_id: 20206,
    wearable_ids: [277, 398],
  },
  {
    genesis_token_id: 20207,
    wearable_ids: [287, 325],
  },
  {
    genesis_token_id: 20208,
    wearable_ids: [387, 371],
  },
  {
    genesis_token_id: 20209,
    wearable_ids: [412, 326],
  },
  {
    genesis_token_id: 20210,
    wearable_ids: [354, 397],
  },
  {
    genesis_token_id: 20211,
    wearable_ids: [348, 304],
  },
  {
    genesis_token_id: 20212,
    wearable_ids: [316, 342],
  },
  {
    genesis_token_id: 20213,
    wearable_ids: [413, 355],
  },
  {
    genesis_token_id: 20214,
    wearable_ids: [444, 436],
  },
  {
    genesis_token_id: 20215,
    wearable_ids: [273, 253],
  },
  {
    genesis_token_id: 20216,
    wearable_ids: [437, 414],
  },
  {
    genesis_token_id: 20217,
    wearable_ids: [343, 368],
  },
  {
    genesis_token_id: 20218,
    wearable_ids: [424, 333],
  },
  {
    genesis_token_id: 20219,
    wearable_ids: [406, 297],
  },
  {
    genesis_token_id: 20220,
    wearable_ids: [343, 374],
  },
  {
    genesis_token_id: 20221,
    wearable_ids: [413, 305],
  },
  {
    genesis_token_id: 20222,
    wearable_ids: [372, 370],
  },
  {
    genesis_token_id: 20223,
    wearable_ids: [290, 385],
  },
  {
    genesis_token_id: 20224,
    wearable_ids: [284, 403],
  },
  {
    genesis_token_id: 20225,
    wearable_ids: [428, 404],
  },
  {
    genesis_token_id: 20226,
    wearable_ids: [339, 382],
  },
  {
    genesis_token_id: 20227,
    wearable_ids: [384, 351],
  },
  {
    genesis_token_id: 20228,
    wearable_ids: [362, 412],
  },
  {
    genesis_token_id: 20229,
    wearable_ids: [365, 420],
  },
  {
    genesis_token_id: 20230,
    wearable_ids: [324, 292],
  },
  {
    genesis_token_id: 20231,
    wearable_ids: [412, 425],
  },
  {
    genesis_token_id: 20232,
    wearable_ids: [409, 296],
  },
  {
    genesis_token_id: 20233,
    wearable_ids: [355, 378],
  },
  {
    genesis_token_id: 20234,
    wearable_ids: [444, 399],
  },
  {
    genesis_token_id: 20235,
    wearable_ids: [304, 363],
  },
  {
    genesis_token_id: 20236,
    wearable_ids: [258, 289],
  },
  {
    genesis_token_id: 20237,
    wearable_ids: [373, 398],
  },
  {
    genesis_token_id: 20238,
    wearable_ids: [444, 352],
  },
  {
    genesis_token_id: 20239,
    wearable_ids: [389, 297],
  },
  {
    genesis_token_id: 20240,
    wearable_ids: [248, 284],
  },
  {
    genesis_token_id: 20241,
    wearable_ids: [304, 376],
  },
  {
    genesis_token_id: 20242,
    wearable_ids: [355, 313],
  },
  {
    genesis_token_id: 20243,
    wearable_ids: [404, 413],
  },
  {
    genesis_token_id: 20244,
    wearable_ids: [442, 294],
  },
  {
    genesis_token_id: 20245,
    wearable_ids: [317, 332],
  },
  {
    genesis_token_id: 20246,
    wearable_ids: [257, 264],
  },
  {
    genesis_token_id: 20247,
    wearable_ids: [280, 320],
  },
  {
    genesis_token_id: 20248,
    wearable_ids: [310, 374],
  },
  {
    genesis_token_id: 20249,
    wearable_ids: [397, 256],
  },
  {
    genesis_token_id: 20250,
    wearable_ids: [292, 312],
  },
  {
    genesis_token_id: 20251,
    wearable_ids: [317, 399],
  },
  {
    genesis_token_id: 20252,
    wearable_ids: [278, 255],
  },
  {
    genesis_token_id: 20253,
    wearable_ids: [325, 375],
  },
  {
    genesis_token_id: 20254,
    wearable_ids: [403, 324],
  },
  {
    genesis_token_id: 20255,
    wearable_ids: [383, 326],
  },
  {
    genesis_token_id: 20256,
    wearable_ids: [425, 324],
  },
  {
    genesis_token_id: 20257,
    wearable_ids: [262, 406],
  },
  {
    genesis_token_id: 20258,
    wearable_ids: [294, 361],
  },
  {
    genesis_token_id: 20259,
    wearable_ids: [415, 428],
  },
  {
    genesis_token_id: 20260,
    wearable_ids: [365, 344],
  },
  {
    genesis_token_id: 20261,
    wearable_ids: [423, 396],
  },
  {
    genesis_token_id: 20262,
    wearable_ids: [346, 286],
  },
  {
    genesis_token_id: 20263,
    wearable_ids: [409, 384],
  },
  {
    genesis_token_id: 20264,
    wearable_ids: [299, 395],
  },
  {
    genesis_token_id: 20265,
    wearable_ids: [256, 304],
  },
  {
    genesis_token_id: 20266,
    wearable_ids: [433, 248],
  },
  {
    genesis_token_id: 20267,
    wearable_ids: [355, 399],
  },
  {
    genesis_token_id: 20268,
    wearable_ids: [304, 364],
  },
  {
    genesis_token_id: 20269,
    wearable_ids: [444, 366],
  },
  {
    genesis_token_id: 20270,
    wearable_ids: [316, 294],
  },
  {
    genesis_token_id: 20271,
    wearable_ids: [350, 428],
  },
  {
    genesis_token_id: 20272,
    wearable_ids: [311, 320],
  },
  {
    genesis_token_id: 20273,
    wearable_ids: [314, 371],
  },
  {
    genesis_token_id: 20274,
    wearable_ids: [289, 370],
  },
  {
    genesis_token_id: 20275,
    wearable_ids: [383, 274],
  },
  {
    genesis_token_id: 20276,
    wearable_ids: [442, 354],
  },
  {
    genesis_token_id: 20277,
    wearable_ids: [396, 280],
  },
  {
    genesis_token_id: 20278,
    wearable_ids: [247, 409],
  },
  {
    genesis_token_id: 20279,
    wearable_ids: [385, 409],
  },
  {
    genesis_token_id: 20280,
    wearable_ids: [429, 401],
  },
  {
    genesis_token_id: 20281,
    wearable_ids: [326, 339],
  },
  {
    genesis_token_id: 20282,
    wearable_ids: [303, 294],
  },
  {
    genesis_token_id: 20283,
    wearable_ids: [426, 355],
  },
  {
    genesis_token_id: 20284,
    wearable_ids: [443, 341],
  },
  {
    genesis_token_id: 20285,
    wearable_ids: [354, 266],
  },
  {
    genesis_token_id: 20286,
    wearable_ids: [274, 371],
  },
  {
    genesis_token_id: 20287,
    wearable_ids: [363, 339],
  },
  {
    genesis_token_id: 20288,
    wearable_ids: [295, 403],
  },
  {
    genesis_token_id: 20289,
    wearable_ids: [364, 354],
  },
  {
    genesis_token_id: 20290,
    wearable_ids: [372, 319],
  },
  {
    genesis_token_id: 20291,
    wearable_ids: [423, 393],
  },
  {
    genesis_token_id: 20292,
    wearable_ids: [404, 422],
  },
  {
    genesis_token_id: 20293,
    wearable_ids: [363, 342],
  },
  {
    genesis_token_id: 20294,
    wearable_ids: [284, 247],
  },
  {
    genesis_token_id: 20295,
    wearable_ids: [423, 270],
  },
  {
    genesis_token_id: 20296,
    wearable_ids: [342, 386],
  },
  {
    genesis_token_id: 20297,
    wearable_ids: [426, 376],
  },
  {
    genesis_token_id: 20298,
    wearable_ids: [289, 269],
  },
  {
    genesis_token_id: 20299,
    wearable_ids: [384, 324],
  },
  {
    genesis_token_id: 20300,
    wearable_ids: [336, 436],
  },
  {
    genesis_token_id: 20301,
    wearable_ids: [413, 434],
  },
  {
    genesis_token_id: 20302,
    wearable_ids: [306, 292],
  },
  {
    genesis_token_id: 20303,
    wearable_ids: [339, 382],
  },
  {
    genesis_token_id: 20304,
    wearable_ids: [413, 399],
  },
  {
    genesis_token_id: 20305,
    wearable_ids: [315, 393],
  },
  {
    genesis_token_id: 20306,
    wearable_ids: [351, 290],
  },
  {
    genesis_token_id: 20307,
    wearable_ids: [422, 347],
  },
  {
    genesis_token_id: 20308,
    wearable_ids: [371, 336],
  },
  {
    genesis_token_id: 20309,
    wearable_ids: [420, 362],
  },
  {
    genesis_token_id: 20310,
    wearable_ids: [432, 429],
  },
  {
    genesis_token_id: 20311,
    wearable_ids: [370, 435],
  },
  {
    genesis_token_id: 20312,
    wearable_ids: [272, 327],
  },
  {
    genesis_token_id: 20313,
    wearable_ids: [399, 292],
  },
  {
    genesis_token_id: 20314,
    wearable_ids: [369, 399],
  },
  {
    genesis_token_id: 20315,
    wearable_ids: [301, 339],
  },
  {
    genesis_token_id: 20316,
    wearable_ids: [286, 251],
  },
  {
    genesis_token_id: 20317,
    wearable_ids: [364, 306],
  },
  {
    genesis_token_id: 20318,
    wearable_ids: [258, 411],
  },
  {
    genesis_token_id: 20319,
    wearable_ids: [371, 362],
  },
  {
    genesis_token_id: 20320,
    wearable_ids: [254, 425],
  },
  {
    genesis_token_id: 20321,
    wearable_ids: [256, 352],
  },
  {
    genesis_token_id: 20322,
    wearable_ids: [286, 313],
  },
  {
    genesis_token_id: 20323,
    wearable_ids: [251, 271],
  },
  {
    genesis_token_id: 20324,
    wearable_ids: [319, 257],
  },
  {
    genesis_token_id: 20325,
    wearable_ids: [294, 301],
  },
  {
    genesis_token_id: 20326,
    wearable_ids: [284, 251],
  },
  {
    genesis_token_id: 20327,
    wearable_ids: [266, 376],
  },
  {
    genesis_token_id: 20328,
    wearable_ids: [347, 368],
  },
  {
    genesis_token_id: 20329,
    wearable_ids: [286, 258],
  },
  {
    genesis_token_id: 20330,
    wearable_ids: [385, 272],
  },
  {
    genesis_token_id: 20331,
    wearable_ids: [355, 349],
  },
  {
    genesis_token_id: 20332,
    wearable_ids: [337, 435],
  },
  {
    genesis_token_id: 20333,
    wearable_ids: [444, 320],
  },
  {
    genesis_token_id: 20334,
    wearable_ids: [395, 339],
  },
  {
    genesis_token_id: 20335,
    wearable_ids: [389, 376],
  },
  {
    genesis_token_id: 20336,
    wearable_ids: [343, 405],
  },
  {
    genesis_token_id: 20337,
    wearable_ids: [397, 445],
  },
  {
    genesis_token_id: 20338,
    wearable_ids: [343, 399],
  },
  {
    genesis_token_id: 20339,
    wearable_ids: [332, 444],
  },
  {
    genesis_token_id: 20340,
    wearable_ids: [248, 304],
  },
  {
    genesis_token_id: 20341,
    wearable_ids: [315, 316],
  },
  {
    genesis_token_id: 20342,
    wearable_ids: [432, 250],
  },
  {
    genesis_token_id: 20343,
    wearable_ids: [428, 434],
  },
  {
    genesis_token_id: 20344,
    wearable_ids: [350, 385],
  },
  {
    genesis_token_id: 20345,
    wearable_ids: [350, 325],
  },
  {
    genesis_token_id: 20346,
    wearable_ids: [259, 418],
  },
  {
    genesis_token_id: 20347,
    wearable_ids: [343, 409],
  },
  {
    genesis_token_id: 20348,
    wearable_ids: [362, 434],
  },
  {
    genesis_token_id: 20349,
    wearable_ids: [375, 260],
  },
  {
    genesis_token_id: 20350,
    wearable_ids: [434, 383],
  },
  {
    genesis_token_id: 20351,
    wearable_ids: [415, 299],
  },
  {
    genesis_token_id: 20352,
    wearable_ids: [365, 256],
  },
  {
    genesis_token_id: 20353,
    wearable_ids: [315, 429],
  },
  {
    genesis_token_id: 20354,
    wearable_ids: [253, 443],
  },
  {
    genesis_token_id: 20355,
    wearable_ids: [382, 347],
  },
  {
    genesis_token_id: 20356,
    wearable_ids: [265, 256],
  },
  {
    genesis_token_id: 20357,
    wearable_ids: [339, 266],
  },
  {
    genesis_token_id: 20358,
    wearable_ids: [255, 409],
  },
  {
    genesis_token_id: 20359,
    wearable_ids: [280, 287],
  },
  {
    genesis_token_id: 20360,
    wearable_ids: [355, 295],
  },
  {
    genesis_token_id: 20361,
    wearable_ids: [364, 314],
  },
  {
    genesis_token_id: 20362,
    wearable_ids: [350, 422],
  },
  {
    genesis_token_id: 20363,
    wearable_ids: [337, 396],
  },
  {
    genesis_token_id: 20364,
    wearable_ids: [412, 278],
  },
  {
    genesis_token_id: 20365,
    wearable_ids: [251, 374],
  },
  {
    genesis_token_id: 20366,
    wearable_ids: [429, 352],
  },
  {
    genesis_token_id: 20367,
    wearable_ids: [396, 315],
  },
  {
    genesis_token_id: 20368,
    wearable_ids: [340, 246],
  },
  {
    genesis_token_id: 20369,
    wearable_ids: [376, 368],
  },
  {
    genesis_token_id: 20370,
    wearable_ids: [408, 256],
  },
  {
    genesis_token_id: 20371,
    wearable_ids: [287, 317],
  },
  {
    genesis_token_id: 20372,
    wearable_ids: [433, 325],
  },
  {
    genesis_token_id: 20373,
    wearable_ids: [376, 342],
  },
  {
    genesis_token_id: 20374,
    wearable_ids: [436, 407],
  },
  {
    genesis_token_id: 20375,
    wearable_ids: [397, 264],
  },
  {
    genesis_token_id: 20376,
    wearable_ids: [351, 373],
  },
  {
    genesis_token_id: 20377,
    wearable_ids: [396, 272],
  },
  {
    genesis_token_id: 20378,
    wearable_ids: [352, 366],
  },
  {
    genesis_token_id: 20379,
    wearable_ids: [431, 432],
  },
  {
    genesis_token_id: 20380,
    wearable_ids: [278, 371],
  },
  {
    genesis_token_id: 20381,
    wearable_ids: [324, 422],
  },
  {
    genesis_token_id: 20382,
    wearable_ids: [287, 373],
  },
  {
    genesis_token_id: 20383,
    wearable_ids: [286, 249],
  },
  {
    genesis_token_id: 20384,
    wearable_ids: [294, 311],
  },
  {
    genesis_token_id: 20385,
    wearable_ids: [434, 372],
  },
  {
    genesis_token_id: 20386,
    wearable_ids: [340, 251],
  },
  {
    genesis_token_id: 20387,
    wearable_ids: [442, 265],
  },
  {
    genesis_token_id: 20388,
    wearable_ids: [274, 397],
  },
  {
    genesis_token_id: 20389,
    wearable_ids: [355, 370],
  },
  {
    genesis_token_id: 20390,
    wearable_ids: [301, 441],
  },
  {
    genesis_token_id: 20391,
    wearable_ids: [248, 407],
  },
  {
    genesis_token_id: 20392,
    wearable_ids: [410, 261],
  },
  {
    genesis_token_id: 20393,
    wearable_ids: [399, 368],
  },
  {
    genesis_token_id: 20394,
    wearable_ids: [370, 443],
  },
  {
    genesis_token_id: 20395,
    wearable_ids: [368, 327],
  },
  {
    genesis_token_id: 20396,
    wearable_ids: [373, 295],
  },
  {
    genesis_token_id: 20397,
    wearable_ids: [277, 355],
  },
  {
    genesis_token_id: 20398,
    wearable_ids: [397, 415],
  },
  {
    genesis_token_id: 20399,
    wearable_ids: [375, 314],
  },
  {
    genesis_token_id: 20400,
    wearable_ids: [378, 271],
  },
  {
    genesis_token_id: 20401,
    wearable_ids: [352, 315],
  },
  {
    genesis_token_id: 20402,
    wearable_ids: [286, 440],
  },
  {
    genesis_token_id: 20403,
    wearable_ids: [253, 306],
  },
  {
    genesis_token_id: 20404,
    wearable_ids: [411, 251],
  },
  {
    genesis_token_id: 20405,
    wearable_ids: [297, 442],
  },
  {
    genesis_token_id: 20406,
    wearable_ids: [274, 294],
  },
  {
    genesis_token_id: 20407,
    wearable_ids: [428, 291],
  },
  {
    genesis_token_id: 20408,
    wearable_ids: [325, 255],
  },
  {
    genesis_token_id: 20409,
    wearable_ids: [413, 400],
  },
  {
    genesis_token_id: 20410,
    wearable_ids: [248, 306],
  },
  {
    genesis_token_id: 20411,
    wearable_ids: [445, 409],
  },
  {
    genesis_token_id: 20412,
    wearable_ids: [306, 441],
  },
  {
    genesis_token_id: 20413,
    wearable_ids: [280, 426],
  },
  {
    genesis_token_id: 20414,
    wearable_ids: [411, 315],
  },
  {
    genesis_token_id: 20415,
    wearable_ids: [304, 347],
  },
  {
    genesis_token_id: 20416,
    wearable_ids: [425, 256],
  },
  {
    genesis_token_id: 20417,
    wearable_ids: [382, 341],
  },
  {
    genesis_token_id: 20418,
    wearable_ids: [294, 333],
  },
  {
    genesis_token_id: 20419,
    wearable_ids: [266, 429],
  },
  {
    genesis_token_id: 20420,
    wearable_ids: [428, 377],
  },
  {
    genesis_token_id: 20421,
    wearable_ids: [382, 324],
  },
  {
    genesis_token_id: 20422,
    wearable_ids: [272, 295],
  },
  {
    genesis_token_id: 20423,
    wearable_ids: [271, 431],
  },
  {
    genesis_token_id: 20424,
    wearable_ids: [264, 314],
  },
  {
    genesis_token_id: 20425,
    wearable_ids: [278, 290],
  },
  {
    genesis_token_id: 20426,
    wearable_ids: [253, 335],
  },
  {
    genesis_token_id: 20427,
    wearable_ids: [273, 280],
  },
  {
    genesis_token_id: 20428,
    wearable_ids: [378, 303],
  },
  {
    genesis_token_id: 20429,
    wearable_ids: [371, 262],
  },
  {
    genesis_token_id: 20430,
    wearable_ids: [258, 310],
  },
  {
    genesis_token_id: 20431,
    wearable_ids: [422, 299],
  },
  {
    genesis_token_id: 20432,
    wearable_ids: [336, 400],
  },
  {
    genesis_token_id: 20433,
    wearable_ids: [377, 265],
  },
  {
    genesis_token_id: 20434,
    wearable_ids: [445, 374],
  },
  {
    genesis_token_id: 20435,
    wearable_ids: [338, 434],
  },
  {
    genesis_token_id: 20436,
    wearable_ids: [310, 422],
  },
  {
    genesis_token_id: 20437,
    wearable_ids: [271, 405],
  },
  {
    genesis_token_id: 20438,
    wearable_ids: [336, 294],
  },
  {
    genesis_token_id: 20439,
    wearable_ids: [255, 413],
  },
  {
    genesis_token_id: 20440,
    wearable_ids: [310, 430],
  },
  {
    genesis_token_id: 20441,
    wearable_ids: [266, 301],
  },
  {
    genesis_token_id: 20442,
    wearable_ids: [324, 442],
  },
  {
    genesis_token_id: 20443,
    wearable_ids: [286, 271],
  },
  {
    genesis_token_id: 20444,
    wearable_ids: [256, 274],
  },
  {
    genesis_token_id: 20445,
    wearable_ids: [338, 429],
  },
  {
    genesis_token_id: 20446,
    wearable_ids: [335, 393],
  },
  {
    genesis_token_id: 20447,
    wearable_ids: [319, 314],
  },
  {
    genesis_token_id: 20448,
    wearable_ids: [403, 296],
  },
  {
    genesis_token_id: 20449,
    wearable_ids: [276, 266],
  },
  {
    genesis_token_id: 20450,
    wearable_ids: [347, 364],
  },
  {
    genesis_token_id: 20451,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 20452,
    wearable_ids: [363, 364],
  },
  {
    genesis_token_id: 20453,
    wearable_ids: [257, 397],
  },
  {
    genesis_token_id: 20454,
    wearable_ids: [371, 301],
  },
  {
    genesis_token_id: 20455,
    wearable_ids: [311, 341],
  },
  {
    genesis_token_id: 20456,
    wearable_ids: [258, 361],
  },
  {
    genesis_token_id: 20457,
    wearable_ids: [336, 286],
  },
  {
    genesis_token_id: 20458,
    wearable_ids: [337, 413],
  },
  {
    genesis_token_id: 20459,
    wearable_ids: [338, 271],
  },
  {
    genesis_token_id: 20460,
    wearable_ids: [397, 258],
  },
  {
    genesis_token_id: 20461,
    wearable_ids: [296, 339],
  },
  {
    genesis_token_id: 20462,
    wearable_ids: [348, 378],
  },
  {
    genesis_token_id: 20463,
    wearable_ids: [297, 382],
  },
  {
    genesis_token_id: 20464,
    wearable_ids: [407, 352],
  },
  {
    genesis_token_id: 20465,
    wearable_ids: [434, 423],
  },
  {
    genesis_token_id: 20466,
    wearable_ids: [420, 437],
  },
  {
    genesis_token_id: 20467,
    wearable_ids: [436, 307],
  },
  {
    genesis_token_id: 20468,
    wearable_ids: [355, 340],
  },
  {
    genesis_token_id: 20469,
    wearable_ids: [316, 266],
  },
  {
    genesis_token_id: 20470,
    wearable_ids: [386, 331],
  },
  {
    genesis_token_id: 20471,
    wearable_ids: [404, 373],
  },
  {
    genesis_token_id: 20472,
    wearable_ids: [272, 417],
  },
  {
    genesis_token_id: 20473,
    wearable_ids: [316, 406],
  },
  {
    genesis_token_id: 20474,
    wearable_ids: [406, 266],
  },
  {
    genesis_token_id: 20475,
    wearable_ids: [274, 291],
  },
  {
    genesis_token_id: 20476,
    wearable_ids: [300, 331],
  },
  {
    genesis_token_id: 20477,
    wearable_ids: [409, 365],
  },
  {
    genesis_token_id: 20478,
    wearable_ids: [295, 373],
  },
  {
    genesis_token_id: 20479,
    wearable_ids: [316, 248],
  },
  {
    genesis_token_id: 20480,
    wearable_ids: [346, 371],
  },
  {
    genesis_token_id: 20481,
    wearable_ids: [403, 308],
  },
  {
    genesis_token_id: 20482,
    wearable_ids: [268, 288],
  },
  {
    genesis_token_id: 20483,
    wearable_ids: [354, 443],
  },
  {
    genesis_token_id: 20484,
    wearable_ids: [259, 351],
  },
  {
    genesis_token_id: 20485,
    wearable_ids: [258, 373],
  },
  {
    genesis_token_id: 20486,
    wearable_ids: [317, 441],
  },
  {
    genesis_token_id: 20487,
    wearable_ids: [423, 322],
  },
  {
    genesis_token_id: 20488,
    wearable_ids: [268, 275],
  },
  {
    genesis_token_id: 20489,
    wearable_ids: [325, 411],
  },
  {
    genesis_token_id: 20490,
    wearable_ids: [375, 306],
  },
  {
    genesis_token_id: 20491,
    wearable_ids: [386, 255],
  },
  {
    genesis_token_id: 20492,
    wearable_ids: [436, 355],
  },
  {
    genesis_token_id: 20493,
    wearable_ids: [259, 389],
  },
  {
    genesis_token_id: 20494,
    wearable_ids: [378, 370],
  },
  {
    genesis_token_id: 20495,
    wearable_ids: [278, 344],
  },
  {
    genesis_token_id: 20496,
    wearable_ids: [352, 278],
  },
  {
    genesis_token_id: 20497,
    wearable_ids: [339, 316],
  },
  {
    genesis_token_id: 20498,
    wearable_ids: [317, 299],
  },
  {
    genesis_token_id: 20499,
    wearable_ids: [395, 426],
  },
  {
    genesis_token_id: 20500,
    wearable_ids: [343, 304],
  },
  {
    genesis_token_id: 20501,
    wearable_ids: [335, 436],
  },
  {
    genesis_token_id: 20502,
    wearable_ids: [248, 406],
  },
  {
    genesis_token_id: 20503,
    wearable_ids: [385, 319],
  },
  {
    genesis_token_id: 20504,
    wearable_ids: [375, 392],
  },
  {
    genesis_token_id: 20505,
    wearable_ids: [368, 246],
  },
  {
    genesis_token_id: 20506,
    wearable_ids: [256, 355],
  },
  {
    genesis_token_id: 20507,
    wearable_ids: [383, 276],
  },
  {
    genesis_token_id: 20508,
    wearable_ids: [335, 416],
  },
  {
    genesis_token_id: 20509,
    wearable_ids: [316, 386],
  },
  {
    genesis_token_id: 20510,
    wearable_ids: [324, 347],
  },
  {
    genesis_token_id: 20511,
    wearable_ids: [256, 433],
  },
  {
    genesis_token_id: 20512,
    wearable_ids: [362, 313],
  },
  {
    genesis_token_id: 20513,
    wearable_ids: [425, 365],
  },
  {
    genesis_token_id: 20514,
    wearable_ids: [284, 287],
  },
  {
    genesis_token_id: 20515,
    wearable_ids: [383, 435],
  },
  {
    genesis_token_id: 20516,
    wearable_ids: [257, 413],
  },
  {
    genesis_token_id: 20517,
    wearable_ids: [303, 258],
  },
  {
    genesis_token_id: 20518,
    wearable_ids: [296, 431],
  },
  {
    genesis_token_id: 20519,
    wearable_ids: [349, 258],
  },
  {
    genesis_token_id: 20520,
    wearable_ids: [289, 276],
  },
  {
    genesis_token_id: 20521,
    wearable_ids: [263, 268],
  },
  {
    genesis_token_id: 20522,
    wearable_ids: [253, 419],
  },
  {
    genesis_token_id: 20523,
    wearable_ids: [332, 350],
  },
  {
    genesis_token_id: 20524,
    wearable_ids: [355, 431],
  },
  {
    genesis_token_id: 20525,
    wearable_ids: [409, 434],
  },
  {
    genesis_token_id: 20526,
    wearable_ids: [289, 332],
  },
  {
    genesis_token_id: 20527,
    wearable_ids: [370, 316],
  },
  {
    genesis_token_id: 20528,
    wearable_ids: [274, 303],
  },
  {
    genesis_token_id: 20529,
    wearable_ids: [319, 440],
  },
  {
    genesis_token_id: 20530,
    wearable_ids: [407, 403],
  },
  {
    genesis_token_id: 20531,
    wearable_ids: [408, 344],
  },
  {
    genesis_token_id: 20532,
    wearable_ids: [253, 437],
  },
  {
    genesis_token_id: 20533,
    wearable_ids: [308, 382],
  },
  {
    genesis_token_id: 20534,
    wearable_ids: [432, 296],
  },
  {
    genesis_token_id: 20535,
    wearable_ids: [408, 278],
  },
  {
    genesis_token_id: 20536,
    wearable_ids: [289, 279],
  },
  {
    genesis_token_id: 20537,
    wearable_ids: [355, 394],
  },
  {
    genesis_token_id: 20538,
    wearable_ids: [317, 292],
  },
  {
    genesis_token_id: 20539,
    wearable_ids: [400, 281],
  },
  {
    genesis_token_id: 20540,
    wearable_ids: [336, 342],
  },
  {
    genesis_token_id: 20541,
    wearable_ids: [256, 306],
  },
  {
    genesis_token_id: 20542,
    wearable_ids: [386, 266],
  },
  {
    genesis_token_id: 20543,
    wearable_ids: [273, 289],
  },
  {
    genesis_token_id: 20544,
    wearable_ids: [378, 347],
  },
  {
    genesis_token_id: 20545,
    wearable_ids: [400, 396],
  },
  {
    genesis_token_id: 20546,
    wearable_ids: [385, 312],
  },
  {
    genesis_token_id: 20547,
    wearable_ids: [338, 325],
  },
  {
    genesis_token_id: 20548,
    wearable_ids: [363, 362],
  },
  {
    genesis_token_id: 20549,
    wearable_ids: [256, 440],
  },
  {
    genesis_token_id: 20550,
    wearable_ids: [339, 254],
  },
  {
    genesis_token_id: 20551,
    wearable_ids: [256, 257],
  },
  {
    genesis_token_id: 20552,
    wearable_ids: [426, 393],
  },
  {
    genesis_token_id: 20553,
    wearable_ids: [286, 426],
  },
  {
    genesis_token_id: 20554,
    wearable_ids: [378, 251],
  },
  {
    genesis_token_id: 20555,
    wearable_ids: [332, 353],
  },
  {
    genesis_token_id: 20556,
    wearable_ids: [348, 293],
  },
  {
    genesis_token_id: 20557,
    wearable_ids: [410, 332],
  },
  {
    genesis_token_id: 20558,
    wearable_ids: [247, 342],
  },
  {
    genesis_token_id: 20559,
    wearable_ids: [268, 302],
  },
  {
    genesis_token_id: 20560,
    wearable_ids: [276, 274],
  },
  {
    genesis_token_id: 20561,
    wearable_ids: [277, 387],
  },
  {
    genesis_token_id: 20562,
    wearable_ids: [266, 443],
  },
  {
    genesis_token_id: 20563,
    wearable_ids: [280, 336],
  },
  {
    genesis_token_id: 20564,
    wearable_ids: [303, 362],
  },
  {
    genesis_token_id: 20565,
    wearable_ids: [337, 441],
  },
  {
    genesis_token_id: 20566,
    wearable_ids: [362, 268],
  },
  {
    genesis_token_id: 20567,
    wearable_ids: [378, 423],
  },
  {
    genesis_token_id: 20568,
    wearable_ids: [338, 445],
  },
  {
    genesis_token_id: 20569,
    wearable_ids: [300, 299],
  },
  {
    genesis_token_id: 20570,
    wearable_ids: [301, 296],
  },
  {
    genesis_token_id: 20571,
    wearable_ids: [331, 417],
  },
  {
    genesis_token_id: 20572,
    wearable_ids: [287, 393],
  },
  {
    genesis_token_id: 20573,
    wearable_ids: [306, 366],
  },
  {
    genesis_token_id: 20574,
    wearable_ids: [442, 289],
  },
  {
    genesis_token_id: 20575,
    wearable_ids: [442, 292],
  },
  {
    genesis_token_id: 20576,
    wearable_ids: [287, 408],
  },
  {
    genesis_token_id: 20577,
    wearable_ids: [371, 356],
  },
  {
    genesis_token_id: 20578,
    wearable_ids: [299, 275],
  },
  {
    genesis_token_id: 20579,
    wearable_ids: [251, 442],
  },
  {
    genesis_token_id: 20580,
    wearable_ids: [409, 385],
  },
  {
    genesis_token_id: 20581,
    wearable_ids: [297, 290],
  },
  {
    genesis_token_id: 20582,
    wearable_ids: [371, 262],
  },
  {
    genesis_token_id: 20583,
    wearable_ids: [436, 352],
  },
  {
    genesis_token_id: 20584,
    wearable_ids: [316, 397],
  },
  {
    genesis_token_id: 20585,
    wearable_ids: [399, 314],
  },
  {
    genesis_token_id: 20586,
    wearable_ids: [314, 402],
  },
  {
    genesis_token_id: 20587,
    wearable_ids: [339, 427],
  },
  {
    genesis_token_id: 20588,
    wearable_ids: [271, 384],
  },
  {
    genesis_token_id: 20589,
    wearable_ids: [437, 345],
  },
  {
    genesis_token_id: 20590,
    wearable_ids: [403, 270],
  },
  {
    genesis_token_id: 20591,
    wearable_ids: [295, 284],
  },
  {
    genesis_token_id: 20592,
    wearable_ids: [363, 339],
  },
  {
    genesis_token_id: 20593,
    wearable_ids: [299, 342],
  },
  {
    genesis_token_id: 20594,
    wearable_ids: [365, 315],
  },
  {
    genesis_token_id: 20595,
    wearable_ids: [351, 422],
  },
  {
    genesis_token_id: 20596,
    wearable_ids: [319, 365],
  },
  {
    genesis_token_id: 20597,
    wearable_ids: [338, 442],
  },
  {
    genesis_token_id: 20598,
    wearable_ids: [306, 283],
  },
  {
    genesis_token_id: 20599,
    wearable_ids: [331, 389],
  },
  {
    genesis_token_id: 20600,
    wearable_ids: [370, 276],
  },
  {
    genesis_token_id: 20601,
    wearable_ids: [370, 430],
  },
  {
    genesis_token_id: 20602,
    wearable_ids: [272, 317],
  },
  {
    genesis_token_id: 20603,
    wearable_ids: [385, 327],
  },
  {
    genesis_token_id: 20604,
    wearable_ids: [266, 362],
  },
  {
    genesis_token_id: 20605,
    wearable_ids: [284, 407],
  },
  {
    genesis_token_id: 20606,
    wearable_ids: [336, 377],
  },
  {
    genesis_token_id: 20607,
    wearable_ids: [339, 351],
  },
  {
    genesis_token_id: 20608,
    wearable_ids: [300, 431],
  },
  {
    genesis_token_id: 20609,
    wearable_ids: [349, 409],
  },
  {
    genesis_token_id: 20610,
    wearable_ids: [291, 385],
  },
  {
    genesis_token_id: 20611,
    wearable_ids: [406, 409],
  },
  {
    genesis_token_id: 20612,
    wearable_ids: [303, 304],
  },
  {
    genesis_token_id: 20613,
    wearable_ids: [364, 382],
  },
  {
    genesis_token_id: 20614,
    wearable_ids: [270, 251],
  },
  {
    genesis_token_id: 20615,
    wearable_ids: [410, 436],
  },
  {
    genesis_token_id: 20616,
    wearable_ids: [399, 339],
  },
  {
    genesis_token_id: 20617,
    wearable_ids: [272, 433],
  },
  {
    genesis_token_id: 20618,
    wearable_ids: [303, 255],
  },
  {
    genesis_token_id: 20619,
    wearable_ids: [280, 253],
  },
  {
    genesis_token_id: 20620,
    wearable_ids: [337, 326],
  },
  {
    genesis_token_id: 20621,
    wearable_ids: [406, 283],
  },
  {
    genesis_token_id: 20622,
    wearable_ids: [443, 375],
  },
  {
    genesis_token_id: 20623,
    wearable_ids: [325, 292],
  },
  {
    genesis_token_id: 20624,
    wearable_ids: [370, 304],
  },
  {
    genesis_token_id: 20625,
    wearable_ids: [378, 441],
  },
  {
    genesis_token_id: 20626,
    wearable_ids: [423, 295],
  },
  {
    genesis_token_id: 20627,
    wearable_ids: [336, 443],
  },
  {
    genesis_token_id: 20628,
    wearable_ids: [397, 374],
  },
  {
    genesis_token_id: 20629,
    wearable_ids: [424, 342],
  },
  {
    genesis_token_id: 20630,
    wearable_ids: [444, 277],
  },
  {
    genesis_token_id: 20631,
    wearable_ids: [372, 288],
  },
  {
    genesis_token_id: 20632,
    wearable_ids: [343, 438],
  },
  {
    genesis_token_id: 20633,
    wearable_ids: [426, 335],
  },
  {
    genesis_token_id: 20634,
    wearable_ids: [350, 297],
  },
  {
    genesis_token_id: 20635,
    wearable_ids: [273, 263],
  },
  {
    genesis_token_id: 20636,
    wearable_ids: [284, 435],
  },
  {
    genesis_token_id: 20637,
    wearable_ids: [434, 342],
  },
  {
    genesis_token_id: 20638,
    wearable_ids: [377, 288],
  },
  {
    genesis_token_id: 20639,
    wearable_ids: [410, 413],
  },
  {
    genesis_token_id: 20640,
    wearable_ids: [426, 276],
  },
  {
    genesis_token_id: 20641,
    wearable_ids: [425, 348],
  },
  {
    genesis_token_id: 20642,
    wearable_ids: [273, 382],
  },
  {
    genesis_token_id: 20643,
    wearable_ids: [351, 339],
  },
  {
    genesis_token_id: 20644,
    wearable_ids: [272, 350],
  },
  {
    genesis_token_id: 20645,
    wearable_ids: [437, 359],
  },
  {
    genesis_token_id: 20646,
    wearable_ids: [423, 256],
  },
  {
    genesis_token_id: 20647,
    wearable_ids: [348, 328],
  },
  {
    genesis_token_id: 20648,
    wearable_ids: [253, 272],
  },
  {
    genesis_token_id: 20649,
    wearable_ids: [289, 255],
  },
  {
    genesis_token_id: 20650,
    wearable_ids: [326, 377],
  },
  {
    genesis_token_id: 20651,
    wearable_ids: [336, 346],
  },
  {
    genesis_token_id: 20652,
    wearable_ids: [423, 337],
  },
  {
    genesis_token_id: 20653,
    wearable_ids: [344, 399],
  },
  {
    genesis_token_id: 20654,
    wearable_ids: [352, 432],
  },
  {
    genesis_token_id: 20655,
    wearable_ids: [428, 398],
  },
  {
    genesis_token_id: 20656,
    wearable_ids: [264, 405],
  },
  {
    genesis_token_id: 20657,
    wearable_ids: [336, 344],
  },
  {
    genesis_token_id: 20658,
    wearable_ids: [255, 434],
  },
  {
    genesis_token_id: 20659,
    wearable_ids: [319, 303],
  },
  {
    genesis_token_id: 20660,
    wearable_ids: [255, 370],
  },
  {
    genesis_token_id: 20661,
    wearable_ids: [404, 277],
  },
  {
    genesis_token_id: 20662,
    wearable_ids: [420, 330],
  },
  {
    genesis_token_id: 20663,
    wearable_ids: [436, 318],
  },
  {
    genesis_token_id: 20664,
    wearable_ids: [263, 373],
  },
  {
    genesis_token_id: 20665,
    wearable_ids: [409, 369],
  },
  {
    genesis_token_id: 20666,
    wearable_ids: [354, 441],
  },
  {
    genesis_token_id: 20667,
    wearable_ids: [444, 359],
  },
  {
    genesis_token_id: 20668,
    wearable_ids: [316, 422],
  },
  {
    genesis_token_id: 20669,
    wearable_ids: [253, 301],
  },
  {
    genesis_token_id: 20670,
    wearable_ids: [415, 339],
  },
  {
    genesis_token_id: 20671,
    wearable_ids: [301, 438],
  },
  {
    genesis_token_id: 20672,
    wearable_ids: [409, 435],
  },
  {
    genesis_token_id: 20673,
    wearable_ids: [445, 370],
  },
  {
    genesis_token_id: 20674,
    wearable_ids: [296, 247],
  },
  {
    genesis_token_id: 20675,
    wearable_ids: [315, 290],
  },
  {
    genesis_token_id: 20676,
    wearable_ids: [411, 423],
  },
  {
    genesis_token_id: 20677,
    wearable_ids: [316, 332],
  },
  {
    genesis_token_id: 20678,
    wearable_ids: [247, 416],
  },
  {
    genesis_token_id: 20679,
    wearable_ids: [274, 423],
  },
  {
    genesis_token_id: 20680,
    wearable_ids: [335, 361],
  },
  {
    genesis_token_id: 20681,
    wearable_ids: [397, 276],
  },
  {
    genesis_token_id: 20682,
    wearable_ids: [434, 382],
  },
  {
    genesis_token_id: 20683,
    wearable_ids: [425, 311],
  },
  {
    genesis_token_id: 20684,
    wearable_ids: [420, 378],
  },
  {
    genesis_token_id: 20685,
    wearable_ids: [415, 337],
  },
  {
    genesis_token_id: 20686,
    wearable_ids: [336, 395],
  },
  {
    genesis_token_id: 20687,
    wearable_ids: [248, 372],
  },
  {
    genesis_token_id: 20688,
    wearable_ids: [423, 407],
  },
  {
    genesis_token_id: 20689,
    wearable_ids: [387, 317],
  },
  {
    genesis_token_id: 20690,
    wearable_ids: [331, 263],
  },
  {
    genesis_token_id: 20691,
    wearable_ids: [442, 366],
  },
  {
    genesis_token_id: 20692,
    wearable_ids: [335, 292],
  },
  {
    genesis_token_id: 20693,
    wearable_ids: [303, 255],
  },
  {
    genesis_token_id: 20694,
    wearable_ids: [406, 363],
  },
  {
    genesis_token_id: 20695,
    wearable_ids: [284, 408],
  },
  {
    genesis_token_id: 20696,
    wearable_ids: [410, 336],
  },
  {
    genesis_token_id: 20697,
    wearable_ids: [247, 444],
  },
  {
    genesis_token_id: 20698,
    wearable_ids: [442, 443],
  },
  {
    genesis_token_id: 20699,
    wearable_ids: [403, 315],
  },
  {
    genesis_token_id: 20700,
    wearable_ids: [374, 422],
  },
  {
    genesis_token_id: 20701,
    wearable_ids: [335, 418],
  },
  {
    genesis_token_id: 20702,
    wearable_ids: [378, 328],
  },
  {
    genesis_token_id: 20703,
    wearable_ids: [332, 423],
  },
  {
    genesis_token_id: 20704,
    wearable_ids: [292, 430],
  },
  {
    genesis_token_id: 20705,
    wearable_ids: [422, 331],
  },
  {
    genesis_token_id: 20706,
    wearable_ids: [251, 270],
  },
  {
    genesis_token_id: 20707,
    wearable_ids: [415, 276],
  },
  {
    genesis_token_id: 20708,
    wearable_ids: [341, 362],
  },
  {
    genesis_token_id: 20709,
    wearable_ids: [432, 357],
  },
  {
    genesis_token_id: 20710,
    wearable_ids: [259, 344],
  },
  {
    genesis_token_id: 20711,
    wearable_ids: [284, 246],
  },
  {
    genesis_token_id: 20712,
    wearable_ids: [251, 338],
  },
  {
    genesis_token_id: 20713,
    wearable_ids: [364, 248],
  },
  {
    genesis_token_id: 20714,
    wearable_ids: [384, 286],
  },
  {
    genesis_token_id: 20715,
    wearable_ids: [442, 351],
  },
  {
    genesis_token_id: 20716,
    wearable_ids: [420, 435],
  },
  {
    genesis_token_id: 20717,
    wearable_ids: [308, 437],
  },
  {
    genesis_token_id: 20718,
    wearable_ids: [264, 360],
  },
  {
    genesis_token_id: 20719,
    wearable_ids: [274, 403],
  },
  {
    genesis_token_id: 20720,
    wearable_ids: [346, 400],
  },
  {
    genesis_token_id: 20721,
    wearable_ids: [443, 437],
  },
  {
    genesis_token_id: 20722,
    wearable_ids: [364, 331],
  },
  {
    genesis_token_id: 20723,
    wearable_ids: [424, 335],
  },
  {
    genesis_token_id: 20724,
    wearable_ids: [397, 266],
  },
  {
    genesis_token_id: 20725,
    wearable_ids: [370, 307],
  },
  {
    genesis_token_id: 20726,
    wearable_ids: [403, 337],
  },
  {
    genesis_token_id: 20727,
    wearable_ids: [247, 437],
  },
  {
    genesis_token_id: 20728,
    wearable_ids: [411, 368],
  },
  {
    genesis_token_id: 20729,
    wearable_ids: [289, 335],
  },
  {
    genesis_token_id: 20730,
    wearable_ids: [363, 384],
  },
  {
    genesis_token_id: 20731,
    wearable_ids: [271, 354],
  },
  {
    genesis_token_id: 20732,
    wearable_ids: [342, 346],
  },
  {
    genesis_token_id: 20733,
    wearable_ids: [274, 306],
  },
  {
    genesis_token_id: 20734,
    wearable_ids: [436, 324],
  },
  {
    genesis_token_id: 20735,
    wearable_ids: [389, 270],
  },
  {
    genesis_token_id: 20736,
    wearable_ids: [256, 274],
  },
  {
    genesis_token_id: 20737,
    wearable_ids: [415, 349],
  },
  {
    genesis_token_id: 20738,
    wearable_ids: [255, 272],
  },
  {
    genesis_token_id: 20739,
    wearable_ids: [411, 339],
  },
  {
    genesis_token_id: 20740,
    wearable_ids: [415, 410],
  },
  {
    genesis_token_id: 20741,
    wearable_ids: [270, 268],
  },
  {
    genesis_token_id: 20742,
    wearable_ids: [274, 254],
  },
  {
    genesis_token_id: 20743,
    wearable_ids: [335, 417],
  },
  {
    genesis_token_id: 20744,
    wearable_ids: [399, 319],
  },
  {
    genesis_token_id: 20745,
    wearable_ids: [286, 349],
  },
  {
    genesis_token_id: 20746,
    wearable_ids: [409, 277],
  },
  {
    genesis_token_id: 20747,
    wearable_ids: [287, 412],
  },
  {
    genesis_token_id: 20748,
    wearable_ids: [425, 343],
  },
  {
    genesis_token_id: 20749,
    wearable_ids: [290, 322],
  },
  {
    genesis_token_id: 20750,
    wearable_ids: [277, 325],
  },
  {
    genesis_token_id: 20751,
    wearable_ids: [376, 326],
  },
  {
    genesis_token_id: 20752,
    wearable_ids: [409, 369],
  },
  {
    genesis_token_id: 20753,
    wearable_ids: [337, 445],
  },
  {
    genesis_token_id: 20754,
    wearable_ids: [255, 256],
  },
  {
    genesis_token_id: 20755,
    wearable_ids: [415, 281],
  },
  {
    genesis_token_id: 20756,
    wearable_ids: [251, 324],
  },
  {
    genesis_token_id: 20757,
    wearable_ids: [389, 263],
  },
  {
    genesis_token_id: 20758,
    wearable_ids: [347, 275],
  },
  {
    genesis_token_id: 20759,
    wearable_ids: [277, 386],
  },
  {
    genesis_token_id: 20760,
    wearable_ids: [395, 286],
  },
  {
    genesis_token_id: 20761,
    wearable_ids: [411, 286],
  },
  {
    genesis_token_id: 20762,
    wearable_ids: [326, 443],
  },
  {
    genesis_token_id: 20763,
    wearable_ids: [382, 277],
  },
  {
    genesis_token_id: 20764,
    wearable_ids: [291, 407],
  },
  {
    genesis_token_id: 20765,
    wearable_ids: [433, 261],
  },
  {
    genesis_token_id: 20766,
    wearable_ids: [276, 296],
  },
  {
    genesis_token_id: 20767,
    wearable_ids: [295, 264],
  },
  {
    genesis_token_id: 20768,
    wearable_ids: [351, 335],
  },
  {
    genesis_token_id: 20769,
    wearable_ids: [434, 325],
  },
  {
    genesis_token_id: 20770,
    wearable_ids: [273, 296],
  },
  {
    genesis_token_id: 20771,
    wearable_ids: [365, 357],
  },
  {
    genesis_token_id: 20772,
    wearable_ids: [383, 362],
  },
  {
    genesis_token_id: 20773,
    wearable_ids: [268, 273],
  },
  {
    genesis_token_id: 20774,
    wearable_ids: [436, 400],
  },
  {
    genesis_token_id: 20775,
    wearable_ids: [251, 299],
  },
  {
    genesis_token_id: 20776,
    wearable_ids: [316, 403],
  },
  {
    genesis_token_id: 20777,
    wearable_ids: [336, 409],
  },
  {
    genesis_token_id: 20778,
    wearable_ids: [300, 304],
  },
  {
    genesis_token_id: 20779,
    wearable_ids: [413, 325],
  },
  {
    genesis_token_id: 20780,
    wearable_ids: [290, 341],
  },
  {
    genesis_token_id: 20781,
    wearable_ids: [325, 326],
  },
  {
    genesis_token_id: 20782,
    wearable_ids: [432, 249],
  },
  {
    genesis_token_id: 20783,
    wearable_ids: [397, 327],
  },
  {
    genesis_token_id: 20784,
    wearable_ids: [286, 444],
  },
  {
    genesis_token_id: 20785,
    wearable_ids: [407, 266],
  },
  {
    genesis_token_id: 20786,
    wearable_ids: [423, 346],
  },
  {
    genesis_token_id: 20787,
    wearable_ids: [289, 346],
  },
  {
    genesis_token_id: 20788,
    wearable_ids: [389, 406],
  },
  {
    genesis_token_id: 20789,
    wearable_ids: [325, 290],
  },
  {
    genesis_token_id: 20790,
    wearable_ids: [426, 371],
  },
  {
    genesis_token_id: 20791,
    wearable_ids: [428, 262],
  },
  {
    genesis_token_id: 20792,
    wearable_ids: [373, 341],
  },
  {
    genesis_token_id: 20793,
    wearable_ids: [251, 376],
  },
  {
    genesis_token_id: 20794,
    wearable_ids: [259, 404],
  },
  {
    genesis_token_id: 20795,
    wearable_ids: [265, 305],
  },
  {
    genesis_token_id: 20796,
    wearable_ids: [349, 347],
  },
  {
    genesis_token_id: 20797,
    wearable_ids: [413, 308],
  },
  {
    genesis_token_id: 20798,
    wearable_ids: [342, 392],
  },
  {
    genesis_token_id: 20799,
    wearable_ids: [396, 422],
  },
  {
    genesis_token_id: 20800,
    wearable_ids: [396, 297],
  },
  {
    genesis_token_id: 20801,
    wearable_ids: [325, 318],
  },
  {
    genesis_token_id: 20802,
    wearable_ids: [385, 396],
  },
  {
    genesis_token_id: 20803,
    wearable_ids: [291, 348],
  },
  {
    genesis_token_id: 20804,
    wearable_ids: [431, 412],
  },
  {
    genesis_token_id: 20805,
    wearable_ids: [337, 263],
  },
  {
    genesis_token_id: 20806,
    wearable_ids: [428, 407],
  },
  {
    genesis_token_id: 20807,
    wearable_ids: [286, 261],
  },
  {
    genesis_token_id: 20808,
    wearable_ids: [266, 433],
  },
  {
    genesis_token_id: 20809,
    wearable_ids: [437, 405],
  },
  {
    genesis_token_id: 20810,
    wearable_ids: [341, 347],
  },
  {
    genesis_token_id: 20811,
    wearable_ids: [363, 265],
  },
  {
    genesis_token_id: 20812,
    wearable_ids: [270, 365],
  },
  {
    genesis_token_id: 20813,
    wearable_ids: [308, 429],
  },
  {
    genesis_token_id: 20814,
    wearable_ids: [286, 404],
  },
  {
    genesis_token_id: 20815,
    wearable_ids: [294, 443],
  },
  {
    genesis_token_id: 20816,
    wearable_ids: [426, 315],
  },
  {
    genesis_token_id: 20817,
    wearable_ids: [277, 396],
  },
  {
    genesis_token_id: 20818,
    wearable_ids: [331, 307],
  },
  {
    genesis_token_id: 20819,
    wearable_ids: [348, 285],
  },
  {
    genesis_token_id: 20820,
    wearable_ids: [433, 399],
  },
  {
    genesis_token_id: 20821,
    wearable_ids: [259, 324],
  },
  {
    genesis_token_id: 20822,
    wearable_ids: [286, 361],
  },
  {
    genesis_token_id: 20823,
    wearable_ids: [436, 406],
  },
  {
    genesis_token_id: 20824,
    wearable_ids: [294, 406],
  },
  {
    genesis_token_id: 20825,
    wearable_ids: [258, 314],
  },
  {
    genesis_token_id: 20826,
    wearable_ids: [315, 324],
  },
  {
    genesis_token_id: 20827,
    wearable_ids: [399, 396],
  },
  {
    genesis_token_id: 20828,
    wearable_ids: [263, 348],
  },
  {
    genesis_token_id: 20829,
    wearable_ids: [415, 247],
  },
  {
    genesis_token_id: 20830,
    wearable_ids: [397, 331],
  },
  {
    genesis_token_id: 20831,
    wearable_ids: [315, 292],
  },
  {
    genesis_token_id: 20832,
    wearable_ids: [403, 295],
  },
  {
    genesis_token_id: 20833,
    wearable_ids: [428, 296],
  },
  {
    genesis_token_id: 20834,
    wearable_ids: [253, 296],
  },
  {
    genesis_token_id: 20835,
    wearable_ids: [326, 325],
  },
  {
    genesis_token_id: 20836,
    wearable_ids: [336, 302],
  },
  {
    genesis_token_id: 20837,
    wearable_ids: [276, 426],
  },
  {
    genesis_token_id: 20838,
    wearable_ids: [251, 377],
  },
  {
    genesis_token_id: 20839,
    wearable_ids: [251, 300],
  },
  {
    genesis_token_id: 20840,
    wearable_ids: [291, 400],
  },
  {
    genesis_token_id: 20841,
    wearable_ids: [341, 445],
  },
  {
    genesis_token_id: 20842,
    wearable_ids: [341, 250],
  },
  {
    genesis_token_id: 20843,
    wearable_ids: [369, 316],
  },
  {
    genesis_token_id: 20844,
    wearable_ids: [338, 375],
  },
  {
    genesis_token_id: 20845,
    wearable_ids: [432, 311],
  },
  {
    genesis_token_id: 20846,
    wearable_ids: [425, 339],
  },
  {
    genesis_token_id: 20847,
    wearable_ids: [289, 406],
  },
  {
    genesis_token_id: 20848,
    wearable_ids: [339, 301],
  },
  {
    genesis_token_id: 20849,
    wearable_ids: [408, 371],
  },
  {
    genesis_token_id: 20850,
    wearable_ids: [248, 298],
  },
  {
    genesis_token_id: 20851,
    wearable_ids: [362, 413],
  },
  {
    genesis_token_id: 20852,
    wearable_ids: [375, 372],
  },
  {
    genesis_token_id: 20853,
    wearable_ids: [290, 284],
  },
  {
    genesis_token_id: 20854,
    wearable_ids: [352, 278],
  },
  {
    genesis_token_id: 20855,
    wearable_ids: [248, 412],
  },
  {
    genesis_token_id: 20856,
    wearable_ids: [331, 342],
  },
  {
    genesis_token_id: 20857,
    wearable_ids: [362, 445],
  },
  {
    genesis_token_id: 20858,
    wearable_ids: [268, 335],
  },
  {
    genesis_token_id: 20859,
    wearable_ids: [272, 247],
  },
  {
    genesis_token_id: 20860,
    wearable_ids: [349, 276],
  },
  {
    genesis_token_id: 20861,
    wearable_ids: [373, 432],
  },
  {
    genesis_token_id: 20862,
    wearable_ids: [443, 404],
  },
  {
    genesis_token_id: 20863,
    wearable_ids: [310, 255],
  },
  {
    genesis_token_id: 20864,
    wearable_ids: [351, 280],
  },
  {
    genesis_token_id: 20865,
    wearable_ids: [263, 260],
  },
  {
    genesis_token_id: 20866,
    wearable_ids: [306, 324],
  },
  {
    genesis_token_id: 20867,
    wearable_ids: [343, 310],
  },
  {
    genesis_token_id: 20868,
    wearable_ids: [300, 326],
  },
  {
    genesis_token_id: 20869,
    wearable_ids: [325, 361],
  },
  {
    genesis_token_id: 20870,
    wearable_ids: [351, 310],
  },
  {
    genesis_token_id: 20871,
    wearable_ids: [273, 294],
  },
  {
    genesis_token_id: 20872,
    wearable_ids: [395, 306],
  },
  {
    genesis_token_id: 20873,
    wearable_ids: [403, 394],
  },
  {
    genesis_token_id: 20874,
    wearable_ids: [382, 420],
  },
  {
    genesis_token_id: 20875,
    wearable_ids: [404, 385],
  },
  {
    genesis_token_id: 20876,
    wearable_ids: [368, 337],
  },
  {
    genesis_token_id: 20877,
    wearable_ids: [271, 292],
  },
  {
    genesis_token_id: 20878,
    wearable_ids: [301, 440],
  },
  {
    genesis_token_id: 20879,
    wearable_ids: [350, 304],
  },
  {
    genesis_token_id: 20880,
    wearable_ids: [341, 432],
  },
  {
    genesis_token_id: 20881,
    wearable_ids: [308, 393],
  },
  {
    genesis_token_id: 20882,
    wearable_ids: [265, 287],
  },
  {
    genesis_token_id: 20883,
    wearable_ids: [331, 407],
  },
  {
    genesis_token_id: 20884,
    wearable_ids: [280, 422],
  },
  {
    genesis_token_id: 20885,
    wearable_ids: [304, 269],
  },
  {
    genesis_token_id: 20886,
    wearable_ids: [319, 260],
  },
  {
    genesis_token_id: 20887,
    wearable_ids: [442, 308],
  },
  {
    genesis_token_id: 20888,
    wearable_ids: [344, 270],
  },
  {
    genesis_token_id: 20889,
    wearable_ids: [338, 357],
  },
  {
    genesis_token_id: 20890,
    wearable_ids: [351, 361],
  },
  {
    genesis_token_id: 20891,
    wearable_ids: [291, 258],
  },
  {
    genesis_token_id: 20892,
    wearable_ids: [247, 352],
  },
  {
    genesis_token_id: 20893,
    wearable_ids: [396, 410],
  },
  {
    genesis_token_id: 20894,
    wearable_ids: [371, 431],
  },
  {
    genesis_token_id: 20895,
    wearable_ids: [287, 443],
  },
  {
    genesis_token_id: 20896,
    wearable_ids: [326, 366],
  },
  {
    genesis_token_id: 20897,
    wearable_ids: [284, 337],
  },
  {
    genesis_token_id: 20898,
    wearable_ids: [426, 425],
  },
  {
    genesis_token_id: 20899,
    wearable_ids: [406, 335],
  },
  {
    genesis_token_id: 20900,
    wearable_ids: [376, 301],
  },
  {
    genesis_token_id: 20901,
    wearable_ids: [396, 256],
  },
  {
    genesis_token_id: 20902,
    wearable_ids: [290, 402],
  },
  {
    genesis_token_id: 20903,
    wearable_ids: [340, 319],
  },
  {
    genesis_token_id: 20904,
    wearable_ids: [395, 378],
  },
  {
    genesis_token_id: 20905,
    wearable_ids: [306, 341],
  },
  {
    genesis_token_id: 20906,
    wearable_ids: [276, 292],
  },
  {
    genesis_token_id: 20907,
    wearable_ids: [373, 377],
  },
  {
    genesis_token_id: 20908,
    wearable_ids: [368, 259],
  },
  {
    genesis_token_id: 20909,
    wearable_ids: [276, 340],
  },
  {
    genesis_token_id: 20910,
    wearable_ids: [256, 362],
  },
  {
    genesis_token_id: 20911,
    wearable_ids: [326, 372],
  },
  {
    genesis_token_id: 20912,
    wearable_ids: [352, 443],
  },
  {
    genesis_token_id: 20913,
    wearable_ids: [284, 312],
  },
  {
    genesis_token_id: 20914,
    wearable_ids: [311, 294],
  },
  {
    genesis_token_id: 20915,
    wearable_ids: [254, 346],
  },
  {
    genesis_token_id: 20916,
    wearable_ids: [425, 343],
  },
  {
    genesis_token_id: 20917,
    wearable_ids: [292, 432],
  },
  {
    genesis_token_id: 20918,
    wearable_ids: [289, 364],
  },
  {
    genesis_token_id: 20919,
    wearable_ids: [248, 412],
  },
  {
    genesis_token_id: 20920,
    wearable_ids: [363, 288],
  },
  {
    genesis_token_id: 20921,
    wearable_ids: [378, 435],
  },
  {
    genesis_token_id: 20922,
    wearable_ids: [262, 247],
  },
  {
    genesis_token_id: 20923,
    wearable_ids: [278, 338],
  },
  {
    genesis_token_id: 20924,
    wearable_ids: [368, 300],
  },
  {
    genesis_token_id: 20925,
    wearable_ids: [368, 369],
  },
  {
    genesis_token_id: 20926,
    wearable_ids: [372, 365],
  },
  {
    genesis_token_id: 20927,
    wearable_ids: [343, 349],
  },
  {
    genesis_token_id: 20928,
    wearable_ids: [396, 370],
  },
  {
    genesis_token_id: 20929,
    wearable_ids: [437, 297],
  },
  {
    genesis_token_id: 20930,
    wearable_ids: [339, 266],
  },
  {
    genesis_token_id: 20931,
    wearable_ids: [415, 445],
  },
  {
    genesis_token_id: 20932,
    wearable_ids: [340, 260],
  },
  {
    genesis_token_id: 20933,
    wearable_ids: [354, 313],
  },
  {
    genesis_token_id: 20934,
    wearable_ids: [259, 364],
  },
  {
    genesis_token_id: 20935,
    wearable_ids: [362, 330],
  },
  {
    genesis_token_id: 20936,
    wearable_ids: [319, 360],
  },
  {
    genesis_token_id: 20937,
    wearable_ids: [346, 395],
  },
  {
    genesis_token_id: 20938,
    wearable_ids: [339, 385],
  },
  {
    genesis_token_id: 20939,
    wearable_ids: [368, 291],
  },
  {
    genesis_token_id: 20940,
    wearable_ids: [286, 389],
  },
  {
    genesis_token_id: 20941,
    wearable_ids: [382, 263],
  },
  {
    genesis_token_id: 20942,
    wearable_ids: [301, 294],
  },
  {
    genesis_token_id: 20943,
    wearable_ids: [270, 337],
  },
  {
    genesis_token_id: 20944,
    wearable_ids: [408, 296],
  },
  {
    genesis_token_id: 20945,
    wearable_ids: [336, 379],
  },
  {
    genesis_token_id: 20946,
    wearable_ids: [404, 428],
  },
  {
    genesis_token_id: 20947,
    wearable_ids: [412, 253],
  },
  {
    genesis_token_id: 20948,
    wearable_ids: [346, 375],
  },
  {
    genesis_token_id: 20949,
    wearable_ids: [351, 386],
  },
  {
    genesis_token_id: 20950,
    wearable_ids: [404, 424],
  },
  {
    genesis_token_id: 20951,
    wearable_ids: [424, 281],
  },
  {
    genesis_token_id: 20952,
    wearable_ids: [255, 335],
  },
  {
    genesis_token_id: 20953,
    wearable_ids: [338, 280],
  },
  {
    genesis_token_id: 20954,
    wearable_ids: [262, 340],
  },
  {
    genesis_token_id: 20955,
    wearable_ids: [420, 358],
  },
  {
    genesis_token_id: 20956,
    wearable_ids: [251, 430],
  },
  {
    genesis_token_id: 20957,
    wearable_ids: [436, 413],
  },
  {
    genesis_token_id: 20958,
    wearable_ids: [294, 287],
  },
  {
    genesis_token_id: 20959,
    wearable_ids: [253, 387],
  },
  {
    genesis_token_id: 20960,
    wearable_ids: [387, 271],
  },
  {
    genesis_token_id: 20961,
    wearable_ids: [389, 354],
  },
  {
    genesis_token_id: 20962,
    wearable_ids: [425, 347],
  },
  {
    genesis_token_id: 20963,
    wearable_ids: [339, 337],
  },
  {
    genesis_token_id: 20964,
    wearable_ids: [278, 414],
  },
  {
    genesis_token_id: 20965,
    wearable_ids: [412, 264],
  },
  {
    genesis_token_id: 20966,
    wearable_ids: [344, 266],
  },
  {
    genesis_token_id: 20967,
    wearable_ids: [286, 285],
  },
  {
    genesis_token_id: 20968,
    wearable_ids: [407, 434],
  },
  {
    genesis_token_id: 20969,
    wearable_ids: [247, 257],
  },
  {
    genesis_token_id: 20970,
    wearable_ids: [339, 410],
  },
  {
    genesis_token_id: 20971,
    wearable_ids: [343, 425],
  },
  {
    genesis_token_id: 20972,
    wearable_ids: [428, 306],
  },
  {
    genesis_token_id: 20973,
    wearable_ids: [341, 386],
  },
  {
    genesis_token_id: 20974,
    wearable_ids: [296, 359],
  },
  {
    genesis_token_id: 20975,
    wearable_ids: [314, 304],
  },
  {
    genesis_token_id: 20976,
    wearable_ids: [407, 341],
  },
  {
    genesis_token_id: 20977,
    wearable_ids: [262, 425],
  },
  {
    genesis_token_id: 20978,
    wearable_ids: [314, 391],
  },
  {
    genesis_token_id: 20979,
    wearable_ids: [297, 272],
  },
  {
    genesis_token_id: 20980,
    wearable_ids: [268, 248],
  },
  {
    genesis_token_id: 20981,
    wearable_ids: [428, 322],
  },
  {
    genesis_token_id: 20982,
    wearable_ids: [272, 410],
  },
  {
    genesis_token_id: 20983,
    wearable_ids: [270, 273],
  },
  {
    genesis_token_id: 20984,
    wearable_ids: [385, 322],
  },
  {
    genesis_token_id: 20985,
    wearable_ids: [432, 425],
  },
  {
    genesis_token_id: 20986,
    wearable_ids: [384, 256],
  },
  {
    genesis_token_id: 20987,
    wearable_ids: [339, 425],
  },
  {
    genesis_token_id: 20988,
    wearable_ids: [342, 267],
  },
  {
    genesis_token_id: 20989,
    wearable_ids: [375, 426],
  },
  {
    genesis_token_id: 20990,
    wearable_ids: [411, 251],
  },
  {
    genesis_token_id: 20991,
    wearable_ids: [268, 435],
  },
  {
    genesis_token_id: 20992,
    wearable_ids: [408, 368],
  },
  {
    genesis_token_id: 20993,
    wearable_ids: [278, 400],
  },
  {
    genesis_token_id: 20994,
    wearable_ids: [372, 424],
  },
  {
    genesis_token_id: 20995,
    wearable_ids: [341, 385],
  },
  {
    genesis_token_id: 20996,
    wearable_ids: [362, 248],
  },
  {
    genesis_token_id: 20997,
    wearable_ids: [287, 280],
  },
  {
    genesis_token_id: 20998,
    wearable_ids: [389, 320],
  },
  {
    genesis_token_id: 20999,
    wearable_ids: [377, 365],
  },
  {
    genesis_token_id: 21000,
    wearable_ids: [253, 415],
  },
  {
    genesis_token_id: 21001,
    wearable_ids: [342, 328],
  },
  {
    genesis_token_id: 21002,
    wearable_ids: [315, 374],
  },
  {
    genesis_token_id: 21003,
    wearable_ids: [256, 435],
  },
  {
    genesis_token_id: 21004,
    wearable_ids: [413, 263],
  },
  {
    genesis_token_id: 21005,
    wearable_ids: [386, 326],
  },
  {
    genesis_token_id: 21006,
    wearable_ids: [369, 404],
  },
  {
    genesis_token_id: 21007,
    wearable_ids: [396, 361],
  },
  {
    genesis_token_id: 21008,
    wearable_ids: [297, 310],
  },
  {
    genesis_token_id: 21009,
    wearable_ids: [349, 280],
  },
  {
    genesis_token_id: 21010,
    wearable_ids: [415, 247],
  },
  {
    genesis_token_id: 21011,
    wearable_ids: [368, 427],
  },
  {
    genesis_token_id: 21012,
    wearable_ids: [263, 407],
  },
  {
    genesis_token_id: 21013,
    wearable_ids: [384, 268],
  },
  {
    genesis_token_id: 21014,
    wearable_ids: [265, 368],
  },
  {
    genesis_token_id: 21015,
    wearable_ids: [399, 325],
  },
  {
    genesis_token_id: 21016,
    wearable_ids: [374, 299],
  },
  {
    genesis_token_id: 21017,
    wearable_ids: [387, 406],
  },
  {
    genesis_token_id: 21018,
    wearable_ids: [433, 281],
  },
  {
    genesis_token_id: 21019,
    wearable_ids: [363, 338],
  },
  {
    genesis_token_id: 21020,
    wearable_ids: [387, 423],
  },
  {
    genesis_token_id: 21021,
    wearable_ids: [272, 406],
  },
  {
    genesis_token_id: 21022,
    wearable_ids: [348, 368],
  },
  {
    genesis_token_id: 21023,
    wearable_ids: [342, 295],
  },
  {
    genesis_token_id: 21024,
    wearable_ids: [436, 437],
  },
  {
    genesis_token_id: 21025,
    wearable_ids: [413, 248],
  },
  {
    genesis_token_id: 21026,
    wearable_ids: [426, 339],
  },
  {
    genesis_token_id: 21027,
    wearable_ids: [253, 406],
  },
  {
    genesis_token_id: 21028,
    wearable_ids: [397, 431],
  },
  {
    genesis_token_id: 21029,
    wearable_ids: [432, 418],
  },
  {
    genesis_token_id: 21030,
    wearable_ids: [415, 362],
  },
  {
    genesis_token_id: 21031,
    wearable_ids: [442, 262],
  },
  {
    genesis_token_id: 21032,
    wearable_ids: [270, 400],
  },
  {
    genesis_token_id: 21033,
    wearable_ids: [383, 338],
  },
  {
    genesis_token_id: 21034,
    wearable_ids: [369, 254],
  },
  {
    genesis_token_id: 21035,
    wearable_ids: [271, 326],
  },
  {
    genesis_token_id: 21036,
    wearable_ids: [314, 349],
  },
  {
    genesis_token_id: 21037,
    wearable_ids: [306, 442],
  },
  {
    genesis_token_id: 21038,
    wearable_ids: [326, 387],
  },
  {
    genesis_token_id: 21039,
    wearable_ids: [372, 346],
  },
  {
    genesis_token_id: 21040,
    wearable_ids: [420, 364],
  },
  {
    genesis_token_id: 21041,
    wearable_ids: [258, 291],
  },
  {
    genesis_token_id: 21042,
    wearable_ids: [422, 378],
  },
  {
    genesis_token_id: 21043,
    wearable_ids: [373, 257],
  },
  {
    genesis_token_id: 21044,
    wearable_ids: [276, 314],
  },
  {
    genesis_token_id: 21045,
    wearable_ids: [301, 340],
  },
  {
    genesis_token_id: 21046,
    wearable_ids: [434, 291],
  },
  {
    genesis_token_id: 21047,
    wearable_ids: [290, 418],
  },
  {
    genesis_token_id: 21048,
    wearable_ids: [400, 409],
  },
  {
    genesis_token_id: 21049,
    wearable_ids: [304, 432],
  },
  {
    genesis_token_id: 21050,
    wearable_ids: [382, 299],
  },
  {
    genesis_token_id: 21051,
    wearable_ids: [376, 397],
  },
  {
    genesis_token_id: 21052,
    wearable_ids: [317, 369],
  },
  {
    genesis_token_id: 21053,
    wearable_ids: [258, 382],
  },
  {
    genesis_token_id: 21054,
    wearable_ids: [404, 267],
  },
  {
    genesis_token_id: 21055,
    wearable_ids: [253, 342],
  },
  {
    genesis_token_id: 21056,
    wearable_ids: [369, 411],
  },
  {
    genesis_token_id: 21057,
    wearable_ids: [373, 358],
  },
  {
    genesis_token_id: 21058,
    wearable_ids: [368, 268],
  },
  {
    genesis_token_id: 21059,
    wearable_ids: [443, 442],
  },
  {
    genesis_token_id: 21060,
    wearable_ids: [408, 369],
  },
  {
    genesis_token_id: 21061,
    wearable_ids: [354, 426],
  },
  {
    genesis_token_id: 21062,
    wearable_ids: [403, 435],
  },
  {
    genesis_token_id: 21063,
    wearable_ids: [378, 266],
  },
  {
    genesis_token_id: 21064,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 21065,
    wearable_ids: [443, 375],
  },
  {
    genesis_token_id: 21066,
    wearable_ids: [347, 378],
  },
  {
    genesis_token_id: 21067,
    wearable_ids: [399, 368],
  },
  {
    genesis_token_id: 21068,
    wearable_ids: [300, 375],
  },
  {
    genesis_token_id: 21069,
    wearable_ids: [308, 365],
  },
  {
    genesis_token_id: 21070,
    wearable_ids: [442, 384],
  },
  {
    genesis_token_id: 21071,
    wearable_ids: [341, 287],
  },
  {
    genesis_token_id: 21072,
    wearable_ids: [268, 382],
  },
  {
    genesis_token_id: 21073,
    wearable_ids: [382, 396],
  },
  {
    genesis_token_id: 21074,
    wearable_ids: [311, 263],
  },
  {
    genesis_token_id: 21075,
    wearable_ids: [386, 266],
  },
  {
    genesis_token_id: 21076,
    wearable_ids: [348, 403],
  },
  {
    genesis_token_id: 21077,
    wearable_ids: [272, 268],
  },
  {
    genesis_token_id: 21078,
    wearable_ids: [410, 360],
  },
  {
    genesis_token_id: 21079,
    wearable_ids: [276, 308],
  },
  {
    genesis_token_id: 21080,
    wearable_ids: [337, 260],
  },
  {
    genesis_token_id: 21081,
    wearable_ids: [355, 403],
  },
  {
    genesis_token_id: 21082,
    wearable_ids: [319, 276],
  },
  {
    genesis_token_id: 21083,
    wearable_ids: [365, 296],
  },
  {
    genesis_token_id: 21084,
    wearable_ids: [290, 427],
  },
  {
    genesis_token_id: 21085,
    wearable_ids: [362, 357],
  },
  {
    genesis_token_id: 21086,
    wearable_ids: [271, 344],
  },
  {
    genesis_token_id: 21087,
    wearable_ids: [368, 377],
  },
  {
    genesis_token_id: 21088,
    wearable_ids: [406, 376],
  },
  {
    genesis_token_id: 21089,
    wearable_ids: [336, 354],
  },
  {
    genesis_token_id: 21090,
    wearable_ids: [432, 335],
  },
  {
    genesis_token_id: 21091,
    wearable_ids: [248, 345],
  },
  {
    genesis_token_id: 21092,
    wearable_ids: [268, 284],
  },
  {
    genesis_token_id: 21093,
    wearable_ids: [295, 322],
  },
  {
    genesis_token_id: 21094,
    wearable_ids: [341, 394],
  },
  {
    genesis_token_id: 21095,
    wearable_ids: [299, 377],
  },
  {
    genesis_token_id: 21096,
    wearable_ids: [423, 271],
  },
  {
    genesis_token_id: 21097,
    wearable_ids: [266, 438],
  },
  {
    genesis_token_id: 21098,
    wearable_ids: [400, 356],
  },
  {
    genesis_token_id: 21099,
    wearable_ids: [423, 298],
  },
  {
    genesis_token_id: 21100,
    wearable_ids: [308, 304],
  },
  {
    genesis_token_id: 21101,
    wearable_ids: [331, 324],
  },
  {
    genesis_token_id: 21102,
    wearable_ids: [253, 324],
  },
  {
    genesis_token_id: 21103,
    wearable_ids: [289, 360],
  },
  {
    genesis_token_id: 21104,
    wearable_ids: [299, 419],
  },
  {
    genesis_token_id: 21105,
    wearable_ids: [291, 292],
  },
  {
    genesis_token_id: 21106,
    wearable_ids: [431, 425],
  },
  {
    genesis_token_id: 21107,
    wearable_ids: [254, 386],
  },
  {
    genesis_token_id: 21108,
    wearable_ids: [370, 376],
  },
  {
    genesis_token_id: 21109,
    wearable_ids: [423, 349],
  },
  {
    genesis_token_id: 21110,
    wearable_ids: [382, 428],
  },
  {
    genesis_token_id: 21111,
    wearable_ids: [316, 433],
  },
  {
    genesis_token_id: 21112,
    wearable_ids: [272, 323],
  },
  {
    genesis_token_id: 21113,
    wearable_ids: [370, 287],
  },
  {
    genesis_token_id: 21114,
    wearable_ids: [271, 411],
  },
  {
    genesis_token_id: 21115,
    wearable_ids: [326, 300],
  },
  {
    genesis_token_id: 21116,
    wearable_ids: [287, 336],
  },
  {
    genesis_token_id: 21117,
    wearable_ids: [296, 325],
  },
  {
    genesis_token_id: 21118,
    wearable_ids: [338, 255],
  },
  {
    genesis_token_id: 21119,
    wearable_ids: [274, 251],
  },
  {
    genesis_token_id: 21120,
    wearable_ids: [271, 310],
  },
  {
    genesis_token_id: 21121,
    wearable_ids: [271, 362],
  },
  {
    genesis_token_id: 21122,
    wearable_ids: [406, 308],
  },
  {
    genesis_token_id: 21123,
    wearable_ids: [324, 350],
  },
  {
    genesis_token_id: 21124,
    wearable_ids: [294, 339],
  },
  {
    genesis_token_id: 21125,
    wearable_ids: [326, 253],
  },
  {
    genesis_token_id: 21126,
    wearable_ids: [399, 303],
  },
  {
    genesis_token_id: 21127,
    wearable_ids: [407, 445],
  },
  {
    genesis_token_id: 21128,
    wearable_ids: [378, 265],
  },
  {
    genesis_token_id: 21129,
    wearable_ids: [331, 435],
  },
  {
    genesis_token_id: 21130,
    wearable_ids: [332, 341],
  },
  {
    genesis_token_id: 21131,
    wearable_ids: [255, 300],
  },
  {
    genesis_token_id: 21132,
    wearable_ids: [271, 406],
  },
  {
    genesis_token_id: 21133,
    wearable_ids: [340, 342],
  },
  {
    genesis_token_id: 21134,
    wearable_ids: [372, 396],
  },
  {
    genesis_token_id: 21135,
    wearable_ids: [325, 337],
  },
  {
    genesis_token_id: 21136,
    wearable_ids: [326, 288],
  },
  {
    genesis_token_id: 21137,
    wearable_ids: [332, 272],
  },
  {
    genesis_token_id: 21138,
    wearable_ids: [259, 299],
  },
  {
    genesis_token_id: 21139,
    wearable_ids: [422, 295],
  },
  {
    genesis_token_id: 21140,
    wearable_ids: [399, 410],
  },
  {
    genesis_token_id: 21141,
    wearable_ids: [277, 423],
  },
  {
    genesis_token_id: 21142,
    wearable_ids: [306, 387],
  },
  {
    genesis_token_id: 21143,
    wearable_ids: [371, 431],
  },
  {
    genesis_token_id: 21144,
    wearable_ids: [292, 343],
  },
  {
    genesis_token_id: 21145,
    wearable_ids: [347, 344],
  },
  {
    genesis_token_id: 21146,
    wearable_ids: [407, 384],
  },
  {
    genesis_token_id: 21147,
    wearable_ids: [294, 411],
  },
  {
    genesis_token_id: 21148,
    wearable_ids: [248, 338],
  },
  {
    genesis_token_id: 21149,
    wearable_ids: [340, 304],
  },
  {
    genesis_token_id: 21150,
    wearable_ids: [262, 268],
  },
  {
    genesis_token_id: 21151,
    wearable_ids: [415, 377],
  },
  {
    genesis_token_id: 21152,
    wearable_ids: [349, 300],
  },
  {
    genesis_token_id: 21153,
    wearable_ids: [299, 292],
  },
  {
    genesis_token_id: 21154,
    wearable_ids: [413, 299],
  },
  {
    genesis_token_id: 21155,
    wearable_ids: [304, 308],
  },
  {
    genesis_token_id: 21156,
    wearable_ids: [431, 361],
  },
  {
    genesis_token_id: 21157,
    wearable_ids: [300, 352],
  },
  {
    genesis_token_id: 21158,
    wearable_ids: [263, 291],
  },
  {
    genesis_token_id: 21159,
    wearable_ids: [266, 399],
  },
  {
    genesis_token_id: 21160,
    wearable_ids: [443, 253],
  },
  {
    genesis_token_id: 21161,
    wearable_ids: [257, 433],
  },
  {
    genesis_token_id: 21162,
    wearable_ids: [331, 296],
  },
  {
    genesis_token_id: 21163,
    wearable_ids: [444, 296],
  },
  {
    genesis_token_id: 21164,
    wearable_ids: [286, 420],
  },
  {
    genesis_token_id: 21165,
    wearable_ids: [265, 344],
  },
  {
    genesis_token_id: 21166,
    wearable_ids: [348, 435],
  },
  {
    genesis_token_id: 21167,
    wearable_ids: [403, 255],
  },
  {
    genesis_token_id: 21168,
    wearable_ids: [435, 328],
  },
  {
    genesis_token_id: 21169,
    wearable_ids: [376, 255],
  },
  {
    genesis_token_id: 21170,
    wearable_ids: [354, 399],
  },
  {
    genesis_token_id: 21171,
    wearable_ids: [304, 257],
  },
  {
    genesis_token_id: 21172,
    wearable_ids: [384, 399],
  },
  {
    genesis_token_id: 21173,
    wearable_ids: [264, 326],
  },
  {
    genesis_token_id: 21174,
    wearable_ids: [420, 409],
  },
  {
    genesis_token_id: 21175,
    wearable_ids: [346, 255],
  },
  {
    genesis_token_id: 21176,
    wearable_ids: [264, 394],
  },
  {
    genesis_token_id: 21177,
    wearable_ids: [411, 343],
  },
  {
    genesis_token_id: 21178,
    wearable_ids: [424, 435],
  },
  {
    genesis_token_id: 21179,
    wearable_ids: [324, 333],
  },
  {
    genesis_token_id: 21180,
    wearable_ids: [276, 326],
  },
  {
    genesis_token_id: 21181,
    wearable_ids: [253, 340],
  },
  {
    genesis_token_id: 21182,
    wearable_ids: [423, 285],
  },
  {
    genesis_token_id: 21183,
    wearable_ids: [336, 438],
  },
  {
    genesis_token_id: 21184,
    wearable_ids: [434, 371],
  },
  {
    genesis_token_id: 21185,
    wearable_ids: [369, 407],
  },
  {
    genesis_token_id: 21186,
    wearable_ids: [339, 314],
  },
  {
    genesis_token_id: 21187,
    wearable_ids: [264, 251],
  },
  {
    genesis_token_id: 21188,
    wearable_ids: [300, 345],
  },
  {
    genesis_token_id: 21189,
    wearable_ids: [248, 279],
  },
  {
    genesis_token_id: 21190,
    wearable_ids: [384, 299],
  },
  {
    genesis_token_id: 21191,
    wearable_ids: [363, 389],
  },
  {
    genesis_token_id: 21192,
    wearable_ids: [346, 256],
  },
  {
    genesis_token_id: 21193,
    wearable_ids: [351, 426],
  },
  {
    genesis_token_id: 21194,
    wearable_ids: [303, 310],
  },
  {
    genesis_token_id: 21195,
    wearable_ids: [443, 436],
  },
  {
    genesis_token_id: 21196,
    wearable_ids: [347, 286],
  },
  {
    genesis_token_id: 21197,
    wearable_ids: [331, 426],
  },
  {
    genesis_token_id: 21198,
    wearable_ids: [429, 399],
  },
  {
    genesis_token_id: 21199,
    wearable_ids: [408, 403],
  },
  {
    genesis_token_id: 21200,
    wearable_ids: [332, 442],
  },
  {
    genesis_token_id: 21201,
    wearable_ids: [442, 391],
  },
  {
    genesis_token_id: 21202,
    wearable_ids: [365, 314],
  },
  {
    genesis_token_id: 21203,
    wearable_ids: [403, 265],
  },
  {
    genesis_token_id: 21204,
    wearable_ids: [300, 404],
  },
  {
    genesis_token_id: 21205,
    wearable_ids: [445, 375],
  },
  {
    genesis_token_id: 21206,
    wearable_ids: [315, 303],
  },
  {
    genesis_token_id: 21207,
    wearable_ids: [444, 375],
  },
  {
    genesis_token_id: 21208,
    wearable_ids: [364, 256],
  },
  {
    genesis_token_id: 21209,
    wearable_ids: [406, 280],
  },
  {
    genesis_token_id: 21210,
    wearable_ids: [407, 311],
  },
  {
    genesis_token_id: 21211,
    wearable_ids: [371, 395],
  },
  {
    genesis_token_id: 21212,
    wearable_ids: [290, 404],
  },
  {
    genesis_token_id: 21213,
    wearable_ids: [387, 432],
  },
  {
    genesis_token_id: 21214,
    wearable_ids: [400, 405],
  },
  {
    genesis_token_id: 21215,
    wearable_ids: [429, 397],
  },
  {
    genesis_token_id: 21216,
    wearable_ids: [284, 403],
  },
  {
    genesis_token_id: 21217,
    wearable_ids: [284, 422],
  },
  {
    genesis_token_id: 21218,
    wearable_ids: [362, 354],
  },
  {
    genesis_token_id: 21219,
    wearable_ids: [295, 395],
  },
  {
    genesis_token_id: 21220,
    wearable_ids: [306, 408],
  },
  {
    genesis_token_id: 21221,
    wearable_ids: [280, 325],
  },
  {
    genesis_token_id: 21222,
    wearable_ids: [442, 257],
  },
  {
    genesis_token_id: 21223,
    wearable_ids: [431, 403],
  },
  {
    genesis_token_id: 21224,
    wearable_ids: [403, 259],
  },
  {
    genesis_token_id: 21225,
    wearable_ids: [276, 413],
  },
  {
    genesis_token_id: 21226,
    wearable_ids: [368, 423],
  },
  {
    genesis_token_id: 21227,
    wearable_ids: [347, 443],
  },
  {
    genesis_token_id: 21228,
    wearable_ids: [326, 297],
  },
  {
    genesis_token_id: 21229,
    wearable_ids: [339, 306],
  },
  {
    genesis_token_id: 21230,
    wearable_ids: [384, 316],
  },
  {
    genesis_token_id: 21231,
    wearable_ids: [420, 410],
  },
  {
    genesis_token_id: 21232,
    wearable_ids: [264, 317],
  },
  {
    genesis_token_id: 21233,
    wearable_ids: [378, 274],
  },
  {
    genesis_token_id: 21234,
    wearable_ids: [251, 378],
  },
  {
    genesis_token_id: 21235,
    wearable_ids: [351, 278],
  },
  {
    genesis_token_id: 21236,
    wearable_ids: [386, 263],
  },
  {
    genesis_token_id: 21237,
    wearable_ids: [294, 377],
  },
  {
    genesis_token_id: 21238,
    wearable_ids: [303, 355],
  },
  {
    genesis_token_id: 21239,
    wearable_ids: [314, 425],
  },
  {
    genesis_token_id: 21240,
    wearable_ids: [301, 263],
  },
  {
    genesis_token_id: 21241,
    wearable_ids: [372, 337],
  },
  {
    genesis_token_id: 21242,
    wearable_ids: [375, 372],
  },
  {
    genesis_token_id: 21243,
    wearable_ids: [247, 305],
  },
  {
    genesis_token_id: 21244,
    wearable_ids: [364, 317],
  },
  {
    genesis_token_id: 21245,
    wearable_ids: [368, 332],
  },
  {
    genesis_token_id: 21246,
    wearable_ids: [319, 371],
  },
  {
    genesis_token_id: 21247,
    wearable_ids: [422, 399],
  },
  {
    genesis_token_id: 21248,
    wearable_ids: [433, 306],
  },
  {
    genesis_token_id: 21249,
    wearable_ids: [387, 297],
  },
  {
    genesis_token_id: 21250,
    wearable_ids: [253, 412],
  },
  {
    genesis_token_id: 21251,
    wearable_ids: [424, 320],
  },
  {
    genesis_token_id: 21252,
    wearable_ids: [426, 279],
  },
  {
    genesis_token_id: 21253,
    wearable_ids: [287, 281],
  },
  {
    genesis_token_id: 21254,
    wearable_ids: [291, 358],
  },
  {
    genesis_token_id: 21255,
    wearable_ids: [397, 263],
  },
  {
    genesis_token_id: 21256,
    wearable_ids: [248, 358],
  },
  {
    genesis_token_id: 21257,
    wearable_ids: [310, 335],
  },
  {
    genesis_token_id: 21258,
    wearable_ids: [374, 295],
  },
  {
    genesis_token_id: 21259,
    wearable_ids: [304, 339],
  },
  {
    genesis_token_id: 21260,
    wearable_ids: [295, 332],
  },
  {
    genesis_token_id: 21261,
    wearable_ids: [383, 335],
  },
  {
    genesis_token_id: 21262,
    wearable_ids: [294, 334],
  },
  {
    genesis_token_id: 21263,
    wearable_ids: [437, 432],
  },
  {
    genesis_token_id: 21264,
    wearable_ids: [273, 382],
  },
  {
    genesis_token_id: 21265,
    wearable_ids: [271, 442],
  },
  {
    genesis_token_id: 21266,
    wearable_ids: [365, 419],
  },
  {
    genesis_token_id: 21267,
    wearable_ids: [424, 368],
  },
  {
    genesis_token_id: 21268,
    wearable_ids: [369, 325],
  },
  {
    genesis_token_id: 21269,
    wearable_ids: [289, 377],
  },
  {
    genesis_token_id: 21270,
    wearable_ids: [433, 331],
  },
  {
    genesis_token_id: 21271,
    wearable_ids: [422, 290],
  },
  {
    genesis_token_id: 21272,
    wearable_ids: [409, 387],
  },
  {
    genesis_token_id: 21273,
    wearable_ids: [403, 277],
  },
  {
    genesis_token_id: 21274,
    wearable_ids: [385, 341],
  },
  {
    genesis_token_id: 21275,
    wearable_ids: [325, 292],
  },
  {
    genesis_token_id: 21276,
    wearable_ids: [338, 352],
  },
  {
    genesis_token_id: 21277,
    wearable_ids: [424, 316],
  },
  {
    genesis_token_id: 21278,
    wearable_ids: [378, 377],
  },
  {
    genesis_token_id: 21279,
    wearable_ids: [273, 351],
  },
  {
    genesis_token_id: 21280,
    wearable_ids: [354, 442],
  },
  {
    genesis_token_id: 21281,
    wearable_ids: [354, 257],
  },
  {
    genesis_token_id: 21282,
    wearable_ids: [315, 429],
  },
  {
    genesis_token_id: 21283,
    wearable_ids: [308, 418],
  },
  {
    genesis_token_id: 21284,
    wearable_ids: [377, 300],
  },
  {
    genesis_token_id: 21285,
    wearable_ids: [265, 400],
  },
  {
    genesis_token_id: 21286,
    wearable_ids: [295, 363],
  },
  {
    genesis_token_id: 21287,
    wearable_ids: [294, 345],
  },
  {
    genesis_token_id: 21288,
    wearable_ids: [433, 359],
  },
  {
    genesis_token_id: 21289,
    wearable_ids: [396, 295],
  },
  {
    genesis_token_id: 21290,
    wearable_ids: [247, 271],
  },
  {
    genesis_token_id: 21291,
    wearable_ids: [347, 326],
  },
  {
    genesis_token_id: 21292,
    wearable_ids: [425, 269],
  },
  {
    genesis_token_id: 21293,
    wearable_ids: [399, 308],
  },
  {
    genesis_token_id: 21294,
    wearable_ids: [372, 289],
  },
  {
    genesis_token_id: 21295,
    wearable_ids: [373, 371],
  },
  {
    genesis_token_id: 21296,
    wearable_ids: [377, 395],
  },
  {
    genesis_token_id: 21297,
    wearable_ids: [290, 355],
  },
  {
    genesis_token_id: 21298,
    wearable_ids: [346, 423],
  },
  {
    genesis_token_id: 21299,
    wearable_ids: [352, 254],
  },
  {
    genesis_token_id: 21300,
    wearable_ids: [263, 325],
  },
  {
    genesis_token_id: 21301,
    wearable_ids: [348, 370],
  },
  {
    genesis_token_id: 21302,
    wearable_ids: [324, 251],
  },
  {
    genesis_token_id: 21303,
    wearable_ids: [290, 313],
  },
  {
    genesis_token_id: 21304,
    wearable_ids: [420, 391],
  },
  {
    genesis_token_id: 21305,
    wearable_ids: [315, 423],
  },
  {
    genesis_token_id: 21306,
    wearable_ids: [324, 277],
  },
  {
    genesis_token_id: 21307,
    wearable_ids: [270, 274],
  },
  {
    genesis_token_id: 21308,
    wearable_ids: [347, 420],
  },
  {
    genesis_token_id: 21309,
    wearable_ids: [422, 263],
  },
  {
    genesis_token_id: 21310,
    wearable_ids: [365, 277],
  },
  {
    genesis_token_id: 21311,
    wearable_ids: [385, 295],
  },
  {
    genesis_token_id: 21312,
    wearable_ids: [274, 412],
  },
  {
    genesis_token_id: 21313,
    wearable_ids: [428, 305],
  },
  {
    genesis_token_id: 21314,
    wearable_ids: [387, 343],
  },
  {
    genesis_token_id: 21315,
    wearable_ids: [415, 424],
  },
  {
    genesis_token_id: 21316,
    wearable_ids: [290, 406],
  },
  {
    genesis_token_id: 21317,
    wearable_ids: [354, 365],
  },
  {
    genesis_token_id: 21318,
    wearable_ids: [431, 336],
  },
  {
    genesis_token_id: 21319,
    wearable_ids: [432, 315],
  },
  {
    genesis_token_id: 21320,
    wearable_ids: [371, 258],
  },
  {
    genesis_token_id: 21321,
    wearable_ids: [262, 348],
  },
  {
    genesis_token_id: 21322,
    wearable_ids: [264, 325],
  },
  {
    genesis_token_id: 21323,
    wearable_ids: [316, 424],
  },
  {
    genesis_token_id: 21324,
    wearable_ids: [373, 335],
  },
  {
    genesis_token_id: 21325,
    wearable_ids: [406, 440],
  },
  {
    genesis_token_id: 21326,
    wearable_ids: [431, 248],
  },
  {
    genesis_token_id: 21327,
    wearable_ids: [265, 359],
  },
  {
    genesis_token_id: 21328,
    wearable_ids: [412, 364],
  },
  {
    genesis_token_id: 21329,
    wearable_ids: [350, 343],
  },
  {
    genesis_token_id: 21330,
    wearable_ids: [395, 302],
  },
  {
    genesis_token_id: 21331,
    wearable_ids: [413, 254],
  },
  {
    genesis_token_id: 21332,
    wearable_ids: [301, 362],
  },
  {
    genesis_token_id: 21333,
    wearable_ids: [403, 408],
  },
  {
    genesis_token_id: 21334,
    wearable_ids: [316, 444],
  },
  {
    genesis_token_id: 21335,
    wearable_ids: [408, 365],
  },
  {
    genesis_token_id: 21336,
    wearable_ids: [376, 248],
  },
  {
    genesis_token_id: 21337,
    wearable_ids: [347, 403],
  },
  {
    genesis_token_id: 21338,
    wearable_ids: [400, 281],
  },
  {
    genesis_token_id: 21339,
    wearable_ids: [432, 435],
  },
  {
    genesis_token_id: 21340,
    wearable_ids: [351, 437],
  },
  {
    genesis_token_id: 21341,
    wearable_ids: [280, 405],
  },
  {
    genesis_token_id: 21342,
    wearable_ids: [445, 346],
  },
  {
    genesis_token_id: 21343,
    wearable_ids: [297, 435],
  },
  {
    genesis_token_id: 21344,
    wearable_ids: [347, 291],
  },
  {
    genesis_token_id: 21345,
    wearable_ids: [303, 362],
  },
  {
    genesis_token_id: 21346,
    wearable_ids: [299, 411],
  },
  {
    genesis_token_id: 21347,
    wearable_ids: [324, 351],
  },
  {
    genesis_token_id: 21348,
    wearable_ids: [400, 306],
  },
  {
    genesis_token_id: 21349,
    wearable_ids: [347, 273],
  },
  {
    genesis_token_id: 21350,
    wearable_ids: [304, 409],
  },
  {
    genesis_token_id: 21351,
    wearable_ids: [303, 397],
  },
  {
    genesis_token_id: 21352,
    wearable_ids: [404, 314],
  },
  {
    genesis_token_id: 21353,
    wearable_ids: [324, 388],
  },
  {
    genesis_token_id: 21354,
    wearable_ids: [426, 433],
  },
  {
    genesis_token_id: 21355,
    wearable_ids: [265, 338],
  },
  {
    genesis_token_id: 21356,
    wearable_ids: [310, 352],
  },
  {
    genesis_token_id: 21357,
    wearable_ids: [253, 404],
  },
  {
    genesis_token_id: 21358,
    wearable_ids: [290, 403],
  },
  {
    genesis_token_id: 21359,
    wearable_ids: [339, 272],
  },
  {
    genesis_token_id: 21360,
    wearable_ids: [310, 286],
  },
  {
    genesis_token_id: 21361,
    wearable_ids: [300, 337],
  },
  {
    genesis_token_id: 21362,
    wearable_ids: [315, 354],
  },
  {
    genesis_token_id: 21363,
    wearable_ids: [337, 386],
  },
  {
    genesis_token_id: 21364,
    wearable_ids: [376, 302],
  },
  {
    genesis_token_id: 21365,
    wearable_ids: [352, 344],
  },
  {
    genesis_token_id: 21366,
    wearable_ids: [443, 445],
  },
  {
    genesis_token_id: 21367,
    wearable_ids: [350, 444],
  },
  {
    genesis_token_id: 21368,
    wearable_ids: [319, 249],
  },
  {
    genesis_token_id: 21369,
    wearable_ids: [332, 422],
  },
  {
    genesis_token_id: 21370,
    wearable_ids: [352, 399],
  },
  {
    genesis_token_id: 21371,
    wearable_ids: [271, 354],
  },
  {
    genesis_token_id: 21372,
    wearable_ids: [297, 382],
  },
  {
    genesis_token_id: 21373,
    wearable_ids: [403, 262],
  },
  {
    genesis_token_id: 21374,
    wearable_ids: [422, 340],
  },
  {
    genesis_token_id: 21375,
    wearable_ids: [383, 429],
  },
  {
    genesis_token_id: 21376,
    wearable_ids: [341, 409],
  },
  {
    genesis_token_id: 21377,
    wearable_ids: [259, 253],
  },
  {
    genesis_token_id: 21378,
    wearable_ids: [263, 276],
  },
  {
    genesis_token_id: 21379,
    wearable_ids: [415, 310],
  },
  {
    genesis_token_id: 21380,
    wearable_ids: [437, 395],
  },
  {
    genesis_token_id: 21381,
    wearable_ids: [295, 435],
  },
  {
    genesis_token_id: 21382,
    wearable_ids: [365, 422],
  },
  {
    genesis_token_id: 21383,
    wearable_ids: [350, 372],
  },
  {
    genesis_token_id: 21384,
    wearable_ids: [373, 431],
  },
  {
    genesis_token_id: 21385,
    wearable_ids: [319, 263],
  },
  {
    genesis_token_id: 21386,
    wearable_ids: [324, 246],
  },
  {
    genesis_token_id: 21387,
    wearable_ids: [350, 354],
  },
  {
    genesis_token_id: 21388,
    wearable_ids: [412, 375],
  },
  {
    genesis_token_id: 21389,
    wearable_ids: [368, 427],
  },
  {
    genesis_token_id: 21390,
    wearable_ids: [435, 375],
  },
  {
    genesis_token_id: 21391,
    wearable_ids: [272, 445],
  },
  {
    genesis_token_id: 21392,
    wearable_ids: [408, 255],
  },
  {
    genesis_token_id: 21393,
    wearable_ids: [277, 432],
  },
  {
    genesis_token_id: 21394,
    wearable_ids: [332, 398],
  },
  {
    genesis_token_id: 21395,
    wearable_ids: [266, 320],
  },
  {
    genesis_token_id: 21396,
    wearable_ids: [354, 407],
  },
  {
    genesis_token_id: 21397,
    wearable_ids: [304, 435],
  },
  {
    genesis_token_id: 21398,
    wearable_ids: [369, 433],
  },
  {
    genesis_token_id: 21399,
    wearable_ids: [272, 315],
  },
  {
    genesis_token_id: 21400,
    wearable_ids: [276, 301],
  },
  {
    genesis_token_id: 21401,
    wearable_ids: [395, 362],
  },
  {
    genesis_token_id: 21402,
    wearable_ids: [434, 275],
  },
  {
    genesis_token_id: 21403,
    wearable_ids: [257, 288],
  },
  {
    genesis_token_id: 21404,
    wearable_ids: [259, 432],
  },
  {
    genesis_token_id: 21405,
    wearable_ids: [376, 385],
  },
  {
    genesis_token_id: 21406,
    wearable_ids: [263, 444],
  },
  {
    genesis_token_id: 21407,
    wearable_ids: [296, 418],
  },
  {
    genesis_token_id: 21408,
    wearable_ids: [332, 387],
  },
  {
    genesis_token_id: 21409,
    wearable_ids: [420, 378],
  },
  {
    genesis_token_id: 21410,
    wearable_ids: [399, 299],
  },
  {
    genesis_token_id: 21411,
    wearable_ids: [347, 351],
  },
  {
    genesis_token_id: 21412,
    wearable_ids: [319, 435],
  },
  {
    genesis_token_id: 21413,
    wearable_ids: [420, 429],
  },
  {
    genesis_token_id: 21414,
    wearable_ids: [294, 420],
  },
  {
    genesis_token_id: 21415,
    wearable_ids: [273, 362],
  },
  {
    genesis_token_id: 21416,
    wearable_ids: [296, 412],
  },
  {
    genesis_token_id: 21417,
    wearable_ids: [444, 280],
  },
  {
    genesis_token_id: 21418,
    wearable_ids: [403, 346],
  },
  {
    genesis_token_id: 21419,
    wearable_ids: [325, 363],
  },
  {
    genesis_token_id: 21420,
    wearable_ids: [442, 278],
  },
  {
    genesis_token_id: 21421,
    wearable_ids: [254, 445],
  },
  {
    genesis_token_id: 21422,
    wearable_ids: [270, 443],
  },
  {
    genesis_token_id: 21423,
    wearable_ids: [437, 413],
  },
  {
    genesis_token_id: 21424,
    wearable_ids: [247, 334],
  },
  {
    genesis_token_id: 21425,
    wearable_ids: [278, 294],
  },
  {
    genesis_token_id: 21426,
    wearable_ids: [395, 331],
  },
  {
    genesis_token_id: 21427,
    wearable_ids: [369, 262],
  },
  {
    genesis_token_id: 21428,
    wearable_ids: [378, 277],
  },
  {
    genesis_token_id: 21429,
    wearable_ids: [407, 401],
  },
  {
    genesis_token_id: 21430,
    wearable_ids: [410, 374],
  },
  {
    genesis_token_id: 21431,
    wearable_ids: [404, 258],
  },
  {
    genesis_token_id: 21432,
    wearable_ids: [272, 262],
  },
  {
    genesis_token_id: 21433,
    wearable_ids: [384, 426],
  },
  {
    genesis_token_id: 21434,
    wearable_ids: [400, 295],
  },
  {
    genesis_token_id: 21435,
    wearable_ids: [415, 359],
  },
  {
    genesis_token_id: 21436,
    wearable_ids: [339, 272],
  },
  {
    genesis_token_id: 21437,
    wearable_ids: [371, 434],
  },
  {
    genesis_token_id: 21438,
    wearable_ids: [372, 341],
  },
  {
    genesis_token_id: 21439,
    wearable_ids: [376, 346],
  },
  {
    genesis_token_id: 21440,
    wearable_ids: [354, 383],
  },
  {
    genesis_token_id: 21441,
    wearable_ids: [350, 401],
  },
  {
    genesis_token_id: 21442,
    wearable_ids: [396, 316],
  },
  {
    genesis_token_id: 21443,
    wearable_ids: [384, 377],
  },
  {
    genesis_token_id: 21444,
    wearable_ids: [374, 401],
  },
  {
    genesis_token_id: 21445,
    wearable_ids: [426, 424],
  },
  {
    genesis_token_id: 21446,
    wearable_ids: [443, 376],
  },
  {
    genesis_token_id: 21447,
    wearable_ids: [423, 248],
  },
  {
    genesis_token_id: 21448,
    wearable_ids: [404, 436],
  },
  {
    genesis_token_id: 21449,
    wearable_ids: [259, 280],
  },
  {
    genesis_token_id: 21450,
    wearable_ids: [263, 297],
  },
  {
    genesis_token_id: 21451,
    wearable_ids: [265, 444],
  },
  {
    genesis_token_id: 21452,
    wearable_ids: [325, 370],
  },
  {
    genesis_token_id: 21453,
    wearable_ids: [342, 368],
  },
  {
    genesis_token_id: 21454,
    wearable_ids: [431, 382],
  },
  {
    genesis_token_id: 21455,
    wearable_ids: [280, 315],
  },
  {
    genesis_token_id: 21456,
    wearable_ids: [362, 389],
  },
  {
    genesis_token_id: 21457,
    wearable_ids: [433, 337],
  },
  {
    genesis_token_id: 21458,
    wearable_ids: [376, 346],
  },
  {
    genesis_token_id: 21459,
    wearable_ids: [277, 266],
  },
  {
    genesis_token_id: 21460,
    wearable_ids: [387, 265],
  },
  {
    genesis_token_id: 21461,
    wearable_ids: [295, 251],
  },
  {
    genesis_token_id: 21462,
    wearable_ids: [445, 291],
  },
  {
    genesis_token_id: 21463,
    wearable_ids: [311, 336],
  },
  {
    genesis_token_id: 21464,
    wearable_ids: [278, 387],
  },
  {
    genesis_token_id: 21465,
    wearable_ids: [348, 386],
  },
  {
    genesis_token_id: 21466,
    wearable_ids: [377, 382],
  },
  {
    genesis_token_id: 21467,
    wearable_ids: [299, 342],
  },
  {
    genesis_token_id: 21468,
    wearable_ids: [442, 307],
  },
  {
    genesis_token_id: 21469,
    wearable_ids: [383, 435],
  },
  {
    genesis_token_id: 21470,
    wearable_ids: [266, 287],
  },
  {
    genesis_token_id: 21471,
    wearable_ids: [304, 349],
  },
  {
    genesis_token_id: 21472,
    wearable_ids: [253, 373],
  },
  {
    genesis_token_id: 21473,
    wearable_ids: [352, 306],
  },
  {
    genesis_token_id: 21474,
    wearable_ids: [370, 378],
  },
  {
    genesis_token_id: 21475,
    wearable_ids: [301, 325],
  },
  {
    genesis_token_id: 21476,
    wearable_ids: [315, 273],
  },
  {
    genesis_token_id: 21477,
    wearable_ids: [428, 374],
  },
  {
    genesis_token_id: 21478,
    wearable_ids: [411, 340],
  },
  {
    genesis_token_id: 21479,
    wearable_ids: [351, 286],
  },
  {
    genesis_token_id: 21480,
    wearable_ids: [422, 371],
  },
  {
    genesis_token_id: 21481,
    wearable_ids: [251, 303],
  },
  {
    genesis_token_id: 21482,
    wearable_ids: [292, 248],
  },
  {
    genesis_token_id: 21483,
    wearable_ids: [290, 430],
  },
  {
    genesis_token_id: 21484,
    wearable_ids: [304, 363],
  },
  {
    genesis_token_id: 21485,
    wearable_ids: [317, 427],
  },
  {
    genesis_token_id: 21486,
    wearable_ids: [319, 443],
  },
  {
    genesis_token_id: 21487,
    wearable_ids: [270, 308],
  },
  {
    genesis_token_id: 21488,
    wearable_ids: [363, 428],
  },
  {
    genesis_token_id: 21489,
    wearable_ids: [365, 277],
  },
  {
    genesis_token_id: 21490,
    wearable_ids: [355, 279],
  },
  {
    genesis_token_id: 21491,
    wearable_ids: [411, 414],
  },
  {
    genesis_token_id: 21492,
    wearable_ids: [259, 345],
  },
  {
    genesis_token_id: 21493,
    wearable_ids: [376, 280],
  },
  {
    genesis_token_id: 21494,
    wearable_ids: [326, 356],
  },
  {
    genesis_token_id: 21495,
    wearable_ids: [294, 315],
  },
  {
    genesis_token_id: 21496,
    wearable_ids: [325, 351],
  },
  {
    genesis_token_id: 21497,
    wearable_ids: [348, 299],
  },
  {
    genesis_token_id: 21498,
    wearable_ids: [420, 301],
  },
  {
    genesis_token_id: 21499,
    wearable_ids: [423, 336],
  },
  {
    genesis_token_id: 21500,
    wearable_ids: [424, 268],
  },
  {
    genesis_token_id: 21501,
    wearable_ids: [296, 308],
  },
  {
    genesis_token_id: 21502,
    wearable_ids: [311, 385],
  },
  {
    genesis_token_id: 21503,
    wearable_ids: [351, 403],
  },
  {
    genesis_token_id: 21504,
    wearable_ids: [290, 427],
  },
  {
    genesis_token_id: 21505,
    wearable_ids: [443, 395],
  },
  {
    genesis_token_id: 21506,
    wearable_ids: [415, 344],
  },
  {
    genesis_token_id: 21507,
    wearable_ids: [290, 444],
  },
  {
    genesis_token_id: 21508,
    wearable_ids: [343, 438],
  },
  {
    genesis_token_id: 21509,
    wearable_ids: [435, 311],
  },
  {
    genesis_token_id: 21510,
    wearable_ids: [292, 268],
  },
  {
    genesis_token_id: 21511,
    wearable_ids: [308, 391],
  },
  {
    genesis_token_id: 21512,
    wearable_ids: [404, 331],
  },
  {
    genesis_token_id: 21513,
    wearable_ids: [341, 247],
  },
  {
    genesis_token_id: 21514,
    wearable_ids: [266, 383],
  },
  {
    genesis_token_id: 21515,
    wearable_ids: [332, 307],
  },
  {
    genesis_token_id: 21516,
    wearable_ids: [369, 375],
  },
  {
    genesis_token_id: 21517,
    wearable_ids: [389, 249],
  },
  {
    genesis_token_id: 21518,
    wearable_ids: [256, 343],
  },
  {
    genesis_token_id: 21519,
    wearable_ids: [258, 358],
  },
  {
    genesis_token_id: 21520,
    wearable_ids: [354, 410],
  },
  {
    genesis_token_id: 21521,
    wearable_ids: [248, 422],
  },
  {
    genesis_token_id: 21522,
    wearable_ids: [370, 308],
  },
  {
    genesis_token_id: 21523,
    wearable_ids: [265, 316],
  },
  {
    genesis_token_id: 21524,
    wearable_ids: [263, 386],
  },
  {
    genesis_token_id: 21525,
    wearable_ids: [324, 441],
  },
  {
    genesis_token_id: 21526,
    wearable_ids: [247, 290],
  },
  {
    genesis_token_id: 21527,
    wearable_ids: [351, 415],
  },
  {
    genesis_token_id: 21528,
    wearable_ids: [324, 289],
  },
  {
    genesis_token_id: 21529,
    wearable_ids: [373, 383],
  },
  {
    genesis_token_id: 21530,
    wearable_ids: [349, 301],
  },
  {
    genesis_token_id: 21531,
    wearable_ids: [248, 280],
  },
  {
    genesis_token_id: 21532,
    wearable_ids: [259, 368],
  },
  {
    genesis_token_id: 21533,
    wearable_ids: [396, 273],
  },
  {
    genesis_token_id: 21534,
    wearable_ids: [384, 362],
  },
  {
    genesis_token_id: 21535,
    wearable_ids: [276, 362],
  },
  {
    genesis_token_id: 21536,
    wearable_ids: [346, 434],
  },
  {
    genesis_token_id: 21537,
    wearable_ids: [296, 436],
  },
  {
    genesis_token_id: 21538,
    wearable_ids: [435, 419],
  },
  {
    genesis_token_id: 21539,
    wearable_ids: [324, 280],
  },
  {
    genesis_token_id: 21540,
    wearable_ids: [284, 363],
  },
  {
    genesis_token_id: 21541,
    wearable_ids: [301, 263],
  },
  {
    genesis_token_id: 21542,
    wearable_ids: [347, 376],
  },
  {
    genesis_token_id: 21543,
    wearable_ids: [324, 385],
  },
  {
    genesis_token_id: 21544,
    wearable_ids: [348, 371],
  },
  {
    genesis_token_id: 21545,
    wearable_ids: [349, 259],
  },
  {
    genesis_token_id: 21546,
    wearable_ids: [349, 260],
  },
  {
    genesis_token_id: 21547,
    wearable_ids: [273, 375],
  },
  {
    genesis_token_id: 21548,
    wearable_ids: [295, 391],
  },
  {
    genesis_token_id: 21549,
    wearable_ids: [411, 368],
  },
  {
    genesis_token_id: 21550,
    wearable_ids: [442, 274],
  },
  {
    genesis_token_id: 21551,
    wearable_ids: [306, 332],
  },
  {
    genesis_token_id: 21552,
    wearable_ids: [304, 267],
  },
  {
    genesis_token_id: 21553,
    wearable_ids: [317, 431],
  },
  {
    genesis_token_id: 21554,
    wearable_ids: [336, 355],
  },
  {
    genesis_token_id: 21555,
    wearable_ids: [395, 388],
  },
  {
    genesis_token_id: 21556,
    wearable_ids: [445, 373],
  },
  {
    genesis_token_id: 21557,
    wearable_ids: [362, 386],
  },
  {
    genesis_token_id: 21558,
    wearable_ids: [385, 376],
  },
  {
    genesis_token_id: 21559,
    wearable_ids: [432, 415],
  },
  {
    genesis_token_id: 21560,
    wearable_ids: [290, 310],
  },
  {
    genesis_token_id: 21561,
    wearable_ids: [404, 438],
  },
  {
    genesis_token_id: 21562,
    wearable_ids: [270, 292],
  },
  {
    genesis_token_id: 21563,
    wearable_ids: [352, 418],
  },
  {
    genesis_token_id: 21564,
    wearable_ids: [373, 374],
  },
  {
    genesis_token_id: 21565,
    wearable_ids: [368, 350],
  },
  {
    genesis_token_id: 21566,
    wearable_ids: [264, 362],
  },
  {
    genesis_token_id: 21567,
    wearable_ids: [352, 373],
  },
  {
    genesis_token_id: 21568,
    wearable_ids: [368, 298],
  },
  {
    genesis_token_id: 21569,
    wearable_ids: [424, 268],
  },
  {
    genesis_token_id: 21570,
    wearable_ids: [301, 382],
  },
  {
    genesis_token_id: 21571,
    wearable_ids: [422, 280],
  },
  {
    genesis_token_id: 21572,
    wearable_ids: [284, 437],
  },
  {
    genesis_token_id: 21573,
    wearable_ids: [369, 424],
  },
  {
    genesis_token_id: 21574,
    wearable_ids: [383, 412],
  },
  {
    genesis_token_id: 21575,
    wearable_ids: [386, 250],
  },
  {
    genesis_token_id: 21576,
    wearable_ids: [311, 338],
  },
  {
    genesis_token_id: 21577,
    wearable_ids: [262, 443],
  },
  {
    genesis_token_id: 21578,
    wearable_ids: [344, 304],
  },
  {
    genesis_token_id: 21579,
    wearable_ids: [387, 317],
  },
  {
    genesis_token_id: 21580,
    wearable_ids: [383, 385],
  },
  {
    genesis_token_id: 21581,
    wearable_ids: [317, 400],
  },
  {
    genesis_token_id: 21582,
    wearable_ids: [382, 344],
  },
  {
    genesis_token_id: 21583,
    wearable_ids: [266, 306],
  },
  {
    genesis_token_id: 21584,
    wearable_ids: [262, 424],
  },
  {
    genesis_token_id: 21585,
    wearable_ids: [251, 258],
  },
  {
    genesis_token_id: 21586,
    wearable_ids: [341, 264],
  },
  {
    genesis_token_id: 21587,
    wearable_ids: [326, 246],
  },
  {
    genesis_token_id: 21588,
    wearable_ids: [286, 377],
  },
  {
    genesis_token_id: 21589,
    wearable_ids: [413, 338],
  },
  {
    genesis_token_id: 21590,
    wearable_ids: [311, 339],
  },
  {
    genesis_token_id: 21591,
    wearable_ids: [258, 443],
  },
  {
    genesis_token_id: 21592,
    wearable_ids: [297, 257],
  },
  {
    genesis_token_id: 21593,
    wearable_ids: [332, 401],
  },
  {
    genesis_token_id: 21594,
    wearable_ids: [400, 335],
  },
  {
    genesis_token_id: 21595,
    wearable_ids: [284, 442],
  },
  {
    genesis_token_id: 21596,
    wearable_ids: [415, 365],
  },
  {
    genesis_token_id: 21597,
    wearable_ids: [270, 253],
  },
  {
    genesis_token_id: 21598,
    wearable_ids: [259, 253],
  },
  {
    genesis_token_id: 21599,
    wearable_ids: [259, 372],
  },
  {
    genesis_token_id: 21600,
    wearable_ids: [362, 271],
  },
  {
    genesis_token_id: 21601,
    wearable_ids: [287, 373],
  },
  {
    genesis_token_id: 21602,
    wearable_ids: [263, 420],
  },
  {
    genesis_token_id: 21603,
    wearable_ids: [343, 435],
  },
  {
    genesis_token_id: 21604,
    wearable_ids: [335, 300],
  },
  {
    genesis_token_id: 21605,
    wearable_ids: [350, 266],
  },
  {
    genesis_token_id: 21606,
    wearable_ids: [431, 370],
  },
  {
    genesis_token_id: 21607,
    wearable_ids: [341, 388],
  },
  {
    genesis_token_id: 21608,
    wearable_ids: [277, 344],
  },
  {
    genesis_token_id: 21609,
    wearable_ids: [300, 337],
  },
  {
    genesis_token_id: 21610,
    wearable_ids: [332, 437],
  },
  {
    genesis_token_id: 21611,
    wearable_ids: [432, 255],
  },
  {
    genesis_token_id: 21612,
    wearable_ids: [364, 278],
  },
  {
    genesis_token_id: 21613,
    wearable_ids: [270, 340],
  },
  {
    genesis_token_id: 21614,
    wearable_ids: [259, 437],
  },
  {
    genesis_token_id: 21615,
    wearable_ids: [251, 411],
  },
  {
    genesis_token_id: 21616,
    wearable_ids: [314, 444],
  },
  {
    genesis_token_id: 21617,
    wearable_ids: [273, 389],
  },
  {
    genesis_token_id: 21618,
    wearable_ids: [444, 406],
  },
  {
    genesis_token_id: 21619,
    wearable_ids: [304, 426],
  },
  {
    genesis_token_id: 21620,
    wearable_ids: [383, 389],
  },
  {
    genesis_token_id: 21621,
    wearable_ids: [306, 440],
  },
  {
    genesis_token_id: 21622,
    wearable_ids: [280, 440],
  },
  {
    genesis_token_id: 21623,
    wearable_ids: [429, 405],
  },
  {
    genesis_token_id: 21624,
    wearable_ids: [290, 249],
  },
  {
    genesis_token_id: 21625,
    wearable_ids: [369, 254],
  },
  {
    genesis_token_id: 21626,
    wearable_ids: [404, 409],
  },
  {
    genesis_token_id: 21627,
    wearable_ids: [374, 318],
  },
  {
    genesis_token_id: 21628,
    wearable_ids: [311, 305],
  },
  {
    genesis_token_id: 21629,
    wearable_ids: [304, 290],
  },
  {
    genesis_token_id: 21630,
    wearable_ids: [299, 435],
  },
  {
    genesis_token_id: 21631,
    wearable_ids: [364, 333],
  },
  {
    genesis_token_id: 21632,
    wearable_ids: [332, 352],
  },
  {
    genesis_token_id: 21633,
    wearable_ids: [337, 344],
  },
  {
    genesis_token_id: 21634,
    wearable_ids: [287, 304],
  },
  {
    genesis_token_id: 21635,
    wearable_ids: [443, 289],
  },
  {
    genesis_token_id: 21636,
    wearable_ids: [415, 337],
  },
  {
    genesis_token_id: 21637,
    wearable_ids: [326, 311],
  },
  {
    genesis_token_id: 21638,
    wearable_ids: [344, 415],
  },
  {
    genesis_token_id: 21639,
    wearable_ids: [314, 248],
  },
  {
    genesis_token_id: 21640,
    wearable_ids: [433, 407],
  },
  {
    genesis_token_id: 21641,
    wearable_ids: [354, 335],
  },
  {
    genesis_token_id: 21642,
    wearable_ids: [443, 301],
  },
  {
    genesis_token_id: 21643,
    wearable_ids: [399, 412],
  },
  {
    genesis_token_id: 21644,
    wearable_ids: [317, 403],
  },
  {
    genesis_token_id: 21645,
    wearable_ids: [387, 411],
  },
  {
    genesis_token_id: 21646,
    wearable_ids: [410, 424],
  },
  {
    genesis_token_id: 21647,
    wearable_ids: [368, 386],
  },
  {
    genesis_token_id: 21648,
    wearable_ids: [428, 403],
  },
  {
    genesis_token_id: 21649,
    wearable_ids: [348, 412],
  },
  {
    genesis_token_id: 21650,
    wearable_ids: [340, 301],
  },
  {
    genesis_token_id: 21651,
    wearable_ids: [428, 315],
  },
  {
    genesis_token_id: 21652,
    wearable_ids: [290, 389],
  },
  {
    genesis_token_id: 21653,
    wearable_ids: [264, 308],
  },
  {
    genesis_token_id: 21654,
    wearable_ids: [314, 384],
  },
  {
    genesis_token_id: 21655,
    wearable_ids: [301, 265],
  },
  {
    genesis_token_id: 21656,
    wearable_ids: [284, 411],
  },
  {
    genesis_token_id: 21657,
    wearable_ids: [278, 285],
  },
  {
    genesis_token_id: 21658,
    wearable_ids: [410, 291],
  },
  {
    genesis_token_id: 21659,
    wearable_ids: [310, 348],
  },
  {
    genesis_token_id: 21660,
    wearable_ids: [268, 280],
  },
  {
    genesis_token_id: 21661,
    wearable_ids: [373, 251],
  },
  {
    genesis_token_id: 21662,
    wearable_ids: [378, 406],
  },
  {
    genesis_token_id: 21663,
    wearable_ids: [349, 441],
  },
  {
    genesis_token_id: 21664,
    wearable_ids: [444, 350],
  },
  {
    genesis_token_id: 21665,
    wearable_ids: [290, 385],
  },
  {
    genesis_token_id: 21666,
    wearable_ids: [347, 403],
  },
  {
    genesis_token_id: 21667,
    wearable_ids: [341, 434],
  },
  {
    genesis_token_id: 21668,
    wearable_ids: [410, 418],
  },
  {
    genesis_token_id: 21669,
    wearable_ids: [263, 438],
  },
  {
    genesis_token_id: 21670,
    wearable_ids: [368, 276],
  },
  {
    genesis_token_id: 21671,
    wearable_ids: [382, 340],
  },
  {
    genesis_token_id: 21672,
    wearable_ids: [292, 363],
  },
  {
    genesis_token_id: 21673,
    wearable_ids: [408, 396],
  },
  {
    genesis_token_id: 21674,
    wearable_ids: [276, 425],
  },
  {
    genesis_token_id: 21675,
    wearable_ids: [253, 387],
  },
  {
    genesis_token_id: 21676,
    wearable_ids: [297, 250],
  },
  {
    genesis_token_id: 21677,
    wearable_ids: [374, 402],
  },
  {
    genesis_token_id: 21678,
    wearable_ids: [336, 338],
  },
  {
    genesis_token_id: 21679,
    wearable_ids: [287, 310],
  },
  {
    genesis_token_id: 21680,
    wearable_ids: [255, 365],
  },
  {
    genesis_token_id: 21681,
    wearable_ids: [400, 289],
  },
  {
    genesis_token_id: 21682,
    wearable_ids: [255, 343],
  },
  {
    genesis_token_id: 21683,
    wearable_ids: [338, 330],
  },
  {
    genesis_token_id: 21684,
    wearable_ids: [257, 353],
  },
  {
    genesis_token_id: 21685,
    wearable_ids: [432, 340],
  },
  {
    genesis_token_id: 21686,
    wearable_ids: [382, 294],
  },
  {
    genesis_token_id: 21687,
    wearable_ids: [287, 276],
  },
  {
    genesis_token_id: 21688,
    wearable_ids: [324, 315],
  },
  {
    genesis_token_id: 21689,
    wearable_ids: [404, 332],
  },
  {
    genesis_token_id: 21690,
    wearable_ids: [277, 301],
  },
  {
    genesis_token_id: 21691,
    wearable_ids: [354, 253],
  },
  {
    genesis_token_id: 21692,
    wearable_ids: [399, 336],
  },
  {
    genesis_token_id: 21693,
    wearable_ids: [384, 273],
  },
  {
    genesis_token_id: 21694,
    wearable_ids: [278, 296],
  },
  {
    genesis_token_id: 21695,
    wearable_ids: [406, 301],
  },
  {
    genesis_token_id: 21696,
    wearable_ids: [363, 392],
  },
  {
    genesis_token_id: 21697,
    wearable_ids: [364, 255],
  },
  {
    genesis_token_id: 21698,
    wearable_ids: [383, 354],
  },
  {
    genesis_token_id: 21699,
    wearable_ids: [262, 315],
  },
  {
    genesis_token_id: 21700,
    wearable_ids: [435, 377],
  },
  {
    genesis_token_id: 21701,
    wearable_ids: [354, 348],
  },
  {
    genesis_token_id: 21702,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 21703,
    wearable_ids: [384, 333],
  },
  {
    genesis_token_id: 21704,
    wearable_ids: [251, 384],
  },
  {
    genesis_token_id: 21705,
    wearable_ids: [368, 389],
  },
  {
    genesis_token_id: 21706,
    wearable_ids: [426, 383],
  },
  {
    genesis_token_id: 21707,
    wearable_ids: [280, 283],
  },
  {
    genesis_token_id: 21708,
    wearable_ids: [369, 405],
  },
  {
    genesis_token_id: 21709,
    wearable_ids: [412, 332],
  },
  {
    genesis_token_id: 21710,
    wearable_ids: [386, 258],
  },
  {
    genesis_token_id: 21711,
    wearable_ids: [426, 431],
  },
  {
    genesis_token_id: 21712,
    wearable_ids: [271, 317],
  },
  {
    genesis_token_id: 21713,
    wearable_ids: [264, 435],
  },
  {
    genesis_token_id: 21714,
    wearable_ids: [259, 319],
  },
  {
    genesis_token_id: 21715,
    wearable_ids: [387, 358],
  },
  {
    genesis_token_id: 21716,
    wearable_ids: [304, 278],
  },
  {
    genesis_token_id: 21717,
    wearable_ids: [316, 413],
  },
  {
    genesis_token_id: 21718,
    wearable_ids: [428, 410],
  },
  {
    genesis_token_id: 21719,
    wearable_ids: [365, 281],
  },
  {
    genesis_token_id: 21720,
    wearable_ids: [376, 315],
  },
  {
    genesis_token_id: 21721,
    wearable_ids: [425, 339],
  },
  {
    genesis_token_id: 21722,
    wearable_ids: [347, 356],
  },
  {
    genesis_token_id: 21723,
    wearable_ids: [386, 389],
  },
  {
    genesis_token_id: 21724,
    wearable_ids: [278, 431],
  },
  {
    genesis_token_id: 21725,
    wearable_ids: [278, 424],
  },
  {
    genesis_token_id: 21726,
    wearable_ids: [445, 266],
  },
  {
    genesis_token_id: 21727,
    wearable_ids: [365, 361],
  },
  {
    genesis_token_id: 21728,
    wearable_ids: [247, 325],
  },
  {
    genesis_token_id: 21729,
    wearable_ids: [308, 432],
  },
  {
    genesis_token_id: 21730,
    wearable_ids: [294, 363],
  },
  {
    genesis_token_id: 21731,
    wearable_ids: [425, 441],
  },
  {
    genesis_token_id: 21732,
    wearable_ids: [408, 264],
  },
  {
    genesis_token_id: 21733,
    wearable_ids: [254, 371],
  },
  {
    genesis_token_id: 21734,
    wearable_ids: [412, 294],
  },
  {
    genesis_token_id: 21735,
    wearable_ids: [424, 308],
  },
  {
    genesis_token_id: 21736,
    wearable_ids: [316, 317],
  },
  {
    genesis_token_id: 21737,
    wearable_ids: [354, 278],
  },
  {
    genesis_token_id: 21738,
    wearable_ids: [365, 445],
  },
  {
    genesis_token_id: 21739,
    wearable_ids: [276, 270],
  },
  {
    genesis_token_id: 21740,
    wearable_ids: [426, 355],
  },
  {
    genesis_token_id: 21741,
    wearable_ids: [254, 351],
  },
  {
    genesis_token_id: 21742,
    wearable_ids: [399, 372],
  },
  {
    genesis_token_id: 21743,
    wearable_ids: [263, 287],
  },
  {
    genesis_token_id: 21744,
    wearable_ids: [280, 395],
  },
  {
    genesis_token_id: 21745,
    wearable_ids: [273, 440],
  },
  {
    genesis_token_id: 21746,
    wearable_ids: [342, 375],
  },
  {
    genesis_token_id: 21747,
    wearable_ids: [310, 350],
  },
  {
    genesis_token_id: 21748,
    wearable_ids: [382, 428],
  },
  {
    genesis_token_id: 21749,
    wearable_ids: [247, 423],
  },
  {
    genesis_token_id: 21750,
    wearable_ids: [407, 399],
  },
  {
    genesis_token_id: 21751,
    wearable_ids: [253, 311],
  },
  {
    genesis_token_id: 21752,
    wearable_ids: [247, 343],
  },
  {
    genesis_token_id: 21753,
    wearable_ids: [340, 364],
  },
  {
    genesis_token_id: 21754,
    wearable_ids: [364, 273],
  },
  {
    genesis_token_id: 21755,
    wearable_ids: [422, 359],
  },
  {
    genesis_token_id: 21756,
    wearable_ids: [247, 400],
  },
  {
    genesis_token_id: 21757,
    wearable_ids: [372, 301],
  },
  {
    genesis_token_id: 21758,
    wearable_ids: [299, 272],
  },
  {
    genesis_token_id: 21759,
    wearable_ids: [376, 290],
  },
  {
    genesis_token_id: 21760,
    wearable_ids: [408, 295],
  },
  {
    genesis_token_id: 21761,
    wearable_ids: [349, 399],
  },
  {
    genesis_token_id: 21762,
    wearable_ids: [396, 286],
  },
  {
    genesis_token_id: 21763,
    wearable_ids: [389, 257],
  },
  {
    genesis_token_id: 21764,
    wearable_ids: [354, 383],
  },
  {
    genesis_token_id: 21765,
    wearable_ids: [308, 435],
  },
  {
    genesis_token_id: 21766,
    wearable_ids: [342, 348],
  },
  {
    genesis_token_id: 21767,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 21768,
    wearable_ids: [415, 417],
  },
  {
    genesis_token_id: 21769,
    wearable_ids: [364, 369],
  },
  {
    genesis_token_id: 21770,
    wearable_ids: [375, 343],
  },
  {
    genesis_token_id: 21771,
    wearable_ids: [378, 414],
  },
  {
    genesis_token_id: 21772,
    wearable_ids: [437, 279],
  },
  {
    genesis_token_id: 21773,
    wearable_ids: [278, 384],
  },
  {
    genesis_token_id: 21774,
    wearable_ids: [297, 259],
  },
  {
    genesis_token_id: 21775,
    wearable_ids: [255, 339],
  },
  {
    genesis_token_id: 21776,
    wearable_ids: [373, 346],
  },
  {
    genesis_token_id: 21777,
    wearable_ids: [444, 257],
  },
  {
    genesis_token_id: 21778,
    wearable_ids: [376, 256],
  },
  {
    genesis_token_id: 21779,
    wearable_ids: [387, 247],
  },
  {
    genesis_token_id: 21780,
    wearable_ids: [284, 369],
  },
  {
    genesis_token_id: 21781,
    wearable_ids: [332, 434],
  },
  {
    genesis_token_id: 21782,
    wearable_ids: [297, 332],
  },
  {
    genesis_token_id: 21783,
    wearable_ids: [324, 253],
  },
  {
    genesis_token_id: 21784,
    wearable_ids: [263, 423],
  },
  {
    genesis_token_id: 21785,
    wearable_ids: [410, 319],
  },
  {
    genesis_token_id: 21786,
    wearable_ids: [315, 379],
  },
  {
    genesis_token_id: 21787,
    wearable_ids: [429, 433],
  },
  {
    genesis_token_id: 21788,
    wearable_ids: [387, 344],
  },
  {
    genesis_token_id: 21789,
    wearable_ids: [335, 264],
  },
  {
    genesis_token_id: 21790,
    wearable_ids: [376, 248],
  },
  {
    genesis_token_id: 21791,
    wearable_ids: [413, 301],
  },
  {
    genesis_token_id: 21792,
    wearable_ids: [407, 387],
  },
  {
    genesis_token_id: 21793,
    wearable_ids: [344, 426],
  },
  {
    genesis_token_id: 21794,
    wearable_ids: [303, 373],
  },
  {
    genesis_token_id: 21795,
    wearable_ids: [296, 376],
  },
  {
    genesis_token_id: 21796,
    wearable_ids: [286, 264],
  },
  {
    genesis_token_id: 21797,
    wearable_ids: [335, 360],
  },
  {
    genesis_token_id: 21798,
    wearable_ids: [404, 324],
  },
  {
    genesis_token_id: 21799,
    wearable_ids: [270, 248],
  },
  {
    genesis_token_id: 21800,
    wearable_ids: [311, 420],
  },
  {
    genesis_token_id: 21801,
    wearable_ids: [339, 430],
  },
  {
    genesis_token_id: 21802,
    wearable_ids: [362, 322],
  },
  {
    genesis_token_id: 21803,
    wearable_ids: [271, 323],
  },
  {
    genesis_token_id: 21804,
    wearable_ids: [262, 356],
  },
  {
    genesis_token_id: 21805,
    wearable_ids: [253, 387],
  },
  {
    genesis_token_id: 21806,
    wearable_ids: [444, 412],
  },
  {
    genesis_token_id: 21807,
    wearable_ids: [338, 429],
  },
  {
    genesis_token_id: 21808,
    wearable_ids: [437, 310],
  },
  {
    genesis_token_id: 21809,
    wearable_ids: [415, 376],
  },
  {
    genesis_token_id: 21810,
    wearable_ids: [374, 362],
  },
  {
    genesis_token_id: 21811,
    wearable_ids: [289, 397],
  },
  {
    genesis_token_id: 21812,
    wearable_ids: [306, 314],
  },
  {
    genesis_token_id: 21813,
    wearable_ids: [247, 277],
  },
  {
    genesis_token_id: 21814,
    wearable_ids: [443, 310],
  },
  {
    genesis_token_id: 21815,
    wearable_ids: [336, 406],
  },
  {
    genesis_token_id: 21816,
    wearable_ids: [375, 314],
  },
  {
    genesis_token_id: 21817,
    wearable_ids: [319, 396],
  },
  {
    genesis_token_id: 21818,
    wearable_ids: [303, 264],
  },
  {
    genesis_token_id: 21819,
    wearable_ids: [316, 428],
  },
  {
    genesis_token_id: 21820,
    wearable_ids: [277, 295],
  },
  {
    genesis_token_id: 21821,
    wearable_ids: [383, 396],
  },
  {
    genesis_token_id: 21822,
    wearable_ids: [387, 343],
  },
  {
    genesis_token_id: 21823,
    wearable_ids: [396, 409],
  },
  {
    genesis_token_id: 21824,
    wearable_ids: [271, 349],
  },
  {
    genesis_token_id: 21825,
    wearable_ids: [336, 412],
  },
  {
    genesis_token_id: 21826,
    wearable_ids: [296, 291],
  },
  {
    genesis_token_id: 21827,
    wearable_ids: [376, 284],
  },
  {
    genesis_token_id: 21828,
    wearable_ids: [262, 386],
  },
  {
    genesis_token_id: 21829,
    wearable_ids: [335, 355],
  },
  {
    genesis_token_id: 21830,
    wearable_ids: [295, 312],
  },
  {
    genesis_token_id: 21831,
    wearable_ids: [339, 249],
  },
  {
    genesis_token_id: 21832,
    wearable_ids: [342, 386],
  },
  {
    genesis_token_id: 21833,
    wearable_ids: [292, 255],
  },
  {
    genesis_token_id: 21834,
    wearable_ids: [290, 303],
  },
  {
    genesis_token_id: 21835,
    wearable_ids: [435, 255],
  },
  {
    genesis_token_id: 21836,
    wearable_ids: [423, 432],
  },
  {
    genesis_token_id: 21837,
    wearable_ids: [355, 354],
  },
  {
    genesis_token_id: 21838,
    wearable_ids: [300, 425],
  },
  {
    genesis_token_id: 21839,
    wearable_ids: [326, 265],
  },
  {
    genesis_token_id: 21840,
    wearable_ids: [259, 408],
  },
  {
    genesis_token_id: 21841,
    wearable_ids: [377, 387],
  },
  {
    genesis_token_id: 21842,
    wearable_ids: [413, 409],
  },
  {
    genesis_token_id: 21843,
    wearable_ids: [437, 377],
  },
  {
    genesis_token_id: 21844,
    wearable_ids: [306, 400],
  },
  {
    genesis_token_id: 21845,
    wearable_ids: [425, 338],
  },
  {
    genesis_token_id: 21846,
    wearable_ids: [433, 264],
  },
  {
    genesis_token_id: 21847,
    wearable_ids: [403, 268],
  },
  {
    genesis_token_id: 21848,
    wearable_ids: [310, 276],
  },
  {
    genesis_token_id: 21849,
    wearable_ids: [378, 397],
  },
  {
    genesis_token_id: 21850,
    wearable_ids: [274, 387],
  },
  {
    genesis_token_id: 21851,
    wearable_ids: [347, 355],
  },
  {
    genesis_token_id: 21852,
    wearable_ids: [346, 322],
  },
  {
    genesis_token_id: 21853,
    wearable_ids: [254, 374],
  },
  {
    genesis_token_id: 21854,
    wearable_ids: [335, 254],
  },
  {
    genesis_token_id: 21855,
    wearable_ids: [265, 345],
  },
  {
    genesis_token_id: 21856,
    wearable_ids: [383, 442],
  },
  {
    genesis_token_id: 21857,
    wearable_ids: [280, 269],
  },
  {
    genesis_token_id: 21858,
    wearable_ids: [259, 368],
  },
  {
    genesis_token_id: 21859,
    wearable_ids: [347, 336],
  },
  {
    genesis_token_id: 21860,
    wearable_ids: [435, 424],
  },
  {
    genesis_token_id: 21861,
    wearable_ids: [351, 373],
  },
  {
    genesis_token_id: 21862,
    wearable_ids: [437, 363],
  },
  {
    genesis_token_id: 21863,
    wearable_ids: [411, 369],
  },
  {
    genesis_token_id: 21864,
    wearable_ids: [363, 263],
  },
  {
    genesis_token_id: 21865,
    wearable_ids: [308, 295],
  },
  {
    genesis_token_id: 21866,
    wearable_ids: [271, 298],
  },
  {
    genesis_token_id: 21867,
    wearable_ids: [338, 276],
  },
  {
    genesis_token_id: 21868,
    wearable_ids: [424, 363],
  },
  {
    genesis_token_id: 21869,
    wearable_ids: [369, 338],
  },
  {
    genesis_token_id: 21870,
    wearable_ids: [351, 364],
  },
  {
    genesis_token_id: 21871,
    wearable_ids: [368, 366],
  },
  {
    genesis_token_id: 21872,
    wearable_ids: [337, 386],
  },
  {
    genesis_token_id: 21873,
    wearable_ids: [432, 370],
  },
  {
    genesis_token_id: 21874,
    wearable_ids: [376, 301],
  },
  {
    genesis_token_id: 21875,
    wearable_ids: [287, 336],
  },
  {
    genesis_token_id: 21876,
    wearable_ids: [382, 436],
  },
  {
    genesis_token_id: 21877,
    wearable_ids: [413, 331],
  },
  {
    genesis_token_id: 21878,
    wearable_ids: [257, 354],
  },
  {
    genesis_token_id: 21879,
    wearable_ids: [374, 251],
  },
  {
    genesis_token_id: 21880,
    wearable_ids: [406, 423],
  },
  {
    genesis_token_id: 21881,
    wearable_ids: [350, 431],
  },
  {
    genesis_token_id: 21882,
    wearable_ids: [291, 387],
  },
  {
    genesis_token_id: 21883,
    wearable_ids: [280, 257],
  },
  {
    genesis_token_id: 21884,
    wearable_ids: [400, 315],
  },
  {
    genesis_token_id: 21885,
    wearable_ids: [295, 325],
  },
  {
    genesis_token_id: 21886,
    wearable_ids: [428, 322],
  },
  {
    genesis_token_id: 21887,
    wearable_ids: [251, 297],
  },
  {
    genesis_token_id: 21888,
    wearable_ids: [248, 332],
  },
  {
    genesis_token_id: 21889,
    wearable_ids: [395, 437],
  },
  {
    genesis_token_id: 21890,
    wearable_ids: [348, 296],
  },
  {
    genesis_token_id: 21891,
    wearable_ids: [428, 336],
  },
  {
    genesis_token_id: 21892,
    wearable_ids: [433, 287],
  },
  {
    genesis_token_id: 21893,
    wearable_ids: [315, 385],
  },
  {
    genesis_token_id: 21894,
    wearable_ids: [372, 338],
  },
  {
    genesis_token_id: 21895,
    wearable_ids: [295, 379],
  },
  {
    genesis_token_id: 21896,
    wearable_ids: [290, 332],
  },
  {
    genesis_token_id: 21897,
    wearable_ids: [428, 247],
  },
  {
    genesis_token_id: 21898,
    wearable_ids: [277, 337],
  },
  {
    genesis_token_id: 21899,
    wearable_ids: [404, 333],
  },
  {
    genesis_token_id: 21900,
    wearable_ids: [399, 274],
  },
  {
    genesis_token_id: 21901,
    wearable_ids: [332, 443],
  },
  {
    genesis_token_id: 21902,
    wearable_ids: [258, 400],
  },
  {
    genesis_token_id: 21903,
    wearable_ids: [387, 337],
  },
  {
    genesis_token_id: 21904,
    wearable_ids: [429, 351],
  },
  {
    genesis_token_id: 21905,
    wearable_ids: [431, 287],
  },
  {
    genesis_token_id: 21906,
    wearable_ids: [255, 296],
  },
  {
    genesis_token_id: 21907,
    wearable_ids: [429, 287],
  },
  {
    genesis_token_id: 21908,
    wearable_ids: [254, 400],
  },
  {
    genesis_token_id: 21909,
    wearable_ids: [254, 396],
  },
  {
    genesis_token_id: 21910,
    wearable_ids: [445, 410],
  },
  {
    genesis_token_id: 21911,
    wearable_ids: [372, 284],
  },
  {
    genesis_token_id: 21912,
    wearable_ids: [422, 346],
  },
  {
    genesis_token_id: 21913,
    wearable_ids: [274, 255],
  },
  {
    genesis_token_id: 21914,
    wearable_ids: [311, 323],
  },
  {
    genesis_token_id: 21915,
    wearable_ids: [316, 372],
  },
  {
    genesis_token_id: 21916,
    wearable_ids: [347, 444],
  },
  {
    genesis_token_id: 21917,
    wearable_ids: [256, 310],
  },
  {
    genesis_token_id: 21918,
    wearable_ids: [429, 310],
  },
  {
    genesis_token_id: 21919,
    wearable_ids: [369, 256],
  },
  {
    genesis_token_id: 21920,
    wearable_ids: [384, 300],
  },
  {
    genesis_token_id: 21921,
    wearable_ids: [413, 425],
  },
  {
    genesis_token_id: 21922,
    wearable_ids: [304, 262],
  },
  {
    genesis_token_id: 21923,
    wearable_ids: [296, 429],
  },
  {
    genesis_token_id: 21924,
    wearable_ids: [277, 352],
  },
  {
    genesis_token_id: 21925,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 21926,
    wearable_ids: [409, 342],
  },
  {
    genesis_token_id: 21927,
    wearable_ids: [295, 292],
  },
  {
    genesis_token_id: 21928,
    wearable_ids: [412, 345],
  },
  {
    genesis_token_id: 21929,
    wearable_ids: [382, 263],
  },
  {
    genesis_token_id: 21930,
    wearable_ids: [422, 288],
  },
  {
    genesis_token_id: 21931,
    wearable_ids: [343, 408],
  },
  {
    genesis_token_id: 21932,
    wearable_ids: [331, 295],
  },
  {
    genesis_token_id: 21933,
    wearable_ids: [304, 277],
  },
  {
    genesis_token_id: 21934,
    wearable_ids: [443, 428],
  },
  {
    genesis_token_id: 21935,
    wearable_ids: [268, 410],
  },
  {
    genesis_token_id: 21936,
    wearable_ids: [314, 375],
  },
  {
    genesis_token_id: 21937,
    wearable_ids: [368, 261],
  },
  {
    genesis_token_id: 21938,
    wearable_ids: [406, 339],
  },
  {
    genesis_token_id: 21939,
    wearable_ids: [308, 412],
  },
  {
    genesis_token_id: 21940,
    wearable_ids: [248, 259],
  },
  {
    genesis_token_id: 21941,
    wearable_ids: [326, 429],
  },
  {
    genesis_token_id: 21942,
    wearable_ids: [287, 342],
  },
  {
    genesis_token_id: 21943,
    wearable_ids: [290, 259],
  },
  {
    genesis_token_id: 21944,
    wearable_ids: [350, 312],
  },
  {
    genesis_token_id: 21945,
    wearable_ids: [351, 336],
  },
  {
    genesis_token_id: 21946,
    wearable_ids: [386, 407],
  },
  {
    genesis_token_id: 21947,
    wearable_ids: [442, 348],
  },
  {
    genesis_token_id: 21948,
    wearable_ids: [411, 335],
  },
  {
    genesis_token_id: 21949,
    wearable_ids: [403, 280],
  },
  {
    genesis_token_id: 21950,
    wearable_ids: [389, 311],
  },
  {
    genesis_token_id: 21951,
    wearable_ids: [355, 324],
  },
  {
    genesis_token_id: 21952,
    wearable_ids: [413, 387],
  },
  {
    genesis_token_id: 21953,
    wearable_ids: [306, 247],
  },
  {
    genesis_token_id: 21954,
    wearable_ids: [292, 257],
  },
  {
    genesis_token_id: 21955,
    wearable_ids: [442, 354],
  },
  {
    genesis_token_id: 21956,
    wearable_ids: [284, 289],
  },
  {
    genesis_token_id: 21957,
    wearable_ids: [274, 386],
  },
  {
    genesis_token_id: 21958,
    wearable_ids: [420, 376],
  },
  {
    genesis_token_id: 21959,
    wearable_ids: [264, 427],
  },
  {
    genesis_token_id: 21960,
    wearable_ids: [429, 434],
  },
  {
    genesis_token_id: 21961,
    wearable_ids: [432, 433],
  },
  {
    genesis_token_id: 21962,
    wearable_ids: [415, 409],
  },
  {
    genesis_token_id: 21963,
    wearable_ids: [311, 294],
  },
  {
    genesis_token_id: 21964,
    wearable_ids: [277, 337],
  },
  {
    genesis_token_id: 21965,
    wearable_ids: [272, 420],
  },
  {
    genesis_token_id: 21966,
    wearable_ids: [362, 328],
  },
  {
    genesis_token_id: 21967,
    wearable_ids: [397, 434],
  },
  {
    genesis_token_id: 21968,
    wearable_ids: [259, 297],
  },
  {
    genesis_token_id: 21969,
    wearable_ids: [354, 291],
  },
  {
    genesis_token_id: 21970,
    wearable_ids: [389, 366],
  },
  {
    genesis_token_id: 21971,
    wearable_ids: [247, 408],
  },
  {
    genesis_token_id: 21972,
    wearable_ids: [290, 433],
  },
  {
    genesis_token_id: 21973,
    wearable_ids: [346, 419],
  },
  {
    genesis_token_id: 21974,
    wearable_ids: [411, 280],
  },
  {
    genesis_token_id: 21975,
    wearable_ids: [371, 333],
  },
  {
    genesis_token_id: 21976,
    wearable_ids: [264, 372],
  },
  {
    genesis_token_id: 21977,
    wearable_ids: [314, 376],
  },
  {
    genesis_token_id: 21978,
    wearable_ids: [376, 341],
  },
  {
    genesis_token_id: 21979,
    wearable_ids: [315, 297],
  },
  {
    genesis_token_id: 21980,
    wearable_ids: [277, 298],
  },
  {
    genesis_token_id: 21981,
    wearable_ids: [375, 308],
  },
  {
    genesis_token_id: 21982,
    wearable_ids: [389, 330],
  },
  {
    genesis_token_id: 21983,
    wearable_ids: [337, 396],
  },
  {
    genesis_token_id: 21984,
    wearable_ids: [355, 368],
  },
  {
    genesis_token_id: 21985,
    wearable_ids: [276, 436],
  },
  {
    genesis_token_id: 21986,
    wearable_ids: [347, 305],
  },
  {
    genesis_token_id: 21987,
    wearable_ids: [263, 266],
  },
  {
    genesis_token_id: 21988,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 21989,
    wearable_ids: [256, 403],
  },
  {
    genesis_token_id: 21990,
    wearable_ids: [433, 408],
  },
  {
    genesis_token_id: 21991,
    wearable_ids: [272, 315],
  },
  {
    genesis_token_id: 21992,
    wearable_ids: [296, 267],
  },
  {
    genesis_token_id: 21993,
    wearable_ids: [434, 258],
  },
  {
    genesis_token_id: 21994,
    wearable_ids: [336, 351],
  },
  {
    genesis_token_id: 21995,
    wearable_ids: [399, 384],
  },
  {
    genesis_token_id: 21996,
    wearable_ids: [325, 256],
  },
  {
    genesis_token_id: 21997,
    wearable_ids: [335, 354],
  },
  {
    genesis_token_id: 21998,
    wearable_ids: [344, 440],
  },
  {
    genesis_token_id: 21999,
    wearable_ids: [371, 395],
  },
  {
    genesis_token_id: 22000,
    wearable_ids: [255, 413],
  },
  {
    genesis_token_id: 22001,
    wearable_ids: [389, 308],
  },
  {
    genesis_token_id: 22002,
    wearable_ids: [433, 395],
  },
  {
    genesis_token_id: 22003,
    wearable_ids: [335, 314],
  },
  {
    genesis_token_id: 22004,
    wearable_ids: [352, 365],
  },
  {
    genesis_token_id: 22005,
    wearable_ids: [264, 287],
  },
  {
    genesis_token_id: 22006,
    wearable_ids: [268, 359],
  },
  {
    genesis_token_id: 22007,
    wearable_ids: [332, 395],
  },
  {
    genesis_token_id: 22008,
    wearable_ids: [371, 340],
  },
  {
    genesis_token_id: 22009,
    wearable_ids: [412, 382],
  },
  {
    genesis_token_id: 22010,
    wearable_ids: [274, 322],
  },
  {
    genesis_token_id: 22011,
    wearable_ids: [340, 385],
  },
  {
    genesis_token_id: 22012,
    wearable_ids: [400, 291],
  },
  {
    genesis_token_id: 22013,
    wearable_ids: [383, 438],
  },
  {
    genesis_token_id: 22014,
    wearable_ids: [332, 292],
  },
  {
    genesis_token_id: 22015,
    wearable_ids: [265, 324],
  },
  {
    genesis_token_id: 22016,
    wearable_ids: [265, 294],
  },
  {
    genesis_token_id: 22017,
    wearable_ids: [400, 256],
  },
  {
    genesis_token_id: 22018,
    wearable_ids: [424, 301],
  },
  {
    genesis_token_id: 22019,
    wearable_ids: [295, 312],
  },
  {
    genesis_token_id: 22020,
    wearable_ids: [383, 258],
  },
  {
    genesis_token_id: 22021,
    wearable_ids: [346, 383],
  },
  {
    genesis_token_id: 22022,
    wearable_ids: [272, 276],
  },
  {
    genesis_token_id: 22023,
    wearable_ids: [324, 371],
  },
  {
    genesis_token_id: 22024,
    wearable_ids: [262, 362],
  },
  {
    genesis_token_id: 22025,
    wearable_ids: [248, 286],
  },
  {
    genesis_token_id: 22026,
    wearable_ids: [296, 259],
  },
  {
    genesis_token_id: 22027,
    wearable_ids: [423, 404],
  },
  {
    genesis_token_id: 22028,
    wearable_ids: [257, 395],
  },
  {
    genesis_token_id: 22029,
    wearable_ids: [432, 402],
  },
  {
    genesis_token_id: 22030,
    wearable_ids: [368, 363],
  },
  {
    genesis_token_id: 22031,
    wearable_ids: [292, 291],
  },
  {
    genesis_token_id: 22032,
    wearable_ids: [423, 335],
  },
  {
    genesis_token_id: 22033,
    wearable_ids: [362, 331],
  },
  {
    genesis_token_id: 22034,
    wearable_ids: [432, 262],
  },
  {
    genesis_token_id: 22035,
    wearable_ids: [442, 389],
  },
  {
    genesis_token_id: 22036,
    wearable_ids: [294, 372],
  },
  {
    genesis_token_id: 22037,
    wearable_ids: [297, 424],
  },
  {
    genesis_token_id: 22038,
    wearable_ids: [347, 407],
  },
  {
    genesis_token_id: 22039,
    wearable_ids: [385, 340],
  },
  {
    genesis_token_id: 22040,
    wearable_ids: [271, 254],
  },
  {
    genesis_token_id: 22041,
    wearable_ids: [332, 289],
  },
  {
    genesis_token_id: 22042,
    wearable_ids: [429, 370],
  },
  {
    genesis_token_id: 22043,
    wearable_ids: [265, 420],
  },
  {
    genesis_token_id: 22044,
    wearable_ids: [432, 441],
  },
  {
    genesis_token_id: 22045,
    wearable_ids: [339, 366],
  },
  {
    genesis_token_id: 22046,
    wearable_ids: [424, 306],
  },
  {
    genesis_token_id: 22047,
    wearable_ids: [264, 340],
  },
  {
    genesis_token_id: 22048,
    wearable_ids: [273, 291],
  },
  {
    genesis_token_id: 22049,
    wearable_ids: [420, 258],
  },
  {
    genesis_token_id: 22050,
    wearable_ids: [444, 337],
  },
  {
    genesis_token_id: 22051,
    wearable_ids: [271, 424],
  },
  {
    genesis_token_id: 22052,
    wearable_ids: [400, 285],
  },
  {
    genesis_token_id: 22053,
    wearable_ids: [335, 274],
  },
  {
    genesis_token_id: 22054,
    wearable_ids: [317, 306],
  },
  {
    genesis_token_id: 22055,
    wearable_ids: [373, 296],
  },
  {
    genesis_token_id: 22056,
    wearable_ids: [310, 354],
  },
  {
    genesis_token_id: 22057,
    wearable_ids: [296, 408],
  },
  {
    genesis_token_id: 22058,
    wearable_ids: [280, 338],
  },
  {
    genesis_token_id: 22059,
    wearable_ids: [308, 395],
  },
  {
    genesis_token_id: 22060,
    wearable_ids: [253, 249],
  },
  {
    genesis_token_id: 22061,
    wearable_ids: [425, 253],
  },
  {
    genesis_token_id: 22062,
    wearable_ids: [403, 316],
  },
  {
    genesis_token_id: 22063,
    wearable_ids: [347, 303],
  },
  {
    genesis_token_id: 22064,
    wearable_ids: [287, 352],
  },
  {
    genesis_token_id: 22065,
    wearable_ids: [400, 395],
  },
  {
    genesis_token_id: 22066,
    wearable_ids: [303, 410],
  },
  {
    genesis_token_id: 22067,
    wearable_ids: [368, 395],
  },
  {
    genesis_token_id: 22068,
    wearable_ids: [443, 283],
  },
  {
    genesis_token_id: 22069,
    wearable_ids: [375, 398],
  },
  {
    genesis_token_id: 22070,
    wearable_ids: [434, 435],
  },
  {
    genesis_token_id: 22071,
    wearable_ids: [255, 353],
  },
  {
    genesis_token_id: 22072,
    wearable_ids: [248, 268],
  },
  {
    genesis_token_id: 22073,
    wearable_ids: [431, 310],
  },
  {
    genesis_token_id: 22074,
    wearable_ids: [331, 318],
  },
  {
    genesis_token_id: 22075,
    wearable_ids: [424, 411],
  },
  {
    genesis_token_id: 22076,
    wearable_ids: [443, 296],
  },
  {
    genesis_token_id: 22077,
    wearable_ids: [374, 247],
  },
  {
    genesis_token_id: 22078,
    wearable_ids: [256, 284],
  },
  {
    genesis_token_id: 22079,
    wearable_ids: [325, 369],
  },
  {
    genesis_token_id: 22080,
    wearable_ids: [263, 328],
  },
  {
    genesis_token_id: 22081,
    wearable_ids: [424, 345],
  },
  {
    genesis_token_id: 22082,
    wearable_ids: [248, 427],
  },
  {
    genesis_token_id: 22083,
    wearable_ids: [295, 268],
  },
  {
    genesis_token_id: 22084,
    wearable_ids: [407, 418],
  },
  {
    genesis_token_id: 22085,
    wearable_ids: [443, 257],
  },
  {
    genesis_token_id: 22086,
    wearable_ids: [247, 428],
  },
  {
    genesis_token_id: 22087,
    wearable_ids: [415, 311],
  },
  {
    genesis_token_id: 22088,
    wearable_ids: [248, 262],
  },
  {
    genesis_token_id: 22089,
    wearable_ids: [296, 437],
  },
  {
    genesis_token_id: 22090,
    wearable_ids: [339, 346],
  },
  {
    genesis_token_id: 22091,
    wearable_ids: [344, 253],
  },
  {
    genesis_token_id: 22092,
    wearable_ids: [332, 314],
  },
  {
    genesis_token_id: 22093,
    wearable_ids: [297, 404],
  },
  {
    genesis_token_id: 22094,
    wearable_ids: [420, 432],
  },
  {
    genesis_token_id: 22095,
    wearable_ids: [271, 443],
  },
  {
    genesis_token_id: 22096,
    wearable_ids: [259, 271],
  },
  {
    genesis_token_id: 22097,
    wearable_ids: [264, 253],
  },
  {
    genesis_token_id: 22098,
    wearable_ids: [299, 308],
  },
  {
    genesis_token_id: 22099,
    wearable_ids: [295, 300],
  },
  {
    genesis_token_id: 22100,
    wearable_ids: [306, 351],
  },
  {
    genesis_token_id: 22101,
    wearable_ids: [371, 340],
  },
  {
    genesis_token_id: 22102,
    wearable_ids: [276, 300],
  },
  {
    genesis_token_id: 22103,
    wearable_ids: [255, 415],
  },
  {
    genesis_token_id: 22104,
    wearable_ids: [271, 326],
  },
  {
    genesis_token_id: 22105,
    wearable_ids: [273, 254],
  },
  {
    genesis_token_id: 22106,
    wearable_ids: [339, 301],
  },
  {
    genesis_token_id: 22107,
    wearable_ids: [268, 333],
  },
  {
    genesis_token_id: 22108,
    wearable_ids: [407, 255],
  },
  {
    genesis_token_id: 22109,
    wearable_ids: [445, 312],
  },
  {
    genesis_token_id: 22110,
    wearable_ids: [297, 434],
  },
  {
    genesis_token_id: 22111,
    wearable_ids: [271, 392],
  },
  {
    genesis_token_id: 22112,
    wearable_ids: [338, 420],
  },
  {
    genesis_token_id: 22113,
    wearable_ids: [339, 425],
  },
  {
    genesis_token_id: 22114,
    wearable_ids: [385, 399],
  },
  {
    genesis_token_id: 22115,
    wearable_ids: [341, 396],
  },
  {
    genesis_token_id: 22116,
    wearable_ids: [444, 340],
  },
  {
    genesis_token_id: 22117,
    wearable_ids: [410, 264],
  },
  {
    genesis_token_id: 22118,
    wearable_ids: [310, 396],
  },
  {
    genesis_token_id: 22119,
    wearable_ids: [396, 395],
  },
  {
    genesis_token_id: 22120,
    wearable_ids: [251, 338],
  },
  {
    genesis_token_id: 22121,
    wearable_ids: [369, 428],
  },
  {
    genesis_token_id: 22122,
    wearable_ids: [412, 425],
  },
  {
    genesis_token_id: 22123,
    wearable_ids: [271, 264],
  },
  {
    genesis_token_id: 22124,
    wearable_ids: [284, 408],
  },
  {
    genesis_token_id: 22125,
    wearable_ids: [326, 265],
  },
  {
    genesis_token_id: 22126,
    wearable_ids: [335, 338],
  },
  {
    genesis_token_id: 22127,
    wearable_ids: [325, 376],
  },
  {
    genesis_token_id: 22128,
    wearable_ids: [273, 247],
  },
  {
    genesis_token_id: 22129,
    wearable_ids: [253, 325],
  },
  {
    genesis_token_id: 22130,
    wearable_ids: [424, 336],
  },
  {
    genesis_token_id: 22131,
    wearable_ids: [352, 278],
  },
  {
    genesis_token_id: 22132,
    wearable_ids: [410, 445],
  },
  {
    genesis_token_id: 22133,
    wearable_ids: [337, 307],
  },
  {
    genesis_token_id: 22134,
    wearable_ids: [350, 444],
  },
  {
    genesis_token_id: 22135,
    wearable_ids: [335, 364],
  },
  {
    genesis_token_id: 22136,
    wearable_ids: [292, 272],
  },
  {
    genesis_token_id: 22137,
    wearable_ids: [384, 314],
  },
  {
    genesis_token_id: 22138,
    wearable_ids: [346, 278],
  },
  {
    genesis_token_id: 22139,
    wearable_ids: [352, 368],
  },
  {
    genesis_token_id: 22140,
    wearable_ids: [294, 267],
  },
  {
    genesis_token_id: 22141,
    wearable_ids: [277, 333],
  },
  {
    genesis_token_id: 22142,
    wearable_ids: [387, 361],
  },
  {
    genesis_token_id: 22143,
    wearable_ids: [389, 304],
  },
  {
    genesis_token_id: 22144,
    wearable_ids: [317, 251],
  },
  {
    genesis_token_id: 22145,
    wearable_ids: [300, 393],
  },
  {
    genesis_token_id: 22146,
    wearable_ids: [435, 403],
  },
  {
    genesis_token_id: 22147,
    wearable_ids: [331, 410],
  },
  {
    genesis_token_id: 22148,
    wearable_ids: [258, 310],
  },
  {
    genesis_token_id: 22149,
    wearable_ids: [308, 251],
  },
  {
    genesis_token_id: 22150,
    wearable_ids: [435, 352],
  },
  {
    genesis_token_id: 22151,
    wearable_ids: [387, 340],
  },
  {
    genesis_token_id: 22152,
    wearable_ids: [369, 384],
  },
  {
    genesis_token_id: 22153,
    wearable_ids: [254, 301],
  },
  {
    genesis_token_id: 22154,
    wearable_ids: [399, 368],
  },
  {
    genesis_token_id: 22155,
    wearable_ids: [289, 328],
  },
  {
    genesis_token_id: 22156,
    wearable_ids: [346, 260],
  },
  {
    genesis_token_id: 22157,
    wearable_ids: [316, 346],
  },
  {
    genesis_token_id: 22158,
    wearable_ids: [256, 433],
  },
  {
    genesis_token_id: 22159,
    wearable_ids: [410, 445],
  },
  {
    genesis_token_id: 22160,
    wearable_ids: [422, 314],
  },
  {
    genesis_token_id: 22161,
    wearable_ids: [375, 265],
  },
  {
    genesis_token_id: 22162,
    wearable_ids: [371, 417],
  },
  {
    genesis_token_id: 22163,
    wearable_ids: [294, 311],
  },
  {
    genesis_token_id: 22164,
    wearable_ids: [434, 327],
  },
  {
    genesis_token_id: 22165,
    wearable_ids: [301, 436],
  },
  {
    genesis_token_id: 22166,
    wearable_ids: [437, 374],
  },
  {
    genesis_token_id: 22167,
    wearable_ids: [365, 291],
  },
  {
    genesis_token_id: 22168,
    wearable_ids: [315, 371],
  },
  {
    genesis_token_id: 22169,
    wearable_ids: [443, 423],
  },
  {
    genesis_token_id: 22170,
    wearable_ids: [428, 302],
  },
  {
    genesis_token_id: 22171,
    wearable_ids: [436, 358],
  },
  {
    genesis_token_id: 22172,
    wearable_ids: [395, 306],
  },
  {
    genesis_token_id: 22173,
    wearable_ids: [324, 342],
  },
  {
    genesis_token_id: 22174,
    wearable_ids: [371, 374],
  },
  {
    genesis_token_id: 22175,
    wearable_ids: [432, 417],
  },
  {
    genesis_token_id: 22176,
    wearable_ids: [290, 415],
  },
  {
    genesis_token_id: 22177,
    wearable_ids: [294, 310],
  },
  {
    genesis_token_id: 22178,
    wearable_ids: [429, 319],
  },
  {
    genesis_token_id: 22179,
    wearable_ids: [363, 386],
  },
  {
    genesis_token_id: 22180,
    wearable_ids: [291, 383],
  },
  {
    genesis_token_id: 22181,
    wearable_ids: [424, 263],
  },
  {
    genesis_token_id: 22182,
    wearable_ids: [303, 337],
  },
  {
    genesis_token_id: 22183,
    wearable_ids: [426, 406],
  },
  {
    genesis_token_id: 22184,
    wearable_ids: [365, 290],
  },
  {
    genesis_token_id: 22185,
    wearable_ids: [370, 396],
  },
  {
    genesis_token_id: 22186,
    wearable_ids: [247, 389],
  },
  {
    genesis_token_id: 22187,
    wearable_ids: [431, 370],
  },
  {
    genesis_token_id: 22188,
    wearable_ids: [258, 404],
  },
  {
    genesis_token_id: 22189,
    wearable_ids: [308, 259],
  },
  {
    genesis_token_id: 22190,
    wearable_ids: [296, 258],
  },
  {
    genesis_token_id: 22191,
    wearable_ids: [442, 331],
  },
  {
    genesis_token_id: 22192,
    wearable_ids: [429, 372],
  },
  {
    genesis_token_id: 22193,
    wearable_ids: [389, 356],
  },
  {
    genesis_token_id: 22194,
    wearable_ids: [295, 419],
  },
  {
    genesis_token_id: 22195,
    wearable_ids: [336, 299],
  },
  {
    genesis_token_id: 22196,
    wearable_ids: [389, 301],
  },
  {
    genesis_token_id: 22197,
    wearable_ids: [346, 442],
  },
  {
    genesis_token_id: 22198,
    wearable_ids: [369, 435],
  },
  {
    genesis_token_id: 22199,
    wearable_ids: [368, 354],
  },
  {
    genesis_token_id: 22200,
    wearable_ids: [310, 355],
  },
  {
    genesis_token_id: 22201,
    wearable_ids: [445, 415],
  },
  {
    genesis_token_id: 22202,
    wearable_ids: [365, 268],
  },
  {
    genesis_token_id: 22203,
    wearable_ids: [407, 393],
  },
  {
    genesis_token_id: 22204,
    wearable_ids: [404, 435],
  },
  {
    genesis_token_id: 22205,
    wearable_ids: [348, 352],
  },
  {
    genesis_token_id: 22206,
    wearable_ids: [406, 284],
  },
  {
    genesis_token_id: 22207,
    wearable_ids: [397, 258],
  },
  {
    genesis_token_id: 22208,
    wearable_ids: [365, 325],
  },
  {
    genesis_token_id: 22209,
    wearable_ids: [265, 339],
  },
  {
    genesis_token_id: 22210,
    wearable_ids: [373, 387],
  },
  {
    genesis_token_id: 22211,
    wearable_ids: [389, 265],
  },
  {
    genesis_token_id: 22212,
    wearable_ids: [268, 327],
  },
  {
    genesis_token_id: 22213,
    wearable_ids: [350, 403],
  },
  {
    genesis_token_id: 22214,
    wearable_ids: [247, 394],
  },
  {
    genesis_token_id: 22215,
    wearable_ids: [319, 388],
  },
  {
    genesis_token_id: 22216,
    wearable_ids: [397, 304],
  },
  {
    genesis_token_id: 22217,
    wearable_ids: [300, 378],
  },
  {
    genesis_token_id: 22218,
    wearable_ids: [290, 276],
  },
  {
    genesis_token_id: 22219,
    wearable_ids: [284, 343],
  },
  {
    genesis_token_id: 22220,
    wearable_ids: [443, 334],
  },
  {
    genesis_token_id: 22221,
    wearable_ids: [306, 383],
  },
  {
    genesis_token_id: 22222,
    wearable_ids: [422, 336],
  },
  {
    genesis_token_id: 22223,
    wearable_ids: [368, 351],
  },
  {
    genesis_token_id: 22224,
    wearable_ids: [257, 259],
  },
  {
    genesis_token_id: 22225,
    wearable_ids: [257, 351],
  },
  {
    genesis_token_id: 22226,
    wearable_ids: [317, 384],
  },
  {
    genesis_token_id: 22227,
    wearable_ids: [289, 441],
  },
  {
    genesis_token_id: 22228,
    wearable_ids: [432, 295],
  },
  {
    genesis_token_id: 22229,
    wearable_ids: [385, 338],
  },
  {
    genesis_token_id: 22230,
    wearable_ids: [442, 294],
  },
  {
    genesis_token_id: 22231,
    wearable_ids: [355, 404],
  },
  {
    genesis_token_id: 22232,
    wearable_ids: [389, 324],
  },
  {
    genesis_token_id: 22233,
    wearable_ids: [332, 438],
  },
  {
    genesis_token_id: 22234,
    wearable_ids: [413, 409],
  },
  {
    genesis_token_id: 22235,
    wearable_ids: [349, 319],
  },
  {
    genesis_token_id: 22236,
    wearable_ids: [352, 275],
  },
  {
    genesis_token_id: 22237,
    wearable_ids: [342, 350],
  },
  {
    genesis_token_id: 22238,
    wearable_ids: [299, 346],
  },
  {
    genesis_token_id: 22239,
    wearable_ids: [443, 286],
  },
  {
    genesis_token_id: 22240,
    wearable_ids: [411, 404],
  },
  {
    genesis_token_id: 22241,
    wearable_ids: [375, 368],
  },
  {
    genesis_token_id: 22242,
    wearable_ids: [271, 396],
  },
  {
    genesis_token_id: 22243,
    wearable_ids: [373, 331],
  },
  {
    genesis_token_id: 22244,
    wearable_ids: [303, 317],
  },
  {
    genesis_token_id: 22245,
    wearable_ids: [412, 443],
  },
  {
    genesis_token_id: 22246,
    wearable_ids: [303, 382],
  },
  {
    genesis_token_id: 22247,
    wearable_ids: [266, 426],
  },
  {
    genesis_token_id: 22248,
    wearable_ids: [274, 319],
  },
  {
    genesis_token_id: 22249,
    wearable_ids: [273, 339],
  },
  {
    genesis_token_id: 22250,
    wearable_ids: [314, 298],
  },
  {
    genesis_token_id: 22251,
    wearable_ids: [428, 425],
  },
  {
    genesis_token_id: 22252,
    wearable_ids: [420, 258],
  },
  {
    genesis_token_id: 22253,
    wearable_ids: [429, 336],
  },
  {
    genesis_token_id: 22254,
    wearable_ids: [432, 377],
  },
  {
    genesis_token_id: 22255,
    wearable_ids: [316, 415],
  },
  {
    genesis_token_id: 22256,
    wearable_ids: [396, 363],
  },
  {
    genesis_token_id: 22257,
    wearable_ids: [292, 337],
  },
  {
    genesis_token_id: 22258,
    wearable_ids: [337, 377],
  },
  {
    genesis_token_id: 22259,
    wearable_ids: [383, 351],
  },
  {
    genesis_token_id: 22260,
    wearable_ids: [299, 349],
  },
  {
    genesis_token_id: 22261,
    wearable_ids: [365, 294],
  },
  {
    genesis_token_id: 22262,
    wearable_ids: [342, 422],
  },
  {
    genesis_token_id: 22263,
    wearable_ids: [344, 376],
  },
  {
    genesis_token_id: 22264,
    wearable_ids: [370, 411],
  },
  {
    genesis_token_id: 22265,
    wearable_ids: [383, 422],
  },
  {
    genesis_token_id: 22266,
    wearable_ids: [348, 432],
  },
  {
    genesis_token_id: 22267,
    wearable_ids: [395, 443],
  },
  {
    genesis_token_id: 22268,
    wearable_ids: [412, 351],
  },
  {
    genesis_token_id: 22269,
    wearable_ids: [443, 362],
  },
  {
    genesis_token_id: 22270,
    wearable_ids: [265, 397],
  },
  {
    genesis_token_id: 22271,
    wearable_ids: [387, 436],
  },
  {
    genesis_token_id: 22272,
    wearable_ids: [424, 289],
  },
  {
    genesis_token_id: 22273,
    wearable_ids: [415, 319],
  },
  {
    genesis_token_id: 22274,
    wearable_ids: [291, 266],
  },
  {
    genesis_token_id: 22275,
    wearable_ids: [341, 306],
  },
  {
    genesis_token_id: 22276,
    wearable_ids: [311, 346],
  },
  {
    genesis_token_id: 22277,
    wearable_ids: [255, 250],
  },
  {
    genesis_token_id: 22278,
    wearable_ids: [276, 385],
  },
  {
    genesis_token_id: 22279,
    wearable_ids: [286, 397],
  },
  {
    genesis_token_id: 22280,
    wearable_ids: [303, 340],
  },
  {
    genesis_token_id: 22281,
    wearable_ids: [291, 257],
  },
  {
    genesis_token_id: 22282,
    wearable_ids: [352, 355],
  },
  {
    genesis_token_id: 22283,
    wearable_ids: [270, 401],
  },
  {
    genesis_token_id: 22284,
    wearable_ids: [272, 267],
  },
  {
    genesis_token_id: 22285,
    wearable_ids: [431, 364],
  },
  {
    genesis_token_id: 22286,
    wearable_ids: [311, 299],
  },
  {
    genesis_token_id: 22287,
    wearable_ids: [336, 378],
  },
  {
    genesis_token_id: 22288,
    wearable_ids: [363, 265],
  },
  {
    genesis_token_id: 22289,
    wearable_ids: [326, 332],
  },
  {
    genesis_token_id: 22290,
    wearable_ids: [265, 339],
  },
  {
    genesis_token_id: 22291,
    wearable_ids: [284, 314],
  },
  {
    genesis_token_id: 22292,
    wearable_ids: [351, 400],
  },
  {
    genesis_token_id: 22293,
    wearable_ids: [370, 371],
  },
  {
    genesis_token_id: 22294,
    wearable_ids: [248, 290],
  },
  {
    genesis_token_id: 22295,
    wearable_ids: [368, 343],
  },
  {
    genesis_token_id: 22296,
    wearable_ids: [348, 382],
  },
  {
    genesis_token_id: 22297,
    wearable_ids: [344, 284],
  },
  {
    genesis_token_id: 22298,
    wearable_ids: [408, 290],
  },
  {
    genesis_token_id: 22299,
    wearable_ids: [442, 434],
  },
  {
    genesis_token_id: 22300,
    wearable_ids: [257, 264],
  },
  {
    genesis_token_id: 22301,
    wearable_ids: [301, 313],
  },
  {
    genesis_token_id: 22302,
    wearable_ids: [274, 377],
  },
  {
    genesis_token_id: 22303,
    wearable_ids: [311, 314],
  },
  {
    genesis_token_id: 22304,
    wearable_ids: [373, 275],
  },
  {
    genesis_token_id: 22305,
    wearable_ids: [343, 304],
  },
  {
    genesis_token_id: 22306,
    wearable_ids: [340, 397],
  },
  {
    genesis_token_id: 22307,
    wearable_ids: [336, 350],
  },
  {
    genesis_token_id: 22308,
    wearable_ids: [443, 430],
  },
  {
    genesis_token_id: 22309,
    wearable_ids: [406, 423],
  },
  {
    genesis_token_id: 22310,
    wearable_ids: [397, 391],
  },
  {
    genesis_token_id: 22311,
    wearable_ids: [364, 246],
  },
  {
    genesis_token_id: 22312,
    wearable_ids: [431, 263],
  },
  {
    genesis_token_id: 22313,
    wearable_ids: [343, 389],
  },
  {
    genesis_token_id: 22314,
    wearable_ids: [428, 246],
  },
  {
    genesis_token_id: 22315,
    wearable_ids: [422, 409],
  },
  {
    genesis_token_id: 22316,
    wearable_ids: [255, 343],
  },
  {
    genesis_token_id: 22317,
    wearable_ids: [428, 284],
  },
  {
    genesis_token_id: 22318,
    wearable_ids: [300, 330],
  },
  {
    genesis_token_id: 22319,
    wearable_ids: [294, 424],
  },
  {
    genesis_token_id: 22320,
    wearable_ids: [445, 292],
  },
  {
    genesis_token_id: 22321,
    wearable_ids: [429, 410],
  },
  {
    genesis_token_id: 22322,
    wearable_ids: [404, 290],
  },
  {
    genesis_token_id: 22323,
    wearable_ids: [423, 291],
  },
  {
    genesis_token_id: 22324,
    wearable_ids: [268, 265],
  },
  {
    genesis_token_id: 22325,
    wearable_ids: [370, 436],
  },
  {
    genesis_token_id: 22326,
    wearable_ids: [263, 348],
  },
  {
    genesis_token_id: 22327,
    wearable_ids: [337, 387],
  },
  {
    genesis_token_id: 22328,
    wearable_ids: [413, 397],
  },
  {
    genesis_token_id: 22329,
    wearable_ids: [317, 366],
  },
  {
    genesis_token_id: 22330,
    wearable_ids: [346, 376],
  },
  {
    genesis_token_id: 22331,
    wearable_ids: [365, 374],
  },
  {
    genesis_token_id: 22332,
    wearable_ids: [248, 311],
  },
  {
    genesis_token_id: 22333,
    wearable_ids: [374, 339],
  },
  {
    genesis_token_id: 22334,
    wearable_ids: [420, 300],
  },
  {
    genesis_token_id: 22335,
    wearable_ids: [369, 247],
  },
  {
    genesis_token_id: 22336,
    wearable_ids: [257, 345],
  },
  {
    genesis_token_id: 22337,
    wearable_ids: [268, 270],
  },
  {
    genesis_token_id: 22338,
    wearable_ids: [287, 373],
  },
  {
    genesis_token_id: 22339,
    wearable_ids: [354, 370],
  },
  {
    genesis_token_id: 22340,
    wearable_ids: [290, 297],
  },
  {
    genesis_token_id: 22341,
    wearable_ids: [290, 294],
  },
  {
    genesis_token_id: 22342,
    wearable_ids: [332, 413],
  },
  {
    genesis_token_id: 22343,
    wearable_ids: [386, 248],
  },
  {
    genesis_token_id: 22344,
    wearable_ids: [431, 347],
  },
  {
    genesis_token_id: 22345,
    wearable_ids: [291, 384],
  },
  {
    genesis_token_id: 22346,
    wearable_ids: [445, 300],
  },
  {
    genesis_token_id: 22347,
    wearable_ids: [343, 362],
  },
  {
    genesis_token_id: 22348,
    wearable_ids: [294, 350],
  },
  {
    genesis_token_id: 22349,
    wearable_ids: [399, 437],
  },
  {
    genesis_token_id: 22350,
    wearable_ids: [273, 296],
  },
  {
    genesis_token_id: 22351,
    wearable_ids: [303, 406],
  },
  {
    genesis_token_id: 22352,
    wearable_ids: [435, 262],
  },
  {
    genesis_token_id: 22353,
    wearable_ids: [310, 444],
  },
  {
    genesis_token_id: 22354,
    wearable_ids: [262, 316],
  },
  {
    genesis_token_id: 22355,
    wearable_ids: [295, 310],
  },
  {
    genesis_token_id: 22356,
    wearable_ids: [436, 264],
  },
  {
    genesis_token_id: 22357,
    wearable_ids: [377, 248],
  },
  {
    genesis_token_id: 22358,
    wearable_ids: [423, 443],
  },
  {
    genesis_token_id: 22359,
    wearable_ids: [280, 335],
  },
  {
    genesis_token_id: 22360,
    wearable_ids: [259, 271],
  },
  {
    genesis_token_id: 22361,
    wearable_ids: [348, 279],
  },
  {
    genesis_token_id: 22362,
    wearable_ids: [350, 304],
  },
  {
    genesis_token_id: 22363,
    wearable_ids: [337, 251],
  },
  {
    genesis_token_id: 22364,
    wearable_ids: [411, 296],
  },
  {
    genesis_token_id: 22365,
    wearable_ids: [395, 301],
  },
  {
    genesis_token_id: 22366,
    wearable_ids: [395, 398],
  },
  {
    genesis_token_id: 22367,
    wearable_ids: [382, 396],
  },
  {
    genesis_token_id: 22368,
    wearable_ids: [247, 357],
  },
  {
    genesis_token_id: 22369,
    wearable_ids: [314, 351],
  },
  {
    genesis_token_id: 22370,
    wearable_ids: [385, 338],
  },
  {
    genesis_token_id: 22371,
    wearable_ids: [386, 399],
  },
  {
    genesis_token_id: 22372,
    wearable_ids: [374, 267],
  },
  {
    genesis_token_id: 22373,
    wearable_ids: [338, 256],
  },
  {
    genesis_token_id: 22374,
    wearable_ids: [445, 325],
  },
  {
    genesis_token_id: 22375,
    wearable_ids: [319, 281],
  },
  {
    genesis_token_id: 22376,
    wearable_ids: [374, 327],
  },
  {
    genesis_token_id: 22377,
    wearable_ids: [445, 404],
  },
  {
    genesis_token_id: 22378,
    wearable_ids: [254, 384],
  },
  {
    genesis_token_id: 22379,
    wearable_ids: [400, 338],
  },
  {
    genesis_token_id: 22380,
    wearable_ids: [428, 371],
  },
  {
    genesis_token_id: 22381,
    wearable_ids: [406, 415],
  },
  {
    genesis_token_id: 22382,
    wearable_ids: [408, 386],
  },
  {
    genesis_token_id: 22383,
    wearable_ids: [248, 420],
  },
  {
    genesis_token_id: 22384,
    wearable_ids: [365, 283],
  },
  {
    genesis_token_id: 22385,
    wearable_ids: [415, 442],
  },
  {
    genesis_token_id: 22386,
    wearable_ids: [369, 409],
  },
  {
    genesis_token_id: 22387,
    wearable_ids: [437, 283],
  },
  {
    genesis_token_id: 22388,
    wearable_ids: [336, 383],
  },
  {
    genesis_token_id: 22389,
    wearable_ids: [374, 347],
  },
  {
    genesis_token_id: 22390,
    wearable_ids: [276, 287],
  },
  {
    genesis_token_id: 22391,
    wearable_ids: [354, 308],
  },
  {
    genesis_token_id: 22392,
    wearable_ids: [277, 399],
  },
  {
    genesis_token_id: 22393,
    wearable_ids: [256, 273],
  },
  {
    genesis_token_id: 22394,
    wearable_ids: [310, 262],
  },
  {
    genesis_token_id: 22395,
    wearable_ids: [343, 350],
  },
  {
    genesis_token_id: 22396,
    wearable_ids: [255, 371],
  },
  {
    genesis_token_id: 22397,
    wearable_ids: [376, 258],
  },
  {
    genesis_token_id: 22398,
    wearable_ids: [423, 323],
  },
  {
    genesis_token_id: 22399,
    wearable_ids: [306, 388],
  },
  {
    genesis_token_id: 22400,
    wearable_ids: [368, 290],
  },
  {
    genesis_token_id: 22401,
    wearable_ids: [365, 297],
  },
  {
    genesis_token_id: 22402,
    wearable_ids: [248, 281],
  },
  {
    genesis_token_id: 22403,
    wearable_ids: [324, 313],
  },
  {
    genesis_token_id: 22404,
    wearable_ids: [335, 296],
  },
  {
    genesis_token_id: 22405,
    wearable_ids: [344, 261],
  },
  {
    genesis_token_id: 22406,
    wearable_ids: [403, 363],
  },
  {
    genesis_token_id: 22407,
    wearable_ids: [412, 248],
  },
  {
    genesis_token_id: 22408,
    wearable_ids: [286, 423],
  },
  {
    genesis_token_id: 22409,
    wearable_ids: [258, 377],
  },
  {
    genesis_token_id: 22410,
    wearable_ids: [413, 269],
  },
  {
    genesis_token_id: 22411,
    wearable_ids: [270, 385],
  },
  {
    genesis_token_id: 22412,
    wearable_ids: [280, 248],
  },
  {
    genesis_token_id: 22413,
    wearable_ids: [377, 353],
  },
  {
    genesis_token_id: 22414,
    wearable_ids: [255, 301],
  },
  {
    genesis_token_id: 22415,
    wearable_ids: [272, 280],
  },
  {
    genesis_token_id: 22416,
    wearable_ids: [343, 257],
  },
  {
    genesis_token_id: 22417,
    wearable_ids: [436, 247],
  },
  {
    genesis_token_id: 22418,
    wearable_ids: [297, 437],
  },
  {
    genesis_token_id: 22419,
    wearable_ids: [420, 424],
  },
  {
    genesis_token_id: 22420,
    wearable_ids: [319, 322],
  },
  {
    genesis_token_id: 22421,
    wearable_ids: [276, 398],
  },
  {
    genesis_token_id: 22422,
    wearable_ids: [324, 375],
  },
  {
    genesis_token_id: 22423,
    wearable_ids: [372, 268],
  },
  {
    genesis_token_id: 22424,
    wearable_ids: [286, 368],
  },
  {
    genesis_token_id: 22425,
    wearable_ids: [426, 433],
  },
  {
    genesis_token_id: 22426,
    wearable_ids: [263, 425],
  },
  {
    genesis_token_id: 22427,
    wearable_ids: [408, 292],
  },
  {
    genesis_token_id: 22428,
    wearable_ids: [354, 277],
  },
  {
    genesis_token_id: 22429,
    wearable_ids: [400, 368],
  },
  {
    genesis_token_id: 22430,
    wearable_ids: [257, 426],
  },
  {
    genesis_token_id: 22431,
    wearable_ids: [299, 360],
  },
  {
    genesis_token_id: 22432,
    wearable_ids: [315, 411],
  },
  {
    genesis_token_id: 22433,
    wearable_ids: [350, 316],
  },
  {
    genesis_token_id: 22434,
    wearable_ids: [389, 378],
  },
  {
    genesis_token_id: 22435,
    wearable_ids: [384, 408],
  },
  {
    genesis_token_id: 22436,
    wearable_ids: [349, 365],
  },
  {
    genesis_token_id: 22437,
    wearable_ids: [342, 389],
  },
  {
    genesis_token_id: 22438,
    wearable_ids: [291, 317],
  },
  {
    genesis_token_id: 22439,
    wearable_ids: [254, 284],
  },
  {
    genesis_token_id: 22440,
    wearable_ids: [423, 375],
  },
  {
    genesis_token_id: 22441,
    wearable_ids: [316, 399],
  },
  {
    genesis_token_id: 22442,
    wearable_ids: [372, 408],
  },
  {
    genesis_token_id: 22443,
    wearable_ids: [286, 339],
  },
  {
    genesis_token_id: 22444,
    wearable_ids: [382, 374],
  },
  {
    genesis_token_id: 22445,
    wearable_ids: [296, 331],
  },
  {
    genesis_token_id: 22446,
    wearable_ids: [410, 433],
  },
  {
    genesis_token_id: 22447,
    wearable_ids: [387, 325],
  },
  {
    genesis_token_id: 22448,
    wearable_ids: [428, 438],
  },
  {
    genesis_token_id: 22449,
    wearable_ids: [408, 349],
  },
  {
    genesis_token_id: 22450,
    wearable_ids: [294, 355],
  },
  {
    genesis_token_id: 22451,
    wearable_ids: [408, 350],
  },
  {
    genesis_token_id: 22452,
    wearable_ids: [415, 286],
  },
  {
    genesis_token_id: 22453,
    wearable_ids: [445, 444],
  },
  {
    genesis_token_id: 22454,
    wearable_ids: [395, 270],
  },
  {
    genesis_token_id: 22455,
    wearable_ids: [247, 299],
  },
  {
    genesis_token_id: 22456,
    wearable_ids: [412, 437],
  },
  {
    genesis_token_id: 22457,
    wearable_ids: [294, 406],
  },
  {
    genesis_token_id: 22458,
    wearable_ids: [377, 333],
  },
  {
    genesis_token_id: 22459,
    wearable_ids: [297, 336],
  },
  {
    genesis_token_id: 22460,
    wearable_ids: [386, 417],
  },
  {
    genesis_token_id: 22461,
    wearable_ids: [423, 301],
  },
  {
    genesis_token_id: 22462,
    wearable_ids: [436, 406],
  },
  {
    genesis_token_id: 22463,
    wearable_ids: [263, 289],
  },
  {
    genesis_token_id: 22464,
    wearable_ids: [385, 379],
  },
  {
    genesis_token_id: 22465,
    wearable_ids: [435, 361],
  },
  {
    genesis_token_id: 22466,
    wearable_ids: [376, 259],
  },
  {
    genesis_token_id: 22467,
    wearable_ids: [349, 315],
  },
  {
    genesis_token_id: 22468,
    wearable_ids: [374, 393],
  },
  {
    genesis_token_id: 22469,
    wearable_ids: [413, 346],
  },
  {
    genesis_token_id: 22470,
    wearable_ids: [311, 268],
  },
  {
    genesis_token_id: 22471,
    wearable_ids: [271, 399],
  },
  {
    genesis_token_id: 22472,
    wearable_ids: [326, 431],
  },
  {
    genesis_token_id: 22473,
    wearable_ids: [378, 363],
  },
  {
    genesis_token_id: 22474,
    wearable_ids: [316, 354],
  },
  {
    genesis_token_id: 22475,
    wearable_ids: [347, 324],
  },
  {
    genesis_token_id: 22476,
    wearable_ids: [270, 262],
  },
  {
    genesis_token_id: 22477,
    wearable_ids: [331, 327],
  },
  {
    genesis_token_id: 22478,
    wearable_ids: [347, 352],
  },
  {
    genesis_token_id: 22479,
    wearable_ids: [272, 335],
  },
  {
    genesis_token_id: 22480,
    wearable_ids: [397, 376],
  },
  {
    genesis_token_id: 22481,
    wearable_ids: [277, 383],
  },
  {
    genesis_token_id: 22482,
    wearable_ids: [347, 429],
  },
  {
    genesis_token_id: 22483,
    wearable_ids: [397, 360],
  },
  {
    genesis_token_id: 22484,
    wearable_ids: [434, 271],
  },
  {
    genesis_token_id: 22485,
    wearable_ids: [296, 276],
  },
  {
    genesis_token_id: 22486,
    wearable_ids: [278, 404],
  },
  {
    genesis_token_id: 22487,
    wearable_ids: [349, 438],
  },
  {
    genesis_token_id: 22488,
    wearable_ids: [409, 363],
  },
  {
    genesis_token_id: 22489,
    wearable_ids: [271, 296],
  },
  {
    genesis_token_id: 22490,
    wearable_ids: [397, 295],
  },
  {
    genesis_token_id: 22491,
    wearable_ids: [369, 260],
  },
  {
    genesis_token_id: 22492,
    wearable_ids: [291, 385],
  },
  {
    genesis_token_id: 22493,
    wearable_ids: [326, 432],
  },
  {
    genesis_token_id: 22494,
    wearable_ids: [343, 442],
  },
  {
    genesis_token_id: 22495,
    wearable_ids: [423, 406],
  },
  {
    genesis_token_id: 22496,
    wearable_ids: [338, 316],
  },
  {
    genesis_token_id: 22497,
    wearable_ids: [272, 408],
  },
  {
    genesis_token_id: 22498,
    wearable_ids: [315, 411],
  },
  {
    genesis_token_id: 22499,
    wearable_ids: [348, 280],
  },
  {
    genesis_token_id: 22500,
    wearable_ids: [428, 295],
  },
  {
    genesis_token_id: 22501,
    wearable_ids: [277, 409],
  },
  {
    genesis_token_id: 22502,
    wearable_ids: [370, 294],
  },
  {
    genesis_token_id: 22503,
    wearable_ids: [426, 292],
  },
  {
    genesis_token_id: 22504,
    wearable_ids: [411, 253],
  },
  {
    genesis_token_id: 22505,
    wearable_ids: [315, 403],
  },
  {
    genesis_token_id: 22506,
    wearable_ids: [386, 315],
  },
  {
    genesis_token_id: 22507,
    wearable_ids: [301, 325],
  },
  {
    genesis_token_id: 22508,
    wearable_ids: [310, 284],
  },
  {
    genesis_token_id: 22509,
    wearable_ids: [412, 410],
  },
  {
    genesis_token_id: 22510,
    wearable_ids: [369, 317],
  },
  {
    genesis_token_id: 22511,
    wearable_ids: [340, 363],
  },
  {
    genesis_token_id: 22512,
    wearable_ids: [272, 286],
  },
  {
    genesis_token_id: 22513,
    wearable_ids: [437, 374],
  },
  {
    genesis_token_id: 22514,
    wearable_ids: [348, 419],
  },
  {
    genesis_token_id: 22515,
    wearable_ids: [351, 264],
  },
  {
    genesis_token_id: 22516,
    wearable_ids: [344, 356],
  },
  {
    genesis_token_id: 22517,
    wearable_ids: [319, 384],
  },
  {
    genesis_token_id: 22518,
    wearable_ids: [339, 331],
  },
  {
    genesis_token_id: 22519,
    wearable_ids: [331, 291],
  },
  {
    genesis_token_id: 22520,
    wearable_ids: [268, 313],
  },
  {
    genesis_token_id: 22521,
    wearable_ids: [316, 331],
  },
  {
    genesis_token_id: 22522,
    wearable_ids: [350, 253],
  },
  {
    genesis_token_id: 22523,
    wearable_ids: [255, 251],
  },
  {
    genesis_token_id: 22524,
    wearable_ids: [408, 311],
  },
  {
    genesis_token_id: 22525,
    wearable_ids: [306, 407],
  },
  {
    genesis_token_id: 22526,
    wearable_ids: [254, 355],
  },
  {
    genesis_token_id: 22527,
    wearable_ids: [349, 336],
  },
  {
    genesis_token_id: 22528,
    wearable_ids: [384, 377],
  },
  {
    genesis_token_id: 22529,
    wearable_ids: [442, 265],
  },
  {
    genesis_token_id: 22530,
    wearable_ids: [346, 276],
  },
  {
    genesis_token_id: 22531,
    wearable_ids: [264, 312],
  },
  {
    genesis_token_id: 22532,
    wearable_ids: [255, 442],
  },
  {
    genesis_token_id: 22533,
    wearable_ids: [406, 355],
  },
  {
    genesis_token_id: 22534,
    wearable_ids: [335, 348],
  },
  {
    genesis_token_id: 22535,
    wearable_ids: [386, 325],
  },
  {
    genesis_token_id: 22536,
    wearable_ids: [431, 266],
  },
  {
    genesis_token_id: 22537,
    wearable_ids: [397, 412],
  },
  {
    genesis_token_id: 22538,
    wearable_ids: [428, 305],
  },
  {
    genesis_token_id: 22539,
    wearable_ids: [434, 375],
  },
  {
    genesis_token_id: 22540,
    wearable_ids: [385, 364],
  },
  {
    genesis_token_id: 22541,
    wearable_ids: [294, 413],
  },
  {
    genesis_token_id: 22542,
    wearable_ids: [444, 401],
  },
  {
    genesis_token_id: 22543,
    wearable_ids: [444, 374],
  },
  {
    genesis_token_id: 22544,
    wearable_ids: [264, 276],
  },
  {
    genesis_token_id: 22545,
    wearable_ids: [403, 424],
  },
  {
    genesis_token_id: 22546,
    wearable_ids: [346, 300],
  },
  {
    genesis_token_id: 22547,
    wearable_ids: [409, 267],
  },
  {
    genesis_token_id: 22548,
    wearable_ids: [287, 412],
  },
  {
    genesis_token_id: 22549,
    wearable_ids: [317, 409],
  },
  {
    genesis_token_id: 22550,
    wearable_ids: [270, 425],
  },
  {
    genesis_token_id: 22551,
    wearable_ids: [343, 287],
  },
  {
    genesis_token_id: 22552,
    wearable_ids: [384, 301],
  },
  {
    genesis_token_id: 22553,
    wearable_ids: [433, 434],
  },
  {
    genesis_token_id: 22554,
    wearable_ids: [426, 326],
  },
  {
    genesis_token_id: 22555,
    wearable_ids: [310, 386],
  },
  {
    genesis_token_id: 22556,
    wearable_ids: [276, 420],
  },
  {
    genesis_token_id: 22557,
    wearable_ids: [254, 306],
  },
  {
    genesis_token_id: 22558,
    wearable_ids: [429, 331],
  },
  {
    genesis_token_id: 22559,
    wearable_ids: [278, 274],
  },
  {
    genesis_token_id: 22560,
    wearable_ids: [434, 331],
  },
  {
    genesis_token_id: 22561,
    wearable_ids: [420, 384],
  },
  {
    genesis_token_id: 22562,
    wearable_ids: [257, 306],
  },
  {
    genesis_token_id: 22563,
    wearable_ids: [406, 276],
  },
  {
    genesis_token_id: 22564,
    wearable_ids: [278, 284],
  },
  {
    genesis_token_id: 22565,
    wearable_ids: [278, 257],
  },
  {
    genesis_token_id: 22566,
    wearable_ids: [396, 293],
  },
  {
    genesis_token_id: 22567,
    wearable_ids: [397, 265],
  },
  {
    genesis_token_id: 22568,
    wearable_ids: [254, 310],
  },
  {
    genesis_token_id: 22569,
    wearable_ids: [412, 280],
  },
  {
    genesis_token_id: 22570,
    wearable_ids: [308, 278],
  },
  {
    genesis_token_id: 22571,
    wearable_ids: [262, 376],
  },
  {
    genesis_token_id: 22572,
    wearable_ids: [435, 364],
  },
  {
    genesis_token_id: 22573,
    wearable_ids: [332, 411],
  },
  {
    genesis_token_id: 22574,
    wearable_ids: [410, 436],
  },
  {
    genesis_token_id: 22575,
    wearable_ids: [277, 319],
  },
  {
    genesis_token_id: 22576,
    wearable_ids: [423, 349],
  },
  {
    genesis_token_id: 22577,
    wearable_ids: [423, 387],
  },
  {
    genesis_token_id: 22578,
    wearable_ids: [371, 315],
  },
  {
    genesis_token_id: 22579,
    wearable_ids: [422, 339],
  },
  {
    genesis_token_id: 22580,
    wearable_ids: [364, 296],
  },
  {
    genesis_token_id: 22581,
    wearable_ids: [291, 430],
  },
  {
    genesis_token_id: 22582,
    wearable_ids: [410, 415],
  },
  {
    genesis_token_id: 22583,
    wearable_ids: [346, 374],
  },
  {
    genesis_token_id: 22584,
    wearable_ids: [428, 284],
  },
  {
    genesis_token_id: 22585,
    wearable_ids: [346, 432],
  },
  {
    genesis_token_id: 22586,
    wearable_ids: [342, 351],
  },
  {
    genesis_token_id: 22587,
    wearable_ids: [411, 396],
  },
  {
    genesis_token_id: 22588,
    wearable_ids: [311, 391],
  },
  {
    genesis_token_id: 22589,
    wearable_ids: [400, 428],
  },
  {
    genesis_token_id: 22590,
    wearable_ids: [377, 355],
  },
  {
    genesis_token_id: 22591,
    wearable_ids: [413, 417],
  },
  {
    genesis_token_id: 22592,
    wearable_ids: [276, 333],
  },
  {
    genesis_token_id: 22593,
    wearable_ids: [351, 383],
  },
  {
    genesis_token_id: 22594,
    wearable_ids: [286, 347],
  },
  {
    genesis_token_id: 22595,
    wearable_ids: [310, 365],
  },
  {
    genesis_token_id: 22596,
    wearable_ids: [443, 285],
  },
  {
    genesis_token_id: 22597,
    wearable_ids: [395, 316],
  },
  {
    genesis_token_id: 22598,
    wearable_ids: [349, 246],
  },
  {
    genesis_token_id: 22599,
    wearable_ids: [341, 408],
  },
  {
    genesis_token_id: 22600,
    wearable_ids: [376, 371],
  },
  {
    genesis_token_id: 22601,
    wearable_ids: [331, 354],
  },
  {
    genesis_token_id: 22602,
    wearable_ids: [316, 292],
  },
  {
    genesis_token_id: 22603,
    wearable_ids: [382, 292],
  },
  {
    genesis_token_id: 22604,
    wearable_ids: [407, 336],
  },
  {
    genesis_token_id: 22605,
    wearable_ids: [292, 274],
  },
  {
    genesis_token_id: 22606,
    wearable_ids: [291, 263],
  },
  {
    genesis_token_id: 22607,
    wearable_ids: [370, 303],
  },
  {
    genesis_token_id: 22608,
    wearable_ids: [265, 255],
  },
  {
    genesis_token_id: 22609,
    wearable_ids: [415, 399],
  },
  {
    genesis_token_id: 22610,
    wearable_ids: [351, 284],
  },
  {
    genesis_token_id: 22611,
    wearable_ids: [277, 373],
  },
  {
    genesis_token_id: 22612,
    wearable_ids: [340, 338],
  },
  {
    genesis_token_id: 22613,
    wearable_ids: [341, 317],
  },
  {
    genesis_token_id: 22614,
    wearable_ids: [424, 257],
  },
  {
    genesis_token_id: 22615,
    wearable_ids: [335, 437],
  },
  {
    genesis_token_id: 22616,
    wearable_ids: [425, 310],
  },
  {
    genesis_token_id: 22617,
    wearable_ids: [304, 443],
  },
  {
    genesis_token_id: 22618,
    wearable_ids: [262, 383],
  },
  {
    genesis_token_id: 22619,
    wearable_ids: [266, 257],
  },
  {
    genesis_token_id: 22620,
    wearable_ids: [406, 387],
  },
  {
    genesis_token_id: 22621,
    wearable_ids: [276, 414],
  },
  {
    genesis_token_id: 22622,
    wearable_ids: [351, 435],
  },
  {
    genesis_token_id: 22623,
    wearable_ids: [423, 339],
  },
  {
    genesis_token_id: 22624,
    wearable_ids: [432, 364],
  },
  {
    genesis_token_id: 22625,
    wearable_ids: [304, 335],
  },
  {
    genesis_token_id: 22626,
    wearable_ids: [290, 392],
  },
  {
    genesis_token_id: 22627,
    wearable_ids: [287, 280],
  },
  {
    genesis_token_id: 22628,
    wearable_ids: [397, 276],
  },
  {
    genesis_token_id: 22629,
    wearable_ids: [397, 409],
  },
  {
    genesis_token_id: 22630,
    wearable_ids: [247, 278],
  },
  {
    genesis_token_id: 22631,
    wearable_ids: [443, 444],
  },
  {
    genesis_token_id: 22632,
    wearable_ids: [351, 284],
  },
  {
    genesis_token_id: 22633,
    wearable_ids: [410, 431],
  },
  {
    genesis_token_id: 22634,
    wearable_ids: [434, 374],
  },
  {
    genesis_token_id: 22635,
    wearable_ids: [406, 248],
  },
  {
    genesis_token_id: 22636,
    wearable_ids: [314, 379],
  },
  {
    genesis_token_id: 22637,
    wearable_ids: [284, 424],
  },
  {
    genesis_token_id: 22638,
    wearable_ids: [363, 420],
  },
  {
    genesis_token_id: 22639,
    wearable_ids: [407, 435],
  },
  {
    genesis_token_id: 22640,
    wearable_ids: [294, 338],
  },
  {
    genesis_token_id: 22641,
    wearable_ids: [346, 347],
  },
  {
    genesis_token_id: 22642,
    wearable_ids: [280, 247],
  },
  {
    genesis_token_id: 22643,
    wearable_ids: [349, 354],
  },
  {
    genesis_token_id: 22644,
    wearable_ids: [292, 384],
  },
  {
    genesis_token_id: 22645,
    wearable_ids: [278, 324],
  },
  {
    genesis_token_id: 22646,
    wearable_ids: [432, 294],
  },
  {
    genesis_token_id: 22647,
    wearable_ids: [335, 365],
  },
  {
    genesis_token_id: 22648,
    wearable_ids: [425, 334],
  },
  {
    genesis_token_id: 22649,
    wearable_ids: [406, 445],
  },
  {
    genesis_token_id: 22650,
    wearable_ids: [258, 318],
  },
  {
    genesis_token_id: 22651,
    wearable_ids: [436, 277],
  },
  {
    genesis_token_id: 22652,
    wearable_ids: [407, 306],
  },
  {
    genesis_token_id: 22653,
    wearable_ids: [340, 350],
  },
  {
    genesis_token_id: 22654,
    wearable_ids: [410, 324],
  },
  {
    genesis_token_id: 22655,
    wearable_ids: [316, 404],
  },
  {
    genesis_token_id: 22656,
    wearable_ids: [378, 422],
  },
  {
    genesis_token_id: 22657,
    wearable_ids: [278, 275],
  },
  {
    genesis_token_id: 22658,
    wearable_ids: [422, 383],
  },
  {
    genesis_token_id: 22659,
    wearable_ids: [319, 259],
  },
  {
    genesis_token_id: 22660,
    wearable_ids: [346, 424],
  },
  {
    genesis_token_id: 22661,
    wearable_ids: [326, 355],
  },
  {
    genesis_token_id: 22662,
    wearable_ids: [258, 326],
  },
  {
    genesis_token_id: 22663,
    wearable_ids: [373, 428],
  },
  {
    genesis_token_id: 22664,
    wearable_ids: [299, 374],
  },
  {
    genesis_token_id: 22665,
    wearable_ids: [432, 363],
  },
  {
    genesis_token_id: 22666,
    wearable_ids: [342, 308],
  },
  {
    genesis_token_id: 22667,
    wearable_ids: [266, 295],
  },
  {
    genesis_token_id: 22668,
    wearable_ids: [348, 410],
  },
  {
    genesis_token_id: 22669,
    wearable_ids: [265, 378],
  },
  {
    genesis_token_id: 22670,
    wearable_ids: [280, 389],
  },
  {
    genesis_token_id: 22671,
    wearable_ids: [403, 397],
  },
  {
    genesis_token_id: 22672,
    wearable_ids: [445, 277],
  },
  {
    genesis_token_id: 22673,
    wearable_ids: [410, 437],
  },
  {
    genesis_token_id: 22674,
    wearable_ids: [377, 407],
  },
  {
    genesis_token_id: 22675,
    wearable_ids: [410, 404],
  },
  {
    genesis_token_id: 22676,
    wearable_ids: [314, 294],
  },
  {
    genesis_token_id: 22677,
    wearable_ids: [286, 344],
  },
  {
    genesis_token_id: 22678,
    wearable_ids: [420, 280],
  },
  {
    genesis_token_id: 22679,
    wearable_ids: [428, 277],
  },
  {
    genesis_token_id: 22680,
    wearable_ids: [406, 431],
  },
  {
    genesis_token_id: 22681,
    wearable_ids: [255, 424],
  },
  {
    genesis_token_id: 22682,
    wearable_ids: [342, 320],
  },
  {
    genesis_token_id: 22683,
    wearable_ids: [306, 283],
  },
  {
    genesis_token_id: 22684,
    wearable_ids: [314, 398],
  },
  {
    genesis_token_id: 22685,
    wearable_ids: [311, 337],
  },
  {
    genesis_token_id: 22686,
    wearable_ids: [337, 333],
  },
  {
    genesis_token_id: 22687,
    wearable_ids: [374, 402],
  },
  {
    genesis_token_id: 22688,
    wearable_ids: [355, 354],
  },
  {
    genesis_token_id: 22689,
    wearable_ids: [433, 248],
  },
  {
    genesis_token_id: 22690,
    wearable_ids: [262, 364],
  },
  {
    genesis_token_id: 22691,
    wearable_ids: [385, 331],
  },
  {
    genesis_token_id: 22692,
    wearable_ids: [365, 353],
  },
  {
    genesis_token_id: 22693,
    wearable_ids: [412, 265],
  },
  {
    genesis_token_id: 22694,
    wearable_ids: [407, 262],
  },
  {
    genesis_token_id: 22695,
    wearable_ids: [371, 304],
  },
  {
    genesis_token_id: 22696,
    wearable_ids: [326, 278],
  },
  {
    genesis_token_id: 22697,
    wearable_ids: [420, 317],
  },
  {
    genesis_token_id: 22698,
    wearable_ids: [349, 374],
  },
  {
    genesis_token_id: 22699,
    wearable_ids: [410, 376],
  },
  {
    genesis_token_id: 22700,
    wearable_ids: [369, 270],
  },
  {
    genesis_token_id: 22701,
    wearable_ids: [399, 345],
  },
  {
    genesis_token_id: 22702,
    wearable_ids: [336, 426],
  },
  {
    genesis_token_id: 22703,
    wearable_ids: [372, 341],
  },
  {
    genesis_token_id: 22704,
    wearable_ids: [383, 253],
  },
  {
    genesis_token_id: 22705,
    wearable_ids: [362, 399],
  },
  {
    genesis_token_id: 22706,
    wearable_ids: [431, 276],
  },
  {
    genesis_token_id: 22707,
    wearable_ids: [342, 325],
  },
  {
    genesis_token_id: 22708,
    wearable_ids: [280, 250],
  },
  {
    genesis_token_id: 22709,
    wearable_ids: [310, 341],
  },
  {
    genesis_token_id: 22710,
    wearable_ids: [373, 314],
  },
  {
    genesis_token_id: 22711,
    wearable_ids: [248, 288],
  },
  {
    genesis_token_id: 22712,
    wearable_ids: [264, 271],
  },
  {
    genesis_token_id: 22713,
    wearable_ids: [272, 415],
  },
  {
    genesis_token_id: 22714,
    wearable_ids: [435, 366],
  },
  {
    genesis_token_id: 22715,
    wearable_ids: [301, 318],
  },
  {
    genesis_token_id: 22716,
    wearable_ids: [362, 337],
  },
  {
    genesis_token_id: 22717,
    wearable_ids: [407, 352],
  },
  {
    genesis_token_id: 22718,
    wearable_ids: [373, 363],
  },
  {
    genesis_token_id: 22719,
    wearable_ids: [341, 394],
  },
  {
    genesis_token_id: 22720,
    wearable_ids: [339, 276],
  },
  {
    genesis_token_id: 22721,
    wearable_ids: [256, 250],
  },
  {
    genesis_token_id: 22722,
    wearable_ids: [256, 303],
  },
  {
    genesis_token_id: 22723,
    wearable_ids: [443, 281],
  },
  {
    genesis_token_id: 22724,
    wearable_ids: [411, 355],
  },
  {
    genesis_token_id: 22725,
    wearable_ids: [428, 397],
  },
  {
    genesis_token_id: 22726,
    wearable_ids: [352, 436],
  },
  {
    genesis_token_id: 22727,
    wearable_ids: [365, 273],
  },
  {
    genesis_token_id: 22728,
    wearable_ids: [300, 411],
  },
  {
    genesis_token_id: 22729,
    wearable_ids: [290, 338],
  },
  {
    genesis_token_id: 22730,
    wearable_ids: [429, 406],
  },
  {
    genesis_token_id: 22731,
    wearable_ids: [255, 374],
  },
  {
    genesis_token_id: 22732,
    wearable_ids: [317, 428],
  },
  {
    genesis_token_id: 22733,
    wearable_ids: [377, 247],
  },
  {
    genesis_token_id: 22734,
    wearable_ids: [415, 338],
  },
  {
    genesis_token_id: 22735,
    wearable_ids: [374, 270],
  },
  {
    genesis_token_id: 22736,
    wearable_ids: [374, 248],
  },
  {
    genesis_token_id: 22737,
    wearable_ids: [382, 270],
  },
  {
    genesis_token_id: 22738,
    wearable_ids: [371, 272],
  },
  {
    genesis_token_id: 22739,
    wearable_ids: [433, 410],
  },
  {
    genesis_token_id: 22740,
    wearable_ids: [363, 352],
  },
  {
    genesis_token_id: 22741,
    wearable_ids: [403, 413],
  },
  {
    genesis_token_id: 22742,
    wearable_ids: [412, 348],
  },
  {
    genesis_token_id: 22743,
    wearable_ids: [306, 413],
  },
  {
    genesis_token_id: 22744,
    wearable_ids: [326, 248],
  },
  {
    genesis_token_id: 22745,
    wearable_ids: [314, 349],
  },
  {
    genesis_token_id: 22746,
    wearable_ids: [291, 351],
  },
  {
    genesis_token_id: 22747,
    wearable_ids: [346, 272],
  },
  {
    genesis_token_id: 22748,
    wearable_ids: [287, 429],
  },
  {
    genesis_token_id: 22749,
    wearable_ids: [389, 422],
  },
  {
    genesis_token_id: 22750,
    wearable_ids: [382, 255],
  },
  {
    genesis_token_id: 22751,
    wearable_ids: [365, 383],
  },
  {
    genesis_token_id: 22752,
    wearable_ids: [304, 247],
  },
  {
    genesis_token_id: 22753,
    wearable_ids: [346, 264],
  },
  {
    genesis_token_id: 22754,
    wearable_ids: [445, 264],
  },
  {
    genesis_token_id: 22755,
    wearable_ids: [378, 351],
  },
  {
    genesis_token_id: 22756,
    wearable_ids: [371, 384],
  },
  {
    genesis_token_id: 22757,
    wearable_ids: [445, 394],
  },
  {
    genesis_token_id: 22758,
    wearable_ids: [443, 305],
  },
  {
    genesis_token_id: 22759,
    wearable_ids: [425, 249],
  },
  {
    genesis_token_id: 22760,
    wearable_ids: [289, 271],
  },
  {
    genesis_token_id: 22761,
    wearable_ids: [365, 288],
  },
  {
    genesis_token_id: 22762,
    wearable_ids: [400, 364],
  },
  {
    genesis_token_id: 22763,
    wearable_ids: [377, 431],
  },
  {
    genesis_token_id: 22764,
    wearable_ids: [255, 343],
  },
  {
    genesis_token_id: 22765,
    wearable_ids: [349, 368],
  },
  {
    genesis_token_id: 22766,
    wearable_ids: [265, 427],
  },
  {
    genesis_token_id: 22767,
    wearable_ids: [363, 330],
  },
  {
    genesis_token_id: 22768,
    wearable_ids: [270, 254],
  },
  {
    genesis_token_id: 22769,
    wearable_ids: [280, 413],
  },
  {
    genesis_token_id: 22770,
    wearable_ids: [254, 262],
  },
  {
    genesis_token_id: 22771,
    wearable_ids: [294, 283],
  },
  {
    genesis_token_id: 22772,
    wearable_ids: [349, 263],
  },
  {
    genesis_token_id: 22773,
    wearable_ids: [444, 355],
  },
  {
    genesis_token_id: 22774,
    wearable_ids: [324, 299],
  },
  {
    genesis_token_id: 22775,
    wearable_ids: [344, 343],
  },
  {
    genesis_token_id: 22776,
    wearable_ids: [336, 426],
  },
  {
    genesis_token_id: 22777,
    wearable_ids: [374, 259],
  },
  {
    genesis_token_id: 22778,
    wearable_ids: [369, 310],
  },
  {
    genesis_token_id: 22779,
    wearable_ids: [326, 399],
  },
  {
    genesis_token_id: 22780,
    wearable_ids: [255, 355],
  },
  {
    genesis_token_id: 22781,
    wearable_ids: [266, 443],
  },
  {
    genesis_token_id: 22782,
    wearable_ids: [343, 378],
  },
  {
    genesis_token_id: 22783,
    wearable_ids: [354, 340],
  },
  {
    genesis_token_id: 22784,
    wearable_ids: [386, 412],
  },
  {
    genesis_token_id: 22785,
    wearable_ids: [340, 342],
  },
  {
    genesis_token_id: 22786,
    wearable_ids: [262, 326],
  },
  {
    genesis_token_id: 22787,
    wearable_ids: [425, 336],
  },
  {
    genesis_token_id: 22788,
    wearable_ids: [247, 250],
  },
  {
    genesis_token_id: 22789,
    wearable_ids: [387, 404],
  },
  {
    genesis_token_id: 22790,
    wearable_ids: [289, 377],
  },
  {
    genesis_token_id: 22791,
    wearable_ids: [254, 413],
  },
  {
    genesis_token_id: 22792,
    wearable_ids: [272, 372],
  },
  {
    genesis_token_id: 22793,
    wearable_ids: [413, 266],
  },
  {
    genesis_token_id: 22794,
    wearable_ids: [424, 336],
  },
  {
    genesis_token_id: 22795,
    wearable_ids: [445, 337],
  },
  {
    genesis_token_id: 22796,
    wearable_ids: [442, 386],
  },
  {
    genesis_token_id: 22797,
    wearable_ids: [314, 264],
  },
  {
    genesis_token_id: 22798,
    wearable_ids: [303, 311],
  },
  {
    genesis_token_id: 22799,
    wearable_ids: [303, 256],
  },
  {
    genesis_token_id: 22800,
    wearable_ids: [258, 291],
  },
  {
    genesis_token_id: 22801,
    wearable_ids: [273, 434],
  },
  {
    genesis_token_id: 22802,
    wearable_ids: [284, 389],
  },
  {
    genesis_token_id: 22803,
    wearable_ids: [409, 368],
  },
  {
    genesis_token_id: 22804,
    wearable_ids: [280, 349],
  },
  {
    genesis_token_id: 22805,
    wearable_ids: [364, 400],
  },
  {
    genesis_token_id: 22806,
    wearable_ids: [426, 319],
  },
  {
    genesis_token_id: 22807,
    wearable_ids: [423, 344],
  },
  {
    genesis_token_id: 22808,
    wearable_ids: [426, 396],
  },
  {
    genesis_token_id: 22809,
    wearable_ids: [377, 287],
  },
  {
    genesis_token_id: 22810,
    wearable_ids: [319, 285],
  },
  {
    genesis_token_id: 22811,
    wearable_ids: [429, 326],
  },
  {
    genesis_token_id: 22812,
    wearable_ids: [314, 313],
  },
  {
    genesis_token_id: 22813,
    wearable_ids: [397, 400],
  },
  {
    genesis_token_id: 22814,
    wearable_ids: [410, 395],
  },
  {
    genesis_token_id: 22815,
    wearable_ids: [404, 276],
  },
  {
    genesis_token_id: 22816,
    wearable_ids: [295, 362],
  },
  {
    genesis_token_id: 22817,
    wearable_ids: [255, 436],
  },
  {
    genesis_token_id: 22818,
    wearable_ids: [375, 262],
  },
  {
    genesis_token_id: 22819,
    wearable_ids: [341, 372],
  },
  {
    genesis_token_id: 22820,
    wearable_ids: [335, 259],
  },
  {
    genesis_token_id: 22821,
    wearable_ids: [374, 424],
  },
  {
    genesis_token_id: 22822,
    wearable_ids: [299, 316],
  },
  {
    genesis_token_id: 22823,
    wearable_ids: [384, 255],
  },
  {
    genesis_token_id: 22824,
    wearable_ids: [368, 359],
  },
  {
    genesis_token_id: 22825,
    wearable_ids: [435, 304],
  },
  {
    genesis_token_id: 22826,
    wearable_ids: [276, 294],
  },
  {
    genesis_token_id: 22827,
    wearable_ids: [276, 339],
  },
  {
    genesis_token_id: 22828,
    wearable_ids: [339, 306],
  },
  {
    genesis_token_id: 22829,
    wearable_ids: [335, 343],
  },
  {
    genesis_token_id: 22830,
    wearable_ids: [437, 336],
  },
  {
    genesis_token_id: 22831,
    wearable_ids: [350, 375],
  },
  {
    genesis_token_id: 22832,
    wearable_ids: [348, 443],
  },
  {
    genesis_token_id: 22833,
    wearable_ids: [292, 350],
  },
  {
    genesis_token_id: 22834,
    wearable_ids: [415, 413],
  },
  {
    genesis_token_id: 22835,
    wearable_ids: [368, 373],
  },
  {
    genesis_token_id: 22836,
    wearable_ids: [296, 350],
  },
  {
    genesis_token_id: 22837,
    wearable_ids: [354, 432],
  },
  {
    genesis_token_id: 22838,
    wearable_ids: [259, 376],
  },
  {
    genesis_token_id: 22839,
    wearable_ids: [308, 436],
  },
  {
    genesis_token_id: 22840,
    wearable_ids: [251, 437],
  },
  {
    genesis_token_id: 22841,
    wearable_ids: [415, 304],
  },
  {
    genesis_token_id: 22842,
    wearable_ids: [325, 273],
  },
  {
    genesis_token_id: 22843,
    wearable_ids: [289, 426],
  },
  {
    genesis_token_id: 22844,
    wearable_ids: [264, 295],
  },
  {
    genesis_token_id: 22845,
    wearable_ids: [397, 313],
  },
  {
    genesis_token_id: 22846,
    wearable_ids: [389, 444],
  },
  {
    genesis_token_id: 22847,
    wearable_ids: [425, 444],
  },
  {
    genesis_token_id: 22848,
    wearable_ids: [375, 418],
  },
  {
    genesis_token_id: 22849,
    wearable_ids: [319, 391],
  },
  {
    genesis_token_id: 22850,
    wearable_ids: [338, 396],
  },
  {
    genesis_token_id: 22851,
    wearable_ids: [336, 341],
  },
  {
    genesis_token_id: 22852,
    wearable_ids: [325, 415],
  },
  {
    genesis_token_id: 22853,
    wearable_ids: [341, 399],
  },
  {
    genesis_token_id: 22854,
    wearable_ids: [292, 444],
  },
  {
    genesis_token_id: 22855,
    wearable_ids: [413, 355],
  },
  {
    genesis_token_id: 22856,
    wearable_ids: [355, 255],
  },
  {
    genesis_token_id: 22857,
    wearable_ids: [337, 412],
  },
  {
    genesis_token_id: 22858,
    wearable_ids: [284, 376],
  },
  {
    genesis_token_id: 22859,
    wearable_ids: [258, 308],
  },
  {
    genesis_token_id: 22860,
    wearable_ids: [331, 283],
  },
  {
    genesis_token_id: 22861,
    wearable_ids: [300, 403],
  },
  {
    genesis_token_id: 22862,
    wearable_ids: [368, 314],
  },
  {
    genesis_token_id: 22863,
    wearable_ids: [383, 314],
  },
  {
    genesis_token_id: 22864,
    wearable_ids: [295, 383],
  },
  {
    genesis_token_id: 22865,
    wearable_ids: [422, 290],
  },
  {
    genesis_token_id: 22866,
    wearable_ids: [396, 272],
  },
  {
    genesis_token_id: 22867,
    wearable_ids: [378, 332],
  },
  {
    genesis_token_id: 22868,
    wearable_ids: [444, 375],
  },
  {
    genesis_token_id: 22869,
    wearable_ids: [336, 435],
  },
  {
    genesis_token_id: 22870,
    wearable_ids: [400, 383],
  },
  {
    genesis_token_id: 22871,
    wearable_ids: [296, 428],
  },
  {
    genesis_token_id: 22872,
    wearable_ids: [264, 410],
  },
  {
    genesis_token_id: 22873,
    wearable_ids: [383, 348],
  },
  {
    genesis_token_id: 22874,
    wearable_ids: [290, 428],
  },
  {
    genesis_token_id: 22875,
    wearable_ids: [284, 368],
  },
  {
    genesis_token_id: 22876,
    wearable_ids: [374, 301],
  },
  {
    genesis_token_id: 22877,
    wearable_ids: [384, 337],
  },
  {
    genesis_token_id: 22878,
    wearable_ids: [373, 411],
  },
  {
    genesis_token_id: 22879,
    wearable_ids: [325, 310],
  },
  {
    genesis_token_id: 22880,
    wearable_ids: [255, 409],
  },
  {
    genesis_token_id: 22881,
    wearable_ids: [292, 404],
  },
  {
    genesis_token_id: 22882,
    wearable_ids: [348, 387],
  },
  {
    genesis_token_id: 22883,
    wearable_ids: [311, 438],
  },
  {
    genesis_token_id: 22884,
    wearable_ids: [382, 297],
  },
  {
    genesis_token_id: 22885,
    wearable_ids: [378, 317],
  },
  {
    genesis_token_id: 22886,
    wearable_ids: [374, 375],
  },
  {
    genesis_token_id: 22887,
    wearable_ids: [377, 294],
  },
  {
    genesis_token_id: 22888,
    wearable_ids: [290, 398],
  },
  {
    genesis_token_id: 22889,
    wearable_ids: [276, 254],
  },
  {
    genesis_token_id: 22890,
    wearable_ids: [435, 401],
  },
  {
    genesis_token_id: 22891,
    wearable_ids: [444, 443],
  },
  {
    genesis_token_id: 22892,
    wearable_ids: [444, 376],
  },
  {
    genesis_token_id: 22893,
    wearable_ids: [363, 254],
  },
  {
    genesis_token_id: 22894,
    wearable_ids: [432, 310],
  },
  {
    genesis_token_id: 22895,
    wearable_ids: [247, 314],
  },
  {
    genesis_token_id: 22896,
    wearable_ids: [368, 271],
  },
  {
    genesis_token_id: 22897,
    wearable_ids: [368, 372],
  },
  {
    genesis_token_id: 22898,
    wearable_ids: [317, 293],
  },
  {
    genesis_token_id: 22899,
    wearable_ids: [251, 290],
  },
  {
    genesis_token_id: 22900,
    wearable_ids: [306, 337],
  },
  {
    genesis_token_id: 22901,
    wearable_ids: [271, 362],
  },
  {
    genesis_token_id: 22902,
    wearable_ids: [351, 370],
  },
  {
    genesis_token_id: 22903,
    wearable_ids: [376, 342],
  },
  {
    genesis_token_id: 22904,
    wearable_ids: [272, 445],
  },
  {
    genesis_token_id: 22905,
    wearable_ids: [373, 269],
  },
  {
    genesis_token_id: 22906,
    wearable_ids: [437, 323],
  },
  {
    genesis_token_id: 22907,
    wearable_ids: [278, 325],
  },
  {
    genesis_token_id: 22908,
    wearable_ids: [346, 445],
  },
  {
    genesis_token_id: 22909,
    wearable_ids: [371, 273],
  },
  {
    genesis_token_id: 22910,
    wearable_ids: [273, 353],
  },
  {
    genesis_token_id: 22911,
    wearable_ids: [355, 423],
  },
  {
    genesis_token_id: 22912,
    wearable_ids: [340, 292],
  },
  {
    genesis_token_id: 22913,
    wearable_ids: [262, 388],
  },
  {
    genesis_token_id: 22914,
    wearable_ids: [257, 407],
  },
  {
    genesis_token_id: 22915,
    wearable_ids: [412, 434],
  },
  {
    genesis_token_id: 22916,
    wearable_ids: [404, 349],
  },
  {
    genesis_token_id: 22917,
    wearable_ids: [354, 270],
  },
  {
    genesis_token_id: 22918,
    wearable_ids: [266, 276],
  },
  {
    genesis_token_id: 22919,
    wearable_ids: [326, 295],
  },
  {
    genesis_token_id: 22920,
    wearable_ids: [262, 296],
  },
  {
    genesis_token_id: 22921,
    wearable_ids: [365, 328],
  },
  {
    genesis_token_id: 22922,
    wearable_ids: [291, 275],
  },
  {
    genesis_token_id: 22923,
    wearable_ids: [266, 386],
  },
  {
    genesis_token_id: 22924,
    wearable_ids: [376, 304],
  },
  {
    genesis_token_id: 22925,
    wearable_ids: [437, 307],
  },
  {
    genesis_token_id: 22926,
    wearable_ids: [344, 287],
  },
  {
    genesis_token_id: 22927,
    wearable_ids: [365, 330],
  },
  {
    genesis_token_id: 22928,
    wearable_ids: [372, 339],
  },
  {
    genesis_token_id: 22929,
    wearable_ids: [271, 305],
  },
  {
    genesis_token_id: 22930,
    wearable_ids: [444, 440],
  },
  {
    genesis_token_id: 22931,
    wearable_ids: [264, 436],
  },
  {
    genesis_token_id: 22932,
    wearable_ids: [290, 350],
  },
  {
    genesis_token_id: 22933,
    wearable_ids: [344, 303],
  },
  {
    genesis_token_id: 22934,
    wearable_ids: [389, 301],
  },
  {
    genesis_token_id: 22935,
    wearable_ids: [433, 332],
  },
  {
    genesis_token_id: 22936,
    wearable_ids: [436, 375],
  },
  {
    genesis_token_id: 22937,
    wearable_ids: [350, 389],
  },
  {
    genesis_token_id: 22938,
    wearable_ids: [444, 294],
  },
  {
    genesis_token_id: 22939,
    wearable_ids: [369, 287],
  },
  {
    genesis_token_id: 22940,
    wearable_ids: [315, 431],
  },
  {
    genesis_token_id: 22941,
    wearable_ids: [280, 395],
  },
  {
    genesis_token_id: 22942,
    wearable_ids: [420, 269],
  },
  {
    genesis_token_id: 22943,
    wearable_ids: [294, 291],
  },
  {
    genesis_token_id: 22944,
    wearable_ids: [422, 296],
  },
  {
    genesis_token_id: 22945,
    wearable_ids: [278, 328],
  },
  {
    genesis_token_id: 22946,
    wearable_ids: [389, 387],
  },
  {
    genesis_token_id: 22947,
    wearable_ids: [426, 300],
  },
  {
    genesis_token_id: 22948,
    wearable_ids: [426, 375],
  },
  {
    genesis_token_id: 22949,
    wearable_ids: [415, 426],
  },
  {
    genesis_token_id: 22950,
    wearable_ids: [347, 331],
  },
  {
    genesis_token_id: 22951,
    wearable_ids: [262, 248],
  },
  {
    genesis_token_id: 22952,
    wearable_ids: [436, 371],
  },
  {
    genesis_token_id: 22953,
    wearable_ids: [444, 337],
  },
  {
    genesis_token_id: 22954,
    wearable_ids: [277, 306],
  },
  {
    genesis_token_id: 22955,
    wearable_ids: [408, 265],
  },
  {
    genesis_token_id: 22956,
    wearable_ids: [386, 306],
  },
  {
    genesis_token_id: 22957,
    wearable_ids: [272, 278],
  },
  {
    genesis_token_id: 22958,
    wearable_ids: [310, 387],
  },
  {
    genesis_token_id: 22959,
    wearable_ids: [372, 355],
  },
  {
    genesis_token_id: 22960,
    wearable_ids: [352, 276],
  },
  {
    genesis_token_id: 22961,
    wearable_ids: [342, 296],
  },
  {
    genesis_token_id: 22962,
    wearable_ids: [437, 349],
  },
  {
    genesis_token_id: 22963,
    wearable_ids: [280, 319],
  },
  {
    genesis_token_id: 22964,
    wearable_ids: [270, 267],
  },
  {
    genesis_token_id: 22965,
    wearable_ids: [304, 419],
  },
  {
    genesis_token_id: 22966,
    wearable_ids: [274, 371],
  },
  {
    genesis_token_id: 22967,
    wearable_ids: [385, 313],
  },
  {
    genesis_token_id: 22968,
    wearable_ids: [431, 423],
  },
  {
    genesis_token_id: 22969,
    wearable_ids: [284, 291],
  },
  {
    genesis_token_id: 22970,
    wearable_ids: [370, 304],
  },
  {
    genesis_token_id: 22971,
    wearable_ids: [385, 310],
  },
  {
    genesis_token_id: 22972,
    wearable_ids: [251, 299],
  },
  {
    genesis_token_id: 22973,
    wearable_ids: [277, 271],
  },
  {
    genesis_token_id: 22974,
    wearable_ids: [429, 276],
  },
  {
    genesis_token_id: 22975,
    wearable_ids: [296, 331],
  },
  {
    genesis_token_id: 22976,
    wearable_ids: [395, 409],
  },
  {
    genesis_token_id: 22977,
    wearable_ids: [266, 325],
  },
  {
    genesis_token_id: 22978,
    wearable_ids: [435, 385],
  },
  {
    genesis_token_id: 22979,
    wearable_ids: [319, 283],
  },
  {
    genesis_token_id: 22980,
    wearable_ids: [346, 425],
  },
  {
    genesis_token_id: 22981,
    wearable_ids: [423, 422],
  },
  {
    genesis_token_id: 22982,
    wearable_ids: [289, 280],
  },
  {
    genesis_token_id: 22983,
    wearable_ids: [428, 344],
  },
  {
    genesis_token_id: 22984,
    wearable_ids: [411, 346],
  },
  {
    genesis_token_id: 22985,
    wearable_ids: [335, 311],
  },
  {
    genesis_token_id: 22986,
    wearable_ids: [301, 402],
  },
  {
    genesis_token_id: 22987,
    wearable_ids: [350, 425],
  },
  {
    genesis_token_id: 22988,
    wearable_ids: [443, 404],
  },
  {
    genesis_token_id: 22989,
    wearable_ids: [433, 363],
  },
  {
    genesis_token_id: 22990,
    wearable_ids: [355, 377],
  },
  {
    genesis_token_id: 22991,
    wearable_ids: [292, 325],
  },
  {
    genesis_token_id: 22992,
    wearable_ids: [433, 300],
  },
  {
    genesis_token_id: 22993,
    wearable_ids: [400, 435],
  },
  {
    genesis_token_id: 22994,
    wearable_ids: [251, 396],
  },
  {
    genesis_token_id: 22995,
    wearable_ids: [259, 353],
  },
  {
    genesis_token_id: 22996,
    wearable_ids: [372, 431],
  },
  {
    genesis_token_id: 22997,
    wearable_ids: [349, 334],
  },
  {
    genesis_token_id: 22998,
    wearable_ids: [431, 291],
  },
  {
    genesis_token_id: 22999,
    wearable_ids: [251, 264],
  },
  {
    genesis_token_id: 23000,
    wearable_ids: [274, 382],
  },
  {
    genesis_token_id: 23001,
    wearable_ids: [399, 415],
  },
  {
    genesis_token_id: 23002,
    wearable_ids: [319, 434],
  },
  {
    genesis_token_id: 23003,
    wearable_ids: [280, 352],
  },
  {
    genesis_token_id: 23004,
    wearable_ids: [276, 354],
  },
  {
    genesis_token_id: 23005,
    wearable_ids: [297, 323],
  },
  {
    genesis_token_id: 23006,
    wearable_ids: [341, 308],
  },
  {
    genesis_token_id: 23007,
    wearable_ids: [406, 275],
  },
  {
    genesis_token_id: 23008,
    wearable_ids: [384, 355],
  },
  {
    genesis_token_id: 23009,
    wearable_ids: [374, 325],
  },
  {
    genesis_token_id: 23010,
    wearable_ids: [268, 312],
  },
  {
    genesis_token_id: 23011,
    wearable_ids: [364, 286],
  },
  {
    genesis_token_id: 23012,
    wearable_ids: [259, 384],
  },
  {
    genesis_token_id: 23013,
    wearable_ids: [407, 330],
  },
  {
    genesis_token_id: 23014,
    wearable_ids: [337, 389],
  },
  {
    genesis_token_id: 23015,
    wearable_ids: [411, 291],
  },
  {
    genesis_token_id: 23016,
    wearable_ids: [291, 311],
  },
  {
    genesis_token_id: 23017,
    wearable_ids: [274, 396],
  },
  {
    genesis_token_id: 23018,
    wearable_ids: [354, 308],
  },
  {
    genesis_token_id: 23019,
    wearable_ids: [396, 361],
  },
  {
    genesis_token_id: 23020,
    wearable_ids: [429, 314],
  },
  {
    genesis_token_id: 23021,
    wearable_ids: [431, 434],
  },
  {
    genesis_token_id: 23022,
    wearable_ids: [442, 274],
  },
  {
    genesis_token_id: 23023,
    wearable_ids: [352, 432],
  },
  {
    genesis_token_id: 23024,
    wearable_ids: [431, 319],
  },
  {
    genesis_token_id: 23025,
    wearable_ids: [442, 422],
  },
  {
    genesis_token_id: 23026,
    wearable_ids: [435, 265],
  },
  {
    genesis_token_id: 23027,
    wearable_ids: [335, 273],
  },
  {
    genesis_token_id: 23028,
    wearable_ids: [433, 308],
  },
  {
    genesis_token_id: 23029,
    wearable_ids: [265, 379],
  },
  {
    genesis_token_id: 23030,
    wearable_ids: [373, 271],
  },
  {
    genesis_token_id: 23031,
    wearable_ids: [263, 271],
  },
  {
    genesis_token_id: 23032,
    wearable_ids: [415, 246],
  },
  {
    genesis_token_id: 23033,
    wearable_ids: [270, 370],
  },
  {
    genesis_token_id: 23034,
    wearable_ids: [337, 315],
  },
  {
    genesis_token_id: 23035,
    wearable_ids: [403, 263],
  },
  {
    genesis_token_id: 23036,
    wearable_ids: [301, 265],
  },
  {
    genesis_token_id: 23037,
    wearable_ids: [299, 441],
  },
  {
    genesis_token_id: 23038,
    wearable_ids: [429, 373],
  },
  {
    genesis_token_id: 23039,
    wearable_ids: [264, 442],
  },
  {
    genesis_token_id: 23040,
    wearable_ids: [412, 445],
  },
  {
    genesis_token_id: 23041,
    wearable_ids: [310, 395],
  },
  {
    genesis_token_id: 23042,
    wearable_ids: [413, 399],
  },
  {
    genesis_token_id: 23043,
    wearable_ids: [426, 335],
  },
  {
    genesis_token_id: 23044,
    wearable_ids: [265, 423],
  },
  {
    genesis_token_id: 23045,
    wearable_ids: [400, 341],
  },
  {
    genesis_token_id: 23046,
    wearable_ids: [340, 388],
  },
  {
    genesis_token_id: 23047,
    wearable_ids: [295, 248],
  },
  {
    genesis_token_id: 23048,
    wearable_ids: [444, 349],
  },
  {
    genesis_token_id: 23049,
    wearable_ids: [434, 347],
  },
  {
    genesis_token_id: 23050,
    wearable_ids: [280, 344],
  },
  {
    genesis_token_id: 23051,
    wearable_ids: [292, 289],
  },
  {
    genesis_token_id: 23052,
    wearable_ids: [331, 373],
  },
  {
    genesis_token_id: 23053,
    wearable_ids: [291, 287],
  },
  {
    genesis_token_id: 23054,
    wearable_ids: [259, 437],
  },
  {
    genesis_token_id: 23055,
    wearable_ids: [280, 371],
  },
  {
    genesis_token_id: 23056,
    wearable_ids: [370, 315],
  },
  {
    genesis_token_id: 23057,
    wearable_ids: [344, 354],
  },
  {
    genesis_token_id: 23058,
    wearable_ids: [348, 370],
  },
  {
    genesis_token_id: 23059,
    wearable_ids: [276, 395],
  },
  {
    genesis_token_id: 23060,
    wearable_ids: [295, 394],
  },
  {
    genesis_token_id: 23061,
    wearable_ids: [341, 260],
  },
  {
    genesis_token_id: 23062,
    wearable_ids: [400, 403],
  },
  {
    genesis_token_id: 23063,
    wearable_ids: [371, 431],
  },
  {
    genesis_token_id: 23064,
    wearable_ids: [339, 373],
  },
  {
    genesis_token_id: 23065,
    wearable_ids: [400, 428],
  },
  {
    genesis_token_id: 23066,
    wearable_ids: [266, 247],
  },
  {
    genesis_token_id: 23067,
    wearable_ids: [350, 399],
  },
  {
    genesis_token_id: 23068,
    wearable_ids: [254, 272],
  },
  {
    genesis_token_id: 23069,
    wearable_ids: [341, 266],
  },
  {
    genesis_token_id: 23070,
    wearable_ids: [264, 311],
  },
  {
    genesis_token_id: 23071,
    wearable_ids: [341, 317],
  },
  {
    genesis_token_id: 23072,
    wearable_ids: [314, 336],
  },
  {
    genesis_token_id: 23073,
    wearable_ids: [375, 256],
  },
  {
    genesis_token_id: 23074,
    wearable_ids: [257, 324],
  },
  {
    genesis_token_id: 23075,
    wearable_ids: [295, 372],
  },
  {
    genesis_token_id: 23076,
    wearable_ids: [349, 399],
  },
  {
    genesis_token_id: 23077,
    wearable_ids: [407, 401],
  },
  {
    genesis_token_id: 23078,
    wearable_ids: [266, 415],
  },
  {
    genesis_token_id: 23079,
    wearable_ids: [352, 378],
  },
  {
    genesis_token_id: 23080,
    wearable_ids: [382, 292],
  },
  {
    genesis_token_id: 23081,
    wearable_ids: [409, 323],
  },
  {
    genesis_token_id: 23082,
    wearable_ids: [291, 393],
  },
  {
    genesis_token_id: 23083,
    wearable_ids: [253, 395],
  },
  {
    genesis_token_id: 23084,
    wearable_ids: [317, 445],
  },
  {
    genesis_token_id: 23085,
    wearable_ids: [408, 364],
  },
  {
    genesis_token_id: 23086,
    wearable_ids: [319, 371],
  },
  {
    genesis_token_id: 23087,
    wearable_ids: [247, 303],
  },
  {
    genesis_token_id: 23088,
    wearable_ids: [423, 400],
  },
  {
    genesis_token_id: 23089,
    wearable_ids: [424, 401],
  },
  {
    genesis_token_id: 23090,
    wearable_ids: [280, 351],
  },
  {
    genesis_token_id: 23091,
    wearable_ids: [272, 376],
  },
  {
    genesis_token_id: 23092,
    wearable_ids: [383, 320],
  },
  {
    genesis_token_id: 23093,
    wearable_ids: [377, 424],
  },
  {
    genesis_token_id: 23094,
    wearable_ids: [297, 259],
  },
  {
    genesis_token_id: 23095,
    wearable_ids: [342, 433],
  },
  {
    genesis_token_id: 23096,
    wearable_ids: [315, 435],
  },
  {
    genesis_token_id: 23097,
    wearable_ids: [343, 256],
  },
  {
    genesis_token_id: 23098,
    wearable_ids: [344, 340],
  },
  {
    genesis_token_id: 23099,
    wearable_ids: [368, 407],
  },
  {
    genesis_token_id: 23100,
    wearable_ids: [372, 379],
  },
  {
    genesis_token_id: 23101,
    wearable_ids: [384, 445],
  },
  {
    genesis_token_id: 23102,
    wearable_ids: [274, 287],
  },
  {
    genesis_token_id: 23103,
    wearable_ids: [412, 261],
  },
  {
    genesis_token_id: 23104,
    wearable_ids: [377, 305],
  },
  {
    genesis_token_id: 23105,
    wearable_ids: [386, 408],
  },
  {
    genesis_token_id: 23106,
    wearable_ids: [436, 247],
  },
  {
    genesis_token_id: 23107,
    wearable_ids: [352, 355],
  },
  {
    genesis_token_id: 23108,
    wearable_ids: [289, 335],
  },
  {
    genesis_token_id: 23109,
    wearable_ids: [368, 423],
  },
  {
    genesis_token_id: 23110,
    wearable_ids: [255, 411],
  },
  {
    genesis_token_id: 23111,
    wearable_ids: [374, 405],
  },
  {
    genesis_token_id: 23112,
    wearable_ids: [295, 393],
  },
  {
    genesis_token_id: 23113,
    wearable_ids: [409, 277],
  },
  {
    genesis_token_id: 23114,
    wearable_ids: [404, 325],
  },
  {
    genesis_token_id: 23115,
    wearable_ids: [382, 304],
  },
  {
    genesis_token_id: 23116,
    wearable_ids: [265, 409],
  },
  {
    genesis_token_id: 23117,
    wearable_ids: [310, 414],
  },
  {
    genesis_token_id: 23118,
    wearable_ids: [406, 315],
  },
  {
    genesis_token_id: 23119,
    wearable_ids: [326, 271],
  },
  {
    genesis_token_id: 23120,
    wearable_ids: [347, 341],
  },
  {
    genesis_token_id: 23121,
    wearable_ids: [319, 368],
  },
  {
    genesis_token_id: 23122,
    wearable_ids: [387, 431],
  },
  {
    genesis_token_id: 23123,
    wearable_ids: [295, 436],
  },
  {
    genesis_token_id: 23124,
    wearable_ids: [331, 285],
  },
  {
    genesis_token_id: 23125,
    wearable_ids: [348, 424],
  },
  {
    genesis_token_id: 23126,
    wearable_ids: [301, 256],
  },
  {
    genesis_token_id: 23127,
    wearable_ids: [407, 346],
  },
  {
    genesis_token_id: 23128,
    wearable_ids: [264, 433],
  },
  {
    genesis_token_id: 23129,
    wearable_ids: [413, 443],
  },
  {
    genesis_token_id: 23130,
    wearable_ids: [387, 286],
  },
  {
    genesis_token_id: 23131,
    wearable_ids: [303, 443],
  },
  {
    genesis_token_id: 23132,
    wearable_ids: [280, 338],
  },
  {
    genesis_token_id: 23133,
    wearable_ids: [314, 249],
  },
  {
    genesis_token_id: 23134,
    wearable_ids: [428, 420],
  },
  {
    genesis_token_id: 23135,
    wearable_ids: [258, 336],
  },
  {
    genesis_token_id: 23136,
    wearable_ids: [383, 425],
  },
  {
    genesis_token_id: 23137,
    wearable_ids: [403, 352],
  },
  {
    genesis_token_id: 23138,
    wearable_ids: [303, 338],
  },
  {
    genesis_token_id: 23139,
    wearable_ids: [319, 415],
  },
  {
    genesis_token_id: 23140,
    wearable_ids: [415, 315],
  },
  {
    genesis_token_id: 23141,
    wearable_ids: [315, 350],
  },
  {
    genesis_token_id: 23142,
    wearable_ids: [271, 445],
  },
  {
    genesis_token_id: 23143,
    wearable_ids: [308, 250],
  },
  {
    genesis_token_id: 23144,
    wearable_ids: [277, 436],
  },
  {
    genesis_token_id: 23145,
    wearable_ids: [378, 319],
  },
  {
    genesis_token_id: 23146,
    wearable_ids: [442, 417],
  },
  {
    genesis_token_id: 23147,
    wearable_ids: [306, 312],
  },
  {
    genesis_token_id: 23148,
    wearable_ids: [397, 389],
  },
  {
    genesis_token_id: 23149,
    wearable_ids: [355, 314],
  },
  {
    genesis_token_id: 23150,
    wearable_ids: [342, 429],
  },
  {
    genesis_token_id: 23151,
    wearable_ids: [428, 384],
  },
  {
    genesis_token_id: 23152,
    wearable_ids: [325, 363],
  },
  {
    genesis_token_id: 23153,
    wearable_ids: [300, 385],
  },
  {
    genesis_token_id: 23154,
    wearable_ids: [346, 434],
  },
  {
    genesis_token_id: 23155,
    wearable_ids: [278, 395],
  },
  {
    genesis_token_id: 23156,
    wearable_ids: [343, 351],
  },
  {
    genesis_token_id: 23157,
    wearable_ids: [437, 297],
  },
  {
    genesis_token_id: 23158,
    wearable_ids: [413, 318],
  },
  {
    genesis_token_id: 23159,
    wearable_ids: [432, 410],
  },
  {
    genesis_token_id: 23160,
    wearable_ids: [385, 364],
  },
  {
    genesis_token_id: 23161,
    wearable_ids: [383, 399],
  },
  {
    genesis_token_id: 23162,
    wearable_ids: [351, 281],
  },
  {
    genesis_token_id: 23163,
    wearable_ids: [247, 299],
  },
  {
    genesis_token_id: 23164,
    wearable_ids: [332, 378],
  },
  {
    genesis_token_id: 23165,
    wearable_ids: [256, 270],
  },
  {
    genesis_token_id: 23166,
    wearable_ids: [296, 247],
  },
  {
    genesis_token_id: 23167,
    wearable_ids: [292, 285],
  },
  {
    genesis_token_id: 23168,
    wearable_ids: [264, 392],
  },
  {
    genesis_token_id: 23169,
    wearable_ids: [278, 246],
  },
  {
    genesis_token_id: 23170,
    wearable_ids: [372, 268],
  },
  {
    genesis_token_id: 23171,
    wearable_ids: [294, 251],
  },
  {
    genesis_token_id: 23172,
    wearable_ids: [428, 385],
  },
  {
    genesis_token_id: 23173,
    wearable_ids: [254, 369],
  },
  {
    genesis_token_id: 23174,
    wearable_ids: [336, 409],
  },
  {
    genesis_token_id: 23175,
    wearable_ids: [395, 278],
  },
  {
    genesis_token_id: 23176,
    wearable_ids: [297, 423],
  },
  {
    genesis_token_id: 23177,
    wearable_ids: [297, 362],
  },
  {
    genesis_token_id: 23178,
    wearable_ids: [383, 265],
  },
  {
    genesis_token_id: 23179,
    wearable_ids: [265, 345],
  },
  {
    genesis_token_id: 23180,
    wearable_ids: [425, 413],
  },
  {
    genesis_token_id: 23181,
    wearable_ids: [287, 267],
  },
  {
    genesis_token_id: 23182,
    wearable_ids: [299, 364],
  },
  {
    genesis_token_id: 23183,
    wearable_ids: [344, 384],
  },
  {
    genesis_token_id: 23184,
    wearable_ids: [257, 388],
  },
  {
    genesis_token_id: 23185,
    wearable_ids: [258, 408],
  },
  {
    genesis_token_id: 23186,
    wearable_ids: [424, 249],
  },
  {
    genesis_token_id: 23187,
    wearable_ids: [290, 433],
  },
  {
    genesis_token_id: 23188,
    wearable_ids: [295, 348],
  },
  {
    genesis_token_id: 23189,
    wearable_ids: [342, 368],
  },
  {
    genesis_token_id: 23190,
    wearable_ids: [349, 387],
  },
  {
    genesis_token_id: 23191,
    wearable_ids: [343, 270],
  },
  {
    genesis_token_id: 23192,
    wearable_ids: [262, 338],
  },
  {
    genesis_token_id: 23193,
    wearable_ids: [247, 365],
  },
  {
    genesis_token_id: 23194,
    wearable_ids: [389, 410],
  },
  {
    genesis_token_id: 23195,
    wearable_ids: [374, 403],
  },
  {
    genesis_token_id: 23196,
    wearable_ids: [278, 363],
  },
  {
    genesis_token_id: 23197,
    wearable_ids: [375, 299],
  },
  {
    genesis_token_id: 23198,
    wearable_ids: [257, 358],
  },
  {
    genesis_token_id: 23199,
    wearable_ids: [352, 297],
  },
  {
    genesis_token_id: 23200,
    wearable_ids: [350, 431],
  },
  {
    genesis_token_id: 23201,
    wearable_ids: [310, 276],
  },
  {
    genesis_token_id: 23202,
    wearable_ids: [424, 289],
  },
  {
    genesis_token_id: 23203,
    wearable_ids: [387, 299],
  },
  {
    genesis_token_id: 23204,
    wearable_ids: [290, 412],
  },
  {
    genesis_token_id: 23205,
    wearable_ids: [397, 316],
  },
  {
    genesis_token_id: 23206,
    wearable_ids: [335, 355],
  },
  {
    genesis_token_id: 23207,
    wearable_ids: [400, 401],
  },
  {
    genesis_token_id: 23208,
    wearable_ids: [362, 425],
  },
  {
    genesis_token_id: 23209,
    wearable_ids: [290, 359],
  },
  {
    genesis_token_id: 23210,
    wearable_ids: [435, 333],
  },
  {
    genesis_token_id: 23211,
    wearable_ids: [314, 391],
  },
  {
    genesis_token_id: 23212,
    wearable_ids: [368, 248],
  },
  {
    genesis_token_id: 23213,
    wearable_ids: [384, 316],
  },
  {
    genesis_token_id: 23214,
    wearable_ids: [395, 336],
  },
  {
    genesis_token_id: 23215,
    wearable_ids: [395, 401],
  },
  {
    genesis_token_id: 23216,
    wearable_ids: [289, 299],
  },
  {
    genesis_token_id: 23217,
    wearable_ids: [372, 432],
  },
  {
    genesis_token_id: 23218,
    wearable_ids: [277, 351],
  },
  {
    genesis_token_id: 23219,
    wearable_ids: [404, 427],
  },
  {
    genesis_token_id: 23220,
    wearable_ids: [395, 250],
  },
  {
    genesis_token_id: 23221,
    wearable_ids: [332, 294],
  },
  {
    genesis_token_id: 23222,
    wearable_ids: [308, 434],
  },
  {
    genesis_token_id: 23223,
    wearable_ids: [407, 257],
  },
  {
    genesis_token_id: 23224,
    wearable_ids: [355, 341],
  },
  {
    genesis_token_id: 23225,
    wearable_ids: [289, 246],
  },
  {
    genesis_token_id: 23226,
    wearable_ids: [383, 251],
  },
  {
    genesis_token_id: 23227,
    wearable_ids: [436, 264],
  },
  {
    genesis_token_id: 23228,
    wearable_ids: [344, 259],
  },
  {
    genesis_token_id: 23229,
    wearable_ids: [348, 343],
  },
  {
    genesis_token_id: 23230,
    wearable_ids: [287, 265],
  },
  {
    genesis_token_id: 23231,
    wearable_ids: [424, 441],
  },
  {
    genesis_token_id: 23232,
    wearable_ids: [411, 358],
  },
  {
    genesis_token_id: 23233,
    wearable_ids: [406, 434],
  },
  {
    genesis_token_id: 23234,
    wearable_ids: [263, 420],
  },
  {
    genesis_token_id: 23235,
    wearable_ids: [314, 415],
  },
  {
    genesis_token_id: 23236,
    wearable_ids: [350, 268],
  },
  {
    genesis_token_id: 23237,
    wearable_ids: [404, 354],
  },
  {
    genesis_token_id: 23238,
    wearable_ids: [271, 408],
  },
  {
    genesis_token_id: 23239,
    wearable_ids: [377, 249],
  },
  {
    genesis_token_id: 23240,
    wearable_ids: [306, 279],
  },
  {
    genesis_token_id: 23241,
    wearable_ids: [270, 336],
  },
  {
    genesis_token_id: 23242,
    wearable_ids: [338, 334],
  },
  {
    genesis_token_id: 23243,
    wearable_ids: [429, 442],
  },
  {
    genesis_token_id: 23244,
    wearable_ids: [306, 411],
  },
  {
    genesis_token_id: 23245,
    wearable_ids: [301, 404],
  },
  {
    genesis_token_id: 23246,
    wearable_ids: [382, 295],
  },
  {
    genesis_token_id: 23247,
    wearable_ids: [301, 338],
  },
  {
    genesis_token_id: 23248,
    wearable_ids: [433, 417],
  },
  {
    genesis_token_id: 23249,
    wearable_ids: [338, 287],
  },
  {
    genesis_token_id: 23250,
    wearable_ids: [395, 394],
  },
  {
    genesis_token_id: 23251,
    wearable_ids: [338, 357],
  },
  {
    genesis_token_id: 23252,
    wearable_ids: [435, 397],
  },
  {
    genesis_token_id: 23253,
    wearable_ids: [364, 336],
  },
  {
    genesis_token_id: 23254,
    wearable_ids: [291, 426],
  },
  {
    genesis_token_id: 23255,
    wearable_ids: [399, 333],
  },
  {
    genesis_token_id: 23256,
    wearable_ids: [277, 372],
  },
  {
    genesis_token_id: 23257,
    wearable_ids: [317, 408],
  },
  {
    genesis_token_id: 23258,
    wearable_ids: [428, 398],
  },
  {
    genesis_token_id: 23259,
    wearable_ids: [435, 433],
  },
  {
    genesis_token_id: 23260,
    wearable_ids: [337, 308],
  },
  {
    genesis_token_id: 23261,
    wearable_ids: [387, 433],
  },
  {
    genesis_token_id: 23262,
    wearable_ids: [436, 349],
  },
  {
    genesis_token_id: 23263,
    wearable_ids: [263, 386],
  },
  {
    genesis_token_id: 23264,
    wearable_ids: [364, 385],
  },
  {
    genesis_token_id: 23265,
    wearable_ids: [255, 356],
  },
  {
    genesis_token_id: 23266,
    wearable_ids: [348, 370],
  },
  {
    genesis_token_id: 23267,
    wearable_ids: [257, 259],
  },
  {
    genesis_token_id: 23268,
    wearable_ids: [299, 404],
  },
  {
    genesis_token_id: 23269,
    wearable_ids: [415, 247],
  },
  {
    genesis_token_id: 23270,
    wearable_ids: [373, 263],
  },
  {
    genesis_token_id: 23271,
    wearable_ids: [387, 349],
  },
  {
    genesis_token_id: 23272,
    wearable_ids: [342, 293],
  },
  {
    genesis_token_id: 23273,
    wearable_ids: [378, 363],
  },
  {
    genesis_token_id: 23274,
    wearable_ids: [406, 292],
  },
  {
    genesis_token_id: 23275,
    wearable_ids: [371, 302],
  },
  {
    genesis_token_id: 23276,
    wearable_ids: [396, 308],
  },
  {
    genesis_token_id: 23277,
    wearable_ids: [253, 420],
  },
  {
    genesis_token_id: 23278,
    wearable_ids: [297, 281],
  },
  {
    genesis_token_id: 23279,
    wearable_ids: [375, 351],
  },
  {
    genesis_token_id: 23280,
    wearable_ids: [290, 348],
  },
  {
    genesis_token_id: 23281,
    wearable_ids: [276, 249],
  },
  {
    genesis_token_id: 23282,
    wearable_ids: [287, 435],
  },
  {
    genesis_token_id: 23283,
    wearable_ids: [387, 383],
  },
  {
    genesis_token_id: 23284,
    wearable_ids: [255, 434],
  },
  {
    genesis_token_id: 23285,
    wearable_ids: [311, 322],
  },
  {
    genesis_token_id: 23286,
    wearable_ids: [273, 445],
  },
  {
    genesis_token_id: 23287,
    wearable_ids: [444, 271],
  },
  {
    genesis_token_id: 23288,
    wearable_ids: [411, 340],
  },
  {
    genesis_token_id: 23289,
    wearable_ids: [435, 246],
  },
  {
    genesis_token_id: 23290,
    wearable_ids: [337, 247],
  },
  {
    genesis_token_id: 23291,
    wearable_ids: [280, 395],
  },
  {
    genesis_token_id: 23292,
    wearable_ids: [291, 424],
  },
  {
    genesis_token_id: 23293,
    wearable_ids: [280, 340],
  },
  {
    genesis_token_id: 23294,
    wearable_ids: [415, 250],
  },
  {
    genesis_token_id: 23295,
    wearable_ids: [411, 266],
  },
  {
    genesis_token_id: 23296,
    wearable_ids: [311, 409],
  },
  {
    genesis_token_id: 23297,
    wearable_ids: [444, 277],
  },
  {
    genesis_token_id: 23298,
    wearable_ids: [346, 373],
  },
  {
    genesis_token_id: 23299,
    wearable_ids: [324, 386],
  },
  {
    genesis_token_id: 23300,
    wearable_ids: [338, 412],
  },
  {
    genesis_token_id: 23301,
    wearable_ids: [319, 296],
  },
  {
    genesis_token_id: 23302,
    wearable_ids: [363, 280],
  },
  {
    genesis_token_id: 23303,
    wearable_ids: [286, 397],
  },
  {
    genesis_token_id: 23304,
    wearable_ids: [295, 341],
  },
  {
    genesis_token_id: 23305,
    wearable_ids: [377, 320],
  },
  {
    genesis_token_id: 23306,
    wearable_ids: [331, 396],
  },
  {
    genesis_token_id: 23307,
    wearable_ids: [296, 302],
  },
  {
    genesis_token_id: 23308,
    wearable_ids: [412, 288],
  },
  {
    genesis_token_id: 23309,
    wearable_ids: [387, 328],
  },
  {
    genesis_token_id: 23310,
    wearable_ids: [291, 272],
  },
  {
    genesis_token_id: 23311,
    wearable_ids: [429, 274],
  },
  {
    genesis_token_id: 23312,
    wearable_ids: [268, 320],
  },
  {
    genesis_token_id: 23313,
    wearable_ids: [351, 338],
  },
  {
    genesis_token_id: 23314,
    wearable_ids: [247, 348],
  },
  {
    genesis_token_id: 23315,
    wearable_ids: [258, 352],
  },
  {
    genesis_token_id: 23316,
    wearable_ids: [444, 428],
  },
  {
    genesis_token_id: 23317,
    wearable_ids: [354, 343],
  },
  {
    genesis_token_id: 23318,
    wearable_ids: [408, 394],
  },
  {
    genesis_token_id: 23319,
    wearable_ids: [412, 315],
  },
  {
    genesis_token_id: 23320,
    wearable_ids: [262, 434],
  },
  {
    genesis_token_id: 23321,
    wearable_ids: [294, 278],
  },
  {
    genesis_token_id: 23322,
    wearable_ids: [406, 363],
  },
  {
    genesis_token_id: 23323,
    wearable_ids: [254, 445],
  },
  {
    genesis_token_id: 23324,
    wearable_ids: [406, 415],
  },
  {
    genesis_token_id: 23325,
    wearable_ids: [407, 437],
  },
  {
    genesis_token_id: 23326,
    wearable_ids: [375, 385],
  },
  {
    genesis_token_id: 23327,
    wearable_ids: [264, 431],
  },
  {
    genesis_token_id: 23328,
    wearable_ids: [299, 437],
  },
  {
    genesis_token_id: 23329,
    wearable_ids: [404, 396],
  },
  {
    genesis_token_id: 23330,
    wearable_ids: [304, 312],
  },
  {
    genesis_token_id: 23331,
    wearable_ids: [295, 336],
  },
  {
    genesis_token_id: 23332,
    wearable_ids: [325, 389],
  },
  {
    genesis_token_id: 23333,
    wearable_ids: [262, 291],
  },
  {
    genesis_token_id: 23334,
    wearable_ids: [335, 386],
  },
  {
    genesis_token_id: 23335,
    wearable_ids: [287, 438],
  },
  {
    genesis_token_id: 23336,
    wearable_ids: [341, 433],
  },
  {
    genesis_token_id: 23337,
    wearable_ids: [384, 274],
  },
  {
    genesis_token_id: 23338,
    wearable_ids: [292, 414],
  },
  {
    genesis_token_id: 23339,
    wearable_ids: [385, 351],
  },
  {
    genesis_token_id: 23340,
    wearable_ids: [251, 305],
  },
  {
    genesis_token_id: 23341,
    wearable_ids: [247, 402],
  },
  {
    genesis_token_id: 23342,
    wearable_ids: [352, 298],
  },
  {
    genesis_token_id: 23343,
    wearable_ids: [304, 346],
  },
  {
    genesis_token_id: 23344,
    wearable_ids: [365, 346],
  },
  {
    genesis_token_id: 23345,
    wearable_ids: [317, 398],
  },
  {
    genesis_token_id: 23346,
    wearable_ids: [423, 328],
  },
  {
    genesis_token_id: 23347,
    wearable_ids: [316, 345],
  },
  {
    genesis_token_id: 23348,
    wearable_ids: [408, 268],
  },
  {
    genesis_token_id: 23349,
    wearable_ids: [344, 291],
  },
  {
    genesis_token_id: 23350,
    wearable_ids: [422, 353],
  },
  {
    genesis_token_id: 23351,
    wearable_ids: [264, 319],
  },
  {
    genesis_token_id: 23352,
    wearable_ids: [343, 292],
  },
  {
    genesis_token_id: 23353,
    wearable_ids: [386, 368],
  },
  {
    genesis_token_id: 23354,
    wearable_ids: [445, 431],
  },
  {
    genesis_token_id: 23355,
    wearable_ids: [412, 338],
  },
  {
    genesis_token_id: 23356,
    wearable_ids: [433, 371],
  },
  {
    genesis_token_id: 23357,
    wearable_ids: [362, 420],
  },
  {
    genesis_token_id: 23358,
    wearable_ids: [254, 417],
  },
  {
    genesis_token_id: 23359,
    wearable_ids: [389, 292],
  },
  {
    genesis_token_id: 23360,
    wearable_ids: [270, 328],
  },
  {
    genesis_token_id: 23361,
    wearable_ids: [351, 336],
  },
  {
    genesis_token_id: 23362,
    wearable_ids: [341, 288],
  },
  {
    genesis_token_id: 23363,
    wearable_ids: [308, 396],
  },
  {
    genesis_token_id: 23364,
    wearable_ids: [362, 264],
  },
  {
    genesis_token_id: 23365,
    wearable_ids: [289, 409],
  },
  {
    genesis_token_id: 23366,
    wearable_ids: [347, 404],
  },
  {
    genesis_token_id: 23367,
    wearable_ids: [382, 304],
  },
  {
    genesis_token_id: 23368,
    wearable_ids: [251, 371],
  },
  {
    genesis_token_id: 23369,
    wearable_ids: [310, 251],
  },
  {
    genesis_token_id: 23370,
    wearable_ids: [349, 341],
  },
  {
    genesis_token_id: 23371,
    wearable_ids: [268, 412],
  },
  {
    genesis_token_id: 23372,
    wearable_ids: [319, 248],
  },
  {
    genesis_token_id: 23373,
    wearable_ids: [400, 357],
  },
  {
    genesis_token_id: 23374,
    wearable_ids: [426, 412],
  },
  {
    genesis_token_id: 23375,
    wearable_ids: [348, 372],
  },
  {
    genesis_token_id: 23376,
    wearable_ids: [428, 326],
  },
  {
    genesis_token_id: 23377,
    wearable_ids: [287, 280],
  },
  {
    genesis_token_id: 23378,
    wearable_ids: [362, 406],
  },
  {
    genesis_token_id: 23379,
    wearable_ids: [331, 286],
  },
  {
    genesis_token_id: 23380,
    wearable_ids: [377, 342],
  },
  {
    genesis_token_id: 23381,
    wearable_ids: [296, 306],
  },
  {
    genesis_token_id: 23382,
    wearable_ids: [431, 285],
  },
  {
    genesis_token_id: 23383,
    wearable_ids: [347, 397],
  },
  {
    genesis_token_id: 23384,
    wearable_ids: [397, 270],
  },
  {
    genesis_token_id: 23385,
    wearable_ids: [445, 324],
  },
  {
    genesis_token_id: 23386,
    wearable_ids: [248, 265],
  },
  {
    genesis_token_id: 23387,
    wearable_ids: [376, 400],
  },
  {
    genesis_token_id: 23388,
    wearable_ids: [326, 383],
  },
  {
    genesis_token_id: 23389,
    wearable_ids: [344, 396],
  },
  {
    genesis_token_id: 23390,
    wearable_ids: [348, 417],
  },
  {
    genesis_token_id: 23391,
    wearable_ids: [396, 405],
  },
  {
    genesis_token_id: 23392,
    wearable_ids: [265, 328],
  },
  {
    genesis_token_id: 23393,
    wearable_ids: [346, 388],
  },
  {
    genesis_token_id: 23394,
    wearable_ids: [424, 347],
  },
  {
    genesis_token_id: 23395,
    wearable_ids: [342, 379],
  },
  {
    genesis_token_id: 23396,
    wearable_ids: [445, 340],
  },
  {
    genesis_token_id: 23397,
    wearable_ids: [346, 352],
  },
  {
    genesis_token_id: 23398,
    wearable_ids: [264, 346],
  },
  {
    genesis_token_id: 23399,
    wearable_ids: [266, 278],
  },
  {
    genesis_token_id: 23400,
    wearable_ids: [311, 348],
  },
  {
    genesis_token_id: 23401,
    wearable_ids: [274, 434],
  },
  {
    genesis_token_id: 23402,
    wearable_ids: [306, 371],
  },
  {
    genesis_token_id: 23403,
    wearable_ids: [444, 368],
  },
  {
    genesis_token_id: 23404,
    wearable_ids: [424, 406],
  },
  {
    genesis_token_id: 23405,
    wearable_ids: [270, 435],
  },
  {
    genesis_token_id: 23406,
    wearable_ids: [347, 271],
  },
  {
    genesis_token_id: 23407,
    wearable_ids: [355, 392],
  },
  {
    genesis_token_id: 23408,
    wearable_ids: [397, 396],
  },
  {
    genesis_token_id: 23409,
    wearable_ids: [343, 370],
  },
  {
    genesis_token_id: 23410,
    wearable_ids: [386, 299],
  },
  {
    genesis_token_id: 23411,
    wearable_ids: [370, 416],
  },
  {
    genesis_token_id: 23412,
    wearable_ids: [344, 301],
  },
  {
    genesis_token_id: 23413,
    wearable_ids: [428, 249],
  },
  {
    genesis_token_id: 23414,
    wearable_ids: [428, 247],
  },
  {
    genesis_token_id: 23415,
    wearable_ids: [409, 251],
  },
  {
    genesis_token_id: 23416,
    wearable_ids: [383, 382],
  },
  {
    genesis_token_id: 23417,
    wearable_ids: [254, 388],
  },
  {
    genesis_token_id: 23418,
    wearable_ids: [378, 443],
  },
  {
    genesis_token_id: 23419,
    wearable_ids: [373, 405],
  },
  {
    genesis_token_id: 23420,
    wearable_ids: [264, 317],
  },
  {
    genesis_token_id: 23421,
    wearable_ids: [406, 313],
  },
  {
    genesis_token_id: 23422,
    wearable_ids: [326, 357],
  },
  {
    genesis_token_id: 23423,
    wearable_ids: [420, 255],
  },
  {
    genesis_token_id: 23424,
    wearable_ids: [290, 298],
  },
  {
    genesis_token_id: 23425,
    wearable_ids: [377, 419],
  },
  {
    genesis_token_id: 23426,
    wearable_ids: [348, 306],
  },
  {
    genesis_token_id: 23427,
    wearable_ids: [319, 373],
  },
  {
    genesis_token_id: 23428,
    wearable_ids: [351, 363],
  },
  {
    genesis_token_id: 23429,
    wearable_ids: [331, 339],
  },
  {
    genesis_token_id: 23430,
    wearable_ids: [280, 332],
  },
  {
    genesis_token_id: 23431,
    wearable_ids: [331, 288],
  },
  {
    genesis_token_id: 23432,
    wearable_ids: [258, 442],
  },
  {
    genesis_token_id: 23433,
    wearable_ids: [301, 332],
  },
  {
    genesis_token_id: 23434,
    wearable_ids: [317, 283],
  },
  {
    genesis_token_id: 23435,
    wearable_ids: [290, 408],
  },
  {
    genesis_token_id: 23436,
    wearable_ids: [301, 353],
  },
  {
    genesis_token_id: 23437,
    wearable_ids: [266, 277],
  },
  {
    genesis_token_id: 23438,
    wearable_ids: [326, 374],
  },
  {
    genesis_token_id: 23439,
    wearable_ids: [387, 363],
  },
  {
    genesis_token_id: 23440,
    wearable_ids: [299, 341],
  },
  {
    genesis_token_id: 23441,
    wearable_ids: [351, 433],
  },
  {
    genesis_token_id: 23442,
    wearable_ids: [348, 389],
  },
  {
    genesis_token_id: 23443,
    wearable_ids: [325, 260],
  },
  {
    genesis_token_id: 23444,
    wearable_ids: [280, 414],
  },
  {
    genesis_token_id: 23445,
    wearable_ids: [433, 445],
  },
  {
    genesis_token_id: 23446,
    wearable_ids: [444, 360],
  },
  {
    genesis_token_id: 23447,
    wearable_ids: [378, 332],
  },
  {
    genesis_token_id: 23448,
    wearable_ids: [317, 281],
  },
  {
    genesis_token_id: 23449,
    wearable_ids: [412, 406],
  },
  {
    genesis_token_id: 23450,
    wearable_ids: [365, 378],
  },
  {
    genesis_token_id: 23451,
    wearable_ids: [316, 371],
  },
  {
    genesis_token_id: 23452,
    wearable_ids: [426, 314],
  },
  {
    genesis_token_id: 23453,
    wearable_ids: [369, 341],
  },
  {
    genesis_token_id: 23454,
    wearable_ids: [384, 278],
  },
  {
    genesis_token_id: 23455,
    wearable_ids: [342, 365],
  },
  {
    genesis_token_id: 23456,
    wearable_ids: [384, 423],
  },
  {
    genesis_token_id: 23457,
    wearable_ids: [378, 280],
  },
  {
    genesis_token_id: 23458,
    wearable_ids: [274, 350],
  },
  {
    genesis_token_id: 23459,
    wearable_ids: [373, 438],
  },
  {
    genesis_token_id: 23460,
    wearable_ids: [310, 331],
  },
  {
    genesis_token_id: 23461,
    wearable_ids: [272, 361],
  },
  {
    genesis_token_id: 23462,
    wearable_ids: [378, 370],
  },
  {
    genesis_token_id: 23463,
    wearable_ids: [344, 254],
  },
  {
    genesis_token_id: 23464,
    wearable_ids: [296, 385],
  },
  {
    genesis_token_id: 23465,
    wearable_ids: [259, 385],
  },
  {
    genesis_token_id: 23466,
    wearable_ids: [400, 251],
  },
  {
    genesis_token_id: 23467,
    wearable_ids: [266, 296],
  },
  {
    genesis_token_id: 23468,
    wearable_ids: [428, 350],
  },
  {
    genesis_token_id: 23469,
    wearable_ids: [434, 278],
  },
  {
    genesis_token_id: 23470,
    wearable_ids: [331, 317],
  },
  {
    genesis_token_id: 23471,
    wearable_ids: [445, 370],
  },
  {
    genesis_token_id: 23472,
    wearable_ids: [371, 270],
  },
  {
    genesis_token_id: 23473,
    wearable_ids: [300, 271],
  },
  {
    genesis_token_id: 23474,
    wearable_ids: [338, 284],
  },
  {
    genesis_token_id: 23475,
    wearable_ids: [383, 434],
  },
  {
    genesis_token_id: 23476,
    wearable_ids: [346, 408],
  },
  {
    genesis_token_id: 23477,
    wearable_ids: [343, 259],
  },
  {
    genesis_token_id: 23478,
    wearable_ids: [397, 327],
  },
  {
    genesis_token_id: 23479,
    wearable_ids: [263, 373],
  },
  {
    genesis_token_id: 23480,
    wearable_ids: [413, 423],
  },
  {
    genesis_token_id: 23481,
    wearable_ids: [404, 389],
  },
  {
    genesis_token_id: 23482,
    wearable_ids: [432, 286],
  },
  {
    genesis_token_id: 23483,
    wearable_ids: [340, 432],
  },
  {
    genesis_token_id: 23484,
    wearable_ids: [335, 375],
  },
  {
    genesis_token_id: 23485,
    wearable_ids: [343, 275],
  },
  {
    genesis_token_id: 23486,
    wearable_ids: [340, 373],
  },
  {
    genesis_token_id: 23487,
    wearable_ids: [339, 286],
  },
  {
    genesis_token_id: 23488,
    wearable_ids: [304, 298],
  },
  {
    genesis_token_id: 23489,
    wearable_ids: [299, 370],
  },
  {
    genesis_token_id: 23490,
    wearable_ids: [347, 272],
  },
  {
    genesis_token_id: 23491,
    wearable_ids: [409, 370],
  },
  {
    genesis_token_id: 23492,
    wearable_ids: [278, 422],
  },
  {
    genesis_token_id: 23493,
    wearable_ids: [348, 416],
  },
  {
    genesis_token_id: 23494,
    wearable_ids: [389, 348],
  },
  {
    genesis_token_id: 23495,
    wearable_ids: [389, 377],
  },
  {
    genesis_token_id: 23496,
    wearable_ids: [409, 428],
  },
  {
    genesis_token_id: 23497,
    wearable_ids: [404, 276],
  },
  {
    genesis_token_id: 23498,
    wearable_ids: [289, 444],
  },
  {
    genesis_token_id: 23499,
    wearable_ids: [348, 257],
  },
  {
    genesis_token_id: 23500,
    wearable_ids: [375, 386],
  },
  {
    genesis_token_id: 23501,
    wearable_ids: [348, 412],
  },
  {
    genesis_token_id: 23502,
    wearable_ids: [286, 389],
  },
  {
    genesis_token_id: 23503,
    wearable_ids: [257, 400],
  },
  {
    genesis_token_id: 23504,
    wearable_ids: [442, 265],
  },
  {
    genesis_token_id: 23505,
    wearable_ids: [324, 317],
  },
  {
    genesis_token_id: 23506,
    wearable_ids: [410, 316],
  },
  {
    genesis_token_id: 23507,
    wearable_ids: [347, 279],
  },
  {
    genesis_token_id: 23508,
    wearable_ids: [299, 258],
  },
  {
    genesis_token_id: 23509,
    wearable_ids: [344, 368],
  },
  {
    genesis_token_id: 23510,
    wearable_ids: [308, 431],
  },
  {
    genesis_token_id: 23511,
    wearable_ids: [265, 246],
  },
  {
    genesis_token_id: 23512,
    wearable_ids: [292, 385],
  },
  {
    genesis_token_id: 23513,
    wearable_ids: [295, 404],
  },
  {
    genesis_token_id: 23514,
    wearable_ids: [278, 247],
  },
  {
    genesis_token_id: 23515,
    wearable_ids: [415, 444],
  },
  {
    genesis_token_id: 23516,
    wearable_ids: [389, 251],
  },
  {
    genesis_token_id: 23517,
    wearable_ids: [286, 263],
  },
  {
    genesis_token_id: 23518,
    wearable_ids: [341, 337],
  },
  {
    genesis_token_id: 23519,
    wearable_ids: [371, 382],
  },
  {
    genesis_token_id: 23520,
    wearable_ids: [259, 428],
  },
  {
    genesis_token_id: 23521,
    wearable_ids: [434, 339],
  },
  {
    genesis_token_id: 23522,
    wearable_ids: [386, 425],
  },
  {
    genesis_token_id: 23523,
    wearable_ids: [399, 248],
  },
  {
    genesis_token_id: 23524,
    wearable_ids: [413, 342],
  },
  {
    genesis_token_id: 23525,
    wearable_ids: [355, 346],
  },
  {
    genesis_token_id: 23526,
    wearable_ids: [251, 314],
  },
  {
    genesis_token_id: 23527,
    wearable_ids: [304, 375],
  },
  {
    genesis_token_id: 23528,
    wearable_ids: [296, 430],
  },
  {
    genesis_token_id: 23529,
    wearable_ids: [346, 267],
  },
  {
    genesis_token_id: 23530,
    wearable_ids: [426, 382],
  },
  {
    genesis_token_id: 23531,
    wearable_ids: [337, 400],
  },
  {
    genesis_token_id: 23532,
    wearable_ids: [363, 326],
  },
  {
    genesis_token_id: 23533,
    wearable_ids: [251, 423],
  },
  {
    genesis_token_id: 23534,
    wearable_ids: [362, 342],
  },
  {
    genesis_token_id: 23535,
    wearable_ids: [399, 296],
  },
  {
    genesis_token_id: 23536,
    wearable_ids: [300, 319],
  },
  {
    genesis_token_id: 23537,
    wearable_ids: [247, 399],
  },
  {
    genesis_token_id: 23538,
    wearable_ids: [435, 431],
  },
  {
    genesis_token_id: 23539,
    wearable_ids: [445, 290],
  },
  {
    genesis_token_id: 23540,
    wearable_ids: [434, 404],
  },
  {
    genesis_token_id: 23541,
    wearable_ids: [426, 403],
  },
  {
    genesis_token_id: 23542,
    wearable_ids: [338, 278],
  },
  {
    genesis_token_id: 23543,
    wearable_ids: [406, 327],
  },
  {
    genesis_token_id: 23544,
    wearable_ids: [362, 385],
  },
  {
    genesis_token_id: 23545,
    wearable_ids: [413, 433],
  },
  {
    genesis_token_id: 23546,
    wearable_ids: [314, 354],
  },
  {
    genesis_token_id: 23547,
    wearable_ids: [277, 258],
  },
  {
    genesis_token_id: 23548,
    wearable_ids: [347, 288],
  },
  {
    genesis_token_id: 23549,
    wearable_ids: [376, 289],
  },
  {
    genesis_token_id: 23550,
    wearable_ids: [258, 268],
  },
  {
    genesis_token_id: 23551,
    wearable_ids: [354, 302],
  },
  {
    genesis_token_id: 23552,
    wearable_ids: [300, 326],
  },
  {
    genesis_token_id: 23553,
    wearable_ids: [445, 426],
  },
  {
    genesis_token_id: 23554,
    wearable_ids: [407, 289],
  },
  {
    genesis_token_id: 23555,
    wearable_ids: [300, 422],
  },
  {
    genesis_token_id: 23556,
    wearable_ids: [296, 274],
  },
  {
    genesis_token_id: 23557,
    wearable_ids: [311, 337],
  },
  {
    genesis_token_id: 23558,
    wearable_ids: [384, 352],
  },
  {
    genesis_token_id: 23559,
    wearable_ids: [351, 290],
  },
  {
    genesis_token_id: 23560,
    wearable_ids: [385, 403],
  },
  {
    genesis_token_id: 23561,
    wearable_ids: [362, 359],
  },
  {
    genesis_token_id: 23562,
    wearable_ids: [422, 324],
  },
  {
    genesis_token_id: 23563,
    wearable_ids: [362, 431],
  },
  {
    genesis_token_id: 23564,
    wearable_ids: [273, 313],
  },
  {
    genesis_token_id: 23565,
    wearable_ids: [364, 410],
  },
  {
    genesis_token_id: 23566,
    wearable_ids: [317, 255],
  },
  {
    genesis_token_id: 23567,
    wearable_ids: [386, 339],
  },
  {
    genesis_token_id: 23568,
    wearable_ids: [425, 408],
  },
  {
    genesis_token_id: 23569,
    wearable_ids: [435, 307],
  },
  {
    genesis_token_id: 23570,
    wearable_ids: [332, 442],
  },
  {
    genesis_token_id: 23571,
    wearable_ids: [400, 277],
  },
  {
    genesis_token_id: 23572,
    wearable_ids: [303, 302],
  },
  {
    genesis_token_id: 23573,
    wearable_ids: [297, 420],
  },
  {
    genesis_token_id: 23574,
    wearable_ids: [376, 272],
  },
  {
    genesis_token_id: 23575,
    wearable_ids: [303, 391],
  },
  {
    genesis_token_id: 23576,
    wearable_ids: [301, 289],
  },
  {
    genesis_token_id: 23577,
    wearable_ids: [256, 266],
  },
  {
    genesis_token_id: 23578,
    wearable_ids: [389, 430],
  },
  {
    genesis_token_id: 23579,
    wearable_ids: [350, 408],
  },
  {
    genesis_token_id: 23580,
    wearable_ids: [319, 268],
  },
  {
    genesis_token_id: 23581,
    wearable_ids: [308, 444],
  },
  {
    genesis_token_id: 23582,
    wearable_ids: [291, 427],
  },
  {
    genesis_token_id: 23583,
    wearable_ids: [251, 355],
  },
  {
    genesis_token_id: 23584,
    wearable_ids: [409, 285],
  },
  {
    genesis_token_id: 23585,
    wearable_ids: [343, 398],
  },
  {
    genesis_token_id: 23586,
    wearable_ids: [335, 286],
  },
  {
    genesis_token_id: 23587,
    wearable_ids: [413, 392],
  },
  {
    genesis_token_id: 23588,
    wearable_ids: [426, 384],
  },
  {
    genesis_token_id: 23589,
    wearable_ids: [264, 375],
  },
  {
    genesis_token_id: 23590,
    wearable_ids: [259, 268],
  },
  {
    genesis_token_id: 23591,
    wearable_ids: [349, 290],
  },
  {
    genesis_token_id: 23592,
    wearable_ids: [299, 247],
  },
  {
    genesis_token_id: 23593,
    wearable_ids: [423, 411],
  },
  {
    genesis_token_id: 23594,
    wearable_ids: [368, 445],
  },
  {
    genesis_token_id: 23595,
    wearable_ids: [276, 284],
  },
  {
    genesis_token_id: 23596,
    wearable_ids: [272, 364],
  },
  {
    genesis_token_id: 23597,
    wearable_ids: [280, 291],
  },
  {
    genesis_token_id: 23598,
    wearable_ids: [373, 410],
  },
  {
    genesis_token_id: 23599,
    wearable_ids: [412, 372],
  },
  {
    genesis_token_id: 23600,
    wearable_ids: [276, 303],
  },
  {
    genesis_token_id: 23601,
    wearable_ids: [248, 339],
  },
  {
    genesis_token_id: 23602,
    wearable_ids: [325, 300],
  },
  {
    genesis_token_id: 23603,
    wearable_ids: [341, 296],
  },
  {
    genesis_token_id: 23604,
    wearable_ids: [433, 317],
  },
  {
    genesis_token_id: 23605,
    wearable_ids: [342, 273],
  },
  {
    genesis_token_id: 23606,
    wearable_ids: [445, 331],
  },
  {
    genesis_token_id: 23607,
    wearable_ids: [266, 445],
  },
  {
    genesis_token_id: 23608,
    wearable_ids: [253, 307],
  },
  {
    genesis_token_id: 23609,
    wearable_ids: [262, 287],
  },
  {
    genesis_token_id: 23610,
    wearable_ids: [354, 386],
  },
  {
    genesis_token_id: 23611,
    wearable_ids: [310, 345],
  },
  {
    genesis_token_id: 23612,
    wearable_ids: [395, 318],
  },
  {
    genesis_token_id: 23613,
    wearable_ids: [259, 336],
  },
  {
    genesis_token_id: 23614,
    wearable_ids: [425, 386],
  },
  {
    genesis_token_id: 23615,
    wearable_ids: [385, 301],
  },
  {
    genesis_token_id: 23616,
    wearable_ids: [347, 349],
  },
  {
    genesis_token_id: 23617,
    wearable_ids: [369, 348],
  },
  {
    genesis_token_id: 23618,
    wearable_ids: [295, 375],
  },
  {
    genesis_token_id: 23619,
    wearable_ids: [274, 395],
  },
  {
    genesis_token_id: 23620,
    wearable_ids: [352, 369],
  },
  {
    genesis_token_id: 23621,
    wearable_ids: [410, 396],
  },
  {
    genesis_token_id: 23622,
    wearable_ids: [341, 413],
  },
  {
    genesis_token_id: 23623,
    wearable_ids: [271, 372],
  },
  {
    genesis_token_id: 23624,
    wearable_ids: [410, 338],
  },
  {
    genesis_token_id: 23625,
    wearable_ids: [363, 292],
  },
  {
    genesis_token_id: 23626,
    wearable_ids: [335, 310],
  },
  {
    genesis_token_id: 23627,
    wearable_ids: [424, 351],
  },
  {
    genesis_token_id: 23628,
    wearable_ids: [331, 373],
  },
  {
    genesis_token_id: 23629,
    wearable_ids: [397, 334],
  },
  {
    genesis_token_id: 23630,
    wearable_ids: [294, 265],
  },
  {
    genesis_token_id: 23631,
    wearable_ids: [263, 411],
  },
  {
    genesis_token_id: 23632,
    wearable_ids: [400, 406],
  },
  {
    genesis_token_id: 23633,
    wearable_ids: [436, 440],
  },
  {
    genesis_token_id: 23634,
    wearable_ids: [445, 326],
  },
  {
    genesis_token_id: 23635,
    wearable_ids: [374, 444],
  },
  {
    genesis_token_id: 23636,
    wearable_ids: [311, 372],
  },
  {
    genesis_token_id: 23637,
    wearable_ids: [259, 434],
  },
  {
    genesis_token_id: 23638,
    wearable_ids: [431, 362],
  },
  {
    genesis_token_id: 23639,
    wearable_ids: [409, 382],
  },
  {
    genesis_token_id: 23640,
    wearable_ids: [325, 344],
  },
  {
    genesis_token_id: 23641,
    wearable_ids: [258, 315],
  },
  {
    genesis_token_id: 23642,
    wearable_ids: [415, 255],
  },
  {
    genesis_token_id: 23643,
    wearable_ids: [400, 409],
  },
  {
    genesis_token_id: 23644,
    wearable_ids: [412, 443],
  },
  {
    genesis_token_id: 23645,
    wearable_ids: [365, 437],
  },
  {
    genesis_token_id: 23646,
    wearable_ids: [262, 270],
  },
  {
    genesis_token_id: 23647,
    wearable_ids: [296, 344],
  },
  {
    genesis_token_id: 23648,
    wearable_ids: [265, 365],
  },
  {
    genesis_token_id: 23649,
    wearable_ids: [406, 414],
  },
  {
    genesis_token_id: 23650,
    wearable_ids: [342, 315],
  },
  {
    genesis_token_id: 23651,
    wearable_ids: [362, 433],
  },
  {
    genesis_token_id: 23652,
    wearable_ids: [347, 382],
  },
  {
    genesis_token_id: 23653,
    wearable_ids: [408, 395],
  },
  {
    genesis_token_id: 23654,
    wearable_ids: [264, 428],
  },
  {
    genesis_token_id: 23655,
    wearable_ids: [340, 299],
  },
  {
    genesis_token_id: 23656,
    wearable_ids: [271, 278],
  },
  {
    genesis_token_id: 23657,
    wearable_ids: [344, 319],
  },
  {
    genesis_token_id: 23658,
    wearable_ids: [248, 315],
  },
  {
    genesis_token_id: 23659,
    wearable_ids: [342, 312],
  },
  {
    genesis_token_id: 23660,
    wearable_ids: [408, 443],
  },
  {
    genesis_token_id: 23661,
    wearable_ids: [332, 257],
  },
  {
    genesis_token_id: 23662,
    wearable_ids: [437, 314],
  },
  {
    genesis_token_id: 23663,
    wearable_ids: [254, 320],
  },
  {
    genesis_token_id: 23664,
    wearable_ids: [365, 408],
  },
  {
    genesis_token_id: 23665,
    wearable_ids: [292, 376],
  },
  {
    genesis_token_id: 23666,
    wearable_ids: [344, 375],
  },
  {
    genesis_token_id: 23667,
    wearable_ids: [338, 334],
  },
  {
    genesis_token_id: 23668,
    wearable_ids: [411, 273],
  },
  {
    genesis_token_id: 23669,
    wearable_ids: [424, 413],
  },
  {
    genesis_token_id: 23670,
    wearable_ids: [303, 256],
  },
  {
    genesis_token_id: 23671,
    wearable_ids: [377, 410],
  },
  {
    genesis_token_id: 23672,
    wearable_ids: [270, 251],
  },
  {
    genesis_token_id: 23673,
    wearable_ids: [276, 382],
  },
  {
    genesis_token_id: 23674,
    wearable_ids: [324, 319],
  },
  {
    genesis_token_id: 23675,
    wearable_ids: [428, 334],
  },
  {
    genesis_token_id: 23676,
    wearable_ids: [422, 320],
  },
  {
    genesis_token_id: 23677,
    wearable_ids: [277, 286],
  },
  {
    genesis_token_id: 23678,
    wearable_ids: [351, 411],
  },
  {
    genesis_token_id: 23679,
    wearable_ids: [404, 411],
  },
  {
    genesis_token_id: 23680,
    wearable_ids: [397, 248],
  },
  {
    genesis_token_id: 23681,
    wearable_ids: [424, 438],
  },
  {
    genesis_token_id: 23682,
    wearable_ids: [344, 437],
  },
  {
    genesis_token_id: 23683,
    wearable_ids: [349, 352],
  },
  {
    genesis_token_id: 23684,
    wearable_ids: [319, 275],
  },
  {
    genesis_token_id: 23685,
    wearable_ids: [387, 255],
  },
  {
    genesis_token_id: 23686,
    wearable_ids: [436, 317],
  },
  {
    genesis_token_id: 23687,
    wearable_ids: [257, 407],
  },
  {
    genesis_token_id: 23688,
    wearable_ids: [363, 369],
  },
  {
    genesis_token_id: 23689,
    wearable_ids: [258, 273],
  },
  {
    genesis_token_id: 23690,
    wearable_ids: [355, 383],
  },
  {
    genesis_token_id: 23691,
    wearable_ids: [263, 369],
  },
  {
    genesis_token_id: 23692,
    wearable_ids: [265, 389],
  },
  {
    genesis_token_id: 23693,
    wearable_ids: [436, 415],
  },
  {
    genesis_token_id: 23694,
    wearable_ids: [308, 248],
  },
  {
    genesis_token_id: 23695,
    wearable_ids: [409, 350],
  },
  {
    genesis_token_id: 23696,
    wearable_ids: [364, 259],
  },
  {
    genesis_token_id: 23697,
    wearable_ids: [363, 266],
  },
  {
    genesis_token_id: 23698,
    wearable_ids: [319, 253],
  },
  {
    genesis_token_id: 23699,
    wearable_ids: [295, 254],
  },
  {
    genesis_token_id: 23700,
    wearable_ids: [403, 254],
  },
  {
    genesis_token_id: 23701,
    wearable_ids: [423, 308],
  },
  {
    genesis_token_id: 23702,
    wearable_ids: [335, 320],
  },
  {
    genesis_token_id: 23703,
    wearable_ids: [404, 365],
  },
  {
    genesis_token_id: 23704,
    wearable_ids: [254, 383],
  },
  {
    genesis_token_id: 23705,
    wearable_ids: [436, 334],
  },
  {
    genesis_token_id: 23706,
    wearable_ids: [276, 414],
  },
  {
    genesis_token_id: 23707,
    wearable_ids: [376, 266],
  },
  {
    genesis_token_id: 23708,
    wearable_ids: [409, 387],
  },
  {
    genesis_token_id: 23709,
    wearable_ids: [420, 354],
  },
  {
    genesis_token_id: 23710,
    wearable_ids: [347, 351],
  },
  {
    genesis_token_id: 23711,
    wearable_ids: [415, 274],
  },
  {
    genesis_token_id: 23712,
    wearable_ids: [372, 444],
  },
  {
    genesis_token_id: 23713,
    wearable_ids: [255, 298],
  },
  {
    genesis_token_id: 23714,
    wearable_ids: [295, 408],
  },
  {
    genesis_token_id: 23715,
    wearable_ids: [315, 336],
  },
  {
    genesis_token_id: 23716,
    wearable_ids: [442, 373],
  },
  {
    genesis_token_id: 23717,
    wearable_ids: [404, 326],
  },
  {
    genesis_token_id: 23718,
    wearable_ids: [442, 369],
  },
  {
    genesis_token_id: 23719,
    wearable_ids: [278, 259],
  },
  {
    genesis_token_id: 23720,
    wearable_ids: [346, 409],
  },
  {
    genesis_token_id: 23721,
    wearable_ids: [289, 336],
  },
  {
    genesis_token_id: 23722,
    wearable_ids: [350, 404],
  },
  {
    genesis_token_id: 23723,
    wearable_ids: [297, 424],
  },
  {
    genesis_token_id: 23724,
    wearable_ids: [314, 276],
  },
  {
    genesis_token_id: 23725,
    wearable_ids: [341, 384],
  },
  {
    genesis_token_id: 23726,
    wearable_ids: [363, 337],
  },
  {
    genesis_token_id: 23727,
    wearable_ids: [426, 429],
  },
  {
    genesis_token_id: 23728,
    wearable_ids: [374, 311],
  },
  {
    genesis_token_id: 23729,
    wearable_ids: [256, 401],
  },
  {
    genesis_token_id: 23730,
    wearable_ids: [365, 307],
  },
  {
    genesis_token_id: 23731,
    wearable_ids: [411, 276],
  },
  {
    genesis_token_id: 23732,
    wearable_ids: [413, 355],
  },
  {
    genesis_token_id: 23733,
    wearable_ids: [420, 287],
  },
  {
    genesis_token_id: 23734,
    wearable_ids: [425, 264],
  },
  {
    genesis_token_id: 23735,
    wearable_ids: [346, 405],
  },
  {
    genesis_token_id: 23736,
    wearable_ids: [412, 331],
  },
  {
    genesis_token_id: 23737,
    wearable_ids: [423, 253],
  },
  {
    genesis_token_id: 23738,
    wearable_ids: [262, 337],
  },
  {
    genesis_token_id: 23739,
    wearable_ids: [289, 358],
  },
  {
    genesis_token_id: 23740,
    wearable_ids: [350, 412],
  },
  {
    genesis_token_id: 23741,
    wearable_ids: [370, 327],
  },
  {
    genesis_token_id: 23742,
    wearable_ids: [397, 263],
  },
  {
    genesis_token_id: 23743,
    wearable_ids: [431, 296],
  },
  {
    genesis_token_id: 23744,
    wearable_ids: [247, 339],
  },
  {
    genesis_token_id: 23745,
    wearable_ids: [376, 339],
  },
  {
    genesis_token_id: 23746,
    wearable_ids: [425, 372],
  },
  {
    genesis_token_id: 23747,
    wearable_ids: [289, 319],
  },
  {
    genesis_token_id: 23748,
    wearable_ids: [331, 258],
  },
  {
    genesis_token_id: 23749,
    wearable_ids: [287, 404],
  },
  {
    genesis_token_id: 23750,
    wearable_ids: [387, 383],
  },
  {
    genesis_token_id: 23751,
    wearable_ids: [370, 392],
  },
  {
    genesis_token_id: 23752,
    wearable_ids: [349, 363],
  },
  {
    genesis_token_id: 23753,
    wearable_ids: [406, 408],
  },
  {
    genesis_token_id: 23754,
    wearable_ids: [437, 432],
  },
  {
    genesis_token_id: 23755,
    wearable_ids: [382, 415],
  },
  {
    genesis_token_id: 23756,
    wearable_ids: [374, 312],
  },
  {
    genesis_token_id: 23757,
    wearable_ids: [301, 306],
  },
  {
    genesis_token_id: 23758,
    wearable_ids: [278, 348],
  },
  {
    genesis_token_id: 23759,
    wearable_ids: [301, 389],
  },
  {
    genesis_token_id: 23760,
    wearable_ids: [426, 375],
  },
  {
    genesis_token_id: 23761,
    wearable_ids: [422, 311],
  },
  {
    genesis_token_id: 23762,
    wearable_ids: [350, 290],
  },
  {
    genesis_token_id: 23763,
    wearable_ids: [287, 295],
  },
  {
    genesis_token_id: 23764,
    wearable_ids: [397, 305],
  },
  {
    genesis_token_id: 23765,
    wearable_ids: [431, 387],
  },
  {
    genesis_token_id: 23766,
    wearable_ids: [349, 424],
  },
  {
    genesis_token_id: 23767,
    wearable_ids: [426, 277],
  },
  {
    genesis_token_id: 23768,
    wearable_ids: [375, 286],
  },
  {
    genesis_token_id: 23769,
    wearable_ids: [406, 318],
  },
  {
    genesis_token_id: 23770,
    wearable_ids: [371, 284],
  },
  {
    genesis_token_id: 23771,
    wearable_ids: [428, 310],
  },
  {
    genesis_token_id: 23772,
    wearable_ids: [396, 290],
  },
  {
    genesis_token_id: 23773,
    wearable_ids: [409, 265],
  },
  {
    genesis_token_id: 23774,
    wearable_ids: [300, 437],
  },
  {
    genesis_token_id: 23775,
    wearable_ids: [310, 437],
  },
  {
    genesis_token_id: 23776,
    wearable_ids: [263, 401],
  },
  {
    genesis_token_id: 23777,
    wearable_ids: [332, 431],
  },
  {
    genesis_token_id: 23778,
    wearable_ids: [406, 335],
  },
  {
    genesis_token_id: 23779,
    wearable_ids: [412, 327],
  },
  {
    genesis_token_id: 23780,
    wearable_ids: [296, 396],
  },
  {
    genesis_token_id: 23781,
    wearable_ids: [383, 442],
  },
  {
    genesis_token_id: 23782,
    wearable_ids: [387, 316],
  },
  {
    genesis_token_id: 23783,
    wearable_ids: [286, 326],
  },
  {
    genesis_token_id: 23784,
    wearable_ids: [347, 324],
  },
  {
    genesis_token_id: 23785,
    wearable_ids: [407, 268],
  },
  {
    genesis_token_id: 23786,
    wearable_ids: [331, 322],
  },
  {
    genesis_token_id: 23787,
    wearable_ids: [262, 351],
  },
  {
    genesis_token_id: 23788,
    wearable_ids: [370, 353],
  },
  {
    genesis_token_id: 23789,
    wearable_ids: [314, 424],
  },
  {
    genesis_token_id: 23790,
    wearable_ids: [399, 397],
  },
  {
    genesis_token_id: 23791,
    wearable_ids: [294, 335],
  },
  {
    genesis_token_id: 23792,
    wearable_ids: [389, 409],
  },
  {
    genesis_token_id: 23793,
    wearable_ids: [413, 271],
  },
  {
    genesis_token_id: 23794,
    wearable_ids: [325, 430],
  },
  {
    genesis_token_id: 23795,
    wearable_ids: [284, 362],
  },
  {
    genesis_token_id: 23796,
    wearable_ids: [310, 338],
  },
  {
    genesis_token_id: 23797,
    wearable_ids: [385, 314],
  },
  {
    genesis_token_id: 23798,
    wearable_ids: [436, 388],
  },
  {
    genesis_token_id: 23799,
    wearable_ids: [270, 411],
  },
  {
    genesis_token_id: 23800,
    wearable_ids: [411, 262],
  },
  {
    genesis_token_id: 23801,
    wearable_ids: [372, 413],
  },
  {
    genesis_token_id: 23802,
    wearable_ids: [386, 343],
  },
  {
    genesis_token_id: 23803,
    wearable_ids: [256, 425],
  },
  {
    genesis_token_id: 23804,
    wearable_ids: [411, 316],
  },
  {
    genesis_token_id: 23805,
    wearable_ids: [273, 376],
  },
  {
    genesis_token_id: 23806,
    wearable_ids: [370, 432],
  },
  {
    genesis_token_id: 23807,
    wearable_ids: [297, 247],
  },
  {
    genesis_token_id: 23808,
    wearable_ids: [413, 266],
  },
  {
    genesis_token_id: 23809,
    wearable_ids: [303, 336],
  },
  {
    genesis_token_id: 23810,
    wearable_ids: [300, 374],
  },
  {
    genesis_token_id: 23811,
    wearable_ids: [382, 429],
  },
  {
    genesis_token_id: 23812,
    wearable_ids: [341, 383],
  },
  {
    genesis_token_id: 23813,
    wearable_ids: [272, 266],
  },
  {
    genesis_token_id: 23814,
    wearable_ids: [268, 306],
  },
  {
    genesis_token_id: 23815,
    wearable_ids: [331, 432],
  },
  {
    genesis_token_id: 23816,
    wearable_ids: [317, 326],
  },
  {
    genesis_token_id: 23817,
    wearable_ids: [348, 270],
  },
  {
    genesis_token_id: 23818,
    wearable_ids: [280, 425],
  },
  {
    genesis_token_id: 23819,
    wearable_ids: [300, 250],
  },
  {
    genesis_token_id: 23820,
    wearable_ids: [420, 419],
  },
  {
    genesis_token_id: 23821,
    wearable_ids: [324, 376],
  },
  {
    genesis_token_id: 23822,
    wearable_ids: [371, 395],
  },
  {
    genesis_token_id: 23823,
    wearable_ids: [352, 428],
  },
  {
    genesis_token_id: 23824,
    wearable_ids: [295, 370],
  },
  {
    genesis_token_id: 23825,
    wearable_ids: [410, 386],
  },
  {
    genesis_token_id: 23826,
    wearable_ids: [258, 284],
  },
  {
    genesis_token_id: 23827,
    wearable_ids: [436, 376],
  },
  {
    genesis_token_id: 23828,
    wearable_ids: [415, 306],
  },
  {
    genesis_token_id: 23829,
    wearable_ids: [433, 267],
  },
  {
    genesis_token_id: 23830,
    wearable_ids: [295, 349],
  },
  {
    genesis_token_id: 23831,
    wearable_ids: [365, 433],
  },
  {
    genesis_token_id: 23832,
    wearable_ids: [262, 292],
  },
  {
    genesis_token_id: 23833,
    wearable_ids: [352, 276],
  },
  {
    genesis_token_id: 23834,
    wearable_ids: [355, 291],
  },
  {
    genesis_token_id: 23835,
    wearable_ids: [287, 415],
  },
  {
    genesis_token_id: 23836,
    wearable_ids: [424, 398],
  },
  {
    genesis_token_id: 23837,
    wearable_ids: [303, 404],
  },
  {
    genesis_token_id: 23838,
    wearable_ids: [424, 336],
  },
  {
    genesis_token_id: 23839,
    wearable_ids: [374, 284],
  },
  {
    genesis_token_id: 23840,
    wearable_ids: [247, 370],
  },
  {
    genesis_token_id: 23841,
    wearable_ids: [346, 403],
  },
  {
    genesis_token_id: 23842,
    wearable_ids: [383, 262],
  },
  {
    genesis_token_id: 23843,
    wearable_ids: [362, 418],
  },
  {
    genesis_token_id: 23844,
    wearable_ids: [386, 422],
  },
  {
    genesis_token_id: 23845,
    wearable_ids: [291, 351],
  },
  {
    genesis_token_id: 23846,
    wearable_ids: [300, 287],
  },
  {
    genesis_token_id: 23847,
    wearable_ids: [377, 412],
  },
  {
    genesis_token_id: 23848,
    wearable_ids: [290, 346],
  },
  {
    genesis_token_id: 23849,
    wearable_ids: [376, 293],
  },
  {
    genesis_token_id: 23850,
    wearable_ids: [284, 292],
  },
  {
    genesis_token_id: 23851,
    wearable_ids: [368, 290],
  },
  {
    genesis_token_id: 23852,
    wearable_ids: [400, 287],
  },
  {
    genesis_token_id: 23853,
    wearable_ids: [371, 425],
  },
  {
    genesis_token_id: 23854,
    wearable_ids: [411, 438],
  },
  {
    genesis_token_id: 23855,
    wearable_ids: [395, 342],
  },
  {
    genesis_token_id: 23856,
    wearable_ids: [354, 247],
  },
  {
    genesis_token_id: 23857,
    wearable_ids: [384, 377],
  },
  {
    genesis_token_id: 23858,
    wearable_ids: [437, 273],
  },
  {
    genesis_token_id: 23859,
    wearable_ids: [399, 338],
  },
  {
    genesis_token_id: 23860,
    wearable_ids: [374, 340],
  },
  {
    genesis_token_id: 23861,
    wearable_ids: [396, 295],
  },
  {
    genesis_token_id: 23862,
    wearable_ids: [287, 300],
  },
  {
    genesis_token_id: 23863,
    wearable_ids: [306, 375],
  },
  {
    genesis_token_id: 23864,
    wearable_ids: [254, 423],
  },
  {
    genesis_token_id: 23865,
    wearable_ids: [311, 273],
  },
  {
    genesis_token_id: 23866,
    wearable_ids: [348, 317],
  },
  {
    genesis_token_id: 23867,
    wearable_ids: [404, 372],
  },
  {
    genesis_token_id: 23868,
    wearable_ids: [396, 389],
  },
  {
    genesis_token_id: 23869,
    wearable_ids: [408, 319],
  },
  {
    genesis_token_id: 23870,
    wearable_ids: [324, 346],
  },
  {
    genesis_token_id: 23871,
    wearable_ids: [384, 323],
  },
  {
    genesis_token_id: 23872,
    wearable_ids: [437, 399],
  },
  {
    genesis_token_id: 23873,
    wearable_ids: [437, 431],
  },
  {
    genesis_token_id: 23874,
    wearable_ids: [384, 263],
  },
  {
    genesis_token_id: 23875,
    wearable_ids: [342, 273],
  },
  {
    genesis_token_id: 23876,
    wearable_ids: [270, 348],
  },
  {
    genesis_token_id: 23877,
    wearable_ids: [348, 341],
  },
  {
    genesis_token_id: 23878,
    wearable_ids: [355, 273],
  },
  {
    genesis_token_id: 23879,
    wearable_ids: [413, 300],
  },
  {
    genesis_token_id: 23880,
    wearable_ids: [342, 420],
  },
  {
    genesis_token_id: 23881,
    wearable_ids: [435, 359],
  },
  {
    genesis_token_id: 23882,
    wearable_ids: [385, 436],
  },
  {
    genesis_token_id: 23883,
    wearable_ids: [344, 437],
  },
  {
    genesis_token_id: 23884,
    wearable_ids: [300, 287],
  },
  {
    genesis_token_id: 23885,
    wearable_ids: [369, 444],
  },
  {
    genesis_token_id: 23886,
    wearable_ids: [350, 435],
  },
  {
    genesis_token_id: 23887,
    wearable_ids: [396, 308],
  },
  {
    genesis_token_id: 23888,
    wearable_ids: [280, 387],
  },
  {
    genesis_token_id: 23889,
    wearable_ids: [276, 310],
  },
  {
    genesis_token_id: 23890,
    wearable_ids: [407, 340],
  },
  {
    genesis_token_id: 23891,
    wearable_ids: [372, 251],
  },
  {
    genesis_token_id: 23892,
    wearable_ids: [386, 369],
  },
  {
    genesis_token_id: 23893,
    wearable_ids: [258, 281],
  },
  {
    genesis_token_id: 23894,
    wearable_ids: [372, 256],
  },
  {
    genesis_token_id: 23895,
    wearable_ids: [306, 399],
  },
  {
    genesis_token_id: 23896,
    wearable_ids: [412, 396],
  },
  {
    genesis_token_id: 23897,
    wearable_ids: [264, 256],
  },
  {
    genesis_token_id: 23898,
    wearable_ids: [287, 315],
  },
  {
    genesis_token_id: 23899,
    wearable_ids: [371, 433],
  },
  {
    genesis_token_id: 23900,
    wearable_ids: [400, 384],
  },
  {
    genesis_token_id: 23901,
    wearable_ids: [364, 438],
  },
  {
    genesis_token_id: 23902,
    wearable_ids: [319, 387],
  },
  {
    genesis_token_id: 23903,
    wearable_ids: [375, 268],
  },
  {
    genesis_token_id: 23904,
    wearable_ids: [425, 267],
  },
  {
    genesis_token_id: 23905,
    wearable_ids: [258, 378],
  },
  {
    genesis_token_id: 23906,
    wearable_ids: [408, 352],
  },
  {
    genesis_token_id: 23907,
    wearable_ids: [331, 289],
  },
  {
    genesis_token_id: 23908,
    wearable_ids: [372, 307],
  },
  {
    genesis_token_id: 23909,
    wearable_ids: [424, 434],
  },
  {
    genesis_token_id: 23910,
    wearable_ids: [338, 248],
  },
  {
    genesis_token_id: 23911,
    wearable_ids: [278, 310],
  },
  {
    genesis_token_id: 23912,
    wearable_ids: [289, 362],
  },
  {
    genesis_token_id: 23913,
    wearable_ids: [413, 344],
  },
  {
    genesis_token_id: 23914,
    wearable_ids: [266, 294],
  },
  {
    genesis_token_id: 23915,
    wearable_ids: [301, 371],
  },
  {
    genesis_token_id: 23916,
    wearable_ids: [382, 434],
  },
  {
    genesis_token_id: 23917,
    wearable_ids: [311, 376],
  },
  {
    genesis_token_id: 23918,
    wearable_ids: [257, 326],
  },
  {
    genesis_token_id: 23919,
    wearable_ids: [294, 258],
  },
  {
    genesis_token_id: 23920,
    wearable_ids: [406, 425],
  },
  {
    genesis_token_id: 23921,
    wearable_ids: [442, 292],
  },
  {
    genesis_token_id: 23922,
    wearable_ids: [263, 278],
  },
  {
    genesis_token_id: 23923,
    wearable_ids: [409, 319],
  },
  {
    genesis_token_id: 23924,
    wearable_ids: [443, 365],
  },
  {
    genesis_token_id: 23925,
    wearable_ids: [400, 412],
  },
  {
    genesis_token_id: 23926,
    wearable_ids: [352, 306],
  },
  {
    genesis_token_id: 23927,
    wearable_ids: [407, 400],
  },
  {
    genesis_token_id: 23928,
    wearable_ids: [258, 384],
  },
  {
    genesis_token_id: 23929,
    wearable_ids: [300, 263],
  },
  {
    genesis_token_id: 23930,
    wearable_ids: [433, 385],
  },
  {
    genesis_token_id: 23931,
    wearable_ids: [297, 314],
  },
  {
    genesis_token_id: 23932,
    wearable_ids: [247, 375],
  },
  {
    genesis_token_id: 23933,
    wearable_ids: [436, 383],
  },
  {
    genesis_token_id: 23934,
    wearable_ids: [342, 350],
  },
  {
    genesis_token_id: 23935,
    wearable_ids: [364, 349],
  },
  {
    genesis_token_id: 23936,
    wearable_ids: [431, 370],
  },
  {
    genesis_token_id: 23937,
    wearable_ids: [443, 258],
  },
  {
    genesis_token_id: 23938,
    wearable_ids: [377, 273],
  },
  {
    genesis_token_id: 23939,
    wearable_ids: [424, 336],
  },
  {
    genesis_token_id: 23940,
    wearable_ids: [265, 286],
  },
  {
    genesis_token_id: 23941,
    wearable_ids: [383, 259],
  },
  {
    genesis_token_id: 23942,
    wearable_ids: [429, 312],
  },
  {
    genesis_token_id: 23943,
    wearable_ids: [253, 423],
  },
  {
    genesis_token_id: 23944,
    wearable_ids: [431, 281],
  },
  {
    genesis_token_id: 23945,
    wearable_ids: [382, 442],
  },
  {
    genesis_token_id: 23946,
    wearable_ids: [373, 349],
  },
  {
    genesis_token_id: 23947,
    wearable_ids: [369, 333],
  },
  {
    genesis_token_id: 23948,
    wearable_ids: [325, 385],
  },
  {
    genesis_token_id: 23949,
    wearable_ids: [445, 334],
  },
  {
    genesis_token_id: 23950,
    wearable_ids: [314, 325],
  },
  {
    genesis_token_id: 23951,
    wearable_ids: [311, 406],
  },
  {
    genesis_token_id: 23952,
    wearable_ids: [348, 377],
  },
  {
    genesis_token_id: 23953,
    wearable_ids: [297, 253],
  },
  {
    genesis_token_id: 23954,
    wearable_ids: [433, 314],
  },
  {
    genesis_token_id: 23955,
    wearable_ids: [262, 316],
  },
  {
    genesis_token_id: 23956,
    wearable_ids: [304, 269],
  },
  {
    genesis_token_id: 23957,
    wearable_ids: [310, 324],
  },
  {
    genesis_token_id: 23958,
    wearable_ids: [442, 416],
  },
  {
    genesis_token_id: 23959,
    wearable_ids: [311, 369],
  },
  {
    genesis_token_id: 23960,
    wearable_ids: [397, 251],
  },
  {
    genesis_token_id: 23961,
    wearable_ids: [386, 343],
  },
  {
    genesis_token_id: 23962,
    wearable_ids: [378, 348],
  },
  {
    genesis_token_id: 23963,
    wearable_ids: [247, 333],
  },
  {
    genesis_token_id: 23964,
    wearable_ids: [436, 286],
  },
  {
    genesis_token_id: 23965,
    wearable_ids: [332, 363],
  },
  {
    genesis_token_id: 23966,
    wearable_ids: [314, 371],
  },
  {
    genesis_token_id: 23967,
    wearable_ids: [276, 306],
  },
  {
    genesis_token_id: 23968,
    wearable_ids: [276, 269],
  },
  {
    genesis_token_id: 23969,
    wearable_ids: [409, 395],
  },
  {
    genesis_token_id: 23970,
    wearable_ids: [407, 343],
  },
  {
    genesis_token_id: 23971,
    wearable_ids: [262, 270],
  },
  {
    genesis_token_id: 23972,
    wearable_ids: [300, 430],
  },
  {
    genesis_token_id: 23973,
    wearable_ids: [319, 266],
  },
  {
    genesis_token_id: 23974,
    wearable_ids: [303, 378],
  },
  {
    genesis_token_id: 23975,
    wearable_ids: [280, 393],
  },
  {
    genesis_token_id: 23976,
    wearable_ids: [256, 257],
  },
  {
    genesis_token_id: 23977,
    wearable_ids: [432, 269],
  },
  {
    genesis_token_id: 23978,
    wearable_ids: [340, 386],
  },
  {
    genesis_token_id: 23979,
    wearable_ids: [292, 392],
  },
  {
    genesis_token_id: 23980,
    wearable_ids: [396, 271],
  },
  {
    genesis_token_id: 23981,
    wearable_ids: [386, 374],
  },
  {
    genesis_token_id: 23982,
    wearable_ids: [299, 324],
  },
  {
    genesis_token_id: 23983,
    wearable_ids: [310, 308],
  },
  {
    genesis_token_id: 23984,
    wearable_ids: [376, 338],
  },
  {
    genesis_token_id: 23985,
    wearable_ids: [273, 331],
  },
  {
    genesis_token_id: 23986,
    wearable_ids: [426, 423],
  },
  {
    genesis_token_id: 23987,
    wearable_ids: [384, 373],
  },
  {
    genesis_token_id: 23988,
    wearable_ids: [378, 374],
  },
  {
    genesis_token_id: 23989,
    wearable_ids: [270, 386],
  },
  {
    genesis_token_id: 23990,
    wearable_ids: [258, 328],
  },
  {
    genesis_token_id: 23991,
    wearable_ids: [331, 339],
  },
  {
    genesis_token_id: 23992,
    wearable_ids: [368, 326],
  },
  {
    genesis_token_id: 23993,
    wearable_ids: [259, 339],
  },
  {
    genesis_token_id: 23994,
    wearable_ids: [278, 442],
  },
  {
    genesis_token_id: 23995,
    wearable_ids: [290, 363],
  },
  {
    genesis_token_id: 23996,
    wearable_ids: [301, 341],
  },
  {
    genesis_token_id: 23997,
    wearable_ids: [397, 351],
  },
  {
    genesis_token_id: 23998,
    wearable_ids: [352, 399],
  },
  {
    genesis_token_id: 23999,
    wearable_ids: [257, 433],
  },
];
